
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("4KsXv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4d721b44212ec2a2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQX23");

var $8BZ1O = parcelRequire("8BZ1O");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $fO5rB = parcelRequire("fO5rB");

var $bhwgQ = parcelRequire("bhwgQ");

var $jK1pm = parcelRequire("jK1pm");

var $Heqyv = parcelRequire("Heqyv");
const $4d721b44212ec2a2$var$JiraBusinessBoardApp = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-board-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BZ1O.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7c3W1.ViewPreferencesProvider), {
        view: "board",
        preferences: (0, $ji3xf.BOARD_VIEW_PREFERENCES)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Heqyv.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "core"
    })));
var $4d721b44212ec2a2$export$2e2bcd8739ae039 = $4d721b44212ec2a2$var$JiraBusinessBoardApp;

});
parcelRegister("8BZ1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $80390eebeffb6a20$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bDUCT = parcelRequire("bDUCT");

var $fDLFb = parcelRequire("fDLFb");

var $eZbpk = parcelRequire("eZbpk");

var $ePgRW = parcelRequire("ePgRW");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $jWIW7 = parcelRequire("jWIW7");

var $7IBv4 = parcelRequire("7IBv4");

var $8WuJm = parcelRequire("8WuJm");

var $aeIT6 = parcelRequire("aeIT6");

var $dWLk9 = parcelRequire("dWLk9");

var $lB25E = parcelRequire("lB25E");

var $hCCuu = parcelRequire("hCCuu");

var $k4xGW = parcelRequire("k4xGW");
const $80390eebeffb6a20$var$ProjectContextProvider = ({ children: children })=>{
    const { data: project, loading: loading, error: error } = (0, $aeIT6.useProject)();
    const { replace: replace } = (0, $lB25E.useRouterActions)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const projectId = project?.id;
    const projectKey = project?.key;
    const projectType = project?.type;
    const isTeamManaged = Boolean(project?.isSimplified);
    const jqlContext = projectKey ? `project = '${projectKey}'` : '';
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            projectId: projectId,
            isTeamManaged: isTeamManaged,
            projectType: projectType
        }), [
        projectId,
        isTeamManaged,
        projectType
    ]);
    const entityData = (0, $eUqFw.useMemo)(()=>project?.permissions?.viewIssues ? {
            name: project.name,
            id: String(project.id)
        } : null, [
        project
    ]);
    const projects = (0, $eUqFw.useMemo)(()=>project ? [
            project
        ] : undefined, [
        project
    ]);
    const projectIdList = (0, $eUqFw.useMemo)(()=>projectId ? [
            projectId
        ] : undefined, [
        projectId
    ]);
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    if (project?.status === 'ARCHIVED') {
        replace('/jira/errors/project-archived');
        return null;
    }
    let content;
    if (loading) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7IBv4.ThemedLazySkeleton), null);
    else if (project == null || entityData == null || error) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4xGW.default), null), error && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceFailed), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE),
        error: error
    }));
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQAZu.ProjectHookProvider), {
        project: project
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDLFb.BusinessEntityProvider), {
        data: entityData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ePgRW.RealtimeProvider), {
        ids: projectIdList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDUCT.AriProvider), {
        ari: projectAri
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZbpk.JqlProvider), {
        jqlContext: jqlContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jWIW7.FiltersProvider), {
        projects: projects
    }, children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        containerId: String(project?.id),
        containerType: "project",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "businessProjectContext",
        attributes: analyticsAttributes,
        // we set a key on the first element to force React to re-render when the context changes
        // to avoid query race-conditions that would lead to promises from a previous context
        // resolving in the current context view, and thus seeing unrelated data
        key: String(project?.id)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceStart), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE)
    }), content);
};
var $80390eebeffb6a20$export$2e2bcd8739ae039 = $80390eebeffb6a20$var$ProjectContextProvider;

});
parcelRegister("bDUCT", function(module, exports) {

$parcel$export(module.exports, "AriProvider", () => $76c0a50c757f3bcd$export$c806f8ac05dc61fa);
$parcel$export(module.exports, "useEntityAri", () => $76c0a50c757f3bcd$export$badcacdc306567b8);

var $eUqFw = parcelRequire("eUqFw");
const $76c0a50c757f3bcd$var$AriContext = /*#__PURE__*/ (0, $eUqFw.createContext)('');
const $76c0a50c757f3bcd$export$c806f8ac05dc61fa = ({ ari: ari, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($76c0a50c757f3bcd$var$AriContext.Provider, {
        value: ari
    }, children);
const $76c0a50c757f3bcd$export$badcacdc306567b8 = ()=>(0, $eUqFw.useContext)($76c0a50c757f3bcd$var$AriContext);

});

parcelRegister("fDLFb", function(module, exports) {

$parcel$export(module.exports, "BusinessEntityProvider", () => $984e8248b41af828$export$c800e064c3c327ef);
$parcel$export(module.exports, "useBusinessEntity", () => $984e8248b41af828$export$ff2574b00bc1c100);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $984e8248b41af828$var$BusinessEntityContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $984e8248b41af828$export$c800e064c3c327ef = ({ data: data, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($984e8248b41af828$var$BusinessEntityContext.Provider, {
        value: data
    }, children);
const $984e8248b41af828$export$ff2574b00bc1c100 = ()=>{
    const entity = (0, $eUqFw.useContext)($984e8248b41af828$var$BusinessEntityContext);
    return {
        data: entity
    };
};

});

parcelRegister("eZbpk", function(module, exports) {

$parcel$export(module.exports, "JqlProvider", () => $28ab7b3257a6571c$export$fdc879e2ba0da048);
$parcel$export(module.exports, "useJqlContext", () => $28ab7b3257a6571c$export$f32e2f688fc08561);

var $eUqFw = parcelRequire("eUqFw");
const $28ab7b3257a6571c$var$JqlContext = /*#__PURE__*/ (0, $eUqFw.createContext)('');
const $28ab7b3257a6571c$export$fdc879e2ba0da048 = ({ jqlContext: jqlContext, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($28ab7b3257a6571c$var$JqlContext.Provider, {
        value: jqlContext
    }, children);
const $28ab7b3257a6571c$export$f32e2f688fc08561 = ()=>(0, $eUqFw.useContext)($28ab7b3257a6571c$var$JqlContext);

});

parcelRegister("ePgRW", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $d87d469a5640e4cf$export$64d242981d970821);
$parcel$export(module.exports, "useRealtimeContext", () => $d87d469a5640e4cf$export$f39c07717ad8c35b);

var $eUqFw = parcelRequire("eUqFw");
const $d87d469a5640e4cf$var$RealtimeContext = /*#__PURE__*/ (0, $eUqFw.createContext)([]);
const $d87d469a5640e4cf$export$64d242981d970821 = ({ ids: ids, children: children })=>{
    const projectsIds = (0, $eUqFw.useMemo)(()=>ids ? ids.map((pid)=>String(pid)) : [], [
        ids
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87d469a5640e4cf$var$RealtimeContext.Provider, {
        value: projectsIds
    }, children);
};
const $d87d469a5640e4cf$export$f39c07717ad8c35b = ()=>(0, $eUqFw.useContext)($d87d469a5640e4cf$var$RealtimeContext);

});

parcelRegister("kQAZu", function(module, exports) {

$parcel$export(module.exports, "ProjectHookProvider", () => $5a070342b3707183$export$f1938a4916a14d9f);
$parcel$export(module.exports, "useProject", () => $5a070342b3707183$export$51b1383ef8844a7);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $5a070342b3707183$var$Context = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $5a070342b3707183$export$f1938a4916a14d9f = ({ project: project, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5a070342b3707183$var$Context.Provider, {
        value: project
    }, children);
const $5a070342b3707183$export$51b1383ef8844a7 = ()=>{
    const project = (0, $eUqFw.useContext)($5a070342b3707183$var$Context);
    if (!project) throw new Error('useProject must be used within a ProjectHookProvider');
    return project;
};

});

parcelRegister("jWIW7", function(module, exports) {

$parcel$export(module.exports, "FiltersProvider", () => $85c94258ff14c8b6$export$905df3588d1d8c75);
$parcel$export(module.exports, "useAssigneesFilterQuery", () => $85c94258ff14c8b6$export$f39bce8705b01ff5);
$parcel$export(module.exports, "useProjectFilter", () => $85c94258ff14c8b6$export$b71768ffb8163578);
$parcel$export(module.exports, "useAllowedFieldTypes", () => $85c94258ff14c8b6$export$9dc8a291956c2fa9);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");
const $85c94258ff14c8b6$var$DEFAULT_VALUE = {
    assigneeQuery: '',
    projectFilter: {
        totalCount: 0,
        options: []
    }
};
const $85c94258ff14c8b6$var$FiltersContext = /*#__PURE__*/ (0, $eUqFw.createContext)($85c94258ff14c8b6$var$DEFAULT_VALUE);
const $85c94258ff14c8b6$export$905df3588d1d8c75 = ({ projects: projects, children: children })=>{
    const value = (0, $eUqFw.useMemo)(()=>{
        if (!projects) return $85c94258ff14c8b6$var$DEFAULT_VALUE;
        const assigneeQuery = `is assignee of (${projects.map((project)=>project.key).join(', ')})`;
        const projectFilter = {
            totalCount: projects.length,
            options: projects.map((project)=>({
                    label: project.name,
                    value: String(project.id),
                    avatar: project.avatarUrl,
                    square: true
                }))
        };
        return {
            assigneeQuery: assigneeQuery,
            projectFilter: projectFilter
        };
    }, [
        projects
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($85c94258ff14c8b6$var$FiltersContext.Provider, {
        value: value
    }, children);
};
const $85c94258ff14c8b6$export$f39bce8705b01ff5 = ()=>(0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext).assigneeQuery;
const $85c94258ff14c8b6$export$b71768ffb8163578 = ()=>(0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext).projectFilter;
const $85c94258ff14c8b6$export$9dc8a291956c2fa9 = (inputAllowedFieldTypes)=>{
    const filtersContext = (0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext);
    return (0, $eUqFw.useMemo)(()=>{
        const result = new Set(inputAllowedFieldTypes ?? (0, $9TEHc.BUSINESS_FIELD_TYPES));
        if (filtersContext.projectFilter.totalCount <= 1) result.delete((0, $lO4Or.PROJECT_TYPE));
        return result;
    }, [
        filtersContext,
        inputAllowedFieldTypes
    ]);
};

});
parcelRegister("9TEHc", function(module, exports) {

$parcel$export(module.exports, "POPUP_WIDTH", () => $199ced4cefdf295b$export$b6d617db656efcca);
$parcel$export(module.exports, "SHOW_MORE_OPTIONS_BTN_SIZE", () => $199ced4cefdf295b$export$dd535f74d98d8b3);
$parcel$export(module.exports, "OPTIONS_AVAILABLE_WIDTH", () => $199ced4cefdf295b$export$dba112976ea61483);
$parcel$export(module.exports, "GAP_BETWEEN_OPTION", () => $199ced4cefdf295b$export$fe1082abeeda69ed);
$parcel$export(module.exports, "OPTION_SPAN_PADDING", () => $199ced4cefdf295b$export$17ed91292eb6c163);
$parcel$export(module.exports, "OPTION_DEFAULT_FONT_SIZE", () => $199ced4cefdf295b$export$fb22dccd99438559);
$parcel$export(module.exports, "POPUP_OFFSET_TOP", () => $199ced4cefdf295b$export$15839778e99d81e7);
$parcel$export(module.exports, "OPTION_MAX_WIDTH", () => $199ced4cefdf295b$export$39aa3a14ebf850c7);
$parcel$export(module.exports, "DATE_RANGE_TYPE", () => $199ced4cefdf295b$export$1178808c606e043b);
$parcel$export(module.exports, "BUSINESS_FIELD_TYPES", () => $199ced4cefdf295b$export$c269ba5d631cb115);
$parcel$export(module.exports, "SOFTWARE_FIELD_TYPES", () => $199ced4cefdf295b$export$232814e45256d5dc);
$parcel$export(module.exports, "IMPLEMENTED_TYPES", () => $199ced4cefdf295b$export$9615a3d79408a88a);
$parcel$export(module.exports, "EXTRA_CUSTOM_FIELD_TYPES", () => $199ced4cefdf295b$export$a21166a4b76932b5);
$parcel$export(module.exports, "SAVED_FILTERS_PER_PAGE", () => $199ced4cefdf295b$export$1989c7236a398e8a);

var $c9TLT = parcelRequire("c9TLT");

var $lO4Or = parcelRequire("lO4Or");
const $199ced4cefdf295b$export$b6d617db656efcca = 360;
const $199ced4cefdf295b$export$90bfd0dcc25478e1 = (0, $c9TLT.gridSize) * 2.5;
const $199ced4cefdf295b$export$dd535f74d98d8b3 = 32;
const $199ced4cefdf295b$export$dba112976ea61483 = $199ced4cefdf295b$export$b6d617db656efcca - $199ced4cefdf295b$export$90bfd0dcc25478e1 * 2;
const $199ced4cefdf295b$export$fe1082abeeda69ed = (0, $c9TLT.gridSize) / 2;
const $199ced4cefdf295b$export$17ed91292eb6c163 = (0, $c9TLT.gridSize) * 2;
const $199ced4cefdf295b$export$fb22dccd99438559 = 14;
const $199ced4cefdf295b$export$15839778e99d81e7 = 215;
const $199ced4cefdf295b$export$de3cbeaaf9d2669 = 28;
const $199ced4cefdf295b$export$39aa3a14ebf850c7 = 150;
const $199ced4cefdf295b$export$1178808c606e043b = 'dateRange';
const $199ced4cefdf295b$export$c269ba5d631cb115 = [
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.CATEGORY_TYPE),
    (0, $lO4Or.COMPONENTS_TYPE),
    (0, $lO4Or.CREATED),
    $199ced4cefdf295b$export$1178808c606e043b,
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.LABELS_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $lO4Or.PROJECT_TYPE),
    (0, $lO4Or.REPORTER_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    (0, $lO4Or.UPDATED),
    (0, $lO4Or.USER_CF_TYPE),
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.DATE_CF_TYPE),
    (0, $lO4Or.GOALS_CF_TYPE),
    (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
    (0, $lO4Or.PARENT_FIELD_TYPE)
];
const $199ced4cefdf295b$export$232814e45256d5dc = [
    (0, $lO4Or.SPRINT_TYPE),
    (0, $lO4Or.FIX_VERSIONS_TYPE)
];
const $199ced4cefdf295b$export$9615a3d79408a88a = new Set([
    ...$199ced4cefdf295b$export$c269ba5d631cb115,
    ...$199ced4cefdf295b$export$232814e45256d5dc
]);
const $199ced4cefdf295b$export$a21166a4b76932b5 = new Set([
    (0, $lO4Or.USER_CF_TYPE),
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.DATE_CF_TYPE)
]);
const $199ced4cefdf295b$export$90ca377eb0b24ff1 = {
    assignee: (0, $lO4Or.ASSIGNEE_TYPE),
    component: (0, $lO4Or.COMPONENTS_TYPE),
    created: (0, $lO4Or.CREATED),
    issuetype: (0, $lO4Or.ISSUE_TYPE),
    labels: (0, $lO4Or.LABELS_TYPE),
    priority: (0, $lO4Or.PRIORITY_TYPE),
    project: (0, $lO4Or.PROJECT_TYPE),
    reporter: (0, $lO4Or.REPORTER_TYPE),
    status: (0, $lO4Or.STATUS_TYPE),
    type: (0, $lO4Or.ISSUE_TYPE),
    updated: (0, $lO4Or.UPDATED)
};
const $199ced4cefdf295b$export$6a2e733db5135f27 = (0, $c9TLT.gridSize) * 3.5;
const $199ced4cefdf295b$export$1989c7236a398e8a = 50;
const $199ced4cefdf295b$export$91fc9d65fca142a3 = 'users';
const $199ced4cefdf295b$export$d74c70f8fb216c6b = 'recentlyUsedUsers';

});


// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("hCCuu", function(module, exports) {

$parcel$export(module.exports, "FETCH_PROJECT_EXPERIENCE", () => $be9e1adc5e199dda$export$cb40bbf7ea51db63);
const $be9e1adc5e199dda$export$cb40bbf7ea51db63 = {
    experience: 'fetch-project',
    packageName: 'jiraBusinessEntityProjectProvider',
    teamName: 'wanjel'
};

});

parcelRegister("k4xGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1de8d4690ad3f8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gGtKh = parcelRequire("gGtKh");

var $dyfd9 = parcelRequire("dyfd9");

const $7e1de8d4690ad3f8$var$NotFoundComponent = (0, $dyfd9.lazyAfterPaint)(()=>(parcelRequire("8UKUA")), {
    moduleId: "./src/packages/business/entity/project-provider/src/ui/project-context/not-found/main.tsx"
});
const $7e1de8d4690ad3f8$var$NotFoundAsync = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "not-found-component",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e1de8d4690ad3f8$var$NotFoundComponent, null));
var $7e1de8d4690ad3f8$export$2e2bcd8739ae039 = $7e1de8d4690ad3f8$var$NotFoundAsync;

});
parcelRegister("8UKUA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("dX4bq")
]).then(()=>parcelRequire('gutLJ'));

});



parcelRegister("ji3xf", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_WORKFLOW_PREFERENCE", () => $3ed190d907cd42b1$export$5d3f940b56d7af28);
$parcel$export(module.exports, "COLLAPSED_COLUMNS_PREFERENCE", () => $3ed190d907cd42b1$export$8019dfa5a44f6d46);
$parcel$export(module.exports, "COLUMNS_ORDER_PREFERENCE", () => $3ed190d907cd42b1$export$3ef984a9f784490f);
$parcel$export(module.exports, "CREATE_TYPE_ID_PREFERENCE", () => $3ed190d907cd42b1$export$2df4c3d44dcb1e5b);
$parcel$export(module.exports, "EXPANDED_ISSUES_PREFERENCE", () => $3ed190d907cd42b1$export$638c3932e4cbdede);
$parcel$export(module.exports, "FIELDS_PREFERENCE", () => $3ed190d907cd42b1$export$e3ddfc509464e305);
$parcel$export(module.exports, "FIELDS_DETAIL_PREFERENCE", () => $3ed190d907cd42b1$export$ffcb5603c64e12d0);
$parcel$export(module.exports, "FILTER_PREFERENCE", () => $3ed190d907cd42b1$export$f50d5db589fb1475);
$parcel$export(module.exports, "GROUPING_PREFERENCE", () => $3ed190d907cd42b1$export$ac8a4771da7f03af);
$parcel$export(module.exports, "HIDE_DONE_ITEMS_PREFERENCE", () => $3ed190d907cd42b1$export$4aace169721c2927);
$parcel$export(module.exports, "HIDE_SOFTWARE_RELEASE_PREFERENCE", () => $3ed190d907cd42b1$export$983f0d3325e2938);
$parcel$export(module.exports, "RANGE_MODE_PREFERENCE", () => $3ed190d907cd42b1$export$f43988a3762bf711);
$parcel$export(module.exports, "SORTING_PREFERENCE", () => $3ed190d907cd42b1$export$373eea1341dcff74);
$parcel$export(module.exports, "BOARD_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$4ec60be96e9eadc0);
$parcel$export(module.exports, "LIST_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$43fc1ec27b2f1801);
$parcel$export(module.exports, "CALENDAR_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$14e2a519a8c2881a);
$parcel$export(module.exports, "TIMELINE_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$8443f3f4fd94276);
$parcel$export(module.exports, "ATTACHMENTS_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$2e2923d9c9daba20);

var $jGcn0 = parcelRequire("jGcn0");

var $khRV9 = parcelRequire("khRV9");
const $3ed190d907cd42b1$export$5d3f940b56d7af28 = (0, $khRV9.createSimplePreference)('activeWorkflow');
const $3ed190d907cd42b1$export$8019dfa5a44f6d46 = (0, $khRV9.createSimplePreference)('collapsedColumns');
const $3ed190d907cd42b1$export$3ef984a9f784490f = (0, $khRV9.createSimplePreference)('columnOrder');
const $3ed190d907cd42b1$export$2df4c3d44dcb1e5b = (0, $khRV9.createSimplePreference)('createType');
const $3ed190d907cd42b1$export$638c3932e4cbdede = (0, $khRV9.createSimplePreference)('expandedIssues');
const $3ed190d907cd42b1$export$e3ddfc509464e305 = (0, $khRV9.createSimplePreference)('fields');
const $3ed190d907cd42b1$export$ffcb5603c64e12d0 = (0, $khRV9.createSimplePreference)('fieldsDetail');
const $3ed190d907cd42b1$export$f50d5db589fb1475 = (0, $khRV9.createSimpleUrlPreference)((0, $jGcn0.FILTER_PARAM));
const $3ed190d907cd42b1$export$ac8a4771da7f03af = (0, $khRV9.createSimpleUrlPreference)('groupBy');
const $3ed190d907cd42b1$export$4aace169721c2927 = (0, $khRV9.createSimpleUrlPreference)('hideDone');
const $3ed190d907cd42b1$export$983f0d3325e2938 = (0, $khRV9.createSimpleUrlPreference)('hideSoftwareRelease');
const $3ed190d907cd42b1$export$f43988a3762bf711 = (0, $khRV9.createSimpleUrlPreference)('rangeMode');
const $3ed190d907cd42b1$export$373eea1341dcff74 = {
    ...(0, $khRV9.createSimplePreference)('sorting'),
    queryParameter: {
        serialize: (value)=>({
                sortBy: value?.sortBy,
                direction: value?.direction
            }),
        deserialize: (value)=>value.sortBy ? {
                sortBy: value.sortBy,
                direction: value.direction
            } : undefined
    }
};
const $3ed190d907cd42b1$export$4ec60be96e9eadc0 = [
    $3ed190d907cd42b1$export$5d3f940b56d7af28,
    $3ed190d907cd42b1$export$8019dfa5a44f6d46,
    $3ed190d907cd42b1$export$3ef984a9f784490f,
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$638c3932e4cbdede,
    $3ed190d907cd42b1$export$e3ddfc509464e305,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$ac8a4771da7f03af
];
const $3ed190d907cd42b1$export$43fc1ec27b2f1801 = [
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$e3ddfc509464e305,
    $3ed190d907cd42b1$export$ffcb5603c64e12d0,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$ac8a4771da7f03af,
    $3ed190d907cd42b1$export$4aace169721c2927,
    $3ed190d907cd42b1$export$373eea1341dcff74
];
const $3ed190d907cd42b1$export$14e2a519a8c2881a = [
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$4aace169721c2927,
    $3ed190d907cd42b1$export$983f0d3325e2938
];
const $3ed190d907cd42b1$export$8443f3f4fd94276 = [
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$4aace169721c2927,
    $3ed190d907cd42b1$export$f43988a3762bf711
];
const $3ed190d907cd42b1$export$2e2923d9c9daba20 = [
    $3ed190d907cd42b1$export$f50d5db589fb1475
];

});
parcelRegister("jGcn0", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RANK_SORTING_DIRECTION", () => $15ed10c690a013f2$export$8386e51ba415e85d);
$parcel$export(module.exports, "DEFAULT_AVATAR_RES", () => $15ed10c690a013f2$export$159fe44438c210e9);
$parcel$export(module.exports, "FILTER_PARAM", () => $15ed10c690a013f2$export$d8301e0b33832d94);
$parcel$export(module.exports, "INLINE_CREATE_PARAM", () => $15ed10c690a013f2$export$599c163c1570a353);
$parcel$export(module.exports, "INVITE_OPEN_PARAM", () => $15ed10c690a013f2$export$3a74d1a195d2f007);
$parcel$export(module.exports, "SELECTED_ISSUE_PARAM", () => $15ed10c690a013f2$export$c070acdc9b0f1be5);
$parcel$export(module.exports, "SELECTED_COMMENT_PARAM", () => $15ed10c690a013f2$export$3bcbd99d0f9ad6d8);
$parcel$export(module.exports, "GROUP_BY_ASSIGNEE", () => $15ed10c690a013f2$export$dba794af6c0f2afc);
$parcel$export(module.exports, "GROUP_BY_PRIORITY", () => $15ed10c690a013f2$export$56ecb5d2dfb80edc);
$parcel$export(module.exports, "GROUP_BY_CATEGORY", () => $15ed10c690a013f2$export$22ef551f315f2786);
$parcel$export(module.exports, "GROUP_BY_STATUS", () => $15ed10c690a013f2$export$6d69efb296b78a);
$parcel$export(module.exports, "START_DATE_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$e23e1d1ea45171c2);
$parcel$export(module.exports, "RANK_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$e35c6e217c75dc4b);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_TYPE", () => $15ed10c690a013f2$export$e5eab344feb92af9);
$parcel$export(module.exports, "COMMENT_SUMMARY_TYPE", () => $15ed10c690a013f2$export$a311e1b78816c048);
$parcel$export(module.exports, "CARD_COVERS_TYPE", () => $15ed10c690a013f2$export$f5583ff4ab4d63e5);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $15ed10c690a013f2$export$5716e8bcb003888d);
$parcel$export(module.exports, "STORY_POINTS_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$1f9fb9f15184100f);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$c72ea455b368cdd9);

const $15ed10c690a013f2$export$8386e51ba415e85d = (0, $44cab0426b6cf0d7$export$1dee026a19752d6b);
const $15ed10c690a013f2$export$159fe44438c210e9 = '48x48';
const $15ed10c690a013f2$export$d8301e0b33832d94 = 'filter';
const $15ed10c690a013f2$export$599c163c1570a353 = 'inlineCreate';
const $15ed10c690a013f2$export$3a74d1a195d2f007 = 'inviteOpen';
const $15ed10c690a013f2$export$e1e3f9fa6f04d6d = 'quickFilters';
const $15ed10c690a013f2$export$c070acdc9b0f1be5 = 'selectedIssue';
const $15ed10c690a013f2$export$3bcbd99d0f9ad6d8 = 'selectedComment';
const $15ed10c690a013f2$export$dba794af6c0f2afc = 'assignee';
const $15ed10c690a013f2$export$56ecb5d2dfb80edc = 'priority';
const $15ed10c690a013f2$export$22ef551f315f2786 = 'category';
const $15ed10c690a013f2$export$6d69efb296b78a = 'status';
const $15ed10c690a013f2$export$e23e1d1ea45171c2 = 'startdate';
const $15ed10c690a013f2$export$e35c6e217c75dc4b = 'rank';
const $15ed10c690a013f2$export$e5eab344feb92af9 = 'remoteIssueLinks';
const $15ed10c690a013f2$export$a311e1b78816c048 = 'commentsummary';
const $15ed10c690a013f2$export$f5583ff4ab4d63e5 = 'cardCovers';
const $15ed10c690a013f2$export$5716e8bcb003888d = 25;
const $15ed10c690a013f2$export$1f9fb9f15184100f = 'storypoints';
const $15ed10c690a013f2$export$c72ea455b368cdd9 = 'storypointestimate';
const $15ed10c690a013f2$export$786b42b4618e6ee4 = 'sprint';
const $15ed10c690a013f2$export$1778b00a1b1bdb85 = 25;

});
const $44cab0426b6cf0d7$export$1dee026a19752d6b = 'ASC';
const $44cab0426b6cf0d7$export$b6abcf7fa1d94f65 = 'DESC';


parcelRegister("khRV9", function(module, exports) {

$parcel$export(module.exports, "createSimplePreference", () => $462fa2c618ea906f$export$464a71be397e5f3d);
$parcel$export(module.exports, "createSimpleUrlPreference", () => $462fa2c618ea906f$export$78f3983105936d30);

var $3QMTK = parcelRequire("3QMTK");
const $462fa2c618ea906f$export$464a71be397e5f3d = (id)=>({
        id: id,
        serialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))),
        deserialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
    });
const $462fa2c618ea906f$export$78f3983105936d30 = (queryParameter)=>({
        id: queryParameter,
        serialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))),
        deserialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))),
        queryParameter: {
            serialize: (value)=>({
                    [queryParameter]: value
                }),
            deserialize: (value)=>value[queryParameter]
        }
    });

});


parcelRegister("7c3W1", function(module, exports) {

$parcel$export(module.exports, "ViewPreferencesProvider", () => $6117ab20ad9a3ccd$export$1db44e21d818b27);
$parcel$export(module.exports, "useViewPreference", () => $6117ab20ad9a3ccd$export$ee494de6c0ff45d7);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $fDLFb = parcelRequire("fDLFb");

var $hzcvF = parcelRequire("hzcvF");

var $lB25E = parcelRequire("lB25E");

var $6YT9E = parcelRequire("6YT9E");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $6117ab20ad9a3ccd$var$ViewPreferencesContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $6117ab20ad9a3ccd$export$1db44e21d818b27 = ({ view: view, preferences: preferences, children: children, persistChanges: persistChanges = true })=>{
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const [{ query: query }, routerActions] = (0, $lB25E.useRouter)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { updateQueryParam: updateQueryParam } = routerActions;
    const prevQuery = (0, $hzcvF.usePreviousWithInitial)(query);
    const [store, setStore] = (0, $eUqFw.useState)(()=>preferences.reduce((acc, preference)=>{
            let value;
            const { id: id, queryParameter: queryParameter } = preference;
            // if the URL has a preference value set
            // we prioritize those values over the persisted ones
            const queryValue = queryParameter && queryParameter.deserialize(query);
            if (queryValue) value = queryValue;
            else if (persistChanges) // if the view is persisting changes, restore the preferences from local storage
            value = preference.deserialize((0, $6YT9E.getPreference)(entity.id, view, preference.id));
            acc[id] = value;
            return acc;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        }, {}));
    const setPreferenceValue = (0, $eUqFw.useCallback)((preference, value, action)=>{
        // set the new preference value in the store
        setStore((prevStore)=>{
            const newStore = {
                ...prevStore,
                [preference.id]: value
            };
            return newStore;
        });
        // if the preference serialises to the URL, update the URL
        if (preference.queryParameter && action !== 'none') updateQueryParam(preference.queryParameter.serialize(value), action);
        // if the view is persisting changes, update the preference in local storage
        if (persistChanges) {
            const serializedValue = preference.serialize(value);
            (0, $6YT9E.setPreference)(entity.id, view, preference.id, serializedValue);
        }
    }, [
        persistChanges,
        updateQueryParam,
        entity.id,
        view
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // if the view is persisting changes, on initial mount
        // check all preferences that serialise to the URL, and set their values to the URL
        if (!persistChanges) return;
        let restoredQuery = {};
        for (const preference of preferences){
            const value = store[preference.id];
            if (value && preference.queryParameter) restoredQuery = {
                ...restoredQuery,
                ...preference.queryParameter.serialize(value)
            };
        }
        updateQueryParam({
            ...restoredQuery,
            ...query
        }, 'replace');
    // only run this effect on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        // this effect updates the store value only when the query has changed
        // we shouldn't run it when the component is mounting the first time
        // or when the query hasn't changed
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(prevQuery, query)) {
            // update the store if the query is updated
            const newState = preferences.reduce((acc, preference)=>{
                const { id: id, queryParameter: queryParameter } = preference;
                if (queryParameter) {
                    const queryValue = queryParameter.deserialize(query);
                    acc[id] = queryValue;
                }
                return acc;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            }, {});
            setStore({
                ...store,
                ...newState
            });
        }
    }, [
        preferences,
        query,
        store,
        entity.id,
        view,
        prevQuery
    ]);
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            store: store,
            setPreferenceValue: setPreferenceValue
        }), [
        store,
        setPreferenceValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6117ab20ad9a3ccd$var$ViewPreferencesContext.Provider, {
        value: contextValue
    }, children);
};
const $6117ab20ad9a3ccd$export$ee494de6c0ff45d7 = (preference)=>{
    const { store: store, setPreferenceValue: setPreferenceValue } = (0, $eUqFw.useContext)($6117ab20ad9a3ccd$var$ViewPreferencesContext);
    const setValue = (0, $eUqFw.useCallback)((value, action = 'push')=>{
        setPreferenceValue(preference, value, action);
    }, [
        preference,
        setPreferenceValue
    ]);
    const value = store[preference.id];
    return [
        value,
        setValue
    ];
};

});
parcelRegister("6YT9E", function(module, exports) {

$parcel$export(module.exports, "setPreference", () => $e32968ac8498b8dc$export$c6483f3cdc3e51e1);
$parcel$export(module.exports, "getPreference", () => $e32968ac8498b8dc$export$5fa261395d19a143);

var $aZaPn = parcelRequire("aZaPn");
const $e32968ac8498b8dc$var$store = (0, $aZaPn.createLocalStorageProvider)('jwm-view-preferences');
const $e32968ac8498b8dc$var$buildPreferenceKey = (entityId, viewId, preferenceId)=>`${entityId}_${viewId}_${preferenceId}`;
const $e32968ac8498b8dc$export$c6483f3cdc3e51e1 = (entityId, viewId, preferenceId, value)=>{
    const key = $e32968ac8498b8dc$var$buildPreferenceKey(entityId, viewId, preferenceId);
    $e32968ac8498b8dc$var$store.set(key, value);
};
const $e32968ac8498b8dc$export$5fa261395d19a143 = (entityId, viewId, preferenceId)=>{
    const key = $e32968ac8498b8dc$var$buildPreferenceKey(entityId, viewId, preferenceId);
    return $e32968ac8498b8dc$var$store.get(key);
};

});


parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("Heqyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e52e256f1a55722d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lRRdT = parcelRequire("lRRdT");

var $7T0RP = parcelRequire("7T0RP");

var $yuXsW = parcelRequire("yuXsW");

var $7e8pf = parcelRequire("7e8pf");

var $fAoR8 = parcelRequire("fAoR8");

var $3555e = parcelRequire("3555e");

var $hJYsP = parcelRequire("hJYsP");

var $cWd72 = parcelRequire("cWd72");

var $4G5xU = parcelRequire("4G5xU");

var $fvzkg = parcelRequire("fvzkg");

var $d3C6e = parcelRequire("d3C6e");

var $c7wtc = parcelRequire("c7wtc");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $ib4WI = parcelRequire("ib4WI");

var $bFk6h = parcelRequire("bFk6h");

var $dtXTv = parcelRequire("dtXTv");

var $iLiDV = parcelRequire("iLiDV");

var $gWYTK = parcelRequire("gWYTK");

var $bJNjm = parcelRequire("bJNjm");

var $bZapc = parcelRequire("bZapc");

var $gKXju = parcelRequire("gKXju");

var $ay4XV = parcelRequire("ay4XV");

var $cgK6s = parcelRequire("cgK6s");

var $iq40z = parcelRequire("iq40z");

var $hppqk = parcelRequire("hppqk");

var $8Tm3w = parcelRequire("8Tm3w");

var $3ImR7 = parcelRequire("3ImR7");

var $l3fLv = parcelRequire("l3fLv");

var $9FDwo = parcelRequire("9FDwo");

var $lQ65S = parcelRequire("lQ65S");
const $e52e256f1a55722d$var$analyticsSourceName = 'board';
const $e52e256f1a55722d$var$FireScreenAnalyticsWithIssueLinksAttributes = ()=>{
    const selectedFields = (0, $bZapc.useSelectedFields)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            withIssueLinks: Boolean(selectedFields[0, $lO4Or.ISSUE_LINKS_TYPE])
        }
    });
};
const $e52e256f1a55722d$var$BoardWithWorkflowsData = ()=>{
    const { workflows: workflows } = (0, $iq40z.useWorkflowStoreState)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const services = (0, $eI5EY.fg)('use-generated-types-for-create-issue') ? (0, $8Tm3w.useCreateIssue)() : undefined;
    const workflowsProviderWorkflows = (0, $eUqFw.useMemo)(()=>workflows.map((0, $lQ65S.transformWorkflow)), [
        workflows
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c7wtc.WorkflowsProvider), {
        workflows: workflowsProviderWorkflows
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d3C6e.IssueCreateProvider), {
        mutation: (0, $3ImR7.CREATE_ISSUE_MUTATION),
        query: (0, $3ImR7.ISSUE_REFETCH_QUERY),
        onCreateIssue: services?.createIssue,
        onRefetchIssue: services?.refetchIssue,
        ignoreFiltersContext: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        objectType: "jwmBoard",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: $e52e256f1a55722d$var$analyticsSourceName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fvzkg.DeserialisedFiltersProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cgK6s.WorkflowActionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dtXTv.IssueStoreContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bJNjm.ColumnDragDropProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gWYTK.CardDragDropProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gKXju.GroupsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bFk6h.BoardDataProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ay4XV.IssueTransitionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLiDV.ConfettiColumnsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9FDwo.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3fLv.default), null))))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e52e256f1a55722d$var$FireScreenAnalyticsWithIssueLinksAttributes, null)))));
};
const $e52e256f1a55722d$export$38c311e2746e0f8b = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const pageHeading = formatMessage((0, $hppqk.default).boardHeading);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJYsP.BusinessDocumentTitle), {
        pageHeading: pageHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7e8pf.default), {
        withSidebar: true,
        withOverflow: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yuXsW.ApolloClientProvider), {
        client: (0, $7T0RP.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cWd72.IssueTypesAndFieldsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iq40z.WorkflowStoreContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e52e256f1a55722d$var$BoardWithWorkflowsData, null))))));
});
const $e52e256f1a55722d$var$BoardViewRootWithSmartCard = ()=>{
    const hasConfluence = (0, $3555e.useTenantHasConfluence)();
    if (hasConfluence) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRRdT.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fAoR8.ConfluenceModalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e52e256f1a55722d$export$38c311e2746e0f8b, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e52e256f1a55722d$export$38c311e2746e0f8b, null);
};
const $e52e256f1a55722d$var$Board = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceErrorBoundary), {
        experience: (0, $ib4WI.VIEW_EXPERIENCE),
        shouldStartExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e52e256f1a55722d$var$BoardViewRootWithSmartCard, null));
var $e52e256f1a55722d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($e52e256f1a55722d$var$Board);

});
parcelRegister("lRRdT", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", () => $facab1608d537f47$export$497ecb0280204df4);

var $eUqFw = parcelRequire("eUqFw");

var $huRi7 = parcelRequire("huRi7");

var $fiHr8 = parcelRequire("fiHr8");

var $710WT = parcelRequire("710WT");

var $50mMw = parcelRequire("50mMw");

var $z3HJw = parcelRequire("z3HJw");

var $juhhD = parcelRequire("juhhD");
function $facab1608d537f47$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
    const parentContext = (0, $eUqFw.useContext)((0, $z3HJw.SmartCardContext));
    const defaultInitialState = (0, $eUqFw.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $eUqFw.useMemo)(()=>{
        return (0, $huRi7.createStore)((0, $50mMw.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $eUqFw.useMemo)(()=>{
        const client = customClient || new (0, $juhhD.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, platform)=>{
            const cardState = (0, $fiHr8.getUrl)(store, url);
            return cardState.details ? (0, $710WT.extractPreview)(cardState.details.data, platform) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            featureFlags: featureFlags,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product
        };
    }, [
        customClient,
        customAuthFlow,
        isAdminHubAIEnabled,
        product,
        renderers,
        featureFlags,
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $z3HJw.SmartCardContext).Provider, {
        value: parentContext || providerValue
    }, children);
}
var $facab1608d537f47$export$2e2bcd8739ae039 = $facab1608d537f47$export$497ecb0280204df4;

});
parcelRegister("fiHr8", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $01bd0ce4d530f38b$export$94df0e59ebebf4a7);
const $01bd0ce4d530f38b$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("710WT", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $17aa594542d67b06$export$4b0d98b1b7f6d115);

var $gvq81 = parcelRequire("gvq81");

var $llIUz = parcelRequire("llIUz");
const $17aa594542d67b06$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $gvq81.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $llIUz.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $llIUz.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("gvq81", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $9762fea1a314f0a2$export$3e8ad908070b68b2);
const $9762fea1a314f0a2$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});

parcelRegister("llIUz", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $c157ff8f6fdf1fb2$export$396ba4ef2e37dc65);
const $c157ff8f6fdf1fb2$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $c157ff8f6fdf1fb2$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});


parcelRegister("50mMw", function(module, exports) {

$parcel$export(module.exports, "cardReducer", () => $ea5bdde2f0d6a214$export$3c7c3113a97b6492);

var $Cb2tk = parcelRequire("Cb2tk");
var $e4YBr = parcelRequire("e4YBr");
const $ea5bdde2f0d6a214$var$isCardAction = (action)=>{
    return [
        (0, $Cb2tk.ACTION_PENDING),
        (0, $Cb2tk.ACTION_RESOLVING),
        (0, $Cb2tk.ACTION_RESOLVED),
        (0, $Cb2tk.ACTION_RELOADING),
        (0, $Cb2tk.ACTION_ERROR),
        (0, $Cb2tk.ACTION_ERROR_FALLBACK),
        (0, $Cb2tk.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $ea5bdde2f0d6a214$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $e4YBr.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $ea5bdde2f0d6a214$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $Cb2tk.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $Cb2tk.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $Cb2tk.ACTION_RESOLVED:
            return $ea5bdde2f0d6a214$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $Cb2tk.ACTION_RELOADING:
            return $ea5bdde2f0d6a214$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $Cb2tk.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $Cb2tk.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $Cb2tk.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $ea5bdde2f0d6a214$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$ea5bdde2f0d6a214$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $ea5bdde2f0d6a214$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});
parcelRegister("Cb2tk", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $8e74ca73501edb77$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $8e74ca73501edb77$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $8e74ca73501edb77$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $8e74ca73501edb77$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $8e74ca73501edb77$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $8e74ca73501edb77$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $8e74ca73501edb77$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $8e74ca73501edb77$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $8e74ca73501edb77$export$6e470aad5ba8952e = 'pending';
const $8e74ca73501edb77$export$9a6a932a0a39498e = 'resolving';
const $8e74ca73501edb77$export$63ec8bc7a8a75482 = 'resolved';
const $8e74ca73501edb77$export$b8cfaa842c9ab487 = 'reloading';
const $8e74ca73501edb77$export$6d8ed3f9433dd372 = 'errored';
const $8e74ca73501edb77$export$cfbbb7126bc8a0c6 = 'fallback';
const $8e74ca73501edb77$export$76b5c1aca20759c6 = 'preload';
const $8e74ca73501edb77$export$2c5edb971b673330 = 'metadata';
const $8e74ca73501edb77$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("e4YBr", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $158855c194185e26$export$b70265791d2079d4);
const $158855c194185e26$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $158855c194185e26$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $158855c194185e26$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});


parcelRegister("z3HJw", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $ab13c94fa77cdc1c$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $ab13c94fa77cdc1c$export$e1d190b530cf0ee9);

var $eUqFw = parcelRequire("eUqFw");

const $ab13c94fa77cdc1c$export$156b523e63b4f63a = (0, $eUqFw.createContext)(undefined);
function $ab13c94fa77cdc1c$export$e1d190b530cf0ee9() {
    const context = (0, $eUqFw.useContext)($ab13c94fa77cdc1c$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
var $ab13c94fa77cdc1c$export$2e2bcd8739ae039 = $ab13c94fa77cdc1c$export$156b523e63b4f63a;

});

parcelRegister("juhhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c186cbc32ad3159$export$2e2bcd8739ae039);

var $1l2Nv = parcelRequire("1l2Nv");

var $aTD8J = parcelRequire("aTD8J");

var $bsIpz = parcelRequire("bsIpz");

var $6Z5Gl = parcelRequire("6Z5Gl");
var $5YG4y = parcelRequire("5YG4y");
var $e4YBr = parcelRequire("e4YBr");
var $eEJIz = parcelRequire("eEJIz");

var $i1ewH = parcelRequire("i1ewH");

var $6roQF = parcelRequire("6roQF");
const $6c186cbc32ad3159$var$MAX_BATCH_SIZE = 50;
const $6c186cbc32ad3159$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $6c186cbc32ad3159$var$URL_RESPONSE_CACHE_SIZE = 100;
const $6c186cbc32ad3159$export$d6a66073b5d79eb3 = new (0, $6roQF.LRUMap)($6c186cbc32ad3159$var$URL_RESPONSE_CACHE_SIZE);
class $6c186cbc32ad3159$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $eEJIz.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $eEJIz.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $i1ewH.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $5YG4y.getResolverUrl)(envKey, baseUrlOverride);
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($bsIpz)))({
            limit: 1,
            interval: $6c186cbc32ad3159$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($1l2Nv)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $6c186cbc32ad3159$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $6c186cbc32ad3159$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            responsePromise = loader.load(url);
            $6c186cbc32ad3159$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $6c186cbc32ad3159$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $i1ewH.isSuccessfulResponse)(response) || (0, $e4YBr.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $6c186cbc32ad3159$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $i1ewH.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $i1ewH.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $i1ewH.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $i1ewH.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $eEJIz.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $eEJIz.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $i1ewH.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $eEJIz.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $eEJIz.NetworkError)) return new (0, $6Z5Gl.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $6Z5Gl.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $6Z5Gl.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    return new (0, $6Z5Gl.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $6Z5Gl.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $6Z5Gl.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("1l2Nv", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $0f99ec2102c35890$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $0f99ec2102c35890$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $0f99ec2102c35890$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $0f99ec2102c35890$var$getValidCacheKeyFn(options);
        this._cacheMap = $0f99ec2102c35890$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $0f99ec2102c35890$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $0f99ec2102c35890$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$0f99ec2102c35890$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $0f99ec2102c35890$var$enqueuePostPromiseJob = typeof $2fFJv === 'object' && typeof $2fFJv.nextTick === 'function' ? function(fn) {
    if (!$0f99ec2102c35890$var$resolvedPromise) $0f99ec2102c35890$var$resolvedPromise = Promise.resolve();
    $0f99ec2102c35890$var$resolvedPromise.then(function() {
        $2fFJv.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $0f99ec2102c35890$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $0f99ec2102c35890$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $0f99ec2102c35890$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $0f99ec2102c35890$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $0f99ec2102c35890$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $0f99ec2102c35890$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $0f99ec2102c35890$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$0f99ec2102c35890$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $0f99ec2102c35890$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $0f99ec2102c35890$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $0f99ec2102c35890$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $0f99ec2102c35890$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $0f99ec2102c35890$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $0f99ec2102c35890$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $0f99ec2102c35890$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $0f99ec2102c35890$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $0f99ec2102c35890$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $0f99ec2102c35890$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $0f99ec2102c35890$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $0f99ec2102c35890$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $0f99ec2102c35890$var$DataLoader;

});

parcelRegister("aTD8J", function(module, exports) {
// Packages

var $kiPA0 = parcelRequire("kiPA0");
function $7eed66c63d4af541$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        var op = $kiPA0.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $7eed66c63d4af541$var$retry;

});
parcelRegister("kiPA0", function(module, exports) {

module.exports = (parcelRequire("2aMUW"));

});
parcelRegister("2aMUW", function(module, exports) {

var $6ZiEJ = parcelRequire("6ZiEJ");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $6ZiEJ(timeouts, {
        forever: options && options.forever,
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("6ZiEJ", function(module, exports) {
function $5166e949108ea881$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $5166e949108ea881$var$RetryOperation;
$5166e949108ea881$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts;
};
$5166e949108ea881$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$5166e949108ea881$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(this._errors.length - 1, this._errors.length);
            this._timeouts = this._cachedTimeouts.slice(0);
            timeout = this._timeouts.shift();
        } else return false;
    }
    var self = this;
    var timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) timer.unref();
    return true;
};
$5166e949108ea881$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$5166e949108ea881$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = $5166e949108ea881$var$RetryOperation.prototype.try;
$5166e949108ea881$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$5166e949108ea881$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$5166e949108ea881$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("bsIpz", function(module, exports) {
'use strict';
class $8584c26edaaf8f93$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $8584c26edaaf8f93$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $8584c26edaaf8f93$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $8584c26edaaf8f93$var$pThrottle;
module.exports.AbortError = $8584c26edaaf8f93$var$AbortError;

});

parcelRegister("6Z5Gl", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $605dfd18750940b5$export$3e5b797e39668f84);
class $605dfd18750940b5$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`);
        this.kind = kind;
        this.hostname = hostname;
        this.message = message;
        this.type = type;
        this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("5YG4y", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $fddc2bc0399fc859$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $fddc2bc0399fc859$export$dc37652c1696f231);
const $fddc2bc0399fc859$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $fddc2bc0399fc859$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $fddc2bc0399fc859$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $fddc2bc0399fc859$export$e2b040f052407032 = {
    dev: $fddc2bc0399fc859$var$devBaseUrl,
    development: $fddc2bc0399fc859$var$devBaseUrl,
    stg: $fddc2bc0399fc859$var$stgBaseUrl,
    staging: $fddc2bc0399fc859$var$stgBaseUrl,
    prd: $fddc2bc0399fc859$var$prodBaseUrl,
    prod: $fddc2bc0399fc859$var$prodBaseUrl,
    production: $fddc2bc0399fc859$var$prodBaseUrl
};
const $fddc2bc0399fc859$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $fddc2bc0399fc859$export$e2b040f052407032 ? $fddc2bc0399fc859$export$e2b040f052407032[envKey] : $fddc2bc0399fc859$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $fddc2bc0399fc859$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $fddc2bc0399fc859$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $fddc2bc0399fc859$export$2e2bcd8739ae039 = $fddc2bc0399fc859$export$e2b040f052407032;

});

parcelRegister("eEJIz", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $e6aea31400544ea8$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $e6aea31400544ea8$export$b5fe3f66a567bec0);
const $e6aea31400544ea8$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $e6aea31400544ea8$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $e6aea31400544ea8$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $e6aea31400544ea8$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $e6aea31400544ea8$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("i1ewH", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", () => $e727902595b0bd7e$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $e727902595b0bd7e$export$bea7bee8a87e7c52);
const $e727902595b0bd7e$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $e727902595b0bd7e$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});

parcelRegister("6roQF", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});



parcelRegister("7T0RP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e42cc5e4608d3fe0$export$2e2bcd8739ae039);

var $illlw = parcelRequire("illlw");

var $2vRh6 = parcelRequire("2vRh6");

var $jlBDe = parcelRequire("jlBDe");

var $bvQX6 = parcelRequire("bvQX6");

var $aqG9W = parcelRequire("aqG9W");

var $35Kb7 = parcelRequire("35Kb7");

var $kcwGc = parcelRequire("kcwGc");

var $10n8H = parcelRequire("10n8H");

var $gUUjF = parcelRequire("gUUjF");

var $9IbeZ = parcelRequire("9IbeZ");

var $iV2Ac = parcelRequire("iV2Ac");

var $1ZkL6 = parcelRequire("1ZkL6");

const $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $e42cc5e4608d3fe0$var$CACHE_NAME = `apollo-cache/${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}`;
const $e42cc5e4608d3fe0$var$LOG_NAMESPACE = `apollo.${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $e42cc5e4608d3fe0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $e42cc5e4608d3fe0$export$851a7159daf49c89 = new (0, $2vRh6.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($iV2Ac))
});
const $e42cc5e4608d3fe0$var$errorLink = (0, $aqG9W.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $1ZkL6.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $1ZkL6.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(operation.getContext(), [
            $e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $e42cc5e4608d3fe0$var$retryLinkWithFama = new (0, $kcwGc.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $1ZkL6.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $e42cc5e4608d3fe0$var$CancelableRequestLink extends (0, $bvQX6.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $bvQX6.Observable)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $e42cc5e4608d3fe0$var$cache = new (0, $2vRh6.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $10n8H.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $e42cc5e4608d3fe0$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
})// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
.restore(!$e42cc5e4608d3fe0$var$isSsrSuccessful() && window.SPA_STATE[$e42cc5e4608d3fe0$var$CACHE_NAME] || {});
const $e42cc5e4608d3fe0$export$de66868aab9e79ea = (baseUrl)=>new (0, $jlBDe.ApolloClient)({
        name: $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $e42cc5e4608d3fe0$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $bvQX6.ApolloLink).from([
            $e42cc5e4608d3fe0$var$retryLinkWithFama,
            $e42cc5e4608d3fe0$var$errorLink,
            (0, $9IbeZ.UFOLoggerLink),
            (0, $10n8H.fragmentLinkState)($e42cc5e4608d3fe0$var$cache),
            ...!$e42cc5e4608d3fe0$var$isSsrSuccessful() ? [
                new $e42cc5e4608d3fe0$var$CancelableRequestLink()
            ] : [],
            new (0, $35Kb7.HttpLink)({
                uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$e42cc5e4608d3fe0$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $e42cc5e4608d3fe0$var$cache,
        connectToDevTools: false
    });
var $e42cc5e4608d3fe0$export$2e2bcd8739ae039 = {
    clientId: $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $e42cc5e4608d3fe0$export$de66868aab9e79ea
};

});
parcelRegister("2vRh6", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $1d47cd4d9b8db33d$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $1d47cd4d9b8db33d$export$467265324939f47f);

var $fKE23 = parcelRequire("fKE23");

var $bO1Qv = parcelRequire("bO1Qv");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $7xYai = parcelRequire("7xYai");

var $8j2fP = parcelRequire("8j2fP");
var $1d47cd4d9b8db33d$var$haveWarned = false;
function $1d47cd4d9b8db33d$var$shouldWarn() {
    var answer = !$1d47cd4d9b8db33d$var$haveWarned;
    if (!(0, $42BH7.isTest)()) $1d47cd4d9b8db33d$var$haveWarned = true;
    return answer;
}
var $1d47cd4d9b8db33d$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $1d47cd4d9b8db33d$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $1d47cd4d9b8db33d$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $1d47cd4d9b8db33d$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $8j2fP.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $8j2fP.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $1d47cd4d9b8db33d$var$hasOwn = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $7xYai.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($1d47cd4d9b8db33d$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$1d47cd4d9b8db33d$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory(seed) {
    return new $1d47cd4d9b8db33d$var$DepTrackingCache(seed);
}
var $1d47cd4d9b8db33d$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $7xYai.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $7xYai.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $7xYai.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $42BH7.getQueryDefinition)(query);
        variables = (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $8j2fP.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $66hGB.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $42BH7.getMainDefinition)(query);
        var fragments = (0, $42BH7.getFragmentDefinitions)(query);
        var fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $8j2fP.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $42BH7.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $42BH7.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $42BH7.resultKeyNameFromField)(field),
            directives: (0, $42BH7.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $42BH7.isIdValue)(value)) throw new (0, $8j2fP.InvariantError)(10);
}
function $1d47cd4d9b8db33d$var$defaultFragmentMatcher() {
    return true;
}
function $1d47cd4d9b8db33d$export$7a4899fe13f33235(idValue) {
    (0, $8j2fP.invariant)((0, $42BH7.isIdValue)(idValue), 11);
}
function $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $42BH7.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $42BH7.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $42BH7.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $1d47cd4d9b8db33d$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $1d47cd4d9b8db33d$export$7e2b40d1002de152(seed) {
    return new $1d47cd4d9b8db33d$export$ee7258b8691956a3(seed);
}
var $1d47cd4d9b8db33d$export$de4e6870dc6ac801 = function(_super) {
    (0, $fKE23.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $1d47cd4d9b8db33d$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $1d47cd4d9b8db33d$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $1d47cd4d9b8db33d$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $42BH7.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $42BH7.createFragmentMap)((0, $42BH7.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $1d47cd4d9b8db33d$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var resultFieldKey = (0, $42BH7.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $8j2fP.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $42BH7.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $1d47cd4d9b8db33d$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $42BH7.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $42BH7.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$1d47cd4d9b8db33d$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $8j2fP.invariant)(!semanticId || !$1d47cd4d9b8db33d$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $42BH7.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $42BH7.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $8j2fP.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $8j2fP.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $1d47cd4d9b8db33d$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $66hGB.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $42BH7.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $1d47cd4d9b8db33d$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $1d47cd4d9b8db33d$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $42BH7.isIdValue)(value) && $1d47cd4d9b8db33d$var$isGeneratedId(value.id) && (0, $42BH7.isIdValue)(realValue) && !(0, $66hGB.equal)(value, realValue) && $1d47cd4d9b8db33d$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, generated), real);
    if ((0, $66hGB.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $1d47cd4d9b8db33d$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $1d47cd4d9b8db33d$var$defaultConfig = {
    fragmentMatcher: new $1d47cd4d9b8db33d$export$5d3fcf53267091de(),
    dataIdFromObject: $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $1d47cd4d9b8db33d$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$OptimisticCacheLayer = function(_super) {
    (0, $fKE23.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $1d47cd4d9b8db33d$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($1d47cd4d9b8db33d$export$ee7258b8691956a3);
var $1d47cd4d9b8db33d$export$467265324939f47f = function(_super) {
    (0, $fKE23.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $1d47cd4d9b8db33d$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $1d47cd4d9b8db33d$var$DepTrackingCache() : new $1d47cd4d9b8db33d$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $1d47cd4d9b8db33d$export$eb8361c5d132fb8f();
        _this.storeReader = new $1d47cd4d9b8db33d$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $7xYai.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $8j2fP.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $1d47cd4d9b8db33d$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $1d47cd4d9b8db33d$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $42BH7.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $bO1Qv.ApolloCache));

});
parcelRegister("bO1Qv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $8985cbc47a37b971$export$5fc74f25506aa9c);

var $42BH7 = parcelRequire("42BH7");
function $8985cbc47a37b971$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $8985cbc47a37b971$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $8985cbc47a37b971$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $8985cbc47a37b971$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $8985cbc47a37b971$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $8985cbc47a37b971$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $8985cbc47a37b971$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $8985cbc47a37b971$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $8985cbc47a37b971$export$94affb487e701bf2;
$8985cbc47a37b971$export$94affb487e701bf2 || ($8985cbc47a37b971$export$94affb487e701bf2 = {});

});

parcelRegister("7xYai", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $57ea48f9f955816f$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $57ea48f9f955816f$export$4997ffc0176396a6);

var $182fv = parcelRequire("182fv");
function $57ea48f9f955816f$var$defaultDispose() {}
var $57ea48f9f955816f$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $57ea48f9f955816f$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $57ea48f9f955816f$var$parentEntrySlot = new (0, $182fv.Slot)();
var $57ea48f9f955816f$var$reusableEmptyArray = [];
var $57ea48f9f955816f$var$emptySetPool = [];
var $57ea48f9f955816f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $57ea48f9f955816f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $57ea48f9f955816f$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $57ea48f9f955816f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $57ea48f9f955816f$var$valueCopy(value) {
    return value.slice(0);
}
var $57ea48f9f955816f$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $57ea48f9f955816f$var$assert(!this.recomputing, "already recomputing");
        if (!$57ea48f9f955816f$var$rememberParent(this) && $57ea48f9f955816f$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $57ea48f9f955816f$var$mightBeDirty(this) ? $57ea48f9f955816f$var$reallyRecompute(this) : $57ea48f9f955816f$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $57ea48f9f955816f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $57ea48f9f955816f$var$forgetChildren(this).forEach($57ea48f9f955816f$var$maybeReportOrphan);
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $57ea48f9f955816f$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $57ea48f9f955816f$var$rememberParent(child) {
    var parent = $57ea48f9f955816f$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($57ea48f9f955816f$var$mightBeDirty(child)) $57ea48f9f955816f$var$reportDirtyChild(parent, child);
        else $57ea48f9f955816f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $57ea48f9f955816f$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $57ea48f9f955816f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $57ea48f9f955816f$var$parentEntrySlot.withValue(entry, $57ea48f9f955816f$var$recomputeNewValue, [
        entry
    ]);
    if ($57ea48f9f955816f$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $57ea48f9f955816f$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($57ea48f9f955816f$var$maybeReportOrphan);
    return $57ea48f9f955816f$var$valueGet(entry.value);
}
function $57ea48f9f955816f$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $57ea48f9f955816f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $57ea48f9f955816f$var$setClean(entry) {
    entry.dirty = false;
    if ($57ea48f9f955816f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $57ea48f9f955816f$var$reportClean(entry);
}
function $57ea48f9f955816f$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportDirtyChild(parent, child);
    });
}
function $57ea48f9f955816f$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $57ea48f9f955816f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert($57ea48f9f955816f$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $57ea48f9f955816f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $57ea48f9f955816f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $57ea48f9f955816f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert(!$57ea48f9f955816f$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $57ea48f9f955816f$var$valueCopy(child.value));
    else if (!$57ea48f9f955816f$var$valueIs(childValue, child.value)) parent.setDirty();
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
    if ($57ea48f9f955816f$var$mightBeDirty(parent)) return;
    $57ea48f9f955816f$var$reportClean(parent);
}
function $57ea48f9f955816f$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($57ea48f9f955816f$var$emptySetPool.length < $57ea48f9f955816f$var$POOL_TARGET_SIZE) $57ea48f9f955816f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $57ea48f9f955816f$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $57ea48f9f955816f$var$forgetChildren(parent) {
    var children = $57ea48f9f955816f$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $57ea48f9f955816f$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $57ea48f9f955816f$var$assert(parent.dirtyChildren === null);
    return children;
}
function $57ea48f9f955816f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
}
function $57ea48f9f955816f$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $57ea48f9f955816f$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $57ea48f9f955816f$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $57ea48f9f955816f$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $57ea48f9f955816f$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $57ea48f9f955816f$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $57ea48f9f955816f$var$keyTrie = new $57ea48f9f955816f$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $57ea48f9f955816f$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $57ea48f9f955816f$var$keyTrie.lookupArray(args);
}
var $57ea48f9f955816f$var$caches = new Set();
function $57ea48f9f955816f$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $57ea48f9f955816f$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $57ea48f9f955816f$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$57ea48f9f955816f$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $57ea48f9f955816f$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $57ea48f9f955816f$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$57ea48f9f955816f$var$parentEntrySlot.hasValue()) {
            $57ea48f9f955816f$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $57ea48f9f955816f$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("182fv", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $0d28486785009faf$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $0d28486785009faf$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $0d28486785009faf$var$MISSING_VALUE = {};
var $0d28486785009faf$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $0d28486785009faf$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $0d28486785009faf$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $0d28486785009faf$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $0d28486785009faf$var$MISSING_VALUE) break;
                if (context_1 !== $0d28486785009faf$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $0d28486785009faf$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($0d28486785009faf$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $0d28486785009faf$var$currentContext.slots[this.id] = $0d28486785009faf$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $0d28486785009faf$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $0d28486785009faf$var$currentContext;
            $0d28486785009faf$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $0d28486785009faf$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $0d28486785009faf$var$currentContext;
            return function() {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($0d28486785009faf$var$currentContext) {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $0d28486785009faf$var$globalKey = "@wry/context:Slot";
var $0d28486785009faf$var$host = Array;
var $0d28486785009faf$export$8c6ed5c666ac1360 = $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] || function() {
    var Slot = $0d28486785009faf$var$makeSlotClass();
    try {
        Object.defineProperty($0d28486785009faf$var$host, $0d28486785009faf$var$globalKey, {
            value: $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $0d28486785009faf$export$2385a24977818dd0 = $0d28486785009faf$export$8c6ed5c666ac1360.bind, $0d28486785009faf$export$9fa6f2e300a97f8 = $0d28486785009faf$export$8c6ed5c666ac1360.noContext;
function $0d28486785009faf$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($0d28486785009faf$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $0d28486785009faf$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $0d28486785009faf$export$2385a24977818dd0(gen.next);
        var boundThrow = $0d28486785009faf$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($0d28486785009faf$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $0d28486785009faf$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $0d28486785009faf$var$wrappedFibers = [];
function $0d28486785009faf$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($0d28486785009faf$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $0d28486785009faf$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $0d28486785009faf$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("aqG9W", function(module, exports) {

$parcel$export(module.exports, "onError", () => $797d090cd04ee84b$export$2288787135a8f66e);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
function $797d090cd04ee84b$export$2288787135a8f66e(errorHandler) {
    return new (0, $bvQX6.ApolloLink)(function(operation, forward) {
        return new (0, $bvQX6.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $797d090cd04ee84b$export$d2c8415987899609 = function(_super) {
    (0, $fKE23.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $797d090cd04ee84b$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("35Kb7", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $2405a8c9bbd1579c$export$f4bbf1aec241cc1);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");

var $cp9eN = parcelRequire("cp9eN");
var $2405a8c9bbd1579c$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $fKE23.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $cp9eN.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $bvQX6.ApolloLink)(function(operation) {
        var chosenURI = (0, $cp9eN.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $fKE23.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $cp9eN.selectHttpOptionsAndBody)(operation, (0, $cp9eN.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $cp9eN.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $bvQX6.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $cp9eN.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $bvQX6.fromError)(parseError);
        }
        return new (0, $bvQX6.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $cp9eN.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $cp9eN.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $cp9eN.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $2405a8c9bbd1579c$export$f4bbf1aec241cc1 = function(_super) {
    (0, $fKE23.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $2405a8c9bbd1579c$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $bvQX6.ApolloLink));

});
parcelRegister("cp9eN", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $907efc3a22e8ac51$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $907efc3a22e8ac51$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $907efc3a22e8ac51$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $907efc3a22e8ac51$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $907efc3a22e8ac51$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $907efc3a22e8ac51$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $907efc3a22e8ac51$export$63ccc2571850f81a);

var $fKE23 = parcelRequire("fKE23");

var $aKlnM = parcelRequire("aKlnM");

var $8j2fP = parcelRequire("8j2fP");
var $907efc3a22e8ac51$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $907efc3a22e8ac51$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $907efc3a22e8ac51$var$defaultOptions = {
    method: 'POST'
};
var $907efc3a22e8ac51$export$dd86f00dc866e75d = {
    http: $907efc3a22e8ac51$var$defaultHttpOptions,
    headers: $907efc3a22e8ac51$var$defaultHeaders,
    options: $907efc3a22e8ac51$var$defaultOptions
};
var $907efc3a22e8ac51$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $907efc3a22e8ac51$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $907efc3a22e8ac51$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $8j2fP.InvariantError)(1);
    }
};
var $907efc3a22e8ac51$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $907efc3a22e8ac51$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $fKE23.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $fKE23.__assign)({}, options, config.options, {
            headers: (0, $fKE23.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $fKE23.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $aKlnM.print)(query);
    return {
        options: options,
        body: body
    };
};
var $907efc3a22e8ac51$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $8j2fP.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $907efc3a22e8ac51$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("kcwGc", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $eb4e47225b0a9c93$export$943d544ad120494a);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
function $eb4e47225b0a9c93$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $eb4e47225b0a9c93$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $eb4e47225b0a9c93$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $fKE23.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $eb4e47225b0a9c93$export$943d544ad120494a = function(_super) {
    (0, $fKE23.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $eb4e47225b0a9c93$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $eb4e47225b0a9c93$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $eb4e47225b0a9c93$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $bvQX6.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("10n8H", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $0bb7bd86ef08f58c$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d);

var $42BH7 = parcelRequire("42BH7");

var $hiwGV = parcelRequire("hiwGV");

var $2vRh6 = parcelRequire("2vRh6");
function $0bb7bd86ef08f58c$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $2vRh6.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $42BH7.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $hiwGV.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("hiwGV", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $c97d79f1a0a9adb8$export$a13f755900e15d9e);

var $bvQX6 = parcelRequire("bvQX6");

var $42BH7 = parcelRequire("42BH7");

var $77JSu = parcelRequire("77JSu");

var $fl4NX = parcelRequire("fl4NX");
var $c97d79f1a0a9adb8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c97d79f1a0a9adb8$var$graphql = $77JSu.graphql;
var $c97d79f1a0a9adb8$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $c97d79f1a0a9adb8$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $c97d79f1a0a9adb8$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $bvQX6.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $fl4NX.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $42BH7.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $fl4NX.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $c97d79f1a0a9adb8$var$capitalizeFirstLetter(((0, $42BH7.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $bvQX6.Observable).of({
                data: {}
            });
            return new (0, $bvQX6.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $c97d79f1a0a9adb8$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $bvQX6.ApolloLink)))();
};

});
parcelRegister("77JSu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");

var $1BuKE = parcelRequire("1BuKE");
function $52fcc63cc3cd9b23$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $52fcc63cc3cd9b23$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $52fcc63cc3cd9b23$var$graphql;
function $52fcc63cc3cd9b23$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $fKE23.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $fKE23.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$42BH7.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$42BH7.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $42BH7.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $1BuKE.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($42BH7.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $1BuKE.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeField(field, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $42BH7.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $42BH7.resultKeyNameFromField(field),
                        directives: $42BH7.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, item, execContext);
        return $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("1BuKE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $42BH7 = parcelRequire("42BH7");
function $12b119b85c2553d1$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $12b119b85c2553d1$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $12b119b85c2553d1$var$graphql;
function $12b119b85c2553d1$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$42BH7.shouldInclude(selection, variables)) return;
        if ($42BH7.isField(selection)) {
            var fieldResult = $12b119b85c2553d1$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $42BH7.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $12b119b85c2553d1$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($42BH7.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $12b119b85c2553d1$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $12b119b85c2553d1$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $12b119b85c2553d1$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $42BH7.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $42BH7.resultKeyNameFromField(field),
        directives: $42BH7.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext);
    return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, item, execContext);
        return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $12b119b85c2553d1$var$hasOwn = Object.prototype.hasOwnProperty;
function $12b119b85c2553d1$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$12b119b85c2553d1$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $12b119b85c2553d1$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $12b119b85c2553d1$var$merge;

});


parcelRegister("fl4NX", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $b2ac8b51e1cafdcd$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $b2ac8b51e1cafdcd$export$467f9c465e4ace4e);

var $aKlnM = parcelRequire("aKlnM");

var $42BH7 = parcelRequire("42BH7");
var $b2ac8b51e1cafdcd$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $b2ac8b51e1cafdcd$var$removed = new Map();
function $b2ac8b51e1cafdcd$export$8eae69e876ee321e(query) {
    var cached = $b2ac8b51e1cafdcd$var$removed.get(query);
    if (cached) return cached;
    (0, $42BH7.checkDocument)(query);
    var docClone = (0, $42BH7.removeDirectivesFromDocument)([
        $b2ac8b51e1cafdcd$var$connectionRemoveConfig
    ], query);
    $b2ac8b51e1cafdcd$var$removed.set(query, docClone);
    return docClone;
}
function $b2ac8b51e1cafdcd$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $aKlnM.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("9IbeZ", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $1a3fcf5bcd878ce5$export$fb326ed954631f3f);

var $bvQX6 = parcelRequire("bvQX6");

var $F4xHF = parcelRequire("F4xHF");
const $1a3fcf5bcd878ce5$export$fb326ed954631f3f = new (0, $bvQX6.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $F4xHF.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("iV2Ac", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("1ZkL6", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $a205b903a47dbc85$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $a205b903a47dbc85$export$a78ebe1911f50d41);

var $illlw = parcelRequire("illlw");

var $jlBDe = parcelRequire("jlBDe");

var $guiFP = parcelRequire("guiFP");
const $a205b903a47dbc85$export$15d632fe38832073 = 'giraErrorAnalytics';
const $a205b903a47dbc85$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$a205b903a47dbc85$export$15d632fe38832073]: errorAnalytics
    });
const $a205b903a47dbc85$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(context, [
        $a205b903a47dbc85$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $a205b903a47dbc85$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $a205b903a47dbc85$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $jlBDe.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $guiFP.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});


parcelRegister("yuXsW", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $343a391851b41a38$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "getClient", () => $343a391851b41a38$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $343a391851b41a38$export$8e363dbef886ff17);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $4ErPU = parcelRequire("4ErPU");

var $gd0Sp = parcelRequire("gd0Sp");
const $343a391851b41a38$var$CLIENTS_CACHE = {};
const $343a391851b41a38$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $343a391851b41a38$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $343a391851b41a38$var$CLIENTS_CACHE[clientId];
};
const $343a391851b41a38$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($343a391851b41a38$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $343a391851b41a38$var$CLIENTS_CACHE[key].extract()
        }), {});
const $343a391851b41a38$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $343a391851b41a38$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $343a391851b41a38$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $343a391851b41a38$export$8e363dbef886ff17 extends (0, $eUqFw.Component) {
    getClient(baseUrl, xsrfToken) {
        return $343a391851b41a38$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ErPU.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("4ErPU", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $36307d91b5e24fba$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $36307d91b5e24fba$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $36307d91b5e24fba$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $36307d91b5e24fba$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $36307d91b5e24fba$export$8f49e4af10703ce3);

var $eUqFw = parcelRequire("eUqFw");

var $8j2fP = parcelRequire("8j2fP");
var $36307d91b5e24fba$var$apolloContext;
function $36307d91b5e24fba$export$a47505d961ee3a1() {
    if (!$36307d91b5e24fba$var$apolloContext) $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
    return $36307d91b5e24fba$var$apolloContext;
}
function $36307d91b5e24fba$export$c2ee824bcc89ca6a() {
    $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
}
var $36307d91b5e24fba$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $8j2fP.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $36307d91b5e24fba$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $8j2fP.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $36307d91b5e24fba$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($36307d91b5e24fba$export$d1d99cf900472499 || ($36307d91b5e24fba$export$d1d99cf900472499 = {}));
var $36307d91b5e24fba$var$cache = new Map();
function $36307d91b5e24fba$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $36307d91b5e24fba$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $36307d91b5e24fba$export$8f49e4af10703ce3(document) {
    var cached = $36307d91b5e24fba$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $8j2fP.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $8j2fP.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $8j2fP.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $36307d91b5e24fba$export$d1d99cf900472499.Query : $36307d91b5e24fba$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $36307d91b5e24fba$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $8j2fP.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $36307d91b5e24fba$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("7e8pf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ed5a3ae63b1b20d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $kar7l = parcelRequire("kar7l");


var $hSCS8 = parcelRequire("hSCS8");

var $eUu4u = parcelRequire("eUu4u");

var $2ESAZ = parcelRequire("2ESAZ");
// This wrapper should be agnostic, please don't add any project or overview logic here.
const $3ed5a3ae63b1b20d$var$BusinessAppWrapper = ({ children: children, className: className, header: header, sidebarTheme: sidebarTheme, shouldAddPadding: shouldAddPadding = true, withSidebar: withSidebar = false, withDynamicHeight: withDynamicHeight = false, withOverflow: withOverflow = false })=>{
    const [{ content: sidebarContent }] = (0, $hSCS8.useSidebar)();
    const isSidebarOpen = withSidebar && sidebarContent != null;
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, header, children);
    if (withSidebar) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUu4u.SidebarLayout), {
        theme: sidebarTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: [
            $3ed5a3ae63b1b20d$var$contentWrapperStyles,
            isSidebarOpen && $3ed5a3ae63b1b20d$var$sidebarOpenContentWrapperStyles
        ]
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ESAZ.ThemedContainer), {
        shouldAddPadding: shouldAddPadding,
        isSidebarOpen: isSidebarOpen,
        withSidebar: withSidebar,
        withDynamicHeight: withDynamicHeight,
        withOverflow: withOverflow,
        id: (0, $d02be44255a1478f$export$e5e75ff4daca6597),
        // Used for styling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className
    }, content);
};
const $3ed5a3ae63b1b20d$var$contentWrapperStyles = (0, $8Vv3m.xcss)({
    // @ts-expect-error - we need to use Tokens to correctly set the color value using CSS variables
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    color: (0, $kar7l.Tokens).COLOR_TEXT,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 1,
    maxWidth: '100%',
    minWidth: '0',
    width: 'auto'
});
const $3ed5a3ae63b1b20d$var$sidebarOpenContentWrapperStyles = (0, $8Vv3m.xcss)({
    paddingRight: 'space.300',
    paddingBottom: 'space.300'
});
var $3ed5a3ae63b1b20d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($3ed5a3ae63b1b20d$var$BusinessAppWrapper);

});
const $d02be44255a1478f$export$e5e75ff4daca6597 = 'jwm-container';

parcelRegister("hSCS8", function(module, exports) {

$parcel$export(module.exports, "getSidebarQueryParams", () => $cda1eebb5d053035$export$ddc11e4d41e7cf62);
$parcel$export(module.exports, "useSidebar", () => $cda1eebb5d053035$export$54c70f22f548bff8);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $jGcn0 = parcelRequire("jGcn0");

var $iclz4 = parcelRequire("iclz4");

var $8rQuz = parcelRequire("8rQuz");

var $WBLbN = parcelRequire("WBLbN");

var $l0jym = parcelRequire("l0jym");
const $cda1eebb5d053035$export$86880b4b2e1a2384 = 'jwm.sidebar';
const $cda1eebb5d053035$var$SIDEBAR_MIN_WIDTH_OLD = 360;
const $cda1eebb5d053035$var$SIDEBAR_MIN_WIDTH = 435;
const $cda1eebb5d053035$export$ddc11e4d41e7cf62 = ()=>[
        (0, $jGcn0.SELECTED_ISSUE_PARAM),
        (0, $jGcn0.SELECTED_COMMENT_PARAM)
    ];
const $cda1eebb5d053035$export$f4c7df452942956a = ()=>(0, $8rQuz.isVisualRefreshEnabled)() ? $cda1eebb5d053035$var$SIDEBAR_MIN_WIDTH : $cda1eebb5d053035$var$SIDEBAR_MIN_WIDTH_OLD;
const $cda1eebb5d053035$var$setSidebarContent = (content)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            content: content
        });
    };
const $cda1eebb5d053035$var$setSidebarWidth = (width)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newWidth = Math.max(width, $cda1eebb5d053035$export$f4c7df452942956a());
        if (newWidth === state.sidebarWidth) return;
        setState({
            ...state,
            sidebarWidth: newWidth
        });
        (0, $l0jym.localStorage).set($cda1eebb5d053035$export$86880b4b2e1a2384, newWidth);
    };
const $cda1eebb5d053035$var$setSidebarOnClose = (onSidebarClose)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            onSidebarClose: onSidebarClose
        });
    };
const $cda1eebb5d053035$var$closeSidebar = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        state.onSidebarClose();
        setState({
            ...state,
            content: null,
            onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        });
    };
const $cda1eebb5d053035$var$actions = {
    setSidebarContent: $cda1eebb5d053035$var$setSidebarContent,
    setSidebarWidth: $cda1eebb5d053035$var$setSidebarWidth,
    setSidebarOnClose: $cda1eebb5d053035$var$setSidebarOnClose,
    closeSidebar: $cda1eebb5d053035$var$closeSidebar
};
const $cda1eebb5d053035$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        content: null,
        sidebarWidth: (0, $l0jym.localStorage).get($cda1eebb5d053035$export$86880b4b2e1a2384) || $cda1eebb5d053035$export$f4c7df452942956a(),
        onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    },
    actions: $cda1eebb5d053035$var$actions,
    name: 'JWMSidebarStore'
});
const $cda1eebb5d053035$var$useHook = (0, $WBLbN.createHook)($cda1eebb5d053035$var$Store);
const $cda1eebb5d053035$export$54c70f22f548bff8 = ()=>{
    const [state, hookActions] = $cda1eebb5d053035$var$useHook();
    const sidebarQueryParams = $cda1eebb5d053035$export$ddc11e4d41e7cf62();
    const [, setQueryParams] = (0, $iclz4.useQueryParams)(...sidebarQueryParams);
    const resetSidebarQueryParams = (0, $eUqFw.useCallback)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = sidebarQueryParams.reduce((acc, param)=>Object.assign(acc, {
                [param]: undefined
            }), {});
        setQueryParams(newQueryParams);
    }, [
        setQueryParams,
        sidebarQueryParams
    ]);
    return [
        state,
        {
            ...hookActions,
            resetSidebarQueryParams: resetSidebarQueryParams
        }
    ];
};

});
parcelRegister("l0jym", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $9c968063af1d87e8$export$c2ed3351cac403d1);

var $aZaPn = parcelRequire("aZaPn");
const $9c968063af1d87e8$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_business_common');

});


parcelRegister("eUu4u", function(module, exports) {

$parcel$export(module.exports, "SidebarLayout", () => $b41642a7c0ef06fe$export$8295a33ab8a36876);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $h585o = parcelRequire("h585o");

var $h5BJf = parcelRequire("h5BJf");

var $hSCS8 = parcelRequire("hSCS8");

var $lRBAz = parcelRequire("lRBAz");
const $b41642a7c0ef06fe$var$Sidebar = ({ children: children, sidebarWidth: sidebarWidth, theme: theme })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: [
            $b41642a7c0ef06fe$var$sidebarStyles,
            theme === 'business' && $b41642a7c0ef06fe$var$businessSidebarStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: sidebarWidth
        }
    }, children);
const $b41642a7c0ef06fe$export$8295a33ab8a36876 = ({ children: children, theme: theme = 'business' })=>{
    (0, $h585o.useSidebarQueryParams)();
    const [{ content: content, sidebarWidth: sidebarWidth }, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const { onMouseDown: onMouseDown, isResizing: isResizing } = (0, $h5BJf.useResizer)();
    // reset sidebar content on view unmount
    (0, $eUqFw.useEffect)(()=>()=>{
            setSidebarContent(null);
        }, [
        setSidebarContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.Wrapper), {
        isResizing: isResizing,
        "data-testid": "business-app-wrapper.ui.app-wrapper.sidebar-layout.sidebar-layout-wrapper"
    }, children, content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b41642a7c0ef06fe$var$Sidebar, {
        sidebarWidth: sidebarWidth,
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.ResizeHandle), {
        onMouseDown: onMouseDown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.SidebarContent), null, content)));
};
const $b41642a7c0ef06fe$var$sidebarStyles = (0, $8Vv3m.xcss)({
    backgroundColor: 'elevation.surface',
    flexGrow: 0,
    flexShrink: 0,
    position: 'relative',
    zIndex: 'card',
    maxWidth: '75%'
});
const $b41642a7c0ef06fe$var$businessSidebarStyles = (0, $8Vv3m.xcss)({
    borderTopLeftRadius: 'border.radius.200',
    borderTopRightRadius: 'border.radius.200',
    boxShadow: 'elevation.shadow.overlay',
    marginRight: 'space.300',
    marginTop: 'space.300'
});

});
parcelRegister("h585o", function(module, exports) {

$parcel$export(module.exports, "useSidebarQueryParams", () => $357741b682c79613$export$34adbeffbeceba68);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $eI5EY = parcelRequire("eI5EY");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $iclz4 = parcelRequire("iclz4");

var $hSCS8 = parcelRequire("hSCS8");
const $357741b682c79613$var$isEscapeEvent = (e)=>e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
const $357741b682c79613$export$34adbeffbeceba68 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const [{ content: content }, { setSidebarContent: setSidebarContent, resetSidebarQueryParams: resetSidebarQueryParams }] = (0, $hSCS8.useSidebar)();
    const sidebarQueryParams = (0, $hSCS8.getSidebarQueryParams)();
    const [queryParams, setQueryParams] = (0, $iclz4.useQueryParams)(...sidebarQueryParams);
    const prevQueryParams = (0, $hzcvF.usePreviousWithInitial)(queryParams);
    const closeSidebar = (0, $eUqFw.useCallback)(()=>{
        // reset sidebar query params (IssueApp, Comments)
        resetSidebarQueryParams();
        // reset sidebar content
        setSidebarContent(null);
    }, [
        resetSidebarQueryParams,
        setSidebarContent
    ]);
    // keep only one sidebar-related query param at the time
    (0, $eUqFw.useEffect)(()=>{
        sidebarQueryParams.forEach((queryParam)=>{
            if (!prevQueryParams[queryParam] && queryParams[queryParam]) {
                const newQueryParams = sidebarQueryParams.filter((param)=>param !== queryParam).reduce((acc, param)=>Object.assign(acc, {
                        [param]: undefined
                    }), {});
                setQueryParams(newQueryParams);
            }
        });
    }, [
        prevQueryParams,
        queryParams,
        setQueryParams,
        sidebarQueryParams
    ]);
    // handle closing sidebar on Escape
    (0, $eUqFw.useEffect)(()=>{
        const handleKeydown = (event)=>{
            if (!queryParams[0, $jGcn0.SELECTED_ISSUE_PARAM] && (0, $eI5EY.fg)('jira_list_keyboard_nav')) // sidebar is not open, exit
            return;
            if (queryParams[0, $jGcn0.SELECTED_ISSUE_PARAM] && content?.key === 'unscheduledSidebar') // should not close the sidebar if the sidebar and modal is open
            return;
            if ($357741b682c79613$var$isEscapeEvent(event)) {
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebar closed', 'esc');
                closeSidebar();
            }
        };
        typeof document !== 'undefined' && document.addEventListener('keydown', handleKeydown);
        return ()=>{
            typeof document !== 'undefined' && document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        closeSidebar,
        content?.key,
        createAnalyticsEvent,
        queryParams
    ]);
};

});

parcelRegister("h5BJf", function(module, exports) {

$parcel$export(module.exports, "useResizer", () => $2c653e9e7bda86ce$export$faede3f1542958fc);

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");

var $hSCS8 = parcelRequire("hSCS8");
const $2c653e9e7bda86ce$var$THROTTLE_TIME = 16;
const $2c653e9e7bda86ce$export$faede3f1542958fc = ()=>{
    const [{ sidebarWidth: sidebarWidth }, { setSidebarWidth: setSidebarWidth }] = (0, $hSCS8.useSidebar)();
    const startRef = (0, $eUqFw.useRef)(0);
    // storing width in a ref to avoid re-creating onMouseMove handler during resize
    const width = (0, $eUqFw.useRef)(0);
    const [isResizing, setIsResizing] = (0, $eUqFw.useState)(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const resize = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))((clientX)=>{
        const proposedWidth = width.current + startRef.current - clientX;
        setSidebarWidth(proposedWidth);
    }, $2c653e9e7bda86ce$var$THROTTLE_TIME), [
        setSidebarWidth
    ]);
    const onMouseMove = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        resize(event.clientX);
    }, [
        resize
    ]);
    const onMouseUp = (0, $eUqFw.useCallback)(()=>{
        startRef.current = 0;
        width.current = 0;
        setIsResizing(false);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('mousemove', onMouseMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('mousemove', onMouseMove);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('mouseup', onMouseUp);
        }, [
        onMouseMove,
        onMouseUp
    ]);
    const onMouseDown = (0, $eUqFw.useCallback)((event)=>{
        startRef.current = event.clientX;
        width.current = sidebarWidth;
        setIsResizing(true);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('mousemove', onMouseMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove,
        onMouseUp,
        sidebarWidth
    ]);
    return {
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseMove: onMouseMove,
        isResizing: isResizing
    };
};

});

parcelRegister("lRBAz", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $8c2051301c5af547$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "SidebarContent", () => $8c2051301c5af547$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "ResizeHandle", () => $8c2051301c5af547$export$33f2411a0ad35be7);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $8c2051301c5af547$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isResizing: isResizing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1fhb _4t3i1osq",
            __cmplp.isResizing ? "_80omuf7j" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $8c2051301c5af547$export$49e8f7b58a4df4ea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18m91wug _13wustnw _1igsidpf _184nidpf _bhl91osq _1j101bpf _134m1txw _sojr1h6o",
            __cmplp.className
        ])
    });
});
const $8c2051301c5af547$export$33f2411a0ad35be7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1tcg _80omuf7j _kqswh2mm _1wpz1fhb _1pbybfng _1ltvxmi2 _4t3i1osq _aetrb3bt _16r2glyw _qc5othzt _18postnw _z0aiyh40 _15l2idpf _19doutpp _1qdg1osq _1jju194a _5u1r194a",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2ESAZ", function(module, exports) {

$parcel$export(module.exports, "ThemedContainer", () => $c8a88c0524c1629a$export$2a4209ec8a7db359);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $c8a88c0524c1629a$export$2a4209ec8a7db359 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withSidebar: withSidebar, withDynamicHeight: withDynamicHeight, shouldAddPadding: shouldAddPadding, isSidebarOpen: isSidebarOpen, withOverflow: withOverflow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ca0qidpf",
            !__cmplp.withSidebar && "_syaz1c2q",
            __cmplp.withDynamicHeight ? "_4t3i1wug" : "_4t3i1osq",
            __cmplp.withDynamicHeight ? "_1tke1osq" : "_1tke1wug",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_u5f3idpf" : "_u5f31ejb",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_n3tdidpf" : "_n3td1ejb",
            __cmplp.shouldAddPadding ? "_19bv1ejb" : "_19bvidpf",
            __cmplp.withOverflow ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
            __cmplp.className
        ])
    });
});

});


parcelRegister("fAoR8", function(module, exports) {

$parcel$export(module.exports, "ConfluenceModalProvider", () => $c504526f38fce139$export$465701d340b2a0fb);

var $eUqFw = parcelRequire("eUqFw");

var $k2V1M = parcelRequire("k2V1M");

var $fQ8Gt = parcelRequire("fQ8Gt");

var $38C70 = parcelRequire("38C70");

var $Mkrqy = parcelRequire("Mkrqy");

var $5bEwi = parcelRequire("5bEwi");
const $c504526f38fce139$export$465701d340b2a0fb = ({ children: children })=>{
    const viewModalControlNew = (0, $Mkrqy.useConfluenceViewModalNew)();
    const { createModalProps: createModalProps, showCreatePage: showCreatePage, hideCreatePage: hideCreatePage } = (0, $Mkrqy.useConfluenceCreatePageModal)();
    const confluenceContext = (0, $eUqFw.useMemo)(()=>({
            showConfluencePage: viewModalControlNew.showConfluencePage,
            showCreatePage: showCreatePage
        }), [
        viewModalControlNew.showConfluencePage,
        showCreatePage
    ]);
    const { confluencePageUrl: confluencePageUrl, viewMode: viewMode, onCloseCompleteCallback: onCloseCompleteCallback } = viewModalControlNew.viewModalProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ8Gt.confluencePagesContext).Provider, {
        value: confluenceContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k2V1M.default), null, confluencePageUrl != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5bEwi.default), {
        onClose: viewModalControlNew.hideConfluencePage,
        confluenceUrl: confluencePageUrl || '',
        mode: viewMode,
        onCloseComplete: onCloseCompleteCallback,
        isOpen: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $38C70.default), {
        onClose: hideCreatePage,
        ...createModalProps
    }));
};

});
parcelRegister("fQ8Gt", function(module, exports) {

$parcel$export(module.exports, "confluencePagesContext", () => $37beefa91041e6e4$export$4cb8e522e2ecb030);
$parcel$export(module.exports, "useConfluencePagesModals", () => $37beefa91041e6e4$export$750ed67ce7764287);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");
const $37beefa91041e6e4$export$4cb8e522e2ecb030 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    showConfluencePage: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    showCreatePage: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});
const $37beefa91041e6e4$export$750ed67ce7764287 = ()=>{
    const context = (0, $eUqFw.useContext)($37beefa91041e6e4$export$4cb8e522e2ecb030);
    const { showConfluencePage: showConfluencePage, showCreatePage: showCreatePage } = context;
    return {
        showConfluencePage: showConfluencePage,
        showCreatePage: showCreatePage
    };
};

});

parcelRegister("38C70", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce5a2043a17368e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gGtKh = parcelRequire("gGtKh");

var $dyfd9 = parcelRequire("dyfd9");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ce5a2043a17368e7$var$LazyCreatePage = (0, $dyfd9.lazy)(()=>(parcelRequire("diKXZ")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/confluence-pages/src/ui/confluence-view-modal/create-page-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ce5a2043a17368e7$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "create-page-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ce5a2043a17368e7$var$LazyCreatePage, props));

});
parcelRegister("diKXZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("iWR0i")
]).then(()=>parcelRequire('4gJwS'));

});


parcelRegister("Mkrqy", function(module, exports) {

$parcel$export(module.exports, "useConfluenceCreatePageModal", () => $7c28d3b4703778fb$export$81799af04beb008f);
$parcel$export(module.exports, "useConfluenceViewModalNew", () => $7c28d3b4703778fb$export$3cac20211c8788d8);

var $eUqFw = parcelRequire("eUqFw");

var $1NDDz = parcelRequire("1NDDz");

var $6Fbwh = parcelRequire("6Fbwh");

var $jMP2a = parcelRequire("jMP2a");
const $7c28d3b4703778fb$export$81799af04beb008f = ()=>{
    const [createModalProps, setCreateModalProps] = (0, $eUqFw.useState)({
        showCreateModal: false,
        onCreate: undefined
    });
    const showCreatePage = (0, $eUqFw.useCallback)(({ onCreate: onCreate, onCloseComplete: onCloseComplete, onCancel: onCancel } = {})=>setCreateModalProps({
            showCreateModal: true,
            onCreate: onCreate,
            onCloseComplete: onCloseComplete,
            onCancel: onCancel
        }), []);
    const hideCreatePage = (0, $eUqFw.useCallback)(()=>setCreateModalProps({
            showCreateModal: false,
            onCreate: undefined
        }), []);
    return {
        createModalProps: createModalProps,
        showCreatePage: showCreatePage,
        hideCreatePage: hideCreatePage
    };
};
const $7c28d3b4703778fb$export$3cac20211c8788d8 = ()=>{
    const [viewModalProps, setViewModalProps] = (0, $eUqFw.useState)({
        confluencePageUrl: null,
        viewMode: (0, $1NDDz.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        onCloseCompleteCallback: undefined
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const showConfluencePage = (0, $eUqFw.useCallback)(({ confluenceUrl: confluenceUrl, mode: mode, onCloseComplete: onCloseComplete })=>{
        setViewModalProps({
            confluencePageUrl: confluenceUrl,
            viewMode: mode || (0, $1NDDz.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            onCloseCompleteCallback: onCloseComplete
        });
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jwmConfluenceModal viewed');
    }, [
        createAnalyticsEvent
    ]);
    /**
	 * Sets the modal props state back to a default state, which will cause the modal to close
	 *
	 * NOTE: There's a [StrictMode](https://react.dev/reference/react/StrictMode) bug using the
	 * `onCloseCompleteCallback` prop on `@atlaskit/modal-dialog`. This issue has been raised with the
	 * Design System team in the following [thread](https://atlassian.slack.com/archives/CFJ9DU39U/p1715670965075749).
	 * StrictMode is enabled by default in local development so this will not work in local dev
	 * until fixed but works in production.
	 */ const hideConfluencePage = (0, $eUqFw.useCallback)(()=>{
        setViewModalProps({
            confluencePageUrl: null,
            viewMode: (0, $1NDDz.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            onCloseCompleteCallback: undefined
        });
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jwmConfluenceModal closed');
    }, [
        createAnalyticsEvent
    ]);
    return {
        viewModalProps: viewModalProps,
        showConfluencePage: showConfluencePage,
        hideConfluencePage: hideConfluencePage
    };
};

});

parcelRegister("5bEwi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6c1b8e81f1ff3d7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gGtKh = parcelRequire("gGtKh");

var $dyfd9 = parcelRequire("dyfd9");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e6c1b8e81f1ff3d7$var$LazyConfluenceViewModal = (0, $dyfd9.lazy)(()=>(parcelRequire("jodWd")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/confluence-pages/src/ui/confluence-view-modal/view-page-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e6c1b8e81f1ff3d7$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "view-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e6c1b8e81f1ff3d7$var$LazyConfluenceViewModal, props));

});
parcelRegister("jodWd", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bfFl5")
]).then(()=>parcelRequire('eCTVv'));

});



parcelRegister("3555e", function(module, exports) {

$parcel$export(module.exports, "useTenantHasConfluence", () => $583c95185f8eb6cc$export$964fe2dd9242a588);

var $e91YZ = parcelRequire("e91YZ");

var $j3FUN = parcelRequire("j3FUN");
const $583c95185f8eb6cc$export$964fe2dd9242a588 = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    return Boolean(licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).CONFLUENCE]);
};

});

parcelRegister("hJYsP", function(module, exports) {

$parcel$export(module.exports, "BusinessDocumentTitle", () => $08e74678968dfe67$export$416064ba09d98e69);

var $eUqFw = parcelRequire("eUqFw");

var $heNSb = parcelRequire("heNSb");

var $fDLFb = parcelRequire("fDLFb");
const $08e74678968dfe67$export$416064ba09d98e69 = /*#__PURE__*/ (0, $eUqFw.memo)(({ pageHeading: pageHeading })=>{
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const documentTitle = entity?.name ? `${pageHeading} - ${entity.name}` : pageHeading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: documentTitle
    });
});

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});


parcelRegister("cWd72", function(module, exports) {

$parcel$export(module.exports, "IssueTypesAndFieldsContext", () => $c6421b4581e45226$export$31eaf35dc72d0fa0);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $gEmpR = parcelRequire("gEmpR");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $c6421b4581e45226$var$noop = ()=>{};
// track Apollo cache watchers 1 sec after availableFields query finishes to make sure UI is fully rendered
const $c6421b4581e45226$var$TRACKING_TIMEOUT = 1000;
const $c6421b4581e45226$export$31eaf35dc72d0fa0 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const client = (0, $iZuDo.useApolloClient)();
    const IssueTypesAndFieldsViewContextProps = (0, $gEmpR.useIssueTypesAndFieldsService)({
        issueOperation: 'VIEW'
    });
    const IssueTypesAndFieldsCreateContextProps = (0, $gEmpR.useIssueTypesAndFieldsService)({
        issueOperation: 'CREATE'
    });
    const loading = IssueTypesAndFieldsViewContextProps.loading || IssueTypesAndFieldsCreateContextProps.loading;
    (0, $eUqFw.useEffect)(()=>{
        if (loading) return $c6421b4581e45226$var$noop;
        const timeoutId = setTimeout(()=>{
            // tracking the number of Apollo cache watches
            // the lower the number, the faster UI
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'apolloCacheWatches created', {
                // @ts-expect-error - TS2551 - Property 'watches' does not exist on type 'ApolloCache<object>'. Did you mean 'watch'?
                watches: client?.cache?.watches?.size
            });
        }, $c6421b4581e45226$var$TRACKING_TIMEOUT);
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        createAnalyticsEvent,
        loading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gEmpR.IssueTypesAndFieldsContextView).Provider, {
        value: IssueTypesAndFieldsViewContextProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gEmpR.IssueTypesAndFieldsContextCreate).Provider, {
        value: IssueTypesAndFieldsCreateContextProps
    }, children));
};

});
parcelRegister("iZuDo", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $dd35afdbf6e72e7e$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $dd35afdbf6e72e7e$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $dd35afdbf6e72e7e$export$eb9a56e7a29e494);

var $4ErPU = parcelRequire("4ErPU");

var $fKE23 = parcelRequire("fKE23");

var $eUqFw = parcelRequire("eUqFw");

var $jlBDe = parcelRequire("jlBDe");

var $66hGB = parcelRequire("66hGB");

var $8j2fP = parcelRequire("8j2fP");
var $dd35afdbf6e72e7e$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $66hGB.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $8j2fP.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $4ErPU.parser)(document);
        var requiredOperationName = (0, $4ErPU.operationName)(type);
        var usedOperationName = (0, $4ErPU.operationName)(operation.type);
        (0, $8j2fP.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $dd35afdbf6e72e7e$var$QueryData = function(_super) {
    (0, $fKE23.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $jlBDe.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $jlBDe.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $4ErPU.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $fKE23.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $66hGB.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $66hGB.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $66hGB.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $jlBDe.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $jlBDe.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $66hGB.equal)(this.previousOptions.query, query) && (0, $66hGB.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$var$useDeepMemo(memoFn, key) {
    var ref = (0, $eUqFw.useRef)();
    if (!ref.current || !(0, $66hGB.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $dd35afdbf6e72e7e$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $eUqFw.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $dd35afdbf6e72e7e$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $dd35afdbf6e72e7e$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $eUqFw.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $eUqFw.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $dd35afdbf6e72e7e$export$dd0a697e1782aedd(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, false);
}
function $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, true);
}
var $dd35afdbf6e72e7e$var$MutationData = function(_super) {
    (0, $fKE23.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $4ErPU.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $4ErPU.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $fKE23.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $fKE23.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $jlBDe.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $66hGB.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$609860bf8b0084c(mutation, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $eUqFw.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $dd35afdbf6e72e7e$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $dd35afdbf6e72e7e$var$SubscriptionData = function(_super) {
    (0, $fKE23.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $66hGB.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$368b4214baeb914c(subscription, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $eUqFw.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $eUqFw.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $dd35afdbf6e72e7e$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $dd35afdbf6e72e7e$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $4ErPU.getApolloContext)()).client;
    (0, $8j2fP.invariant)(client, 1);
    return client;
}
function $dd35afdbf6e72e7e$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $dd35afdbf6e72e7e$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $dd35afdbf6e72e7e$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});

parcelRegister("gEmpR", function(module, exports) {

$parcel$export(module.exports, "useIssueTypesAndFieldsService", () => $0655e80332547c29$export$3ef3324b7f7d6a38);
$parcel$export(module.exports, "IssueTypesAndFieldsContextView", () => $0655e80332547c29$export$77937175321fab39);
$parcel$export(module.exports, "IssueTypesAndFieldsContextCreate", () => $0655e80332547c29$export$fbd286e14113bfc);
$parcel$export(module.exports, "useIssueTypesAndFields", () => $0655e80332547c29$export$d2121b02f0b65782);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");


var $ZvXTS = parcelRequire("ZvXTS");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");

var $i2apV = parcelRequire("i2apV");

var $2RZxj = parcelRequire("2RZxj");
const $0655e80332547c29$export$d7241b17c19f0a9c = 'PROJECT_NOT_FOUND';
const $0655e80332547c29$export$4c72baf45fce4585 = 'VIEW_PROJECT_PERMISSION_ERROR';
const $0655e80332547c29$var$isProjectPermissionError = (error)=>error.message.indexOf($0655e80332547c29$export$d7241b17c19f0a9c) > -1 || error.message.indexOf($0655e80332547c29$export$4c72baf45fce4585) > -1 || // @ts-expect-error TS2339 - Property 'extensions' does not exist on type 'ApolloError'
    error.extensions?.statusCode === 403 || // @ts-expect-error TS2339 - Property 'extensions' does not exist on type 'ApolloError'
    error.extensions?.statusCode === 404;
const $0655e80332547c29$export$6b9bc8a33ade0736 = (input)=>{
    const [routerState] = (0, $lB25E.useRouter)();
    const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(routerState?.match, routerState?.query);
    const variables = (0, $eUqFw.useMemo)(()=>({
            projectKey: projectKey,
            issueOperation: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            input.issueOperation,
            first: 100
        }), [
        input.issueOperation,
        projectKey
    ]);
    const { query: query, view: view } = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "classic-business-form": { readonly view: "Form"; readonly query: DocumentNode; }; readonly "classic-business-form-submit": { readonly view: "FormSubmit"; readonly query: DocumentNode; }; ... 8 more ...; readonly default: { ...; }; }'.
    (0, $2RZxj.JWMQueryByRouteMap)?.[routerState?.route?.name] ?? (0, $2RZxj.JWMQueryByRouteMap)[0, $i2apV.DEFAULT];
    return (0, $eUqFw.useMemo)(()=>({
            loading: false,
            query: query,
            view: view,
            variables: variables
        }), [
        query,
        view,
        variables
    ]);
};
const $0655e80332547c29$export$1768f0a0f85b4de9 = (input)=>{
    const client = (0, $iZuDo.useApolloClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const { variables: queryVariables, query: query } = $0655e80332547c29$export$6b9bc8a33ade0736(input);
    const analyticsTaskName = 'useIssueTypesAndFieldsCacheApolloCacheActions';
    return (0, $eUqFw.useCallback)(({ findField: findField, updateItem: updateItem })=>{
        const getCacheData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: queryVariables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'useIssueTypesAndFieldsCache',
                        packageName: 'jiraBusinessEntityProject',
                        teamName: 'wanjel'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(queryVariables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const cacheData = getCacheData();
        const existingEdges = cacheData?.jiraBusinessAvailableFields?.edges;
        if (existingEdges == null) return;
        let shouldUpdate = false;
        const newEdges = existingEdges.map((edge)=>{
            const existingFields = edge?.node?.fields?.edges;
            if (existingFields == null) return edge;
            const itemToUpdateIndex = existingFields.findIndex((fieldEdge)=>findField ? findField(fieldEdge?.node) : false) ?? undefined;
            const existingField = existingFields[itemToUpdateIndex]?.node;
            if (itemToUpdateIndex === undefined || itemToUpdateIndex === -1 || existingField == null) return edge;
            const itemOverride = updateItem(existingField);
            if (itemOverride === undefined) return edge;
            const newFields = [
                ...existingFields
            ];
            newFields[itemToUpdateIndex] = {
                node: itemOverride,
                __typename: 'JiraIssueFieldEdge'
            };
            shouldUpdate = true;
            return {
                ...edge,
                node: {
                    ...edge?.node || {},
                    fields: {
                        edges: newFields,
                        __typename: 'JiraIssueFieldConnection'
                    }
                }
            };
        });
        if (!shouldUpdate) return;
        const newData = {
            ...cacheData,
            jiraBusinessAvailableFields: {
                ...cacheData?.jiraBusinessAvailableFields || {},
                edges: newEdges
            }
        };
        try {
            client.writeQuery({
                query: query,
                variables: queryVariables,
                // @ts-expect-error - TS2345 - Argument of type '{ query: any; variables: { projectId: number | undefined; issueOperation: IssueOperation; first: number; } | undefined; notifyOnNetworkStatusChange: boolean; data: { jiraBusinessAvailableFields: { ...; }; }; }' is not assignable to parameter of type 'WriteQueryOptions<{ jiraBusinessAvailableFields: { edges: (JiraBusinessAvailableFieldsListView_jiraBusinessAvailableFields_edges | { ...; } | null)[]; __typename?: "JiraBusinessAvailableFieldsConnection" | undefined; }; }, { ...; }>'.
                notifyOnNetworkStatusChange: true,
                data: newData
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'useIssueTypesAndFieldsCache',
                    packageName: 'jiraBusinessEntityProject',
                    teamName: 'wanjel'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(queryVariables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent,
        query,
        queryVariables
    ]);
};
const $0655e80332547c29$export$3ef3324b7f7d6a38 = (input)=>{
    const [hasStartedFetchingFields, setHasStartedFetchingFields] = (0, $eUqFw.useState)(false);
    const fetchAttempts = (0, $eUqFw.useRef)(0);
    const { variables: queryVariables, loading: isQueryLoading, query: query, view: view } = $0655e80332547c29$export$6b9bc8a33ade0736(input);
    const [getAvailableFields, { data: data, called: called, loading: loading, error: error, refetch: refetchQuery }] = (0, $iZuDo.useLazyQuery)(query, {
        variables: queryVariables,
        errorPolicy: (0, $eI5EY.fg)('handle_partial_errors_for_availablefields_query') ? 'all' : undefined,
        fetchPolicy: 'cache-first',
        onError: (apolloError)=>{
            (0, $ZvXTS.markViewMetric)(view.toLowerCase(), (0, $78bb8734d7176028$export$ac953882305d6102));
            // do not fire error if user doesn't have project permissions
            if ($0655e80332547c29$var$isProjectPermissionError(apolloError)) return;
            (0, $guiFP.default)({
                meta: {
                    id: `availableFields${view}ViewQuery`,
                    packageName: 'jiraBusinessEntityProject',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: `Failed to fetch available fields in ${view} view`
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onCompleted: (onCompletedData)=>{
            (0, $ZvXTS.markViewMetric)(view.toLowerCase(), (0, $78bb8734d7176028$export$ac953882305d6102));
            if (onCompletedData?.jiraBusinessAvailableFields == null && (0, $eI5EY.fg)('handle_partial_errors_for_availablefields_query')) throw error || new Error('No available fields data');
            onCompletedData?.jiraBusinessAvailableFields?.edges?.forEach((e)=>{
                const fieldEdges = e?.node?.fields?.edges;
                if (fieldEdges == null || fieldEdges?.length === 0) {
                    const emptyMessage = fieldEdges == null ? 'null fields' : '0 length fields';
                    const emptyFieldsError = new Error(`availableFieldsAPI is returning ${emptyMessage} for issueType ${e?.node?.issueType.name ?? 'UNKNOWN'}`);
                    // retrying due to intermittent error related to new projects: FUN-570
                    if (fetchAttempts.current < 1) {
                        fetchAttempts.current += 1;
                        refetch();
                    } else throw emptyFieldsError;
                }
            });
        }
    });
    (0, $eUqFw.useEffect)(()=>{
        if (queryVariables && !hasStartedFetchingFields && !error) {
            setHasStartedFetchingFields(true);
            (0, $ZvXTS.markViewMetric)(view.toLowerCase(), (0, $78bb8734d7176028$export$7b887ee35f2b465e));
            getAvailableFields();
        }
    }, [
        error,
        getAvailableFields,
        hasStartedFetchingFields,
        queryVariables,
        view
    ]);
    const refetch = (0, $eUqFw.useCallback)(()=>{
        if (called && typeof refetchQuery === 'function') return refetchQuery(queryVariables);
        const err = new Error('availableFields refetch is undefined because the service has not been called yet');
        (0, $guiFP.default)({
            meta: {
                id: 'availableFieldsRefetchIsUndefined',
                packageName: 'jiraBusinessEntityProject',
                teamName: 'wanjel'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    }, [
        called,
        refetchQuery,
        queryVariables
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasStartedFetchingFields && error) setHasStartedFetchingFields(false);
    }, [
        hasStartedFetchingFields,
        error
    ]);
    const result = (0, $eUqFw.useMemo)(()=>(0, $2RZxj.transformResult)(data), [
        data
    ]);
    const typesWithFields = (0, $eUqFw.useMemo)(()=>(0, $2RZxj.transformResultToTypesWithFields)(data), [
        data
    ]);
    const hierarchyLevels = (0, $eUqFw.useMemo)(()=>result.issueTypes.map((issueType)=>({
                level: issueType.hierarchyLevel,
                name: issueType.name,
                id: issueType.id
            })).sort((a, b)=>a.level !== b.level ? b.level - a.level : a.name.localeCompare(b.name)), [
        result.issueTypes
    ]);
    // make sure "loading" flag starts from "true"
    const isFieldsLoading = hasStartedFetchingFields ? loading : true;
    return {
        error: error,
        loading: error ? false : isQueryLoading || isFieldsLoading,
        data: result,
        typesWithFields: typesWithFields,
        hierarchyLevels: hierarchyLevels,
        refetch: refetch
    };
};
const $0655e80332547c29$var$issueTypesAndFieldsContextDefaultValue = {
    data: {
        fields: [],
        issueTypes: []
    },
    loading: false,
    error: undefined,
    typesWithFields: [],
    hierarchyLevels: []
};
const $0655e80332547c29$export$77937175321fab39 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    ...$0655e80332547c29$var$issueTypesAndFieldsContextDefaultValue
});
const $0655e80332547c29$export$fbd286e14113bfc = /*#__PURE__*/ (0, $eUqFw.createContext)({
    ...$0655e80332547c29$var$issueTypesAndFieldsContextDefaultValue
});
const $0655e80332547c29$export$d2121b02f0b65782 = (input)=>{
    const issueTypesAndFieldsViewData = (0, $eUqFw.useContext)($0655e80332547c29$export$77937175321fab39);
    const issueTypesAndFieldsCreateData = (0, $eUqFw.useContext)($0655e80332547c29$export$fbd286e14113bfc);
    if (!input || input.issueOperation === 'VIEW') return issueTypesAndFieldsViewData;
    return issueTypesAndFieldsCreateData;
};

});
const $78bb8734d7176028$export$747aad128920134d = 3000;
const $78bb8734d7176028$export$e4f8d353742c04ac = 4000;
const $78bb8734d7176028$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $78bb8734d7176028$export$23e322eb7c526958 = 'REQUEST_START';
const $78bb8734d7176028$export$83ca21a50372ea3b = 'REQUEST_END';
const $78bb8734d7176028$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $78bb8734d7176028$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $78bb8734d7176028$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $78bb8734d7176028$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $78bb8734d7176028$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $78bb8734d7176028$export$88ea1e280513690f = 'UI_RENDER_END';

parcelRegister("i2apV", function(module, exports) {

$parcel$export(module.exports, "DEFAULT", () => $3bfdf44128ce0634$export$e6952b12ade67489);
$parcel$export(module.exports, "HierarchyLevel", () => $3bfdf44128ce0634$export$7faaf3222dfd10db);
const $3bfdf44128ce0634$export$e6952b12ade67489 = 'default';
const $3bfdf44128ce0634$export$7faaf3222dfd10db = Object.freeze({
    EPIC: 1,
    BASE: 0,
    SUBTASK: -1
});

});

parcelRegister("2RZxj", function(module, exports) {

$parcel$export(module.exports, "transformResult", () => $36ea36a72d22859a$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "transformResultToTypesWithFields", () => $36ea36a72d22859a$export$55ab7865f91ba09b);
$parcel$export(module.exports, "JWMQueryByRouteMap", () => $36ea36a72d22859a$export$7188da46161cbb8f);

var $exb0h = parcelRequire("exb0h");

var $lO4Or = parcelRequire("lO4Or");

var $i2apV = parcelRequire("i2apV");

var $fEf9a = parcelRequire("fEf9a");
const $36ea36a72d22859a$export$b07b0d8dc0894ecf = {
    fields: [],
    issueTypes: []
};
const $36ea36a72d22859a$var$emptyArray = [];
const $36ea36a72d22859a$export$bffa388e20165996 = (node, issueType)=>{
    const fieldConfig = {
        isRequired: !!node.fieldConfig?.isRequired,
        isEditable: !!node.fieldConfig?.isEditable
    };
    if (node.type === 'priority') {
        fieldConfig.options = node.priorities.nodes;
        // Set middle priority as default if backend doesn't return any
        if (node.priority) fieldConfig.defaultPriorityId = node.priority.priorityId;
        else if (fieldConfig.options.length > 0) fieldConfig.defaultPriorityId = // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        node.priorities.nodes[Math.floor(fieldConfig.options.length / 2)].priorityId;
    }
    if (node.type === 'issuetype') {
        fieldConfig.options = node.issueTypes.nodes;
        fieldConfig.avatarId = issueType.avatarId;
        fieldConfig.avatarUrl = issueType.avatar?.medium;
    }
    if (node.type === 'issuelinks' && node.issueLinkTypeRelations) // 'is blocked by' / 'blocks' is used as the default issue link type
    fieldConfig.defaultIssueLinkTypeId = node.issueLinkTypeRelations.nodes.find(// @ts-expect-error - TS7006 - Parameter 'linkNode' implicitly has an 'any' type.
    (linkNode)=>linkNode.relationName === 'is blocked by')?.linkTypeId || // take the first awailable otherwise
    node.issueLinkTypeRelations.nodes[0]?.linkTypeId;
    if (node.type === (0, $lO4Or.MULTI_SELECT_CF_TYPE) || node.type === (0, $lO4Or.SELECT_CF_TYPE)) {
        const fieldOptions = [];
        // convert so that it can be used by the select field
        // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    if (node.type === (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)) {
        const fieldOptions = [];
        // convert so that it can be used by the select field
        // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    if (node.type === (0, $lO4Or.CATEGORY_TYPE)) {
        // @ts-expect-error - TS2304 - Cannot find name 'SelectOption'.
        const fieldOptions = [];
        // convert so that it can be used by the select field
        // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId, color: color })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId,
                color: color?.colorKey ?? null
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    return {
        id: node.fieldId,
        aliasFieldId: node.aliasFieldId,
        name: node.name,
        type: node.type,
        fieldConfig: fieldConfig,
        issueTypes: [],
        __typename: node.__typename
    };
};
const $36ea36a72d22859a$export$f13b29f9ed0c5a03 = (data)=>{
    if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) {
        const issueFieldsById = {};
        const issueTypesById = {};
        data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).forEach(// @ts-expect-error - TS2345 - Argument of type '({ issueType, fields, isDefaultIssueType, }: { issueType: {    name: string;    issueTypeId: string;    type: string;    avatarId: string;    hierarchy?: {        level: number;    };}; fields: {    edges: {        nodes: [];    }[];}; isDefaultIssueType: boolean; }) => void' is not assignable to parameter of type '(value: {}, index: number, array: {}[]) => void'.
        ({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>{
            issueTypesById[issueType.issueTypeId] = {
                id: issueType.issueTypeId,
                isDefault: isDefaultIssueType,
                name: issueType.name,
                subtask: issueType.type === 'SUB_TASK',
                avatarId: issueType.avatarId,
                avatarUrl: issueType.avatar?.medium ?? null,
                hierarchyLevel: issueType.hierarchy?.level ?? 0
            };
            fields.edges// @ts-expect-error - TS2551 - Property 'node' does not exist on type '{ nodes: []; }'. Did you mean 'nodes'?
            .map((edge)=>edge && edge.node || {}).forEach((node)=>{
                if (node.fieldId) {
                    if (!issueFieldsById[node.fieldId]) issueFieldsById[node.fieldId] = $36ea36a72d22859a$export$bffa388e20165996(node, issueType);
                    issueFieldsById[node.fieldId].issueTypes = issueFieldsById[node.fieldId].issueTypes || [];
                    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
                    issueFieldsById[node.fieldId].issueTypes.push(issueType.issueTypeId);
                }
            });
        });
        return {
            fields: Object.keys(issueFieldsById).map((id)=>issueFieldsById[id]),
            issueTypes: Object.keys(issueTypesById).map((id)=>issueTypesById[id])
        };
    }
    // @ts-expect-error - TS2322 - Type '{ readonly fields: readonly []; readonly issueTypes: readonly []; }' is not assignable to type '{ fields: BusinessIssueField[]; issueTypes: BusinessIssueType[]; }'.
    return $36ea36a72d22859a$export$b07b0d8dc0894ecf;
};
const $36ea36a72d22859a$export$55ab7865f91ba09b = (data)=>{
    if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) return data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).map(// @ts-expect-error - TS2345 - Argument of type '({ issueType, fields, isDefaultIssueType, }: { issueType: {    name: string;    issueTypeId: string;    type: string;    avatarId: string;    hierarchy?: {        level: number;    };}; fields: {    edges: {        nodes: [];    }[];}; isDefaultIssueType: boolean; }) => { issueType: { id: string; isDefault: boolean;...' is not assignable to parameter of type '(value: {}, index: number, array: {}[]) => { issueType: { id: string; isDefault: boolean; name: string; subtask: boolean; avatarId: string; hierarchyLevel: number; }; fields: BusinessIssueField[]; }'.
    ({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>({
            issueType: {
                id: issueType.issueTypeId,
                isDefault: isDefaultIssueType,
                name: issueType.name,
                subtask: issueType.type === 'SUB_TASK',
                avatarId: issueType.avatarId,
                avatarUrl: issueType.avatar?.medium ?? '',
                hierarchyLevel: issueType.hierarchy?.level ?? 0
            },
            fields: fields.edges// @ts-expect-error - TS2551 - Property 'node' does not exist on type '{ nodes: []; }'. Did you mean 'nodes'?
            .map((edge)=>edge && edge.node || {}).map((node)=>$36ea36a72d22859a$export$bffa388e20165996(node, issueType))
        }));
    return $36ea36a72d22859a$var$emptyArray;
};
const $36ea36a72d22859a$export$7188da46161cbb8f = {
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM)]: {
        view: 'Form',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_FORM_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT)]: {
        view: 'FormSubmit',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR)]: {
        view: 'Calendar',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED)]: {
        view: 'CalendarEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST)]: {
        view: 'List',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED)]: {
        view: 'ListEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE)]: {
        view: 'Timeline',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED)]: {
        view: 'TimelineEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD)]: {
        view: 'Board',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED)]: {
        view: 'BoardEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
    },
    [(0, $i2apV.DEFAULT)]: {
        view: 'Common',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    }
};

});
parcelRegister("fEf9a", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_LIST_QUERY", () => $546f0d2a9095de4c$export$ba5f98a8d6136727);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY", () => $546f0d2a9095de4c$export$cba408dff1091b60);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY", () => $546f0d2a9095de4c$export$363435cea078aa93);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_BOARD_QUERY", () => $546f0d2a9095de4c$export$1641a42cf2cdb09a);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_QUERY", () => $546f0d2a9095de4c$export$7903c43b0ec55315);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY", () => $546f0d2a9095de4c$export$79304c172f5555ae);

var $9ypom = parcelRequire("9ypom");
const $546f0d2a9095de4c$export$ec2562ca5badac3b = (0, $9ypom.default)`
  fragment GetIssueTypesAndFields on JiraBusinessAvailableFields {
    issueType {
      issueTypeId
      name
      type
      avatarId
      avatar {
        medium
      }
      hierarchy {
        level
      }
    }
    isDefaultIssueType
    fields {
      edges {
        node {
          fieldId
          type
          name
          aliasFieldId
          ... on GenericIssueField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueTypes {
              nodes {
                name
                id
              }
            }
          }
          ... on JiraPriorityField {
            fieldConfig {
              isRequired
              isEditable
            }
            priority {
              priorityId
            }
            priorities {
              nodes {
                priorityId
                name
                iconUrl
              }
            }
          }
          ... on JiraLabelsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleLineTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDatePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAffectedServicesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAttachmentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCMDBField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCascadingSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraColorField {
            fieldConfig {
              isRequired
              isEditable
            }
            color {
              colorKey
            }
          }
          ... on JiraComponentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDateTimePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraEpicLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueLinkTypeRelations(first: 10) {
              nodes {
                linkTypeId
                relationName
              }
            }
          }
          ... on JiraIssueRestrictionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraMultipleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraNumberField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraPeopleField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraProjectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRadioSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraResolutionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRichTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSecurityLevelField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraSingleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSprintField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraUrlField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JsmRequestTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JWMCategoryField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
                color {
                    colorKey
                }
              }
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraAtlassianTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraGoalsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
        }
      }
    }
  }
`;
const $546f0d2a9095de4c$export$ba5f98a8d6136727 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsListView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$cba408dff1091b60 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsCalendarView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$363435cea078aa93 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsTimelineView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$1641a42cf2cdb09a = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsBoardView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$7903c43b0ec55315 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsFormView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$79304c172f5555ae = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsFormSubmitView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;

});




parcelRegister("fvzkg", function(module, exports) {

$parcel$export(module.exports, "DeserialisedFiltersProvider", () => $df8b3ad8c9e75684$export$c5640c1fbeb250b6);
$parcel$export(module.exports, "useDeserialisedFilters", () => $df8b3ad8c9e75684$export$ac7ff3aa0620d1a7);
$parcel$export(module.exports, "useDeserialiseJqlFilters", () => $df8b3ad8c9e75684$export$eaa578dc219a620a);
$parcel$export(module.exports, "useDeserialiseJqlFiltersWithContext", () => $df8b3ad8c9e75684$export$87f52da20e747485);

var $eUqFw = parcelRequire("eUqFw");

var $jhNgz = parcelRequire("jhNgz");

var $hLW3I = parcelRequire("hLW3I");

var $gZpkQ = parcelRequire("gZpkQ");

var $lEWmB = parcelRequire("lEWmB");

var $9GlEj = parcelRequire("9GlEj");

var $coMWQ = parcelRequire("coMWQ");
const $df8b3ad8c9e75684$var$DEFAULT_VALUE = {
    filters: {}
};
/* Context used by the board view until the filters get implemented in the backend */ const $df8b3ad8c9e75684$var$DeserialisedFiltersContext = /*#__PURE__*/ (0, $eUqFw.createContext)($df8b3ad8c9e75684$var$DEFAULT_VALUE);
const $df8b3ad8c9e75684$export$c5640c1fbeb250b6 = ({ children: children })=>{
    const [filters, setFilters] = (0, $eUqFw.useState)({});
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(true);
    const value = (0, $eUqFw.useMemo)(()=>({
            filters: filters,
            setFilters: setFilters,
            isLoading: isLoading,
            setIsLoading: setIsLoading
        }), [
        filters,
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df8b3ad8c9e75684$var$DeserialisedFiltersContext.Provider, {
        value: value
    }, children);
};
const $df8b3ad8c9e75684$export$ac7ff3aa0620d1a7 = ()=>(0, $eUqFw.useContext)($df8b3ad8c9e75684$var$DeserialisedFiltersContext);
const $df8b3ad8c9e75684$var$EMPTY_FILTER = {};
const $df8b3ad8c9e75684$export$eaa578dc219a620a = ({ view: view, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, allowCustomFields: allowCustomFields })=>{
    const { jql: jql, setFilter: setFilter } = (0, $lEWmB.useFilters)();
    const { fieldConfig: fieldConfig, resolvers: resolvers, customFieldsLoader: customFieldsLoader, loading: isLoadingFieldConfig } = (0, $jhNgz.useFieldConfigWithCustomFields)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allowCustomFields: allowCustomFields
    });
    const [filters, setFilters] = (0, $eUqFw.useState)({});
    const [error, setError] = (0, $eUqFw.useState)(null);
    const hasFilterError = error != null;
    const [isDeserialisingFilters, setIsDeserialisingFilters] = (0, $eUqFw.useState)(false);
    const [filtersCache, setFiltersCache] = (0, $eUqFw.useState)({});
    const { data: filterFields, loading: isLoadingFilterFields } = (0, $hLW3I.useFilterFields)();
    const { quickFiltersJql: quickFiltersJql } = (0, $9GlEj.useQuickFilters)();
    (0, $eUqFw.useEffect)(()=>{
        // Skip if loading
        if (isDeserialisingFilters || isLoadingFieldConfig || isLoadingFilterFields) return;
        // Skip if no fields supported
        if (!Object.keys(fieldConfig).length) return;
        // Skip if deserialised this jql before
        if (jql != null && filters === filtersCache[jql]) return;
        // Skip if has error and jql not empty
        if (hasFilterError && jql != null) return;
        if (jql == null) {
            if (hasFilterError) setError(null);
            if (filters !== $df8b3ad8c9e75684$var$EMPTY_FILTER) setFilters($df8b3ad8c9e75684$var$EMPTY_FILTER);
            return;
        }
        if (quickFiltersJql !== null) {
            setFilters($df8b3ad8c9e75684$var$EMPTY_FILTER);
            return;
        }
        if (filtersCache[jql]) {
            setFilters(filtersCache[jql]);
            return;
        }
        setIsDeserialisingFilters(true);
        (0, $coMWQ.deserialiseJql)(jql, fieldConfig, filterFields, resolvers).then((result)=>{
            setFilters(result);
            setFiltersCache({
                ...filtersCache,
                [jql]: result
            });
        }).catch((e)=>{
            setError(e);
        }).finally(()=>{
            setIsDeserialisingFilters(false);
        });
    }, [
        hasFilterError,
        quickFiltersJql,
        error,
        filters,
        isLoadingFieldConfig,
        isLoadingFilterFields,
        fieldConfig,
        jql,
        filtersCache,
        filterFields,
        resolvers,
        isDeserialisingFilters
    ]);
    (0, $gZpkQ.useInferHideDoneItemsWithFilters)({
        filters: filters
    });
    return {
        fieldConfig: fieldConfig,
        filters: filters,
        hasFilterError: hasFilterError,
        customFieldsLoader: customFieldsLoader,
        setFilters: setFilter,
        loading: isLoadingFieldConfig || isDeserialisingFilters
    };
};
const $df8b3ad8c9e75684$export$87f52da20e747485 = (props)=>{
    const { fieldConfig: fieldConfig, filters: filters, hasFilterError: hasFilterError, customFieldsLoader: customFieldsLoader, setFilters: setFilters, loading: loading } = $df8b3ad8c9e75684$export$eaa578dc219a620a(props);
    const { setFilters: setContextFilters, setIsLoading: setIsLoadingFilters } = $df8b3ad8c9e75684$export$ac7ff3aa0620d1a7();
    (0, $eUqFw.useEffect)(()=>{
        if (setContextFilters) setContextFilters(filters);
    }, [
        filters,
        setContextFilters
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (setIsLoadingFilters) setIsLoadingFilters(loading);
    }, [
        loading,
        setIsLoadingFilters
    ]);
    return {
        fieldConfig: fieldConfig,
        filters: filters,
        hasFilterError: hasFilterError,
        customFieldsLoader: customFieldsLoader,
        setFilters: setFilters
    };
};

});
parcelRegister("jhNgz", function(module, exports) {

$parcel$export(module.exports, "useFieldConfigWithCustomFields", () => $d017338cf4a59425$export$9f6dc7e3584916fa);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");

var $ejYlo = parcelRequire("ejYlo");

var $bPRqC = parcelRequire("bPRqC");

var $aWjLM = parcelRequire("aWjLM");
const $d017338cf4a59425$var$emptySet = new Set();
const $d017338cf4a59425$var$CustomFieldsLoader = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, setFieldConfig: setFieldConfig })=>{
    const { fieldConfig: fieldConfig, resolvers: resolvers, loading: loading } = (0, $bPRqC.useFieldConfig)({
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId
    });
    (0, $eUqFw.useEffect)(()=>{
        setFieldConfig({
            fieldConfig: fieldConfig,
            resolvers: resolvers,
            loading: loading
        });
    }, [
        fieldConfig,
        resolvers,
        loading,
        setFieldConfig
    ]);
    return null;
};
const $d017338cf4a59425$export$9f6dc7e3584916fa = ({ view: view, allowCustomFields: allowCustomFields, allowedAliasFieldId: allowedAliasFieldId, allowedFieldTypes: allowedFieldTypes })=>{
    const [newAllowedFieldTypes, oldAllowedFieldTypes] = (0, $eUqFw.useMemo)(()=>{
        // split allowedFieldTypes into new and old input for useFieldConfigV2 and useFieldConfigOld
        const newTypes = new Set(allowedFieldTypes);
        const oldTypes = new Set();
        (0, $9TEHc.EXTRA_CUSTOM_FIELD_TYPES).forEach((type)=>{
            if (allowedFieldTypes.has(type)) {
                newTypes.delete(type);
                oldTypes.add(type);
            }
        });
        return [
            newTypes,
            oldTypes
        ];
    }, [
        allowedFieldTypes
    ]);
    const hasCustomFields = Boolean(allowCustomFields) && oldAllowedFieldTypes.size > 0;
    const hasAliasFields = allowedAliasFieldId != null && allowedAliasFieldId.size > 0;
    const shouldLoadOldFieldConfig = hasAliasFields || hasCustomFields;
    const { fieldConfig: fieldConfigNew, resolvers: resolversNew, loading: isLoadingFieldConfigNew } = (0, $aWjLM.useFieldConfigV2)({
        view: view,
        allowedFieldTypes: newAllowedFieldTypes
    });
    const [{ fieldConfig: fieldConfigOld, loading: isLoadingFieldConfigOld, resolvers: resolversOld }, setFieldConfig] = (0, $eUqFw.useState)({
        fieldConfig: {},
        resolvers: {},
        loading: shouldLoadOldFieldConfig
    });
    const customFieldsLoader = (0, $eUqFw.useMemo)(()=>{
        if (!shouldLoadOldFieldConfig) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d017338cf4a59425$var$CustomFieldsLoader, {
            allowedFieldTypes: allowCustomFields ? oldAllowedFieldTypes : $d017338cf4a59425$var$emptySet,
            allowedAliasFieldId: allowedAliasFieldId,
            setFieldConfig: setFieldConfig
        });
    }, [
        allowCustomFields,
        allowedAliasFieldId,
        oldAllowedFieldTypes,
        shouldLoadOldFieldConfig
    ]);
    const { fetchUsers: fetchUsers } = (0, $ejYlo.useFetchFieldValues)({
        view: view,
        allowedFieldTypes: allowedFieldTypes
    });
    const fieldConfig = (0, $eUqFw.useMemo)(()=>{
        const aliasFields = {};
        const otherFields = {};
        Object.keys(fieldConfigOld).forEach((id)=>{
            if (fieldConfigOld[id].systemType === (0, $lO4Or.PEOPLE_CF_TYPE) || fieldConfigOld[id].systemType === (0, $lO4Or.USER_CF_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            fieldConfigOld[id] = {
                ...fieldConfigOld[id],
                loadOptions: fetchUsers
            };
            // We want to assure that alias fields are always at the end of the filter
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (fieldConfigOld[id].aliasFieldId != null) aliasFields[id] = fieldConfigOld[id];
            else otherFields[id] = fieldConfigOld[id];
        });
        return {
            ...otherFields,
            ...fieldConfigNew,
            ...aliasFields
        };
    }, [
        fieldConfigOld,
        fieldConfigNew,
        fetchUsers
    ]);
    return {
        fieldConfig: fieldConfig,
        resolvers: {
            ...resolversOld,
            ...resolversNew
        },
        customFieldsLoader: customFieldsLoader,
        loading: isLoadingFieldConfigNew || isLoadingFieldConfigOld
    };
};

});
parcelRegister("ejYlo", function(module, exports) {

$parcel$export(module.exports, "useFetchFieldValues", () => $a250a9d5a7d089ab$export$6cb851ed13e3949e);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $jGcn0 = parcelRequire("jGcn0");

var $eZbpk = parcelRequire("eZbpk");

var $dlVOn = parcelRequire("dlVOn");

var $eI5EY = parcelRequire("eI5EY");

var $lRmyA = parcelRequire("lRmyA");

var $lO4Or = parcelRequire("lO4Or");

var $dWLk9 = parcelRequire("dWLk9");

var $lB25E = parcelRequire("lB25E");

var $kIODn = parcelRequire("kIODn");

var $4Zgod = parcelRequire("4Zgod");

var $gF4D9 = parcelRequire("gF4D9");

var $5IIOI = parcelRequire("5IIOI");


var $bRzz9 = parcelRequire("bRzz9");
const $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS = 20; // min number to render two rows of the priority filter
const $a250a9d5a7d089ab$var$MAX_INITIAL_NUMBER_OF_OPTIONS = 50; // Increased initial number of options fetched
const $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA = {
    totalCount: 0,
    options: []
};
const $a250a9d5a7d089ab$var$ACTIVE_SPRINTS_JQL = '(sprint in openSprints() OR sprint in futureSprints())';
// TODO: remove shouldFetchSprints and keep shouldFetchSoftwareFields after clean up  jsw_list_view_-_all_the_fields
const $a250a9d5a7d089ab$var$fetchInitialDataInternal = async (cloudId, jqlContext, jqlURLParam, allowedFieldTypes, goalsJqlTerm)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMInitialFilterFieldValues', {
            body: JSON.stringify({
                query: (0, $8d92abf0af87bfd8$export$a48313dd44fc9855),
                variables: {
                    cloudId: cloudId,
                    first: $a250a9d5a7d089ab$var$MAX_INITIAL_NUMBER_OF_OPTIONS,
                    jql: jqlContext,
                    shouldFetchSprints: Boolean(allowedFieldTypes?.has((0, $lO4Or.SPRINT_TYPE))),
                    shouldFetchSoftwareFields: Boolean((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') && allowedFieldTypes?.has((0, $lO4Or.FIX_VERSIONS_TYPE))),
                    shouldFetchParentField: Boolean((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')),
                    shouldFetchGoalsField: Boolean(allowedFieldTypes?.has((0, $lO4Or.GOALS_CF_TYPE)) && !!goalsJqlTerm && (0, $eI5EY.fg)('native_goals_integration_on_list_view')),
                    goalsJqlTerm: goalsJqlTerm && (0, $eI5EY.fg)('native_goals_integration_on_list_view') ? goalsJqlTerm : '',
                    sprintsJqlContext: allowedFieldTypes?.has((0, $lO4Or.SPRINT_TYPE)) ? `${jqlContext} AND ${$a250a9d5a7d089ab$var$ACTIVE_SPRINTS_JQL}` : undefined
                }
            })
        });
        if (response.data?.jira?.jqlBuilder == null && response.data?.jwmCategoryOptions == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        const hydratedValues = jqlURLParam ? await (0, $gF4D9.hydrateFilterValues)(cloudId, jqlURLParam) : null;
        const transformedInitialData = (0, $bRzz9.transformInitialData)(response.data);
        if (hydratedValues !== null) {
            const transformedHydratedValues = (0, $5IIOI.transformHydratedValues)(hydratedValues);
            return (0, $5IIOI.mergeHydratedValues)(transformedInitialData, transformedHydratedValues);
        }
        return transformedInitialData;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $bRzz9.fireFieldValuesErrorAnalytics)('initialiseFilterData', 'Failed to initialise filter data', err);
    }
    return null;
};
const $a250a9d5a7d089ab$var$memoizedFetchInitialData = (0, $5iWql.default)($a250a9d5a7d089ab$var$fetchInitialDataInternal);
const $a250a9d5a7d089ab$var$fetchTeamsServiceFnc = ()=>Promise.resolve((0, $4Zgod.EMPTY_TEAMS));
const $a250a9d5a7d089ab$export$6cb851ed13e3949e = ({ view: view, allowedFieldTypes: allowedFieldTypes, filterFields: filterFields })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const [jqlURLParam] = (0, $lB25E.useQueryParam)((0, $jGcn0.FILTER_PARAM));
    const jqlURLParamRef = (0, $eUqFw.useRef)(jqlURLParam);
    const goalsJqlTerm = (0, $bRzz9.useGoalsJqlTerm)(filterFields);
    let fetchTeamsService = $a250a9d5a7d089ab$var$fetchTeamsServiceFnc;
    if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) // eslint-disable-next-line react-hooks/rules-of-hooks
    fetchTeamsService = (0, $4Zgod.useFetchTeams)();
    const fetchInitialData = (0, $eUqFw.useCallback)(async ()=>{
        if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) return Promise.all([
            $a250a9d5a7d089ab$var$memoizedFetchInitialData(cloudId, jqlContext, jqlURLParamRef.current, allowedFieldTypes, goalsJqlTerm),
            fetchTeamsService({
                first: $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS
            })
        ]).then((values)=>{
            let result = (0, $kIODn.EMPTY_TRANSFORMED_DATA);
            values.forEach((value)=>{
                result = {
                    ...result,
                    ...value
                };
            });
            return result;
        });
        return $a250a9d5a7d089ab$var$memoizedFetchInitialData(cloudId, jqlContext, jqlURLParamRef.current, allowedFieldTypes, goalsJqlTerm);
    }, [
        allowedFieldTypes,
        cloudId,
        fetchTeamsService,
        goalsJqlTerm,
        jqlContext
    ]);
    const fetchData = (0, $eUqFw.useCallback)(async ({ fieldName: fieldName, query: query = '', first: first = $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS, afterCursor: afterCursor, jqlContext: jqlContextProp })=>{
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMFilterFieldValues', {
            body: JSON.stringify({
                query: (0, $8d92abf0af87bfd8$export$f8e8a5f34f6ea725),
                variables: {
                    cloudId: cloudId,
                    first: first,
                    jqlTerm: fieldName,
                    jql: jqlContextProp ?? jqlContext,
                    searchString: query,
                    after: afterCursor
                }
            })
        });
        if (response.data?.jira?.jqlBuilder?.fieldValues == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        return response.data.jira.jqlBuilder.fieldValues;
    }, [
        cloudId,
        jqlContext
    ]);
    const fetchLabels = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'labels',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterLabels', 'Failed to search labels', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchComponents = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'component',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterComponents', 'Failed to search components', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchPriorities = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'priority',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformPriorities)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterPriorities', 'Failed to search priorities', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchUsers = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'assignee',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformUsers)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterUsers', 'Failed to search users', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchIssueTypes = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'issuetype',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            let options = (0, $kIODn.transformIssueTypes)(fieldValuesData);
            if (view === 'board') options = options.filter((option)=>option.hierarchyLevel !== -1);
            return {
                totalCount: fieldValuesData.totalCount,
                options: options
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterIssueTypes', 'Failed to search issue types', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        view
    ]);
    const fetchStatuses = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'status',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformStatuses)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterStatuses', 'Failed to search statuses', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchCategories = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first = $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS })=>{
        try {
            const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMCategoryFieldValuesSearch', {
                body: JSON.stringify({
                    query: (0, $8d92abf0af87bfd8$export$562e34ec948f373d),
                    variables: {
                        first: first,
                        jql: jqlContext,
                        searchQuery: query,
                        after: afterCursor
                    }
                })
            });
            if (response.errors != null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
            if (response.data?.jira?.jwmCategoryOptions?.edges == null) throw new Error('GraphQL response has no data');
            return {
                totalCount: response.data.jira.jwmCategoryOptions.totalCount,
                options: (0, $kIODn.transformCategories)(response.data.jira.jwmCategoryOptions)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterCategories', 'Failed to search categories', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        jqlContext
    ]);
    const fetchSprints = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'sprint',
                query: query,
                first: first,
                afterCursor: afterCursor,
                jqlContext: `${jqlContext} AND ${$a250a9d5a7d089ab$var$ACTIVE_SPRINTS_JQL}`
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformSprints)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterSprints', 'Failed to search sprints', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        jqlContext
    ]);
    const fetchFixVersions = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'fixVersion',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterFixVersion', 'Failed to search fix version', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchParents = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'parent',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformParent)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterParent', 'Failed to search parents', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchGoals = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        if (!goalsJqlTerm) return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: goalsJqlTerm,
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformGoals)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterGoals', 'Failed to search goals', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        goalsJqlTerm
    ]);
    const fetchTeams = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            const fieldValuesData = await fetchTeamsService({
                query: query,
                first: first,
                after: afterCursor
            });
            return fieldValuesData[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterTeams', 'Failed to search teams', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchTeamsService
    ]);
    return {
        fetchInitialData: fetchInitialData,
        fetchLabels: fetchLabels,
        fetchComponents: fetchComponents,
        fetchPriorities: fetchPriorities,
        fetchUsers: fetchUsers,
        fetchIssueTypes: fetchIssueTypes,
        fetchStatuses: fetchStatuses,
        fetchCategories: fetchCategories,
        fetchSprints: fetchSprints,
        ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
            fetchFixVersions: fetchFixVersions,
            fetchParents: fetchParents,
            fetchTeams: fetchTeams
        } : {},
        fetchGoals: fetchGoals
    };
};

});
parcelRegister("kIODn", function(module, exports) {

$parcel$export(module.exports, "transformPriorities", () => $661a0fc6907b6ea1$export$86ca92dec35c4797);
$parcel$export(module.exports, "transformUsers", () => $661a0fc6907b6ea1$export$fb8c90bfc4beaa59);
$parcel$export(module.exports, "transformIssueTypes", () => $661a0fc6907b6ea1$export$4c05e2584b34e4d8);
$parcel$export(module.exports, "transformStatuses", () => $661a0fc6907b6ea1$export$20a57a5ec025f2d);
$parcel$export(module.exports, "transformCategories", () => $661a0fc6907b6ea1$export$1b389c47cf1df04e);
$parcel$export(module.exports, "transformDefaultField", () => $661a0fc6907b6ea1$export$6133e08eeff30d5f);
$parcel$export(module.exports, "transformSprints", () => $661a0fc6907b6ea1$export$6a33be7fc7f04943);
$parcel$export(module.exports, "transformGoals", () => $661a0fc6907b6ea1$export$673d4fceed3e8383);
$parcel$export(module.exports, "transformParent", () => $661a0fc6907b6ea1$export$87e9766fb5100314);
$parcel$export(module.exports, "transformTeams", () => $661a0fc6907b6ea1$export$fd398a52d6f57b46);
$parcel$export(module.exports, "EMPTY_TRANSFORMED_DATA", () => $661a0fc6907b6ea1$export$ca9df9cab9cc134f);
$parcel$export(module.exports, "transformValuesData", () => $661a0fc6907b6ea1$export$8e327b5f9ebc175d);
/* eslint-disable complexity */ 
var $lyOYo = parcelRequire("lyOYo");

var $lO4Or = parcelRequire("lO4Or");

var $8rQuz = parcelRequire("8rQuz");
const $661a0fc6907b6ea1$var$getFirstIssueTypeAvatar = (node)=>node.issueTypes?.find((issueType)=>issueType?.avatar?.medium != null)?.avatar?.medium;
const $661a0fc6907b6ea1$var$getFirstIssueTypeId = (node)=>node.issueTypes[0]?.issueTypeId;
const $661a0fc6907b6ea1$var$getFirstIssueTypeHierarchyLevel = (node)=>node.issueTypes[0]?.hierarchy?.level;
const $661a0fc6907b6ea1$export$86ca92dec35c4797 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: node.priority.iconUrl || ''
        }));
const $661a0fc6907b6ea1$export$fb8c90bfc4beaa59 = (data)=>data.edges.filter(({ node: node })=>node?.user != null).map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: node?.user?.picture || ''
        }));
const $661a0fc6907b6ea1$export$4c05e2584b34e4d8 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            id: $661a0fc6907b6ea1$var$getFirstIssueTypeId(node),
            avatar: $661a0fc6907b6ea1$var$getFirstIssueTypeAvatar(node) || '',
            square: true,
            hierarchyLevel: $661a0fc6907b6ea1$var$getFirstIssueTypeHierarchyLevel(node) || 0
        }));
const $661a0fc6907b6ea1$export$20a57a5ec025f2d = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            categoryId: node.statusCategory.statusCategoryId
        }));
const $661a0fc6907b6ea1$export$1b389c47cf1df04e = (data)=>{
    const transformedCategories = data.edges.map((edge)=>({
            cursor: edge?.cursor,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            value: edge.node.option.value,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            label: edge.node.option.value,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            color: edge.node.color
        }));
    // Remove any categories that have the same name across multiple projects
    return (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(transformedCategories, ({ value: value })=>value);
};
const $661a0fc6907b6ea1$export$6133e08eeff30d5f = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName
        }));
const $661a0fc6907b6ea1$export$6a33be7fc7f04943 = (data)=>data.edges.filter(({ node: node })=>node?.sprint != null).map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.displayName,
            label: node.sprint?.name || ''
        }));
const $661a0fc6907b6ea1$export$673d4fceed3e8383 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.goal.name || '',
            status: node.goal.status || ''
        }));
const $661a0fc6907b6ea1$export$87e9766fb5100314 = (data)=>data?.edges.map(({ node: node, cursor: cursor })=>{
        let avatar = '';
        if (Number(node.issue?.fieldsByIdOrAlias.length) > 0) avatar = node.issue?.fieldsByIdOrAlias[0].issueType?.avatar?.medium || '';
        return {
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: avatar,
            ...(0, $8rQuz.isVisualRefreshEnabled)() && {
                square: true
            }
        };
    });
const $661a0fc6907b6ea1$export$fd398a52d6f57b46 = (data)=>data?.edges.filter(({ node: node })=>node?.team != null).map(({ node: node })=>({
            cursor: data.pageInfo?.endCursor,
            value: node.team.id.replace('ari:cloud:identity::team/', ''),
            label: node.team.displayName || '',
            avatar: node.team.smallAvatarImageUrl || ''
        }));
// Type predicted
const $661a0fc6907b6ea1$var$isIssueType = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'issueTypes' in node);
};
const $661a0fc6907b6ea1$var$isPriority = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'priority' in node);
};
const $661a0fc6907b6ea1$var$isStatus = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'statusCategory' in node);
};
const $661a0fc6907b6ea1$var$isSprint = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'sprint' in node);
};
const $661a0fc6907b6ea1$var$isGoal = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'goal' in node);
};
const $661a0fc6907b6ea1$var$isParent = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'issue' in node);
};
// any fieldValue could be a UserFieldValues because the edges could have some node with "user" undefined
// for example : { node: { displayName: "administrators", jqlTerm: "membersOf(administrators)" }}
const $661a0fc6907b6ea1$var$isUser = (fieldValue)=>true;
const $661a0fc6907b6ea1$var$isDefaultField = (fieldValue)=>Boolean(fieldValue.edges[0]);
const $661a0fc6907b6ea1$export$ca9df9cab9cc134f = {
    labels: {
        totalCount: 0,
        options: []
    },
    components: {
        totalCount: 0,
        options: []
    },
    priority: {
        totalCount: 0,
        options: []
    },
    users: {
        totalCount: 0,
        options: []
    },
    issuetype: {
        totalCount: 0,
        options: []
    },
    status: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.CATEGORY_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.SPRINT_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.PARENT_FIELD_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.GOALS_CF_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
        totalCount: 0,
        options: []
    }
};
const $661a0fc6907b6ea1$export$8e327b5f9ebc175d = (data)=>{
    const transformedData = {
        ...$661a0fc6907b6ea1$export$ca9df9cab9cc134f
    };
    Object.entries(data).forEach(([key, fieldValue])=>{
        if (fieldValue && fieldValue.edges && Array.isArray(fieldValue.edges) && fieldValue.edges.length) switch(key){
            case 'issuetype':
                if ($661a0fc6907b6ea1$var$isIssueType(fieldValue)) transformedData.issuetype = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$4c05e2584b34e4d8(fieldValue)
                };
                break;
            case 'priority':
                if ($661a0fc6907b6ea1$var$isPriority(fieldValue)) transformedData.priority = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$86ca92dec35c4797(fieldValue)
                };
                break;
            case 'status':
                if ($661a0fc6907b6ea1$var$isStatus(fieldValue)) transformedData.status = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$20a57a5ec025f2d(fieldValue)
                };
                break;
            case 'component':
            case 'components':
            case 'fixVersions':
            case 'labels':
                if ($661a0fc6907b6ea1$var$isDefaultField(fieldValue)) {
                    const transformedKey = key === 'component' ? (0, $lO4Or.COMPONENTS_TYPE) : key;
                    transformedData[transformedKey] = {
                        totalCount: fieldValue.totalCount,
                        options: $661a0fc6907b6ea1$export$6133e08eeff30d5f(fieldValue)
                    };
                }
                break;
            case 'parent':
                if ($661a0fc6907b6ea1$var$isParent(fieldValue)) transformedData[key] = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$87e9766fb5100314(fieldValue)
                };
                break;
            default:
                if ($661a0fc6907b6ea1$var$isSprint(fieldValue)) transformedData[0, $lO4Or.SPRINT_TYPE] = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$6a33be7fc7f04943(fieldValue)
                };
                else if (fieldValue.edges.some((item)=>item.node && 'user' in item.node) && $661a0fc6907b6ea1$var$isUser(fieldValue)) {
                    const usersData = $661a0fc6907b6ea1$export$fb8c90bfc4beaa59(fieldValue);
                    const userOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                        ...usersData,
                        ...transformedData.users?.options ?? []
                    ], ({ value: value })=>value);
                    transformedData.users = {
                        totalCount: userOptions.length,
                        options: userOptions
                    };
                } else if ($661a0fc6907b6ea1$var$isGoal(fieldValue)) transformedData[0, $lO4Or.GOALS_CF_TYPE] = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$673d4fceed3e8383(fieldValue)
                };
        }
    });
    return transformedData;
};

});

parcelRegister("4Zgod", function(module, exports) {

$parcel$export(module.exports, "EMPTY_TEAMS", () => $f012c42657d68d46$export$37430da53242c305);
$parcel$export(module.exports, "useFetchTeams", () => $f012c42657d68d46$export$da1ab223b3f1410c);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $lO4Or = parcelRequire("lO4Or");

var $jD3pk = parcelRequire("jD3pk");

var $dWLk9 = parcelRequire("dWLk9");

var $kIODn = parcelRequire("kIODn");

// use ari functions from @atlassian/ari whenever it is ready for import
const $f012c42657d68d46$var$prependOrgIdAri = (orgId)=>`ari:cloud:platform::org/${orgId}`;
const $f012c42657d68d46$export$37430da53242c305 = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
        totalCount: 0,
        options: []
    }
};
const $f012c42657d68d46$var$MAX_NUMBER_OF_OPTIONS = 20;
const $f012c42657d68d46$export$da1ab223b3f1410c = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const fetchTeams = (0, $eUqFw.useCallback)(async ({ query: query, first: first = $f012c42657d68d46$var$MAX_NUMBER_OF_OPTIONS, after: after })=>{
        if (orgId) try {
            const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $1a073e75df73c791$export$cbe5a6af25588495),
                    variables: {
                        orgId: $f012c42657d68d46$var$prependOrgIdAri(orgId),
                        cloudId: cloudId,
                        queryString: query,
                        first: first,
                        after: after
                    }
                })
            });
            const options = (0, $kIODn.transformTeams)(response.data.team.teamSearchV2) || [];
            // Teams query doesn't return the total count
            const totalCount = options.length >= first ? first : options.length;
            return {
                [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
                    totalCount: totalCount,
                    options: options
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchTeams',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch team filter data'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return $f012c42657d68d46$export$37430da53242c305;
    }, [
        cloudId,
        orgId
    ]);
    return fetchTeams;
};

});
const $1a073e75df73c791$export$cbe5a6af25588495 = `
    query JWMTeamFilterValues($cloudId: String!, $orgId: ID!, $queryString: String, $first: Int, $after: String) {
        team @optIn(to: "Team-search-v2") {
            teamSearchV2(
                organizationId: $orgId
                siteId: $cloudId
                first: $first
                after: $after
                filter: {query: $queryString}
            ) {
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        team {
                            id
                            displayName
                            smallAvatarImageUrl
                        }
                    }
                }
            }
        }
    }
`;


parcelRegister("gF4D9", function(module, exports) {

$parcel$export(module.exports, "hydrateFilterValues", () => $12ce55db15189323$export$b18eef22aaa99c21);

var $5iWql = parcelRequire("5iWql");

var $6gPph = parcelRequire("6gPph");

var $dlVOn = parcelRequire("dlVOn");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $lRmyA = parcelRequire("lRmyA");

const $12ce55db15189323$export$3361e9be8093ddcc = (fields)=>{
    const hydratedValues = {};
    fields.forEach((hydratedField)=>{
        if (!hydratedField) return;
        const { field: field, values: values } = hydratedField;
        if (!field || !values) return;
        hydratedValues[field.jqlTerm] = {
            edges: values.map((item)=>(item && item.values && item.values[0]) ?? null).filter(Boolean).map((item)=>({
                    node: item
                })),
            totalCount: 0
        };
    });
    return hydratedValues;
};
const $12ce55db15189323$export$7a89edfb546e2344 = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMHydrateFilterValues', {
            body: JSON.stringify({
                query: (0, $eI5EY.fg)('native_goals_integration_on_list_view') ? (0, $a02b4224be9155fa$export$2bd792833522f1f1) : (0, $a02b4224be9155fa$export$e8b5e80812d4a604),
                variables: {
                    cloudId: cloudId,
                    jql: jqlContext
                }
            })
        });
        if (response.errors != null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.fields == null) {
            if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.__typename === 'QueryError') throw new (0, $6gPph.QueryError)(response.data.jira.jqlBuilder.hydrateJqlQuery);
            throw new Error('Failed to fetch on hydrateFilterValuesService');
        }
        return $12ce55db15189323$export$3361e9be8093ddcc(response.data.jira.jqlBuilder.hydrateJqlQuery.fields);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'JWMHydrateFilterValues',
                packageName: 'jiraBusinessFilters',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $12ce55db15189323$export$b18eef22aaa99c21 = (0, $5iWql.default)($12ce55db15189323$export$7a89edfb546e2344);

});
parcelRegister("6gPph", function(module, exports) {

$parcel$export(module.exports, "QueryError", () => $cba33ea5171f294f$export$83dcbdfe8cbc1e17);
const $cba33ea5171f294f$export$f215947b3d76a6b7 = 'QueryError';
class $cba33ea5171f294f$export$83dcbdfe8cbc1e17 extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.extensions = payload.extensions;
        this.message = payload.message ?? '';
        this.statusCode = payload.extensions?.[0]?.statusCode ?? -1;
    }
}

});

const $a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT_OLD = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $a02b4224be9155fa$export$e8b5e80812d4a604 = `
query JwmHydrateFilterValues($cloudId: ID!, $jql: String!) {
	jira {
        jqlBuilder(cloudId: $cloudId) {
            hydrateJqlQuery(query: $jql, viewContext: JWM) {
                ... on JiraJqlHydratedQuery {
                    fields {
                        ... on JiraJqlQueryHydratedField {
                            field {
                                jqlTerm
                            }
                            values {
                                ... on JiraJqlQueryHydratedValue {
                                    values {
                                        jqlTerm
                                        displayName
                                        ...FieldValueNodeFragment
                                    }
                                }
                            }
                        }
                    }
                }
                ... on QueryError {
                    message
                    extensions {
                      statusCode
                    }
                }
                __typename
            }
        }
	}
}
${$a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT_OLD}
`;
const $a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $a02b4224be9155fa$export$2bd792833522f1f1 = `
query JwmHydrateFilterValues($cloudId: ID!, $jql: String!) {
	jira {
        jqlBuilder(cloudId: $cloudId) {
            hydrateJqlQuery(query: $jql, viewContext: JWM) {
                ... on JiraJqlHydratedQuery {
                    fields {
                        ... on JiraJqlQueryHydratedField {
                            field {
                                jqlTerm
                            }
                            values {
                                ... on JiraJqlQueryHydratedValue {
                                    values {
                                        jqlTerm
                                        displayName
                                        ...FieldValueNodeFragment
                                    }
                                }
                            }
                        }
                    }
                }
                ... on QueryError {
                    message
                    extensions {
                      statusCode
                    }
                }
                __typename
            }
        }
	}
}
${$a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT}
`;


parcelRegister("5IIOI", function(module, exports) {

$parcel$export(module.exports, "transformHydratedValues", () => $3cf74c17db7589d0$export$56282b201a60959e);
$parcel$export(module.exports, "mergeHydratedValues", () => $3cf74c17db7589d0$export$8f60413c08081990);

var $lyOYo = parcelRequire("lyOYo");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $kIODn = parcelRequire("kIODn");
const $3cf74c17db7589d0$var$transformHydratedValuesOld = (data)=>{
    const transformedHydratedData = {
        labels: {
            totalCount: 0,
            options: []
        },
        components: {
            totalCount: 0,
            options: []
        },
        priority: {
            totalCount: 0,
            options: []
        },
        users: {
            totalCount: 0,
            options: []
        },
        issuetype: {
            totalCount: 0,
            options: []
        },
        status: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.CATEGORY_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.SPRINT_TYPE)]: {
            totalCount: 0,
            options: []
        }
    };
    Object.keys(data).forEach((key)=>{
        if (data[key] && data[key].edges && Array.isArray(data[key].edges)) switch(key){
            case 'issuetype':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformIssueTypes)(data[key])
                };
                return;
            case 'priority':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformPriorities)(data[key])
                };
                return;
            case 'status':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformStatuses)(data[key])
                };
                return;
            case 'labels':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformDefaultField)(data[key])
                };
                return;
            case 'component':
                transformedHydratedData.components = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformDefaultField)(data[key])
                };
                return;
            default:
                if (data[key].edges.some((item)=>item.node && 'user' in item.node)) transformedHydratedData.users = {
                    totalCount: 0,
                    options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        ...(0, $kIODn.transformUsers)(data[key]),
                        ...transformedHydratedData.users?.options ?? []
                    ], ({ value: value })=>value)
                };
                else if (data[key].edges.some((item)=>item.node && 'sprint' in item.node)) transformedHydratedData[0, $lO4Or.SPRINT_TYPE] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformSprints)(data[key])
                };
        }
    });
    return transformedHydratedData;
};
const $3cf74c17db7589d0$export$56282b201a60959e = (data)=>{
    if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) return (0, $kIODn.transformValuesData)(data);
    return $3cf74c17db7589d0$var$transformHydratedValuesOld(data);
};
const $3cf74c17db7589d0$export$8f60413c08081990 = (initialData, hydratedValues)=>({
        labels: {
            totalCount: initialData.labels.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.labels.options,
                ...initialData.labels.options
            ], ({ value: value })=>value)
        },
        components: {
            totalCount: initialData.components.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.components.options,
                ...initialData.components.options
            ], ({ value: value })=>value)
        },
        priority: {
            totalCount: initialData.priority.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.priority.options,
                ...initialData.priority.options
            ], ({ value: value })=>value)
        },
        users: {
            totalCount: initialData.users.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.users.options,
                ...initialData.users.options
            ], ({ value: value })=>value)
        },
        issuetype: {
            totalCount: initialData.issuetype.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.issuetype.options,
                ...initialData.issuetype.options
            ], ({ value: value })=>value)
        },
        status: {
            totalCount: initialData.status.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.status.options,
                ...initialData.status.options
            ], ({ value: value })=>value)
        },
        // hydrate values endpoint doesn't support categories
        [(0, $lO4Or.CATEGORY_TYPE)]: initialData[0, $lO4Or.CATEGORY_TYPE],
        [(0, $lO4Or.SPRINT_TYPE)]: {
            totalCount: initialData[0, $lO4Or.SPRINT_TYPE].totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.SPRINT_TYPE].options,
                ...initialData[0, $lO4Or.SPRINT_TYPE].options
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.FIX_VERSIONS_TYPE)]: {
            totalCount: initialData[0, $lO4Or.FIX_VERSIONS_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.FIX_VERSIONS_TYPE]?.options || [],
                ...initialData[0, $lO4Or.FIX_VERSIONS_TYPE]?.options || []
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.PARENT_FIELD_TYPE)]: {
            totalCount: initialData[0, $lO4Or.PARENT_FIELD_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.PARENT_FIELD_TYPE]?.options || [],
                ...initialData[0, $lO4Or.PARENT_FIELD_TYPE]?.options || []
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.GOALS_CF_TYPE)]: {
            totalCount: initialData[0, $lO4Or.GOALS_CF_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.GOALS_CF_TYPE]?.options || [],
                ...initialData[0, $lO4Or.GOALS_CF_TYPE]?.options || []
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
            totalCount: initialData[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE]?.options || [],
                ...initialData[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE]?.options || []
            ], ({ value: value })=>value)
        }
    });

});

const $8d92abf0af87bfd8$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $8d92abf0af87bfd8$var$CATEGORY_CONNECTION_FRAGMENT = `
fragment CategoryConnection on JiraWorkManagementCategoryOptionConnection {
    edges {
        cursor
        node {
            option {
              value
            }
            color
        }
    }
    totalCount
}
`;
const $8d92abf0af87bfd8$export$a48313dd44fc9855 = `
query JwmInitialFilterValues($cloudId: ID!, $first: Int, $jql: String!, $shouldFetchSprints: Boolean = false, $shouldFetchSoftwareFields: Boolean = false, $sprintsJqlContext: String, $goalsJqlTerm: String!, $shouldFetchGoalsField: Boolean = false, $shouldFetchParentField: Boolean = false) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            labels: fieldValues(
                first: $first
                jqlTerm: "labels"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            components: fieldValues(
                first: $first
                jqlTerm: "component"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            priority: fieldValues(
                first: $first
                jqlTerm: "priority"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            users: fieldValues(
                first: $first
                jqlTerm: "assignee"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            recentlyUsedUsers(
                first: $first
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            issuetype: fieldValues(
                first: $first
                jqlTerm: "issuetype"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                     cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            status: fieldValues(
                first: $first
                jqlTerm: "status"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            sprints: fieldValues(
                first: $first
                jqlTerm: "sprint"
                jqlContext: $sprintsJqlContext
                viewContext: JSW
            ) @include(if: $shouldFetchSprints) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            fixVersions: fieldValues(
                first: $first
                jqlTerm: "fixVersion"
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchSoftwareFields) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            parent: fieldValues(
                first: $first
                jqlTerm: "parent"
                jqlContext: $jql
                viewContext: JSW
            ) @include(if: $shouldFetchParentField) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }

            goals: fieldValues(
                first: $first
                jqlTerm: $goalsJqlTerm
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchGoalsField) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
        jwmCategoryOptions(jqlContext: $jql, first: $first) {
            ...CategoryConnection
        }
    }
}
${$8d92abf0af87bfd8$var$FIELD_VALUE_NODE_FRAGMENT}
${$8d92abf0af87bfd8$var$CATEGORY_CONNECTION_FRAGMENT}
`;
const $8d92abf0af87bfd8$export$f8e8a5f34f6ea725 = `
query JwmSearchFilterValues($cloudId: ID!, $first: Int, $jqlTerm: String!, $jql: String!, $searchString: String, $after: String) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            fieldValues(
                first: $first
                jqlTerm: $jqlTerm
                jqlContext: $jql
                searchString: $searchString
                after: $after
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
    }
}
${$8d92abf0af87bfd8$var$FIELD_VALUE_NODE_FRAGMENT}
`;
const $8d92abf0af87bfd8$export$562e34ec948f373d = `
query JwmCategorySearchFilterValues($first: Int, $jql: String!, $searchQuery: String, $after: String) {
    jira {       
        jwmCategoryOptions(jqlContext: $jql, first: $first, searchQuery: $searchQuery, after: $after) {
            ...CategoryConnection
        }
    }
}
${$8d92abf0af87bfd8$var$CATEGORY_CONNECTION_FRAGMENT}
`;

parcelRegister("bRzz9", function(module, exports) {

$parcel$export(module.exports, "transformInitialData", () => $26047d310e78058e$export$93219b8691fe49a0);
$parcel$export(module.exports, "fireFieldValuesErrorAnalytics", () => $26047d310e78058e$export$c3c62a63250fc6f8);
$parcel$export(module.exports, "useGoalsJqlTerm", () => $26047d310e78058e$export$674eff5ec8403101);

var $eUqFw = parcelRequire("eUqFw");

var $lyOYo = parcelRequire("lyOYo");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $kIODn = parcelRequire("kIODn");
const $26047d310e78058e$var$transformInitialCategories = (data)=>{
    if (data.jira.jwmCategoryOptions?.edges != null && Array.isArray(data.jira.jwmCategoryOptions.edges)) return {
        totalCount: data.jira.jwmCategoryOptions.totalCount,
        options: (0, $kIODn.transformCategories)(data.jira.jwmCategoryOptions)
    };
    return undefined;
};
const $26047d310e78058e$var$transformInitialDataOld = (data)=>{
    const { components: components, issuetype: issuetype, priority: priority, labels: labels, status: status, users: users, recentlyUsedUsers: recentlyUsedUsers, sprints: sprints } = data.jira.jqlBuilder;
    const transformedData = {
        labels: {
            totalCount: 0,
            options: []
        },
        components: {
            totalCount: 0,
            options: []
        },
        priority: {
            totalCount: 0,
            options: []
        },
        users: {
            totalCount: 0,
            options: []
        },
        issuetype: {
            totalCount: 0,
            options: []
        },
        status: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.CATEGORY_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.SPRINT_TYPE)]: {
            totalCount: 0,
            options: []
        }
    };
    if (components?.edges != null && Array.isArray(components.edges)) transformedData.components = {
        totalCount: components.totalCount,
        options: (0, $kIODn.transformDefaultField)(components)
    };
    if (issuetype?.edges != null && Array.isArray(issuetype.edges)) transformedData.issuetype = {
        totalCount: issuetype.totalCount,
        options: (0, $kIODn.transformIssueTypes)(issuetype)
    };
    if (priority?.edges != null && Array.isArray(priority.edges)) transformedData.priority = {
        totalCount: priority.totalCount,
        options: (0, $kIODn.transformPriorities)(priority)
    };
    if (labels?.edges != null && Array.isArray(labels.edges)) transformedData.labels = {
        totalCount: labels.totalCount,
        options: (0, $kIODn.transformDefaultField)(labels)
    };
    if (status?.edges != null && Array.isArray(status.edges)) transformedData.status = {
        totalCount: status.totalCount,
        options: (0, $kIODn.transformStatuses)(status)
    };
    if (users?.edges != null && Array.isArray(users.edges)) {
        const usersData = (0, $kIODn.transformUsers)(users);
        const recentlyUsedUsersData = recentlyUsedUsers?.edges != null && Array.isArray(recentlyUsedUsers.edges) ? (0, $kIODn.transformUsers)(recentlyUsedUsers) : null;
        transformedData.users = {
            totalCount: users.totalCount,
            options: // combine `recentlyUsedUsers` and `users` options to improve relevancy of the users field
            recentlyUsedUsersData != null ? (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...recentlyUsedUsersData,
                ...usersData
            ], ({ value: value })=>value) : usersData
        };
    }
    const categories = $26047d310e78058e$var$transformInitialCategories(data);
    if (categories) transformedData[0, $lO4Or.CATEGORY_TYPE] = categories;
    if (sprints?.edges != null && Array.isArray(sprints.edges)) transformedData[0, $lO4Or.SPRINT_TYPE] = {
        options: (0, $kIODn.transformSprints)(sprints),
        totalCount: sprints.totalCount
    };
    return transformedData;
};
const $26047d310e78058e$export$93219b8691fe49a0 = (data)=>{
    if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
        const transformedData = (0, $kIODn.transformValuesData)(data.jira.jqlBuilder);
        const categories = $26047d310e78058e$var$transformInitialCategories(data);
        if (categories) transformedData[0, $lO4Or.CATEGORY_TYPE] = categories;
        return transformedData;
    }
    return $26047d310e78058e$var$transformInitialDataOld(data);
};
const $26047d310e78058e$export$c3c62a63250fc6f8 = (errorId, errorMessage, // eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>{
    (0, $guiFP.default)({
        meta: {
            id: errorId,
            packageName: 'jiraBusinessFilters',
            teamName: 'wanjel'
        },
        attributes: {
            message: errorMessage
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $26047d310e78058e$export$674eff5ec8403101 = (filterFields)=>{
    const goalsJqlTerm = (0, $eUqFw.useMemo)(()=>filterFields?.find((field)=>field?.type === (0, $lO4Or.GOALS_CF_TYPE))?.id, [
        filterFields
    ]);
    return goalsJqlTerm;
};

});


parcelRegister("bPRqC", function(module, exports) {

$parcel$export(module.exports, "useFieldConfig", () => $527c6b4310270d47$export$70da50df1be2dbe1);

var $eUqFw = parcelRequire("eUqFw");

var $lyOYo = parcelRequire("lyOYo");

var $jGcn0 = parcelRequire("jGcn0");

var $35jYz = parcelRequire("35jYz");

var $gEmpR = parcelRequire("gEmpR");

var $ihkPC = parcelRequire("ihkPC");

var $fP7qq = parcelRequire("fP7qq");

var $e20I1 = parcelRequire("e20I1");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $dWLk9 = parcelRequire("dWLk9");

var $lB25E = parcelRequire("lB25E");

var $gF4D9 = parcelRequire("gF4D9");

var $5IIOI = parcelRequire("5IIOI");

var $a75Ge = parcelRequire("a75Ge");

var $7G14t = parcelRequire("7G14t");

var $ijEQD = parcelRequire("ijEQD");
const $527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS = 10;
const $527c6b4310270d47$var$useFilterMapper = true;
const $527c6b4310270d47$var$EMPTY_ARRAY = [];
const $527c6b4310270d47$var$EMPTY_USER_ARRAY = [];
const $527c6b4310270d47$var$EMPTY_COMPONENT_ARRAY = [];
const $527c6b4310270d47$var$EMPTY_CATEGORY_ARRAY = [];
const $527c6b4310270d47$export$1fe8227c57fa0d68 = ()=>({
        initialUsers: {
            data: $527c6b4310270d47$var$EMPTY_USER_ARRAY,
            isLoading: false
        },
        initialLabels: {
            data: $527c6b4310270d47$var$EMPTY_ARRAY,
            isLoading: false
        },
        initialComponents: {
            data: $527c6b4310270d47$var$EMPTY_COMPONENT_ARRAY,
            isLoading: false
        },
        initialCategories: {
            data: $527c6b4310270d47$var$EMPTY_CATEGORY_ARRAY,
            isLoading: false
        },
        projectKey: null
    });
const $527c6b4310270d47$export$74cea4b24a6bc9fa = $527c6b4310270d47$export$1fe8227c57fa0d68();
const $527c6b4310270d47$var$useForceUpdate = ()=>{
    const [, setValue] = (0, $eUqFw.useState)(0);
    return (0, $eUqFw.useCallback)(()=>setValue((value)=>value + 1), []);
};
const $527c6b4310270d47$export$70da50df1be2dbe1 = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [userResolver] = (0, $eUqFw.useState)(new (0, $e20I1.UserResolver)());
    const forceUpdate = $527c6b4310270d47$var$useForceUpdate();
    // this is used to check whether the hook is still mounted by the time we call fireErrorAnalytics
    // see JET-2324
    const mounted = (0, $eUqFw.useRef)(true);
    const [priorityFieldConfig] = (0, $35jYz.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: 'priority'
    });
    const { data: issueTypeData, loading: loadingIssueTypesAndFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const formattedCategoryOptions = (0, $eUqFw.useMemo)(()=>{
        const categoryOptions = issueTypeData.fields.find((field)=>field.type === (0, $lO4Or.CATEGORY_TYPE))?.fieldConfig?.selectOptions ?? [];
        return categoryOptions.map(({ value: value })=>({
                label: value,
                value: value
            }));
    }, [
        issueTypeData
    ]);
    const { statuses: statuses, loading: loadingStatuses } = (0, $a75Ge.useProjectStatuses)();
    const [{ match: { params: { projectKey: projectKey } } }] = (0, $lB25E.useRouter)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const [jqlURLParam] = (0, $lB25E.useQueryParam)((0, $jGcn0.FILTER_PARAM));
    const jqlURLParamRef = (0, $eUqFw.useRef)(jqlURLParam);
    const hydratedUsers = (0, $eUqFw.useRef)(null);
    const fetchInitialUsers = (0, $eUqFw.useCallback)(async ()=>{
        $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers.isLoading = true;
        let users = [];
        const hydratedValues = jqlURLParamRef.current ? await (0, $gF4D9.hydrateFilterValues)(cloudId, jqlURLParamRef.current) : null;
        if (hydratedValues !== null) {
            const transformedHydratedValues = (0, $5IIOI.transformHydratedValues)(hydratedValues);
            hydratedUsers.current = transformedHydratedValues.users.options;
        }
        const url = `/rest/api/3/user/search?maxResults=${$527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS}&query=`;
        users = await (0, $2OdyW.default)(url);
        $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers = {
            data: users,
            isLoading: false
        };
        forceUpdate();
        return users;
    }, [
        cloudId,
        forceUpdate
    ]);
    const fetchInitialLabels = (0, $eUqFw.useCallback)(async ()=>{
        const url = `/rest/api/3/label?maxResults=${$527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS}`;
        try {
            $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels.isLoading = true;
            const response = await (0, $2OdyW.default)(url);
            const labels = response.values;
            $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels = {
                data: labels,
                isLoading: false
            };
            forceUpdate();
            return labels;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchFilterInitialLabels',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch initial labels',
                    errorType: (0, $ihkPC.getErrorType)(err),
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    online: window.navigator.onLine,
                    mounted: mounted.current
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels = {
            data: $527c6b4310270d47$var$EMPTY_ARRAY,
            isLoading: false
        };
        forceUpdate();
        return $527c6b4310270d47$var$EMPTY_ARRAY;
    }, [
        forceUpdate
    ]);
    const fetchUsers = (0, $eUqFw.useCallback)(async (query = '')=>{
        if (projectKey != null) {
            const url = `/rest/api/2/user/assignable/search?project=${projectKey}&maxResults=${$527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS}&query=${query}`;
            try {
                const response = await (0, $2OdyW.default)(url);
                return response;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'searchFilterUsers',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to search users',
                        errorType: (0, $ihkPC.getErrorType)(err),
                        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        online: window.navigator.onLine,
                        mounted: mounted.current
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }
        return $527c6b4310270d47$var$EMPTY_USER_ARRAY;
    }, [
        projectKey
    ]);
    const fetchProjectComponents = (0, $eUqFw.useCallback)(async (query = '')=>{
        if (projectKey != null) try {
            const response = await (0, $fP7qq.fetchComponents)({
                inputValue: query,
                autoCompleteUrl: `/rest/api/3/project/${projectKey}/component`,
                useFilterMapper: $527c6b4310270d47$var$useFilterMapper,
                mounted: mounted.current
            });
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchFilterComponents',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch components',
                    errorType: (0, $ihkPC.getErrorType)(err),
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    online: window.navigator.onLine,
                    mounted: mounted.current
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return [];
    }, [
        projectKey
    ]);
    const fetchLabels = (0, $eUqFw.useCallback)((query = '')=>(0, $2OdyW.default)(`/rest/api/1.0/labels/suggest?query=${query}`).catch((err)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'searchFilterLabels',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to search labels',
                    errorType: (0, $ihkPC.getErrorType)(err),
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    online: window.navigator.onLine,
                    mounted: mounted.current
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }), []);
    const fetchProjectCategories = (0, $eUqFw.useCallback)((query = '')=>{
        // TODO Replace with back end fetch API
        const filteredCategoriesQuery = formattedCategoryOptions?.filter((categoryOption)=>categoryOption.label.toLowerCase().startsWith(query.toLowerCase()));
        return Promise.resolve(filteredCategoriesQuery ?? []);
    }, [
        formattedCategoryOptions
    ]);
    const { fetch: fetchInitialStoryPointsData, data: initialStoryPoints, loading: loadingStoryPoints } = (0, $7G14t.useGroupItemValues)({
        groupFieldId: (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)
    });
    const { fetch: fetchInitialStoryPointsEstimateData, data: initialStoryPointsEstimate, loading: loadingStoryPointsEstimate } = (0, $7G14t.useGroupItemValues)({
        groupFieldId: (0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)
    });
    (0, $eUqFw.useEffect)(()=>{
        if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID))) fetchInitialStoryPointsData();
    }, [
        allowedAliasFieldId,
        fetchInitialStoryPointsData
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID))) fetchInitialStoryPointsEstimateData();
    }, [
        allowedAliasFieldId,
        fetchInitialStoryPointsEstimateData
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            mounted.current = false;
        }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (projectKey != null && // Initially fetch for everything if projectKey is updated or users is empty
        ($527c6b4310270d47$export$74cea4b24a6bc9fa.projectKey !== projectKey || $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers.data === $527c6b4310270d47$var$EMPTY_USER_ARRAY)) {
            if ($527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers.isLoading === false) {
                $527c6b4310270d47$export$74cea4b24a6bc9fa.projectKey = projectKey;
                fetchInitialUsers();
            }
        }
    }, [
        fetchInitialUsers,
        fetchProjectComponents,
        projectKey,
        fetchInitialLabels,
        fetchProjectCategories,
        forceUpdate
    ]);
    const { data: initialUsers, isLoading: isLoadingUsers } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers;
    const { data: initialLabels, isLoading: isLoadingLabels } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels;
    const { data: initialComponents, isLoading: isLoadingComponents } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialComponents;
    const { data: initialCategories, isLoading: isLoadingCategories } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialCategories;
    const fieldOptionsData = (0, $eUqFw.useMemo)(()=>({
            priority: (0, $ijEQD.transformPriority)(priorityFieldConfig),
            issuetype: (0, $ijEQD.transformIssueType)(issueTypeData),
            status: (0, $ijEQD.transformStatuses)(statuses),
            users: (0, $ijEQD.transformUsers)(initialUsers),
            labels: (0, $ijEQD.transformLabels)(initialLabels),
            components: initialComponents,
            [(0, $lO4Or.CATEGORY_TYPE)]: initialCategories,
            [(0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)]: initialStoryPoints?.options || [],
            [(0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)]: initialStoryPointsEstimate?.options || []
        }), [
        priorityFieldConfig,
        issueTypeData,
        statuses,
        initialUsers,
        initialLabels,
        initialComponents,
        initialCategories,
        initialStoryPoints?.options,
        initialStoryPointsEstimate?.options
    ]);
    fieldOptionsData.users = (0, $eUqFw.useMemo)(()=>{
        if (hydratedUsers.current === null) return fieldOptionsData.users;
        return (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
            ...hydratedUsers.current ?? [],
            ...fieldOptionsData.users ?? []
        ], ({ value: value })=>value);
    }, [
        fieldOptionsData
    ]);
    const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, $ijEQD.getFilterFieldConfigAndResolvers)({
        formatMessage: formatMessage,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allFields: issueTypeData.fields,
        fieldOptionsData: fieldOptionsData,
        fetchUsers: (query)=>fetchUsers(query).then((users)=>(0, $ijEQD.transformUsers)(users || [])),
        fetchLabels: (query)=>fetchLabels(query).then((labels)=>labels ? (0, $ijEQD.transformLabelSuggestions)(labels) : []),
        fetchComponents: (query)=>fetchProjectComponents(query).then((components)=>components),
        fetchCategories: (query)=>fetchProjectCategories(query).then((categoriesResponse)=>categoriesResponse),
        userResolver: userResolver
    });
    const fetching = isLoadingUsers || isLoadingLabels || isLoadingComponents || isLoadingCategories || loadingStoryPoints || loadingStoryPointsEstimate;
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers,
        loading: loadingIssueTypesAndFields || loadingStatuses || fetching
    };
};

});
parcelRegister("35jYz", function(module, exports) {

$parcel$export(module.exports, "useIssueTypeFieldConfig", () => $81e81ebd14cd3d82$export$42e875bfb69ded2);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $WBLbN = parcelRequire("WBLbN");

var $gEmpR = parcelRequire("gEmpR");
const $81e81ebd14cd3d82$var$merge = (screen, issueTypeId, configs)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            [screen]: {
                ...(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(getState(), [
                    screen
                ], {}),
                [issueTypeId]: configs
            }
        });
    };
const $81e81ebd14cd3d82$var$actions = {
    merge: $81e81ebd14cd3d82$var$merge
};
const $81e81ebd14cd3d82$export$cbf0f7fe9ca42a65 = (0, $WBLbN.createStore)({
    initialState: {},
    actions: $81e81ebd14cd3d82$var$actions,
    name: 'issueTypeFieldConfig'
});
const $81e81ebd14cd3d82$var$getIssueTypeFieldConfigSelector = (0, $WBLbN.createSelector)((state)=>state, (_, props)=>props?.screen ?? undefined, (_, props)=>props?.issueTypeId ?? undefined, (_, props)=>props?.fieldId ?? undefined, (state, screen, issueTypeId, fieldId)=>{
    if (screen === undefined || issueTypeId === undefined || fieldId === undefined) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(state, [
        screen,
        issueTypeId,
        fieldId
    ], null);
});
const $81e81ebd14cd3d82$export$47647eb426e85a25 = (0, $WBLbN.createHook)($81e81ebd14cd3d82$export$cbf0f7fe9ca42a65, {
    selector: $81e81ebd14cd3d82$var$getIssueTypeFieldConfigSelector
});
const $81e81ebd14cd3d82$export$42e875bfb69ded2 = (props)=>{
    const [state, fieldsConfigActions] = $81e81ebd14cd3d82$export$47647eb426e85a25(props);
    const screen = props?.screen || 'VIEW';
    const { data: data, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: screen
    });
    // store field config to be consumed at the cell level
    return (0, $eUqFw.useMemo)(()=>{
        if (state != null) return [
            state,
            fieldsConfigActions,
            {
                loading: false,
                error: undefined
            }
        ];
        if (loading === false && (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, [
            'issueTypes'
        ], []).length > 0) data.issueTypes.forEach((issueType)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const config = {};
            data.fields.forEach((field)=>{
                if ((field.issueTypes || []).includes(issueType.id) && field.id != null) config[field.id] = {
                    ...field.fieldConfig,
                    fieldType: field.type
                };
            });
            fieldsConfigActions.merge(screen, issueType.id, config);
            if (issueType.isDefault) fieldsConfigActions.merge(screen, 'default', config);
        });
        return [
            state,
            fieldsConfigActions,
            {
                loading: loading,
                error: error
            }
        ];
    }, [
        data,
        error,
        fieldsConfigActions,
        loading,
        screen,
        state
    ]);
};

});

parcelRegister("ihkPC", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $348eddd0ac284a22$export$e19f9f08a6d79fd2);

var $7byHA = parcelRequire("7byHA");
const $348eddd0ac284a22$export$7453182ebe5973d4 = 'APOLLO_NETWORK_ERROR';
const $348eddd0ac284a22$export$9705762bba4e9e25 = 'NULL_OR_UNDEFINED';
const $348eddd0ac284a22$export$d46a05f8561f868a = 'OTHER';
const $348eddd0ac284a22$export$c748438cec453c9f = {
    FAILED_TO_FETCH: 'Failed to fetch',
    NETWORK_ERROR: 'NetworkError when attempting to fetch resource.',
    NETWORK_REQUEST_FAILED: 'Network request failed',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    NETWORK_CONNECTION_ERROR: 'upstream connect error or disconnect/reset before headers. reset reason: connection',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    ABORTED: 'operation was aborted.',
    CANCELLED: 'cancelled',
    TIMEOUT: 'The request timed out.'
};
const $348eddd0ac284a22$var$isApolloClientNetworkError = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>error.networkError !== undefined && error.networkError !== null;
const $348eddd0ac284a22$export$e19f9f08a6d79fd2 = (error)=>{
    if (error == null) return $348eddd0ac284a22$export$9705762bba4e9e25;
    const message = String(error instanceof Error ? error.message : error).trim();
    if (error instanceof (0, $7byHA.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode) return `FETCH_ERROR_${statusCode}`;
    }
    if ($348eddd0ac284a22$var$isApolloClientNetworkError(error)) return $348eddd0ac284a22$export$7453182ebe5973d4;
    const entry = Object.entries($348eddd0ac284a22$export$c748438cec453c9f).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    return entry ? entry[0] : $348eddd0ac284a22$export$d46a05f8561f868a;
};

});

parcelRegister("fP7qq", function(module, exports) {

$parcel$export(module.exports, "fetchComponents", () => $9fb5f20e4a6bfa39$export$4f703ddb7c8cc5b3);

var $53ciZ = parcelRequire("53ciZ");

var $ihkPC = parcelRequire("ihkPC");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $a9hW2 = parcelRequire("a9hW2");
const $9fb5f20e4a6bfa39$export$4f703ddb7c8cc5b3 = ({ inputValue: inputValue, autoCompleteUrl: autoCompleteUrl, useFilterMapper: useFilterMapper, mounted: mounted, queryParameters: queryParameters })=>{
    const mapperFunction = useFilterMapper === true ? (0, $a9hW2.mapComponentsToFilterOptions) : (0, $a9hW2.mapComponentsToOptions);
    const query = (0, $1ybV0.ff)('jira.list.field-support-part1') ? (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        query: inputValue,
        ...queryParameters
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        query: inputValue
    });
    return (0, $lRmyA.performGetRequest)(`${autoCompleteUrl}?${query}`).then((response)=>mapperFunction(response.values)).catch((error)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'fetchProjectComponents',
                packageName: 'jiraBusinessFetchComponents',
                teamName: 'wanjel'
            },
            attributes: {
                message: 'Failed to fetch jwm project components',
                errorType: (0, $ihkPC.getErrorType)(error),
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                online: window.navigator.onLine,
                mounted: mounted
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });
};

});
parcelRegister("a9hW2", function(module, exports) {

$parcel$export(module.exports, "mapComponentsToOptions", () => $c0b17925cb48a958$export$85e44418187c2c1e);
$parcel$export(module.exports, "mapComponentsToFilterOptions", () => $c0b17925cb48a958$export$b4ef58d3e943e4d5);
const $c0b17925cb48a958$export$85e44418187c2c1e = (components)=>components.map(({ id: id, componentId: componentId, name: name })=>({
            label: name,
            value: componentId !== undefined ? String(componentId) : String(id)
        }));
const $c0b17925cb48a958$export$b4ef58d3e943e4d5 = (components)=>components.map(({ name: name })=>({
            label: name,
            value: name
        }));

});


parcelRegister("e20I1", function(module, exports) {

$parcel$export(module.exports, "UserResolver", () => $2f3c56b3440530f6$export$723df28d03868f02);

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
class $2f3c56b3440530f6$export$723df28d03868f02 {
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        this.getUsersFromAccountId = (accountIds)=>{
            const recoveredFromCache = [];
            const missingFromCache = [];
            accountIds.forEach((accountId)=>{
                const user = this.cache.get(accountId);
                if (user) recoveredFromCache.push(user);
                else missingFromCache.push(accountId);
            });
            if (missingFromCache.length === 0) // @ts-expect-error - User is not assignable to type 'string'
            return Promise.resolve(recoveredFromCache);
            return (0, $2OdyW.default)(`/rest/api/2/user/bulk?maxResults=10&${missingFromCache.map((accountId)=>`accountId=${accountId}`).join('&')}`).then((response)=>response && response.values.length > 0 && // @ts-expect-error - TS2339 - Property 'forEach' does not exist on type '() => IterableIterator<Readonly<Partial<Diff<ResponseSuccess, Record<any, any>>> & { accountId: string | null; displayName: string; avatarUrls: { readonly "48x48"?: string | undefined; readonly "32x32"?: string | undefined; readonly "24x24"?: string | undefined; readonly "16x16"?: string | undefined; }; }>>'. | TS7006 - Parameter 'user' implicitly has an 'any' type.
                response.values.forEach((user)=>{
                    if (user) this.cache.set(user.accountId, user);
                })).then(()=>this.getUsersFromAccountId(accountIds)).catch((err)=>{
                (0, $gUUjF.default).safeErrorWithoutCustomerData('jwm.services.get-users', 'Failed to fetch users', err);
            });
        };
        this.cache = new Map();
    }
}

});

parcelRegister("a75Ge", function(module, exports) {

$parcel$export(module.exports, "useProjectStatuses", () => $342d49f1f4fd71f7$export$11ff6a520db76faf);

var $eUqFw = parcelRequire("eUqFw");

var $3G3gn = parcelRequire("3G3gn");

var $lyOYo = parcelRequire("lyOYo");

var $kQAZu = parcelRequire("kQAZu");

var $gUUjF = parcelRequire("gUUjF");

var $WBLbN = parcelRequire("WBLbN");
const $342d49f1f4fd71f7$var$PACKAGE_LOCATION = 'jira-business.common.services.project-statuses';
const $342d49f1f4fd71f7$var$MAX_RETRIES = 3;
const $342d49f1f4fd71f7$var$set = (projectKey, statuses)=>({ setState: setState })=>setState({
            [projectKey]: statuses
        });
const $342d49f1f4fd71f7$var$actions = {
    set: $342d49f1f4fd71f7$var$set
};
const $342d49f1f4fd71f7$var$ProjectStatusesStore = (0, $WBLbN.createStore)({
    initialState: {},
    actions: $342d49f1f4fd71f7$var$actions,
    name: 'projectStatuses'
});
const $342d49f1f4fd71f7$var$getProjectStatusesSelector = (0, $WBLbN.createSelector)((state)=>state, (_, props)=>props?.projectKey ?? undefined, (state, projectKey)=>{
    if (projectKey === undefined || state[projectKey] == null) return [];
    return state[projectKey];
});
const $342d49f1f4fd71f7$export$482f388228eef22c = (0, $WBLbN.createHook)($342d49f1f4fd71f7$var$ProjectStatusesStore, {
    selector: $342d49f1f4fd71f7$var$getProjectStatusesSelector
});
const $342d49f1f4fd71f7$var$emptyArray = [];
const $342d49f1f4fd71f7$export$11ff6a520db76faf = ()=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasLoaded, setHasLoaded] = (0, $eUqFw.useState)(false);
    const [retriesCount, setRetriesCount] = (0, $eUqFw.useState)(0);
    const projectData = (0, $kQAZu.useProject)();
    const projectKey = projectData.key;
    const [statuses, statusActions] = $342d49f1f4fd71f7$export$482f388228eef22c({
        projectKey: projectKey
    });
    const retry = ()=>{
        setRetriesCount(retriesCount + 1);
        setIsLoading(false);
        setHasLoaded(false);
    };
    if (projectKey != null && Array.isArray(statuses) && statuses.length > 0) return {
        statuses: statuses,
        loading: isLoading
    };
    if (!isLoading && !hasLoaded) {
        fetch(`/rest/api/3/project/${projectKey}/statuses`).then((response)=>response.json()).then((issueTypes)=>{
            const allStatuses = issueTypes.reduce(// @ts-expect-error - TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7006 - Parameter 'next' implicitly has an 'any' type.
            (acc, next)=>acc.concat(next.statuses), []);
            const dedupedResults = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(allStatuses, 'id');
            return (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(dedupedResults, [
                'name'
            ]);
        }).then((uniqueStatuses)=>{
            statusActions.set(projectKey, uniqueStatuses);
            setIsLoading(false);
            setHasLoaded(true);
        }).catch(()=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData($342d49f1f4fd71f7$var$PACKAGE_LOCATION, `Failed to retrieve project statuses - Retry #${retriesCount}`);
            if (retriesCount < $342d49f1f4fd71f7$var$MAX_RETRIES) retry();
        });
        setIsLoading(true);
    }
    return {
        statuses: $342d49f1f4fd71f7$var$emptyArray,
        loading: isLoading
    };
};

});

parcelRegister("7G14t", function(module, exports) {

$parcel$export(module.exports, "useGroupItemValues", () => $f05aa0c8a487bc66$export$f05af123f98299b0);

var $eUqFw = parcelRequire("eUqFw");

var $NFHn0 = parcelRequire("NFHn0");

var $eZbpk = parcelRequire("eZbpk");

var $dlVOn = parcelRequire("dlVOn");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lKPnc = parcelRequire("lKPnc");

var $fOoev = parcelRequire("fOoev");
const $f05aa0c8a487bc66$var$reducer = (state, action)=>{
    switch(action.type){
        case 'loading':
            return {
                loading: true
            };
        case 'success':
            return {
                loading: false,
                data: action.payload
            };
        case 'error':
            return {
                loading: false,
                data: null
            };
        default:
            return state;
    }
};
const $f05aa0c8a487bc66$export$f05af123f98299b0 = ({ groupFieldId: groupFieldId })=>{
    const [state, dispatch] = (0, $eUqFw.useReducer)($f05aa0c8a487bc66$var$reducer, {
        loading: false
    });
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const fetchDataAbortable = (0, $NFHn0.useAbortable)((0, $lKPnc.fetchGroupItemValues));
    const fetch = (0, $eUqFw.useCallback)(async ()=>{
        try {
            dispatch({
                type: 'loading'
            });
            const response = await fetchDataAbortable(groupFieldId, jqlContext);
            if (response.data?.items == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
            dispatch({
                type: 'success',
                payload: (0, $fOoev.transformInitialData)({
                    data: response.data,
                    formatMessage: formatMessage
                })
            });
        } catch (error) {
            if (error === (0, $NFHn0.ABORTED)) return;
            dispatch({
                type: 'error'
            });
        }
    }, [
        fetchDataAbortable,
        formatMessage,
        groupFieldId,
        jqlContext
    ]);
    return {
        fetch: fetch,
        data: state.data,
        loading: state.loading
    };
};

});
parcelRegister("NFHn0", function(module, exports) {

$parcel$export(module.exports, "ABORTED", () => $f9f77c4f962e82bc$export$23e29024ea698a35);
$parcel$export(module.exports, "useAbortable", () => $f9f77c4f962e82bc$export$a487c7eb4387f959);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eUqFw = parcelRequire("eUqFw");
const $f9f77c4f962e82bc$export$23e29024ea698a35 = Symbol('ABORTED');
const $f9f77c4f962e82bc$export$a487c7eb4387f959 = (fetch)=>{
    const prevControllerRef = (0, $eUqFw.useRef)(null);
    return (0, $eUqFw.useCallback)((...args)=>{
        if (prevControllerRef.current) prevControllerRef.current.abort();
        const controller = new AbortController();
        prevControllerRef.current = controller;
        return fetch(controller.signal, ...args).catch((error)=>{
            if (controller.signal.aborted) throw $f9f77c4f962e82bc$export$23e29024ea698a35;
            else throw error;
        });
    }, [
        fetch
    ]);
};

});

parcelRegister("lKPnc", function(module, exports) {

$parcel$export(module.exports, "fetchGroupItemValues", () => $8489c6f37b087f09$export$7e6e0c3f4468ce45);

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");

var $lRmyA = parcelRequire("lRmyA");

const $8489c6f37b087f09$var$MAX_NUMBER_OF_OPTIONS = 20; // min number to render two rows
const $8489c6f37b087f09$export$7e6e0c3f4468ce45 = async (signal, groupFieldId, jqlContext)=>{
    try {
        const variables = {
            fieldId: groupFieldId,
            first: $8489c6f37b087f09$var$MAX_NUMBER_OF_OPTIONS,
            jql: jqlContext
        };
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMFilterValuesByGroupItems', {
            body: JSON.stringify({
                query: (0, $622211c2999f2f37$export$a48313dd44fc9855),
                variables: variables
            })
        });
        return response;
    } catch (error) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (!(0, $JRB5w.isHttpClientErrorResponse)(error) && !signal.aborted) (0, $guiFP.default)({
            meta: {
                id: 'initializeFilterGroupItemsData',
                packageName: 'jiraBusinessFilters',
                teamName: 'wanjel'
            },
            attributes: {
                message: 'Failed to initialize filter data using the group query'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
const $622211c2999f2f37$export$a48313dd44fc9855 = `
query JWMFilterValuesByGroupItems($fieldId: ID!, $jql: String!, $first: Int!) {
  items: jwmItemGroups(jql: $jql, groupByFieldId: $fieldId, fieldIds: [], first: $first) {
    totalCount
    edges {
      node {
        id
        field {
          __typename
          ... on FloatCustomField {
            floatValue
          }
        }
      }
    }
  }
}
`;


parcelRegister("fOoev", function(module, exports) {

$parcel$export(module.exports, "transformInitialData", () => $2b76e62e743cb9ff$export$93219b8691fe49a0);

var $ivaRx = parcelRequire("ivaRx");
const $2b76e62e743cb9ff$export$93219b8691fe49a0 = ({ data: data, formatMessage: formatMessage })=>({
        totalCount: data.items.totalCount,
        options: data.items.edges.map((edge)=>{
            if (edge.node.field.floatValue == null) return {
                value: null,
                label: formatMessage((0, $ivaRx.default).noneOption)
            };
            const stringFloatValue = String(edge.node.field.floatValue);
            return {
                value: stringFloatValue,
                label: stringFloatValue
            };
        })
    });

});
parcelRegister("ivaRx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dd2394f0a911447$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4dd2394f0a911447$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noneOption: {
        "id": "business-filters.controllers.group-item-values.none-option",
        "defaultMessage": "None"
    }
});

});



parcelRegister("ijEQD", function(module, exports) {

$parcel$export(module.exports, "transformPriority", () => $c6e67604bea772f5$export$1b9f55a39456e911);
$parcel$export(module.exports, "transformIssueType", () => $c6e67604bea772f5$export$96520244689f81c1);
$parcel$export(module.exports, "transformStatuses", () => $c6e67604bea772f5$export$20a57a5ec025f2d);
$parcel$export(module.exports, "transformUsers", () => $c6e67604bea772f5$export$fb8c90bfc4beaa59);
$parcel$export(module.exports, "transformLabels", () => $c6e67604bea772f5$export$c072126708d93f04);
$parcel$export(module.exports, "transformLabelSuggestions", () => $c6e67604bea772f5$export$cdfcc40760c1a4f8);
$parcel$export(module.exports, "getFilterFieldConfigAndResolvers", () => $c6e67604bea772f5$export$ba4f3d2149c2bf3b);

var $illlw = parcelRequire("illlw");

var $5iWql = parcelRequire("5iWql");

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");

var $1run3 = parcelRequire("1run3");

var $dG4cR = parcelRequire("dG4cR");

var $h1vWF = parcelRequire("h1vWF");
const $c6e67604bea772f5$export$1b9f55a39456e911 = (0, $5iWql.default)((priorityFieldConfig)=>[
        ...priorityFieldConfig?.options || []
    ].reduce((acc, next)=>{
        acc.push({
            value: next.name,
            label: next.name,
            avatar: next.iconUrl || ''
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$96520244689f81c1 = (0, $5iWql.default)((issueTypeData)=>issueTypeData.issueTypes.reduce((acc, next)=>{
        acc.push({
            value: next.id,
            label: next.name,
            id: next.id,
            avatar: next.avatarUrl,
            square: true
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$20a57a5ec025f2d = (0, $5iWql.default)((statuses)=>statuses.reduce((acc, next)=>{
        acc.push({
            value: next.untranslatedName,
            label: next.name,
            categoryId: next.statusCategory.id,
            // Board needs the status id as number for client side filtering
            id: Number(next.id)
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$fb8c90bfc4beaa59 = (0, $5iWql.default)((users)=>users.reduce((acc, next)=>{
        acc.push({
            value: next.accountId || '',
            label: next.displayName,
            avatar: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(next, [
                'avatarUrls',
                '24x24'
            ], '')
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$c072126708d93f04 = (0, $5iWql.default)((labels)=>labels.reduce((acc, next)=>{
        acc.push({
            value: next || '',
            label: next
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$cdfcc40760c1a4f8 = (0, $5iWql.default)((labels)=>labels?.suggestions.reduce((acc, next)=>{
        acc.push({
            value: next.label || '',
            label: next.label
        });
        return acc;
    }, []));
const $c6e67604bea772f5$var$getType = ({ type: type })=>{
    switch(type){
        case 0, $lO4Or.PRIORITY_TYPE:
            return (0, $1run3.FieldType).PrioritySelectFilter;
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            return (0, $1run3.FieldType).AvatarAsyncSelectFilter;
        case 0, $lO4Or.ISSUE_TYPE:
            return (0, $1run3.FieldType).AvatarSelectFilter;
        case 0, $lO4Or.STATUS_TYPE:
            return (0, $1run3.FieldType).LozengeSelectFilter;
        case 0, $lO4Or.LABELS_TYPE:
        case 0, $lO4Or.COMPONENTS_TYPE:
        case 0, $lO4Or.SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
            return (0, $1run3.FieldType).AsyncSelectFilter;
        case 0, $lO4Or.CREATED:
        case 0, $lO4Or.UPDATED:
        case 0, $lO4Or.DATE_CF_TYPE:
            return (0, $1run3.FieldType).DateFilter;
        case 0, $lO4Or.CATEGORY_TYPE:
            return (0, $1run3.FieldType).CategorySelectFilter;
        case 0, $lO4Or.NUMBER_CF_TYPE:
        case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
        default:
            return (0, $1run3.FieldType).SelectFilter;
    }
};
const $c6e67604bea772f5$var$getSelectCustomFieldValues = (field)=>(field?.fieldConfig?.selectOptions ?? []).map(({ value: value })=>({
            label: value,
            value: value
        }));
const $c6e67604bea772f5$var$getValues = ({ type: type, fieldOptionsData: fieldOptionsData, field: field, aliasFieldId: aliasFieldId })=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            return fieldOptionsData.users;
        case 0, $lO4Or.SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
            return $c6e67604bea772f5$var$getSelectCustomFieldValues(field);
        case 0, $lO4Or.NUMBER_CF_TYPE:
            if (aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)) return fieldOptionsData[0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID];
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return fieldOptionsData[type];
        case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
            return fieldOptionsData[0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID];
        default:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return fieldOptionsData[type];
    }
};
const $c6e67604bea772f5$var$isUserField = (type)=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            return true;
        default:
            return false;
    }
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $c6e67604bea772f5$var$isCustomField = (type)=>(0, $9TEHc.EXTRA_CUSTOM_FIELD_TYPES).has(type);
const $c6e67604bea772f5$var$createUserValueGetter = (userResolver)=>(0, $5iWql.default)((accountIds)=>// @ts-expect-error - TS7006 - Parameter 'response' implicitly has an 'any' type.
        userResolver.getUsersFromAccountId(accountIds).then((response)=>$c6e67604bea772f5$export$fb8c90bfc4beaa59(response)));
const $c6e67604bea772f5$export$ba4f3d2149c2bf3b = ({ formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId = new Set(), allFields: allFields, fieldOptionsData: fieldOptionsData, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, userResolver: userResolver })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldConfig = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const resolvers = {};
    if (allowedFieldTypes.has((0, $9TEHc.DATE_RANGE_TYPE))) // manually add dateRange to fieldConfig
    fieldConfig.dateRange = {
        label: formatMessage((0, $h1vWF.default).dateRangeLabel),
        type: (0, $1run3.FieldType).DateFilter
    };
    const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? '') || allowedAliasFieldId.has(field.aliasFieldId || ''));
    fields.forEach((field)=>{
        const { name: name, type: type, id: id, aliasFieldId: aliasFieldId } = field;
        // if the type is unsupported
        // or it's the start date field (which is handled separately as 'date range')
        // then skip
        if (type == null || aliasFieldId === (0, $jGcn0.START_DATE_ALIAS_FIELD_ID)) return;
        const selectType = $c6e67604bea772f5$var$getType({
            type: type
        });
        fieldConfig[id] = {
            systemType: type,
            label: name,
            type: selectType,
            placeholder: formatMessage((0, $h1vWF.default).filterPlaceholder),
            options: $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData,
                field: field,
                aliasFieldId: aliasFieldId
            }),
            isCustomField: $c6e67604bea772f5$var$isCustomField(type),
            fieldConfigVersion: 1
        };
        if (aliasFieldId != null && allowedAliasFieldId.has(aliasFieldId)) fieldConfig[id].aliasFieldId = aliasFieldId;
        if (type === (0, $lO4Or.ISSUE_TYPE)) fieldConfig[id].label = formatMessage((0, $h1vWF.default).typeLabel);
        if ($c6e67604bea772f5$var$isUserField(type)) {
            fieldConfig[id].loadOptions = fetchUsers;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
            resolvers[id] = $c6e67604bea772f5$var$createUserValueGetter(userResolver);
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: 'EMPTY',
                    label: formatMessage((0, $h1vWF.default).unassignedLabel),
                    isEmptyOption: true
                }
            ];
        }
        if (type === (0, $lO4Or.LABELS_TYPE)) {
            fieldConfig[id].loadOptions = fetchLabels;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $lO4Or.COMPONENTS_TYPE)) {
            fieldConfig[id].loadOptions = fetchComponents;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $lO4Or.CATEGORY_TYPE)) {
            fieldConfig[id].loadOptions = fetchCategories;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $lO4Or.SELECT_CF_TYPE) || type === (0, $lO4Or.MULTI_SELECT_CF_TYPE) || type === (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)) fieldConfig[id].options = [
            ...fieldConfig[id].options,
            {
                value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                label: formatMessage((0, $h1vWF.default).noneOption),
                isEmptyOption: true
            }
        ];
    });
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers
    };
};

});
parcelRegister("1run3", function(module, exports) {

$parcel$export(module.exports, "FieldType", () => $0804b64445570a47$export$ed12481c953b8653);
$parcel$export(module.exports, "isDateField", () => $0804b64445570a47$export$7d34c8548269835d);
const $0804b64445570a47$export$ed12481c953b8653 = {
    AsyncSelectFilter: 'AsyncSelectFilter',
    AvatarSelectFilter: 'AvatarSelectFilter',
    AvatarAsyncSelectFilter: 'AvatarAsyncSelectFilter',
    PaginatedAsyncSelectFilter: 'PaginatedAsyncSelectFilter',
    LozengeAsyncSelectFilter: 'LozengeAsyncSelectFilter',
    PaginatedLozengeAsyncSelectFilter: 'PaginatedLozengeAsyncSelectFilter',
    LozengeSelectFilter: 'LozengeSelectFilter',
    PrioritySelectFilter: 'PrioritySelectFilter',
    CategorySelectFilter: 'CategorySelectFilter',
    GoalsSelectFilter: 'GoalsSelectFilter',
    PaginatedAvatarAsyncSelectFilter: 'PaginatedAvatarAsyncSelectFilter',
    NumberFilter: 'NumberFilter',
    SelectFilter: 'SelectFilter',
    SearchFilter: 'SearchFilter',
    TextFilter: 'TextFilter',
    DateFilter: 'DateFilter',
    ProjectFilter: 'ProjectFilter'
};
const $0804b64445570a47$export$7d34c8548269835d = (field)=>field.type === $0804b64445570a47$export$ed12481c953b8653.DateFilter;

});

parcelRegister("dG4cR", function(module, exports) {

$parcel$export(module.exports, "OPTIMISTIC_ID", () => $36a0671262b022c0$export$6e40821019289c70);
$parcel$export(module.exports, "CREATE_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$d6ceedee35ae2c19);
$parcel$export(module.exports, "UPDATE_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$ca3691ea47eec823);
$parcel$export(module.exports, "DELETE_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$2a5fce320f18ac6c);
$parcel$export(module.exports, "STAR_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$b0ec8deb6068dc3b);
$parcel$export(module.exports, "SAVED_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$6c99c87a0ac0052a);
$parcel$export(module.exports, "EMPTY_FILTER_VALUE", () => $36a0671262b022c0$export$9ebaf9fe814731d3);
$parcel$export(module.exports, "SIMPLE_SEARCH_PARAM", () => $36a0671262b022c0$export$9b72011e2eb8d7d0);
const $36a0671262b022c0$export$b8b9d90f9e5bd72b = 'jiraBusinessFilters';
const $36a0671262b022c0$export$6e40821019289c70 = 'optimistic-filter-id';
const $36a0671262b022c0$export$d6ceedee35ae2c19 = {
    experience: 'filtersCreateSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$ca3691ea47eec823 = {
    experience: 'filtersUpdateSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$2a5fce320f18ac6c = {
    experience: 'filtersDeleteSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$b0ec8deb6068dc3b = {
    experience: 'filtersStarSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$6c99c87a0ac0052a = {
    experience: 'filtersLoadSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$9ebaf9fe814731d3 = null;
const $36a0671262b022c0$export$9b72011e2eb8d7d0 = 'text';

});

parcelRegister("h1vWF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a86e8a54f0713c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e2a86e8a54f0713c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filterPlaceholder: {
        "id": "business-filters.controllers.field-config.filter-placeholder",
        "defaultMessage": "Search"
    },
    dateRangeLabel: {
        "id": "business-filters.controllers.field-config.date-range-label",
        "defaultMessage": "Date range"
    },
    typeLabel: {
        "id": "business-filters.controllers.field-config.type-label",
        "defaultMessage": "Type"
    },
    unassignedLabel: {
        "id": "business-filters.controllers.field-config.unassigned-label",
        "defaultMessage": "Unassigned"
    },
    noneOption: {
        "id": "business-filters.controllers.field-config.none-option",
        "defaultMessage": "None"
    }
});

});



parcelRegister("aWjLM", function(module, exports) {

$parcel$export(module.exports, "useFieldConfigV2", () => $f0c719cf639dcc71$export$c041141a7ef797c1);

var $eUqFw = parcelRequire("eUqFw");

var $fDLFb = parcelRequire("fDLFb");

var $e20I1 = parcelRequire("e20I1");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $ejYlo = parcelRequire("ejYlo");

var $hLW3I = parcelRequire("hLW3I");

var $jWIW7 = parcelRequire("jWIW7");

var $7goEv = parcelRequire("7goEv");
const $f0c719cf639dcc71$var$EMPTY_FIELD_DATA = {
    totalCount: 0,
    options: []
};
const $f0c719cf639dcc71$var$EMPTY_FILTER_DATA = {
    initialUsers: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialLabels: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialComponents: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialPriorities: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialIssueTypes: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialStatuses: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialCategories: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialSprints: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialFixVersions: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialParents: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialGoals: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialTeams: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA
};
const $f0c719cf639dcc71$var$initialState = {
    data: undefined,
    loadingData: true
};
const $f0c719cf639dcc71$var$reducer = (state, action)=>{
    switch(action.type){
        case 'init':
            return $f0c719cf639dcc71$var$initialState;
        case 'fetch-data-success':
            return {
                ...state,
                data: action.value,
                loadingData: false
            };
        case 'fetch-data-error':
            return {
                ...state,
                data: $f0c719cf639dcc71$var$EMPTY_FILTER_DATA,
                loadingData: false
            };
        default:
            return state;
    }
};
/**
 * useFieldConfig hook that is used to populate the field and field values for JWM Filters.
 * It can be used for JWM Overviews which includes multiple Jira Projects.
 */ const $f0c719cf639dcc71$var$emptyFieldValue = {
    totalCount: 0,
    options: []
};
const $f0c719cf639dcc71$export$c041141a7ef797c1 = ({ view: view, allowedFieldTypes: allowedFieldTypes })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectFieldData = (0, $jWIW7.useProjectFilter)();
    const { data: filterFields, loading: loadingFilterFields } = (0, $hLW3I.useFilterFields)();
    const [{ data: data, loadingData: loadingData }, dispatch] = (0, $eUqFw.useReducer)($f0c719cf639dcc71$var$reducer, $f0c719cf639dcc71$var$initialState);
    const userResolver = (0, $eUqFw.useRef)(new (0, $e20I1.UserResolver)());
    const { fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchUsers: fetchUsers, fetchCategories: fetchCategories, fetchInitialData: fetchInitialData, ...fetchOptions } = (0, $ejYlo.useFetchFieldValues)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        filterFields: filterFields
    });
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const businessEntityId = entity.id;
    const initialiseDefaultData = (0, $eUqFw.useCallback)(()=>{
        fetchInitialData().then((initialData)=>{
            dispatch({
                type: 'fetch-data-success',
                value: {
                    initialUsers: initialData?.users ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialLabels: initialData?.labels ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialComponents: initialData?.components ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialPriorities: initialData?.priority ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialIssueTypes: initialData?.issuetype ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialStatuses: initialData?.status ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialCategories: initialData?.[0, $lO4Or.CATEGORY_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialSprints: initialData?.[0, $lO4Or.SPRINT_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
                        initialFixVersions: initialData?.[0, $lO4Or.FIX_VERSIONS_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                        initialParents: initialData?.[0, $lO4Or.PARENT_FIELD_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                        initialTeams: initialData?.[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue
                    } : {},
                    initialGoals: initialData?.[0, $lO4Or.GOALS_CF_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue
                }
            });
        }).catch(()=>{
            dispatch({
                type: 'fetch-data-error'
            });
        });
    }, [
        fetchInitialData
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!loadingFilterFields) {
            dispatch({
                type: 'init'
            });
            initialiseDefaultData();
        }
    }, [
        initialiseDefaultData,
        loadingFilterFields,
        businessEntityId
    ]);
    const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, $eUqFw.useMemo)(()=>{
        const fieldOptionsData = {
            priority: data?.initialPriorities ?? $f0c719cf639dcc71$var$emptyFieldValue,
            issuetype: data?.initialIssueTypes ?? $f0c719cf639dcc71$var$emptyFieldValue,
            status: data?.initialStatuses ?? $f0c719cf639dcc71$var$emptyFieldValue,
            users: data?.initialUsers ?? $f0c719cf639dcc71$var$emptyFieldValue,
            labels: data?.initialLabels ?? $f0c719cf639dcc71$var$emptyFieldValue,
            components: data?.initialComponents ?? $f0c719cf639dcc71$var$emptyFieldValue,
            [(0, $lO4Or.CATEGORY_TYPE)]: data?.initialCategories ?? $f0c719cf639dcc71$var$emptyFieldValue,
            [(0, $lO4Or.SPRINT_TYPE)]: data?.initialSprints ?? $f0c719cf639dcc71$var$emptyFieldValue,
            project: projectFieldData,
            ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
                [(0, $lO4Or.FIX_VERSIONS_TYPE)]: data?.initialFixVersions ?? $f0c719cf639dcc71$var$emptyFieldValue,
                [(0, $lO4Or.PARENT_FIELD_TYPE)]: data?.initialParents ?? $f0c719cf639dcc71$var$emptyFieldValue,
                [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: data?.initialTeams ?? $f0c719cf639dcc71$var$emptyFieldValue
            } : {},
            [(0, $lO4Or.GOALS_CF_TYPE)]: data?.initialGoals ?? $f0c719cf639dcc71$var$emptyFieldValue
        };
        return (0, $7goEv.getFilterFieldConfigAndResolvers)({
            view: view,
            formatMessage: formatMessage,
            allFields: filterFields,
            allowedFieldTypes: allowedFieldTypes,
            fieldOptionsData: fieldOptionsData,
            fetchUsers: fetchUsers,
            fetchLabels: fetchLabels,
            fetchComponents: fetchComponents,
            fetchCategories: fetchCategories,
            ...fetchOptions,
            userResolver: userResolver.current
        });
    }, [
        data?.initialPriorities,
        data?.initialIssueTypes,
        data?.initialStatuses,
        data?.initialUsers,
        data?.initialLabels,
        data?.initialComponents,
        data?.initialCategories,
        data?.initialSprints,
        data?.initialFixVersions,
        data?.initialParents,
        data?.initialGoals,
        data?.initialTeams,
        projectFieldData,
        view,
        formatMessage,
        filterFields,
        allowedFieldTypes,
        fetchUsers,
        fetchLabels,
        fetchComponents,
        fetchCategories,
        fetchOptions
    ]);
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers,
        loading: loadingData || loadingFilterFields || data == null
    };
};

});
parcelRegister("hLW3I", function(module, exports) {

$parcel$export(module.exports, "useFilterFields", () => $b966faf4b3b8c8a2$export$b2d30fa5478b571a);

var $eUqFw = parcelRequire("eUqFw");

var $kMmsu = parcelRequire("kMmsu");
const $b966faf4b3b8c8a2$export$b2d30fa5478b571a = ()=>{
    const { data: fields, loading: loading } = (0, $kMmsu.useFieldsResource)();
    const data = (0, $eUqFw.useMemo)(()=>fields?.map((field)=>({
                id: field.jqlTerm,
                name: field.displayName,
                type: field.type
            })) ?? [], [
        fields
    ]);
    return {
        data: data,
        loading: loading,
        error: undefined
    };
};

});

parcelRegister("7goEv", function(module, exports) {

$parcel$export(module.exports, "getFilterFieldConfigAndResolvers", () => $1ffbd75d284f79d7$export$ba4f3d2149c2bf3b);

var $illlw = parcelRequire("illlw");

var $5iWql = parcelRequire("5iWql");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $8rQuz = parcelRequire("8rQuz");

var $9TEHc = parcelRequire("9TEHc");

var $1run3 = parcelRequire("1run3");

var $dG4cR = parcelRequire("dG4cR");

var $9Jtgc = parcelRequire("9Jtgc");
const $1ffbd75d284f79d7$export$fb8c90bfc4beaa59 = (0, $5iWql.default)((users)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    users.reduce((acc, next)=>{
        acc.push({
            value: next.accountId || '',
            label: next.displayName,
            avatar: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(next, [
                'avatarUrls',
                '24x24'
            ], '')
        });
        return acc;
    }, []));
const $1ffbd75d284f79d7$var$getType = (type)=>{
    switch(type){
        case 0, $lO4Or.CATEGORY_TYPE:
            return (0, $1run3.FieldType).CategorySelectFilter;
        case 0, $lO4Or.PRIORITY_TYPE:
            return (0, $1run3.FieldType).PrioritySelectFilter;
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
            return (0, $1run3.FieldType).AvatarAsyncSelectFilter;
        case 0, $lO4Or.ISSUE_TYPE:
        case 0, $lO4Or.PARENT_FIELD_TYPE:
        case 0, $lO4Or.TEAMS_PLATFORM_CF_TYPE:
            return (0, $1run3.FieldType).AvatarSelectFilter;
        case 0, $lO4Or.STATUS_TYPE:
            return (0, $1run3.FieldType).LozengeSelectFilter;
        case 0, $lO4Or.LABELS_TYPE:
        case 0, $lO4Or.COMPONENTS_TYPE:
        case 0, $lO4Or.FIX_VERSIONS_TYPE:
        case 0, $lO4Or.SPRINT_TYPE:
            return (0, $1run3.FieldType).AsyncSelectFilter;
        case 0, $lO4Or.CREATED:
        case 0, $lO4Or.UPDATED:
            return (0, $1run3.FieldType).DateFilter;
        case 0, $lO4Or.PROJECT_TYPE:
            return (0, $1run3.FieldType).ProjectFilter;
        case 0, $lO4Or.GOALS_CF_TYPE:
            return (0, $1run3.FieldType).GoalsSelectFilter;
        default:
            return (0, $1run3.FieldType).SelectFilter;
    }
};
const $1ffbd75d284f79d7$var$getValues = (type, fieldOptionsData)=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
            return fieldOptionsData.users;
        default:
            return fieldOptionsData[type];
    }
};
const $1ffbd75d284f79d7$var$isUserField = (type)=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
            return true;
        default:
            return false;
    }
};
const $1ffbd75d284f79d7$var$isCustomField = (type)=>{
    switch(type){
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
        case 0, $lO4Or.SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
            return true;
        default:
            return false;
    }
};
const $1ffbd75d284f79d7$var$createUserValueGetter = (userResolver)=>(0, $5iWql.default)((accountIds)=>userResolver.getUsersFromAccountId(accountIds) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((response)=>$1ffbd75d284f79d7$export$fb8c90bfc4beaa59(response)));
const $1ffbd75d284f79d7$export$ba4f3d2149c2bf3b = ({ view: view, formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allFields: allFields, fieldOptionsData: fieldOptionsData, userResolver: userResolver, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, fetchStatuses: fetchStatuses, fetchPriorities: fetchPriorities, fetchIssueTypes: fetchIssueTypes, fetchSprints: fetchSprints, fetchFixVersions: fetchFixVersions, fetchParents: fetchParents, fetchGoals: fetchGoals, fetchTeams: fetchTeams })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldConfig = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const resolvers = {};
    if (allowedFieldTypes.has((0, $9TEHc.DATE_RANGE_TYPE))) // manually add dateRange to fieldConfig
    fieldConfig.dateRange = {
        label: formatMessage((0, $9Jtgc.default).dateRangeLabel),
        type: (0, $1run3.FieldType).DateFilter,
        fromLabel: formatMessage((0, $9Jtgc.default).startDateLabel),
        toLabel: formatMessage((0, $9Jtgc.default).dueDateLabel)
    };
    const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? ''));
    // eslint-disable-next-line complexity
    fields.forEach((field)=>{
        const { name: name, type: type, id: id } = field;
        const fieldType = type ?? '';
        const fieldValues = $1ffbd75d284f79d7$var$getValues(fieldType, fieldOptionsData);
        fieldConfig[id] = {
            label: name,
            type: $1ffbd75d284f79d7$var$getType(fieldType),
            placeholder: formatMessage((0, $9Jtgc.default).filterPlaceholder),
            options: fieldValues?.options || [],
            totalCount: fieldValues?.totalCount || 0,
            isCustomField: $1ffbd75d284f79d7$var$isCustomField(fieldType),
            fieldConfigVersion: 2
        };
        // issue type
        if (type === (0, $lO4Or.ISSUE_TYPE)) {
            let options = fieldValues?.options || [];
            if (view === 'board') {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                options = (fieldValues?.options).filter((option)=>option.hierarchyLevel !== -1);
                fieldConfig[id].options = options;
            }
            if (fetchIssueTypes) {
                fieldConfig[id].loadOptions = fetchIssueTypes;
                fieldConfig[id].defaultOptions = options;
            }
        } else if ($1ffbd75d284f79d7$var$isUserField(fieldType)) {
            fieldConfig[id].loadOptions = fetchUsers;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            resolvers[id] = $1ffbd75d284f79d7$var$createUserValueGetter(userResolver);
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).unassignedLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.LABELS_TYPE)) {
            fieldConfig[id].loadOptions = fetchLabels;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noLabelsLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.COMPONENTS_TYPE)) {
            fieldConfig[id].loadOptions = fetchComponents;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noComponentsLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.CATEGORY_TYPE)) {
            fieldConfig[id].loadOptions = fetchCategories;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noCategoriesLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.STATUS_TYPE) && fetchStatuses) {
            fieldConfig[id].loadOptions = fetchStatuses;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
        } else if (fieldType === (0, $lO4Or.PRIORITY_TYPE) && fetchPriorities) {
            fieldConfig[id].loadOptions = fetchPriorities;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
        } else if (fieldType === (0, $lO4Or.SPRINT_TYPE) && fetchSprints) {
            fieldConfig[id].loadOptions = fetchSprints;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noSprintLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.FIX_VERSIONS_TYPE) && fetchFixVersions && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            fieldConfig[id].loadOptions = fetchFixVersions;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noVersionLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.PARENT_FIELD_TYPE) && fetchParents && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            fieldConfig[id].loadOptions = fetchParents;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noParentLabel),
                    isEmptyOption: true,
                    ...(0, $8rQuz.isVisualRefreshEnabled)() && {
                        square: true
                    }
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.GOALS_CF_TYPE) && fetchGoals) {
            fieldConfig[id].loadOptions = fetchGoals;
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noGoalLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fetchTeams && fieldType === (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            fieldConfig[id].loadOptions = fetchTeams;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noTeamLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        }
    });
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers
    };
};

});
parcelRegister("9Jtgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $510082940a52668b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $510082940a52668b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filterPlaceholder: {
        "id": "business-filters.controllers.field-config-v2.filter-placeholder",
        "defaultMessage": "Search"
    },
    dateRangeLabel: {
        "id": "business-filters.controllers.field-config-v2.date-range-label",
        "defaultMessage": "Date range"
    },
    startDateLabel: {
        "id": "business-filters.controllers.field-config-v2.start-date-label",
        "defaultMessage": "Start date"
    },
    dueDateLabel: {
        "id": "business-filters.controllers.field-config-v2.due-date-label",
        "defaultMessage": "Due date"
    },
    unassignedLabel: {
        "id": "business-filters.controllers.field-config-v2.unassigned-label",
        "defaultMessage": "Unassigned"
    },
    noLabelsLabel: {
        "id": "business-filters.controllers.field-config-v2.no-labels-label",
        "defaultMessage": "No label"
    },
    noCategoriesLabel: {
        "id": "business-filters.controllers.field-config-v2.no-categories-label",
        "defaultMessage": "No category"
    },
    noComponentsLabel: {
        "id": "business-filters.controllers.field-config-v2.no-components-label",
        "defaultMessage": "No component"
    },
    noSprintLabel: {
        "id": "business-filters.controllers.field-config-v2.no-sprint-label",
        "defaultMessage": "Backlog"
    },
    noVersionLabel: {
        "id": "business-filters.controllers.field-config-v2.no-version-label",
        "defaultMessage": "No version"
    },
    noParentLabel: {
        "id": "business-filters.controllers.field-config-v2.no-parent-label",
        "defaultMessage": "No parent"
    },
    noGoalLabel: {
        "id": "business-filters.controllers.field-config-v2.no-goal-label",
        "defaultMessage": "No goal"
    },
    noTeamLabel: {
        "id": "business-filters.controllers.field-config-v2.no-team-label",
        "defaultMessage": "No team"
    }
});

});




parcelRegister("gZpkQ", function(module, exports) {

$parcel$export(module.exports, "useHideDoneItems", () => $0e65969a09396197$export$c2cb7b17819b92d4);
$parcel$export(module.exports, "useInferHideDoneItemsWithFilters", () => $0e65969a09396197$export$a14bc8305f71e469);

var $eUqFw = parcelRequire("eUqFw");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $8Qd0L = parcelRequire("8Qd0L");

var $9GlEj = parcelRequire("9GlEj");
const $0e65969a09396197$export$c2cb7b17819b92d4 = ()=>{
    const [hideDoneItems, persistHideDoneItems] = (0, $7c3W1.useViewPreference)((0, $ji3xf.HIDE_DONE_ITEMS_PREFERENCE));
    const setHideDoneItems = (0, $eUqFw.useCallback)((hide, action = 'push')=>persistHideDoneItems(hide ? 'true' : undefined, action), [
        persistHideDoneItems
    ]);
    return [
        hideDoneItems === 'true',
        setHideDoneItems
    ];
};
const $0e65969a09396197$export$a14bc8305f71e469 = ({ filters: filters })=>{
    const [hideDoneItems, setHideDoneItems] = $0e65969a09396197$export$c2cb7b17819b92d4();
    const { quickFilters: quickFilters } = (0, $9GlEj.useQuickFilters)();
    (0, $eUqFw.useEffect)(()=>{
        if (hideDoneItems) {
            const isFilteringByDoneStatus = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (filters && filters.status)?.find((status)=>Number(status.categoryId) === (0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).DONE]);
            if (isFilteringByDoneStatus || quickFilters?.DONE) setHideDoneItems(false, 'replace');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filters,
        quickFilters?.DONE
    ]);
};

});
parcelRegister("9GlEj", function(module, exports) {

$parcel$export(module.exports, "useQuickFilters", () => $20c7583d02c9250e$export$3dae1bb95b659fd4);

var $eUqFw = parcelRequire("eUqFw");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $lO4Or = parcelRequire("lO4Or");

var $kMmsu = parcelRequire("kMmsu");
const $20c7583d02c9250e$var$quickFilterToJQLMapOld = {
    ASSIGNED_TO_ME: 'assignee = currentUser()',
    DONE: "StatusCategory = 'Complete'",
    DUE_THIS_WEEK: 'duedate <= endOfWeek() and duedate > startOfWeek()'
};
const $20c7583d02c9250e$export$808f76242d61e1a5 = (sprintJQLTerm)=>{
    if (sprintJQLTerm == null) return $20c7583d02c9250e$var$quickFilterToJQLMapOld;
    return {
        ...$20c7583d02c9250e$var$quickFilterToJQLMapOld,
        ACTIVE_SPRINTS: `${sprintJQLTerm} in openSprints()`
    };
};
const $20c7583d02c9250e$var$buildJQLFromQuickFilters = (quickFilters, { quickFilterToJQLMap: quickFilterToJQLMap = $20c7583d02c9250e$var$quickFilterToJQLMapOld } = {})=>{
    const jqlClauses = Object.entries(quickFilters).map(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly ASSIGNED_TO_ME: "assignee = currentUser()"; readonly DONE: "StatusCategory = 'Complete'"; readonly DUE_THIS_WEEK: "duedate <= endOfWeek() and duedate > startOfWeek()"; }'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([key, isEnabled])=>isEnabled === true && quickFilterToJQLMap[key]);
    const enabledFilters = jqlClauses.filter((jql)=>jql);
    return enabledFilters.join(' AND ') || null;
};
const $20c7583d02c9250e$export$9294471da4d3c33f = {
    ASSIGNED_TO_ME: false,
    DONE: false,
    DUE_THIS_WEEK: false,
    ACTIVE_SPRINTS: false
};
const $20c7583d02c9250e$export$9692fc1a2fd983f5 = (jql, { quickFilterToJQLMap: quickFilterToJQLMap = $20c7583d02c9250e$var$quickFilterToJQLMapOld } = {})=>{
    const quickFilters = {
        ...$20c7583d02c9250e$export$9294471da4d3c33f
    };
    if (!jql) return quickFilters;
    if (jql.includes(quickFilterToJQLMap.ASSIGNED_TO_ME)) quickFilters.ASSIGNED_TO_ME = true;
    if (jql.includes(quickFilterToJQLMap.DONE)) quickFilters.DONE = true;
    if (jql.includes(quickFilterToJQLMap.DUE_THIS_WEEK)) quickFilters.DUE_THIS_WEEK = true;
    if (quickFilterToJQLMap.ACTIVE_SPRINTS && jql.includes(quickFilterToJQLMap.ACTIVE_SPRINTS)) quickFilters.ACTIVE_SPRINTS = true;
    return quickFilters;
};
const $20c7583d02c9250e$var$useSprintFieldJQLTerm = ()=>{
    const { data: fields } = (0, $kMmsu.useFieldsResource)();
    return (0, $eUqFw.useMemo)(()=>{
        if (fields == null) return undefined;
        const sprintField = fields.find((field)=>field.type === (0, $lO4Or.SPRINT_TYPE));
        return sprintField != null ? sprintField.jqlTerm : undefined;
    }, [
        fields
    ]);
};
const $20c7583d02c9250e$export$3dae1bb95b659fd4 = ()=>{
    const sprintFieldJQLTerm = $20c7583d02c9250e$var$useSprintFieldJQLTerm();
    const quickFilterToJQLMap = (0, $eUqFw.useMemo)(()=>$20c7583d02c9250e$export$808f76242d61e1a5(sprintFieldJQLTerm), [
        sprintFieldJQLTerm
    ]);
    const [filters, setFilters] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FILTER_PREFERENCE));
    const setQuickFilters = (0, $eUqFw.useCallback)((newQuickFilters)=>{
        if (newQuickFilters) {
            const jql = $20c7583d02c9250e$var$buildJQLFromQuickFilters(newQuickFilters, {
                quickFilterToJQLMap: quickFilterToJQLMap
            });
            if (jql == null) setFilters(undefined);
            else setFilters(jql);
        } else setFilters(undefined);
    }, [
        quickFilterToJQLMap,
        setFilters
    ]);
    const quickFilters = (0, $eUqFw.useMemo)(()=>$20c7583d02c9250e$export$9692fc1a2fd983f5(filters, {
            quickFilterToJQLMap: quickFilterToJQLMap
        }), [
        filters,
        quickFilterToJQLMap
    ]);
    return {
        quickFilters: quickFilters,
        persistQuickFilters: setQuickFilters,
        quickFiltersJql: $20c7583d02c9250e$var$buildJQLFromQuickFilters(quickFilters, {
            quickFilterToJQLMap: quickFilterToJQLMap
        })
    };
};

});


parcelRegister("lEWmB", function(module, exports) {

$parcel$export(module.exports, "useFilters", () => $2972841342234906$export$973ca22476b0e05f);

var $eUqFw = parcelRequire("eUqFw");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $8aCHU = parcelRequire("8aCHU");
const $2972841342234906$export$973ca22476b0e05f = ()=>{
    const [jql, saveFilters] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FILTER_PREFERENCE));
    const setFilter = (0, $eUqFw.useCallback)((filters)=>{
        const serialisedJql = (0, $8aCHU.serialiseJql)(filters);
        saveFilters(serialisedJql !== '' ? serialisedJql : undefined);
    }, [
        saveFilters
    ]);
    return {
        setFilter: setFilter,
        jql: jql
    };
};

});
parcelRegister("8aCHU", function(module, exports) {

$parcel$export(module.exports, "serialiseJql", () => $0e700551905b00b3$export$e1718e1e441cb0f6);
$parcel$export(module.exports, "extractAnalyticsFilterDataFromJQL", () => $0e700551905b00b3$export$9ee6085825c9cbfa);

var $8blac = parcelRequire("8blac");

var $27QuD = parcelRequire("27QuD");

var $6wqPF = parcelRequire("6wqPF");

var $6x1NF = parcelRequire("6x1NF");

var $55Dca = parcelRequire("55Dca");
var $8XgA0 = parcelRequire("8XgA0");
var $kIKLu = parcelRequire("kIKLu");

var $dG4cR = parcelRequire("dG4cR");
const $0e700551905b00b3$var$START_DATE_JQL = 'Start date[Date]';
const $0e700551905b00b3$var$EMPTY = 'EMPTY';
const $0e700551905b00b3$var$getQuotedFieldName = (fieldName)=>`"${fieldName}"`;
const $0e700551905b00b3$var$getFieldNameForJqlRaw = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    if (fieldName.indexOf('customfield_') === 0) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
    // the "to" fieldName for the date range will be transformed to "due" in the "serialiseJql" function
    // where "const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;"
    if (fieldName === 'dateRange') return $0e700551905b00b3$var$START_DATE_JQL;
    return fieldName;
};
const $0e700551905b00b3$var$getFieldNameForJql = (fieldName)=>$0e700551905b00b3$var$getQuotedFieldName($0e700551905b00b3$var$getFieldNameForJqlRaw(fieldName));
const $0e700551905b00b3$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
    const fieldName = (0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(rawFieldName, '"');
    const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
    // `cf[id]` -> `customfield_${id}`.
    if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
        const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
        if (!extraction) return fieldName;
        const fieldId = extraction[1];
        return `customfield_${fieldId}`;
    }
    const startDateJql = $0e700551905b00b3$var$START_DATE_JQL;
    // update this if we add a start date or due date filter
    if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
    return fieldName;
};
const $0e700551905b00b3$var$sanitizeWord = (word)=>word.replace(/(["\\])/g, '\\$1');
const $0e700551905b00b3$var$sanitizeWordOld = (word)=>word.replace(/'/g, "\\'");
const $0e700551905b00b3$export$e1718e1e441cb0f6 = (filters)=>{
    const jqlQuery = (0, $55Dca.default).query();
    Object.entries(filters).filter(([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options.value)))).forEach(([fieldId, options])=>{
        const fieldName = $0e700551905b00b3$var$getFieldNameForJqlRaw(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;
            if (options.value.to != null) {
                const toDate = (0, $6x1NF.default)((0, $6wqPF.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
                jqlQuery.appendClause((0, $55Dca.default).terminalClause((0, $55Dca.default).field(toFieldName), (0, $55Dca.default).operator((0, $8XgA0.OPERATOR_LT)), (0, $55Dca.default).valueOperand(toDate)), (0, $e1349279c1d70213$export$6d6d48d210d3ca97));
            }
            if (options.value.from != null) jqlQuery.appendClause((0, $55Dca.default).terminalClause((0, $55Dca.default).field(fieldName), (0, $55Dca.default).operator((0, $8XgA0.OPERATOR_GT_EQUALS)), (0, $55Dca.default).valueOperand(options.value.from)), (0, $e1349279c1d70213$export$6d6d48d210d3ca97));
            return;
        }
        if (Array.isArray(options)) {
            const operands = options.map((option)=>{
                if (option.isEmptyOption) return (0, $55Dca.default).valueOperand((0, $2de6644e999aca05$export$1c46dca02aac24dd));
                if (option.value) // Currently, the AST does not sanatize all values correctly (no \ or JQL keywords), so we need to manually wrap in quotes
                // We can remove this once https://jplat.jira.atlassian.cloud/browse/EM-6563 is implemented
                return (0, $55Dca.default).byText.valueOperand(`"${$0e700551905b00b3$var$sanitizeWord(option.value)}"`);
                return null;
            }).filter((operand)=>operand != null);
            if (operands.length === 1) jqlQuery.appendClause((0, $55Dca.default).terminalClause((0, $55Dca.default).field(fieldName), (0, $55Dca.default).operator((0, $8XgA0.OPERATOR_EQUALS)), operands[0]), (0, $e1349279c1d70213$export$6d6d48d210d3ca97));
            else if (operands.length > 1) jqlQuery.appendClause((0, $55Dca.default).terminalClause((0, $55Dca.default).field(fieldName), (0, $55Dca.default).operator((0, $8XgA0.OPERATOR_IN)), (0, $55Dca.default).listOperand(operands)), (0, $e1349279c1d70213$export$6d6d48d210d3ca97));
        }
    });
    const jast = (0, $55Dca.default).jast(jqlQuery);
    return (0, $kIKLu.print)(jast, {
        operatorCase: 'upper',
        printWidth: null
    });
};
const $0e700551905b00b3$export$5bd6a523f48a18cd = (filters)=>{
    const pairs = Object.entries(filters).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options.value)))) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(([fieldId, options])=>{
        const fieldName = $0e700551905b00b3$var$getFieldNameForJql(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? $0e700551905b00b3$var$getQuotedFieldName('due') : fieldName;
            let toDate;
            if (options.value.to) toDate = (0, $6x1NF.default)((0, $6wqPF.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
            else toDate = options.value.to;
            if (options.value.from != null && options.value.to != null) return `${fieldName} >= ${options.value.from} AND ${toFieldName} < ${toDate}`;
            if (options.value.from != null) return `${fieldName} >= ${options.value.from}`;
            return `${toFieldName} < ${toDate}`;
        }
        if (Array.isArray(options)) {
            const values = options.map((option)=>// make sure we don't wrap EMPTY with quotation marks
                option.value === (0, $dG4cR.EMPTY_FILTER_VALUE) ? $0e700551905b00b3$var$EMPTY : `'${$0e700551905b00b3$var$sanitizeWordOld(option.value)}'`).join(',');
            if (options.length > 1) return `${fieldName} in (${values})`;
            if (options.length === 1) return `${fieldName} = ${values}`;
        }
        return null;
    });
    return pairs.join(' AND ');
};
const $0e700551905b00b3$var$extractField = (statement)=>{
    let fieldId;
    const dateOperatorRegex = />=|</;
    if (dateOperatorRegex.test(statement)) {
        const operator = statement.includes('>=') ? ' >= ' : ' < ';
        [fieldId] = statement.split(operator);
    }
    if (statement.includes(' = ')) [fieldId] = statement.split(/ = /);
    if (statement.includes(' in ')) [fieldId] = statement.split(' in ');
    if (fieldId) return $0e700551905b00b3$var$getFieldIdFromJql(fieldId);
};
const $0e700551905b00b3$export$9ee6085825c9cbfa = (jql)=>{
    if (!jql) return {};
    return jql.split(/ AND | OR /).map($0e700551905b00b3$var$extractField).reduce((acc, curr)=>{
        if (curr) acc[curr] = true;
        return acc;
    }, {});
};

});
parcelRegister("27QuD", function(module, exports) {

var $TLr3n = parcelRequire("TLr3n");

var $2cjNq = parcelRequire("2cjNq");

var $8SGvQ = parcelRequire("8SGvQ");

var $1qE1i = parcelRequire("1qE1i");

var $3Muqa = parcelRequire("3Muqa");

var $aSldm = parcelRequire("aSldm");

var $1uqnh = parcelRequire("1uqnh");
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */ function $18c4f43cd593e3cf$var$trim(string, chars, guard) {
    string = $1uqnh(string);
    if (string && (guard || chars === undefined)) return $2cjNq(string);
    if (!string || !(chars = $TLr3n(chars))) return string;
    var strSymbols = $aSldm(string), chrSymbols = $aSldm(chars), start = $3Muqa(strSymbols, chrSymbols), end = $1qE1i(strSymbols, chrSymbols) + 1;
    return $8SGvQ(strSymbols, start, end).join('');
}
module.exports = $18c4f43cd593e3cf$var$trim;

});
parcelRegister("1qE1i", function(module, exports) {

var $jkhuN = parcelRequire("jkhuN");
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */ function $10a7434ada2e55c3$var$charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while(index-- && $jkhuN(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $10a7434ada2e55c3$var$charsEndIndex;

});

parcelRegister("3Muqa", function(module, exports) {

var $jkhuN = parcelRequire("jkhuN");
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */ function $2c0d73c17288fd42$var$charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while(++index < length && $jkhuN(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $2c0d73c17288fd42$var$charsStartIndex;

});


const $e1349279c1d70213$export$6d6d48d210d3ca97 = 'and';
const $e1349279c1d70213$export$7b8f0a728d79a753 = 'or';

parcelRegister("55Dca", function(module, exports) {

$parcel$export(module.exports, "internalCreators", () => $876926dadbc56bc1$export$64d991963cfb5532);
$parcel$export(module.exports, "default", () => $876926dadbc56bc1$export$2e2bcd8739ae039);

var $4mYVT = parcelRequire("4mYVT");

var $3IhRr = parcelRequire("3IhRr");

var $70rVX = parcelRequire("70rVX");

var $h5i68 = parcelRequire("h5i68");

var $fXQsV = parcelRequire("fXQsV");

var $jL5jO = parcelRequire("jL5jO");

var $b8zeG = parcelRequire("b8zeG");

var $keFUI = parcelRequire("keFUI");

var $2QYLq = parcelRequire("2QYLq");

var $lLAVO = parcelRequire("lLAVO");

var $9jf8v = parcelRequire("9jf8v");

var $exKrk = parcelRequire("exKrk");

var $bRHc6 = parcelRequire("bRHc6");

var $k4WW7 = parcelRequire("k4WW7");

var $5W28H = parcelRequire("5W28H");

var $l2Fln = parcelRequire("l2Fln");

var $48MtH = parcelRequire("48MtH");

var $bnlOP = parcelRequire("bnlOP");

var $3RwpB = parcelRequire("3RwpB");

var $3wJKB = parcelRequire("3wJKB");

var $8I1Hc = parcelRequire("8I1Hc");

var $eCGp1 = parcelRequire("eCGp1");
const $876926dadbc56bc1$export$64d991963cfb5532 = {
    query: (0, $3wJKB.queryInternal),
    compoundClause: (0, $3IhRr.compoundClauseInternal),
    compoundOperator: (0, $70rVX.compoundOperatorInternal),
    terminalClause: (0, $8I1Hc.terminalClauseInternal),
    notClause: (0, $lLAVO.notClauseInternal),
    notClauseOperator: (0, $9jf8v.notClauseOperatorInternal),
    predicate: (0, $48MtH.predicateInternal),
    predicateOperator: (0, $bnlOP.predicateOperatorInternal),
    field: (0, $h5i68.fieldInternal),
    property: (0, $3RwpB.propertyInternal),
    operator: (0, $exKrk.operatorInternal),
    valueOperand: (0, $eCGp1.valueOperandInternal),
    keywordOperand: (0, $keFUI.keywordOperandInternal),
    functionOperand: (0, $fXQsV.functionOperandInternal),
    functionString: (0, $jL5jO.functionStringInternal),
    argument: (0, $4mYVT.argumentInternal),
    listOperand: (0, $2QYLq.listOperandInternal),
    orderBy: (0, $bRHc6.orderByInternal),
    orderByOperator: (0, $l2Fln.orderByOperatorInternal),
    orderByField: (0, $5W28H.orderByFieldInternal),
    orderByDirection: (0, $k4WW7.orderByDirectionInternal)
};
var $876926dadbc56bc1$export$2e2bcd8739ae039 = {
    jast: $b8zeG.jast,
    query: $3wJKB.query,
    compoundClause: $3IhRr.compoundClause,
    compoundOperator: $70rVX.compoundOperator,
    terminalClause: $8I1Hc.terminalClause,
    notClause: $lLAVO.notClause,
    notClauseOperator: $9jf8v.notClauseOperator,
    predicate: $48MtH.predicate,
    predicateOperator: $bnlOP.predicateOperator,
    field: $h5i68.field,
    property: $3RwpB.property,
    operator: $exKrk.operator,
    valueOperand: $eCGp1.valueOperand,
    keywordOperand: $keFUI.keywordOperand,
    functionOperand: $fXQsV.functionOperand,
    functionString: $jL5jO.functionString,
    argument: $4mYVT.argument,
    listOperand: $2QYLq.listOperand,
    orderBy: $bRHc6.orderBy,
    orderByOperator: $l2Fln.orderByOperator,
    orderByField: $5W28H.orderByField,
    orderByDirection: $k4WW7.orderByDirection,
    byText: {
        argument: (0, $4mYVT.argumentByText),
        valueOperand: (0, $eCGp1.valueOperandByText)
    }
};

});
parcelRegister("4mYVT", function(module, exports) {

$parcel$export(module.exports, "argument", () => $bd726e6c839618bd$export$6ea29ee575e3f5ff);
$parcel$export(module.exports, "argumentInternal", () => $bd726e6c839618bd$export$5b341d50fa5bcdd5);
$parcel$export(module.exports, "argumentByText", () => $bd726e6c839618bd$export$84c43d23f51170cb);

var $12XiF = parcelRequire("12XiF");
var $41dcP = parcelRequire("41dcP");

var $kbDZ5 = parcelRequire("kbDZ5");
function $bd726e6c839618bd$var$acceptArgument(visitor) {
    return visitor.visitArgument ? visitor.visitArgument(this) : visitor.visitChildren(this);
}
function $bd726e6c839618bd$var$enterNode(listener) {
    listener.enterArgument && listener.enterArgument(this);
}
function $bd726e6c839618bd$var$exitNode(listener) {
    listener.exitArgument && listener.exitArgument(this);
}
const $bd726e6c839618bd$export$6ea29ee575e3f5ff = (value)=>$bd726e6c839618bd$export$5b341d50fa5bcdd5(value, (0, $41dcP.sanitiseJqlString)(value));
const $bd726e6c839618bd$export$84c43d23f51170cb = (text)=>$bd726e6c839618bd$export$5b341d50fa5bcdd5((0, $12XiF.normaliseJqlString)(text), text);
const $bd726e6c839618bd$export$5b341d50fa5bcdd5 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $bd726e6c839618bd$var$acceptArgument,
        enterNode: $bd726e6c839618bd$var$enterNode,
        exitNode: $bd726e6c839618bd$var$exitNode,
        getChildren: (0, $kbDZ5.noChildren),
        parent: null
    });

});
parcelRegister("12XiF", function(module, exports) {

$parcel$export(module.exports, "normaliseJqlString", () => $a65a0427dc5dde28$export$cecf78a779acc0ff);
const $a65a0427dc5dde28$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $a65a0427dc5dde28$export$d5efd6512db694fd = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $a65a0427dc5dde28$export$b86601123607fee5 = (maybeQuotedString)=>$a65a0427dc5dde28$export$7a0b99b892e0dda8(maybeQuotedString) || $a65a0427dc5dde28$export$d5efd6512db694fd(maybeQuotedString);
const $a65a0427dc5dde28$export$cecf78a779acc0ff = (maybeQuotedString)=>{
    if ($a65a0427dc5dde28$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
    if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
    return maybeQuotedString;
};

});

parcelRegister("41dcP", function(module, exports) {

$parcel$export(module.exports, "sanitiseJqlString", () => $6158181a9442288a$export$3eb9033c48208278);

var $e1vfz = parcelRequire("e1vfz");
// Derived from JQLLexer#VALID_UNQUOTED_CHARS
const $6158181a9442288a$var$CHARS_TO_QUOTE = new RegExp(`[\\s${(0, (/*@__PURE__*/$parcel$interopDefault($e1vfz)))(`"'=!<>()~,[]|&{}*/%+^$#@?;`)}]`);
const $6158181a9442288a$export$3eb9033c48208278 = (jqlString)=>{
    if ($6158181a9442288a$var$CHARS_TO_QUOTE.test(jqlString)) return `"${jqlString.replace(/"/g, '\\"')}"`;
    return jqlString;
};

});
parcelRegister("e1vfz", function(module, exports) {

var $1uqnh = parcelRequire("1uqnh");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $a359664a3c663e8b$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $a359664a3c663e8b$var$reHasRegExpChar = RegExp($a359664a3c663e8b$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $a359664a3c663e8b$var$escapeRegExp(string) {
    string = $1uqnh(string);
    return string && $a359664a3c663e8b$var$reHasRegExpChar.test(string) ? string.replace($a359664a3c663e8b$var$reRegExpChar, '\\$&') : string;
}
module.exports = $a359664a3c663e8b$var$escapeRegExp;

});


parcelRegister("kbDZ5", function(module, exports) {

$parcel$export(module.exports, "noChildren", () => $4c6ebdf242fd43ee$export$470bef71e654b804);
$parcel$export(module.exports, "assignParent", () => $4c6ebdf242fd43ee$export$a4685923af2913a);
const $4c6ebdf242fd43ee$export$470bef71e654b804 = ()=>[];
const $4c6ebdf242fd43ee$export$a4685923af2913a = (node)=>{
    node.getChildren().forEach((child)=>{
        child.parent = node;
    });
};

});


parcelRegister("3IhRr", function(module, exports) {

$parcel$export(module.exports, "compoundClause", () => $9904eba3974f5fe3$export$ab714e56a32c25f2);
$parcel$export(module.exports, "compoundClauseInternal", () => $9904eba3974f5fe3$export$cd65eed8c10b0911);


var $cTsBk = parcelRequire("cTsBk");

var $kbDZ5 = parcelRequire("kbDZ5");
function $9904eba3974f5fe3$var$acceptCompoundClause(visitor) {
    return visitor.visitCompoundClause ? visitor.visitCompoundClause(this) : visitor.visitChildren(this);
}
function $9904eba3974f5fe3$var$enterNode(listener) {
    listener.enterCompoundClause && listener.enterCompoundClause(this);
}
function $9904eba3974f5fe3$var$exitNode(listener) {
    listener.exitCompoundClause && listener.exitCompoundClause(this);
}
function $9904eba3974f5fe3$var$getChildren() {
    return [
        this.operator,
        ...this.clauses
    ];
}
const $9904eba3974f5fe3$export$ab714e56a32c25f2 = (operator, clauses)=>{
    return $9904eba3974f5fe3$export$cd65eed8c10b0911(operator, clauses);
};
const $9904eba3974f5fe3$export$cd65eed8c10b0911 = (operator, clauses, position = null)=>{
    const node = {
        type: (0, $91159b9055013116$export$2d205682cc545947),
        clauseType: (0, $24102d5d112d2831$export$7a58b23488ea076b),
        operator: operator,
        clauses: clauses,
        position: position,
        accept: $9904eba3974f5fe3$var$acceptCompoundClause,
        enterNode: $9904eba3974f5fe3$var$enterNode,
        exitNode: $9904eba3974f5fe3$var$exitNode,
        getChildren: $9904eba3974f5fe3$var$getChildren,
        parent: null,
        appendClause: $cTsBk.appendClause,
        remove: $cTsBk.remove,
        removeClause: $cTsBk.removeClause,
        replace: $cTsBk.replace,
        replaceClause: $cTsBk.replaceClause
    };
    (0, $kbDZ5.assignParent)(node);
    return node;
};

});
const $24102d5d112d2831$export$7a58b23488ea076b = 'compound';
const $24102d5d112d2831$export$ae56b4ef248a2b6a = 'terminal';
const $24102d5d112d2831$export$e356b89f8c8d2fcb = 'not';

const $91159b9055013116$export$98dda21ec825792 = 'query';
const $91159b9055013116$export$2d205682cc545947 = 'clause';
const $91159b9055013116$export$d2f212d8ddbc8d1d = 'operand';
const $91159b9055013116$export$da0f73edded4a63d = 'order_by';

parcelRegister("cTsBk", function(module, exports) {

$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);


var $kbDZ5 = parcelRequire("kbDZ5");
function appendClause(clause) {
    let clausesToAppend = [
        clause
    ];
    // If the clause to append is compound with a matching operator then we flatten it into the current clause
    if (clause.clauseType === (0, $24102d5d112d2831$export$7a58b23488ea076b) && clause.operator.value === this.operator.value) clausesToAppend = clause.clauses;
    this.clauses.push(...clausesToAppend);
    (0, $kbDZ5.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    this.clauses = this.clauses.filter((val)=>val !== clause);
    if (this.clauses.length === 1) this.replace(this.clauses[0]);
    else if (this.clauses.length === 0) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    this.clauses = this.clauses.map((child)=>{
        return child === clause ? nextClause : child;
    });
    (0, $kbDZ5.assignParent)(this);
}

});


parcelRegister("70rVX", function(module, exports) {

$parcel$export(module.exports, "compoundOperator", () => $8bd48275984f4d0a$export$84bb3ebbba491aee);
$parcel$export(module.exports, "compoundOperatorInternal", () => $8bd48275984f4d0a$export$63c33bc3fe74fee6);

var $kbDZ5 = parcelRequire("kbDZ5");
function $8bd48275984f4d0a$var$acceptCompoundOperator(visitor) {
    return visitor.visitCompoundOperator ? visitor.visitCompoundOperator(this) : visitor.visitChildren(this);
}
function $8bd48275984f4d0a$var$enterNode(listener) {
    listener.enterCompoundOperator && listener.enterCompoundOperator(this);
}
function $8bd48275984f4d0a$var$exitNode(listener) {
    listener.exitCompoundOperator && listener.exitCompoundOperator(this);
}
const $8bd48275984f4d0a$export$84bb3ebbba491aee = (value)=>$8bd48275984f4d0a$export$63c33bc3fe74fee6(value, []);
const $8bd48275984f4d0a$export$63c33bc3fe74fee6 = (value, operatorPositions)=>({
        value: value,
        positions: operatorPositions,
        position: null,
        accept: $8bd48275984f4d0a$var$acceptCompoundOperator,
        enterNode: $8bd48275984f4d0a$var$enterNode,
        exitNode: $8bd48275984f4d0a$var$exitNode,
        getChildren: (0, $kbDZ5.noChildren),
        parent: null
    });

});

parcelRegister("h5i68", function(module, exports) {

$parcel$export(module.exports, "field", () => $867ff7b6cc0ee596$export$e0f35d825088c098);
$parcel$export(module.exports, "fieldInternal", () => $867ff7b6cc0ee596$export$2193f8c541622b6);

var $41dcP = parcelRequire("41dcP");

var $kbDZ5 = parcelRequire("kbDZ5");
function $867ff7b6cc0ee596$var$acceptField(visitor) {
    return visitor.visitField ? visitor.visitField(this) : visitor.visitChildren(this);
}
function $867ff7b6cc0ee596$var$enterNode(listener) {
    listener.enterField && listener.enterField(this);
}
function $867ff7b6cc0ee596$var$exitNode(listener) {
    listener.exitField && listener.exitField(this);
}
function $867ff7b6cc0ee596$var$getChildren() {
    return this.properties ? [
        ...this.properties
    ] : [];
}
const $867ff7b6cc0ee596$export$e0f35d825088c098 = (value, properties)=>{
    return $867ff7b6cc0ee596$export$2193f8c541622b6(value, (0, $41dcP.sanitiseJqlString)(value), properties);
};
const $867ff7b6cc0ee596$export$2193f8c541622b6 = (value, text, properties, position = null)=>{
    const node = {
        text: text,
        value: value,
        properties: properties,
        position: position,
        accept: $867ff7b6cc0ee596$var$acceptField,
        enterNode: $867ff7b6cc0ee596$var$enterNode,
        exitNode: $867ff7b6cc0ee596$var$exitNode,
        getChildren: $867ff7b6cc0ee596$var$getChildren,
        parent: null
    };
    (0, $kbDZ5.assignParent)(node);
    return node;
};

});

parcelRegister("fXQsV", function(module, exports) {

$parcel$export(module.exports, "functionOperand", () => $821bef24bd40e21d$export$4f981b0e83488ce);
$parcel$export(module.exports, "functionOperandInternal", () => $821bef24bd40e21d$export$c1f2ce91dc05872a);


var $kbDZ5 = parcelRequire("kbDZ5");
function $821bef24bd40e21d$var$acceptFunctionOperand(visitor) {
    return visitor.visitFunctionOperand ? visitor.visitFunctionOperand(this) : visitor.visitChildren(this);
}
function $821bef24bd40e21d$var$enterNode(listener) {
    listener.enterFunctionOperand && listener.enterFunctionOperand(this);
}
function $821bef24bd40e21d$var$exitNode(listener) {
    listener.exitFunctionOperand && listener.exitFunctionOperand(this);
}
function $821bef24bd40e21d$var$getChildren() {
    return [
        this.function,
        ...this.arguments
    ];
}
const $821bef24bd40e21d$export$4f981b0e83488ce = (functionString, args = [])=>$821bef24bd40e21d$export$c1f2ce91dc05872a(functionString, args);
const $821bef24bd40e21d$export$c1f2ce91dc05872a = (functionString, args, position = null)=>{
    const node = {
        type: (0, $91159b9055013116$export$d2f212d8ddbc8d1d),
        operandType: (0, $2de6644e999aca05$export$19c7c729db381f9d),
        function: functionString,
        arguments: args,
        position: position,
        accept: $821bef24bd40e21d$var$acceptFunctionOperand,
        enterNode: $821bef24bd40e21d$var$enterNode,
        exitNode: $821bef24bd40e21d$var$exitNode,
        getChildren: $821bef24bd40e21d$var$getChildren,
        parent: null
    };
    (0, $kbDZ5.assignParent)(node);
    return node;
};

});
const $2de6644e999aca05$export$38accfc5a5d1c113 = 'value';
const $2de6644e999aca05$export$f6049126fd97001f = 'keyword';
const $2de6644e999aca05$export$19c7c729db381f9d = 'function';
const $2de6644e999aca05$export$fabec4aebba3f4df = 'list';
const $2de6644e999aca05$export$1c46dca02aac24dd = 'empty';


parcelRegister("jL5jO", function(module, exports) {

$parcel$export(module.exports, "functionString", () => $a4d0349b399cba4a$export$4e1bb9a7ff8d0ef9);
$parcel$export(module.exports, "functionStringInternal", () => $a4d0349b399cba4a$export$7aa9944588b7a69f);

var $41dcP = parcelRequire("41dcP");

var $kbDZ5 = parcelRequire("kbDZ5");
function $a4d0349b399cba4a$var$acceptFunctionString(visitor) {
    return visitor.visitFunction ? visitor.visitFunction(this) : visitor.visitChildren(this);
}
function $a4d0349b399cba4a$var$enterNode(listener) {
    listener.enterFunction && listener.enterFunction(this);
}
function $a4d0349b399cba4a$var$exitNode(listener) {
    listener.exitFunction && listener.exitFunction(this);
}
const $a4d0349b399cba4a$export$4e1bb9a7ff8d0ef9 = (value)=>$a4d0349b399cba4a$export$7aa9944588b7a69f(value, (0, $41dcP.sanitiseJqlString)(value));
const $a4d0349b399cba4a$export$7aa9944588b7a69f = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $a4d0349b399cba4a$var$acceptFunctionString,
        enterNode: $a4d0349b399cba4a$var$enterNode,
        exitNode: $a4d0349b399cba4a$var$exitNode,
        getChildren: (0, $kbDZ5.noChildren),
        parent: null
    });

});

parcelRegister("b8zeG", function(module, exports) {

$parcel$export(module.exports, "jast", () => $e544c80e33d1b309$export$b9e70a00f479ff43);
const $e544c80e33d1b309$export$b9e70a00f479ff43 = (query, represents = '', errors = [])=>({
        query: query,
        represents: represents,
        errors: errors
    });

});

parcelRegister("keFUI", function(module, exports) {

$parcel$export(module.exports, "keywordOperand", () => $678640649a1ed887$export$2edd4971ed69f2ce);
$parcel$export(module.exports, "keywordOperandInternal", () => $678640649a1ed887$export$7cc55480b054047b);


var $kbDZ5 = parcelRequire("kbDZ5");
function $678640649a1ed887$var$acceptKeywordOperand(visitor) {
    return visitor.visitKeywordOperand ? visitor.visitKeywordOperand(this) : visitor.visitChildren(this);
}
function $678640649a1ed887$var$enterNode(listener) {
    listener.enterKeywordOperand && listener.enterKeywordOperand(this);
}
function $678640649a1ed887$var$exitNode(listener) {
    listener.exitKeywordOperand && listener.exitKeywordOperand(this);
}
const $678640649a1ed887$export$2edd4971ed69f2ce = ()=>$678640649a1ed887$export$7cc55480b054047b((0, $2de6644e999aca05$export$1c46dca02aac24dd));
const $678640649a1ed887$export$7cc55480b054047b = (value, position = null)=>({
        type: (0, $91159b9055013116$export$d2f212d8ddbc8d1d),
        operandType: (0, $2de6644e999aca05$export$f6049126fd97001f),
        value: value,
        position: position,
        accept: $678640649a1ed887$var$acceptKeywordOperand,
        enterNode: $678640649a1ed887$var$enterNode,
        exitNode: $678640649a1ed887$var$exitNode,
        getChildren: (0, $kbDZ5.noChildren),
        parent: null
    });

});

parcelRegister("2QYLq", function(module, exports) {

$parcel$export(module.exports, "listOperand", () => $f95a98e5f2119f47$export$769866c3e9d41d50);
$parcel$export(module.exports, "listOperandInternal", () => $f95a98e5f2119f47$export$663c7831528c984b);


var $8YNYK = parcelRequire("8YNYK");

var $kbDZ5 = parcelRequire("kbDZ5");
function $f95a98e5f2119f47$var$acceptListOperand(visitor) {
    return visitor.visitListOperand ? visitor.visitListOperand(this) : visitor.visitChildren(this);
}
function $f95a98e5f2119f47$var$enterNode(listener) {
    listener.enterListOperand && listener.enterListOperand(this);
}
function $f95a98e5f2119f47$var$exitNode(listener) {
    listener.exitListOperand && listener.exitListOperand(this);
}
function $f95a98e5f2119f47$var$getChildren() {
    return [
        ...this.values
    ];
}
const $f95a98e5f2119f47$export$769866c3e9d41d50 = (values)=>$f95a98e5f2119f47$export$663c7831528c984b(values);
const $f95a98e5f2119f47$export$663c7831528c984b = (values, position = null)=>{
    const node = {
        type: (0, $91159b9055013116$export$d2f212d8ddbc8d1d),
        operandType: (0, $2de6644e999aca05$export$fabec4aebba3f4df),
        values: values,
        position: position,
        accept: $f95a98e5f2119f47$var$acceptListOperand,
        enterNode: $f95a98e5f2119f47$var$enterNode,
        exitNode: $f95a98e5f2119f47$var$exitNode,
        getChildren: $f95a98e5f2119f47$var$getChildren,
        parent: null,
        appendOperand: $8YNYK.appendOperand
    };
    (0, $kbDZ5.assignParent)(node);
    return node;
};

});
parcelRegister("8YNYK", function(module, exports) {

$parcel$export(module.exports, "appendOperand", () => $d667c56fedbab1f0$export$d94c54f1aee177c4);


var $kbDZ5 = parcelRequire("kbDZ5");
function $d667c56fedbab1f0$export$d94c54f1aee177c4(operand) {
    this.values.push(...operand.operandType === (0, $2de6644e999aca05$export$fabec4aebba3f4df) ? operand.values : [
        operand
    ]);
    (0, $kbDZ5.assignParent)(this);
}

});


parcelRegister("lLAVO", function(module, exports) {

$parcel$export(module.exports, "notClause", () => $a6a1f72599bfe084$export$b4734a9fedb4d44e);
$parcel$export(module.exports, "notClauseInternal", () => $a6a1f72599bfe084$export$b25621824fea4548);


var $9dUN5 = parcelRequire("9dUN5");

var $kbDZ5 = parcelRequire("kbDZ5");

var $9jf8v = parcelRequire("9jf8v");
function $a6a1f72599bfe084$var$acceptNotClause(visitor) {
    return visitor.visitNotClause ? visitor.visitNotClause(this) : visitor.visitChildren(this);
}
function $a6a1f72599bfe084$var$enterNode(listener) {
    listener.enterNotClause && listener.enterNotClause(this);
}
function $a6a1f72599bfe084$var$exitNode(listener) {
    listener.exitNotClause && listener.exitNotClause(this);
}
function $a6a1f72599bfe084$var$getChildren() {
    return [
        this.operator,
        this.clause
    ];
}
const $a6a1f72599bfe084$export$b4734a9fedb4d44e = (clause)=>{
    return $a6a1f72599bfe084$export$b25621824fea4548(clause, (0, $9jf8v.notClauseOperator)());
};
const $a6a1f72599bfe084$export$b25621824fea4548 = (clause, operator, position = null)=>{
    const node = {
        type: (0, $91159b9055013116$export$2d205682cc545947),
        clauseType: (0, $24102d5d112d2831$export$e356b89f8c8d2fcb),
        clause: clause,
        operator: operator,
        position: position,
        accept: $a6a1f72599bfe084$var$acceptNotClause,
        enterNode: $a6a1f72599bfe084$var$enterNode,
        exitNode: $a6a1f72599bfe084$var$exitNode,
        getChildren: $a6a1f72599bfe084$var$getChildren,
        parent: null,
        remove: $9dUN5.remove,
        removeClause: $9dUN5.removeClause,
        replace: $9dUN5.replace,
        replaceClause: $9dUN5.replaceClause
    };
    (0, $kbDZ5.assignParent)(node);
    return node;
};

});
parcelRegister("9dUN5", function(module, exports) {

$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);

var $kbDZ5 = parcelRequire("kbDZ5");
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    if (this.clause === clause) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    if (this.clause === clause) {
        this.clause = nextClause;
        (0, $kbDZ5.assignParent)(this);
    }
}

});

parcelRegister("9jf8v", function(module, exports) {

$parcel$export(module.exports, "notClauseOperator", () => $55a816037928d1dd$export$d2cd8239f99c13d3);
$parcel$export(module.exports, "notClauseOperatorInternal", () => $55a816037928d1dd$export$1b15a32bb57b9020);

var $8XgA0 = parcelRequire("8XgA0");

var $kbDZ5 = parcelRequire("kbDZ5");
function $55a816037928d1dd$var$acceptNotClauseOperator(visitor) {
    return visitor.visitNotClauseOperator ? visitor.visitNotClauseOperator(this) : visitor.visitChildren(this);
}
function $55a816037928d1dd$var$enterNode(listener) {
    listener.enterNotClauseOperator && listener.enterNotClauseOperator(this);
}
function $55a816037928d1dd$var$exitNode(listener) {
    listener.exitNotClauseOperator && listener.exitNotClauseOperator(this);
}
const $55a816037928d1dd$export$d2cd8239f99c13d3 = ()=>$55a816037928d1dd$export$1b15a32bb57b9020();
const $55a816037928d1dd$export$1b15a32bb57b9020 = (position = null)=>({
        value: (0, $8XgA0.CLAUSE_OPERATOR_NOT),
        position: position,
        accept: $55a816037928d1dd$var$acceptNotClauseOperator,
        enterNode: $55a816037928d1dd$var$enterNode,
        exitNode: $55a816037928d1dd$var$exitNode,
        getChildren: (0, $kbDZ5.noChildren),
        parent: null
    });

});
parcelRegister("8XgA0", function(module, exports) {

$parcel$export(module.exports, "CLAUSE_OPERATOR_NOT", () => $f6764c99ab16c00b$export$c6c71ceedb15cda9);
$parcel$export(module.exports, "OPERATOR_EQUALS", () => $f6764c99ab16c00b$export$466517a888d00195);
$parcel$export(module.exports, "OPERATOR_NOT_EQUALS", () => $f6764c99ab16c00b$export$6d0d8810623974a5);
$parcel$export(module.exports, "OPERATOR_GT", () => $f6764c99ab16c00b$export$bcbb090ab3c498b3);
$parcel$export(module.exports, "OPERATOR_LT", () => $f6764c99ab16c00b$export$4bf1a4aa659c6ea4);
$parcel$export(module.exports, "OPERATOR_GT_EQUALS", () => $f6764c99ab16c00b$export$83ce674214a54b2a);
$parcel$export(module.exports, "OPERATOR_LT_EQUALS", () => $f6764c99ab16c00b$export$9629fd1727ef62ee);
$parcel$export(module.exports, "OPERATOR_IN", () => $f6764c99ab16c00b$export$c4e3fb55e320e979);
$parcel$export(module.exports, "OPERATOR_NOT_IN", () => $f6764c99ab16c00b$export$f9857532eaa24ddc);
$parcel$export(module.exports, "OPERATOR_LIKE", () => $f6764c99ab16c00b$export$221595834b8766ab);
$parcel$export(module.exports, "OPERATOR_NOT_LIKE", () => $f6764c99ab16c00b$export$fcefabf94a9bffbf);
$parcel$export(module.exports, "OPERATOR_IS", () => $f6764c99ab16c00b$export$4feeb3f4ff56bcef);
$parcel$export(module.exports, "OPERATOR_IS_NOT", () => $f6764c99ab16c00b$export$d08d969a0da27188);
$parcel$export(module.exports, "OPERATOR_WAS", () => $f6764c99ab16c00b$export$8f907e179985256d);
$parcel$export(module.exports, "OPERATOR_WAS_IN", () => $f6764c99ab16c00b$export$cc7b9d0b3ee23193);
$parcel$export(module.exports, "OPERATOR_WAS_NOT_IN", () => $f6764c99ab16c00b$export$585d3c004af078bb);
$parcel$export(module.exports, "OPERATOR_WAS_NOT", () => $f6764c99ab16c00b$export$123eaa9ccc2d9445);
$parcel$export(module.exports, "OPERATOR_CHANGED", () => $f6764c99ab16c00b$export$15f5b446ba8c941e);
$parcel$export(module.exports, "EQUALS_OPERATORS", () => $f6764c99ab16c00b$export$643c6101f3fc8547);
$parcel$export(module.exports, "LIKE_OPERATORS", () => $f6764c99ab16c00b$export$329664c9cf18cca6);
$parcel$export(module.exports, "COMPARISON_OPERATORS", () => $f6764c99ab16c00b$export$1b167a3705885a8b);
$parcel$export(module.exports, "IN_OPERATORS", () => $f6764c99ab16c00b$export$f25cf16c2270312f);
$parcel$export(module.exports, "IS_OPERATORS", () => $f6764c99ab16c00b$export$eb58cfffe4a6b805);
$parcel$export(module.exports, "WAS_OPERATORS", () => $f6764c99ab16c00b$export$c22a981f581de218);
$parcel$export(module.exports, "WAS_IN_OPERATORS", () => $f6764c99ab16c00b$export$6d08c4699bb75284);
$parcel$export(module.exports, "CHANGED_OPERATORS", () => $f6764c99ab16c00b$export$b7dc214eef214c1c);
$parcel$export(module.exports, "OPERATORS", () => $f6764c99ab16c00b$export$184799fc79ccac89);
$parcel$export(module.exports, "LIST_OPERATORS", () => $f6764c99ab16c00b$export$77c793736847e030);
const $f6764c99ab16c00b$export$c6c71ceedb15cda9 = 'not';
const $f6764c99ab16c00b$export$466517a888d00195 = '=';
const $f6764c99ab16c00b$export$6d0d8810623974a5 = '!=';
const $f6764c99ab16c00b$export$bcbb090ab3c498b3 = '>';
const $f6764c99ab16c00b$export$4bf1a4aa659c6ea4 = '<';
const $f6764c99ab16c00b$export$83ce674214a54b2a = '>=';
const $f6764c99ab16c00b$export$9629fd1727ef62ee = '<=';
const $f6764c99ab16c00b$export$c4e3fb55e320e979 = 'in';
const $f6764c99ab16c00b$export$f9857532eaa24ddc = 'not in';
const $f6764c99ab16c00b$export$221595834b8766ab = '~';
const $f6764c99ab16c00b$export$fcefabf94a9bffbf = '!~';
const $f6764c99ab16c00b$export$4feeb3f4ff56bcef = 'is';
const $f6764c99ab16c00b$export$d08d969a0da27188 = 'is not';
const $f6764c99ab16c00b$export$8f907e179985256d = 'was';
const $f6764c99ab16c00b$export$cc7b9d0b3ee23193 = 'was in';
const $f6764c99ab16c00b$export$585d3c004af078bb = 'was not in';
const $f6764c99ab16c00b$export$123eaa9ccc2d9445 = 'was not';
const $f6764c99ab16c00b$export$15f5b446ba8c941e = 'changed';
const $f6764c99ab16c00b$export$643c6101f3fc8547 = [
    $f6764c99ab16c00b$export$466517a888d00195,
    $f6764c99ab16c00b$export$6d0d8810623974a5
];
const $f6764c99ab16c00b$export$329664c9cf18cca6 = [
    $f6764c99ab16c00b$export$221595834b8766ab,
    $f6764c99ab16c00b$export$fcefabf94a9bffbf
];
const $f6764c99ab16c00b$export$1b167a3705885a8b = [
    $f6764c99ab16c00b$export$4bf1a4aa659c6ea4,
    $f6764c99ab16c00b$export$bcbb090ab3c498b3,
    $f6764c99ab16c00b$export$9629fd1727ef62ee,
    $f6764c99ab16c00b$export$83ce674214a54b2a
];
const $f6764c99ab16c00b$export$f25cf16c2270312f = [
    $f6764c99ab16c00b$export$c4e3fb55e320e979,
    $f6764c99ab16c00b$export$f9857532eaa24ddc
];
const $f6764c99ab16c00b$export$eb58cfffe4a6b805 = [
    $f6764c99ab16c00b$export$4feeb3f4ff56bcef,
    $f6764c99ab16c00b$export$d08d969a0da27188
];
const $f6764c99ab16c00b$export$c22a981f581de218 = [
    $f6764c99ab16c00b$export$8f907e179985256d,
    $f6764c99ab16c00b$export$123eaa9ccc2d9445
];
const $f6764c99ab16c00b$export$6d08c4699bb75284 = [
    $f6764c99ab16c00b$export$cc7b9d0b3ee23193,
    $f6764c99ab16c00b$export$585d3c004af078bb
];
const $f6764c99ab16c00b$export$b7dc214eef214c1c = [
    $f6764c99ab16c00b$export$15f5b446ba8c941e
];
const $f6764c99ab16c00b$export$184799fc79ccac89 = [
    ...$f6764c99ab16c00b$export$643c6101f3fc8547,
    ...$f6764c99ab16c00b$export$329664c9cf18cca6,
    ...$f6764c99ab16c00b$export$1b167a3705885a8b,
    ...$f6764c99ab16c00b$export$f25cf16c2270312f,
    ...$f6764c99ab16c00b$export$eb58cfffe4a6b805,
    ...$f6764c99ab16c00b$export$c22a981f581de218,
    ...$f6764c99ab16c00b$export$6d08c4699bb75284,
    ...$f6764c99ab16c00b$export$b7dc214eef214c1c
];
const $f6764c99ab16c00b$export$77c793736847e030 = [
    $f6764c99ab16c00b$export$c4e3fb55e320e979,
    $f6764c99ab16c00b$export$f9857532eaa24ddc,
    $f6764c99ab16c00b$export$cc7b9d0b3ee23193,
    $f6764c99ab16c00b$export$585d3c004af078bb
];

});



parcelRegister("exKrk", function(module, exports) {

$parcel$export(module.exports, "operator", () => $db839cb176fef18c$export$dbd72860f701d4f3);
$parcel$export(module.exports, "operatorInternal", () => $db839cb176fef18c$export$649025bc60ab9c3b);

var $kbDZ5 = parcelRequire("kbDZ5");
function $db839cb176fef18c$var$acceptOperator(visitor) {
    return visitor.visitOperator ? visitor.visitOperator(this) : visitor.visitChildren(this);
}
function $db839cb176fef18c$var$enterNode(listener) {
    listener.enterOperator && listener.enterOperator(this);
}
function $db839cb176fef18c$var$exitNode(listener) {
    listener.exitOperator && listener.exitOperator(this);
}
const $db839cb176fef18c$export$dbd72860f701d4f3 = (value)=>$db839cb176fef18c$export$649025bc60ab9c3b(value, value);
const $db839cb176fef18c$export$649025bc60ab9c3b = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $db839cb176fef18c$var$acceptOperator,
        enterNode: $db839cb176fef18c$var$enterNode,
        exitNode: $db839cb176fef18c$var$exitNode,
        getChildren: (0, $kbDZ5.noChildren),
        parent: null
    });

});

parcelRegister("bRHc6", function(module, exports) {

$parcel$export(module.exports, "orderBy", () => $cca3b9e6aa7646b4$export$f18af21d6f4dafd8);
$parcel$export(module.exports, "orderByInternal", () => $cca3b9e6aa7646b4$export$e4eb1fa6bc8465c1);


var $ccGs8 = parcelRequire("ccGs8");

var $kbDZ5 = parcelRequire("kbDZ5");

var $l2Fln = parcelRequire("l2Fln");
function $cca3b9e6aa7646b4$var$acceptOrderBy(visitor) {
    return visitor.visitOrderBy ? visitor.visitOrderBy(this) : visitor.visitChildren(this);
}
function $cca3b9e6aa7646b4$var$enterNode(listener) {
    listener.enterOrderBy && listener.enterOrderBy(this);
}
function $cca3b9e6aa7646b4$var$exitNode(listener) {
    listener.exitOrderBy && listener.exitOrderBy(this);
}
function $cca3b9e6aa7646b4$var$getChildren() {
    return [
        this.operator,
        ...this.fields
    ];
}
const $cca3b9e6aa7646b4$export$f18af21d6f4dafd8 = (fields)=>{
    return $cca3b9e6aa7646b4$export$e4eb1fa6bc8465c1(fields, (0, $l2Fln.orderByOperator)());
};
const $cca3b9e6aa7646b4$export$e4eb1fa6bc8465c1 = (fields, operator, position = null)=>{
    const node = {
        type: (0, $91159b9055013116$export$da0f73edded4a63d),
        operator: operator,
        fields: fields,
        position: position,
        accept: $cca3b9e6aa7646b4$var$acceptOrderBy,
        enterNode: $cca3b9e6aa7646b4$var$enterNode,
        exitNode: $cca3b9e6aa7646b4$var$exitNode,
        getChildren: $cca3b9e6aa7646b4$var$getChildren,
        parent: null,
        prependOrderField: $ccGs8.prependOrderField,
        setOrderDirection: $ccGs8.setOrderDirection,
        replace: $ccGs8.replace,
        replaceOrderField: $ccGs8.replaceOrderField,
        remove: $ccGs8.remove,
        removeOrderField: $ccGs8.removeOrderField
    };
    (0, $kbDZ5.assignParent)(node);
    return node;
};

});
parcelRegister("ccGs8", function(module, exports) {

$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceOrderField", () => replaceOrderField);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeOrderField", () => removeOrderField);

var $kbDZ5 = parcelRequire("kbDZ5");
function prependOrderField(orderField) {
    this.fields.unshift(orderField);
    (0, $kbDZ5.assignParent)(this);
}
function setOrderDirection(orderDirection) {
    if (this.fields.length > 0) this.fields[0].setOrderDirection(orderDirection);
}
function replace(nextOrderBy) {
    if (this.parent) this.parent.replaceOrderBy(nextOrderBy);
}
function replaceOrderField(orderByField, nextOrderByField) {
    this.fields = this.fields.map((child)=>{
        return child === orderByField ? nextOrderByField : child;
    });
    (0, $kbDZ5.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeOrderBy();
}
function removeOrderField(orderByField) {
    this.fields = this.fields.filter((field)=>field !== orderByField);
    if (this.fields.length === 0) this.remove();
}

});

parcelRegister("l2Fln", function(module, exports) {

$parcel$export(module.exports, "orderByOperator", () => $aa6e3981b6aefe0d$export$c7307b67924c61ea);
$parcel$export(module.exports, "orderByOperatorInternal", () => $aa6e3981b6aefe0d$export$739e30af23a08da0);


var $kbDZ5 = parcelRequire("kbDZ5");
function $aa6e3981b6aefe0d$var$acceptOrderByOperator(visitor) {
    return visitor.visitOrderByOperator ? visitor.visitOrderByOperator(this) : visitor.visitChildren(this);
}
function $aa6e3981b6aefe0d$var$enterNode(listener) {
    listener.enterOrderByOperator && listener.enterOrderByOperator(this);
}
function $aa6e3981b6aefe0d$var$exitNode(listener) {
    listener.exitOrderByOperator && listener.exitOrderByOperator(this);
}
const $aa6e3981b6aefe0d$export$c7307b67924c61ea = ()=>$aa6e3981b6aefe0d$export$739e30af23a08da0();
const $aa6e3981b6aefe0d$export$739e30af23a08da0 = (position = null)=>({
        value: (0, $70c12d333a882310$export$ca51f5fd60a74517),
        position: position,
        accept: $aa6e3981b6aefe0d$var$acceptOrderByOperator,
        enterNode: $aa6e3981b6aefe0d$var$enterNode,
        exitNode: $aa6e3981b6aefe0d$var$exitNode,
        getChildren: (0, $kbDZ5.noChildren),
        parent: null
    });

});
const $70c12d333a882310$export$ca51f5fd60a74517 = 'ORDER BY';
const $70c12d333a882310$export$6d60017b9e092e73 = 'ASC';
const $70c12d333a882310$export$2ea27ea5f2121899 = 'DESC';



parcelRegister("k4WW7", function(module, exports) {

$parcel$export(module.exports, "orderByDirection", () => $a97dafeeef0eec83$export$864d934efed3ccaa);
$parcel$export(module.exports, "orderByDirectionInternal", () => $a97dafeeef0eec83$export$8c65cac1a7852d1f);

var $kbDZ5 = parcelRequire("kbDZ5");
function $a97dafeeef0eec83$var$acceptOrderByDirection(visitor) {
    return visitor.visitOrderByDirection ? visitor.visitOrderByDirection(this) : visitor.visitChildren(this);
}
function $a97dafeeef0eec83$var$enterNode(listener) {
    listener.enterOrderByDirection && listener.enterOrderByDirection(this);
}
function $a97dafeeef0eec83$var$exitNode(listener) {
    listener.exitOrderByDirection && listener.exitOrderByDirection(this);
}
const $a97dafeeef0eec83$export$864d934efed3ccaa = (value)=>$a97dafeeef0eec83$export$8c65cac1a7852d1f(value);
const $a97dafeeef0eec83$export$8c65cac1a7852d1f = (value, position = null)=>({
        value: value,
        position: position,
        accept: $a97dafeeef0eec83$var$acceptOrderByDirection,
        enterNode: $a97dafeeef0eec83$var$enterNode,
        exitNode: $a97dafeeef0eec83$var$exitNode,
        getChildren: (0, $kbDZ5.noChildren),
        parent: null
    });

});

parcelRegister("5W28H", function(module, exports) {

$parcel$export(module.exports, "orderByField", () => $ebc17e983fc7007b$export$942df63e5e3d3899);
$parcel$export(module.exports, "orderByFieldInternal", () => $ebc17e983fc7007b$export$661a7786e3d15926);

var $7sPnB = parcelRequire("7sPnB");

var $kbDZ5 = parcelRequire("kbDZ5");
function $ebc17e983fc7007b$var$acceptOrderByField(visitor) {
    return visitor.visitOrderByField ? visitor.visitOrderByField(this) : visitor.visitChildren(this);
}
function $ebc17e983fc7007b$var$enterNode(listener) {
    listener.enterOrderByField && listener.enterOrderByField(this);
}
function $ebc17e983fc7007b$var$exitNode(listener) {
    listener.exitOrderByField && listener.exitOrderByField(this);
}
function $ebc17e983fc7007b$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.direction) children.push(this.direction);
    return children;
}
const $ebc17e983fc7007b$export$942df63e5e3d3899 = (field, direction)=>$ebc17e983fc7007b$export$661a7786e3d15926(field, direction);
const $ebc17e983fc7007b$export$661a7786e3d15926 = (field, direction, position = null)=>{
    const node = {
        field: field,
        direction: direction,
        position: position,
        accept: $ebc17e983fc7007b$var$acceptOrderByField,
        enterNode: $ebc17e983fc7007b$var$enterNode,
        exitNode: $ebc17e983fc7007b$var$exitNode,
        getChildren: $ebc17e983fc7007b$var$getChildren,
        parent: null,
        setOrderDirection: $7sPnB.setOrderDirection,
        replace: $7sPnB.replace,
        remove: $7sPnB.remove
    };
    (0, $kbDZ5.assignParent)(node);
    return node;
};

});
parcelRegister("7sPnB", function(module, exports) {

$parcel$export(module.exports, "setOrderDirection", () => $4a7a72c1f71591d0$export$b596730931a09703);
$parcel$export(module.exports, "replace", () => $4a7a72c1f71591d0$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "remove", () => $4a7a72c1f71591d0$export$cd7f480d6b8286c3);

var $kbDZ5 = parcelRequire("kbDZ5");
function $4a7a72c1f71591d0$export$b596730931a09703(orderDirection) {
    this.direction = orderDirection;
    (0, $kbDZ5.assignParent)(this);
}
function $4a7a72c1f71591d0$export$77ad94ebf1c2b9ed(orderByField) {
    if (this.parent) this.parent.replaceOrderField(this, orderByField);
}
function $4a7a72c1f71591d0$export$cd7f480d6b8286c3() {
    if (this.parent) this.parent.removeOrderField(this);
}

});


parcelRegister("48MtH", function(module, exports) {

$parcel$export(module.exports, "predicate", () => $bd15657316edaad4$export$5fc51e445ce24faf);
$parcel$export(module.exports, "predicateInternal", () => $bd15657316edaad4$export$a767a27ad05a38a2);

var $kbDZ5 = parcelRequire("kbDZ5");
function $bd15657316edaad4$var$acceptPredicate(visitor) {
    return visitor.visitPredicate ? visitor.visitPredicate(this) : visitor.visitChildren(this);
}
function $bd15657316edaad4$var$enterNode(listener) {
    listener.enterPredicate && listener.enterPredicate(this);
}
function $bd15657316edaad4$var$exitNode(listener) {
    listener.exitPredicate && listener.exitPredicate(this);
}
function $bd15657316edaad4$var$getChildren() {
    const children = [
        this.operator
    ];
    if (this.operand) children.push(this.operand);
    return children;
}
const $bd15657316edaad4$export$5fc51e445ce24faf = (operator, operand)=>$bd15657316edaad4$export$a767a27ad05a38a2(operator, operand);
const $bd15657316edaad4$export$a767a27ad05a38a2 = (operator, operand, position = null)=>{
    const node = {
        operator: operator,
        operand: operand,
        position: position,
        accept: $bd15657316edaad4$var$acceptPredicate,
        enterNode: $bd15657316edaad4$var$enterNode,
        exitNode: $bd15657316edaad4$var$exitNode,
        getChildren: $bd15657316edaad4$var$getChildren,
        parent: null
    };
    (0, $kbDZ5.assignParent)(node);
    return node;
};

});

parcelRegister("bnlOP", function(module, exports) {

$parcel$export(module.exports, "predicateOperator", () => $62d3c30348b84bf0$export$5419b7f16910ea62);
$parcel$export(module.exports, "predicateOperatorInternal", () => $62d3c30348b84bf0$export$c69d893689716768);

var $kbDZ5 = parcelRequire("kbDZ5");
function $62d3c30348b84bf0$var$acceptPredicateOperator(visitor) {
    return visitor.visitPredicateOperator ? visitor.visitPredicateOperator(this) : visitor.visitChildren(this);
}
function $62d3c30348b84bf0$var$enterNode(listener) {
    listener.enterPredicateOperator && listener.enterPredicateOperator(this);
}
function $62d3c30348b84bf0$var$exitNode(listener) {
    listener.exitPredicateOperator && listener.exitPredicateOperator(this);
}
const $62d3c30348b84bf0$export$5419b7f16910ea62 = (value)=>$62d3c30348b84bf0$export$c69d893689716768(value, value);
const $62d3c30348b84bf0$export$c69d893689716768 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $62d3c30348b84bf0$var$acceptPredicateOperator,
        enterNode: $62d3c30348b84bf0$var$enterNode,
        exitNode: $62d3c30348b84bf0$var$exitNode,
        getChildren: (0, $kbDZ5.noChildren),
        parent: null
    });

});

parcelRegister("3RwpB", function(module, exports) {

$parcel$export(module.exports, "property", () => $1121c6db164925e8$export$d541bacb2bda4494);
$parcel$export(module.exports, "propertyInternal", () => $1121c6db164925e8$export$1cbd90994fef1fad);

var $kbDZ5 = parcelRequire("kbDZ5");
function $1121c6db164925e8$var$acceptProperty(visitor) {
    return visitor.visitProperty ? visitor.visitProperty(this) : visitor.visitChildren(this);
}
function $1121c6db164925e8$var$enterNode(listener) {
    listener.enterProperty && listener.enterProperty(this);
}
function $1121c6db164925e8$var$exitNode(listener) {
    listener.exitProperty && listener.exitProperty(this);
}
function $1121c6db164925e8$var$getChildren() {
    const children = [];
    if (this.key) children.push(this.key);
    if (this.path) return children.concat(this.path);
    return children;
}
const $1121c6db164925e8$export$d541bacb2bda4494 = (key, path = [])=>$1121c6db164925e8$export$1cbd90994fef1fad(key, path);
const $1121c6db164925e8$export$1cbd90994fef1fad = (key, path, position = null)=>{
    const node = {
        key: key,
        path: path,
        position: position,
        accept: $1121c6db164925e8$var$acceptProperty,
        enterNode: $1121c6db164925e8$var$enterNode,
        exitNode: $1121c6db164925e8$var$exitNode,
        getChildren: $1121c6db164925e8$var$getChildren,
        parent: null
    };
    (0, $kbDZ5.assignParent)(node);
    return node;
};

});

parcelRegister("3wJKB", function(module, exports) {

$parcel$export(module.exports, "query", () => $7be041a2d947db35$export$2fa187e846a241c4);
$parcel$export(module.exports, "queryInternal", () => $7be041a2d947db35$export$bc2d6e2e1fd9014);


var $aEOW6 = parcelRequire("aEOW6");

var $kbDZ5 = parcelRequire("kbDZ5");
/**
 * AstNode accept functions. We define them outside of the creator function so the same function reference is returned
 * when a creator is invoked multiple times (which is helpful when testing for equality of AST objects).
 */ function $7be041a2d947db35$var$acceptQuery(visitor) {
    return visitor.visitQuery ? visitor.visitQuery(this) : visitor.visitChildren(this);
}
function $7be041a2d947db35$var$enterNode(listener) {
    listener.enterQuery && listener.enterQuery(this);
}
function $7be041a2d947db35$var$exitNode(listener) {
    listener.exitQuery && listener.exitQuery(this);
}
function $7be041a2d947db35$var$getChildren() {
    const children = [];
    if (this.where) children.push(this.where);
    if (this.orderBy) children.push(this.orderBy);
    return children;
}
const $7be041a2d947db35$export$2fa187e846a241c4 = (where, orderBy)=>$7be041a2d947db35$export$bc2d6e2e1fd9014(where, orderBy);
const $7be041a2d947db35$export$bc2d6e2e1fd9014 = (where, orderBy, position = null)=>{
    const node = {
        type: (0, $91159b9055013116$export$98dda21ec825792),
        where: where,
        orderBy: orderBy,
        position: position,
        accept: $7be041a2d947db35$var$acceptQuery,
        enterNode: $7be041a2d947db35$var$enterNode,
        exitNode: $7be041a2d947db35$var$exitNode,
        getChildren: $7be041a2d947db35$var$getChildren,
        parent: null,
        appendClause: $aEOW6.appendClause,
        prependOrderField: $aEOW6.prependOrderField,
        setOrderDirection: $aEOW6.setOrderDirection,
        removeClause: $aEOW6.removeClause,
        replaceClause: $aEOW6.replaceClause,
        replaceOrderBy: $aEOW6.replaceOrderBy,
        removeOrderBy: $aEOW6.removeOrderBy
    };
    (0, $kbDZ5.assignParent)(node);
    return node;
};

});
parcelRegister("aEOW6", function(module, exports) {

$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replaceOrderBy", () => replaceOrderBy);
$parcel$export(module.exports, "replaceClause", () => replaceClause);
$parcel$export(module.exports, "removeOrderBy", () => removeOrderBy);

var $55Dca = parcelRequire("55Dca");

var $kbDZ5 = parcelRequire("kbDZ5");
function appendClause(clause, compoundOperatorValue) {
    if (!this.where) this.where = clause;
    else {
        const nextCompoundOperator = (0, $55Dca.default).compoundOperator(compoundOperatorValue);
        const nextClause = (0, $55Dca.default).compoundClause(nextCompoundOperator, []);
        // Append previous and new clause which will flatten compound clauses with matching operators.
        nextClause.appendClause(this.where);
        nextClause.appendClause(clause);
        this.where = nextClause;
    }
    (0, $kbDZ5.assignParent)(this);
}
function prependOrderField(orderField) {
    if (!this.orderBy) {
        this.orderBy = (0, $55Dca.default).orderBy([
            orderField
        ]);
        (0, $kbDZ5.assignParent)(this);
    } else this.orderBy.prependOrderField(orderField);
}
function setOrderDirection(orderDirection) {
    if (this.orderBy) this.orderBy.setOrderDirection(orderDirection);
}
function removeClause(clause) {
    if (this.where === clause) this.where = undefined;
}
function replaceOrderBy(orderBy) {
    if (orderBy && orderBy.fields.length === 0) this.removeOrderBy();
    else {
        this.orderBy = orderBy;
        (0, $kbDZ5.assignParent)(this);
    }
}
function replaceClause(clause, nextClause) {
    if (this.where === clause) {
        this.where = nextClause;
        (0, $kbDZ5.assignParent)(this);
    }
}
function removeOrderBy() {
    this.orderBy = undefined;
}

});


parcelRegister("8I1Hc", function(module, exports) {

$parcel$export(module.exports, "terminalClause", () => $7fa0fc0ba5e40a50$export$2627cbe08dd86b00);
$parcel$export(module.exports, "terminalClauseInternal", () => $7fa0fc0ba5e40a50$export$cc08e43598d091fc);


var $eUeMK = parcelRequire("eUeMK");

var $kbDZ5 = parcelRequire("kbDZ5");
function $7fa0fc0ba5e40a50$var$acceptTerminalClause(visitor) {
    return visitor.visitTerminalClause ? visitor.visitTerminalClause(this) : visitor.visitChildren(this);
}
function $7fa0fc0ba5e40a50$var$enterNode(listener) {
    listener.enterTerminalClause && listener.enterTerminalClause(this);
}
function $7fa0fc0ba5e40a50$var$exitNode(listener) {
    listener.exitTerminalClause && listener.exitTerminalClause(this);
}
function $7fa0fc0ba5e40a50$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.operator) children.push(this.operator);
    if (this.operand) children.push(this.operand);
    return children.concat(this.predicates);
}
const $7fa0fc0ba5e40a50$export$2627cbe08dd86b00 = (field, operator, operand, predicates = [])=>{
    return $7fa0fc0ba5e40a50$export$cc08e43598d091fc(field, operator, operand, predicates);
};
const $7fa0fc0ba5e40a50$export$cc08e43598d091fc = (field, operator, operand, predicates, position = null)=>{
    const node = {
        type: (0, $91159b9055013116$export$2d205682cc545947),
        clauseType: (0, $24102d5d112d2831$export$ae56b4ef248a2b6a),
        field: field,
        operator: operator,
        operand: operand,
        predicates: predicates,
        position: position,
        accept: $7fa0fc0ba5e40a50$var$acceptTerminalClause,
        enterNode: $7fa0fc0ba5e40a50$var$enterNode,
        exitNode: $7fa0fc0ba5e40a50$var$exitNode,
        getChildren: $7fa0fc0ba5e40a50$var$getChildren,
        parent: null,
        setOperator: $eUeMK.setOperator,
        setOperand: $eUeMK.setOperand,
        appendOperand: $eUeMK.appendOperand,
        remove: $eUeMK.remove,
        replace: $eUeMK.replace
    };
    (0, $kbDZ5.assignParent)(node);
    return node;
};

});
parcelRegister("eUeMK", function(module, exports) {

$parcel$export(module.exports, "setOperator", () => setOperator);
$parcel$export(module.exports, "setOperand", () => setOperand);
$parcel$export(module.exports, "appendOperand", () => appendOperand);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "replace", () => replace);


var $55Dca = parcelRequire("55Dca");

var $kbDZ5 = parcelRequire("kbDZ5");
function setOperator(operator) {
    this.operator = operator;
    (0, $kbDZ5.assignParent)(this);
}
function setOperand(operand) {
    this.operand = operand;
    (0, $kbDZ5.assignParent)(this);
}
function appendOperand(operand) {
    if (this.operand) {
        if (this.operand.operandType === (0, $2de6644e999aca05$export$fabec4aebba3f4df)) this.operand.appendOperand(operand);
        else this.setOperand((0, $55Dca.default).listOperand([
            this.operand,
            ...operand.operandType === (0, $2de6644e999aca05$export$fabec4aebba3f4df) ? operand.values : [
                operand
            ]
        ]));
    } else this.setOperand(operand);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}

});


parcelRegister("eCGp1", function(module, exports) {

$parcel$export(module.exports, "valueOperand", () => $24d97b24148b43f2$export$2b6e4d2ed8d53bf3);
$parcel$export(module.exports, "valueOperandInternal", () => $24d97b24148b43f2$export$79c37d97caac8627);
$parcel$export(module.exports, "valueOperandByText", () => $24d97b24148b43f2$export$3ac9155bde56a45f);


var $12XiF = parcelRequire("12XiF");
var $41dcP = parcelRequire("41dcP");

var $kbDZ5 = parcelRequire("kbDZ5");
function $24d97b24148b43f2$var$acceptValueOperand(visitor) {
    return visitor.visitValueOperand ? visitor.visitValueOperand(this) : visitor.visitChildren(this);
}
function $24d97b24148b43f2$var$enterNode(listener) {
    listener.enterValueOperand && listener.enterValueOperand(this);
}
function $24d97b24148b43f2$var$exitNode(listener) {
    listener.exitValueOperand && listener.exitValueOperand(this);
}
const $24d97b24148b43f2$export$2b6e4d2ed8d53bf3 = (value)=>$24d97b24148b43f2$export$79c37d97caac8627(value, (0, $41dcP.sanitiseJqlString)(value));
const $24d97b24148b43f2$export$3ac9155bde56a45f = (text)=>$24d97b24148b43f2$export$79c37d97caac8627((0, $12XiF.normaliseJqlString)(text), text);
const $24d97b24148b43f2$export$79c37d97caac8627 = (value, text, position = null)=>({
        type: (0, $91159b9055013116$export$d2f212d8ddbc8d1d),
        operandType: (0, $2de6644e999aca05$export$38accfc5a5d1c113),
        text: text,
        value: value,
        position: position,
        accept: $24d97b24148b43f2$var$acceptValueOperand,
        enterNode: $24d97b24148b43f2$var$enterNode,
        exitNode: $24d97b24148b43f2$var$exitNode,
        getChildren: (0, $kbDZ5.noChildren),
        parent: null
    });

});


parcelRegister("kIKLu", function(module, exports) {

$parcel$export(module.exports, "print", () => $d7f7333cf0422e2c$export$c2d084dc44961371);

var $8dloj = parcelRequire("8dloj");

var $4Cljx = parcelRequire("4Cljx");

var $hm29V = parcelRequire("hm29V");
const $d7f7333cf0422e2c$export$c2d084dc44961371 = (jast, options = {})=>{
    return (0, $hm29V.printDocToString)((0, $4Cljx.printAstToDoc)(jast, (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(options, [
        'operatorCase'
    ])), (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(options, [
        'printWidth'
    ]));
};

});
parcelRegister("4Cljx", function(module, exports) {

$parcel$export(module.exports, "printAstToDoc", () => $eefc42943df59f99$export$f0ef38932978952);


var $i1EwT = parcelRequire("i1EwT");

var $kXQh5 = parcelRequire("kXQh5");
const $eefc42943df59f99$var$formatOperator = (operator, operatorCase)=>{
    switch(operatorCase){
        case 'lower':
            return operator.toLowerCase();
        case 'upper':
            return operator.toUpperCase();
        case 'preserve':
            return operator;
    }
};
class $eefc42943df59f99$export$27a275559a5c8102 extends (0, $i1EwT.AbstractJastVisitor) {
    constructor({ operatorCase: operatorCase } = {}){
        super();
        this.operatorCase = operatorCase || 'preserve';
    }
    visitArgument(argument) {
        return argument.text;
    }
    /**
	 * Visit each of the provided nodes and form a new array with each `Doc` joined by the provided separator.
	 */ joinNodes(nodes, separator) {
        const docs = [];
        nodes.forEach((node)=>{
            if (separator !== undefined && docs.length > 0) docs.push(separator);
            docs.push(node.accept(this));
        });
        return docs;
    }
    visitCompoundClause(compoundClause) {
        const operatorDoc = compoundClause.operator.accept(this);
        const clauseDocs = [];
        compoundClause.clauses.forEach((clause)=>{
            if (clauseDocs.length > 0) clauseDocs.push((0, $kXQh5.ifBreak)((0, $kXQh5.newLine)(), ' '), operatorDoc, ' ');
            // Wrap nested compound clauses in parentheses
            if (clause.clauseType === (0, $24102d5d112d2831$export$7a58b23488ea076b)) clauseDocs.push('(', clause.accept(this), ')');
            else clauseDocs.push(clause.accept(this));
        });
        return (0, $kXQh5.group)(clauseDocs);
    }
    visitCompoundOperator(compoundOperator) {
        return $eefc42943df59f99$var$formatOperator(compoundOperator.value, this.operatorCase);
    }
    visitField(field) {
        const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
        return (0, $kXQh5.group)([
            field.text,
            ...propertyDocs
        ]);
    }
    visitFunction(functionString) {
        return functionString.text;
    }
    visitFunctionOperand(functionOperand) {
        const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
        return (0, $kXQh5.group)([
            functionOperand.function.accept(this),
            '(',
            ...argumentDocs,
            ')'
        ]);
    }
    visitKeywordOperand(keywordOperand) {
        return keywordOperand.value;
    }
    visitListOperand(listOperand) {
        const operandDocs = this.joinNodes(listOperand.values, ', ');
        return (0, $kXQh5.group)([
            '(',
            ...operandDocs,
            ')'
        ]);
    }
    visitOperator(operator) {
        return $eefc42943df59f99$var$formatOperator(operator.text, this.operatorCase);
    }
    visitOrderBy(orderBy) {
        const fieldDocs = this.joinNodes(orderBy.fields, ', ');
        return (0, $kXQh5.group)([
            orderBy.operator.accept(this),
            ' ',
            ...fieldDocs
        ]);
    }
    visitOrderByDirection(orderByDirection) {
        return orderByDirection.value;
    }
    visitOrderByField(orderByField) {
        const docs = [
            orderByField.field.accept(this)
        ];
        if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
        return (0, $kXQh5.group)(docs);
    }
    visitOrderByOperator(orderByOperator) {
        return $eefc42943df59f99$var$formatOperator(orderByOperator.value, this.operatorCase);
    }
    visitPredicate(predicate) {
        const docs = [
            predicate.operator.accept(this)
        ];
        if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
        return (0, $kXQh5.group)(docs);
    }
    visitPredicateOperator(predicateOperator) {
        return $eefc42943df59f99$var$formatOperator(predicateOperator.text, this.operatorCase);
    }
    visitProperty(property) {
        const docs = [];
        if (property.key) docs.push('[', property.key.accept(this), ']');
        if (property.path) {
            const pathDocs = this.joinNodes(property.path, ' ');
            docs.push(...pathDocs);
        }
        return (0, $kXQh5.group)(docs);
    }
    visitQuery(query) {
        if (query.where && query.orderBy) return (0, $kXQh5.group)([
            query.where.accept(this),
            (0, $kXQh5.ifBreak)((0, $kXQh5.newLine)(), ' '),
            query.orderBy.accept(this)
        ]);
        else if (query.where) return query.where.accept(this);
        else if (query.orderBy) return query.orderBy.accept(this);
        return '';
    }
    visitTerminalClause(terminalClause) {
        const docs = [
            terminalClause.field.accept(this)
        ];
        if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
        if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
        terminalClause.predicates.forEach((predicate)=>{
            docs.push(' ', predicate.accept(this));
        });
        return (0, $kXQh5.group)(docs);
    }
    visitValueOperand(valueOperand) {
        return valueOperand.text;
    }
    visitNotClause(notClause) {
        const clauseDocs = [];
        // Wrap nested compound clauses in parentheses
        if (notClause.clause.clauseType === (0, $24102d5d112d2831$export$7a58b23488ea076b)) clauseDocs.push('(', notClause.clause.accept(this), ')');
        else clauseDocs.push(notClause.clause.accept(this));
        return (0, $kXQh5.group)([
            notClause.operator.accept(this),
            ' ',
            ...clauseDocs
        ]);
    }
    visitNotClauseOperator(notClauseOperator) {
        return notClauseOperator.value;
    }
    visitChildren() {
        throw new Error('Required visit method not implemented for node');
    }
    defaultResult() {
        return '';
    }
}
const $eefc42943df59f99$export$f0ef38932978952 = (jast, options)=>{
    const astToDocVisitor = new $eefc42943df59f99$export$27a275559a5c8102(options);
    return jast.query ? jast.query.accept(astToDocVisitor) : '';
};

});
parcelRegister("i1EwT", function(module, exports) {

$parcel$export(module.exports, "AbstractJastVisitor", () => $b6f0b0d4c9d6efd0$export$51be62b46ee668fd);
class $b6f0b0d4c9d6efd0$export$51be62b46ee668fd {
    /**
	 * The default implementation calls AstNode#accept on the specified node.
	 * @param node
	 */ visit(node) {
        return node.accept(this);
    }
    /**
	 * The default implementation initializes the aggregate result to defaultResult(). Before visiting each child, it
	 * calls shouldVisitNextChild; if the result is false no more children are visited and the current aggregate result is
	 * returned. After visiting a child, the aggregate result is updated by calling aggregateResult with the previous
	 * aggregate result and the result of visiting the child.
	 */ visitChildren(node) {
        let result = this.defaultResult();
        const children = node.getChildren();
        for(let i = 0; i < children.length; i++){
            if (!this.shouldVisitNextChild(node, result)) break;
            const childResult = children[i].accept(this);
            result = this.aggregateResult(result, childResult);
        }
        return result;
    }
    /**
	 * Aggregates the results of visiting multiple children of a node.
	 *
	 * The default implementation returns `nextResult`, meaning
	 * {@link #visitChildren} will return the result of the last child visited
	 * (or return the initial value if the node has no children).
	 *
	 * @param aggregate The previous aggregate value. In the default
	 * implementation, the aggregate value is initialized to
	 * {@link #defaultResult}, which is passed as the `aggregate` argument
	 * to this method after the first child node is visited.
	 * @param nextResult The result of the immediately preceeding call to visit
	 * a child node.
	 *
	 * @returns The updated aggregate result.
	 */ aggregateResult(aggregate, nextResult) {
        return nextResult;
    }
    /**
	 * This method is called before visiting each child in
	 * {@link #visitChildren}. When the method is first called\ `currentResult`
	 * will be the initial value (in the default implementation, the initial value
	 * is returned by a call to {@link #defaultResult}).
	 *
	 * The default implementation always returns `true`, indicating that
	 * `visitChildren` should only return after all children are visited.
	 * One reason to override this method is to provide a "short circuit"
	 * evaluation option for situations where the result of visiting a single
	 * child has the potential to determine the result of the visit operation as
	 * a whole.
	 *
	 * @param node The {@link AstNode} whose children are currently being
	 * visited.
	 * @param currentResult The current aggregate result of the children visited
	 * to the current point.
	 *
	 * @returns `true` to continue visiting children. Otherwise return
	 * `false` to stop visiting children and immediately return the
	 * current aggregate result from {@link #visitChildren}.
	 */ shouldVisitNextChild(node, currentResult) {
        return true;
    }
}

});

parcelRegister("kXQh5", function(module, exports) {

$parcel$export(module.exports, "group", () => $81510cf4df5f2250$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "ifBreak", () => $81510cf4df5f2250$export$1db8e61901dcb0fa);
$parcel$export(module.exports, "newLine", () => $81510cf4df5f2250$export$dc84f6841f96b7da);
const $81510cf4df5f2250$export$e5e25fbcc1f7affe = (contents)=>{
    return {
        type: 'group',
        contents: contents
    };
};
const $81510cf4df5f2250$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
    return {
        type: 'if-break',
        breakContents: breakContents,
        flatContents: flatContents
    };
};
const $81510cf4df5f2250$export$dc84f6841f96b7da = ()=>{
    return {
        type: 'new-line'
    };
};

});


parcelRegister("hm29V", function(module, exports) {

$parcel$export(module.exports, "printDocToString", () => $464156ad3de5b656$export$316fc7e94b95b118);
const $464156ad3de5b656$var$computeFlatWidth = (doc)=>{
    if (typeof doc === 'string') return doc.length;
    if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $464156ad3de5b656$var$computeFlatWidth(innerDoc), 0);
    switch(doc.type){
        case 'group':
            return $464156ad3de5b656$var$computeFlatWidth(doc.contents);
        case 'if-break':
            return $464156ad3de5b656$var$computeFlatWidth(doc.flatContents);
        case 'new-line':
            // TODO This probably represents a bug as we don't expect new lines in the flat path
            return 0;
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $464156ad3de5b656$var$printDoc = (doc, context)=>{
    if (typeof doc === 'string') return {
        result: doc,
        endIndex: context.startIndex + doc.length
    };
    switch(doc.type){
        case 'group':
            return $464156ad3de5b656$var$printGroup(doc, context);
        case 'if-break':
            return $464156ad3de5b656$var$printIfBreak(doc, context);
        case 'new-line':
            return $464156ad3de5b656$var$printNewLine();
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $464156ad3de5b656$var$printGroup = (doc, context)=>{
    const docWidth = context.startIndex + $464156ad3de5b656$var$computeFlatWidth(doc);
    const breakContents = context.printWidth !== null && docWidth > context.printWidth;
    return doc.contents.reduce((agg, innerDoc)=>{
        const innerContext = {
            ...context,
            startIndex: agg.endIndex,
            breakContents: breakContents
        };
        const output = $464156ad3de5b656$var$printDoc(innerDoc, innerContext);
        return {
            result: agg.result + output.result,
            endIndex: output.endIndex
        };
    }, {
        result: '',
        endIndex: context.startIndex
    });
};
const $464156ad3de5b656$var$printIfBreak = (doc, context)=>{
    if (context.breakContents) return $464156ad3de5b656$var$printDoc(doc.breakContents, context);
    return $464156ad3de5b656$var$printDoc(doc.flatContents, context);
};
const $464156ad3de5b656$var$printNewLine = ()=>{
    return {
        result: '\n',
        // Reset our end index as a new line is being output.
        endIndex: 0
    };
};
// TODO Tweak this number with design
const $464156ad3de5b656$var$defaultPrintWidth = 100;
const $464156ad3de5b656$export$316fc7e94b95b118 = (doc, options = {})=>{
    const { printWidth: printWidth = $464156ad3de5b656$var$defaultPrintWidth } = options;
    const output = $464156ad3de5b656$var$printDoc(doc, {
        printWidth: printWidth,
        startIndex: 0,
        breakContents: false
    });
    return output.result;
};

});




parcelRegister("coMWQ", function(module, exports) {

$parcel$export(module.exports, "deserialiseJql", () => $67199c690c914c16$export$214464255b766962);

var $hir2i = parcelRequire("hir2i");

var $27QuD = parcelRequire("27QuD");

var $9FEvp = parcelRequire("9FEvp");

var $6x1NF = parcelRequire("6x1NF");

var $i1EwT = parcelRequire("i1EwT");
var $hV92L = parcelRequire("hV92L");
var $8XgA0 = parcelRequire("8XgA0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $1run3 = parcelRequire("1run3");

var $dG4cR = parcelRequire("dG4cR");
const $67199c690c914c16$var$START_DATE_JQL = 'Start date[Date]';
const $67199c690c914c16$var$EMPTY = 'EMPTY';
const $67199c690c914c16$var$cleanString = (value)=>value.trim();
// some filters should display options retrieved from the URL parameters even when they are not returned amongst the useFieldConfig field values
const $67199c690c914c16$var$shouldIncludeUnknownOption = (filterField)=>{
    const allowedFieldTypes = new Set([
        (0, $lO4Or.COMPONENTS_TYPE),
        (0, $lO4Or.LABELS_TYPE),
        (0, $lO4Or.PRIORITY_TYPE),
        (0, $lO4Or.CATEGORY_TYPE)
    ]);
    return allowedFieldTypes.has(filterField?.type ?? '');
};
const $67199c690c914c16$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
    const fieldName = (0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(rawFieldName, '"');
    const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
    // `cf[id]` -> `customfield_${id}`.
    if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
        const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
        if (!extraction) return fieldName;
        const fieldId = extraction[1];
        return `customfield_${fieldId}`;
    }
    const startDateJql = $67199c690c914c16$var$START_DATE_JQL;
    // update this if we add a start date or due date filter
    if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
    return fieldName;
};
const $67199c690c914c16$var$transformIntoOptions = async (list, field, resolver, filterField)=>{
    if (resolver && typeof resolver === 'function') {
        const ids = list.map((value)=>(0, $eI5EY.fg)('wanjel-fix-filters-including-whitespace') ? value : $67199c690c914c16$var$cleanString(value));
        return resolver(ids);
    }
    const allowUnknownOption = $67199c690c914c16$var$shouldIncludeUnknownOption(filterField);
    return list.map((value)=>{
        const cleanValue = (0, $eI5EY.fg)('wanjel-fix-filters-including-whitespace') ? value : $67199c690c914c16$var$cleanString(value);
        if (field && !(0, $1run3.isDateField)(field) && Array.isArray(field.options)) {
            const optionInField = field.options.find((option)=>{
                if ((option == null || option.value == null) && !option.isEmptyOption) return null;
                if (option.isEmptyOption) return value === $67199c690c914c16$var$EMPTY;
                return option.value === cleanValue;
            });
            if (!optionInField && allowUnknownOption) return {
                value: cleanValue,
                label: cleanValue
            };
            return optionInField;
        }
        return undefined;
    }).filter((item)=>item != null && 'value' in item);
};
class $67199c690c914c16$export$5299115fe71e8b39 extends (0, $i1EwT.AbstractJastVisitor) {
    constructor(fieldConfig, filterFields, resolvers){
        super();
        this.getOption = (fieldName, items)=>$67199c690c914c16$var$transformIntoOptions(items, this.fieldConfig[fieldName], this.resolvers[fieldName], this.filterFields.find((field)=>field.id === fieldName));
        this.visitCompoundClause = async (compoundClause)=>{
            if ((0, $eI5EY.fg)('wanjel-fix-deserialise-filters-sentry-errors')) {
                const clauseMap = {};
                const operator = compoundClause.operator.value;
                if (operator === (0, $e1349279c1d70213$export$6d6d48d210d3ca97)) {
                    const clausePromises = await Promise.all(compoundClause.clauses.map((clause)=>clause.accept(this)));
                    return clausePromises.reduce((result, clause)=>this.aggregateResultSync(clause, result), clauseMap);
                }
                throw new Error(`JQL contains invalid operator between clauses: ${operator}`);
            }
            const clauseMap = Promise.resolve({});
            const operator = compoundClause.operator.value;
            if (operator === (0, $e1349279c1d70213$export$6d6d48d210d3ca97)) return compoundClause.clauses.reduce((result, clause)=>this.aggregateResult(clause.accept(this), result), clauseMap);
            throw new Error(`JQL contains invalid operator between clauses: ${operator}`);
        };
        this.parseDateOperand = (operator, operand)=>{
            if (operand?.operandType === (0, $2de6644e999aca05$export$38accfc5a5d1c113)) {
                let date = (0, $6x1NF.default)(new Date(operand.value), 'UTC', 'yyyy-MM-dd');
                if (operator.value === (0, $8XgA0.OPERATOR_LT)) date = (0, $6x1NF.default)((0, $9FEvp.default)(new Date(operand.value), 1), 'UTC', 'yyyy-MM-dd');
                const dateType = operator.value === (0, $8XgA0.OPERATOR_LT) ? 'to' : 'from';
                return {
                    value: {
                        [dateType]: date
                    }
                };
            }
            throw new Error(`JQL cannot parse date operand type: ${operand.operandType}`);
        };
        this.parseSelectOperand = async (fieldName, operand)=>{
            if (operand?.operandType === (0, $2de6644e999aca05$export$fabec4aebba3f4df)) {
                const optionPromises = operand.values.flatMap((value)=>this.parseSelectOperand(fieldName, value));
                return (await Promise.all(optionPromises)).flatMap((option)=>option);
            }
            if (operand?.operandType === (0, $2de6644e999aca05$export$38accfc5a5d1c113)) return this.getOption(fieldName, [
                operand.value
            ]);
            if (operand?.operandType === (0, $2de6644e999aca05$export$f6049126fd97001f)) return [
                {
                    isEmptyOption: true,
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: ''
                }
            ];
            throw new Error(`JQL cannot parse select operand type: ${operand.operandType}`);
        };
        this.visitTerminalClause = async (terminalClause)=>{
            const { field: field, operand: operand, operator: operator } = terminalClause;
            if (!operand || !operator) return Promise.resolve({});
            const getShouldConvertCustomField = (fieldName)=>// should convert cf[] -> customfield_ if it's not a field from version 2
                !(this.fieldConfig[fieldName] && this.fieldConfig[fieldName].fieldConfigVersion === 2);
            const fieldName = $67199c690c914c16$var$getFieldIdFromJql(field.value, getShouldConvertCustomField);
            if (!Object.keys(this.fieldConfig).includes(fieldName)) throw new Error(`JQL contains unsupported fields: ${fieldName}`);
            let value = [];
            if (operator.value === (0, $8XgA0.OPERATOR_GT_EQUALS) || operator.value === (0, $8XgA0.OPERATOR_LT)) value = this.parseDateOperand(operator, operand);
            else if (operator.value === (0, $8XgA0.OPERATOR_EQUALS) || operator.value === (0, $8XgA0.OPERATOR_IN)) value = await this.parseSelectOperand(fieldName, operand);
            else throw new Error(`JQL contains unsupported operator in terminal clause: ${operator.value}`);
            return {
                [fieldName]: value
            };
        };
        this.fieldConfig = fieldConfig;
        this.filterFields = filterFields;
        this.resolvers = resolvers;
    }
    visitNotClause() {
        throw new Error('JQL contains invalid clause: NOT');
    }
    defaultResult() {
        return Promise.resolve({});
    }
    /**
	 * @param aggregate new ClauseMap to add into nextResult
	 * @param nextResult ClauseMap with previous results
	 * @returns ClauseMap with the merged results adding the aggregate at the end
	 */ async aggregateResult(aggregate, nextResult) {
        // First parameter is the object where we want to add the values and the second the new values to merge into the first object.
        return (0, (/*@__PURE__*/$parcel$interopDefault($hir2i)))(await nextResult, await aggregate, (destValue, srcValue)=>{
            if (Array.isArray(srcValue)) return srcValue.concat(destValue ?? []);
            return undefined;
        });
    }
    aggregateResultSync(aggregate, nextResult) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($hir2i)))(nextResult, aggregate, (destValue, srcValue)=>{
            if (Array.isArray(srcValue)) return srcValue.concat(destValue ?? []);
            return undefined;
        });
    }
}
const $67199c690c914c16$export$214464255b766962 = async (jql, fieldConfig, filterFields, resolvers)=>{
    // Create the syntax tree for the filters JQL
    const builder = new (0, $hV92L.JastBuilder)();
    const jast = builder.build(jql);
    if (jast.query?.orderBy != null) throw new Error('JQL contains unsupported ORDER BY');
    // Parse the JQL AST into a FilterType object
    const parser = new $67199c690c914c16$export$5299115fe71e8b39(fieldConfig, filterFields, resolvers);
    const parsedJql = await jast.query?.accept(parser);
    return parsedJql ?? {};
};

});
parcelRegister("hir2i", function(module, exports) {

var $eljWd = parcelRequire("eljWd");

var $3Bqj8 = parcelRequire("3Bqj8");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $c97916e8180d3b9a$var$mergeWith = $3Bqj8(function(object, source, srcIndex, customizer) {
    $eljWd(object, source, srcIndex, customizer);
});
module.exports = $c97916e8180d3b9a$var$mergeWith;

});

parcelRegister("hV92L", function(module, exports) {

$parcel$export(module.exports, "JastBuilder", () => $b6da0d0dc4365a29$export$99cae18a5a6ba8cf);

var $9pfFs = parcelRequire("9pfFs");

var $5iWql = parcelRequire("5iWql");

var $yUeX5 = parcelRequire("yUeX5");
var $e3Si3 = parcelRequire("e3Si3");

var $55Dca = parcelRequire("55Dca");

var $2LdPw = parcelRequire("2LdPw");
var $5f9Gp = parcelRequire("5f9Gp");

var $b4x0R = parcelRequire("b4x0R");
class $b6da0d0dc4365a29$export$99cae18a5a6ba8cf {
    setErrorHandler(errorHandler) {
        this.errorHandler = errorHandler;
        return this;
    }
    setErrorListeners(errorListeners) {
        this.errorListeners = this.errorListeners.concat(errorListeners);
        return this;
    }
    build(value) {
        const tokens = this.getTokens(value);
        const parser = this.getParser(tokens);
        const astErrorListener = new (0, $2LdPw.JastBuilderErrorListener)();
        parser.removeErrorListeners();
        parser.addErrorListener(astErrorListener);
        this.errorListeners.forEach((errorListener)=>parser.addErrorListener(errorListener));
        if (this.errorHandler) {
            parser.errorHandler = this.errorHandler;
            this.errorHandler.reset(parser);
        }
        const visitor = new (0, $b4x0R.QueryVisitor)(tokens);
        try {
            const parseTree = parser.jqlQuery();
            const query = parseTree.accept(visitor);
            return (0, $55Dca.default).jast(query, value, astErrorListener.errors);
        } catch (error) {
            return (0, $55Dca.default).jast(undefined, value, [
                new (0, $5f9Gp.JQLParseError)(error.message, error)
            ]);
        }
    }
    constructor(){
        this.errorListeners = [];
        this.errorHandler = undefined;
        this.getTokens = (0, $5iWql.default)((value)=>{
            const chars = (0, $9pfFs.CharStreams).fromString(value);
            const lexer = new (0, $yUeX5.JQLLexer)(chars);
            return new (0, $9pfFs.CommonTokenStream)(lexer);
        });
        this.getParser = (0, $5iWql.default)((tokens)=>new (0, $e3Si3.JQLParser)(tokens));
    }
}

});
parcelRegister("9pfFs", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6d929a23f22266a3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6d929a23f22266a3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6d929a23f22266a3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6d929a23f22266a3$var$__exportStar((parcelRequire("5oG2w")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("gO8Xw")), module.exports);

// export * from "./ANTLRFileStream";
$6d929a23f22266a3$var$__exportStar((parcelRequire("eZYsJ")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("csTA1")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("doEv1")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("aUhGF")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("8tY30")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("cNEtm")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("1EXcP")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("exlin")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("9hrXh")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("eCP5Y")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("eEgBk")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("3HZil")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("9xPUt")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("67k7F")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("2quiJ")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("5jZSY")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("jo2Zj")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("ldi9e")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("h7Q3L")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("hVliW")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("l3IpB")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("c8NTK")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("iAlWg")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("c9Sjf")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("5n08Y")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("8rZl7")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("2pDMz")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("3Wiwr")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("jdbdJ")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("b7PPe")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("dwftT")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("1xO0Q")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("atcwe")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("3d5Fu")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("hHHux")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("eKXi4")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("lL3Js")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("03lZa")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("b3QEj")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("hwMU6")), module.exports);

// export * from "./UnbufferedCharStream";
// export * from "./UnbufferedTokenStream";
$6d929a23f22266a3$var$__exportStar((parcelRequire("2YAkU")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("hBnE1")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("edl4x")), module.exports);

});
parcelRegister("5oG2w", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gO8Xw", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eZYsJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ // ConvertTo-TS run at 2016-10-04T11:26:49.0828748-07:00
var $aeb5a9c9d3e1e2dc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ANTLRInputStream = void 0;

var $fomfP = parcelRequire("fomfP");

var $aN41m = parcelRequire("aN41m");

var $ldi9e = parcelRequire("ldi9e");
const $aeb5a9c9d3e1e2dc$var$READ_BUFFER_SIZE = 1024;
const $aeb5a9c9d3e1e2dc$var$INITIAL_BUFFER_SIZE = 1024;
/**
 * Vacuum all input from a {@link Reader}/{@link InputStream} and then treat it
 * like a `char[]` buffer. Can also pass in a {@link String} or
 * `char[]` to use.
 *
 * If you need encoding, pass in stream/reader with correct encoding.
 *
 * @deprecated as of 4.7, please use `CharStreams` interface.
 */ class $aeb5a9c9d3e1e2dc$var$ANTLRInputStream {
    /** Copy data in string to a local char array */ constructor(input){
        /** 0..n-1 index into string of next char */ this.p = 0;
        this.data = input;
        this.n = input.length;
    }
    /** Reset the stream so that it's in the same state it was
     *  when the object was created *except* the data array is not
     *  touched.
     */ reset() {
        this.p = 0;
    }
    consume() {
        if (this.p >= this.n) {
            $fomfP(this.LA(1) === $ldi9e.IntStream.EOF);
            throw new Error("cannot consume EOF");
        }
        //System.out.println("prev p="+p+", c="+(char)data[p]);
        if (this.p < this.n) this.p++;
    }
    LA(i) {
        if (i === 0) return 0; // undefined
        if (i < 0) {
            i++; // e.g., translate LA(-1) to use offset i=0; then data[p+0-1]
            if (this.p + i - 1 < 0) return $ldi9e.IntStream.EOF; // invalid; no char before first char
        }
        if (this.p + i - 1 >= this.n) //System.out.println("char LA("+i+")=EOF; p="+p);
        return $ldi9e.IntStream.EOF;
        //System.out.println("char LA("+i+")="+(char)data[p+i-1]+"; p="+p);
        //System.out.println("LA("+i+"); p="+p+" n="+n+" data.length="+data.length);
        return this.data.charCodeAt(this.p + i - 1);
    }
    LT(i) {
        return this.LA(i);
    }
    /** Return the current input symbol index 0..n where n indicates the
     *  last symbol has been read.  The index is the index of char to
     *  be returned from LA(1).
     */ get index() {
        return this.p;
    }
    get size() {
        return this.n;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    /** consume() ahead until p==index; can't just set p=index as we must
     *  update line and charPositionInLine. If we seek backwards, just set p
     */ seek(index) {
        if (index <= this.p) {
            this.p = index; // just jump; don't update stream state (line, ...)
            return;
        }
        // seek forward, consume until p hits index or n (whichever comes first)
        index = Math.min(index, this.n);
        while(this.p < index)this.consume();
    }
    getText(interval) {
        let start = interval.a;
        let stop = interval.b;
        if (stop >= this.n) stop = this.n - 1;
        let count = stop - start + 1;
        if (start >= this.n) return "";
        // System.err.println("data: "+Arrays.toString(data)+", n="+n+
        // 				   ", start="+start+
        // 				   ", stop="+stop);
        return this.data.substr(start, count);
    }
    get sourceName() {
        if (!this.name) return $ldi9e.IntStream.UNKNOWN_SOURCE_NAME;
        return this.name;
    }
    toString() {
        return this.data;
    }
}
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "consume", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "LA", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "index", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "size", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "mark", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "release", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "seek", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "getText", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "sourceName", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "toString", null);
module.exports.ANTLRInputStream = $aeb5a9c9d3e1e2dc$var$ANTLRInputStream;

});
parcelRegister("fomfP", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $2fFJv = parcelRequire("2fFJv");
'use strict';
function $b34a5c254ce73537$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b34a5c254ce73537$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b34a5c254ce73537$var$_typeof(o);
}
function $b34a5c254ce73537$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $b34a5c254ce73537$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $b34a5c254ce73537$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b34a5c254ce73537$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b34a5c254ce73537$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b34a5c254ce73537$var$_toPropertyKey(arg) {
    var key = $b34a5c254ce73537$var$_toPrimitive(arg, "string");
    return $b34a5c254ce73537$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b34a5c254ce73537$var$_toPrimitive(input, hint) {
    if ($b34a5c254ce73537$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b34a5c254ce73537$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $b34a5c254ce73537$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $5xQQM = parcelRequire("5xQQM");
var $b34a5c254ce73537$var$_require$codes = $5xQQM.codes, $b34a5c254ce73537$var$ERR_AMBIGUOUS_ARGUMENT = $b34a5c254ce73537$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE = $b34a5c254ce73537$var$_require$codes.ERR_INVALID_ARG_TYPE, $b34a5c254ce73537$var$ERR_INVALID_ARG_VALUE = $b34a5c254ce73537$var$_require$codes.ERR_INVALID_ARG_VALUE, $b34a5c254ce73537$var$ERR_INVALID_RETURN_VALUE = $b34a5c254ce73537$var$_require$codes.ERR_INVALID_RETURN_VALUE, $b34a5c254ce73537$var$ERR_MISSING_ARGS = $b34a5c254ce73537$var$_require$codes.ERR_MISSING_ARGS;

var $4ZhvB = parcelRequire("4ZhvB");

var $ibOwR = parcelRequire("ibOwR");
var $b34a5c254ce73537$var$inspect = $ibOwR.inspect;

var $ibOwR = parcelRequire("ibOwR");
var $b34a5c254ce73537$require$_require$types = $ibOwR.types;
var $b34a5c254ce73537$var$isPromise = $b34a5c254ce73537$require$_require$types.isPromise, $b34a5c254ce73537$var$isRegExp = $b34a5c254ce73537$require$_require$types.isRegExp;

var $b34a5c254ce73537$var$objectAssign = (parcelRequire("5Nqsj"))();

var $b34a5c254ce73537$var$objectIs = (parcelRequire("c4ycW"))();

var $b34a5c254ce73537$var$RegExpPrototypeTest = (parcelRequire("g94P8"))('RegExp.prototype.test');
var $b34a5c254ce73537$var$errorCache = new Map();
var $b34a5c254ce73537$var$isDeepEqual;
var $b34a5c254ce73537$var$isDeepStrictEqual;
var $b34a5c254ce73537$var$parseExpressionAt;
var $b34a5c254ce73537$var$findNodeAround;
var $b34a5c254ce73537$var$decoder;

function $b34a5c254ce73537$var$lazyLoadComparison() {
    var comparison = (parcelRequire("55ouo"));
    $b34a5c254ce73537$var$isDeepEqual = comparison.isDeepEqual;
    $b34a5c254ce73537$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $b34a5c254ce73537$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $b34a5c254ce73537$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $b34a5c254ce73537$var$escapeFn = function escapeFn(str) {
    return $b34a5c254ce73537$var$meta[str.charCodeAt(0)];
};
var $b34a5c254ce73537$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $b34a5c254ce73537$var$assert = module.exports = $b34a5c254ce73537$var$ok;
var $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $b34a5c254ce73537$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $4ZhvB(obj);
}
function $b34a5c254ce73537$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($b34a5c254ce73537$var$warned === false) {
            $b34a5c254ce73537$var$warned = true;
            var warn = $2fFJv.emitWarning ? $2fFJv.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $b34a5c254ce73537$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $4ZhvB(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$b34a5c254ce73537$var$assert.fail = $b34a5c254ce73537$var$fail;
// The AssertionError is defined in internal/error.
$b34a5c254ce73537$var$assert.AssertionError = $4ZhvB;
function $b34a5c254ce73537$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $4ZhvB({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $b34a5c254ce73537$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $b34a5c254ce73537$var$innerOk.apply(void 0, [
        $b34a5c254ce73537$var$ok,
        args.length
    ].concat(args));
}
$b34a5c254ce73537$var$assert.ok = $b34a5c254ce73537$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $b34a5c254ce73537$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$b34a5c254ce73537$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$b34a5c254ce73537$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
    if (!$b34a5c254ce73537$var$isDeepEqual(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$b34a5c254ce73537$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
    if ($b34a5c254ce73537$var$isDeepEqual(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $b34a5c254ce73537$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
    if (!$b34a5c254ce73537$var$isDeepStrictEqual(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$b34a5c254ce73537$var$assert.notDeepStrictEqual = $b34a5c254ce73537$var$notDeepStrictEqual;
function $b34a5c254ce73537$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
    if ($b34a5c254ce73537$var$isDeepStrictEqual(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $b34a5c254ce73537$var$notDeepStrictEqual
    });
}
$b34a5c254ce73537$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$b34a5c254ce73537$var$objectIs(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$b34a5c254ce73537$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$objectIs(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $b34a5c254ce73537$var$Comparison = /*#__PURE__*/ $b34a5c254ce73537$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $b34a5c254ce73537$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $b34a5c254ce73537$var$isRegExp(obj[key]) && $b34a5c254ce73537$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $b34a5c254ce73537$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$b34a5c254ce73537$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $b34a5c254ce73537$var$Comparison(actual, keys);
            var b = new $b34a5c254ce73537$var$Comparison(expected, keys, actual);
            var err = new $4ZhvB({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $b34a5c254ce73537$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $b34a5c254ce73537$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($b34a5c254ce73537$var$isRegExp(expected)) return $b34a5c254ce73537$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($b34a5c254ce73537$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $4ZhvB({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $b34a5c254ce73537$var$isRegExp(expected[key]) && $b34a5c254ce73537$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $b34a5c254ce73537$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $b34a5c254ce73537$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL;
}
function $b34a5c254ce73537$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $b34a5c254ce73537$var$isPromise(obj) || obj !== null && $b34a5c254ce73537$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $b34a5c254ce73537$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$b34a5c254ce73537$var$checkIsPromise(resultPromise)) throw new $b34a5c254ce73537$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($b34a5c254ce73537$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $b34a5c254ce73537$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($b34a5c254ce73537$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $b34a5c254ce73537$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $b34a5c254ce73537$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $b34a5c254ce73537$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $b34a5c254ce73537$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$b34a5c254ce73537$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $b34a5c254ce73537$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $b34a5c254ce73537$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $b34a5c254ce73537$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$b34a5c254ce73537$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $b34a5c254ce73537$var$expectsError.apply(void 0, [
        throws,
        $b34a5c254ce73537$var$getActual(promiseFn)
    ].concat(args));
};
$b34a5c254ce73537$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $b34a5c254ce73537$var$waitForActual(promiseFn).then(function(result) {
        return $b34a5c254ce73537$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$b34a5c254ce73537$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $b34a5c254ce73537$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $b34a5c254ce73537$var$getActual(fn)
    ].concat(args));
};
$b34a5c254ce73537$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $b34a5c254ce73537$var$waitForActual(fn).then(function(result) {
        return $b34a5c254ce73537$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$b34a5c254ce73537$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($b34a5c254ce73537$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $b34a5c254ce73537$var$inspect(err);
        var newErr = new $4ZhvB({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $b34a5c254ce73537$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$b34a5c254ce73537$var$isRegExp(regexp)) throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $b34a5c254ce73537$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($b34a5c254ce73537$var$_typeof(string), " (").concat($b34a5c254ce73537$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($b34a5c254ce73537$var$inspect(regexp), ". Input:\n\n").concat($b34a5c254ce73537$var$inspect(string), "\n"));
        var err = new $4ZhvB({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$b34a5c254ce73537$var$assert.match = function match(string, regexp, message) {
    $b34a5c254ce73537$var$internalMatch(string, regexp, message, match, 'match');
};
$b34a5c254ce73537$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $b34a5c254ce73537$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $b34a5c254ce73537$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $b34a5c254ce73537$var$innerOk.apply(void 0, [
        $b34a5c254ce73537$var$strict,
        args.length
    ].concat(args));
}
$b34a5c254ce73537$var$assert.strict = $b34a5c254ce73537$var$objectAssign($b34a5c254ce73537$var$strict, $b34a5c254ce73537$var$assert, {
    equal: $b34a5c254ce73537$var$assert.strictEqual,
    deepEqual: $b34a5c254ce73537$var$assert.deepStrictEqual,
    notEqual: $b34a5c254ce73537$var$assert.notStrictEqual,
    notDeepEqual: $b34a5c254ce73537$var$assert.notDeepStrictEqual
});
$b34a5c254ce73537$var$assert.strict.strict = $b34a5c254ce73537$var$assert.strict;

});
parcelRegister("5xQQM", function(module, exports) {

$parcel$export(module.exports, "codes", () => $409907ccfa1a83e8$export$e45cb6485273080e, (v) => $409907ccfa1a83e8$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $409907ccfa1a83e8$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $409907ccfa1a83e8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $409907ccfa1a83e8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $409907ccfa1a83e8$var$_typeof(o);
}
function $409907ccfa1a83e8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $409907ccfa1a83e8$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $409907ccfa1a83e8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $409907ccfa1a83e8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $409907ccfa1a83e8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $409907ccfa1a83e8$var$_toPropertyKey(arg) {
    var key = $409907ccfa1a83e8$var$_toPrimitive(arg, "string");
    return $409907ccfa1a83e8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $409907ccfa1a83e8$var$_toPrimitive(input, hint) {
    if ($409907ccfa1a83e8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($409907ccfa1a83e8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $409907ccfa1a83e8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $409907ccfa1a83e8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $409907ccfa1a83e8$var$_setPrototypeOf(subClass, superClass);
}
function $409907ccfa1a83e8$var$_setPrototypeOf(o, p) {
    $409907ccfa1a83e8$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $409907ccfa1a83e8$var$_setPrototypeOf(o, p);
}
function $409907ccfa1a83e8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $409907ccfa1a83e8$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $409907ccfa1a83e8$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $409907ccfa1a83e8$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $409907ccfa1a83e8$var$_possibleConstructorReturn(this, result);
    };
}
function $409907ccfa1a83e8$var$_possibleConstructorReturn(self, call) {
    if (call && ($409907ccfa1a83e8$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $409907ccfa1a83e8$var$_assertThisInitialized(self);
}
function $409907ccfa1a83e8$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $409907ccfa1a83e8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $409907ccfa1a83e8$var$_getPrototypeOf(o) {
    $409907ccfa1a83e8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $409907ccfa1a83e8$var$_getPrototypeOf(o);
}
var $409907ccfa1a83e8$var$codes = {};
// Lazy loaded
var $409907ccfa1a83e8$var$assert;
var $409907ccfa1a83e8$var$util;
function $409907ccfa1a83e8$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $409907ccfa1a83e8$var$_inherits(NodeError, _Base);
        var _super = $409907ccfa1a83e8$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $409907ccfa1a83e8$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $409907ccfa1a83e8$var$_createClass(NodeError);
    }(Base);
    $409907ccfa1a83e8$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $409907ccfa1a83e8$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $409907ccfa1a83e8$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $409907ccfa1a83e8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $409907ccfa1a83e8$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$409907ccfa1a83e8$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$409907ccfa1a83e8$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($409907ccfa1a83e8$var$assert === undefined) $409907ccfa1a83e8$var$assert = (parcelRequire("fomfP"));
    $409907ccfa1a83e8$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $409907ccfa1a83e8$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($409907ccfa1a83e8$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($409907ccfa1a83e8$var$oneOf(expected, 'type'));
    else {
        var type = $409907ccfa1a83e8$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($409907ccfa1a83e8$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($409907ccfa1a83e8$var$_typeof(actual));
    return msg;
}, TypeError);

$409907ccfa1a83e8$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($409907ccfa1a83e8$var$util === undefined) $409907ccfa1a83e8$var$util = (parcelRequire("ibOwR"));
    var inspected = $409907ccfa1a83e8$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$409907ccfa1a83e8$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($409907ccfa1a83e8$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$409907ccfa1a83e8$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($409907ccfa1a83e8$var$assert === undefined) $409907ccfa1a83e8$var$assert = (parcelRequire("fomfP"));
    $409907ccfa1a83e8$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$409907ccfa1a83e8$export$e45cb6485273080e = $409907ccfa1a83e8$var$codes;

});
parcelRegister("ibOwR", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $2fFJv = parcelRequire("2fFJv");
var $d3e0731ae145e11c$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $d3e0731ae145e11c$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$d3e0731ae145e11c$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($d3e0731ae145e11c$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($d3e0731ae145e11c$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($d3e0731ae145e11c$var$isNull(x) || !$d3e0731ae145e11c$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $d3e0731ae145e11c$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $2fFJv !== 'undefined' && $2fFJv.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $2fFJv === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($2fFJv.throwDeprecation) throw new Error(msg);
            else if ($2fFJv.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $d3e0731ae145e11c$var$debugs = {};
var $d3e0731ae145e11c$var$debugEnvRegex = /^$/;
var $d3e0731ae145e11c$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$d3e0731ae145e11c$var$debugs[set]) {
        if ($d3e0731ae145e11c$var$debugEnvRegex.test(set)) {
            var pid = $2fFJv.pid;
            $d3e0731ae145e11c$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $d3e0731ae145e11c$var$debugs[set] = function() {};
    }
    return $d3e0731ae145e11c$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $d3e0731ae145e11c$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $d3e0731ae145e11c$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($d3e0731ae145e11c$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($d3e0731ae145e11c$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($d3e0731ae145e11c$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($d3e0731ae145e11c$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($d3e0731ae145e11c$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $d3e0731ae145e11c$var$stylizeWithColor;
    return $d3e0731ae145e11c$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $d3e0731ae145e11c$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$d3e0731ae145e11c$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$d3e0731ae145e11c$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $d3e0731ae145e11c$var$stylizeWithColor(str, styleType) {
    var style = $d3e0731ae145e11c$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $d3e0731ae145e11c$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $d3e0731ae145e11c$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $d3e0731ae145e11c$var$stylizeNoColor(str, styleType) {
    return str;
}
function $d3e0731ae145e11c$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $d3e0731ae145e11c$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $d3e0731ae145e11c$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$d3e0731ae145e11c$var$isString(ret)) ret = $d3e0731ae145e11c$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $d3e0731ae145e11c$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $d3e0731ae145e11c$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($d3e0731ae145e11c$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $d3e0731ae145e11c$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($d3e0731ae145e11c$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($d3e0731ae145e11c$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($d3e0731ae145e11c$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($d3e0731ae145e11c$var$isError(value)) return $d3e0731ae145e11c$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($d3e0731ae145e11c$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($d3e0731ae145e11c$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($d3e0731ae145e11c$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($d3e0731ae145e11c$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($d3e0731ae145e11c$var$isError(value)) base = ' ' + $d3e0731ae145e11c$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($d3e0731ae145e11c$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $d3e0731ae145e11c$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $d3e0731ae145e11c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $d3e0731ae145e11c$var$reduceToSingleString(output, base, braces);
}
function $d3e0731ae145e11c$var$formatPrimitive(ctx, value) {
    if ($d3e0731ae145e11c$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($d3e0731ae145e11c$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($d3e0731ae145e11c$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($d3e0731ae145e11c$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($d3e0731ae145e11c$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $d3e0731ae145e11c$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $d3e0731ae145e11c$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($d3e0731ae145e11c$var$hasOwnProperty(value, String(i))) output.push($d3e0731ae145e11c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($d3e0731ae145e11c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $d3e0731ae145e11c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$d3e0731ae145e11c$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($d3e0731ae145e11c$var$isNull(recurseTimes)) str = $d3e0731ae145e11c$var$formatValue(ctx, desc.value, null);
            else str = $d3e0731ae145e11c$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($d3e0731ae145e11c$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $d3e0731ae145e11c$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("jpjK2"));
function $d3e0731ae145e11c$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $d3e0731ae145e11c$var$isArray;
function $d3e0731ae145e11c$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $d3e0731ae145e11c$var$isBoolean;
function $d3e0731ae145e11c$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $d3e0731ae145e11c$var$isNull;
function $d3e0731ae145e11c$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $d3e0731ae145e11c$var$isNullOrUndefined;
function $d3e0731ae145e11c$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $d3e0731ae145e11c$var$isNumber;
function $d3e0731ae145e11c$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $d3e0731ae145e11c$var$isString;
function $d3e0731ae145e11c$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $d3e0731ae145e11c$var$isSymbol;
function $d3e0731ae145e11c$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $d3e0731ae145e11c$var$isUndefined;
function $d3e0731ae145e11c$var$isRegExp(re) {
    return $d3e0731ae145e11c$var$isObject(re) && $d3e0731ae145e11c$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $d3e0731ae145e11c$var$isRegExp;
module.exports.types.isRegExp = $d3e0731ae145e11c$var$isRegExp;
function $d3e0731ae145e11c$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $d3e0731ae145e11c$var$isObject;
function $d3e0731ae145e11c$var$isDate(d) {
    return $d3e0731ae145e11c$var$isObject(d) && $d3e0731ae145e11c$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $d3e0731ae145e11c$var$isDate;
module.exports.types.isDate = $d3e0731ae145e11c$var$isDate;
function $d3e0731ae145e11c$var$isError(e) {
    return $d3e0731ae145e11c$var$isObject(e) && ($d3e0731ae145e11c$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $d3e0731ae145e11c$var$isError;
module.exports.types.isNativeError = $d3e0731ae145e11c$var$isError;
function $d3e0731ae145e11c$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $d3e0731ae145e11c$var$isFunction;
function $d3e0731ae145e11c$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $d3e0731ae145e11c$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("fDPIL"));
function $d3e0731ae145e11c$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $d3e0731ae145e11c$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $d3e0731ae145e11c$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $d3e0731ae145e11c$var$timestamp() {
    var d = new Date();
    var time = [
        $d3e0731ae145e11c$var$pad(d.getHours()),
        $d3e0731ae145e11c$var$pad(d.getMinutes()),
        $d3e0731ae145e11c$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $d3e0731ae145e11c$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $d3e0731ae145e11c$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("lyUaN"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$d3e0731ae145e11c$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $d3e0731ae145e11c$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $d3e0731ae145e11c$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($d3e0731ae145e11c$var$kCustomPromisifiedSymbol && original[$d3e0731ae145e11c$var$kCustomPromisifiedSymbol]) {
        var fn = original[$d3e0731ae145e11c$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $d3e0731ae145e11c$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($d3e0731ae145e11c$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $d3e0731ae145e11c$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $d3e0731ae145e11c$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $d3e0731ae145e11c$var$kCustomPromisifiedSymbol;
function $d3e0731ae145e11c$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $d3e0731ae145e11c$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $2fFJv.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $2fFJv.nextTick($d3e0731ae145e11c$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $d3e0731ae145e11c$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $d3e0731ae145e11c$var$callbackify;

});
parcelRegister("jpjK2", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $9fDHT = parcelRequire("9fDHT");

var $e77t3 = parcelRequire("e77t3");

var $btMNR = parcelRequire("btMNR");

var $kQIcs = parcelRequire("kQIcs");
function $e20faa668af53337$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $e20faa668af53337$var$BigIntSupported = typeof BigInt !== 'undefined';
var $e20faa668af53337$var$SymbolSupported = typeof Symbol !== 'undefined';
var $e20faa668af53337$var$ObjectToString = $e20faa668af53337$var$uncurryThis(Object.prototype.toString);
var $e20faa668af53337$var$numberValue = $e20faa668af53337$var$uncurryThis(Number.prototype.valueOf);
var $e20faa668af53337$var$stringValue = $e20faa668af53337$var$uncurryThis(String.prototype.valueOf);
var $e20faa668af53337$var$booleanValue = $e20faa668af53337$var$uncurryThis(Boolean.prototype.valueOf);
if ($e20faa668af53337$var$BigIntSupported) var $e20faa668af53337$var$bigIntValue = $e20faa668af53337$var$uncurryThis(BigInt.prototype.valueOf);
if ($e20faa668af53337$var$SymbolSupported) var $e20faa668af53337$var$symbolValue = $e20faa668af53337$var$uncurryThis(Symbol.prototype.valueOf);
function $e20faa668af53337$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $9fDHT;
module.exports.isGeneratorFunction = $e77t3;
module.exports.isTypedArray = $kQIcs;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $e20faa668af53337$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $e20faa668af53337$var$isPromise;
function $e20faa668af53337$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $kQIcs(value) || $e20faa668af53337$var$isDataView(value);
}
module.exports.isArrayBufferView = $e20faa668af53337$var$isArrayBufferView;
function $e20faa668af53337$var$isUint8Array(value) {
    return $btMNR(value) === 'Uint8Array';
}
module.exports.isUint8Array = $e20faa668af53337$var$isUint8Array;
function $e20faa668af53337$var$isUint8ClampedArray(value) {
    return $btMNR(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $e20faa668af53337$var$isUint8ClampedArray;
function $e20faa668af53337$var$isUint16Array(value) {
    return $btMNR(value) === 'Uint16Array';
}
module.exports.isUint16Array = $e20faa668af53337$var$isUint16Array;
function $e20faa668af53337$var$isUint32Array(value) {
    return $btMNR(value) === 'Uint32Array';
}
module.exports.isUint32Array = $e20faa668af53337$var$isUint32Array;
function $e20faa668af53337$var$isInt8Array(value) {
    return $btMNR(value) === 'Int8Array';
}
module.exports.isInt8Array = $e20faa668af53337$var$isInt8Array;
function $e20faa668af53337$var$isInt16Array(value) {
    return $btMNR(value) === 'Int16Array';
}
module.exports.isInt16Array = $e20faa668af53337$var$isInt16Array;
function $e20faa668af53337$var$isInt32Array(value) {
    return $btMNR(value) === 'Int32Array';
}
module.exports.isInt32Array = $e20faa668af53337$var$isInt32Array;
function $e20faa668af53337$var$isFloat32Array(value) {
    return $btMNR(value) === 'Float32Array';
}
module.exports.isFloat32Array = $e20faa668af53337$var$isFloat32Array;
function $e20faa668af53337$var$isFloat64Array(value) {
    return $btMNR(value) === 'Float64Array';
}
module.exports.isFloat64Array = $e20faa668af53337$var$isFloat64Array;
function $e20faa668af53337$var$isBigInt64Array(value) {
    return $btMNR(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $e20faa668af53337$var$isBigInt64Array;
function $e20faa668af53337$var$isBigUint64Array(value) {
    return $btMNR(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $e20faa668af53337$var$isBigUint64Array;
function $e20faa668af53337$var$isMapToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Map]';
}
$e20faa668af53337$var$isMapToString.working = typeof Map !== 'undefined' && $e20faa668af53337$var$isMapToString(new Map());
function $e20faa668af53337$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $e20faa668af53337$var$isMapToString.working ? $e20faa668af53337$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $e20faa668af53337$var$isMap;
function $e20faa668af53337$var$isSetToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Set]';
}
$e20faa668af53337$var$isSetToString.working = typeof Set !== 'undefined' && $e20faa668af53337$var$isSetToString(new Set());
function $e20faa668af53337$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $e20faa668af53337$var$isSetToString.working ? $e20faa668af53337$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $e20faa668af53337$var$isSet;
function $e20faa668af53337$var$isWeakMapToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object WeakMap]';
}
$e20faa668af53337$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $e20faa668af53337$var$isWeakMapToString(new WeakMap());
function $e20faa668af53337$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $e20faa668af53337$var$isWeakMapToString.working ? $e20faa668af53337$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $e20faa668af53337$var$isWeakMap;
function $e20faa668af53337$var$isWeakSetToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object WeakSet]';
}
$e20faa668af53337$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $e20faa668af53337$var$isWeakSetToString(new WeakSet());
function $e20faa668af53337$var$isWeakSet(value) {
    return $e20faa668af53337$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $e20faa668af53337$var$isWeakSet;
function $e20faa668af53337$var$isArrayBufferToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$e20faa668af53337$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $e20faa668af53337$var$isArrayBufferToString(new ArrayBuffer());
function $e20faa668af53337$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $e20faa668af53337$var$isArrayBufferToString.working ? $e20faa668af53337$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $e20faa668af53337$var$isArrayBuffer;
function $e20faa668af53337$var$isDataViewToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object DataView]';
}
$e20faa668af53337$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $e20faa668af53337$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $e20faa668af53337$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $e20faa668af53337$var$isDataViewToString.working ? $e20faa668af53337$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $e20faa668af53337$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $e20faa668af53337$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $e20faa668af53337$var$isSharedArrayBufferToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $e20faa668af53337$var$isSharedArrayBuffer(value) {
    if (typeof $e20faa668af53337$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $e20faa668af53337$var$isSharedArrayBufferToString.working === 'undefined') $e20faa668af53337$var$isSharedArrayBufferToString.working = $e20faa668af53337$var$isSharedArrayBufferToString(new $e20faa668af53337$var$SharedArrayBufferCopy());
    return $e20faa668af53337$var$isSharedArrayBufferToString.working ? $e20faa668af53337$var$isSharedArrayBufferToString(value) : value instanceof $e20faa668af53337$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $e20faa668af53337$var$isSharedArrayBuffer;
function $e20faa668af53337$var$isAsyncFunction(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $e20faa668af53337$var$isAsyncFunction;
function $e20faa668af53337$var$isMapIterator(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $e20faa668af53337$var$isMapIterator;
function $e20faa668af53337$var$isSetIterator(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $e20faa668af53337$var$isSetIterator;
function $e20faa668af53337$var$isGeneratorObject(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $e20faa668af53337$var$isGeneratorObject;
function $e20faa668af53337$var$isWebAssemblyCompiledModule(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $e20faa668af53337$var$isWebAssemblyCompiledModule;
function $e20faa668af53337$var$isNumberObject(value) {
    return $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$numberValue);
}
module.exports.isNumberObject = $e20faa668af53337$var$isNumberObject;
function $e20faa668af53337$var$isStringObject(value) {
    return $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$stringValue);
}
module.exports.isStringObject = $e20faa668af53337$var$isStringObject;
function $e20faa668af53337$var$isBooleanObject(value) {
    return $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$booleanValue);
}
module.exports.isBooleanObject = $e20faa668af53337$var$isBooleanObject;
function $e20faa668af53337$var$isBigIntObject(value) {
    return $e20faa668af53337$var$BigIntSupported && $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$bigIntValue);
}
module.exports.isBigIntObject = $e20faa668af53337$var$isBigIntObject;
function $e20faa668af53337$var$isSymbolObject(value) {
    return $e20faa668af53337$var$SymbolSupported && $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$symbolValue);
}
module.exports.isSymbolObject = $e20faa668af53337$var$isSymbolObject;
function $e20faa668af53337$var$isBoxedPrimitive(value) {
    return $e20faa668af53337$var$isNumberObject(value) || $e20faa668af53337$var$isStringObject(value) || $e20faa668af53337$var$isBooleanObject(value) || $e20faa668af53337$var$isBigIntObject(value) || $e20faa668af53337$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $e20faa668af53337$var$isBoxedPrimitive;
function $e20faa668af53337$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($e20faa668af53337$var$isArrayBuffer(value) || $e20faa668af53337$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $e20faa668af53337$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("9fDHT", function(module, exports) {
'use strict';

var $6bc450c4a7d545b1$var$hasToStringTag = (parcelRequire("6jtVY"))();

var $g94P8 = parcelRequire("g94P8");
var $6bc450c4a7d545b1$var$$toString = $g94P8('Object.prototype.toString');
var $6bc450c4a7d545b1$var$isStandardArguments = function isArguments(value) {
    if ($6bc450c4a7d545b1$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $6bc450c4a7d545b1$var$$toString(value) === '[object Arguments]';
};
var $6bc450c4a7d545b1$var$isLegacyArguments = function isArguments(value) {
    if ($6bc450c4a7d545b1$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $6bc450c4a7d545b1$var$$toString(value) !== '[object Array]' && $6bc450c4a7d545b1$var$$toString(value.callee) === '[object Function]';
};
var $6bc450c4a7d545b1$var$supportsStandardArguments = function() {
    return $6bc450c4a7d545b1$var$isStandardArguments(arguments);
}();
$6bc450c4a7d545b1$var$isStandardArguments.isLegacyArguments = $6bc450c4a7d545b1$var$isLegacyArguments; // for tests
module.exports = $6bc450c4a7d545b1$var$supportsStandardArguments ? $6bc450c4a7d545b1$var$isStandardArguments : $6bc450c4a7d545b1$var$isLegacyArguments;

});
parcelRegister("6jtVY", function(module, exports) {
'use strict';

var $3e6zG = parcelRequire("3e6zG");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $3e6zG() && !!Symbol.toStringTag;
};

});


parcelRegister("e77t3", function(module, exports) {
'use strict';
var $a4678312b9f54a56$var$toStr = Object.prototype.toString;
var $a4678312b9f54a56$var$fnToStr = Function.prototype.toString;
var $a4678312b9f54a56$var$isFnRegex = /^\s*(?:function)?\*/;

var $a4678312b9f54a56$var$hasToStringTag = (parcelRequire("6jtVY"))();
var $a4678312b9f54a56$var$getProto = Object.getPrototypeOf;
var $a4678312b9f54a56$var$getGeneratorFunc = function() {
    if (!$a4678312b9f54a56$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
var $a4678312b9f54a56$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($a4678312b9f54a56$var$isFnRegex.test($a4678312b9f54a56$var$fnToStr.call(fn))) return true;
    if (!$a4678312b9f54a56$var$hasToStringTag) {
        var str = $a4678312b9f54a56$var$toStr.call(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$a4678312b9f54a56$var$getProto) return false;
    if (typeof $a4678312b9f54a56$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $a4678312b9f54a56$var$getGeneratorFunc();
        $a4678312b9f54a56$var$GeneratorFunction = generatorFunc ? $a4678312b9f54a56$var$getProto(generatorFunc) : false;
    }
    return $a4678312b9f54a56$var$getProto(fn) === $a4678312b9f54a56$var$GeneratorFunction;
};

});

parcelRegister("btMNR", function(module, exports) {
'use strict';

var $lUcp2 = parcelRequire("lUcp2");

var $isVN0 = parcelRequire("isVN0");

var $eitbu = parcelRequire("eitbu");

var $g94P8 = parcelRequire("g94P8");

var $aBzvk = parcelRequire("aBzvk");
/** @type {(O: object) => string} */ var $85b8426f3d620737$var$$toString = $g94P8('Object.prototype.toString');

var $85b8426f3d620737$var$hasToStringTag = (parcelRequire("6jtVY"))();
var $85b8426f3d620737$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $85b8426f3d620737$var$typedArrays = $isVN0();
var $85b8426f3d620737$var$$slice = $g94P8('String.prototype.slice');
var $85b8426f3d620737$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $85b8426f3d620737$var$$indexOf = $g94P8('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */ /** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */ var $85b8426f3d620737$var$cache = {
    __proto__: null
};
if ($85b8426f3d620737$var$hasToStringTag && $aBzvk && $85b8426f3d620737$var$getPrototypeOf) $lUcp2($85b8426f3d620737$var$typedArrays, function(typedArray) {
    var arr = new $85b8426f3d620737$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $85b8426f3d620737$var$getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $aBzvk(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $85b8426f3d620737$var$getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $aBzvk(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $85b8426f3d620737$var$cache['$' + typedArray] = $eitbu(descriptor.get);
    }
});
else $lUcp2($85b8426f3d620737$var$typedArrays, function(typedArray) {
    var arr = new $85b8426f3d620737$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    $85b8426f3d620737$var$cache['$' + typedArray] = $eitbu(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $85b8426f3d620737$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $lUcp2(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $85b8426f3d620737$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ('$' + getter(value) === typedArray) found = $85b8426f3d620737$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $85b8426f3d620737$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $lUcp2(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $85b8426f3d620737$var$cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $85b8426f3d620737$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$85b8426f3d620737$var$hasToStringTag) {
        /** @type {string} */ var tag = $85b8426f3d620737$var$$slice($85b8426f3d620737$var$$toString(value), 8, -1);
        if ($85b8426f3d620737$var$$indexOf($85b8426f3d620737$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $85b8426f3d620737$var$trySlices(value);
    }
    if (!$aBzvk) return null;
     // unknown engine
    return $85b8426f3d620737$var$tryTypedArrays(value);
};

});
parcelRegister("lUcp2", function(module, exports) {
'use strict';

var $2GDa0 = parcelRequire("2GDa0");
var $ff2872e50ec13c73$var$toStr = Object.prototype.toString;
var $ff2872e50ec13c73$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $ff2872e50ec13c73$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($ff2872e50ec13c73$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $ff2872e50ec13c73$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $ff2872e50ec13c73$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($ff2872e50ec13c73$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $ff2872e50ec13c73$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$2GDa0(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($ff2872e50ec13c73$var$toStr.call(list) === '[object Array]') $ff2872e50ec13c73$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $ff2872e50ec13c73$var$forEachString(list, iterator, receiver);
    else $ff2872e50ec13c73$var$forEachObject(list, iterator, receiver);
};
module.exports = $ff2872e50ec13c73$var$forEach;

});
parcelRegister("2GDa0", function(module, exports) {
'use strict';
var $1f4de171721c0f5b$var$fnToStr = Function.prototype.toString;
var $1f4de171721c0f5b$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $1f4de171721c0f5b$var$badArrayLike;
var $1f4de171721c0f5b$var$isCallableMarker;
if (typeof $1f4de171721c0f5b$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $1f4de171721c0f5b$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $1f4de171721c0f5b$var$isCallableMarker;
        }
    });
    $1f4de171721c0f5b$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $1f4de171721c0f5b$var$reflectApply(function() {
        throw 42;
    }, null, $1f4de171721c0f5b$var$badArrayLike);
} catch (_) {
    if (_ !== $1f4de171721c0f5b$var$isCallableMarker) $1f4de171721c0f5b$var$reflectApply = null;
}
else $1f4de171721c0f5b$var$reflectApply = null;
var $1f4de171721c0f5b$var$constructorRegex = /^\s*class\b/;
var $1f4de171721c0f5b$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $1f4de171721c0f5b$var$fnToStr.call(value);
        return $1f4de171721c0f5b$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $1f4de171721c0f5b$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($1f4de171721c0f5b$var$isES6ClassFn(value)) return false;
        $1f4de171721c0f5b$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $1f4de171721c0f5b$var$toStr = Object.prototype.toString;
var $1f4de171721c0f5b$var$objectClass = '[object Object]';
var $1f4de171721c0f5b$var$fnClass = '[object Function]';
var $1f4de171721c0f5b$var$genClass = '[object GeneratorFunction]';
var $1f4de171721c0f5b$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $1f4de171721c0f5b$var$ddaClass2 = '[object HTML document.all class]';
var $1f4de171721c0f5b$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $1f4de171721c0f5b$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $1f4de171721c0f5b$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $1f4de171721c0f5b$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $1f4de171721c0f5b$var$all = document.all;
    if ($1f4de171721c0f5b$var$toStr.call($1f4de171721c0f5b$var$all) === $1f4de171721c0f5b$var$toStr.call(document.all)) $1f4de171721c0f5b$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($1f4de171721c0f5b$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $1f4de171721c0f5b$var$toStr.call(value);
            return (str === $1f4de171721c0f5b$var$ddaClass || str === $1f4de171721c0f5b$var$ddaClass2 || str === $1f4de171721c0f5b$var$ddaClass3 // opera 12.16
             || str === $1f4de171721c0f5b$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $1f4de171721c0f5b$var$reflectApply ? function isCallable(value) {
    if ($1f4de171721c0f5b$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $1f4de171721c0f5b$var$reflectApply(value, null, $1f4de171721c0f5b$var$badArrayLike);
    } catch (e) {
        if (e !== $1f4de171721c0f5b$var$isCallableMarker) return false;
    }
    return !$1f4de171721c0f5b$var$isES6ClassFn(value) && $1f4de171721c0f5b$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($1f4de171721c0f5b$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($1f4de171721c0f5b$var$hasToStringTag) return $1f4de171721c0f5b$var$tryFunctionObject(value);
    if ($1f4de171721c0f5b$var$isES6ClassFn(value)) return false;
    var strClass = $1f4de171721c0f5b$var$toStr.call(value);
    if (strClass !== $1f4de171721c0f5b$var$fnClass && strClass !== $1f4de171721c0f5b$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $1f4de171721c0f5b$var$tryFunctionObject(value);
};

});


parcelRegister("isVN0", function(module, exports) {
'use strict';

var $3LhLu = parcelRequire("3LhLu");
var $d717ab4641bd380c$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $3LhLu.length; i++)if (typeof $d717ab4641bd380c$var$g[$3LhLu[i]] === 'function') // @ts-expect-error
    out[out.length] = $3LhLu[i];
    return out;
};

});
parcelRegister("3LhLu", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});



parcelRegister("kQIcs", function(module, exports) {
'use strict';

var $btMNR = parcelRequire("btMNR");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$btMNR(value);
};

});


parcelRegister("fDPIL", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("lyUaN", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRegister("4ZhvB", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $2fFJv = parcelRequire("2fFJv");
'use strict';
function $3a1a70c979998564$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3a1a70c979998564$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3a1a70c979998564$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3a1a70c979998564$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3a1a70c979998564$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3a1a70c979998564$var$_defineProperty(obj, key, value) {
    key = $3a1a70c979998564$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3a1a70c979998564$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3a1a70c979998564$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3a1a70c979998564$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3a1a70c979998564$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3a1a70c979998564$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3a1a70c979998564$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3a1a70c979998564$var$_toPropertyKey(arg) {
    var key = $3a1a70c979998564$var$_toPrimitive(arg, "string");
    return $3a1a70c979998564$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3a1a70c979998564$var$_toPrimitive(input, hint) {
    if ($3a1a70c979998564$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3a1a70c979998564$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $3a1a70c979998564$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3a1a70c979998564$var$_setPrototypeOf(subClass, superClass);
}
function $3a1a70c979998564$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3a1a70c979998564$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3a1a70c979998564$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3a1a70c979998564$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3a1a70c979998564$var$_possibleConstructorReturn(this, result);
    };
}
function $3a1a70c979998564$var$_possibleConstructorReturn(self, call) {
    if (call && ($3a1a70c979998564$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3a1a70c979998564$var$_assertThisInitialized(self);
}
function $3a1a70c979998564$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3a1a70c979998564$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $3a1a70c979998564$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$3a1a70c979998564$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $3a1a70c979998564$var$_construct(Class, arguments, $3a1a70c979998564$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $3a1a70c979998564$var$_setPrototypeOf(Wrapper, Class);
    };
    return $3a1a70c979998564$var$_wrapNativeSuper(Class);
}
function $3a1a70c979998564$var$_construct(Parent, args, Class) {
    if ($3a1a70c979998564$var$_isNativeReflectConstruct()) $3a1a70c979998564$var$_construct = Reflect.construct.bind();
    else $3a1a70c979998564$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $3a1a70c979998564$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $3a1a70c979998564$var$_construct.apply(null, arguments);
}
function $3a1a70c979998564$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3a1a70c979998564$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $3a1a70c979998564$var$_setPrototypeOf(o, p) {
    $3a1a70c979998564$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3a1a70c979998564$var$_setPrototypeOf(o, p);
}
function $3a1a70c979998564$var$_getPrototypeOf(o) {
    $3a1a70c979998564$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3a1a70c979998564$var$_getPrototypeOf(o);
}
function $3a1a70c979998564$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3a1a70c979998564$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3a1a70c979998564$var$_typeof(o);
}

var $ibOwR = parcelRequire("ibOwR");
var $3a1a70c979998564$var$inspect = $ibOwR.inspect;

var $5xQQM = parcelRequire("5xQQM");
var $3a1a70c979998564$var$ERR_INVALID_ARG_TYPE = $5xQQM.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $3a1a70c979998564$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $3a1a70c979998564$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $3a1a70c979998564$var$blue = '';
var $3a1a70c979998564$var$green = '';
var $3a1a70c979998564$var$red = '';
var $3a1a70c979998564$var$white = '';
var $3a1a70c979998564$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $3a1a70c979998564$var$kMaxShortLength = 10;
function $3a1a70c979998564$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $3a1a70c979998564$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $3a1a70c979998564$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $3a1a70c979998564$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $3a1a70c979998564$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $3a1a70c979998564$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $3a1a70c979998564$var$_typeof(actual) === 'object' && $3a1a70c979998564$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $3a1a70c979998564$var$kMaxShortLength) {
            if (($3a1a70c979998564$var$_typeof(actual) !== 'object' || actual === null) && ($3a1a70c979998564$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($3a1a70c979998564$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $2fFJv.stderr && $2fFJv.stderr.isTTY ? $2fFJv.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($3a1a70c979998564$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($3a1a70c979998564$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $3a1a70c979998564$var$kReadableOperator[operator] + "\n".concat($3a1a70c979998564$var$green, "+ actual").concat($3a1a70c979998564$var$white, " ").concat($3a1a70c979998564$var$red, "- expected").concat($3a1a70c979998564$var$white);
    var skippedMsg = " ".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($3a1a70c979998564$var$red, "-").concat($3a1a70c979998564$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($3a1a70c979998564$var$green, "+").concat($3a1a70c979998564$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$3a1a70c979998564$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $3a1a70c979998564$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($3a1a70c979998564$var$green, "+").concat($3a1a70c979998564$var$white, " ").concat(actualLine);
                other += "\n".concat($3a1a70c979998564$var$red, "-").concat($3a1a70c979998564$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white).concat(other, "\n") + "".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $3a1a70c979998564$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $3a1a70c979998564$var$_inherits(AssertionError, _Error);
    var _super = $3a1a70c979998564$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $3a1a70c979998564$var$_classCallCheck(this, AssertionError);
        if ($3a1a70c979998564$var$_typeof(options) !== 'object' || options === null) throw new $3a1a70c979998564$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($2fFJv.stderr && $2fFJv.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($2fFJv.stderr && $2fFJv.stderr.getColorDepth && $2fFJv.stderr.getColorDepth() !== 1) {
                    $3a1a70c979998564$var$blue = "\x1B[34m";
                    $3a1a70c979998564$var$green = "\x1B[32m";
                    $3a1a70c979998564$var$white = "\x1B[39m";
                    $3a1a70c979998564$var$red = "\x1B[31m";
                } else {
                    $3a1a70c979998564$var$blue = '';
                    $3a1a70c979998564$var$green = '';
                    $3a1a70c979998564$var$white = '';
                    $3a1a70c979998564$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($3a1a70c979998564$var$_typeof(actual) === 'object' && actual !== null && $3a1a70c979998564$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $3a1a70c979998564$var$copyError(actual);
                expected = $3a1a70c979998564$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $3a1a70c979998564$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $3a1a70c979998564$var$kReadableOperator[operator];
                var res = $3a1a70c979998564$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $3a1a70c979998564$var$_typeof(actual) === 'object' && actual !== null) base = $3a1a70c979998564$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $3a1a70c979998564$var$inspectValue(actual);
                var other = '';
                var knownOperators = $3a1a70c979998564$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($3a1a70c979998564$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($3a1a70c979998564$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($3a1a70c979998564$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($3a1a70c979998564$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $3a1a70c979998564$var$_possibleConstructorReturn(_this);
    }
    $3a1a70c979998564$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $3a1a70c979998564$var$inspect(this, $3a1a70c979998564$var$_objectSpread($3a1a70c979998564$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $3a1a70c979998564$var$_wrapNativeSuper(Error), $3a1a70c979998564$var$inspect.custom);
module.exports = $3a1a70c979998564$var$AssertionError;

});

parcelRegister("5Nqsj", function(module, exports) {
'use strict';

var $k8FtN = parcelRequire("k8FtN");
var $43860ce23fee442b$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $43860ce23fee442b$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $k8FtN;
    if ($43860ce23fee442b$var$lacksProperEnumerationOrder()) return $k8FtN;
    if ($43860ce23fee442b$var$assignHasPendingExceptions()) return $k8FtN;
    return Object.assign;
};

});
parcelRegister("k8FtN", function(module, exports) {
'use strict';

var $4jDQV = parcelRequire("4jDQV");

var $ea94bafcb8dd6915$var$hasSymbols = (parcelRequire("3e6zG"))();

var $g94P8 = parcelRequire("g94P8");
var $ea94bafcb8dd6915$var$toObject = Object;
var $ea94bafcb8dd6915$var$$push = $g94P8('Array.prototype.push');
var $ea94bafcb8dd6915$var$$propIsEnumerable = $g94P8('Object.prototype.propertyIsEnumerable');
var $ea94bafcb8dd6915$var$originalGetSymbols = $ea94bafcb8dd6915$var$hasSymbols ? Object.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $ea94bafcb8dd6915$var$toObject(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $ea94bafcb8dd6915$var$toObject(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $4jDQV(from);
        var getSymbols = $ea94bafcb8dd6915$var$hasSymbols && (Object.getOwnPropertySymbols || $ea94bafcb8dd6915$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($ea94bafcb8dd6915$var$$propIsEnumerable(from, key)) $ea94bafcb8dd6915$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($ea94bafcb8dd6915$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("4jDQV", function(module, exports) {
'use strict';
var $3247d9b061104208$var$slice = Array.prototype.slice;

var $96nTn = parcelRequire("96nTn");
var $3247d9b061104208$var$origKeys = Object.keys;

var $3247d9b061104208$var$keysShim = $3247d9b061104208$var$origKeys ? function keys(o) {
    return $3247d9b061104208$var$origKeys(o);
} : (parcelRequire("a7WlO"));
var $3247d9b061104208$var$originalKeys = Object.keys;
$3247d9b061104208$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($96nTn(object)) return $3247d9b061104208$var$originalKeys($3247d9b061104208$var$slice.call(object));
            return $3247d9b061104208$var$originalKeys(object);
        };
    } else Object.keys = $3247d9b061104208$var$keysShim;
    return Object.keys || $3247d9b061104208$var$keysShim;
};
module.exports = $3247d9b061104208$var$keysShim;

});
parcelRegister("96nTn", function(module, exports) {
'use strict';
var $6a0735185fec05e3$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $6a0735185fec05e3$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $6a0735185fec05e3$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("a7WlO", function(module, exports) {
'use strict';
var $75f7d21b7a735a78$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $75f7d21b7a735a78$var$has = Object.prototype.hasOwnProperty;
    var $75f7d21b7a735a78$var$toStr = Object.prototype.toString;
    var $75f7d21b7a735a78$var$isArgs = (parcelRequire("96nTn")); // eslint-disable-line global-require
    var $75f7d21b7a735a78$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $75f7d21b7a735a78$var$hasDontEnumBug = !$75f7d21b7a735a78$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $75f7d21b7a735a78$var$hasProtoEnumBug = $75f7d21b7a735a78$var$isEnumerable.call(function() {}, 'prototype');
    var $75f7d21b7a735a78$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $75f7d21b7a735a78$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $75f7d21b7a735a78$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $75f7d21b7a735a78$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$75f7d21b7a735a78$var$excludedKeys['$' + k] && $75f7d21b7a735a78$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $75f7d21b7a735a78$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $75f7d21b7a735a78$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$75f7d21b7a735a78$var$hasAutomationEqualityBug) return $75f7d21b7a735a78$var$equalsConstructorPrototype(o);
        try {
            return $75f7d21b7a735a78$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $75f7d21b7a735a78$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $75f7d21b7a735a78$var$toStr.call(object) === '[object Function]';
        var isArguments = $75f7d21b7a735a78$var$isArgs(object);
        var isString = isObject && $75f7d21b7a735a78$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $75f7d21b7a735a78$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$75f7d21b7a735a78$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $75f7d21b7a735a78$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($75f7d21b7a735a78$var$hasDontEnumBug) {
            var skipConstructor = $75f7d21b7a735a78$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $75f7d21b7a735a78$var$dontEnums.length; ++k)if (!(skipConstructor && $75f7d21b7a735a78$var$dontEnums[k] === 'constructor') && $75f7d21b7a735a78$var$has.call(object, $75f7d21b7a735a78$var$dontEnums[k])) theKeys.push($75f7d21b7a735a78$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $75f7d21b7a735a78$var$keysShim;

});




parcelRegister("c4ycW", function(module, exports) {
'use strict';

var $dAjEz = parcelRequire("dAjEz");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $dAjEz;
};

});
parcelRegister("dAjEz", function(module, exports) {
'use strict';
var $9e3de1e5d12e41fc$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($9e3de1e5d12e41fc$var$numberIsNaN(a) && $9e3de1e5d12e41fc$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("55ouo", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $3b406a6c1a6d91fb$var$_slicedToArray(arr, i) {
    return $3b406a6c1a6d91fb$var$_arrayWithHoles(arr) || $3b406a6c1a6d91fb$var$_iterableToArrayLimit(arr, i) || $3b406a6c1a6d91fb$var$_unsupportedIterableToArray(arr, i) || $3b406a6c1a6d91fb$var$_nonIterableRest();
}
function $3b406a6c1a6d91fb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3b406a6c1a6d91fb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3b406a6c1a6d91fb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3b406a6c1a6d91fb$var$_arrayLikeToArray(o, minLen);
}
function $3b406a6c1a6d91fb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3b406a6c1a6d91fb$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3b406a6c1a6d91fb$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3b406a6c1a6d91fb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3b406a6c1a6d91fb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3b406a6c1a6d91fb$var$_typeof(o);
}
var $3b406a6c1a6d91fb$var$regexFlagsSupported = /a/g.flags !== undefined;
var $3b406a6c1a6d91fb$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $3b406a6c1a6d91fb$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $3b406a6c1a6d91fb$var$objectIs = Object.is ? Object.is : (parcelRequire("4BFNJ"));
var $3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $3b406a6c1a6d91fb$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("djuuL"));
function $3b406a6c1a6d91fb$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $3b406a6c1a6d91fb$var$hasOwnProperty = $3b406a6c1a6d91fb$var$uncurryThis(Object.prototype.hasOwnProperty);
var $3b406a6c1a6d91fb$var$propertyIsEnumerable = $3b406a6c1a6d91fb$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $3b406a6c1a6d91fb$var$objectToString = $3b406a6c1a6d91fb$var$uncurryThis(Object.prototype.toString);

var $ibOwR = parcelRequire("ibOwR");
var $3b406a6c1a6d91fb$require$_require$types = $ibOwR.types;
var $3b406a6c1a6d91fb$var$isAnyArrayBuffer = $3b406a6c1a6d91fb$require$_require$types.isAnyArrayBuffer, $3b406a6c1a6d91fb$var$isArrayBufferView = $3b406a6c1a6d91fb$require$_require$types.isArrayBufferView, $3b406a6c1a6d91fb$var$isDate = $3b406a6c1a6d91fb$require$_require$types.isDate, $3b406a6c1a6d91fb$var$isMap = $3b406a6c1a6d91fb$require$_require$types.isMap, $3b406a6c1a6d91fb$var$isRegExp = $3b406a6c1a6d91fb$require$_require$types.isRegExp, $3b406a6c1a6d91fb$var$isSet = $3b406a6c1a6d91fb$require$_require$types.isSet, $3b406a6c1a6d91fb$var$isNativeError = $3b406a6c1a6d91fb$require$_require$types.isNativeError, $3b406a6c1a6d91fb$var$isBoxedPrimitive = $3b406a6c1a6d91fb$require$_require$types.isBoxedPrimitive, $3b406a6c1a6d91fb$var$isNumberObject = $3b406a6c1a6d91fb$require$_require$types.isNumberObject, $3b406a6c1a6d91fb$var$isStringObject = $3b406a6c1a6d91fb$require$_require$types.isStringObject, $3b406a6c1a6d91fb$var$isBooleanObject = $3b406a6c1a6d91fb$require$_require$types.isBooleanObject, $3b406a6c1a6d91fb$var$isBigIntObject = $3b406a6c1a6d91fb$require$_require$types.isBigIntObject, $3b406a6c1a6d91fb$var$isSymbolObject = $3b406a6c1a6d91fb$require$_require$types.isSymbolObject, $3b406a6c1a6d91fb$var$isFloat32Array = $3b406a6c1a6d91fb$require$_require$types.isFloat32Array, $3b406a6c1a6d91fb$var$isFloat64Array = $3b406a6c1a6d91fb$require$_require$types.isFloat64Array;
function $3b406a6c1a6d91fb$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($3b406a6c1a6d91fb$var$isNonIndex).concat($3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $3b406a6c1a6d91fb$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE = undefined;
var $3b406a6c1a6d91fb$var$kStrict = true;
var $3b406a6c1a6d91fb$var$kLoose = false;
var $3b406a6c1a6d91fb$var$kNoIterator = 0;
var $3b406a6c1a6d91fb$var$kIsArray = 1;
var $3b406a6c1a6d91fb$var$kIsSet = 2;
var $3b406a6c1a6d91fb$var$kIsMap = 3;
// Check if they have the same source and flags
function $3b406a6c1a6d91fb$var$areSimilarRegExps(a, b) {
    return $3b406a6c1a6d91fb$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $3b406a6c1a6d91fb$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $3b406a6c1a6d91fb$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $3b406a6c1a6d91fb$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $3b406a6c1a6d91fb$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $3b406a6c1a6d91fb$var$isEqualBoxedPrimitive(val1, val2) {
    if ($3b406a6c1a6d91fb$var$isNumberObject(val1)) return $3b406a6c1a6d91fb$var$isNumberObject(val2) && $3b406a6c1a6d91fb$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($3b406a6c1a6d91fb$var$isStringObject(val1)) return $3b406a6c1a6d91fb$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($3b406a6c1a6d91fb$var$isBooleanObject(val1)) return $3b406a6c1a6d91fb$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($3b406a6c1a6d91fb$var$isBigIntObject(val1)) return $3b406a6c1a6d91fb$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $3b406a6c1a6d91fb$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $3b406a6c1a6d91fb$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $3b406a6c1a6d91fb$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($3b406a6c1a6d91fb$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $3b406a6c1a6d91fb$var$numberIsNaN(val1) && $3b406a6c1a6d91fb$var$numberIsNaN(val2);
        if ($3b406a6c1a6d91fb$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $3b406a6c1a6d91fb$var$_typeof(val1) !== 'object') {
            if (val2 === null || $3b406a6c1a6d91fb$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $3b406a6c1a6d91fb$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $3b406a6c1a6d91fb$var$objectToString(val1);
    var val2Tag = $3b406a6c1a6d91fb$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(val1, $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE);
        var keys2 = $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(val2, $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$3b406a6c1a6d91fb$var$isMap(val1) && $3b406a6c1a6d91fb$var$isMap(val2) || !$3b406a6c1a6d91fb$var$isSet(val1) && $3b406a6c1a6d91fb$var$isSet(val2)) return false;
    }
    if ($3b406a6c1a6d91fb$var$isDate(val1)) {
        if (!$3b406a6c1a6d91fb$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($3b406a6c1a6d91fb$var$isRegExp(val1)) {
        if (!$3b406a6c1a6d91fb$var$isRegExp(val2) || !$3b406a6c1a6d91fb$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($3b406a6c1a6d91fb$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($3b406a6c1a6d91fb$var$isArrayBufferView(val1)) {
        if (!strict && ($3b406a6c1a6d91fb$var$isFloat32Array(val1) || $3b406a6c1a6d91fb$var$isFloat64Array(val1))) {
            if (!$3b406a6c1a6d91fb$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$3b406a6c1a6d91fb$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(val1, $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE);
        var _keys2 = $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(val2, $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kNoIterator, _keys);
    } else if ($3b406a6c1a6d91fb$var$isSet(val1)) {
        if (!$3b406a6c1a6d91fb$var$isSet(val2) || val1.size !== val2.size) return false;
        return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kIsSet);
    } else if ($3b406a6c1a6d91fb$var$isMap(val1)) {
        if (!$3b406a6c1a6d91fb$var$isMap(val2) || val1.size !== val2.size) return false;
        return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kIsMap);
    } else if ($3b406a6c1a6d91fb$var$isAnyArrayBuffer(val1)) {
        if (!$3b406a6c1a6d91fb$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($3b406a6c1a6d91fb$var$isBoxedPrimitive(val1) && !$3b406a6c1a6d91fb$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kNoIterator);
}
function $3b406a6c1a6d91fb$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $3b406a6c1a6d91fb$var$propertyIsEnumerable(val, k);
    });
}
function $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$3b406a6c1a6d91fb$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($3b406a6c1a6d91fb$var$propertyIsEnumerable(val1, key)) {
                    if (!$3b406a6c1a6d91fb$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($3b406a6c1a6d91fb$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $3b406a6c1a6d91fb$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $3b406a6c1a6d91fb$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $3b406a6c1a6d91fb$var$kNoIterator || iterationType === $3b406a6c1a6d91fb$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $3b406a6c1a6d91fb$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $3b406a6c1a6d91fb$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $3b406a6c1a6d91fb$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($3b406a6c1a6d91fb$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $3b406a6c1a6d91fb$var$findLooseMatchingPrimitives(prim) {
    switch($3b406a6c1a6d91fb$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($3b406a6c1a6d91fb$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $3b406a6c1a6d91fb$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $3b406a6c1a6d91fb$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $3b406a6c1a6d91fb$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$3b406a6c1a6d91fb$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $3b406a6c1a6d91fb$var$innerDeepEqual(item, curB, false, memo);
}
function $3b406a6c1a6d91fb$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $3b406a6c1a6d91fb$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($3b406a6c1a6d91fb$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$3b406a6c1a6d91fb$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $3b406a6c1a6d91fb$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($3b406a6c1a6d91fb$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$3b406a6c1a6d91fb$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$3b406a6c1a6d91fb$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $3b406a6c1a6d91fb$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($3b406a6c1a6d91fb$var$innerDeepEqual(key1, key2, strict, memo) && $3b406a6c1a6d91fb$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $3b406a6c1a6d91fb$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $3b406a6c1a6d91fb$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $3b406a6c1a6d91fb$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($3b406a6c1a6d91fb$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$3b406a6c1a6d91fb$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$3b406a6c1a6d91fb$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $3b406a6c1a6d91fb$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $3b406a6c1a6d91fb$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($3b406a6c1a6d91fb$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$3b406a6c1a6d91fb$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$3b406a6c1a6d91fb$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$3b406a6c1a6d91fb$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $3b406a6c1a6d91fb$var$kIsSet) {
        if (!$3b406a6c1a6d91fb$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $3b406a6c1a6d91fb$var$kIsMap) {
        if (!$3b406a6c1a6d91fb$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $3b406a6c1a6d91fb$var$kIsArray) for(; i < a.length; i++){
        if ($3b406a6c1a6d91fb$var$hasOwnProperty(a, i)) {
            if (!$3b406a6c1a6d91fb$var$hasOwnProperty(b, i) || !$3b406a6c1a6d91fb$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($3b406a6c1a6d91fb$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$3b406a6c1a6d91fb$var$hasOwnProperty(b, key) || !$3b406a6c1a6d91fb$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$3b406a6c1a6d91fb$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$isDeepEqual(val1, val2) {
    return $3b406a6c1a6d91fb$var$innerDeepEqual(val1, val2, $3b406a6c1a6d91fb$var$kLoose);
}
function $3b406a6c1a6d91fb$var$isDeepStrictEqual(val1, val2) {
    return $3b406a6c1a6d91fb$var$innerDeepEqual(val1, val2, $3b406a6c1a6d91fb$var$kStrict);
}
module.exports = {
    isDeepEqual: $3b406a6c1a6d91fb$var$isDeepEqual,
    isDeepStrictEqual: $3b406a6c1a6d91fb$var$isDeepStrictEqual
};

});
parcelRegister("4BFNJ", function(module, exports) {
'use strict';

var $7DUGk = parcelRequire("7DUGk");

var $eitbu = parcelRequire("eitbu");

var $dAjEz = parcelRequire("dAjEz");

var $c4ycW = parcelRequire("c4ycW");

var $29zXl = parcelRequire("29zXl");
var $35ab0af6f8ad58df$var$polyfill = $eitbu($c4ycW(), Object);
$7DUGk($35ab0af6f8ad58df$var$polyfill, {
    getPolyfill: $c4ycW,
    implementation: $dAjEz,
    shim: $29zXl
});
module.exports = $35ab0af6f8ad58df$var$polyfill;

});
parcelRegister("7DUGk", function(module, exports) {
'use strict';

var $4jDQV = parcelRequire("4jDQV");
var $590824c046b6e009$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $590824c046b6e009$var$toStr = Object.prototype.toString;
var $590824c046b6e009$var$concat = Array.prototype.concat;

var $cCdl2 = parcelRequire("cCdl2");
var $590824c046b6e009$var$isFunction = function(fn) {
    return typeof fn === 'function' && $590824c046b6e009$var$toStr.call(fn) === '[object Function]';
};

var $590824c046b6e009$var$supportsDescriptors = (parcelRequire("kjsHT"))();
var $590824c046b6e009$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$590824c046b6e009$var$isFunction(predicate) || !predicate()) return;
    }
    if ($590824c046b6e009$var$supportsDescriptors) $cCdl2(object, name, value, true);
    else $cCdl2(object, name, value);
};
var $590824c046b6e009$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $4jDQV(map);
    if ($590824c046b6e009$var$hasSymbols) props = $590824c046b6e009$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$590824c046b6e009$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$590824c046b6e009$var$defineProperties.supportsDescriptors = !!$590824c046b6e009$var$supportsDescriptors;
module.exports = $590824c046b6e009$var$defineProperties;

});

parcelRegister("29zXl", function(module, exports) {
'use strict';

var $c4ycW = parcelRequire("c4ycW");

var $7DUGk = parcelRequire("7DUGk");
module.exports = function shimObjectIs() {
    var polyfill = $c4ycW();
    $7DUGk(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("djuuL", function(module, exports) {
'use strict';

var $eitbu = parcelRequire("eitbu");

var $7DUGk = parcelRequire("7DUGk");

var $9NVyy = parcelRequire("9NVyy");

var $klO7B = parcelRequire("klO7B");

var $4dQLh = parcelRequire("4dQLh");
var $9b14b4694a770524$var$polyfill = $eitbu($klO7B(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $7DUGk($9b14b4694a770524$var$polyfill, {
    getPolyfill: $klO7B,
    implementation: $9NVyy,
    shim: $4dQLh
});
module.exports = $9b14b4694a770524$var$polyfill;

});
parcelRegister("9NVyy", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("klO7B", function(module, exports) {
'use strict';

var $9NVyy = parcelRequire("9NVyy");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $9NVyy;
};

});

parcelRegister("4dQLh", function(module, exports) {
'use strict';

var $7DUGk = parcelRequire("7DUGk");

var $klO7B = parcelRequire("klO7B");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $klO7B();
    $7DUGk(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("aN41m", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SuppressWarnings = module.exports.Override = module.exports.Nullable = module.exports.NotNull = void 0;
function $7db19978462a2871$var$NotNull(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.NotNull = $7db19978462a2871$var$NotNull;
function $7db19978462a2871$var$Nullable(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.Nullable = $7db19978462a2871$var$Nullable;
function $7db19978462a2871$var$Override(target, propertyKey, propertyDescriptor) {
// do something with 'target' ...
}
module.exports.Override = $7db19978462a2871$var$Override;
function $7db19978462a2871$var$SuppressWarnings(options) {
    return (target, propertyKey, descriptor)=>{
    // intentionally empty
    };
}
module.exports.SuppressWarnings = $7db19978462a2871$var$SuppressWarnings;

});

parcelRegister("ldi9e", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntStream = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.6934376-07:00
var $f718e3b116f54f2a$var$IntStream;
(function(IntStream) {
    /**
     * The value returned by {@link #LA LA()} when the end of the stream is
     * reached.
     */ IntStream.EOF = -1;
    /**
     * The value returned by {@link #getSourceName} when the actual name of the
     * underlying source is not known.
     */ IntStream.UNKNOWN_SOURCE_NAME = "<unknown>";
})($f718e3b116f54f2a$var$IntStream = module.exports.IntStream || (module.exports.IntStream = {}));

});


parcelRegister("csTA1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9133369c31e91133$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BailErrorStrategy = void 0;

var $3HZil = parcelRequire("3HZil");

var $5jZSY = parcelRequire("5jZSY");

var $aN41m = parcelRequire("aN41m");

var $hXb5J = parcelRequire("hXb5J");
/**
 * This implementation of {@link ANTLRErrorStrategy} responds to syntax errors
 * by immediately canceling the parse operation with a
 * {@link ParseCancellationException}. The implementation ensures that the
 * {@link ParserRuleContext#exception} field is set for all parse tree nodes
 * that were not completed prior to encountering the error.
 *
 * This error strategy is useful in the following scenarios.
 *
 * * **Two-stage parsing:** This error strategy allows the first
 *   stage of two-stage parsing to immediately terminate if an error is
 *   encountered, and immediately fall back to the second stage. In addition to
 *   avoiding wasted work by attempting to recover from errors here, the empty
 *   implementation of {@link BailErrorStrategy#sync} improves the performance of
 *   the first stage.
 * * **Silent validation:** When syntax errors are not being
 *   reported or logged, and the parse result is simply ignored if errors occur,
 *   the {@link BailErrorStrategy} avoids wasting work on recovering from errors
 *   when the result will be ignored either way.
 *
 * ```
 * myparser.errorHandler = new BailErrorStrategy();
 * ```
 *
 * @see Parser.errorHandler
 */ class $9133369c31e91133$var$BailErrorStrategy extends $3HZil.DefaultErrorStrategy {
    /** Instead of recovering from exception `e`, re-throw it wrapped
     *  in a {@link ParseCancellationException} so it is not caught by the
     *  rule function catches.  Use {@link Exception#getCause()} to get the
     *  original {@link RecognitionException}.
     */ recover(recognizer, e) {
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $hXb5J.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover inline; if the parser
     *  successfully recovers, it won't throw an exception.
     */ recoverInline(recognizer) {
        let e = new $5jZSY.InputMismatchException(recognizer);
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $hXb5J.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover from problems in subrules. */ sync(recognizer) {
    // intentionally empty
    }
}
$9133369c31e91133$var$__decorate([
    $aN41m.Override
], $9133369c31e91133$var$BailErrorStrategy.prototype, "recover", null);
$9133369c31e91133$var$__decorate([
    $aN41m.Override
], $9133369c31e91133$var$BailErrorStrategy.prototype, "recoverInline", null);
$9133369c31e91133$var$__decorate([
    $aN41m.Override
], $9133369c31e91133$var$BailErrorStrategy.prototype, "sync", null);
module.exports.BailErrorStrategy = $9133369c31e91133$var$BailErrorStrategy;

});
parcelRegister("3HZil", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2b34ef24d781854a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2b34ef24d781854a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultErrorStrategy = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $2quiJ = parcelRequire("2quiJ");

var $5jZSY = parcelRequire("5jZSY");

var $6kdz0 = parcelRequire("6kdz0");

var $iAlWg = parcelRequire("iAlWg");

var $jaUCz = parcelRequire("jaUCz");

var $eKXi4 = parcelRequire("eKXi4");

var $aN41m = parcelRequire("aN41m");
/**
 * This is the default implementation of {@link ANTLRErrorStrategy} used for
 * error reporting and recovery in ANTLR parsers.
 */ class $2b34ef24d781854a$var$DefaultErrorStrategy {
    constructor(){
        /**
         * Indicates whether the error strategy is currently "recovering from an
         * error". This is used to suppress reporting multiple error messages while
         * attempting to recover from a detected syntax error.
         *
         * @see #inErrorRecoveryMode
         */ this.errorRecoveryMode = false;
        /** The index into the input stream where the last error occurred.
         * 	This is used to prevent infinite loops where an error is found
         *  but no token is consumed during recovery...another error is found,
         *  ad nauseum.  This is a failsafe mechanism to guarantee that at least
         *  one token/tree node is consumed for two errors.
         */ this.lastErrorIndex = -1;
        /**
         * @see #nextTokensContext
         */ this.nextTokensState = $dv9vN.ATNState.INVALID_STATE_NUMBER;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition} to
     * ensure that the handler is not in error recovery mode.
     */ reset(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * This method is called to enter error recovery mode when a recognition
     * exception is reported.
     *
     * @param recognizer the parser instance
     */ beginErrorCondition(recognizer) {
        this.errorRecoveryMode = true;
    }
    /**
     * {@inheritDoc}
     */ inErrorRecoveryMode(recognizer) {
        return this.errorRecoveryMode;
    }
    /**
     * This method is called to leave error recovery mode after recovering from
     * a recognition exception.
     *
     * @param recognizer
     */ endErrorCondition(recognizer) {
        this.errorRecoveryMode = false;
        this.lastErrorStates = undefined;
        this.lastErrorIndex = -1;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition}.
     */ reportMatch(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation returns immediately if the handler is already
     * in error recovery mode. Otherwise, it calls {@link #beginErrorCondition}
     * and dispatches the reporting task based on the runtime type of `e`
     * according to the following table.
     *
     * * {@link NoViableAltException}: Dispatches the call to
     *   {@link #reportNoViableAlternative}
     * * {@link InputMismatchException}: Dispatches the call to
     *   {@link #reportInputMismatch}
     * * {@link FailedPredicateException}: Dispatches the call to
     *   {@link #reportFailedPredicate}
     * * All other types: calls {@link Parser#notifyErrorListeners} to report
     *   the exception
     */ reportError(recognizer, e) {
        // if we've already reported an error and have not matched a token
        // yet successfully, don't report any errors.
        if (this.inErrorRecoveryMode(recognizer)) //			System.err.print("[SPURIOUS] ");
        return; // don't report spurious errors
        this.beginErrorCondition(recognizer);
        if (e instanceof $iAlWg.NoViableAltException) this.reportNoViableAlternative(recognizer, e);
        else if (e instanceof $5jZSY.InputMismatchException) this.reportInputMismatch(recognizer, e);
        else if (e instanceof $2quiJ.FailedPredicateException) this.reportFailedPredicate(recognizer, e);
        else {
            console.error(`unknown recognition error type: ${e}`);
            this.notifyErrorListeners(recognizer, e.toString(), e);
        }
    }
    notifyErrorListeners(recognizer, message, e) {
        let offendingToken = e.getOffendingToken(recognizer);
        if (offendingToken === undefined) // Pass null to notifyErrorListeners so it in turn calls the error listeners with undefined as the offending
        // token. If we passed undefined, it would instead call the listeners with currentToken from the parser.
        offendingToken = null;
        recognizer.notifyErrorListeners(message, offendingToken, e);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation resynchronizes the parser by consuming tokens
     * until we find one in the resynchronization set--loosely the set of tokens
     * that can follow the current rule.
     */ recover(recognizer, e) {
        //		System.out.println("recover in "+recognizer.getRuleInvocationStack()+
        //						   " index="+recognizer.inputStream.index+
        //						   ", lastErrorIndex="+
        //						   lastErrorIndex+
        //						   ", states="+lastErrorStates);
        if (this.lastErrorIndex === recognizer.inputStream.index && this.lastErrorStates && this.lastErrorStates.contains(recognizer.state)) // uh oh, another error at same token index and previously-visited
        // state in ATN; must be a case where LT(1) is in the recovery
        // token set so nothing got consumed. Consume a single token
        // at least to prevent an infinite loop; this is a failsafe.
        //			System.err.println("seen error condition before index="+
        //							   lastErrorIndex+", states="+lastErrorStates);
        //			System.err.println("FAILSAFE consumes "+recognizer.getTokenNames()[recognizer.inputStream.LA(1)]);
        recognizer.consume();
        this.lastErrorIndex = recognizer.inputStream.index;
        if (!this.lastErrorStates) this.lastErrorStates = new $6kdz0.IntervalSet();
        this.lastErrorStates.add(recognizer.state);
        let followSet = this.getErrorRecoverySet(recognizer);
        this.consumeUntil(recognizer, followSet);
    }
    /**
     * The default implementation of {@link ANTLRErrorStrategy#sync} makes sure
     * that the current lookahead symbol is consistent with what were expecting
     * at this point in the ATN. You can call this anytime but ANTLR only
     * generates code to check before subrules/loops and each iteration.
     *
     * Implements Jim Idle's magic sync mechanism in closures and optional
     * subrules. E.g.,
     *
     * ```antlr
     * a : sync ( stuff sync )* ;
     * sync : {consume to what can follow sync} ;
     * ```
     *
     * At the start of a sub rule upon error, {@link #sync} performs single
     * token deletion, if possible. If it can't do that, it bails on the current
     * rule and uses the default error recovery, which consumes until the
     * resynchronization set of the current rule.
     *
     * If the sub rule is optional (`(...)?`, `(...)*`, or block
     * with an empty alternative), then the expected set includes what follows
     * the subrule.
     *
     * During loop iteration, it consumes until it sees a token that can start a
     * sub rule or what follows loop. Yes, that is pretty aggressive. We opt to
     * stay in the loop as long as possible.
     *
     * **ORIGINS**
     *
     * Previous versions of ANTLR did a poor job of their recovery within loops.
     * A single mismatch token or missing token would force the parser to bail
     * out of the entire rules surrounding the loop. So, for rule
     *
     * ```antlr
     * classDef : 'class' ID '{' member* '}'
     * ```
     *
     * input with an extra token between members would force the parser to
     * consume until it found the next class definition rather than the next
     * member definition of the current class.
     *
     * This functionality cost a little bit of effort because the parser has to
     * compare token set at the start of the loop and at each iteration. If for
     * some reason speed is suffering for you, you can turn off this
     * functionality by simply overriding this method as a blank { }.
     */ sync(recognizer) {
        let s = recognizer.interpreter.atn.states[recognizer.state];
        //		System.err.println("sync @ "+s.stateNumber+"="+s.getClass().getSimpleName());
        // If already recovering, don't try to sync
        if (this.inErrorRecoveryMode(recognizer)) return;
        let tokens = recognizer.inputStream;
        let la = tokens.LA(1);
        // try cheaper subset first; might get lucky. seems to shave a wee bit off
        let nextTokens = recognizer.atn.nextTokens(s);
        if (nextTokens.contains(la)) {
            // We are sure the token matches
            this.nextTokensContext = undefined;
            this.nextTokensState = $dv9vN.ATNState.INVALID_STATE_NUMBER;
            return;
        }
        if (nextTokens.contains($eKXi4.Token.EPSILON)) {
            if (this.nextTokensContext === undefined) {
                // It's possible the next token won't match; information tracked
                // by sync is restricted for performance.
                this.nextTokensContext = recognizer.context;
                this.nextTokensState = recognizer.state;
            }
            return;
        }
        switch(s.stateType){
            case $fZESB.ATNStateType.BLOCK_START:
            case $fZESB.ATNStateType.STAR_BLOCK_START:
            case $fZESB.ATNStateType.PLUS_BLOCK_START:
            case $fZESB.ATNStateType.STAR_LOOP_ENTRY:
                // report error and recover if possible
                if (this.singleTokenDeletion(recognizer)) return;
                throw new $5jZSY.InputMismatchException(recognizer);
            case $fZESB.ATNStateType.PLUS_LOOP_BACK:
            case $fZESB.ATNStateType.STAR_LOOP_BACK:
                //			System.err.println("at loop back: "+s.getClass().getSimpleName());
                this.reportUnwantedToken(recognizer);
                let expecting = recognizer.getExpectedTokens();
                let whatFollowsLoopIterationOrRule = expecting.or(this.getErrorRecoverySet(recognizer));
                this.consumeUntil(recognizer, whatFollowsLoopIterationOrRule);
                break;
            default:
                break;
        }
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link NoViableAltException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportNoViableAlternative(recognizer, e) {
        let tokens = recognizer.inputStream;
        let input;
        if (tokens) {
            if (e.startToken.type === $eKXi4.Token.EOF) input = "<EOF>";
            else input = tokens.getTextFromRange(e.startToken, e.getOffendingToken());
        } else input = "<unknown input>";
        let msg = "no viable alternative at input " + this.escapeWSAndQuote(input);
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is an
     * {@link InputMismatchException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportInputMismatch(recognizer, e) {
        let expected = e.expectedTokens;
        let expectedString = expected ? expected.toStringVocabulary(recognizer.vocabulary) : "";
        let msg = "mismatched input " + this.getTokenErrorDisplay(e.getOffendingToken(recognizer)) + " expecting " + expectedString;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link FailedPredicateException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportFailedPredicate(recognizer, e) {
        let ruleName = recognizer.ruleNames[recognizer.context.ruleIndex];
        let msg = "rule " + ruleName + " " + e.message;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This method is called to report a syntax error which requires the removal
     * of a token from the input stream. At the time this method is called, the
     * erroneous symbol is current `LT(1)` symbol and has not yet been
     * removed from the input stream. When this method returns,
     * `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenDeletion} identifies
     * single-token deletion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportUnwantedToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let tokenName = this.getTokenErrorDisplay(t);
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "extraneous input " + tokenName + " expecting " + expecting.toStringVocabulary(recognizer.vocabulary);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * This method is called to report a syntax error which requires the
     * insertion of a missing token into the input stream. At the time this
     * method is called, the missing token has not yet been inserted. When this
     * method returns, `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenInsertion} identifies
     * single-token insertion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportMissingToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "missing " + expecting.toStringVocabulary(recognizer.vocabulary) + " at " + this.getTokenErrorDisplay(t);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation attempts to recover from the mismatched input
     * by using single token insertion and deletion as described below. If the
     * recovery attempt fails, this method
     * {@link InputMismatchException}.
     *
     * **EXTRA TOKEN** (single token deletion)
     *
     * `LA(1)` is not what we are looking for. If `LA(2)` has the
     * right token, however, then assume `LA(1)` is some extra spurious
     * token and delete it. Then consume and return the next token (which was
     * the `LA(2)` token) as the successful result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenDeletion}.
     *
     * **MISSING TOKEN** (single token insertion)
     *
     * If current token (at `LA(1)`) is consistent with what could come
     * after the expected `LA(1)` token, then assume the token is missing
     * and use the parser's {@link TokenFactory} to create it on the fly. The
     * "insertion" is performed by returning the created token as the successful
     * result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenInsertion}.
     *
     * **EXAMPLE**
     *
     * For example, Input `i=(3;` is clearly missing the `')'`. When
     * the parser returns from the nested call to `expr`, it will have
     * call chain:
     *
     * ```
     * stat → expr → atom
     * ```
     *
     * and it will be trying to match the `')'` at this point in the
     * derivation:
     *
     * ```
     * => ID '=' '(' INT ')' ('+' atom)* ';'
     *                    ^
     * ```
     *
     * The attempt to match `')'` will fail when it sees `';'` and
     * call {@link #recoverInline}. To recover, it sees that `LA(1)==';'`
     * is in the set of tokens that can follow the `')'` token reference
     * in rule `atom`. It can assume that you forgot the `')'`.
     */ recoverInline(recognizer) {
        // SINGLE TOKEN DELETION
        let matchedSymbol = this.singleTokenDeletion(recognizer);
        if (matchedSymbol) {
            // we have deleted the extra token.
            // now, move past ttype token as if all were ok
            recognizer.consume();
            return matchedSymbol;
        }
        // SINGLE TOKEN INSERTION
        if (this.singleTokenInsertion(recognizer)) return this.getMissingSymbol(recognizer);
        // even that didn't work; must throw the exception
        if (this.nextTokensContext === undefined) throw new $5jZSY.InputMismatchException(recognizer);
        else throw new $5jZSY.InputMismatchException(recognizer, this.nextTokensState, this.nextTokensContext);
    }
    /**
     * This method implements the single-token insertion inline error recovery
     * strategy. It is called by {@link #recoverInline} if the single-token
     * deletion strategy fails to recover from the mismatched input. If this
     * method returns `true`, `recognizer` will be in error recovery
     * mode.
     *
     * This method determines whether or not single-token insertion is viable by
     * checking if the `LA(1)` input symbol could be successfully matched
     * if it were instead the `LA(2)` symbol. If this method returns
     * `true`, the caller is responsible for creating and inserting a
     * token with the correct type to produce this behavior.
     *
     * @param recognizer the parser instance
     * @returns `true` if single-token insertion is a viable recovery
     * strategy for the current mismatched input, otherwise `false`
     */ singleTokenInsertion(recognizer) {
        let currentSymbolType = recognizer.inputStream.LA(1);
        // if current token is consistent with what could come after current
        // ATN state, then we know we're missing a token; error recovery
        // is free to conjure up and insert the missing token
        let currentState = recognizer.interpreter.atn.states[recognizer.state];
        let next = currentState.transition(0).target;
        let atn = recognizer.interpreter.atn;
        let expectingAtLL2 = atn.nextTokens(next, $jaUCz.PredictionContext.fromRuleContext(atn, recognizer.context));
        //		console.warn("LT(2) set="+expectingAtLL2.toString(recognizer.getTokenNames()));
        if (expectingAtLL2.contains(currentSymbolType)) {
            this.reportMissingToken(recognizer);
            return true;
        }
        return false;
    }
    /**
     * This method implements the single-token deletion inline error recovery
     * strategy. It is called by {@link #recoverInline} to attempt to recover
     * from mismatched input. If this method returns `undefined`, the parser and error
     * handler state will not have changed. If this method returns non-`undefined`,
     * `recognizer` will *not* be in error recovery mode since the
     * returned token was a successful match.
     *
     * If the single-token deletion is successful, this method calls
     * {@link #reportUnwantedToken} to report the error, followed by
     * {@link Parser#consume} to actually "delete" the extraneous token. Then,
     * before returning {@link #reportMatch} is called to signal a successful
     * match.
     *
     * @param recognizer the parser instance
     * @returns the successfully matched {@link Token} instance if single-token
     * deletion successfully recovers from the mismatched input, otherwise
     * `undefined`
     */ singleTokenDeletion(recognizer) {
        let nextTokenType = recognizer.inputStream.LA(2);
        let expecting = this.getExpectedTokens(recognizer);
        if (expecting.contains(nextTokenType)) {
            this.reportUnwantedToken(recognizer);
            /*
            System.err.println("recoverFromMismatchedToken deleting "+
                               ((TokenStream)recognizer.inputStream).LT(1)+
                               " since "+((TokenStream)recognizer.inputStream).LT(2)+
                               " is what we want");
            */ recognizer.consume(); // simply delete extra token
            // we want to return the token we're actually matching
            let matchedSymbol = recognizer.currentToken;
            this.reportMatch(recognizer); // we know current token is correct
            return matchedSymbol;
        }
        return undefined;
    }
    /** Conjure up a missing token during error recovery.
     *
     *  The recognizer attempts to recover from single missing
     *  symbols. But, actions might refer to that missing symbol.
     *  For example, x=ID {f($x);}. The action clearly assumes
     *  that there has been an identifier matched previously and that
     *  $x points at that token. If that token is missing, but
     *  the next token in the stream is what we want we assume that
     *  this token is missing and we keep going. Because we
     *  have to return some token to replace the missing token,
     *  we have to conjure one up. This method gives the user control
     *  over the tokens returned for missing tokens. Mostly,
     *  you will want to create something special for identifier
     *  tokens. For literals such as '{' and ',', the default
     *  action in the parser or tree parser works. It simply creates
     *  a CommonToken of the appropriate type. The text will be the token.
     *  If you change what tokens must be created by the lexer,
     *  override this method to create the appropriate tokens.
     */ getMissingSymbol(recognizer) {
        let currentSymbol = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let expectedTokenType = $eKXi4.Token.INVALID_TYPE;
        if (!expecting.isNil) // get any element
        expectedTokenType = expecting.minElement;
        let tokenText;
        if (expectedTokenType === $eKXi4.Token.EOF) tokenText = "<missing EOF>";
        else tokenText = "<missing " + recognizer.vocabulary.getDisplayName(expectedTokenType) + ">";
        let current = currentSymbol;
        let lookback = recognizer.inputStream.tryLT(-1);
        if (current.type === $eKXi4.Token.EOF && lookback != null) current = lookback;
        return this.constructToken(recognizer.inputStream.tokenSource, expectedTokenType, tokenText, current);
    }
    constructToken(tokenSource, expectedTokenType, tokenText, current) {
        let factory = tokenSource.tokenFactory;
        let x = current.tokenSource;
        let stream = x ? x.inputStream : undefined;
        return factory.create({
            source: tokenSource,
            stream: stream
        }, expectedTokenType, tokenText, $eKXi4.Token.DEFAULT_CHANNEL, -1, -1, current.line, current.charPositionInLine);
    }
    getExpectedTokens(recognizer) {
        return recognizer.getExpectedTokens();
    }
    /** How should a token be displayed in an error message? The default
     *  is to display just the text, but during development you might
     *  want to have a lot of information spit out.  Override in that case
     *  to use t.toString() (which, for CommonToken, dumps everything about
     *  the token). This is better than forcing you to override a method in
     *  your token objects because you don't have to go modify your lexer
     *  so that it creates a new Java type.
     */ getTokenErrorDisplay(t) {
        if (!t) return "<no token>";
        let s = this.getSymbolText(t);
        if (!s) {
            if (this.getSymbolType(t) === $eKXi4.Token.EOF) s = "<EOF>";
            else s = `<${this.getSymbolType(t)}>`;
        }
        return this.escapeWSAndQuote(s);
    }
    getSymbolText(symbol) {
        return symbol.text;
    }
    getSymbolType(symbol) {
        return symbol.type;
    }
    escapeWSAndQuote(s) {
        //		if ( s==null ) return s;
        s = s.replace("\n", "\\n");
        s = s.replace("\r", "\\r");
        s = s.replace("\t", "\\t");
        return "'" + s + "'";
    }
    /*  Compute the error recovery set for the current rule.  During
     *  rule invocation, the parser pushes the set of tokens that can
     *  follow that rule reference on the stack; this amounts to
     *  computing FIRST of what follows the rule reference in the
     *  enclosing rule. See LinearApproximator.FIRST().
     *  This local follow set only includes tokens
     *  from within the rule; i.e., the FIRST computation done by
     *  ANTLR stops at the end of a rule.
     *
     *  EXAMPLE
     *
     *  When you find a "no viable alt exception", the input is not
     *  consistent with any of the alternatives for rule r.  The best
     *  thing to do is to consume tokens until you see something that
     *  can legally follow a call to r *or* any rule that called r.
     *  You don't want the exact set of viable next tokens because the
     *  input might just be missing a token--you might consume the
     *  rest of the input looking for one of the missing tokens.
     *
     *  Consider grammar:
     *
     *  a : '[' b ']'
     *    | '(' b ')'
     *    ;
     *  b : c '^' INT ;
     *  c : ID
     *    | INT
     *    ;
     *
     *  At each rule invocation, the set of tokens that could follow
     *  that rule is pushed on a stack.  Here are the various
     *  context-sensitive follow sets:
     *
     *  FOLLOW(b1_in_a) = FIRST(']') = ']'
     *  FOLLOW(b2_in_a) = FIRST(')') = ')'
     *  FOLLOW(c_in_b) = FIRST('^') = '^'
     *
     *  Upon erroneous input "[]", the call chain is
     *
     *  a -> b -> c
     *
     *  and, hence, the follow context stack is:
     *
     *  depth     follow set       start of rule execution
     *    0         <EOF>                    a (from main())
     *    1          ']'                     b
     *    2          '^'                     c
     *
     *  Notice that ')' is not included, because b would have to have
     *  been called from a different context in rule a for ')' to be
     *  included.
     *
     *  For error recovery, we cannot consider FOLLOW(c)
     *  (context-sensitive or otherwise).  We need the combined set of
     *  all context-sensitive FOLLOW sets--the set of all tokens that
     *  could follow any reference in the call chain.  We need to
     *  resync to one of those tokens.  Note that FOLLOW(c)='^' and if
     *  we resync'd to that token, we'd consume until EOF.  We need to
     *  sync to context-sensitive FOLLOWs for a, b, and c: {']','^'}.
     *  In this case, for input "[]", LA(1) is ']' and in the set, so we would
     *  not consume anything. After printing an error, rule c would
     *  return normally.  Rule b would not find the required '^' though.
     *  At this point, it gets a mismatched token error and
     *  exception (since LA(1) is not in the viable following token
     *  set).  The rule exception handler tries to recover, but finds
     *  the same recovery set and doesn't consume anything.  Rule b
     *  exits normally returning to rule a.  Now it finds the ']' (and
     *  with the successful match exits errorRecovery mode).
     *
     *  So, you can see that the parser walks up the call chain looking
     *  for the token that was a member of the recovery set.
     *
     *  Errors are not generated in errorRecovery mode.
     *
     *  ANTLR's error recovery mechanism is based upon original ideas:
     *
     *  "Algorithms + Data Structures = Programs" by Niklaus Wirth
     *
     *  and
     *
     *  "A note on error recovery in recursive descent parsers":
     *  http://portal.acm.org/citation.cfm?id=947902.947905
     *
     *  Later, Josef Grosch had some good ideas:
     *
     *  "Efficient and Comfortable Error Recovery in Recursive Descent
     *  Parsers":
     *  ftp://www.cocolab.com/products/cocktail/doca4.ps/ell.ps.zip
     *
     *  Like Grosch I implement context-sensitive FOLLOW sets that are combined
     *  at run-time upon error to avoid overhead during parsing.
     */ getErrorRecoverySet(recognizer) {
        let atn = recognizer.interpreter.atn;
        let ctx = recognizer.context;
        let recoverSet = new $6kdz0.IntervalSet();
        while(ctx && ctx.invokingState >= 0){
            // compute what follows who invoked us
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            let follow = atn.nextTokens(rt.followState);
            recoverSet.addAll(follow);
            ctx = ctx._parent;
        }
        recoverSet.remove($eKXi4.Token.EPSILON);
        //		System.out.println("recover set "+recoverSet.toString(recognizer.getTokenNames()));
        return recoverSet;
    }
    /** Consume tokens until one matches the given token set. */ consumeUntil(recognizer, set) {
        //		System.err.println("consumeUntil("+set.toString(recognizer.getTokenNames())+")");
        let ttype = recognizer.inputStream.LA(1);
        while(ttype !== $eKXi4.Token.EOF && !set.contains(ttype)){
            //System.out.println("consume during recover LA(1)="+getTokenNames()[input.LA(1)]);
            //			recognizer.inputStream.consume();
            recognizer.consume();
            ttype = recognizer.inputStream.LA(1);
        }
    }
}
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reset", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "beginErrorCondition", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "inErrorRecoveryMode", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "endErrorCondition", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportMatch", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportError", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "notifyErrorListeners", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "recover", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "sync", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull),
    $2b34ef24d781854a$var$__param(1, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportNoViableAlternative", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull),
    $2b34ef24d781854a$var$__param(1, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportInputMismatch", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull),
    $2b34ef24d781854a$var$__param(1, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportFailedPredicate", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportUnwantedToken", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportMissingToken", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "recoverInline", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "singleTokenInsertion", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "singleTokenDeletion", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.NotNull,
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "getMissingSymbol", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.NotNull,
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "getExpectedTokens", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "getSymbolText", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "getSymbolType", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.NotNull,
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "escapeWSAndQuote", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.NotNull,
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "getErrorRecoverySet", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull),
    $2b34ef24d781854a$var$__param(1, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "consumeUntil", null);
module.exports.DefaultErrorStrategy = $2b34ef24d781854a$var$DefaultErrorStrategy;

});
parcelRegister("dv9vN", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9d458c7a5aa2e8f5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNState = void 0;

var $aN41m = parcelRequire("aN41m");
const $9d458c7a5aa2e8f5$var$INITIAL_NUM_TRANSITIONS = 4;
/**
 * The following images show the relation of states and
 * {@link ATNState#transitions} for various grammar constructs.
 *
 * * Solid edges marked with an &#0949; indicate a required
 *   {@link EpsilonTransition}.
 *
 * * Dashed edges indicate locations where any transition derived from
 *   {@link Transition} might appear.
 *
 * * Dashed nodes are place holders for either a sequence of linked
 *   {@link BasicState} states or the inclusion of a block representing a nested
 *   construct in one of the forms below.
 *
 * * Nodes showing multiple outgoing alternatives with a `...` support
 *   any number of alternatives (one or more). Nodes without the `...` only
 *   support the exact number of alternatives shown in the diagram.
 *
 * <h2>Basic Blocks</h2>
 *
 * <h3>Rule</h3>
 *
 * <embed src="images/Rule.svg" type="image/svg+xml"/>
 *
 * <h3>Block of 1 or more alternatives</h3>
 *
 * <embed src="images/Block.svg" type="image/svg+xml"/>
 *
 * <h2>Greedy Loops</h2>
 *
 * <h3>Greedy Closure: `(...)*`</h3>
 *
 * <embed src="images/ClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Positive Closure: `(...)+`</h3>
 *
 * <embed src="images/PositiveClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Optional: `(...)?`</h3>
 *
 * <embed src="images/OptionalGreedy.svg" type="image/svg+xml"/>
 *
 * <h2>Non-Greedy Loops</h2>
 *
 * <h3>Non-Greedy Closure: `(...)*?`</h3>
 *
 * <embed src="images/ClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Positive Closure: `(...)+?`</h3>
 *
 * <embed src="images/PositiveClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Optional: `(...)??`</h3>
 *
 * <embed src="images/OptionalNonGreedy.svg" type="image/svg+xml"/>
 */ class $9d458c7a5aa2e8f5$var$ATNState {
    constructor(){
        this.stateNumber = $9d458c7a5aa2e8f5$var$ATNState.INVALID_STATE_NUMBER;
        this.ruleIndex = 0; // at runtime, we don't have Rule objects
        this.epsilonOnlyTransitions = false;
        /** Track the transitions emanating from this ATN state. */ this.transitions = [];
        this.optimizedTransitions = this.transitions;
    }
    /**
     * Gets the state number.
     *
     * @returns the state number
     */ getStateNumber() {
        return this.stateNumber;
    }
    /**
     * For all states except {@link RuleStopState}, this returns the state
     * number. Returns -1 for stop states.
     *
     * @returns -1 for {@link RuleStopState}, otherwise the state number
     */ get nonStopStateNumber() {
        return this.getStateNumber();
    }
    hashCode() {
        return this.stateNumber;
    }
    equals(o) {
        // are these states same object?
        if (o instanceof $9d458c7a5aa2e8f5$var$ATNState) return this.stateNumber === o.stateNumber;
        return false;
    }
    get isNonGreedyExitState() {
        return false;
    }
    toString() {
        return String(this.stateNumber);
    }
    getTransitions() {
        return this.transitions.slice(0);
    }
    get numberOfTransitions() {
        return this.transitions.length;
    }
    addTransition(e, index) {
        if (this.transitions.length === 0) this.epsilonOnlyTransitions = e.isEpsilon;
        else if (this.epsilonOnlyTransitions !== e.isEpsilon) {
            this.epsilonOnlyTransitions = false;
            throw new Error("ATN state " + this.stateNumber + " has both epsilon and non-epsilon transitions.");
        }
        this.transitions.splice(index !== undefined ? index : this.transitions.length, 0, e);
    }
    transition(i) {
        return this.transitions[i];
    }
    setTransition(i, e) {
        this.transitions[i] = e;
    }
    removeTransition(index) {
        return this.transitions.splice(index, 1)[0];
    }
    get onlyHasEpsilonTransitions() {
        return this.epsilonOnlyTransitions;
    }
    setRuleIndex(ruleIndex) {
        this.ruleIndex = ruleIndex;
    }
    get isOptimized() {
        return this.optimizedTransitions !== this.transitions;
    }
    get numberOfOptimizedTransitions() {
        return this.optimizedTransitions.length;
    }
    getOptimizedTransition(i) {
        return this.optimizedTransitions[i];
    }
    addOptimizedTransition(e) {
        if (!this.isOptimized) this.optimizedTransitions = new Array();
        this.optimizedTransitions.push(e);
    }
    setOptimizedTransition(i, e) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions[i] = e;
    }
    removeOptimizedTransition(i) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions.splice(i, 1);
    }
}
$9d458c7a5aa2e8f5$var$__decorate([
    $aN41m.Override
], $9d458c7a5aa2e8f5$var$ATNState.prototype, "hashCode", null);
$9d458c7a5aa2e8f5$var$__decorate([
    $aN41m.Override
], $9d458c7a5aa2e8f5$var$ATNState.prototype, "equals", null);
$9d458c7a5aa2e8f5$var$__decorate([
    $aN41m.Override
], $9d458c7a5aa2e8f5$var$ATNState.prototype, "toString", null);
module.exports.ATNState = $9d458c7a5aa2e8f5$var$ATNState;
(function(ATNState) {
    ATNState.INVALID_STATE_NUMBER = -1;
})($9d458c7a5aa2e8f5$var$ATNState = module.exports.ATNState || (module.exports.ATNState = {}));

});

parcelRegister("fZESB", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNStateType = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:27.4734328-07:00
var $ba4c43613bc5a0e0$var$ATNStateType;
(function(ATNStateType) {
    ATNStateType[ATNStateType["INVALID_TYPE"] = 0] = "INVALID_TYPE";
    ATNStateType[ATNStateType["BASIC"] = 1] = "BASIC";
    ATNStateType[ATNStateType["RULE_START"] = 2] = "RULE_START";
    ATNStateType[ATNStateType["BLOCK_START"] = 3] = "BLOCK_START";
    ATNStateType[ATNStateType["PLUS_BLOCK_START"] = 4] = "PLUS_BLOCK_START";
    ATNStateType[ATNStateType["STAR_BLOCK_START"] = 5] = "STAR_BLOCK_START";
    ATNStateType[ATNStateType["TOKEN_START"] = 6] = "TOKEN_START";
    ATNStateType[ATNStateType["RULE_STOP"] = 7] = "RULE_STOP";
    ATNStateType[ATNStateType["BLOCK_END"] = 8] = "BLOCK_END";
    ATNStateType[ATNStateType["STAR_LOOP_BACK"] = 9] = "STAR_LOOP_BACK";
    ATNStateType[ATNStateType["STAR_LOOP_ENTRY"] = 10] = "STAR_LOOP_ENTRY";
    ATNStateType[ATNStateType["PLUS_LOOP_BACK"] = 11] = "PLUS_LOOP_BACK";
    ATNStateType[ATNStateType["LOOP_END"] = 12] = "LOOP_END";
})($ba4c43613bc5a0e0$var$ATNStateType = module.exports.ATNStateType || (module.exports.ATNStateType = {}));

});

parcelRegister("2quiJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1c4583a876daf8fc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1c4583a876daf8fc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FailedPredicateException = void 0;

var $b7PPe = parcelRequire("b7PPe");

var $aN41m = parcelRequire("aN41m");

var $j3Sey = parcelRequire("j3Sey");
/** A semantic predicate failed during validation.  Validation of predicates
 *  occurs when normally parsing the alternative just like matching a token.
 *  Disambiguating predicate evaluation occurs when we test a predicate during
 *  prediction.
 */ let $1c4583a876daf8fc$var$FailedPredicateException = class FailedPredicateException extends $b7PPe.RecognitionException {
    constructor(recognizer, predicate, message){
        super(recognizer, recognizer.inputStream, recognizer.context, FailedPredicateException.formatMessage(predicate, message));
        let s = recognizer.interpreter.atn.states[recognizer.state];
        let trans = s.transition(0);
        if (trans instanceof $j3Sey.PredicateTransition) {
            this._ruleIndex = trans.ruleIndex;
            this._predicateIndex = trans.predIndex;
        } else {
            this._ruleIndex = 0;
            this._predicateIndex = 0;
        }
        this._predicate = predicate;
        super.setOffendingToken(recognizer, recognizer.currentToken);
    }
    get ruleIndex() {
        return this._ruleIndex;
    }
    get predicateIndex() {
        return this._predicateIndex;
    }
    get predicate() {
        return this._predicate;
    }
    static formatMessage(predicate, message) {
        if (message) return message;
        return `failed predicate: {${predicate}}?`;
    }
};
$1c4583a876daf8fc$var$__decorate([
    $aN41m.NotNull
], $1c4583a876daf8fc$var$FailedPredicateException, "formatMessage", null);
$1c4583a876daf8fc$var$FailedPredicateException = $1c4583a876daf8fc$var$__decorate([
    $1c4583a876daf8fc$var$__param(0, $aN41m.NotNull)
], $1c4583a876daf8fc$var$FailedPredicateException);
module.exports.FailedPredicateException = $1c4583a876daf8fc$var$FailedPredicateException;

});
parcelRegister("b7PPe", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionException = void 0;
/** The root of the ANTLR exception hierarchy. In general, ANTLR tracks just
 *  3 kinds of errors: prediction errors, failed predicate errors, and
 *  mismatched input errors. In each case, the parser knows where it is
 *  in the input, where it is in the ATN, the rule invocation stack,
 *  and what kind of problem occurred.
 */ class $81988c99cb6b26c7$var$RecognitionException extends Error {
    constructor(recognizer, input, ctx, message){
        super(message);
        this._offendingState = -1;
        this._recognizer = recognizer;
        this.input = input;
        this.ctx = ctx;
        if (recognizer) this._offendingState = recognizer.state;
    }
    /**
     * Get the ATN state number the parser was in at the time the error
     * occurred. For {@link NoViableAltException} and
     * {@link LexerNoViableAltException} exceptions, this is the
     * {@link DecisionState} number. For others, it is the state whose outgoing
     * edge we couldn't match.
     *
     * If the state number is not known, this method returns -1.
     */ get offendingState() {
        return this._offendingState;
    }
    setOffendingState(offendingState) {
        this._offendingState = offendingState;
    }
    /**
     * Gets the set of input symbols which could potentially follow the
     * previously matched symbol at the time this exception was thrown.
     *
     * If the set of expected tokens is not known and could not be computed,
     * this method returns `undefined`.
     *
     * @returns The set of token types that could potentially follow the current
     * state in the ATN, or `undefined` if the information is not available.
     */ get expectedTokens() {
        if (this._recognizer) return this._recognizer.atn.getExpectedTokens(this._offendingState, this.ctx);
        return undefined;
    }
    /**
     * Gets the {@link RuleContext} at the time this exception was thrown.
     *
     * If the context is not available, this method returns `undefined`.
     *
     * @returns The {@link RuleContext} at the time this exception was thrown.
     * If the context is not available, this method returns `undefined`.
     */ get context() {
        return this.ctx;
    }
    /**
     * Gets the input stream which is the symbol source for the recognizer where
     * this exception was thrown.
     *
     * If the input stream is not available, this method returns `undefined`.
     *
     * @returns The input stream which is the symbol source for the recognizer
     * where this exception was thrown, or `undefined` if the stream is not
     * available.
     */ get inputStream() {
        return this.input;
    }
    getOffendingToken(recognizer) {
        if (recognizer && recognizer !== this._recognizer) return undefined;
        return this.offendingToken;
    }
    setOffendingToken(recognizer, offendingToken) {
        if (recognizer === this._recognizer) this.offendingToken = offendingToken;
    }
    /**
     * Gets the {@link Recognizer} where this exception occurred.
     *
     * If the recognizer is not available, this method returns `undefined`.
     *
     * @returns The recognizer where this exception occurred, or `undefined` if
     * the recognizer is not available.
     */ get recognizer() {
        return this._recognizer;
    }
}
module.exports.RecognitionException = $81988c99cb6b26c7$var$RecognitionException;

});

parcelRegister("j3Sey", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $de085dd8bf5f9774$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $de085dd8bf5f9774$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredicateTransition = void 0;

var $kvmNv = parcelRequire("kvmNv");

var $aN41m = parcelRequire("aN41m");

var $3JS45 = parcelRequire("3JS45");
/** TODO: this is old comment:
 *  A tree of semantic predicates from the grammar AST if label==SEMPRED.
 *  In the ATN, labels will always be exactly one predicate, but the DFA
 *  may have to combine a bunch of them as it collects predicates from
 *  multiple ATN configurations into a single DFA state.
 */ let $de085dd8bf5f9774$var$PredicateTransition = class PredicateTransition extends $kvmNv.AbstractPredicateTransition {
    constructor(target, ruleIndex, predIndex, isCtxDependent){
        super(target);
        this.ruleIndex = ruleIndex;
        this.predIndex = predIndex;
        this.isCtxDependent = isCtxDependent;
    }
    get serializationType() {
        return 4 /* PREDICATE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $3JS45.SemanticContext.Predicate(this.ruleIndex, this.predIndex, this.isCtxDependent);
    }
    toString() {
        return "pred_" + this.ruleIndex + ":" + this.predIndex;
    }
};
$de085dd8bf5f9774$var$__decorate([
    $aN41m.Override
], $de085dd8bf5f9774$var$PredicateTransition.prototype, "serializationType", null);
$de085dd8bf5f9774$var$__decorate([
    $aN41m.Override
], $de085dd8bf5f9774$var$PredicateTransition.prototype, "isEpsilon", null);
$de085dd8bf5f9774$var$__decorate([
    $aN41m.Override
], $de085dd8bf5f9774$var$PredicateTransition.prototype, "matches", null);
$de085dd8bf5f9774$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $de085dd8bf5f9774$var$PredicateTransition.prototype, "toString", null);
$de085dd8bf5f9774$var$PredicateTransition = $de085dd8bf5f9774$var$__decorate([
    $de085dd8bf5f9774$var$__param(0, $aN41m.NotNull)
], $de085dd8bf5f9774$var$PredicateTransition);
module.exports.PredicateTransition = $de085dd8bf5f9774$var$PredicateTransition;

});
parcelRegister("kvmNv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AbstractPredicateTransition = void 0;

var $5NWCj = parcelRequire("5NWCj");
/**
 *
 * @author Sam Harwell
 */ class $eed8630418e17dbe$var$AbstractPredicateTransition extends $5NWCj.Transition {
    constructor(target){
        super(target);
    }
}
module.exports.AbstractPredicateTransition = $eed8630418e17dbe$var$AbstractPredicateTransition;

});
parcelRegister("5NWCj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $439eff7922051987$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $439eff7922051987$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transition = void 0;

var $aN41m = parcelRequire("aN41m");
/** An ATN transition between any two ATN states.  Subclasses define
 *  atom, set, epsilon, action, predicate, rule transitions.
 *
 *  This is a one way link.  It emanates from a state (usually via a list of
 *  transitions) and has a target state.
 *
 *  Since we never have to change the ATN transitions once we construct it,
 *  we can fix these transitions as specific classes. The DFA transitions
 *  on the other hand need to update the labels as it adds transitions to
 *  the states. We'll use the term Edge for the DFA to distinguish them from
 *  ATN transitions.
 */ let $439eff7922051987$var$Transition = class Transition {
    constructor(target){
        if (target == null) throw new Error("target cannot be null.");
        this.target = target;
    }
    /**
     * Determines if the transition is an "epsilon" transition.
     *
     * The default implementation returns `false`.
     *
     * @returns `true` if traversing this transition in the ATN does not
     * consume an input symbol; otherwise, `false` if traversing this
     * transition consumes (matches) an input symbol.
     */ get isEpsilon() {
        return false;
    }
    get label() {
        return undefined;
    }
};
$439eff7922051987$var$Transition.serializationNames = [
    "INVALID",
    "EPSILON",
    "RANGE",
    "RULE",
    "PREDICATE",
    "ATOM",
    "ACTION",
    "SET",
    "NOT_SET",
    "WILDCARD",
    "PRECEDENCE"
];
$439eff7922051987$var$__decorate([
    $aN41m.NotNull
], $439eff7922051987$var$Transition.prototype, "target", void 0);
$439eff7922051987$var$Transition = $439eff7922051987$var$__decorate([
    $439eff7922051987$var$__param(0, $aN41m.NotNull)
], $439eff7922051987$var$Transition);
module.exports.Transition = $439eff7922051987$var$Transition;

});


parcelRegister("3JS45", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2b8f833777da73eb$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2b8f833777da73eb$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SemanticContext = void 0;

var $fsqYw = parcelRequire("fsqYw");

var $6iIjF = parcelRequire("6iIjF");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");

var $9eW9B = parcelRequire("9eW9B");

var $62Uvn = parcelRequire("62Uvn");
function $2b8f833777da73eb$var$max(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison < 0) result = current;
    }
    return result;
}
function $2b8f833777da73eb$var$min(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison > 0) result = current;
    }
    return result;
}
/** A tree structure used to record the semantic context in which
 *  an ATN configuration is valid.  It's either a single predicate,
 *  a conjunction `p1&&p2`, or a sum of products `p1||p2`.
 *
 *  I have scoped the {@link AND}, {@link OR}, and {@link Predicate} subclasses of
 *  {@link SemanticContext} within the scope of this outer class.
 */ class $2b8f833777da73eb$var$SemanticContext {
    /**
     * The default {@link SemanticContext}, which is semantically equivalent to
     * a predicate of the form `{true}?`.
     */ static get NONE() {
        if ($2b8f833777da73eb$var$SemanticContext._NONE === undefined) $2b8f833777da73eb$var$SemanticContext._NONE = new $2b8f833777da73eb$var$SemanticContext.Predicate();
        return $2b8f833777da73eb$var$SemanticContext._NONE;
    }
    /**
     * Evaluate the precedence predicates for the context and reduce the result.
     *
     * @param parser The parser instance.
     * @param parserCallStack
     * @returns The simplified semantic context after precedence predicates are
     * evaluated, which will be one of the following values.
     *
     * * {@link #NONE}: if the predicate simplifies to `true` after
     *   precedence predicates are evaluated.
     * * `undefined`: if the predicate simplifies to `false` after
     *   precedence predicates are evaluated.
     * * `this`: if the semantic context is not changed as a result of
     *   precedence predicate evaluation.
     * * A non-`undefined` {@link SemanticContext}: the new simplified
     *   semantic context after precedence predicates are evaluated.
     */ evalPrecedence(parser, parserCallStack) {
        return this;
    }
    static and(a, b) {
        if (!a || a === $2b8f833777da73eb$var$SemanticContext.NONE) return b;
        if (b === $2b8f833777da73eb$var$SemanticContext.NONE) return a;
        let result = new $2b8f833777da73eb$var$SemanticContext.AND(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
    /**
     *
     *  @see ParserATNSimulator#getPredsForAmbigAlts
     */ static or(a, b) {
        if (!a) return b;
        if (a === $2b8f833777da73eb$var$SemanticContext.NONE || b === $2b8f833777da73eb$var$SemanticContext.NONE) return $2b8f833777da73eb$var$SemanticContext.NONE;
        let result = new $2b8f833777da73eb$var$SemanticContext.OR(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
}
module.exports.SemanticContext = $2b8f833777da73eb$var$SemanticContext;
(function(SemanticContext) {
    /**
     * This random 30-bit prime represents the value of `AND.class.hashCode()`.
     */ const AND_HASHCODE = 40363613;
    /**
     * This random 30-bit prime represents the value of `OR.class.hashCode()`.
     */ const OR_HASHCODE = 486279973;
    function filterPrecedencePredicates(collection) {
        let result = [];
        for(let i = 0; i < collection.length; i++){
            let context = collection[i];
            if (context instanceof SemanticContext.PrecedencePredicate) {
                result.push(context);
                // Remove the item from 'collection' and move i back so we look at the same index again
                collection.splice(i, 1);
                i--;
            }
        }
        return result;
    }
    class Predicate extends SemanticContext {
        constructor(ruleIndex = -1, predIndex = -1, isCtxDependent = false){
            super();
            this.ruleIndex = ruleIndex;
            this.predIndex = predIndex;
            this.isCtxDependent = isCtxDependent;
        }
        eval(parser, parserCallStack) {
            let localctx = this.isCtxDependent ? parserCallStack : undefined;
            return parser.sempred(localctx, this.ruleIndex, this.predIndex);
        }
        hashCode() {
            let hashCode = $amQx9.MurmurHash.initialize();
            hashCode = $amQx9.MurmurHash.update(hashCode, this.ruleIndex);
            hashCode = $amQx9.MurmurHash.update(hashCode, this.predIndex);
            hashCode = $amQx9.MurmurHash.update(hashCode, this.isCtxDependent ? 1 : 0);
            hashCode = $amQx9.MurmurHash.finish(hashCode, 3);
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof Predicate)) return false;
            if (this === obj) return true;
            return this.ruleIndex === obj.ruleIndex && this.predIndex === obj.predIndex && this.isCtxDependent === obj.isCtxDependent;
        }
        toString() {
            return "{" + this.ruleIndex + ":" + this.predIndex + "}?";
        }
    }
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], Predicate.prototype, "eval", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], Predicate.prototype, "hashCode", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], Predicate.prototype, "equals", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], Predicate.prototype, "toString", null);
    SemanticContext.Predicate = Predicate;
    class PrecedencePredicate extends SemanticContext {
        constructor(precedence){
            super();
            this.precedence = precedence;
        }
        eval(parser, parserCallStack) {
            return parser.precpred(parserCallStack, this.precedence);
        }
        evalPrecedence(parser, parserCallStack) {
            if (parser.precpred(parserCallStack, this.precedence)) return SemanticContext.NONE;
            else return undefined;
        }
        compareTo(o) {
            return this.precedence - o.precedence;
        }
        hashCode() {
            let hashCode = 1;
            hashCode = 31 * hashCode + this.precedence;
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof PrecedencePredicate)) return false;
            if (this === obj) return true;
            return this.precedence === obj.precedence;
        }
        toString() {
            return "{" + this.precedence + ">=prec}?";
        }
    }
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], PrecedencePredicate.prototype, "eval", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], PrecedencePredicate.prototype, "evalPrecedence", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], PrecedencePredicate.prototype, "compareTo", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], PrecedencePredicate.prototype, "hashCode", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], PrecedencePredicate.prototype, "equals", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], PrecedencePredicate.prototype, "toString", null);
    SemanticContext.PrecedencePredicate = PrecedencePredicate;
    /**
     * This is the base class for semantic context "operators", which operate on
     * a collection of semantic context "operands".
     *
     * @since 4.3
     */ class Operator extends SemanticContext {
    }
    SemanticContext.Operator = Operator;
    /**
     * A semantic context which is true whenever none of the contained contexts
     * is false.
     */ let AND = class AND extends Operator {
        constructor(a, b){
            super();
            let operands = new $fsqYw.Array2DHashSet($9eW9B.ObjectEqualityComparator.INSTANCE);
            if (a instanceof AND) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof AND) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the lowest precedence
            let reduced = $2b8f833777da73eb$var$min(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof AND)) return false;
            return $6iIjF.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $amQx9.MurmurHash.hashCode(this.opnds, AND_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (!opnd.eval(parser, parserCallStack)) return false;
            }
            return true;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated == null) // The AND context is false if any element is false
                return undefined;
                else if (evaluated !== SemanticContext.NONE) // Reduce the result by skipping true elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were true, so the AND context is true
            return SemanticContext.NONE;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.and(result, operands[i]);
            return result;
        }
        toString() {
            return $62Uvn.join(this.opnds, "&&");
        }
    };
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], AND.prototype, "operands", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], AND.prototype, "equals", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], AND.prototype, "hashCode", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], AND.prototype, "eval", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], AND.prototype, "evalPrecedence", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], AND.prototype, "toString", null);
    AND = $2b8f833777da73eb$var$__decorate([
        $2b8f833777da73eb$var$__param(0, $aN41m.NotNull),
        $2b8f833777da73eb$var$__param(1, $aN41m.NotNull)
    ], AND);
    SemanticContext.AND = AND;
    /**
     * A semantic context which is true whenever at least one of the contained
     * contexts is true.
     */ let OR = class OR extends Operator {
        constructor(a, b){
            super();
            let operands = new $fsqYw.Array2DHashSet($9eW9B.ObjectEqualityComparator.INSTANCE);
            if (a instanceof OR) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof OR) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the highest precedence
            let reduced = $2b8f833777da73eb$var$max(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof OR)) return false;
            return $6iIjF.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $amQx9.MurmurHash.hashCode(this.opnds, OR_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (opnd.eval(parser, parserCallStack)) return true;
            }
            return false;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated === SemanticContext.NONE) // The OR context is true if any element is true
                return SemanticContext.NONE;
                else if (evaluated) // Reduce the result by skipping false elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were false, so the OR context is false
            return undefined;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.or(result, operands[i]);
            return result;
        }
        toString() {
            return $62Uvn.join(this.opnds, "||");
        }
    };
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], OR.prototype, "operands", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], OR.prototype, "equals", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], OR.prototype, "hashCode", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], OR.prototype, "eval", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], OR.prototype, "evalPrecedence", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], OR.prototype, "toString", null);
    OR = $2b8f833777da73eb$var$__decorate([
        $2b8f833777da73eb$var$__param(0, $aN41m.NotNull),
        $2b8f833777da73eb$var$__param(1, $aN41m.NotNull)
    ], OR);
    SemanticContext.OR = OR;
})($2b8f833777da73eb$var$SemanticContext = module.exports.SemanticContext || (module.exports.SemanticContext = {}));

});
parcelRegister("fsqYw", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b40e65386248425a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b40e65386248425a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashSet = void 0;

var $fomfP = parcelRequire("fomfP");

var $aGZuj = parcelRequire("aGZuj");

var $aN41m = parcelRequire("aN41m");

var $amQx9 = parcelRequire("amQx9");
/** {@link Set} implementation with closed hashing (open addressing). */ // NOTE:  JavaScript's Set interface has on significant different diffrence from Java's:
// 		  e.g. the return type of add() differs!
//        For this reason I've commented tweaked the implements clause
const $b40e65386248425a$var$INITAL_CAPACITY = 16; // must be power of 2
const $b40e65386248425a$var$LOAD_FACTOR = 0.75;
class $b40e65386248425a$var$Array2DHashSet {
    constructor(comparatorOrSet, initialCapacity = $b40e65386248425a$var$INITAL_CAPACITY){
        /** How many elements in set */ this.n = 0;
        this.threshold = Math.floor($b40e65386248425a$var$INITAL_CAPACITY * $b40e65386248425a$var$LOAD_FACTOR); // when to expand
        if (comparatorOrSet instanceof $b40e65386248425a$var$Array2DHashSet) {
            this.comparator = comparatorOrSet.comparator;
            this.buckets = comparatorOrSet.buckets.slice(0);
            for(let i = 0; i < this.buckets.length; i++){
                let bucket = this.buckets[i];
                if (bucket) this.buckets[i] = bucket.slice(0);
            }
            this.n = comparatorOrSet.n;
            this.threshold = comparatorOrSet.threshold;
        } else {
            this.comparator = comparatorOrSet || $aGZuj.DefaultEqualityComparator.INSTANCE;
            this.buckets = this.createBuckets(initialCapacity);
        }
    }
    /**
     * Add `o` to set if not there; return existing value if already
     * there. This method performs the same operation as {@link #add} aside from
     * the return value.
     */ getOrAdd(o) {
        if (this.n > this.threshold) this.expand();
        return this.getOrAddImpl(o);
    }
    getOrAddImpl(o) {
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        // NEW BUCKET
        if (!bucket) {
            bucket = [
                o
            ];
            this.buckets[b] = bucket;
            this.n++;
            return o;
        }
        // LOOK FOR IT IN BUCKET
        for (let existing of bucket){
            if (this.comparator.equals(existing, o)) return existing; // found existing, quit
        }
        // FULL BUCKET, expand and add to end
        bucket.push(o);
        this.n++;
        return o;
    }
    get(o) {
        if (o == null) return o;
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        if (!bucket) // no bucket
        return undefined;
        for (let e of bucket){
            if (this.comparator.equals(e, o)) return e;
        }
        return undefined;
    }
    getBucket(o) {
        let hash = this.comparator.hashCode(o);
        let b = hash & this.buckets.length - 1; // assumes len is power of 2
        return b;
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                hash = $amQx9.MurmurHash.update(hash, this.comparator.hashCode(o));
            }
        }
        hash = $amQx9.MurmurHash.finish(hash, this.size);
        return hash;
    }
    equals(o) {
        if (o === this) return true;
        if (!(o instanceof $b40e65386248425a$var$Array2DHashSet)) return false;
        if (o.size !== this.size) return false;
        let same = this.containsAll(o);
        return same;
    }
    expand() {
        let old = this.buckets;
        let newCapacity = this.buckets.length * 2;
        let newTable = this.createBuckets(newCapacity);
        this.buckets = newTable;
        this.threshold = Math.floor(newCapacity * $b40e65386248425a$var$LOAD_FACTOR);
        //		System.out.println("new size="+newCapacity+", thres="+threshold);
        // rehash all existing entries
        let oldSize = this.size;
        for (let bucket of old){
            if (!bucket) continue;
            for (let o of bucket){
                let b = this.getBucket(o);
                let newBucket = this.buckets[b];
                if (!newBucket) {
                    newBucket = [];
                    this.buckets[b] = newBucket;
                }
                newBucket.push(o);
            }
        }
        $fomfP(this.n === oldSize);
    }
    add(t) {
        let existing = this.getOrAdd(t);
        return existing === t;
    }
    get size() {
        return this.n;
    }
    get isEmpty() {
        return this.n === 0;
    }
    contains(o) {
        return this.containsFast(this.asElementType(o));
    }
    containsFast(obj) {
        if (obj == null) return false;
        return this.get(obj) != null;
    }
    *[Symbol.iterator]() {
        yield* this.toArray();
    }
    toArray() {
        const a = new Array(this.size);
        // Copy elements from the nested arrays into the destination array
        let i = 0; // Position within destination array
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                a[i++] = o;
            }
        }
        return a;
    }
    containsAll(collection) {
        if (collection instanceof $b40e65386248425a$var$Array2DHashSet) {
            let s = collection;
            for (let bucket of s.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    if (!this.containsFast(this.asElementType(o))) return false;
                }
            }
        } else for (let o of collection){
            if (!this.containsFast(this.asElementType(o))) return false;
        }
        return true;
    }
    addAll(c) {
        let changed = false;
        for (let o of c){
            let existing = this.getOrAdd(o);
            if (existing !== o) changed = true;
        }
        return changed;
    }
    clear() {
        this.buckets = this.createBuckets($b40e65386248425a$var$INITAL_CAPACITY);
        this.n = 0;
        this.threshold = Math.floor($b40e65386248425a$var$INITAL_CAPACITY * $b40e65386248425a$var$LOAD_FACTOR);
    }
    toString() {
        if (this.size === 0) return "{}";
        let buf = "{";
        let first = true;
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                if (first) first = false;
                else buf += ", ";
                buf += o.toString();
            }
        }
        buf += "}";
        return buf;
    }
    toTableString() {
        let buf = "";
        for (let bucket of this.buckets){
            if (bucket == null) {
                buf += "null\n";
                continue;
            }
            buf += "[";
            let first = true;
            for (let o of bucket){
                if (first) first = false;
                else buf += " ";
                if (o == null) buf += "_";
                else buf += o.toString();
            }
            buf += "]\n";
        }
        return buf;
    }
    /**
     * Return `o` as an instance of the element type `T`. If
     * `o` is non-undefined but known to not be an instance of `T`, this
     * method returns `undefined`. The base implementation does not perform any
     * type checks; override this method to provide strong type checks for the
     * {@link #contains} and {@link #remove} methods to ensure the arguments to
     * the {@link EqualityComparator} for the set always have the expected
     * types.
     *
     * @param o the object to try and cast to the element type of the set
     * @returns `o` if it could be an instance of `T`, otherwise
     * `undefined`.
     */ asElementType(o) {
        return o;
    }
    /**
     * Return an array of `T[]` with length `capacity`.
     *
     * @param capacity the length of the array to return
     * @returns the newly constructed array
     */ createBuckets(capacity) {
        return new Array(capacity);
    }
}
$b40e65386248425a$var$__decorate([
    $aN41m.NotNull
], $b40e65386248425a$var$Array2DHashSet.prototype, "comparator", void 0);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "hashCode", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "equals", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "add", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "size", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "isEmpty", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "contains", null);
$b40e65386248425a$var$__decorate([
    $b40e65386248425a$var$__param(0, $aN41m.Nullable)
], $b40e65386248425a$var$Array2DHashSet.prototype, "containsFast", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, Symbol.iterator, null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "toArray", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "containsAll", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "addAll", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "clear", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "toString", null);
$b40e65386248425a$var$__decorate([
    $aN41m.SuppressWarnings("unchecked")
], $b40e65386248425a$var$Array2DHashSet.prototype, "asElementType", null);
$b40e65386248425a$var$__decorate([
    $aN41m.SuppressWarnings("unchecked")
], $b40e65386248425a$var$Array2DHashSet.prototype, "createBuckets", null);
module.exports.Array2DHashSet = $b40e65386248425a$var$Array2DHashSet;

});
parcelRegister("aGZuj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7c8d85d29b04f35b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultEqualityComparator = void 0;

var $aN41m = parcelRequire("aN41m");

var $amQx9 = parcelRequire("amQx9");

var $9eW9B = parcelRequire("9eW9B");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $7c8d85d29b04f35b$var$DefaultEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        else if (typeof obj === "string" || typeof obj === "number") return $amQx9.MurmurHash.hashCode([
            obj
        ]);
        else return $9eW9B.ObjectEqualityComparator.INSTANCE.hashCode(obj);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (typeof a === "string" || typeof a === "number") return a === b;
        else return $9eW9B.ObjectEqualityComparator.INSTANCE.equals(a, b);
    }
}
$7c8d85d29b04f35b$var$DefaultEqualityComparator.INSTANCE = new $7c8d85d29b04f35b$var$DefaultEqualityComparator();
$7c8d85d29b04f35b$var$__decorate([
    $aN41m.Override
], $7c8d85d29b04f35b$var$DefaultEqualityComparator.prototype, "hashCode", null);
$7c8d85d29b04f35b$var$__decorate([
    $aN41m.Override
], $7c8d85d29b04f35b$var$DefaultEqualityComparator.prototype, "equals", null);
module.exports.DefaultEqualityComparator = $7c8d85d29b04f35b$var$DefaultEqualityComparator;

});
parcelRegister("amQx9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MurmurHash = void 0;
/**
 *
 * @author Sam Harwell
 */ var $78c4b58c32e2212f$var$MurmurHash;
(function(MurmurHash) {
    const DEFAULT_SEED = 0;
    /**
     * Initialize the hash using the specified `seed`.
     *
     * @param seed the seed (optional)
     * @returns the intermediate hash value
     */ function initialize(seed = DEFAULT_SEED) {
        return seed;
    }
    MurmurHash.initialize = initialize;
    /**
     * Update the intermediate hash value for the next input `value`.
     *
     * @param hash the intermediate hash value
     * @param value the value to add to the current hash
     * @returns the updated intermediate hash value
     */ function update(hash, value) {
        const c1 = 0xCC9E2D51;
        const c2 = 0x1B873593;
        const r1 = 15;
        const r2 = 13;
        const m = 5;
        const n = 0xE6546B64;
        if (value == null) value = 0;
        else if (typeof value === "string") value = hashString(value);
        else if (typeof value === "object") value = value.hashCode();
        let k = value;
        k = Math.imul(k, c1);
        k = k << r1 | k >>> 32 - r1;
        k = Math.imul(k, c2);
        hash = hash ^ k;
        hash = hash << r2 | hash >>> 32 - r2;
        hash = Math.imul(hash, m) + n;
        return hash & 0xFFFFFFFF;
    }
    MurmurHash.update = update;
    /**
     * Apply the final computation steps to the intermediate value `hash`
     * to form the final result of the MurmurHash 3 hash function.
     *
     * @param hash the intermediate hash value
     * @param numberOfWords the number of integer values added to the hash
     * @returns the final hash result
     */ function finish(hash, numberOfWords) {
        hash = hash ^ numberOfWords * 4;
        hash = hash ^ hash >>> 16;
        hash = Math.imul(hash, 0x85EBCA6B);
        hash = hash ^ hash >>> 13;
        hash = Math.imul(hash, 0xC2B2AE35);
        hash = hash ^ hash >>> 16;
        return hash;
    }
    MurmurHash.finish = finish;
    /**
     * Utility function to compute the hash code of an array using the
     * MurmurHash algorithm.
     *
     * @param <T> the array element type
     * @param data the array data
     * @param seed the seed for the MurmurHash algorithm
     * @returns the hash code of the data
     */ function hashCode(data, seed = DEFAULT_SEED) {
        let hash = initialize(seed);
        let length = 0;
        for (let value of data){
            hash = update(hash, value);
            length++;
        }
        hash = finish(hash, length);
        return hash;
    }
    MurmurHash.hashCode = hashCode;
    /**
     * Function to hash a string. Based on the implementation found here:
     * http://stackoverflow.com/a/7616484
     */ function hashString(str) {
        let len = str.length;
        if (len === 0) return 0;
        let hash = 0;
        for(let i = 0; i < len; i++){
            let c = str.charCodeAt(i);
            hash = (hash << 5 >>> 0) - hash + c;
            hash |= 0;
        }
        return hash;
    }
})($78c4b58c32e2212f$var$MurmurHash = module.exports.MurmurHash || (module.exports.MurmurHash = {}));

});

parcelRegister("9eW9B", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6ba288078a70e293$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObjectEqualityComparator = void 0;

var $aN41m = parcelRequire("aN41m");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $6ba288078a70e293$var$ObjectEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return obj.hashCode();
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        return a.equals(b);
    }
}
$6ba288078a70e293$var$ObjectEqualityComparator.INSTANCE = new $6ba288078a70e293$var$ObjectEqualityComparator();
$6ba288078a70e293$var$__decorate([
    $aN41m.Override
], $6ba288078a70e293$var$ObjectEqualityComparator.prototype, "hashCode", null);
$6ba288078a70e293$var$__decorate([
    $aN41m.Override
], $6ba288078a70e293$var$ObjectEqualityComparator.prototype, "equals", null);
module.exports.ObjectEqualityComparator = $6ba288078a70e293$var$ObjectEqualityComparator;

});



parcelRegister("6iIjF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4966cccca723aa26$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrayEqualityComparator = void 0;

var $aN41m = parcelRequire("aN41m");

var $amQx9 = parcelRequire("amQx9");

var $9eW9B = parcelRequire("9eW9B");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $4966cccca723aa26$var$ArrayEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return $amQx9.MurmurHash.hashCode(obj, 0);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined`, this method returns `true`. Otherwise if only
     * `a` is `undefined`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (b == null) return false;
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$9eW9B.ObjectEqualityComparator.INSTANCE.equals(a[i], b[i])) return false;
        }
        return true;
    }
}
$4966cccca723aa26$var$ArrayEqualityComparator.INSTANCE = new $4966cccca723aa26$var$ArrayEqualityComparator();
$4966cccca723aa26$var$__decorate([
    $aN41m.Override
], $4966cccca723aa26$var$ArrayEqualityComparator.prototype, "hashCode", null);
$4966cccca723aa26$var$__decorate([
    $aN41m.Override
], $4966cccca723aa26$var$ArrayEqualityComparator.prototype, "equals", null);
module.exports.ArrayEqualityComparator = $4966cccca723aa26$var$ArrayEqualityComparator;

});

parcelRegister("62Uvn", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toCharArray = module.exports.toMap = module.exports.equals = module.exports.join = module.exports.escapeWhitespace = void 0;
function $466ec2b4a094d7df$var$escapeWhitespace(s, escapeSpaces) {
    return escapeSpaces ? s.replace(/ /, "\u00B7") : s.replace(/\t/, "\\t").replace(/\n/, "\\n").replace(/\r/, "\\r");
}
module.exports.escapeWhitespace = $466ec2b4a094d7df$var$escapeWhitespace;
// Seriously: why isn't this built in to java? ugh!
function $466ec2b4a094d7df$var$join(collection, separator) {
    let buf = "";
    let first = true;
    for (let current of collection){
        if (first) first = false;
        else buf += separator;
        buf += current;
    }
    return buf;
}
module.exports.join = $466ec2b4a094d7df$var$join;
function $466ec2b4a094d7df$var$equals(x, y) {
    if (x === y) return true;
    if (x === undefined || y === undefined) return false;
    return x.equals(y);
}
module.exports.equals = $466ec2b4a094d7df$var$equals;
// export function numNonnull(data: any[]): number {
// 	let n: number =  0;
// 	if ( data == null ) return n;
// 	for (let o of data) {
// 		if ( o!=null ) n++;
// 	}
// 	return n;
// }
// export function removeAllElements<T>(data: Collection<T>, value: T): void {
// 	if ( data==null ) return;
// 	while ( data.contains(value) ) data.remove(value);
// }
// export function writeFile(@NotNull file: File, @NotNull content: Uint8Array): void {
// 	let fos: FileOutputStream = new FileOutputStream(file);
// 	try {
// 		fos.write(content);
// 	} finally {
// 		fos.close();
// 	}
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string): void {
// 	writeFile(fileName, content, null);
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string, @Nullable encoding: string): void {
// 	let f: File =  new File(fileName);
// 	let fos: FileOutputStream =  new FileOutputStream(f);
// 	let osw: OutputStreamWriter;
// 	if (encoding != null) {
// 		osw = new OutputStreamWriter(fos, encoding);
// 	}
// 	else {
// 		osw = new OutputStreamWriter(fos);
// 	}
// 	try {
// 		osw.write(content);
// 	}
// 	finally {
// 		osw.close();
// 	}
// }
// @NotNull
// export function readFile(@NotNull fileName: string): char[] {
// 	return readFile(fileName, null);
// }
// @NotNull
// export function readFile(@NotNull fileName: string, @Nullable encoding: string): char[] {
// 	let f: File =  new File(fileName);
// 	let size: number =  (int)f.length();
// 	let isr: InputStreamReader;
// 	let fis: FileInputStream =  new FileInputStream(fileName);
// 	if ( encoding!=null ) {
// 		isr = new InputStreamReader(fis, encoding);
// 	}
// 	else {
// 		isr = new InputStreamReader(fis);
// 	}
// 	let data: char[] =  null;
// 	try {
// 		data = new char[size];
// 		let n: number =  isr.read(data);
// 		if (n < data.length) {
// 			data = Arrays.copyOf(data, n);
// 		}
// 	}
// 	finally {
// 		isr.close();
// 	}
// 	return data;
// }
// export function removeAll<T>(@NotNull predicate: List<T> list,@NotNull Predicate<? super T>): void {
// 	let j: number =  0;
// 	for (let i = 0; i < list.size; i++) {
// 		let item: T =  list.get(i);
// 		if (!predicate.eval(item)) {
// 			if (j != i) {
// 				list.set(j, item);
// 			}
// 			j++;
// 		}
// 	}
// 	if (j < list.size) {
// 		list.subList(j, list.size).clear();
// 	}
// }
// export function removeAll<T>(@NotNull predicate: Iterable<T> iterable,@NotNull Predicate<? super T>): void {
// 	if (iterable instanceof List<?>) {
// 		removeAll((List<T>)iterable, predicate);
// 		return;
// 	}
// 	for (Iterator<T> iterator = iterable.iterator(); iterator.hasNext(); ) {
// 		let item: T =  iterator.next();
// 		if (predicate.eval(item)) {
// 			iterator.remove();
// 		}
// 	}
// }
/** Convert array of strings to string&rarr;index map. Useful for
 *  converting rulenames to name&rarr;ruleindex map.
 */ function $466ec2b4a094d7df$var$toMap(keys) {
    let m = new Map();
    for(let i = 0; i < keys.length; i++)m.set(keys[i], i);
    return m;
}
module.exports.toMap = $466ec2b4a094d7df$var$toMap;
function $466ec2b4a094d7df$var$toCharArray(str) {
    if (typeof str === "string") {
        let result = new Uint16Array(str.length);
        for(let i = 0; i < str.length; i++)result[i] = str.charCodeAt(i);
        return result;
    } else return str.toCharArray();
}
module.exports.toCharArray = $466ec2b4a094d7df$var$toCharArray; // /**
 // 	* @since 4.5
 // 	*/
 // @NotNull
 // export function toSet(@NotNull bits: BitSet): IntervalSet {
 // 	let s: IntervalSet =  new IntervalSet();
 // 	let i: number =  bits.nextSetBit(0);
 // 	while ( i >= 0 ) {
 // 		s.add(i);
 // 		i = bits.nextSetBit(i+1);
 // 	}
 // 	return s;
 // }

});




parcelRegister("5jZSY", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3dfebb51130d9868$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3dfebb51130d9868$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InputMismatchException = void 0;

var $b7PPe = parcelRequire("b7PPe");

var $aN41m = parcelRequire("aN41m");
/** This signifies any kind of mismatched input exceptions such as
 *  when the current input does not match the expected token.
 */ let $3dfebb51130d9868$var$InputMismatchException = class InputMismatchException extends $b7PPe.RecognitionException {
    constructor(recognizer, state, context){
        if (context === undefined) context = recognizer.context;
        super(recognizer, recognizer.inputStream, context);
        if (state !== undefined) this.setOffendingState(state);
        this.setOffendingToken(recognizer, recognizer.currentToken);
    }
};
$3dfebb51130d9868$var$InputMismatchException = $3dfebb51130d9868$var$__decorate([
    $3dfebb51130d9868$var$__param(0, $aN41m.NotNull)
], $3dfebb51130d9868$var$InputMismatchException);
module.exports.InputMismatchException = $3dfebb51130d9868$var$InputMismatchException;

});

parcelRegister("6kdz0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $49af21c6dd39b813$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $49af21c6dd39b813$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntervalSet = void 0;

var $6iIjF = parcelRequire("6iIjF");

var $eRSlM = parcelRequire("eRSlM");

var $l8y5T = parcelRequire("l8y5T");

var $h7Q3L = parcelRequire("h7Q3L");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
/**
 * This class implements the {@link IntSet} backed by a sorted array of
 * non-overlapping intervals. It is particularly efficient for representing
 * large collections of numbers, where the majority of elements appear as part
 * of a sequential range of numbers that are all part of the set. For example,
 * the set { 1, 2, 3, 4, 7, 8 } may be represented as { [1, 4], [7, 8] }.
 *
 * This class is able to represent sets containing any combination of values in
 * the range {@link Integer#MIN_VALUE} to {@link Integer#MAX_VALUE}
 * (inclusive).
 */ class $49af21c6dd39b813$var$IntervalSet {
    constructor(intervals){
        this.readonly = false;
        if (intervals != null) this._intervals = intervals.slice(0);
        else this._intervals = [];
    }
    static get COMPLETE_CHAR_SET() {
        if ($49af21c6dd39b813$var$IntervalSet._COMPLETE_CHAR_SET === undefined) {
            $49af21c6dd39b813$var$IntervalSet._COMPLETE_CHAR_SET = $49af21c6dd39b813$var$IntervalSet.of($h7Q3L.Lexer.MIN_CHAR_VALUE, $h7Q3L.Lexer.MAX_CHAR_VALUE);
            $49af21c6dd39b813$var$IntervalSet._COMPLETE_CHAR_SET.setReadonly(true);
        }
        return $49af21c6dd39b813$var$IntervalSet._COMPLETE_CHAR_SET;
    }
    static get EMPTY_SET() {
        if ($49af21c6dd39b813$var$IntervalSet._EMPTY_SET == null) {
            $49af21c6dd39b813$var$IntervalSet._EMPTY_SET = new $49af21c6dd39b813$var$IntervalSet();
            $49af21c6dd39b813$var$IntervalSet._EMPTY_SET.setReadonly(true);
        }
        return $49af21c6dd39b813$var$IntervalSet._EMPTY_SET;
    }
    /**
     * Create a set with all ints within range [a..b] (inclusive). If b is omitted, the set contains the single element
     * a.
     */ static of(a, b = a) {
        let s = new $49af21c6dd39b813$var$IntervalSet();
        s.add(a, b);
        return s;
    }
    clear() {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        this._intervals.length = 0;
    }
    /** Add interval; i.e., add all integers from a to b to set.
     *  If b&lt;a, do nothing.
     *  Keep list in sorted order (by left range value).
     *  If overlap, combine ranges.  For example,
     *  If this is {1..5, 10..20}, adding 6..7 yields
     *  {1..5, 6..7, 10..20}.  Adding 4..8 yields {1..8, 10..20}.
     */ add(a, b = a) {
        this.addRange($l8y5T.Interval.of(a, b));
    }
    // copy on write so we can cache a..a intervals and sets of that
    addRange(addition) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        //System.out.println("add "+addition+" to "+intervals.toString());
        if (addition.b < addition.a) return;
        // find position in list
        // Use iterators as we modify list in place
        for(let i = 0; i < this._intervals.length; i++){
            let r = this._intervals[i];
            if (addition.equals(r)) return;
            if (addition.adjacent(r) || !addition.disjoint(r)) {
                // next to each other, make a single larger interval
                let bigger = addition.union(r);
                this._intervals[i] = bigger;
                // make sure we didn't just create an interval that
                // should be merged with next interval in list
                while(i < this._intervals.length - 1){
                    i++;
                    let next = this._intervals[i];
                    if (!bigger.adjacent(next) && bigger.disjoint(next)) break;
                    // if we bump up against or overlap next, merge
                    // remove this one
                    this._intervals.splice(i, 1);
                    i--;
                    // move backwards to what we just set
                    this._intervals[i] = bigger.union(next);
                // set to 3 merged ones
                }
                // first call to next after previous duplicates the result
                return;
            }
            if (addition.startsBeforeDisjoint(r)) {
                // insert before r
                this._intervals.splice(i, 0, addition);
                return;
            }
        // if disjoint and after r, a future iteration will handle it
        }
        // ok, must be after last interval (and disjoint from last interval)
        // just add it
        this._intervals.push(addition);
    }
    /** combine all sets in the array returned the or'd value */ static or(sets) {
        let r = new $49af21c6dd39b813$var$IntervalSet();
        for (let s of sets)r.addAll(s);
        return r;
    }
    addAll(set) {
        if (set == null) return this;
        if (set instanceof $49af21c6dd39b813$var$IntervalSet) {
            let other = set;
            // walk set and add each interval
            let n = other._intervals.length;
            for(let i = 0; i < n; i++){
                let I = other._intervals[i];
                this.add(I.a, I.b);
            }
        } else for (let value of set.toArray())this.add(value);
        return this;
    }
    complementRange(minElement, maxElement) {
        return this.complement($49af21c6dd39b813$var$IntervalSet.of(minElement, maxElement));
    }
    /** {@inheritDoc} */ complement(vocabulary) {
        if (vocabulary.isNil) // nothing in common with null set
        return $49af21c6dd39b813$var$IntervalSet.EMPTY_SET;
        let vocabularyIS;
        if (vocabulary instanceof $49af21c6dd39b813$var$IntervalSet) vocabularyIS = vocabulary;
        else {
            vocabularyIS = new $49af21c6dd39b813$var$IntervalSet();
            vocabularyIS.addAll(vocabulary);
        }
        return vocabularyIS.subtract(this);
    }
    subtract(a) {
        if (a == null || a.isNil) return new $49af21c6dd39b813$var$IntervalSet(this._intervals);
        if (a instanceof $49af21c6dd39b813$var$IntervalSet) return $49af21c6dd39b813$var$IntervalSet.subtract(this, a);
        let other = new $49af21c6dd39b813$var$IntervalSet();
        other.addAll(a);
        return $49af21c6dd39b813$var$IntervalSet.subtract(this, other);
    }
    /**
     * Compute the set difference between two interval sets. The specific
     * operation is `left - right`.
     */ static subtract(left, right) {
        if (left.isNil) return new $49af21c6dd39b813$var$IntervalSet();
        let result = new $49af21c6dd39b813$var$IntervalSet(left._intervals);
        if (right.isNil) // right set has no elements; just return the copy of the current set
        return result;
        let resultI = 0;
        let rightI = 0;
        while(resultI < result._intervals.length && rightI < right._intervals.length){
            let resultInterval = result._intervals[resultI];
            let rightInterval = right._intervals[rightI];
            // operation: (resultInterval - rightInterval) and update indexes
            if (rightInterval.b < resultInterval.a) {
                rightI++;
                continue;
            }
            if (rightInterval.a > resultInterval.b) {
                resultI++;
                continue;
            }
            let beforeCurrent;
            let afterCurrent;
            if (rightInterval.a > resultInterval.a) beforeCurrent = new $l8y5T.Interval(resultInterval.a, rightInterval.a - 1);
            if (rightInterval.b < resultInterval.b) afterCurrent = new $l8y5T.Interval(rightInterval.b + 1, resultInterval.b);
            if (beforeCurrent) {
                if (afterCurrent) {
                    // split the current interval into two
                    result._intervals[resultI] = beforeCurrent;
                    result._intervals.splice(resultI + 1, 0, afterCurrent);
                    resultI++;
                    rightI++;
                    continue;
                } else {
                    // replace the current interval
                    result._intervals[resultI] = beforeCurrent;
                    resultI++;
                    continue;
                }
            } else if (afterCurrent) {
                // replace the current interval
                result._intervals[resultI] = afterCurrent;
                rightI++;
                continue;
            } else {
                // remove the current interval (thus no need to increment resultI)
                result._intervals.splice(resultI, 1);
                continue;
            }
        }
        // If rightI reached right.intervals.size, no more intervals to subtract from result.
        // If resultI reached result.intervals.size, we would be subtracting from an empty set.
        // Either way, we are done.
        return result;
    }
    or(a) {
        let o = new $49af21c6dd39b813$var$IntervalSet();
        o.addAll(this);
        o.addAll(a);
        return o;
    }
    /** {@inheritDoc} */ and(other) {
        if (other.isNil) // nothing in common with null set
        return new $49af21c6dd39b813$var$IntervalSet();
        let myIntervals = this._intervals;
        let theirIntervals = other._intervals;
        let intersection;
        let mySize = myIntervals.length;
        let theirSize = theirIntervals.length;
        let i = 0;
        let j = 0;
        // iterate down both interval lists looking for nondisjoint intervals
        while(i < mySize && j < theirSize){
            let mine = myIntervals[i];
            let theirs = theirIntervals[j];
            //System.out.println("mine="+mine+" and theirs="+theirs);
            if (mine.startsBeforeDisjoint(theirs)) // move this iterator looking for interval that might overlap
            i++;
            else if (theirs.startsBeforeDisjoint(mine)) // move other iterator looking for interval that might overlap
            j++;
            else if (mine.properlyContains(theirs)) {
                // overlap, add intersection, get next theirs
                if (!intersection) intersection = new $49af21c6dd39b813$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                j++;
            } else if (theirs.properlyContains(mine)) {
                // overlap, add intersection, get next mine
                if (!intersection) intersection = new $49af21c6dd39b813$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                i++;
            } else if (!mine.disjoint(theirs)) {
                // overlap, add intersection
                if (!intersection) intersection = new $49af21c6dd39b813$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                // Move the iterator of lower range [a..b], but not
                // the upper range as it may contain elements that will collide
                // with the next iterator. So, if mine=[0..115] and
                // theirs=[115..200], then intersection is 115 and move mine
                // but not theirs as theirs may collide with the next range
                // in thisIter.
                // move both iterators to next ranges
                if (mine.startsAfterNonDisjoint(theirs)) j++;
                else if (theirs.startsAfterNonDisjoint(mine)) i++;
            }
        }
        if (!intersection) return new $49af21c6dd39b813$var$IntervalSet();
        return intersection;
    }
    /** {@inheritDoc} */ contains(el) {
        let n = this._intervals.length;
        let l = 0;
        let r = n - 1;
        // Binary search for the element in the (sorted, disjoint) array of intervals.
        while(l <= r){
            let m = l + r >> 1;
            let I = this._intervals[m];
            let a = I.a;
            let b = I.b;
            if (b < el) l = m + 1;
            else if (a > el) r = m - 1;
            else // el >= a && el <= b
            return true;
        }
        return false;
    }
    /** {@inheritDoc} */ get isNil() {
        return this._intervals == null || this._intervals.length === 0;
    }
    /**
     * Returns the maximum value contained in the set if not isNil.
     *
     * @return the maximum value contained in the set.
     * @throws RangeError if set is empty
     */ get maxElement() {
        if (this.isNil) throw new RangeError("set is empty");
        let last = this._intervals[this._intervals.length - 1];
        return last.b;
    }
    /**
     * Returns the minimum value contained in the set if not isNil.
     *
     * @return the minimum value contained in the set.
     * @throws RangeError if set is empty
     */ get minElement() {
        if (this.isNil) throw new RangeError("set is empty");
        return this._intervals[0].a;
    }
    /** Return a list of Interval objects. */ get intervals() {
        return this._intervals;
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        for (let I of this._intervals){
            hash = $amQx9.MurmurHash.update(hash, I.a);
            hash = $amQx9.MurmurHash.update(hash, I.b);
        }
        hash = $amQx9.MurmurHash.finish(hash, this._intervals.length * 2);
        return hash;
    }
    /** Are two IntervalSets equal?  Because all intervals are sorted
     *  and disjoint, equals is a simple linear walk over both lists
     *  to make sure they are the same.  Interval.equals() is used
     *  by the List.equals() method to check the ranges.
     */ equals(o) {
        if (o == null || !(o instanceof $49af21c6dd39b813$var$IntervalSet)) return false;
        return $6iIjF.ArrayEqualityComparator.INSTANCE.equals(this._intervals, o._intervals);
    }
    toString(elemAreChar = false) {
        let buf = "";
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) {
                if (a === $eKXi4.Token.EOF) buf += "<EOF>";
                else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'";
                else buf += a;
            } else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'..'" + String.fromCodePoint(b) + "'";
            else buf += a + ".." + b;
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    toStringVocabulary(vocabulary) {
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        let buf = "";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) buf += this.elementName(vocabulary, a);
            else for(let i = a; i <= b; i++){
                if (i > a) buf += ", ";
                buf += this.elementName(vocabulary, i);
            }
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    elementName(vocabulary, a) {
        if (a === $eKXi4.Token.EOF) return "<EOF>";
        else if (a === $eKXi4.Token.EPSILON) return "<EPSILON>";
        else return vocabulary.getDisplayName(a);
    }
    get size() {
        let n = 0;
        let numIntervals = this._intervals.length;
        if (numIntervals === 1) {
            let firstInterval = this._intervals[0];
            return firstInterval.b - firstInterval.a + 1;
        }
        for(let i = 0; i < numIntervals; i++){
            let I = this._intervals[i];
            n += I.b - I.a + 1;
        }
        return n;
    }
    toIntegerList() {
        let values = new $eRSlM.IntegerList(this.size);
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.add(v);
        }
        return values;
    }
    toSet() {
        let s = new Set();
        for (let I of this._intervals){
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)s.add(v);
        }
        return s;
    }
    toArray() {
        let values = new Array();
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.push(v);
        }
        return values;
    }
    remove(el) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            if (el < a) break; // list is sorted and el is before this interval; not here
            // if whole interval x..x, rm
            if (el === a && el === b) {
                this._intervals.splice(i, 1);
                break;
            }
            // if on left edge x..b, adjust left
            if (el === a) {
                this._intervals[i] = $l8y5T.Interval.of(I.a + 1, I.b);
                break;
            }
            // if on right edge a..x, adjust right
            if (el === b) {
                this._intervals[i] = $l8y5T.Interval.of(I.a, I.b - 1);
                break;
            }
            // if in middle a..x..b, split interval
            if (el > a && el < b) {
                let oldb = I.b;
                this._intervals[i] = $l8y5T.Interval.of(I.a, el - 1); // [a..x-1]
                this.add(el + 1, oldb); // add [x+1..b]
            }
        }
    }
    get isReadonly() {
        return this.readonly;
    }
    setReadonly(readonly) {
        if (this.readonly && !readonly) throw new Error("can't alter readonly IntervalSet");
        this.readonly = readonly;
    }
}
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "addAll", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "complement", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "subtract", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "or", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "and", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "contains", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "isNil", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "hashCode", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "equals", null);
$49af21c6dd39b813$var$__decorate([
    $49af21c6dd39b813$var$__param(0, $aN41m.NotNull)
], $49af21c6dd39b813$var$IntervalSet.prototype, "toStringVocabulary", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.NotNull,
    $49af21c6dd39b813$var$__param(0, $aN41m.NotNull)
], $49af21c6dd39b813$var$IntervalSet.prototype, "elementName", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "size", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "remove", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.NotNull
], $49af21c6dd39b813$var$IntervalSet, "of", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.NotNull
], $49af21c6dd39b813$var$IntervalSet, "subtract", null);
module.exports.IntervalSet = $49af21c6dd39b813$var$IntervalSet;

});
parcelRegister("eRSlM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ad302cc069821a02$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerList = void 0;

var $4dKou = parcelRequire("4dKou");

var $aN41m = parcelRequire("aN41m");
const $ad302cc069821a02$var$EMPTY_DATA = new Int32Array(0);
const $ad302cc069821a02$var$INITIAL_SIZE = 4;
const $ad302cc069821a02$var$MAX_ARRAY_SIZE = 2147483639;
/**
 *
 * @author Sam Harwell
 */ class $ad302cc069821a02$var$IntegerList {
    constructor(arg){
        if (!arg) {
            this._data = $ad302cc069821a02$var$EMPTY_DATA;
            this._size = 0;
        } else if (arg instanceof $ad302cc069821a02$var$IntegerList) {
            this._data = arg._data.slice(0);
            this._size = arg._size;
        } else if (typeof arg === "number") {
            if (arg === 0) {
                this._data = $ad302cc069821a02$var$EMPTY_DATA;
                this._size = 0;
            } else {
                this._data = new Int32Array(arg);
                this._size = 0;
            }
        } else {
            // arg is Iterable<number>
            this._data = $ad302cc069821a02$var$EMPTY_DATA;
            this._size = 0;
            for (let value of arg)this.add(value);
        }
    }
    add(value) {
        if (this._data.length === this._size) this.ensureCapacity(this._size + 1);
        this._data[this._size] = value;
        this._size++;
    }
    addAll(list) {
        if (Array.isArray(list)) {
            this.ensureCapacity(this._size + list.length);
            this._data.subarray(this._size, this._size + list.length).set(list);
            this._size += list.length;
        } else if (list instanceof $ad302cc069821a02$var$IntegerList) {
            this.ensureCapacity(this._size + list._size);
            this._data.subarray(this._size, this._size + list.size).set(list._data);
            this._size += list._size;
        } else {
            // list is JavaCollection<number>
            this.ensureCapacity(this._size + list.size);
            let current = 0;
            for (let xi of list){
                this._data[this._size + current] = xi;
                current++;
            }
            this._size += list.size;
        }
    }
    get(index) {
        if (index < 0 || index >= this._size) throw RangeError();
        return this._data[index];
    }
    contains(value) {
        for(let i = 0; i < this._size; i++){
            if (this._data[i] === value) return true;
        }
        return false;
    }
    set(index, value) {
        if (index < 0 || index >= this._size) throw RangeError();
        let previous = this._data[index];
        this._data[index] = value;
        return previous;
    }
    removeAt(index) {
        let value = this.get(index);
        this._data.copyWithin(index, index + 1, this._size);
        this._data[this._size - 1] = 0;
        this._size--;
        return value;
    }
    removeRange(fromIndex, toIndex) {
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw RangeError();
        if (fromIndex > toIndex) throw RangeError();
        this._data.copyWithin(toIndex, fromIndex, this._size);
        this._data.fill(0, this._size - (toIndex - fromIndex), this._size);
        this._size -= toIndex - fromIndex;
    }
    get isEmpty() {
        return this._size === 0;
    }
    get size() {
        return this._size;
    }
    trimToSize() {
        if (this._data.length === this._size) return;
        this._data = this._data.slice(0, this._size);
    }
    clear() {
        this._data.fill(0, 0, this._size);
        this._size = 0;
    }
    toArray() {
        if (this._size === 0) return [];
        return Array.from(this._data.subarray(0, this._size));
    }
    sort() {
        this._data.subarray(0, this._size).sort();
    }
    /**
     * Compares the specified object with this list for equality.  Returns
     * `true` if and only if the specified object is also an {@link IntegerList},
     * both lists have the same size, and all corresponding pairs of elements in
     * the two lists are equal.  In other words, two lists are defined to be
     * equal if they contain the same elements in the same order.
     *
     * This implementation first checks if the specified object is this
     * list. If so, it returns `true`; if not, it checks if the
     * specified object is an {@link IntegerList}. If not, it returns `false`;
     * if so, it checks the size of both lists. If the lists are not the same size,
     * it returns `false`; otherwise it iterates over both lists, comparing
     * corresponding pairs of elements.  If any comparison returns `false`,
     * this method returns `false`.
     *
     * @param o the object to be compared for equality with this list
     * @returns `true` if the specified object is equal to this list
     */ equals(o) {
        if (o === this) return true;
        if (!(o instanceof $ad302cc069821a02$var$IntegerList)) return false;
        if (this._size !== o._size) return false;
        for(let i = 0; i < this._size; i++){
            if (this._data[i] !== o._data[i]) return false;
        }
        return true;
    }
    /**
     * Returns the hash code value for this list.
     *
     * This implementation uses exactly the code that is used to define the
     * list hash function in the documentation for the {@link List#hashCode}
     * method.
     *
     * @returns the hash code value for this list
     */ hashCode() {
        let hashCode = 1;
        for(let i = 0; i < this._size; i++)hashCode = 31 * hashCode + this._data[i];
        return hashCode;
    }
    /**
     * Returns a string representation of this list.
     */ toString() {
        return this._data.toString();
    }
    binarySearch(key, fromIndex, toIndex) {
        if (fromIndex === undefined) fromIndex = 0;
        if (toIndex === undefined) toIndex = this._size;
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw new RangeError();
        if (fromIndex > toIndex) throw new RangeError();
        return $4dKou.Arrays.binarySearch(this._data, key, fromIndex, toIndex);
    }
    ensureCapacity(capacity) {
        if (capacity < 0 || capacity > $ad302cc069821a02$var$MAX_ARRAY_SIZE) throw new RangeError();
        let newLength;
        if (this._data.length === 0) newLength = $ad302cc069821a02$var$INITIAL_SIZE;
        else newLength = this._data.length;
        while(newLength < capacity){
            newLength = newLength * 2;
            if (newLength < 0 || newLength > $ad302cc069821a02$var$MAX_ARRAY_SIZE) newLength = $ad302cc069821a02$var$MAX_ARRAY_SIZE;
        }
        let tmp = new Int32Array(newLength);
        tmp.set(this._data);
        this._data = tmp;
    }
    /** Convert the list to a UTF-16 encoded char array. If all values are less
     *  than the 0xFFFF 16-bit code point limit then this is just a char array
     *  of 16-bit char as usual. For values in the supplementary range, encode
     * them as two UTF-16 code units.
     */ toCharArray() {
        // Optimize for the common case (all data values are < 0xFFFF) to avoid an extra scan
        let resultArray = new Uint16Array(this._size);
        let resultIdx = 0;
        let calculatedPreciseResultSize = false;
        for(let i = 0; i < this._size; i++){
            let codePoint = this._data[i];
            if (codePoint >= 0 && codePoint < 0x10000) {
                resultArray[resultIdx] = codePoint;
                resultIdx++;
                continue;
            }
            // Calculate the precise result size if we encounter a code point > 0xFFFF
            if (!calculatedPreciseResultSize) {
                let newResultArray = new Uint16Array(this.charArraySize());
                newResultArray.set(resultArray, 0);
                resultArray = newResultArray;
                calculatedPreciseResultSize = true;
            }
            // This will throw RangeError if the code point is not a valid Unicode code point
            let pair = String.fromCodePoint(codePoint);
            resultArray[resultIdx] = pair.charCodeAt(0);
            resultArray[resultIdx + 1] = pair.charCodeAt(1);
            resultIdx += 2;
        }
        return resultArray;
    }
    charArraySize() {
        let result = 0;
        for(let i = 0; i < this._size; i++)result += this._data[i] >= 0x10000 ? 2 : 1;
        return result;
    }
}
$ad302cc069821a02$var$__decorate([
    $aN41m.NotNull
], $ad302cc069821a02$var$IntegerList.prototype, "_data", void 0);
$ad302cc069821a02$var$__decorate([
    $aN41m.Override
], $ad302cc069821a02$var$IntegerList.prototype, "equals", null);
$ad302cc069821a02$var$__decorate([
    $aN41m.Override
], $ad302cc069821a02$var$IntegerList.prototype, "hashCode", null);
$ad302cc069821a02$var$__decorate([
    $aN41m.Override
], $ad302cc069821a02$var$IntegerList.prototype, "toString", null);
module.exports.IntegerList = $ad302cc069821a02$var$IntegerList;

});
parcelRegister("4dKou", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Arrays = void 0;
var $312c5d30775d92ef$var$Arrays;
(function(Arrays) {
    /**
     * Searches the specified array of numbers for the specified value using the binary search algorithm. The array must
     * be sorted prior to making this call. If it is not sorted, the results are unspecified. If the array contains
     * multiple elements with the specified value, there is no guarantee which one will be found.
     *
     * @returns index of the search key, if it is contained in the array; otherwise, (-(insertion point) - 1). The
     * insertion point is defined as the point at which the key would be inserted into the array: the index of the first
     * element greater than the key, or array.length if all elements in the array are less than the specified key. Note
     * that this guarantees that the return value will be >= 0 if and only if the key is found.
     */ function binarySearch(array, key, fromIndex, toIndex) {
        return binarySearch0(array, fromIndex !== undefined ? fromIndex : 0, toIndex !== undefined ? toIndex : array.length, key);
    }
    Arrays.binarySearch = binarySearch;
    function binarySearch0(array, fromIndex, toIndex, key) {
        let low = fromIndex;
        let high = toIndex - 1;
        while(low <= high){
            let mid = low + high >>> 1;
            let midVal = array[mid];
            if (midVal < key) low = mid + 1;
            else if (midVal > key) high = mid - 1;
            else // key found
            return mid;
        }
        // key not found.
        return -(low + 1);
    }
    function toString(array) {
        let result = "[";
        let first = true;
        for (let element of array){
            if (first) first = false;
            else result += ", ";
            if (element === null) result += "null";
            else if (element === undefined) result += "undefined";
            else result += element;
        }
        result += "]";
        return result;
    }
    Arrays.toString = toString;
})($312c5d30775d92ef$var$Arrays = module.exports.Arrays || (module.exports.Arrays = {}));

});


parcelRegister("l8y5T", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f634cab1d0696c5f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Interval = void 0;

var $aN41m = parcelRequire("aN41m");
const $f634cab1d0696c5f$var$INTERVAL_POOL_MAX_VALUE = 1000;
/** An immutable inclusive interval a..b */ class $f634cab1d0696c5f$var$Interval {
    /**
     * @param a The start of the interval
     * @param b The end of the interval (inclusive)
     */ constructor(a, b){
        this.a = a;
        this.b = b;
    }
    static get INVALID() {
        return $f634cab1d0696c5f$var$Interval._INVALID;
    }
    /** Interval objects are used readonly so share all with the
     *  same single value a==b up to some max size.  Use an array as a perfect hash.
     *  Return shared object for 0..INTERVAL_POOL_MAX_VALUE or a new
     *  Interval object with a..a in it.  On Java.g4, 218623 IntervalSets
     *  have a..a (set with 1 element).
     */ static of(a, b) {
        // cache just a..a
        if (a !== b || a < 0 || a > $f634cab1d0696c5f$var$INTERVAL_POOL_MAX_VALUE) return new $f634cab1d0696c5f$var$Interval(a, b);
        if ($f634cab1d0696c5f$var$Interval.cache[a] == null) $f634cab1d0696c5f$var$Interval.cache[a] = new $f634cab1d0696c5f$var$Interval(a, a);
        return $f634cab1d0696c5f$var$Interval.cache[a];
    }
    /** return number of elements between a and b inclusively. x..x is length 1.
     *  if b &lt; a, then length is 0.  9..10 has length 2.
     */ get length() {
        if (this.b < this.a) return 0;
        return this.b - this.a + 1;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof $f634cab1d0696c5f$var$Interval)) return false;
        return this.a === o.a && this.b === o.b;
    }
    hashCode() {
        let hash = 23;
        hash = hash * 31 + this.a;
        hash = hash * 31 + this.b;
        return hash;
    }
    /** Does this start completely before other? Disjoint */ startsBeforeDisjoint(other) {
        return this.a < other.a && this.b < other.a;
    }
    /** Does this start at or before other? Nondisjoint */ startsBeforeNonDisjoint(other) {
        return this.a <= other.a && this.b >= other.a;
    }
    /** Does this.a start after other.b? May or may not be disjoint */ startsAfter(other) {
        return this.a > other.a;
    }
    /** Does this start completely after other? Disjoint */ startsAfterDisjoint(other) {
        return this.a > other.b;
    }
    /** Does this start after other? NonDisjoint */ startsAfterNonDisjoint(other) {
        return this.a > other.a && this.a <= other.b; // this.b>=other.b implied
    }
    /** Are both ranges disjoint? I.e., no overlap? */ disjoint(other) {
        return this.startsBeforeDisjoint(other) || this.startsAfterDisjoint(other);
    }
    /** Are two intervals adjacent such as 0..41 and 42..42? */ adjacent(other) {
        return this.a === other.b + 1 || this.b === other.a - 1;
    }
    properlyContains(other) {
        return other.a >= this.a && other.b <= this.b;
    }
    /** Return the interval computed from combining this and other */ union(other) {
        return $f634cab1d0696c5f$var$Interval.of(Math.min(this.a, other.a), Math.max(this.b, other.b));
    }
    /** Return the interval in common between this and o */ intersection(other) {
        return $f634cab1d0696c5f$var$Interval.of(Math.max(this.a, other.a), Math.min(this.b, other.b));
    }
    /** Return the interval with elements from `this` not in `other`;
     *  `other` must not be totally enclosed (properly contained)
     *  within `this`, which would result in two disjoint intervals
     *  instead of the single one returned by this method.
     */ differenceNotProperlyContained(other) {
        let diff;
        if (other.startsBeforeNonDisjoint(this)) // other.a to left of this.a (or same)
        diff = $f634cab1d0696c5f$var$Interval.of(Math.max(this.a, other.b + 1), this.b);
        else if (other.startsAfterNonDisjoint(this)) // other.a to right of this.a
        diff = $f634cab1d0696c5f$var$Interval.of(this.a, other.a - 1);
        return diff;
    }
    toString() {
        return this.a + ".." + this.b;
    }
}
$f634cab1d0696c5f$var$Interval._INVALID = new $f634cab1d0696c5f$var$Interval(-1, -2);
$f634cab1d0696c5f$var$Interval.cache = new Array($f634cab1d0696c5f$var$INTERVAL_POOL_MAX_VALUE + 1);
$f634cab1d0696c5f$var$__decorate([
    $aN41m.Override
], $f634cab1d0696c5f$var$Interval.prototype, "equals", null);
$f634cab1d0696c5f$var$__decorate([
    $aN41m.Override
], $f634cab1d0696c5f$var$Interval.prototype, "hashCode", null);
$f634cab1d0696c5f$var$__decorate([
    $aN41m.Override
], $f634cab1d0696c5f$var$Interval.prototype, "toString", null);
module.exports.Interval = $f634cab1d0696c5f$var$Interval;

});

parcelRegister("h7Q3L", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c77b7912a6658aa1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Lexer = void 0;

var $9hrXh = parcelRequire("9hrXh");

var $jB0DW = parcelRequire("jB0DW");

var $l8y5T = parcelRequire("l8y5T");

var $ldi9e = parcelRequire("ldi9e");

var $2160U = parcelRequire("2160U");

var $l3IpB = parcelRequire("l3IpB");

var $aN41m = parcelRequire("aN41m");

var $dwftT = parcelRequire("dwftT");

var $eKXi4 = parcelRequire("eKXi4");
/** A lexer is recognizer that draws input symbols from a character stream.
 *  lexer grammars result in a subclass of this object. A Lexer object
 *  uses simplified match() and error recovery mechanisms in the interest
 *  of speed.
 */ class $c77b7912a6658aa1$var$Lexer extends $dwftT.Recognizer {
    constructor(input){
        super();
        /** How to create token objects */ this._factory = $9hrXh.CommonTokenFactory.DEFAULT;
        /** What character index in the stream did the current token start at?
         *  Needed, for example, to get the text for current token.  Set at
         *  the start of nextToken.
         */ this._tokenStartCharIndex = -1;
        /** The line on which the first character of the token resides */ this._tokenStartLine = 0;
        /** The character position of first character within the line */ this._tokenStartCharPositionInLine = 0;
        /** Once we see EOF on char stream, next token will be EOF.
         *  If you have DONE : EOF ; then you see DONE EOF.
         */ this._hitEOF = false;
        /** The channel number for the current token */ this._channel = 0;
        /** The token type for the current token */ this._type = 0;
        this._modeStack = new $jB0DW.IntegerStack();
        this._mode = $c77b7912a6658aa1$var$Lexer.DEFAULT_MODE;
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: input
        };
    }
    static get DEFAULT_TOKEN_CHANNEL() {
        return $eKXi4.Token.DEFAULT_CHANNEL;
    }
    static get HIDDEN() {
        return $eKXi4.Token.HIDDEN_CHANNEL;
    }
    reset(resetInput) {
        // wack Lexer state variables
        if (resetInput === undefined || resetInput) this._input.seek(0); // rewind the input
        this._token = undefined;
        this._type = $eKXi4.Token.INVALID_TYPE;
        this._channel = $eKXi4.Token.DEFAULT_CHANNEL;
        this._tokenStartCharIndex = -1;
        this._tokenStartCharPositionInLine = -1;
        this._tokenStartLine = -1;
        this._text = undefined;
        this._hitEOF = false;
        this._mode = $c77b7912a6658aa1$var$Lexer.DEFAULT_MODE;
        this._modeStack.clear();
        this.interpreter.reset();
    }
    /** Return a token from this source; i.e., match a token on the char
     *  stream.
     */ nextToken() {
        if (this._input == null) throw new Error("nextToken requires a non-null input stream.");
        // Mark start location in char stream so unbuffered streams are
        // guaranteed at least have text of current token
        let tokenStartMarker = this._input.mark();
        try {
            outer: while(true){
                if (this._hitEOF) return this.emitEOF();
                this._token = undefined;
                this._channel = $eKXi4.Token.DEFAULT_CHANNEL;
                this._tokenStartCharIndex = this._input.index;
                this._tokenStartCharPositionInLine = this.interpreter.charPositionInLine;
                this._tokenStartLine = this.interpreter.line;
                this._text = undefined;
                do {
                    this._type = $eKXi4.Token.INVALID_TYPE;
                    //				System.out.println("nextToken line "+tokenStartLine+" at "+((char)input.LA(1))+
                    //								   " in mode "+mode+
                    //								   " at index "+input.index);
                    let ttype;
                    try {
                        ttype = this.interpreter.match(this._input, this._mode);
                    } catch (e) {
                        if (e instanceof $l3IpB.LexerNoViableAltException) {
                            this.notifyListeners(e); // report error
                            this.recover(e);
                            ttype = $c77b7912a6658aa1$var$Lexer.SKIP;
                        } else throw e;
                    }
                    if (this._input.LA(1) === $ldi9e.IntStream.EOF) this._hitEOF = true;
                    if (this._type === $eKXi4.Token.INVALID_TYPE) this._type = ttype;
                    if (this._type === $c77b7912a6658aa1$var$Lexer.SKIP) continue outer;
                }while (this._type === $c77b7912a6658aa1$var$Lexer.MORE);
                if (this._token == null) return this.emit();
                return this._token;
            }
        } finally{
            // make sure we release marker after match or
            // unbuffered char stream will keep buffering
            this._input.release(tokenStartMarker);
        }
    }
    /** Instruct the lexer to skip creating a token for current lexer rule
     *  and look for another token.  nextToken() knows to keep looking when
     *  a lexer rule finishes with token set to SKIP_TOKEN.  Recall that
     *  if token==undefined at end of any token rule, it creates one for you
     *  and emits it.
     */ skip() {
        this._type = $c77b7912a6658aa1$var$Lexer.SKIP;
    }
    more() {
        this._type = $c77b7912a6658aa1$var$Lexer.MORE;
    }
    mode(m) {
        this._mode = m;
    }
    pushMode(m) {
        if ($2160U.LexerATNSimulator.debug) console.log("pushMode " + m);
        this._modeStack.push(this._mode);
        this.mode(m);
    }
    popMode() {
        if (this._modeStack.isEmpty) throw new Error("EmptyStackException");
        if ($2160U.LexerATNSimulator.debug) console.log("popMode back to " + this._modeStack.peek());
        this.mode(this._modeStack.pop());
        return this._mode;
    }
    get tokenFactory() {
        return this._factory;
    }
    // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the char stream and reset the lexer */ set inputStream(input) {
        this.reset(false);
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: this._input
        };
    }
    get sourceName() {
        return this._input.sourceName;
    }
    emit(token) {
        if (!token) token = this._factory.create(this._tokenFactorySourcePair, this._type, this._text, this._channel, this._tokenStartCharIndex, this.charIndex - 1, this._tokenStartLine, this._tokenStartCharPositionInLine);
        this._token = token;
        return token;
    }
    emitEOF() {
        let cpos = this.charPositionInLine;
        let line = this.line;
        let eof = this._factory.create(this._tokenFactorySourcePair, $eKXi4.Token.EOF, undefined, $eKXi4.Token.DEFAULT_CHANNEL, this._input.index, this._input.index - 1, line, cpos);
        this.emit(eof);
        return eof;
    }
    get line() {
        return this.interpreter.line;
    }
    set line(line) {
        this.interpreter.line = line;
    }
    get charPositionInLine() {
        return this.interpreter.charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this.interpreter.charPositionInLine = charPositionInLine;
    }
    /** What is the index of the current character of lookahead? */ get charIndex() {
        return this._input.index;
    }
    /** Return the text matched so far for the current token or any
     *  text override.
     */ get text() {
        if (this._text != null) return this._text;
        return this.interpreter.getText(this._input);
    }
    /** Set the complete text of this token; it wipes any previous
     *  changes to the text.
     */ set text(text) {
        this._text = text;
    }
    /** Override if emitting multiple tokens. */ get token() {
        return this._token;
    }
    set token(_token) {
        this._token = _token;
    }
    set type(ttype) {
        this._type = ttype;
    }
    get type() {
        return this._type;
    }
    set channel(channel) {
        this._channel = channel;
    }
    get channel() {
        return this._channel;
    }
    /** Return a list of all Token objects in input char stream.
     *  Forces load of all tokens. Does not include EOF token.
     */ getAllTokens() {
        let tokens = [];
        let t = this.nextToken();
        while(t.type !== $eKXi4.Token.EOF){
            tokens.push(t);
            t = this.nextToken();
        }
        return tokens;
    }
    notifyListeners(e) {
        let text = this._input.getText($l8y5T.Interval.of(this._tokenStartCharIndex, this._input.index));
        let msg = "token recognition error at: '" + this.getErrorDisplay(text) + "'";
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, undefined, this._tokenStartLine, this._tokenStartCharPositionInLine, msg, e);
    }
    getErrorDisplay(s) {
        if (typeof s === "number") {
            switch(s){
                case $eKXi4.Token.EOF:
                    return "<EOF>";
                case 0x0a:
                    return "\\n";
                case 0x09:
                    return "\\t";
                case 0x0d:
                    return "\\r";
            }
            return String.fromCharCode(s);
        }
        return s.replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r");
    }
    getCharErrorDisplay(c) {
        let s = this.getErrorDisplay(c);
        return "'" + s + "'";
    }
    recover(re) {
        if (re instanceof $l3IpB.LexerNoViableAltException) {
            if (this._input.LA(1) !== $ldi9e.IntStream.EOF) // skip a char and try again
            this.interpreter.consume(this._input);
        } else //System.out.println("consuming char "+(char)input.LA(1)+" during recovery");
        //re.printStackTrace();
        // TODO: Do we lose character or line position information?
        this._input.consume();
    }
}
$c77b7912a6658aa1$var$Lexer.DEFAULT_MODE = 0;
$c77b7912a6658aa1$var$Lexer.MORE = -2;
$c77b7912a6658aa1$var$Lexer.SKIP = -3;
$c77b7912a6658aa1$var$Lexer.MIN_CHAR_VALUE = 0x0000;
$c77b7912a6658aa1$var$Lexer.MAX_CHAR_VALUE = 0x10FFFF;
$c77b7912a6658aa1$var$__decorate([
    $aN41m.Override
], $c77b7912a6658aa1$var$Lexer.prototype, "nextToken", null);
$c77b7912a6658aa1$var$__decorate([
    $aN41m.Override
], $c77b7912a6658aa1$var$Lexer.prototype, "tokenFactory", null);
$c77b7912a6658aa1$var$__decorate([
    $aN41m.Override
], $c77b7912a6658aa1$var$Lexer.prototype, "inputStream", null);
$c77b7912a6658aa1$var$__decorate([
    $aN41m.Override
], $c77b7912a6658aa1$var$Lexer.prototype, "sourceName", null);
$c77b7912a6658aa1$var$__decorate([
    $aN41m.Override
], $c77b7912a6658aa1$var$Lexer.prototype, "line", null);
$c77b7912a6658aa1$var$__decorate([
    $aN41m.Override
], $c77b7912a6658aa1$var$Lexer.prototype, "charPositionInLine", null);
module.exports.Lexer = $c77b7912a6658aa1$var$Lexer;

});
parcelRegister("9hrXh", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6c1b62e47790a82a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenFactory = void 0;

var $exlin = parcelRequire("exlin");

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");
/**
 * This default implementation of {@link TokenFactory} creates
 * {@link CommonToken} objects.
 */ class $6c1b62e47790a82a$var$CommonTokenFactory {
    /**
     * Constructs a {@link CommonTokenFactory} with the specified value for
     * {@link #copyText}.
     *
     * When `copyText` is `false`, the {@link #DEFAULT} instance
     * should be used instead of constructing a new instance.
     *
     * @param copyText The value for {@link #copyText}.
     */ constructor(copyText = false){
        this.copyText = copyText;
    }
    create(source, type, text, channel, start, stop, line, charPositionInLine) {
        let t = new $exlin.CommonToken(type, text, source, channel, start, stop);
        t.line = line;
        t.charPositionInLine = charPositionInLine;
        if (text == null && this.copyText && source.stream != null) t.text = source.stream.getText($l8y5T.Interval.of(start, stop));
        return t;
    }
    createSimple(type, text) {
        return new $exlin.CommonToken(type, text);
    }
}
$6c1b62e47790a82a$var$__decorate([
    $aN41m.Override
], $6c1b62e47790a82a$var$CommonTokenFactory.prototype, "create", null);
$6c1b62e47790a82a$var$__decorate([
    $aN41m.Override
], $6c1b62e47790a82a$var$CommonTokenFactory.prototype, "createSimple", null);
module.exports.CommonTokenFactory = $6c1b62e47790a82a$var$CommonTokenFactory;
(function(CommonTokenFactory) {
    /**
     * The default {@link CommonTokenFactory} instance.
     *
     * This token factory does not explicitly copy token text when constructing
     * tokens.
     */ CommonTokenFactory.DEFAULT = new CommonTokenFactory();
})($6c1b62e47790a82a$var$CommonTokenFactory = module.exports.CommonTokenFactory || (module.exports.CommonTokenFactory = {}));

});
parcelRegister("exlin", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a954aa91d3b92162$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a954aa91d3b92162$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonToken = void 0;

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
let $a954aa91d3b92162$var$CommonToken = class CommonToken {
    constructor(type, text, source = CommonToken.EMPTY_SOURCE, channel = $eKXi4.Token.DEFAULT_CHANNEL, start = 0, stop = 0){
        /**
         * This is the backing field for {@link #getLine} and {@link #setLine}.
         */ this._line = 0;
        /**
         * This is the backing field for {@link #getCharPositionInLine} and
         * {@link #setCharPositionInLine}.
         */ this._charPositionInLine = -1; // set to invalid position
        /**
         * This is the backing field for {@link #getChannel} and
         * {@link #setChannel}.
         */ this._channel = $eKXi4.Token.DEFAULT_CHANNEL;
        /**
         * This is the backing field for `tokenIndex`.
         */ this.index = -1;
        this._text = text;
        this._type = type;
        this.source = source;
        this._channel = channel;
        this.start = start;
        this.stop = stop;
        if (source.source != null) {
            this._line = source.source.line;
            this._charPositionInLine = source.source.charPositionInLine;
        }
    }
    /**
     * Constructs a new {@link CommonToken} as a copy of another {@link Token}.
     *
     * If `oldToken` is also a {@link CommonToken} instance, the newly
     * constructed token will share a reference to the {@link #text} field and
     * the {@link Tuple2} stored in {@link #source}. Otherwise, {@link #text} will
     * be assigned the result of calling {@link #getText}, and {@link #source}
     * will be constructed from the result of {@link Token#getTokenSource} and
     * {@link Token#getInputStream}.
     *
     * @param oldToken The token to copy.
     */ static fromToken(oldToken) {
        let result = new CommonToken(oldToken.type, undefined, CommonToken.EMPTY_SOURCE, oldToken.channel, oldToken.startIndex, oldToken.stopIndex);
        result._line = oldToken.line;
        result.index = oldToken.tokenIndex;
        result._charPositionInLine = oldToken.charPositionInLine;
        if (oldToken instanceof CommonToken) {
            result._text = oldToken._text;
            result.source = oldToken.source;
        } else {
            result._text = oldToken.text;
            result.source = {
                source: oldToken.tokenSource,
                stream: oldToken.inputStream
            };
        }
        return result;
    }
    get type() {
        return this._type;
    }
    // @Override
    set type(type) {
        this._type = type;
    }
    get line() {
        return this._line;
    }
    // @Override
    set line(line) {
        this._line = line;
    }
    get text() {
        if (this._text != null) return this._text;
        let input = this.inputStream;
        if (input == null) return undefined;
        let n = input.size;
        if (this.start < n && this.stop < n) return input.getText($l8y5T.Interval.of(this.start, this.stop));
        else return "<EOF>";
    }
    /**
     * Explicitly set the text for this token. If {code text} is not
     * `undefined`, then {@link #getText} will return this value rather than
     * extracting the text from the input.
     *
     * @param text The explicit text of the token, or `undefined` if the text
     * should be obtained from the input along with the start and stop indexes
     * of the token.
     */ // @Override
    set text(text) {
        this._text = text;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    // @Override
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    get channel() {
        return this._channel;
    }
    // @Override
    set channel(channel) {
        this._channel = channel;
    }
    get startIndex() {
        return this.start;
    }
    set startIndex(start) {
        this.start = start;
    }
    get stopIndex() {
        return this.stop;
    }
    set stopIndex(stop) {
        this.stop = stop;
    }
    get tokenIndex() {
        return this.index;
    }
    // @Override
    set tokenIndex(index) {
        this.index = index;
    }
    get tokenSource() {
        return this.source.source;
    }
    get inputStream() {
        return this.source.stream;
    }
    toString(recognizer) {
        let channelStr = "";
        if (this._channel > 0) channelStr = ",channel=" + this._channel;
        let txt = this.text;
        if (txt != null) {
            txt = txt.replace(/\n/g, "\\n");
            txt = txt.replace(/\r/g, "\\r");
            txt = txt.replace(/\t/g, "\\t");
        } else txt = "<no text>";
        let typeString = String(this._type);
        if (recognizer) typeString = recognizer.vocabulary.getDisplayName(this._type);
        return "[@" + this.tokenIndex + "," + this.start + ":" + this.stop + "='" + txt + "',<" + typeString + ">" + channelStr + "," + this._line + ":" + this.charPositionInLine + "]";
    }
};
/**
 * An empty {@link Tuple2} which is used as the default value of
 * {@link #source} for tokens that do not have a source.
 */ $a954aa91d3b92162$var$CommonToken.EMPTY_SOURCE = {
    source: undefined,
    stream: undefined
};
$a954aa91d3b92162$var$__decorate([
    $aN41m.NotNull
], $a954aa91d3b92162$var$CommonToken.prototype, "source", void 0);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "type", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "line", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "text", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "charPositionInLine", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "channel", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "startIndex", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "stopIndex", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "tokenIndex", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "tokenSource", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "inputStream", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "toString", null);
$a954aa91d3b92162$var$__decorate([
    $a954aa91d3b92162$var$__param(0, $aN41m.NotNull)
], $a954aa91d3b92162$var$CommonToken, "fromToken", null);
$a954aa91d3b92162$var$CommonToken = $a954aa91d3b92162$var$__decorate([
    $a954aa91d3b92162$var$__param(2, $aN41m.NotNull)
], $a954aa91d3b92162$var$CommonToken);
module.exports.CommonToken = $a954aa91d3b92162$var$CommonToken;

});
parcelRegister("eKXi4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Token = void 0;

var $ldi9e = parcelRequire("ldi9e");
var $abe35a6f47a957ff$var$Token;
(function(Token) {
    Token.INVALID_TYPE = 0;
    /** During lookahead operations, this "token" signifies we hit rule end ATN state
     *  and did not follow it despite needing to.
     */ Token.EPSILON = -2;
    Token.MIN_USER_TOKEN_TYPE = 1;
    Token.EOF = $ldi9e.IntStream.EOF;
    /** All tokens go to the parser (unless skip() is called in that rule)
     *  on a particular "channel".  The parser tunes to a particular channel
     *  so that whitespace etc... can go to the parser on a "hidden" channel.
     */ Token.DEFAULT_CHANNEL = 0;
    /** Anything on different channel than DEFAULT_CHANNEL is not parsed
     *  by parser.
     */ Token.HIDDEN_CHANNEL = 1;
    /**
     * This is the minimum constant value which can be assigned to a
     * user-defined token channel.
     *
     * The non-negative numbers less than {@link #MIN_USER_CHANNEL_VALUE} are
     * assigned to the predefined channels {@link #DEFAULT_CHANNEL} and
     * {@link #HIDDEN_CHANNEL}.
     *
     * @see `Token.channel`
     */ Token.MIN_USER_CHANNEL_VALUE = 2;
})($abe35a6f47a957ff$var$Token = module.exports.Token || (module.exports.Token = {}));

});



parcelRegister("jB0DW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerStack = void 0;

var $eRSlM = parcelRequire("eRSlM");
/**
 *
 * @author Sam Harwell
 */ class $e441f8bbaf193f9f$var$IntegerStack extends $eRSlM.IntegerList {
    constructor(arg){
        super(arg);
    }
    push(value) {
        this.add(value);
    }
    pop() {
        return this.removeAt(this.size - 1);
    }
    peek() {
        return this.get(this.size - 1);
    }
}
module.exports.IntegerStack = $e441f8bbaf193f9f$var$IntegerStack;

});

parcelRegister("2160U", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $178056f04e0087b5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $178056f04e0087b5$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerATNSimulator = void 0;

var $hu8W9 = parcelRequire("hu8W9");

var $eeOLb = parcelRequire("eeOLb");

var $hdFz0 = parcelRequire("hdFz0");

var $2SGHL = parcelRequire("2SGHL");

var $ceQRA = parcelRequire("ceQRA");

var $6P9ap = parcelRequire("6P9ap");

var $l8y5T = parcelRequire("l8y5T");

var $ldi9e = parcelRequire("ldi9e");

var $h7Q3L = parcelRequire("h7Q3L");

var $i6TH4 = parcelRequire("i6TH4");

var $l3IpB = parcelRequire("l3IpB");

var $aN41m = parcelRequire("aN41m");

var $9O0ze = parcelRequire("9O0ze");

var $jaUCz = parcelRequire("jaUCz");

var $jWsYN = parcelRequire("jWsYN");

var $eKXi4 = parcelRequire("eKXi4");

var $fomfP = parcelRequire("fomfP");
/** "dup" of ParserInterpreter */ let $178056f04e0087b5$var$LexerATNSimulator = class LexerATNSimulator extends $ceQRA.ATNSimulator {
    constructor(atn, recog){
        super(atn);
        this.optimize_tail_calls = true;
        /** The current token's starting index into the character stream.
         *  Shared across DFA to ATN simulation in case the ATN fails and the
         *  DFA did not have a previous accept state. In this case, we use the
         *  ATN-generated exception object.
         */ this.startIndex = -1;
        /** line number 1..n within the input */ this._line = 1;
        /** The index of the character relative to the beginning of the line 0..n-1 */ this._charPositionInLine = 0;
        this.mode = $h7Q3L.Lexer.DEFAULT_MODE;
        /** Used during DFA/ATN exec to record the most recent accept configuration info */ this.prevAccept = new LexerATNSimulator.SimState();
        this.recog = recog;
    }
    copyState(simulator) {
        this._charPositionInLine = simulator.charPositionInLine;
        this._line = simulator._line;
        this.mode = simulator.mode;
        this.startIndex = simulator.startIndex;
    }
    match(input, mode) {
        this.mode = mode;
        let mark = input.mark();
        try {
            this.startIndex = input.index;
            this.prevAccept.reset();
            let s0 = this.atn.modeToDFA[mode].s0;
            if (s0 == null) return this.matchATN(input);
            else return this.execATN(input, s0);
        } finally{
            input.release(mark);
        }
    }
    reset() {
        this.prevAccept.reset();
        this.startIndex = -1;
        this._line = 1;
        this._charPositionInLine = 0;
        this.mode = $h7Q3L.Lexer.DEFAULT_MODE;
    }
    matchATN(input) {
        let startState = this.atn.modeToStartState[this.mode];
        if (LexerATNSimulator.debug) console.log(`matchATN mode ${this.mode} start: ${startState}`);
        let old_mode = this.mode;
        let s0_closure = this.computeStartState(input, startState);
        let suppressEdge = s0_closure.hasSemanticContext;
        if (suppressEdge) s0_closure.hasSemanticContext = false;
        let next = this.addDFAState(s0_closure);
        if (!suppressEdge) {
            let dfa = this.atn.modeToDFA[this.mode];
            if (!dfa.s0) dfa.s0 = next;
            else next = dfa.s0;
        }
        let predict = this.execATN(input, next);
        if (LexerATNSimulator.debug) console.log(`DFA after matchATN: ${this.atn.modeToDFA[old_mode].toLexerString()}`);
        return predict;
    }
    execATN(input, ds0) {
        // console.log("enter exec index "+input.index+" from "+ds0.configs);
        if (LexerATNSimulator.debug) console.log(`start state closure=${ds0.configs}`);
        if (ds0.isAcceptState) // allow zero-length tokens
        this.captureSimState(this.prevAccept, input, ds0);
        let t = input.LA(1);
        // @NotNull
        let s = ds0; // s is current/from DFA state
        while(true){
            if (LexerATNSimulator.debug) console.log(`execATN loop starting closure: ${s.configs}`);
            // As we move src->trg, src->trg, we keep track of the previous trg to
            // avoid looking up the DFA state again, which is expensive.
            // If the previous target was already part of the DFA, we might
            // be able to avoid doing a reach operation upon t. If s!=null,
            // it means that semantic predicates didn't prevent us from
            // creating a DFA state. Once we know s!=null, we check to see if
            // the DFA state has an edge already for t. If so, we can just reuse
            // it's configuration set; there's no point in re-computing it.
            // This is kind of like doing DFA simulation within the ATN
            // simulation because DFA simulation is really just a way to avoid
            // computing reach/closure sets. Technically, once we know that
            // we have a previously added DFA state, we could jump over to
            // the DFA simulator. But, that would mean popping back and forth
            // a lot and making things more complicated algorithmically.
            // This optimization makes a lot of sense for loops within DFA.
            // A character will take us back to an existing DFA state
            // that already has lots of edges out of it. e.g., .* in comments.
            let target = this.getExistingTargetState(s, t);
            if (target == null) target = this.computeTargetState(input, s, t);
            if (target === $ceQRA.ATNSimulator.ERROR) break;
            // If this is a consumable input element, make sure to consume before
            // capturing the accept state so the input index, line, and char
            // position accurately reflect the state of the interpreter at the
            // end of the token.
            if (t !== $ldi9e.IntStream.EOF) this.consume(input);
            if (target.isAcceptState) {
                this.captureSimState(this.prevAccept, input, target);
                if (t === $ldi9e.IntStream.EOF) break;
            }
            t = input.LA(1);
            s = target; // flip; current DFA target becomes new src/from state
        }
        return this.failOrAccept(this.prevAccept, input, s.configs, t);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        let target = s.getTarget(t);
        if (LexerATNSimulator.debug && target != null) console.log("reuse state " + s.stateNumber + " edge to " + target.stateNumber);
        return target;
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param input The input stream
     * @param s The current DFA state
     * @param t The next input symbol
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(input, s, t) {
        let reach = new $9O0ze.OrderedATNConfigSet();
        // if we don't find an existing DFA state
        // Fill reach starting from closure, following t transitions
        this.getReachableConfigSet(input, s.configs, reach, t);
        if (reach.isEmpty) {
            if (!reach.hasSemanticContext) // we got nowhere on t, don't throw out this knowledge; it'd
            // cause a failover from DFA later.
            this.addDFAEdge(s, t, $ceQRA.ATNSimulator.ERROR);
            // stop when we can't match any more char
            return $ceQRA.ATNSimulator.ERROR;
        }
        // Add an edge from s to target DFA found/created for reach
        return this.addDFAEdge(s, t, reach);
    }
    failOrAccept(prevAccept, input, reach, t) {
        if (prevAccept.dfaState != null) {
            let lexerActionExecutor = prevAccept.dfaState.lexerActionExecutor;
            this.accept(input, lexerActionExecutor, this.startIndex, prevAccept.index, prevAccept.line, prevAccept.charPos);
            return prevAccept.dfaState.prediction;
        } else {
            // if no accept and EOF is first char, return EOF
            if (t === $ldi9e.IntStream.EOF && input.index === this.startIndex) return $eKXi4.Token.EOF;
            throw new $l3IpB.LexerNoViableAltException(this.recog, input, this.startIndex, reach);
        }
    }
    /** Given a starting configuration set, figure out all ATN configurations
     *  we can reach upon input `t`. Parameter `reach` is a return
     *  parameter.
     */ getReachableConfigSet(input, closure, reach, t) {
        // this is used to skip processing for configs which have a lower priority
        // than a config that already reached an accept state for the same rule
        let skipAlt = $eeOLb.ATN.INVALID_ALT_NUMBER;
        for (let c of closure){
            let currentAltReachedAcceptState = c.alt === skipAlt;
            if (currentAltReachedAcceptState && c.hasPassedThroughNonGreedyDecision) continue;
            if (LexerATNSimulator.debug) console.log(`testing ${this.getTokenName(t)} at ${c.toString(this.recog, true)}`);
            let n = c.state.numberOfOptimizedTransitions;
            for(let ti = 0; ti < n; ti++){
                let trans = c.state.getOptimizedTransition(ti);
                let target = this.getReachableTarget(trans, t);
                if (target != null) {
                    let lexerActionExecutor = c.lexerActionExecutor;
                    let config;
                    if (lexerActionExecutor != null) {
                        lexerActionExecutor = lexerActionExecutor.fixOffsetBeforeMatch(input.index - this.startIndex);
                        config = c.transform(target, true, lexerActionExecutor);
                    } else {
                        $fomfP(c.lexerActionExecutor == null);
                        config = c.transform(target, true);
                    }
                    let treatEofAsEpsilon = t === $ldi9e.IntStream.EOF;
                    if (this.closure(input, config, reach, currentAltReachedAcceptState, true, treatEofAsEpsilon)) {
                        // any remaining configs for this alt have a lower priority than
                        // the one that just reached an accept state.
                        skipAlt = c.alt;
                        break;
                    }
                }
            }
        }
    }
    accept(input, lexerActionExecutor, startIndex, index, line, charPos) {
        if (LexerATNSimulator.debug) console.log(`ACTION ${lexerActionExecutor}`);
        // seek to after last char in token
        input.seek(index);
        this._line = line;
        this._charPositionInLine = charPos;
        if (lexerActionExecutor != null && this.recog != null) lexerActionExecutor.execute(this.recog, input, startIndex);
    }
    getReachableTarget(trans, t) {
        if (trans.matches(t, $h7Q3L.Lexer.MIN_CHAR_VALUE, $h7Q3L.Lexer.MAX_CHAR_VALUE)) return trans.target;
        return undefined;
    }
    computeStartState(input, p) {
        let initialContext = $jaUCz.PredictionContext.EMPTY_FULL;
        let configs = new $9O0ze.OrderedATNConfigSet();
        for(let i = 0; i < p.numberOfTransitions; i++){
            let target = p.transition(i).target;
            let c = $hdFz0.ATNConfig.create(target, i + 1, initialContext);
            this.closure(input, c, configs, false, false, false);
        }
        return configs;
    }
    /**
     * Since the alternatives within any lexer decision are ordered by
     * preference, this method stops pursuing the closure as soon as an accept
     * state is reached. After the first accept state is reached by depth-first
     * search from `config`, all other (potentially reachable) states for
     * this rule would have a lower priority.
     *
     * @returns `true` if an accept state is reached, otherwise
     * `false`.
     */ closure(input, config, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon) {
        if (LexerATNSimulator.debug) console.log("closure(" + config.toString(this.recog, true) + ")");
        if (config.state instanceof $jWsYN.RuleStopState) {
            if (LexerATNSimulator.debug) {
                if (this.recog != null) console.log(`closure at ${this.recog.ruleNames[config.state.ruleIndex]} rule stop ${config}`);
                else console.log(`closure at rule stop ${config}`);
            }
            let context = config.context;
            if (context.isEmpty) {
                configs.add(config);
                return true;
            } else if (context.hasEmpty) {
                configs.add(config.transform(config.state, true, $jaUCz.PredictionContext.EMPTY_FULL));
                currentAltReachedAcceptState = true;
            }
            for(let i = 0; i < context.size; i++){
                let returnStateNumber = context.getReturnState(i);
                if (returnStateNumber === $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                let newContext = context.getParent(i); // "pop" return state
                let returnState = this.atn.states[returnStateNumber];
                let c = config.transform(returnState, false, newContext);
                currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
            }
            return currentAltReachedAcceptState;
        }
        // optimization
        if (!config.state.onlyHasEpsilonTransitions) {
            if (!currentAltReachedAcceptState || !config.hasPassedThroughNonGreedyDecision) configs.add(config);
        }
        let p = config.state;
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            let t = p.getOptimizedTransition(i);
            let c = this.getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon);
            if (c != null) currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
        }
        return currentAltReachedAcceptState;
    }
    // side-effect: can alter configs.hasSemanticContext
    getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon) {
        let c;
        switch(t.serializationType){
            case 3 /* RULE */ :
                let ruleTransition = t;
                if (this.optimize_tail_calls && ruleTransition.optimizedTailCall && !config.context.hasEmpty) c = config.transform(t.target, true);
                else {
                    let newContext = config.context.getChild(ruleTransition.followState.stateNumber);
                    c = config.transform(t.target, true, newContext);
                }
                break;
            case 10 /* PRECEDENCE */ :
                throw new Error("Precedence predicates are not supported in lexers.");
            case 4 /* PREDICATE */ :
                /*  Track traversing semantic predicates. If we traverse,
                    we cannot add a DFA state for this "reach" computation
                    because the DFA would not test the predicate again in the
                    future. Rather than creating collections of semantic predicates
                    like v3 and testing them on prediction, v4 will test them on the
                    fly all the time using the ATN not the DFA. This is slower but
                    semantically it's not used that often. One of the key elements to
                    this predicate mechanism is not adding DFA states that see
                    predicates immediately afterwards in the ATN. For example,
    
                    a : ID {p1}? | ID {p2}? ;
    
                    should create the start state for rule 'a' (to save start state
                    competition), but should not create target of ID state. The
                    collection of ATN states the following ID references includes
                    states reached by traversing predicates. Since this is when we
                    test them, we cannot cash the DFA state target of ID.
                */ let pt = t;
                if (LexerATNSimulator.debug) console.log("EVAL rule " + pt.ruleIndex + ":" + pt.predIndex);
                configs.hasSemanticContext = true;
                if (this.evaluatePredicate(input, pt.ruleIndex, pt.predIndex, speculative)) c = config.transform(t.target, true);
                else c = undefined;
                break;
            case 6 /* ACTION */ :
                if (config.context.hasEmpty) {
                    // execute actions anywhere in the start rule for a token.
                    //
                    // TODO: if the entry rule is invoked recursively, some
                    // actions may be executed during the recursive call. The
                    // problem can appear when hasEmpty is true but
                    // isEmpty is false. In this case, the config needs to be
                    // split into two contexts - one with just the empty path
                    // and another with everything but the empty path.
                    // Unfortunately, the current algorithm does not allow
                    // getEpsilonTarget to return two configurations, so
                    // additional modifications are needed before we can support
                    // the split operation.
                    let lexerActionExecutor = $i6TH4.LexerActionExecutor.append(config.lexerActionExecutor, this.atn.lexerActions[t.actionIndex]);
                    c = config.transform(t.target, true, lexerActionExecutor);
                    break;
                } else {
                    // ignore actions in referenced rules
                    c = config.transform(t.target, true);
                    break;
                }
            case 1 /* EPSILON */ :
                c = config.transform(t.target, true);
                break;
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                if (treatEofAsEpsilon) {
                    if (t.matches($ldi9e.IntStream.EOF, $h7Q3L.Lexer.MIN_CHAR_VALUE, $h7Q3L.Lexer.MAX_CHAR_VALUE)) {
                        c = config.transform(t.target, false);
                        break;
                    }
                }
                c = undefined;
                break;
            default:
                c = undefined;
                break;
        }
        return c;
    }
    /**
     * Evaluate a predicate specified in the lexer.
     *
     * If `speculative` is `true`, this method was called before
     * {@link #consume} for the matched character. This method should call
     * {@link #consume} before evaluating the predicate to ensure position
     * sensitive values, including {@link Lexer#getText}, {@link Lexer#getLine},
     * and {@link Lexer#getCharPositionInLine}, properly reflect the current
     * lexer state. This method should restore `input` and the simulator
     * to the original state before returning (i.e. undo the actions made by the
     * call to {@link #consume}.
     *
     * @param input The input stream.
     * @param ruleIndex The rule containing the predicate.
     * @param predIndex The index of the predicate within the rule.
     * @param speculative `true` if the current index in `input` is
     * one character before the predicate's location.
     *
     * @returns `true` if the specified predicate evaluates to
     * `true`.
     */ evaluatePredicate(input, ruleIndex, predIndex, speculative) {
        // assume true if no recognizer was provided
        if (this.recog == null) return true;
        if (!speculative) return this.recog.sempred(undefined, ruleIndex, predIndex);
        let savedCharPositionInLine = this._charPositionInLine;
        let savedLine = this._line;
        let index = input.index;
        let marker = input.mark();
        try {
            this.consume(input);
            return this.recog.sempred(undefined, ruleIndex, predIndex);
        } finally{
            this._charPositionInLine = savedCharPositionInLine;
            this._line = savedLine;
            input.seek(index);
            input.release(marker);
        }
    }
    captureSimState(settings, input, dfaState) {
        settings.index = input.index;
        settings.line = this._line;
        settings.charPos = this._charPositionInLine;
        settings.dfaState = dfaState;
    }
    addDFAEdge(p, t, q) {
        if (q instanceof $2SGHL.ATNConfigSet) {
            /* leading to this call, ATNConfigSet.hasSemanticContext is used as a
            * marker indicating dynamic predicate evaluation makes this edge
            * dependent on the specific input sequence, so the static edge in the
            * DFA should be omitted. The target DFAState is still created since
            * execATN has the ability to resynchronize with the DFA state cache
            * following the predicate evaluation step.
            *
            * TJP notes: next time through the DFA, we see a pred again and eval.
            * If that gets us to a previously created (but dangling) DFA
            * state, we can continue in pure DFA mode from there.
            */ let suppressEdge = q.hasSemanticContext;
            if (suppressEdge) q.hasSemanticContext = false;
            // @NotNull
            let to = this.addDFAState(q);
            if (suppressEdge) return to;
            this.addDFAEdge(p, t, to);
            return to;
        } else {
            if (LexerATNSimulator.debug) console.log("EDGE " + p + " -> " + q + " upon " + String.fromCharCode(t));
            if (p != null) p.setTarget(t, q);
        }
    }
    /** Add a new DFA state if there isn't one with this set of
     * 	configurations already. This method also detects the first
     * 	configuration containing an ATN rule stop state. Later, when
     * 	traversing the DFA, we will know which rule to accept.
     */ addDFAState(configs) {
        /* the lexer evaluates predicates on-the-fly; by this point configs
         * should not contain any configurations with unevaluated predicates.
         */ $fomfP(!configs.hasSemanticContext);
        let proposed = new $6P9ap.DFAState(configs);
        let existing = this.atn.modeToDFA[this.mode].states.get(proposed);
        if (existing != null) return existing;
        configs.optimizeConfigs(this);
        let newState = new $6P9ap.DFAState(configs.clone(true));
        let firstConfigWithRuleStopState;
        for (let c of configs)if (c.state instanceof $jWsYN.RuleStopState) {
            firstConfigWithRuleStopState = c;
            break;
        }
        if (firstConfigWithRuleStopState != null) {
            let prediction = this.atn.ruleToTokenType[firstConfigWithRuleStopState.state.ruleIndex];
            let lexerActionExecutor = firstConfigWithRuleStopState.lexerActionExecutor;
            newState.acceptStateInfo = new $hu8W9.AcceptStateInfo(prediction, lexerActionExecutor);
        }
        return this.atn.modeToDFA[this.mode].addState(newState);
    }
    getDFA(mode) {
        return this.atn.modeToDFA[mode];
    }
    /** Get the text matched so far for the current token.
     */ getText(input) {
        // index is first lookahead char, don't include.
        return input.getText($l8y5T.Interval.of(this.startIndex, input.index - 1));
    }
    get line() {
        return this._line;
    }
    set line(line) {
        this._line = line;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    consume(input) {
        let curChar = input.LA(1);
        if (curChar === "\n".charCodeAt(0)) {
            this._line++;
            this._charPositionInLine = 0;
        } else this._charPositionInLine++;
        input.consume();
    }
    getTokenName(t) {
        if (t === -1) return "EOF";
        //if ( atn.g!=null ) return atn.g.getTokenDisplayName(t);
        return "'" + String.fromCharCode(t) + "'";
    }
};
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "prevAccept", void 0);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "copyState", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "match", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.Override
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "reset", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "matchATN", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "execATN", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "getExistingTargetState", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull,
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "computeTargetState", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(2, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "getReachableConfigSet", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "accept", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull,
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "computeStartState", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(2, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "closure", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(2, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(3, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "getEpsilonTarget", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "evaluatePredicate", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(2, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "captureSimState", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull,
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "addDFAState", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "getDFA", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull,
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "getText", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "consume", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "getTokenName", null);
$178056f04e0087b5$var$LexerATNSimulator = $178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator);
module.exports.LexerATNSimulator = $178056f04e0087b5$var$LexerATNSimulator;
(function(LexerATNSimulator) {
    LexerATNSimulator.debug = false;
    LexerATNSimulator.dfa_debug = false;
    /** When we hit an accept state in either the DFA or the ATN, we
     *  have to notify the character stream to start buffering characters
     *  via {@link IntStream#mark} and record the current state. The current sim state
     *  includes the current index into the input, the current line,
     *  and current character position in that line. Note that the Lexer is
     *  tracking the starting line and characterization of the token. These
     *  variables track the "state" of the simulator when it hits an accept state.
     *
     *  We track these variables separately for the DFA and ATN simulation
     *  because the DFA simulation often has to fail over to the ATN
     *  simulation. If the ATN simulation fails, we need the DFA to fall
     *  back to its previously accepted state, if any. If the ATN succeeds,
     *  then the ATN does the accept and the DFA simulator that invoked it
     *  can simply return the predicted token type.
     */ class SimState {
        constructor(){
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
        }
        reset() {
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
            this.dfaState = undefined;
        }
    }
    LexerATNSimulator.SimState = SimState;
})($178056f04e0087b5$var$LexerATNSimulator = module.exports.LexerATNSimulator || (module.exports.LexerATNSimulator = {}));
module.exports.LexerATNSimulator = $178056f04e0087b5$var$LexerATNSimulator;

});
parcelRegister("hu8W9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AcceptStateInfo = void 0;
/**
 * Stores information about a {@link DFAState} which is an accept state under
 * some condition. Certain settings, such as
 * {@link ParserATNSimulator#getPredictionMode()}, may be used in addition to
 * this information to determine whether or not a particular state is an accept
 * state.
 *
 * @author Sam Harwell
 */ class $cbac2bb2f6962aae$var$AcceptStateInfo {
    constructor(prediction, lexerActionExecutor){
        this._prediction = prediction;
        this._lexerActionExecutor = lexerActionExecutor;
    }
    /**
     * Gets the prediction made by this accept state. Note that this value
     * assumes the predicates, if any, in the {@link DFAState} evaluate to
     * `true`. If predicate evaluation is enabled, the final prediction of
     * the accept state will be determined by the result of predicate
     * evaluation.
     */ get prediction() {
        return this._prediction;
    }
    /**
     * Gets the {@link LexerActionExecutor} which can be used to execute actions
     * and/or commands after the lexer matches a token.
     */ get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
}
module.exports.AcceptStateInfo = $cbac2bb2f6962aae$var$AcceptStateInfo;

});

parcelRegister("eeOLb", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a5d9bf5b15739a51$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a5d9bf5b15739a51$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATN = void 0;

var $jRlcM = parcelRequire("jRlcM");

var $1Cdmr = parcelRequire("1Cdmr");

var $6kdz0 = parcelRequire("6kdz0");

var $8ii30 = parcelRequire("8ii30");

var $kUmff = parcelRequire("kUmff");

var $aN41m = parcelRequire("aN41m");

var $9eW9B = parcelRequire("9eW9B");

var $jaUCz = parcelRequire("jaUCz");

var $eKXi4 = parcelRequire("eKXi4");

var $fomfP = parcelRequire("fomfP");
/** */ let $a5d9bf5b15739a51$var$ATN = class ATN {
    /** Used for runtime deserialization of ATNs from strings */ constructor(grammarType, maxTokenType){
        this.states = [];
        /** Each subrule/rule is a decision point and we must track them so we
         *  can go back later and build DFA predictors for them.  This includes
         *  all the rules, subrules, optional blocks, ()+, ()* etc...
         */ this.decisionToState = [];
        this.modeNameToStartState = new Map();
        this.modeToStartState = [];
        this.contextCache = new $jRlcM.Array2DHashMap($9eW9B.ObjectEqualityComparator.INSTANCE);
        this.decisionToDFA = [];
        this.modeToDFA = [];
        this.LL1Table = new Map();
        this.grammarType = grammarType;
        this.maxTokenType = maxTokenType;
    }
    clearDFA() {
        this.decisionToDFA = new Array(this.decisionToState.length);
        for(let i = 0; i < this.decisionToDFA.length; i++)this.decisionToDFA[i] = new $1Cdmr.DFA(this.decisionToState[i], i);
        this.modeToDFA = new Array(this.modeToStartState.length);
        for(let i = 0; i < this.modeToDFA.length; i++)this.modeToDFA[i] = new $1Cdmr.DFA(this.modeToStartState[i]);
        this.contextCache.clear();
        this.LL1Table.clear();
    }
    get contextCacheSize() {
        return this.contextCache.size;
    }
    getCachedContext(context) {
        return $jaUCz.PredictionContext.getCachedContext(context, this.contextCache, new $jaUCz.PredictionContext.IdentityHashMap());
    }
    getDecisionToDFA() {
        $fomfP(this.decisionToDFA != null && this.decisionToDFA.length === this.decisionToState.length);
        return this.decisionToDFA;
    }
    nextTokens(s, ctx) {
        if (ctx) {
            let anal = new $kUmff.LL1Analyzer(this);
            let next = anal.LOOK(s, ctx);
            return next;
        } else {
            if (s.nextTokenWithinRule) return s.nextTokenWithinRule;
            s.nextTokenWithinRule = this.nextTokens(s, $jaUCz.PredictionContext.EMPTY_LOCAL);
            s.nextTokenWithinRule.setReadonly(true);
            return s.nextTokenWithinRule;
        }
    }
    addState(state) {
        state.atn = this;
        state.stateNumber = this.states.length;
        this.states.push(state);
    }
    removeState(state) {
        // just replace the state, don't shift states in list
        let invalidState = new $8ii30.InvalidState();
        invalidState.atn = this;
        invalidState.stateNumber = state.stateNumber;
        this.states[state.stateNumber] = invalidState;
    }
    defineMode(name, s) {
        this.modeNameToStartState.set(name, s);
        this.modeToStartState.push(s);
        this.modeToDFA.push(new $1Cdmr.DFA(s));
        this.defineDecisionState(s);
    }
    defineDecisionState(s) {
        this.decisionToState.push(s);
        s.decision = this.decisionToState.length - 1;
        this.decisionToDFA.push(new $1Cdmr.DFA(s, s.decision));
        return s.decision;
    }
    getDecisionState(decision) {
        if (this.decisionToState.length > 0) return this.decisionToState[decision];
        return undefined;
    }
    get numberOfDecisions() {
        return this.decisionToState.length;
    }
    /**
     * Computes the set of input symbols which could follow ATN state number
     * `stateNumber` in the specified full `context`. This method
     * considers the complete parser context, but does not evaluate semantic
     * predicates (i.e. all predicates encountered during the calculation are
     * assumed true). If a path in the ATN exists from the starting state to the
     * {@link RuleStopState} of the outermost context without matching any
     * symbols, {@link Token#EOF} is added to the returned set.
     *
     * If `context` is `undefined`, it is treated as
     * {@link ParserRuleContext#EMPTY}.
     *
     * Note that this does NOT give you the set of all tokens that could
     * appear at a given token position in the input phrase.  In other words, it
     * does not answer:
     *
     * > Given a specific partial input phrase, return the set of all
     * > tokens that can follow the last token in the input phrase.
     *
     * The big difference is that with just the input, the parser could land
     * right in the middle of a lookahead decision. Getting all
     * *possible* tokens given a partial input stream is a separate
     * computation. See https://github.com/antlr/antlr4/issues/1428
     *
     * For this function, we are specifying an ATN state and call stack to
     * compute what token(s) can come next and specifically: outside of a
     * lookahead decision. That is what you want for error reporting and
     * recovery upon parse error.
     *
     * @param stateNumber the ATN state number
     * @param context the full parse context
     * @returns The set of potentially valid input symbols which could follow the
     * specified state in the specified context.
     * @ if the ATN does not contain a state with
     * number `stateNumber`
     */ getExpectedTokens(stateNumber, context) {
        if (stateNumber < 0 || stateNumber >= this.states.length) throw new RangeError("Invalid state number.");
        let ctx = context;
        let s = this.states[stateNumber];
        let following = this.nextTokens(s);
        if (!following.contains($eKXi4.Token.EPSILON)) return following;
        let expected = new $6kdz0.IntervalSet();
        expected.addAll(following);
        expected.remove($eKXi4.Token.EPSILON);
        while(ctx != null && ctx.invokingState >= 0 && following.contains($eKXi4.Token.EPSILON)){
            let invokingState = this.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = this.nextTokens(rt.followState);
            expected.addAll(following);
            expected.remove($eKXi4.Token.EPSILON);
            ctx = ctx._parent;
        }
        if (following.contains($eKXi4.Token.EPSILON)) expected.add($eKXi4.Token.EOF);
        return expected;
    }
};
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "states", void 0);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "decisionToState", void 0);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "modeNameToStartState", void 0);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "modeToStartState", void 0);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "decisionToDFA", void 0);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "modeToDFA", void 0);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "nextTokens", null);
$a5d9bf5b15739a51$var$__decorate([
    $a5d9bf5b15739a51$var$__param(0, $aN41m.NotNull)
], $a5d9bf5b15739a51$var$ATN.prototype, "removeState", null);
$a5d9bf5b15739a51$var$__decorate([
    $a5d9bf5b15739a51$var$__param(0, $aN41m.NotNull),
    $a5d9bf5b15739a51$var$__param(1, $aN41m.NotNull)
], $a5d9bf5b15739a51$var$ATN.prototype, "defineMode", null);
$a5d9bf5b15739a51$var$__decorate([
    $a5d9bf5b15739a51$var$__param(0, $aN41m.NotNull)
], $a5d9bf5b15739a51$var$ATN.prototype, "defineDecisionState", null);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "getExpectedTokens", null);
$a5d9bf5b15739a51$var$ATN = $a5d9bf5b15739a51$var$__decorate([
    $a5d9bf5b15739a51$var$__param(0, $aN41m.NotNull)
], $a5d9bf5b15739a51$var$ATN);
module.exports.ATN = $a5d9bf5b15739a51$var$ATN;
(function(ATN) {
    ATN.INVALID_ALT_NUMBER = 0;
})($a5d9bf5b15739a51$var$ATN = module.exports.ATN || (module.exports.ATN = {}));
module.exports.ATN = $a5d9bf5b15739a51$var$ATN;

});
parcelRegister("jRlcM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashMap = void 0;

var $fsqYw = parcelRequire("fsqYw");
class $e7536a7825c78fd8$var$MapKeyEqualityComparator {
    constructor(keyComparator){
        this.keyComparator = keyComparator;
    }
    hashCode(obj) {
        return this.keyComparator.hashCode(obj.key);
    }
    equals(a, b) {
        return this.keyComparator.equals(a.key, b.key);
    }
}
class $e7536a7825c78fd8$var$Array2DHashMap {
    constructor(keyComparer){
        if (keyComparer instanceof $e7536a7825c78fd8$var$Array2DHashMap) this.backingStore = new $fsqYw.Array2DHashSet(keyComparer.backingStore);
        else this.backingStore = new $fsqYw.Array2DHashSet(new $e7536a7825c78fd8$var$MapKeyEqualityComparator(keyComparer));
    }
    clear() {
        this.backingStore.clear();
    }
    containsKey(key) {
        return this.backingStore.contains({
            key: key
        });
    }
    get(key) {
        let bucket = this.backingStore.get({
            key: key
        });
        if (!bucket) return undefined;
        return bucket.value;
    }
    get isEmpty() {
        return this.backingStore.isEmpty;
    }
    put(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else {
            result = element.value;
            element.value = value;
        }
        return result;
    }
    putIfAbsent(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else result = element.value;
        return result;
    }
    get size() {
        return this.backingStore.size;
    }
    hashCode() {
        return this.backingStore.hashCode();
    }
    equals(o) {
        if (!(o instanceof $e7536a7825c78fd8$var$Array2DHashMap)) return false;
        return this.backingStore.equals(o.backingStore);
    }
}
module.exports.Array2DHashMap = $e7536a7825c78fd8$var$Array2DHashMap;

});

parcelRegister("1Cdmr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $12d3b4406c1292f5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $12d3b4406c1292f5$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFA = void 0;

var $fsqYw = parcelRequire("fsqYw");

var $2SGHL = parcelRequire("2SGHL");

var $aVeml = parcelRequire("aVeml");

var $6P9ap = parcelRequire("6P9ap");

var $gwhAV = parcelRequire("gwhAV");

var $aN41m = parcelRequire("aN41m");

var $9eW9B = parcelRequire("9eW9B");

var $e0pjt = parcelRequire("e0pjt");

var $hBnE1 = parcelRequire("hBnE1");
let $12d3b4406c1292f5$var$DFA = class DFA {
    constructor(atnStartState, decision = 0){
        /**
         * A set of all states in the `DFA`.
         *
         * Note that this collection of states holds the DFA states for both SLL and LL prediction. Only the start state
         * needs to be differentiated for these cases, which is tracked by the `s0` and `s0full` fields.
         */ this.states = new $fsqYw.Array2DHashSet($9eW9B.ObjectEqualityComparator.INSTANCE);
        this.nextStateNumber = 0;
        if (!atnStartState.atn) throw new Error("The ATNState must be associated with an ATN");
        this.atnStartState = atnStartState;
        this.atn = atnStartState.atn;
        this.decision = decision;
        // Precedence DFAs are associated with the special precedence decision created for left-recursive rules which
        // evaluate their alternatives using a precedence hierarchy. When such a decision is encountered, we mark this
        // DFA instance as a precedence DFA and initialize the initial states s0 and s0full to special DFAState
        // instances which use outgoing edges to link to the actual start state used for each precedence level.
        let isPrecedenceDfa = false;
        if (atnStartState instanceof $e0pjt.StarLoopEntryState) {
            if (atnStartState.precedenceRuleDecision) {
                isPrecedenceDfa = true;
                this.s0 = new $6P9ap.DFAState(new $2SGHL.ATNConfigSet());
                this.s0full = new $6P9ap.DFAState(new $2SGHL.ATNConfigSet());
            }
        }
        this.precedenceDfa = isPrecedenceDfa;
    }
    /**
     * Gets whether this DFA is a precedence DFA. Precedence DFAs use a special
     * start state {@link #s0} which is not stored in {@link #states}. The
     * {@link DFAState#edges} array for this start state contains outgoing edges
     * supplying individual start states corresponding to specific precedence
     * values.
     *
     * @returns `true` if this is a precedence DFA; otherwise,
     * `false`.
     * @see Parser.precedence
     */ get isPrecedenceDfa() {
        return this.precedenceDfa;
    }
    /**
     * Get the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @returns The start state corresponding to the specified precedence, or
     * `undefined` if no start state exists for the specified precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ getPrecedenceStartState(precedence, fullContext) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        // s0 and s0full are never null for a precedence DFA
        if (fullContext) return this.s0full.getTarget(precedence);
        else return this.s0.getTarget(precedence);
    }
    /**
     * Set the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @param startState The start state corresponding to the specified
     * precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ setPrecedenceStartState(precedence, fullContext, startState) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        if (precedence < 0) return;
        if (fullContext) // s0full is never null for a precedence DFA
        this.s0full.setTarget(precedence, startState);
        else // s0 is never null for a precedence DFA
        this.s0.setTarget(precedence, startState);
    }
    get isEmpty() {
        if (this.isPrecedenceDfa) // s0 and s0full are never null for a precedence DFA
        return this.s0.getEdgeMap().size === 0 && this.s0full.getEdgeMap().size === 0;
        return this.s0 == null && this.s0full == null;
    }
    get isContextSensitive() {
        if (this.isPrecedenceDfa) // s0full is never null for a precedence DFA
        return this.s0full.getEdgeMap().size > 0;
        return this.s0full != null;
    }
    addState(state) {
        state.stateNumber = this.nextStateNumber++;
        return this.states.getOrAdd(state);
    }
    toString(vocabulary, ruleNames) {
        if (!vocabulary) vocabulary = $hBnE1.VocabularyImpl.EMPTY_VOCABULARY;
        if (!this.s0) return "";
        let serializer;
        if (ruleNames) serializer = new $aVeml.DFASerializer(this, vocabulary, ruleNames, this.atnStartState.atn);
        else serializer = new $aVeml.DFASerializer(this, vocabulary);
        return serializer.toString();
    }
    toLexerString() {
        if (!this.s0) return "";
        let serializer = new $gwhAV.LexerDFASerializer(this);
        return serializer.toString();
    }
};
$12d3b4406c1292f5$var$__decorate([
    $aN41m.NotNull
], $12d3b4406c1292f5$var$DFA.prototype, "states", void 0);
$12d3b4406c1292f5$var$__decorate([
    $aN41m.NotNull
], $12d3b4406c1292f5$var$DFA.prototype, "atnStartState", void 0);
$12d3b4406c1292f5$var$__decorate([
    $aN41m.NotNull
], $12d3b4406c1292f5$var$DFA.prototype, "atn", void 0);
$12d3b4406c1292f5$var$DFA = $12d3b4406c1292f5$var$__decorate([
    $12d3b4406c1292f5$var$__param(0, $aN41m.NotNull)
], $12d3b4406c1292f5$var$DFA);
module.exports.DFA = $12d3b4406c1292f5$var$DFA;

});
parcelRegister("2SGHL", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2191c0313d388677$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfigSet = void 0;

var $jRlcM = parcelRequire("jRlcM");

var $fsqYw = parcelRequire("fsqYw");

var $6iIjF = parcelRequire("6iIjF");

var $eeOLb = parcelRequire("eeOLb");

var $hdFz0 = parcelRequire("hdFz0");

var $8WIez = parcelRequire("8WIez");

var $aN41m = parcelRequire("aN41m");

var $9eW9B = parcelRequire("9eW9B");

var $jaUCz = parcelRequire("jaUCz");

var $4BvNW = parcelRequire("4BvNW");

var $3JS45 = parcelRequire("3JS45");

var $fomfP = parcelRequire("fomfP");

var $62Uvn = parcelRequire("62Uvn");
class $2191c0313d388677$var$KeyTypeEqualityComparer {
    hashCode(key) {
        return key.state ^ key.alt;
    }
    equals(a, b) {
        return a.state === b.state && a.alt === b.alt;
    }
}
$2191c0313d388677$var$KeyTypeEqualityComparer.INSTANCE = new $2191c0313d388677$var$KeyTypeEqualityComparer();
function $2191c0313d388677$var$NewKeyedConfigMap(map) {
    if (map) return new $jRlcM.Array2DHashMap(map);
    else return new $jRlcM.Array2DHashMap($2191c0313d388677$var$KeyTypeEqualityComparer.INSTANCE);
}
/**
 * Represents a set of ATN configurations (see `ATNConfig`). As configurations are added to the set, they are merged
 * with other `ATNConfig` instances already in the set when possible using the graph-structured stack.
 *
 * An instance of this class represents the complete set of positions (with context) in an ATN which would be associated
 * with a single DFA state. Its internal representation is more complex than traditional state used for NFA to DFA
 * conversion due to performance requirements (both improving speed and reducing memory overhead) as well as supporting
 * features such as semantic predicates and non-greedy operators in a form to support ANTLR's prediction algorithm.
 *
 * @author Sam Harwell
 */ class $2191c0313d388677$var$ATNConfigSet {
    constructor(set, readonly){
        this._uniqueAlt = 0;
        // Used in parser and lexer. In lexer, it indicates we hit a pred
        // while computing a closure operation.  Don't make a DFA state from this.
        this._hasSemanticContext = false;
        this._dipsIntoOuterContext = false;
        /**
         * When `true`, this config set represents configurations where the entire
         * outer context has been consumed by the ATN interpreter. This prevents the
         * {@link ParserATNSimulator#closure} from pursuing the global FOLLOW when a
         * rule stop state is reached with an empty prediction context.
         *
         * Note: `outermostConfigSet` and {@link #dipsIntoOuterContext} should never
         * be true at the same time.
         */ this.outermostConfigSet = false;
        this.cachedHashCode = -1;
        if (!set) {
            this.mergedConfigs = $2191c0313d388677$var$NewKeyedConfigMap();
            this.unmerged = [];
            this.configs = [];
            this._uniqueAlt = $eeOLb.ATN.INVALID_ALT_NUMBER;
        } else {
            if (readonly) {
                this.mergedConfigs = undefined;
                this.unmerged = undefined;
            } else if (!set.isReadOnly) {
                this.mergedConfigs = $2191c0313d388677$var$NewKeyedConfigMap(set.mergedConfigs);
                this.unmerged = set.unmerged.slice(0);
            } else {
                this.mergedConfigs = $2191c0313d388677$var$NewKeyedConfigMap();
                this.unmerged = [];
            }
            this.configs = set.configs.slice(0);
            this._dipsIntoOuterContext = set._dipsIntoOuterContext;
            this._hasSemanticContext = set._hasSemanticContext;
            this.outermostConfigSet = set.outermostConfigSet;
            if (readonly || !set.isReadOnly) {
                this._uniqueAlt = set._uniqueAlt;
                this._conflictInfo = set._conflictInfo;
            }
        // if (!readonly && set.isReadOnly) -> addAll is called from clone()
        }
    }
    /**
     * Get the set of all alternatives represented by configurations in this
     * set.
     */ getRepresentedAlternatives() {
        if (this._conflictInfo != null) return this._conflictInfo.conflictedAlts.clone();
        let alts = new $8WIez.BitSet();
        for (let config of this)alts.set(config.alt);
        return alts;
    }
    get isReadOnly() {
        return this.mergedConfigs == null;
    }
    get isOutermostConfigSet() {
        return this.outermostConfigSet;
    }
    set isOutermostConfigSet(outermostConfigSet) {
        if (this.outermostConfigSet && !outermostConfigSet) throw new Error("IllegalStateException");
        $fomfP(!outermostConfigSet || !this._dipsIntoOuterContext);
        this.outermostConfigSet = outermostConfigSet;
    }
    getStates() {
        let states = new $fsqYw.Array2DHashSet($9eW9B.ObjectEqualityComparator.INSTANCE);
        for (let c of this.configs)states.add(c.state);
        return states;
    }
    optimizeConfigs(interpreter) {
        if (this.configs.length === 0) return;
        for (let config of this.configs)config.context = interpreter.atn.getCachedContext(config.context);
    }
    clone(readonly) {
        let copy = new $2191c0313d388677$var$ATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this.configs);
        return copy;
    }
    get size() {
        return this.configs.length;
    }
    get isEmpty() {
        return this.configs.length === 0;
    }
    contains(o) {
        if (!(o instanceof $hdFz0.ATNConfig)) return false;
        if (this.mergedConfigs && this.unmerged) {
            let config = o;
            let configKey = this.getKey(config);
            let mergedConfig = this.mergedConfigs.get(configKey);
            if (mergedConfig != null && this.canMerge(config, configKey, mergedConfig)) return mergedConfig.contains(config);
            for (let c of this.unmerged){
                if (c.contains(o)) return true;
            }
        } else for (let c of this.configs){
            if (c.contains(o)) return true;
        }
        return false;
    }
    *[Symbol.iterator]() {
        yield* this.configs;
    }
    toArray() {
        return this.configs;
    }
    add(e, contextCache) {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        $fomfP(!this.outermostConfigSet || !e.reachesIntoOuterContext);
        if (contextCache == null) contextCache = $4BvNW.PredictionContextCache.UNCACHED;
        let addKey;
        let key = this.getKey(e);
        let mergedConfig = this.mergedConfigs.get(key);
        addKey = mergedConfig == null;
        if (mergedConfig != null && this.canMerge(e, key, mergedConfig)) {
            mergedConfig.outerContextDepth = Math.max(mergedConfig.outerContextDepth, e.outerContextDepth);
            if (e.isPrecedenceFilterSuppressed) mergedConfig.isPrecedenceFilterSuppressed = true;
            let joined = $jaUCz.PredictionContext.join(mergedConfig.context, e.context, contextCache);
            this.updatePropertiesForMergedConfig(e);
            if (mergedConfig.context === joined) return false;
            mergedConfig.context = joined;
            return true;
        }
        for(let i = 0; i < this.unmerged.length; i++){
            let unmergedConfig = this.unmerged[i];
            if (this.canMerge(e, key, unmergedConfig)) {
                unmergedConfig.outerContextDepth = Math.max(unmergedConfig.outerContextDepth, e.outerContextDepth);
                if (e.isPrecedenceFilterSuppressed) unmergedConfig.isPrecedenceFilterSuppressed = true;
                let joined = $jaUCz.PredictionContext.join(unmergedConfig.context, e.context, contextCache);
                this.updatePropertiesForMergedConfig(e);
                if (unmergedConfig.context === joined) return false;
                unmergedConfig.context = joined;
                if (addKey) {
                    this.mergedConfigs.put(key, unmergedConfig);
                    this.unmerged.splice(i, 1);
                }
                return true;
            }
        }
        this.configs.push(e);
        if (addKey) this.mergedConfigs.put(key, e);
        else this.unmerged.push(e);
        this.updatePropertiesForAddedConfig(e);
        return true;
    }
    updatePropertiesForMergedConfig(config) {
        // merged configs can't change the alt or semantic context
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $fomfP(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    updatePropertiesForAddedConfig(config) {
        if (this.configs.length === 1) this._uniqueAlt = config.alt;
        else if (this._uniqueAlt !== config.alt) this._uniqueAlt = $eeOLb.ATN.INVALID_ALT_NUMBER;
        this._hasSemanticContext = this._hasSemanticContext || !$3JS45.SemanticContext.NONE.equals(config.semanticContext);
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $fomfP(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    canMerge(left, leftKey, right) {
        if (left.state.stateNumber !== right.state.stateNumber) return false;
        if (leftKey.alt !== right.alt) return false;
        return left.semanticContext.equals(right.semanticContext);
    }
    getKey(e) {
        return {
            state: e.state.stateNumber,
            alt: e.alt
        };
    }
    containsAll(c) {
        for (let o of c){
            if (!(o instanceof $hdFz0.ATNConfig)) return false;
            if (!this.contains(o)) return false;
        }
        return true;
    }
    addAll(c, contextCache) {
        this.ensureWritable();
        let changed = false;
        for (let group of c)if (this.add(group, contextCache)) changed = true;
        return changed;
    }
    clear() {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        this.mergedConfigs.clear();
        this.unmerged.length = 0;
        this.configs.length = 0;
        this._dipsIntoOuterContext = false;
        this._hasSemanticContext = false;
        this._uniqueAlt = $eeOLb.ATN.INVALID_ALT_NUMBER;
        this._conflictInfo = undefined;
    }
    equals(obj) {
        if (this === obj) return true;
        if (!(obj instanceof $2191c0313d388677$var$ATNConfigSet)) return false;
        return this.outermostConfigSet === obj.outermostConfigSet && $62Uvn.equals(this._conflictInfo, obj._conflictInfo) && $6iIjF.ArrayEqualityComparator.INSTANCE.equals(this.configs, obj.configs);
    }
    hashCode() {
        if (this.isReadOnly && this.cachedHashCode !== -1) return this.cachedHashCode;
        let hashCode = 1;
        hashCode = 5 * hashCode ^ (this.outermostConfigSet ? 1 : 0);
        hashCode = 5 * hashCode ^ $6iIjF.ArrayEqualityComparator.INSTANCE.hashCode(this.configs);
        if (this.isReadOnly) this.cachedHashCode = hashCode;
        return hashCode;
    }
    toString(showContext) {
        if (showContext == null) showContext = false;
        let buf = "";
        let sortedConfigs = this.configs.slice(0);
        sortedConfigs.sort((o1, o2)=>{
            if (o1.alt !== o2.alt) return o1.alt - o2.alt;
            else if (o1.state.stateNumber !== o2.state.stateNumber) return o1.state.stateNumber - o2.state.stateNumber;
            else return o1.semanticContext.toString().localeCompare(o2.semanticContext.toString());
        });
        buf += "[";
        for(let i = 0; i < sortedConfigs.length; i++){
            if (i > 0) buf += ", ";
            buf += sortedConfigs[i].toString(undefined, true, showContext);
        }
        buf += "]";
        if (this._hasSemanticContext) buf += ",hasSemanticContext=" + this._hasSemanticContext;
        if (this._uniqueAlt !== $eeOLb.ATN.INVALID_ALT_NUMBER) buf += ",uniqueAlt=" + this._uniqueAlt;
        if (this._conflictInfo != null) {
            buf += ",conflictingAlts=" + this._conflictInfo.conflictedAlts;
            if (!this._conflictInfo.isExact) buf += "*";
        }
        if (this._dipsIntoOuterContext) buf += ",dipsIntoOuterContext";
        return buf.toString();
    }
    get uniqueAlt() {
        return this._uniqueAlt;
    }
    get hasSemanticContext() {
        return this._hasSemanticContext;
    }
    set hasSemanticContext(value) {
        this.ensureWritable();
        this._hasSemanticContext = value;
    }
    get conflictInfo() {
        return this._conflictInfo;
    }
    set conflictInfo(conflictInfo) {
        this.ensureWritable();
        this._conflictInfo = conflictInfo;
    }
    get conflictingAlts() {
        if (this._conflictInfo == null) return undefined;
        return this._conflictInfo.conflictedAlts;
    }
    get isExactConflict() {
        if (this._conflictInfo == null) return false;
        return this._conflictInfo.isExact;
    }
    get dipsIntoOuterContext() {
        return this._dipsIntoOuterContext;
    }
    get(index) {
        return this.configs[index];
    }
    ensureWritable() {
        if (this.isReadOnly) throw new Error("This ATNConfigSet is read only.");
    }
}
$2191c0313d388677$var$__decorate([
    $aN41m.NotNull
], $2191c0313d388677$var$ATNConfigSet.prototype, "getRepresentedAlternatives", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "size", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "isEmpty", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "contains", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, Symbol.iterator, null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "toArray", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "containsAll", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "clear", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "equals", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "hashCode", null);
module.exports.ATNConfigSet = $2191c0313d388677$var$ATNConfigSet;

});
parcelRegister("hdFz0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c893e436b255fe4f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c893e436b255fe4f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfig = void 0;

var $jRlcM = parcelRequire("jRlcM");

var $42ptv = parcelRequire("42ptv");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");

var $9eW9B = parcelRequire("9eW9B");

var $jaUCz = parcelRequire("jaUCz");

var $3JS45 = parcelRequire("3JS45");

var $fomfP = parcelRequire("fomfP");
/**
 * This field stores the bit mask for implementing the
 * {@link #isPrecedenceFilterSuppressed} property as a bit within the
 * existing {@link #altAndOuterContextDepth} field.
 */ const $c893e436b255fe4f$var$SUPPRESS_PRECEDENCE_FILTER = 0x80000000;
/**
 * Represents a location with context in an ATN. The location is identified by the following values:
 *
 * * The current ATN state
 * * The predicted alternative
 * * The semantic context which must be true for this configuration to be enabled
 * * The syntactic context, which is represented as a graph-structured stack whose path(s) lead to the root of the rule
 *   invocations leading to this state
 *
 * In addition to these values, `ATNConfig` stores several properties about paths taken to get to the location which
 * were added over time to help with performance, correctness, and/or debugging.
 *
 * * `reachesIntoOuterContext`:: Used to ensure semantic predicates are not evaluated in the wrong context.
 * * `hasPassedThroughNonGreedyDecision`: Used for enabling first-match-wins instead of longest-match-wins after
 *   crossing a non-greedy decision.
 * * `lexerActionExecutor`: Used for tracking the lexer action(s) to execute should this instance be selected during
 *   lexing.
 * * `isPrecedenceFilterSuppressed`: A state variable for one of the dynamic disambiguation strategies employed by
 *   `ParserATNSimulator.applyPrecedenceFilter`.
 *
 * Due to the use of a graph-structured stack, a single `ATNConfig` is capable of representing many individual ATN
 * configurations which reached the same location in an ATN by following different paths.
 *
 * PERF: To conserve memory, `ATNConfig` is split into several different concrete types. `ATNConfig` itself stores the
 * minimum amount of information typically used to define an `ATNConfig` instance. Various derived types provide
 * additional storage space for cases where a non-default value is used for some of the object properties. The
 * `ATNConfig.create` and `ATNConfig.transform` methods automatically select the smallest concrete type capable of
 * representing the unique information for any given `ATNConfig`.
 */ let $c893e436b255fe4f$var$ATNConfig = class ATNConfig {
    constructor(state, altOrConfig, context){
        if (typeof altOrConfig === "number") {
            $fomfP((altOrConfig & 0xFFFFFF) === altOrConfig);
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig;
            this._context = context;
        } else {
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig.altAndOuterContextDepth;
            this._context = context;
        }
    }
    static create(state, alt, context, semanticContext = $3JS45.SemanticContext.NONE, lexerActionExecutor) {
        if (semanticContext !== $3JS45.SemanticContext.NONE) {
            if (lexerActionExecutor != null) return new $c893e436b255fe4f$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, alt, context, false);
            else return new $c893e436b255fe4f$var$SemanticContextATNConfig(semanticContext, state, alt, context);
        } else if (lexerActionExecutor != null) return new $c893e436b255fe4f$var$ActionATNConfig(lexerActionExecutor, state, alt, context, false);
        else return new ATNConfig(state, alt, context);
    }
    /** Gets the ATN state associated with this configuration */ get state() {
        return this._state;
    }
    /** What alt (or lexer rule) is predicted by this configuration */ get alt() {
        return this.altAndOuterContextDepth & 0x00FFFFFF;
    }
    get context() {
        return this._context;
    }
    set context(context) {
        this._context = context;
    }
    get reachesIntoOuterContext() {
        return this.outerContextDepth !== 0;
    }
    /**
     * We cannot execute predicates dependent upon local context unless
     * we know for sure we are in the correct context. Because there is
     * no way to do this efficiently, we simply cannot evaluate
     * dependent predicates unless we are in the rule that initially
     * invokes the ATN simulator.
     *
     * closure() tracks the depth of how far we dip into the outer context:
     * depth &gt; 0.  Note that it may not be totally accurate depth since I
     * don't ever decrement. TODO: make it a boolean then
     */ get outerContextDepth() {
        return this.altAndOuterContextDepth >>> 24 & 0x7F;
    }
    set outerContextDepth(outerContextDepth) {
        $fomfP(outerContextDepth >= 0);
        // saturate at 0x7F - everything but zero/positive is only used for debug information anyway
        outerContextDepth = Math.min(outerContextDepth, 0x7F);
        this.altAndOuterContextDepth = outerContextDepth << 24 | (this.altAndOuterContextDepth & -2130706433) >>> 0;
    }
    get lexerActionExecutor() {
        return undefined;
    }
    get semanticContext() {
        return $3JS45.SemanticContext.NONE;
    }
    get hasPassedThroughNonGreedyDecision() {
        return false;
    }
    clone() {
        return this.transform(this.state, false);
    }
    transform(/*@NotNull*/ state, checkNonGreedy, arg2) {
        if (arg2 == null) return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $jaUCz.PredictionContext) return this.transformImpl(state, arg2, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $3JS45.SemanticContext) return this.transformImpl(state, this._context, arg2, checkNonGreedy, this.lexerActionExecutor);
        else return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, arg2);
    }
    transformImpl(state, context, semanticContext, checkNonGreedy, lexerActionExecutor) {
        let passedThroughNonGreedy = checkNonGreedy && ATNConfig.checkNonGreedyDecision(this, state);
        if (semanticContext !== $3JS45.SemanticContext.NONE) {
            if (lexerActionExecutor != null || passedThroughNonGreedy) return new $c893e436b255fe4f$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, this, context, passedThroughNonGreedy);
            else return new $c893e436b255fe4f$var$SemanticContextATNConfig(semanticContext, state, this, context);
        } else if (lexerActionExecutor != null || passedThroughNonGreedy) return new $c893e436b255fe4f$var$ActionATNConfig(lexerActionExecutor, state, this, context, passedThroughNonGreedy);
        else return new ATNConfig(state, this, context);
    }
    static checkNonGreedyDecision(source, target) {
        return source.hasPassedThroughNonGreedyDecision || target instanceof $42ptv.DecisionState && target.nonGreedy;
    }
    appendContext(context, contextCache) {
        if (typeof context === "number") {
            let appendedContext = this.context.appendSingleContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        } else {
            let appendedContext = this.context.appendContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        }
    }
    /**
     * Determines if this `ATNConfig` fully contains another `ATNConfig`.
     *
     * An ATN configuration represents a position (including context) in an ATN during parsing. Since `ATNConfig` stores
     * the context as a graph, a single `ATNConfig` instance is capable of representing many ATN configurations which
     * are all in the same "location" but have different contexts. These `ATNConfig` instances are again merged when
     * they are added to an `ATNConfigSet`. This method supports `ATNConfigSet.contains` by evaluating whether a
     * particular `ATNConfig` contains all of the ATN configurations represented by another `ATNConfig`.
     *
     * An `ATNConfig` _a_ contains another `ATNConfig` _b_ if all of the following conditions are met:
     *
     * * The configurations are in the same state (`state`)
     * * The configurations predict the same alternative (`alt`)
     * * The semantic context of _a_ implies the semantic context of _b_ (this method performs a weaker equality check)
     * * Joining the prediction contexts of _a_ and _b_ results in the prediction context of _a_
     *
     * This method implements a conservative approximation of containment. As a result, when this method returns `true`
     * it is known that parsing from `subconfig` can only recognize a subset of the inputs which can be recognized
     * starting at the current `ATNConfig`. However, due to the imprecise evaluation of implication for the semantic
     * contexts, no assumptions can be made about the relationship between the configurations when this method returns
     * `false`.
     *
     * @param subconfig The sub configuration.
     * @returns `true` if this configuration contains `subconfig`; otherwise, `false`.
     */ contains(subconfig) {
        if (this.state.stateNumber !== subconfig.state.stateNumber || this.alt !== subconfig.alt || !this.semanticContext.equals(subconfig.semanticContext)) return false;
        let leftWorkList = [];
        let rightWorkList = [];
        leftWorkList.push(this.context);
        rightWorkList.push(subconfig.context);
        while(true){
            let left = leftWorkList.pop();
            let right = rightWorkList.pop();
            if (!left || !right) break;
            if (left === right) return true;
            if (left.size < right.size) return false;
            if (right.isEmpty) return left.hasEmpty;
            else for(let i = 0; i < right.size; i++){
                let index = left.findReturnState(right.getReturnState(i));
                if (index < 0) // assumes invokingStates has no duplicate entries
                return false;
                leftWorkList.push(left.getParent(index));
                rightWorkList.push(right.getParent(i));
            }
        }
        return false;
    }
    get isPrecedenceFilterSuppressed() {
        return (this.altAndOuterContextDepth & $c893e436b255fe4f$var$SUPPRESS_PRECEDENCE_FILTER) !== 0;
    }
    set isPrecedenceFilterSuppressed(value) {
        if (value) this.altAndOuterContextDepth |= $c893e436b255fe4f$var$SUPPRESS_PRECEDENCE_FILTER;
        else this.altAndOuterContextDepth &= ~$c893e436b255fe4f$var$SUPPRESS_PRECEDENCE_FILTER;
    }
    /** An ATN configuration is equal to another if both have
     *  the same state, they predict the same alternative, and
     *  syntactic/semantic contexts are the same.
     */ equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ATNConfig)) return false;
        return this.state.stateNumber === o.state.stateNumber && this.alt === o.alt && this.reachesIntoOuterContext === o.reachesIntoOuterContext && this.context.equals(o.context) && this.semanticContext.equals(o.semanticContext) && this.isPrecedenceFilterSuppressed === o.isPrecedenceFilterSuppressed && this.hasPassedThroughNonGreedyDecision === o.hasPassedThroughNonGreedyDecision && $9eW9B.ObjectEqualityComparator.INSTANCE.equals(this.lexerActionExecutor, o.lexerActionExecutor);
    }
    hashCode() {
        let hashCode = $amQx9.MurmurHash.initialize(7);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.state.stateNumber);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.alt);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.reachesIntoOuterContext ? 1 : 0);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.context);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.semanticContext);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.hasPassedThroughNonGreedyDecision ? 1 : 0);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.lexerActionExecutor);
        hashCode = $amQx9.MurmurHash.finish(hashCode, 7);
        return hashCode;
    }
    /**
     * Returns a graphical representation of the current `ATNConfig` in Graphviz format. The graph can be stored to a
     * **.dot** file and then rendered to an image using Graphviz.
     *
     * @returns A Graphviz graph representing the current `ATNConfig`.
     *
     * @see http://www.graphviz.org/
     */ toDotString() {
        let builder = "";
        builder += "digraph G {\n";
        builder += "rankdir=LR;\n";
        let visited = new $jRlcM.Array2DHashMap($jaUCz.PredictionContext.IdentityEqualityComparator.INSTANCE);
        let workList = [];
        function getOrAddContext(context) {
            let newNumber = visited.size;
            let result = visited.putIfAbsent(context, newNumber);
            if (result != null) // Already saw this context
            return result;
            workList.push(context);
            return newNumber;
        }
        workList.push(this.context);
        visited.put(this.context, 0);
        while(true){
            let current = workList.pop();
            if (!current) break;
            for(let i = 0; i < current.size; i++){
                builder += "  s" + getOrAddContext(current);
                builder += "->";
                builder += "s" + getOrAddContext(current.getParent(i));
                builder += "[label=\"" + current.getReturnState(i) + "\"];\n";
            }
        }
        builder += "}\n";
        return builder.toString();
    }
    toString(recog, showAlt, showContext) {
        // Must check showContext before showAlt to preserve original overload behavior
        if (showContext == null) showContext = showAlt != null;
        if (showAlt == null) showAlt = true;
        let buf = "";
        // if (this.state.ruleIndex >= 0) {
        // 	if (recog != null) {
        // 		buf += (recog.ruleNames[this.state.ruleIndex] + ":");
        // 	} else {
        // 		buf += (this.state.ruleIndex + ":");
        // 	}
        // }
        let contexts;
        if (showContext) contexts = this.context.toStrings(recog, this.state.stateNumber);
        else contexts = [
            "?"
        ];
        let first = true;
        for (let contextDesc of contexts){
            if (first) first = false;
            else buf += ", ";
            buf += "(";
            buf += this.state;
            if (showAlt) {
                buf += ",";
                buf += this.alt;
            }
            if (this.context) {
                buf += ",";
                buf += contextDesc;
            }
            if (this.semanticContext !== $3JS45.SemanticContext.NONE) {
                buf += ",";
                buf += this.semanticContext;
            }
            if (this.reachesIntoOuterContext) buf += ",up=" + this.outerContextDepth;
            buf += ")";
        }
        return buf.toString();
    }
};
$c893e436b255fe4f$var$__decorate([
    $aN41m.NotNull
], $c893e436b255fe4f$var$ATNConfig.prototype, "_state", void 0);
$c893e436b255fe4f$var$__decorate([
    $aN41m.NotNull
], $c893e436b255fe4f$var$ATNConfig.prototype, "_context", void 0);
$c893e436b255fe4f$var$__decorate([
    $aN41m.NotNull
], $c893e436b255fe4f$var$ATNConfig.prototype, "state", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.NotNull,
    $c893e436b255fe4f$var$__param(0, $aN41m.NotNull)
], $c893e436b255fe4f$var$ATNConfig.prototype, "context", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.NotNull
], $c893e436b255fe4f$var$ATNConfig.prototype, "semanticContext", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ATNConfig.prototype, "clone", null);
$c893e436b255fe4f$var$__decorate([
    $c893e436b255fe4f$var$__param(0, $aN41m.NotNull),
    $c893e436b255fe4f$var$__param(2, $aN41m.NotNull)
], $c893e436b255fe4f$var$ATNConfig.prototype, "transformImpl", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ATNConfig.prototype, "equals", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ATNConfig.prototype, "hashCode", null);
$c893e436b255fe4f$var$__decorate([
    $c893e436b255fe4f$var$__param(0, $aN41m.NotNull),
    $c893e436b255fe4f$var$__param(3, $aN41m.NotNull)
], $c893e436b255fe4f$var$ATNConfig, "create", null);
$c893e436b255fe4f$var$ATNConfig = $c893e436b255fe4f$var$__decorate([
    $c893e436b255fe4f$var$__param(0, $aN41m.NotNull),
    $c893e436b255fe4f$var$__param(2, $aN41m.NotNull)
], $c893e436b255fe4f$var$ATNConfig);
module.exports.ATNConfig = $c893e436b255fe4f$var$ATNConfig;
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $c893e436b255fe4f$var$SemanticContextATNConfig = class SemanticContextATNConfig extends $c893e436b255fe4f$var$ATNConfig {
    constructor(semanticContext, state, altOrConfig, context){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else super(state, altOrConfig, context);
        this._semanticContext = semanticContext;
    }
    get semanticContext() {
        return this._semanticContext;
    }
};
$c893e436b255fe4f$var$__decorate([
    $aN41m.NotNull
], $c893e436b255fe4f$var$SemanticContextATNConfig.prototype, "_semanticContext", void 0);
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$SemanticContextATNConfig.prototype, "semanticContext", null);
$c893e436b255fe4f$var$SemanticContextATNConfig = $c893e436b255fe4f$var$__decorate([
    $c893e436b255fe4f$var$__param(1, $aN41m.NotNull),
    $c893e436b255fe4f$var$__param(2, $aN41m.NotNull)
], $c893e436b255fe4f$var$SemanticContextATNConfig);
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a lexer action.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $c893e436b255fe4f$var$ActionATNConfig = class ActionATNConfig extends $c893e436b255fe4f$var$ATNConfig {
    constructor(lexerActionExecutor, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else {
            super(state, altOrConfig, context);
            if (altOrConfig.semanticContext !== $3JS45.SemanticContext.NONE) throw new Error("Not supported");
        }
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
};
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ActionATNConfig.prototype, "lexerActionExecutor", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ActionATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$c893e436b255fe4f$var$ActionATNConfig = $c893e436b255fe4f$var$__decorate([
    $c893e436b255fe4f$var$__param(1, $aN41m.NotNull),
    $c893e436b255fe4f$var$__param(2, $aN41m.NotNull)
], $c893e436b255fe4f$var$ActionATNConfig);
/**
 * This class was derived from `SemanticContextATNConfig` purely as a memory optimization. It allows for the creation of
 * an `ATNConfig` with both a lexer action and a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $c893e436b255fe4f$var$ActionSemanticContextATNConfig = class ActionSemanticContextATNConfig extends $c893e436b255fe4f$var$SemanticContextATNConfig {
    constructor(lexerActionExecutor, semanticContext, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(semanticContext, state, altOrConfig, context);
        else super(semanticContext, state, altOrConfig, context);
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
};
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ActionSemanticContextATNConfig.prototype, "lexerActionExecutor", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ActionSemanticContextATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$c893e436b255fe4f$var$ActionSemanticContextATNConfig = $c893e436b255fe4f$var$__decorate([
    $c893e436b255fe4f$var$__param(1, $aN41m.NotNull),
    $c893e436b255fe4f$var$__param(2, $aN41m.NotNull)
], $c893e436b255fe4f$var$ActionSemanticContextATNConfig);

});
parcelRegister("42ptv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecisionState = void 0;

var $dv9vN = parcelRequire("dv9vN");
class $2f0b1c18dfdc93d3$var$DecisionState extends $dv9vN.ATNState {
    constructor(){
        super(...arguments);
        this.decision = -1;
        this.nonGreedy = false;
        this.sll = false;
    }
}
module.exports.DecisionState = $2f0b1c18dfdc93d3$var$DecisionState;

});

parcelRegister("jaUCz", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $df5adf3eeab6304c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $df5adf3eeab6304c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SingletonPredictionContext = module.exports.PredictionContext = void 0;

var $jRlcM = parcelRequire("jRlcM");

var $fsqYw = parcelRequire("fsqYw");

var $4dKou = parcelRequire("4dKou");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");

var $4BvNW = parcelRequire("4BvNW");

var $fomfP = parcelRequire("fomfP");
const $df5adf3eeab6304c$var$INITIAL_HASH = 1;
class $df5adf3eeab6304c$var$PredictionContext {
    constructor(cachedHashCode){
        this.cachedHashCode = cachedHashCode;
    }
    static calculateEmptyHashCode() {
        let hash = $amQx9.MurmurHash.initialize($df5adf3eeab6304c$var$INITIAL_HASH);
        hash = $amQx9.MurmurHash.finish(hash, 0);
        return hash;
    }
    static calculateSingleHashCode(parent, returnState) {
        let hash = $amQx9.MurmurHash.initialize($df5adf3eeab6304c$var$INITIAL_HASH);
        hash = $amQx9.MurmurHash.update(hash, parent);
        hash = $amQx9.MurmurHash.update(hash, returnState);
        hash = $amQx9.MurmurHash.finish(hash, 2);
        return hash;
    }
    static calculateHashCode(parents, returnStates) {
        let hash = $amQx9.MurmurHash.initialize($df5adf3eeab6304c$var$INITIAL_HASH);
        for (let parent of parents)hash = $amQx9.MurmurHash.update(hash, parent);
        for (let returnState of returnStates)hash = $amQx9.MurmurHash.update(hash, returnState);
        hash = $amQx9.MurmurHash.finish(hash, 2 * parents.length);
        return hash;
    }
    static fromRuleContext(atn, outerContext, fullContext = true) {
        if (outerContext.isEmpty) return fullContext ? $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL : $df5adf3eeab6304c$var$PredictionContext.EMPTY_LOCAL;
        let parent;
        if (outerContext._parent) parent = $df5adf3eeab6304c$var$PredictionContext.fromRuleContext(atn, outerContext._parent, fullContext);
        else parent = fullContext ? $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL : $df5adf3eeab6304c$var$PredictionContext.EMPTY_LOCAL;
        let state = atn.states[outerContext.invokingState];
        let transition = state.transition(0);
        return parent.getChild(transition.followState.stateNumber);
    }
    static addEmptyContext(context) {
        return context.addEmptyContext();
    }
    static removeEmptyContext(context) {
        return context.removeEmptyContext();
    }
    static join(context0, context1, contextCache = $4BvNW.PredictionContextCache.UNCACHED) {
        if (context0 === context1) return context0;
        if (context0.isEmpty) return $df5adf3eeab6304c$var$PredictionContext.isEmptyLocal(context0) ? context0 : $df5adf3eeab6304c$var$PredictionContext.addEmptyContext(context1);
        else if (context1.isEmpty) return $df5adf3eeab6304c$var$PredictionContext.isEmptyLocal(context1) ? context1 : $df5adf3eeab6304c$var$PredictionContext.addEmptyContext(context0);
        let context0size = context0.size;
        let context1size = context1.size;
        if (context0size === 1 && context1size === 1 && context0.getReturnState(0) === context1.getReturnState(0)) {
            let merged = contextCache.join(context0.getParent(0), context1.getParent(0));
            if (merged === context0.getParent(0)) return context0;
            else if (merged === context1.getParent(0)) return context1;
            else return merged.getChild(context0.getReturnState(0));
        }
        let count = 0;
        let parentsList = new Array(context0size + context1size);
        let returnStatesList = new Array(parentsList.length);
        let leftIndex = 0;
        let rightIndex = 0;
        let canReturnLeft = true;
        let canReturnRight = true;
        while(leftIndex < context0size && rightIndex < context1size){
            if (context0.getReturnState(leftIndex) === context1.getReturnState(rightIndex)) {
                parentsList[count] = contextCache.join(context0.getParent(leftIndex), context1.getParent(rightIndex));
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnLeft = canReturnLeft && parentsList[count] === context0.getParent(leftIndex);
                canReturnRight = canReturnRight && parentsList[count] === context1.getParent(rightIndex);
                leftIndex++;
                rightIndex++;
            } else if (context0.getReturnState(leftIndex) < context1.getReturnState(rightIndex)) {
                parentsList[count] = context0.getParent(leftIndex);
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnRight = false;
                leftIndex++;
            } else {
                $fomfP(context1.getReturnState(rightIndex) < context0.getReturnState(leftIndex));
                parentsList[count] = context1.getParent(rightIndex);
                returnStatesList[count] = context1.getReturnState(rightIndex);
                canReturnLeft = false;
                rightIndex++;
            }
            count++;
        }
        while(leftIndex < context0size){
            parentsList[count] = context0.getParent(leftIndex);
            returnStatesList[count] = context0.getReturnState(leftIndex);
            leftIndex++;
            canReturnRight = false;
            count++;
        }
        while(rightIndex < context1size){
            parentsList[count] = context1.getParent(rightIndex);
            returnStatesList[count] = context1.getReturnState(rightIndex);
            rightIndex++;
            canReturnLeft = false;
            count++;
        }
        if (canReturnLeft) return context0;
        else if (canReturnRight) return context1;
        if (count < parentsList.length) {
            parentsList = parentsList.slice(0, count);
            returnStatesList = returnStatesList.slice(0, count);
        }
        if (parentsList.length === 0) // if one of them was EMPTY_LOCAL, it would be empty and handled at the beginning of the method
        return $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL;
        else if (parentsList.length === 1) return new $df5adf3eeab6304c$var$SingletonPredictionContext(parentsList[0], returnStatesList[0]);
        else return new $df5adf3eeab6304c$var$ArrayPredictionContext(parentsList, returnStatesList);
    }
    static isEmptyLocal(context) {
        return context === $df5adf3eeab6304c$var$PredictionContext.EMPTY_LOCAL;
    }
    static getCachedContext(context, contextCache, visited) {
        if (context.isEmpty) return context;
        let existing = visited.get(context);
        if (existing) return existing;
        existing = contextCache.get(context);
        if (existing) {
            visited.put(context, existing);
            return existing;
        }
        let changed = false;
        let parents = new Array(context.size);
        for(let i = 0; i < parents.length; i++){
            let parent = $df5adf3eeab6304c$var$PredictionContext.getCachedContext(context.getParent(i), contextCache, visited);
            if (changed || parent !== context.getParent(i)) {
                if (!changed) {
                    parents = new Array(context.size);
                    for(let j = 0; j < context.size; j++)parents[j] = context.getParent(j);
                    changed = true;
                }
                parents[i] = parent;
            }
        }
        if (!changed) {
            existing = contextCache.putIfAbsent(context, context);
            visited.put(context, existing != null ? existing : context);
            return context;
        }
        // We know parents.length>0 because context.isEmpty is checked at the beginning of the method.
        let updated;
        if (parents.length === 1) updated = new $df5adf3eeab6304c$var$SingletonPredictionContext(parents[0], context.getReturnState(0));
        else {
            let returnStates = new Array(context.size);
            for(let i = 0; i < context.size; i++)returnStates[i] = context.getReturnState(i);
            updated = new $df5adf3eeab6304c$var$ArrayPredictionContext(parents, returnStates, context.hashCode());
        }
        existing = contextCache.putIfAbsent(updated, updated);
        visited.put(updated, existing || updated);
        visited.put(context, existing || updated);
        return updated;
    }
    appendSingleContext(returnContext, contextCache) {
        return this.appendContext($df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL.getChild(returnContext), contextCache);
    }
    getChild(returnState) {
        return new $df5adf3eeab6304c$var$SingletonPredictionContext(this, returnState);
    }
    hashCode() {
        return this.cachedHashCode;
    }
    toStrings(recognizer, currentState, stop = $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL) {
        let result = [];
        outer: for(let perm = 0;; perm++){
            let offset = 0;
            let last = true;
            let p = this;
            let stateNumber = currentState;
            let localBuffer = "";
            localBuffer += "[";
            while(!p.isEmpty && p !== stop){
                let index = 0;
                if (p.size > 0) {
                    let bits = 1;
                    while(1 << bits >>> 0 < p.size)bits++;
                    let mask = (1 << bits >>> 0) - 1;
                    index = perm >> offset & mask;
                    last = last && index >= p.size - 1;
                    if (index >= p.size) continue outer;
                    offset += bits;
                }
                if (recognizer) {
                    if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                    localBuffer += " ";
                    let atn = recognizer.atn;
                    let s = atn.states[stateNumber];
                    let ruleName = recognizer.ruleNames[s.ruleIndex];
                    localBuffer += ruleName;
                } else if (p.getReturnState(index) !== $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL_STATE_KEY) {
                    if (!p.isEmpty) {
                        if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                        localBuffer += " ";
                        localBuffer += p.getReturnState(index);
                    }
                }
                stateNumber = p.getReturnState(index);
                p = p.getParent(index);
            }
            localBuffer += "]";
            result.push(localBuffer);
            if (last) break;
        }
        return result;
    }
}
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$PredictionContext.prototype, "hashCode", null);
$df5adf3eeab6304c$var$__decorate([
    $df5adf3eeab6304c$var$__param(0, $aN41m.NotNull),
    $df5adf3eeab6304c$var$__param(1, $aN41m.NotNull),
    $df5adf3eeab6304c$var$__param(2, $aN41m.NotNull)
], $df5adf3eeab6304c$var$PredictionContext, "join", null);
$df5adf3eeab6304c$var$__decorate([
    $df5adf3eeab6304c$var$__param(0, $aN41m.NotNull),
    $df5adf3eeab6304c$var$__param(1, $aN41m.NotNull),
    $df5adf3eeab6304c$var$__param(2, $aN41m.NotNull)
], $df5adf3eeab6304c$var$PredictionContext, "getCachedContext", null);
module.exports.PredictionContext = $df5adf3eeab6304c$var$PredictionContext;
class $df5adf3eeab6304c$var$EmptyPredictionContext extends $df5adf3eeab6304c$var$PredictionContext {
    constructor(fullContext){
        super($df5adf3eeab6304c$var$PredictionContext.calculateEmptyHashCode());
        this.fullContext = fullContext;
    }
    get isFullContext() {
        return this.fullContext;
    }
    addEmptyContext() {
        return this;
    }
    removeEmptyContext() {
        throw new Error("Cannot remove the empty context from itself.");
    }
    getParent(index) {
        throw new Error("index out of bounds");
    }
    getReturnState(index) {
        throw new Error("index out of bounds");
    }
    findReturnState(returnState) {
        return -1;
    }
    get size() {
        return 0;
    }
    appendSingleContext(returnContext, contextCache) {
        return contextCache.getChild(this, returnContext);
    }
    appendContext(suffix, contextCache) {
        return suffix;
    }
    get isEmpty() {
        return true;
    }
    get hasEmpty() {
        return true;
    }
    equals(o) {
        return this === o;
    }
    toStrings(recognizer, currentState, stop) {
        return [
            "[]"
        ];
    }
}
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "addEmptyContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "removeEmptyContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "getParent", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "getReturnState", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "findReturnState", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "size", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "appendSingleContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "appendContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "isEmpty", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "hasEmpty", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "equals", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "toStrings", null);
let $df5adf3eeab6304c$var$ArrayPredictionContext = class ArrayPredictionContext extends $df5adf3eeab6304c$var$PredictionContext {
    constructor(parents, returnStates, hashCode){
        super(hashCode || $df5adf3eeab6304c$var$PredictionContext.calculateHashCode(parents, returnStates));
        $fomfP(parents.length === returnStates.length);
        $fomfP(returnStates.length > 1 || returnStates[0] !== $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL_STATE_KEY, "Should be using PredictionContext.EMPTY instead.");
        this.parents = parents;
        this.returnStates = returnStates;
    }
    getParent(index) {
        return this.parents[index];
    }
    getReturnState(index) {
        return this.returnStates[index];
    }
    findReturnState(returnState) {
        return $4dKou.Arrays.binarySearch(this.returnStates, returnState);
    }
    get size() {
        return this.returnStates.length;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return this.returnStates[this.returnStates.length - 1] === $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL_STATE_KEY;
    }
    addEmptyContext() {
        if (this.hasEmpty) return this;
        let parents2 = this.parents.slice(0);
        let returnStates2 = this.returnStates.slice(0);
        parents2.push($df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL);
        returnStates2.push($df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL_STATE_KEY);
        return new ArrayPredictionContext(parents2, returnStates2);
    }
    removeEmptyContext() {
        if (!this.hasEmpty) return this;
        if (this.returnStates.length === 2) return new $df5adf3eeab6304c$var$SingletonPredictionContext(this.parents[0], this.returnStates[0]);
        else {
            let parents2 = this.parents.slice(0, this.parents.length - 1);
            let returnStates2 = this.returnStates.slice(0, this.returnStates.length - 1);
            return new ArrayPredictionContext(parents2, returnStates2);
        }
    }
    appendContext(suffix, contextCache) {
        return ArrayPredictionContext.appendContextImpl(this, suffix, new $df5adf3eeab6304c$var$PredictionContext.IdentityHashMap());
    }
    static appendContextImpl(context, suffix, visited) {
        if (suffix.isEmpty) {
            if ($df5adf3eeab6304c$var$PredictionContext.isEmptyLocal(suffix)) {
                if (context.hasEmpty) return $df5adf3eeab6304c$var$PredictionContext.EMPTY_LOCAL;
                throw new Error("what to do here?");
            }
            return context;
        }
        if (suffix.size !== 1) throw new Error("Appending a tree suffix is not yet supported.");
        let result = visited.get(context);
        if (!result) {
            if (context.isEmpty) result = suffix;
            else {
                let parentCount = context.size;
                if (context.hasEmpty) parentCount--;
                let updatedParents = new Array(parentCount);
                let updatedReturnStates = new Array(parentCount);
                for(let i = 0; i < parentCount; i++)updatedReturnStates[i] = context.getReturnState(i);
                for(let i = 0; i < parentCount; i++)updatedParents[i] = ArrayPredictionContext.appendContextImpl(context.getParent(i), suffix, visited);
                if (updatedParents.length === 1) result = new $df5adf3eeab6304c$var$SingletonPredictionContext(updatedParents[0], updatedReturnStates[0]);
                else {
                    $fomfP(updatedParents.length > 1);
                    result = new ArrayPredictionContext(updatedParents, updatedReturnStates);
                }
                if (context.hasEmpty) result = $df5adf3eeab6304c$var$PredictionContext.join(result, suffix);
            }
            visited.put(context, result);
        }
        return result;
    }
    equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ArrayPredictionContext)) return false;
        if (this.hashCode() !== o.hashCode()) // can't be same if hash is different
        return false;
        let other = o;
        return this.equalsImpl(other, new $fsqYw.Array2DHashSet());
    }
    equalsImpl(other, visited) {
        let selfWorkList = [];
        let otherWorkList = [];
        selfWorkList.push(this);
        otherWorkList.push(other);
        while(true){
            let currentSelf = selfWorkList.pop();
            let currentOther = otherWorkList.pop();
            if (!currentSelf || !currentOther) break;
            let operands = new $4BvNW.PredictionContextCache.IdentityCommutativePredictionContextOperands(currentSelf, currentOther);
            if (!visited.add(operands)) continue;
            let selfSize = operands.x.size;
            if (selfSize === 0) {
                if (!operands.x.equals(operands.y)) return false;
                continue;
            }
            let otherSize = operands.y.size;
            if (selfSize !== otherSize) return false;
            for(let i = 0; i < selfSize; i++){
                if (operands.x.getReturnState(i) !== operands.y.getReturnState(i)) return false;
                let selfParent = operands.x.getParent(i);
                let otherParent = operands.y.getParent(i);
                if (selfParent.hashCode() !== otherParent.hashCode()) return false;
                if (selfParent !== otherParent) {
                    selfWorkList.push(selfParent);
                    otherWorkList.push(otherParent);
                }
            }
        }
        return true;
    }
};
$df5adf3eeab6304c$var$__decorate([
    $aN41m.NotNull
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "parents", void 0);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.NotNull
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "returnStates", void 0);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "getParent", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "getReturnState", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "findReturnState", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "size", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "isEmpty", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "hasEmpty", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "addEmptyContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "removeEmptyContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "appendContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "equals", null);
$df5adf3eeab6304c$var$ArrayPredictionContext = $df5adf3eeab6304c$var$__decorate([
    $df5adf3eeab6304c$var$__param(0, $aN41m.NotNull)
], $df5adf3eeab6304c$var$ArrayPredictionContext);
let $df5adf3eeab6304c$var$SingletonPredictionContext = class SingletonPredictionContext extends $df5adf3eeab6304c$var$PredictionContext {
    constructor(parent, returnState){
        super($df5adf3eeab6304c$var$PredictionContext.calculateSingleHashCode(parent, returnState));
        // assert(returnState != PredictionContext.EMPTY_FULL_STATE_KEY && returnState != PredictionContext.EMPTY_LOCAL_STATE_KEY);
        this.parent = parent;
        this.returnState = returnState;
    }
    getParent(index) {
        // assert(index == 0);
        return this.parent;
    }
    getReturnState(index) {
        // assert(index == 0);
        return this.returnState;
    }
    findReturnState(returnState) {
        return this.returnState === returnState ? 0 : -1;
    }
    get size() {
        return 1;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return false;
    }
    appendContext(suffix, contextCache) {
        return contextCache.getChild(this.parent.appendContext(suffix, contextCache), this.returnState);
    }
    addEmptyContext() {
        let parents = [
            this.parent,
            $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL
        ];
        let returnStates = [
            this.returnState,
            $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL_STATE_KEY
        ];
        return new $df5adf3eeab6304c$var$ArrayPredictionContext(parents, returnStates);
    }
    removeEmptyContext() {
        return this;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof SingletonPredictionContext)) return false;
        let other = o;
        if (this.hashCode() !== other.hashCode()) return false;
        return this.returnState === other.returnState && this.parent.equals(other.parent);
    }
};
$df5adf3eeab6304c$var$__decorate([
    $aN41m.NotNull
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "parent", void 0);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "getParent", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "getReturnState", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "findReturnState", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "size", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "isEmpty", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "hasEmpty", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "appendContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "addEmptyContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "removeEmptyContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "equals", null);
$df5adf3eeab6304c$var$SingletonPredictionContext = $df5adf3eeab6304c$var$__decorate([
    $df5adf3eeab6304c$var$__param(0, $aN41m.NotNull)
], $df5adf3eeab6304c$var$SingletonPredictionContext);
module.exports.SingletonPredictionContext = $df5adf3eeab6304c$var$SingletonPredictionContext;
(function(PredictionContext) {
    PredictionContext.EMPTY_LOCAL = new $df5adf3eeab6304c$var$EmptyPredictionContext(false);
    PredictionContext.EMPTY_FULL = new $df5adf3eeab6304c$var$EmptyPredictionContext(true);
    PredictionContext.EMPTY_LOCAL_STATE_KEY = -2147483648;
    PredictionContext.EMPTY_FULL_STATE_KEY = 2147483647;
    class IdentityHashMap extends $jRlcM.Array2DHashMap {
        constructor(){
            super(IdentityEqualityComparator.INSTANCE);
        }
    }
    PredictionContext.IdentityHashMap = IdentityHashMap;
    class IdentityEqualityComparator {
        IdentityEqualityComparator() {
        // intentionally empty
        }
        hashCode(obj) {
            return obj.hashCode();
        }
        equals(a, b) {
            return a === b;
        }
    }
    IdentityEqualityComparator.INSTANCE = new IdentityEqualityComparator();
    $df5adf3eeab6304c$var$__decorate([
        $aN41m.Override
    ], IdentityEqualityComparator.prototype, "hashCode", null);
    $df5adf3eeab6304c$var$__decorate([
        $aN41m.Override
    ], IdentityEqualityComparator.prototype, "equals", null);
    PredictionContext.IdentityEqualityComparator = IdentityEqualityComparator;
})($df5adf3eeab6304c$var$PredictionContext = module.exports.PredictionContext || (module.exports.PredictionContext = {}));

});
parcelRegister("4BvNW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $35a349d4d8246799$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionContextCache = void 0;

var $jRlcM = parcelRequire("jRlcM");

var $aN41m = parcelRequire("aN41m");

var $9eW9B = parcelRequire("9eW9B");

var $jaUCz = parcelRequire("jaUCz");

var $fomfP = parcelRequire("fomfP");
/** Used to cache {@link PredictionContext} objects. Its used for the shared
 *  context cash associated with contexts in DFA states. This cache
 *  can be used for both lexers and parsers.
 *
 * @author Sam Harwell
 */ class $35a349d4d8246799$var$PredictionContextCache {
    constructor(enableCache = true){
        this.contexts = new $jRlcM.Array2DHashMap($9eW9B.ObjectEqualityComparator.INSTANCE);
        this.childContexts = new $jRlcM.Array2DHashMap($9eW9B.ObjectEqualityComparator.INSTANCE);
        this.joinContexts = new $jRlcM.Array2DHashMap($9eW9B.ObjectEqualityComparator.INSTANCE);
        this.enableCache = enableCache;
    }
    getAsCached(context) {
        if (!this.enableCache) return context;
        let result = this.contexts.get(context);
        if (!result) {
            result = context;
            this.contexts.put(context, context);
        }
        return result;
    }
    getChild(context, invokingState) {
        if (!this.enableCache) return context.getChild(invokingState);
        let operands = new $35a349d4d8246799$var$PredictionContextCache.PredictionContextAndInt(context, invokingState);
        let result = this.childContexts.get(operands);
        if (!result) {
            result = context.getChild(invokingState);
            result = this.getAsCached(result);
            this.childContexts.put(operands, result);
        }
        return result;
    }
    join(x, y) {
        if (!this.enableCache) return $jaUCz.PredictionContext.join(x, y, this);
        let operands = new $35a349d4d8246799$var$PredictionContextCache.IdentityCommutativePredictionContextOperands(x, y);
        let result = this.joinContexts.get(operands);
        if (result) return result;
        result = $jaUCz.PredictionContext.join(x, y, this);
        result = this.getAsCached(result);
        this.joinContexts.put(operands, result);
        return result;
    }
}
module.exports.PredictionContextCache = $35a349d4d8246799$var$PredictionContextCache;
$35a349d4d8246799$var$PredictionContextCache.UNCACHED = new $35a349d4d8246799$var$PredictionContextCache(false);
(function(PredictionContextCache) {
    class PredictionContextAndInt {
        constructor(obj, value){
            this.obj = obj;
            this.value = value;
        }
        equals(obj) {
            if (!(obj instanceof PredictionContextAndInt)) return false;
            else if (obj === this) return true;
            let other = obj;
            return this.value === other.value && (this.obj === other.obj || this.obj != null && this.obj.equals(other.obj));
        }
        hashCode() {
            let hashCode = 5;
            hashCode = 7 * hashCode + (this.obj != null ? this.obj.hashCode() : 0);
            hashCode = 7 * hashCode + this.value;
            return hashCode;
        }
    }
    $35a349d4d8246799$var$__decorate([
        $aN41m.Override
    ], PredictionContextAndInt.prototype, "equals", null);
    $35a349d4d8246799$var$__decorate([
        $aN41m.Override
    ], PredictionContextAndInt.prototype, "hashCode", null);
    PredictionContextCache.PredictionContextAndInt = PredictionContextAndInt;
    class IdentityCommutativePredictionContextOperands {
        constructor(x, y){
            $fomfP(x != null);
            $fomfP(y != null);
            this._x = x;
            this._y = y;
        }
        get x() {
            return this._x;
        }
        get y() {
            return this._y;
        }
        equals(o) {
            if (!(o instanceof IdentityCommutativePredictionContextOperands)) return false;
            else if (this === o) return true;
            let other = o;
            return this._x === other._x && this._y === other._y || this._x === other._y && this._y === other._x;
        }
        hashCode() {
            return this._x.hashCode() ^ this._y.hashCode();
        }
    }
    $35a349d4d8246799$var$__decorate([
        $aN41m.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "equals", null);
    $35a349d4d8246799$var$__decorate([
        $aN41m.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "hashCode", null);
    PredictionContextCache.IdentityCommutativePredictionContextOperands = IdentityCommutativePredictionContextOperands;
})($35a349d4d8246799$var$PredictionContextCache = module.exports.PredictionContextCache || (module.exports.PredictionContextCache = {}));

});



parcelRegister("8WIez", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BitSet = void 0;

var $ibOwR = parcelRequire("ibOwR");

var $amQx9 = parcelRequire("amQx9");
/**
 * Private empty array used to construct empty BitSets
 */ const $68360d7390f2502b$var$EMPTY_DATA = new Uint16Array(0);
/**
 * Gets the word index of the `UInt16` element in `BitSet.data` containing the bit with the specified index.
 */ function $68360d7390f2502b$var$getIndex(bitNumber) {
    return bitNumber >>> 4;
}
/**
 * Convert a word index into the bit index of the LSB of that word
 */ function $68360d7390f2502b$var$unIndex(n) {
    return n * 16;
}
/**
 * Get's the bit number of the least signficant bit set LSB which is set in a word non-zero word;
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $68360d7390f2502b$var$findLSBSet(word) {
    let bit = 1;
    for(let i = 0; i < 16; i++){
        if ((word & bit) !== 0) return i;
        bit = bit << 1 >>> 0;
    }
    throw new RangeError("No specified bit found");
}
function $68360d7390f2502b$var$findMSBSet(word) {
    let bit = 32768;
    for(let i = 15; i >= 0; i--){
        if ((word & bit) !== 0) return i;
        bit = bit >>> 1;
    }
    throw new RangeError("No specified bit found");
}
/**
 * Gets a 16-bit mask with bit numbers fromBit to toBit (inclusive) set.
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $68360d7390f2502b$var$bitsFor(fromBit, toBit) {
    fromBit &= 0xF;
    toBit &= 0xF;
    if (fromBit === toBit) return 1 << fromBit >>> 0;
    return 0xFFFF >>> 15 - toBit ^ 0xFFFF >>> 16 - fromBit;
}
/**
 * A lookup table for number of set bits in a 16-bit integer.   This is used to quickly count the cardinality (number of unique elements) of a BitSet.
 */ const $68360d7390f2502b$var$POP_CNT = new Uint8Array(65536);
for(let i = 0; i < 16; i++){
    const stride = 1 << i >>> 0;
    let index = 0;
    while(index < $68360d7390f2502b$var$POP_CNT.length){
        // skip the numbers where the bit isn't set
        index += stride;
        // increment the ones where the bit is set
        for(let j = 0; j < stride; j++){
            $68360d7390f2502b$var$POP_CNT[index]++;
            index++;
        }
    }
}
class $68360d7390f2502b$var$BitSet {
    /*
    ** constructor implementation
    */ constructor(arg){
        if (!arg) // covering the case of unspecified and nbits===0
        this.data = $68360d7390f2502b$var$EMPTY_DATA;
        else if (typeof arg === "number") {
            if (arg < 0) throw new RangeError("nbits cannot be negative");
            else this.data = new Uint16Array($68360d7390f2502b$var$getIndex(arg - 1) + 1);
        } else if (arg instanceof $68360d7390f2502b$var$BitSet) this.data = arg.data.slice(0); // Clone the data
        else {
            let max = -1;
            for (let v of arg)if (max < v) max = v;
            this.data = new Uint16Array($68360d7390f2502b$var$getIndex(max - 1) + 1);
            for (let v of arg)this.set(v);
        }
    }
    /**
     * Performs a logical **AND** of this target bit set with the argument bit set. This bit set is modified so that
     * each bit in it has the value `true` if and only if it both initially had the value `true` and the corresponding
     * bit in the bit set argument also had the value `true`.
     */ and(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $68360d7390f2502b$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Clears all of the bits in this `BitSet` whose corresponding bit is set in the specified `BitSet`.
     */ andNot(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i] ^ 0xFFFF;
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $68360d7390f2502b$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Returns the number of bits set to `true` in this `BitSet`.
     */ cardinality() {
        if (this.isEmpty) return 0;
        const data = this.data;
        const length = data.length;
        let result = 0;
        for(let i = 0; i < length; i++)result += $68360d7390f2502b$var$POP_CNT[data[i]];
        return result;
    }
    clear(fromIndex, toIndex) {
        if (fromIndex == null) this.data.fill(0);
        else if (toIndex == null) this.set(fromIndex, false);
        else this.set(fromIndex, toIndex, false);
    }
    flip(fromIndex, toIndex) {
        if (toIndex == null) toIndex = fromIndex;
        if (fromIndex < 0 || toIndex < fromIndex) throw new RangeError();
        let word = $68360d7390f2502b$var$getIndex(fromIndex);
        const lastWord = $68360d7390f2502b$var$getIndex(toIndex);
        if (word === lastWord) this.data[word] ^= $68360d7390f2502b$var$bitsFor(fromIndex, toIndex);
        else {
            this.data[word++] ^= $68360d7390f2502b$var$bitsFor(fromIndex, 15);
            while(word < lastWord)this.data[word++] ^= 0xFFFF;
            this.data[word++] ^= $68360d7390f2502b$var$bitsFor(0, toIndex);
        }
    }
    get(fromIndex, toIndex) {
        if (toIndex === undefined) return !!(this.data[$68360d7390f2502b$var$getIndex(fromIndex)] & $68360d7390f2502b$var$bitsFor(fromIndex, fromIndex));
        else {
            // return a BitSet
            let result = new $68360d7390f2502b$var$BitSet(toIndex + 1);
            for(let i = fromIndex; i <= toIndex; i++)result.set(i, this.get(i));
            return result;
        }
    }
    /**
     * Returns true if the specified `BitSet` has any bits set to `true` that are also set to `true` in this `BitSet`.
     *
     * @param set `BitSet` to intersect with
     */ intersects(set) {
        let smallerLength = Math.min(this.length(), set.length());
        if (smallerLength === 0) return false;
        let bound = $68360d7390f2502b$var$getIndex(smallerLength - 1);
        for(let i = 0; i <= bound; i++){
            if ((this.data[i] & set.data[i]) !== 0) return true;
        }
        return false;
    }
    /**
     * Returns true if this `BitSet` contains no bits that are set to `true`.
     */ get isEmpty() {
        return this.length() === 0;
    }
    /**
     * Returns the "logical size" of this `BitSet`: the index of the highest set bit in the `BitSet` plus one. Returns
     * zero if the `BitSet` contains no set bits.
     */ length() {
        if (!this.data.length) return 0;
        return this.previousSetBit($68360d7390f2502b$var$unIndex(this.data.length) - 1) + 1;
    }
    /**
     * Returns the index of the first bit that is set to `false` that occurs on or after the specified starting index,
     * If no such bit exists then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $68360d7390f2502b$var$getIndex(fromIndex);
        if (word > length) return -1;
        let ignore = 0xFFFF ^ $68360d7390f2502b$var$bitsFor(fromIndex, 15);
        if ((data[word] | ignore) === 0xFFFF) {
            word++;
            ignore = 0;
            for(; word < length; word++){
                if (data[word] !== 0xFFFF) break;
            }
            if (word === length) // Hit the end
            return -1;
        }
        return $68360d7390f2502b$var$unIndex(word) + $68360d7390f2502b$var$findLSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the first bit that is set to `true` that occurs on or after the specified starting index.
     * If no such bit exists then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.nextSetBit(0); i >= 0; i = bs.nextSetBit(i + 1)) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $68360d7390f2502b$var$getIndex(fromIndex);
        if (word > length) return -1;
        let mask = $68360d7390f2502b$var$bitsFor(fromIndex, 15);
        if ((data[word] & mask) === 0) {
            word++;
            mask = 0xFFFF;
            for(; word < length; word++){
                if (data[word] !== 0) break;
            }
            if (word >= length) return -1;
        }
        return $68360d7390f2502b$var$unIndex(word) + $68360d7390f2502b$var$findLSBSet(data[word] & mask);
    }
    /**
     * Performs a logical **OR** of this bit set with the bit set argument. This bit set is modified so that a bit in it
     * has the value `true` if and only if it either already had the value `true` or the corresponding bit in the bit
     * set argument has the value `true`.
     */ or(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Or those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] | other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $68360d7390f2502b$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord);
    }
    /**
     * Returns the index of the nearest bit that is set to `false` that occurs on or before the specified starting
     * index. If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $68360d7390f2502b$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let ignore = 0xFFFF ^ $68360d7390f2502b$var$bitsFor(0, fromIndex);
        if ((data[word] | ignore) === 0xFFFF) {
            ignore = 0;
            word--;
            for(; word >= 0; word--){
                if (data[word] !== 0xFFFF) break;
            }
            if (word < 0) // Hit the end
            return -1;
        }
        return $68360d7390f2502b$var$unIndex(word) + $68360d7390f2502b$var$findMSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the nearest bit that is set to `true` that occurs on or before the specified starting index.
     * If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.length(); (i = bs.previousSetBit(i-1)) >= 0; ) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $68360d7390f2502b$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let mask = $68360d7390f2502b$var$bitsFor(0, fromIndex);
        if ((data[word] & mask) === 0) {
            word--;
            mask = 0xFFFF;
            for(; word >= 0; word--){
                if (data[word] !== 0) break;
            }
            if (word < 0) return -1;
        }
        return $68360d7390f2502b$var$unIndex(word) + $68360d7390f2502b$var$findMSBSet(data[word] & mask);
    }
    set(fromIndex, toIndex, value) {
        if (toIndex === undefined) {
            toIndex = fromIndex;
            value = true;
        } else if (typeof toIndex === "boolean") {
            value = toIndex;
            toIndex = fromIndex;
        }
        if (value === undefined) value = true;
        if (fromIndex < 0 || fromIndex > toIndex) throw new RangeError();
        let word = $68360d7390f2502b$var$getIndex(fromIndex);
        let lastWord = $68360d7390f2502b$var$getIndex(toIndex);
        if (value && lastWord >= this.data.length) {
            // Grow array "just enough" for bits we need to set
            let temp = new Uint16Array(lastWord + 1);
            this.data.forEach((value, index)=>temp[index] = value);
            this.data = temp;
        } else if (!value) {
            // But there is no need to grow array to clear bits.
            if (word >= this.data.length) // Early exit
            return;
            if (lastWord >= this.data.length) {
                // Adjust work to fit array
                lastWord = this.data.length - 1;
                toIndex = this.data.length * 16 - 1;
            }
        }
        if (word === lastWord) this._setBits(word, value, $68360d7390f2502b$var$bitsFor(fromIndex, toIndex));
        else {
            this._setBits(word++, value, $68360d7390f2502b$var$bitsFor(fromIndex, 15));
            while(word < lastWord)this.data[word++] = value ? 0xFFFF : 0;
            this._setBits(word, value, $68360d7390f2502b$var$bitsFor(0, toIndex));
        }
    }
    _setBits(word, value, mask) {
        if (value) this.data[word] |= mask;
        else this.data[word] &= 0xFFFF ^ mask;
    }
    /**
     * Returns the number of bits of space actually in use by this `BitSet` to represent bit values. The maximum element
     * in the set is the size - 1st element.
     */ get size() {
        return this.data.byteLength * 8;
    }
    /**
     * Returns a new byte array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let bytes = s.toByteArray();`
     * then `bytes.length === (s.length()+7)/8` and `s.get(n) === ((bytes[n/8] & (1<<(n%8))) != 0)` for all
     * `n < 8 * bytes.length`.
     */ // toByteArray(): Int8Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Returns a new integer array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let integers = s.toIntegerArray();`
     * then `integers.length === (s.length()+31)/32` and `s.get(n) === ((integers[n/32] & (1<<(n%32))) != 0)` for all
     * `n < 32 * integers.length`.
     */ // toIntegerArray(): Int32Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    hashCode() {
        return $amQx9.MurmurHash.hashCode(this.data, 22);
    }
    /**
     * Compares this object against the specified object. The result is `true` if and only if the argument is not
     * `undefined` and is a `Bitset` object that has exactly the same set of bits set to `true` as this bit set. That
     * is, for every nonnegative index `k`,
     *
     * ```
     * ((BitSet)obj).get(k) == this.get(k)
     * ```
     *
     * must be true. The current sizes of the two bit sets are not compared.
     */ equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $68360d7390f2502b$var$BitSet)) return false;
        const len = this.length();
        if (len !== obj.length()) return false;
        if (len === 0) return true;
        let bound = $68360d7390f2502b$var$getIndex(len - 1);
        for(let i = 0; i <= bound; i++){
            if (this.data[i] !== obj.data[i]) return false;
        }
        return true;
    }
    /**
     * Returns a string representation of this bit set. For every index for which this `BitSet` contains a bit in the
     * set state, the decimal representation of that index is included in the result. Such indices are listed in order
     * from lowest to highest, separated by ", " (a comma and a space) and surrounded by braces, resulting in the usual
     * mathematical notation for a set of integers.
     *
     * Example:
     *
     *     BitSet drPepper = new BitSet();
     *
     * Now `drPepper.toString()` returns `"{}"`.
     *
     *     drPepper.set(2);
     *
     * Now `drPepper.toString()` returns `"{2}"`.
     *
     *     drPepper.set(4);
     *     drPepper.set(10);
     *
     * Now `drPepper.toString()` returns `"{2, 4, 10}"`.
     */ toString() {
        let result = "{";
        let first = true;
        for(let i = this.nextSetBit(0); i >= 0; i = this.nextSetBit(i + 1)){
            if (first) first = false;
            else result += ", ";
            result += i;
        }
        result += "}";
        return result;
    }
    // static valueOf(bytes: Int8Array): BitSet;
    // static valueOf(buffer: ArrayBuffer): BitSet;
    // static valueOf(integers: Int32Array): BitSet;
    // static valueOf(data: Int8Array | Int32Array | ArrayBuffer): BitSet {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Performs a logical **XOR** of this bit set with the bit set argument. This bit set is modified so that a bit in
     * it has the value `true` if and only if one of the following statements holds:
     *
     * * The bit initially has the value `true`, and the corresponding bit in the argument has the value `false`.
     * * The bit initially has the value `false`, and the corresponding bit in the argument has the value `true`.
     */ xor(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Xor those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] ^ other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $68360d7390f2502b$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord + 1);
    }
    clone() {
        return new $68360d7390f2502b$var$BitSet(this);
    }
    [Symbol.iterator]() {
        return new $68360d7390f2502b$var$BitSetIterator(this.data);
    }
    // Overrides formatting for nodejs assert etc.
    [$ibOwR.inspect.custom]() {
        return "BitSet " + this.toString();
    }
}
module.exports.BitSet = $68360d7390f2502b$var$BitSet;
class $68360d7390f2502b$var$BitSetIterator {
    constructor(data){
        this.data = data;
        this.index = 0;
        this.mask = 0xFFFF;
    }
    next() {
        while(this.index < this.data.length){
            const bits = this.data[this.index] & this.mask;
            if (bits !== 0) {
                const bitNumber = $68360d7390f2502b$var$unIndex(this.index) + $68360d7390f2502b$var$findLSBSet(bits);
                this.mask = $68360d7390f2502b$var$bitsFor(bitNumber + 1, 15);
                return {
                    done: false,
                    value: bitNumber
                };
            }
            this.index++;
            this.mask = 0xFFFF;
        }
        return {
            done: true,
            value: -1
        };
    }
    [Symbol.iterator]() {
        return this;
    }
}

});


parcelRegister("aVeml", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7f3a5dbd36c0ece1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFASerializer = void 0;

var $ceQRA = parcelRequire("ceQRA");

var $aN41m = parcelRequire("aN41m");

var $jaUCz = parcelRequire("jaUCz");

var $dwftT = parcelRequire("dwftT");

var $hBnE1 = parcelRequire("hBnE1");
/** A DFA walker that knows how to dump them to serialized strings. */ class $7f3a5dbd36c0ece1$var$DFASerializer {
    constructor(dfa, vocabulary, ruleNames, atn){
        if (vocabulary instanceof $dwftT.Recognizer) {
            ruleNames = vocabulary.ruleNames;
            atn = vocabulary.atn;
            vocabulary = vocabulary.vocabulary;
        } else if (!vocabulary) vocabulary = $hBnE1.VocabularyImpl.EMPTY_VOCABULARY;
        this.dfa = dfa;
        this.vocabulary = vocabulary;
        this.ruleNames = ruleNames;
        this.atn = atn;
    }
    toString() {
        if (!this.dfa.s0) return "";
        let buf = "";
        if (this.dfa.states) {
            let states = new Array(...this.dfa.states.toArray());
            states.sort((o1, o2)=>o1.stateNumber - o2.stateNumber);
            for (let s of states){
                let edges = s.getEdgeMap();
                let edgeKeys = [
                    ...edges.keys()
                ].sort((a, b)=>a - b);
                let contextEdges = s.getContextEdgeMap();
                let contextEdgeKeys = [
                    ...contextEdges.keys()
                ].sort((a, b)=>a - b);
                for (let entry of edgeKeys){
                    let value = edges.get(entry);
                    if ((value == null || value === $ceQRA.ATNSimulator.ERROR) && !s.isContextSymbol(entry)) continue;
                    let contextSymbol = false;
                    buf += this.getStateString(s) + "-" + this.getEdgeLabel(entry) + "->";
                    if (s.isContextSymbol(entry)) {
                        buf += "!";
                        contextSymbol = true;
                    }
                    let t = value;
                    if (t && t.stateNumber !== $ceQRA.ATNSimulator.ERROR.stateNumber) buf += this.getStateString(t) + "\n";
                    else if (contextSymbol) buf += "ctx\n";
                }
                if (s.isContextSensitive) for (let entry of contextEdgeKeys)buf += this.getStateString(s) + "-" + this.getContextLabel(entry) + "->" + this.getStateString(contextEdges.get(entry)) + "\n";
            }
        }
        let output = buf;
        if (output.length === 0) return "";
        //return Utils.sortLinesInString(output);
        return output;
    }
    getContextLabel(i) {
        if (i === $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) return "ctx:EMPTY_FULL";
        else if (i === $jaUCz.PredictionContext.EMPTY_LOCAL_STATE_KEY) return "ctx:EMPTY_LOCAL";
        if (this.atn && i > 0 && i <= this.atn.states.length) {
            let state = this.atn.states[i];
            let ruleIndex = state.ruleIndex;
            if (this.ruleNames && ruleIndex >= 0 && ruleIndex < this.ruleNames.length) return "ctx:" + String(i) + "(" + this.ruleNames[ruleIndex] + ")";
        }
        return "ctx:" + String(i);
    }
    getEdgeLabel(i) {
        return this.vocabulary.getDisplayName(i);
    }
    getStateString(s) {
        if (s === $ceQRA.ATNSimulator.ERROR) return "ERROR";
        let n = s.stateNumber;
        let stateStr = "s" + n;
        if (s.isAcceptState) {
            if (s.predicates) stateStr = ":s" + n + "=>" + s.predicates;
            else stateStr = ":s" + n + "=>" + s.prediction;
        }
        if (s.isContextSensitive) {
            stateStr += "*";
            for (let config of s.configs)if (config.reachesIntoOuterContext) {
                stateStr += "*";
                break;
            }
        }
        return stateStr;
    }
}
$7f3a5dbd36c0ece1$var$__decorate([
    $aN41m.NotNull
], $7f3a5dbd36c0ece1$var$DFASerializer.prototype, "dfa", void 0);
$7f3a5dbd36c0ece1$var$__decorate([
    $aN41m.NotNull
], $7f3a5dbd36c0ece1$var$DFASerializer.prototype, "vocabulary", void 0);
$7f3a5dbd36c0ece1$var$__decorate([
    $aN41m.Override
], $7f3a5dbd36c0ece1$var$DFASerializer.prototype, "toString", null);
module.exports.DFASerializer = $7f3a5dbd36c0ece1$var$DFASerializer;

});
parcelRegister("ceQRA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8e8fcc5f6dae8ba8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8e8fcc5f6dae8ba8$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNSimulator = void 0;

var $2SGHL = parcelRequire("2SGHL");

var $6P9ap = parcelRequire("6P9ap");

var $aN41m = parcelRequire("aN41m");

var $jaUCz = parcelRequire("jaUCz");
let $8e8fcc5f6dae8ba8$var$ATNSimulator = class ATNSimulator {
    constructor(atn){
        this.atn = atn;
    }
    static get ERROR() {
        if (!ATNSimulator._ERROR) {
            ATNSimulator._ERROR = new $6P9ap.DFAState(new $2SGHL.ATNConfigSet());
            ATNSimulator._ERROR.stateNumber = $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY;
        }
        return ATNSimulator._ERROR;
    }
    /**
     * Clear the DFA cache used by the current instance. Since the DFA cache may
     * be shared by multiple ATN simulators, this method may affect the
     * performance (but not accuracy) of other parsers which are being used
     * concurrently.
     *
     * @ if the current instance does not
     * support clearing the DFA.
     *
     * @since 4.3
     */ clearDFA() {
        this.atn.clearDFA();
    }
};
$8e8fcc5f6dae8ba8$var$__decorate([
    $aN41m.NotNull
], $8e8fcc5f6dae8ba8$var$ATNSimulator.prototype, "atn", void 0);
$8e8fcc5f6dae8ba8$var$__decorate([
    $aN41m.NotNull
], $8e8fcc5f6dae8ba8$var$ATNSimulator, "ERROR", null);
$8e8fcc5f6dae8ba8$var$ATNSimulator = $8e8fcc5f6dae8ba8$var$__decorate([
    $8e8fcc5f6dae8ba8$var$__param(0, $aN41m.NotNull)
], $8e8fcc5f6dae8ba8$var$ATNSimulator);
module.exports.ATNSimulator = $8e8fcc5f6dae8ba8$var$ATNSimulator;
(function(ATNSimulator) {
    const RULE_VARIANT_DELIMITER = "$";
    const RULE_LF_VARIANT_MARKER = "$lf$";
    const RULE_NOLF_VARIANT_MARKER = "$nolf$";
})($8e8fcc5f6dae8ba8$var$ATNSimulator = module.exports.ATNSimulator || (module.exports.ATNSimulator = {}));
module.exports.ATNSimulator = $8e8fcc5f6dae8ba8$var$ATNSimulator;

});
parcelRegister("6P9ap", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4f7e9dd79d87c511$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4f7e9dd79d87c511$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFAState = void 0;

var $eeOLb = parcelRequire("eeOLb");

var $8WIez = parcelRequire("8WIez");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");

var $jaUCz = parcelRequire("jaUCz");

var $fomfP = parcelRequire("fomfP");
/** A DFA state represents a set of possible ATN configurations.
 *  As Aho, Sethi, Ullman p. 117 says "The DFA uses its state
 *  to keep track of all possible states the ATN can be in after
 *  reading each input symbol.  That is to say, after reading
 *  input a1a2..an, the DFA is in a state that represents the
 *  subset T of the states of the ATN that are reachable from the
 *  ATN's start state along some path labeled a1a2..an."
 *  In conventional NFA&rarr;DFA conversion, therefore, the subset T
 *  would be a bitset representing the set of states the
 *  ATN could be in.  We need to track the alt predicted by each
 *  state as well, however.  More importantly, we need to maintain
 *  a stack of states, tracking the closure operations as they
 *  jump from rule to rule, emulating rule invocations (method calls).
 *  I have to add a stack to simulate the proper lookahead sequences for
 *  the underlying LL grammar from which the ATN was derived.
 *
 *  I use a set of ATNConfig objects not simple states.  An ATNConfig
 *  is both a state (ala normal conversion) and a RuleContext describing
 *  the chain of rules (if any) followed to arrive at that state.
 *
 *  A DFA state may have multiple references to a particular state,
 *  but with different ATN contexts (with same or different alts)
 *  meaning that state was reached via a different set of rule invocations.
 */ class $4f7e9dd79d87c511$var$DFAState {
    /**
     * Constructs a new `DFAState`.
     *
     * @param configs The set of ATN configurations defining this state.
     */ constructor(configs){
        this.stateNumber = -1;
        this.configs = configs;
        this.edges = new Map();
        this.contextEdges = new Map();
    }
    get isContextSensitive() {
        return !!this.contextSymbols;
    }
    isContextSymbol(symbol) {
        if (!this.isContextSensitive) return false;
        return this.contextSymbols.get(symbol);
    }
    setContextSymbol(symbol) {
        $fomfP(this.isContextSensitive);
        this.contextSymbols.set(symbol);
    }
    setContextSensitive(atn) {
        $fomfP(!this.configs.isOutermostConfigSet);
        if (this.isContextSensitive) return;
        if (!this.contextSymbols) this.contextSymbols = new $8WIez.BitSet();
    }
    get acceptStateInfo() {
        return this._acceptStateInfo;
    }
    set acceptStateInfo(acceptStateInfo) {
        this._acceptStateInfo = acceptStateInfo;
    }
    get isAcceptState() {
        return !!this._acceptStateInfo;
    }
    get prediction() {
        if (!this._acceptStateInfo) return $eeOLb.ATN.INVALID_ALT_NUMBER;
        return this._acceptStateInfo.prediction;
    }
    get lexerActionExecutor() {
        if (!this._acceptStateInfo) return undefined;
        return this._acceptStateInfo.lexerActionExecutor;
    }
    getTarget(symbol) {
        return this.edges.get(symbol);
    }
    setTarget(symbol, target) {
        this.edges.set(symbol, target);
    }
    getEdgeMap() {
        return this.edges;
    }
    getContextTarget(invokingState) {
        if (invokingState === $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        return this.contextEdges.get(invokingState);
    }
    setContextTarget(invokingState, target) {
        if (!this.isContextSensitive) throw new Error("The state is not context sensitive.");
        if (invokingState === $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        this.contextEdges.set(invokingState, target);
    }
    getContextEdgeMap() {
        let map = new Map(this.contextEdges);
        let existing = map.get(-1);
        if (existing !== undefined) {
            if (map.size === 1) {
                let result = new Map();
                result.set($jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                return result;
            } else {
                map.delete(-1);
                map.set($jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
            }
        }
        return map;
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize(7);
        hash = $amQx9.MurmurHash.update(hash, this.configs.hashCode());
        hash = $amQx9.MurmurHash.finish(hash, 1);
        return hash;
    }
    /**
     * Two {@link DFAState} instances are equal if their ATN configuration sets
     * are the same. This method is used to see if a state already exists.
     *
     * Because the number of alternatives and number of ATN configurations are
     * finite, there is a finite number of DFA states that can be processed.
     * This is necessary to show that the algorithm terminates.
     *
     * Cannot test the DFA state numbers here because in
     * {@link ParserATNSimulator#addDFAState} we need to know if any other state
     * exists that has this exact set of ATN configurations. The
     * {@link #stateNumber} is irrelevant.
     */ equals(o) {
        // compare set of ATN configurations in this set with other
        if (this === o) return true;
        if (!(o instanceof $4f7e9dd79d87c511$var$DFAState)) return false;
        let other = o;
        let sameSet = this.configs.equals(other.configs);
        //		System.out.println("DFAState.equals: "+configs+(sameSet?"==":"!=")+other.configs);
        return sameSet;
    }
    toString() {
        let buf = "";
        buf += this.stateNumber + ":" + this.configs;
        if (this.isAcceptState) {
            buf += "=>";
            if (this.predicates) buf += this.predicates;
            else buf += this.prediction;
        }
        return buf.toString();
    }
}
$4f7e9dd79d87c511$var$__decorate([
    $aN41m.NotNull
], $4f7e9dd79d87c511$var$DFAState.prototype, "configs", void 0);
$4f7e9dd79d87c511$var$__decorate([
    $aN41m.NotNull
], $4f7e9dd79d87c511$var$DFAState.prototype, "edges", void 0);
$4f7e9dd79d87c511$var$__decorate([
    $aN41m.NotNull
], $4f7e9dd79d87c511$var$DFAState.prototype, "contextEdges", void 0);
$4f7e9dd79d87c511$var$__decorate([
    $aN41m.Override
], $4f7e9dd79d87c511$var$DFAState.prototype, "hashCode", null);
$4f7e9dd79d87c511$var$__decorate([
    $aN41m.Override
], $4f7e9dd79d87c511$var$DFAState.prototype, "equals", null);
$4f7e9dd79d87c511$var$__decorate([
    $aN41m.Override
], $4f7e9dd79d87c511$var$DFAState.prototype, "toString", null);
module.exports.DFAState = $4f7e9dd79d87c511$var$DFAState;
(function(DFAState) {
    /** Map a predicate to a predicted alternative. */ let PredPrediction = class PredPrediction {
        constructor(pred, alt){
            this.alt = alt;
            this.pred = pred;
        }
        toString() {
            return "(" + this.pred + ", " + this.alt + ")";
        }
    };
    $4f7e9dd79d87c511$var$__decorate([
        $aN41m.NotNull
    ], PredPrediction.prototype, "pred", void 0);
    $4f7e9dd79d87c511$var$__decorate([
        $aN41m.Override
    ], PredPrediction.prototype, "toString", null);
    PredPrediction = $4f7e9dd79d87c511$var$__decorate([
        $4f7e9dd79d87c511$var$__param(0, $aN41m.NotNull)
    ], PredPrediction);
    DFAState.PredPrediction = PredPrediction;
})($4f7e9dd79d87c511$var$DFAState = module.exports.DFAState || (module.exports.DFAState = {}));

});


parcelRegister("dwftT", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9d7a45bfa60542a5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9d7a45bfa60542a5$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Recognizer = void 0;

var $eEgBk = parcelRequire("eEgBk");

var $3Wiwr = parcelRequire("3Wiwr");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");

var $62Uvn = parcelRequire("62Uvn");
class $9d7a45bfa60542a5$var$Recognizer {
    constructor(){
        this._listeners = [
            $eEgBk.ConsoleErrorListener.INSTANCE
        ];
        this._stateNumber = -1;
    }
    /**
     * Get a map from token names to token types.
     *
     * Used for XPath and tree pattern compilation.
     */ getTokenTypeMap() {
        let vocabulary = this.vocabulary;
        let result = $9d7a45bfa60542a5$var$Recognizer.tokenTypeMapCache.get(vocabulary);
        if (result == null) {
            let intermediateResult = new Map();
            for(let i = 0; i <= this.atn.maxTokenType; i++){
                let literalName = vocabulary.getLiteralName(i);
                if (literalName != null) intermediateResult.set(literalName, i);
                let symbolicName = vocabulary.getSymbolicName(i);
                if (symbolicName != null) intermediateResult.set(symbolicName, i);
            }
            intermediateResult.set("EOF", $eKXi4.Token.EOF);
            result = intermediateResult;
            $9d7a45bfa60542a5$var$Recognizer.tokenTypeMapCache.set(vocabulary, result);
        }
        return result;
    }
    /**
     * Get a map from rule names to rule indexes.
     *
     * Used for XPath and tree pattern compilation.
     */ getRuleIndexMap() {
        let ruleNames = this.ruleNames;
        if (ruleNames == null) throw new Error("The current recognizer does not provide a list of rule names.");
        let result = $9d7a45bfa60542a5$var$Recognizer.ruleIndexMapCache.get(ruleNames);
        if (result == null) {
            result = $62Uvn.toMap(ruleNames);
            $9d7a45bfa60542a5$var$Recognizer.ruleIndexMapCache.set(ruleNames, result);
        }
        return result;
    }
    getTokenType(tokenName) {
        let ttype = this.getTokenTypeMap().get(tokenName);
        if (ttype != null) return ttype;
        return $eKXi4.Token.INVALID_TYPE;
    }
    /**
     * If this recognizer was generated, it will have a serialized ATN
     * representation of the grammar.
     *
     * For interpreters, we don't know their serialized ATN despite having
     * created the interpreter from it.
     */ get serializedATN() {
        throw new Error("there is no serialized ATN");
    }
    /**
     * Get the {@link ATN} used by the recognizer for prediction.
     *
     * @returns The {@link ATN} used by the recognizer for prediction.
     */ get atn() {
        return this._interp.atn;
    }
    /**
     * Get the ATN interpreter used by the recognizer for prediction.
     *
     * @returns The ATN interpreter used by the recognizer for prediction.
     */ get interpreter() {
        return this._interp;
    }
    /**
     * Set the ATN interpreter used by the recognizer for prediction.
     *
     * @param interpreter The ATN interpreter used by the recognizer for
     * prediction.
     */ set interpreter(interpreter) {
        this._interp = interpreter;
    }
    /** If profiling during the parse/lex, this will return DecisionInfo records
     *  for each decision in recognizer in a ParseInfo object.
     *
     * @since 4.3
     */ get parseInfo() {
        return Promise.resolve(undefined);
    }
    /** What is the error header, normally line/character position information? */ getErrorHeader(e) {
        let token = e.getOffendingToken();
        if (!token) return "";
        let line = token.line;
        let charPositionInLine = token.charPositionInLine;
        return "line " + line + ":" + charPositionInLine;
    }
    /**
     * @exception NullPointerException if `listener` is `undefined`.
     */ addErrorListener(listener) {
        if (!listener) throw new TypeError("listener must not be null");
        this._listeners.push(listener);
    }
    removeErrorListener(listener) {
        let position = this._listeners.indexOf(listener);
        if (position !== -1) this._listeners.splice(position, 1);
    }
    removeErrorListeners() {
        this._listeners.length = 0;
    }
    getErrorListeners() {
        return this._listeners.slice(0);
    }
    getErrorListenerDispatch() {
        return new $3Wiwr.ProxyErrorListener(this.getErrorListeners());
    }
    // subclass needs to override these if there are sempreds or actions
    // that the ATN interp needs to execute
    sempred(_localctx, ruleIndex, actionIndex) {
        return true;
    }
    precpred(localctx, precedence) {
        return true;
    }
    action(_localctx, ruleIndex, actionIndex) {
    // intentionally empty
    }
    get state() {
        return this._stateNumber;
    }
    /** Indicate that the recognizer has changed internal state that is
     *  consistent with the ATN state passed in.  This way we always know
     *  where we are in the ATN as the parser goes along. The rule
     *  context objects form a stack that lets us see the stack of
     *  invoking rules. Combine this and we have complete ATN
     *  configuration information.
     */ set state(atnState) {
        //		System.err.println("setState "+atnState);
        this._stateNumber = atnState;
    //		if ( traceATNStates ) _ctx.trace(atnState);
    }
}
$9d7a45bfa60542a5$var$Recognizer.EOF = -1;
$9d7a45bfa60542a5$var$Recognizer.tokenTypeMapCache = new WeakMap();
$9d7a45bfa60542a5$var$Recognizer.ruleIndexMapCache = new WeakMap();
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.SuppressWarnings("serial"),
    $aN41m.NotNull
], $9d7a45bfa60542a5$var$Recognizer.prototype, "_listeners", void 0);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull
], $9d7a45bfa60542a5$var$Recognizer.prototype, "getTokenTypeMap", null);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull
], $9d7a45bfa60542a5$var$Recognizer.prototype, "getRuleIndexMap", null);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull
], $9d7a45bfa60542a5$var$Recognizer.prototype, "serializedATN", null);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull
], $9d7a45bfa60542a5$var$Recognizer.prototype, "atn", null);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull,
    $9d7a45bfa60542a5$var$__param(0, $aN41m.NotNull)
], $9d7a45bfa60542a5$var$Recognizer.prototype, "interpreter", null);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull,
    $9d7a45bfa60542a5$var$__param(0, $aN41m.NotNull)
], $9d7a45bfa60542a5$var$Recognizer.prototype, "getErrorHeader", null);
$9d7a45bfa60542a5$var$__decorate([
    $9d7a45bfa60542a5$var$__param(0, $aN41m.NotNull)
], $9d7a45bfa60542a5$var$Recognizer.prototype, "addErrorListener", null);
$9d7a45bfa60542a5$var$__decorate([
    $9d7a45bfa60542a5$var$__param(0, $aN41m.NotNull)
], $9d7a45bfa60542a5$var$Recognizer.prototype, "removeErrorListener", null);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull
], $9d7a45bfa60542a5$var$Recognizer.prototype, "getErrorListeners", null);
module.exports.Recognizer = $9d7a45bfa60542a5$var$Recognizer;

});
parcelRegister("eEgBk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsoleErrorListener = void 0;
/**
 *
 * @author Sam Harwell
 */ class $aaa1adc002ecda3b$var$ConsoleErrorListener {
    /**
     * {@inheritDoc}
     *
     * This implementation prints messages to {@link System#err} containing the
     * values of `line`, `charPositionInLine`, and `msg` using
     * the following format.
     *
     * <pre>
     * line *line*:*charPositionInLine* *msg*
     * </pre>
     */ syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        console.error(`line ${line}:${charPositionInLine} ${msg}`);
    }
}
module.exports.ConsoleErrorListener = $aaa1adc002ecda3b$var$ConsoleErrorListener;
/**
 * Provides a default instance of {@link ConsoleErrorListener}.
 */ $aaa1adc002ecda3b$var$ConsoleErrorListener.INSTANCE = new $aaa1adc002ecda3b$var$ConsoleErrorListener();

});

parcelRegister("3Wiwr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2de528078ef3db4e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2de528078ef3db4e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyErrorListener = void 0;

var $aN41m = parcelRequire("aN41m");
/**
 * This implementation of {@link ANTLRErrorListener} dispatches all calls to a
 * collection of delegate listeners. This reduces the effort required to support multiple
 * listeners.
 *
 * @author Sam Harwell
 */ class $2de528078ef3db4e$var$ProxyErrorListener {
    constructor(delegates){
        this.delegates = delegates;
        if (!delegates) throw new Error("Invalid delegates");
    }
    getDelegates() {
        return this.delegates;
    }
    syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        this.delegates.forEach((listener)=>{
            if (listener.syntaxError) listener.syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e);
        });
    }
}
$2de528078ef3db4e$var$__decorate([
    $aN41m.Override,
    $2de528078ef3db4e$var$__param(0, $aN41m.NotNull),
    $2de528078ef3db4e$var$__param(4, $aN41m.NotNull)
], $2de528078ef3db4e$var$ProxyErrorListener.prototype, "syntaxError", null);
module.exports.ProxyErrorListener = $2de528078ef3db4e$var$ProxyErrorListener;

});


parcelRegister("hBnE1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cd083bb3193af652$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VocabularyImpl = void 0;

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
/**
 * This class provides a default implementation of the {@link Vocabulary}
 * interface.
 *
 * @author Sam Harwell
 */ class $cd083bb3193af652$var$VocabularyImpl {
    /**
     * Constructs a new instance of {@link VocabularyImpl} from the specified
     * literal, symbolic, and display token names.
     *
     * @param literalNames The literal names assigned to tokens, or an empty array
     * if no literal names are assigned.
     * @param symbolicNames The symbolic names assigned to tokens, or
     * an empty array if no symbolic names are assigned.
     * @param displayNames The display names assigned to tokens, or an empty array
     * to use the values in `literalNames` and `symbolicNames` as
     * the source of display names, as described in
     * {@link #getDisplayName(int)}.
     *
     * @see #getLiteralName(int)
     * @see #getSymbolicName(int)
     * @see #getDisplayName(int)
     */ constructor(literalNames, symbolicNames, displayNames){
        this.literalNames = literalNames;
        this.symbolicNames = symbolicNames;
        this.displayNames = displayNames;
        // See note here on -1 part: https://github.com/antlr/antlr4/pull/1146
        this._maxTokenType = Math.max(this.displayNames.length, Math.max(this.literalNames.length, this.symbolicNames.length)) - 1;
    }
    get maxTokenType() {
        return this._maxTokenType;
    }
    getLiteralName(tokenType) {
        if (tokenType >= 0 && tokenType < this.literalNames.length) return this.literalNames[tokenType];
        return undefined;
    }
    getSymbolicName(tokenType) {
        if (tokenType >= 0 && tokenType < this.symbolicNames.length) return this.symbolicNames[tokenType];
        if (tokenType === $eKXi4.Token.EOF) return "EOF";
        return undefined;
    }
    getDisplayName(tokenType) {
        if (tokenType >= 0 && tokenType < this.displayNames.length) {
            let displayName = this.displayNames[tokenType];
            if (displayName) return displayName;
        }
        let literalName = this.getLiteralName(tokenType);
        if (literalName) return literalName;
        let symbolicName = this.getSymbolicName(tokenType);
        if (symbolicName) return symbolicName;
        return String(tokenType);
    }
}
/**
 * Gets an empty {@link Vocabulary} instance.
 *
 * No literal or symbol names are assigned to token types, so
 * {@link #getDisplayName(int)} returns the numeric value for all tokens
 * except {@link Token#EOF}.
 */ $cd083bb3193af652$var$VocabularyImpl.EMPTY_VOCABULARY = new $cd083bb3193af652$var$VocabularyImpl([], [], []);
$cd083bb3193af652$var$__decorate([
    $aN41m.NotNull
], $cd083bb3193af652$var$VocabularyImpl.prototype, "literalNames", void 0);
$cd083bb3193af652$var$__decorate([
    $aN41m.NotNull
], $cd083bb3193af652$var$VocabularyImpl.prototype, "symbolicNames", void 0);
$cd083bb3193af652$var$__decorate([
    $aN41m.NotNull
], $cd083bb3193af652$var$VocabularyImpl.prototype, "displayNames", void 0);
$cd083bb3193af652$var$__decorate([
    $aN41m.Override
], $cd083bb3193af652$var$VocabularyImpl.prototype, "maxTokenType", null);
$cd083bb3193af652$var$__decorate([
    $aN41m.Override
], $cd083bb3193af652$var$VocabularyImpl.prototype, "getLiteralName", null);
$cd083bb3193af652$var$__decorate([
    $aN41m.Override
], $cd083bb3193af652$var$VocabularyImpl.prototype, "getSymbolicName", null);
$cd083bb3193af652$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $cd083bb3193af652$var$VocabularyImpl.prototype, "getDisplayName", null);
$cd083bb3193af652$var$__decorate([
    $aN41m.NotNull
], $cd083bb3193af652$var$VocabularyImpl, "EMPTY_VOCABULARY", void 0);
module.exports.VocabularyImpl = $cd083bb3193af652$var$VocabularyImpl;

});


parcelRegister("gwhAV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c06d486e830ea671$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c06d486e830ea671$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerDFASerializer = void 0;

var $aVeml = parcelRequire("aVeml");

var $aN41m = parcelRequire("aN41m");

var $hBnE1 = parcelRequire("hBnE1");
let $c06d486e830ea671$var$LexerDFASerializer = class LexerDFASerializer extends $aVeml.DFASerializer {
    constructor(dfa){
        super(dfa, $hBnE1.VocabularyImpl.EMPTY_VOCABULARY);
    }
    getEdgeLabel(i) {
        return "'" + String.fromCodePoint(i) + "'";
    }
};
$c06d486e830ea671$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $c06d486e830ea671$var$LexerDFASerializer.prototype, "getEdgeLabel", null);
$c06d486e830ea671$var$LexerDFASerializer = $c06d486e830ea671$var$__decorate([
    $c06d486e830ea671$var$__param(0, $aN41m.NotNull)
], $c06d486e830ea671$var$LexerDFASerializer);
module.exports.LexerDFASerializer = $c06d486e830ea671$var$LexerDFASerializer;

});

parcelRegister("e0pjt", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a324b36ed5e65ddb$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopEntryState = void 0;

var $fZESB = parcelRequire("fZESB");

var $8WIez = parcelRequire("8WIez");

var $42ptv = parcelRequire("42ptv");

var $aN41m = parcelRequire("aN41m");
class $a324b36ed5e65ddb$var$StarLoopEntryState extends $42ptv.DecisionState {
    constructor(){
        super(...arguments);
        /**
         * Indicates whether this state can benefit from a precedence DFA during SLL
         * decision making.
         *
         * This is a computed property that is calculated during ATN deserialization
         * and stored for use in {@link ParserATNSimulator} and
         * {@link ParserInterpreter}.
         *
         * @see `DFA.isPrecedenceDfa`
         */ this.precedenceRuleDecision = false;
        /**
         * For precedence decisions, this set marks states *S* which have all
         * of the following characteristics:
         *
         * * One or more invocation sites of the current rule returns to
         *   *S*.
         * * The closure from *S* includes the current decision without
         *   passing through any rule invocations or stepping out of the current
         *   rule.
         *
         * This field is not used when {@link #precedenceRuleDecision} is
         * `false`.
         */ this.precedenceLoopbackStates = new $8WIez.BitSet();
    }
    get stateType() {
        return $fZESB.ATNStateType.STAR_LOOP_ENTRY;
    }
}
$a324b36ed5e65ddb$var$__decorate([
    $aN41m.Override
], $a324b36ed5e65ddb$var$StarLoopEntryState.prototype, "stateType", null);
module.exports.StarLoopEntryState = $a324b36ed5e65ddb$var$StarLoopEntryState;

});


parcelRegister("8ii30", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $609e010be7b51ab4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidState = void 0;

var $fZESB = parcelRequire("fZESB");

var $3XAPg = parcelRequire("3XAPg");

var $aN41m = parcelRequire("aN41m");
/**
 *
 * @author Sam Harwell
 */ class $609e010be7b51ab4$var$InvalidState extends $3XAPg.BasicState {
    get stateType() {
        return $fZESB.ATNStateType.INVALID_TYPE;
    }
}
$609e010be7b51ab4$var$__decorate([
    $aN41m.Override
], $609e010be7b51ab4$var$InvalidState.prototype, "stateType", null);
module.exports.InvalidState = $609e010be7b51ab4$var$InvalidState;

});
parcelRegister("3XAPg", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2e2372a25da2f9ab$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicState = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $aN41m = parcelRequire("aN41m");
/**
 *
 * @author Sam Harwell
 */ class $2e2372a25da2f9ab$var$BasicState extends $dv9vN.ATNState {
    get stateType() {
        return $fZESB.ATNStateType.BASIC;
    }
}
$2e2372a25da2f9ab$var$__decorate([
    $aN41m.Override
], $2e2372a25da2f9ab$var$BasicState.prototype, "stateType", null);
module.exports.BasicState = $2e2372a25da2f9ab$var$BasicState;

});


parcelRegister("kUmff", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f38a4b008fb55a2e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f38a4b008fb55a2e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LL1Analyzer = void 0;

var $kvmNv = parcelRequire("kvmNv");

var $fsqYw = parcelRequire("fsqYw");

var $hdFz0 = parcelRequire("hdFz0");

var $8WIez = parcelRequire("8WIez");

var $6kdz0 = parcelRequire("6kdz0");

var $aN41m = parcelRequire("aN41m");

var $gFTdY = parcelRequire("gFTdY");

var $9eW9B = parcelRequire("9eW9B");

var $jaUCz = parcelRequire("jaUCz");

var $jWsYN = parcelRequire("jWsYN");

var $lmhna = parcelRequire("lmhna");

var $eKXi4 = parcelRequire("eKXi4");

var $69uaV = parcelRequire("69uaV");
let $f38a4b008fb55a2e$var$LL1Analyzer = class LL1Analyzer {
    constructor(atn){
        this.atn = atn;
    }
    /**
     * Calculates the SLL(1) expected lookahead set for each outgoing transition
     * of an {@link ATNState}. The returned array has one element for each
     * outgoing transition in `s`. If the closure from transition
     * *i* leads to a semantic predicate before matching a symbol, the
     * element at index *i* of the result will be `undefined`.
     *
     * @param s the ATN state
     * @returns the expected symbols for each outgoing transition of `s`.
     */ getDecisionLookahead(s) {
        //		System.out.println("LOOK("+s.stateNumber+")");
        if (s == null) return undefined;
        let look = new Array(s.numberOfTransitions);
        for(let alt = 0; alt < s.numberOfTransitions; alt++){
            let current = new $6kdz0.IntervalSet();
            look[alt] = current;
            let lookBusy = new $fsqYw.Array2DHashSet($9eW9B.ObjectEqualityComparator.INSTANCE);
            let seeThruPreds = false; // fail to get lookahead upon pred
            this._LOOK(s.transition(alt).target, undefined, $jaUCz.PredictionContext.EMPTY_LOCAL, current, lookBusy, new $8WIez.BitSet(), seeThruPreds, false);
            // Wipe out lookahead for this alternative if we found nothing
            // or we had a predicate when we !seeThruPreds
            if (current.size === 0 || current.contains(LL1Analyzer.HIT_PRED)) {
                current = undefined;
                look[alt] = current;
            }
        }
        return look;
    }
    LOOK(s, ctx, stopState) {
        if (stopState === undefined) {
            if (s.atn == null) throw new Error("Illegal state");
            stopState = s.atn.ruleToStopState[s.ruleIndex];
        } else if (stopState === null) // This is an explicit request to pass undefined as the stopState to _LOOK. Used to distinguish an overload
        // from the method which simply omits the stopState parameter.
        stopState = undefined;
        let r = new $6kdz0.IntervalSet();
        let seeThruPreds = true; // ignore preds; get all lookahead
        let addEOF = true;
        this._LOOK(s, stopState, ctx, r, new $fsqYw.Array2DHashSet(), new $8WIez.BitSet(), seeThruPreds, addEOF);
        return r;
    }
    /**
     * Compute set of tokens that can follow `s` in the ATN in the
     * specified `ctx`.
     * <p/>
     * If `ctx` is {@link PredictionContext#EMPTY_LOCAL} and
     * `stopState` or the end of the rule containing `s` is reached,
     * {@link Token#EPSILON} is added to the result set. If `ctx` is not
     * {@link PredictionContext#EMPTY_LOCAL} and `addEOF` is `true`
     * and `stopState` or the end of the outermost rule is reached,
     * {@link Token#EOF} is added to the result set.
     *
     * @param s the ATN state.
     * @param stopState the ATN state to stop at. This can be a
     * {@link BlockEndState} to detect epsilon paths through a closure.
     * @param ctx The outer context, or {@link PredictionContext#EMPTY_LOCAL} if
     * the outer context should not be used.
     * @param look The result lookahead set.
     * @param lookBusy A set used for preventing epsilon closures in the ATN
     * from causing a stack overflow. Outside code should pass
     * `new HashSet<ATNConfig>` for this argument.
     * @param calledRuleStack A set used for preventing left recursion in the
     * ATN from causing a stack overflow. Outside code should pass
     * `new BitSet()` for this argument.
     * @param seeThruPreds `true` to true semantic predicates as
     * implicitly `true` and "see through them", otherwise `false`
     * to treat semantic predicates as opaque and add {@link #HIT_PRED} to the
     * result if one is encountered.
     * @param addEOF Add {@link Token#EOF} to the result if the end of the
     * outermost context is reached. This parameter has no effect if `ctx`
     * is {@link PredictionContext#EMPTY_LOCAL}.
     */ _LOOK(s, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF) {
        //		System.out.println("_LOOK("+s.stateNumber+", ctx="+ctx);
        let c = $hdFz0.ATNConfig.create(s, 0, ctx);
        if (!lookBusy.add(c)) return;
        if (s === stopState) {
            if ($jaUCz.PredictionContext.isEmptyLocal(ctx)) {
                look.add($eKXi4.Token.EPSILON);
                return;
            } else if (ctx.isEmpty) {
                if (addEOF) look.add($eKXi4.Token.EOF);
                return;
            }
        }
        if (s instanceof $jWsYN.RuleStopState) {
            if (ctx.isEmpty && !$jaUCz.PredictionContext.isEmptyLocal(ctx)) {
                if (addEOF) look.add($eKXi4.Token.EOF);
                return;
            }
            let removed = calledRuleStack.get(s.ruleIndex);
            try {
                calledRuleStack.clear(s.ruleIndex);
                for(let i = 0; i < ctx.size; i++){
                    if (ctx.getReturnState(i) === $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                    let returnState = this.atn.states[ctx.getReturnState(i)];
                    //					System.out.println("popping back to "+retState);
                    this._LOOK(returnState, stopState, ctx.getParent(i), look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                }
            } finally{
                if (removed) calledRuleStack.set(s.ruleIndex);
            }
        }
        let n = s.numberOfTransitions;
        for(let i = 0; i < n; i++){
            let t = s.transition(i);
            if (t instanceof $lmhna.RuleTransition) {
                if (calledRuleStack.get(t.ruleIndex)) continue;
                let newContext = ctx.getChild(t.followState.stateNumber);
                try {
                    calledRuleStack.set(t.ruleIndex);
                    this._LOOK(t.target, stopState, newContext, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                } finally{
                    calledRuleStack.clear(t.ruleIndex);
                }
            } else if (t instanceof $kvmNv.AbstractPredicateTransition) {
                if (seeThruPreds) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                else look.add(LL1Analyzer.HIT_PRED);
            } else if (t.isEpsilon) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
            else if (t instanceof $69uaV.WildcardTransition) look.addAll($6kdz0.IntervalSet.of($eKXi4.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
            else {
                //				System.out.println("adding "+ t);
                let set = t.label;
                if (set != null) {
                    if (t instanceof $gFTdY.NotSetTransition) set = set.complement($6kdz0.IntervalSet.of($eKXi4.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                    look.addAll(set);
                }
            }
        }
    }
};
/** Special value added to the lookahead sets to indicate that we hit
 *  a predicate during analysis if `seeThruPreds==false`.
 */ $f38a4b008fb55a2e$var$LL1Analyzer.HIT_PRED = $eKXi4.Token.INVALID_TYPE;
$f38a4b008fb55a2e$var$__decorate([
    $aN41m.NotNull
], $f38a4b008fb55a2e$var$LL1Analyzer.prototype, "atn", void 0);
$f38a4b008fb55a2e$var$__decorate([
    $aN41m.NotNull,
    $f38a4b008fb55a2e$var$__param(0, $aN41m.NotNull),
    $f38a4b008fb55a2e$var$__param(1, $aN41m.NotNull)
], $f38a4b008fb55a2e$var$LL1Analyzer.prototype, "LOOK", null);
$f38a4b008fb55a2e$var$__decorate([
    $f38a4b008fb55a2e$var$__param(0, $aN41m.NotNull),
    $f38a4b008fb55a2e$var$__param(2, $aN41m.NotNull),
    $f38a4b008fb55a2e$var$__param(3, $aN41m.NotNull),
    $f38a4b008fb55a2e$var$__param(4, $aN41m.NotNull),
    $f38a4b008fb55a2e$var$__param(5, $aN41m.NotNull)
], $f38a4b008fb55a2e$var$LL1Analyzer.prototype, "_LOOK", null);
$f38a4b008fb55a2e$var$LL1Analyzer = $f38a4b008fb55a2e$var$__decorate([
    $f38a4b008fb55a2e$var$__param(0, $aN41m.NotNull)
], $f38a4b008fb55a2e$var$LL1Analyzer);
module.exports.LL1Analyzer = $f38a4b008fb55a2e$var$LL1Analyzer;

});
parcelRegister("gFTdY", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c23b501a5502a14e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c23b501a5502a14e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NotSetTransition = void 0;

var $aN41m = parcelRequire("aN41m");

var $5EcBU = parcelRequire("5EcBU");
let $c23b501a5502a14e$var$NotSetTransition = class NotSetTransition extends $5EcBU.SetTransition {
    constructor(target, set){
        super(target, set);
    }
    get serializationType() {
        return 8 /* NOT_SET */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol && !super.matches(symbol, minVocabSymbol, maxVocabSymbol);
    }
    toString() {
        return "~" + super.toString();
    }
};
$c23b501a5502a14e$var$__decorate([
    $aN41m.Override
], $c23b501a5502a14e$var$NotSetTransition.prototype, "serializationType", null);
$c23b501a5502a14e$var$__decorate([
    $aN41m.Override
], $c23b501a5502a14e$var$NotSetTransition.prototype, "matches", null);
$c23b501a5502a14e$var$__decorate([
    $aN41m.Override
], $c23b501a5502a14e$var$NotSetTransition.prototype, "toString", null);
$c23b501a5502a14e$var$NotSetTransition = $c23b501a5502a14e$var$__decorate([
    $c23b501a5502a14e$var$__param(0, $aN41m.NotNull),
    $c23b501a5502a14e$var$__param(1, $aN41m.Nullable)
], $c23b501a5502a14e$var$NotSetTransition);
module.exports.NotSetTransition = $c23b501a5502a14e$var$NotSetTransition;

});
parcelRegister("5EcBU", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $41ca785f4c67a19a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $41ca785f4c67a19a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetTransition = void 0;

var $6kdz0 = parcelRequire("6kdz0");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");

var $5NWCj = parcelRequire("5NWCj");
/** A transition containing a set of values. */ let $41ca785f4c67a19a$var$SetTransition = class SetTransition extends $5NWCj.Transition {
    // TODO (sam): should we really allow undefined here?
    constructor(target, set){
        super(target);
        if (set == null) set = $6kdz0.IntervalSet.of($eKXi4.Token.INVALID_TYPE);
        this.set = set;
    }
    get serializationType() {
        return 7 /* SET */ ;
    }
    get label() {
        return this.set;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this.set.contains(symbol);
    }
    toString() {
        return this.set.toString();
    }
};
$41ca785f4c67a19a$var$__decorate([
    $aN41m.NotNull
], $41ca785f4c67a19a$var$SetTransition.prototype, "set", void 0);
$41ca785f4c67a19a$var$__decorate([
    $aN41m.Override
], $41ca785f4c67a19a$var$SetTransition.prototype, "serializationType", null);
$41ca785f4c67a19a$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $41ca785f4c67a19a$var$SetTransition.prototype, "label", null);
$41ca785f4c67a19a$var$__decorate([
    $aN41m.Override
], $41ca785f4c67a19a$var$SetTransition.prototype, "matches", null);
$41ca785f4c67a19a$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $41ca785f4c67a19a$var$SetTransition.prototype, "toString", null);
$41ca785f4c67a19a$var$SetTransition = $41ca785f4c67a19a$var$__decorate([
    $41ca785f4c67a19a$var$__param(0, $aN41m.NotNull),
    $41ca785f4c67a19a$var$__param(1, $aN41m.Nullable)
], $41ca785f4c67a19a$var$SetTransition);
module.exports.SetTransition = $41ca785f4c67a19a$var$SetTransition;

});


parcelRegister("jWsYN", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e849e9dccd4b044f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStopState = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $aN41m = parcelRequire("aN41m");
/** The last node in the ATN for a rule, unless that rule is the start symbol.
 *  In that case, there is one transition to EOF. Later, we might encode
 *  references to all calls to this rule to compute FOLLOW sets for
 *  error handling.
 */ class $e849e9dccd4b044f$var$RuleStopState extends $dv9vN.ATNState {
    get nonStopStateNumber() {
        return -1;
    }
    get stateType() {
        return $fZESB.ATNStateType.RULE_STOP;
    }
}
$e849e9dccd4b044f$var$__decorate([
    $aN41m.Override
], $e849e9dccd4b044f$var$RuleStopState.prototype, "nonStopStateNumber", null);
$e849e9dccd4b044f$var$__decorate([
    $aN41m.Override
], $e849e9dccd4b044f$var$RuleStopState.prototype, "stateType", null);
module.exports.RuleStopState = $e849e9dccd4b044f$var$RuleStopState;

});

parcelRegister("lmhna", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f8c920e267cf5afe$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f8c920e267cf5afe$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleTransition = void 0;

var $aN41m = parcelRequire("aN41m");

var $5NWCj = parcelRequire("5NWCj");
/** */ let $f8c920e267cf5afe$var$RuleTransition = class RuleTransition extends $5NWCj.Transition {
    constructor(ruleStart, ruleIndex, precedence, followState){
        super(ruleStart);
        this.tailCall = false;
        this.optimizedTailCall = false;
        this.ruleIndex = ruleIndex;
        this.precedence = precedence;
        this.followState = followState;
    }
    get serializationType() {
        return 3 /* RULE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
};
$f8c920e267cf5afe$var$__decorate([
    $aN41m.NotNull
], $f8c920e267cf5afe$var$RuleTransition.prototype, "followState", void 0);
$f8c920e267cf5afe$var$__decorate([
    $aN41m.Override
], $f8c920e267cf5afe$var$RuleTransition.prototype, "serializationType", null);
$f8c920e267cf5afe$var$__decorate([
    $aN41m.Override
], $f8c920e267cf5afe$var$RuleTransition.prototype, "isEpsilon", null);
$f8c920e267cf5afe$var$__decorate([
    $aN41m.Override
], $f8c920e267cf5afe$var$RuleTransition.prototype, "matches", null);
$f8c920e267cf5afe$var$RuleTransition = $f8c920e267cf5afe$var$__decorate([
    $f8c920e267cf5afe$var$__param(0, $aN41m.NotNull),
    $f8c920e267cf5afe$var$__param(3, $aN41m.NotNull)
], $f8c920e267cf5afe$var$RuleTransition);
module.exports.RuleTransition = $f8c920e267cf5afe$var$RuleTransition;

});

parcelRegister("69uaV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0127eb50794c99a9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0127eb50794c99a9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WildcardTransition = void 0;

var $aN41m = parcelRequire("aN41m");

var $5NWCj = parcelRequire("5NWCj");
let $0127eb50794c99a9$var$WildcardTransition = class WildcardTransition extends $5NWCj.Transition {
    constructor(target){
        super(target);
    }
    get serializationType() {
        return 9 /* WILDCARD */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol;
    }
    toString() {
        return ".";
    }
};
$0127eb50794c99a9$var$__decorate([
    $aN41m.Override
], $0127eb50794c99a9$var$WildcardTransition.prototype, "serializationType", null);
$0127eb50794c99a9$var$__decorate([
    $aN41m.Override
], $0127eb50794c99a9$var$WildcardTransition.prototype, "matches", null);
$0127eb50794c99a9$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $0127eb50794c99a9$var$WildcardTransition.prototype, "toString", null);
$0127eb50794c99a9$var$WildcardTransition = $0127eb50794c99a9$var$__decorate([
    $0127eb50794c99a9$var$__param(0, $aN41m.NotNull)
], $0127eb50794c99a9$var$WildcardTransition);
module.exports.WildcardTransition = $0127eb50794c99a9$var$WildcardTransition;

});



parcelRegister("i6TH4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d2f3fd2991f6cfe3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d2f3fd2991f6cfe3$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerActionExecutor = void 0;

var $6iIjF = parcelRequire("6iIjF");

var $jKxtl = parcelRequire("jKxtl");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Represents an executor for a sequence of lexer actions which traversed during
 * the matching operation of a lexer rule (token).
 *
 * The executor tracks position information for position-dependent lexer actions
 * efficiently, ensuring that actions appearing only at the end of the rule do
 * not cause bloating of the {@link DFA} created for the lexer.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $d2f3fd2991f6cfe3$var$LexerActionExecutor = class LexerActionExecutor {
    /**
     * Constructs an executor for a sequence of {@link LexerAction} actions.
     * @param lexerActions The lexer actions to execute.
     */ constructor(lexerActions){
        this._lexerActions = lexerActions;
        let hash = $amQx9.MurmurHash.initialize();
        for (let lexerAction of lexerActions)hash = $amQx9.MurmurHash.update(hash, lexerAction);
        this.cachedHashCode = $amQx9.MurmurHash.finish(hash, lexerActions.length);
    }
    /**
     * Creates a {@link LexerActionExecutor} which executes the actions for
     * the input `lexerActionExecutor` followed by a specified
     * `lexerAction`.
     *
     * @param lexerActionExecutor The executor for actions already traversed by
     * the lexer while matching a token within a particular
     * {@link ATNConfig}. If this is `undefined`, the method behaves as though
     * it were an empty executor.
     * @param lexerAction The lexer action to execute after the actions
     * specified in `lexerActionExecutor`.
     *
     * @returns A {@link LexerActionExecutor} for executing the combine actions
     * of `lexerActionExecutor` and `lexerAction`.
     */ static append(lexerActionExecutor, lexerAction) {
        if (!lexerActionExecutor) return new LexerActionExecutor([
            lexerAction
        ]);
        let lexerActions = lexerActionExecutor._lexerActions.slice(0);
        lexerActions.push(lexerAction);
        return new LexerActionExecutor(lexerActions);
    }
    /**
     * Creates a {@link LexerActionExecutor} which encodes the current offset
     * for position-dependent lexer actions.
     *
     * Normally, when the executor encounters lexer actions where
     * {@link LexerAction#isPositionDependent} returns `true`, it calls
     * {@link IntStream#seek} on the input {@link CharStream} to set the input
     * position to the *end* of the current token. This behavior provides
     * for efficient DFA representation of lexer actions which appear at the end
     * of a lexer rule, even when the lexer rule matches a variable number of
     * characters.
     *
     * Prior to traversing a match transition in the ATN, the current offset
     * from the token start index is assigned to all position-dependent lexer
     * actions which have not already been assigned a fixed offset. By storing
     * the offsets relative to the token start index, the DFA representation of
     * lexer actions which appear in the middle of tokens remains efficient due
     * to sharing among tokens of the same length, regardless of their absolute
     * position in the input stream.
     *
     * If the current executor already has offsets assigned to all
     * position-dependent lexer actions, the method returns `this`.
     *
     * @param offset The current offset to assign to all position-dependent
     * lexer actions which do not already have offsets assigned.
     *
     * @returns A {@link LexerActionExecutor} which stores input stream offsets
     * for all position-dependent lexer actions.
     */ fixOffsetBeforeMatch(offset) {
        let updatedLexerActions;
        for(let i = 0; i < this._lexerActions.length; i++)if (this._lexerActions[i].isPositionDependent && !(this._lexerActions[i] instanceof $jKxtl.LexerIndexedCustomAction)) {
            if (!updatedLexerActions) updatedLexerActions = this._lexerActions.slice(0);
            updatedLexerActions[i] = new $jKxtl.LexerIndexedCustomAction(offset, this._lexerActions[i]);
        }
        if (!updatedLexerActions) return this;
        return new LexerActionExecutor(updatedLexerActions);
    }
    /**
     * Gets the lexer actions to be executed by this executor.
     * @returns The lexer actions to be executed by this executor.
     */ get lexerActions() {
        return this._lexerActions;
    }
    /**
     * Execute the actions encapsulated by this executor within the context of a
     * particular {@link Lexer}.
     *
     * This method calls {@link IntStream#seek} to set the position of the
     * `input` {@link CharStream} prior to calling
     * {@link LexerAction#execute} on a position-dependent action. Before the
     * method returns, the input position will be restored to the same position
     * it was in when the method was invoked.
     *
     * @param lexer The lexer instance.
     * @param input The input stream which is the source for the current token.
     * When this method is called, the current {@link IntStream#index} for
     * `input` should be the start of the following token, i.e. 1
     * character past the end of the current token.
     * @param startIndex The token start index. This value may be passed to
     * {@link IntStream#seek} to set the `input` position to the beginning
     * of the token.
     */ execute(lexer, input, startIndex) {
        let requiresSeek = false;
        let stopIndex = input.index;
        try {
            for (let lexerAction of this._lexerActions){
                if (lexerAction instanceof $jKxtl.LexerIndexedCustomAction) {
                    let offset = lexerAction.offset;
                    input.seek(startIndex + offset);
                    lexerAction = lexerAction.action;
                    requiresSeek = startIndex + offset !== stopIndex;
                } else if (lexerAction.isPositionDependent) {
                    input.seek(stopIndex);
                    requiresSeek = false;
                }
                lexerAction.execute(lexer);
            }
        } finally{
            if (requiresSeek) input.seek(stopIndex);
        }
    }
    hashCode() {
        return this.cachedHashCode;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerActionExecutor)) return false;
        return this.cachedHashCode === obj.cachedHashCode && $6iIjF.ArrayEqualityComparator.INSTANCE.equals(this._lexerActions, obj._lexerActions);
    }
};
$d2f3fd2991f6cfe3$var$__decorate([
    $aN41m.NotNull
], $d2f3fd2991f6cfe3$var$LexerActionExecutor.prototype, "_lexerActions", void 0);
$d2f3fd2991f6cfe3$var$__decorate([
    $aN41m.NotNull
], $d2f3fd2991f6cfe3$var$LexerActionExecutor.prototype, "lexerActions", null);
$d2f3fd2991f6cfe3$var$__decorate([
    $d2f3fd2991f6cfe3$var$__param(0, $aN41m.NotNull)
], $d2f3fd2991f6cfe3$var$LexerActionExecutor.prototype, "execute", null);
$d2f3fd2991f6cfe3$var$__decorate([
    $aN41m.Override
], $d2f3fd2991f6cfe3$var$LexerActionExecutor.prototype, "hashCode", null);
$d2f3fd2991f6cfe3$var$__decorate([
    $aN41m.Override
], $d2f3fd2991f6cfe3$var$LexerActionExecutor.prototype, "equals", null);
$d2f3fd2991f6cfe3$var$__decorate([
    $aN41m.NotNull,
    $d2f3fd2991f6cfe3$var$__param(1, $aN41m.NotNull)
], $d2f3fd2991f6cfe3$var$LexerActionExecutor, "append", null);
$d2f3fd2991f6cfe3$var$LexerActionExecutor = $d2f3fd2991f6cfe3$var$__decorate([
    $d2f3fd2991f6cfe3$var$__param(0, $aN41m.NotNull)
], $d2f3fd2991f6cfe3$var$LexerActionExecutor);
module.exports.LexerActionExecutor = $d2f3fd2991f6cfe3$var$LexerActionExecutor;

});
parcelRegister("jKxtl", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e60c471ba1c7e661$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e60c471ba1c7e661$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerIndexedCustomAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * This implementation of {@link LexerAction} is used for tracking input offsets
 * for position-dependent actions within a {@link LexerActionExecutor}.
 *
 * This action is not serialized as part of the ATN, and is only required for
 * position-dependent lexer actions which appear at a location other than the
 * end of a rule. For more information about DFA optimizations employed for
 * lexer actions, see {@link LexerActionExecutor#append} and
 * {@link LexerActionExecutor#fixOffsetBeforeMatch}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $e60c471ba1c7e661$var$LexerIndexedCustomAction = class LexerIndexedCustomAction {
    /**
     * Constructs a new indexed custom action by associating a character offset
     * with a {@link LexerAction}.
     *
     * Note: This class is only required for lexer actions for which
     * {@link LexerAction#isPositionDependent} returns `true`.
     *
     * @param offset The offset into the input {@link CharStream}, relative to
     * the token start index, at which the specified lexer action should be
     * executed.
     * @param action The lexer action to execute at a particular offset in the
     * input {@link CharStream}.
     */ constructor(offset, action){
        this._offset = offset;
        this._action = action;
    }
    /**
     * Gets the location in the input {@link CharStream} at which the lexer
     * action should be executed. The value is interpreted as an offset relative
     * to the token start index.
     *
     * @returns The location in the input {@link CharStream} at which the lexer
     * action should be executed.
     */ get offset() {
        return this._offset;
    }
    /**
     * Gets the lexer action to execute.
     *
     * @returns A {@link LexerAction} object which executes the lexer action.
     */ get action() {
        return this._action;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns the result of calling {@link #getActionType}
     * on the {@link LexerAction} returned by {@link #getAction}.
     */ get actionType() {
        return this._action.actionType;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * This method calls {@link #execute} on the result of {@link #getAction}
     * using the provided `lexer`.
     */ execute(lexer) {
        // assume the input stream position was properly set by the calling code
        this._action.execute(lexer);
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this._offset);
        hash = $amQx9.MurmurHash.update(hash, this._action);
        return $amQx9.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerIndexedCustomAction)) return false;
        return this._offset === obj._offset && this._action.equals(obj._action);
    }
};
$e60c471ba1c7e661$var$__decorate([
    $aN41m.NotNull
], $e60c471ba1c7e661$var$LexerIndexedCustomAction.prototype, "action", null);
$e60c471ba1c7e661$var$__decorate([
    $aN41m.Override
], $e60c471ba1c7e661$var$LexerIndexedCustomAction.prototype, "actionType", null);
$e60c471ba1c7e661$var$__decorate([
    $aN41m.Override
], $e60c471ba1c7e661$var$LexerIndexedCustomAction.prototype, "isPositionDependent", null);
$e60c471ba1c7e661$var$__decorate([
    $aN41m.Override
], $e60c471ba1c7e661$var$LexerIndexedCustomAction.prototype, "execute", null);
$e60c471ba1c7e661$var$__decorate([
    $aN41m.Override
], $e60c471ba1c7e661$var$LexerIndexedCustomAction.prototype, "hashCode", null);
$e60c471ba1c7e661$var$__decorate([
    $aN41m.Override
], $e60c471ba1c7e661$var$LexerIndexedCustomAction.prototype, "equals", null);
$e60c471ba1c7e661$var$LexerIndexedCustomAction = $e60c471ba1c7e661$var$__decorate([
    $e60c471ba1c7e661$var$__param(1, $aN41m.NotNull)
], $e60c471ba1c7e661$var$LexerIndexedCustomAction);
module.exports.LexerIndexedCustomAction = $e60c471ba1c7e661$var$LexerIndexedCustomAction;

});


parcelRegister("l3IpB", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f54c54195bb1f77d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f54c54195bb1f77d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerNoViableAltException = void 0;

var $b7PPe = parcelRequire("b7PPe");

var $aN41m = parcelRequire("aN41m");

var $l8y5T = parcelRequire("l8y5T");

var $62Uvn = parcelRequire("62Uvn");
let $f54c54195bb1f77d$var$LexerNoViableAltException = class LexerNoViableAltException extends $b7PPe.RecognitionException {
    constructor(lexer, input, startIndex, deadEndConfigs){
        super(lexer, input);
        this._startIndex = startIndex;
        this._deadEndConfigs = deadEndConfigs;
    }
    get startIndex() {
        return this._startIndex;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
    get inputStream() {
        return super.inputStream;
    }
    toString() {
        let symbol = "";
        if (this._startIndex >= 0 && this._startIndex < this.inputStream.size) {
            symbol = this.inputStream.getText($l8y5T.Interval.of(this._startIndex, this._startIndex));
            symbol = $62Uvn.escapeWhitespace(symbol, false);
        }
        // return String.format(Locale.getDefault(), "%s('%s')", LexerNoViableAltException.class.getSimpleName(), symbol);
        return `LexerNoViableAltException('${symbol}')`;
    }
};
$f54c54195bb1f77d$var$__decorate([
    $aN41m.Override
], $f54c54195bb1f77d$var$LexerNoViableAltException.prototype, "inputStream", null);
$f54c54195bb1f77d$var$__decorate([
    $aN41m.Override
], $f54c54195bb1f77d$var$LexerNoViableAltException.prototype, "toString", null);
$f54c54195bb1f77d$var$LexerNoViableAltException = $f54c54195bb1f77d$var$__decorate([
    $f54c54195bb1f77d$var$__param(1, $aN41m.NotNull)
], $f54c54195bb1f77d$var$LexerNoViableAltException);
module.exports.LexerNoViableAltException = $f54c54195bb1f77d$var$LexerNoViableAltException;

});

parcelRegister("9O0ze", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7239393757aed774$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OrderedATNConfigSet = void 0;

var $2SGHL = parcelRequire("2SGHL");

var $aN41m = parcelRequire("aN41m");
/**
 *
 * @author Sam Harwell
 */ class $7239393757aed774$var$OrderedATNConfigSet extends $2SGHL.ATNConfigSet {
    constructor(set, readonly){
        if (set != null && readonly != null) super(set, readonly);
        else super();
    }
    clone(readonly) {
        let copy = new $7239393757aed774$var$OrderedATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this);
        return copy;
    }
    getKey(e) {
        // This is a specially crafted key to ensure configurations are only merged if they are equal
        return {
            state: 0,
            alt: e.hashCode()
        };
    }
    canMerge(left, leftKey, right) {
        return left.equals(right);
    }
}
$7239393757aed774$var$__decorate([
    $aN41m.Override
], $7239393757aed774$var$OrderedATNConfigSet.prototype, "clone", null);
$7239393757aed774$var$__decorate([
    $aN41m.Override
], $7239393757aed774$var$OrderedATNConfigSet.prototype, "getKey", null);
$7239393757aed774$var$__decorate([
    $aN41m.Override
], $7239393757aed774$var$OrderedATNConfigSet.prototype, "canMerge", null);
module.exports.OrderedATNConfigSet = $7239393757aed774$var$OrderedATNConfigSet;

});




parcelRegister("iAlWg", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d87c9b6083957611$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoViableAltException = void 0;

var $c9Sjf = parcelRequire("c9Sjf");

var $b7PPe = parcelRequire("b7PPe");

var $aN41m = parcelRequire("aN41m");
/** Indicates that the parser could not decide which of two or more paths
 *  to take based upon the remaining input. It tracks the starting token
 *  of the offending input and also knows where the parser was
 *  in the various paths when the error. Reported by reportNoViableAlternative()
 */ class $d87c9b6083957611$var$NoViableAltException extends $b7PPe.RecognitionException {
    constructor(recognizer, input, startToken, offendingToken, deadEndConfigs, ctx){
        if (recognizer instanceof $c9Sjf.Parser) {
            if (input === undefined) input = recognizer.inputStream;
            if (startToken === undefined) startToken = recognizer.currentToken;
            if (offendingToken === undefined) offendingToken = recognizer.currentToken;
            if (ctx === undefined) ctx = recognizer.context;
        }
        super(recognizer, input, ctx);
        this._deadEndConfigs = deadEndConfigs;
        this._startToken = startToken;
        this.setOffendingToken(recognizer, offendingToken);
    }
    get startToken() {
        return this._startToken;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
}
$d87c9b6083957611$var$__decorate([
    $aN41m.NotNull
], $d87c9b6083957611$var$NoViableAltException.prototype, "_startToken", void 0);
module.exports.NoViableAltException = $d87c9b6083957611$var$NoViableAltException;

});
parcelRegister("c9Sjf", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8da07405e42e2bc1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8da07405e42e2bc1$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var $8da07405e42e2bc1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Parser = void 0;

var $62Uvn = parcelRequire("62Uvn");

var $3VQ9j = parcelRequire("3VQ9j");

var $1ztRl = parcelRequire("1ztRl");

var $3HZil = parcelRequire("3HZil");

var $co9Xk = parcelRequire("co9Xk");

var $jB0DW = parcelRequire("jB0DW");

var $h7Q3L = parcelRequire("h7Q3L");

var $aN41m = parcelRequire("aN41m");

var $8EOCV = parcelRequire("8EOCV");

var $gzbPK = parcelRequire("gzbPK");

var $jdbdJ = parcelRequire("jdbdJ");

var $dwftT = parcelRequire("dwftT");

var $2IN61 = parcelRequire("2IN61");

var $eKXi4 = parcelRequire("eKXi4");
class $8da07405e42e2bc1$var$TraceListener {
    constructor(ruleNames, tokenStream){
        this.ruleNames = ruleNames;
        this.tokenStream = tokenStream;
    }
    enterEveryRule(ctx) {
        console.log("enter   " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    exitEveryRule(ctx) {
        console.log("exit    " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    visitErrorNode(node) {
    // intentionally empty
    }
    visitTerminal(node) {
        let parent = node.parent.ruleContext;
        let token = node.symbol;
        console.log("consume " + token + " rule " + this.ruleNames[parent.ruleIndex]);
    }
}
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$TraceListener.prototype, "enterEveryRule", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$TraceListener.prototype, "exitEveryRule", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$TraceListener.prototype, "visitErrorNode", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$TraceListener.prototype, "visitTerminal", null);



/** This is all the parsing support code essentially; most of it is error recovery stuff. */ class $8da07405e42e2bc1$var$Parser extends $dwftT.Recognizer {
    constructor(input){
        super();
        /**
         * The error handling strategy for the parser. The default value is a new
         * instance of {@link DefaultErrorStrategy}.
         *
         * @see #getErrorHandler
         * @see #setErrorHandler
         */ this._errHandler = new $3HZil.DefaultErrorStrategy();
        this._precedenceStack = new $jB0DW.IntegerStack();
        /**
         * Specifies whether or not the parser should construct a parse tree during
         * the parsing process. The default value is `true`.
         *
         * @see `buildParseTree`
         */ this._buildParseTrees = true;
        /**
         * The list of {@link ParseTreeListener} listeners registered to receive
         * events during the parse.
         *
         * @see #addParseListener
         */ this._parseListeners = [];
        /**
         * The number of syntax errors reported during parsing. This value is
         * incremented each time {@link #notifyErrorListeners} is called.
         */ this._syntaxErrors = 0;
        /** Indicates parser has match()ed EOF token. See {@link #exitRule()}. */ this.matchedEOF = false;
        this._precedenceStack.push(0);
        this.inputStream = input;
    }
    reset(resetInput) {
        // Note: this method executes when not parsing, so _ctx can be undefined
        if (resetInput === undefined || resetInput) this.inputStream.seek(0);
        this._errHandler.reset(this);
        this._ctx = undefined;
        this._syntaxErrors = 0;
        this.matchedEOF = false;
        this.isTrace = false;
        this._precedenceStack.clear();
        this._precedenceStack.push(0);
        let interpreter = this.interpreter;
        if (interpreter != null) interpreter.reset();
    }
    /**
     * Match current input symbol against `ttype`. If the symbol type
     * matches, {@link ANTLRErrorStrategy#reportMatch} and {@link #consume} are
     * called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @param ttype the token type to match
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * `ttype` and the error strategy could not recover from the
     * mismatched symbol
     */ match(ttype) {
        let t = this.currentToken;
        if (t.type === ttype) {
            if (ttype === $eKXi4.Token.EOF) this.matchedEOF = true;
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Match current input symbol as a wildcard. If the symbol type matches
     * (i.e. has a value greater than 0), {@link ANTLRErrorStrategy#reportMatch}
     * and {@link #consume} are called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link Parser#createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * a wildcard and the error strategy could not recover from the mismatched
     * symbol
     */ matchWildcard() {
        let t = this.currentToken;
        if (t.type > 0) {
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Track the {@link ParserRuleContext} objects during the parse and hook
     * them up using the {@link ParserRuleContext#children} list so that it
     * forms a parse tree. The {@link ParserRuleContext} returned from the start
     * rule represents the root of the parse tree.
     *
     * Note that if we are not building parse trees, rule contexts only point
     * upwards. When a rule exits, it returns the context but that gets garbage
     * collected if nobody holds a reference. It points upwards but nobody
     * points at it.
     *
     * When we build parse trees, we are adding all of these contexts to
     * {@link ParserRuleContext#children} list. Contexts are then not candidates
     * for garbage collection.
     */ set buildParseTree(buildParseTrees) {
        this._buildParseTrees = buildParseTrees;
    }
    /**
     * Gets whether or not a complete parse tree will be constructed while
     * parsing. This property is `true` for a newly constructed parser.
     *
     * @returns `true` if a complete parse tree will be constructed while
     * parsing, otherwise `false`
     */ get buildParseTree() {
        return this._buildParseTrees;
    }
    getParseListeners() {
        return this._parseListeners;
    }
    /**
     * Registers `listener` to receive events during the parsing process.
     *
     * To support output-preserving grammar transformations (including but not
     * limited to left-recursion removal, automated left-factoring, and
     * optimized code generation), calls to listener methods during the parse
     * may differ substantially from calls made by
     * {@link ParseTreeWalker#DEFAULT} used after the parse is complete. In
     * particular, rule entry and exit events may occur in a different order
     * during the parse than after the parser. In addition, calls to certain
     * rule entry methods may be omitted.
     *
     * With the following specific exceptions, calls to listener events are
     * *deterministic*, i.e. for identical input the calls to listener
     * methods will be the same.
     *
     * * Alterations to the grammar used to generate code may change the
     *   behavior of the listener calls.
     * * Alterations to the command line options passed to ANTLR 4 when
     *   generating the parser may change the behavior of the listener calls.
     * * Changing the version of the ANTLR Tool used to generate the parser
     *   may change the behavior of the listener calls.
     *
     * @param listener the listener to add
     *
     * @throws {@link TypeError} if `listener` is `undefined`
     */ addParseListener(listener) {
        if (listener == null) throw new TypeError("listener cannot be null");
        this._parseListeners.push(listener);
    }
    /**
     * Remove `listener` from the list of parse listeners.
     *
     * If `listener` is `undefined` or has not been added as a parse
     * listener, this method does nothing.
     *
     * @see #addParseListener
     *
     * @param listener the listener to remove
     */ removeParseListener(listener) {
        let index = this._parseListeners.findIndex((l)=>l === listener);
        if (index !== -1) this._parseListeners.splice(index, 1);
    }
    /**
     * Remove all parse listeners.
     *
     * @see #addParseListener
     */ removeParseListeners() {
        this._parseListeners.length = 0;
    }
    /**
     * Notify any parse listeners of an enter rule event.
     *
     * @see #addParseListener
     */ triggerEnterRuleEvent() {
        for (let listener of this._parseListeners){
            if (listener.enterEveryRule) listener.enterEveryRule(this._ctx);
            this._ctx.enterRule(listener);
        }
    }
    /**
     * Notify any parse listeners of an exit rule event.
     *
     * @see #addParseListener
     */ triggerExitRuleEvent() {
        // reverse order walk of listeners
        for(let i = this._parseListeners.length - 1; i >= 0; i--){
            let listener = this._parseListeners[i];
            this._ctx.exitRule(listener);
            if (listener.exitEveryRule) listener.exitEveryRule(this._ctx);
        }
    }
    /**
     * Gets the number of syntax errors reported during parsing. This value is
     * incremented each time {@link #notifyErrorListeners} is called.
     *
     * @see #notifyErrorListeners
     */ get numberOfSyntaxErrors() {
        return this._syntaxErrors;
    }
    get tokenFactory() {
        return this._input.tokenSource.tokenFactory;
    }
    /**
     * The ATN with bypass alternatives is expensive to create so we create it
     * lazily.
     *
     * @ if the current parser does not
     * implement the `serializedATN` property.
     */ getATNWithBypassAlts() {
        let serializedAtn = this.serializedATN;
        if (serializedAtn == null) throw new Error("The current parser does not support an ATN with bypass alternatives.");
        let result = $8da07405e42e2bc1$var$Parser.bypassAltsAtnCache.get(serializedAtn);
        if (result == null) {
            let deserializationOptions = new $3VQ9j.ATNDeserializationOptions();
            deserializationOptions.isGenerateRuleBypassTransitions = true;
            result = new $1ztRl.ATNDeserializer(deserializationOptions).deserialize($62Uvn.toCharArray(serializedAtn));
            $8da07405e42e2bc1$var$Parser.bypassAltsAtnCache.set(serializedAtn, result);
        }
        return result;
    }
    compileParseTreePattern(pattern, patternRuleIndex, lexer) {
        return $8da07405e42e2bc1$var$__awaiter(this, void 0, void 0, function*() {
            if (!lexer) {
                if (this.inputStream) {
                    let tokenSource = this.inputStream.tokenSource;
                    if (tokenSource instanceof $h7Q3L.Lexer) lexer = tokenSource;
                }
                if (!lexer) throw new Error("Parser can't discover a lexer to use");
            }
            let currentLexer = lexer;
            let m = yield Promise.resolve().then(()=>(parcelRequire("gQja9")));
            let matcher = new m.ParseTreePatternMatcher(currentLexer, this);
            return matcher.compile(pattern, patternRuleIndex);
        });
    }
    get errorHandler() {
        return this._errHandler;
    }
    set errorHandler(handler) {
        this._errHandler = handler;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the token stream and reset the parser. */ set inputStream(input) {
        this.reset(false);
        this._input = input;
    }
    /** Match needs to return the current input symbol, which gets put
     *  into the label for the associated token ref; e.g., x=ID.
     */ get currentToken() {
        return this._input.LT(1);
    }
    notifyErrorListeners(msg, offendingToken, e) {
        if (offendingToken === undefined) offendingToken = this.currentToken;
        else if (offendingToken === null) offendingToken = undefined;
        this._syntaxErrors++;
        let line = -1;
        let charPositionInLine = -1;
        if (offendingToken != null) {
            line = offendingToken.line;
            charPositionInLine = offendingToken.charPositionInLine;
        }
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, offendingToken, line, charPositionInLine, msg, e);
    }
    /**
     * Consume and return the [current symbol](`currentToken`).
     *
     * E.g., given the following input with `A` being the current
     * lookahead symbol, this function moves the cursor to `B` and returns
     * `A`.
     *
     * ```
     * A B
     * ^
     * ```
     *
     * If the parser is not in error recovery mode, the consumed symbol is added
     * to the parse tree using {@link ParserRuleContext#addChild(TerminalNode)}, and
     * {@link ParseTreeListener#visitTerminal} is called on any parse listeners.
     * If the parser *is* in error recovery mode, the consumed symbol is
     * added to the parse tree using {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)} and
     * {@link ParseTreeListener#visitErrorNode} is called on any parse
     * listeners.
     */ consume() {
        let o = this.currentToken;
        if (o.type !== $8da07405e42e2bc1$var$Parser.EOF) this.inputStream.consume();
        let hasListener = this._parseListeners.length !== 0;
        if (this._buildParseTrees || hasListener) {
            if (this._errHandler.inErrorRecoveryMode(this)) {
                let node = this._ctx.addErrorNode(this.createErrorNode(this._ctx, o));
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitErrorNode) listener.visitErrorNode(node);
                }
            } else {
                let node = this.createTerminalNode(this._ctx, o);
                this._ctx.addChild(node);
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitTerminal) listener.visitTerminal(node);
                }
            }
        }
        return o;
    }
    /**
     * How to create a token leaf node associated with a parent.
     * Typically, the terminal node to create is not a function of the parent.
     *
     * @since 4.7
     */ createTerminalNode(parent, t) {
        return new $2IN61.TerminalNode(t);
    }
    /**
     * How to create an error node, given a token, associated with a parent.
     * Typically, the error node to create is not a function of the parent.
     *
     * @since 4.7
     */ createErrorNode(parent, t) {
        return new $co9Xk.ErrorNode(t);
    }
    addContextToParseTree() {
        let parent = this._ctx._parent;
        // add current context to parent if we have a parent
        if (parent != null) parent.addChild(this._ctx);
    }
    /**
     * Always called by generated parsers upon entry to a rule. Access field
     * {@link #_ctx} get the current context.
     */ enterRule(localctx, state, ruleIndex) {
        this.state = state;
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    enterLeftFactoredRule(localctx, state, ruleIndex) {
        this.state = state;
        if (this._buildParseTrees) {
            let factoredContext = this._ctx.getChild(this._ctx.childCount - 1);
            this._ctx.removeLastChild();
            factoredContext._parent = localctx;
            localctx.addChild(factoredContext);
        }
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    exitRule() {
        if (this.matchedEOF) // if we have matched EOF, it cannot consume past EOF so we use LT(1) here
        this._ctx._stop = this._input.LT(1); // LT(1) will be end of file
        else this._ctx._stop = this._input.tryLT(-1); // stop node is what we just matched
        // trigger event on _ctx, before it reverts to parent
        this.triggerExitRuleEvent();
        this.state = this._ctx.invokingState;
        this._ctx = this._ctx._parent;
    }
    enterOuterAlt(localctx, altNum) {
        localctx.altNumber = altNum;
        // if we have new localctx, make sure we replace existing ctx
        // that is previous child of parse tree
        if (this._buildParseTrees && this._ctx !== localctx) {
            let parent = this._ctx._parent;
            if (parent != null) {
                parent.removeLastChild();
                parent.addChild(localctx);
            }
        }
        this._ctx = localctx;
    }
    /**
     * Get the precedence level for the top-most precedence rule.
     *
     * @returns The precedence level for the top-most precedence rule, or -1 if
     * the parser context is not nested within a precedence rule.
     */ get precedence() {
        if (this._precedenceStack.isEmpty) return -1;
        return this._precedenceStack.peek();
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this.state = state;
        this._precedenceStack.push(precedence);
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    /** Like {@link #enterRule} but for recursive rules.
     *  Make the current context the child of the incoming localctx.
     */ pushNewRecursionContext(localctx, state, ruleIndex) {
        let previous = this._ctx;
        previous._parent = localctx;
        previous.invokingState = state;
        previous._stop = this._input.tryLT(-1);
        this._ctx = localctx;
        this._ctx._start = previous._start;
        if (this._buildParseTrees) this._ctx.addChild(previous);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    unrollRecursionContexts(_parentctx) {
        this._precedenceStack.pop();
        this._ctx._stop = this._input.tryLT(-1);
        let retctx = this._ctx; // save current ctx (return value)
        // unroll so _ctx is as it was before call to recursive method
        if (this._parseListeners.length > 0) while(this._ctx !== _parentctx){
            this.triggerExitRuleEvent();
            this._ctx = this._ctx._parent;
        }
        else this._ctx = _parentctx;
        // hook into tree
        retctx._parent = _parentctx;
        if (this._buildParseTrees && _parentctx != null) // add return ctx into invoking rule's tree
        _parentctx.addChild(retctx);
    }
    getInvokingContext(ruleIndex) {
        let p = this._ctx;
        while(p && p.ruleIndex !== ruleIndex)p = p._parent;
        return p;
    }
    get context() {
        return this._ctx;
    }
    set context(ctx) {
        this._ctx = ctx;
    }
    precpred(localctx, precedence) {
        return precedence >= this._precedenceStack.peek();
    }
    getErrorListenerDispatch() {
        return new $jdbdJ.ProxyParserErrorListener(this.getErrorListeners());
    }
    inContext(context) {
        // TODO: useful in parser?
        return false;
    }
    /**
     * Checks whether or not `symbol` can follow the current state in the
     * ATN. The behavior of this method is equivalent to the following, but is
     * implemented such that the complete context-sensitive follow set does not
     * need to be explicitly constructed.
     *
     * ```
     * return getExpectedTokens().contains(symbol);
     * ```
     *
     * @param symbol the symbol type to check
     * @returns `true` if `symbol` can follow the current state in
     * the ATN, otherwise `false`.
     */ isExpectedToken(symbol) {
        //   		return interpreter.atn.nextTokens(_ctx);
        let atn = this.interpreter.atn;
        let ctx = this._ctx;
        let s = atn.states[this.state];
        let following = atn.nextTokens(s);
        if (following.contains(symbol)) return true;
        //        System.out.println("following "+s+"="+following);
        if (!following.contains($eKXi4.Token.EPSILON)) return false;
        while(ctx != null && ctx.invokingState >= 0 && following.contains($eKXi4.Token.EPSILON)){
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = atn.nextTokens(rt.followState);
            if (following.contains(symbol)) return true;
            ctx = ctx._parent;
        }
        if (following.contains($eKXi4.Token.EPSILON) && symbol === $eKXi4.Token.EOF) return true;
        return false;
    }
    get isMatchedEOF() {
        return this.matchedEOF;
    }
    /**
     * Computes the set of input symbols which could follow the current parser
     * state and context, as given by {@link #getState} and {@link #getContext},
     * respectively.
     *
     * @see ATN#getExpectedTokens(int, RuleContext)
     */ getExpectedTokens() {
        return this.atn.getExpectedTokens(this.state, this.context);
    }
    getExpectedTokensWithinCurrentRule() {
        let atn = this.interpreter.atn;
        let s = atn.states[this.state];
        return atn.nextTokens(s);
    }
    /** Get a rule's index (i.e., `RULE_ruleName` field) or -1 if not found. */ getRuleIndex(ruleName) {
        let ruleIndex = this.getRuleIndexMap().get(ruleName);
        if (ruleIndex != null) return ruleIndex;
        return -1;
    }
    get ruleContext() {
        return this._ctx;
    }
    /** Return List&lt;String&gt; of the rule names in your parser instance
     *  leading up to a call to the current rule.  You could override if
     *  you want more details such as the file/line info of where
     *  in the ATN a rule is invoked.
     *
     *  This is very useful for error messages.
     */ getRuleInvocationStack(ctx = this._ctx) {
        let p = ctx; // Workaround for Microsoft/TypeScript#14487
        let ruleNames = this.ruleNames;
        let stack = [];
        while(p != null){
            // compute what follows who invoked us
            let ruleIndex = p.ruleIndex;
            if (ruleIndex < 0) stack.push("n/a");
            else stack.push(ruleNames[ruleIndex]);
            p = p._parent;
        }
        return stack;
    }
    /** For debugging and other purposes. */ getDFAStrings() {
        let s = [];
        for (let dfa of this._interp.atn.decisionToDFA)s.push(dfa.toString(this.vocabulary, this.ruleNames));
        return s;
    }
    /** For debugging and other purposes. */ dumpDFA() {
        let seenOne = false;
        for (let dfa of this._interp.atn.decisionToDFA)if (!dfa.isEmpty) {
            if (seenOne) console.log();
            console.log("Decision " + dfa.decision + ":");
            $2fFJv.stdout.write(dfa.toString(this.vocabulary, this.ruleNames));
            seenOne = true;
        }
    }
    get sourceName() {
        return this._input.sourceName;
    }
    get parseInfo() {
        return Promise.resolve().then(()=>(parcelRequire("kTiid"))).then((m)=>{
            let interp = this.interpreter;
            if (interp instanceof m.ProfilingATNSimulator) return new $8EOCV.ParseInfo(interp);
            return undefined;
        });
    }
    /**
     * @since 4.3
     */ setProfile(profile) {
        return $8da07405e42e2bc1$var$__awaiter(this, void 0, void 0, function*() {
            let m = yield Promise.resolve().then(()=>(parcelRequire("kTiid")));
            let interp = this.interpreter;
            if (profile) {
                if (!(interp instanceof m.ProfilingATNSimulator)) this.interpreter = new m.ProfilingATNSimulator(this);
            } else if (interp instanceof m.ProfilingATNSimulator) this.interpreter = new $gzbPK.ParserATNSimulator(this.atn, this);
            this.interpreter.setPredictionMode(interp.getPredictionMode());
        });
    }
    /** During a parse is sometimes useful to listen in on the rule entry and exit
     *  events as well as token matches. This is for quick and dirty debugging.
     */ set isTrace(trace) {
        if (!trace) {
            if (this._tracer) {
                this.removeParseListener(this._tracer);
                this._tracer = undefined;
            }
        } else {
            if (this._tracer) this.removeParseListener(this._tracer);
            else this._tracer = new $8da07405e42e2bc1$var$TraceListener(this.ruleNames, this._input);
            this.addParseListener(this._tracer);
        }
    }
    /**
     * Gets whether a {@link TraceListener} is registered as a parse listener
     * for the parser.
     */ get isTrace() {
        return this._tracer != null;
    }
}
/**
 * This field maps from the serialized ATN string to the deserialized {@link ATN} with
 * bypass alternatives.
 *
 * @see ATNDeserializationOptions.isGenerateRuleBypassTransitions
 */ $8da07405e42e2bc1$var$Parser.bypassAltsAtnCache = new Map();
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "_errHandler", void 0);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "match", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "matchWildcard", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "getParseListeners", null);
$8da07405e42e2bc1$var$__decorate([
    $8da07405e42e2bc1$var$__param(0, $aN41m.NotNull)
], $8da07405e42e2bc1$var$Parser.prototype, "addParseListener", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "getATNWithBypassAlts", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull,
    $8da07405e42e2bc1$var$__param(0, $aN41m.NotNull)
], $8da07405e42e2bc1$var$Parser.prototype, "errorHandler", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$Parser.prototype, "inputStream", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "currentToken", null);
$8da07405e42e2bc1$var$__decorate([
    $8da07405e42e2bc1$var$__param(0, $aN41m.NotNull)
], $8da07405e42e2bc1$var$Parser.prototype, "enterRule", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override,
    $8da07405e42e2bc1$var$__param(0, $aN41m.Nullable)
], $8da07405e42e2bc1$var$Parser.prototype, "precpred", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$Parser.prototype, "getErrorListenerDispatch", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "getExpectedTokens", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "getExpectedTokensWithinCurrentRule", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$Parser.prototype, "parseInfo", null);
module.exports.Parser = $8da07405e42e2bc1$var$Parser;

});
parcelRegister("3VQ9j", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2dcf25b78652d5b7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializationOptions = void 0;

var $aN41m = parcelRequire("aN41m");
/**
 *
 * @author Sam Harwell
 */ class $2dcf25b78652d5b7$var$ATNDeserializationOptions {
    constructor(options){
        this.readOnly = false;
        if (options) {
            this.verifyATN = options.verifyATN;
            this.generateRuleBypassTransitions = options.generateRuleBypassTransitions;
            this.optimize = options.optimize;
        } else {
            this.verifyATN = true;
            this.generateRuleBypassTransitions = false;
            this.optimize = true;
        }
    }
    static get defaultOptions() {
        if ($2dcf25b78652d5b7$var$ATNDeserializationOptions._defaultOptions == null) {
            $2dcf25b78652d5b7$var$ATNDeserializationOptions._defaultOptions = new $2dcf25b78652d5b7$var$ATNDeserializationOptions();
            $2dcf25b78652d5b7$var$ATNDeserializationOptions._defaultOptions.makeReadOnly();
        }
        return $2dcf25b78652d5b7$var$ATNDeserializationOptions._defaultOptions;
    }
    get isReadOnly() {
        return this.readOnly;
    }
    makeReadOnly() {
        this.readOnly = true;
    }
    get isVerifyATN() {
        return this.verifyATN;
    }
    set isVerifyATN(verifyATN) {
        this.throwIfReadOnly();
        this.verifyATN = verifyATN;
    }
    get isGenerateRuleBypassTransitions() {
        return this.generateRuleBypassTransitions;
    }
    set isGenerateRuleBypassTransitions(generateRuleBypassTransitions) {
        this.throwIfReadOnly();
        this.generateRuleBypassTransitions = generateRuleBypassTransitions;
    }
    get isOptimize() {
        return this.optimize;
    }
    set isOptimize(optimize) {
        this.throwIfReadOnly();
        this.optimize = optimize;
    }
    throwIfReadOnly() {
        if (this.isReadOnly) throw new Error("The object is read only.");
    }
}
$2dcf25b78652d5b7$var$__decorate([
    $aN41m.NotNull
], $2dcf25b78652d5b7$var$ATNDeserializationOptions, "defaultOptions", null);
module.exports.ATNDeserializationOptions = $2dcf25b78652d5b7$var$ATNDeserializationOptions;

});

parcelRegister("1ztRl", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $125038c9196d1598$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $125038c9196d1598$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializer = void 0;

var $dNkDA = parcelRequire("dNkDA");

var $fsqYw = parcelRequire("fsqYw");

var $eeOLb = parcelRequire("eeOLb");

var $3VQ9j = parcelRequire("3VQ9j");

var $fZESB = parcelRequire("fZESB");

var $kXmw5 = parcelRequire("kXmw5");

var $exhhk = parcelRequire("exhhk");

var $3XAPg = parcelRequire("3XAPg");

var $8WIez = parcelRequire("8WIez");

var $jDuoI = parcelRequire("jDuoI");

var $jizfq = parcelRequire("jizfq");

var $42ptv = parcelRequire("42ptv");

var $1Cdmr = parcelRequire("1Cdmr");

var $7Ey8M = parcelRequire("7Ey8M");

var $6kdz0 = parcelRequire("6kdz0");

var $8ii30 = parcelRequire("8ii30");

var $96Can = parcelRequire("96Can");

var $8Nhul = parcelRequire("8Nhul");

var $Sqz9e = parcelRequire("Sqz9e");

var $a52hA = parcelRequire("a52hA");

var $etfit = parcelRequire("etfit");

var $en1aY = parcelRequire("en1aY");

var $jH58C = parcelRequire("jH58C");

var $345c1 = parcelRequire("345c1");

var $fFNPu = parcelRequire("fFNPu");

var $aN41m = parcelRequire("aN41m");

var $gFTdY = parcelRequire("gFTdY");

var $gzbPK = parcelRequire("gzbPK");

var $pC9Ki = parcelRequire("pC9Ki");

var $a84wo = parcelRequire("a84wo");

var $kIrC4 = parcelRequire("kIrC4");

var $j3Sey = parcelRequire("j3Sey");

var $6WqDl = parcelRequire("6WqDl");

var $UvARH = parcelRequire("UvARH");

var $jWsYN = parcelRequire("jWsYN");

var $lmhna = parcelRequire("lmhna");

var $5EcBU = parcelRequire("5EcBU");

var $ferBg = parcelRequire("ferBg");

var $9kZdU = parcelRequire("9kZdU");

var $e0pjt = parcelRequire("e0pjt");

var $eKXi4 = parcelRequire("eKXi4");

var $J9RdB = parcelRequire("J9RdB");

var $f0PQ3 = parcelRequire("f0PQ3");

var $69uaV = parcelRequire("69uaV");
var $125038c9196d1598$var$UnicodeDeserializingMode;
(function(UnicodeDeserializingMode) {
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_BMP"] = 0] = "UNICODE_BMP";
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_SMP"] = 1] = "UNICODE_SMP";
})($125038c9196d1598$var$UnicodeDeserializingMode || ($125038c9196d1598$var$UnicodeDeserializingMode = {}));
/**
 *
 * @author Sam Harwell
 */ class $125038c9196d1598$var$ATNDeserializer {
    constructor(deserializationOptions){
        if (deserializationOptions === undefined) deserializationOptions = $3VQ9j.ATNDeserializationOptions.defaultOptions;
        this.deserializationOptions = deserializationOptions;
    }
    static get SERIALIZED_VERSION() {
        /* This value should never change. Updates following this version are
         * reflected as change in the unique ID SERIALIZED_UUID.
         */ return 3;
    }
    /**
     * Determines if a particular serialized representation of an ATN supports
     * a particular feature, identified by the {@link UUID} used for serializing
     * the ATN at the time the feature was first introduced.
     *
     * @param feature The {@link UUID} marking the first time the feature was
     * supported in the serialized ATN.
     * @param actualUuid The {@link UUID} of the actual serialized ATN which is
     * currently being deserialized.
     * @returns `true` if the `actualUuid` value represents a
     * serialized ATN at or after the feature identified by `feature` was
     * introduced; otherwise, `false`.
     */ static isFeatureSupported(feature, actualUuid) {
        let featureIndex = $125038c9196d1598$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(feature));
        if (featureIndex < 0) return false;
        return $125038c9196d1598$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(actualUuid)) >= featureIndex;
    }
    static getUnicodeDeserializer(mode) {
        if (mode === 0 /* UNICODE_BMP */ ) return {
            readUnicode: (data, p)=>{
                return $125038c9196d1598$var$ATNDeserializer.toInt(data[p]);
            },
            size: 1
        };
        else return {
            readUnicode: (data, p)=>{
                return $125038c9196d1598$var$ATNDeserializer.toInt32(data, p);
            },
            size: 2
        };
    }
    deserialize(data) {
        data = data.slice(0);
        // Each Uint16 value in data is shifted by +2 at the entry to this method. This is an encoding optimization
        // targeting the serialized values 0 and -1 (serialized to 0xFFFF), each of which are very common in the
        // serialized form of the ATN. In the modified UTF-8 that Java uses for compiled string literals, these two
        // character values have multi-byte forms. By shifting each value by +2, they become characters 2 and 1 prior to
        // writing the string, each of which have single-byte representations. Since the shift occurs in the tool during
        // ATN serialization, each target is responsible for adjusting the values during deserialization.
        //
        // As a special case, note that the first element of data is not adjusted because it contains the major version
        // number of the serialized ATN, which was fixed at 3 at the time the value shifting was implemented.
        for(let i = 1; i < data.length; i++)data[i] = data[i] - 2 & 0xFFFF;
        let p = 0;
        let version = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        if (version !== $125038c9196d1598$var$ATNDeserializer.SERIALIZED_VERSION) {
            let reason = `Could not deserialize ATN with version ${version} (expected ${$125038c9196d1598$var$ATNDeserializer.SERIALIZED_VERSION}).`;
            throw new Error(reason);
        }
        let uuid = $125038c9196d1598$var$ATNDeserializer.toUUID(data, p);
        p += 8;
        if ($125038c9196d1598$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(uuid)) < 0) {
            let reason = `Could not deserialize ATN with UUID ${uuid} (expected ${$125038c9196d1598$var$ATNDeserializer.SERIALIZED_UUID} or a legacy UUID).`;
            throw new Error(reason);
        }
        let supportsLexerActions = $125038c9196d1598$var$ATNDeserializer.isFeatureSupported($125038c9196d1598$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid);
        let grammarType = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        let maxTokenType = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        let atn = new $eeOLb.ATN(grammarType, maxTokenType);
        //
        // STATES
        //
        let loopBackStateNumbers = [];
        let endStateNumbers = [];
        let nstates = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nstates; i++){
            let stype = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            // ignore bad type of states
            if (stype === $fZESB.ATNStateType.INVALID_TYPE) {
                atn.addState(new $8ii30.InvalidState());
                continue;
            }
            let ruleIndex = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            if (ruleIndex === 0xFFFF) ruleIndex = -1;
            let s = this.stateFactory(stype, ruleIndex);
            if (stype === $fZESB.ATNStateType.LOOP_END) {
                let loopBackStateNumber = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                loopBackStateNumbers.push([
                    s,
                    loopBackStateNumber
                ]);
            } else if (s instanceof $jizfq.BlockStartState) {
                let endStateNumber = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                endStateNumbers.push([
                    s,
                    endStateNumber
                ]);
            }
            atn.addState(s);
        }
        // delay the assignment of loop back and end states until we know all the state instances have been initialized
        for (let pair of loopBackStateNumbers)pair[0].loopBackState = atn.states[pair[1]];
        for (let pair of endStateNumbers)pair[0].endState = atn.states[pair[1]];
        let numNonGreedyStates = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numNonGreedyStates; i++){
            let stateNumber = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].nonGreedy = true;
        }
        let numSllDecisions = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numSllDecisions; i++){
            let stateNumber = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].sll = true;
        }
        let numPrecedenceStates = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numPrecedenceStates; i++){
            let stateNumber = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].isPrecedenceRule = true;
        }
        //
        // RULES
        //
        let nrules = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        if (atn.grammarType === 0 /* LEXER */ ) atn.ruleToTokenType = new Int32Array(nrules);
        atn.ruleToStartState = new Array(nrules);
        for(let i = 0; i < nrules; i++){
            let s = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            let startState = atn.states[s];
            startState.leftFactored = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]) !== 0;
            atn.ruleToStartState[i] = startState;
            if (atn.grammarType === 0 /* LEXER */ ) {
                let tokenType = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                if (tokenType === 0xFFFF) tokenType = $eKXi4.Token.EOF;
                atn.ruleToTokenType[i] = tokenType;
                if (!$125038c9196d1598$var$ATNDeserializer.isFeatureSupported($125038c9196d1598$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid)) {
                    // this piece of unused metadata was serialized prior to the
                    // addition of LexerAction
                    let actionIndexIgnored = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                    if (actionIndexIgnored === 0xFFFF) actionIndexIgnored = -1;
                }
            }
        }
        atn.ruleToStopState = new Array(nrules);
        for (let state of atn.states){
            if (!(state instanceof $jWsYN.RuleStopState)) continue;
            atn.ruleToStopState[state.ruleIndex] = state;
            atn.ruleToStartState[state.ruleIndex].stopState = state;
        }
        //
        // MODES
        //
        let nmodes = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nmodes; i++){
            let s = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            atn.modeToStartState.push(atn.states[s]);
        }
        atn.modeToDFA = new Array(nmodes);
        for(let i = 0; i < nmodes; i++)atn.modeToDFA[i] = new $1Cdmr.DFA(atn.modeToStartState[i]);
        //
        // SETS
        //
        let sets = [];
        // First, read all sets with 16-bit Unicode code points <= U+FFFF.
        p = this.deserializeSets(data, p, sets, $125038c9196d1598$var$ATNDeserializer.getUnicodeDeserializer(0 /* UNICODE_BMP */ ));
        // Next, if the ATN was serialized with the Unicode SMP feature,
        // deserialize sets with 32-bit arguments <= U+10FFFF.
        if ($125038c9196d1598$var$ATNDeserializer.isFeatureSupported($125038c9196d1598$var$ATNDeserializer.ADDED_UNICODE_SMP, uuid)) p = this.deserializeSets(data, p, sets, $125038c9196d1598$var$ATNDeserializer.getUnicodeDeserializer(1 /* UNICODE_SMP */ ));
        //
        // EDGES
        //
        let nedges = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nedges; i++){
            let src = $125038c9196d1598$var$ATNDeserializer.toInt(data[p]);
            let trg = $125038c9196d1598$var$ATNDeserializer.toInt(data[p + 1]);
            let ttype = $125038c9196d1598$var$ATNDeserializer.toInt(data[p + 2]);
            let arg1 = $125038c9196d1598$var$ATNDeserializer.toInt(data[p + 3]);
            let arg2 = $125038c9196d1598$var$ATNDeserializer.toInt(data[p + 4]);
            let arg3 = $125038c9196d1598$var$ATNDeserializer.toInt(data[p + 5]);
            let trans = this.edgeFactory(atn, ttype, src, trg, arg1, arg2, arg3, sets);
            // console.log(`EDGE ${trans.constructor.name} ${src}->${trg} ${Transition.serializationNames[ttype]} ${arg1},${arg2},${arg3}`);
            let srcState = atn.states[src];
            srcState.addTransition(trans);
            p += 6;
        }
        let returnTransitionsSet = new $fsqYw.Array2DHashSet({
            hashCode: (o)=>o.stopState ^ o.returnState ^ o.outermostPrecedenceReturn,
            equals: (a, b)=>{
                return a.stopState === b.stopState && a.returnState === b.returnState && a.outermostPrecedenceReturn === b.outermostPrecedenceReturn;
            }
        });
        let returnTransitions = [];
        for (let state of atn.states){
            let returningToLeftFactored = state.ruleIndex >= 0 && atn.ruleToStartState[state.ruleIndex].leftFactored;
            for(let i = 0; i < state.numberOfTransitions; i++){
                let t = state.transition(i);
                if (!(t instanceof $lmhna.RuleTransition)) continue;
                let ruleTransition = t;
                let returningFromLeftFactored = atn.ruleToStartState[ruleTransition.target.ruleIndex].leftFactored;
                if (!returningFromLeftFactored && returningToLeftFactored) continue;
                let outermostPrecedenceReturn = -1;
                if (atn.ruleToStartState[ruleTransition.target.ruleIndex].isPrecedenceRule) {
                    if (ruleTransition.precedence === 0) outermostPrecedenceReturn = ruleTransition.target.ruleIndex;
                }
                let current = {
                    stopState: ruleTransition.target.ruleIndex,
                    returnState: ruleTransition.followState.stateNumber,
                    outermostPrecedenceReturn: outermostPrecedenceReturn
                };
                if (returnTransitionsSet.add(current)) returnTransitions.push(current);
            }
        }
        // Add all elements from returnTransitions to the ATN
        for (let returnTransition of returnTransitions){
            let transition = new $7Ey8M.EpsilonTransition(atn.states[returnTransition.returnState], returnTransition.outermostPrecedenceReturn);
            atn.ruleToStopState[returnTransition.stopState].addTransition(transition);
        }
        for (let state of atn.states){
            if (state instanceof $jizfq.BlockStartState) {
                // we need to know the end state to set its start state
                if (state.endState === undefined) throw new Error("IllegalStateException");
                // block end states can only be associated to a single block start state
                if (state.endState.startState !== undefined) throw new Error("IllegalStateException");
                state.endState.startState = state;
            }
            if (state instanceof $a84wo.PlusLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $pC9Ki.PlusBlockStartState) target.loopBackState = loopbackState;
                }
            } else if (state instanceof $9kZdU.StarLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $e0pjt.StarLoopEntryState) target.loopBackState = loopbackState;
                }
            }
        }
        //
        // DECISIONS
        //
        let ndecisions = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 1; i <= ndecisions; i++){
            let s = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            let decState = atn.states[s];
            atn.decisionToState.push(decState);
            decState.decision = i - 1;
        }
        //
        // LEXER ACTIONS
        //
        if (atn.grammarType === 0 /* LEXER */ ) {
            if (supportsLexerActions) {
                atn.lexerActions = new Array($125038c9196d1598$var$ATNDeserializer.toInt(data[p++]));
                for(let i = 0; i < atn.lexerActions.length; i++){
                    let actionType = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                    let data1 = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                    if (data1 === 0xFFFF) data1 = -1;
                    let data2 = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                    if (data2 === 0xFFFF) data2 = -1;
                    let lexerAction = this.lexerActionFactory(actionType, data1, data2);
                    atn.lexerActions[i] = lexerAction;
                }
            } else {
                // for compatibility with older serialized ATNs, convert the old
                // serialized action index for action transitions to the new
                // form, which is the index of a LexerCustomAction
                let legacyLexerActions = [];
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (!(transition instanceof $dNkDA.ActionTransition)) continue;
                    let ruleIndex = transition.ruleIndex;
                    let actionIndex = transition.actionIndex;
                    let lexerAction = new $8Nhul.LexerCustomAction(ruleIndex, actionIndex);
                    state.setTransition(i, new $dNkDA.ActionTransition(transition.target, ruleIndex, legacyLexerActions.length, false));
                    legacyLexerActions.push(lexerAction);
                }
                atn.lexerActions = legacyLexerActions;
            }
        }
        this.markPrecedenceDecisions(atn);
        atn.decisionToDFA = new Array(ndecisions);
        for(let i = 0; i < ndecisions; i++)atn.decisionToDFA[i] = new $1Cdmr.DFA(atn.decisionToState[i], i);
        if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
        if (this.deserializationOptions.isGenerateRuleBypassTransitions && atn.grammarType === 1 /* PARSER */ ) {
            atn.ruleToTokenType = new Int32Array(atn.ruleToStartState.length);
            for(let i = 0; i < atn.ruleToStartState.length; i++)atn.ruleToTokenType[i] = atn.maxTokenType + i + 1;
            for(let i = 0; i < atn.ruleToStartState.length; i++){
                let bypassStart = new $exhhk.BasicBlockStartState();
                bypassStart.ruleIndex = i;
                atn.addState(bypassStart);
                let bypassStop = new $jDuoI.BlockEndState();
                bypassStop.ruleIndex = i;
                atn.addState(bypassStop);
                bypassStart.endState = bypassStop;
                atn.defineDecisionState(bypassStart);
                bypassStop.startState = bypassStart;
                let endState;
                let excludeTransition;
                if (atn.ruleToStartState[i].isPrecedenceRule) {
                    // wrap from the beginning of the rule to the StarLoopEntryState
                    endState = undefined;
                    for (let state of atn.states){
                        if (state.ruleIndex !== i) continue;
                        if (!(state instanceof $e0pjt.StarLoopEntryState)) continue;
                        let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                        if (!(maybeLoopEndState instanceof $fFNPu.LoopEndState)) continue;
                        if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $jWsYN.RuleStopState) {
                            endState = state;
                            break;
                        }
                    }
                    if (!endState) throw new Error("Couldn't identify final state of the precedence rule prefix section.");
                    excludeTransition = endState.loopBackState.transition(0);
                } else endState = atn.ruleToStopState[i];
                // all non-excluded transitions that currently target end state need to target blockEnd instead
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (transition === excludeTransition) continue;
                    if (transition.target === endState) transition.target = bypassStop;
                }
                // all transitions leaving the rule start state need to leave blockStart instead
                while(atn.ruleToStartState[i].numberOfTransitions > 0){
                    let transition = atn.ruleToStartState[i].removeTransition(atn.ruleToStartState[i].numberOfTransitions - 1);
                    bypassStart.addTransition(transition);
                }
                // link the new states
                atn.ruleToStartState[i].addTransition(new $7Ey8M.EpsilonTransition(bypassStart));
                bypassStop.addTransition(new $7Ey8M.EpsilonTransition(endState));
                let matchState = new $3XAPg.BasicState();
                atn.addState(matchState);
                matchState.addTransition(new $kXmw5.AtomTransition(bypassStop, atn.ruleToTokenType[i]));
                bypassStart.addTransition(new $7Ey8M.EpsilonTransition(matchState));
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        if (this.deserializationOptions.isOptimize) {
            while(true){
                let optimizationCount = 0;
                optimizationCount += $125038c9196d1598$var$ATNDeserializer.inlineSetRules(atn);
                optimizationCount += $125038c9196d1598$var$ATNDeserializer.combineChainedEpsilons(atn);
                let preserveOrder = atn.grammarType === 0 /* LEXER */ ;
                optimizationCount += $125038c9196d1598$var$ATNDeserializer.optimizeSets(atn, preserveOrder);
                if (optimizationCount === 0) break;
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        $125038c9196d1598$var$ATNDeserializer.identifyTailCalls(atn);
        return atn;
    }
    deserializeSets(data, p, sets, unicodeDeserializer) {
        let nsets = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nsets; i++){
            let nintervals = $125038c9196d1598$var$ATNDeserializer.toInt(data[p]);
            p++;
            let set = new $6kdz0.IntervalSet();
            sets.push(set);
            let containsEof = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]) !== 0;
            if (containsEof) set.add(-1);
            for(let j = 0; j < nintervals; j++){
                let a = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                let b = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                set.add(a, b);
            }
        }
        return p;
    }
    /**
     * Analyze the {@link StarLoopEntryState} states in the specified ATN to set
     * the {@link StarLoopEntryState#precedenceRuleDecision} field to the
     * correct value.
     *
     * @param atn The ATN.
     */ markPrecedenceDecisions(atn) {
        // Map rule index -> precedence decision for that rule
        let rulePrecedenceDecisions = new Map();
        for (let state of atn.states){
            if (!(state instanceof $e0pjt.StarLoopEntryState)) continue;
            /* We analyze the ATN to determine if this ATN decision state is the
             * decision for the closure block that determines whether a
             * precedence rule should continue or complete.
             */ if (atn.ruleToStartState[state.ruleIndex].isPrecedenceRule) {
                let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                if (maybeLoopEndState instanceof $fFNPu.LoopEndState) {
                    if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $jWsYN.RuleStopState) {
                        rulePrecedenceDecisions.set(state.ruleIndex, state);
                        state.precedenceRuleDecision = true;
                        state.precedenceLoopbackStates = new $8WIez.BitSet(atn.states.length);
                    }
                }
            }
        }
        // After marking precedence decisions, we go back through and fill in
        // StarLoopEntryState.precedenceLoopbackStates.
        for (let precedenceDecision of rulePrecedenceDecisions)for (let transition of atn.ruleToStopState[precedenceDecision[0]].getTransitions()){
            if (transition.serializationType !== 1 /* EPSILON */ ) continue;
            let epsilonTransition = transition;
            if (epsilonTransition.outermostPrecedenceReturn !== -1) continue;
            precedenceDecision[1].precedenceLoopbackStates.set(transition.target.stateNumber);
        }
    }
    verifyATN(atn) {
        // verify assumptions
        for (let state of atn.states){
            this.checkCondition(state !== undefined, "ATN states should not be undefined.");
            if (state.stateType === $fZESB.ATNStateType.INVALID_TYPE) continue;
            this.checkCondition(state.onlyHasEpsilonTransitions || state.numberOfTransitions <= 1);
            if (state instanceof $pC9Ki.PlusBlockStartState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $e0pjt.StarLoopEntryState) {
                let starLoopEntryState = state;
                this.checkCondition(starLoopEntryState.loopBackState !== undefined);
                this.checkCondition(starLoopEntryState.numberOfTransitions === 2);
                if (starLoopEntryState.transition(0).target instanceof $ferBg.StarBlockStartState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $fFNPu.LoopEndState);
                    this.checkCondition(!starLoopEntryState.nonGreedy);
                } else if (starLoopEntryState.transition(0).target instanceof $fFNPu.LoopEndState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $ferBg.StarBlockStartState);
                    this.checkCondition(starLoopEntryState.nonGreedy);
                } else throw new Error("IllegalStateException");
            }
            if (state instanceof $9kZdU.StarLoopbackState) {
                this.checkCondition(state.numberOfTransitions === 1);
                this.checkCondition(state.transition(0).target instanceof $e0pjt.StarLoopEntryState);
            }
            if (state instanceof $fFNPu.LoopEndState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $UvARH.RuleStartState) this.checkCondition(state.stopState !== undefined);
            if (state instanceof $jizfq.BlockStartState) this.checkCondition(state.endState !== undefined);
            if (state instanceof $jDuoI.BlockEndState) this.checkCondition(state.startState !== undefined);
            if (state instanceof $42ptv.DecisionState) {
                let decisionState = state;
                this.checkCondition(decisionState.numberOfTransitions <= 1 || decisionState.decision >= 0);
            } else this.checkCondition(state.numberOfTransitions <= 1 || state instanceof $jWsYN.RuleStopState);
        }
    }
    checkCondition(condition, message) {
        if (!condition) throw new Error("IllegalStateException: " + message);
    }
    static inlineSetRules(atn) {
        let inlinedCalls = 0;
        let ruleToInlineTransition = new Array(atn.ruleToStartState.length);
        for(let i = 0; i < atn.ruleToStartState.length; i++){
            let startState = atn.ruleToStartState[i];
            let middleState = startState;
            while(middleState.onlyHasEpsilonTransitions && middleState.numberOfOptimizedTransitions === 1 && middleState.getOptimizedTransition(0).serializationType === 1 /* EPSILON */ )middleState = middleState.getOptimizedTransition(0).target;
            if (middleState.numberOfOptimizedTransitions !== 1) continue;
            let matchTransition = middleState.getOptimizedTransition(0);
            let matchTarget = matchTransition.target;
            if (matchTransition.isEpsilon || !matchTarget.onlyHasEpsilonTransitions || matchTarget.numberOfOptimizedTransitions !== 1 || !(matchTarget.getOptimizedTransition(0).target instanceof $jWsYN.RuleStopState)) continue;
            switch(matchTransition.serializationType){
                case 5 /* ATOM */ :
                case 2 /* RANGE */ :
                case 7 /* SET */ :
                    ruleToInlineTransition[i] = matchTransition;
                    break;
                case 8 /* NOT_SET */ :
                case 9 /* WILDCARD */ :
                    continue;
                default:
                    continue;
            }
        }
        for (let state of atn.states){
            if (state.ruleIndex < 0) continue;
            let optimizedTransitions;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $lmhna.RuleTransition)) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                let ruleTransition = transition;
                let effective = ruleToInlineTransition[ruleTransition.target.ruleIndex];
                if (effective === undefined) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(i));
                }
                inlinedCalls++;
                let target = ruleTransition.followState;
                let intermediateState = new $3XAPg.BasicState();
                intermediateState.setRuleIndex(target.ruleIndex);
                atn.addState(intermediateState);
                optimizedTransitions.push(new $7Ey8M.EpsilonTransition(intermediateState));
                switch(effective.serializationType){
                    case 5 /* ATOM */ :
                        intermediateState.addTransition(new $kXmw5.AtomTransition(target, effective._label));
                        break;
                    case 2 /* RANGE */ :
                        intermediateState.addTransition(new $6WqDl.RangeTransition(target, effective.from, effective.to));
                        break;
                    case 7 /* SET */ :
                        intermediateState.addTransition(new $5EcBU.SetTransition(target, effective.label));
                        break;
                    default:
                        throw new Error("UnsupportedOperationException");
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($gzbPK.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + inlinedCalls + " rule invocations by inlining sets.");
        return inlinedCalls;
    }
    static combineChainedEpsilons(atn) {
        let removedEdges = 0;
        for (let state of atn.states){
            if (!state.onlyHasEpsilonTransitions || state instanceof $jWsYN.RuleStopState) continue;
            let optimizedTransitions;
            nextTransition: for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                let intermediate = transition.target;
                if (transition.serializationType !== 1 /* EPSILON */  || transition.outermostPrecedenceReturn !== -1 || intermediate.stateType !== $fZESB.ATNStateType.BASIC || !intermediate.onlyHasEpsilonTransitions) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++)if (intermediate.getOptimizedTransition(j).serializationType !== 1 /* EPSILON */  || intermediate.getOptimizedTransition(j).outermostPrecedenceReturn !== -1) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                removedEdges++;
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(j));
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++){
                    let target = intermediate.getOptimizedTransition(j).target;
                    optimizedTransitions.push(new $7Ey8M.EpsilonTransition(target));
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($gzbPK.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedEdges + " transitions by combining chained epsilon transitions.");
        return removedEdges;
    }
    static optimizeSets(atn, preserveOrder) {
        if (preserveOrder) // this optimization currently doesn't preserve edge order.
        return 0;
        let removedPaths = 0;
        let decisions = atn.decisionToState;
        for (let decision of decisions){
            let setTransitions = new $6kdz0.IntervalSet();
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++){
                let epsTransition = decision.getOptimizedTransition(i);
                if (!(epsTransition instanceof $7Ey8M.EpsilonTransition)) continue;
                if (epsTransition.target.numberOfOptimizedTransitions !== 1) continue;
                let transition = epsTransition.target.getOptimizedTransition(0);
                if (!(transition.target instanceof $jDuoI.BlockEndState)) continue;
                if (transition instanceof $gFTdY.NotSetTransition) continue;
                if (transition instanceof $kXmw5.AtomTransition || transition instanceof $6WqDl.RangeTransition || transition instanceof $5EcBU.SetTransition) setTransitions.add(i);
            }
            if (setTransitions.size <= 1) continue;
            let optimizedTransitions = [];
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++)if (!setTransitions.contains(i)) optimizedTransitions.push(decision.getOptimizedTransition(i));
            let blockEndState = decision.getOptimizedTransition(setTransitions.minElement).target.getOptimizedTransition(0).target;
            let matchSet = new $6kdz0.IntervalSet();
            for (let interval of setTransitions.intervals)for(let j = interval.a; j <= interval.b; j++){
                let matchTransition = decision.getOptimizedTransition(j).target.getOptimizedTransition(0);
                if (matchTransition instanceof $gFTdY.NotSetTransition) throw new Error("Not yet implemented.");
                else matchSet.addAll(matchTransition.label);
            }
            let newTransition;
            if (matchSet.intervals.length === 1) {
                if (matchSet.size === 1) newTransition = new $kXmw5.AtomTransition(blockEndState, matchSet.minElement);
                else {
                    let matchInterval = matchSet.intervals[0];
                    newTransition = new $6WqDl.RangeTransition(blockEndState, matchInterval.a, matchInterval.b);
                }
            } else newTransition = new $5EcBU.SetTransition(blockEndState, matchSet);
            let setOptimizedState = new $3XAPg.BasicState();
            setOptimizedState.setRuleIndex(decision.ruleIndex);
            atn.addState(setOptimizedState);
            setOptimizedState.addTransition(newTransition);
            optimizedTransitions.push(new $7Ey8M.EpsilonTransition(setOptimizedState));
            removedPaths += decision.numberOfOptimizedTransitions - optimizedTransitions.length;
            if (decision.isOptimized) while(decision.numberOfOptimizedTransitions > 0)decision.removeOptimizedTransition(decision.numberOfOptimizedTransitions - 1);
            for (let transition of optimizedTransitions)decision.addOptimizedTransition(transition);
        }
        if ($gzbPK.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedPaths + " paths by collapsing sets.");
        return removedPaths;
    }
    static identifyTailCalls(atn) {
        for (let state of atn.states){
            for(let i = 0; i < state.numberOfTransitions; i++){
                let transition = state.transition(i);
                if (!(transition instanceof $lmhna.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
            if (!state.isOptimized) continue;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $lmhna.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
        }
    }
    static testTailCall(atn, transition, optimizedPath) {
        if (!optimizedPath && transition.tailCall) return true;
        if (optimizedPath && transition.optimizedTailCall) return true;
        let reachable = new $8WIez.BitSet(atn.states.length);
        let worklist = [];
        worklist.push(transition.followState);
        while(true){
            let state = worklist.pop();
            if (!state) break;
            if (reachable.get(state.stateNumber)) continue;
            if (state instanceof $jWsYN.RuleStopState) continue;
            if (!state.onlyHasEpsilonTransitions) return false;
            let transitionCount = optimizedPath ? state.numberOfOptimizedTransitions : state.numberOfTransitions;
            for(let i = 0; i < transitionCount; i++){
                let t = optimizedPath ? state.getOptimizedTransition(i) : state.transition(i);
                if (t.serializationType !== 1 /* EPSILON */ ) return false;
                worklist.push(t.target);
            }
        }
        return true;
    }
    static toInt(c) {
        return c;
    }
    static toInt32(data, offset) {
        return (data[offset] | data[offset + 1] << 16) >>> 0;
    }
    static toUUID(data, offset) {
        let leastSigBits = $125038c9196d1598$var$ATNDeserializer.toInt32(data, offset);
        let lessSigBits = $125038c9196d1598$var$ATNDeserializer.toInt32(data, offset + 2);
        let moreSigBits = $125038c9196d1598$var$ATNDeserializer.toInt32(data, offset + 4);
        let mostSigBits = $125038c9196d1598$var$ATNDeserializer.toInt32(data, offset + 6);
        return new $f0PQ3.UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    edgeFactory(atn, type, src, trg, arg1, arg2, arg3, sets) {
        let target = atn.states[trg];
        switch(type){
            case 1 /* EPSILON */ :
                return new $7Ey8M.EpsilonTransition(target);
            case 2 /* RANGE */ :
                if (arg3 !== 0) return new $6WqDl.RangeTransition(target, $eKXi4.Token.EOF, arg2);
                else return new $6WqDl.RangeTransition(target, arg1, arg2);
            case 3 /* RULE */ :
                let rt = new $lmhna.RuleTransition(atn.states[arg1], arg2, arg3, target);
                return rt;
            case 4 /* PREDICATE */ :
                let pt = new $j3Sey.PredicateTransition(target, arg1, arg2, arg3 !== 0);
                return pt;
            case 10 /* PRECEDENCE */ :
                return new $kIrC4.PrecedencePredicateTransition(target, arg1);
            case 5 /* ATOM */ :
                if (arg3 !== 0) return new $kXmw5.AtomTransition(target, $eKXi4.Token.EOF);
                else return new $kXmw5.AtomTransition(target, arg1);
            case 6 /* ACTION */ :
                let a = new $dNkDA.ActionTransition(target, arg1, arg2, arg3 !== 0);
                return a;
            case 7 /* SET */ :
                return new $5EcBU.SetTransition(target, sets[arg1]);
            case 8 /* NOT_SET */ :
                return new $gFTdY.NotSetTransition(target, sets[arg1]);
            case 9 /* WILDCARD */ :
                return new $69uaV.WildcardTransition(target);
        }
        throw new Error("The specified transition type is not valid.");
    }
    stateFactory(type, ruleIndex) {
        let s;
        switch(type){
            case $fZESB.ATNStateType.INVALID_TYPE:
                return new $8ii30.InvalidState();
            case $fZESB.ATNStateType.BASIC:
                s = new $3XAPg.BasicState();
                break;
            case $fZESB.ATNStateType.RULE_START:
                s = new $UvARH.RuleStartState();
                break;
            case $fZESB.ATNStateType.BLOCK_START:
                s = new $exhhk.BasicBlockStartState();
                break;
            case $fZESB.ATNStateType.PLUS_BLOCK_START:
                s = new $pC9Ki.PlusBlockStartState();
                break;
            case $fZESB.ATNStateType.STAR_BLOCK_START:
                s = new $ferBg.StarBlockStartState();
                break;
            case $fZESB.ATNStateType.TOKEN_START:
                s = new $J9RdB.TokensStartState();
                break;
            case $fZESB.ATNStateType.RULE_STOP:
                s = new $jWsYN.RuleStopState();
                break;
            case $fZESB.ATNStateType.BLOCK_END:
                s = new $jDuoI.BlockEndState();
                break;
            case $fZESB.ATNStateType.STAR_LOOP_BACK:
                s = new $9kZdU.StarLoopbackState();
                break;
            case $fZESB.ATNStateType.STAR_LOOP_ENTRY:
                s = new $e0pjt.StarLoopEntryState();
                break;
            case $fZESB.ATNStateType.PLUS_LOOP_BACK:
                s = new $a84wo.PlusLoopbackState();
                break;
            case $fZESB.ATNStateType.LOOP_END:
                s = new $fFNPu.LoopEndState();
                break;
            default:
                let message = `The specified state type ${type} is not valid.`;
                throw new Error(message);
        }
        s.ruleIndex = ruleIndex;
        return s;
    }
    lexerActionFactory(type, data1, data2) {
        switch(type){
            case 0 /* CHANNEL */ :
                return new $96Can.LexerChannelAction(data1);
            case 1 /* CUSTOM */ :
                return new $8Nhul.LexerCustomAction(data1, data2);
            case 2 /* MODE */ :
                return new $Sqz9e.LexerModeAction(data1);
            case 3 /* MORE */ :
                return $a52hA.LexerMoreAction.INSTANCE;
            case 4 /* POP_MODE */ :
                return $etfit.LexerPopModeAction.INSTANCE;
            case 5 /* PUSH_MODE */ :
                return new $en1aY.LexerPushModeAction(data1);
            case 6 /* SKIP */ :
                return $jH58C.LexerSkipAction.INSTANCE;
            case 7 /* TYPE */ :
                return new $345c1.LexerTypeAction(data1);
            default:
                let message = `The specified lexer action type ${type} is not valid.`;
                throw new Error(message);
        }
    }
}
/* WARNING: DO NOT MERGE THESE LINES. If UUIDs differ during a merge,
 * resolve the conflict by generating a new ID!
 */ /**
 * This is the earliest supported serialized UUID.
 */ $125038c9196d1598$var$ATNDeserializer.BASE_SERIALIZED_UUID = $f0PQ3.UUID.fromString("E4178468-DF95-44D0-AD87-F22A5D5FB6D3");
/**
 * This UUID indicates an extension of {@link #ADDED_PRECEDENCE_TRANSITIONS}
 * for the addition of lexer actions encoded as a sequence of
 * {@link LexerAction} instances.
 */ $125038c9196d1598$var$ATNDeserializer.ADDED_LEXER_ACTIONS = $f0PQ3.UUID.fromString("AB35191A-1603-487E-B75A-479B831EAF6D");
/**
 * This UUID indicates the serialized ATN contains two sets of
 * IntervalSets, where the second set's values are encoded as
 * 32-bit integers to support the full Unicode SMP range up to U+10FFFF.
 */ $125038c9196d1598$var$ATNDeserializer.ADDED_UNICODE_SMP = $f0PQ3.UUID.fromString("C23FEA89-0605-4f51-AFB8-058BCAB8C91B");
/**
 * This list contains all of the currently supported UUIDs, ordered by when
 * the feature first appeared in this branch.
 */ $125038c9196d1598$var$ATNDeserializer.SUPPORTED_UUIDS = [
    $125038c9196d1598$var$ATNDeserializer.BASE_SERIALIZED_UUID,
    $125038c9196d1598$var$ATNDeserializer.ADDED_LEXER_ACTIONS,
    $125038c9196d1598$var$ATNDeserializer.ADDED_UNICODE_SMP
];
/**
 * This is the current serialized UUID.
 */ $125038c9196d1598$var$ATNDeserializer.SERIALIZED_UUID = $125038c9196d1598$var$ATNDeserializer.ADDED_UNICODE_SMP;
$125038c9196d1598$var$__decorate([
    $aN41m.NotNull
], $125038c9196d1598$var$ATNDeserializer.prototype, "deserializationOptions", void 0);
$125038c9196d1598$var$__decorate([
    $125038c9196d1598$var$__param(0, $aN41m.NotNull)
], $125038c9196d1598$var$ATNDeserializer.prototype, "deserialize", null);
$125038c9196d1598$var$__decorate([
    $125038c9196d1598$var$__param(0, $aN41m.NotNull)
], $125038c9196d1598$var$ATNDeserializer.prototype, "markPrecedenceDecisions", null);
$125038c9196d1598$var$__decorate([
    $aN41m.NotNull,
    $125038c9196d1598$var$__param(0, $aN41m.NotNull)
], $125038c9196d1598$var$ATNDeserializer.prototype, "edgeFactory", null);
module.exports.ATNDeserializer = $125038c9196d1598$var$ATNDeserializer;

});
parcelRegister("dNkDA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a0afdc24220f1b76$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a0afdc24220f1b76$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionTransition = void 0;

var $aN41m = parcelRequire("aN41m");

var $5NWCj = parcelRequire("5NWCj");
let $a0afdc24220f1b76$var$ActionTransition = class ActionTransition extends $5NWCj.Transition {
    constructor(target, ruleIndex, actionIndex = -1, isCtxDependent = false){
        super(target);
        this.ruleIndex = ruleIndex;
        this.actionIndex = actionIndex;
        this.isCtxDependent = isCtxDependent;
    }
    get serializationType() {
        return 6 /* ACTION */ ;
    }
    get isEpsilon() {
        return true; // we are to be ignored by analysis 'cept for predicates
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "action_" + this.ruleIndex + ":" + this.actionIndex;
    }
};
$a0afdc24220f1b76$var$__decorate([
    $aN41m.Override
], $a0afdc24220f1b76$var$ActionTransition.prototype, "serializationType", null);
$a0afdc24220f1b76$var$__decorate([
    $aN41m.Override
], $a0afdc24220f1b76$var$ActionTransition.prototype, "isEpsilon", null);
$a0afdc24220f1b76$var$__decorate([
    $aN41m.Override
], $a0afdc24220f1b76$var$ActionTransition.prototype, "matches", null);
$a0afdc24220f1b76$var$__decorate([
    $aN41m.Override
], $a0afdc24220f1b76$var$ActionTransition.prototype, "toString", null);
$a0afdc24220f1b76$var$ActionTransition = $a0afdc24220f1b76$var$__decorate([
    $a0afdc24220f1b76$var$__param(0, $aN41m.NotNull)
], $a0afdc24220f1b76$var$ActionTransition);
module.exports.ActionTransition = $a0afdc24220f1b76$var$ActionTransition;

});

parcelRegister("kXmw5", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f41ac8aa56432c28$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f41ac8aa56432c28$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtomTransition = void 0;

var $6kdz0 = parcelRequire("6kdz0");

var $aN41m = parcelRequire("aN41m");

var $5NWCj = parcelRequire("5NWCj");
/** TODO: make all transitions sets? no, should remove set edges */ let $f41ac8aa56432c28$var$AtomTransition = class AtomTransition extends $5NWCj.Transition {
    constructor(target, label){
        super(target);
        this._label = label;
    }
    get serializationType() {
        return 5 /* ATOM */ ;
    }
    get label() {
        return $6kdz0.IntervalSet.of(this._label);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this._label === symbol;
    }
    toString() {
        return String(this.label);
    }
};
$f41ac8aa56432c28$var$__decorate([
    $aN41m.Override
], $f41ac8aa56432c28$var$AtomTransition.prototype, "serializationType", null);
$f41ac8aa56432c28$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $f41ac8aa56432c28$var$AtomTransition.prototype, "label", null);
$f41ac8aa56432c28$var$__decorate([
    $aN41m.Override
], $f41ac8aa56432c28$var$AtomTransition.prototype, "matches", null);
$f41ac8aa56432c28$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $f41ac8aa56432c28$var$AtomTransition.prototype, "toString", null);
$f41ac8aa56432c28$var$AtomTransition = $f41ac8aa56432c28$var$__decorate([
    $f41ac8aa56432c28$var$__param(0, $aN41m.NotNull)
], $f41ac8aa56432c28$var$AtomTransition);
module.exports.AtomTransition = $f41ac8aa56432c28$var$AtomTransition;

});

parcelRegister("exhhk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a9518ce3013a5e52$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicBlockStartState = void 0;

var $fZESB = parcelRequire("fZESB");

var $jizfq = parcelRequire("jizfq");

var $aN41m = parcelRequire("aN41m");
/**
 *
 * @author Sam Harwell
 */ class $a9518ce3013a5e52$var$BasicBlockStartState extends $jizfq.BlockStartState {
    get stateType() {
        return $fZESB.ATNStateType.BLOCK_START;
    }
}
$a9518ce3013a5e52$var$__decorate([
    $aN41m.Override
], $a9518ce3013a5e52$var$BasicBlockStartState.prototype, "stateType", null);
module.exports.BasicBlockStartState = $a9518ce3013a5e52$var$BasicBlockStartState;

});
parcelRegister("jizfq", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockStartState = void 0;

var $42ptv = parcelRequire("42ptv");
/**  The start of a regular `(...)` block. */ class $e0cb0a3899ef814e$var$BlockStartState extends $42ptv.DecisionState {
}
module.exports.BlockStartState = $e0cb0a3899ef814e$var$BlockStartState;

});


parcelRegister("jDuoI", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e4b93d2d29e74e89$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockEndState = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $aN41m = parcelRequire("aN41m");
/** Terminal node of a simple `(a|b|c)` block. */ class $e4b93d2d29e74e89$var$BlockEndState extends $dv9vN.ATNState {
    get stateType() {
        return $fZESB.ATNStateType.BLOCK_END;
    }
}
$e4b93d2d29e74e89$var$__decorate([
    $aN41m.Override
], $e4b93d2d29e74e89$var$BlockEndState.prototype, "stateType", null);
module.exports.BlockEndState = $e4b93d2d29e74e89$var$BlockEndState;

});

parcelRegister("7Ey8M", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $5926c077d80a870b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5926c077d80a870b$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EpsilonTransition = void 0;

var $aN41m = parcelRequire("aN41m");

var $5NWCj = parcelRequire("5NWCj");
let $5926c077d80a870b$var$EpsilonTransition = class EpsilonTransition extends $5NWCj.Transition {
    constructor(target, outermostPrecedenceReturn = -1){
        super(target);
        this._outermostPrecedenceReturn = outermostPrecedenceReturn;
    }
    /**
     * @returns the rule index of a precedence rule for which this transition is
     * returning from, where the precedence value is 0; otherwise, -1.
     *
     * @see ATNConfig.isPrecedenceFilterSuppressed
     * @see ParserATNSimulator#applyPrecedenceFilter(ATNConfigSet, ParserRuleContext, PredictionContextCache)
     * @since 4.4.1
     */ get outermostPrecedenceReturn() {
        return this._outermostPrecedenceReturn;
    }
    get serializationType() {
        return 1 /* EPSILON */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "epsilon";
    }
};
$5926c077d80a870b$var$__decorate([
    $aN41m.Override
], $5926c077d80a870b$var$EpsilonTransition.prototype, "serializationType", null);
$5926c077d80a870b$var$__decorate([
    $aN41m.Override
], $5926c077d80a870b$var$EpsilonTransition.prototype, "isEpsilon", null);
$5926c077d80a870b$var$__decorate([
    $aN41m.Override
], $5926c077d80a870b$var$EpsilonTransition.prototype, "matches", null);
$5926c077d80a870b$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $5926c077d80a870b$var$EpsilonTransition.prototype, "toString", null);
$5926c077d80a870b$var$EpsilonTransition = $5926c077d80a870b$var$__decorate([
    $5926c077d80a870b$var$__param(0, $aN41m.NotNull)
], $5926c077d80a870b$var$EpsilonTransition);
module.exports.EpsilonTransition = $5926c077d80a870b$var$EpsilonTransition;

});

parcelRegister("96Can", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6a1247a4f2c7624c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6a1247a4f2c7624c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerChannelAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `channel` lexer action by calling
 * {@link Lexer#setChannel} with the assigned channel.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $6a1247a4f2c7624c$var$LexerChannelAction {
    /**
     * Constructs a new `channel` action with the specified channel value.
     * @param channel The channel value to pass to {@link Lexer#setChannel}.
     */ constructor(channel){
        this._channel = channel;
    }
    /**
     * Gets the channel to use for the {@link Token} created by the lexer.
     *
     * @returns The channel to use for the {@link Token} created by the lexer.
     */ get channel() {
        return this._channel;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#CHANNEL}.
     */ get actionType() {
        return 0 /* CHANNEL */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#setChannel} with the
     * value provided by {@link #getChannel}.
     */ execute(lexer) {
        lexer.channel = this._channel;
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        hash = $amQx9.MurmurHash.update(hash, this._channel);
        return $amQx9.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $6a1247a4f2c7624c$var$LexerChannelAction)) return false;
        return this._channel === obj._channel;
    }
    toString() {
        return `channel(${this._channel})`;
    }
}
$6a1247a4f2c7624c$var$__decorate([
    $aN41m.Override
], $6a1247a4f2c7624c$var$LexerChannelAction.prototype, "actionType", null);
$6a1247a4f2c7624c$var$__decorate([
    $aN41m.Override
], $6a1247a4f2c7624c$var$LexerChannelAction.prototype, "isPositionDependent", null);
$6a1247a4f2c7624c$var$__decorate([
    $aN41m.Override,
    $6a1247a4f2c7624c$var$__param(0, $aN41m.NotNull)
], $6a1247a4f2c7624c$var$LexerChannelAction.prototype, "execute", null);
$6a1247a4f2c7624c$var$__decorate([
    $aN41m.Override
], $6a1247a4f2c7624c$var$LexerChannelAction.prototype, "hashCode", null);
$6a1247a4f2c7624c$var$__decorate([
    $aN41m.Override
], $6a1247a4f2c7624c$var$LexerChannelAction.prototype, "equals", null);
$6a1247a4f2c7624c$var$__decorate([
    $aN41m.Override
], $6a1247a4f2c7624c$var$LexerChannelAction.prototype, "toString", null);
module.exports.LexerChannelAction = $6a1247a4f2c7624c$var$LexerChannelAction;

});

parcelRegister("8Nhul", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $66707726ebb084aa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $66707726ebb084aa$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerCustomAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Executes a custom lexer action by calling {@link Recognizer#action} with the
 * rule and action indexes assigned to the custom action. The implementation of
 * a custom action is added to the generated code for the lexer in an override
 * of {@link Recognizer#action} when the grammar is compiled.
 *
 * This class may represent embedded actions created with the `{...}`
 * syntax in ANTLR 4, as well as actions created for lexer commands where the
 * command argument could not be evaluated when the grammar was compiled.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $66707726ebb084aa$var$LexerCustomAction {
    /**
     * Constructs a custom lexer action with the specified rule and action
     * indexes.
     *
     * @param ruleIndex The rule index to use for calls to
     * {@link Recognizer#action}.
     * @param actionIndex The action index to use for calls to
     * {@link Recognizer#action}.
     */ constructor(ruleIndex, actionIndex){
        this._ruleIndex = ruleIndex;
        this._actionIndex = actionIndex;
    }
    /**
     * Gets the rule index to use for calls to {@link Recognizer#action}.
     *
     * @returns The rule index for the custom action.
     */ get ruleIndex() {
        return this._ruleIndex;
    }
    /**
     * Gets the action index to use for calls to {@link Recognizer#action}.
     *
     * @returns The action index for the custom action.
     */ get actionIndex() {
        return this._actionIndex;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns {@link LexerActionType#CUSTOM}.
     */ get actionType() {
        return 1 /* CUSTOM */ ;
    }
    /**
     * Gets whether the lexer action is position-dependent. Position-dependent
     * actions may have different semantics depending on the {@link CharStream}
     * index at the time the action is executed.
     *
     * Custom actions are position-dependent since they may represent a
     * user-defined embedded action which makes calls to methods like
     * {@link Lexer#getText}.
     *
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * Custom actions are implemented by calling {@link Lexer#action} with the
     * appropriate rule and action indexes.
     */ execute(lexer) {
        lexer.action(undefined, this._ruleIndex, this._actionIndex);
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        hash = $amQx9.MurmurHash.update(hash, this._ruleIndex);
        hash = $amQx9.MurmurHash.update(hash, this._actionIndex);
        return $amQx9.MurmurHash.finish(hash, 3);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $66707726ebb084aa$var$LexerCustomAction)) return false;
        return this._ruleIndex === obj._ruleIndex && this._actionIndex === obj._actionIndex;
    }
}
$66707726ebb084aa$var$__decorate([
    $aN41m.Override
], $66707726ebb084aa$var$LexerCustomAction.prototype, "actionType", null);
$66707726ebb084aa$var$__decorate([
    $aN41m.Override
], $66707726ebb084aa$var$LexerCustomAction.prototype, "isPositionDependent", null);
$66707726ebb084aa$var$__decorate([
    $aN41m.Override,
    $66707726ebb084aa$var$__param(0, $aN41m.NotNull)
], $66707726ebb084aa$var$LexerCustomAction.prototype, "execute", null);
$66707726ebb084aa$var$__decorate([
    $aN41m.Override
], $66707726ebb084aa$var$LexerCustomAction.prototype, "hashCode", null);
$66707726ebb084aa$var$__decorate([
    $aN41m.Override
], $66707726ebb084aa$var$LexerCustomAction.prototype, "equals", null);
module.exports.LexerCustomAction = $66707726ebb084aa$var$LexerCustomAction;

});

parcelRegister("Sqz9e", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0a39a6b1f9fd5776$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0a39a6b1f9fd5776$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerModeAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `mode` lexer action by calling {@link Lexer#mode} with
 * the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $0a39a6b1f9fd5776$var$LexerModeAction {
    /**
     * Constructs a new `mode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#mode}.
     */ constructor(mode){
        this._mode = mode;
    }
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `mode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MODE}.
     */ get actionType() {
        return 2 /* MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#mode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.mode(this._mode);
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        hash = $amQx9.MurmurHash.update(hash, this._mode);
        return $amQx9.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $0a39a6b1f9fd5776$var$LexerModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `mode(${this._mode})`;
    }
}
$0a39a6b1f9fd5776$var$__decorate([
    $aN41m.Override
], $0a39a6b1f9fd5776$var$LexerModeAction.prototype, "actionType", null);
$0a39a6b1f9fd5776$var$__decorate([
    $aN41m.Override
], $0a39a6b1f9fd5776$var$LexerModeAction.prototype, "isPositionDependent", null);
$0a39a6b1f9fd5776$var$__decorate([
    $aN41m.Override,
    $0a39a6b1f9fd5776$var$__param(0, $aN41m.NotNull)
], $0a39a6b1f9fd5776$var$LexerModeAction.prototype, "execute", null);
$0a39a6b1f9fd5776$var$__decorate([
    $aN41m.Override
], $0a39a6b1f9fd5776$var$LexerModeAction.prototype, "hashCode", null);
$0a39a6b1f9fd5776$var$__decorate([
    $aN41m.Override
], $0a39a6b1f9fd5776$var$LexerModeAction.prototype, "equals", null);
$0a39a6b1f9fd5776$var$__decorate([
    $aN41m.Override
], $0a39a6b1f9fd5776$var$LexerModeAction.prototype, "toString", null);
module.exports.LexerModeAction = $0a39a6b1f9fd5776$var$LexerModeAction;

});

parcelRegister("a52hA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $756c244b6a2751b3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $756c244b6a2751b3$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerMoreAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `more` lexer action by calling {@link Lexer#more}.
 *
 * The `more` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $756c244b6a2751b3$var$LexerMoreAction {
    /**
     * Constructs the singleton instance of the lexer `more` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MORE}.
     */ get actionType() {
        return 3 /* MORE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#more}.
     */ execute(lexer) {
        lexer.more();
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        return $amQx9.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "more";
    }
}
$756c244b6a2751b3$var$__decorate([
    $aN41m.Override
], $756c244b6a2751b3$var$LexerMoreAction.prototype, "actionType", null);
$756c244b6a2751b3$var$__decorate([
    $aN41m.Override
], $756c244b6a2751b3$var$LexerMoreAction.prototype, "isPositionDependent", null);
$756c244b6a2751b3$var$__decorate([
    $aN41m.Override,
    $756c244b6a2751b3$var$__param(0, $aN41m.NotNull)
], $756c244b6a2751b3$var$LexerMoreAction.prototype, "execute", null);
$756c244b6a2751b3$var$__decorate([
    $aN41m.Override
], $756c244b6a2751b3$var$LexerMoreAction.prototype, "hashCode", null);
$756c244b6a2751b3$var$__decorate([
    $aN41m.Override
], $756c244b6a2751b3$var$LexerMoreAction.prototype, "equals", null);
$756c244b6a2751b3$var$__decorate([
    $aN41m.Override
], $756c244b6a2751b3$var$LexerMoreAction.prototype, "toString", null);
module.exports.LexerMoreAction = $756c244b6a2751b3$var$LexerMoreAction;
(function(LexerMoreAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerMoreAction.INSTANCE = new LexerMoreAction();
})($756c244b6a2751b3$var$LexerMoreAction = module.exports.LexerMoreAction || (module.exports.LexerMoreAction = {}));

});

parcelRegister("etfit", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a88fa3c89bb51f5a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a88fa3c89bb51f5a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPopModeAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `popMode` lexer action by calling {@link Lexer#popMode}.
 *
 * The `popMode` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $a88fa3c89bb51f5a$var$LexerPopModeAction {
    /**
     * Constructs the singleton instance of the lexer `popMode` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#POP_MODE}.
     */ get actionType() {
        return 4 /* POP_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#popMode}.
     */ execute(lexer) {
        lexer.popMode();
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        return $amQx9.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "popMode";
    }
}
$a88fa3c89bb51f5a$var$__decorate([
    $aN41m.Override
], $a88fa3c89bb51f5a$var$LexerPopModeAction.prototype, "actionType", null);
$a88fa3c89bb51f5a$var$__decorate([
    $aN41m.Override
], $a88fa3c89bb51f5a$var$LexerPopModeAction.prototype, "isPositionDependent", null);
$a88fa3c89bb51f5a$var$__decorate([
    $aN41m.Override,
    $a88fa3c89bb51f5a$var$__param(0, $aN41m.NotNull)
], $a88fa3c89bb51f5a$var$LexerPopModeAction.prototype, "execute", null);
$a88fa3c89bb51f5a$var$__decorate([
    $aN41m.Override
], $a88fa3c89bb51f5a$var$LexerPopModeAction.prototype, "hashCode", null);
$a88fa3c89bb51f5a$var$__decorate([
    $aN41m.Override
], $a88fa3c89bb51f5a$var$LexerPopModeAction.prototype, "equals", null);
$a88fa3c89bb51f5a$var$__decorate([
    $aN41m.Override
], $a88fa3c89bb51f5a$var$LexerPopModeAction.prototype, "toString", null);
module.exports.LexerPopModeAction = $a88fa3c89bb51f5a$var$LexerPopModeAction;
(function(LexerPopModeAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerPopModeAction.INSTANCE = new LexerPopModeAction();
})($a88fa3c89bb51f5a$var$LexerPopModeAction = module.exports.LexerPopModeAction || (module.exports.LexerPopModeAction = {}));

});

parcelRegister("en1aY", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a764202e107f6da8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a764202e107f6da8$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPushModeAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `pushMode` lexer action by calling
 * {@link Lexer#pushMode} with the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $a764202e107f6da8$var$LexerPushModeAction {
    /**
     * Constructs a new `pushMode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#pushMode}.
     */ constructor(mode){
        this._mode = mode;
    }
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `pushMode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#PUSH_MODE}.
     */ get actionType() {
        return 5 /* PUSH_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#pushMode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.pushMode(this._mode);
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        hash = $amQx9.MurmurHash.update(hash, this._mode);
        return $amQx9.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $a764202e107f6da8$var$LexerPushModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `pushMode(${this._mode})`;
    }
}
$a764202e107f6da8$var$__decorate([
    $aN41m.Override
], $a764202e107f6da8$var$LexerPushModeAction.prototype, "actionType", null);
$a764202e107f6da8$var$__decorate([
    $aN41m.Override
], $a764202e107f6da8$var$LexerPushModeAction.prototype, "isPositionDependent", null);
$a764202e107f6da8$var$__decorate([
    $aN41m.Override,
    $a764202e107f6da8$var$__param(0, $aN41m.NotNull)
], $a764202e107f6da8$var$LexerPushModeAction.prototype, "execute", null);
$a764202e107f6da8$var$__decorate([
    $aN41m.Override
], $a764202e107f6da8$var$LexerPushModeAction.prototype, "hashCode", null);
$a764202e107f6da8$var$__decorate([
    $aN41m.Override
], $a764202e107f6da8$var$LexerPushModeAction.prototype, "equals", null);
$a764202e107f6da8$var$__decorate([
    $aN41m.Override
], $a764202e107f6da8$var$LexerPushModeAction.prototype, "toString", null);
module.exports.LexerPushModeAction = $a764202e107f6da8$var$LexerPushModeAction;

});

parcelRegister("jH58C", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e56604c1d2a640c8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e56604c1d2a640c8$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerSkipAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `skip` lexer action by calling {@link Lexer#skip}.
 *
 * The `skip` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $e56604c1d2a640c8$var$LexerSkipAction {
    /**
     * Constructs the singleton instance of the lexer `skip` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#SKIP}.
     */ get actionType() {
        return 6 /* SKIP */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#skip}.
     */ execute(lexer) {
        lexer.skip();
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        return $amQx9.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "skip";
    }
}
$e56604c1d2a640c8$var$__decorate([
    $aN41m.Override
], $e56604c1d2a640c8$var$LexerSkipAction.prototype, "actionType", null);
$e56604c1d2a640c8$var$__decorate([
    $aN41m.Override
], $e56604c1d2a640c8$var$LexerSkipAction.prototype, "isPositionDependent", null);
$e56604c1d2a640c8$var$__decorate([
    $aN41m.Override,
    $e56604c1d2a640c8$var$__param(0, $aN41m.NotNull)
], $e56604c1d2a640c8$var$LexerSkipAction.prototype, "execute", null);
$e56604c1d2a640c8$var$__decorate([
    $aN41m.Override
], $e56604c1d2a640c8$var$LexerSkipAction.prototype, "hashCode", null);
$e56604c1d2a640c8$var$__decorate([
    $aN41m.Override
], $e56604c1d2a640c8$var$LexerSkipAction.prototype, "equals", null);
$e56604c1d2a640c8$var$__decorate([
    $aN41m.Override
], $e56604c1d2a640c8$var$LexerSkipAction.prototype, "toString", null);
module.exports.LexerSkipAction = $e56604c1d2a640c8$var$LexerSkipAction;
(function(LexerSkipAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerSkipAction.INSTANCE = new LexerSkipAction();
})($e56604c1d2a640c8$var$LexerSkipAction = module.exports.LexerSkipAction || (module.exports.LexerSkipAction = {}));

});

parcelRegister("345c1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $23b5c605e8108d72$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $23b5c605e8108d72$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerTypeAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `type` lexer action by setting `Lexer.type`
 * with the assigned type.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $23b5c605e8108d72$var$LexerTypeAction {
    /**
     * Constructs a new `type` action with the specified token type value.
     * @param type The type to assign to the token using `Lexer.type`.
     */ constructor(type){
        this._type = type;
    }
    /**
     * Gets the type to assign to a token created by the lexer.
     * @returns The type to assign to a token created by the lexer.
     */ get type() {
        return this._type;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#TYPE}.
     */ get actionType() {
        return 7 /* TYPE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by setting `Lexer.type` with the
     * value provided by `type`.
     */ execute(lexer) {
        lexer.type = this._type;
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        hash = $amQx9.MurmurHash.update(hash, this._type);
        return $amQx9.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $23b5c605e8108d72$var$LexerTypeAction)) return false;
        return this._type === obj._type;
    }
    toString() {
        return `type(${this._type})`;
    }
}
$23b5c605e8108d72$var$__decorate([
    $aN41m.Override
], $23b5c605e8108d72$var$LexerTypeAction.prototype, "actionType", null);
$23b5c605e8108d72$var$__decorate([
    $aN41m.Override
], $23b5c605e8108d72$var$LexerTypeAction.prototype, "isPositionDependent", null);
$23b5c605e8108d72$var$__decorate([
    $aN41m.Override,
    $23b5c605e8108d72$var$__param(0, $aN41m.NotNull)
], $23b5c605e8108d72$var$LexerTypeAction.prototype, "execute", null);
$23b5c605e8108d72$var$__decorate([
    $aN41m.Override
], $23b5c605e8108d72$var$LexerTypeAction.prototype, "hashCode", null);
$23b5c605e8108d72$var$__decorate([
    $aN41m.Override
], $23b5c605e8108d72$var$LexerTypeAction.prototype, "equals", null);
$23b5c605e8108d72$var$__decorate([
    $aN41m.Override
], $23b5c605e8108d72$var$LexerTypeAction.prototype, "toString", null);
module.exports.LexerTypeAction = $23b5c605e8108d72$var$LexerTypeAction;

});

parcelRegister("fFNPu", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b6915673a04edde3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoopEndState = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $aN41m = parcelRequire("aN41m");
/** Mark the end of a * or + loop. */ class $b6915673a04edde3$var$LoopEndState extends $dv9vN.ATNState {
    get stateType() {
        return $fZESB.ATNStateType.LOOP_END;
    }
}
$b6915673a04edde3$var$__decorate([
    $aN41m.Override
], $b6915673a04edde3$var$LoopEndState.prototype, "stateType", null);
module.exports.LoopEndState = $b6915673a04edde3$var$LoopEndState;

});

parcelRegister("gzbPK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c0f91822940cc2ea$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c0f91822940cc2ea$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserATNSimulator = void 0;

var $hu8W9 = parcelRequire("hu8W9");

var $dNkDA = parcelRequire("dNkDA");

var $fsqYw = parcelRequire("fsqYw");

var $4dKou = parcelRequire("4dKou");

var $eeOLb = parcelRequire("eeOLb");

var $hdFz0 = parcelRequire("hdFz0");

var $2SGHL = parcelRequire("2SGHL");

var $ceQRA = parcelRequire("ceQRA");

var $fZESB = parcelRequire("fZESB");

var $kXmw5 = parcelRequire("kXmw5");

var $8WIez = parcelRequire("8WIez");

var $bPdk6 = parcelRequire("bPdk6");

var $42ptv = parcelRequire("42ptv");

var $6P9ap = parcelRequire("6P9ap");

var $eRSlM = parcelRequire("eRSlM");

var $l8y5T = parcelRequire("l8y5T");

var $ldi9e = parcelRequire("ldi9e");

var $aN41m = parcelRequire("aN41m");

var $gFTdY = parcelRequire("gFTdY");

var $iAlWg = parcelRequire("iAlWg");

var $9eW9B = parcelRequire("9eW9B");

var $2pDMz = parcelRequire("2pDMz");

var $jaUCz = parcelRequire("jaUCz");

var $4BvNW = parcelRequire("4BvNW");

var $hwoBE = parcelRequire("hwoBE");

var $jWsYN = parcelRequire("jWsYN");

var $lmhna = parcelRequire("lmhna");

var $3JS45 = parcelRequire("3JS45");

var $5EcBU = parcelRequire("5EcBU");

var $eDtKk = parcelRequire("eDtKk");

var $eKXi4 = parcelRequire("eKXi4");

var $hBnE1 = parcelRequire("hBnE1");

var $fomfP = parcelRequire("fomfP");
const $c0f91822940cc2ea$var$MAX_SHORT_VALUE = 0xFFFF;
const $c0f91822940cc2ea$var$MIN_INTEGER_VALUE = -2147483648;
/**
 * The embodiment of the adaptive LL(*), ALL(*), parsing strategy.
 *
 * The basic complexity of the adaptive strategy makes it harder to understand.
 * We begin with ATN simulation to build paths in a DFA. Subsequent prediction
 * requests go through the DFA first. If they reach a state without an edge for
 * the current symbol, the algorithm fails over to the ATN simulation to
 * complete the DFA path for the current input (until it finds a conflict state
 * or uniquely predicting state).
 *
 * All of that is done without using the outer context because we want to create
 * a DFA that is not dependent upon the rule invocation stack when we do a
 * prediction. One DFA works in all contexts. We avoid using context not
 * necessarily because it's slower, although it can be, but because of the DFA
 * caching problem. The closure routine only considers the rule invocation stack
 * created during prediction beginning in the decision rule. For example, if
 * prediction occurs without invoking another rule's ATN, there are no context
 * stacks in the configurations. When lack of context leads to a conflict, we
 * don't know if it's an ambiguity or a weakness in the strong LL(*) parsing
 * strategy (versus full LL(*)).
 *
 * When SLL yields a configuration set with conflict, we rewind the input and
 * retry the ATN simulation, this time using full outer context without adding
 * to the DFA. Configuration context stacks will be the full invocation stacks
 * from the start rule. If we get a conflict using full context, then we can
 * definitively say we have a true ambiguity for that input sequence. If we
 * don't get a conflict, it implies that the decision is sensitive to the outer
 * context. (It is not context-sensitive in the sense of context-sensitive
 * grammars.)
 *
 * The next time we reach this DFA state with an SLL conflict, through DFA
 * simulation, we will again retry the ATN simulation using full context mode.
 * This is slow because we can't save the results and have to "interpret" the
 * ATN each time we get that input.
 *
 * **CACHING FULL CONTEXT PREDICTIONS**
 *
 * We could cache results from full context to predicted alternative easily and
 * that saves a lot of time but doesn't work in presence of predicates. The set
 * of visible predicates from the ATN start state changes depending on the
 * context, because closure can fall off the end of a rule. I tried to cache
 * tuples (stack context, semantic context, predicted alt) but it was slower
 * than interpreting and much more complicated. Also required a huge amount of
 * memory. The goal is not to create the world's fastest parser anyway. I'd like
 * to keep this algorithm simple. By launching multiple threads, we can improve
 * the speed of parsing across a large number of files.
 *
 * There is no strict ordering between the amount of input used by SLL vs LL,
 * which makes it really hard to build a cache for full context. Let's say that
 * we have input A B C that leads to an SLL conflict with full context X. That
 * implies that using X we might only use A B but we could also use A B C D to
 * resolve conflict. Input A B C D could predict alternative 1 in one position
 * in the input and A B C E could predict alternative 2 in another position in
 * input. The conflicting SLL configurations could still be non-unique in the
 * full context prediction, which would lead us to requiring more input than the
 * original A B C.	To make a	prediction cache work, we have to track	the exact
 * input	used during the previous prediction. That amounts to a cache that maps
 * X to a specific DFA for that context.
 *
 * Something should be done for left-recursive expression predictions. They are
 * likely LL(1) + pred eval. Easier to do the whole SLL unless error and retry
 * with full LL thing Sam does.
 *
 * **AVOIDING FULL CONTEXT PREDICTION**
 *
 * We avoid doing full context retry when the outer context is empty, we did not
 * dip into the outer context by falling off the end of the decision state rule,
 * or when we force SLL mode.
 *
 * As an example of the not dip into outer context case, consider as super
 * constructor calls versus function calls. One grammar might look like
 * this:
 *
 * ```antlr
 * ctorBody
 *   : '{' superCall? stat* '}'
 *   ;
 * ```
 *
 * Or, you might see something like
 *
 * ```antlr
 * stat
 *   : superCall ';'
 *   | expression ';'
 *   | ...
 *   ;
 * ```
 *
 * In both cases I believe that no closure operations will dip into the outer
 * context. In the first case ctorBody in the worst case will stop at the '}'.
 * In the 2nd case it should stop at the ';'. Both cases should stay within the
 * entry rule and not dip into the outer context.
 *
 * **PREDICATES**
 *
 * Predicates are always evaluated if present in either SLL or LL both. SLL and
 * LL simulation deals with predicates differently. SLL collects predicates as
 * it performs closure operations like ANTLR v3 did. It delays predicate
 * evaluation until it reaches and accept state. This allows us to cache the SLL
 * ATN simulation whereas, if we had evaluated predicates on-the-fly during
 * closure, the DFA state configuration sets would be different and we couldn't
 * build up a suitable DFA.
 *
 * When building a DFA accept state during ATN simulation, we evaluate any
 * predicates and return the sole semantically valid alternative. If there is
 * more than 1 alternative, we report an ambiguity. If there are 0 alternatives,
 * we throw an exception. Alternatives without predicates act like they have
 * true predicates. The simple way to think about it is to strip away all
 * alternatives with false predicates and choose the minimum alternative that
 * remains.
 *
 * When we start in the DFA and reach an accept state that's predicated, we test
 * those and return the minimum semantically viable alternative. If no
 * alternatives are viable, we throw an exception.
 *
 * During full LL ATN simulation, closure always evaluates predicates and
 * on-the-fly. This is crucial to reducing the configuration set size during
 * closure. It hits a landmine when parsing with the Java grammar, for example,
 * without this on-the-fly evaluation.
 *
 * **SHARING DFA**
 *
 * All instances of the same parser share the same decision DFAs through a
 * static field. Each instance gets its own ATN simulator but they share the
 * same {@link ATN#decisionToDFA} field. They also share a
 * {@link PredictionContextCache} object that makes sure that all
 * {@link PredictionContext} objects are shared among the DFA states. This makes
 * a big size difference.
 *
 * **THREAD SAFETY**
 *
 * The {@link ParserATNSimulator} locks on the {@link ATN#decisionToDFA} field when
 * it adds a new DFA object to that array. {@link #addDFAEdge}
 * locks on the DFA for the current decision when setting the
 * {@link DFAState#edges} field. {@link #addDFAState} locks on
 * the DFA for the current decision when looking up a DFA state to see if it
 * already exists. We must make sure that all requests to add DFA states that
 * are equivalent result in the same shared DFA object. This is because lots of
 * threads will be trying to update the DFA at once. The
 * {@link #addDFAState} method also locks inside the DFA lock
 * but this time on the shared context cache when it rebuilds the
 * configurations' {@link PredictionContext} objects using cached
 * subgraphs/nodes. No other locking occurs, even during DFA simulation. This is
 * safe as long as we can guarantee that all threads referencing
 * `s.edge[t]` get the same physical target {@link DFAState}, or
 * `undefined`. Once into the DFA, the DFA simulation does not reference the
 * {@link DFA#states} map. It follows the {@link DFAState#edges} field to new
 * targets. The DFA simulator will either find {@link DFAState#edges} to be
 * `undefined`, to be non-`undefined` and `dfa.edges[t]` undefined, or
 * `dfa.edges[t]` to be non-undefined. The
 * {@link #addDFAEdge} method could be racing to set the field
 * but in either case the DFA simulator works; if `undefined`, and requests ATN
 * simulation. It could also race trying to get `dfa.edges[t]`, but either
 * way it will work because it's not doing a test and set operation.
 *
 * **Starting with SLL then failing to combined SLL/LL (Two-Stage
 * Parsing)**
 *
 * Sam pointed out that if SLL does not give a syntax error, then there is no
 * point in doing full LL, which is slower. We only have to try LL if we get a
 * syntax error. For maximum speed, Sam starts the parser set to pure SLL
 * mode with the {@link BailErrorStrategy}:
 *
 * ```
 * parser.interpreter.{@link #setPredictionMode setPredictionMode}`(`{@link PredictionMode#SLL}`)`;
 * parser.{@link Parser#setErrorHandler setErrorHandler}(new {@link BailErrorStrategy}());
 * ```
 *
 * If it does not get a syntax error, then we're done. If it does get a syntax
 * error, we need to retry with the combined SLL/LL strategy.
 *
 * The reason this works is as follows. If there are no SLL conflicts, then the
 * grammar is SLL (at least for that input set). If there is an SLL conflict,
 * the full LL analysis must yield a set of viable alternatives which is a
 * subset of the alternatives reported by SLL. If the LL set is a singleton,
 * then the grammar is LL but not SLL. If the LL set is the same size as the SLL
 * set, the decision is SLL. If the LL set has size &gt; 1, then that decision
 * is truly ambiguous on the current input. If the LL set is smaller, then the
 * SLL conflict resolution might choose an alternative that the full LL would
 * rule out as a possibility based upon better context information. If that's
 * the case, then the SLL parse will definitely get an error because the full LL
 * analysis says it's not viable. If SLL conflict resolution chooses an
 * alternative within the LL set, them both SLL and LL would choose the same
 * alternative because they both choose the minimum of multiple conflicting
 * alternatives.
 *
 * Let's say we have a set of SLL conflicting alternatives `{1, 2, 3}` and
 * a smaller LL set called *s*. If *s* is `{2, 3}`, then SLL
 * parsing will get an error because SLL will pursue alternative 1. If
 * *s* is `{1, 2}` or `{1, 3}` then both SLL and LL will
 * choose the same alternative because alternative one is the minimum of either
 * set. If *s* is `{2}` or `{3}` then SLL will get a syntax
 * error. If *s* is `{1}` then SLL will succeed.
 *
 * Of course, if the input is invalid, then we will get an error for sure in
 * both SLL and LL parsing. Erroneous input will therefore require 2 passes over
 * the input.
 */ let $c0f91822940cc2ea$var$ParserATNSimulator = class ParserATNSimulator extends $ceQRA.ATNSimulator {
    constructor(atn, parser){
        super(atn);
        this.predictionMode = $hwoBE.PredictionMode.LL;
        this.force_global_context = false;
        this.always_try_local_context = true;
        /**
         * Determines whether the DFA is used for full-context predictions. When
         * `true`, the DFA stores transition information for both full-context
         * and SLL parsing; otherwise, the DFA only stores SLL transition
         * information.
         *
         * For some grammars, enabling the full-context DFA can result in a
         * substantial performance improvement. However, this improvement typically
         * comes at the expense of memory used for storing the cached DFA states,
         * configuration sets, and prediction contexts.
         *
         * The default value is `false`.
         */ this.enable_global_context_dfa = false;
        this.optimize_unique_closure = true;
        this.optimize_ll1 = true;
        this.optimize_tail_calls = true;
        this.tail_call_preserves_sll = true;
        this.treat_sllk1_conflict_as_ambiguity = false;
        /**
         * When `true`, ambiguous alternatives are reported when they are
         * encountered within {@link #execATN}. When `false`, these messages
         * are suppressed. The default is `false`.
         *
         * When messages about ambiguous alternatives are not required, setting this
         * to `false` enables additional internal optimizations which may lose
         * this information.
         */ this.reportAmbiguities = false;
        /** By default we do full context-sensitive LL(*) parsing not
         *  Strong LL(*) parsing. If we fail with Strong LL(*) we
         *  try full LL(*). That means we rewind and use context information
         *  when closure operations fall off the end of the rule that
         *  holds the decision were evaluating.
         */ this.userWantsCtxSensitive = true;
        this._parser = parser;
    }
    getPredictionMode() {
        return this.predictionMode;
    }
    setPredictionMode(predictionMode) {
        this.predictionMode = predictionMode;
    }
    reset() {
    // intentionally empty
    }
    adaptivePredict(input, decision, outerContext, useContext) {
        if (useContext === undefined) useContext = false;
        let dfa = this.atn.decisionToDFA[decision];
        $fomfP(dfa != null);
        if (this.optimize_ll1 && !dfa.isPrecedenceDfa && !dfa.isEmpty) {
            let ll_1 = input.LA(1);
            if (ll_1 >= 0 && ll_1 <= 0xFFFF) {
                let key = (decision << 16 >>> 0) + ll_1;
                let alt = this.atn.LL1Table.get(key);
                if (alt != null) return alt;
            }
        }
        this.dfa = dfa;
        if (this.force_global_context) useContext = true;
        else if (!this.always_try_local_context) useContext = useContext || dfa.isContextSensitive;
        this.userWantsCtxSensitive = useContext || this.predictionMode !== $hwoBE.PredictionMode.SLL && outerContext != null && !this.atn.decisionToState[decision].sll;
        if (outerContext == null) outerContext = $2pDMz.ParserRuleContext.emptyContext();
        let state;
        if (!dfa.isEmpty) state = this.getStartState(dfa, input, outerContext, useContext);
        if (state == null) {
            if (outerContext == null) outerContext = $2pDMz.ParserRuleContext.emptyContext();
            if (ParserATNSimulator.debug) console.log("ATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
            state = this.computeStartState(dfa, outerContext, useContext);
        }
        let m = input.mark();
        let index = input.index;
        try {
            let alt = this.execDFA(dfa, input, index, state);
            if (ParserATNSimulator.debug) console.log("DFA after predictATN: " + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
            return alt;
        } finally{
            this.dfa = undefined;
            input.seek(index);
            input.release(m);
        }
    }
    getStartState(dfa, input, outerContext, useContext) {
        if (!useContext) {
            if (dfa.isPrecedenceDfa) {
                // the start state for a precedence DFA depends on the current
                // parser precedence, and is provided by a DFA method.
                let state = dfa.getPrecedenceStartState(this._parser.precedence, false);
                if (state == null) return undefined;
                return new $eDtKk.SimulatorState(outerContext, state, false, outerContext);
            } else {
                if (dfa.s0 == null) return undefined;
                return new $eDtKk.SimulatorState(outerContext, dfa.s0, false, outerContext);
            }
        }
        if (!this.enable_global_context_dfa) return undefined;
        let remainingContext = outerContext;
        $fomfP(outerContext != null);
        let s0;
        if (dfa.isPrecedenceDfa) s0 = dfa.getPrecedenceStartState(this._parser.precedence, true);
        else s0 = dfa.s0full;
        while(remainingContext != null && s0 != null && s0.isContextSensitive){
            remainingContext = this.skipTailCalls(remainingContext);
            s0 = s0.getContextTarget(this.getReturnState(remainingContext));
            if (remainingContext.isEmpty) $fomfP(s0 == null || !s0.isContextSensitive);
            else remainingContext = remainingContext.parent;
        }
        if (s0 == null) return undefined;
        return new $eDtKk.SimulatorState(outerContext, s0, useContext, remainingContext);
    }
    execDFA(dfa, input, startIndex, state) {
        let outerContext = state.outerContext;
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
        if (ParserATNSimulator.dfa_debug) console.log(dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
        let s = state.s0;
        let t = input.LA(1);
        let remainingOuterContext = state.remainingOuterContext;
        while(true){
            if (ParserATNSimulator.dfa_debug) console.log("DFA state " + s.stateNumber + " LA(1)==" + this.getLookaheadName(input));
            if (state.useContext) while(s.isContextSymbol(t)){
                let next;
                if (remainingOuterContext != null) {
                    remainingOuterContext = this.skipTailCalls(remainingOuterContext);
                    next = s.getContextTarget(this.getReturnState(remainingOuterContext));
                }
                if (next == null) {
                    // fail over to ATN
                    let initialState = new $eDtKk.SimulatorState(state.outerContext, s, state.useContext, remainingOuterContext);
                    return this.execATN(dfa, input, startIndex, initialState);
                }
                $fomfP(remainingOuterContext != null);
                remainingOuterContext = remainingOuterContext.parent;
                s = next;
            }
            if (this.isAcceptState(s, state.useContext)) {
                if (s.predicates != null) {
                    if (ParserATNSimulator.dfa_debug) console.log("accept " + s);
                } else if (ParserATNSimulator.dfa_debug) console.log("accept; predict " + s.prediction + " in state " + s.stateNumber);
                break;
            }
            // t is not updated if one of these states is reached
            $fomfP(!this.isAcceptState(s, state.useContext));
            // if no edge, pop over to ATN interpreter, update DFA and return
            let target = this.getExistingTargetState(s, t);
            if (target == null) {
                if (ParserATNSimulator.dfa_debug && t >= 0) console.log("no edge for " + this._parser.vocabulary.getDisplayName(t));
                let alt;
                if (ParserATNSimulator.dfa_debug) {
                    let interval = $l8y5T.Interval.of(startIndex, this._parser.inputStream.index);
                    console.log("ATN exec upon " + this._parser.inputStream.getText(interval) + " at DFA state " + s.stateNumber);
                }
                let initialState = new $eDtKk.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                alt = this.execATN(dfa, input, startIndex, initialState);
                if (ParserATNSimulator.dfa_debug) console.log("back from DFA update, alt=" + alt + ", dfa=\n" + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                // action already executed
                if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + alt);
                return alt; // we've updated DFA, exec'd action, and have our deepest answer
            } else if (target === $ceQRA.ATNSimulator.ERROR) {
                let errorState = new $eDtKk.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                return this.handleNoViableAlt(input, startIndex, errorState);
            }
            s = target;
            if (!this.isAcceptState(s, state.useContext) && t !== $ldi9e.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
        //		if ( acceptState==null ) {
        //			if ( debug ) System.out.println("!!! no viable alt in dfa");
        //			return -1;
        //		}
        if (!state.useContext && s.configs.conflictInfo != null) {
            if (dfa.atnStartState instanceof $42ptv.DecisionState) {
                if (!this.userWantsCtxSensitive || !s.configs.dipsIntoOuterContext && s.configs.isExactConflict || this.treat_sllk1_conflict_as_ambiguity && input.index === startIndex) ;
                else {
                    $fomfP(!state.useContext);
                    // Before attempting full context prediction, check to see if there are
                    // disambiguating or validating predicates to evaluate which allow an
                    // immediate decision
                    let conflictingAlts;
                    let predicates = s.predicates;
                    if (predicates != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        conflictingAlts = this.evalSemanticContext(predicates, outerContext, true);
                        if (conflictingAlts.cardinality() === 1) return conflictingAlts.nextSetBit(0);
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                    if (this.reportAmbiguities) {
                        let conflictState = new $eDtKk.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                        this.reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, input.index);
                    }
                    input.seek(startIndex);
                    return this.adaptivePredict(input, dfa.decision, outerContext, true);
                }
            }
        }
        // Before jumping to prediction, check to see if there are
        // disambiguating or validating predicates to evaluate
        let predicates = s.predicates;
        if (predicates != null) {
            let stopIndex = input.index;
            if (startIndex !== stopIndex) input.seek(startIndex);
            let alts = this.evalSemanticContext(predicates, outerContext, this.reportAmbiguities && this.predictionMode === $hwoBE.PredictionMode.LL_EXACT_AMBIG_DETECTION);
            switch(alts.cardinality()){
                case 0:
                    throw this.noViableAlt(input, outerContext, s.configs, startIndex);
                case 1:
                    return alts.nextSetBit(0);
                default:
                    // report ambiguity after predicate evaluation to make sure the correct
                    // set of ambig alts is reported.
                    if (startIndex !== stopIndex) input.seek(stopIndex);
                    this.reportAmbiguity(dfa, s, startIndex, stopIndex, s.configs.isExactConflict, alts, s.configs);
                    return alts.nextSetBit(0);
            }
        }
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + s.prediction);
        return s.prediction;
    }
    /**
     * Determines if a particular DFA state should be treated as an accept state
     * for the current prediction mode. In addition to the `useContext`
     * parameter, the {@link #getPredictionMode()} method provides the
     * prediction mode controlling the prediction algorithm as a whole.
     *
     * The default implementation simply returns the value of
     * `DFAState.isAcceptState` except for conflict states when
     * `useContext` is `true` and {@link #getPredictionMode()} is
     * {@link PredictionMode#LL_EXACT_AMBIG_DETECTION}. In that case, only
     * conflict states where {@link ATNConfigSet#isExactConflict} is
     * `true` are considered accept states.
     *
     * @param state The DFA state to check.
     * @param useContext `true` if the prediction algorithm is currently
     * considering the full parser context; otherwise, `false` if the
     * algorithm is currently performing a local context prediction.
     *
     * @returns `true` if the specified `state` is an accept state;
     * otherwise, `false`.
     */ isAcceptState(state, useContext) {
        if (!state.isAcceptState) return false;
        if (state.configs.conflictingAlts == null) // unambiguous
        return true;
        // More picky when we need exact conflicts
        if (useContext && this.predictionMode === $hwoBE.PredictionMode.LL_EXACT_AMBIG_DETECTION) return state.configs.isExactConflict;
        return true;
    }
    /** Performs ATN simulation to compute a predicted alternative based
     *  upon the remaining input, but also updates the DFA cache to avoid
     *  having to traverse the ATN again for the same input sequence.
     *
     * There are some key conditions we're looking for after computing a new
     * set of ATN configs (proposed DFA state):
     *
     * * if the set is empty, there is no viable alternative for current symbol
     * * does the state uniquely predict an alternative?
     * * does the state have a conflict that would prevent us from
     *   putting it on the work list?
     * * if in non-greedy decision is there a config at a rule stop state?
     *
     * We also have some key operations to do:
     *
     * * add an edge from previous DFA state to potentially new DFA state, D,
     *   upon current symbol but only if adding to work list, which means in all
     *   cases except no viable alternative (and possibly non-greedy decisions?)
     * * collecting predicates and adding semantic context to DFA accept states
     * * adding rule context to context-sensitive DFA accept states
     * * consuming an input symbol
     * * reporting a conflict
     * * reporting an ambiguity
     * * reporting a context sensitivity
     * * reporting insufficient predicates
     *
     * We should isolate those operations, which are side-effecting, to the
     * main work loop. We can isolate lots of code into other functions, but
     * they should be side effect free. They can return package that
     * indicates whether we should report something, whether we need to add a
     * DFA edge, whether we need to augment accept state with semantic
     * context or rule invocation context. Actually, it seems like we always
     * add predicates if they exist, so that can simply be done in the main
     * loop for any accept state creation or modification request.
     *
     * cover these cases:
     *   dead end
     *   single alt
     *   single alt + preds
     *   conflict
     *   conflict + preds
     *
     * TODO: greedy + those
     */ execATN(dfa, input, startIndex, initialState) {
        if (ParserATNSimulator.debug) console.log("execATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input));
        let outerContext = initialState.outerContext;
        let useContext = initialState.useContext;
        let t = input.LA(1);
        let previous = initialState;
        let contextCache = new $4BvNW.PredictionContextCache();
        while(true){
            let nextState = this.computeReachSet(dfa, previous, t, contextCache);
            if (nextState == null) {
                this.setDFAEdge(previous.s0, input.LA(1), $ceQRA.ATNSimulator.ERROR);
                return this.handleNoViableAlt(input, startIndex, previous);
            }
            let D = nextState.s0;
            // predicted alt => accept state
            $fomfP(D.isAcceptState || D.prediction === $eeOLb.ATN.INVALID_ALT_NUMBER);
            // conflicted => accept state
            $fomfP(D.isAcceptState || D.configs.conflictInfo == null);
            if (this.isAcceptState(D, useContext)) {
                let conflictingAlts = D.configs.conflictingAlts;
                let predictedAlt = conflictingAlts == null ? D.prediction : $eeOLb.ATN.INVALID_ALT_NUMBER;
                if (predictedAlt !== $eeOLb.ATN.INVALID_ALT_NUMBER) {
                    if (this.optimize_ll1 && input.index === startIndex && !dfa.isPrecedenceDfa && nextState.outerContext === nextState.remainingOuterContext && dfa.decision >= 0 && !D.configs.hasSemanticContext) {
                        if (t >= 0 && t <= $c0f91822940cc2ea$var$MAX_SHORT_VALUE) {
                            let key = (dfa.decision << 16 >>> 0) + t;
                            this.atn.LL1Table.set(key, predictedAlt);
                        }
                    }
                    if (useContext && this.always_try_local_context) this.reportContextSensitivity(dfa, predictedAlt, nextState, startIndex, input.index);
                }
                predictedAlt = D.prediction;
                //				int k = input.index - startIndex + 1; // how much input we used
                //				System.out.println("used k="+k);
                let attemptFullContext = conflictingAlts != null && this.userWantsCtxSensitive;
                if (attemptFullContext) // Only exact conflicts are known to be ambiguous when local
                // prediction does not step out of the decision rule.
                attemptFullContext = !useContext && (D.configs.dipsIntoOuterContext || !D.configs.isExactConflict) && (!this.treat_sllk1_conflict_as_ambiguity || input.index !== startIndex);
                if (D.configs.hasSemanticContext) {
                    let predPredictions = D.predicates;
                    if (predPredictions != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        // use complete evaluation here if we'll want to retry with full context if still ambiguous
                        conflictingAlts = this.evalSemanticContext(predPredictions, outerContext, attemptFullContext || this.reportAmbiguities);
                        switch(conflictingAlts.cardinality()){
                            case 0:
                                throw this.noViableAlt(input, outerContext, D.configs, startIndex);
                            case 1:
                                return conflictingAlts.nextSetBit(0);
                            default:
                                break;
                        }
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                }
                if (!attemptFullContext) {
                    if (conflictingAlts != null) {
                        if (this.reportAmbiguities && conflictingAlts.cardinality() > 1) this.reportAmbiguity(dfa, D, startIndex, input.index, D.configs.isExactConflict, conflictingAlts, D.configs);
                        predictedAlt = conflictingAlts.nextSetBit(0);
                    }
                    return predictedAlt;
                } else {
                    $fomfP(!useContext);
                    $fomfP(this.isAcceptState(D, false));
                    if (ParserATNSimulator.debug) console.log("RETRY with outerContext=" + outerContext);
                    let fullContextState = this.computeStartState(dfa, outerContext, true);
                    if (this.reportAmbiguities) this.reportAttemptingFullContext(dfa, conflictingAlts, nextState, startIndex, input.index);
                    input.seek(startIndex);
                    return this.execATN(dfa, input, startIndex, fullContextState);
                }
            }
            previous = nextState;
            if (t !== $ldi9e.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
    }
    /**
     * This method is used to improve the localization of error messages by
     * choosing an alternative rather than throwing a
     * {@link NoViableAltException} in particular prediction scenarios where the
     * {@link #ERROR} state was reached during ATN simulation.
     *
     * The default implementation of this method uses the following
     * algorithm to identify an ATN configuration which successfully parsed the
     * decision entry rule. Choosing such an alternative ensures that the
     * {@link ParserRuleContext} returned by the calling rule will be complete
     * and valid, and the syntax error will be reported later at a more
     * localized location.
     *
     * * If no configuration in `configs` reached the end of the
     *   decision rule, return {@link ATN#INVALID_ALT_NUMBER}.
     * * If all configurations in `configs` which reached the end of the
     *   decision rule predict the same alternative, return that alternative.
     * * If the configurations in `configs` which reached the end of the
     *   decision rule predict multiple alternatives (call this *S*),
     *   choose an alternative in the following order.
     *
     *     1. Filter the configurations in `configs` to only those
     *        configurations which remain viable after evaluating semantic predicates.
     *        If the set of these filtered configurations which also reached the end of
     *        the decision rule is not empty, return the minimum alternative
     *        represented in this set.
     *     1. Otherwise, choose the minimum alternative in *S*.
     *
     * In some scenarios, the algorithm described above could predict an
     * alternative which will result in a {@link FailedPredicateException} in
     * parser. Specifically, this could occur if the *only* configuration
     * capable of successfully parsing to the end of the decision rule is
     * blocked by a semantic predicate. By choosing this alternative within
     * {@link #adaptivePredict} instead of throwing a
     * {@link NoViableAltException}, the resulting
     * {@link FailedPredicateException} in the parser will identify the specific
     * predicate which is preventing the parser from successfully parsing the
     * decision rule, which helps developers identify and correct logic errors
     * in semantic predicates.
     *
     * @param input The input {@link TokenStream}
     * @param startIndex The start index for the current prediction, which is
     * the input index where any semantic context in `configs` should be
     * evaluated
     * @param previous The ATN simulation state immediately before the
     * {@link #ERROR} state was reached
     *
     * @returns The value to return from {@link #adaptivePredict}, or
     * {@link ATN#INVALID_ALT_NUMBER} if a suitable alternative was not
     * identified and {@link #adaptivePredict} should report an error instead.
     */ handleNoViableAlt(input, startIndex, previous) {
        if (previous.s0 != null) {
            let alts = new $8WIez.BitSet();
            let maxAlt = 0;
            for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $jWsYN.RuleStopState) {
                alts.set(config.alt);
                maxAlt = Math.max(maxAlt, config.alt);
            }
            switch(alts.cardinality()){
                case 0:
                    break;
                case 1:
                    return alts.nextSetBit(0);
                default:
                    if (!previous.s0.configs.hasSemanticContext) // configs doesn't contain any predicates, so the predicate
                    // filtering code below would be pointless
                    return alts.nextSetBit(0);
                    /*
                     * Try to find a configuration set that not only dipped into the outer
                     * context, but also isn't eliminated by a predicate.
                     */ let filteredConfigs = new $2SGHL.ATNConfigSet();
                    for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $jWsYN.RuleStopState) filteredConfigs.add(config);
                    /* The following code blocks are adapted from predicateDFAState with
                     * the following key changes.
                     *
                     *  1. The code operates on an ATNConfigSet rather than a DFAState.
                     *  2. Predicates are collected for all alternatives represented in
                     *     filteredConfigs, rather than restricting the evaluation to
                     *     conflicting and/or unique configurations.
                     */ let altToPred = this.getPredsForAmbigAlts(alts, filteredConfigs, maxAlt);
                    if (altToPred != null) {
                        let predicates = this.getPredicatePredictions(alts, altToPred);
                        if (predicates != null) {
                            let stopIndex = input.index;
                            try {
                                input.seek(startIndex);
                                let filteredAlts = this.evalSemanticContext(predicates, previous.outerContext, false);
                                if (!filteredAlts.isEmpty) return filteredAlts.nextSetBit(0);
                            } finally{
                                input.seek(stopIndex);
                            }
                        }
                    }
                    return alts.nextSetBit(0);
            }
        }
        throw this.noViableAlt(input, previous.outerContext, previous.s0.configs, startIndex);
    }
    computeReachSet(dfa, previous, t, contextCache) {
        let useContext = previous.useContext;
        let remainingGlobalContext = previous.remainingOuterContext;
        let s = previous.s0;
        if (useContext) while(s.isContextSymbol(t)){
            let next;
            if (remainingGlobalContext != null) {
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                next = s.getContextTarget(this.getReturnState(remainingGlobalContext));
            }
            if (next == null) break;
            $fomfP(remainingGlobalContext != null);
            remainingGlobalContext = remainingGlobalContext.parent;
            s = next;
        }
        $fomfP(!this.isAcceptState(s, useContext));
        if (this.isAcceptState(s, useContext)) return new $eDtKk.SimulatorState(previous.outerContext, s, useContext, remainingGlobalContext);
        let s0 = s;
        let target = this.getExistingTargetState(s0, t);
        if (target == null) {
            let result = this.computeTargetState(dfa, s0, remainingGlobalContext, t, useContext, contextCache);
            target = result[0];
            remainingGlobalContext = result[1];
        }
        if (target === $ceQRA.ATNSimulator.ERROR) return undefined;
        $fomfP(!useContext || !target.configs.dipsIntoOuterContext);
        return new $eDtKk.SimulatorState(previous.outerContext, target, useContext, remainingGlobalContext);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        return s.getTarget(t);
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param dfa
     * @param s The current DFA state
     * @param remainingGlobalContext
     * @param t The next input symbol
     * @param useContext
     * @param contextCache
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(dfa, s, remainingGlobalContext, t, useContext, contextCache) {
        let closureConfigs = s.configs.toArray();
        let contextElements;
        let reach = new $2SGHL.ATNConfigSet();
        let stepIntoGlobal;
        do {
            let hasMoreContext = !useContext || remainingGlobalContext != null;
            if (!hasMoreContext) reach.isOutermostConfigSet = true;
            let reachIntermediate = new $2SGHL.ATNConfigSet();
            /* Configurations already in a rule stop state indicate reaching the end
             * of the decision rule (local context) or end of the start rule (full
             * context). Once reached, these configurations are never updated by a
             * closure operation, so they are handled separately for the performance
             * advantage of having a smaller intermediate set when calling closure.
             *
             * For full-context reach operations, separate handling is required to
             * ensure that the alternative matching the longest overall sequence is
             * chosen when multiple such configurations can match the input.
             */ let skippedStopStates;
            for (let c of closureConfigs){
                if (ParserATNSimulator.debug) console.log("testing " + this.getTokenName(t) + " at " + c.toString());
                if (c.state instanceof $jWsYN.RuleStopState) {
                    $fomfP(c.context.isEmpty);
                    if (useContext && !c.reachesIntoOuterContext || t === $ldi9e.IntStream.EOF) {
                        if (skippedStopStates == null) skippedStopStates = [];
                        skippedStopStates.push(c);
                    }
                    continue;
                }
                let n = c.state.numberOfOptimizedTransitions;
                for(let ti = 0; ti < n; ti++){
                    let trans = c.state.getOptimizedTransition(ti);
                    let target = this.getReachableTarget(c, trans, t);
                    if (target != null) reachIntermediate.add(c.transform(target, false), contextCache);
                }
            }
            /* This block optimizes the reach operation for intermediate sets which
             * trivially indicate a termination state for the overall
             * adaptivePredict operation.
             *
             * The conditions assume that intermediate
             * contains all configurations relevant to the reach set, but this
             * condition is not true when one or more configurations have been
             * withheld in skippedStopStates, or when the current symbol is EOF.
             */ if (this.optimize_unique_closure && skippedStopStates == null && t !== $eKXi4.Token.EOF && reachIntermediate.uniqueAlt !== $eeOLb.ATN.INVALID_ALT_NUMBER) {
                reachIntermediate.isOutermostConfigSet = reach.isOutermostConfigSet;
                reach = reachIntermediate;
                break;
            }
            /* If the reach set could not be trivially determined, perform a closure
             * operation on the intermediate set to compute its initial value.
             */ let collectPredicates = false;
            let treatEofAsEpsilon = t === $eKXi4.Token.EOF;
            this.closure(reachIntermediate, reach, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon);
            stepIntoGlobal = reach.dipsIntoOuterContext;
            if (t === $ldi9e.IntStream.EOF) /* After consuming EOF no additional input is possible, so we are
                 * only interested in configurations which reached the end of the
                 * decision rule (local context) or end of the start rule (full
                 * context). Update reach to contain only these configurations. This
                 * handles both explicit EOF transitions in the grammar and implicit
                 * EOF transitions following the end of the decision or start rule.
                 *
                 * This is handled before the configurations in skippedStopStates,
                 * because any configurations potentially added from that list are
                 * already guaranteed to meet this condition whether or not it's
                 * required.
                 */ reach = this.removeAllConfigsNotInRuleStopState(reach, contextCache);
            /* If skippedStopStates is not undefined, then it contains at least one
             * configuration. For full-context reach operations, these
             * configurations reached the end of the start rule, in which case we
             * only add them back to reach if no configuration during the current
             * closure operation reached such a state. This ensures adaptivePredict
             * chooses an alternative matching the longest overall sequence when
             * multiple alternatives are viable.
             */ if (skippedStopStates != null && (!useContext || !$hwoBE.PredictionMode.hasConfigInRuleStopState(reach))) {
                $fomfP(skippedStopStates.length > 0);
                for (let c of skippedStopStates)reach.add(c, contextCache);
            }
            if (useContext && stepIntoGlobal) {
                reach.clear();
                // We know remainingGlobalContext is not undefined at this point (why?)
                remainingGlobalContext;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                let nextContextElement = this.getReturnState(remainingGlobalContext);
                if (contextElements == null) contextElements = new $eRSlM.IntegerList();
                if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                else remainingGlobalContext = remainingGlobalContext.parent;
                contextElements.add(nextContextElement);
                if (nextContextElement !== $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) for(let i = 0; i < closureConfigs.length; i++)closureConfigs[i] = closureConfigs[i].appendContext(nextContextElement, contextCache);
            }
        }while (useContext && stepIntoGlobal);
        if (reach.isEmpty) {
            this.setDFAEdge(s, t, $ceQRA.ATNSimulator.ERROR);
            return [
                $ceQRA.ATNSimulator.ERROR,
                remainingGlobalContext
            ];
        }
        let result = this.addDFAEdge(dfa, s, t, contextElements, reach, contextCache);
        return [
            result,
            remainingGlobalContext
        ];
    }
    /**
     * Return a configuration set containing only the configurations from
     * `configs` which are in a {@link RuleStopState}. If all
     * configurations in `configs` are already in a rule stop state, this
     * method simply returns `configs`.
     *
     * @param configs the configuration set to update
     * @param contextCache the {@link PredictionContext} cache
     *
     * @returns `configs` if all configurations in `configs` are in a
     * rule stop state, otherwise return a new configuration set containing only
     * the configurations from `configs` which are in a rule stop state
     */ removeAllConfigsNotInRuleStopState(configs, contextCache) {
        if ($hwoBE.PredictionMode.allConfigsInRuleStopStates(configs)) return configs;
        let result = new $2SGHL.ATNConfigSet();
        for (let config of configs){
            if (!(config.state instanceof $jWsYN.RuleStopState)) continue;
            result.add(config, contextCache);
        }
        return result;
    }
    computeStartState(dfa, globalContext, useContext) {
        let s0 = dfa.isPrecedenceDfa ? dfa.getPrecedenceStartState(this._parser.precedence, useContext) : useContext ? dfa.s0full : dfa.s0;
        if (s0 != null) {
            if (!useContext) return new $eDtKk.SimulatorState(globalContext, s0, useContext, globalContext);
            s0.setContextSensitive(this.atn);
        }
        let decision = dfa.decision;
        // @NotNull
        let p = dfa.atnStartState;
        let previousContext = 0;
        let remainingGlobalContext = globalContext;
        let initialContext = useContext ? $jaUCz.PredictionContext.EMPTY_FULL : $jaUCz.PredictionContext.EMPTY_LOCAL; // always at least the implicit call to start rule
        let contextCache = new $4BvNW.PredictionContextCache();
        if (useContext) {
            if (!this.enable_global_context_dfa) {
                while(remainingGlobalContext != null)if (remainingGlobalContext.isEmpty) {
                    previousContext = $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
            }
            while(s0 != null && s0.isContextSensitive && remainingGlobalContext != null){
                let next;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                if (remainingGlobalContext.isEmpty) {
                    next = s0.getContextTarget($jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY);
                    previousContext = $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    next = s0.getContextTarget(previousContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
                if (next == null) break;
                s0 = next;
            }
        }
        if (s0 != null && !s0.isContextSensitive) return new $eDtKk.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
        let configs = new $2SGHL.ATNConfigSet();
        while(true){
            let reachIntermediate = new $2SGHL.ATNConfigSet();
            let n = p.numberOfTransitions;
            for(let ti = 0; ti < n; ti++){
                // for each transition
                let target = p.transition(ti).target;
                reachIntermediate.add($hdFz0.ATNConfig.create(target, ti + 1, initialContext));
            }
            let hasMoreContext = remainingGlobalContext != null;
            if (!hasMoreContext) configs.isOutermostConfigSet = true;
            let collectPredicates = true;
            this.closure(reachIntermediate, configs, collectPredicates, hasMoreContext, contextCache, false);
            let stepIntoGlobal = configs.dipsIntoOuterContext;
            let next;
            if (useContext && !this.enable_global_context_dfa) {
                s0 = this.addDFAState(dfa, configs, contextCache);
                break;
            } else if (s0 == null) {
                if (!dfa.isPrecedenceDfa) {
                    next = this.addDFAState(dfa, configs, contextCache);
                    if (useContext) {
                        if (!dfa.s0full) dfa.s0full = next;
                        else next = dfa.s0full;
                    } else if (!dfa.s0) dfa.s0 = next;
                    else next = dfa.s0;
                } else {
                    /* If this is a precedence DFA, we use applyPrecedenceFilter
                     * to convert the computed start state to a precedence start
                     * state. We then use DFA.setPrecedenceStartState to set the
                     * appropriate start state for the precedence level rather
                     * than simply setting DFA.s0.
                     */ configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                    next = this.addDFAState(dfa, configs, contextCache);
                    dfa.setPrecedenceStartState(this._parser.precedence, useContext, next);
                }
            } else {
                if (dfa.isPrecedenceDfa) configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                next = this.addDFAState(dfa, configs, contextCache);
                s0.setContextTarget(previousContext, next);
            }
            s0 = next;
            if (!useContext || !stepIntoGlobal) break;
            // TODO: make sure it distinguishes empty stack states
            next.setContextSensitive(this.atn);
            // We know remainingGlobalContext is not undefined at this point (why?)
            remainingGlobalContext;
            configs.clear();
            remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
            let nextContextElement = this.getReturnState(remainingGlobalContext);
            if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
            else remainingGlobalContext = remainingGlobalContext.parent;
            if (nextContextElement !== $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) initialContext = initialContext.appendSingleContext(nextContextElement, contextCache);
            previousContext = nextContextElement;
        }
        return new $eDtKk.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
    }
    /**
     * This method transforms the start state computed by
     * {@link #computeStartState} to the special start state used by a
     * precedence DFA for a particular precedence value. The transformation
     * process applies the following changes to the start state's configuration
     * set.
     *
     * 1. Evaluate the precedence predicates for each configuration using
     *    {@link SemanticContext#evalPrecedence}.
     * 1. When {@link ATNConfig#isPrecedenceFilterSuppressed} is `false`,
     *    remove all configurations which predict an alternative greater than 1,
     *    for which another configuration that predicts alternative 1 is in the
     *    same ATN state with the same prediction context. This transformation is
     *    valid for the following reasons:
     *
     *     * The closure block cannot contain any epsilon transitions which bypass
     *       the body of the closure, so all states reachable via alternative 1 are
     *       part of the precedence alternatives of the transformed left-recursive
     *       rule.
     *     * The "primary" portion of a left recursive rule cannot contain an
     *       epsilon transition, so the only way an alternative other than 1 can exist
     *       in a state that is also reachable via alternative 1 is by nesting calls
     *       to the left-recursive rule, with the outer calls not being at the
     *       preferred precedence level. The
     *       {@link ATNConfig#isPrecedenceFilterSuppressed} property marks ATN
     *       configurations which do not meet this condition, and therefore are not
     *       eligible for elimination during the filtering process.
     *
     * The prediction context must be considered by this filter to address
     * situations like the following.
     *
     * ```antlr
     * grammar TA;
     * prog: statement* EOF;
     * statement: letterA | statement letterA 'b' ;
     * letterA: 'a';
     * ```
     *
     * If the above grammar, the ATN state immediately before the token
     * reference `'a'` in `letterA` is reachable from the left edge
     * of both the primary and closure blocks of the left-recursive rule
     * `statement`. The prediction context associated with each of these
     * configurations distinguishes between them, and prevents the alternative
     * which stepped out to `prog` (and then back in to `statement`
     * from being eliminated by the filter.
     *
     * @param configs The configuration set computed by
     * {@link #computeStartState} as the start state for the DFA.
     * @returns The transformed configuration set representing the start state
     * for a precedence DFA at a particular precedence level (determined by
     * calling {@link Parser#getPrecedence}).
     */ applyPrecedenceFilter(configs, globalContext, contextCache) {
        let statesFromAlt1 = new Map();
        let configSet = new $2SGHL.ATNConfigSet();
        for (let config of configs){
            // handle alt 1 first
            if (config.alt !== 1) continue;
            let updatedContext = config.semanticContext.evalPrecedence(this._parser, globalContext);
            if (updatedContext == null) continue;
            statesFromAlt1.set(config.state.stateNumber, config.context);
            if (updatedContext !== config.semanticContext) configSet.add(config.transform(config.state, false, updatedContext), contextCache);
            else configSet.add(config, contextCache);
        }
        for (let config of configs){
            if (config.alt === 1) continue;
            if (!config.isPrecedenceFilterSuppressed) {
                /* In the future, this elimination step could be updated to also
                 * filter the prediction context for alternatives predicting alt>1
                 * (basically a graph subtraction algorithm).
                 */ let context = statesFromAlt1.get(config.state.stateNumber);
                if (context != null && context.equals(config.context)) continue;
            }
            configSet.add(config, contextCache);
        }
        return configSet;
    }
    getReachableTarget(source, trans, ttype) {
        if (trans.matches(ttype, 0, this.atn.maxTokenType)) return trans.target;
        return undefined;
    }
    /** collect and set D's semantic context */ predicateDFAState(D, configs, nalts) {
        let conflictingAlts = this.getConflictingAltsFromConfigSet(configs);
        if (!conflictingAlts) throw new Error("This unhandled scenario is intended to be unreachable, but I'm currently not sure of why we know that's the case.");
        if (ParserATNSimulator.debug) console.log("predicateDFAState " + D);
        let altToPred = this.getPredsForAmbigAlts(conflictingAlts, configs, nalts);
        // altToPred[uniqueAlt] is now our validating predicate (if any)
        let predPredictions;
        if (altToPred != null) {
            // we have a validating predicate; test it
            // Update DFA so reach becomes accept state with predicate
            predPredictions = this.getPredicatePredictions(conflictingAlts, altToPred);
            D.predicates = predPredictions;
        }
        return predPredictions;
    }
    getPredsForAmbigAlts(ambigAlts, configs, nalts) {
        // REACH=[1|1|[]|0:0, 1|2|[]|0:1]
        /* altToPred starts as an array of all undefined contexts. The entry at index i
         * corresponds to alternative i. altToPred[i] may have one of three values:
         *   1. undefined: no ATNConfig c is found such that c.alt===i
         *   2. SemanticContext.NONE: At least one ATNConfig c exists such that
         *      c.alt===i and c.semanticContext===SemanticContext.NONE. In other words,
         *      alt i has at least one unpredicated config.
         *   3. Non-NONE Semantic Context: There exists at least one, and for all
         *      ATNConfig c such that c.alt===i, c.semanticContext!==SemanticContext.NONE.
         *
         * From this, it is clear that NONE||anything==NONE.
         */ let altToPred = new Array(nalts + 1);
        let n = altToPred.length;
        for (let c of configs)if (ambigAlts.get(c.alt)) altToPred[c.alt] = $3JS45.SemanticContext.or(altToPred[c.alt], c.semanticContext);
        let nPredAlts = 0;
        for(let i = 0; i < n; i++){
            if (altToPred[i] == null) altToPred[i] = $3JS45.SemanticContext.NONE;
            else if (altToPred[i] !== $3JS45.SemanticContext.NONE) nPredAlts++;
        }
        // At this point we know `altToPred` doesn't contain any undefined entries
        let result = altToPred;
        // nonambig alts are undefined in result
        if (nPredAlts === 0) result = undefined;
        if (ParserATNSimulator.debug) console.log("getPredsForAmbigAlts result " + (result ? $4dKou.Arrays.toString(result) : "undefined"));
        return result;
    }
    getPredicatePredictions(ambigAlts, altToPred) {
        let pairs = [];
        let containsPredicate = false;
        for(let i = 1; i < altToPred.length; i++){
            let pred = altToPred[i];
            // unpredicated is indicated by SemanticContext.NONE
            $fomfP(pred != null);
            // find first unpredicated but ambig alternative, if any.
            // Only ambiguous alternatives will have SemanticContext.NONE.
            // Any unambig alts or ambig naked alts after first ambig naked are ignored
            // (undefined, i) means alt i is the default prediction
            // if no (undefined, i), then no default prediction.
            if (ambigAlts != null && ambigAlts.get(i) && pred === $3JS45.SemanticContext.NONE) pairs.push(new $6P9ap.DFAState.PredPrediction(pred, i));
            else if (pred !== $3JS45.SemanticContext.NONE) {
                containsPredicate = true;
                pairs.push(new $6P9ap.DFAState.PredPrediction(pred, i));
            }
        }
        if (!containsPredicate) return undefined;
        //		System.out.println(Arrays.toString(altToPred)+"->"+pairs);
        return pairs;
    }
    /** Look through a list of predicate/alt pairs, returning alts for the
     *  pairs that win. An `undefined` predicate indicates an alt containing an
     *  unpredicated config which behaves as "always true."
     */ evalSemanticContext(predPredictions, outerContext, complete) {
        let predictions = new $8WIez.BitSet();
        for (let pair of predPredictions){
            if (pair.pred === $3JS45.SemanticContext.NONE) {
                predictions.set(pair.alt);
                if (!complete) break;
                continue;
            }
            let evaluatedResult = this.evalSemanticContextImpl(pair.pred, outerContext, pair.alt);
            if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("eval pred " + pair + "=" + evaluatedResult);
            if (evaluatedResult) {
                if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("PREDICT " + pair.alt);
                predictions.set(pair.alt);
                if (!complete) break;
            }
        }
        return predictions;
    }
    /**
     * Evaluate a semantic context within a specific parser context.
     *
     * This method might not be called for every semantic context evaluated
     * during the prediction process. In particular, we currently do not
     * evaluate the following but it may change in the future:
     *
     * * Precedence predicates (represented by
     *   {@link SemanticContext.PrecedencePredicate}) are not currently evaluated
     *   through this method.
     * * Operator predicates (represented by {@link SemanticContext.AND} and
     *   {@link SemanticContext.OR}) are evaluated as a single semantic
     *   context, rather than evaluating the operands individually.
     *   Implementations which require evaluation results from individual
     *   predicates should override this method to explicitly handle evaluation of
     *   the operands within operator predicates.
     *
     * @param pred The semantic context to evaluate
     * @param parserCallStack The parser context in which to evaluate the
     * semantic context
     * @param alt The alternative which is guarded by `pred`
     *
     * @since 4.3
     */ evalSemanticContextImpl(pred, parserCallStack, alt) {
        return pred.eval(this._parser, parserCallStack);
    }
    /* TODO: If we are doing predicates, there is no point in pursuing
         closure operations if we reach a DFA state that uniquely predicts
         alternative. We will not be caching that DFA state and it is a
         waste to pursue the closure. Might have to advance when we do
         ambig detection thought :(
          */ closure(sourceConfigs, configs, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon) {
        if (contextCache == null) contextCache = $4BvNW.PredictionContextCache.UNCACHED;
        let currentConfigs = sourceConfigs;
        let closureBusy = new $fsqYw.Array2DHashSet($9eW9B.ObjectEqualityComparator.INSTANCE);
        while(currentConfigs.size > 0){
            let intermediate = new $2SGHL.ATNConfigSet();
            for (let config of currentConfigs)this.closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContext, contextCache, 0, treatEofAsEpsilon);
            currentConfigs = intermediate;
        }
    }
    closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth, treatEofAsEpsilon) {
        if (ParserATNSimulator.debug) console.log("closure(" + config.toString(this._parser, true) + ")");
        if (config.state instanceof $jWsYN.RuleStopState) {
            // We hit rule end. If we have context info, use it
            if (!config.context.isEmpty) {
                let hasEmpty = config.context.hasEmpty;
                let nonEmptySize = config.context.size - (hasEmpty ? 1 : 0);
                for(let i = 0; i < nonEmptySize; i++){
                    let newContext = config.context.getParent(i); // "pop" return state
                    let returnState = this.atn.states[config.context.getReturnState(i)];
                    let c = $hdFz0.ATNConfig.create(returnState, config.alt, newContext, config.semanticContext);
                    // While we have context to pop back from, we may have
                    // gotten that context AFTER having fallen off a rule.
                    // Make sure we track that we are now out of context.
                    c.outerContextDepth = config.outerContextDepth;
                    c.isPrecedenceFilterSuppressed = config.isPrecedenceFilterSuppressed;
                    $fomfP(depth > $c0f91822940cc2ea$var$MIN_INTEGER_VALUE);
                    this.closureImpl(c, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth - 1, treatEofAsEpsilon);
                }
                if (!hasEmpty || !hasMoreContexts) return;
                config = config.transform(config.state, false, $jaUCz.PredictionContext.EMPTY_LOCAL);
            } else if (!hasMoreContexts) {
                configs.add(config, contextCache);
                return;
            } else {
                // else if we have no context info, just chase follow links (if greedy)
                if (ParserATNSimulator.debug) console.log("FALLING off rule " + this.getRuleName(config.state.ruleIndex));
                if (config.context === $jaUCz.PredictionContext.EMPTY_FULL) // no need to keep full context overhead when we step out
                config = config.transform(config.state, false, $jaUCz.PredictionContext.EMPTY_LOCAL);
                else if (!config.reachesIntoOuterContext && $jaUCz.PredictionContext.isEmptyLocal(config.context)) // add stop state when leaving decision rule for the first time
                configs.add(config, contextCache);
            }
        }
        let p = config.state;
        // optimization
        if (!p.onlyHasEpsilonTransitions) {
            configs.add(config, contextCache);
            // make sure to not return here, because EOF transitions can act as
            // both epsilon transitions and non-epsilon transitions.
            if (ParserATNSimulator.debug) console.log("added config " + configs);
        }
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            // This block implements first-edge elimination of ambiguous LR
            // alternatives as part of dynamic disambiguation during prediction.
            // See antlr/antlr4#1398.
            if (i === 0 && p.stateType === $fZESB.ATNStateType.STAR_LOOP_ENTRY && p.precedenceRuleDecision && !config.context.hasEmpty) {
                let precedenceDecision = p;
                // When suppress is true, it means the outgoing edge i==0 is
                // ambiguous with the outgoing edge i==1, and thus the closure
                // operation can dynamically disambiguate by suppressing this
                // edge during the closure operation.
                let suppress = true;
                for(let j = 0; j < config.context.size; j++)if (!precedenceDecision.precedenceLoopbackStates.get(config.context.getReturnState(j))) {
                    suppress = false;
                    break;
                }
                if (suppress) continue;
            }
            let t = p.getOptimizedTransition(i);
            let continueCollecting = !(t instanceof $dNkDA.ActionTransition) && collectPredicates;
            let c = this.getEpsilonTarget(config, t, continueCollecting, depth === 0, contextCache, treatEofAsEpsilon);
            if (c != null) {
                if (t instanceof $lmhna.RuleTransition) {
                    if (intermediate != null && !collectPredicates) {
                        intermediate.add(c, contextCache);
                        continue;
                    }
                }
                let newDepth = depth;
                if (config.state instanceof $jWsYN.RuleStopState) {
                    // target fell off end of rule; mark resulting c as having dipped into outer context
                    // We can't get here if incoming config was rule stop and we had context
                    // track how far we dip into outer context.  Might
                    // come in handy and we avoid evaluating context dependent
                    // preds if this is > 0.
                    if (this.dfa != null && this.dfa.isPrecedenceDfa) {
                        let outermostPrecedenceReturn = t.outermostPrecedenceReturn;
                        if (outermostPrecedenceReturn === this.dfa.atnStartState.ruleIndex) c.isPrecedenceFilterSuppressed = true;
                    }
                    c.outerContextDepth = c.outerContextDepth + 1;
                    if (!closureBusy.add(c)) continue;
                    $fomfP(newDepth > $c0f91822940cc2ea$var$MIN_INTEGER_VALUE);
                    newDepth--;
                    if (ParserATNSimulator.debug) console.log("dips into outer ctx: " + c);
                } else if (t instanceof $lmhna.RuleTransition) {
                    if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$jaUCz.PredictionContext.isEmptyLocal(config.context))) {
                        $fomfP(c.context === config.context);
                        if (newDepth === 0) {
                            // the pop/push of a tail call would keep the depth
                            // constant, except we latch if it goes negative
                            newDepth--;
                            if (!this.tail_call_preserves_sll && $jaUCz.PredictionContext.isEmptyLocal(config.context)) // make sure the SLL config "dips into the outer context" or prediction may not fall back to LL on conflict
                            c.outerContextDepth = c.outerContextDepth + 1;
                        }
                    } else // latch when newDepth goes negative - once we step out of the entry context we can't return
                    if (newDepth >= 0) newDepth++;
                } else {
                    if (!t.isEpsilon && !closureBusy.add(c)) continue;
                }
                this.closureImpl(c, configs, intermediate, closureBusy, continueCollecting, hasMoreContexts, contextCache, newDepth, treatEofAsEpsilon);
            }
        }
    }
    getRuleName(index) {
        if (this._parser != null && index >= 0) return this._parser.ruleNames[index];
        return "<rule " + index + ">";
    }
    getEpsilonTarget(config, t, collectPredicates, inContext, contextCache, treatEofAsEpsilon) {
        switch(t.serializationType){
            case 3 /* RULE */ :
                return this.ruleTransition(config, t, contextCache);
            case 10 /* PRECEDENCE */ :
                return this.precedenceTransition(config, t, collectPredicates, inContext);
            case 4 /* PREDICATE */ :
                return this.predTransition(config, t, collectPredicates, inContext);
            case 6 /* ACTION */ :
                return this.actionTransition(config, t);
            case 1 /* EPSILON */ :
                return config.transform(t.target, false);
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                // EOF transitions act like epsilon transitions after the first EOF
                // transition is traversed
                if (treatEofAsEpsilon) {
                    if (t.matches($eKXi4.Token.EOF, 0, 1)) return config.transform(t.target, false);
                }
                return undefined;
            default:
                return undefined;
        }
    }
    actionTransition(config, t) {
        if (ParserATNSimulator.debug) console.log("ACTION edge " + t.ruleIndex + ":" + t.actionIndex);
        return config.transform(t.target, false);
    }
    precedenceTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.precedence + ">=_p" + ", ctx dependent=true");
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && inContext) {
            let newSemCtx = $3JS45.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    predTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.ruleIndex + ":" + pt.predIndex + ", ctx dependent=" + pt.isCtxDependent);
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && (!pt.isCtxDependent || pt.isCtxDependent && inContext)) {
            let newSemCtx = $3JS45.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    ruleTransition(config, t, contextCache) {
        if (ParserATNSimulator.debug) console.log("CALL rule " + this.getRuleName(t.target.ruleIndex) + ", ctx=" + config.context);
        let returnState = t.followState;
        let newContext;
        if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$jaUCz.PredictionContext.isEmptyLocal(config.context))) newContext = config.context;
        else if (contextCache != null) newContext = contextCache.getChild(config.context, returnState.stateNumber);
        else newContext = config.context.getChild(returnState.stateNumber);
        return config.transform(t.target, false, newContext);
    }
    isConflicted(configset, contextCache) {
        if (configset.uniqueAlt !== $eeOLb.ATN.INVALID_ALT_NUMBER || configset.size <= 1) return undefined;
        let configs = configset.toArray();
        configs.sort(ParserATNSimulator.STATE_ALT_SORT_COMPARATOR);
        let exact = !configset.dipsIntoOuterContext;
        let alts = new $8WIez.BitSet();
        let minAlt = configs[0].alt;
        alts.set(minAlt);
        /* Quick checks come first (single pass, no context joining):
         *  1. Make sure first config in the sorted list predicts the minimum
         *     represented alternative.
         *  2. Make sure every represented state has at least one configuration
         *     which predicts the minimum represented alternative.
         *  3. (exact only) make sure every represented state has at least one
         *     configuration which predicts each represented alternative.
         */ // quick check 1 & 2 => if we assume #1 holds and check #2 against the
        // minAlt from the first state, #2 will fail if the assumption was
        // incorrect
        let currentState = configs[0].state.nonStopStateNumber;
        for (let config of configs){
            let stateNumber = config.state.nonStopStateNumber;
            if (stateNumber !== currentState) {
                if (config.alt !== minAlt) return undefined;
                currentState = stateNumber;
            }
        }
        let representedAlts;
        if (exact) {
            currentState = configs[0].state.nonStopStateNumber;
            // get the represented alternatives of the first state
            representedAlts = new $8WIez.BitSet();
            let maxAlt = minAlt;
            for (let config of configs){
                if (config.state.nonStopStateNumber !== currentState) break;
                let alt = config.alt;
                representedAlts.set(alt);
                maxAlt = alt;
            }
            // quick check #3:
            currentState = configs[0].state.nonStopStateNumber;
            let currentAlt = minAlt;
            for (let config of configs){
                let stateNumber = config.state.nonStopStateNumber;
                let alt = config.alt;
                if (stateNumber !== currentState) {
                    if (currentAlt !== maxAlt) {
                        exact = false;
                        break;
                    }
                    currentState = stateNumber;
                    currentAlt = minAlt;
                } else if (alt !== currentAlt) {
                    if (alt !== representedAlts.nextSetBit(currentAlt + 1)) {
                        exact = false;
                        break;
                    }
                    currentAlt = alt;
                }
            }
        }
        currentState = configs[0].state.nonStopStateNumber;
        let firstIndexCurrentState = 0;
        let lastIndexCurrentStateMinAlt = 0;
        let joinedCheckContext = configs[0].context;
        for(let i = 1; i < configs.length; i++){
            let config = configs[i];
            if (config.alt !== minAlt) break;
            if (config.state.nonStopStateNumber !== currentState) break;
            lastIndexCurrentStateMinAlt = i;
            joinedCheckContext = contextCache.join(joinedCheckContext, configs[i].context);
        }
        for(let i = lastIndexCurrentStateMinAlt + 1; i < configs.length; i++){
            let config = configs[i];
            let state = config.state;
            alts.set(config.alt);
            if (state.nonStopStateNumber !== currentState) {
                currentState = state.nonStopStateNumber;
                firstIndexCurrentState = i;
                lastIndexCurrentStateMinAlt = i;
                joinedCheckContext = config.context;
                for(let j = firstIndexCurrentState + 1; j < configs.length; j++){
                    let config2 = configs[j];
                    if (config2.alt !== minAlt) break;
                    if (config2.state.nonStopStateNumber !== currentState) break;
                    lastIndexCurrentStateMinAlt = j;
                    joinedCheckContext = contextCache.join(joinedCheckContext, config2.context);
                }
                i = lastIndexCurrentStateMinAlt;
                continue;
            }
            let joinedCheckContext2 = config.context;
            let currentAlt = config.alt;
            let lastIndexCurrentStateCurrentAlt = i;
            for(let j = lastIndexCurrentStateCurrentAlt + 1; j < configs.length; j++){
                let config2 = configs[j];
                if (config2.alt !== currentAlt) break;
                if (config2.state.nonStopStateNumber !== currentState) break;
                lastIndexCurrentStateCurrentAlt = j;
                joinedCheckContext2 = contextCache.join(joinedCheckContext2, config2.context);
            }
            i = lastIndexCurrentStateCurrentAlt;
            let check = contextCache.join(joinedCheckContext, joinedCheckContext2);
            if (!joinedCheckContext.equals(check)) return undefined;
            // update exact if necessary
            exact = exact && joinedCheckContext.equals(joinedCheckContext2);
        }
        return new $bPdk6.ConflictInfo(alts, exact);
    }
    getConflictingAltsFromConfigSet(configs) {
        let conflictingAlts = configs.conflictingAlts;
        if (conflictingAlts == null && configs.uniqueAlt !== $eeOLb.ATN.INVALID_ALT_NUMBER) {
            conflictingAlts = new $8WIez.BitSet();
            conflictingAlts.set(configs.uniqueAlt);
        }
        return conflictingAlts;
    }
    getTokenName(t) {
        if (t === $eKXi4.Token.EOF) return "EOF";
        let vocabulary = this._parser != null ? this._parser.vocabulary : $hBnE1.VocabularyImpl.EMPTY_VOCABULARY;
        let displayName = vocabulary.getDisplayName(t);
        if (displayName === String(t)) return displayName;
        return displayName + "<" + t + ">";
    }
    getLookaheadName(input) {
        return this.getTokenName(input.LA(1));
    }
    dumpDeadEndConfigs(nvae) {
        console.log("dead end configs: ");
        let deadEndConfigs = nvae.deadEndConfigs;
        if (!deadEndConfigs) return;
        for (let c of deadEndConfigs){
            let trans = "no edges";
            if (c.state.numberOfOptimizedTransitions > 0) {
                let t = c.state.getOptimizedTransition(0);
                if (t instanceof $kXmw5.AtomTransition) trans = "Atom " + this.getTokenName(t._label);
                else if (t instanceof $5EcBU.SetTransition) {
                    let not = t instanceof $gFTdY.NotSetTransition;
                    trans = (not ? "~" : "") + "Set " + t.set.toString();
                }
            }
            console.log(c.toString(this._parser, true) + ":" + trans);
        }
    }
    noViableAlt(input, outerContext, configs, startIndex) {
        return new $iAlWg.NoViableAltException(this._parser, input, input.get(startIndex), input.LT(1), configs, outerContext);
    }
    getUniqueAlt(configs) {
        let alt = $eeOLb.ATN.INVALID_ALT_NUMBER;
        for (let c of configs){
            if (alt === $eeOLb.ATN.INVALID_ALT_NUMBER) alt = c.alt; // found first alt
            else if (c.alt !== alt) return $eeOLb.ATN.INVALID_ALT_NUMBER;
        }
        return alt;
    }
    configWithAltAtStopState(configs, alt) {
        for (let c of configs)if (c.alt === alt) {
            if (c.state instanceof $jWsYN.RuleStopState) return true;
        }
        return false;
    }
    addDFAEdge(dfa, fromState, t, contextTransitions, toConfigs, contextCache) {
        $fomfP(contextTransitions == null || contextTransitions.isEmpty || dfa.isContextSensitive);
        let from = fromState;
        let to = this.addDFAState(dfa, toConfigs, contextCache);
        if (contextTransitions != null) for (let context of contextTransitions.toArray()){
            if (context === $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) {
                if (from.configs.isOutermostConfigSet) continue;
            }
            from.setContextSensitive(this.atn);
            from.setContextSymbol(t);
            let next = from.getContextTarget(context);
            if (next != null) {
                from = next;
                continue;
            }
            next = this.addDFAContextState(dfa, from.configs, context, contextCache);
            $fomfP(context !== $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY || next.configs.isOutermostConfigSet);
            from.setContextTarget(context, next);
            from = next;
        }
        if (ParserATNSimulator.debug) console.log("EDGE " + from + " -> " + to + " upon " + this.getTokenName(t));
        this.setDFAEdge(from, t, to);
        if (ParserATNSimulator.debug) console.log("DFA=\n" + dfa.toString(this._parser != null ? this._parser.vocabulary : $hBnE1.VocabularyImpl.EMPTY_VOCABULARY, this._parser != null ? this._parser.ruleNames : undefined));
        return to;
    }
    setDFAEdge(p, t, q) {
        if (p != null) p.setTarget(t, q);
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAContextState(dfa, configs, returnContext, contextCache) {
        if (returnContext !== $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) {
            let contextConfigs = new $2SGHL.ATNConfigSet();
            for (let config of configs)contextConfigs.add(config.appendContext(returnContext, contextCache));
            return this.addDFAState(dfa, contextConfigs, contextCache);
        } else {
            $fomfP(!configs.isOutermostConfigSet, "Shouldn't be adding a duplicate edge.");
            configs = configs.clone(true);
            configs.isOutermostConfigSet = true;
            return this.addDFAState(dfa, configs, contextCache);
        }
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAState(dfa, configs, contextCache) {
        let enableDfa = this.enable_global_context_dfa || !configs.isOutermostConfigSet;
        if (enableDfa) {
            if (!configs.isReadOnly) configs.optimizeConfigs(this);
            let proposed = this.createDFAState(dfa, configs);
            let existing = dfa.states.get(proposed);
            if (existing != null) return existing;
        }
        if (!configs.isReadOnly) {
            if (configs.conflictInfo == null) configs.conflictInfo = this.isConflicted(configs, contextCache);
        }
        let newState = this.createDFAState(dfa, configs.clone(true));
        // getDecisionState won't return undefined when we request a known valid decision
        let decisionState = this.atn.getDecisionState(dfa.decision);
        let predictedAlt = this.getUniqueAlt(configs);
        if (predictedAlt !== $eeOLb.ATN.INVALID_ALT_NUMBER) newState.acceptStateInfo = new $hu8W9.AcceptStateInfo(predictedAlt);
        else if (configs.conflictingAlts != null) {
            let conflictingAlts = configs.conflictingAlts;
            if (conflictingAlts) newState.acceptStateInfo = new $hu8W9.AcceptStateInfo(conflictingAlts.nextSetBit(0));
        }
        if (newState.isAcceptState && configs.hasSemanticContext) this.predicateDFAState(newState, configs, decisionState.numberOfTransitions);
        if (!enableDfa) return newState;
        let added = dfa.addState(newState);
        if (ParserATNSimulator.debug && added === newState) console.log("adding new DFA state: " + newState);
        return added;
    }
    createDFAState(dfa, configs) {
        return new $6P9ap.DFAState(configs);
    }
    reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $l8y5T.Interval.of(startIndex, stopIndex);
            console.log("reportAttemptingFullContext decision=" + dfa.decision + ":" + conflictState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(this._parser, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        }
    }
    reportContextSensitivity(dfa, prediction, acceptState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $l8y5T.Interval.of(startIndex, stopIndex);
            console.log("reportContextSensitivity decision=" + dfa.decision + ":" + acceptState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(this._parser, dfa, startIndex, stopIndex, prediction, acceptState);
        }
    }
    /** If context sensitive parsing, we know it's ambiguity not conflict */ reportAmbiguity(dfa, D, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $l8y5T.Interval.of(startIndex, stopIndex);
            console.log("reportAmbiguity " + ambigAlts + ":" + configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAmbiguity) listener.reportAmbiguity(this._parser, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        }
    }
    getReturnState(context) {
        if (context.isEmpty) return $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY;
        let state = this.atn.states[context.invokingState];
        let transition = state.transition(0);
        return transition.followState.stateNumber;
    }
    skipTailCalls(context) {
        if (!this.optimize_tail_calls) return context;
        while(!context.isEmpty){
            let state = this.atn.states[context.invokingState];
            $fomfP(state.numberOfTransitions === 1 && state.transition(0).serializationType === 3 /* RULE */ );
            let transition = state.transition(0);
            if (!transition.tailCall) break;
            // This method requires that the root ancestor of the ParserRuleContext be empty. If we make it to this
            // line, we know the current node is not empty, which means it does have a parent.
            context = context.parent;
        }
        return context;
    }
    /**
     * @since 4.3
     */ get parser() {
        return this._parser;
    }
};
$c0f91822940cc2ea$var$ParserATNSimulator.debug = false;
$c0f91822940cc2ea$var$ParserATNSimulator.dfa_debug = false;
$c0f91822940cc2ea$var$ParserATNSimulator.retry_debug = false;
$c0f91822940cc2ea$var$ParserATNSimulator.STATE_ALT_SORT_COMPARATOR = (o1, o2)=>{
    let diff = o1.state.nonStopStateNumber - o2.state.nonStopStateNumber;
    if (diff !== 0) return diff;
    diff = o1.alt - o2.alt;
    if (diff !== 0) return diff;
    return 0;
};
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "predictionMode", void 0);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getPredictionMode", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "setPredictionMode", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.Override
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "reset", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "adaptivePredict", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getStartState", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(3, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "execDFA", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(3, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "execATN", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "handleNoViableAlt", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getExistingTargetState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "computeTargetState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "removeAllConfigsNotInRuleStopState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "computeStartState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "applyPrecedenceFilter", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getReachableTarget", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getPredsForAmbigAlts", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "evalSemanticContext", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "evalSemanticContextImpl", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(4, $aN41m.Nullable)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "closure", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.Nullable),
    $c0f91822940cc2ea$var$__param(3, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(6, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "closureImpl", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getRuleName", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getEpsilonTarget", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "actionTransition", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.Nullable,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "precedenceTransition", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.Nullable,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "predTransition", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.Nullable)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "ruleTransition", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "isConflicted", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getTokenName", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "dumpDeadEndConfigs", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "noViableAlt", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getUniqueAlt", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "configWithAltAtStopState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(4, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "addDFAEdge", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.Nullable),
    $c0f91822940cc2ea$var$__param(2, $aN41m.Nullable)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "setDFAEdge", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "addDFAContextState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "addDFAState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "createDFAState", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "reportAttemptingFullContext", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "reportContextSensitivity", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(5, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(6, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "reportAmbiguity", null);
$c0f91822940cc2ea$var$ParserATNSimulator = $c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator);
module.exports.ParserATNSimulator = $c0f91822940cc2ea$var$ParserATNSimulator;

});
parcelRegister("bPdk6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $89becade1f0ea245$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConflictInfo = void 0;

var $aN41m = parcelRequire("aN41m");

var $62Uvn = parcelRequire("62Uvn");
/**
 * This class stores information about a configuration conflict.
 *
 * @author Sam Harwell
 */ class $89becade1f0ea245$var$ConflictInfo {
    constructor(conflictedAlts, exact){
        this._conflictedAlts = conflictedAlts;
        this.exact = exact;
    }
    /**
     * Gets the set of conflicting alternatives for the configuration set.
     */ get conflictedAlts() {
        return this._conflictedAlts;
    }
    /**
     * Gets whether or not the configuration conflict is an exact conflict.
     * An exact conflict occurs when the prediction algorithm determines that
     * the represented alternatives for a particular configuration set cannot be
     * further reduced by consuming additional input. After reaching an exact
     * conflict during an SLL prediction, only switch to full-context prediction
     * could reduce the set of viable alternatives. In LL prediction, an exact
     * conflict indicates a true ambiguity in the input.
     *
     * For the {@link PredictionMode#LL_EXACT_AMBIG_DETECTION} prediction mode,
     * accept states are conflicting but not exact are treated as non-accept
     * states.
     */ get isExact() {
        return this.exact;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $89becade1f0ea245$var$ConflictInfo)) return false;
        return this.isExact === obj.isExact && $62Uvn.equals(this.conflictedAlts, obj.conflictedAlts);
    }
    hashCode() {
        return this.conflictedAlts.hashCode();
    }
}
$89becade1f0ea245$var$__decorate([
    $aN41m.Override
], $89becade1f0ea245$var$ConflictInfo.prototype, "equals", null);
$89becade1f0ea245$var$__decorate([
    $aN41m.Override
], $89becade1f0ea245$var$ConflictInfo.prototype, "hashCode", null);
module.exports.ConflictInfo = $89becade1f0ea245$var$ConflictInfo;

});

parcelRegister("2pDMz", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1c1cc68451022b8b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserRuleContext = void 0;

var $co9Xk = parcelRequire("co9Xk");

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");

var $1xO0Q = parcelRequire("1xO0Q");

var $2IN61 = parcelRequire("2IN61");
/** A rule invocation record for parsing.
 *
 *  Contains all of the information about the current rule not stored in the
 *  RuleContext. It handles parse tree children list, Any ATN state
 *  tracing, and the default values available for rule invocations:
 *  start, stop, rule index, current alt number.
 *
 *  Subclasses made for each rule and grammar track the parameters,
 *  return values, locals, and labels specific to that rule. These
 *  are the objects that are returned from rules.
 *
 *  Note text is not an actual field of a rule return value; it is computed
 *  from start and stop using the input stream's toString() method.  I
 *  could add a ctor to this so that we can pass in and store the input
 *  stream, but I'm not sure we want to do that.  It would seem to be undefined
 *  to get the .text property anyway if the rule matches tokens from multiple
 *  input streams.
 *
 *  I do not use getters for fields of objects that are used simply to
 *  group values such as this aggregate.  The getters/setters are there to
 *  satisfy the superclass interface.
 */ class $1c1cc68451022b8b$var$ParserRuleContext extends $1xO0Q.RuleContext {
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber == null) super();
        else super(parent, invokingStateNumber);
    }
    static emptyContext() {
        return $1c1cc68451022b8b$var$ParserRuleContext.EMPTY;
    }
    /**
     * COPY a ctx (I'm deliberately not using copy constructor) to avoid
     * confusion with creating node with parent. Does not copy children
     * (except error leaves).
     *
     * This is used in the generated parser code to flip a generic XContext
     * node for rule X to a YContext for alt label Y. In that sense, it is not
     * really a generic copy function.
     *
     * If we do an error sync() at start of a rule, we might add error nodes
     * to the generic XContext so this function must copy those nodes to the
     * YContext as well else they are lost!
     */ copyFrom(ctx) {
        this._parent = ctx._parent;
        this.invokingState = ctx.invokingState;
        this._start = ctx._start;
        this._stop = ctx._stop;
        // copy any error nodes to alt label node
        if (ctx.children) {
            this.children = [];
            // reset parent pointer for any error nodes
            for (let child of ctx.children)if (child instanceof $co9Xk.ErrorNode) this.addChild(child);
        }
    }
    // Double dispatch methods for listeners
    enterRule(listener) {
    // intentionally empty
    }
    exitRule(listener) {
    // intentionally empty
    }
    /** Add a parse tree node to this as a child.  Works for
     *  internal and leaf nodes. Does not set parent link;
     *  other add methods must do that. Other addChild methods
     *  call this.
     *
     *  We cannot set the parent pointer of the incoming node
     *  because the existing interfaces do not have a setParent()
     *  method and I don't want to break backward compatibility for this.
     *
     *  @since 4.7
     */ addAnyChild(t) {
        if (!this.children) this.children = [
            t
        ];
        else this.children.push(t);
        return t;
    }
    addChild(t) {
        let result;
        if (t instanceof $2IN61.TerminalNode) {
            t.setParent(this);
            this.addAnyChild(t);
            return;
        } else if (t instanceof $1xO0Q.RuleContext) {
            // Does not set parent link
            this.addAnyChild(t);
            return;
        } else {
            // Deprecated code path
            t = new $2IN61.TerminalNode(t);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    addErrorNode(node) {
        if (node instanceof $co9Xk.ErrorNode) {
            const errorNode = node;
            errorNode.setParent(this);
            return this.addAnyChild(errorNode);
        } else {
            // deprecated path
            const badToken = node;
            let t = new $co9Xk.ErrorNode(badToken);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    //	public void trace(int s) {
    //		if ( states==null ) states = new ArrayList<Integer>();
    //		states.add(s);
    //	}
    /** Used by enterOuterAlt to toss out a RuleContext previously added as
     *  we entered a rule. If we have # label, we will need to remove
     *  generic ruleContext object.
     */ removeLastChild() {
        if (this.children) this.children.pop();
    }
    get parent() {
        let parent = super.parent;
        if (parent === undefined || parent instanceof $1c1cc68451022b8b$var$ParserRuleContext) return parent;
        throw new TypeError("Invalid parent type for ParserRuleContext");
    }
    // Note: in TypeScript, order or arguments reversed
    getChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) throw new RangeError("index parameter must be between >= 0 and <= number of children.");
        if (ctxType == null) return this.children[i];
        let result = this.tryGetChild(i, ctxType);
        if (result === undefined) throw new Error("The specified node does not exist");
        return result;
    }
    tryGetChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what node with ctxType have we found?
        for (let o of this.children)if (o instanceof ctxType) {
            j++;
            if (j === i) return o;
        }
        return undefined;
    }
    getToken(ttype, i) {
        let result = this.tryGetToken(ttype, i);
        if (result === undefined) throw new Error("The specified token does not exist");
        return result;
    }
    tryGetToken(ttype, i) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what token with ttype have we found?
        for (let o of this.children)if (o instanceof $2IN61.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) {
                j++;
                if (j === i) return o;
            }
        }
        return undefined;
    }
    getTokens(ttype) {
        let tokens = [];
        if (!this.children) return tokens;
        for (let o of this.children)if (o instanceof $2IN61.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) tokens.push(o);
        }
        return tokens;
    }
    get ruleContext() {
        return this;
    }
    // NOTE: argument order change from Java version
    getRuleContext(i, ctxType) {
        return this.getChild(i, ctxType);
    }
    tryGetRuleContext(i, ctxType) {
        return this.tryGetChild(i, ctxType);
    }
    getRuleContexts(ctxType) {
        let contexts = [];
        if (!this.children) return contexts;
        for (let o of this.children)if (o instanceof ctxType) contexts.push(o);
        return contexts;
    }
    get childCount() {
        return this.children ? this.children.length : 0;
    }
    get sourceInterval() {
        if (!this._start) return $l8y5T.Interval.INVALID;
        if (!this._stop || this._stop.tokenIndex < this._start.tokenIndex) return $l8y5T.Interval.of(this._start.tokenIndex, this._start.tokenIndex - 1); // empty
        return $l8y5T.Interval.of(this._start.tokenIndex, this._stop.tokenIndex);
    }
    /**
     * Get the initial token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may exceed stop.
     */ get start() {
        return this._start;
    }
    /**
     * Get the final token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may precede start.
     */ get stop() {
        return this._stop;
    }
    /** Used for rule context info debugging during parse-time, not so much for ATN debugging */ toInfoString(recognizer) {
        let rules = recognizer.getRuleInvocationStack(this).reverse();
        return "ParserRuleContext" + rules + "{" + "start=" + this._start + ", stop=" + this._stop + "}";
    }
}
$1c1cc68451022b8b$var$ParserRuleContext.EMPTY = new $1c1cc68451022b8b$var$ParserRuleContext();
$1c1cc68451022b8b$var$__decorate([
    $aN41m.Override
], $1c1cc68451022b8b$var$ParserRuleContext.prototype, "parent", null);
$1c1cc68451022b8b$var$__decorate([
    $aN41m.Override
], $1c1cc68451022b8b$var$ParserRuleContext.prototype, "childCount", null);
$1c1cc68451022b8b$var$__decorate([
    $aN41m.Override
], $1c1cc68451022b8b$var$ParserRuleContext.prototype, "sourceInterval", null);
module.exports.ParserRuleContext = $1c1cc68451022b8b$var$ParserRuleContext;

});
parcelRegister("co9Xk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $904f72f292ced1ea$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorNode = void 0;

var $aN41m = parcelRequire("aN41m");

var $2IN61 = parcelRequire("2IN61");
/** Represents a token that was consumed during resynchronization
 *  rather than during a valid match operation. For example,
 *  we will create this kind of a node during single token insertion
 *  and deletion as well as during "consume until error recovery set"
 *  upon no viable alternative exceptions.
 */ class $904f72f292ced1ea$var$ErrorNode extends $2IN61.TerminalNode {
    constructor(token){
        super(token);
    }
    accept(visitor) {
        return visitor.visitErrorNode(this);
    }
}
$904f72f292ced1ea$var$__decorate([
    $aN41m.Override
], $904f72f292ced1ea$var$ErrorNode.prototype, "accept", null);
module.exports.ErrorNode = $904f72f292ced1ea$var$ErrorNode;

});
parcelRegister("2IN61", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1fb5c64751fbd583$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TerminalNode = void 0;

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
class $1fb5c64751fbd583$var$TerminalNode {
    constructor(symbol){
        this._symbol = symbol;
    }
    getChild(i) {
        throw new RangeError("Terminal Node has no children.");
    }
    get symbol() {
        return this._symbol;
    }
    get parent() {
        return this._parent;
    }
    setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this._symbol;
    }
    get sourceInterval() {
        let tokenIndex = this._symbol.tokenIndex;
        return new $l8y5T.Interval(tokenIndex, tokenIndex);
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitTerminal(this);
    }
    get text() {
        return this._symbol.text || "";
    }
    toStringTree(parser) {
        return this.toString();
    }
    toString() {
        if (this._symbol.type === $eKXi4.Token.EOF) return "<EOF>";
        return this._symbol.text || "";
    }
}
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "getChild", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "parent", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "setParent", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "payload", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "sourceInterval", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "childCount", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "accept", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "text", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "toStringTree", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "toString", null);
module.exports.TerminalNode = $1fb5c64751fbd583$var$TerminalNode;

});


parcelRegister("1xO0Q", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $11ffaafc1554cb2d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContext = void 0;

var $eeOLb = parcelRequire("eeOLb");

var $dwftT = parcelRequire("dwftT");

var $UzGvw = parcelRequire("UzGvw");

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");

var $iEJpM = parcelRequire("iEJpM");

var $2pDMz = parcelRequire("2pDMz");
/** A rule context is a record of a single rule invocation.
 *
 *  We form a stack of these context objects using the parent
 *  pointer. A parent pointer of `undefined` indicates that the current
 *  context is the bottom of the stack. The ParserRuleContext subclass
 *  as a children list so that we can turn this data structure into a
 *  tree.
 *
 *  The root node always has a `undefined` pointer and invokingState of -1.
 *
 *  Upon entry to parsing, the first invoked rule function creates a
 *  context object (a subclass specialized for that rule such as
 *  SContext) and makes it the root of a parse tree, recorded by field
 *  Parser._ctx.
 *
 *  public final SContext s() throws RecognitionException {
 *      SContext _localctx = new SContext(_ctx, state); <-- create new node
 *      enterRule(_localctx, 0, RULE_s);                     <-- push it
 *      ...
 *      exitRule();                                          <-- pop back to _localctx
 *      return _localctx;
 *  }
 *
 *  A subsequent rule invocation of r from the start rule s pushes a
 *  new context object for r whose parent points at s and use invoking
 *  state is the state with r emanating as edge label.
 *
 *  The invokingState fields from a context object to the root
 *  together form a stack of rule indication states where the root
 *  (bottom of the stack) has a -1 sentinel value. If we invoke start
 *  symbol s then call r1, which calls r2, the  would look like
 *  this:
 *
 *     SContext[-1]   <- root node (bottom of the stack)
 *     R1Context[p]   <- p in rule s called r1
 *     R2Context[q]   <- q in rule r1 called r2
 *
 *  So the top of the stack, _ctx, represents a call to the current
 *  rule and it holds the return address from another rule that invoke
 *  to this rule. To invoke a rule, we must always have a current context.
 *
 *  The parent contexts are useful for computing lookahead sets and
 *  getting error information.
 *
 *  These objects are used during parsing and prediction.
 *  For the special case of parsers, we use the subclass
 *  ParserRuleContext.
 *
 *  @see ParserRuleContext
 */ class $11ffaafc1554cb2d$var$RuleContext extends $UzGvw.RuleNode {
    constructor(parent, invokingState){
        super();
        this._parent = parent;
        this.invokingState = invokingState != null ? invokingState : -1;
    }
    static getChildContext(parent, invokingState) {
        return new $11ffaafc1554cb2d$var$RuleContext(parent, invokingState);
    }
    depth() {
        let n = 0;
        let p = this;
        while(p){
            p = p._parent;
            n++;
        }
        return n;
    }
    /** A context is empty if there is no invoking state; meaning nobody called
     *  current context.
     */ get isEmpty() {
        return this.invokingState === -1;
    }
    // satisfy the ParseTree / SyntaxTree interface
    get sourceInterval() {
        return $l8y5T.Interval.INVALID;
    }
    get ruleContext() {
        return this;
    }
    get parent() {
        return this._parent;
    }
    /** @since 4.7. {@see ParseTree#setParent} comment */ setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this;
    }
    /** Return the combined text of all child nodes. This method only considers
     *  tokens which have been added to the parse tree.
     *
     *  Since tokens on hidden channels (e.g. whitespace or comments) are not
     *  added to the parse trees, they will not appear in the output of this
     *  method.
     */ get text() {
        if (this.childCount === 0) return "";
        let builder = "";
        for(let i = 0; i < this.childCount; i++)builder += this.getChild(i).text;
        return builder.toString();
    }
    get ruleIndex() {
        return -1;
    }
    /** For rule associated with this parse tree internal node, return
     *  the outer alternative number used to match the input. Default
     *  implementation does not compute nor store this alt num. Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *  to set it.
     *
     *  @since 4.5.3
     */ get altNumber() {
        return $eeOLb.ATN.INVALID_ALT_NUMBER;
    }
    /** Set the outer alternative number for this context node. Default
     *  implementation does nothing to avoid backing field overhead for
     *  trees that don't need it.  Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *
     *  @since 4.5.3
     */ set altNumber(altNumber) {
    // intentionally ignored by the base implementation
    }
    getChild(i) {
        throw new RangeError("i must be greater than or equal to 0 and less than childCount");
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitChildren(this);
    }
    toStringTree(recog) {
        return $iEJpM.Trees.toStringTree(this, recog);
    }
    toString(arg1, stop) {
        const ruleNames = arg1 instanceof $dwftT.Recognizer ? arg1.ruleNames : arg1;
        stop = stop || $2pDMz.ParserRuleContext.emptyContext();
        let buf = "";
        let p = this;
        buf += "[";
        while(p && p !== stop){
            if (!ruleNames) {
                if (!p.isEmpty) buf += p.invokingState;
            } else {
                let ruleIndex = p.ruleIndex;
                let ruleName = ruleIndex >= 0 && ruleIndex < ruleNames.length ? ruleNames[ruleIndex] : ruleIndex.toString();
                buf += ruleName;
            }
            if (p._parent && (ruleNames || !p._parent.isEmpty)) buf += " ";
            p = p._parent;
        }
        buf += "]";
        return buf.toString();
    }
}
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "sourceInterval", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "ruleContext", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "parent", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "setParent", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "payload", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "text", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "getChild", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "childCount", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "accept", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "toStringTree", null);
module.exports.RuleContext = $11ffaafc1554cb2d$var$RuleContext;

});
parcelRegister("UzGvw", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleNode = void 0;
class $0aa0e94bd9481018$var$RuleNode {
}
module.exports.RuleNode = $0aa0e94bd9481018$var$RuleNode;

});

parcelRegister("iEJpM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d94f30dcc5121681$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d94f30dcc5121681$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Trees = void 0;

var $eeOLb = parcelRequire("eeOLb");

var $exlin = parcelRequire("exlin");

var $co9Xk = parcelRequire("co9Xk");

var $aN41m = parcelRequire("aN41m");

var $c9Sjf = parcelRequire("c9Sjf");

var $2pDMz = parcelRequire("2pDMz");

var $UzGvw = parcelRequire("UzGvw");

var $2IN61 = parcelRequire("2IN61");

var $eKXi4 = parcelRequire("eKXi4");

var $62Uvn = parcelRequire("62Uvn");
/** A set of utility routines useful for all kinds of ANTLR trees. */ class $d94f30dcc5121681$var$Trees {
    static toStringTree(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $c9Sjf.Parser) ruleNames = arg2.ruleNames;
        else ruleNames = arg2;
        let s = $62Uvn.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        if (t.childCount === 0) return s;
        let buf = "";
        buf += "(";
        s = $62Uvn.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        buf += s;
        buf += " ";
        for(let i = 0; i < t.childCount; i++){
            if (i > 0) buf += " ";
            buf += this.toStringTree(t.getChild(i), ruleNames);
        }
        buf += ")";
        return buf;
    }
    static getNodeText(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $c9Sjf.Parser) ruleNames = arg2.ruleNames;
        else if (arg2) ruleNames = arg2;
        else {
            // no recog or rule names
            let payload = t.payload;
            if (typeof payload.text === "string") return payload.text;
            return t.payload.toString();
        }
        if (t instanceof $UzGvw.RuleNode) {
            let ruleContext = t.ruleContext;
            let ruleIndex = ruleContext.ruleIndex;
            let ruleName = ruleNames[ruleIndex];
            let altNumber = ruleContext.altNumber;
            if (altNumber !== $eeOLb.ATN.INVALID_ALT_NUMBER) return ruleName + ":" + altNumber;
            return ruleName;
        } else if (t instanceof $co9Xk.ErrorNode) return t.toString();
        else if (t instanceof $2IN61.TerminalNode) {
            let symbol = t.symbol;
            return symbol.text || "";
        }
        throw new TypeError("Unexpected node type");
    }
    static getChildren(t) {
        let kids = [];
        for(let i = 0; i < t.childCount; i++)kids.push(t.getChild(i));
        return kids;
    }
    static getAncestors(t) {
        let ancestors = [];
        let p = t.parent;
        while(p){
            ancestors.unshift(p); // insert at start
            p = p.parent;
        }
        return ancestors;
    }
    /** Return true if t is u's parent or a node on path to root from u.
     *  Use === not equals().
     *
     *  @since 4.5.1
     */ static isAncestorOf(t, u) {
        if (!t || !u || !t.parent) return false;
        let p = u.parent;
        while(p){
            if (t === p) return true;
            p = p.parent;
        }
        return false;
    }
    static findAllTokenNodes(t, ttype) {
        return $d94f30dcc5121681$var$Trees.findAllNodes(t, ttype, true);
    }
    static findAllRuleNodes(t, ruleIndex) {
        return $d94f30dcc5121681$var$Trees.findAllNodes(t, ruleIndex, false);
    }
    static findAllNodes(t, index, findTokens) {
        let nodes = [];
        $d94f30dcc5121681$var$Trees._findAllNodes(t, index, findTokens, nodes);
        return nodes;
    }
    static _findAllNodes(t, index, findTokens, nodes) {
        // check this node (the root) first
        if (findTokens && t instanceof $2IN61.TerminalNode) {
            if (t.symbol.type === index) nodes.push(t);
        } else if (!findTokens && t instanceof $2pDMz.ParserRuleContext) {
            if (t.ruleIndex === index) nodes.push(t);
        }
        // check children
        for(let i = 0; i < t.childCount; i++)$d94f30dcc5121681$var$Trees._findAllNodes(t.getChild(i), index, findTokens, nodes);
    }
    /** Get all descendents; includes t itself.
     *
     * @since 4.5.1
     */ static getDescendants(t) {
        let nodes = [];
        function recurse(e) {
            nodes.push(e);
            const n = e.childCount;
            for(let i = 0; i < n; i++)recurse(e.getChild(i));
        }
        recurse(t);
        return nodes;
    }
    /** Find smallest subtree of t enclosing range startTokenIndex..stopTokenIndex
     *  inclusively using postorder traversal.  Recursive depth-first-search.
     *
     *  @since 4.5
     */ static getRootOfSubtreeEnclosingRegion(t, startTokenIndex, stopTokenIndex) {
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let child = t.getChild(i);
            let r = $d94f30dcc5121681$var$Trees.getRootOfSubtreeEnclosingRegion(child, startTokenIndex, stopTokenIndex);
            if (r) return r;
        }
        if (t instanceof $2pDMz.ParserRuleContext) {
            let stopToken = t.stop;
            if (startTokenIndex >= t.start.tokenIndex && // is range fully contained in t?
            (stopToken == null || stopTokenIndex <= stopToken.tokenIndex)) // note: r.stop==null likely implies that we bailed out of parser and there's nothing to the right
            return t;
        }
        return undefined;
    }
    /** Replace any subtree siblings of root that are completely to left
     *  or right of lookahead range with a CommonToken(Token.INVALID_TYPE,"...")
     *  node. The source interval for t is not altered to suit smaller range!
     *
     *  WARNING: destructive to t.
     *
     *  @since 4.5.1
     */ static stripChildrenOutOfRange(t, root, startIndex, stopIndex) {
        if (!t) return;
        let count = t.childCount;
        for(let i = 0; i < count; i++){
            let child = t.getChild(i);
            let range = child.sourceInterval;
            if (child instanceof $2pDMz.ParserRuleContext && (range.b < startIndex || range.a > stopIndex)) {
                if ($d94f30dcc5121681$var$Trees.isAncestorOf(child, root)) {
                    let abbrev = new $exlin.CommonToken($eKXi4.Token.INVALID_TYPE, "...");
                    t.children[i] = new $2IN61.TerminalNode(abbrev); // HACK access to private
                }
            }
        }
    }
    static findNodeSuchThat(t, pred) {
        // No type check needed as long as users only use one of the available overloads
        if (pred(t)) return t;
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let u = $d94f30dcc5121681$var$Trees.findNodeSuchThat(t.getChild(i), pred);
            if (u !== undefined) return u;
        }
        return undefined;
    }
}
$d94f30dcc5121681$var$__decorate([
    $d94f30dcc5121681$var$__param(0, $aN41m.NotNull)
], $d94f30dcc5121681$var$Trees, "toStringTree", null);
$d94f30dcc5121681$var$__decorate([
    $aN41m.NotNull,
    $d94f30dcc5121681$var$__param(0, $aN41m.NotNull)
], $d94f30dcc5121681$var$Trees, "getAncestors", null);
$d94f30dcc5121681$var$__decorate([
    $d94f30dcc5121681$var$__param(0, $aN41m.NotNull)
], $d94f30dcc5121681$var$Trees, "getRootOfSubtreeEnclosingRegion", null);
module.exports.Trees = $d94f30dcc5121681$var$Trees;

});



parcelRegister("hwoBE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cc18831aaf00aa66$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionMode = void 0;

var $jRlcM = parcelRequire("jRlcM");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");

var $jWsYN = parcelRequire("jWsYN");
/**
 * This enumeration defines the prediction modes available in ANTLR 4 along with
 * utility methods for analyzing configuration sets for conflicts and/or
 * ambiguities.
 */ var $cc18831aaf00aa66$var$PredictionMode;
(function(PredictionMode) {
    /**
     * The SLL(*) prediction mode. This prediction mode ignores the current
     * parser context when making predictions. This is the fastest prediction
     * mode, and provides correct results for many grammars. This prediction
     * mode is more powerful than the prediction mode provided by ANTLR 3, but
     * may result in syntax errors for grammar and input combinations which are
     * not SLL.
     *
     * When using this prediction mode, the parser will either return a correct
     * parse tree (i.e. the same parse tree that would be returned with the
     * {@link #LL} prediction mode), or it will report a syntax error. If a
     * syntax error is encountered when using the {@link #SLL} prediction mode,
     * it may be due to either an actual syntax error in the input or indicate
     * that the particular combination of grammar and input requires the more
     * powerful {@link #LL} prediction abilities to complete successfully.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["SLL"] = 0] = "SLL";
    /**
     * The LL(*) prediction mode. This prediction mode allows the current parser
     * context to be used for resolving SLL conflicts that occur during
     * prediction. This is the fastest prediction mode that guarantees correct
     * parse results for all combinations of grammars with syntactically correct
     * inputs.
     *
     * When using this prediction mode, the parser will make correct decisions
     * for all syntactically-correct grammar and input combinations. However, in
     * cases where the grammar is truly ambiguous this prediction mode might not
     * report a precise answer for *exactly which* alternatives are
     * ambiguous.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL"] = 1] = "LL";
    /**
     * The LL(*) prediction mode with exact ambiguity detection. In addition to
     * the correctness guarantees provided by the {@link #LL} prediction mode,
     * this prediction mode instructs the prediction algorithm to determine the
     * complete and exact set of ambiguous alternatives for every ambiguous
     * decision encountered while parsing.
     *
     * This prediction mode may be used for diagnosing ambiguities during
     * grammar development. Due to the performance overhead of calculating sets
     * of ambiguous alternatives, this prediction mode should be avoided when
     * the exact results are not necessary.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL_EXACT_AMBIG_DETECTION"] = 2] = "LL_EXACT_AMBIG_DETECTION";
})($cc18831aaf00aa66$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
(function(PredictionMode) {
    /** A Map that uses just the state and the stack context as the key. */ // NOTE: Base type used to be FlexibleHashMap<ATNConfig, BitSet>
    class AltAndContextMap extends $jRlcM.Array2DHashMap {
        constructor(){
            super(AltAndContextConfigEqualityComparator.INSTANCE);
        }
    }
    class AltAndContextConfigEqualityComparator {
        AltAndContextConfigEqualityComparator() {
        // intentionally empty
        }
        /**
         * The hash code is only a function of the {@link ATNState#stateNumber}
         * and {@link ATNConfig#context}.
         */ hashCode(o) {
            let hashCode = $amQx9.MurmurHash.initialize(7);
            hashCode = $amQx9.MurmurHash.update(hashCode, o.state.stateNumber);
            hashCode = $amQx9.MurmurHash.update(hashCode, o.context);
            hashCode = $amQx9.MurmurHash.finish(hashCode, 2);
            return hashCode;
        }
        equals(a, b) {
            if (a === b) return true;
            if (a == null || b == null) return false;
            return a.state.stateNumber === b.state.stateNumber && a.context.equals(b.context);
        }
    }
    AltAndContextConfigEqualityComparator.INSTANCE = new AltAndContextConfigEqualityComparator();
    $cc18831aaf00aa66$var$__decorate([
        $aN41m.Override
    ], AltAndContextConfigEqualityComparator.prototype, "hashCode", null);
    $cc18831aaf00aa66$var$__decorate([
        $aN41m.Override
    ], AltAndContextConfigEqualityComparator.prototype, "equals", null);
    /**
     * Checks if any configuration in `configs` is in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if any configuration in `configs` is in a
     * {@link RuleStopState}, otherwise `false`
     */ function hasConfigInRuleStopState(configs) {
        for (let c of configs){
            if (c.state instanceof $jWsYN.RuleStopState) return true;
        }
        return false;
    }
    PredictionMode.hasConfigInRuleStopState = hasConfigInRuleStopState;
    /**
     * Checks if all configurations in `configs` are in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if all configurations in `configs` are in a
     * {@link RuleStopState}, otherwise `false`
     */ function allConfigsInRuleStopStates(/*@NotNull*/ configs) {
        for (let config of configs){
            if (!(config.state instanceof $jWsYN.RuleStopState)) return false;
        }
        return true;
    }
    PredictionMode.allConfigsInRuleStopStates = allConfigsInRuleStopStates;
})($cc18831aaf00aa66$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));

});

parcelRegister("eDtKk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $aa7bc8301b4366a9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $aa7bc8301b4366a9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimulatorState = void 0;

var $aN41m = parcelRequire("aN41m");

var $2pDMz = parcelRequire("2pDMz");
/**
 *
 * @author Sam Harwell
 */ let $aa7bc8301b4366a9$var$SimulatorState = class SimulatorState {
    constructor(outerContext, s0, useContext, remainingOuterContext){
        this.outerContext = outerContext != null ? outerContext : $2pDMz.ParserRuleContext.emptyContext();
        this.s0 = s0;
        this.useContext = useContext;
        this.remainingOuterContext = remainingOuterContext;
    }
};
$aa7bc8301b4366a9$var$SimulatorState = $aa7bc8301b4366a9$var$__decorate([
    $aa7bc8301b4366a9$var$__param(1, $aN41m.NotNull)
], $aa7bc8301b4366a9$var$SimulatorState);
module.exports.SimulatorState = $aa7bc8301b4366a9$var$SimulatorState;

});


parcelRegister("pC9Ki", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $04cfeef02e935189$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusBlockStartState = void 0;

var $fZESB = parcelRequire("fZESB");

var $jizfq = parcelRequire("jizfq");

var $aN41m = parcelRequire("aN41m");
/** Start of `(A|B|...)+` loop. Technically a decision state, but
 *  we don't use for code generation; somebody might need it, so I'm defining
 *  it for completeness. In reality, the {@link PlusLoopbackState} node is the
 *  real decision-making note for `A+`.
 */ class $04cfeef02e935189$var$PlusBlockStartState extends $jizfq.BlockStartState {
    get stateType() {
        return $fZESB.ATNStateType.PLUS_BLOCK_START;
    }
}
$04cfeef02e935189$var$__decorate([
    $aN41m.Override
], $04cfeef02e935189$var$PlusBlockStartState.prototype, "stateType", null);
module.exports.PlusBlockStartState = $04cfeef02e935189$var$PlusBlockStartState;

});

parcelRegister("a84wo", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $75fe289bbbae0de7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusLoopbackState = void 0;

var $fZESB = parcelRequire("fZESB");

var $42ptv = parcelRequire("42ptv");

var $aN41m = parcelRequire("aN41m");
/** Decision state for `A+` and `(A|B)+`.  It has two transitions:
 *  one to the loop back to start of the block and one to exit.
 */ class $75fe289bbbae0de7$var$PlusLoopbackState extends $42ptv.DecisionState {
    get stateType() {
        return $fZESB.ATNStateType.PLUS_LOOP_BACK;
    }
}
$75fe289bbbae0de7$var$__decorate([
    $aN41m.Override
], $75fe289bbbae0de7$var$PlusLoopbackState.prototype, "stateType", null);
module.exports.PlusLoopbackState = $75fe289bbbae0de7$var$PlusLoopbackState;

});

parcelRegister("kIrC4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f14d5618acbd1a12$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f14d5618acbd1a12$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrecedencePredicateTransition = void 0;

var $kvmNv = parcelRequire("kvmNv");

var $aN41m = parcelRequire("aN41m");

var $3JS45 = parcelRequire("3JS45");
/**
 *
 * @author Sam Harwell
 */ let $f14d5618acbd1a12$var$PrecedencePredicateTransition = class PrecedencePredicateTransition extends $kvmNv.AbstractPredicateTransition {
    constructor(target, precedence){
        super(target);
        this.precedence = precedence;
    }
    get serializationType() {
        return 10 /* PRECEDENCE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $3JS45.SemanticContext.PrecedencePredicate(this.precedence);
    }
    toString() {
        return this.precedence + " >= _p";
    }
};
$f14d5618acbd1a12$var$__decorate([
    $aN41m.Override
], $f14d5618acbd1a12$var$PrecedencePredicateTransition.prototype, "serializationType", null);
$f14d5618acbd1a12$var$__decorate([
    $aN41m.Override
], $f14d5618acbd1a12$var$PrecedencePredicateTransition.prototype, "isEpsilon", null);
$f14d5618acbd1a12$var$__decorate([
    $aN41m.Override
], $f14d5618acbd1a12$var$PrecedencePredicateTransition.prototype, "matches", null);
$f14d5618acbd1a12$var$__decorate([
    $aN41m.Override
], $f14d5618acbd1a12$var$PrecedencePredicateTransition.prototype, "toString", null);
$f14d5618acbd1a12$var$PrecedencePredicateTransition = $f14d5618acbd1a12$var$__decorate([
    $f14d5618acbd1a12$var$__param(0, $aN41m.NotNull)
], $f14d5618acbd1a12$var$PrecedencePredicateTransition);
module.exports.PrecedencePredicateTransition = $f14d5618acbd1a12$var$PrecedencePredicateTransition;

});

parcelRegister("6WqDl", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $50dcd1b7595942de$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $50dcd1b7595942de$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RangeTransition = void 0;

var $6kdz0 = parcelRequire("6kdz0");

var $aN41m = parcelRequire("aN41m");

var $5NWCj = parcelRequire("5NWCj");
let $50dcd1b7595942de$var$RangeTransition = class RangeTransition extends $5NWCj.Transition {
    constructor(target, from, to){
        super(target);
        this.from = from;
        this.to = to;
    }
    get serializationType() {
        return 2 /* RANGE */ ;
    }
    get label() {
        return $6kdz0.IntervalSet.of(this.from, this.to);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= this.from && symbol <= this.to;
    }
    toString() {
        return "'" + String.fromCodePoint(this.from) + "'..'" + String.fromCodePoint(this.to) + "'";
    }
};
$50dcd1b7595942de$var$__decorate([
    $aN41m.Override
], $50dcd1b7595942de$var$RangeTransition.prototype, "serializationType", null);
$50dcd1b7595942de$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $50dcd1b7595942de$var$RangeTransition.prototype, "label", null);
$50dcd1b7595942de$var$__decorate([
    $aN41m.Override
], $50dcd1b7595942de$var$RangeTransition.prototype, "matches", null);
$50dcd1b7595942de$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $50dcd1b7595942de$var$RangeTransition.prototype, "toString", null);
$50dcd1b7595942de$var$RangeTransition = $50dcd1b7595942de$var$__decorate([
    $50dcd1b7595942de$var$__param(0, $aN41m.NotNull)
], $50dcd1b7595942de$var$RangeTransition);
module.exports.RangeTransition = $50dcd1b7595942de$var$RangeTransition;

});

parcelRegister("UvARH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0a9dbce885ceff1c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStartState = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $aN41m = parcelRequire("aN41m");
class $0a9dbce885ceff1c$var$RuleStartState extends $dv9vN.ATNState {
    constructor(){
        super(...arguments);
        this.isPrecedenceRule = false;
        this.leftFactored = false;
    }
    get stateType() {
        return $fZESB.ATNStateType.RULE_START;
    }
}
$0a9dbce885ceff1c$var$__decorate([
    $aN41m.Override
], $0a9dbce885ceff1c$var$RuleStartState.prototype, "stateType", null);
module.exports.RuleStartState = $0a9dbce885ceff1c$var$RuleStartState;

});

parcelRegister("ferBg", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b16d929992a0672d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarBlockStartState = void 0;

var $fZESB = parcelRequire("fZESB");

var $jizfq = parcelRequire("jizfq");

var $aN41m = parcelRequire("aN41m");
/** The block that begins a closure loop. */ class $b16d929992a0672d$var$StarBlockStartState extends $jizfq.BlockStartState {
    get stateType() {
        return $fZESB.ATNStateType.STAR_BLOCK_START;
    }
}
$b16d929992a0672d$var$__decorate([
    $aN41m.Override
], $b16d929992a0672d$var$StarBlockStartState.prototype, "stateType", null);
module.exports.StarBlockStartState = $b16d929992a0672d$var$StarBlockStartState;

});

parcelRegister("9kZdU", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6cc579002aad9995$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopbackState = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $aN41m = parcelRequire("aN41m");
class $6cc579002aad9995$var$StarLoopbackState extends $dv9vN.ATNState {
    get loopEntryState() {
        return this.transition(0).target;
    }
    get stateType() {
        return $fZESB.ATNStateType.STAR_LOOP_BACK;
    }
}
$6cc579002aad9995$var$__decorate([
    $aN41m.Override
], $6cc579002aad9995$var$StarLoopbackState.prototype, "stateType", null);
module.exports.StarLoopbackState = $6cc579002aad9995$var$StarLoopbackState;

});

parcelRegister("J9RdB", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $087bd98cf80f5dfc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokensStartState = void 0;

var $fZESB = parcelRequire("fZESB");

var $42ptv = parcelRequire("42ptv");

var $aN41m = parcelRequire("aN41m");
/** The Tokens rule start state linking to each lexer rule start state */ class $087bd98cf80f5dfc$var$TokensStartState extends $42ptv.DecisionState {
    get stateType() {
        return $fZESB.ATNStateType.TOKEN_START;
    }
}
$087bd98cf80f5dfc$var$__decorate([
    $aN41m.Override
], $087bd98cf80f5dfc$var$TokensStartState.prototype, "stateType", null);
module.exports.TokensStartState = $087bd98cf80f5dfc$var$TokensStartState;

});

parcelRegister("f0PQ3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UUID = void 0;

var $amQx9 = parcelRequire("amQx9");
class $02d20ca9e1d240ed$var$UUID {
    constructor(mostSigBits, moreSigBits, lessSigBits, leastSigBits){
        this.data = new Uint32Array(4);
        this.data[0] = mostSigBits;
        this.data[1] = moreSigBits;
        this.data[2] = lessSigBits;
        this.data[3] = leastSigBits;
    }
    static fromString(data) {
        if (!/^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(data)) throw new Error("Incorrectly formatted UUID");
        let segments = data.split("-");
        let mostSigBits = parseInt(segments[0], 16);
        let moreSigBits = (parseInt(segments[1], 16) << 16 >>> 0) + parseInt(segments[2], 16);
        let lessSigBits = (parseInt(segments[3], 16) << 16 >>> 0) + parseInt(segments[4].substr(0, 4), 16);
        let leastSigBits = parseInt(segments[4].substr(-8), 16);
        return new $02d20ca9e1d240ed$var$UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    hashCode() {
        return $amQx9.MurmurHash.hashCode([
            this.data[0],
            this.data[1],
            this.data[2],
            this.data[3]
        ]);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $02d20ca9e1d240ed$var$UUID)) return false;
        return this.data[0] === obj.data[0] && this.data[1] === obj.data[1] && this.data[2] === obj.data[2] && this.data[3] === obj.data[3];
    }
    toString() {
        return ("00000000" + this.data[0].toString(16)).substr(-8) + "-" + ("0000" + (this.data[1] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[1].toString(16)).substr(-4) + "-" + ("0000" + (this.data[2] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[2].toString(16)).substr(-4) + ("00000000" + this.data[3].toString(16)).substr(-8);
    }
}
module.exports.UUID = $02d20ca9e1d240ed$var$UUID;

});


parcelRegister("8EOCV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $64d95490c532b14b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $64d95490c532b14b$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseInfo = void 0;

var $aN41m = parcelRequire("aN41m");
/**
 * This class provides access to specific and aggregate statistics gathered
 * during profiling of a parser.
 *
 * @since 4.3
 */ let $64d95490c532b14b$var$ParseInfo = class ParseInfo {
    constructor(atnSimulator){
        this.atnSimulator = atnSimulator;
    }
    /**
     * Gets an array of {@link DecisionInfo} instances containing the profiling
     * information gathered for each decision in the ATN.
     *
     * @returns An array of {@link DecisionInfo} instances, indexed by decision
     * number.
     */ getDecisionInfo() {
        return this.atnSimulator.getDecisionInfo();
    }
    /**
     * Gets the decision numbers for decisions that required one or more
     * full-context predictions during parsing. These are decisions for which
     * {@link DecisionInfo#LL_Fallback} is non-zero.
     *
     * @returns A list of decision numbers which required one or more
     * full-context predictions during parsing.
     */ getLLDecisions() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let LL = [];
        for(let i = 0; i < decisions.length; i++){
            let fallBack = decisions[i].LL_Fallback;
            if (fallBack > 0) LL.push(i);
        }
        return LL;
    }
    /**
     * Gets the total time spent during prediction across all decisions made
     * during parsing. This value is the sum of
     * {@link DecisionInfo#timeInPrediction} for all decisions.
     */ getTotalTimeInPrediction() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let t = 0;
        for (let decision of decisions)t += decision.timeInPrediction;
        return t;
    }
    /**
     * Gets the total number of SLL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#SLL_TotalLook} for all decisions.
     */ getTotalSLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of LL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#LL_TotalLook} for all decisions.
     */ getTotalLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL prediction
     * across all decisions made during parsing.
     */ getTotalSLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for LL prediction
     * across all decisions made during parsing.
     */ getTotalLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL and LL
     * prediction across all decisions made during parsing.
     *
     * This value is the sum of {@link #getTotalSLLATNLookaheadOps} and
     * {@link #getTotalLLATNLookaheadOps}.
     */ getTotalATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions){
            k += decision.SLL_ATNTransitions;
            k += decision.LL_ATNTransitions;
        }
        return k;
    }
    getDFASize(decision) {
        if (decision) {
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA[decision];
            return decisionToDFA.states.size;
        } else {
            let n = 0;
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA;
            for(let i = 0; i < decisionToDFA.length; i++)n += this.getDFASize(i);
            return n;
        }
    }
};
$64d95490c532b14b$var$__decorate([
    $aN41m.NotNull
], $64d95490c532b14b$var$ParseInfo.prototype, "getDecisionInfo", null);
$64d95490c532b14b$var$__decorate([
    $aN41m.NotNull
], $64d95490c532b14b$var$ParseInfo.prototype, "getLLDecisions", null);
$64d95490c532b14b$var$ParseInfo = $64d95490c532b14b$var$__decorate([
    $64d95490c532b14b$var$__param(0, $aN41m.NotNull)
], $64d95490c532b14b$var$ParseInfo);
module.exports.ParseInfo = $64d95490c532b14b$var$ParseInfo;

});

parcelRegister("jdbdJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $dfc7ef60d4f1d1dc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyParserErrorListener = void 0;

var $3Wiwr = parcelRequire("3Wiwr");

var $aN41m = parcelRequire("aN41m");
/**
 * @author Sam Harwell
 */ class $dfc7ef60d4f1d1dc$var$ProxyParserErrorListener extends $3Wiwr.ProxyErrorListener {
    constructor(delegates){
        super(delegates);
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAmbiguity) listener.reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        });
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        });
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState);
        });
    }
}
$dfc7ef60d4f1d1dc$var$__decorate([
    $aN41m.Override
], $dfc7ef60d4f1d1dc$var$ProxyParserErrorListener.prototype, "reportAmbiguity", null);
$dfc7ef60d4f1d1dc$var$__decorate([
    $aN41m.Override
], $dfc7ef60d4f1d1dc$var$ProxyParserErrorListener.prototype, "reportAttemptingFullContext", null);
$dfc7ef60d4f1d1dc$var$__decorate([
    $aN41m.Override
], $dfc7ef60d4f1d1dc$var$ProxyParserErrorListener.prototype, "reportContextSensitivity", null);
module.exports.ProxyParserErrorListener = $dfc7ef60d4f1d1dc$var$ProxyParserErrorListener;

});

parcelRegister("gQja9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iWnPX").then(()=>parcelRequire('kU89k'));

});

parcelRegister("kTiid", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6JQOE").then(()=>parcelRequire('aVl0f'));

});




parcelRegister("hXb5J", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseCancellationException = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:42.5447085-07:00
/**
 * This exception is thrown to cancel a parsing operation. This exception does
 * not extend {@link RecognitionException}, allowing it to bypass the standard
 * error recovery mechanisms. {@link BailErrorStrategy} throws this exception in
 * response to a parse error.
 *
 * @author Sam Harwell
 */ class $d1208ce2fa370cab$var$ParseCancellationException extends Error {
    constructor(cause){
        super(cause.message);
        this.cause = cause;
        this.stack = cause.stack;
    }
    getCause() {
        return this.cause;
    }
}
module.exports.ParseCancellationException = $d1208ce2fa370cab$var$ParseCancellationException;

});


parcelRegister("doEv1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9c0cee8efd4f75ec$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9c0cee8efd4f75ec$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BufferedTokenStream = void 0;

var $fomfP = parcelRequire("fomfP");

var $exlin = parcelRequire("exlin");

var $l8y5T = parcelRequire("l8y5T");

var $h7Q3L = parcelRequire("h7Q3L");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
/**
 * This implementation of {@link TokenStream} loads tokens from a
 * {@link TokenSource} on-demand, and places the tokens in a buffer to provide
 * access to any previous token by index.
 *
 * This token stream ignores the value of {@link Token#getChannel}. If your
 * parser requires the token stream filter tokens to only those on a particular
 * channel, such as {@link Token#DEFAULT_CHANNEL} or
 * {@link Token#HIDDEN_CHANNEL}, use a filtering token stream such a
 * {@link CommonTokenStream}.
 */ let $9c0cee8efd4f75ec$var$BufferedTokenStream = class BufferedTokenStream {
    constructor(tokenSource){
        /**
         * A collection of all tokens fetched from the token source. The list is
         * considered a complete view of the input once {@link #fetchedEOF} is set
         * to `true`.
         */ this.tokens = [];
        /**
         * The index into {@link #tokens} of the current token (next token to
         * {@link #consume}). {@link #tokens}`[`{@link #p}`]` should be
         * {@link #LT LT(1)}.
         *
         * This field is set to -1 when the stream is first constructed or when
         * {@link #setTokenSource} is called, indicating that the first token has
         * not yet been fetched from the token source. For additional information,
         * see the documentation of {@link IntStream} for a description of
         * Initializing Methods.
         */ this.p = -1;
        /**
         * Indicates whether the {@link Token#EOF} token has been fetched from
         * {@link #tokenSource} and added to {@link #tokens}. This field improves
         * performance for the following cases:
         *
         * * {@link #consume}: The lookahead check in {@link #consume} to prevent
         *   consuming the EOF symbol is optimized by checking the values of
         *   {@link #fetchedEOF} and {@link #p} instead of calling {@link #LA}.
         * * {@link #fetch}: The check to prevent adding multiple EOF symbols into
         *   {@link #tokens} is trivial with this field.
         */ this.fetchedEOF = false;
        if (tokenSource == null) throw new Error("tokenSource cannot be null");
        this._tokenSource = tokenSource;
    }
    get tokenSource() {
        return this._tokenSource;
    }
    /** Reset this token stream by setting its token source. */ set tokenSource(tokenSource) {
        this._tokenSource = tokenSource;
        this.tokens.length = 0;
        this.p = -1;
        this.fetchedEOF = false;
    }
    get index() {
        return this.p;
    }
    mark() {
        return 0;
    }
    release(marker) {
    // no resources to release
    }
    seek(index) {
        this.lazyInit();
        this.p = this.adjustSeekIndex(index);
    }
    get size() {
        return this.tokens.length;
    }
    consume() {
        let skipEofCheck;
        if (this.p >= 0) {
            if (this.fetchedEOF) // the last token in tokens is EOF. skip check if p indexes any
            // fetched token except the last.
            skipEofCheck = this.p < this.tokens.length - 1;
            else // no EOF token in tokens. skip check if p indexes a fetched token.
            skipEofCheck = this.p < this.tokens.length;
        } else // not yet initialized
        skipEofCheck = false;
        if (!skipEofCheck && this.LA(1) === $eKXi4.Token.EOF) throw new Error("cannot consume EOF");
        if (this.sync(this.p + 1)) this.p = this.adjustSeekIndex(this.p + 1);
    }
    /** Make sure index `i` in tokens has a token.
     *
     * @returns `true` if a token is located at index `i`, otherwise
     *    `false`.
     * @see #get(int i)
     */ sync(i) {
        $fomfP(i >= 0);
        let n = i - this.tokens.length + 1; // how many more elements we need?
        //System.out.println("sync("+i+") needs "+n);
        if (n > 0) {
            let fetched = this.fetch(n);
            return fetched >= n;
        }
        return true;
    }
    /** Add `n` elements to buffer.
     *
     * @returns The actual number of elements added to the buffer.
     */ fetch(n) {
        if (this.fetchedEOF) return 0;
        for(let i = 0; i < n; i++){
            let t = this.tokenSource.nextToken();
            if (this.isWritableToken(t)) t.tokenIndex = this.tokens.length;
            this.tokens.push(t);
            if (t.type === $eKXi4.Token.EOF) {
                this.fetchedEOF = true;
                return i + 1;
            }
        }
        return n;
    }
    get(i) {
        if (i < 0 || i >= this.tokens.length) throw new RangeError("token index " + i + " out of range 0.." + (this.tokens.length - 1));
        return this.tokens[i];
    }
    /** Get all tokens from start..stop inclusively. */ getRange(start, stop) {
        if (start < 0 || stop < 0) return [];
        this.lazyInit();
        let subset = new Array();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $eKXi4.Token.EOF) break;
            subset.push(t);
        }
        return subset;
    }
    LA(i) {
        let token = this.LT(i);
        if (!token) return $eKXi4.Token.INVALID_TYPE;
        return token.type;
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        return this.tokens[this.p - k];
    }
    LT(k) {
        let result = this.tryLT(k);
        if (result === undefined) throw new RangeError("requested lookback index out of range");
        return result;
    }
    tryLT(k) {
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p + k - 1;
        this.sync(i);
        if (i >= this.tokens.length) // return EOF token
        // EOF must be last token
        return this.tokens[this.tokens.length - 1];
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /**
     * Allowed derived classes to modify the behavior of operations which change
     * the current stream position by adjusting the target token index of a seek
     * operation. The default implementation simply returns `i`. If an
     * exception is thrown in this method, the current stream index should not be
     * changed.
     *
     * For example, {@link CommonTokenStream} overrides this method to ensure that
     * the seek target is always an on-channel token.
     *
     * @param i The target token index.
     * @returns The adjusted target token index.
     */ adjustSeekIndex(i) {
        return i;
    }
    lazyInit() {
        if (this.p === -1) this.setup();
    }
    setup() {
        this.sync(0);
        this.p = this.adjustSeekIndex(0);
    }
    /** Given a start and stop index, return a `List` of all tokens in
     *  the token type `BitSet`.  Return an empty array if no tokens were found.  This
     *  method looks at both on and off channel tokens.
     */ getTokens(start, stop, types) {
        this.lazyInit();
        if (start === undefined) {
            $fomfP(stop === undefined && types === undefined);
            return this.tokens;
        } else if (stop === undefined) stop = this.tokens.length - 1;
        if (start < 0 || stop >= this.tokens.length || stop < 0 || start >= this.tokens.length) throw new RangeError("start " + start + " or stop " + stop + " not in 0.." + (this.tokens.length - 1));
        if (start > stop) return [];
        if (types === undefined) return this.tokens.slice(start, stop + 1);
        else if (typeof types === "number") types = new Set().add(types);
        let typesSet = types;
        // list = tokens[start:stop]:{T t, t.type in types}
        let filteredTokens = this.tokens.slice(start, stop + 1);
        filteredTokens = filteredTokens.filter((value)=>typesSet.has(value.type));
        return filteredTokens;
    }
    /**
     * Given a starting index, return the index of the next token on channel.
     * Return `i` if `tokens[i]` is on channel. Return the index of
     * the EOF token if there are no tokens on channel between `i` and
     * EOF.
     */ nextTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) return this.size - 1;
        let token = this.tokens[i];
        while(token.channel !== channel){
            if (token.type === $eKXi4.Token.EOF) return i;
            i++;
            this.sync(i);
            token = this.tokens[i];
        }
        return i;
    }
    /**
     * Given a starting index, return the index of the previous token on
     * channel. Return `i` if `tokens[i]` is on channel. Return -1
     * if there are no tokens on channel between `i` and 0.
     *
     * If `i` specifies an index at or after the EOF token, the EOF token
     * index is returned. This is due to the fact that the EOF token is treated
     * as though it were on every channel.
     */ previousTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) // the EOF token is on every channel
        return this.size - 1;
        while(i >= 0){
            let token = this.tokens[i];
            if (token.type === $eKXi4.Token.EOF || token.channel === channel) return i;
            i--;
        }
        return i;
    }
    /** Collect all tokens on specified channel to the right of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL} or
     *  EOF. If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToRight(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        let nextOnChannel = this.nextTokenOnChannel(tokenIndex + 1, $h7Q3L.Lexer.DEFAULT_TOKEN_CHANNEL);
        let to;
        let from = tokenIndex + 1;
        // if none onchannel to right, nextOnChannel=-1 so set to = last token
        if (nextOnChannel === -1) to = this.size - 1;
        else to = nextOnChannel;
        return this.filterForChannel(from, to, channel);
    }
    /** Collect all tokens on specified channel to the left of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL}.
     *  If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToLeft(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        if (tokenIndex === 0) // obviously no tokens can appear before the first token
        return [];
        let prevOnChannel = this.previousTokenOnChannel(tokenIndex - 1, $h7Q3L.Lexer.DEFAULT_TOKEN_CHANNEL);
        if (prevOnChannel === tokenIndex - 1) return [];
        // if none onchannel to left, prevOnChannel=-1 then from=0
        let from = prevOnChannel + 1;
        let to = tokenIndex - 1;
        return this.filterForChannel(from, to, channel);
    }
    filterForChannel(from, to, channel) {
        let hidden = new Array();
        for(let i = from; i <= to; i++){
            let t = this.tokens[i];
            if (channel === -1) {
                if (t.channel !== $h7Q3L.Lexer.DEFAULT_TOKEN_CHANNEL) hidden.push(t);
            } else if (t.channel === channel) hidden.push(t);
        }
        return hidden;
    }
    get sourceName() {
        return this.tokenSource.sourceName;
    }
    getText(interval) {
        if (interval === undefined) interval = $l8y5T.Interval.of(0, this.size - 1);
        else if (!(interval instanceof $l8y5T.Interval)) // Note: the more obvious check for 'instanceof RuleContext' results in a circular dependency problem
        interval = interval.sourceInterval;
        let start = interval.a;
        let stop = interval.b;
        if (start < 0 || stop < 0) return "";
        this.fill();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        let buf = "";
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $eKXi4.Token.EOF) break;
            buf += t.text;
        }
        return buf.toString();
    }
    getTextFromRange(start, stop) {
        if (this.isToken(start) && this.isToken(stop)) return this.getText($l8y5T.Interval.of(start.tokenIndex, stop.tokenIndex));
        return "";
    }
    /** Get all tokens from lexer until EOF. */ fill() {
        this.lazyInit();
        const blockSize = 1000;
        while(true){
            let fetched = this.fetch(blockSize);
            if (fetched < blockSize) return;
        }
    }
    // TODO: Figure out a way to make this more flexible?
    isWritableToken(t) {
        return t instanceof $exlin.CommonToken;
    }
    // TODO: Figure out a way to make this more flexible?
    isToken(t) {
        return t instanceof $exlin.CommonToken;
    }
};
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.NotNull
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "_tokenSource", void 0);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "tokenSource", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "index", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "mark", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "release", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "seek", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "size", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "consume", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "get", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "LA", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.NotNull,
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "LT", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "sourceName", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.NotNull,
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "getText", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.NotNull,
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "getTextFromRange", null);
$9c0cee8efd4f75ec$var$BufferedTokenStream = $9c0cee8efd4f75ec$var$__decorate([
    $9c0cee8efd4f75ec$var$__param(0, $aN41m.NotNull)
], $9c0cee8efd4f75ec$var$BufferedTokenStream);
module.exports.BufferedTokenStream = $9c0cee8efd4f75ec$var$BufferedTokenStream;

});

parcelRegister("aUhGF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8tY30", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CharStreams = void 0;

var $cNEtm = parcelRequire("cNEtm");

var $1EXcP = parcelRequire("1EXcP");

var $ldi9e = parcelRequire("ldi9e");
// const DEFAULT_BUFFER_SIZE: number = 4096;
/** This class represents the primary interface for creating {@link CharStream}s
 *  from a variety of sources as of 4.7.  The motivation was to support
 *  Unicode code points > U+FFFF.  {@link ANTLRInputStream} and
 *  {@link ANTLRFileStream} are now deprecated in favor of the streams created
 *  by this interface.
 *
 *  DEPRECATED: {@code new ANTLRFileStream("myinputfile")}
 *  NEW:        {@code CharStreams.fromFileName("myinputfile")}
 *
 *  WARNING: If you use both the deprecated and the new streams, you will see
 *  a nontrivial performance degradation. This speed hit is because the
 *  {@link Lexer}'s internal code goes from a monomorphic to megamorphic
 *  dynamic dispatch to get characters from the input stream. Java's
 *  on-the-fly compiler (JIT) is unable to perform the same optimizations
 *  so stick with either the old or the new streams, if performance is
 *  a primary concern. See the extreme debugging and spelunking
 *  needed to identify this issue in our timing rig:
 *
 *      https://github.com/antlr/antlr4/pull/1781
 *
 *  The ANTLR character streams still buffer all the input when you create
 *  the stream, as they have done for ~20 years. If you need unbuffered
 *  access, please note that it becomes challenging to create
 *  parse trees. The parse tree has to point to tokens which will either
 *  point into a stale location in an unbuffered stream or you have to copy
 *  the characters out of the buffer into the token. That defeats the purpose
 *  of unbuffered input. Per the ANTLR book, unbuffered streams are primarily
 *  useful for processing infinite streams *during the parse.*
 *
 *  The new streams also use 8-bit buffers when possible so this new
 *  interface supports character streams that use half as much memory
 *  as the old {@link ANTLRFileStream}, which assumed 16-bit characters.
 *
 *  A big shout out to Ben Hamilton (github bhamiltoncx) for his superhuman
 *  efforts across all targets to get true Unicode 3.1 support for U+10FFFF.
 *
 *  @since 4.7
 */ var $62cf9c5e285e940f$var$CharStreams;
(function(CharStreams) {
    // /**
    //  * Creates a {@link CharStream} given a path to a UTF-8
    //  * encoded file on disk.
    //  *
    //  * Reads the entire contents of the file into the result before returning.
    //  */
    // export function fromFile(file: File): CharStream;
    // export function fromFile(file: File, charset: Charset): CharStream;
    // export function fromFile(file: File, charset?: Charset): CharStream {
    // 	if (charset === undefined) {
    // 		charset = Charset.forName("UTF-8");
    // 	}
    function fromString(s, sourceName) {
        if (sourceName === undefined || sourceName.length === 0) sourceName = $ldi9e.IntStream.UNKNOWN_SOURCE_NAME;
        // Initial guess assumes no code points > U+FFFF: one code
        // point for each code unit in the string
        let codePointBufferBuilder = $cNEtm.CodePointBuffer.builder(s.length);
        // TODO: CharBuffer.wrap(String) rightfully returns a read-only buffer
        // which doesn't expose its array, so we make a copy.
        let cb = new Uint16Array(s.length);
        for(let i = 0; i < s.length; i++)cb[i] = s.charCodeAt(i);
        codePointBufferBuilder.append(cb);
        return $1EXcP.CodePointCharStream.fromBuffer(codePointBufferBuilder.build(), sourceName);
    }
    CharStreams.fromString = fromString;
// export function bufferFromChannel(
// 	channel: ReadableByteChannel,
// 	charset: Charset,
// 	bufferSize: number,
// 	decodingErrorAction: CodingErrorAction,
// 	inputSize: number): CodePointBuffer {
// 	try {
// 		let utf8BytesIn: Uint8Array = new Uint8Array(bufferSize);
// 		let utf16CodeUnitsOut: Uint16Array = new Uint16Array(bufferSize);
// 		if (inputSize === -1) {
// 			inputSize = bufferSize;
// 		} else if (inputSize > Integer.MAX_VALUE) {
// 			// ByteBuffer et al don't support long sizes
// 			throw new RangeError(`inputSize ${inputSize} larger than max ${Integer.MAX_VALUE}`);
// 		}
// 		let codePointBufferBuilder: CodePointBuffer.Builder = CodePointBuffer.builder(inputSize);
// 		let decoder: CharsetDecoder = charset
// 				.newDecoder()
// 				.onMalformedInput(decodingErrorAction)
// 				.onUnmappableCharacter(decodingErrorAction);
// 		let endOfInput: boolean = false;
// 		while (!endOfInput) {
// 			let bytesRead: number = channel.read(utf8BytesIn);
// 			endOfInput = (bytesRead === -1);
// 			utf8BytesIn.flip();
// 			let result: CoderResult = decoder.decode(
// 				utf8BytesIn,
// 				utf16CodeUnitsOut,
// 				endOfInput);
// 			if (result.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 				result.throwException();
// 			}
// 			utf16CodeUnitsOut.flip();
// 			codePointBufferBuilder.append(utf16CodeUnitsOut);
// 			utf8BytesIn.compact();
// 			utf16CodeUnitsOut.compact();
// 		}
// 		// Handle any bytes at the end of the file which need to
// 		// be represented as errors or substitution characters.
// 		let flushResult: CoderResult = decoder.flush(utf16CodeUnitsOut);
// 		if (flushResult.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 			flushResult.throwException();
// 		}
// 		utf16CodeUnitsOut.flip();
// 		codePointBufferBuilder.append(utf16CodeUnitsOut);
// 		return codePointBufferBuilder.build();
// 	}
// 	finally {
// 		channel.close();
// 	}
// }
})($62cf9c5e285e940f$var$CharStreams = module.exports.CharStreams || (module.exports.CharStreams = {}));

});
parcelRegister("cNEtm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointBuffer = void 0;

var $fomfP = parcelRequire("fomfP");

var $2ImFx = parcelRequire("2ImFx");
/**
 * Wrapper for `Uint8Array` / `Uint16Array` / `Int32Array`.
 */ class $951974a04eabf1bc$var$CodePointBuffer {
    constructor(buffer, size){
        this.buffer = buffer;
        this._position = 0;
        this._size = size;
    }
    static withArray(buffer) {
        return new $951974a04eabf1bc$var$CodePointBuffer(buffer, buffer.length);
    }
    get position() {
        return this._position;
    }
    set position(newPosition) {
        if (newPosition < 0 || newPosition > this._size) throw new RangeError();
        this._position = newPosition;
    }
    get remaining() {
        return this._size - this.position;
    }
    get(offset) {
        return this.buffer[offset];
    }
    array() {
        return this.buffer.slice(0, this._size);
    }
    static builder(initialBufferSize) {
        return new $951974a04eabf1bc$var$CodePointBuffer.Builder(initialBufferSize);
    }
}
module.exports.CodePointBuffer = $951974a04eabf1bc$var$CodePointBuffer;
(function(CodePointBuffer) {
    let Type;
    (function(Type) {
        Type[Type["BYTE"] = 0] = "BYTE";
        Type[Type["CHAR"] = 1] = "CHAR";
        Type[Type["INT"] = 2] = "INT";
    })(Type || (Type = {}));
    class Builder {
        constructor(initialBufferSize){
            this.type = 0 /* BYTE */ ;
            this.buffer = new Uint8Array(initialBufferSize);
            this.prevHighSurrogate = -1;
            this.position = 0;
        }
        build() {
            return new CodePointBuffer(this.buffer, this.position);
        }
        static roundUpToNextPowerOfTwo(i) {
            let nextPowerOfTwo = 32 - Math.clz32(i - 1);
            return Math.pow(2, nextPowerOfTwo);
        }
        ensureRemaining(remainingNeeded) {
            switch(this.type){
                case 0 /* BYTE */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint8Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 1 /* CHAR */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint16Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 2 /* INT */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Int32Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
            }
        }
        append(utf16In) {
            this.ensureRemaining(utf16In.length);
            this.appendArray(utf16In);
        }
        appendArray(utf16In) {
            switch(this.type){
                case 0 /* BYTE */ :
                    this.appendArrayByte(utf16In);
                    break;
                case 1 /* CHAR */ :
                    this.appendArrayChar(utf16In);
                    break;
                case 2 /* INT */ :
                    this.appendArrayInt(utf16In);
                    break;
            }
        }
        appendArrayByte(utf16In) {
            $fomfP(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outByte = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (c <= 0xFF) outByte[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    if (!$2ImFx.isHighSurrogate(c)) {
                        this.byteToCharBuffer(utf16In.length);
                        this.appendArrayChar(utf16In);
                        return;
                    } else {
                        this.byteToIntBuffer(utf16In.length);
                        this.appendArrayInt(utf16In);
                        return;
                    }
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayChar(utf16In) {
            $fomfP(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outChar = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (!$2ImFx.isHighSurrogate(c)) outChar[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    this.charToIntBuffer(utf16In.length);
                    this.appendArrayInt(utf16In);
                    return;
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayInt(utf16In) {
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outInt = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                inOffset++;
                if (this.prevHighSurrogate !== -1) {
                    if ($2ImFx.isLowSurrogate(c)) {
                        outInt[outOffset] = String.fromCharCode(this.prevHighSurrogate, c).codePointAt(0);
                        outOffset++;
                        this.prevHighSurrogate = -1;
                    } else {
                        // Dangling high surrogate
                        outInt[outOffset] = this.prevHighSurrogate;
                        outOffset++;
                        if ($2ImFx.isHighSurrogate(c)) this.prevHighSurrogate = c;
                        else {
                            outInt[outOffset] = c;
                            outOffset++;
                            this.prevHighSurrogate = -1;
                        }
                    }
                } else if ($2ImFx.isHighSurrogate(c)) this.prevHighSurrogate = c;
                else {
                    outInt[outOffset] = c;
                    outOffset++;
                }
            }
            if (this.prevHighSurrogate !== -1) {
                // Dangling high surrogate
                outInt[outOffset] = this.prevHighSurrogate;
                outOffset++;
            }
            this.position = outOffset;
        }
        byteToCharBuffer(toAppend) {
            // CharBuffers hold twice as much per unit as ByteBuffers, so start with half the capacity.
            let newBuffer = new Uint16Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 1 /* CHAR */ ;
            this.buffer = newBuffer;
        }
        byteToIntBuffer(toAppend) {
            // IntBuffers hold four times as much per unit as ByteBuffers, so start with one quarter the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 2));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
        charToIntBuffer(toAppend) {
            // IntBuffers hold two times as much per unit as ByteBuffers, so start with one half the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
    }
    CodePointBuffer.Builder = Builder;
})($951974a04eabf1bc$var$CodePointBuffer = module.exports.CodePointBuffer || (module.exports.CodePointBuffer = {}));

});
parcelRegister("2ImFx", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSupplementaryCodePoint = module.exports.isLowSurrogate = module.exports.isHighSurrogate = void 0;
function $1fa1466b3c6105b0$var$isHighSurrogate(ch) {
    return ch >= 0xD800 && ch <= 0xDBFF;
}
module.exports.isHighSurrogate = $1fa1466b3c6105b0$var$isHighSurrogate;
function $1fa1466b3c6105b0$var$isLowSurrogate(ch) {
    return ch >= 0xDC00 && ch <= 0xDFFF;
}
module.exports.isLowSurrogate = $1fa1466b3c6105b0$var$isLowSurrogate;
function $1fa1466b3c6105b0$var$isSupplementaryCodePoint(ch) {
    return ch >= 0x10000;
}
module.exports.isSupplementaryCodePoint = $1fa1466b3c6105b0$var$isSupplementaryCodePoint;

});


parcelRegister("1EXcP", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $135773ef6fd5bbbc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointCharStream = void 0;

var $fomfP = parcelRequire("fomfP");

var $ldi9e = parcelRequire("ldi9e");

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");
/**
 * Alternative to {@link ANTLRInputStream} which treats the input
 * as a series of Unicode code points, instead of a series of UTF-16
 * code units.
 *
 * Use this if you need to parse input which potentially contains
 * Unicode values > U+FFFF.
 */ class $135773ef6fd5bbbc$var$CodePointCharStream {
    // Use the factory method {@link #fromBuffer(CodePointBuffer)} to
    // construct instances of this type.
    constructor(array, position, remaining, name){
        // TODO
        $fomfP(position === 0);
        this._array = array;
        this._size = remaining;
        this._name = name;
        this._position = 0;
    }
    get internalStorage() {
        return this._array;
    }
    static fromBuffer(codePointBuffer, name) {
        if (name === undefined || name.length === 0) name = $ldi9e.IntStream.UNKNOWN_SOURCE_NAME;
        // Java lacks generics on primitive types.
        //
        // To avoid lots of calls to virtual methods in the
        // very hot codepath of LA() below, we construct one
        // of three concrete subclasses.
        //
        // The concrete subclasses directly access the code
        // points stored in the underlying array (byte[],
        // char[], or int[]), so we can avoid lots of virtual
        // method calls to ByteBuffer.get(offset).
        return new $135773ef6fd5bbbc$var$CodePointCharStream(codePointBuffer.array(), codePointBuffer.position, codePointBuffer.remaining, name);
    }
    consume() {
        if (this._size - this._position === 0) {
            $fomfP(this.LA(1) === $ldi9e.IntStream.EOF);
            throw new RangeError("cannot consume EOF");
        }
        this._position++;
    }
    get index() {
        return this._position;
    }
    get size() {
        return this._size;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    seek(index) {
        this._position = index;
    }
    get sourceName() {
        return this._name;
    }
    toString() {
        return this.getText($l8y5T.Interval.of(0, this.size - 1));
    }
    LA(i) {
        let offset;
        switch(Math.sign(i)){
            case -1:
                offset = this.index + i;
                if (offset < 0) return $ldi9e.IntStream.EOF;
                return this._array[offset];
            case 0:
                // Undefined
                return 0;
            case 1:
                offset = this.index + i - 1;
                if (offset >= this.size) return $ldi9e.IntStream.EOF;
                return this._array[offset];
        }
        throw new RangeError("Not reached");
    }
    /** Return the UTF-16 encoded string for the given interval */ getText(interval) {
        const startIdx = Math.min(interval.a, this.size);
        const len = Math.min(interval.b - interval.a + 1, this.size - startIdx);
        if (this._array instanceof Int32Array) return String.fromCodePoint(...Array.from(this._array.subarray(startIdx, startIdx + len)));
        else return String.fromCharCode(...Array.from(this._array.subarray(startIdx, startIdx + len)));
    }
}
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "consume", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "index", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "size", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "mark", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "release", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "seek", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "sourceName", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "toString", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "LA", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "getText", null);
module.exports.CodePointCharStream = $135773ef6fd5bbbc$var$CodePointCharStream;

});


parcelRegister("eCP5Y", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $aa5c3fc2017da3f2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $aa5c3fc2017da3f2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenStream = void 0;

var $doEv1 = parcelRequire("doEv1");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
/**
 * This class extends {@link BufferedTokenStream} with functionality to filter
 * token streams to tokens on a particular channel (tokens where
 * {@link Token#getChannel} returns a particular value).
 *
 * This token stream provides access to all tokens by index or when calling
 * methods like {@link #getText}. The channel filtering is only used for code
 * accessing tokens via the lookahead methods {@link #LA}, {@link #LT}, and
 * {@link #LB}.
 *
 * By default, tokens are placed on the default channel
 * ({@link Token#DEFAULT_CHANNEL}), but may be reassigned by using the
 * `->channel(HIDDEN)` lexer command, or by using an embedded action to
 * call {@link Lexer#setChannel}.
 *
 * Note: lexer rules which use the `->skip` lexer command or call
 * {@link Lexer#skip} do not produce tokens at all, so input text matched by
 * such a rule will not be available as part of the token stream, regardless of
 * channel.
 */ let $aa5c3fc2017da3f2$var$CommonTokenStream = class CommonTokenStream extends $doEv1.BufferedTokenStream {
    /**
     * Constructs a new {@link CommonTokenStream} using the specified token
     * source and filtering tokens to the specified channel. Only tokens whose
     * {@link Token#getChannel} matches `channel` or have the
     * `Token.type` equal to {@link Token#EOF} will be returned by the
     * token stream lookahead methods.
     *
     * @param tokenSource The token source.
     * @param channel The channel to use for filtering tokens.
     */ constructor(tokenSource, channel = $eKXi4.Token.DEFAULT_CHANNEL){
        super(tokenSource);
        this.channel = channel;
    }
    adjustSeekIndex(i) {
        return this.nextTokenOnChannel(i, this.channel);
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        let i = this.p;
        let n = 1;
        // find k good tokens looking backwards
        while(n <= k && i > 0){
            // skip off-channel tokens
            i = this.previousTokenOnChannel(i - 1, this.channel);
            n++;
        }
        if (i < 0) return undefined;
        return this.tokens[i];
    }
    tryLT(k) {
        //System.out.println("enter LT("+k+")");
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p;
        let n = 1; // we know tokens[p] is a good one
        // find k good tokens
        while(n < k){
            // skip off-channel tokens, but make sure to not look past EOF
            if (this.sync(i + 1)) i = this.nextTokenOnChannel(i + 1, this.channel);
            n++;
        }
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /** Count EOF just once. */ getNumberOfOnChannelTokens() {
        let n = 0;
        this.fill();
        for (let t of this.tokens){
            if (t.channel === this.channel) n++;
            if (t.type === $eKXi4.Token.EOF) break;
        }
        return n;
    }
};
$aa5c3fc2017da3f2$var$__decorate([
    $aN41m.Override
], $aa5c3fc2017da3f2$var$CommonTokenStream.prototype, "adjustSeekIndex", null);
$aa5c3fc2017da3f2$var$__decorate([
    $aN41m.Override
], $aa5c3fc2017da3f2$var$CommonTokenStream.prototype, "tryLB", null);
$aa5c3fc2017da3f2$var$__decorate([
    $aN41m.Override
], $aa5c3fc2017da3f2$var$CommonTokenStream.prototype, "tryLT", null);
$aa5c3fc2017da3f2$var$CommonTokenStream = $aa5c3fc2017da3f2$var$__decorate([
    $aa5c3fc2017da3f2$var$__param(0, $aN41m.NotNull)
], $aa5c3fc2017da3f2$var$CommonTokenStream);
module.exports.CommonTokenStream = $aa5c3fc2017da3f2$var$CommonTokenStream;

});

parcelRegister("9xPUt", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dependents = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.1349829-07:00
/**
 *
 * @author Sam Harwell
 */ var $6f2f765ae75dbe26$var$Dependents;
(function(Dependents) {
    /**
     * The element is dependent upon the specified rule.
     */ Dependents[Dependents["SELF"] = 0] = "SELF";
    /**
     * The element is dependent upon the set of the specified rule's parents
     * (rules which directly reference it).
     */ Dependents[Dependents["PARENTS"] = 1] = "PARENTS";
    /**
     * The element is dependent upon the set of the specified rule's children
     * (rules which it directly references).
     */ Dependents[Dependents["CHILDREN"] = 2] = "CHILDREN";
    /**
     * The element is dependent upon the set of the specified rule's ancestors
     * (the transitive closure of `PARENTS` rules).
     */ Dependents[Dependents["ANCESTORS"] = 3] = "ANCESTORS";
    /**
     * The element is dependent upon the set of the specified rule's descendants
     * (the transitive closure of `CHILDREN` rules).
     */ Dependents[Dependents["DESCENDANTS"] = 4] = "DESCENDANTS";
    /**
     * The element is dependent upon the set of the specified rule's siblings
     * (the union of `CHILDREN` of its `PARENTS`).
     */ Dependents[Dependents["SIBLINGS"] = 5] = "SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear before a reference to the rule).
     */ Dependents[Dependents["PRECEEDING_SIBLINGS"] = 6] = "PRECEEDING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's following
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear after a reference to the rule).
     */ Dependents[Dependents["FOLLOWING_SIBLINGS"] = 7] = "FOLLOWING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * elements (rules which might end before the start of the specified rule
     * while parsing). This is calculated by taking the
     * `PRECEEDING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["PRECEEDING"] = 8] = "PRECEEDING";
    /**
     * The element is dependent upon the set of the specified rule's following
     * elements (rules which might start after the end of the specified rule
     * while parsing). This is calculated by taking the
     * `FOLLOWING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["FOLLOWING"] = 9] = "FOLLOWING";
})($6f2f765ae75dbe26$var$Dependents = module.exports.Dependents || (module.exports.Dependents = {}));

});

parcelRegister("67k7F", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4743017423787884$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4743017423787884$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiagnosticErrorListener = void 0;

var $8WIez = parcelRequire("8WIez");

var $aN41m = parcelRequire("aN41m");

var $l8y5T = parcelRequire("l8y5T");
/**
 * This implementation of {@link ANTLRErrorListener} can be used to identify
 * certain potential correctness and performance problems in grammars. "Reports"
 * are made by calling {@link Parser#notifyErrorListeners} with the appropriate
 * message.
 *
 * * **Ambiguities**: These are cases where more than one path through the
 *   grammar can match the input.
 * * **Weak context sensitivity**: These are cases where full-context
 *   prediction resolved an SLL conflict to a unique alternative which equaled the
 *   minimum alternative of the SLL conflict.
 * * **Strong (forced) context sensitivity**: These are cases where the
 *   full-context prediction resolved an SLL conflict to a unique alternative,
 *   *and* the minimum alternative of the SLL conflict was found to not be
 *   a truly viable alternative. Two-stage parsing cannot be used for inputs where
 *   this situation occurs.
 *
 * @author Sam Harwell
 */ class $4743017423787884$var$DiagnosticErrorListener {
    /**
     * Initializes a new instance of {@link DiagnosticErrorListener}, specifying
     * whether all ambiguities or only exact ambiguities are reported.
     *
     * @param exactOnly `true` to report only exact ambiguities, otherwise
     * `false` to report all ambiguities.  Defaults to true.
     */ constructor(exactOnly = true){
        this.exactOnly = exactOnly;
        this.exactOnly = exactOnly;
    }
    syntaxError(/*@NotNull*/ recognizer, offendingSymbol, line, charPositionInLine, /*@NotNull*/ msg, e) {
    // intentionally empty
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (this.exactOnly && !exact) return;
        let decision = this.getDecisionDescription(recognizer, dfa);
        let conflictingAlts = this.getConflictingAlts(ambigAlts, configs);
        let text = recognizer.inputStream.getText($l8y5T.Interval.of(startIndex, stopIndex));
        let message = `reportAmbiguity d=${decision}: ambigAlts=${conflictingAlts}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        let format = "reportAttemptingFullContext d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($l8y5T.Interval.of(startIndex, stopIndex));
        let message = `reportAttemptingFullContext d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        let format = "reportContextSensitivity d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($l8y5T.Interval.of(startIndex, stopIndex));
        let message = `reportContextSensitivity d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    getDecisionDescription(recognizer, dfa) {
        let decision = dfa.decision;
        let ruleIndex = dfa.atnStartState.ruleIndex;
        let ruleNames = recognizer.ruleNames;
        if (ruleIndex < 0 || ruleIndex >= ruleNames.length) return decision.toString();
        let ruleName = ruleNames[ruleIndex];
        if (!ruleName) return decision.toString();
        return `${decision} (${ruleName})`;
    }
    /**
     * Computes the set of conflicting or ambiguous alternatives from a
     * configuration set, if that information was not already provided by the
     * parser.
     *
     * @param reportedAlts The set of conflicting or ambiguous alternatives, as
     * reported by the parser.
     * @param configs The conflicting or ambiguous configuration set.
     * @returns Returns `reportedAlts` if it is not `undefined`, otherwise
     * returns the set of alternatives represented in `configs`.
     */ getConflictingAlts(reportedAlts, configs) {
        if (reportedAlts != null) return reportedAlts;
        let result = new $8WIez.BitSet();
        for (let config of configs)result.set(config.alt);
        return result;
    }
}
$4743017423787884$var$__decorate([
    $aN41m.Override
], $4743017423787884$var$DiagnosticErrorListener.prototype, "syntaxError", null);
$4743017423787884$var$__decorate([
    $aN41m.Override,
    $4743017423787884$var$__param(0, $aN41m.NotNull),
    $4743017423787884$var$__param(1, $aN41m.NotNull),
    $4743017423787884$var$__param(6, $aN41m.NotNull)
], $4743017423787884$var$DiagnosticErrorListener.prototype, "reportAmbiguity", null);
$4743017423787884$var$__decorate([
    $aN41m.Override,
    $4743017423787884$var$__param(0, $aN41m.NotNull),
    $4743017423787884$var$__param(1, $aN41m.NotNull),
    $4743017423787884$var$__param(5, $aN41m.NotNull)
], $4743017423787884$var$DiagnosticErrorListener.prototype, "reportAttemptingFullContext", null);
$4743017423787884$var$__decorate([
    $aN41m.Override,
    $4743017423787884$var$__param(0, $aN41m.NotNull),
    $4743017423787884$var$__param(1, $aN41m.NotNull),
    $4743017423787884$var$__param(5, $aN41m.NotNull)
], $4743017423787884$var$DiagnosticErrorListener.prototype, "reportContextSensitivity", null);
$4743017423787884$var$__decorate([
    $4743017423787884$var$__param(0, $aN41m.NotNull),
    $4743017423787884$var$__param(1, $aN41m.NotNull)
], $4743017423787884$var$DiagnosticErrorListener.prototype, "getDecisionDescription", null);
$4743017423787884$var$__decorate([
    $aN41m.NotNull,
    $4743017423787884$var$__param(1, $aN41m.NotNull)
], $4743017423787884$var$DiagnosticErrorListener.prototype, "getConflictingAlts", null);
module.exports.DiagnosticErrorListener = $4743017423787884$var$DiagnosticErrorListener;

});

parcelRegister("jo2Zj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e1d2938a086e1390$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InterpreterRuleContext = void 0;

var $aN41m = parcelRequire("aN41m");

var $2pDMz = parcelRequire("2pDMz");
/**
 * This class extends {@link ParserRuleContext} by allowing the value of
 * {@link #getRuleIndex} to be explicitly set for the context.
 *
 * {@link ParserRuleContext} does not include field storage for the rule index
 * since the context classes created by the code generator override the
 * {@link #getRuleIndex} method to return the correct value for that context.
 * Since the parser interpreter does not use the context classes generated for a
 * parser, this class (with slightly more memory overhead per node) is used to
 * provide equivalent functionality.
 */ class $e1d2938a086e1390$var$InterpreterRuleContext extends $2pDMz.ParserRuleContext {
    constructor(ruleIndex, parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._ruleIndex = ruleIndex;
    }
    get ruleIndex() {
        return this._ruleIndex;
    }
}
$e1d2938a086e1390$var$__decorate([
    $aN41m.Override
], $e1d2938a086e1390$var$InterpreterRuleContext.prototype, "ruleIndex", null);
module.exports.InterpreterRuleContext = $e1d2938a086e1390$var$InterpreterRuleContext;

});

parcelRegister("hVliW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d0c8492ceb048178$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d0c8492ceb048178$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerInterpreter = void 0;

var $h7Q3L = parcelRequire("h7Q3L");

var $2160U = parcelRequire("2160U");

var $aN41m = parcelRequire("aN41m");

var $aN41m = parcelRequire("aN41m");
let $d0c8492ceb048178$var$LexerInterpreter = class LexerInterpreter extends $h7Q3L.Lexer {
    constructor(grammarFileName, vocabulary, ruleNames, channelNames, modeNames, atn, input){
        super(input);
        if (atn.grammarType !== 0 /* LEXER */ ) throw new Error("IllegalArgumentException: The ATN must be a lexer ATN.");
        this._grammarFileName = grammarFileName;
        this._atn = atn;
        this._ruleNames = ruleNames.slice(0);
        this._channelNames = channelNames.slice(0);
        this._modeNames = modeNames.slice(0);
        this._vocabulary = vocabulary;
        this._interp = new $2160U.LexerATNSimulator(atn, this);
    }
    get atn() {
        return this._atn;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get channelNames() {
        return this._channelNames;
    }
    get modeNames() {
        return this._modeNames;
    }
    get vocabulary() {
        return this._vocabulary;
    }
};
$d0c8492ceb048178$var$__decorate([
    $aN41m.NotNull
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "_vocabulary", void 0);
$d0c8492ceb048178$var$__decorate([
    $aN41m.Override
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "atn", null);
$d0c8492ceb048178$var$__decorate([
    $aN41m.Override
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "grammarFileName", null);
$d0c8492ceb048178$var$__decorate([
    $aN41m.Override
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "ruleNames", null);
$d0c8492ceb048178$var$__decorate([
    $aN41m.Override
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "channelNames", null);
$d0c8492ceb048178$var$__decorate([
    $aN41m.Override
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "modeNames", null);
$d0c8492ceb048178$var$__decorate([
    $aN41m.Override
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "vocabulary", null);
$d0c8492ceb048178$var$LexerInterpreter = $d0c8492ceb048178$var$__decorate([
    $d0c8492ceb048178$var$__param(1, $aN41m.NotNull)
], $d0c8492ceb048178$var$LexerInterpreter);
module.exports.LexerInterpreter = $d0c8492ceb048178$var$LexerInterpreter;

});

parcelRegister("c8NTK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8d6cf020aadeeb48$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8d6cf020aadeeb48$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ListTokenSource = void 0;

var $9hrXh = parcelRequire("9hrXh");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
/**
 * Provides an implementation of {@link TokenSource} as a wrapper around a list
 * of {@link Token} objects.
 *
 * If the final token in the list is an {@link Token#EOF} token, it will be used
 * as the EOF token for every call to {@link #nextToken} after the end of the
 * list is reached. Otherwise, an EOF token will be created.
 */ let $8d6cf020aadeeb48$var$ListTokenSource = class ListTokenSource {
    /**
     * Constructs a new {@link ListTokenSource} instance from the specified
     * collection of {@link Token} objects and source name.
     *
     * @param tokens The collection of {@link Token} objects to provide as a
     * {@link TokenSource}.
     * @param sourceName The name of the {@link TokenSource}. If this value is
     * `undefined`, {@link #getSourceName} will attempt to infer the name from
     * the next {@link Token} (or the previous token if the end of the input has
     * been reached).
     *
     * @exception NullPointerException if `tokens` is `undefined`
     */ constructor(tokens, sourceName){
        /**
         * The index into {@link #tokens} of token to return by the next call to
         * {@link #nextToken}. The end of the input is indicated by this value
         * being greater than or equal to the number of items in {@link #tokens}.
         */ this.i = 0;
        /**
         * This is the backing field for {@link #getTokenFactory} and
         * {@link setTokenFactory}.
         */ this._factory = $9hrXh.CommonTokenFactory.DEFAULT;
        if (tokens == null) throw new Error("tokens cannot be null");
        this.tokens = tokens;
        this._sourceName = sourceName;
    }
    /**
     * {@inheritDoc}
     */ get charPositionInLine() {
        if (this.i < this.tokens.length) return this.tokens[this.i].charPositionInLine;
        else if (this.eofToken != null) return this.eofToken.charPositionInLine;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let tokenText = lastToken.text;
            if (tokenText != null) {
                let lastNewLine = tokenText.lastIndexOf("\n");
                if (lastNewLine >= 0) return tokenText.length - lastNewLine - 1;
            }
            return lastToken.charPositionInLine + lastToken.stopIndex - lastToken.startIndex + 1;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 0;
    }
    /**
     * {@inheritDoc}
     */ nextToken() {
        if (this.i >= this.tokens.length) {
            if (this.eofToken == null) {
                let start = -1;
                if (this.tokens.length > 0) {
                    let previousStop = this.tokens[this.tokens.length - 1].stopIndex;
                    if (previousStop !== -1) start = previousStop + 1;
                }
                let stop = Math.max(-1, start - 1);
                this.eofToken = this._factory.create({
                    source: this,
                    stream: this.inputStream
                }, $eKXi4.Token.EOF, "EOF", $eKXi4.Token.DEFAULT_CHANNEL, start, stop, this.line, this.charPositionInLine);
            }
            return this.eofToken;
        }
        let t = this.tokens[this.i];
        if (this.i === this.tokens.length - 1 && t.type === $eKXi4.Token.EOF) this.eofToken = t;
        this.i++;
        return t;
    }
    /**
     * {@inheritDoc}
     */ get line() {
        if (this.i < this.tokens.length) return this.tokens[this.i].line;
        else if (this.eofToken != null) return this.eofToken.line;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let line = lastToken.line;
            let tokenText = lastToken.text;
            if (tokenText != null) {
                for(let i = 0; i < tokenText.length; i++)if (tokenText.charAt(i) === "\n") line++;
            }
            // if no text is available, assume the token did not contain any newline characters.
            return line;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 1;
    }
    /**
     * {@inheritDoc}
     */ get inputStream() {
        if (this.i < this.tokens.length) return this.tokens[this.i].inputStream;
        else if (this.eofToken != null) return this.eofToken.inputStream;
        else if (this.tokens.length > 0) return this.tokens[this.tokens.length - 1].inputStream;
        // no input stream information is available
        return undefined;
    }
    /**
     * {@inheritDoc}
     */ get sourceName() {
        if (this._sourceName) return this._sourceName;
        let inputStream = this.inputStream;
        if (inputStream != null) return inputStream.sourceName;
        return "List";
    }
    /**
     * {@inheritDoc}
     */ // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    /**
     * {@inheritDoc}
     */ get tokenFactory() {
        return this._factory;
    }
};
$8d6cf020aadeeb48$var$__decorate([
    $aN41m.Override
], $8d6cf020aadeeb48$var$ListTokenSource.prototype, "charPositionInLine", null);
$8d6cf020aadeeb48$var$__decorate([
    $aN41m.Override
], $8d6cf020aadeeb48$var$ListTokenSource.prototype, "nextToken", null);
$8d6cf020aadeeb48$var$__decorate([
    $aN41m.Override
], $8d6cf020aadeeb48$var$ListTokenSource.prototype, "line", null);
$8d6cf020aadeeb48$var$__decorate([
    $aN41m.Override
], $8d6cf020aadeeb48$var$ListTokenSource.prototype, "inputStream", null);
$8d6cf020aadeeb48$var$__decorate([
    $aN41m.Override
], $8d6cf020aadeeb48$var$ListTokenSource.prototype, "sourceName", null);
$8d6cf020aadeeb48$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull,
    $8d6cf020aadeeb48$var$__param(0, $aN41m.NotNull)
], $8d6cf020aadeeb48$var$ListTokenSource.prototype, "tokenFactory", null);
$8d6cf020aadeeb48$var$ListTokenSource = $8d6cf020aadeeb48$var$__decorate([
    $8d6cf020aadeeb48$var$__param(0, $aN41m.NotNull)
], $8d6cf020aadeeb48$var$ListTokenSource);
module.exports.ListTokenSource = $8d6cf020aadeeb48$var$ListTokenSource;

});

parcelRegister("5n08Y", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8rZl7", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $62706d1c6fe2cac4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $62706d1c6fe2cac4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserInterpreter = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $8WIez = parcelRequire("8WIez");

var $2quiJ = parcelRequire("2quiJ");

var $5jZSY = parcelRequire("5jZSY");

var $jo2Zj = parcelRequire("jo2Zj");

var $fFNPu = parcelRequire("fFNPu");

var $aN41m = parcelRequire("aN41m");

var $aN41m = parcelRequire("aN41m");

var $c9Sjf = parcelRequire("c9Sjf");

var $gzbPK = parcelRequire("gzbPK");

var $b7PPe = parcelRequire("b7PPe");

var $e0pjt = parcelRequire("e0pjt");

var $eKXi4 = parcelRequire("eKXi4");
/** A parser simulator that mimics what ANTLR's generated
 *  parser code does. A ParserATNSimulator is used to make
 *  predictions via adaptivePredict but this class moves a pointer through the
 *  ATN to simulate parsing. ParserATNSimulator just
 *  makes us efficient rather than having to backtrack, for example.
 *
 *  This properly creates parse trees even for left recursive rules.
 *
 *  We rely on the left recursive rule invocation and special predicate
 *  transitions to make left recursive rules work.
 *
 *  See TestParserInterpreter for examples.
 */ let $62706d1c6fe2cac4$var$ParserInterpreter = class ParserInterpreter extends $c9Sjf.Parser {
    constructor(grammarFileName, vocabulary, ruleNames, atn, input){
        super(grammarFileName instanceof ParserInterpreter ? grammarFileName.inputStream : input);
        /** This stack corresponds to the _parentctx, _parentState pair of locals
         *  that would exist on call stack frames with a recursive descent parser;
         *  in the generated function for a left-recursive rule you'd see:
         *
         *  private EContext e(int _p) {
         *      ParserRuleContext _parentctx = _ctx;    // Pair.a
         *      int _parentState = state;          // Pair.b
         *      ...
         *  }
         *
         *  Those values are used to create new recursive rule invocation contexts
         *  associated with left operand of an alt like "expr '*' expr".
         */ this._parentContextStack = [];
        /** We need a map from (decision,inputIndex)->forced alt for computing ambiguous
         *  parse trees. For now, we allow exactly one override.
         */ this.overrideDecision = -1;
        this.overrideDecisionInputIndex = -1;
        this.overrideDecisionAlt = -1;
        this.overrideDecisionReached = false; // latch and only override once; error might trigger infinite loop
        /** What is the current context when we override a decisions?  This tells
         *  us what the root of the parse tree is when using override
         *  for an ambiguity/lookahead check.
         */ this._overrideDecisionRoot = undefined;
        if (grammarFileName instanceof ParserInterpreter) {
            let old = grammarFileName;
            this._grammarFileName = old._grammarFileName;
            this._atn = old._atn;
            this.pushRecursionContextStates = old.pushRecursionContextStates;
            this._ruleNames = old._ruleNames;
            this._vocabulary = old._vocabulary;
            this.interpreter = new $gzbPK.ParserATNSimulator(this._atn, this);
        } else {
            // The second constructor requires non-null arguments
            vocabulary;
            ruleNames;
            atn;
            this._grammarFileName = grammarFileName;
            this._atn = atn;
            this._ruleNames = ruleNames.slice(0);
            this._vocabulary = vocabulary;
            // identify the ATN states where pushNewRecursionContext() must be called
            this.pushRecursionContextStates = new $8WIez.BitSet(atn.states.length);
            for (let state of atn.states){
                if (!(state instanceof $e0pjt.StarLoopEntryState)) continue;
                if (state.precedenceRuleDecision) this.pushRecursionContextStates.set(state.stateNumber);
            }
            // get atn simulator that knows how to do predictions
            this.interpreter = new $gzbPK.ParserATNSimulator(atn, this);
        }
    }
    reset(resetInput) {
        if (resetInput === undefined) super.reset();
        else super.reset(resetInput);
        this.overrideDecisionReached = false;
        this._overrideDecisionRoot = undefined;
    }
    get atn() {
        return this._atn;
    }
    get vocabulary() {
        return this._vocabulary;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    /** Begin parsing at startRuleIndex */ parse(startRuleIndex) {
        let startRuleStartState = this._atn.ruleToStartState[startRuleIndex];
        this._rootContext = this.createInterpreterRuleContext(undefined, $dv9vN.ATNState.INVALID_STATE_NUMBER, startRuleIndex);
        if (startRuleStartState.isPrecedenceRule) this.enterRecursionRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex, 0);
        else this.enterRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex);
        while(true){
            let p = this.atnState;
            switch(p.stateType){
                case $fZESB.ATNStateType.RULE_STOP:
                    // pop; return from rule
                    if (this._ctx.isEmpty) {
                        if (startRuleStartState.isPrecedenceRule) {
                            let result = this._ctx;
                            let parentContext = this._parentContextStack.pop();
                            this.unrollRecursionContexts(parentContext[0]);
                            return result;
                        } else {
                            this.exitRule();
                            return this._rootContext;
                        }
                    }
                    this.visitRuleStopState(p);
                    break;
                default:
                    try {
                        this.visitState(p);
                    } catch (e) {
                        if (e instanceof $b7PPe.RecognitionException) {
                            this.state = this._atn.ruleToStopState[p.ruleIndex].stateNumber;
                            this.context.exception = e;
                            this.errorHandler.reportError(this, e);
                            this.recover(e);
                        } else throw e;
                    }
                    break;
            }
        }
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this._parentContextStack.push([
            this._ctx,
            localctx.invokingState
        ]);
        super.enterRecursionRule(localctx, state, ruleIndex, precedence);
    }
    get atnState() {
        return this._atn.states[this.state];
    }
    visitState(p) {
        let predictedAlt = 1;
        if (p.numberOfTransitions > 1) predictedAlt = this.visitDecisionState(p);
        let transition = p.transition(predictedAlt - 1);
        switch(transition.serializationType){
            case 1 /* EPSILON */ :
                if (this.pushRecursionContextStates.get(p.stateNumber) && !(transition.target instanceof $fFNPu.LoopEndState)) {
                    // We are at the start of a left recursive rule's (...)* loop
                    // and we're not taking the exit branch of loop.
                    let parentContext = this._parentContextStack[this._parentContextStack.length - 1];
                    let localctx = this.createInterpreterRuleContext(parentContext[0], parentContext[1], this._ctx.ruleIndex);
                    this.pushNewRecursionContext(localctx, this._atn.ruleToStartState[p.ruleIndex].stateNumber, this._ctx.ruleIndex);
                }
                break;
            case 5 /* ATOM */ :
                this.match(transition._label);
                break;
            case 2 /* RANGE */ :
            case 7 /* SET */ :
            case 8 /* NOT_SET */ :
                if (!transition.matches(this._input.LA(1), $eKXi4.Token.MIN_USER_TOKEN_TYPE, 65535)) this.recoverInline();
                this.matchWildcard();
                break;
            case 9 /* WILDCARD */ :
                this.matchWildcard();
                break;
            case 3 /* RULE */ :
                let ruleStartState = transition.target;
                let ruleIndex = ruleStartState.ruleIndex;
                let newctx = this.createInterpreterRuleContext(this._ctx, p.stateNumber, ruleIndex);
                if (ruleStartState.isPrecedenceRule) this.enterRecursionRule(newctx, ruleStartState.stateNumber, ruleIndex, transition.precedence);
                else this.enterRule(newctx, transition.target.stateNumber, ruleIndex);
                break;
            case 4 /* PREDICATE */ :
                let predicateTransition = transition;
                if (!this.sempred(this._ctx, predicateTransition.ruleIndex, predicateTransition.predIndex)) throw new $2quiJ.FailedPredicateException(this);
                break;
            case 6 /* ACTION */ :
                let actionTransition = transition;
                this.action(this._ctx, actionTransition.ruleIndex, actionTransition.actionIndex);
                break;
            case 10 /* PRECEDENCE */ :
                if (!this.precpred(this._ctx, transition.precedence)) {
                    let precedence = transition.precedence;
                    throw new $2quiJ.FailedPredicateException(this, `precpred(_ctx, ${precedence})`);
                }
                break;
            default:
                throw new Error("UnsupportedOperationException: Unrecognized ATN transition type.");
        }
        this.state = transition.target.stateNumber;
    }
    /** Method visitDecisionState() is called when the interpreter reaches
     *  a decision state (instance of DecisionState). It gives an opportunity
     *  for subclasses to track interesting things.
     */ visitDecisionState(p) {
        let predictedAlt;
        this.errorHandler.sync(this);
        let decision = p.decision;
        if (decision === this.overrideDecision && this._input.index === this.overrideDecisionInputIndex && !this.overrideDecisionReached) {
            predictedAlt = this.overrideDecisionAlt;
            this.overrideDecisionReached = true;
        } else predictedAlt = this.interpreter.adaptivePredict(this._input, decision, this._ctx);
        return predictedAlt;
    }
    /** Provide simple "factory" for InterpreterRuleContext's.
     *  @since 4.5.1
     */ createInterpreterRuleContext(parent, invokingStateNumber, ruleIndex) {
        return new $jo2Zj.InterpreterRuleContext(ruleIndex, parent, invokingStateNumber);
    }
    visitRuleStopState(p) {
        let ruleStartState = this._atn.ruleToStartState[p.ruleIndex];
        if (ruleStartState.isPrecedenceRule) {
            let parentContext = this._parentContextStack.pop();
            this.unrollRecursionContexts(parentContext[0]);
            this.state = parentContext[1];
        } else this.exitRule();
        let ruleTransition = this._atn.states[this.state].transition(0);
        this.state = ruleTransition.followState.stateNumber;
    }
    /** Override this parser interpreters normal decision-making process
     *  at a particular decision and input token index. Instead of
     *  allowing the adaptive prediction mechanism to choose the
     *  first alternative within a block that leads to a successful parse,
     *  force it to take the alternative, 1..n for n alternatives.
     *
     *  As an implementation limitation right now, you can only specify one
     *  override. This is sufficient to allow construction of different
     *  parse trees for ambiguous input. It means re-parsing the entire input
     *  in general because you're never sure where an ambiguous sequence would
     *  live in the various parse trees. For example, in one interpretation,
     *  an ambiguous input sequence would be matched completely in expression
     *  but in another it could match all the way back to the root.
     *
     *  s : e '!'? ;
     *  e : ID
     *    | ID '!'
     *    ;
     *
     *  Here, x! can be matched as (s (e ID) !) or (s (e ID !)). In the first
     *  case, the ambiguous sequence is fully contained only by the root.
     *  In the second case, the ambiguous sequences fully contained within just
     *  e, as in: (e ID !).
     *
     *  Rather than trying to optimize this and make
     *  some intelligent decisions for optimization purposes, I settled on
     *  just re-parsing the whole input and then using
     *  {link Trees#getRootOfSubtreeEnclosingRegion} to find the minimal
     *  subtree that contains the ambiguous sequence. I originally tried to
     *  record the call stack at the point the parser detected and ambiguity but
     *  left recursive rules create a parse tree stack that does not reflect
     *  the actual call stack. That impedance mismatch was enough to make
     *  it it challenging to restart the parser at a deeply nested rule
     *  invocation.
     *
     *  Only parser interpreters can override decisions so as to avoid inserting
     *  override checking code in the critical ALL(*) prediction execution path.
     *
     *  @since 4.5
     */ addDecisionOverride(decision, tokenIndex, forcedAlt) {
        this.overrideDecision = decision;
        this.overrideDecisionInputIndex = tokenIndex;
        this.overrideDecisionAlt = forcedAlt;
    }
    get overrideDecisionRoot() {
        return this._overrideDecisionRoot;
    }
    /** Rely on the error handler for this parser but, if no tokens are consumed
     *  to recover, add an error node. Otherwise, nothing is seen in the parse
     *  tree.
     */ recover(e) {
        let i = this._input.index;
        this.errorHandler.recover(this, e);
        if (this._input.index === i) {
            // no input consumed, better add an error node
            let tok = e.getOffendingToken();
            if (!tok) throw new Error("Expected exception to have an offending token");
            let source = tok.tokenSource;
            let stream = source !== undefined ? source.inputStream : undefined;
            let sourcePair = {
                source: source,
                stream: stream
            };
            if (e instanceof $5jZSY.InputMismatchException) {
                let expectedTokens = e.expectedTokens;
                if (expectedTokens === undefined) throw new Error("Expected the exception to provide expected tokens");
                let expectedTokenType = $eKXi4.Token.INVALID_TYPE;
                if (!expectedTokens.isNil) // get any element
                expectedTokenType = expectedTokens.minElement;
                let errToken = this.tokenFactory.create(sourcePair, expectedTokenType, tok.text, $eKXi4.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            } else {
                let source = tok.tokenSource;
                let errToken = this.tokenFactory.create(sourcePair, $eKXi4.Token.INVALID_TYPE, tok.text, $eKXi4.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            }
        }
    }
    recoverInline() {
        return this._errHandler.recoverInline(this);
    }
    /** Return the root of the parse, which can be useful if the parser
     *  bails out. You still can access the top node. Note that,
     *  because of the way left recursive rules add children, it's possible
     *  that the root will not have any children if the start rule immediately
     *  called and left recursive rule that fails.
     *
     * @since 4.5.1
     */ get rootContext() {
        return this._rootContext;
    }
};
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.NotNull
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "_vocabulary", void 0);
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.Override
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "reset", null);
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.Override
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "atn", null);
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.Override
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "vocabulary", null);
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.Override
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "ruleNames", null);
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.Override
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "grammarFileName", null);
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.Override
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "enterRecursionRule", null);
$62706d1c6fe2cac4$var$ParserInterpreter = $62706d1c6fe2cac4$var$__decorate([
    $62706d1c6fe2cac4$var$__param(1, $aN41m.NotNull)
], $62706d1c6fe2cac4$var$ParserInterpreter);
module.exports.ParserInterpreter = $62706d1c6fe2cac4$var$ParserInterpreter;

});

parcelRegister("atcwe", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $79f652cad683467f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContextWithAltNum = void 0;

var $eeOLb = parcelRequire("eeOLb");

var $aN41m = parcelRequire("aN41m");

var $2pDMz = parcelRequire("2pDMz");
/** A handy class for use with
 *
 *  options {contextSuperClass=org.antlr.v4.runtime.RuleContextWithAltNum;}
 *
 *  that provides a backing field / impl for the outer alternative number
 *  matched for an internal parse tree node.
 *
 *  I'm only putting into Java runtime as I'm certain I'm the only one that
 *  will really every use this.
 */ class $79f652cad683467f$var$RuleContextWithAltNum extends $2pDMz.ParserRuleContext {
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._altNumber = $eeOLb.ATN.INVALID_ALT_NUMBER;
    }
    get altNumber() {
        return this._altNumber;
    }
    // @Override
    set altNumber(altNum) {
        this._altNumber = altNum;
    }
}
$79f652cad683467f$var$__decorate([
    $aN41m.Override
], $79f652cad683467f$var$RuleContextWithAltNum.prototype, "altNumber", null);
module.exports.RuleContextWithAltNum = $79f652cad683467f$var$RuleContextWithAltNum;

});

parcelRegister("3d5Fu", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleDependency = void 0;
/**
 * Declares a dependency upon a grammar rule, along with a set of zero or more dependent rules.
 *
 * Version numbers within a grammar should be assigned on a monotonically increasing basis to allow for accurate
 * tracking of dependent rules.
 *
 * @author Sam Harwell
 */ function $2566fb8eb3eb638e$var$RuleDependency(dependency) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleDependency = $2566fb8eb3eb638e$var$RuleDependency;

});

parcelRegister("hHHux", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleVersion = void 0;
/**
 *
 * @author Sam Harwell
 */ function $ce3830527f1ccb0d$var$RuleVersion(version) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleVersion = $ce3830527f1ccb0d$var$RuleVersion;

});

parcelRegister("lL3Js", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("03lZa", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("b3QEj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hwMU6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cc2b5c1f9eca6d60$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RewriteOperation = module.exports.TokenStreamRewriter = void 0;

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
/**
 * Useful for rewriting out a buffered input token stream after doing some
 * augmentation or other manipulations on it.
 *
 * You can insert stuff, replace, and delete chunks. Note that the operations
 * are done lazily--only if you convert the buffer to a {@link String} with
 * {@link TokenStream#getText()}. This is very efficient because you are not
 * moving data around all the time. As the buffer of tokens is converted to
 * strings, the {@link #getText()} method(s) scan the input token stream and
 * check to see if there is an operation at the current index. If so, the
 * operation is done and then normal {@link String} rendering continues on the
 * buffer. This is like having multiple Turing machine instruction streams
 * (programs) operating on a single input tape. :)
 *
 * This rewriter makes no modifications to the token stream. It does not ask the
 * stream to fill itself up nor does it advance the input cursor. The token
 * stream `TokenStream.index` will return the same value before and
 * after any {@link #getText()} call.
 *
 * The rewriter only works on tokens that you have in the buffer and ignores the
 * current input cursor. If you are buffering tokens on-demand, calling
 * {@link #getText()} halfway through the input will only do rewrites for those
 * tokens in the first half of the file.
 *
 * Since the operations are done lazily at {@link #getText}-time, operations do
 * not screw up the token index values. That is, an insert operation at token
 * index `i` does not change the index values for tokens
 * `i`+1..n-1.
 *
 * Because operations never actually alter the buffer, you may always get the
 * original token stream back without undoing anything. Since the instructions
 * are queued up, you can easily simulate transactions and roll back any changes
 * if there is an error just by removing instructions. For example,
 *
 * ```
 * CharStream input = new ANTLRFileStream("input");
 * TLexer lex = new TLexer(input);
 * CommonTokenStream tokens = new CommonTokenStream(lex);
 * T parser = new T(tokens);
 * TokenStreamRewriter rewriter = new TokenStreamRewriter(tokens);
 * parser.startRule();
 * ```
 *
 * Then in the rules, you can execute (assuming rewriter is visible):
 *
 * ```
 * Token t,u;
 * ...
 * rewriter.insertAfter(t, "text to put after t");}
 * rewriter.insertAfter(u, "text after u");}
 * System.out.println(rewriter.getText());
 * ```
 *
 * You can also have multiple "instruction streams" and get multiple rewrites
 * from a single pass over the input. Just name the instruction streams and use
 * that name again when printing the buffer. This could be useful for generating
 * a C file and also its header file--all from the same buffer:
 *
 * ```
 * rewriter.insertAfter("pass1", t, "text to put after t");}
 * rewriter.insertAfter("pass2", u, "text after u");}
 * System.out.println(rewriter.getText("pass1"));
 * System.out.println(rewriter.getText("pass2"));
 * ```
 *
 * If you don't use named rewrite streams, a "default" stream is used as the
 * first example shows.
 */ class $cc2b5c1f9eca6d60$var$TokenStreamRewriter {
    constructor(tokens){
        this.tokens = tokens;
        this.programs = new Map();
        this.programs.set($cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME, []);
        this.lastRewriteTokenIndexes = new Map();
    }
    getTokenStream() {
        return this.tokens;
    }
    rollback(instructionIndex, programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let is = this.programs.get(programName);
        if (is != null) this.programs.set(programName, is.slice($cc2b5c1f9eca6d60$var$TokenStreamRewriter.MIN_TOKEN_INDEX, instructionIndex));
    }
    deleteProgram(programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        this.rollback($cc2b5c1f9eca6d60$var$TokenStreamRewriter.MIN_TOKEN_INDEX, programName);
    }
    insertAfter(tokenOrIndex, text, programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        // to insert after, just insert before next index (even if past end)
        let rewrites = this.getProgram(programName);
        let op = new $cc2b5c1f9eca6d60$var$InsertAfterOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    insertBefore(tokenOrIndex, text, programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        let rewrites = this.getProgram(programName);
        let op = new $cc2b5c1f9eca6d60$var$InsertBeforeOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    replaceSingle(index, text) {
        if (typeof index === "number") this.replace(index, index, text);
        else this.replace(index, index, text);
    }
    replace(from, to, text, programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (typeof from !== "number") from = from.tokenIndex;
        if (typeof to !== "number") to = to.tokenIndex;
        if (from > to || from < 0 || to < 0 || to >= this.tokens.size) throw new RangeError(`replace: range invalid: ${from}..${to}(size=${this.tokens.size})`);
        let rewrites = this.getProgram(programName);
        let op = new $cc2b5c1f9eca6d60$var$ReplaceOp(this.tokens, from, to, rewrites.length, text);
        rewrites.push(op);
    }
    delete(from, to, programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (to === undefined) to = from;
        if (typeof from === "number") this.replace(from, to, "", programName);
        else this.replace(from, to, "", programName);
    }
    getLastRewriteTokenIndex(programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let I = this.lastRewriteTokenIndexes.get(programName);
        if (I == null) return -1;
        return I;
    }
    setLastRewriteTokenIndex(programName, i) {
        this.lastRewriteTokenIndexes.set(programName, i);
    }
    getProgram(name) {
        let is = this.programs.get(name);
        if (is == null) is = this.initializeProgram(name);
        return is;
    }
    initializeProgram(name) {
        let is = [];
        this.programs.set(name, is);
        return is;
    }
    getText(intervalOrProgram, programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let interval;
        if (intervalOrProgram instanceof $l8y5T.Interval) interval = intervalOrProgram;
        else interval = $l8y5T.Interval.of(0, this.tokens.size - 1);
        if (typeof intervalOrProgram === "string") programName = intervalOrProgram;
        let rewrites = this.programs.get(programName);
        let start = interval.a;
        let stop = interval.b;
        // ensure start/end are in range
        if (stop > this.tokens.size - 1) stop = this.tokens.size - 1;
        if (start < 0) start = 0;
        if (rewrites == null || rewrites.length === 0) return this.tokens.getText(interval); // no instructions to execute
        let buf = [];
        // First, optimize instruction stream
        let indexToOp = this.reduceToSingleOperationPerIndex(rewrites);
        // Walk buffer, executing instructions and emitting tokens
        let i = start;
        while(i <= stop && i < this.tokens.size){
            let op = indexToOp.get(i);
            indexToOp.delete(i); // remove so any left have index size-1
            let t = this.tokens.get(i);
            if (op == null) {
                // no operation at that index, just dump token
                if (t.type !== $eKXi4.Token.EOF) buf.push(String(t.text));
                i++; // move to next token
            } else i = op.execute(buf); // execute operation and skip
        }
        // include stuff after end if it's last index in buffer
        // So, if they did an insertAfter(lastValidIndex, "foo"), include
        // foo if end==lastValidIndex.
        if (stop === this.tokens.size - 1) {
            // Scan any remaining operations after last token
            // should be included (they will be inserts).
            for (let op of indexToOp.values())if (op.index >= this.tokens.size - 1) buf.push(op.text.toString());
        }
        return buf.join("");
    }
    /** We need to combine operations and report invalid operations (like
     *  overlapping replaces that are not completed nested). Inserts to
     *  same index need to be combined etc...  Here are the cases:
     *
     *  I.i.u I.j.v								leave alone, nonoverlapping
     *  I.i.u I.i.v								combine: Iivu
     *
     *  R.i-j.u R.x-y.v	| i-j in x-y			delete first R
     *  R.i-j.u R.i-j.v							delete first R
     *  R.i-j.u R.x-y.v	| x-y in i-j			ERROR
     *  R.i-j.u R.x-y.v	| boundaries overlap	ERROR
     *
     *  Delete special case of replace (text==undefined):
     *  D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
     *
     *  I.i.u R.x-y.v | i in (x+1)-y			delete I (since insert before
     * 											we're not deleting i)
     *  I.i.u R.x-y.v | i not in (x+1)-y		leave alone, nonoverlapping
     *  R.x-y.v I.i.u | i in x-y				ERROR
     *  R.x-y.v I.x.u 							R.x-y.uv (combine, delete I)
     *  R.x-y.v I.i.u | i not in x-y			leave alone, nonoverlapping
     *
     *  I.i.u = insert u before op @ index i
     *  R.x-y.u = replace x-y indexed tokens with u
     *
     *  First we need to examine replaces. For any replace op:
     *
     * 		1. wipe out any insertions before op within that range.
     * 		2. Drop any replace op before that is contained completely within
     * 	 that range.
     * 		3. Throw exception upon boundary overlap with any previous replace.
     *
     *  Then we can deal with inserts:
     *
     * 		1. for any inserts to same index, combine even if not adjacent.
     * 		2. for any prior replace with same left boundary, combine this
     * 	 insert with replace and delete this replace.
     * 		3. throw exception if index in same range as previous replace
     *
     *  Don't actually delete; make op undefined in list. Easier to walk list.
     *  Later we can throw as we add to index &rarr; op map.
     *
     *  Note that I.2 R.2-2 will wipe out I.2 even though, technically, the
     *  inserted stuff would be before the replace range. But, if you
     *  add tokens in front of a method body '{' and then delete the method
     *  body, I think the stuff before the '{' you added should disappear too.
     *
     *  Return a map from token index to operation.
     */ reduceToSingleOperationPerIndex(rewrites) {
        // console.log(`rewrites=[${Utils.join(rewrites, ", ")}]`);
        // WALK REPLACES
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $cc2b5c1f9eca6d60$var$ReplaceOp)) continue;
            let rop = op;
            // Wipe prior inserts within range
            let inserts = this.getKindOfOps(rewrites, $cc2b5c1f9eca6d60$var$InsertBeforeOp, i);
            for (let iop of inserts){
                if (iop.index === rop.index) {
                    // E.g., insert before 2, delete 2..2; update replace
                    // text to include insert before, kill insert
                    rewrites[iop.instructionIndex] = undefined;
                    rop.text = iop.text.toString() + (rop.text != null ? rop.text.toString() : "");
                } else if (iop.index > rop.index && iop.index <= rop.lastIndex) // delete insert as it's a no-op.
                rewrites[iop.instructionIndex] = undefined;
            }
            // Drop any prior replaces contained within
            let prevReplaces = this.getKindOfOps(rewrites, $cc2b5c1f9eca6d60$var$ReplaceOp, i);
            for (let prevRop of prevReplaces){
                if (prevRop.index >= rop.index && prevRop.lastIndex <= rop.lastIndex) {
                    // delete replace as it's a no-op.
                    rewrites[prevRop.instructionIndex] = undefined;
                    continue;
                }
                // throw exception unless disjoint or identical
                let disjoint = prevRop.lastIndex < rop.index || prevRop.index > rop.lastIndex;
                // Delete special case of replace (text==null):
                // D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
                if (prevRop.text == null && rop.text == null && !disjoint) {
                    // console.log(`overlapping deletes: ${prevRop}, ${rop}`);
                    rewrites[prevRop.instructionIndex] = undefined; // kill first delete
                    rop.index = Math.min(prevRop.index, rop.index);
                    rop.lastIndex = Math.max(prevRop.lastIndex, rop.lastIndex);
                // console.log(`new rop ${rop}`);
                } else if (!disjoint) throw new Error(`replace op boundaries of ${rop} overlap with previous ${prevRop}`);
            }
        }
        // WALK INSERTS
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $cc2b5c1f9eca6d60$var$InsertBeforeOp)) continue;
            let iop = op;
            // combine current insert with prior if any at same index
            let prevInserts = this.getKindOfOps(rewrites, $cc2b5c1f9eca6d60$var$InsertBeforeOp, i);
            for (let prevIop of prevInserts)if (prevIop.index === iop.index) {
                if (prevIop instanceof $cc2b5c1f9eca6d60$var$InsertAfterOp) {
                    iop.text = this.catOpText(prevIop.text, iop.text);
                    rewrites[prevIop.instructionIndex] = undefined;
                } else if (prevIop instanceof $cc2b5c1f9eca6d60$var$InsertBeforeOp) {
                    // convert to strings...we're in process of toString'ing
                    // whole token buffer so no lazy eval issue with any templates
                    iop.text = this.catOpText(iop.text, prevIop.text);
                    // delete redundant prior insert
                    rewrites[prevIop.instructionIndex] = undefined;
                }
            }
            // look for replaces where iop.index is in range; error
            let prevReplaces = this.getKindOfOps(rewrites, $cc2b5c1f9eca6d60$var$ReplaceOp, i);
            for (let rop of prevReplaces){
                if (iop.index === rop.index) {
                    rop.text = this.catOpText(iop.text, rop.text);
                    rewrites[i] = undefined; // delete current insert
                    continue;
                }
                if (iop.index >= rop.index && iop.index <= rop.lastIndex) throw new Error(`insert op ${iop} within boundaries of previous ${rop}`);
            }
        }
        // console.log(`rewrites after=[${Utils.join(rewrites, ", ")}]`);
        let m = new Map();
        for (let op of rewrites){
            if (op == null) continue;
            if (m.get(op.index) != null) throw new Error("should only be one op per index");
            m.set(op.index, op);
        }
        // console.log(`index to op: ${m}`);
        return m;
    }
    catOpText(a, b) {
        let x = "";
        let y = "";
        if (a != null) x = a.toString();
        if (b != null) y = b.toString();
        return x + y;
    }
    /** Get all operations before an index of a particular kind */ getKindOfOps(rewrites, kind, before) {
        let ops = [];
        for(let i = 0; i < before && i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (op instanceof kind) ops.push(op);
        }
        return ops;
    }
}
module.exports.TokenStreamRewriter = $cc2b5c1f9eca6d60$var$TokenStreamRewriter;
$cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME = "default";
$cc2b5c1f9eca6d60$var$TokenStreamRewriter.PROGRAM_INIT_SIZE = 100;
$cc2b5c1f9eca6d60$var$TokenStreamRewriter.MIN_TOKEN_INDEX = 0;
// Define the rewrite operation hierarchy
class $cc2b5c1f9eca6d60$var$RewriteOperation {
    constructor(tokens, index, instructionIndex, text){
        this.tokens = tokens;
        this.instructionIndex = instructionIndex;
        this.index = index;
        this.text = text === undefined ? "" : text;
    }
    /** Execute the rewrite operation by possibly adding to the buffer.
     *  Return the index of the next token to operate on.
     */ execute(buf) {
        return this.index;
    }
    toString() {
        let opName = this.constructor.name;
        let $index = opName.indexOf("$");
        opName = opName.substring($index + 1, opName.length);
        return "<" + opName + "@" + this.tokens.get(this.index) + ":\"" + this.text + "\">";
    }
}
$cc2b5c1f9eca6d60$var$__decorate([
    $aN41m.Override
], $cc2b5c1f9eca6d60$var$RewriteOperation.prototype, "toString", null);
module.exports.RewriteOperation = $cc2b5c1f9eca6d60$var$RewriteOperation;
class $cc2b5c1f9eca6d60$var$InsertBeforeOp extends $cc2b5c1f9eca6d60$var$RewriteOperation {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index, instructionIndex, text);
    }
    execute(buf) {
        buf.push(this.text.toString());
        if (this.tokens.get(this.index).type !== $eKXi4.Token.EOF) buf.push(String(this.tokens.get(this.index).text));
        return this.index + 1;
    }
}
$cc2b5c1f9eca6d60$var$__decorate([
    $aN41m.Override
], $cc2b5c1f9eca6d60$var$InsertBeforeOp.prototype, "execute", null);
/** Distinguish between insert after/before to do the "insert afters"
 *  first and then the "insert befores" at same index. Implementation
 *  of "insert after" is "insert before index+1".
 */ class $cc2b5c1f9eca6d60$var$InsertAfterOp extends $cc2b5c1f9eca6d60$var$InsertBeforeOp {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index + 1, instructionIndex, text); // insert after is insert before index+1
    }
}
/** I'm going to try replacing range from x..y with (y-x)+1 ReplaceOp
 *  instructions.
 */ class $cc2b5c1f9eca6d60$var$ReplaceOp extends $cc2b5c1f9eca6d60$var$RewriteOperation {
    constructor(tokens, from, to, instructionIndex, text){
        super(tokens, from, instructionIndex, text);
        this.lastIndex = to;
    }
    execute(buf) {
        if (this.text != null) buf.push(this.text.toString());
        return this.lastIndex + 1;
    }
    toString() {
        if (this.text == null) return "<DeleteOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ">";
        return "<ReplaceOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ":\"" + this.text + "\">";
    }
}
$cc2b5c1f9eca6d60$var$__decorate([
    $aN41m.Override
], $cc2b5c1f9eca6d60$var$ReplaceOp.prototype, "execute", null);
$cc2b5c1f9eca6d60$var$__decorate([
    $aN41m.Override
], $cc2b5c1f9eca6d60$var$ReplaceOp.prototype, "toString", null);

});

parcelRegister("2YAkU", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("edl4x", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("yUeX5", function(module, exports) {

$parcel$export(module.exports, "JQLLexer", () => $6201fadffaeceba5$export$375c79404cc64c7f);
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Generated from JQLLexer.g4 by ANTLR 4.7.3-SNAPSHOT

var $1ztRl = parcelRequire("1ztRl");

var $h7Q3L = parcelRequire("h7Q3L");

var $2160U = parcelRequire("2160U");

var $hBnE1 = parcelRequire("hBnE1");

var $62Uvn = parcelRequire("62Uvn");
class $6201fadffaeceba5$export$375c79404cc64c7f extends (0, $h7Q3L.Lexer) {
    static{
        this.LPAREN = 1;
    }
    static{
        this.RPAREN = 2;
    }
    static{
        this.COMMA = 3;
    }
    static{
        this.LBRACKET = 4;
    }
    static{
        this.RBRACKET = 5;
    }
    static{
        this.BANG = 6;
    }
    static{
        this.LT = 7;
    }
    static{
        this.GT = 8;
    }
    static{
        this.GTEQ = 9;
    }
    static{
        this.LTEQ = 10;
    }
    static{
        this.EQUALS = 11;
    }
    static{
        this.NOT_EQUALS = 12;
    }
    static{
        this.LIKE = 13;
    }
    static{
        this.NOT_LIKE = 14;
    }
    static{
        this.IN = 15;
    }
    static{
        this.IS = 16;
    }
    static{
        this.AND = 17;
    }
    static{
        this.OR = 18;
    }
    static{
        this.NOT = 19;
    }
    static{
        this.EMPTY = 20;
    }
    static{
        this.WAS = 21;
    }
    static{
        this.CHANGED = 22;
    }
    static{
        this.BEFORE = 23;
    }
    static{
        this.AFTER = 24;
    }
    static{
        this.FROM = 25;
    }
    static{
        this.TO = 26;
    }
    static{
        this.ON = 27;
    }
    static{
        this.DURING = 28;
    }
    static{
        this.ORDER = 29;
    }
    static{
        this.BY = 30;
    }
    static{
        this.ASC = 31;
    }
    static{
        this.DESC = 32;
    }
    static{
        this.POSNUMBER = 33;
    }
    static{
        this.NEGNUMBER = 34;
    }
    static{
        this.CUSTOMFIELD = 35;
    }
    static{
        this.RESERVED_WORD = 36;
    }
    static{
        this.STRING = 37;
    }
    static{
        this.MATCHWS = 38;
    }
    static{
        this.ERROR_RESERVED = 39;
    }
    static{
        this.ERRORCHAR = 40;
    }
    static{
        this.QUOTE_STRING = 41;
    }
    static{
        this.UNCLOSED_QUOTE_STRING = 42;
    }
    static{
        this.INVALID_QUOTE_STRING = 43;
    }
    static{
        this.SQUOTE_STRING = 44;
    }
    static{
        this.UNCLOSED_SQUOTE_STRING = 45;
    }
    static{
        this.INVALID_SQUOTE_STRING = 46;
    }
    static{
        this.QUOTED_STR = 1;
    }
    static{
        this.SQUOTED_STR = 2;
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.channelNames = [
            'DEFAULT_TOKEN_CHANNEL',
            'HIDDEN'
        ];
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.modeNames = [
            'DEFAULT_MODE',
            'QUOTED_STR',
            'SQUOTED_STR'
        ];
    }
    static{
        this.ruleNames = [
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'LQUOTE',
            'LSQUOTE',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'QUOTED_CONTENT',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'SQUOTED_CONTENT',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING',
            'VALID_UNQUOTED_CHARS',
            'VALID_QUOTED_CHARS',
            'VALID_SQUOTED_CHARS',
            'RESERVED_CHARS',
            'QUOTE',
            'SQUOTE',
            'BSLASH',
            'NL',
            'CR',
            'SPACE',
            'AMPER',
            'AMPER_AMPER',
            'PIPE',
            'PIPE_PIPE',
            'ESCAPE',
            'NEWLINE',
            'HEXDIGIT',
            'WS',
            'MINUS',
            'DIGIT',
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z'
        ];
    }
    static{
        this._LITERAL_NAMES = [
            undefined,
            "'('",
            "')'",
            "','",
            "'['",
            "']'",
            "'!'",
            "'<'",
            "'>'",
            "'>='",
            "'<='",
            "'='",
            "'!='",
            "'~'",
            "'!~'"
        ];
    }
    static{
        this._SYMBOLIC_NAMES = [
            undefined,
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING'
        ];
    }
    static{
        this.VOCABULARY = new (0, $hBnE1.VocabularyImpl)($6201fadffaeceba5$export$375c79404cc64c7f._LITERAL_NAMES, $6201fadffaeceba5$export$375c79404cc64c7f._SYMBOLIC_NAMES, []);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return $6201fadffaeceba5$export$375c79404cc64c7f.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    constructor(input){
        super(input);
        this._interp = new (0, $2160U.LexerATNSimulator)($6201fadffaeceba5$export$375c79404cc64c7f._ATN, this);
    }
    // @Override
    get grammarFileName() {
        return 'JQLLexer.g4';
    }
    // @Override
    get ruleNames() {
        return $6201fadffaeceba5$export$375c79404cc64c7f.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $6201fadffaeceba5$export$375c79404cc64c7f._serializedATN;
    }
    // @Override
    get channelNames() {
        return $6201fadffaeceba5$export$375c79404cc64c7f.channelNames;
    }
    // @Override
    get modeNames() {
        return $6201fadffaeceba5$export$375c79404cc64c7f.modeNames;
    }
    static{
        this._serializedATNSegments = 3;
    }
    static{
        this._serializedATNSegment0 = "\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x020\u062E\b\x01\b\x01\b\x01\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04\"	\"\x04#	#\x04$	$\x04%	%\x04&	&\x04'	'\x04(	(\x04)	)\x04*	*\x04+	+\x04,	,\x04-	-\x04.	.\x04/	/\x040	0\x041	1\x042	2\x043	3\x044	4\x045	5\x046	6\x047	7\x048	8\x049	9\x04:	:\x04;	;\x04<	<\x04=	=\x04>	>\x04?	?\x04@	@\x04A	A\x04B	B\x04C	C\x04D	D\x04E	E\x04F	F\x04G	G\x04H	H\x04I	I\x04J	J\x04K	K\x04L	L\x04M	M\x04N	N\x04O	O\x04P	P\x04Q	Q\x04R	R\x04S	S\x04T	T\x04U	U\x04V	V\x04W	W\x04X	X\x04Y	Y\x04Z	Z\x04[	[\x04\\	\\\x04]	]\x04^	^\x04_	_\x04`	`\x04a	a\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x05\x03\x05\x03\x06\x03\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03\b\x03\b\x03	\x03	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\f\x03\r\x03\r\x03\r\x03\x0e\x03\x0e\x03\x0f\x03\x0f\x03\x0f\x03\x10\x03\x10\x03\x11\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x03\x13\x03\x13\x03\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x05\x14\xfc\n\x14\x03\x15\x03\x15\x03\x15\x03\x15\x03\x15\x05\x15\u0103\n\x15\x03\x16\x03\x16\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\u0114\n\x17\x03\x18\x03\x18\x03\x18\x03\x18\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03 \x03 \x03 \x03 \x03 \x03 \x03!\x03!\x03!\x03\"\x03\"\x03\"\x03\"\x03#\x03#\x03#\x03#\x03#\x03$\x06$\u0154\n$\r$\x0e$\u0155\x03%\x03%\x06%\u015A\n%\r%\x0e%\u015B\x03&\x03&\x03&\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x05'\u0582\n'\x03(\x03(\x06(\u0586\n(\r(\x0e(\u0587\x03)\x06)\u058B\n)\r)\x0e)\u058C\x03)\x03)\x03*\x03*\x03+\x03+\x03,\x03,\x03,\x03,\x03-\x03-\x05-\u059B\n-\x03-\x03-\x03.\x03.\x03.\x03.\x03/\x03/\x03/\x03/\x030\x030\x030\x030\x031\x031\x051\u05AD\n1\x031\x031\x032\x032\x032\x032\x033\x033\x033\x033\x034\x034\x035\x035\x036\x036\x037\x037\x038\x038\x039\x039\x03:\x03:\x03;\x03;\x03<\x03<\x03=\x03=\x03>\x03>\x03?\x03?\x03?\x03@\x03@\x03A\x03A\x03A\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x05B\u05E3\nB\x03C\x03C\x05C\u05E7\nC\x03D\x03D\x03D\x03D\x03D\x03D\x03D\x05D\u05F0\nD\x03E\x03E\x03E\x05E\u05F5\nE\x03F\x03F\x03G\x03G\x03H\x03H\x03I\x03I\x03J\x03J\x03K\x03K\x03L\x03L\x03M\x03M\x03N\x03N\x03O\x03O\x03P\x03P\x03Q\x03Q\x03R\x03R\x03S\x03S\x03T\x03T\x03U\x03U\x03V\x03V\x03W\x03W\x03X\x03X\x03Y\x03Y\x03Z\x03Z\x03[\x03[\x03\\\x03\\\x03]\x03]\x03^\x03^\x03_\x03_\x03`\x03`\x03a\x03a\x02\x02\x02b\x05\x02\x03\x07\x02\x04	\x02\x05\v\x02\x06\r\x02\x07\x0f\x02\x02\x11\x02\x02\x13\x02\b\x15\x02	\x17\x02\n\x19\x02\v\x1b\x02\f\x1d\x02\r\x1f\x02\x0e!\x02\x0f#\x02\x10%\x02\x11'\x02\x12)\x02\x13+\x02\x14-\x02\x15/\x02\x161\x02\x173\x02\x185\x02\x197\x02\x1a9\x02\x1b;\x02\x1c=\x02\x1d?\x02\x1eA\x02\x1fC\x02 E\x02!G\x02\"I\x02#K\x02$M\x02%O\x02&Q\x02'S\x02(U\x02)W\x02*Y\x02+[\x02\x02]\x02,_\x02-a\x02.c\x02\x02e\x02/g\x020i\x02\x02k\x02\x02m\x02\x02o\x02\x02q\x02\x02s\x02\x02u\x02\x02w\x02\x02y\x02\x02{\x02\x02}\x02\x02\x7f\x02\x02\x81\x02\x02\x83\x02\x02\x85\x02\x02\x87\x02\x02\x89\x02\x02\x8b\x02\x02\x8d\x02\x02\x8f\x02\x02\x91\x02\x02\x93\x02\x02\x95\x02\x02\x97\x02\x02\x99\x02\x02\x9b\x02\x02\x9d\x02\x02\x9f\x02\x02\xa1\x02\x02\xa3\x02\x02\xa5\x02\x02\xa7\x02\x02\xa9\x02\x02\xab\x02\x02\xad\x02\x02\xaf\x02\x02\xb1\x02\x02\xb3\x02\x02\xb5\x02\x02\xb7\x02\x02\xb9\x02\x02\xbb\x02\x02\xbd\x02\x02\xbf\x02\x02\xc1\x02\x02\xc3\x02\x02\x05\x02\x03\x04\"	\x02\x02.11=B]`}\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!$$^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!))^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02%',-11==AB``}}\x7f\x7f\x05\x02ppttvv\x03\x022;\x04\x02CCcc\x04\x02DDdd\x04\x02EEee\x04\x02FFff\x04\x02GGgg\x04\x02HHhh\x04\x02IIii\x04\x02JJjj\x04\x02KKkk\x04\x02LLll\x04\x02MMmm\x04\x02NNnn\x04\x02OOoo\x04\x02PPpp\x04\x02QQqq\x04\x02RRrr\x04\x02SSss\x04\x02TTtt\x04\x02UUuu\x04\x02VVvv\x04\x02WWww\x04\x02XXxx\x04\x02YYyy\x04\x02ZZzz\x04\x02[[{{\x04\x02\\\\||\x02\u06B5\x02\x05\x03\x02\x02\x02\x02\x07\x03\x02\x02\x02\x02	\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03\x02\x02\x02\x02\x0f\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03\x02\x02\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03\x02\x02\x02\x02\x1b\x03\x02\x02\x02\x02\x1d\x03\x02\x02\x02\x02\x1f\x03\x02\x02\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02%\x03\x02\x02\x02\x02'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03\x02\x02\x02\x02-\x03\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02\x02\x023\x03\x02\x02\x02\x025\x03\x02\x02\x02\x027\x03\x02\x02\x02\x029\x03\x02\x02\x02\x02;\x03\x02\x02\x02\x02=\x03\x02\x02\x02\x02?\x03\x02\x02\x02\x02A\x03\x02\x02\x02\x02C\x03\x02\x02\x02\x02E\x03\x02\x02\x02\x02G\x03\x02\x02\x02\x02I\x03\x02\x02\x02\x02K\x03\x02\x02\x02\x02M\x03\x02\x02\x02\x02O\x03\x02\x02\x02\x02Q\x03\x02\x02\x02\x02S\x03\x02\x02\x02\x02U\x03\x02\x02\x02\x02W\x03\x02\x02\x02\x03Y\x03\x02\x02\x02\x03[\x03\x02\x02\x02\x03]\x03\x02\x02\x02\x03_\x03\x02\x02\x02\x04a\x03\x02\x02\x02\x04c\x03\x02\x02\x02\x04e\x03\x02\x02\x02\x04g\x03\x02\x02\x02\x05\xc5\x03\x02\x02\x02\x07\xc7\x03\x02\x02\x02	\xc9\x03\x02\x02\x02\v\xcb\x03\x02\x02\x02\r\xcd\x03\x02\x02\x02\x0f\xcf\x03\x02\x02\x02\x11\xd4\x03\x02\x02\x02\x13\xd9\x03\x02\x02\x02\x15\xdb\x03\x02\x02\x02\x17\xdd\x03\x02\x02\x02\x19\xdf\x03\x02\x02\x02\x1b\xe2\x03\x02\x02\x02\x1d\xe5\x03\x02\x02\x02\x1f\xe7\x03\x02\x02\x02!\xea\x03\x02\x02\x02#\xec\x03\x02\x02\x02%\xef\x03\x02\x02\x02'\xf2\x03\x02\x02\x02)\xfb\x03\x02\x02\x02+\u0102\x03\x02\x02\x02-\u0104\x03\x02\x02\x02/\u0113\x03\x02\x02\x021\u0115\x03\x02\x02\x023\u0119\x03\x02\x02\x025\u0121\x03\x02\x02\x027\u0128\x03\x02\x02\x029\u012E\x03\x02\x02\x02;\u0133\x03\x02\x02\x02=\u0136\x03\x02\x02\x02?\u0139\x03\x02\x02\x02A\u0140\x03\x02\x02\x02C\u0146\x03\x02\x02\x02E\u0149\x03\x02\x02\x02G\u014D\x03\x02\x02\x02I\u0153\x03\x02\x02\x02K\u0157\x03\x02\x02\x02M\u015D\x03\x02\x02\x02O\u0581\x03\x02\x02\x02Q\u0585\x03\x02\x02\x02S\u058A\x03\x02\x02\x02U\u0590\x03\x02\x02\x02W\u0592\x03\x02\x02\x02Y\u0594\x03\x02\x02\x02[\u059A\x03\x02\x02\x02]\u059E\x03\x02\x02\x02_\u05A2\x03\x02\x02\x02a\u05A6\x03\x02\x02\x02c\u05AC\x03\x02\x02\x02e\u05B0\x03\x02\x02\x02g\u05B4\x03\x02\x02\x02i\u05B8\x03\x02\x02\x02k\u05BA\x03\x02\x02\x02m\u05BC\x03\x02\x02\x02o\u05BE\x03\x02\x02\x02q\u05C0\x03\x02\x02\x02s\u05C2\x03\x02\x02\x02u\u05C4\x03\x02\x02\x02w\u05C6\x03\x02\x02\x02y\u05C8\x03\x02\x02\x02{\u05CA\x03\x02\x02\x02}\u05CC\x03\x02\x02\x02\x7f\u05CE\x03\x02\x02\x02\x81\u05D1\x03\x02\x02\x02\x83\u05D3\x03\x02\x02\x02\x85\u05D6\x03\x02\x02\x02\x87\u05E6\x03\x02\x02\x02\x89\u05EF\x03\x02\x02\x02\x8b\u05F4\x03\x02\x02\x02\x8d\u05F6\x03\x02\x02\x02\x8f\u05F8\x03\x02\x02\x02\x91\u05FA\x03\x02\x02\x02\x93\u05FC\x03\x02\x02\x02\x95\u05FE\x03\x02\x02\x02\x97\u0600\x03\x02\x02\x02\x99\u0602\x03\x02\x02\x02\x9b\u0604\x03\x02\x02\x02\x9d\u0606\x03\x02\x02\x02\x9f\u0608\x03\x02\x02\x02\xa1\u060A\x03\x02\x02\x02\xa3\u060C\x03\x02\x02\x02\xa5\u060E\x03\x02\x02\x02\xa7\u0610\x03\x02\x02\x02\xa9\u0612\x03\x02\x02\x02\xab\u0614\x03\x02\x02\x02\xad\u0616\x03\x02\x02\x02\xaf\u0618\x03\x02\x02\x02\xb1\u061A\x03\x02\x02\x02\xb3\u061C\x03\x02\x02\x02\xb5\u061E\x03\x02\x02\x02\xb7\u0620\x03\x02\x02\x02\xb9\u0622\x03\x02\x02\x02\xbb\u0624\x03\x02\x02\x02\xbd\u0626\x03\x02\x02\x02\xbf\u0628\x03\x02\x02\x02\xc1\u062A\x03\x02\x02\x02\xc3\u062C\x03\x02\x02\x02\xc5\xc6\x07*\x02\x02\xc6\x06\x03\x02\x02\x02\xc7\xc8\x07+\x02\x02\xc8\b\x03\x02\x02\x02\xc9\xca\x07.\x02\x02\xca\n\x03\x02\x02\x02\xcb\xcc\x07]\x02\x02\xcc\f\x03\x02\x02\x02\xcd\xce\x07_\x02\x02\xce\x0e\x03\x02\x02\x02\xcf\xd0\x05q8\x02\xd0\xd1\x03\x02\x02\x02\xd1\xd2\b\x07\x02\x02\xd2\xd3\b\x07\x03\x02\xd3\x10\x03\x02\x02\x02\xd4\xd5\x05s9\x02\xd5\xd6\x03\x02\x02\x02\xd6\xd7\b\b\x02\x02\xd7\xd8\b\b\x04\x02\xd8\x12\x03\x02\x02\x02\xd9\xda\x07#\x02\x02\xda\x14\x03\x02\x02\x02\xdb\xdc\x07>\x02\x02\xdc\x16\x03\x02\x02\x02\xdd\xde\x07@\x02\x02\xde\x18\x03\x02\x02\x02\xdf\xe0\x07@\x02\x02\xe0\xe1\x07?\x02\x02\xe1\x1a\x03\x02\x02\x02\xe2\xe3\x07>\x02\x02\xe3\xe4\x07?\x02\x02\xe4\x1c\x03\x02\x02\x02\xe5\xe6\x07?\x02\x02\xe6\x1e\x03\x02\x02\x02\xe7\xe8\x07#\x02\x02\xe8\xe9\x07?\x02\x02\xe9 \x03\x02\x02\x02\xea\xeb\x07\x80\x02\x02\xeb\"\x03\x02\x02\x02\xec\xed\x07#\x02\x02\xed\xee\x07\x80\x02\x02\xee$\x03\x02\x02\x02\xef\xf0\x05\xa1P\x02\xf0\xf1\x05\xabU\x02\xf1&\x03\x02\x02\x02\xf2\xf3\x05\xa1P\x02\xf3\xf4\x05\xb5Z\x02\xf4(\x03\x02\x02\x02\xf5\xf6\x05\x91H\x02\xf6\xf7\x05\xabU\x02\xf7\xf8\x05\x97K\x02\xf8\xfc\x03\x02\x02\x02\xf9\xfc\x05}>\x02\xfa\xfc\x05\x7f?\x02\xfb\xf5\x03\x02\x02\x02\xfb\xf9\x03\x02\x02\x02\xfb\xfa\x03\x02\x02\x02\xfc*\x03\x02\x02\x02\xfd\xfe\x05\xadV\x02\xfe\xff\x05\xb3Y\x02\xff\u0103\x03\x02\x02\x02\u0100\u0103\x05\x81@\x02\u0101\u0103\x05\x83A\x02\u0102\xfd\x03\x02\x02\x02\u0102\u0100\x03\x02\x02\x02\u0102\u0101\x03\x02\x02\x02\u0103";
    }
    static{
        this._serializedATNSegment1 = ",\x03\x02\x02\x02\u0104\u0105\x05\xabU\x02\u0105\u0106\x05\xadV\x02\u0106\u0107\x05\xb7[\x02\u0107.\x03\x02\x02\x02\u0108\u0109\x05\x99L\x02\u0109\u010A\x05\xa9T\x02\u010A\u010B\x05\xafW\x02\u010B\u010C\x05\xb7[\x02\u010C\u010D\x05\xc1`\x02\u010D\u0114\x03\x02\x02\x02\u010E\u010F\x05\xabU\x02\u010F\u0110\x05\xb9\\\x02\u0110\u0111\x05\xa7S\x02\u0111\u0112\x05\xa7S\x02\u0112\u0114\x03\x02\x02\x02\u0113\u0108\x03\x02\x02\x02\u0113\u010E\x03\x02\x02\x02\u01140\x03\x02\x02\x02\u0115\u0116\x05\xbd^\x02\u0116\u0117\x05\x91H\x02\u0117\u0118\x05\xb5Z\x02\u01182\x03\x02\x02\x02\u0119\u011A\x05\x95J\x02\u011A\u011B\x05\x9fO\x02\u011B\u011C\x05\x91H\x02\u011C\u011D\x05\xabU\x02\u011D\u011E\x05\x9dN\x02\u011E\u011F\x05\x99L\x02\u011F\u0120\x05\x97K\x02\u01204\x03\x02\x02\x02\u0121\u0122\x05\x93I\x02\u0122\u0123\x05\x99L\x02\u0123\u0124\x05\x9bM\x02\u0124\u0125\x05\xadV\x02\u0125\u0126\x05\xb3Y\x02\u0126\u0127\x05\x99L\x02\u01276\x03\x02\x02\x02\u0128\u0129\x05\x91H\x02\u0129\u012A\x05\x9bM\x02\u012A\u012B\x05\xb7[\x02\u012B\u012C\x05\x99L\x02\u012C\u012D\x05\xb3Y\x02\u012D8\x03\x02\x02\x02\u012E\u012F\x05\x9bM\x02\u012F\u0130\x05\xb3Y\x02\u0130\u0131\x05\xadV\x02\u0131\u0132\x05\xa9T\x02\u0132:\x03\x02\x02\x02\u0133\u0134\x05\xb7[\x02\u0134\u0135\x05\xadV\x02\u0135<\x03\x02\x02\x02\u0136\u0137\x05\xadV\x02\u0137\u0138\x05\xabU\x02\u0138>\x03\x02\x02\x02\u0139\u013A\x05\x97K\x02\u013A\u013B\x05\xb9\\\x02\u013B\u013C\x05\xb3Y\x02\u013C\u013D\x05\xa1P\x02\u013D\u013E\x05\xabU\x02\u013E\u013F\x05\x9dN\x02\u013F@\x03\x02\x02\x02\u0140\u0141\x05\xadV\x02\u0141\u0142\x05\xb3Y\x02\u0142\u0143\x05\x97K\x02\u0143\u0144\x05\x99L\x02\u0144\u0145\x05\xb3Y\x02\u0145B\x03\x02\x02\x02\u0146\u0147\x05\x93I\x02\u0147\u0148\x05\xc1`\x02\u0148D\x03\x02\x02\x02\u0149\u014A\x05\x91H\x02\u014A\u014B\x05\xb5Z\x02\u014B\u014C\x05\x95J\x02\u014CF\x03\x02\x02\x02\u014D\u014E\x05\x97K\x02\u014E\u014F\x05\x99L\x02\u014F\u0150\x05\xb5Z\x02\u0150\u0151\x05\x95J\x02\u0151H\x03\x02\x02\x02\u0152\u0154\x05\x8fG\x02\u0153\u0152\x03\x02\x02\x02\u0154\u0155\x03\x02\x02\x02\u0155\u0153\x03\x02\x02\x02\u0155\u0156\x03\x02\x02\x02\u0156J\x03\x02\x02\x02\u0157\u0159\x05\x8dF\x02\u0158\u015A\x05\x8fG\x02\u0159\u0158\x03\x02\x02\x02\u015A\u015B\x03\x02\x02\x02\u015B\u0159\x03\x02\x02\x02\u015B\u015C\x03\x02\x02\x02\u015CL\x03\x02\x02\x02\u015D\u015E\x05\x95J\x02\u015E\u015F\x05\x9bM\x02\u015FN\x03\x02\x02\x02\u0160\u0161\x05\x91H\x02\u0161\u0162\x05\x93I\x02\u0162\u0163\x05\xadV\x02\u0163\u0164\x05\xb3Y\x02\u0164\u0165\x05\xb7[\x02\u0165\u0582\x03\x02\x02\x02\u0166\u0167\x05\x91H\x02\u0167\u0168\x05\x95J\x02\u0168\u0169\x05\x95J\x02\u0169\u016A\x05\x99L\x02\u016A\u016B\x05\xb5Z\x02\u016B\u016C\x05\xb5Z\x02\u016C\u0582\x03\x02\x02\x02\u016D\u016E\x05\x91H\x02\u016E\u016F\x05\x97K\x02\u016F\u0170\x05\x97K\x02\u0170\u0582\x03\x02\x02\x02\u0171\u0172\x05\x91H\x02\u0172\u0173\x05\xa7S\x02\u0173\u0174\x05\xa1P\x02\u0174\u0175\x05\x91H\x02\u0175\u0176\x05\xb5Z\x02\u0176\u0582\x03\x02\x02\x02\u0177\u0178\x05\x91H\x02\u0178\u0179\x05\xa7S\x02\u0179\u017A\x05\xb7[\x02\u017A\u017B\x05\x99L\x02\u017B\u017C\x05\xb3Y\x02\u017C\u0582\x03\x02\x02\x02\u017D\u017E\x05\x91H\x02\u017E\u017F\x05\xabU\x02\u017F\u0180\x05\xc1`\x02\u0180\u0582\x03\x02\x02\x02\u0181\u0182\x05\x91H\x02\u0182\u0183\x05\xb5Z\x02\u0183\u0582\x03\x02\x02\x02\u0184\u0185\x05\x91H\x02\u0185\u0186\x05\xb9\\\x02\u0186\u0187\x05\x97K\x02\u0187\u0188\x05\xa1P\x02\u0188\u0189\x05\xb7[\x02\u0189\u0582\x03\x02\x02\x02\u018A\u018B\x05\x91H\x02\u018B\u018C\x05\xbb]\x02\u018C\u018D\x05\x9dN\x02\u018D\u0582\x03\x02\x02\x02\u018E\u018F\x05\x93I\x02\u018F\u0190\x05\x99L\x02\u0190\u0191\x05\x9dN\x02\u0191\u0192\x05\xa1P\x02\u0192\u0193\x05\xabU\x02\u0193\u0582\x03\x02\x02\x02\u0194\u0195\x05\x93I\x02\u0195\u0196\x05\x99L\x02\u0196\u0197\x05\xb7[\x02\u0197\u0198\x05\xbd^\x02\u0198\u0199\x05\x99L\x02\u0199\u019A\x05\x99L\x02\u019A\u019B\x05\xabU\x02\u019B\u0582\x03\x02\x02\x02\u019C\u019D\x05\x93I\x02\u019D\u019E\x05\xadV\x02\u019E\u019F\x05\xadV\x02\u019F\u01A0\x05\xa7S\x02\u01A0\u01A1\x05\x99L\x02\u01A1\u01A2\x05\x91H\x02\u01A2\u01A3\x05\xabU\x02\u01A3\u0582\x03\x02\x02\x02\u01A4\u01A5\x05\x93I\x02\u01A5\u01A6\x05\xb3Y\x02\u01A6\u01A7\x05\x99L\x02\u01A7\u01A8\x05\x91H\x02\u01A8\u01A9\x05\xa5R\x02\u01A9\u0582\x03\x02\x02\x02\u01AA\u01AB\x05\x93I\x02\u01AB\u01AC\x05\xc1`\x02\u01AC\u01AD\x05\xb7[\x02\u01AD\u01AE\x05\x99L\x02\u01AE\u0582\x03\x02\x02\x02\u01AF\u01B0\x05\x95J\x02\u01B0\u01B1\x05\x91H\x02\u01B1\u01B2\x05\xb7[\x02\u01B2\u01B3\x05\x95J\x02\u01B3\u01B4\x05\x9fO\x02\u01B4\u0582\x03\x02\x02\x02\u01B5\u01B6\x05\x95J\x02\u01B6\u01B7\x05\x9fO\x02\u01B7\u01B8\x05\x91H\x02\u01B8\u01B9\x05\xb3Y\x02\u01B9\u0582\x03\x02\x02\x02\u01BA\u01BB\x05\x95J\x02\u01BB\u01BC\x05\x9fO\x02\u01BC\u01BD\x05\x91H\x02\u01BD\u01BE\x05\xb3Y\x02\u01BE\u01BF\x05\x91H\x02\u01BF\u01C0\x05\x95J\x02\u01C0\u01C1\x05\xb7[\x02\u01C1\u01C2\x05\x99L\x02\u01C2\u01C3\x05\xb3Y\x02\u01C3\u0582\x03\x02\x02\x02\u01C4\u01C5\x05\x95J\x02\u01C5\u01C6\x05\x9fO\x02\u01C6\u01C7\x05\x99L\x02\u01C7\u01C8\x05\x95J\x02\u01C8\u01C9\x05\xa5R\x02\u01C9\u0582\x03\x02\x02\x02\u01CA\u01CB\x05\x95J\x02\u01CB\u01CC\x05\x9fO\x02\u01CC\u01CD\x05\x99L\x02\u01CD\u01CE\x05\x95J\x02\u01CE\u01CF\x05\xa5R\x02\u01CF\u01D0\x05\xafW\x02\u01D0\u01D1\x05\xadV\x02\u01D1\u01D2\x05\xa1P\x02\u01D2\u01D3\x05\xabU\x02\u01D3\u01D4\x05\xb7[\x02\u01D4\u0582\x03\x02\x02\x02\u01D5\u01D6\x05\x95J\x02\u01D6\u01D7\x05\xadV\x02\u01D7\u01D8\x05\xa7S\x02\u01D8\u01D9\x05\xa7S\x02\u01D9\u01DA\x05\x91H\x02\u01DA\u01DB\x05\xb7[\x02\u01DB\u01DC\x05\x99L\x02\u01DC\u0582\x03\x02\x02\x02\u01DD\u01DE\x05\x95J\x02\u01DE\u01DF\x05\xadV\x02\u01DF\u01E0\x05\xa7S\x02\u01E0\u01E1\x05\xa7S\x02\u01E1\u01E2\x05\x91H\x02\u01E2\u01E3\x05\xb7[\x02\u01E3\u01E4\x05\xa1P\x02\u01E4\u01E5\x05\xadV\x02\u01E5\u01E6\x05\xabU\x02\u01E6\u0582\x03\x02\x02\x02\u01E7\u01E8\x05\x95J\x02\u01E8\u01E9\x05\xadV\x02\u01E9\u01EA\x05\xa7S\x02\u01EA\u01EB\x05\xb9\\\x02\u01EB\u01EC\x05\xa9T\x02\u01EC\u01ED\x05\xabU\x02\u01ED\u0582\x03\x02\x02\x02\u01EE\u01EF\x05\x95J\x02\u01EF\u01F0\x05\xadV\x02\u01F0\u01F1\x05\xa9T\x02\u01F1\u01F2\x05\xa9T\x02\u01F2\u01F3\x05\xa1P\x02\u01F3\u01F4\x05\xb7[\x02\u01F4\u0582\x03\x02\x02\x02\u01F5\u01F6\x05\x95J\x02\u01F6\u01F7\x05\xadV\x02\u01F7\u01F8\x05\xabU\x02\u01F8\u01F9\x05\xabU\x02\u01F9\u01FA\x05\x99L\x02\u01FA\u01FB\x05\x95J\x02\u01FB\u01FC\x05\xb7[\x02\u01FC\u0582\x03\x02\x02\x02\u01FD\u01FE\x05\x95J\x02\u01FE\u01FF\x05\xadV\x02\u01FF\u0200\x05\xabU\x02\u0200\u0201\x05\xb7[\x02\u0201\u0202\x05\xa1P\x02\u0202\u0203\x05\xabU\x02\u0203\u0204\x05\xb9\\\x02\u0204\u0205\x05\x99L\x02\u0205\u0582\x03\x02\x02\x02\u0206\u0207\x05\x95J\x02\u0207\u0208\x05\xadV\x02\u0208\u0209\x05\xb9\\\x02\u0209\u020A\x05\xabU\x02\u020A\u020B\x05\xb7[\x02\u020B\u0582\x03\x02\x02\x02\u020C\u020D\x05\x95J\x02\u020D\u020E\x05\xb3Y\x02\u020E\u020F\x05\x99L\x02\u020F\u0210\x05\x91H\x02\u0210\u0211\x05\xb7[\x02\u0211\u0212\x05\x99L\x02\u0212\u0582\x03\x02\x02\x02\u0213\u0214\x05\x95J\x02\u0214\u0215\x05\xb9\\\x02\u0215\u0216\x05\xb3Y\x02\u0216\u0217\x05\xb3Y\x02\u0217\u0218\x05\x99L\x02\u0218\u0219\x05\xabU\x02\u0219\u021A\x05\xb7[\x02\u021A\u0582\x03\x02\x02\x02\u021B\u021C\x05\x97K\x02\u021C\u021D\x05\x91H\x02\u021D\u021E\x05\xb7[\x02\u021E\u021F\x05\x99L\x02\u021F\u0582\x03\x02\x02\x02\u0220\u0221\x05\x97K\x02\u0221\u0222\x05\x99L\x02\u0222\u0223\x05\x95J\x02\u0223\u0224\x05\xa1P\x02\u0224\u0225\x05\xa9T\x02\u0225\u0226\x05\x91H\x02\u0226\u0227\x05\xa7S\x02\u0227\u0582\x03\x02\x02\x02\u0228\u0229\x05\x97K\x02\u0229\u022A\x05\x99L\x02\u022A\u022B\x05\x95J\x02\u022B\u022C\x05\xa7S\x02\u022C\u022D\x05\x91H\x02\u022D\u022E\x05\xb3Y\x02\u022E\u022F\x05\x99L\x02\u022F\u0582\x03\x02\x02\x02\u0230\u0231\x05\x97K\x02\u0231\u0232\x05\x99L\x02\u0232\u0233\x05\x95J\x02\u0233\u0234\x05\xb3Y\x02\u0234\u0235\x05\x99L\x02\u0235\u0236\x05\xa9T\x02\u0236\u0237\x05\x99L\x02\u0237\u0238\x05\xabU\x02\u0238\u0239\x05\xb7[\x02\u0239\u0582\x03\x02\x02\x02\u023A\u023B\x05\x97K\x02\u023B\u023C\x05\x99L\x02\u023C\u023D\x05\x9bM\x02\u023D\u023E\x05\x91H\x02\u023E\u023F\x05\xb9\\\x02\u023F\u0240\x05\xa7S\x02\u0240\u0241\x05\xb7[\x02\u0241\u0582\x03\x02\x02\x02\u0242\u0243\x05\x97K\x02\u0243\u0244\x05\x99L\x02\u0244\u0245\x05\x9bM\x02\u0245\u0246\x05\x91H\x02\u0246\u0247\x05\xb9\\\x02\u0247\u0248\x05\xa7S\x02\u0248\u0249\x05\xb7[\x02\u0249\u024A\x05\xb5Z\x02\u024A\u0582\x03\x02\x02\x02\u024B\u024C\x05\x97K\x02\u024C\u024D\x05\x99L\x02\u024D\u024E\x05\x9bM\x02\u024E\u024F\x05\xa1P\x02\u024F\u0250\x05\xabU\x02\u0250\u0251\x05\x99L\x02\u0251\u0582\x03\x02\x02\x02\u0252\u0253\x05\x97K\x02\u0253\u0254\x05\x99L\x02\u0254\u0255\x05\xa7S\x02\u0255\u0256\x05\x99L\x02\u0256\u0257\x05\xb7[\x02\u0257\u0258\x05\x99L\x02\u0258\u0582\x03\x02\x02\x02\u0259\u025A\x05\x97K\x02\u025A\u025B\x05\x99L\x02\u025B\u025C\x05\xa7S\x02\u025C\u025D\x05\xa1P\x02\u025D\u025E\x05\xa9T\x02\u025E\u025F\x05\xa1P\x02\u025F\u0260\x05\xb7[\x02\u0260\u0261\x05\x99L\x02\u0261\u0262\x05\xb3Y\x02\u0262\u0582\x03\x02\x02\x02\u0263\u0264\x05\x97K\x02\u0264\u0265\x05\xa1P\x02\u0265\u0266\x05\x9bM\x02\u0266\u0267\x05\x9bM\x02\u0267\u0268\x05\x99L\x02\u0268\u0269\x05\xb3Y\x02\u0269\u026A\x05\x99L\x02\u026A\u026B\x05\xabU\x02\u026B\u026C\x05\x95J\x02\u026C\u026D\x05\x99L\x02\u026D\u0582\x03\x02\x02\x02\u026E\u026F\x05\x97K\x02\u026F\u0270\x05\xa1P\x02\u0270\u0271\x05\xb5Z\x02\u0271\u0272\x05\xb7[\x02\u0272\u0273\x05\xa1P\x02\u0273\u0274\x05\xabU\x02\u0274\u0275\x05\x95J\x02\u0275\u0276\x05\xb7[\x02\u0276\u0582\x03\x02\x02\x02\u0277\u0278\x05\x97K\x02\u0278\u0279\x05\xa1P\x02\u0279\u027A\x05\xbb]\x02\u027A\u027B\x05\xa1P\x02\u027B\u027C\x05\x97K\x02\u027C\u027D\x05\x99L\x02\u027D\u0582\x03\x02\x02\x02\u027E\u027F\x05\x97K\x02\u027F\u0280\x05\xadV\x02\u0280\u0582\x03\x02\x02\x02\u0281\u0282\x05\x97K\x02\u0282\u0283\x05\xadV\x02\u0283\u0284\x05\xb9\\\x02\u0284\u0285\x05\x93I\x02\u0285\u0286\x05\xa7S\x02\u0286\u0287\x05\x99L\x02\u0287\u0582\x03\x02\x02\x02\u0288\u0289\x05\x97K\x02\u0289\u028A\x05\xb3Y\x02\u028A\u028B\x05\xadV\x02\u028B\u028C\x05\xafW\x02\u028C\u0582\x03\x02\x02\x02\u028D\u028E\x05\x99L\x02\u028E\u028F\x05\xa7S\x02\u028F\u0290\x05\xb5Z\x02\u0290\u0291\x05\x99L\x02\u0291\u0582\x03\x02\x02\x02\u0292\u0293\x05\x99L\x02\u0293\u0294\x05\xabU\x02\u0294\u0295\x05\x95J\x02\u0295\u0296\x05\xadV\x02\u0296\u0297\x05\x97K\x02\u0297\u0298\x05\xa1P\x02\u0298\u0299\x05\xabU\x02\u0299\u029A\x05\x9dN\x02\u029A\u0582\x03\x02\x02\x02\u029B\u029C\x05\x99L\x02\u029C\u029D\x05\xabU\x02\u029D\u029E\x05\x97K\x02\u029E\u0582\x03\x02\x02\x02\u029F\u02A0\x05\x99L\x02\u02A0\u02A1\x05\xb1X\x02\u02A1\u02A2\x05\xb9\\\x02\u02A2\u02A3\x05\x91H\x02\u02A3\u02A4\x05\xa7S\x02\u02A4\u02A5\x05\xb5Z\x02\u02A5\u0582\x03\x02\x02\x02\u02A6\u02A7\x05\x99L\x02\u02A7\u02A8\x05\xb5Z\x02\u02A8\u02A9\x05\x95J\x02\u02A9\u02AA\x05\x91H\x02\u02AA\u02AB\x05\xafW\x02\u02AB\u02AC\x05\x99L\x02\u02AC\u0582\x03\x02\x02\x02\u02AD\u02AE\x05\x99L\x02\u02AE\u02AF\x05\xbf_\x02\u02AF\u02B0\x05\x95J\x02\u02B0\u02B1\x05\xa7S\x02\u02B1\u02B2\x05\xb9\\\x02\u02B2\u02B3\x05\xb5Z\x02\u02B3\u02B4\x05\xa1P\x02\u02B4\u02B5\x05\xbb]\x02\u02B5\u02B6\x05\x99L\x02\u02B6\u0582\x03\x02\x02\x02\u02B7\u02B8\x05\x99L\x02\u02B8\u02B9\x05\xbf_\x02\u02B9\u02BA\x05\x99L\x02\u02BA\u02BB\x05\x95J\x02\u02BB\u0582\x03\x02\x02\x02\u02BC\u02BD\x05\x99L\x02\u02BD\u02BE\x05\xbf_\x02\u02BE\u02BF\x05\x99L\x02\u02BF\u02C0\x05\x95J\x02\u02C0\u02C1\x05\xb9\\\x02\u02C1\u02C2\x05\xb7[\x02\u02C2\u02C3\x05\x99L\x02\u02C3\u0582\x03\x02\x02\x02\u02C4\u02C5\x05\x99L\x02\u02C5\u02C6\x05\xbf_\x02\u02C6\u02C7\x05\xa1P\x02\u02C7\u02C8\x05\xb5Z\x02\u02C8\u02C9\x05\xb7[\x02\u02C9\u02CA\x05\xb5Z\x02\u02CA\u0582\x03\x02\x02\x02\u02CB\u02CC\x05\x99L\x02\u02CC\u02CD\x05\xbf_\x02\u02CD\u02CE\x05\xafW\x02\u02CE\u02CF\x05\xa7S\x02\u02CF\u02D0\x05\x91H\x02\u02D0\u02D1\x05\xa1P\x02\u02D1\u02D2\x05\xabU\x02\u02D2\u0582\x03\x02\x02\x02\u02D3\u02D4\x05\x9bM\x02\u02D4\u02D5\x05\x91H\x02\u02D5\u02D6\x05\xa7S\x02\u02D6\u02D7\x05\xb5Z\x02\u02D7\u02D8\x05\x99L\x02\u02D8\u0582\x03\x02\x02\x02\u02D9\u02DA\x05\x9bM\x02\u02DA\u02DB\x05\x99L\x02\u02DB\u02DC\x05\xb7[\x02\u02DC\u02DD\x05\x95J\x02\u02DD\u02DE\x05\x9fO\x02\u02DE\u0582\x03\x02\x02\x02\u02DF\u02E0\x05\x9bM\x02\u02E0\u02E1\x05\xa1P\x02\u02E1\u02E2\x05\xa7S\x02\u02E2\u02E3\x05\x99L\x02\u02E3\u0582\x03\x02\x02\x02\u02E4\u02E5\x05\x9bM\x02\u02E5\u02E6\x05\xa1P\x02\u02E6\u02E7\x05\x99L\x02\u02E7\u02E8\x05\xa7S\x02\u02E8\u02E9\x05\x97K\x02\u02E9\u0582\x03\x02\x02\x02\u02EA\u02EB\x05\x9bM\x02\u02EB\u02EC\x05\xa1P\x02\u02EC\u02ED\x05\xb3Y\x02\u02ED\u02EE\x05\xb5Z\x02\u02EE\u02EF\x05\xb7[\x02\u02EF\u0582\x03\x02\x02\x02\u02F0\u02F1\x05\x9bM\x02\u02F1\u02F2\x05\xa7S\x02\u02F2\u02F3\x05\xadV\x02\u02F3\u02F4\x05\x91H\x02\u02F4\u02F5\x05\xb7[\x02\u02F5\u0582\x03\x02\x02\x02\u02F6\u02F7\x05\x9bM\x02\u02F7\u02F8\x05\xadV\x02\u02F8\u02F9\x05\xb3Y\x02\u02F9\u0582\x03\x02\x02\x02\u02FA\u02FB\x05\x9bM\x02\u02FB\u02FC\x05\xb9\\\x02\u02FC\u02FD\x05\xabU\x02\u02FD\u02FE\x05\x95J\x02\u02FE\u02FF\x05\xb7[\x02\u02FF\u0300\x05\xa1P\x02\u0300\u0301\x05\xadV\x02\u0301\u0302\x05\xabU\x02\u0302\u0582\x03\x02\x02\x02\u0303\u0304\x05\x9dN\x02\u0304\u0305\x05\xadV\x02\u0305\u0582\x03\x02\x02\x02\u0306\u0307\x05\x9dN\x02\u0307\u0308\x05\xadV\x02\u0308\u0309\x05\xb7[\x02\u0309\u030A\x05\xadV\x02\u030A\u0582\x03\x02\x02\x02\u030B\u030C\x05\x9dN\x02\u030C\u030D\x05\xb3Y\x02\u030D\u030E\x05\x91H\x02\u030E\u030F\x05\xabU\x02\u030F\u0310\x05\xb7[\x02\u0310\u0582\x03\x02\x02\x02\u0311\u0312\x05\x9dN\x02\u0312\u0313\x05\xb3Y\x02\u0313\u0314\x05\x99L\x02\u0314\u0315\x05\x91H\x02\u0315\u0316\x05\xb7[\x02\u0316\u0317\x05\x99L\x02\u0317\u0318\x05\xb3Y\x02\u0318\u0582\x03\x02\x02\x02\u0319\u031A\x05\x9dN\x02\u031A\u031B\x05\xb3Y\x02\u031B\u031C\x05\xadV\x02\u031C\u031D\x05\xb9\\\x02\u031D\u031E\x05\xafW\x02\u031E\u0582\x03\x02\x02\x02\u031F\u0320\x05\x9fO\x02\u0320\u0321\x05\x91H\x02\u0321\u0322\x05\xbb]\x02\u0322\u0323\x05\xa1P\x02\u0323\u0324\x05\xabU\x02\u0324\u0325\x05\x9dN\x02\u0325\u0582\x03\x02\x02\x02\u0326\u0327\x05\xa1P\x02\u0327\u0328\x05\x97K\x02\u0328\u0329\x05\x99L\x02\u0329\u032A\x05\xabU\x02\u032A\u032B\x05\xb7[\x02\u032B\u032C\x05\xa1P\x02\u032C\u032D\x05\x9bM\x02\u032D\u032E\x05\xa1P\x02\u032E\u032F\x05\x99L\x02\u032F\u0330\x05\x97K\x02\u0330\u0582\x03\x02\x02\x02\u0331\u0332\x05\xa1P\x02\u0332\u0333\x05\x9bM\x02\u0333\u0582\x03\x02\x02\x02\u0334\u0335\x05\xa1P\x02\u0335\u0336\x05\xa9T\x02\u0336\u0337\x05\xa9T\x02\u0337\u0338\x05\x99L\x02\u0338\u0339\x05\x97K\x02\u0339\u033A\x05\xa1P\x02\u033A\u033B\x05\x91H\x02\u033B\u033C\x05\xb7[\x02\u033C\u033D\x05\x99L\x02\u033D\u0582\x03\x02\x02\x02\u033E\u033F\x05\xa1P\x02\u033F\u0340\x05\xabU\x02\u0340\u0341\x05\x95J\x02\u0341\u0342\x05\xb3Y\x02\u0342\u0343\x05\x99L\x02\u0343\u0344\x05\xa9T\x02\u0344\u0345\x05\x99L\x02\u0345\u0346\x05\xabU\x02\u0346\u0347\x05\xb7[\x02\u0347\u0582\x03\x02\x02\x02\u0348\u0349\x05\xa1P\x02\u0349\u034A\x05\xabU\x02\u034A\u034B\x05\x97K\x02\u034B\u034C\x05\x99L\x02\u034C\u034D\x05\xbf_\x02\u034D\u0582\x03\x02\x02\x02\u034E\u034F\x05\xa1P\x02\u034F\u0350\x05\xabU\x02\u0350\u0351\x05\xa1P\x02\u0351\u0352\x05\xb7[\x02\u0352\u0353\x05\xa1P\x02\u0353\u0354\x05\x91H\x02\u0354\u0355\x05\xa7S\x02\u0355\u0582\x03\x02\x02\x02\u0356\u0357\x05\xa1P\x02\u0357\u0358\x05\xabU\x02\u0358\u0359\x05\xabU\x02\u0359\u035A\x05\x99L\x02\u035A\u035B\x05\xb3Y\x02\u035B\u0582\x03\x02\x02\x02\u035C\u035D\x05\xa1P\x02\u035D\u035E\x05\xabU\x02\u035E\u035F\x05\xadV\x02\u035F\u0360\x05\xb9\\\x02\u0360\u0361\x05\xb7[\x02\u0361\u0582\x03\x02\x02\x02\u0362\u0363\x05\xa1P\x02\u0363\u0364\x05\xabU\x02\u0364\u0365\x05\xafW\x02\u0365\u0366\x05\xb9\\\x02\u0366\u0367\x05\xb7[\x02\u0367\u0582\x03\x02\x02\x02\u0368\u0369\x05\xa1P\x02\u0369\u036A\x05\xabU\x02\u036A\u036B\x05\xb5Z\x02\u036B\u036C\x05\x99L\x02\u036C\u036D\x05\xb3Y\x02\u036D\u036E\x05\xb7[\x02\u036E\u0582\x03\x02\x02\x02\u036F\u0370\x05\xa1P\x02\u0370\u0371\x05\xabU\x02\u0371\u0372\x05\xb7[\x02\u0372\u0582\x03\x02\x02\x02\u0373\u0374\x05\xa1P\x02\u0374\u0375\x05\xabU\x02\u0375\u0376\x05\xb7[\x02\u0376\u0377\x05\x99L\x02\u0377\u0378\x05\x9dN\x02\u0378\u0379\x05\x99L\x02\u0379\u037A\x05\xb3Y\x02\u037A\u0582\x03\x02\x02\x02\u037B\u037C\x05\xa1P\x02\u037C\u037D\x05\xabU\x02\u037D\u037E\x05\xb7[\x02\u037E\u037F\x05\x99L\x02\u037F\u0380\x05\xb3Y\x02\u0380\u0381\x05\xb5Z\x02\u0381\u0382\x05\x99L\x02\u0382\u0383\x05\x95J\x02\u0383\u0384\x05\xb7[\x02\u0384\u0582\x03\x02\x02\x02\u0385\u0386\x05\xa1P\x02\u0386\u0387\x05\xabU\x02\u0387\u0388\x05\xb7[\x02\u0388\u0389\x05\x99L\x02\u0389\u038A\x05\xb3Y\x02\u038A\u038B\x05\xb5Z\x02\u038B\u038C\x05\x99L\x02\u038C\u038D\x05\x95J\x02\u038D\u038E\x05\xb7[\x02\u038E\u038F\x05\xa1P\x02\u038F\u0390\x05\xadV\x02\u0390\u0391\x05\xabU\x02\u0391\u0582\x03\x02\x02\x02\u0392\u0393\x05\xa1P\x02\u0393\u0394\x05\xabU\x02\u0394\u0395\x05\xb7[\x02\u0395\u0396\x05\xadV\x02\u0396\u0582\x03\x02\x02\x02\u0397\u0398\x05\xa1P\x02\u0398\u0399\x05\xb5Z\x02\u0399\u039A\x05\x99L\x02\u039A\u039B\x05\xa9T\x02\u039B\u039C\x05\xafW\x02\u039C\u039D\x05\xb7[\x02\u039D\u039E\x05\xc1`\x02\u039E\u0582\x03\x02\x02\x02\u039F\u03A0\x05\xa1P\x02\u03A0\u03A1\x05\xb5Z\x02\u03A1\u03A2\x05\xabU\x02\u03A2\u03A3\x05\xb9\\\x02\u03A3\u03A4\x05\xa7S\x02\u03A4\u03A5\x05\xa7S\x02\u03A5\u0582\x03\x02\x02\x02\u03A6\u03A7\x05\xa3Q\x02\u03A7\u03A8\x05\xadV\x02\u03A8\u03A9\x05\xa1P\x02\u03A9\u03AA\x05\xabU\x02\u03AA\u0582\x03\x02\x02\x02\u03AB\u03AC\x05\xa7S\x02\u03AC\u03AD\x05\x91H\x02\u03AD\u03AE\x05\xb5Z\x02\u03AE\u03AF\x05\xb7[\x02\u03AF\u0582\x03\x02\x02\x02\u03B0\u03B1\x05\xa7S\x02\u03B1\u03B2\x05\x99L\x02\u03B2\u03B3\x05\x9bM\x02\u03B3\u03B4\x05\xb7[\x02\u03B4\u0582\x03\x02\x02\x02\u03B5\u03B6\x05\xa7S\x02\u03B6\u03B7\x05\x99L\x02\u03B7\u03B8\x05\xb5Z\x02\u03B8\u03B9\x05\xb5Z\x02\u03B9\u0582\x03\x02\x02\x02\u03BA\u03BB\x05\xa7S\x02\u03BB\u03BC\x05\xa1P\x02\u03BC\u03BD\x05\xa5R\x02\u03BD\u03BE\x05\x99L\x02\u03BE\u0582\x03\x02\x02\x02\u03BF\u03C0\x05\xa7S\x02\u03C0\u03C1\x05\xa1P\x02\u03C1\u03C2\x05\xa9T\x02\u03C2\u03C3\x05\xa1P\x02\u03C3\u03C4\x05\xb7[\x02\u03C4\u0582\x03\x02\x02\x02\u03C5\u03C6\x05\xa7S\x02\u03C6\u03C7\x05\xadV\x02\u03C7\u03C8\x05\x95J\x02\u03C8\u03C9\x05\xa5R\x02\u03C9\u0582\x03\x02\x02\x02\u03CA\u03CB\x05\xa7S\x02\u03CB\u03CC\x05\xadV\x02\u03CC\u03CD\x05\xabU\x02\u03CD\u03CE\x05\x9dN\x02\u03CE\u0582\x03\x02\x02\x02\u03CF\u03D0\x05\xa9T\x02\u03D0\u03D1\x05\x91H\x02\u03D1\u03D2\x05\xbf_\x02\u03D2\u0582\x03\x02\x02\x02\u03D3\u03D4\x05\xa9T\x02\u03D4\u03D5\x05\xa1P\x02\u03D5\u03D6\x05\xabU\x02\u03D6\u0582\x03\x02\x02\x02\u03D7\u03D8\x05\xa9T\x02\u03D8\u03D9\x05\xa1P\x02\u03D9\u03DA\x05\xabU\x02\u03DA\u03DB\x05\xb9\\\x02\u03DB\u03DC\x05\xb5Z\x02\u03DC\u0582\x03\x02\x02\x02\u03DD\u03DE\x05\xa9T\x02\u03DE\u03DF\x05\xadV\x02\u03DF\u03E0\x05\x97K\x02\u03E0\u03E1\x05\x99L\x02\u03E1\u0582\x03\x02\x02\x02\u03E2\u03E3\x05\xa9T\x02\u03E3\u03E4\x05\xadV\x02\u03E4\u03E5\x05\x97K\x02\u03E5\u03E6\x05\xa1P\x02\u03E6\u03E7\x05\x9bM\x02\u03E7\u03E8\x05\xc1`\x02\u03E8\u0582\x03\x02\x02\x02\u03E9\u03EA\x05\xa9T\x02\u03EA\u03EB\x05\xadV\x02\u03EB\u03EC\x05\x97K\x02\u03EC\u03ED\x05\xb9\\\x02\u03ED\u03EE\x05\xa7S\x02\u03EE\u03EF\x05\xadV\x02\u03EF\u0582\x03\x02\x02\x02\u03F0\u03F1\x05\xa9T\x02\u03F1\u03F2\x05\xadV\x02\u03F2\u03F3\x05\xb3Y\x02\u03F3\u03F4\x05\x99L\x02\u03F4\u0582\x03\x02\x02\x02\u03F5\u03F6\x05\xa9T\x02\u03F6\u03F7\x05\xb9\\\x02\u03F7\u03F8\x05\xa7S\x02\u03F8\u03F9\x05\xb7[\x02\u03F9\u03FA\x05\xa1P\x02\u03FA\u03FB\x05\xafW\x02\u03FB\u03FC\x05\xa7S\x02\u03FC\u03FD\x05\xc1`\x02\u03FD\u0582\x03\x02\x02\x02\u03FE\u03FF\x05\xabU\x02\u03FF\u0400\x05\x99L\x02\u0400\u0401\x05\xbf_\x02\u0401\u0402\x05\xb7[\x02\u0402\u0582\x03\x02\x02\x02\u0403\u0404\x05\xabU\x02\u0404\u0405\x05\xadV\x02\u0405\u0406\x05\x91H\x02\u0406\u0407\x05\xb9\\\x02\u0407\u0408\x05\x97K\x02\u0408\u0409\x05\xa1P\x02\u0409\u040A\x05\xb7[\x02\u040A\u0582\x03\x02\x02\x02\u040B\u040C\x05\xabU\x02\u040C\u040D\x05\xadV\x02\u040D\u040E\x05\xb7[\x02\u040E\u040F\x05\xa1P\x02\u040F\u0410\x05\xabU\x02\u0410\u0582\x03\x02\x02\x02\u0411\u0412\x05\xabU\x02\u0412\u0413\x05\xadV\x02\u0413\u0414\x05\xbd^\x02\u0414\u0415\x05\x91H\x02\u0415\u0416\x05\xa1P\x02\u0416\u0417\x05\xb7[\x02\u0417\u0582\x03\x02\x02\x02\u0418\u0419\x05\xabU\x02\u0419\u041A\x05\xb9\\\x02\u041A\u041B\x05\xa9T\x02\u041B\u041C\x05\x93I\x02\u041C\u041D\x05\x99L\x02\u041D\u041E\x05\xb3Y\x02\u041E\u0582\x03\x02\x02\x02\u041F\u0420\x05\xadV\x02\u0420\u0421\x05\x93I\x02\u0421\u0422\x05\xa3Q\x02\u0422\u0423\x05\x99L\x02\u0423\u0424\x05\x95J\x02\u0424\u0425\x05\xb7[\x02\u0425\u0582\x03\x02\x02\x02\u0426\u0427\x05\xadV\x02\u0427\u0428\x05\x9bM\x02\u0428\u0582\x03\x02\x02\x02\u0429\u042A\x05\xadV\x02\u042A\u042B\x05\xafW\x02\u042B\u042C\x05\xb7[\x02\u042C\u042D\x05\xa1P\x02\u042D\u042E\x05\xadV\x02\u042E\u042F\x05\xabU\x02\u042F\u0582\x03\x02\x02\x02\u0430\u0431\x05\xadV\x02\u0431\u0432\x05\xb9\\\x02\u0432\u0433\x05\xb7[\x02\u0433\u0434\x05\x99L\x02\u0434\u0435\x05\xb3Y\x02\u0435\u0582\x03\x02\x02\x02\u0436\u0437\x05\xadV\x02\u0437\u0438\x05\xb9\\\x02\u0438\u0439\x05\xb7[\x02\u0439\u043A\x05\xafW\x02\u043A\u043B\x05\xb9\\\x02\u043B\u043C\x05\xb7[\x02\u043C\u0582\x03\x02\x02\x02\u043D\u043E\x05\xafW\x02\u043E\u043F\x05\xadV\x02\u043F\u0440\x05\xbd^\x02\u0440\u0441\x05\x99L\x02\u0441\u0442\x05";
    }
    static{
        this._serializedATNSegment2 = '\xb3Y\x02\u0442\u0582\x03\x02\x02\x02\u0443\u0444\x05\xafW\x02\u0444\u0445\x05\xb3Y\x02\u0445\u0446\x05\x99L\x02\u0446\u0447\x05\xbb]\x02\u0447\u0448\x05\xa1P\x02\u0448\u0449\x05\xadV\x02\u0449\u044A\x05\xb9\\\x02\u044A\u044B\x05\xb5Z\x02\u044B\u0582\x03\x02\x02\x02\u044C\u044D\x05\xafW\x02\u044D\u044E\x05\xb3Y\x02\u044E\u044F\x05\xa1P\x02\u044F\u0450\x05\xadV\x02\u0450\u0451\x05\xb3Y\x02\u0451\u0582\x03\x02\x02\x02\u0452\u0453\x05\xafW\x02\u0453\u0454\x05\xb3Y\x02\u0454\u0455\x05\xa1P\x02\u0455\u0456\x05\xbb]\x02\u0456\u0457\x05\xa1P\x02\u0457\u0458\x05\xa7S\x02\u0458\u0459\x05\x99L\x02\u0459\u045A\x05\x9dN\x02\u045A\u045B\x05\x99L\x02\u045B\u045C\x05\xb5Z\x02\u045C\u0582\x03\x02\x02\x02\u045D\u045E\x05\xafW\x02\u045E\u045F\x05\xb9\\\x02\u045F\u0460\x05\x93I\x02\u0460\u0461\x05\xa7S\x02\u0461\u0462\x05\xa1P\x02\u0462\u0463\x05\x95J\x02\u0463\u0582\x03\x02\x02\x02\u0464\u0465\x05\xb3Y\x02\u0465\u0466\x05\x91H\x02\u0466\u0467\x05\xa1P\x02\u0467\u0468\x05\xb5Z\x02\u0468\u0469\x05\x99L\x02\u0469\u0582\x03\x02\x02\x02\u046A\u046B\x05\xb3Y\x02\u046B\u046C\x05\x91H\x02\u046C\u046D\x05\xbd^\x02\u046D\u0582\x03\x02\x02\x02\u046E\u046F\x05\xb3Y\x02\u046F\u0470\x05\x99L\x02\u0470\u0471\x05\xa9T\x02\u0471\u0472\x05\x91H\x02\u0472\u0473\x05\xa1P\x02\u0473\u0474\x05\xabU\x02\u0474\u0475\x05\x97K\x02\u0475\u0476\x05\x99L\x02\u0476\u0477\x05\xb3Y\x02\u0477\u0582\x03\x02\x02\x02\u0478\u0479\x05\xb3Y\x02\u0479\u047A\x05\x99L\x02\u047A\u047B\x05\xabU\x02\u047B\u047C\x05\x91H\x02\u047C\u047D\x05\xa9T\x02\u047D\u047E\x05\x99L\x02\u047E\u0582\x03\x02\x02\x02\u047F\u0480\x05\xb3Y\x02\u0480\u0481\x05\x99L\x02\u0481\u0482\x05\xb5Z\x02\u0482\u0483\x05\xadV\x02\u0483\u0484\x05\xb9\\\x02\u0484\u0485\x05\xb3Y\x02\u0485\u0486\x05\x95J\x02\u0486\u0487\x05\x99L\x02\u0487\u0582\x03\x02\x02\x02\u0488\u0489\x05\xb3Y\x02\u0489\u048A\x05\x99L\x02\u048A\u048B\x05\xb7[\x02\u048B\u048C\x05\xb9\\\x02\u048C\u048D\x05\xb3Y\x02\u048D\u048E\x05\xabU\x02\u048E\u0582\x03\x02\x02\x02\u048F\u0490\x05\xb3Y\x02\u0490\u0491\x05\x99L\x02\u0491\u0492\x05\xb7[\x02\u0492\u0493\x05\xb9\\\x02\u0493\u0494\x05\xb3Y\x02\u0494\u0495\x05\xabU\x02\u0495\u0496\x05\xb5Z\x02\u0496\u0582\x03\x02\x02\x02\u0497\u0498\x05\xb3Y\x02\u0498\u0499\x05\x99L\x02\u0499\u049A\x05\xbb]\x02\u049A\u049B\x05\xadV\x02\u049B\u049C\x05\xa5R\x02\u049C\u049D\x05\x99L\x02\u049D\u0582\x03\x02\x02\x02\u049E\u049F\x05\xb3Y\x02\u049F\u04A0\x05\xa1P\x02\u04A0\u04A1\x05\x9dN\x02\u04A1\u04A2\x05\x9fO\x02\u04A2\u04A3\x05\xb7[\x02\u04A3\u0582\x03\x02\x02\x02\u04A4\u04A5\x05\xb3Y\x02\u04A5\u04A6\x05\xadV\x02\u04A6\u04A7\x05\xbd^\x02\u04A7\u0582\x03\x02\x02\x02\u04A8\u04A9\x05\xb3Y\x02\u04A9\u04AA\x05\xadV\x02\u04AA\u04AB\x05\xbd^\x02\u04AB\u04AC\x05\xa1P\x02\u04AC\u04AD\x05\x97K\x02\u04AD\u0582\x03\x02\x02\x02\u04AE\u04AF\x05\xb3Y\x02\u04AF\u04B0\x05\xadV\x02\u04B0\u04B1\x05\xbd^\x02\u04B1\u04B2\x05\xabU\x02\u04B2\u04B3\x05\xb9\\\x02\u04B3\u04B4\x05\xa9T\x02\u04B4\u0582\x03\x02\x02\x02\u04B5\u04B6\x05\xb3Y\x02\u04B6\u04B7\x05\xadV\x02\u04B7\u04B8\x05\xbd^\x02\u04B8\u04B9\x05\xb5Z\x02\u04B9\u0582\x03\x02\x02\x02\u04BA\u04BB\x05\xb5Z\x02\u04BB\u04BC\x05\x99L\x02\u04BC\u04BD\x05\xa7S\x02\u04BD\u04BE\x05\x99L\x02\u04BE\u04BF\x05\x95J\x02\u04BF\u04C0\x05\xb7[\x02\u04C0\u0582\x03\x02\x02\x02\u04C1\u04C2\x05\xb5Z\x02\u04C2\u04C3\x05\x99L\x02\u04C3\u04C4\x05\xb5Z\x02\u04C4\u04C5\x05\xb5Z\x02\u04C5\u04C6\x05\xa1P\x02\u04C6\u04C7\x05\xadV\x02\u04C7\u04C8\x05\xabU\x02\u04C8\u0582\x03\x02\x02\x02\u04C9\u04CA\x05\xb5Z\x02\u04CA\u04CB\x05\x99L\x02\u04CB\u04CC\x05\xb7[\x02\u04CC\u0582\x03\x02\x02\x02\u04CD\u04CE\x05\xb5Z\x02\u04CE\u04CF\x05\x9fO\x02\u04CF\u04D0\x05\x91H\x02\u04D0\u04D1\x05\xb3Y\x02\u04D1\u04D2\x05\x99L\x02\u04D2\u0582\x03\x02\x02\x02\u04D3\u04D4\x05\xb5Z\x02\u04D4\u04D5\x05\xa1P\x02\u04D5\u04D6\x05\xc3a\x02\u04D6\u04D7\x05\x99L\x02\u04D7\u0582\x03\x02\x02\x02\u04D8\u04D9\x05\xb5Z\x02\u04D9\u04DA\x05\xb1X\x02\u04DA\u04DB\x05\xb3Y\x02\u04DB\u04DC\x05\xb7[\x02\u04DC\u0582\x03\x02\x02\x02\u04DD\u04DE\x05\xb5Z\x02\u04DE\u04DF\x05\xb7[\x02\u04DF\u04E0\x05\x91H\x02\u04E0\u04E1\x05\xb3Y\x02\u04E1\u04E2\x05\xb7[\x02\u04E2\u0582\x03\x02\x02\x02\u04E3\u04E4\x05\xb5Z\x02\u04E4\u04E5\x05\xb7[\x02\u04E5\u04E6\x05\xb3Y\x02\u04E6\u04E7\x05\xa1P\x02\u04E7\u04E8\x05\x95J\x02\u04E8\u04E9\x05\xb7[\x02\u04E9\u0582\x03\x02\x02\x02\u04EA\u04EB\x05\xb5Z\x02\u04EB\u04EC\x05\xb7[\x02\u04EC\u04ED\x05\xb3Y\x02\u04ED\u04EE\x05\xa1P\x02\u04EE\u04EF\x05\xabU\x02\u04EF\u04F0\x05\x9dN\x02\u04F0\u0582\x03\x02\x02\x02\u04F1\u04F2\x05\xb5Z\x02\u04F2\u04F3\x05\xb9\\\x02\u04F3\u04F4\x05\x93I\x02\u04F4\u04F5\x05\xb7[\x02\u04F5\u04F6\x05\xb3Y\x02\u04F6\u04F7\x05\x91H\x02\u04F7\u04F8\x05\x95J\x02\u04F8\u04F9\x05\xb7[\x02\u04F9\u0582\x03\x02\x02\x02\u04FA\u04FB\x05\xb5Z\x02\u04FB\u04FC\x05\xb9\\\x02\u04FC\u04FD\x05\xa9T\x02\u04FD\u0582\x03\x02\x02\x02\u04FE\u04FF\x05\xb5Z\x02\u04FF\u0500\x05\xc1`\x02\u0500\u0501\x05\xabU\x02\u0501\u0502\x05\xadV\x02\u0502\u0503\x05\xabU\x02\u0503\u0504\x05\xc1`\x02\u0504\u0505\x05\xa9T\x02\u0505\u0582\x03\x02\x02\x02\u0506\u0507\x05\xb7[\x02\u0507\u0508\x05\x91H\x02\u0508\u0509\x05\x93I\x02\u0509\u050A\x05\xa7S\x02\u050A\u050B\x05\x99L\x02\u050B\u0582\x03\x02\x02\x02\u050C\u050D\x05\xb7[\x02\u050D\u050E\x05\x9fO\x02\u050E\u050F\x05\x99L\x02\u050F\u0510\x05\xabU\x02\u0510\u0582\x03\x02\x02\x02\u0511\u0512\x05\xb7[\x02\u0512\u0513\x05\xb3Y\x02\u0513\u0514\x05\x91H\x02\u0514\u0515\x05\xabU\x02\u0515\u0516\x05\xb5Z\x02\u0516\u0582\x03\x02\x02\x02\u0517\u0518\x05\xb7[\x02\u0518\u0519\x05\xb3Y\x02\u0519\u051A\x05\x91H\x02\u051A\u051B\x05\xabU\x02\u051B\u051C\x05\xb5Z\x02\u051C\u051D\x05\x91H\x02\u051D\u051E\x05\x95J\x02\u051E\u051F\x05\xb7[\x02\u051F\u0520\x05\xa1P\x02\u0520\u0521\x05\xadV\x02\u0521\u0522\x05\xabU\x02\u0522\u0582\x03\x02\x02\x02\u0523\u0524\x05\xb7[\x02\u0524\u0525\x05\xb3Y\x02\u0525\u0526\x05\xa1P\x02\u0526\u0527\x05\x9dN\x02\u0527\u0528\x05\x9dN\x02\u0528\u0529\x05\x99L\x02\u0529\u052A\x05\xb3Y\x02\u052A\u0582\x03\x02\x02\x02\u052B\u052C\x05\xb7[\x02\u052C\u052D\x05\xb3Y\x02\u052D\u052E\x05\xb9\\\x02\u052E\u052F\x05\x99L\x02\u052F\u0582\x03\x02\x02\x02\u0530\u0531\x05\xb9\\\x02\u0531\u0532\x05\xa1P\x02\u0532\u0533\x05\x97K\x02\u0533\u0582\x03\x02\x02\x02\u0534\u0535\x05\xb9\\\x02\u0535\u0536\x05\xabU\x02\u0536\u0537\x05\xa1P\x02\u0537\u0538\x05\xadV\x02\u0538\u0539\x05\xabU\x02\u0539\u0582\x03\x02\x02\x02\u053A\u053B\x05\xb9\\\x02\u053B\u053C\x05\xabU\x02\u053C\u053D\x05\xa1P\x02\u053D\u053E\x05\xb1X\x02\u053E\u053F\x05\xb9\\\x02\u053F\u0540\x05\x99L\x02\u0540\u0582\x03\x02\x02\x02\u0541\u0542\x05\xb9\\\x02\u0542\u0543\x05\xafW\x02\u0543\u0544\x05\x97K\x02\u0544\u0545\x05\x91H\x02\u0545\u0546\x05\xb7[\x02\u0546\u0547\x05\x99L\x02\u0547\u0582\x03\x02\x02\x02\u0548\u0549\x05\xb9\\\x02\u0549\u054A\x05\xb5Z\x02\u054A\u054B\x05\x99L\x02\u054B\u054C\x05\xb3Y\x02\u054C\u0582\x03\x02\x02\x02\u054D\u054E\x05\xbb]\x02\u054E\u054F\x05\x91H\x02\u054F\u0550\x05\xa7S\x02\u0550\u0551\x05\xa1P\x02\u0551\u0552\x05\x97K\x02\u0552\u0553\x05\x91H\x02\u0553\u0554\x05\xb7[\x02\u0554\u0555\x05\x99L\x02\u0555\u0582\x03\x02\x02\x02\u0556\u0557\x05\xbb]\x02\u0557\u0558\x05\x91H\x02\u0558\u0559\x05\xa7S\x02\u0559\u055A\x05\xb9\\\x02\u055A\u055B\x05\x99L\x02\u055B\u055C\x05\xb5Z\x02\u055C\u0582\x03\x02\x02\x02\u055D\u055E\x05\xbb]\x02\u055E\u055F\x05\xa1P\x02\u055F\u0560\x05\x99L\x02\u0560\u0561\x05\xbd^\x02\u0561\u0582\x03\x02\x02\x02\u0562\u0563\x05\xbd^\x02\u0563\u0564\x05\x9fO\x02\u0564\u0565\x05\x99L\x02\u0565\u0566\x05\xabU\x02\u0566\u0582\x03\x02\x02\x02\u0567\u0568\x05\xbd^\x02\u0568\u0569\x05\x9fO\x02\u0569\u056A\x05\x99L\x02\u056A\u056B\x05\xabU\x02\u056B\u056C\x05\x99L\x02\u056C\u056D\x05\xbb]\x02\u056D\u056E\x05\x99L\x02\u056E\u056F\x05\xb3Y\x02\u056F\u0582\x03\x02\x02\x02\u0570\u0571\x05\xbd^\x02\u0571\u0572\x05\x9fO\x02\u0572\u0573\x05\x99L\x02\u0573\u0574\x05\xb3Y\x02\u0574\u0575\x05\x99L\x02\u0575\u0582\x03\x02\x02\x02\u0576\u0577\x05\xbd^\x02\u0577\u0578\x05\x9fO\x02\u0578\u0579\x05\xa1P\x02\u0579\u057A\x05\xa7S\x02\u057A\u057B\x05\x99L\x02\u057B\u0582\x03\x02\x02\x02\u057C\u057D\x05\xbd^\x02\u057D\u057E\x05\xa1P\x02\u057E\u057F\x05\xb7[\x02\u057F\u0580\x05\x9fO\x02\u0580\u0582\x03\x02\x02\x02\u0581\u0160\x03\x02\x02\x02\u0581\u0166\x03\x02\x02\x02\u0581\u016D\x03\x02\x02\x02\u0581\u0171\x03\x02\x02\x02\u0581\u0177\x03\x02\x02\x02\u0581\u017D\x03\x02\x02\x02\u0581\u0181\x03\x02\x02\x02\u0581\u0184\x03\x02\x02\x02\u0581\u018A\x03\x02\x02\x02\u0581\u018E\x03\x02\x02\x02\u0581\u0194\x03\x02\x02\x02\u0581\u019C\x03\x02\x02\x02\u0581\u01A4\x03\x02\x02\x02\u0581\u01AA\x03\x02\x02\x02\u0581\u01AF\x03\x02\x02\x02\u0581\u01B5\x03\x02\x02\x02\u0581\u01BA\x03\x02\x02\x02\u0581\u01C4\x03\x02\x02\x02\u0581\u01CA\x03\x02\x02\x02\u0581\u01D5\x03\x02\x02\x02\u0581\u01DD\x03\x02\x02\x02\u0581\u01E7\x03\x02\x02\x02\u0581\u01EE\x03\x02\x02\x02\u0581\u01F5\x03\x02\x02\x02\u0581\u01FD\x03\x02\x02\x02\u0581\u0206\x03\x02\x02\x02\u0581\u020C\x03\x02\x02\x02\u0581\u0213\x03\x02\x02\x02\u0581\u021B\x03\x02\x02\x02\u0581\u0220\x03\x02\x02\x02\u0581\u0228\x03\x02\x02\x02\u0581\u0230\x03\x02\x02\x02\u0581\u023A\x03\x02\x02\x02\u0581\u0242\x03\x02\x02\x02\u0581\u024B\x03\x02\x02\x02\u0581\u0252\x03\x02\x02\x02\u0581\u0259\x03\x02\x02\x02\u0581\u0263\x03\x02\x02\x02\u0581\u026E\x03\x02\x02\x02\u0581\u0277\x03\x02\x02\x02\u0581\u027E\x03\x02\x02\x02\u0581\u0281\x03\x02\x02\x02\u0581\u0288\x03\x02\x02\x02\u0581\u028D\x03\x02\x02\x02\u0581\u0292\x03\x02\x02\x02\u0581\u029B\x03\x02\x02\x02\u0581\u029F\x03\x02\x02\x02\u0581\u02A6\x03\x02\x02\x02\u0581\u02AD\x03\x02\x02\x02\u0581\u02B7\x03\x02\x02\x02\u0581\u02BC\x03\x02\x02\x02\u0581\u02C4\x03\x02\x02\x02\u0581\u02CB\x03\x02\x02\x02\u0581\u02D3\x03\x02\x02\x02\u0581\u02D9\x03\x02\x02\x02\u0581\u02DF\x03\x02\x02\x02\u0581\u02E4\x03\x02\x02\x02\u0581\u02EA\x03\x02\x02\x02\u0581\u02F0\x03\x02\x02\x02\u0581\u02F6\x03\x02\x02\x02\u0581\u02FA\x03\x02\x02\x02\u0581\u0303\x03\x02\x02\x02\u0581\u0306\x03\x02\x02\x02\u0581\u030B\x03\x02\x02\x02\u0581\u0311\x03\x02\x02\x02\u0581\u0319\x03\x02\x02\x02\u0581\u031F\x03\x02\x02\x02\u0581\u0326\x03\x02\x02\x02\u0581\u0331\x03\x02\x02\x02\u0581\u0334\x03\x02\x02\x02\u0581\u033E\x03\x02\x02\x02\u0581\u0348\x03\x02\x02\x02\u0581\u034E\x03\x02\x02\x02\u0581\u0356\x03\x02\x02\x02\u0581\u035C\x03\x02\x02\x02\u0581\u0362\x03\x02\x02\x02\u0581\u0368\x03\x02\x02\x02\u0581\u036F\x03\x02\x02\x02\u0581\u0373\x03\x02\x02\x02\u0581\u037B\x03\x02\x02\x02\u0581\u0385\x03\x02\x02\x02\u0581\u0392\x03\x02\x02\x02\u0581\u0397\x03\x02\x02\x02\u0581\u039F\x03\x02\x02\x02\u0581\u03A6\x03\x02\x02\x02\u0581\u03AB\x03\x02\x02\x02\u0581\u03B0\x03\x02\x02\x02\u0581\u03B5\x03\x02\x02\x02\u0581\u03BA\x03\x02\x02\x02\u0581\u03BF\x03\x02\x02\x02\u0581\u03C5\x03\x02\x02\x02\u0581\u03CA\x03\x02\x02\x02\u0581\u03CF\x03\x02\x02\x02\u0581\u03D3\x03\x02\x02\x02\u0581\u03D7\x03\x02\x02\x02\u0581\u03DD\x03\x02\x02\x02\u0581\u03E2\x03\x02\x02\x02\u0581\u03E9\x03\x02\x02\x02\u0581\u03F0\x03\x02\x02\x02\u0581\u03F5\x03\x02\x02\x02\u0581\u03FE\x03\x02\x02\x02\u0581\u0403\x03\x02\x02\x02\u0581\u040B\x03\x02\x02\x02\u0581\u0411\x03\x02\x02\x02\u0581\u0418\x03\x02\x02\x02\u0581\u041F\x03\x02\x02\x02\u0581\u0426\x03\x02\x02\x02\u0581\u0429\x03\x02\x02\x02\u0581\u0430\x03\x02\x02\x02\u0581\u0436\x03\x02\x02\x02\u0581\u043D\x03\x02\x02\x02\u0581\u0443\x03\x02\x02\x02\u0581\u044C\x03\x02\x02\x02\u0581\u0452\x03\x02\x02\x02\u0581\u045D\x03\x02\x02\x02\u0581\u0464\x03\x02\x02\x02\u0581\u046A\x03\x02\x02\x02\u0581\u046E\x03\x02\x02\x02\u0581\u0478\x03\x02\x02\x02\u0581\u047F\x03\x02\x02\x02\u0581\u0488\x03\x02\x02\x02\u0581\u048F\x03\x02\x02\x02\u0581\u0497\x03\x02\x02\x02\u0581\u049E\x03\x02\x02\x02\u0581\u04A4\x03\x02\x02\x02\u0581\u04A8\x03\x02\x02\x02\u0581\u04AE\x03\x02\x02\x02\u0581\u04B5\x03\x02\x02\x02\u0581\u04BA\x03\x02\x02\x02\u0581\u04C1\x03\x02\x02\x02\u0581\u04C9\x03\x02\x02\x02\u0581\u04CD\x03\x02\x02\x02\u0581\u04D3\x03\x02\x02\x02\u0581\u04D8\x03\x02\x02\x02\u0581\u04DD\x03\x02\x02\x02\u0581\u04E3\x03\x02\x02\x02\u0581\u04EA\x03\x02\x02\x02\u0581\u04F1\x03\x02\x02\x02\u0581\u04FA\x03\x02\x02\x02\u0581\u04FE\x03\x02\x02\x02\u0581\u0506\x03\x02\x02\x02\u0581\u050C\x03\x02\x02\x02\u0581\u0511\x03\x02\x02\x02\u0581\u0517\x03\x02\x02\x02\u0581\u0523\x03\x02\x02\x02\u0581\u052B\x03\x02\x02\x02\u0581\u0530\x03\x02\x02\x02\u0581\u0534\x03\x02\x02\x02\u0581\u053A\x03\x02\x02\x02\u0581\u0541\x03\x02\x02\x02\u0581\u0548\x03\x02\x02\x02\u0581\u054D\x03\x02\x02\x02\u0581\u0556\x03\x02\x02\x02\u0581\u055D\x03\x02\x02\x02\u0581\u0562\x03\x02\x02\x02\u0581\u0567\x03\x02\x02\x02\u0581\u0570\x03\x02\x02\x02\u0581\u0576\x03\x02\x02\x02\u0581\u057C\x03\x02\x02\x02\u0582P\x03\x02\x02\x02\u0583\u0586\x05\x85B\x02\u0584\u0586\x05i4\x02\u0585\u0583\x03\x02\x02\x02\u0585\u0584\x03\x02\x02\x02\u0586\u0587\x03\x02\x02\x02\u0587\u0585\x03\x02\x02\x02\u0587\u0588\x03\x02\x02\x02\u0588R\x03\x02\x02\x02\u0589\u058B\x05\x8bE\x02\u058A\u0589\x03\x02\x02\x02\u058B\u058C\x03\x02\x02\x02\u058C\u058A\x03\x02\x02\x02\u058C\u058D\x03\x02\x02\x02\u058D\u058E\x03\x02\x02\x02\u058E\u058F\b)\x05\x02\u058FT\x03\x02\x02\x02\u0590\u0591\x05o7\x02\u0591V\x03\x02\x02\x02\u0592\u0593\v\x02\x02\x02\u0593X\x03\x02\x02\x02\u0594\u0595\x05q8\x02\u0595\u0596\x03\x02\x02\x02\u0596\u0597\b,\x06\x02\u0597Z\x03\x02\x02\x02\u0598\u059B\x05\x85B\x02\u0599\u059B\x05k5\x02\u059A\u0598\x03\x02\x02\x02\u059A\u0599\x03\x02\x02\x02\u059B\u059C\x03\x02\x02\x02\u059C\u059D\b-\x02\x02\u059D\\\x03\x02\x02\x02\u059E\u059F\x07\x02\x02\x03\u059F\u05A0\x03\x02\x02\x02\u05A0\u05A1\b.\x06\x02\u05A1^\x03\x02\x02\x02\u05A2\u05A3\v\x02\x02\x02\u05A3\u05A4\x03\x02\x02\x02\u05A4\u05A5\b/\x06\x02\u05A5`\x03\x02\x02\x02\u05A6\u05A7\x05s9\x02\u05A7\u05A8\x03\x02\x02\x02\u05A8\u05A9\b0\x06\x02\u05A9b\x03\x02\x02\x02\u05AA\u05AD\x05\x85B\x02\u05AB\u05AD\x05m6\x02\u05AC\u05AA\x03\x02\x02\x02\u05AC\u05AB\x03\x02\x02\x02\u05AD\u05AE\x03\x02\x02\x02\u05AE\u05AF\b1\x02\x02\u05AFd\x03\x02\x02\x02\u05B0\u05B1\x07\x02\x02\x03\u05B1\u05B2\x03\x02\x02\x02\u05B2\u05B3\b2\x06\x02\u05B3f\x03\x02\x02\x02\u05B4\u05B5\v\x02\x02\x02\u05B5\u05B6\x03\x02\x02\x02\u05B6\u05B7\b3\x06\x02\u05B7h\x03\x02\x02\x02\u05B8\u05B9\n\x02\x02\x02\u05B9j\x03\x02\x02\x02\u05BA\u05BB\n\x03\x02\x02\u05BBl\x03\x02\x02\x02\u05BC\u05BD\n\x04\x02\x02\u05BDn\x03\x02\x02\x02\u05BE\u05BF	\x05\x02\x02\u05BFp\x03\x02\x02\x02\u05C0\u05C1\x07$\x02\x02\u05C1r\x03\x02\x02\x02\u05C2\u05C3\x07)\x02\x02\u05C3t\x03\x02\x02\x02\u05C4\u05C5\x07^\x02\x02\u05C5v\x03\x02\x02\x02\u05C6\u05C7\x07\x0f\x02\x02\u05C7x\x03\x02\x02\x02\u05C8\u05C9\x07\f\x02\x02\u05C9z\x03\x02\x02\x02\u05CA\u05CB\x07"\x02\x02\u05CB|\x03\x02\x02\x02\u05CC\u05CD\x07(\x02\x02\u05CD~\x03\x02\x02\x02\u05CE\u05CF\x07(\x02\x02\u05CF\u05D0\x07(\x02\x02\u05D0\x80\x03\x02\x02\x02\u05D1\u05D2\x07~\x02\x02\u05D2\x82\x03\x02\x02\x02\u05D3\u05D4\x07~\x02\x02\u05D4\u05D5\x07~\x02\x02\u05D5\x84\x03\x02\x02\x02\u05D6\u05E2\x05u:\x02\u05D7\u05E3	\x06\x02\x02\u05D8\u05E3\x05q8\x02\u05D9\u05E3\x05s9\x02\u05DA\u05E3\x05u:\x02\u05DB\u05E3\x05{=\x02\u05DC\u05DD\x07w\x02\x02\u05DD\u05DE\x05\x89D\x02\u05DE\u05DF\x05\x89D\x02\u05DF\u05E0\x05\x89D\x02\u05E0\u05E1\x05\x89D\x02\u05E1\u05E3\x03\x02\x02\x02\u05E2\u05D7\x03\x02\x02\x02\u05E2\u05D8\x03\x02\x02\x02\u05E2\u05D9\x03\x02\x02\x02\u05E2\u05DA\x03\x02\x02\x02\u05E2\u05DB\x03\x02\x02\x02\u05E2\u05DC\x03\x02\x02\x02\u05E3\x86\x03\x02\x02\x02\u05E4\u05E7\x05w;\x02\u05E5\u05E7\x05y<\x02\u05E6\u05E4\x03\x02\x02\x02\u05E6\u05E5\x03\x02\x02\x02\u05E7\x88\x03\x02\x02\x02\u05E8\u05F0\x05\x8fG\x02\u05E9\u05F0\x05\x91H\x02\u05EA\u05F0\x05\x93I\x02\u05EB\u05F0\x05\x95J\x02\u05EC\u05F0\x05\x97K\x02\u05ED\u05F0\x05\x99L\x02\u05EE\u05F0\x05\x9bM\x02\u05EF\u05E8\x03\x02\x02\x02\u05EF\u05E9\x03\x02\x02\x02\u05EF\u05EA\x03\x02\x02\x02\u05EF\u05EB\x03\x02\x02\x02\u05EF\u05EC\x03\x02\x02\x02\u05EF\u05ED\x03\x02\x02\x02\u05EF\u05EE\x03\x02\x02\x02\u05F0\x8a\x03\x02\x02\x02\u05F1\u05F5\x05{=\x02\u05F2\u05F5\x07\v\x02\x02\u05F3\u05F5\x05\x87C\x02\u05F4\u05F1\x03\x02\x02\x02\u05F4\u05F2\x03\x02\x02\x02\u05F4\u05F3\x03\x02\x02\x02\u05F5\x8c\x03\x02\x02\x02\u05F6\u05F7\x07/\x02\x02\u05F7\x8e\x03\x02\x02\x02\u05F8\u05F9	\x07\x02\x02\u05F9\x90\x03\x02\x02\x02\u05FA\u05FB	\b\x02\x02\u05FB\x92\x03\x02\x02\x02\u05FC\u05FD		\x02\x02\u05FD\x94\x03\x02\x02\x02\u05FE\u05FF	\n\x02\x02\u05FF\x96\x03\x02\x02\x02\u0600\u0601	\v\x02\x02\u0601\x98\x03\x02\x02\x02\u0602\u0603	\f\x02\x02\u0603\x9a\x03\x02\x02\x02\u0604\u0605	\r\x02\x02\u0605\x9c\x03\x02\x02\x02\u0606\u0607	\x0e\x02\x02\u0607\x9e\x03\x02\x02\x02\u0608\u0609	\x0f\x02\x02\u0609\xa0\x03\x02\x02\x02\u060A\u060B	\x10\x02\x02\u060B\xa2\x03\x02\x02\x02\u060C\u060D	\x11\x02\x02\u060D\xa4\x03\x02\x02\x02\u060E\u060F	\x12\x02\x02\u060F\xa6\x03\x02\x02\x02\u0610\u0611	\x13\x02\x02\u0611\xa8\x03\x02\x02\x02\u0612\u0613	\x14\x02\x02\u0613\xaa\x03\x02\x02\x02\u0614\u0615	\x15\x02\x02\u0615\xac\x03\x02\x02\x02\u0616\u0617	\x16\x02\x02\u0617\xae\x03\x02\x02\x02\u0618\u0619	\x17\x02\x02\u0619\xb0\x03\x02\x02\x02\u061A\u061B	\x18\x02\x02\u061B\xb2\x03\x02\x02\x02\u061C\u061D	\x19\x02\x02\u061D\xb4\x03\x02\x02\x02\u061E\u061F	\x1a\x02\x02\u061F\xb6\x03\x02\x02\x02\u0620\u0621	\x1b\x02\x02\u0621\xb8\x03\x02\x02\x02\u0622\u0623	\x1c\x02\x02\u0623\xba\x03\x02\x02\x02\u0624\u0625	\x1d\x02\x02\u0625\xbc\x03\x02\x02\x02\u0626\u0627	\x1e\x02\x02\u0627\xbe\x03\x02\x02\x02\u0628\u0629	\x1f\x02\x02\u0629\xc0\x03\x02\x02\x02\u062A\u062B	 \x02\x02\u062B\xc2\x03\x02\x02\x02\u062C\u062D	!\x02\x02\u062D\xc4\x03\x02\x02\x02\x14\x02\x03\x04\xfb\u0102\u0113\u0155\u015B\u0581\u0585\u0587\u058C\u059A\u05AC\u05E2\u05E6\u05EF\u05F4\x07\x05\x02\x02\x04\x03\x02\x04\x04\x02\x02\x03\x02\x04\x02\x02';
    }
    static{
        this._serializedATN = $62Uvn.join([
            $6201fadffaeceba5$export$375c79404cc64c7f._serializedATNSegment0,
            $6201fadffaeceba5$export$375c79404cc64c7f._serializedATNSegment1,
            $6201fadffaeceba5$export$375c79404cc64c7f._serializedATNSegment2
        ], '');
    }
    static get _ATN() {
        if (!$6201fadffaeceba5$export$375c79404cc64c7f.__ATN) $6201fadffaeceba5$export$375c79404cc64c7f.__ATN = new (0, $1ztRl.ATNDeserializer)().deserialize($62Uvn.toCharArray($6201fadffaeceba5$export$375c79404cc64c7f._serializedATN));
        return $6201fadffaeceba5$export$375c79404cc64c7f.__ATN;
    }
}

});

parcelRegister("e3Si3", function(module, exports) {

$parcel$export(module.exports, "JQLParser", () => $da70a06608213e15$export$9c4772e191bdb810);
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Generated from JQLParser.g4 by ANTLR 4.7.3-SNAPSHOT

var $1ztRl = parcelRequire("1ztRl");

var $iAlWg = parcelRequire("iAlWg");

var $c9Sjf = parcelRequire("c9Sjf");

var $2pDMz = parcelRequire("2pDMz");

var $gzbPK = parcelRequire("gzbPK");

var $b7PPe = parcelRequire("b7PPe");

var $eKXi4 = parcelRequire("eKXi4");

var $hBnE1 = parcelRequire("hBnE1");

var $62Uvn = parcelRequire("62Uvn");
class $da70a06608213e15$export$9c4772e191bdb810 extends (0, $c9Sjf.Parser) {
    static{
        this.LPAREN = 1;
    }
    static{
        this.RPAREN = 2;
    }
    static{
        this.COMMA = 3;
    }
    static{
        this.LBRACKET = 4;
    }
    static{
        this.RBRACKET = 5;
    }
    static{
        this.BANG = 6;
    }
    static{
        this.LT = 7;
    }
    static{
        this.GT = 8;
    }
    static{
        this.GTEQ = 9;
    }
    static{
        this.LTEQ = 10;
    }
    static{
        this.EQUALS = 11;
    }
    static{
        this.NOT_EQUALS = 12;
    }
    static{
        this.LIKE = 13;
    }
    static{
        this.NOT_LIKE = 14;
    }
    static{
        this.IN = 15;
    }
    static{
        this.IS = 16;
    }
    static{
        this.AND = 17;
    }
    static{
        this.OR = 18;
    }
    static{
        this.NOT = 19;
    }
    static{
        this.EMPTY = 20;
    }
    static{
        this.WAS = 21;
    }
    static{
        this.CHANGED = 22;
    }
    static{
        this.BEFORE = 23;
    }
    static{
        this.AFTER = 24;
    }
    static{
        this.FROM = 25;
    }
    static{
        this.TO = 26;
    }
    static{
        this.ON = 27;
    }
    static{
        this.DURING = 28;
    }
    static{
        this.ORDER = 29;
    }
    static{
        this.BY = 30;
    }
    static{
        this.ASC = 31;
    }
    static{
        this.DESC = 32;
    }
    static{
        this.POSNUMBER = 33;
    }
    static{
        this.NEGNUMBER = 34;
    }
    static{
        this.CUSTOMFIELD = 35;
    }
    static{
        this.RESERVED_WORD = 36;
    }
    static{
        this.STRING = 37;
    }
    static{
        this.MATCHWS = 38;
    }
    static{
        this.ERROR_RESERVED = 39;
    }
    static{
        this.ERRORCHAR = 40;
    }
    static{
        this.QUOTE_STRING = 41;
    }
    static{
        this.UNCLOSED_QUOTE_STRING = 42;
    }
    static{
        this.INVALID_QUOTE_STRING = 43;
    }
    static{
        this.SQUOTE_STRING = 44;
    }
    static{
        this.UNCLOSED_SQUOTE_STRING = 45;
    }
    static{
        this.INVALID_SQUOTE_STRING = 46;
    }
    static{
        this.RULE_jqlQuery = 0;
    }
    static{
        this.RULE_jqlWhere = 1;
    }
    static{
        this.RULE_jqlOrClause = 2;
    }
    static{
        this.RULE_jqlAndClause = 3;
    }
    static{
        this.RULE_jqlNotClause = 4;
    }
    static{
        this.RULE_jqlSubClause = 5;
    }
    static{
        this.RULE_jqlTerminalClause = 6;
    }
    static{
        this.RULE_jqlTerminalClauseRhs = 7;
    }
    static{
        this.RULE_jqlEqualsOperator = 8;
    }
    static{
        this.RULE_jqlLikeOperator = 9;
    }
    static{
        this.RULE_jqlComparisonOperator = 10;
    }
    static{
        this.RULE_jqlInOperator = 11;
    }
    static{
        this.RULE_jqlIsOperator = 12;
    }
    static{
        this.RULE_jqlWasOperator = 13;
    }
    static{
        this.RULE_jqlWasInOperator = 14;
    }
    static{
        this.RULE_jqlChangedOperator = 15;
    }
    static{
        this.RULE_jqlField = 16;
    }
    static{
        this.RULE_jqlFieldProperty = 17;
    }
    static{
        this.RULE_jqlCustomField = 18;
    }
    static{
        this.RULE_jqlString = 19;
    }
    static{
        this.RULE_jqlNumber = 20;
    }
    static{
        this.RULE_jqlOperand = 21;
    }
    static{
        this.RULE_jqlEmpty = 22;
    }
    static{
        this.RULE_jqlValue = 23;
    }
    static{
        this.RULE_jqlFunction = 24;
    }
    static{
        this.RULE_jqlFunctionName = 25;
    }
    static{
        this.RULE_jqlArgumentList = 26;
    }
    static{
        this.RULE_jqlList = 27;
    }
    static{
        this.RULE_jqlListStart = 28;
    }
    static{
        this.RULE_jqlListEnd = 29;
    }
    static{
        this.RULE_jqlPropertyArgument = 30;
    }
    static{
        this.RULE_jqlArgument = 31;
    }
    static{
        this.RULE_jqlWasPredicate = 32;
    }
    static{
        this.RULE_jqlChangedPredicate = 33;
    }
    static{
        this.RULE_jqlDatePredicateOperator = 34;
    }
    static{
        this.RULE_jqlDateRangePredicateOperator = 35;
    }
    static{
        this.RULE_jqlUserPredicateOperator = 36;
    }
    static{
        this.RULE_jqlValuePredicateOperator = 37;
    }
    static{
        this.RULE_jqlPredicateOperand = 38;
    }
    static{
        this.RULE_jqlOrderBy = 39;
    }
    static{
        this.RULE_jqlSearchSort = 40;
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.ruleNames = [
            'jqlQuery',
            'jqlWhere',
            'jqlOrClause',
            'jqlAndClause',
            'jqlNotClause',
            'jqlSubClause',
            'jqlTerminalClause',
            'jqlTerminalClauseRhs',
            'jqlEqualsOperator',
            'jqlLikeOperator',
            'jqlComparisonOperator',
            'jqlInOperator',
            'jqlIsOperator',
            'jqlWasOperator',
            'jqlWasInOperator',
            'jqlChangedOperator',
            'jqlField',
            'jqlFieldProperty',
            'jqlCustomField',
            'jqlString',
            'jqlNumber',
            'jqlOperand',
            'jqlEmpty',
            'jqlValue',
            'jqlFunction',
            'jqlFunctionName',
            'jqlArgumentList',
            'jqlList',
            'jqlListStart',
            'jqlListEnd',
            'jqlPropertyArgument',
            'jqlArgument',
            'jqlWasPredicate',
            'jqlChangedPredicate',
            'jqlDatePredicateOperator',
            'jqlDateRangePredicateOperator',
            'jqlUserPredicateOperator',
            'jqlValuePredicateOperator',
            'jqlPredicateOperand',
            'jqlOrderBy',
            'jqlSearchSort'
        ];
    }
    static{
        this._LITERAL_NAMES = [
            undefined,
            "'('",
            "')'",
            "','",
            "'['",
            "']'",
            "'!'",
            "'<'",
            "'>'",
            "'>='",
            "'<='",
            "'='",
            "'!='",
            "'~'",
            "'!~'"
        ];
    }
    static{
        this._SYMBOLIC_NAMES = [
            undefined,
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING'
        ];
    }
    static{
        this.VOCABULARY = new (0, $hBnE1.VocabularyImpl)($da70a06608213e15$export$9c4772e191bdb810._LITERAL_NAMES, $da70a06608213e15$export$9c4772e191bdb810._SYMBOLIC_NAMES, []);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return $da70a06608213e15$export$9c4772e191bdb810.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    // @Override
    get grammarFileName() {
        return 'JQLParser.g4';
    }
    // @Override
    get ruleNames() {
        return $da70a06608213e15$export$9c4772e191bdb810.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $da70a06608213e15$export$9c4772e191bdb810._serializedATN;
    }
    constructor(input){
        super(input);
        this._interp = new (0, $gzbPK.ParserATNSimulator)($da70a06608213e15$export$9c4772e191bdb810._ATN, this);
    }
    // @RuleVersion(0)
    jqlQuery() {
        let _localctx = new $da70a06608213e15$export$ff413535b9575c8(this._ctx, this.state);
        this.enterRule(_localctx, 0, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlQuery);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 83;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la & -32) === 0 && (1 << _la & (1 << $da70a06608213e15$export$9c4772e191bdb810.LPAREN | 1 << $da70a06608213e15$export$9c4772e191bdb810.BANG | 1 << $da70a06608213e15$export$9c4772e191bdb810.NOT)) !== 0 || (_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $da70a06608213e15$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $da70a06608213e15$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $da70a06608213e15$export$9c4772e191bdb810.CUSTOMFIELD - 33 | 1 << $da70a06608213e15$export$9c4772e191bdb810.STRING - 33 | 1 << $da70a06608213e15$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $da70a06608213e15$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 82;
                this.jqlWhere();
            }
            this.state = 86;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $da70a06608213e15$export$9c4772e191bdb810.ORDER) {
                this.state = 85;
                this.jqlOrderBy();
            }
            this.state = 88;
            this.match($da70a06608213e15$export$9c4772e191bdb810.EOF);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWhere() {
        let _localctx = new $da70a06608213e15$export$4148a879cab28017(this._ctx, this.state);
        this.enterRule(_localctx, 2, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlWhere);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 90;
            this.jqlOrClause();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrClause() {
        let _localctx = new $da70a06608213e15$export$d69831d387793480(this._ctx, this.state);
        this.enterRule(_localctx, 4, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlOrClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 92;
            this.jqlAndClause();
            this.state = 97;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $da70a06608213e15$export$9c4772e191bdb810.OR){
                this.state = 93;
                this.match($da70a06608213e15$export$9c4772e191bdb810.OR);
                this.state = 94;
                this.jqlAndClause();
                this.state = 99;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlAndClause() {
        let _localctx = new $da70a06608213e15$export$f16819001158b9e(this._ctx, this.state);
        this.enterRule(_localctx, 6, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlAndClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 100;
            this.jqlNotClause();
            this.state = 105;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $da70a06608213e15$export$9c4772e191bdb810.AND){
                this.state = 101;
                this.match($da70a06608213e15$export$9c4772e191bdb810.AND);
                this.state = 102;
                this.jqlNotClause();
                this.state = 107;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNotClause() {
        let _localctx = new $da70a06608213e15$export$5e9146f8d5cf1330(this._ctx, this.state);
        this.enterRule(_localctx, 8, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlNotClause);
        let _la;
        try {
            this.state = 112;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $da70a06608213e15$export$9c4772e191bdb810.BANG:
                case $da70a06608213e15$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 108;
                    _la = this._input.LA(1);
                    if (!(_la === $da70a06608213e15$export$9c4772e191bdb810.BANG || _la === $da70a06608213e15$export$9c4772e191bdb810.NOT)) this._errHandler.recoverInline(this);
                    else {
                        if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                        this._errHandler.reportMatch(this);
                        this.consume();
                    }
                    this.state = 109;
                    this.jqlNotClause();
                    break;
                case $da70a06608213e15$export$9c4772e191bdb810.LPAREN:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 110;
                    this.jqlSubClause();
                    break;
                case $da70a06608213e15$export$9c4772e191bdb810.POSNUMBER:
                case $da70a06608213e15$export$9c4772e191bdb810.NEGNUMBER:
                case $da70a06608213e15$export$9c4772e191bdb810.CUSTOMFIELD:
                case $da70a06608213e15$export$9c4772e191bdb810.STRING:
                case $da70a06608213e15$export$9c4772e191bdb810.QUOTE_STRING:
                case $da70a06608213e15$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 111;
                    this.jqlTerminalClause();
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSubClause() {
        let _localctx = new $da70a06608213e15$export$a136a0e9655bfb04(this._ctx, this.state);
        this.enterRule(_localctx, 10, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlSubClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 114;
            this.match($da70a06608213e15$export$9c4772e191bdb810.LPAREN);
            this.state = 115;
            this.jqlOrClause();
            this.state = 116;
            this.match($da70a06608213e15$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClause() {
        let _localctx = new $da70a06608213e15$export$23486a2f2ddd5bcd(this._ctx, this.state);
        this.enterRule(_localctx, 12, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlTerminalClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 118;
            this.jqlField();
            this.state = 119;
            this.jqlTerminalClauseRhs();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClauseRhs() {
        let _localctx = new $da70a06608213e15$export$93924a205c12d32c(this._ctx, this.state);
        this.enterRule(_localctx, 14, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs);
        let _la;
        try {
            this.state = 176;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 14, this._ctx)){
                case 1:
                    _localctx = new $da70a06608213e15$export$c428f709a58396e5(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 121;
                    this.jqlEqualsOperator();
                    this.state = 125;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 5, this._ctx)){
                        case 1:
                            this.state = 122;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 123;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 124;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 2:
                    _localctx = new $da70a06608213e15$export$1b131204ef9fa33d(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 127;
                    this.jqlLikeOperator();
                    this.state = 131;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 6, this._ctx)){
                        case 1:
                            this.state = 128;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 129;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 130;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 3:
                    _localctx = new $da70a06608213e15$export$d83706ee80a9852a(_localctx);
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 133;
                    this.jqlComparisonOperator();
                    this.state = 136;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 7, this._ctx)){
                        case 1:
                            this.state = 134;
                            this.jqlValue();
                            break;
                        case 2:
                            this.state = 135;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 4:
                    _localctx = new $da70a06608213e15$export$2934b8ff22fddd2d(_localctx);
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 138;
                    this.jqlInOperator();
                    this.state = 141;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $da70a06608213e15$export$9c4772e191bdb810.LPAREN:
                            this.state = 139;
                            this.jqlList();
                            break;
                        case $da70a06608213e15$export$9c4772e191bdb810.POSNUMBER:
                        case $da70a06608213e15$export$9c4772e191bdb810.NEGNUMBER:
                        case $da70a06608213e15$export$9c4772e191bdb810.STRING:
                        case $da70a06608213e15$export$9c4772e191bdb810.QUOTE_STRING:
                        case $da70a06608213e15$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 140;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $iAlWg.NoViableAltException)(this);
                    }
                    break;
                case 5:
                    _localctx = new $da70a06608213e15$export$8b84310182afcf93(_localctx);
                    this.enterOuterAlt(_localctx, 5);
                    this.state = 143;
                    this.jqlIsOperator();
                    this.state = 144;
                    this.jqlEmpty();
                    break;
                case 6:
                    _localctx = new $da70a06608213e15$export$5df295dc7a2cac7c(_localctx);
                    this.enterOuterAlt(_localctx, 6);
                    this.state = 146;
                    this.jqlWasOperator();
                    this.state = 150;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 9, this._ctx)){
                        case 1:
                            this.state = 147;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 148;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 149;
                            this.jqlFunction();
                            break;
                    }
                    this.state = 155;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $da70a06608213e15$export$9c4772e191bdb810.BEFORE | 1 << $da70a06608213e15$export$9c4772e191bdb810.AFTER | 1 << $da70a06608213e15$export$9c4772e191bdb810.ON | 1 << $da70a06608213e15$export$9c4772e191bdb810.DURING | 1 << $da70a06608213e15$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 152;
                        this.jqlWasPredicate();
                        this.state = 157;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 7:
                    _localctx = new $da70a06608213e15$export$9ac3367aee261b32(_localctx);
                    this.enterOuterAlt(_localctx, 7);
                    this.state = 158;
                    this.jqlWasInOperator();
                    this.state = 161;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $da70a06608213e15$export$9c4772e191bdb810.LPAREN:
                            this.state = 159;
                            this.jqlList();
                            break;
                        case $da70a06608213e15$export$9c4772e191bdb810.POSNUMBER:
                        case $da70a06608213e15$export$9c4772e191bdb810.NEGNUMBER:
                        case $da70a06608213e15$export$9c4772e191bdb810.STRING:
                        case $da70a06608213e15$export$9c4772e191bdb810.QUOTE_STRING:
                        case $da70a06608213e15$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 160;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $iAlWg.NoViableAltException)(this);
                    }
                    this.state = 166;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $da70a06608213e15$export$9c4772e191bdb810.BEFORE | 1 << $da70a06608213e15$export$9c4772e191bdb810.AFTER | 1 << $da70a06608213e15$export$9c4772e191bdb810.ON | 1 << $da70a06608213e15$export$9c4772e191bdb810.DURING | 1 << $da70a06608213e15$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 163;
                        this.jqlWasPredicate();
                        this.state = 168;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 8:
                    _localctx = new $da70a06608213e15$export$7a7defca8628a13c(_localctx);
                    this.enterOuterAlt(_localctx, 8);
                    this.state = 169;
                    this.jqlChangedOperator();
                    this.state = 173;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $da70a06608213e15$export$9c4772e191bdb810.BEFORE | 1 << $da70a06608213e15$export$9c4772e191bdb810.AFTER | 1 << $da70a06608213e15$export$9c4772e191bdb810.FROM | 1 << $da70a06608213e15$export$9c4772e191bdb810.TO | 1 << $da70a06608213e15$export$9c4772e191bdb810.ON | 1 << $da70a06608213e15$export$9c4772e191bdb810.DURING | 1 << $da70a06608213e15$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 170;
                        this.jqlChangedPredicate();
                        this.state = 175;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEqualsOperator() {
        let _localctx = new $da70a06608213e15$export$41e475fc1988e413(this._ctx, this.state);
        this.enterRule(_localctx, 16, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlEqualsOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 178;
            _la = this._input.LA(1);
            if (!(_la === $da70a06608213e15$export$9c4772e191bdb810.EQUALS || _la === $da70a06608213e15$export$9c4772e191bdb810.NOT_EQUALS)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlLikeOperator() {
        let _localctx = new $da70a06608213e15$export$b76fe5387fdd7efd(this._ctx, this.state);
        this.enterRule(_localctx, 18, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlLikeOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 180;
            _la = this._input.LA(1);
            if (!(_la === $da70a06608213e15$export$9c4772e191bdb810.LIKE || _la === $da70a06608213e15$export$9c4772e191bdb810.NOT_LIKE)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlComparisonOperator() {
        let _localctx = new $da70a06608213e15$export$d821da0716b3ec95(this._ctx, this.state);
        this.enterRule(_localctx, 20, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlComparisonOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 182;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $da70a06608213e15$export$9c4772e191bdb810.LT | 1 << $da70a06608213e15$export$9c4772e191bdb810.GT | 1 << $da70a06608213e15$export$9c4772e191bdb810.GTEQ | 1 << $da70a06608213e15$export$9c4772e191bdb810.LTEQ)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlInOperator() {
        let _localctx = new $da70a06608213e15$export$178478bfa8292f72(this._ctx, this.state);
        this.enterRule(_localctx, 22, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlInOperator);
        try {
            this.state = 187;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $da70a06608213e15$export$9c4772e191bdb810.IN:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 184;
                    this.match($da70a06608213e15$export$9c4772e191bdb810.IN);
                    break;
                case $da70a06608213e15$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 185;
                    this.match($da70a06608213e15$export$9c4772e191bdb810.NOT);
                    this.state = 186;
                    this.match($da70a06608213e15$export$9c4772e191bdb810.IN);
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlIsOperator() {
        let _localctx = new $da70a06608213e15$export$e64c31d2830b66e4(this._ctx, this.state);
        this.enterRule(_localctx, 24, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlIsOperator);
        try {
            this.state = 192;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 16, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 189;
                    this.match($da70a06608213e15$export$9c4772e191bdb810.IS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 190;
                    this.match($da70a06608213e15$export$9c4772e191bdb810.IS);
                    this.state = 191;
                    this.match($da70a06608213e15$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasOperator() {
        let _localctx = new $da70a06608213e15$export$7e283636700e4a6c(this._ctx, this.state);
        this.enterRule(_localctx, 26, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlWasOperator);
        try {
            this.state = 197;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 17, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 194;
                    this.match($da70a06608213e15$export$9c4772e191bdb810.WAS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 195;
                    this.match($da70a06608213e15$export$9c4772e191bdb810.WAS);
                    this.state = 196;
                    this.match($da70a06608213e15$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasInOperator() {
        let _localctx = new $da70a06608213e15$export$b9118b1ed9a78d66(this._ctx, this.state);
        this.enterRule(_localctx, 28, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlWasInOperator);
        try {
            this.state = 204;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 18, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 199;
                    this.match($da70a06608213e15$export$9c4772e191bdb810.WAS);
                    this.state = 200;
                    this.match($da70a06608213e15$export$9c4772e191bdb810.IN);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 201;
                    this.match($da70a06608213e15$export$9c4772e191bdb810.WAS);
                    this.state = 202;
                    this.match($da70a06608213e15$export$9c4772e191bdb810.NOT);
                    this.state = 203;
                    this.match($da70a06608213e15$export$9c4772e191bdb810.IN);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedOperator() {
        let _localctx = new $da70a06608213e15$export$493d626ed78ca66(this._ctx, this.state);
        this.enterRule(_localctx, 30, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlChangedOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 206;
            this.match($da70a06608213e15$export$9c4772e191bdb810.CHANGED);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlField() {
        let _localctx = new $da70a06608213e15$export$b33300c3d916229a(this._ctx, this.state);
        this.enterRule(_localctx, 32, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlField);
        let _la;
        try {
            this.state = 219;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $da70a06608213e15$export$9c4772e191bdb810.POSNUMBER:
                case $da70a06608213e15$export$9c4772e191bdb810.NEGNUMBER:
                    _localctx = new $da70a06608213e15$export$11fec15307d2e17b(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 208;
                    this.jqlNumber();
                    break;
                case $da70a06608213e15$export$9c4772e191bdb810.CUSTOMFIELD:
                case $da70a06608213e15$export$9c4772e191bdb810.STRING:
                case $da70a06608213e15$export$9c4772e191bdb810.QUOTE_STRING:
                case $da70a06608213e15$export$9c4772e191bdb810.SQUOTE_STRING:
                    _localctx = new $da70a06608213e15$export$b8b24f99f985ebb3(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 211;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $da70a06608213e15$export$9c4772e191bdb810.STRING:
                        case $da70a06608213e15$export$9c4772e191bdb810.QUOTE_STRING:
                        case $da70a06608213e15$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 209;
                            this.jqlString();
                            break;
                        case $da70a06608213e15$export$9c4772e191bdb810.CUSTOMFIELD:
                            this.state = 210;
                            this.jqlCustomField();
                            break;
                        default:
                            throw new (0, $iAlWg.NoViableAltException)(this);
                    }
                    this.state = 216;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la === $da70a06608213e15$export$9c4772e191bdb810.LBRACKET){
                        this.state = 213;
                        this.jqlFieldProperty();
                        this.state = 218;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFieldProperty() {
        let _localctx = new $da70a06608213e15$export$b02d0b6637ce0593(this._ctx, this.state);
        this.enterRule(_localctx, 34, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlFieldProperty);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 221;
            this.match($da70a06608213e15$export$9c4772e191bdb810.LBRACKET);
            this.state = 222;
            this.jqlArgument();
            this.state = 223;
            this.match($da70a06608213e15$export$9c4772e191bdb810.RBRACKET);
            this.state = 228;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $da70a06608213e15$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $da70a06608213e15$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $da70a06608213e15$export$9c4772e191bdb810.STRING - 33 | 1 << $da70a06608213e15$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $da70a06608213e15$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0){
                this.state = 225;
                this.jqlPropertyArgument();
                this.state = 230;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlCustomField() {
        let _localctx = new $da70a06608213e15$export$401a038855cc5b15(this._ctx, this.state);
        this.enterRule(_localctx, 36, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlCustomField);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 231;
            this.match($da70a06608213e15$export$9c4772e191bdb810.CUSTOMFIELD);
            this.state = 232;
            this.match($da70a06608213e15$export$9c4772e191bdb810.LBRACKET);
            this.state = 233;
            this.match($da70a06608213e15$export$9c4772e191bdb810.POSNUMBER);
            this.state = 234;
            this.match($da70a06608213e15$export$9c4772e191bdb810.RBRACKET);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlString() {
        let _localctx = new $da70a06608213e15$export$bde73d8ad7c8b71e(this._ctx, this.state);
        this.enterRule(_localctx, 38, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlString);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 236;
            _la = this._input.LA(1);
            if (!((_la - 37 & -32) === 0 && (1 << _la - 37 & (1 << $da70a06608213e15$export$9c4772e191bdb810.STRING - 37 | 1 << $da70a06608213e15$export$9c4772e191bdb810.QUOTE_STRING - 37 | 1 << $da70a06608213e15$export$9c4772e191bdb810.SQUOTE_STRING - 37)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNumber() {
        let _localctx = new $da70a06608213e15$export$8737d94a1880e8b3(this._ctx, this.state);
        this.enterRule(_localctx, 40, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlNumber);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 238;
            _localctx._jqlNum = this._input.LT(1);
            _la = this._input.LA(1);
            if (!(_la === $da70a06608213e15$export$9c4772e191bdb810.POSNUMBER || _la === $da70a06608213e15$export$9c4772e191bdb810.NEGNUMBER)) _localctx._jqlNum = this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOperand() {
        let _localctx = new $da70a06608213e15$export$2eaac5a9828bf647(this._ctx, this.state);
        this.enterRule(_localctx, 42, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlOperand);
        try {
            this.state = 244;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 23, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 240;
                    this.jqlEmpty();
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 241;
                    this.jqlValue();
                    break;
                case 3:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 242;
                    this.jqlFunction();
                    break;
                case 4:
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 243;
                    this.jqlList();
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEmpty() {
        let _localctx = new $da70a06608213e15$export$d85a062f90025e5c(this._ctx, this.state);
        this.enterRule(_localctx, 44, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlEmpty);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 246;
            this.match($da70a06608213e15$export$9c4772e191bdb810.EMPTY);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValue() {
        let _localctx = new $da70a06608213e15$export$2e17d457b0933bec(this._ctx, this.state);
        this.enterRule(_localctx, 46, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlValue);
        try {
            this.state = 250;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $da70a06608213e15$export$9c4772e191bdb810.STRING:
                case $da70a06608213e15$export$9c4772e191bdb810.QUOTE_STRING:
                case $da70a06608213e15$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 248;
                    this.jqlString();
                    break;
                case $da70a06608213e15$export$9c4772e191bdb810.POSNUMBER:
                case $da70a06608213e15$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 249;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunction() {
        let _localctx = new $da70a06608213e15$export$ebf0cc785e9ee41a(this._ctx, this.state);
        this.enterRule(_localctx, 48, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlFunction);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 252;
            this.jqlFunctionName();
            this.state = 253;
            this.match($da70a06608213e15$export$9c4772e191bdb810.LPAREN);
            this.state = 255;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $da70a06608213e15$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $da70a06608213e15$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $da70a06608213e15$export$9c4772e191bdb810.STRING - 33 | 1 << $da70a06608213e15$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $da70a06608213e15$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 254;
                this.jqlArgumentList();
            }
            this.state = 257;
            this.match($da70a06608213e15$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunctionName() {
        let _localctx = new $da70a06608213e15$export$1f5f7ac816788f44(this._ctx, this.state);
        this.enterRule(_localctx, 50, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlFunctionName);
        try {
            this.state = 261;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $da70a06608213e15$export$9c4772e191bdb810.STRING:
                case $da70a06608213e15$export$9c4772e191bdb810.QUOTE_STRING:
                case $da70a06608213e15$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 259;
                    this.jqlString();
                    break;
                case $da70a06608213e15$export$9c4772e191bdb810.POSNUMBER:
                case $da70a06608213e15$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 260;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgumentList() {
        let _localctx = new $da70a06608213e15$export$83d7c13849b931c3(this._ctx, this.state);
        this.enterRule(_localctx, 52, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlArgumentList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 263;
            this.jqlArgument();
            this.state = 268;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $da70a06608213e15$export$9c4772e191bdb810.COMMA){
                this.state = 264;
                this.match($da70a06608213e15$export$9c4772e191bdb810.COMMA);
                this.state = 265;
                this.jqlArgument();
                this.state = 270;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlList() {
        let _localctx = new $da70a06608213e15$export$9cb97a63f2be4864(this._ctx, this.state);
        this.enterRule(_localctx, 54, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 271;
            this.jqlListStart();
            this.state = 272;
            this.jqlOperand();
            this.state = 277;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $da70a06608213e15$export$9c4772e191bdb810.COMMA){
                this.state = 273;
                this.match($da70a06608213e15$export$9c4772e191bdb810.COMMA);
                this.state = 274;
                this.jqlOperand();
                this.state = 279;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 280;
            this.jqlListEnd();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListStart() {
        let _localctx = new $da70a06608213e15$export$c419f717bfc46a5d(this._ctx, this.state);
        this.enterRule(_localctx, 56, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlListStart);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 282;
            this.match($da70a06608213e15$export$9c4772e191bdb810.LPAREN);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListEnd() {
        let _localctx = new $da70a06608213e15$export$f6cd3e372f5ab120(this._ctx, this.state);
        this.enterRule(_localctx, 58, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlListEnd);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 284;
            this.match($da70a06608213e15$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPropertyArgument() {
        let _localctx = new $da70a06608213e15$export$e20ce4a2ed16372c(this._ctx, this.state);
        this.enterRule(_localctx, 60, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlPropertyArgument);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 286;
            this.jqlArgument();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgument() {
        let _localctx = new $da70a06608213e15$export$a95583953c237f88(this._ctx, this.state);
        this.enterRule(_localctx, 62, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlArgument);
        try {
            this.state = 290;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $da70a06608213e15$export$9c4772e191bdb810.STRING:
                case $da70a06608213e15$export$9c4772e191bdb810.QUOTE_STRING:
                case $da70a06608213e15$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 288;
                    this.jqlString();
                    break;
                case $da70a06608213e15$export$9c4772e191bdb810.POSNUMBER:
                case $da70a06608213e15$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 289;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasPredicate() {
        let _localctx = new $da70a06608213e15$export$9fa1e4d63f31b911(this._ctx, this.state);
        this.enterRule(_localctx, 64, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlWasPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 295;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $da70a06608213e15$export$9c4772e191bdb810.BEFORE:
                case $da70a06608213e15$export$9c4772e191bdb810.AFTER:
                case $da70a06608213e15$export$9c4772e191bdb810.ON:
                    this.state = 292;
                    this.jqlDatePredicateOperator();
                    break;
                case $da70a06608213e15$export$9c4772e191bdb810.DURING:
                    this.state = 293;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $da70a06608213e15$export$9c4772e191bdb810.BY:
                    this.state = 294;
                    this.jqlUserPredicateOperator();
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
            this.state = 297;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedPredicate() {
        let _localctx = new $da70a06608213e15$export$e77e479a48133015(this._ctx, this.state);
        this.enterRule(_localctx, 66, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlChangedPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 303;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $da70a06608213e15$export$9c4772e191bdb810.BEFORE:
                case $da70a06608213e15$export$9c4772e191bdb810.AFTER:
                case $da70a06608213e15$export$9c4772e191bdb810.ON:
                    this.state = 299;
                    this.jqlDatePredicateOperator();
                    break;
                case $da70a06608213e15$export$9c4772e191bdb810.DURING:
                    this.state = 300;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $da70a06608213e15$export$9c4772e191bdb810.BY:
                    this.state = 301;
                    this.jqlUserPredicateOperator();
                    break;
                case $da70a06608213e15$export$9c4772e191bdb810.FROM:
                case $da70a06608213e15$export$9c4772e191bdb810.TO:
                    this.state = 302;
                    this.jqlValuePredicateOperator();
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
            this.state = 305;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDatePredicateOperator() {
        let _localctx = new $da70a06608213e15$export$dc01290aee731418(this._ctx, this.state);
        this.enterRule(_localctx, 68, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 307;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $da70a06608213e15$export$9c4772e191bdb810.BEFORE | 1 << $da70a06608213e15$export$9c4772e191bdb810.AFTER | 1 << $da70a06608213e15$export$9c4772e191bdb810.ON)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDateRangePredicateOperator() {
        let _localctx = new $da70a06608213e15$export$75412b8b6a6442e1(this._ctx, this.state);
        this.enterRule(_localctx, 70, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 309;
            this.match($da70a06608213e15$export$9c4772e191bdb810.DURING);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlUserPredicateOperator() {
        let _localctx = new $da70a06608213e15$export$ad402332075c8656(this._ctx, this.state);
        this.enterRule(_localctx, 72, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 311;
            this.match($da70a06608213e15$export$9c4772e191bdb810.BY);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValuePredicateOperator() {
        let _localctx = new $da70a06608213e15$export$4239d7c0fbafd3f1(this._ctx, this.state);
        this.enterRule(_localctx, 74, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 313;
            _la = this._input.LA(1);
            if (!(_la === $da70a06608213e15$export$9c4772e191bdb810.FROM || _la === $da70a06608213e15$export$9c4772e191bdb810.TO)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPredicateOperand() {
        let _localctx = new $da70a06608213e15$export$6b796c5a4b8c18e(this._ctx, this.state);
        this.enterRule(_localctx, 76, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlPredicateOperand);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 315;
            this.jqlOperand();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrderBy() {
        let _localctx = new $da70a06608213e15$export$534469b9c8f44139(this._ctx, this.state);
        this.enterRule(_localctx, 78, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlOrderBy);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 317;
            this.match($da70a06608213e15$export$9c4772e191bdb810.ORDER);
            this.state = 318;
            this.match($da70a06608213e15$export$9c4772e191bdb810.BY);
            this.state = 319;
            this.jqlSearchSort();
            this.state = 324;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $da70a06608213e15$export$9c4772e191bdb810.COMMA){
                this.state = 320;
                this.match($da70a06608213e15$export$9c4772e191bdb810.COMMA);
                this.state = 321;
                this.jqlSearchSort();
                this.state = 326;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSearchSort() {
        let _localctx = new $da70a06608213e15$export$c7d8f03f36952a46(this._ctx, this.state);
        this.enterRule(_localctx, 80, $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlSearchSort);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 327;
            this.jqlField();
            this.state = 329;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $da70a06608213e15$export$9c4772e191bdb810.ASC || _la === $da70a06608213e15$export$9c4772e191bdb810.DESC) {
                this.state = 328;
                _la = this._input.LA(1);
                if (!(_la === $da70a06608213e15$export$9c4772e191bdb810.ASC || _la === $da70a06608213e15$export$9c4772e191bdb810.DESC)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    static{
        this._serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x030\u014E\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04"	"\x04#	#\x04$	$\x04%	%\x04&	&\x04\'	\'\x04(	(\x04)	)\x04*	*\x03\x02\x05\x02V\n\x02\x03\x02\x05\x02Y\n\x02\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x04\x07\x04b\n\x04\f\x04\x0e\x04e\v\x04\x03\x05\x03\x05\x03\x05\x07\x05j\n\x05\f\x05\x0e\x05m\v\x05\x03\x06\x03\x06\x03\x06\x03\x06\x05\x06s\n\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03	\x03	\x03	\x03	\x05	\x80\n	\x03	\x03	\x03	\x03	\x05	\x86\n	\x03	\x03	\x03	\x05	\x8b\n	\x03	\x03	\x03	\x05	\x90\n	\x03	\x03	\x03	\x03	\x03	\x03	\x03	\x05	\x99\n	\x03	\x07	\x9c\n	\f	\x0e	\x9f\v	\x03	\x03	\x03	\x05	\xa4\n	\x03	\x07	\xa7\n	\f	\x0e	\xaa\v	\x03	\x03	\x07	\xae\n	\f	\x0e	\xb1\v	\x05	\xb3\n	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\r\x05\r\xbe\n\r\x03\x0e\x03\x0e\x03\x0e\x05\x0e\xc3\n\x0e\x03\x0f\x03\x0f\x03\x0f\x05\x0f\xc8\n\x0f\x03\x10\x03\x10\x03\x10\x03\x10\x03\x10\x05\x10\xcf\n\x10\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x05\x12\xd6\n\x12\x03\x12\x07\x12\xd9\n\x12\f\x12\x0e\x12\xdc\v\x12\x05\x12\xde\n\x12\x03\x13\x03\x13\x03\x13\x03\x13\x03\x13\x07\x13\xe5\n\x13\f\x13\x0e\x13\xe8\v\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x15\x03\x15\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\xf7\n\x17\x03\x18\x03\x18\x03\x19\x03\x19\x05\x19\xfd\n\x19\x03\x1a\x03\x1a\x03\x1a\x05\x1a\u0102\n\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x05\x1b\u0108\n\x1b\x03\x1c\x03\x1c\x03\x1c\x07\x1c\u010D\n\x1c\f\x1c\x0e\x1c\u0110\v\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1d\x07\x1d\u0116\n\x1d\f\x1d\x0e\x1d\u0119\v\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03 \x03 \x03!\x03!\x05!\u0125\n!\x03"\x03"\x03"\x05"\u012A\n"\x03"\x03"\x03#\x03#\x03#\x03#\x05#\u0132\n#\x03#\x03#\x03$\x03$\x03%\x03%\x03&\x03&\x03\'\x03\'\x03(\x03(\x03)\x03)\x03)\x03)\x03)\x07)\u0145\n)\f)\x0e)\u0148\v)\x03*\x03*\x05*\u014C\n*\x03*\x02\x02\x02+\x02\x02\x04\x02\x06\x02\b\x02\n\x02\f\x02\x0e\x02\x10\x02\x12\x02\x14\x02\x16\x02\x18\x02\x1a\x02\x1c\x02\x1e\x02 \x02"\x02$\x02&\x02(\x02*\x02,\x02.\x020\x022\x024\x026\x028\x02:\x02<\x02>\x02@\x02B\x02D\x02F\x02H\x02J\x02L\x02N\x02P\x02R\x02\x02\v\x04\x02\b\b\x15\x15\x03\x02\r\x0e\x03\x02\x0f\x10\x03\x02	\f\x05\x02\'\'++..\x03\x02#$\x04\x02\x19\x1a\x1d\x1d\x03\x02\x1b\x1c\x03\x02!"\x02\u0155\x02U\x03\x02\x02\x02\x04\\\x03\x02\x02\x02\x06^\x03\x02\x02\x02\bf\x03\x02\x02\x02\nr\x03\x02\x02\x02\ft\x03\x02\x02\x02\x0ex\x03\x02\x02\x02\x10\xb2\x03\x02\x02\x02\x12\xb4\x03\x02\x02\x02\x14\xb6\x03\x02\x02\x02\x16\xb8\x03\x02\x02\x02\x18\xbd\x03\x02\x02\x02\x1a\xc2\x03\x02\x02\x02\x1c\xc7\x03\x02\x02\x02\x1e\xce\x03\x02\x02\x02 \xd0\x03\x02\x02\x02"\xdd\x03\x02\x02\x02$\xdf\x03\x02\x02\x02&\xe9\x03\x02\x02\x02(\xee\x03\x02\x02\x02*\xf0\x03\x02\x02\x02,\xf6\x03\x02\x02\x02.\xf8\x03\x02\x02\x020\xfc\x03\x02\x02\x022\xfe\x03\x02\x02\x024\u0107\x03\x02\x02\x026\u0109\x03\x02\x02\x028\u0111\x03\x02\x02\x02:\u011C\x03\x02\x02\x02<\u011E\x03\x02\x02\x02>\u0120\x03\x02\x02\x02@\u0124\x03\x02\x02\x02B\u0129\x03\x02\x02\x02D\u0131\x03\x02\x02\x02F\u0135\x03\x02\x02\x02H\u0137\x03\x02\x02\x02J\u0139\x03\x02\x02\x02L\u013B\x03\x02\x02\x02N\u013D\x03\x02\x02\x02P\u013F\x03\x02\x02\x02R\u0149\x03\x02\x02\x02TV\x05\x04\x03\x02UT\x03\x02\x02\x02UV\x03\x02\x02\x02VX\x03\x02\x02\x02WY\x05P)\x02XW\x03\x02\x02\x02XY\x03\x02\x02\x02YZ\x03\x02\x02\x02Z[\x07\x02\x02\x03[\x03\x03\x02\x02\x02\\]\x05\x06\x04\x02]\x05\x03\x02\x02\x02^c\x05\b\x05\x02_`\x07\x14\x02\x02`b\x05\b\x05\x02a_\x03\x02\x02\x02be\x03\x02\x02\x02ca\x03\x02\x02\x02cd\x03\x02\x02\x02d\x07\x03\x02\x02\x02ec\x03\x02\x02\x02fk\x05\n\x06\x02gh\x07\x13\x02\x02hj\x05\n\x06\x02ig\x03\x02\x02\x02jm\x03\x02\x02\x02ki\x03\x02\x02\x02kl\x03\x02\x02\x02l	\x03\x02\x02\x02mk\x03\x02\x02\x02no	\x02\x02\x02os\x05\n\x06\x02ps\x05\f\x07\x02qs\x05\x0e\b\x02rn\x03\x02\x02\x02rp\x03\x02\x02\x02rq\x03\x02\x02\x02s\v\x03\x02\x02\x02tu\x07\x03\x02\x02uv\x05\x06\x04\x02vw\x07\x04\x02\x02w\r\x03\x02\x02\x02xy\x05"\x12\x02yz\x05\x10	\x02z\x0f\x03\x02\x02\x02{\x7f\x05\x12\n\x02|\x80\x05.\x18\x02}\x80\x050\x19\x02~\x80\x052\x1a\x02\x7f|\x03\x02\x02\x02\x7f}\x03\x02\x02\x02\x7f~\x03\x02\x02\x02\x80\xb3\x03\x02\x02\x02\x81\x85\x05\x14\v\x02\x82\x86\x05.\x18\x02\x83\x86\x050\x19\x02\x84\x86\x052\x1a\x02\x85\x82\x03\x02\x02\x02\x85\x83\x03\x02\x02\x02\x85\x84\x03\x02\x02\x02\x86\xb3\x03\x02\x02\x02\x87\x8a\x05\x16\f\x02\x88\x8b\x050\x19\x02\x89\x8b\x052\x1a\x02\x8a\x88\x03\x02\x02\x02\x8a\x89\x03\x02\x02\x02\x8b\xb3\x03\x02\x02\x02\x8c\x8f\x05\x18\r\x02\x8d\x90\x058\x1d\x02\x8e\x90\x052\x1a\x02\x8f\x8d\x03\x02\x02\x02\x8f\x8e\x03\x02\x02\x02\x90\xb3\x03\x02\x02\x02\x91\x92\x05\x1a\x0e\x02\x92\x93\x05.\x18\x02\x93\xb3\x03\x02\x02\x02\x94\x98\x05\x1c\x0f\x02\x95\x99\x05.\x18\x02\x96\x99\x050\x19\x02\x97\x99\x052\x1a\x02\x98\x95\x03\x02\x02\x02\x98\x96\x03\x02\x02\x02\x98\x97\x03\x02\x02\x02\x99\x9d\x03\x02\x02\x02\x9a\x9c\x05B"\x02\x9b\x9a\x03\x02\x02\x02\x9c\x9f\x03\x02\x02\x02\x9d\x9b\x03\x02\x02\x02\x9d\x9e\x03\x02\x02\x02\x9e\xb3\x03\x02\x02\x02\x9f\x9d\x03\x02\x02\x02\xa0\xa3\x05\x1e\x10\x02\xa1\xa4\x058\x1d\x02\xa2\xa4\x052\x1a\x02\xa3\xa1\x03\x02\x02\x02\xa3\xa2\x03\x02\x02\x02\xa4\xa8\x03\x02\x02\x02\xa5\xa7\x05B"\x02\xa6\xa5\x03\x02\x02\x02\xa7\xaa\x03\x02\x02\x02\xa8\xa6\x03\x02\x02\x02\xa8\xa9\x03\x02\x02\x02\xa9\xb3\x03\x02\x02\x02\xaa\xa8\x03\x02\x02\x02\xab\xaf\x05 \x11\x02\xac\xae\x05D#\x02\xad\xac\x03\x02\x02\x02\xae\xb1\x03\x02\x02\x02\xaf\xad\x03\x02\x02\x02\xaf\xb0\x03\x02\x02\x02\xb0\xb3\x03\x02\x02\x02\xb1\xaf\x03\x02\x02\x02\xb2{\x03\x02\x02\x02\xb2\x81\x03\x02\x02\x02\xb2\x87\x03\x02\x02\x02\xb2\x8c\x03\x02\x02\x02\xb2\x91\x03\x02\x02\x02\xb2\x94\x03\x02\x02\x02\xb2\xa0\x03\x02\x02\x02\xb2\xab\x03\x02\x02\x02\xb3\x11\x03\x02\x02\x02\xb4\xb5	\x03\x02\x02\xb5\x13\x03\x02\x02\x02\xb6\xb7	\x04\x02\x02\xb7\x15\x03\x02\x02\x02\xb8\xb9	\x05\x02\x02\xb9\x17\x03\x02\x02\x02\xba\xbe\x07\x11\x02\x02\xbb\xbc\x07\x15\x02\x02\xbc\xbe\x07\x11\x02\x02\xbd\xba\x03\x02\x02\x02\xbd\xbb\x03\x02\x02\x02\xbe\x19\x03\x02\x02\x02\xbf\xc3\x07\x12\x02\x02\xc0\xc1\x07\x12\x02\x02\xc1\xc3\x07\x15\x02\x02\xc2\xbf\x03\x02\x02\x02\xc2\xc0\x03\x02\x02\x02\xc3\x1b\x03\x02\x02\x02\xc4\xc8\x07\x17\x02\x02\xc5\xc6\x07\x17\x02\x02\xc6\xc8\x07\x15\x02\x02\xc7\xc4\x03\x02\x02\x02\xc7\xc5\x03\x02\x02\x02\xc8\x1d\x03\x02\x02\x02\xc9\xca\x07\x17\x02\x02\xca\xcf\x07\x11\x02\x02\xcb\xcc\x07\x17\x02\x02\xcc\xcd\x07\x15\x02\x02\xcd\xcf\x07\x11\x02\x02\xce\xc9\x03\x02\x02\x02\xce\xcb\x03\x02\x02\x02\xcf\x1f\x03\x02\x02\x02\xd0\xd1\x07\x18\x02\x02\xd1!\x03\x02\x02\x02\xd2\xde\x05*\x16\x02\xd3\xd6\x05(\x15\x02\xd4\xd6\x05&\x14\x02\xd5\xd3\x03\x02\x02\x02\xd5\xd4\x03\x02\x02\x02\xd6\xda\x03\x02\x02\x02\xd7\xd9\x05$\x13\x02\xd8\xd7\x03\x02\x02\x02\xd9\xdc\x03\x02\x02\x02\xda\xd8\x03\x02\x02\x02\xda\xdb\x03\x02\x02\x02\xdb\xde\x03\x02\x02\x02\xdc\xda\x03\x02\x02\x02\xdd\xd2\x03\x02\x02\x02\xdd\xd5\x03\x02\x02\x02\xde#\x03\x02\x02\x02\xdf\xe0\x07\x06\x02\x02\xe0\xe1\x05@!\x02\xe1\xe2\x07\x07\x02\x02\xe2\xe6\x03\x02\x02\x02\xe3\xe5\x05> \x02\xe4\xe3\x03\x02\x02\x02\xe5\xe8\x03\x02\x02\x02\xe6\xe4\x03\x02\x02\x02\xe6\xe7\x03\x02\x02\x02\xe7%\x03\x02\x02\x02\xe8\xe6\x03\x02\x02\x02\xe9\xea\x07%\x02\x02\xea\xeb\x07\x06\x02\x02\xeb\xec\x07#\x02\x02\xec\xed\x07\x07\x02\x02\xed\'\x03\x02\x02\x02\xee\xef	\x06\x02\x02\xef)\x03\x02\x02\x02\xf0\xf1	\x07\x02\x02\xf1+\x03\x02\x02\x02\xf2\xf7\x05.\x18\x02\xf3\xf7\x050\x19\x02\xf4\xf7\x052\x1a\x02\xf5\xf7\x058\x1d\x02\xf6\xf2\x03\x02\x02\x02\xf6\xf3\x03\x02\x02\x02\xf6\xf4\x03\x02\x02\x02\xf6\xf5\x03\x02\x02\x02\xf7-\x03\x02\x02\x02\xf8\xf9\x07\x16\x02\x02\xf9/\x03\x02\x02\x02\xfa\xfd\x05(\x15\x02\xfb\xfd\x05*\x16\x02\xfc\xfa\x03\x02\x02\x02\xfc\xfb\x03\x02\x02\x02\xfd1\x03\x02\x02\x02\xfe\xff\x054\x1b\x02\xff\u0101\x07\x03\x02\x02\u0100\u0102\x056\x1c\x02\u0101\u0100\x03\x02\x02\x02\u0101\u0102\x03\x02\x02\x02\u0102\u0103\x03\x02\x02\x02\u0103\u0104\x07\x04\x02\x02\u01043\x03\x02\x02\x02\u0105\u0108\x05(\x15\x02\u0106\u0108\x05*\x16\x02\u0107\u0105\x03\x02\x02\x02\u0107\u0106\x03\x02\x02\x02\u01085\x03\x02\x02\x02\u0109\u010E\x05@!\x02\u010A\u010B\x07\x05\x02\x02\u010B\u010D\x05@!\x02\u010C\u010A\x03\x02\x02\x02\u010D\u0110\x03\x02\x02\x02\u010E\u010C\x03\x02\x02\x02\u010E\u010F\x03\x02\x02\x02\u010F7\x03\x02\x02\x02\u0110\u010E\x03\x02\x02\x02\u0111\u0112\x05:\x1e\x02\u0112\u0117\x05,\x17\x02\u0113\u0114\x07\x05\x02\x02\u0114\u0116\x05,\x17\x02\u0115\u0113\x03\x02\x02\x02\u0116\u0119\x03\x02\x02\x02\u0117\u0115\x03\x02\x02\x02\u0117\u0118\x03\x02\x02\x02\u0118\u011A\x03\x02\x02\x02\u0119\u0117\x03\x02\x02\x02\u011A\u011B\x05<\x1f\x02\u011B9\x03\x02\x02\x02\u011C\u011D\x07\x03\x02\x02\u011D;\x03\x02\x02\x02\u011E\u011F\x07\x04\x02\x02\u011F=\x03\x02\x02\x02\u0120\u0121\x05@!\x02\u0121?\x03\x02\x02\x02\u0122\u0125\x05(\x15\x02\u0123\u0125\x05*\x16\x02\u0124\u0122\x03\x02\x02\x02\u0124\u0123\x03\x02\x02\x02\u0125A\x03\x02\x02\x02\u0126\u012A\x05F$\x02\u0127\u012A\x05H%\x02\u0128\u012A\x05J&\x02\u0129\u0126\x03\x02\x02\x02\u0129\u0127\x03\x02\x02\x02\u0129\u0128\x03\x02\x02\x02\u012A\u012B\x03\x02\x02\x02\u012B\u012C\x05N(\x02\u012CC\x03\x02\x02\x02\u012D\u0132\x05F$\x02\u012E\u0132\x05H%\x02\u012F\u0132\x05J&\x02\u0130\u0132\x05L\'\x02\u0131\u012D\x03\x02\x02\x02\u0131\u012E\x03\x02\x02\x02\u0131\u012F\x03\x02\x02\x02\u0131\u0130\x03\x02\x02\x02\u0132\u0133\x03\x02\x02\x02\u0133\u0134\x05N(\x02\u0134E\x03\x02\x02\x02\u0135\u0136	\b\x02\x02\u0136G\x03\x02\x02\x02\u0137\u0138\x07\x1e\x02\x02\u0138I\x03\x02\x02\x02\u0139\u013A\x07 \x02\x02\u013AK\x03\x02\x02\x02\u013B\u013C		\x02\x02\u013CM\x03\x02\x02\x02\u013D\u013E\x05,\x17\x02\u013EO\x03\x02\x02\x02\u013F\u0140\x07\x1f\x02\x02\u0140\u0141\x07 \x02\x02\u0141\u0146\x05R*\x02\u0142\u0143\x07\x05\x02\x02\u0143\u0145\x05R*\x02\u0144\u0142\x03\x02\x02\x02\u0145\u0148\x03\x02\x02\x02\u0146\u0144\x03\x02\x02\x02\u0146\u0147\x03\x02\x02\x02\u0147Q\x03\x02\x02\x02\u0148\u0146\x03\x02\x02\x02\u0149\u014B\x05"\x12\x02\u014A\u014C	\n\x02\x02\u014B\u014A\x03\x02\x02\x02\u014B\u014C\x03\x02\x02\x02\u014CS\x03\x02\x02\x02$UXckr\x7f\x85\x8a\x8f\x98\x9d\xa3\xa8\xaf\xb2\xbd\xc2\xc7\xce\xd5\xda\xdd\xe6\xf6\xfc\u0101\u0107\u010E\u0117\u0124\u0129\u0131\u0146\u014B';
    }
    static get _ATN() {
        if (!$da70a06608213e15$export$9c4772e191bdb810.__ATN) $da70a06608213e15$export$9c4772e191bdb810.__ATN = new (0, $1ztRl.ATNDeserializer)().deserialize($62Uvn.toCharArray($da70a06608213e15$export$9c4772e191bdb810._serializedATN));
        return $da70a06608213e15$export$9c4772e191bdb810.__ATN;
    }
}
class $da70a06608213e15$export$ff413535b9575c8 extends (0, $2pDMz.ParserRuleContext) {
    EOF() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.EOF, 0);
    }
    jqlWhere() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$4148a879cab28017);
    }
    jqlOrderBy() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$534469b9c8f44139);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlQuery;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlQuery) listener.enterJqlQuery(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlQuery) listener.exitJqlQuery(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlQuery) return visitor.visitJqlQuery(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$4148a879cab28017 extends (0, $2pDMz.ParserRuleContext) {
    jqlOrClause() {
        return this.getRuleContext(0, $da70a06608213e15$export$d69831d387793480);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlWhere;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWhere) listener.enterJqlWhere(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWhere) listener.exitJqlWhere(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWhere) return visitor.visitJqlWhere(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$d69831d387793480 extends (0, $2pDMz.ParserRuleContext) {
    jqlAndClause(i) {
        if (i === undefined) return this.getRuleContexts($da70a06608213e15$export$f16819001158b9e);
        else return this.getRuleContext(i, $da70a06608213e15$export$f16819001158b9e);
    }
    OR(i) {
        if (i === undefined) return this.getTokens($da70a06608213e15$export$9c4772e191bdb810.OR);
        else return this.getToken($da70a06608213e15$export$9c4772e191bdb810.OR, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlOrClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrClause) listener.enterJqlOrClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrClause) listener.exitJqlOrClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrClause) return visitor.visitJqlOrClause(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$f16819001158b9e extends (0, $2pDMz.ParserRuleContext) {
    jqlNotClause(i) {
        if (i === undefined) return this.getRuleContexts($da70a06608213e15$export$5e9146f8d5cf1330);
        else return this.getRuleContext(i, $da70a06608213e15$export$5e9146f8d5cf1330);
    }
    AND(i) {
        if (i === undefined) return this.getTokens($da70a06608213e15$export$9c4772e191bdb810.AND);
        else return this.getToken($da70a06608213e15$export$9c4772e191bdb810.AND, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlAndClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlAndClause) listener.enterJqlAndClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlAndClause) listener.exitJqlAndClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlAndClause) return visitor.visitJqlAndClause(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$5e9146f8d5cf1330 extends (0, $2pDMz.ParserRuleContext) {
    jqlNotClause() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$5e9146f8d5cf1330);
    }
    NOT() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.NOT, 0);
    }
    BANG() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.BANG, 0);
    }
    jqlSubClause() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$a136a0e9655bfb04);
    }
    jqlTerminalClause() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$23486a2f2ddd5bcd);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlNotClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNotClause) listener.enterJqlNotClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNotClause) listener.exitJqlNotClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNotClause) return visitor.visitJqlNotClause(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$a136a0e9655bfb04 extends (0, $2pDMz.ParserRuleContext) {
    LPAREN() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.LPAREN, 0);
    }
    jqlOrClause() {
        return this.getRuleContext(0, $da70a06608213e15$export$d69831d387793480);
    }
    RPAREN() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.RPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlSubClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSubClause) listener.enterJqlSubClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSubClause) listener.exitJqlSubClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSubClause) return visitor.visitJqlSubClause(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$23486a2f2ddd5bcd extends (0, $2pDMz.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $da70a06608213e15$export$b33300c3d916229a);
    }
    jqlTerminalClauseRhs() {
        return this.getRuleContext(0, $da70a06608213e15$export$93924a205c12d32c);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlTerminalClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlTerminalClause) listener.enterJqlTerminalClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlTerminalClause) listener.exitJqlTerminalClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlTerminalClause) return visitor.visitJqlTerminalClause(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$93924a205c12d32c extends (0, $2pDMz.ParserRuleContext) {
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
class $da70a06608213e15$export$c428f709a58396e5 extends $da70a06608213e15$export$93924a205c12d32c {
    jqlEqualsOperator() {
        return this.getRuleContext(0, $da70a06608213e15$export$41e475fc1988e413);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsClause) listener.enterJqlEqualsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsClause) listener.exitJqlEqualsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsClause) return visitor.visitJqlEqualsClause(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$1b131204ef9fa33d extends $da70a06608213e15$export$93924a205c12d32c {
    jqlLikeOperator() {
        return this.getRuleContext(0, $da70a06608213e15$export$b76fe5387fdd7efd);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeClause) listener.enterJqlLikeClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeClause) listener.exitJqlLikeClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeClause) return visitor.visitJqlLikeClause(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$d83706ee80a9852a extends $da70a06608213e15$export$93924a205c12d32c {
    jqlComparisonOperator() {
        return this.getRuleContext(0, $da70a06608213e15$export$d821da0716b3ec95);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonClause) listener.enterJqlComparisonClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonClause) listener.exitJqlComparisonClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonClause) return visitor.visitJqlComparisonClause(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$2934b8ff22fddd2d extends $da70a06608213e15$export$93924a205c12d32c {
    jqlInOperator() {
        return this.getRuleContext(0, $da70a06608213e15$export$178478bfa8292f72);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInClause) listener.enterJqlInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInClause) listener.exitJqlInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInClause) return visitor.visitJqlInClause(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$8b84310182afcf93 extends $da70a06608213e15$export$93924a205c12d32c {
    jqlIsOperator() {
        return this.getRuleContext(0, $da70a06608213e15$export$e64c31d2830b66e4);
    }
    jqlEmpty() {
        return this.getRuleContext(0, $da70a06608213e15$export$d85a062f90025e5c);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsClause) listener.enterJqlIsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsClause) listener.exitJqlIsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsClause) return visitor.visitJqlIsClause(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$5df295dc7a2cac7c extends $da70a06608213e15$export$93924a205c12d32c {
    jqlWasOperator() {
        return this.getRuleContext(0, $da70a06608213e15$export$7e283636700e4a6c);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($da70a06608213e15$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $da70a06608213e15$export$9fa1e4d63f31b911);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasClause) listener.enterJqlWasClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasClause) listener.exitJqlWasClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasClause) return visitor.visitJqlWasClause(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$9ac3367aee261b32 extends $da70a06608213e15$export$93924a205c12d32c {
    jqlWasInOperator() {
        return this.getRuleContext(0, $da70a06608213e15$export$b9118b1ed9a78d66);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($da70a06608213e15$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $da70a06608213e15$export$9fa1e4d63f31b911);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInClause) listener.enterJqlWasInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInClause) listener.exitJqlWasInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInClause) return visitor.visitJqlWasInClause(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$7a7defca8628a13c extends $da70a06608213e15$export$93924a205c12d32c {
    jqlChangedOperator() {
        return this.getRuleContext(0, $da70a06608213e15$export$493d626ed78ca66);
    }
    jqlChangedPredicate(i) {
        if (i === undefined) return this.getRuleContexts($da70a06608213e15$export$e77e479a48133015);
        else return this.getRuleContext(i, $da70a06608213e15$export$e77e479a48133015);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedClause) listener.enterJqlChangedClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedClause) listener.exitJqlChangedClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedClause) return visitor.visitJqlChangedClause(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$41e475fc1988e413 extends (0, $2pDMz.ParserRuleContext) {
    EQUALS() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.EQUALS, 0);
    }
    NOT_EQUALS() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.NOT_EQUALS, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlEqualsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsOperator) listener.enterJqlEqualsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsOperator) listener.exitJqlEqualsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsOperator) return visitor.visitJqlEqualsOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$b76fe5387fdd7efd extends (0, $2pDMz.ParserRuleContext) {
    LIKE() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.LIKE, 0);
    }
    NOT_LIKE() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.NOT_LIKE, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlLikeOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeOperator) listener.enterJqlLikeOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeOperator) listener.exitJqlLikeOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeOperator) return visitor.visitJqlLikeOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$d821da0716b3ec95 extends (0, $2pDMz.ParserRuleContext) {
    LT() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.LT, 0);
    }
    GT() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.GT, 0);
    }
    LTEQ() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.LTEQ, 0);
    }
    GTEQ() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.GTEQ, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlComparisonOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonOperator) listener.enterJqlComparisonOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonOperator) listener.exitJqlComparisonOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonOperator) return visitor.visitJqlComparisonOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$178478bfa8292f72 extends (0, $2pDMz.ParserRuleContext) {
    IN() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInOperator) listener.enterJqlInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInOperator) listener.exitJqlInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInOperator) return visitor.visitJqlInOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$e64c31d2830b66e4 extends (0, $2pDMz.ParserRuleContext) {
    IS() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.IS, 0);
    }
    NOT() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlIsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsOperator) listener.enterJqlIsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsOperator) listener.exitJqlIsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsOperator) return visitor.visitJqlIsOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$7e283636700e4a6c extends (0, $2pDMz.ParserRuleContext) {
    WAS() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.WAS, 0);
    }
    NOT() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlWasOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasOperator) listener.enterJqlWasOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasOperator) listener.exitJqlWasOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasOperator) return visitor.visitJqlWasOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$b9118b1ed9a78d66 extends (0, $2pDMz.ParserRuleContext) {
    WAS() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.WAS, 0);
    }
    IN() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlWasInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInOperator) listener.enterJqlWasInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInOperator) listener.exitJqlWasInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInOperator) return visitor.visitJqlWasInOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$493d626ed78ca66 extends (0, $2pDMz.ParserRuleContext) {
    CHANGED() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.CHANGED, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlChangedOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedOperator) listener.enterJqlChangedOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedOperator) listener.exitJqlChangedOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedOperator) return visitor.visitJqlChangedOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$b33300c3d916229a extends (0, $2pDMz.ParserRuleContext) {
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlField;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
class $da70a06608213e15$export$11fec15307d2e17b extends $da70a06608213e15$export$b33300c3d916229a {
    jqlNumber() {
        return this.getRuleContext(0, $da70a06608213e15$export$8737d94a1880e8b3);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumberField) listener.enterJqlNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumberField) listener.exitJqlNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumberField) return visitor.visitJqlNumberField(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$b8b24f99f985ebb3 extends $da70a06608213e15$export$b33300c3d916229a {
    jqlString() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$bde73d8ad7c8b71e);
    }
    jqlCustomField() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$401a038855cc5b15);
    }
    jqlFieldProperty(i) {
        if (i === undefined) return this.getRuleContexts($da70a06608213e15$export$b02d0b6637ce0593);
        else return this.getRuleContext(i, $da70a06608213e15$export$b02d0b6637ce0593);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNonNumberField) listener.enterJqlNonNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNonNumberField) listener.exitJqlNonNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNonNumberField) return visitor.visitJqlNonNumberField(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$b02d0b6637ce0593 extends (0, $2pDMz.ParserRuleContext) {
    LBRACKET() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.LBRACKET, 0);
    }
    RBRACKET() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.RBRACKET, 0);
    }
    jqlPropertyArgument(i) {
        if (i === undefined) return this.getRuleContexts($da70a06608213e15$export$e20ce4a2ed16372c);
        else return this.getRuleContext(i, $da70a06608213e15$export$e20ce4a2ed16372c);
    }
    jqlArgument() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$a95583953c237f88);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlFieldProperty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFieldProperty) listener.enterJqlFieldProperty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFieldProperty) listener.exitJqlFieldProperty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFieldProperty) return visitor.visitJqlFieldProperty(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$401a038855cc5b15 extends (0, $2pDMz.ParserRuleContext) {
    CUSTOMFIELD() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.CUSTOMFIELD, 0);
    }
    LBRACKET() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.LBRACKET, 0);
    }
    POSNUMBER() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    RBRACKET() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.RBRACKET, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlCustomField;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlCustomField) listener.enterJqlCustomField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlCustomField) listener.exitJqlCustomField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlCustomField) return visitor.visitJqlCustomField(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$bde73d8ad7c8b71e extends (0, $2pDMz.ParserRuleContext) {
    STRING() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.STRING, 0);
    }
    QUOTE_STRING() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.QUOTE_STRING, 0);
    }
    SQUOTE_STRING() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.SQUOTE_STRING, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlString;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlString) listener.enterJqlString(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlString) listener.exitJqlString(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlString) return visitor.visitJqlString(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$8737d94a1880e8b3 extends (0, $2pDMz.ParserRuleContext) {
    POSNUMBER() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    NEGNUMBER() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.NEGNUMBER, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlNumber;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumber) listener.enterJqlNumber(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumber) listener.exitJqlNumber(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumber) return visitor.visitJqlNumber(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$2eaac5a9828bf647 extends (0, $2pDMz.ParserRuleContext) {
    jqlEmpty() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$ebf0cc785e9ee41a);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$9cb97a63f2be4864);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOperand) listener.enterJqlOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOperand) listener.exitJqlOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOperand) return visitor.visitJqlOperand(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$d85a062f90025e5c extends (0, $2pDMz.ParserRuleContext) {
    EMPTY() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.EMPTY, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlEmpty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEmpty) listener.enterJqlEmpty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEmpty) listener.exitJqlEmpty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEmpty) return visitor.visitJqlEmpty(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$2e17d457b0933bec extends (0, $2pDMz.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlValue;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValue) listener.enterJqlValue(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValue) listener.exitJqlValue(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValue) return visitor.visitJqlValue(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$ebf0cc785e9ee41a extends (0, $2pDMz.ParserRuleContext) {
    jqlFunctionName() {
        return this.getRuleContext(0, $da70a06608213e15$export$1f5f7ac816788f44);
    }
    LPAREN() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.RPAREN, 0);
    }
    jqlArgumentList() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$83d7c13849b931c3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlFunction;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunction) listener.enterJqlFunction(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunction) listener.exitJqlFunction(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunction) return visitor.visitJqlFunction(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$1f5f7ac816788f44 extends (0, $2pDMz.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlFunctionName;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunctionName) listener.enterJqlFunctionName(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunctionName) listener.exitJqlFunctionName(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunctionName) return visitor.visitJqlFunctionName(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$83d7c13849b931c3 extends (0, $2pDMz.ParserRuleContext) {
    jqlArgument(i) {
        if (i === undefined) return this.getRuleContexts($da70a06608213e15$export$a95583953c237f88);
        else return this.getRuleContext(i, $da70a06608213e15$export$a95583953c237f88);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($da70a06608213e15$export$9c4772e191bdb810.COMMA);
        else return this.getToken($da70a06608213e15$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlArgumentList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgumentList) listener.enterJqlArgumentList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgumentList) listener.exitJqlArgumentList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgumentList) return visitor.visitJqlArgumentList(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$9cb97a63f2be4864 extends (0, $2pDMz.ParserRuleContext) {
    jqlListStart() {
        return this.getRuleContext(0, $da70a06608213e15$export$c419f717bfc46a5d);
    }
    jqlOperand(i) {
        if (i === undefined) return this.getRuleContexts($da70a06608213e15$export$2eaac5a9828bf647);
        else return this.getRuleContext(i, $da70a06608213e15$export$2eaac5a9828bf647);
    }
    jqlListEnd() {
        return this.getRuleContext(0, $da70a06608213e15$export$f6cd3e372f5ab120);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($da70a06608213e15$export$9c4772e191bdb810.COMMA);
        else return this.getToken($da70a06608213e15$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlList) listener.enterJqlList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlList) listener.exitJqlList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlList) return visitor.visitJqlList(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$c419f717bfc46a5d extends (0, $2pDMz.ParserRuleContext) {
    LPAREN() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.LPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlListStart;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListStart) listener.enterJqlListStart(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListStart) listener.exitJqlListStart(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListStart) return visitor.visitJqlListStart(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$f6cd3e372f5ab120 extends (0, $2pDMz.ParserRuleContext) {
    RPAREN() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.RPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlListEnd;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListEnd) listener.enterJqlListEnd(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListEnd) listener.exitJqlListEnd(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListEnd) return visitor.visitJqlListEnd(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$e20ce4a2ed16372c extends (0, $2pDMz.ParserRuleContext) {
    jqlArgument() {
        return this.getRuleContext(0, $da70a06608213e15$export$a95583953c237f88);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlPropertyArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPropertyArgument) listener.enterJqlPropertyArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPropertyArgument) listener.exitJqlPropertyArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPropertyArgument) return visitor.visitJqlPropertyArgument(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$a95583953c237f88 extends (0, $2pDMz.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgument) listener.enterJqlArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgument) listener.exitJqlArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgument) return visitor.visitJqlArgument(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$9fa1e4d63f31b911 extends (0, $2pDMz.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $da70a06608213e15$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$ad402332075c8656);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlWasPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasPredicate) listener.enterJqlWasPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasPredicate) listener.exitJqlWasPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasPredicate) return visitor.visitJqlWasPredicate(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$e77e479a48133015 extends (0, $2pDMz.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $da70a06608213e15$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$ad402332075c8656);
    }
    jqlValuePredicateOperator() {
        return this.tryGetRuleContext(0, $da70a06608213e15$export$4239d7c0fbafd3f1);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlChangedPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedPredicate) listener.enterJqlChangedPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedPredicate) listener.exitJqlChangedPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedPredicate) return visitor.visitJqlChangedPredicate(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$dc01290aee731418 extends (0, $2pDMz.ParserRuleContext) {
    AFTER() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.AFTER, 0);
    }
    BEFORE() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.BEFORE, 0);
    }
    ON() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.ON, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDatePredicateOperator) listener.enterJqlDatePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDatePredicateOperator) listener.exitJqlDatePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDatePredicateOperator) return visitor.visitJqlDatePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$75412b8b6a6442e1 extends (0, $2pDMz.ParserRuleContext) {
    DURING() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.DURING, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDateRangePredicateOperator) listener.enterJqlDateRangePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDateRangePredicateOperator) listener.exitJqlDateRangePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDateRangePredicateOperator) return visitor.visitJqlDateRangePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$ad402332075c8656 extends (0, $2pDMz.ParserRuleContext) {
    BY() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.BY, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlUserPredicateOperator) listener.enterJqlUserPredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlUserPredicateOperator) listener.exitJqlUserPredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlUserPredicateOperator) return visitor.visitJqlUserPredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$4239d7c0fbafd3f1 extends (0, $2pDMz.ParserRuleContext) {
    FROM() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.FROM, 0);
    }
    TO() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.TO, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValuePredicateOperator) listener.enterJqlValuePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValuePredicateOperator) listener.exitJqlValuePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValuePredicateOperator) return visitor.visitJqlValuePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$6b796c5a4b8c18e extends (0, $2pDMz.ParserRuleContext) {
    jqlOperand() {
        return this.getRuleContext(0, $da70a06608213e15$export$2eaac5a9828bf647);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlPredicateOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPredicateOperand) listener.enterJqlPredicateOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPredicateOperand) listener.exitJqlPredicateOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPredicateOperand) return visitor.visitJqlPredicateOperand(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$534469b9c8f44139 extends (0, $2pDMz.ParserRuleContext) {
    ORDER() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.ORDER, 0);
    }
    BY() {
        return this.getToken($da70a06608213e15$export$9c4772e191bdb810.BY, 0);
    }
    jqlSearchSort(i) {
        if (i === undefined) return this.getRuleContexts($da70a06608213e15$export$c7d8f03f36952a46);
        else return this.getRuleContext(i, $da70a06608213e15$export$c7d8f03f36952a46);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($da70a06608213e15$export$9c4772e191bdb810.COMMA);
        else return this.getToken($da70a06608213e15$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlOrderBy;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrderBy) listener.enterJqlOrderBy(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrderBy) listener.exitJqlOrderBy(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrderBy) return visitor.visitJqlOrderBy(this);
        else return visitor.visitChildren(this);
    }
}
class $da70a06608213e15$export$c7d8f03f36952a46 extends (0, $2pDMz.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $da70a06608213e15$export$b33300c3d916229a);
    }
    DESC() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.DESC, 0);
    }
    ASC() {
        return this.tryGetToken($da70a06608213e15$export$9c4772e191bdb810.ASC, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $da70a06608213e15$export$9c4772e191bdb810.RULE_jqlSearchSort;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSearchSort) listener.enterJqlSearchSort(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSearchSort) listener.exitJqlSearchSort(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSearchSort) return visitor.visitJqlSearchSort(this);
        else return visitor.visitChildren(this);
    }
}

});

parcelRegister("2LdPw", function(module, exports) {

$parcel$export(module.exports, "JastBuilderErrorListener", () => $9d1e757a85c6d8f7$export$d0857f60ff1f385);

var $5f9Gp = parcelRequire("5f9Gp");

var $jvkYJ = parcelRequire("jvkYJ");
class $9d1e757a85c6d8f7$export$d0857f60ff1f385 {
    constructor(){
        this.errors = [];
        this.syntaxError = (recognizer, offendingSymbol, line, charPositionInLine, msg)=>{
            if (offendingSymbol === undefined) this.errors.push(new (0, $5f9Gp.JQLParseError)(msg));
            else this.errors.push(new (0, $jvkYJ.JQLSyntaxError)(msg, offendingSymbol.startIndex, offendingSymbol.stopIndex + 1, line, charPositionInLine));
        };
    }
}

});
parcelRegister("5f9Gp", function(module, exports) {

$parcel$export(module.exports, "JQLParseError", () => $fcea64aa89bd25b5$export$e8cfe2b2c93fbd4b);
/**
 * Represents a error occurring when trying to parse JQL into a Jast.
 */ class $fcea64aa89bd25b5$export$e8cfe2b2c93fbd4b extends Error {
    constructor(message, cause){
        super(message);
        this.name = 'JQLParseError';
        this.cause = cause;
        this.description = message;
    }
}

});

parcelRegister("jvkYJ", function(module, exports) {

$parcel$export(module.exports, "JQLSyntaxError", () => $dd59473da10f4ab1$export$3276184116160c41);

var $5f9Gp = parcelRequire("5f9Gp");
class $dd59473da10f4ab1$export$3276184116160c41 extends (0, $5f9Gp.JQLParseError) {
    constructor(message, start, stop, line, charPositionInLine){
        super(message);
        this.name = 'JQLSyntaxError';
        this.start = start;
        this.stop = stop;
        this.line = line;
        this.charPositionInLine = charPositionInLine;
    }
}

});


parcelRegister("b4x0R", function(module, exports) {

$parcel$export(module.exports, "QueryVisitor", () => $2b2312574b9790db$export$418003b930734805);

var $55Dca = parcelRequire("55Dca");

var $aGIwH = parcelRequire("aGIwH");

var $cNXii = parcelRequire("cNXii");

var $kivNc = parcelRequire("kivNc");
class $2b2312574b9790db$export$418003b930734805 extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.whereVisitor = new (0, $kivNc.WhereVisitor)(this.tokens);
        this.orderByVisitor = new (0, $cNXii.OrderByVisitor)(this.tokens);
        this.visitJqlQuery = (ctx)=>{
            const whereContext = ctx.jqlWhere();
            const orderByContext = ctx.jqlOrderBy();
            return (0, $55Dca.internalCreators).query(whereContext && whereContext.accept(this.whereVisitor), orderByContext && orderByContext.accept(this.orderByVisitor), (0, $aGIwH.getPositionFromContext)(ctx));
        };
    }
}

});
parcelRegister("aGIwH", function(module, exports) {

$parcel$export(module.exports, "JastBuildingVisitor", () => $f0376253d885c31f$export$d3c14d7188b09387);
$parcel$export(module.exports, "getPositionFromToken", () => $f0376253d885c31f$export$85a4e6d858dbc6fb);
$parcel$export(module.exports, "getPositionFromContext", () => $f0376253d885c31f$export$264629d4cd3cad3f);
$parcel$export(module.exports, "getPositionsFromTerminalNodes", () => $f0376253d885c31f$export$30d51184879cbaa8);
$parcel$export(module.exports, "normalizeText", () => $f0376253d885c31f$export$7c2714a5250b9239);
class $f0376253d885c31f$export$d3c14d7188b09387 {
    constructor(tokens){
        this.tokens = tokens;
    }
    visit(tree) {
        throw new Error('Unsupported operation visit(ParseTree)');
    }
    visitChildren(node) {
        throw new Error('Unsupported operation visitChildren(RuleNode)');
    }
    visitErrorNode(node) {
        throw new Error('Unsupported operation visitErrorNode(ErrorNode)');
    }
    visitTerminal(node) {
        throw new Error('Unsupported operation visitTerminal(TerminalNode)');
    }
}
const $f0376253d885c31f$export$85a4e6d858dbc6fb = (startToken, stopToken)=>[
        startToken.startIndex,
        (stopToken || startToken).stopIndex + 1
    ];
const $f0376253d885c31f$export$264629d4cd3cad3f = (ctx)=>[
        ctx.start.startIndex,
        ctx.stop ? ctx.stop.stopIndex + 1 : ctx.start.stopIndex
    ];
const $f0376253d885c31f$export$30d51184879cbaa8 = (terminalNodes)=>terminalNodes.map((node)=>$f0376253d885c31f$export$85a4e6d858dbc6fb(node.payload));
const $f0376253d885c31f$export$7c2714a5250b9239 = (text)=>text.toLowerCase().replace(/\s+/g, ' ');

});

parcelRegister("cNXii", function(module, exports) {

$parcel$export(module.exports, "OrderByVisitor", () => $799480cf51dbaadc$export$2774b71b99734811);


var $55Dca = parcelRequire("55Dca");

var $6R7C1 = parcelRequire("6R7C1");

var $aGIwH = parcelRequire("aGIwH");

var $hxSby = parcelRequire("hxSby");
class $799480cf51dbaadc$export$2774b71b99734811 extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.searchSortVisitor = new $799480cf51dbaadc$var$SearchSortVisitor(this.tokens);
        this.visitJqlOrderBy = (ctx)=>{
            // If this rule returned due to an exception then the order by operator is incomplete so we should exit early,
            // e.g. 'order '.
            if (ctx.exception) return undefined;
            const operator = (0, $55Dca.internalCreators).orderByOperator((0, $aGIwH.getPositionFromToken)(ctx.ORDER().payload, ctx.BY().payload));
            const fields = ctx.jqlSearchSort().map((searchSortCtx)=>searchSortCtx.accept(this.searchSortVisitor)).filter((0, $6R7C1.notUndefined));
            return (0, $55Dca.internalCreators).orderBy(fields, operator, (0, $aGIwH.getPositionFromContext)(ctx));
        };
    }
}
class $799480cf51dbaadc$var$SearchSortVisitor extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.fieldVisitor = new (0, $hxSby.FieldVisitor)(this.tokens);
        this.visitJqlSearchSort = (ctx)=>{
            const fieldCtx = ctx.jqlField();
            // If the field rule is returned due to an exception then we should ignore this search search rule. This happens
            // when there are no fields following and order by clause, e.g. 'order by '
            if (fieldCtx.exception) return undefined;
            let direction;
            const desc = ctx.DESC();
            const asc = ctx.ASC();
            if (desc !== undefined) direction = (0, $55Dca.internalCreators).orderByDirection((0, $70c12d333a882310$export$2ea27ea5f2121899), (0, $aGIwH.getPositionFromToken)(desc.payload));
            else if (asc !== undefined) direction = (0, $55Dca.internalCreators).orderByDirection((0, $70c12d333a882310$export$6d60017b9e092e73), (0, $aGIwH.getPositionFromToken)(asc.payload));
            return (0, $55Dca.internalCreators).orderByField(ctx.jqlField().accept(this.fieldVisitor), direction, (0, $aGIwH.getPositionFromContext)(ctx));
        };
    }
}

});
parcelRegister("6R7C1", function(module, exports) {

$parcel$export(module.exports, "notUndefined", () => $0f54475b388c26e6$export$9a1adf421b69c6a);
/**
 * Type predicate to assert an argument is not undefined.
 */ function $0f54475b388c26e6$export$9a1adf421b69c6a(x) {
    return x !== undefined;
}

});

parcelRegister("hxSby", function(module, exports) {

$parcel$export(module.exports, "FieldVisitor", () => $95635f56ebf6c101$export$c6a85c4c3bf2317d);

var $55Dca = parcelRequire("55Dca");

var $2NHz8 = parcelRequire("2NHz8");

var $aGIwH = parcelRequire("aGIwH");

var $l3nZm = parcelRequire("l3nZm");
class $95635f56ebf6c101$export$c6a85c4c3bf2317d extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $l3nZm.StringVisitor)(this.tokens);
        this.fieldPropertyVisitor = new $95635f56ebf6c101$var$FieldPropertyVisitor(this.tokens);
        this.visitJqlNumberField = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $55Dca.internalCreators).field(text, text, undefined, (0, $aGIwH.getPositionFromContext)(ctx));
        };
        this.visitJqlNonNumberField = (ctx)=>{
            const stringContext = ctx.jqlString();
            const properties = ctx.jqlFieldProperty().map((context)=>context.accept(this.fieldPropertyVisitor));
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $55Dca.internalCreators).field(stringValue.value, stringValue.text, properties, (0, $aGIwH.getPositionFromContext)(ctx));
            }
            const text = this.tokens.getText(ctx);
            return (0, $55Dca.internalCreators).field(text, text, properties, (0, $aGIwH.getPositionFromContext)(ctx));
        };
    }
}
class $95635f56ebf6c101$var$FieldPropertyVisitor extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.argumentVisitor = new (0, $2NHz8.ArgumentVisitor)(this.tokens);
        this.propertyArgumentVisitor = new $95635f56ebf6c101$var$PropertyArgumentVisitor(this.tokens);
        this.visitJqlFieldProperty = (ctx)=>{
            const argumentContext = ctx.jqlArgument();
            const propertyArgumentContext = ctx.jqlPropertyArgument();
            const path = propertyArgumentContext.map((context)=>context.accept(this.propertyArgumentVisitor));
            return (0, $55Dca.internalCreators).property(argumentContext && argumentContext.accept(this.argumentVisitor), path, (0, $aGIwH.getPositionFromContext)(ctx));
        };
    }
}
class $95635f56ebf6c101$var$PropertyArgumentVisitor extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.argumentVisitor = new (0, $2NHz8.ArgumentVisitor)(this.tokens);
        this.visitJqlPropertyArgument = (ctx)=>{
            return ctx.jqlArgument().accept(this.argumentVisitor);
        };
    }
}

});
parcelRegister("2NHz8", function(module, exports) {

$parcel$export(module.exports, "ArgumentVisitor", () => $d7f75985ee85a33b$export$46b5a1f6d962d533);

var $55Dca = parcelRequire("55Dca");

var $aGIwH = parcelRequire("aGIwH");

var $l3nZm = parcelRequire("l3nZm");
class $d7f75985ee85a33b$export$46b5a1f6d962d533 extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $l3nZm.StringVisitor)(this.tokens);
        this.visitJqlArgument = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $55Dca.internalCreators).argument(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $55Dca.internalCreators).argument(text, text, (0, $aGIwH.getPositionFromContext)(ctx));
            }
        };
    }
}

});
parcelRegister("l3nZm", function(module, exports) {

$parcel$export(module.exports, "StringVisitor", () => $18135553f20a087e$export$617850cb96304515);

var $aGIwH = parcelRequire("aGIwH");
class $18135553f20a087e$export$617850cb96304515 extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.visitJqlString = (ctx)=>{
            const text = this.tokens.getText(ctx);
            const position = (0, $aGIwH.getPositionFromContext)(ctx);
            let value;
            if (ctx.QUOTE_STRING()) value = text.replace(/^"|"$/g, '').replace(/(?:\\(.))/g, '$1');
            else if (ctx.SQUOTE_STRING()) value = text.replace(/^'|'$/g, '').replace(/(?:\\(.))/g, '$1');
            else // unquoted string
            value = text;
            return {
                text: text,
                value: value,
                position: position
            };
        };
    }
}

});




parcelRegister("kivNc", function(module, exports) {

$parcel$export(module.exports, "WhereVisitor", () => $31f74921393a31ec$export$c573472f1d20e15d);


var $55Dca = parcelRequire("55Dca");

var $6R7C1 = parcelRequire("6R7C1");

var $aGIwH = parcelRequire("aGIwH");

var $62EJv = parcelRequire("62EJv");
class $31f74921393a31ec$export$c573472f1d20e15d extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.terminalClauseVisitor = new (0, $62EJv.TerminalClauseVisitor)(this.tokens);
        this.visitJqlWhere = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        };
        this.visitJqlOrClause = (ctx)=>{
            const clauses = ctx.jqlAndClause().map((andClauseContext)=>andClauseContext.accept(this)).filter((0, $6R7C1.notUndefined));
            if (clauses.length > 1) {
                const operator = (0, $55Dca.internalCreators).compoundOperator((0, $e1349279c1d70213$export$7b8f0a728d79a753), (0, $aGIwH.getPositionsFromTerminalNodes)(ctx.OR()));
                return (0, $55Dca.internalCreators).compoundClause(operator, clauses, (0, $aGIwH.getPositionFromContext)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        };
        this.visitJqlAndClause = (ctx)=>{
            const clauses = ctx.jqlNotClause().map((notClauseContext)=>notClauseContext.accept(this)).filter((0, $6R7C1.notUndefined));
            if (clauses.length > 1) {
                const operator = (0, $55Dca.internalCreators).compoundOperator((0, $e1349279c1d70213$export$6d6d48d210d3ca97), (0, $aGIwH.getPositionsFromTerminalNodes)(ctx.AND()));
                return (0, $55Dca.internalCreators).compoundClause(operator, clauses, (0, $aGIwH.getPositionFromContext)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        };
        this.visitJqlNotClause = (ctx)=>{
            const notClauseContext = ctx.jqlNotClause();
            const subClauseContext = ctx.jqlSubClause();
            const terminalClauseContext = ctx.jqlTerminalClause();
            let clause;
            if (notClauseContext !== undefined) clause = notClauseContext.accept(this) || undefined;
            else if (subClauseContext !== undefined) clause = subClauseContext.accept(this) || undefined;
            else if (terminalClauseContext !== undefined) clause = terminalClauseContext.accept(this.terminalClauseVisitor);
            // Our token can be either NOT or !
            let notToken = ctx.NOT();
            notToken = notToken === undefined ? ctx.BANG() : notToken;
            if (notToken && clause) return (0, $55Dca.internalCreators).notClause(clause, (0, $55Dca.internalCreators).notClauseOperator((0, $aGIwH.getPositionFromToken)(notToken.payload)), (0, $aGIwH.getPositionFromContext)(ctx));
            return clause;
        };
        this.visitJqlSubClause = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        };
    }
}

});
parcelRegister("62EJv", function(module, exports) {

$parcel$export(module.exports, "TerminalClauseVisitor", () => $88b0e15d73115c48$export$14576ae5bd1874a9);

var $55Dca = parcelRequire("55Dca");

var $6R7C1 = parcelRequire("6R7C1");

var $aGIwH = parcelRequire("aGIwH");

var $hxSby = parcelRequire("hxSby");

var $3B1SK = parcelRequire("3B1SK");

var $8Y90f = parcelRequire("8Y90f");

var $5L736 = parcelRequire("5L736");
class $88b0e15d73115c48$export$14576ae5bd1874a9 extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.fieldVisitor = new (0, $hxSby.FieldVisitor)(this.tokens);
        this.terminalClauseRhsVisitor = new $88b0e15d73115c48$var$TerminalClauseRhsVisitor(this.tokens);
        this.visitJqlTerminalClause = (ctx)=>{
            const field = ctx.jqlField().accept(this.fieldVisitor);
            const { operator: operator, operand: operand, predicates: predicates } = ctx.jqlTerminalClauseRhs().accept(this.terminalClauseRhsVisitor);
            const position = (0, $aGIwH.getPositionFromContext)(ctx);
            return (0, $55Dca.internalCreators).terminalClause(field, operator, operand, predicates, position);
        };
    }
}
class $88b0e15d73115c48$var$TerminalClauseRhsVisitor extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.operatorVisitor = new (0, $8Y90f.OperatorVisitor)(this.tokens);
        this.terminalClauseOperandVisitor = new $88b0e15d73115c48$var$TerminalClauseOperandVisitor(this.tokens);
        this.predicateVisitor = new (0, $5L736.PredicateVisitor)(this.tokens);
        this.visitJqlEqualsClause = (ctx)=>{
            const operator = ctx.jqlEqualsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlLikeClause = (ctx)=>{
            const operator = ctx.jqlLikeOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlComparisonClause = (ctx)=>{
            const operator = ctx.jqlComparisonOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlInClause = (ctx)=>{
            const operator = ctx.jqlInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlIsClause = (ctx)=>{
            const operator = ctx.jqlIsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlWasClause = (ctx)=>{
            const operator = ctx.jqlWasOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $6R7C1.notUndefined));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        };
        this.visitJqlWasInClause = (ctx)=>{
            const operator = ctx.jqlWasInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $6R7C1.notUndefined));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        };
        this.visitJqlChangedClause = (ctx)=>{
            const operator = ctx.jqlChangedOperator().accept(this.operatorVisitor);
            const predicates = ctx.jqlChangedPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $6R7C1.notUndefined));
            return {
                operator: operator,
                operand: undefined,
                predicates: predicates
            };
        };
        // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const operator = node.accept(this.operatorVisitor);
            return {
                operator: operator,
                operand: undefined,
                predicates: []
            };
        };
    }
}
class $88b0e15d73115c48$var$TerminalClauseOperandVisitor extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.operandVisitor = new (0, $3B1SK.OperandVisitor)(this.tokens);
        this.visitJqlEqualsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlLikeClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlComparisonClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlIsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty()
            ]);
        };
        this.visitJqlWasClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlWasInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        };
        this.getOperandForContexts = (contexts)=>{
            const operandContext = contexts.find((0, $6R7C1.notUndefined));
            return operandContext?.accept(this.operandVisitor);
        };
    }
}

});
parcelRegister("3B1SK", function(module, exports) {

$parcel$export(module.exports, "OperandVisitor", () => $765a5ae0a0bfaf9a$export$ef8ae1aa15d9c9af);


var $55Dca = parcelRequire("55Dca");

var $6R7C1 = parcelRequire("6R7C1");

var $2NHz8 = parcelRequire("2NHz8");

var $aGIwH = parcelRequire("aGIwH");

var $hd3JX = parcelRequire("hd3JX");

var $l3nZm = parcelRequire("l3nZm");
class $765a5ae0a0bfaf9a$export$ef8ae1aa15d9c9af extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $l3nZm.StringVisitor)(this.tokens);
        this.numberVisitor = new (0, $hd3JX.NumberVisitor)(this.tokens);
        this.functionNameVisitor = new $765a5ae0a0bfaf9a$var$FunctionNameVisitor(this.tokens);
        this.argumentListVisitor = new $765a5ae0a0bfaf9a$var$ArgumentListVisitor(this.tokens);
        this.visitJqlOperand = (ctx)=>{
            const operandContext = [
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlList(),
                ctx.jqlFunction()
            ].find((0, $6R7C1.notUndefined));
            return operandContext?.accept(this);
        };
        this.visitJqlEmpty = (ctx)=>{
            // ANTLR will optimistically create a jqlEmpty node in some situations where user input doesn't match the EMPTY
            // token, e.g. when using value operands in IS clauses ("field is value"), where EMPTY is the only valid operand.
            if (ctx.exception) return undefined;
            return (0, $55Dca.internalCreators).keywordOperand((0, $2de6644e999aca05$export$1c46dca02aac24dd), (0, $aGIwH.getPositionFromToken)(ctx.EMPTY().payload));
        };
        this.visitJqlValue = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $55Dca.internalCreators).valueOperand(stringValue.value, stringValue.text, stringValue.position);
            }
            const numberContext = ctx.jqlNumber();
            if (numberContext !== undefined) return numberContext.accept(this.numberVisitor);
        };
        this.visitJqlList = (ctx)=>{
            const values = ctx.jqlOperand().map((operandCtx)=>operandCtx.accept(this)).filter((0, $6R7C1.notUndefined));
            return (0, $55Dca.internalCreators).listOperand(values, (0, $aGIwH.getPositionFromContext)(ctx));
        };
        this.visitJqlFunction = (ctx)=>{
            const argumentListContext = ctx.jqlArgumentList();
            return (0, $55Dca.internalCreators).functionOperand(ctx.jqlFunctionName().accept(this.functionNameVisitor), argumentListContext === undefined ? [] : argumentListContext.accept(this.argumentListVisitor), (0, $aGIwH.getPositionFromContext)(ctx));
        };
    }
}
class $765a5ae0a0bfaf9a$var$FunctionNameVisitor extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $l3nZm.StringVisitor)(this.tokens);
        this.visitJqlFunctionName = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $55Dca.internalCreators).functionString(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $55Dca.internalCreators).functionString(text, text, (0, $aGIwH.getPositionFromContext)(ctx));
            }
        };
    }
}
class $765a5ae0a0bfaf9a$var$ArgumentListVisitor extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.argumentVisitor = new (0, $2NHz8.ArgumentVisitor)(this.tokens);
        this.visitJqlArgumentList = (ctx)=>{
            return ctx.jqlArgument().map((argumentCtx)=>argumentCtx.accept(this.argumentVisitor));
        };
    }
}

});
parcelRegister("hd3JX", function(module, exports) {

$parcel$export(module.exports, "NumberVisitor", () => $04bacb0e8d538d32$export$a55432f0884633e4);

var $55Dca = parcelRequire("55Dca");

var $aGIwH = parcelRequire("aGIwH");
class $04bacb0e8d538d32$export$a55432f0884633e4 extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.visitJqlNumber = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $55Dca.internalCreators).valueOperand(text, text, (0, $aGIwH.getPositionFromContext)(ctx));
        };
    }
}

});


parcelRegister("8Y90f", function(module, exports) {

$parcel$export(module.exports, "OperatorVisitor", () => $a7c3a4161de89a7b$export$e56f89ba95b51d2a);

var $55Dca = parcelRequire("55Dca");

var $e57LZ = parcelRequire("e57LZ");

var $aGIwH = parcelRequire("aGIwH");
class $a7c3a4161de89a7b$export$e56f89ba95b51d2a extends (0, $aGIwH.JastBuildingVisitor) {
    visitJqlEqualsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $e57LZ.isEqualsOperator)(text)) throw new Error(`'${text}' does not match any of the recognised equals operators`);
        return (0, $55Dca.internalCreators).operator(text, text, (0, $aGIwH.getPositionFromContext)(ctx));
    }
    visitJqlLikeOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $e57LZ.isLikeOperator)(text)) throw new Error(`'${text}' does not match any of the recognised like operators`);
        return (0, $55Dca.internalCreators).operator(text, text, (0, $aGIwH.getPositionFromContext)(ctx));
    }
    visitJqlComparisonOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $e57LZ.isComparisonOperator)(text)) throw new Error(`'${text}' does not match any of the recognised comparison operators`);
        return (0, $55Dca.internalCreators).operator(text, text, (0, $aGIwH.getPositionFromContext)(ctx));
    }
    visitJqlInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $aGIwH.normalizeText)(text);
        if (!(0, $e57LZ.isInOperator)(value)) // This can happen if an incomplete operator is used, e.g. `status not open`.
        return undefined;
        return (0, $55Dca.internalCreators).operator(value, text, (0, $aGIwH.getPositionFromContext)(ctx));
    }
    visitJqlIsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $aGIwH.normalizeText)(text);
        if (!(0, $e57LZ.isIsOperator)(value)) throw new Error(`'${text}' does not match any of the recognised is operators`);
        return (0, $55Dca.internalCreators).operator(value, text, (0, $aGIwH.getPositionFromContext)(ctx));
    }
    visitJqlWasOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $aGIwH.normalizeText)(text);
        if (!(0, $e57LZ.isWasOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was operators`);
        return (0, $55Dca.internalCreators).operator(value, text, (0, $aGIwH.getPositionFromContext)(ctx));
    }
    visitJqlWasInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $aGIwH.normalizeText)(text);
        if (!(0, $e57LZ.isWasInOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was in operators`);
        return (0, $55Dca.internalCreators).operator(value, text, (0, $aGIwH.getPositionFromContext)(ctx));
    }
    visitJqlChangedOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $aGIwH.normalizeText)(text);
        if (!(0, $e57LZ.isChangedOperator)(value)) throw new Error(`'${text}' does not match any of the recognised changed operators`);
        return (0, $55Dca.internalCreators).operator(value, text, (0, $aGIwH.getPositionFromContext)(ctx));
    }
    constructor(...args){
        super(...args);
        // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const { sourceInterval: sourceInterval } = node;
            const text = this.tokens.getText(sourceInterval);
            if (text) {
                const value = (0, $aGIwH.normalizeText)(text);
                const { a: startIndex, b: stopIndex } = sourceInterval;
                const startToken = this.tokens.get(startIndex);
                const stopToken = this.tokens.get(stopIndex);
                const position = (0, $aGIwH.getPositionFromToken)(startToken, stopToken);
                if ((0, $e57LZ.isOperator)(value)) return (0, $55Dca.internalCreators).operator(value, text, position);
            }
        };
    }
}

});
parcelRegister("e57LZ", function(module, exports) {

$parcel$export(module.exports, "isOperator", () => $64d369acfd68dde7$export$4e40859592ee7ac2);
$parcel$export(module.exports, "isEqualsOperator", () => $64d369acfd68dde7$export$6d0fc196fa8a1673);
$parcel$export(module.exports, "isLikeOperator", () => $64d369acfd68dde7$export$ad91b6d6a89cb64e);
$parcel$export(module.exports, "isComparisonOperator", () => $64d369acfd68dde7$export$4477c442bd5c2a6d);
$parcel$export(module.exports, "isInOperator", () => $64d369acfd68dde7$export$c5e1cdef30e30bff);
$parcel$export(module.exports, "isIsOperator", () => $64d369acfd68dde7$export$ccc3334744e395c7);
$parcel$export(module.exports, "isWasOperator", () => $64d369acfd68dde7$export$2b1c5d7e7856f91d);
$parcel$export(module.exports, "isWasInOperator", () => $64d369acfd68dde7$export$55d8c9b20d99509f);
$parcel$export(module.exports, "isChangedOperator", () => $64d369acfd68dde7$export$b65d23d23ade534b);
$parcel$export(module.exports, "isListOperator", () => $64d369acfd68dde7$export$b09522e4061bbdd6);

var $8XgA0 = parcelRequire("8XgA0");
const $64d369acfd68dde7$export$4e40859592ee7ac2 = (operator)=>(0, $8XgA0.OPERATORS).includes(operator);
const $64d369acfd68dde7$export$6d0fc196fa8a1673 = (operator)=>(0, $8XgA0.EQUALS_OPERATORS).includes(operator);
const $64d369acfd68dde7$export$ad91b6d6a89cb64e = (operator)=>(0, $8XgA0.LIKE_OPERATORS).includes(operator);
const $64d369acfd68dde7$export$4477c442bd5c2a6d = (operator)=>(0, $8XgA0.COMPARISON_OPERATORS).includes(operator);
const $64d369acfd68dde7$export$c5e1cdef30e30bff = (operator)=>(0, $8XgA0.IN_OPERATORS).includes(operator);
const $64d369acfd68dde7$export$ccc3334744e395c7 = (operator)=>(0, $8XgA0.IS_OPERATORS).includes(operator);
const $64d369acfd68dde7$export$2b1c5d7e7856f91d = (operator)=>(0, $8XgA0.WAS_OPERATORS).includes(operator);
const $64d369acfd68dde7$export$55d8c9b20d99509f = (operator)=>(0, $8XgA0.WAS_IN_OPERATORS).includes(operator);
const $64d369acfd68dde7$export$b65d23d23ade534b = (operator)=>(0, $8XgA0.CHANGED_OPERATORS).includes(operator);
const $64d369acfd68dde7$export$b09522e4061bbdd6 = (operator)=>(0, $8XgA0.LIST_OPERATORS).includes(operator);

});


parcelRegister("5L736", function(module, exports) {

$parcel$export(module.exports, "PredicateVisitor", () => $dc1e9d5e3397c6c5$export$33bb52a35c693109);

var $55Dca = parcelRequire("55Dca");

var $3CyUd = parcelRequire("3CyUd");

var $6R7C1 = parcelRequire("6R7C1");

var $aGIwH = parcelRequire("aGIwH");

var $3B1SK = parcelRequire("3B1SK");
class $dc1e9d5e3397c6c5$export$33bb52a35c693109 extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.predicateOperatorVisitor = new $dc1e9d5e3397c6c5$var$PredicateOperatorVisitor(this.tokens);
        this.predicateOperandVisitor = new $dc1e9d5e3397c6c5$var$PredicateOperandVisitor(this.tokens);
        this.visitJqlWasPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $aGIwH.getPositionFromContext)(ctx);
            return (0, $55Dca.internalCreators).predicate(operator, operand, position);
        };
        this.visitJqlChangedPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator(),
                ctx.jqlValuePredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $aGIwH.getPositionFromContext)(ctx);
            return (0, $55Dca.internalCreators).predicate(operator, operand, position);
        };
        this.getOperatorForContexts = (contexts)=>{
            const operatorContext = contexts.find((0, $6R7C1.notUndefined));
            if (operatorContext !== undefined) return operatorContext.accept(this.predicateOperatorVisitor);
            else throw new Error('Undefined predicate operator context');
        };
    }
}
class $dc1e9d5e3397c6c5$var$PredicateOperatorVisitor extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.visitJqlDatePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.visitJqlDateRangePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.visitJqlUserPredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.visitJqlValuePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.getPredicateOperator = (ctx)=>{
            const text = this.tokens.getText(ctx);
            // Replace consecutive whitespace chars with single space
            const value = text.toLowerCase().replace(/\s+/g, ' ');
            if (!(0, $3CyUd.isPredicateOperator)(value)) throw new Error(`Found a history predicate operator which does not map to a changed time predicate operator in the ast: ${text}`);
            return (0, $55Dca.internalCreators).predicateOperator(value, text, (0, $aGIwH.getPositionFromContext)(ctx));
        };
    }
}
class $dc1e9d5e3397c6c5$var$PredicateOperandVisitor extends (0, $aGIwH.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.operandVisitor = new (0, $3B1SK.OperandVisitor)(this.tokens);
        this.visitJqlPredicateOperand = (ctx)=>{
            return ctx.jqlOperand().accept(this.operandVisitor);
        };
    }
}

});
parcelRegister("3CyUd", function(module, exports) {

$parcel$export(module.exports, "isPredicateOperator", () => $22f66e88c94ee8cb$export$188978ad94919403);

var $aiKxg = parcelRequire("aiKxg");
const $22f66e88c94ee8cb$export$188978ad94919403 = (operator)=>(0, $aiKxg.PREDICATE_OPERATORS).includes(operator);

});
parcelRegister("aiKxg", function(module, exports) {

$parcel$export(module.exports, "PREDICATE_OPERATORS", () => $f05eabe48b165417$export$e200440af9f1d9f);
const $f05eabe48b165417$export$3d56e2ae1b4bbbf9 = 'after';
const $f05eabe48b165417$export$f0a816341603bb63 = 'before';
const $f05eabe48b165417$export$cdc81c84f768d513 = 'by';
const $f05eabe48b165417$export$8a5280c65e704c3d = 'during';
const $f05eabe48b165417$export$71f882dcac65f97a = 'from';
const $f05eabe48b165417$export$5685a35c6b0a7ee8 = 'on';
const $f05eabe48b165417$export$5a83c4789e531a = 'to';
const $f05eabe48b165417$export$e200440af9f1d9f = [
    $f05eabe48b165417$export$3d56e2ae1b4bbbf9,
    $f05eabe48b165417$export$f0a816341603bb63,
    $f05eabe48b165417$export$cdc81c84f768d513,
    $f05eabe48b165417$export$8a5280c65e704c3d,
    $f05eabe48b165417$export$71f882dcac65f97a,
    $f05eabe48b165417$export$5685a35c6b0a7ee8,
    $f05eabe48b165417$export$5a83c4789e531a
];

});









parcelRegister("d3C6e", function(module, exports) {

$parcel$export(module.exports, "IssueCreateProvider", () => $167db4325906604f$export$a975cd9627cdf4b6);
$parcel$export(module.exports, "useCreateIssue", () => $167db4325906604f$export$8af2d18142c8506c);
$parcel$export(module.exports, "isOptimisticIssue", () => $167db4325906604f$export$8512029c7fc94e58);
$parcel$export(module.exports, "useIsHighlighted", () => $167db4325906604f$export$2ecca9d8a7f031af);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eUqFw = parcelRequire("eUqFw");

var $lskA1 = parcelRequire("lskA1");

var $eI5EY = parcelRequire("eI5EY");

var $cWiVr = parcelRequire("cWiVr");

var $kjzom = parcelRequire("kjzom");

var $frfm9 = parcelRequire("frfm9");
class $167db4325906604f$var$IssueCreateJob {
    constructor(createParams){
        this.createParams = createParams;
        this.promise = new Promise((resolve, reject)=>{
            this.reject = reject;
            this.resolve = resolve;
        });
    }
}
const $167db4325906604f$var$IssueCreateContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $167db4325906604f$var$reducer = (state, action)=>{
    switch(action.type){
        case 'enqueue':
            return {
                ...state,
                jobQueue: [
                    ...state.jobQueue,
                    action.job
                ]
            };
        case 'start-job':
            return {
                ...state,
                runningJob: state.jobQueue[0],
                jobQueue: state.jobQueue.slice(1)
            };
        case 'end-job':
            return {
                ...state,
                runningJob: null
            };
        case 'highlight':
            return {
                ...state,
                highlightedIssues: new Set([
                    ...state.highlightedIssues,
                    action.issueId
                ])
            };
        case 'unhighlight':
            return {
                ...state,
                highlightedIssues: new Set([
                    ...state.highlightedIssues
                ].filter((id)=>id !== action.issueId))
            };
        case 'save-summary':
            return {
                ...state,
                summary: action.summary
            };
        default:
            return state;
    }
};
const $167db4325906604f$var$initialState = {
    jobQueue: [],
    runningJob: null,
    highlightedIssues: new Set(),
    summary: ''
};
const $167db4325906604f$export$a975cd9627cdf4b6 = ({ mutation: mutation, query: query, onCreateIssue: onCreateIssue, onRefetchIssue: onRefetchIssue, ignoreFiltersContext: ignoreFiltersContext = false, children: children })=>{
    const { data: { user: user } } = (0, $cWiVr.useCurrentUser)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const currentUser = user;
    // optimistic issue ids are negative numbers to distinguish them from real issue ids
    const nextIssueId = (0, $eUqFw.useRef)(-1);
    const [{ jobQueue: jobQueue, runningJob: runningJob, highlightedIssues: highlightedIssues, summary: summary }, dispatch] = (0, $eUqFw.useReducer)($167db4325906604f$var$reducer, $167db4325906604f$var$initialState);
    const createIssueController = onCreateIssue && onRefetchIssue ? (0, $kjzom.useCreateIssue)(onCreateIssue, onRefetchIssue) : (0, $kjzom.useCreateIssueOld)(mutation, query);
    const highlightIssue = (0, $eUqFw.useCallback)((issueId)=>dispatch({
            type: 'highlight',
            issueId: issueId
        }), []);
    const unhighlightIssue = (0, $eUqFw.useCallback)((issueId)=>setTimeout(()=>{
            dispatch({
                type: 'unhighlight',
                issueId: issueId
            });
        }, 2000), []);
    const createIssue = (0, $eUqFw.useCallback)((createParams)=>{
        const job = new $167db4325906604f$var$IssueCreateJob(createParams);
        dispatch({
            type: 'enqueue',
            job: job
        });
        let rank;
        if (createParams.input.rankAfter) rank = (0, $lskA1.getNextRank)(createParams.input.rankAfter.rank);
        else if (createParams.input.rankBefore) rank = (0, $lskA1.getPreviousRank)(createParams.input.rankBefore.rank);
        const reporter = {
            accountId: currentUser.accountId,
            avatarUrl: currentUser.avatarUrls['48x48'],
            displayName: currentUser.displayName
        };
        const optimisticIssuePayload = {
            issueId: nextIssueId.current--,
            rank: rank,
            reporter: reporter,
            ...createParams.input
        };
        return {
            optimisticIssuePayload: optimisticIssuePayload,
            promise: job.promise
        };
    }, [
        currentUser
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // dequeue and run the next job if there is one and there is no running job
        if (jobQueue.length > 0 && !runningJob) {
            const job = jobQueue[0];
            dispatch({
                type: 'start-job'
            });
            createIssueController({
                createParams: job.createParams,
                highlightIssue: highlightIssue,
                unhighlightIssue: unhighlightIssue,
                ignoreFiltersContext: ignoreFiltersContext
            }).then(job.resolve).catch(job.reject).finally(()=>dispatch({
                    type: 'end-job'
                }));
        }
    }, [
        createIssueController,
        highlightedIssues,
        jobQueue,
        runningJob,
        highlightIssue,
        unhighlightIssue,
        ignoreFiltersContext
    ]);
    (0, $frfm9.useCreateParamHandler)();
    const saveSummary = (0, $eUqFw.useCallback)((newSummary)=>{
        dispatch({
            type: 'save-summary',
            summary: newSummary
        });
    }, []);
    const value = (0, $eUqFw.useMemo)(()=>({
            createIssue: createIssue,
            highlightedIssues: highlightedIssues,
            summary: summary,
            saveSummary: saveSummary
        }), [
        createIssue,
        highlightedIssues,
        summary,
        saveSummary
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($167db4325906604f$var$IssueCreateContext.Provider, {
        value: value
    }, children);
};
const $167db4325906604f$export$8af2d18142c8506c = (onSubmit, onBlur)=>{
    const context = (0, $eUqFw.useContext)($167db4325906604f$var$IssueCreateContext);
    if (!context) throw new Error('useCreateIssue must be used within an IssueCreateProvider');
    const { createIssue: createIssue, summary: summary, saveSummary: saveSummary } = context;
    const summaryRef = (0, $eUqFw.useRef)(summary);
    const hasExitedWithoutUserAction = (0, $eUqFw.useRef)(true);
    const submit = (0, $eUqFw.useCallback)((createParams)=>{
        const result = createIssue(createParams);
        onSubmit(result);
        hasExitedWithoutUserAction.current = false;
        setTimeout(()=>{
            // reset the value as the form can stay open after submitting
            hasExitedWithoutUserAction.current = true;
        }, 100);
        return result;
    }, [
        createIssue,
        onSubmit
    ]);
    const blur = (0, $eUqFw.useCallback)((event)=>{
        if ((0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) onBlur?.(event);
        else onBlur?.();
        hasExitedWithoutUserAction.current = false;
    }, [
        onBlur
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            // if the component has exited without the user blurring the form or submitting,
            // then save the summary value so it can be reapplied
            saveSummary(hasExitedWithoutUserAction.current ? summaryRef.current : '');
        }, [
        saveSummary
    ]);
    return {
        summaryRef: summaryRef,
        submit: submit,
        blur: blur
    };
};
const $167db4325906604f$export$8512029c7fc94e58 = (issueId)=>issueId < 0;
const $167db4325906604f$export$2ecca9d8a7f031af = ()=>{
    const context = (0, $eUqFw.useContext)($167db4325906604f$var$IssueCreateContext);
    if (!context) throw new Error('useIsHighlighted must be used within an IssueCreateProvider');
    const { highlightedIssues: highlightedIssues } = context;
    return (0, $eUqFw.useCallback)((issueId)=>$167db4325906604f$export$8512029c7fc94e58(issueId) || highlightedIssues.has(issueId), [
        highlightedIssues
    ]);
};

});
parcelRegister("lskA1", function(module, exports) {

$parcel$export(module.exports, "getNextRank", () => $7b4071d915fd0829$export$5c16a8b7eebff4b8);
$parcel$export(module.exports, "getPreviousRank", () => $7b4071d915fd0829$export$e2047b3433d9f565);
const $7b4071d915fd0829$export$5c16a8b7eebff4b8 = (s)=>`${s}0`;
const $7b4071d915fd0829$export$e2047b3433d9f565 = (s)=>{
    const lastCharCode = s.charCodeAt(s.length - 1);
    const previousLastChar = String.fromCharCode(lastCharCode - 1);
    if (lastCharCode === 0) return $7b4071d915fd0829$export$e2047b3433d9f565(s.substring(0, s.length - 1));
    return `${s.substring(0, s.length - 1)}${previousLastChar}99`;
};

});

parcelRegister("kjzom", function(module, exports) {

$parcel$export(module.exports, "useCreateIssueOld", () => $b3543cf4b0365df5$export$1245c77f7693955b);
$parcel$export(module.exports, "useCreateIssue", () => $b3543cf4b0365df5$export$8af2d18142c8506c);

var $eUqFw = parcelRequire("eUqFw");

var $gEmpR = parcelRequire("gEmpR");

var $c7wtc = parcelRequire("c7wtc");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $7byHA = parcelRequire("7byHA");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $iNULk = parcelRequire("iNULk");

var $fop6E = parcelRequire("fop6E");

var $5ujax = parcelRequire("5ujax");

var $auegK = parcelRequire("auegK");

var $fOAem = parcelRequire("fOAem");

var $9Y2JR = parcelRequire("9Y2JR");
const $b3543cf4b0365df5$export$8edbb6d449614942 = ()=>{
    const workflows = (0, $c7wtc.useWorkflows)();
    return (0, $eUqFw.useCallback)((createInput)=>{
        if (createInput.status && workflows != null) {
            // find the workflow for the input issue type
            const workflow = workflows.find((w)=>w.issueTypes.some((it)=>it.issueTypeId === createInput.issueType.id));
            // find the first transition to the input status that is initial, or global but not conditional
            const { statusId: statusId } = createInput.status;
            const transition = workflow?.transitions.find((t)=>t.to.statusId === statusId && (t.isInitial || t.isGlobal && !t.isConditional));
            return transition?.transitionId;
        }
    }, [
        workflows
    ]);
};
const $b3543cf4b0365df5$export$1245c77f7693955b = (mutation, query)=>{
    const createIssue = (0, $iNULk.useCreateIssue)(mutation);
    const refetchIssue = (0, $fop6E.useRefetchIssue)(query);
    const showCreateSuccessFlag = (0, $fOAem.useShowCreateSuccessFlag)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    const getTransitionId = $b3543cf4b0365df5$export$8edbb6d449614942();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const showCreateIssueDialog = (0, $auegK.useCreateIssueDialog)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(async ({ createParams: createParams, highlightIssue: highlightIssue, unhighlightIssue: unhighlightIssue, ignoreFiltersContext: ignoreFiltersContext })=>{
        const transitionId = getTransitionId(createParams.input);
        try {
            if (!(0, $5ujax.hasAllRequiredFields)({
                issueType: typesWithFields.find(({ issueType: issueType })=>issueType.id === createParams.input.issueType.id),
                createInput: createParams.input
            })) throw new (0, $7byHA.ValidationError)('Missing required fields');
            const response = await createIssue(createParams, {
                transitionId: transitionId
            });
            highlightIssue(response.itemIdentifiers.issueId);
            if (createParams.showSuccessFlag) showCreateSuccessFlag(response.itemIdentifiers.issueKey);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', String(response.itemIdentifiers.issueId), {
                location: createParams.location
            });
            unhighlightIssue(response.itemIdentifiers.issueId);
            return response.item;
        } catch (error) {
            let finalError = error;
            try {
                if (error instanceof (0, $7byHA.ValidationError)) {
                    const { issueId: issueId, issueKey: issueKey } = await showCreateIssueDialog(createParams.input, {
                        transitionId: transitionId
                    });
                    highlightIssue(issueId);
                    const issue = await refetchIssue(issueId, createParams.fieldIdsToReturn, !ignoreFiltersContext);
                    if (createParams.showSuccessFlag) showCreateSuccessFlag(issueKey);
                    unhighlightIssue(issueId);
                    return issue;
                }
            } catch (refetchError) {
                finalError = refetchError;
            }
            if (finalError instanceof (0, $auegK.CancelledError)) return null;
            showFlag({
                type: 'error',
                title: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9Y2JR.default).errorFlagTitleIssueTermRefresh : (0, $9Y2JR.default).errorFlagTitle),
                description: formatMessage((0, $9Y2JR.default).errorFlagDescription)
            });
            throw finalError;
        }
    }, [
        getTransitionId,
        typesWithFields,
        createIssue,
        createAnalyticsEvent,
        showCreateSuccessFlag,
        showFlag,
        formatMessage,
        showCreateIssueDialog,
        refetchIssue
    ]);
};
const $b3543cf4b0365df5$export$8af2d18142c8506c = (onCreateIssue, onRefetchIssue)=>{
    const showCreateSuccessFlag = (0, $fOAem.useShowCreateSuccessFlag)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    const getTransitionId = $b3543cf4b0365df5$export$8edbb6d449614942();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const showCreateIssueDialog = (0, $auegK.useCreateIssueDialog)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(async ({ createParams: createParams, highlightIssue: highlightIssue, unhighlightIssue: unhighlightIssue, ignoreFiltersContext: ignoreFiltersContext })=>{
        const transitionId = getTransitionId(createParams.input);
        try {
            if (!(0, $5ujax.hasAllRequiredFields)({
                issueType: typesWithFields.find(({ issueType: issueType })=>issueType.id === createParams.input.issueType.id),
                createInput: createParams.input
            })) throw new (0, $7byHA.ValidationError)('Missing required fields');
            const response = await onCreateIssue(createParams, {
                transitionId: transitionId
            });
            highlightIssue(response.itemIdentifiers.issueId);
            if (createParams.showSuccessFlag) showCreateSuccessFlag(response.itemIdentifiers.issueKey);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', String(response.itemIdentifiers.issueId), {
                location: createParams.location
            });
            unhighlightIssue(response.itemIdentifiers.issueId);
            return response.item;
        } catch (error) {
            let finalError = error;
            try {
                if (error instanceof (0, $7byHA.ValidationError)) {
                    const { issueId: issueId, issueKey: issueKey } = await showCreateIssueDialog(createParams.input, {
                        transitionId: transitionId
                    });
                    highlightIssue(issueId);
                    const issue = await onRefetchIssue(issueId, createParams.fieldIdsToReturn, !ignoreFiltersContext);
                    if (createParams.showSuccessFlag) showCreateSuccessFlag(issueKey);
                    unhighlightIssue(issueId);
                    return issue;
                }
                if (error instanceof Error) (0, $guiFP.default)({
                    meta: {
                        id: 'JWMCreateIssueInline',
                        packageName: 'jiraBusinessIssueCreate',
                        teamName: 'wanjel'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } catch (refetchError) {
                finalError = refetchError;
            }
            if (finalError instanceof (0, $auegK.CancelledError)) return null;
            showFlag({
                type: 'error',
                title: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9Y2JR.default).errorFlagTitleIssueTermRefresh : (0, $9Y2JR.default).errorFlagTitle),
                description: formatMessage((0, $9Y2JR.default).errorFlagDescription)
            });
            throw finalError;
        }
    }, [
        getTransitionId,
        typesWithFields,
        onCreateIssue,
        createAnalyticsEvent,
        showCreateSuccessFlag,
        showFlag,
        formatMessage,
        showCreateIssueDialog,
        onRefetchIssue
    ]);
};

});
parcelRegister("c7wtc", function(module, exports) {

$parcel$export(module.exports, "WorkflowsProvider", () => $0662fc67a6d31ad1$export$80a1d3130ff3ec75);
$parcel$export(module.exports, "useWorkflows", () => $0662fc67a6d31ad1$export$437f9bd807b88beb);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $6LdZl = parcelRequire("6LdZl");

var $8xqyO = parcelRequire("8xqyO");
const $0662fc67a6d31ad1$var$FETCH_WORKFLOW_FLAG_ID = (0, $eo17r.toFlagId)('fetch-board-error-flag');
const $0662fc67a6d31ad1$var$WorkflowsContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $0662fc67a6d31ad1$export$80a1d3130ff3ec75 = ({ children: children, enabled: enabled = true, workflows: workflows })=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { fetch: fetch, data: data, error: error } = (0, $6LdZl.useFetchWorkflows)();
    (0, $eUqFw.useEffect)(()=>{
        if ((!(0, $eI5EY.fg)('jwm_conditional_workflow_data_loading') || enabled) && workflows == null) fetch();
    }, [
        enabled,
        fetch,
        workflows
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) showFlag({
            id: $0662fc67a6d31ad1$var$FETCH_WORKFLOW_FLAG_ID,
            type: 'error',
            title: (0, $8xqyO.default).workflowsErrorTitle,
            description: (0, $8xqyO.default).workflowsErrorDescription
        });
    }, [
        error,
        showFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0662fc67a6d31ad1$var$WorkflowsContext.Provider, {
        value: workflows ?? data
    }, children);
};
const $0662fc67a6d31ad1$export$437f9bd807b88beb = ()=>(0, $eUqFw.useContext)($0662fc67a6d31ad1$var$WorkflowsContext);

});
parcelRegister("6LdZl", function(module, exports) {

$parcel$export(module.exports, "useFetchWorkflows", () => $999083320983ea8a$export$41ba56ef14d1b9b1);
/* eslint-disable @typescript-eslint/no-non-null-assertion */ 
var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $kQAZu = parcelRequire("kQAZu");

var $guiFP = parcelRequire("guiFP");

var $5Hc99 = parcelRequire("5Hc99");
const $999083320983ea8a$export$41ba56ef14d1b9b1 = ()=>{
    const project = (0, $kQAZu.useProject)();
    const [fetch, { data: data, loading: loading, error: error }] = (0, $iZuDo.useLazyQuery)((0, $5Hc99.WORKFLOWS_QUERY), {
        variables: {
            projectId: project.id,
            first: 100
        },
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'jwmFetchWorkflows',
                    packageName: 'jiraBusinessWorkflows',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch workflows'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    const workflowsDetails = (0, $eUqFw.useMemo)(()=>data?.jwmWorkflowWithIssueTypes?.edges?.map((edge)=>{
            const { workflow: workflow, issueTypes: issueTypes } = edge?.node || {};
            return {
                workflowId: workflow.workflowId,
                name: workflow?.name ?? undefined,
                transitions: workflow.transitions.edges.map((transitionEdge)=>({
                        transitionId: transitionEdge.node.transitionId,
                        name: transitionEdge.node.name ?? undefined,
                        isInitial: transitionEdge.node.isInitial,
                        isGlobal: transitionEdge.node.isGlobal,
                        isConditional: transitionEdge.node.isConditional,
                        to: {
                            statusId: transitionEdge.node.to.statusId
                        }
                    })),
                issueTypes: issueTypes.edges.map((issueTypeEdge)=>({
                        issueTypeId: issueTypeEdge.node.issueTypeId,
                        name: issueTypeEdge.node.name,
                        avatarUrl: issueTypeEdge.node.avatar.medium,
                        hierarchyLevel: issueTypeEdge.node.hierarchy.level
                    }))
            };
        }), [
        data
    ]);
    return {
        fetch: fetch,
        data: workflowsDetails,
        loading: loading,
        error: error
    };
};

});
parcelRegister("5Hc99", function(module, exports) {

$parcel$export(module.exports, "WORKFLOWS_QUERY", () => $d1ebb9e47bb48695$export$d54deb6c2b9695b7);

var $9ypom = parcelRequire("9ypom");
const $d1ebb9e47bb48695$export$d54deb6c2b9695b7 = (0, $9ypom.default)`
    query JWMWorkflowWithIssueTypes($projectId: Long!, $filter: JWMWorkflowWithIssueTypesFilter, $first: Int, $after: String, $last: Int, $before: String) {
        jwmWorkflowWithIssueTypes(projectId: $projectId, filter: $filter, first: $first, after: $after, last: $last, before: $before) {
            edges {
                node {
                    workflow {
                        workflowId
                        name
                        transitions(first: $first) {
                            edges {
                                node {
                                    transitionId
                                    name
                                    isInitial
                                    isGlobal
                                    isConditional
                                    to {
                                        statusId
                                    }
                                }
                            }
                        }
                    }
                    issueTypes(first: $first) {
                        edges {
                            node {
                                issueTypeId
                                name
                                avatar {
                                  medium
                                }
                              	hierarchy {
                              	  level
                              	}
                            }
                        }
                    }
                }
            }
        }
    }
`;

});


parcelRegister("8xqyO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2d03bd6919e7a8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5f2d03bd6919e7a8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    workflowsErrorTitle: {
        "id": "business-workflows.controllers.workflows-context.workflows-error-title",
        "defaultMessage": "Failed to load workflows details"
    },
    workflowsErrorDescription: {
        "id": "business-workflows.controllers.workflows-context.workflows-error-description",
        "defaultMessage": "We couldn't load your workflow details, try refreshing the page or try again later."
    }
});

});


parcelRegister("iNULk", function(module, exports) {

$parcel$export(module.exports, "useCreateIssue", () => $7f9682590ce5c99c$export$8af2d18142c8506c);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $jGcn0 = parcelRequire("jGcn0");

var $e4qlg = parcelRequire("e4qlg");

var $4S5hf = parcelRequire("4S5hf");

var $kkYfO = parcelRequire("kkYfO");

var $dlVOn = parcelRequire("dlVOn");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $7byHA = parcelRequire("7byHA");

var $lO4Or = parcelRequire("lO4Or");

var $fD1Hq = parcelRequire("fD1Hq");

var $4xHig = parcelRequire("4xHig");


var $iWGMH = parcelRequire("iWGMH");
const $7f9682590ce5c99c$var$storyPointEstimateFieldPredicate = (field)=>field.type === (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE);
const $7f9682590ce5c99c$var$storyPointsFieldPredicate = (field)=>field.type === (0, $lO4Or.NUMBER_CF_TYPE) && field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID);
const $7f9682590ce5c99c$var$sprintFieldPredicate = (field)=>field.type === (0, $lO4Or.SPRINT_TYPE);
const $7f9682590ce5c99c$export$8af2d18142c8506c = (mutation)=>{
    const locale = (0, $4xHig.useLocale)();
    const { data: categoryField } = (0, $e4qlg.useCategoryField)();
    const { data: startDateField } = (0, $fD1Hq.useStartDateField)();
    const { data: storyPointEstimateField } = (0, $4S5hf.useFindField)($7f9682590ce5c99c$var$storyPointEstimateFieldPredicate);
    const { data: storyPointsField } = (0, $4S5hf.useFindField)($7f9682590ce5c99c$var$storyPointsFieldPredicate);
    const { data: sprintField } = (0, $4S5hf.useFindField)($7f9682590ce5c99c$var$sprintFieldPredicate);
    const isLinkingEnabled = (0, $fD1Hq.useIsLinkingEnabled)();
    const [createIssue] = (0, $iZuDo.useMutation)(mutation);
    return (0, $eUqFw.useCallback)(async (createParams, extraPayload)=>{
        try {
            const input = (0, $iWGMH.buildInput)(createParams.input, locale, extraPayload, categoryField, startDateField, sprintField, storyPointEstimateField, storyPointsField);
            const fieldIdsSet = new Set(createParams.fieldIdsToReturn);
            let isParentFieldVisible = false;
            let isDevSummaryFieldVisible = false;
            if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
                isDevSummaryFieldVisible = fieldIdsSet.has((0, $908924b2d198da78$export$20b3b4741b8cfb64));
                isParentFieldVisible = fieldIdsSet.has((0, $908924b2d198da78$export$bf9df74e065af482));
                fieldIdsSet.delete((0, $908924b2d198da78$export$20b3b4741b8cfb64));
                fieldIdsSet.delete((0, $908924b2d198da78$export$bf9df74e065af482));
            }
            const withIssueLinks = fieldIdsSet.has((0, $lO4Or.ISSUE_LINKS_TYPE)) && isLinkingEnabled;
            fieldIdsSet.delete((0, $lO4Or.ISSUE_LINKS_TYPE));
            const withCoverMedia = fieldIdsSet.has((0, $jGcn0.CARD_COVERS_TYPE));
            fieldIdsSet.delete((0, $jGcn0.CARD_COVERS_TYPE));
            const fieldIds = Array.from(fieldIdsSet);
            const { data: data, errors: errors } = await createIssue({
                variables: {
                    input: input,
                    fieldIds: fieldIds,
                    withCoverMedia: withCoverMedia,
                    withChildrenCount: false,
                    isParentFieldVisible: isParentFieldVisible,
                    isDevSummaryFieldVisible: isDevSummaryFieldVisible,
                    withIssueLinks: withIssueLinks,
                    withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
                },
                // @ts-expect-error - errorPolicy is not in the types but does work
                errorPolicy: 'all'
            });
            const result = data?.createJiraBusinessIssue;
            if (result?.success !== true || !result?.item) {
                const firstMutationError = result?.errors?.[0];
                if (firstMutationError) {
                    const statusCode = firstMutationError.extensions?.statusCode;
                    if (statusCode && statusCode >= 400 && statusCode < 500) throw new (0, $7byHA.ValidationError)(firstMutationError.message ?? 'Failed to create issue');
                    throw new (0, $kkYfO.MutationError)(firstMutationError);
                }
                throw new (0, $dlVOn.GraphQLErrors)(errors);
            }
            return {
                item: result.item,
                itemIdentifiers: {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    issueId: result.itemIdentifiers.issueId,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-non-null-assertion
                    issueKey: result.itemIdentifiers.issueKey[0].text
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (!(error instanceof (0, $7byHA.ValidationError))) (0, $guiFP.default)({
                meta: {
                    id: 'JWMCreateIssueInline',
                    packageName: 'jiraBusinessIssueCreate',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, [
        categoryField,
        createIssue,
        locale,
        sprintField,
        startDateField,
        storyPointEstimateField,
        storyPointsField,
        isLinkingEnabled
    ]);
};

});
parcelRegister("e4qlg", function(module, exports) {

$parcel$export(module.exports, "useCategoryField", () => $ce9b32995a7706e8$export$f7ac7f1f12b4c794);

var $lO4Or = parcelRequire("lO4Or");

var $gEmpR = parcelRequire("gEmpR");
const $ce9b32995a7706e8$export$f7ac7f1f12b4c794 = ()=>{
    const { data: { fields: fields }, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const categoryField = fields.find((field)=>field.type === (0, $lO4Or.CATEGORY_TYPE)) ?? null;
    return {
        data: categoryField,
        loading: loading,
        error: error
    };
};

});

parcelRegister("4S5hf", function(module, exports) {

$parcel$export(module.exports, "useFindField", () => $8ce2e5c1390595df$export$4b0b80fa50e6b4be);

var $gEmpR = parcelRequire("gEmpR");
const $8ce2e5c1390595df$export$4b0b80fa50e6b4be = (predicate)=>{
    const { data: { fields: fields }, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const field = fields.find(predicate) ?? null;
    return {
        data: field,
        loading: loading,
        error: error
    };
};

});

parcelRegister("kkYfO", function(module, exports) {

$parcel$export(module.exports, "MutationError", () => $f83939e5f3c23160$export$10c788363424e94e);
const $f83939e5f3c23160$export$bd0568a021288e41 = 'MutationError';
class $f83939e5f3c23160$export$10c788363424e94e extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.message = payload.message ?? '';
        this.extensions = payload.extensions;
        this.statusCode = payload.extensions?.statusCode ?? null;
    }
}

});

const $908924b2d198da78$export$41b6c9f5441c22c5 = 'rankBefore';
const $908924b2d198da78$export$d564e563c2ee8c4f = 'rankAfter';
const $908924b2d198da78$export$20b3b4741b8cfb64 = 'devSummaryField';
const $908924b2d198da78$export$bf9df74e065af482 = 'parentField';

parcelRegister("iWGMH", function(module, exports) {

$parcel$export(module.exports, "buildInput", () => $6cba527c033852df$export$f4db126e014728a3);

var $lO4Or = parcelRequire("lO4Or");

var $8K9kM = parcelRequire("8K9kM");

const $6cba527c033852df$export$f4db126e014728a3 = (input, locale, extraPayload, categoryField, startDateField, sprintField, storyPointEstimateField, storyPointsField)=>{
    const result = {
        projectId: input.projectId,
        issueType: input.issueType.id,
        fields: {
            singleLineTextFields: [
                {
                    fieldId: (0, $lO4Or.SUMMARY_TYPE),
                    text: input.summary
                }
            ],
            singleSelectUserPickerFields: [],
            datePickerFields: [],
            numberFields: []
        },
        rank: {}
    };
    if (input.category && categoryField?.id) result.fields.singleLineTextFields.push({
        fieldId: categoryField.id,
        text: input.category.optionId
    });
    if (input.assignee) result.fields.singleSelectUserPickerFields.push({
        fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
        user: {
            accountId: input.assignee.accountId
        }
    });
    if (input.startDate && startDateField?.id) result.fields.datePickerFields.push({
        fieldId: startDateField?.id,
        date: {
            formattedDate: (0, $8K9kM.formatTimezonedWithLocale)(input.startDate, 'dd/MMM/yy', locale, 'UTC')
        }
    });
    if (input.dueDate) result.fields.datePickerFields.push({
        fieldId: (0, $lO4Or.DUE_DATE_TYPE),
        date: {
            formattedDate: (0, $8K9kM.formatTimezonedWithLocale)(input.dueDate, 'dd/MMM/yy', locale, 'UTC')
        }
    });
    if (input.priority) result.fields.priority = {
        priorityId: input.priority.priorityId
    };
    if (input.parentIssueId) result.fields.parentField = {
        issueId: input.parentIssueId
    };
    if (input.rankBefore) result.rank.before = {
        id: (0, $908924b2d198da78$export$41b6c9f5441c22c5),
        issueId: input.rankBefore.issueId
    };
    if (input.rankAfter) result.rank.after = {
        id: (0, $908924b2d198da78$export$d564e563c2ee8c4f),
        issueId: input.rankAfter.issueId
    };
    if (extraPayload.transitionId) result.transitionId = extraPayload.transitionId;
    if (input.storyPointEstimate != null && storyPointEstimateField?.id) result.fields.numberFields.push({
        fieldId: storyPointEstimateField.id,
        value: input.storyPointEstimate
    });
    if (input.storyPoints != null && storyPointsField?.id) result.fields.numberFields.push({
        fieldId: storyPointsField.id,
        value: input.storyPoints
    });
    if (input.sprint && sprintField?.id) result.fields.sprintsField = {
        fieldId: sprintField.id,
        sprints: [
            {
                sprintId: input.sprint.id
            }
        ]
    };
    return result;
};

});


parcelRegister("fop6E", function(module, exports) {

$parcel$export(module.exports, "useRefetchIssue", () => $afeef06c89f9a563$export$8bf876d423f9293d);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $i3K0B = parcelRequire("i3K0B");

var $jGcn0 = parcelRequire("jGcn0");

var $eZbpk = parcelRequire("eZbpk");

var $lGxgz = parcelRequire("lGxgz");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $fD1Hq = parcelRequire("fD1Hq");

var $dWLk9 = parcelRequire("dWLk9");
function $afeef06c89f9a563$export$fd83eea6ecd2d8fa(query) {
    const client = (0, $iZuDo.useApolloClient)();
    return (0, $eUqFw.useCallback)((variables)=>client.query({
            query: query,
            variables: variables,
            errorPolicy: 'all'
        }), [
        client,
        query
    ]);
}
const $afeef06c89f9a563$export$8bf876d423f9293d = (query)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const filtersJQL = (0, $lGxgz.useFilteredViewJQL)();
    const isLinkingEnabled = (0, $fD1Hq.useIsLinkingEnabled)();
    const refetchIssue = $afeef06c89f9a563$export$fd83eea6ecd2d8fa(query);
    return (0, $eUqFw.useCallback)(async (issueId, fieldIds, withFiltersContext)=>{
        const jql = (0, $i3K0B.generateJql)({
            jqlContext: jqlContext,
            quickFiltersJql: withFiltersContext ? filtersJQL : undefined,
            issueIds: [
                issueId
            ]
        });
        const fieldIdsSet = new Set(fieldIds);
        const withIssueLinks = fieldIdsSet.has((0, $lO4Or.ISSUE_LINKS_TYPE)) && isLinkingEnabled;
        fieldIdsSet.delete((0, $lO4Or.ISSUE_LINKS_TYPE));
        const withCoverMedia = fieldIdsSet.has((0, $jGcn0.CARD_COVERS_TYPE));
        const fieldIdsToRequest = Array.from(fieldIdsSet);
        const { data: data } = await refetchIssue({
            jql: jql,
            fieldIds: fieldIdsToRequest,
            cloudId: cloudId,
            first: 1,
            withCoverMedia: withCoverMedia,
            withChildrenCount: false,
            isParentFieldVisible: false,
            isDevSummaryFieldVisible: false,
            withIssueLinks: withIssueLinks,
            withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
        });
        const viewItems = data?.jira?.jwmViewItems;
        if (!viewItems || viewItems.__typename === 'QueryError') throw new Error('Issue not found');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const issue = viewItems.edges?.[0]?.node;
        return issue ?? null;
    }, [
        cloudId,
        filtersJQL,
        jqlContext,
        refetchIssue,
        isLinkingEnabled
    ]);
};

});
parcelRegister("i3K0B", function(module, exports) {

$parcel$export(module.exports, "generateJql", () => $6bd61e247d9e0007$export$d43e55153d6948c0);
$parcel$export(module.exports, "getVariables", () => $6bd61e247d9e0007$export$a39eddd73bba62c1);

var $jGcn0 = parcelRequire("jGcn0");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");


var $lF3sI = parcelRequire("lF3sI");
const $6bd61e247d9e0007$var$DEFAULT_CHILDREN_PER_PAGE = (0, $jGcn0.DEFAULT_PAGE_SIZE);
const $6bd61e247d9e0007$var$IS_EMPTY = 'IS EMPTY';
const $6bd61e247d9e0007$var$IS_NOT_EMPTY = 'IS NOT EMPTY';
const $6bd61e247d9e0007$export$d43e55153d6948c0 = (input, parentIssueForJql)=>{
    const { groupQuery: groupQuery, hierarchyLevel: hierarchyLevel, hierarchyParent: hierarchyParent, issueIds: issueIds, jqlContext: jqlContext, projectIdOrKey: projectIdOrKey, quickFiltersJql: quickFiltersJql, sorting: sorting } = input;
    const defaultSorting = `ORDER BY Rank ${(0, $jGcn0.DEFAULT_RANK_SORTING_DIRECTION)}`;
    const jql = [];
    // Check if sorting direction is valid, the direction possible passed from the URL params which can be invalid
    const isValidDirection = sorting?.direction?.toUpperCase() === 'ASC' || sorting?.direction?.toUpperCase() === 'DESC';
    const sortByClause = sorting != null && sorting.sortBy != null && sorting.direction != null && isValidDirection ? `ORDER By ${(0, $lF3sI.getJqlTerm)(sorting.sortBy)} ${sorting.direction}, Rank ${sorting.direction}` : defaultSorting;
    if (Array.isArray(issueIds) && issueIds.length > 0) jql.push(`(${issueIds.map((id)=>`id = ${id}`).join(' or ')})`);
    if (jqlContext) jql.push(jqlContext);
    else if (typeof projectIdOrKey !== 'undefined') jql.push(`project = '${projectIdOrKey}'`);
    if (typeof hierarchyLevel === 'number' && hierarchyParent === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) {
        // fetch items by hierarchyLevel + any item that doesn't have a parent (e.g. tasks that don't belong to any Epic)
        if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') && typeof projectIdOrKey !== 'undefined') jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$6bd61e247d9e0007$var$IS_EMPTY} OR (parent ${$6bd61e247d9e0007$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
        else jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$6bd61e247d9e0007$var$IS_EMPTY})`);
    }
    if (hierarchyParent === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) jql.push('type in standardIssueTypes()');
    // Controls the query to get all children for a single parent
    if (parentIssueForJql && parentIssueForJql.hierarchyType === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) jql.push(`parent = '${parentIssueForJql.issueId}'`);
    // Controls the query to get group items
    if (groupQuery) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { jqlTerm: jqlTerm, value: value } = groupQuery;
        if (!value) jql.push(`${jqlTerm} ${$6bd61e247d9e0007$var$IS_EMPTY}`);
        else jql.push(`${jqlTerm} = ${value}`);
        if (hierarchyParent === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) {
            if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') && typeof projectIdOrKey !== 'undefined') jql.push(`(parent ${$6bd61e247d9e0007$var$IS_EMPTY} OR (parent ${$6bd61e247d9e0007$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
            else jql.push(`parent ${$6bd61e247d9e0007$var$IS_EMPTY}`);
        }
    }
    if (quickFiltersJql != null) jql.push(`(${quickFiltersJql})`);
    return `${jql.join(' AND ')} ${sortByClause}`;
};
const $6bd61e247d9e0007$export$a39eddd73bba62c1 = (input)=>{
    const { fieldIds: fieldIds, parentIssue: parentIssue } = input;
    const singleQueryJql = {
        jql: $6bd61e247d9e0007$export$d43e55153d6948c0(input, parentIssue)
    };
    // REMOTE_ISSUE_LINKS_TYPE should not be part of the fieldIds as it is only used to determine
    // whether legacyConfluenceLinks(JIS2) is fetched
    const newFieldIds = Array.isArray(fieldIds) ? [
        ...fieldIds
    ] : [];
    const remoteIssueLinksIndex = newFieldIds.indexOf((0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE));
    const hasConfluenceLinks = remoteIssueLinksIndex > -1;
    if (hasConfluenceLinks) newFieldIds.splice(remoteIssueLinksIndex, 1);
    return {
        ...singleQueryJql,
        first: parentIssue ? $6bd61e247d9e0007$var$DEFAULT_CHILDREN_PER_PAGE : (0, $jGcn0.DEFAULT_PAGE_SIZE),
        fieldIds: newFieldIds,
        withConfluenceLinks: hasConfluenceLinks,
        includeDoneItems: input.isHidingDoneItems === false,
        isParentFieldVisible: input.isParentFieldVisible ?? false,
        isDevSummaryFieldVisible: input.isDevSummaryFieldVisible ?? false,
        withParentRank: (0, $1ybV0.ff)('jwm-timeline-sort-parent-rank-first_waal4'),
        withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
    };
};

});
const $2a7b21c0842403e6$export$9355e489ad16f98e = 'TASK';
const $2a7b21c0842403e6$export$3cb4a99a332e4186 = 'EPIC';

parcelRegister("lF3sI", function(module, exports) {

$parcel$export(module.exports, "getJqlTerm", () => $74367c535f0c8550$export$43330b5a5235b231);

var $79xbN = parcelRequire("79xbN");

var $lO4Or = parcelRequire("lO4Or");
const $74367c535f0c8550$export$43330b5a5235b231 = (fieldId, fieldType)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    if (fieldId.indexOf('customfield_') === 0) {
        const customFieldId = fieldId.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    // We are hardcoding the components field jqlTerm because is not the same as field ID
    // We should get the jqlTerm from the BE
    // https://atlassian.slack.com/archives/CFGMKF5QC/p1724650674231049?thread_ts=1720579171.825049&cid=CFGMKF5QC
    if (fieldType === (0, $lO4Or.COMPONENTS_TYPE) && (0, $79xbN.expValEquals)('list_view_conditional_formatting', 'cohort', 'variation')) return 'component';
    return fieldId;
};

});


parcelRegister("lGxgz", function(module, exports) {

$parcel$export(module.exports, "useFilteredViewJQL", () => $6fc881cfc8a36877$export$a50cc7c1087f7d9b);
$parcel$export(module.exports, "useFilteredViewContextInput", () => $6fc881cfc8a36877$export$d566b5d8a729afa0);

var $eUqFw = parcelRequire("eUqFw");


var $eZbpk = parcelRequire("eZbpk");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $iaCjO = parcelRequire("iaCjO");

var $gZpkQ = parcelRequire("gZpkQ");

var $lEWmB = parcelRequire("lEWmB");

var $96etS = parcelRequire("96etS");

var $jQFcD = parcelRequire("jQFcD");
const $6fc881cfc8a36877$export$a50cc7c1087f7d9b = ()=>{
    const { addSimpleSearchToJQL: addSimpleSearchToJQL } = (0, $96etS.useSimpleSearchJQL)();
    const { jql: jql } = (0, $lEWmB.useFilters)();
    const [isHidingDoneItems] = (0, $gZpkQ.useHideDoneItems)();
    // ensure views recieve filters jql that will not cause a page crash
    const jqlSanitised = (0, $eUqFw.useMemo)(()=>(0, $jQFcD.sanitiseJql)(jql), [
        jql
    ]);
    const filtersJQL = (0, $eUqFw.useMemo)(()=>{
        if (isHidingDoneItems) {
            const filtersJql = [
                jqlSanitised,
                "StatusCategory != 'Complete'"
            ].filter(Boolean).join(' AND ');
            return addSimpleSearchToJQL(filtersJql);
        }
        return addSimpleSearchToJQL(jqlSanitised || null);
    }, [
        jqlSanitised,
        addSimpleSearchToJQL,
        isHidingDoneItems
    ]);
    return filtersJQL;
};
const $6fc881cfc8a36877$var$FIX_VERSION_SORTING_JQL = 'fixVersion';
const $6fc881cfc8a36877$export$d566b5d8a729afa0 = ({ view: view })=>{
    const filtersJQL = $6fc881cfc8a36877$export$a50cc7c1087f7d9b();
    const { isSearching: isSearching } = (0, $96etS.useSimpleSearchJQL)();
    const [sortingBy] = (0, $iaCjO.useSorting)();
    const { jql: jql } = (0, $lEWmB.useFilters)();
    const isFiltering = jql != null || isSearching;
    const [isHidingDoneItems] = (0, $gZpkQ.useHideDoneItems)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const hierarchyParent = (view === 'list' || view === 'timeline') && !isFiltering ? (0, $2a7b21c0842403e6$export$9355e489ad16f98e) : undefined;
    const jqlErrors = (0, $eUqFw.useMemo)(()=>{
        if ((0, $1ybV0.ff)('jwm.filters.handle-invalid-jql')) return (0, $jQFcD.getJqlErrors)(jql);
        return [];
    }, [
        jql
    ]);
    const sorting = (0, $eUqFw.useMemo)(()=>{
        /*
			When sorting by a specific field, we use the fieldId in the JQL query.
			For the fix version field, the fieldId doesn’t work in JQL must be “fixVersion”.
			Apparently, "fixVersion" is the clause name. It's a legacy choice that was made from the very beginning, and now we're unable to change it.
		*/ if (sortingBy.sortBy === (0, $lO4Or.FIX_VERSIONS_TYPE) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) return {
            ...sortingBy,
            sortBy: $6fc881cfc8a36877$var$FIX_VERSION_SORTING_JQL
        };
        return sortingBy;
    }, [
        sortingBy
    ]);
    return {
        jqlContext: jqlContext,
        quickFiltersJql: filtersJQL,
        sorting: sorting,
        isFiltering: isFiltering,
        hierarchyParent: hierarchyParent,
        isHidingDoneItems: isHidingDoneItems,
        jqlErrors: jqlErrors
    };
};

});
parcelRegister("iaCjO", function(module, exports) {

$parcel$export(module.exports, "useSorting", () => $35b6a42c26975572$export$21ebc1ba2b2bee67);
$parcel$export(module.exports, "useSorter", () => $35b6a42c26975572$export$f161a6f9d84a6fea);

var $eUqFw = parcelRequire("eUqFw");

var $35jYz = parcelRequire("35jYz");

var $gEmpR = parcelRequire("gEmpR");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $a75Ge = parcelRequire("a75Ge");

var $a6BBe = parcelRequire("a6BBe");

var $iP9h2 = parcelRequire("iP9h2");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $35b6a42c26975572$var$EMPTY_SORTING_ATTRIBUTE = {};
const $35b6a42c26975572$export$21ebc1ba2b2bee67 = ()=>{
    const [sorting, setSorting] = (0, $7c3W1.useViewPreference)((0, $ji3xf.SORTING_PREFERENCE));
    return [
        sorting || $35b6a42c26975572$var$EMPTY_SORTING_ATTRIBUTE,
        setSorting
    ];
};
const $35b6a42c26975572$var$emptyArray = [];
const $35b6a42c26975572$export$f161a6f9d84a6fea = ()=>{
    const [sorting] = $35b6a42c26975572$export$21ebc1ba2b2bee67();
    const [sortingFieldConfig] = (0, $35jYz.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: sorting.sortBy
    });
    const [priorityFieldConfig] = (0, $35jYz.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: 'priority'
    });
    const { data: data } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const sortingFieldConfigFieldType = sortingFieldConfig?.fieldType ?? data?.fields?.find((field)=>field?.id === sorting.sortBy)?.type;
    const { statuses: statuses } = (0, $a75Ge.useProjectStatuses)();
    const priorities = priorityFieldConfig?.options || $35b6a42c26975572$var$emptyArray;
    const sortFunction = (0, $eUqFw.useCallback)((issues)=>{
        const getPrioritiesSortedList = ()=>[
                ...priorities
            ].reverse().reduce((acc, next, index)=>{
                acc[next.priorityId] = index;
                return acc;
            }, {});
        const getIssueTypesSortedList = ()=>[
                ...data.issueTypes
            ].sort((a, b)=>a.name.localeCompare(b.name)).reduce((acc, next, index)=>{
                acc[next.name] = index;
                return acc;
            }, {});
        const getStatusSortOrder = (key)=>{
            if (key in (0, $a6BBe.STATUS_SORT_ORDER)) return (0, $a6BBe.STATUS_SORT_ORDER)[key];
            return -1;
        };
        const getStatusesSortedList = ()=>[
                ...statuses
            ].sort((a, b)=>{
                const orderComparison = getStatusSortOrder(a.statusCategory.key) - getStatusSortOrder(b.statusCategory.key);
                if (orderComparison !== 0) return orderComparison;
                // If the status category order is the same, then sort alphabetically by name.
                return a.name.localeCompare(b.name);
            }).reduce((acc, next, index)=>{
                acc[next.name] = index;
                return acc;
            }, {});
        const sortedLists = {
            priorities: getPrioritiesSortedList(),
            issueTypes: getIssueTypesSortedList(),
            statuses: getStatusesSortedList()
        };
        const { getters: getters, orders: orders } = (0, $iP9h2.createSortingGettersAndOrders)(sorting, sortingFieldConfigFieldType, sortedLists);
        return (0, $iP9h2.sortListBy)(issues, getters, orders);
    }, [
        sorting,
        sortingFieldConfigFieldType,
        priorities,
        data.issueTypes,
        statuses
    ]);
    return {
        sort: sortFunction
    };
};

});
parcelRegister("a6BBe", function(module, exports) {

$parcel$export(module.exports, "STATUS_SORT_ORDER", () => $4f70cf7d8b2e6b0e$export$de9c103e53e690d1);
const $4f70cf7d8b2e6b0e$export$de9c103e53e690d1 = {
    new: 1,
    indeterminate: 2,
    done: 3
};

});

parcelRegister("iP9h2", function(module, exports) {

$parcel$export(module.exports, "sortListBy", () => $61a5cf2a87fc48eb$export$3793ed28be8699ad);
$parcel$export(module.exports, "createSortingGettersAndOrders", () => $61a5cf2a87fc48eb$export$b3fdfcb601c683c3);

var $bDIST = parcelRequire("bDIST");

var $jGcn0 = parcelRequire("jGcn0");

var $6imc4 = parcelRequire("6imc4");

var $iJbbQ = parcelRequire("iJbbQ");

var $3uSNh = parcelRequire("3uSNh");

var $8Qd0L = parcelRequire("8Qd0L");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $90Dtq = parcelRequire("90Dtq");
const $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE = 'Z';
const $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE = '~~';
const $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE = 0;
const $61a5cf2a87fc48eb$var$toAcceptedOrder = (order)=>order != null && order.toLowerCase() === 'asc' ? 'asc' : 'desc';
const $61a5cf2a87fc48eb$export$3793ed28be8699ad = (nodes, getters, orders)=>(0, (/*@__PURE__*/$parcel$interopDefault($bDIST)))(nodes, getters, orders.map($61a5cf2a87fc48eb$var$toAcceptedOrder));
const $61a5cf2a87fc48eb$var$getValueMapAndJoin = (fields, fieldKey, attributeName, defaultValue, // eslint-disable-next-line @typescript-eslint/no-explicit-any
getMapValueCb)=>{
    // join array with space so alphabetical order can be applied.
    // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
    const fieldValue = (0, $3uSNh.safeGetValue)(fields, fieldKey, attributeName, defaultValue) ?? defaultValue;
    return fieldValue.map(getMapValueCb).join(' ') || $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
};
const $61a5cf2a87fc48eb$var$resolvePriorityOrder = (fields, priorities)=>{
    const priorityId = (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour') ? (0, $3uSNh.safeGetValue)(fields, 'priority', 'value.priorityId', '') : (0, $3uSNh.safeGetValue)(fields, 'priority', 'priorityId', '');
    const priorityOrder = priorities[priorityId];
    if (priorityOrder == null) return -1;
    return priorityOrder;
};
const $61a5cf2a87fc48eb$var$resolveStatusOrder = (fields, statuses)=>{
    const statusName = (0, $3uSNh.safeGetValue)(fields, 'status', 'name', '');
    const statusOrder = statuses[statusName];
    if (statusOrder == null) return -1;
    return statusOrder;
};
const $61a5cf2a87fc48eb$var$resolveTypeOrder = (fields, types)=>{
    const typeName = (0, $3uSNh.safeGetValue)(fields, 'issuetype', 'value', '');
    const typeOrder = types[typeName];
    if (typeOrder == null) return -1;
    return typeOrder;
};
const $61a5cf2a87fc48eb$var$resolveIssueKeyOrder = (fields)=>{
    const [, issueKeyNumber = 0] = (0, $3uSNh.safeGetValue)(fields, 'issuekey', 'value', '').split('-');
    return Number(issueKeyNumber);
};
const $61a5cf2a87fc48eb$var$resolveCustomTextFieldOrder = (fields, sortingField)=>{
    // wiki value will be null when empty
    const value = (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', null);
    return value != null ? value.toLowerCase() : $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE; // empty values should rank lower
};
/* eslint-disable complexity */ const $61a5cf2a87fc48eb$var$createSortableGetter = (fieldType, sortingField, sortedList)=>(node)=>{
        const { rank: rank, fields: fields = [] } = node;
        if (fieldType != null && (0, $6imc4.isSortingSupportedFieldTypePredicated)(fieldType) && (0, $6imc4.isSortingSupported)(fieldType) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            const field = (0, $3uSNh.getFieldValue)(fields, sortingField);
            if ((0, $iJbbQ.isNewTransformedFieldPredicated)(field)) return (0, $6imc4.getSorting)(fieldType, field) || $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
            return $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
        }
        switch(fieldType){
            case 0, $lO4Or.LABELS_TYPE:
            case 0, $lO4Or.LABELS_CF_TYPE:
                // The backend will return [''] when it's empty so our default value might not be applied so we force return ~~ when it happens so empty items are ordered properly
                return $61a5cf2a87fc48eb$var$getValueMapAndJoin(fields, sortingField, 'value', [
                    ''
                ], (label)=>label.toLowerCase());
            case 0, $lO4Or.PRIORITY_TYPE:
                return $61a5cf2a87fc48eb$var$resolvePriorityOrder(fields, sortedList != null && sortedList.priorities || {});
            case 0, $lO4Or.STATUS_TYPE:
                return $61a5cf2a87fc48eb$var$resolveStatusOrder(fields, sortedList != null && sortedList.statuses || {});
            case 0, $lO4Or.ISSUE_TYPE:
                return $61a5cf2a87fc48eb$var$resolveTypeOrder(fields, sortedList != null && sortedList.issueTypes || {});
            case 0, $lO4Or.ASSIGNEE_TYPE:
            case 0, $lO4Or.REPORTER_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.name', // unassigned items are ranked higher than the ones with an user :shrug:
                $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
            case 0, $lO4Or.USER_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.name', // unassigned items are ranked higher than the ones with an user :shrug:
                $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
            case 'issuekey':
                return $61a5cf2a87fc48eb$var$resolveIssueKeyOrder(fields);
            case 0, $lO4Or.CREATED:
            case 0, $lO4Or.UPDATED:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', '');
            case 0, $lO4Or.DATE_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $lO4Or.DUE_DATE_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', // empty dates are ranked higher than the ones with set date :shrug:
                $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $lO4Or.DATETIME_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $jGcn0.RANK_ALIAS_FIELD_ID:
                if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
                    // We want to check for l-1 if the new jql parent is on
                    if ((0, $3uSNh.safeGetValue)(fields, 'issuetype', 'level', undefined) === -1) return (0, $90Dtq.resolveRank)((0, $3uSNh.safeGetValue)(fields, 'parent', 'value', undefined), rank ?? '');
                } else return (0, $90Dtq.resolveRank)((0, $3uSNh.safeGetValue)(fields, 'parent', 'value', undefined), rank ?? '');
                return rank ?? '';
            case 0, $lO4Or.SUMMARY_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', '').toLowerCase();
            case 0, $lO4Or.TEXT_CF_TYPE:
                return $61a5cf2a87fc48eb$var$resolveCustomTextFieldOrder(fields, sortingField);
            case 0, $lO4Or.SELECT_CF_TYPE:
            case 0, $lO4Or.CATEGORY_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE);
            case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
            case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
                return $61a5cf2a87fc48eb$var$getValueMapAndJoin(fields, sortingField, 'value', [], (selectedValue)=>selectedValue?.value.toLowerCase());
            case 0, $lO4Or.TIME_ESTIMATE_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.timeInSeconds', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
            case 0, $lO4Or.URL_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE);
            case 0, $lO4Or.NUMBER_CF_TYPE:
            case 0, $lO4Or.STORY_POINTS_TYPE:
            case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
            case 0, $lO4Or.COMPONENTS_TYPE:
                return $61a5cf2a87fc48eb$var$getValueMapAndJoin(fields, sortingField, 'value', [], (component)=>component?.name.toLowerCase());
            case 0, $lO4Or.SPRINT_TYPE:
                {
                    const sprintValue = (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE);
                    if (Array.isArray(sprintValue) && sprintValue.length) {
                        const { name: name, state: state } = sprintValue[0];
                        if (state === 'CLOSED') {
                            const statusId = (0, $3uSNh.safeGetValue)(fields, 'status', 'value', '');
                            // closed sprints should not be shown if the status is not done
                            // means that this ticket is on the backlog
                            if (statusId?.toString() !== (0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).DONE].toString()) return $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
                        }
                        return name.toLowerCase();
                    }
                    return $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
                }
            default:
                return (0, $3uSNh.safeGetValue)(fields, (0, $jGcn0.RANK_ALIAS_FIELD_ID), 'value', '');
        }
    };
const $61a5cf2a87fc48eb$export$b3fdfcb601c683c3 = (sorting, fieldType, sortedLists)=>{
    const getters = [];
    const orders = [];
    let sortFieldType = fieldType;
    // fieldType for key is not returned from useIssueTypeFieldConfig
    if (sorting?.sortBy === 'key') sortFieldType = 'issuekey';
    if (sorting != null && sorting.sortBy != null) {
        orders.push(sorting.direction, sorting.direction);
        getters.push($61a5cf2a87fc48eb$var$createSortableGetter(sortFieldType, sorting.sortBy, sortedLists));
        getters.push($61a5cf2a87fc48eb$var$createSortableGetter((0, $jGcn0.RANK_ALIAS_FIELD_ID), (0, $jGcn0.RANK_ALIAS_FIELD_ID)));
    } else {
        orders.push((0, $jGcn0.DEFAULT_RANK_SORTING_DIRECTION));
        getters.push($61a5cf2a87fc48eb$var$createSortableGetter((0, $jGcn0.RANK_ALIAS_FIELD_ID), (0, $jGcn0.RANK_ALIAS_FIELD_ID)));
    }
    return {
        getters: getters,
        orders: orders
    };
};

});
parcelRegister("bDIST", function(module, exports) {

var $943C2 = parcelRequire("943C2");

var $1c8hB = parcelRequire("1c8hB");
/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $8796275107b9d4d1$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!$1c8hB(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!$1c8hB(orders)) orders = orders == null ? [] : [
        orders
    ];
    return $943C2(collection, iteratees, orders);
}
module.exports = $8796275107b9d4d1$var$orderBy;

});

parcelRegister("6imc4", function(module, exports) {

$parcel$export(module.exports, "getSorting", () => $5172533d88399045$export$654dceec98f3061f);
$parcel$export(module.exports, "isSortingSupported", () => $5172533d88399045$export$c6c6084d02f37d7e);
$parcel$export(module.exports, "isSortingSupportedFieldTypePredicated", () => $5172533d88399045$export$190ed2ad153b150b);
$parcel$export(module.exports, "getSortingDisabledFields", () => $5172533d88399045$export$56c924491e5617ad);

var $5iWql = parcelRequire("5iWql");

var $hPNnE = parcelRequire("hPNnE");

var $6Kxnm = parcelRequire("6Kxnm");

var $4dn6Q = parcelRequire("4dn6Q");

var $fgDTb = parcelRequire("fgDTb");

var $4kOft = parcelRequire("4kOft");

var $dnGVZ = parcelRequire("dnGVZ");

var $5GKSf = parcelRequire("5GKSf");

var $4ACib = parcelRequire("4ACib");

var $8DMfR = parcelRequire("8DMfR");

var $77PMd = parcelRequire("77PMd");

var $fGEjz = parcelRequire("fGEjz");
const $5172533d88399045$var$createSortingHandlers = (0, $5iWql.default)(()=>({
        ...(0, $4kOft.parentSortingHandler),
        ...(0, $fGEjz.versionSortingHandler),
        ...(0, $4ACib.resolutionSortingHandler),
        ...(0, $fgDTb.groupSortingHandler),
        ...(0, $5GKSf.radioSelectSortingHandler),
        ...(0, $hPNnE.cascadingSelectSortingHandler),
        ...(0, $dnGVZ.projectSortingHandler)
    }));
const $5172533d88399045$export$654dceec98f3061f = (fieldType, ...args)=>{
    const handlers = $5172533d88399045$var$createSortingHandlers();
    if (handlers[fieldType] == null) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType]?.(...args);
};
const $5172533d88399045$export$c6c6084d02f37d7e = (fieldType)=>{
    const handlers = $5172533d88399045$var$createSortingHandlers();
    return handlers[fieldType] != null;
};
const $5172533d88399045$export$190ed2ad153b150b = (fieldType)=>true;
const $5172533d88399045$export$56c924491e5617ad = (0, $5iWql.default)(()=>({
        ...(0, $6Kxnm.devSummaryDisabledSorting),
        ...(0, $77PMd.teamDisabledSorting),
        ...(0, $8DMfR.statusCategoryDisabledSorting),
        ...(0, $4dn6Q.goalsDisabledSorting)
    }));

});
parcelRegister("hPNnE", function(module, exports) {

$parcel$export(module.exports, "cascadingSelectSortingHandler", () => $9006c1312190fa14$export$7b0bfc6838ff3257);

var $lO4Or = parcelRequire("lO4Or");

var $yTRlI = parcelRequire("yTRlI");
const $9006c1312190fa14$var$getCascadingSelectSorting = (field)=>(0, $yTRlI.getCascadingSelectStringValue)(field.value);
const $9006c1312190fa14$export$7b0bfc6838ff3257 = {
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $9006c1312190fa14$var$getCascadingSelectSorting
};

});
parcelRegister("yTRlI", function(module, exports) {

$parcel$export(module.exports, "getCascadingSelectStringValue", () => $501644a5d0f27e91$export$f110a74eb752aa7e);
$parcel$export(module.exports, "cascadingSelectStringValueHandler", () => $501644a5d0f27e91$export$f39c163ada81742a);
$parcel$export(module.exports, "cascadingSelectRichValueHandler", () => $501644a5d0f27e91$export$af92c160980c340f);

var $lO4Or = parcelRequire("lO4Or");
const $501644a5d0f27e91$export$f110a74eb752aa7e = (fieldValue)=>{
    if (fieldValue && fieldValue.parentOptionValue) {
        if (fieldValue.childOptionValue) return `${fieldValue.parentOptionValue.value} - ${fieldValue.childOptionValue.value}`;
        return `${fieldValue.parentOptionValue.value}`;
    }
    return '';
};
const $501644a5d0f27e91$var$getCascadingSelectValue = (field)=>$501644a5d0f27e91$export$f110a74eb752aa7e(field.value);
const $501644a5d0f27e91$var$getCascadingSelectRichValue = (field)=>field.value ?? null;
const $501644a5d0f27e91$export$f39c163ada81742a = {
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $501644a5d0f27e91$var$getCascadingSelectValue
};
const $501644a5d0f27e91$export$af92c160980c340f = {
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $501644a5d0f27e91$var$getCascadingSelectRichValue
};

});


parcelRegister("6Kxnm", function(module, exports) {

$parcel$export(module.exports, "devSummaryDisabledSorting", () => $13cd49fb2f12cee8$export$8cf683615a3ccf77);

var $lO4Or = parcelRequire("lO4Or");
const $13cd49fb2f12cee8$export$8cf683615a3ccf77 = {
    [(0, $lO4Or.DEV_SUMMARY_CF_TYPE)]: false
};

});

parcelRegister("4dn6Q", function(module, exports) {

$parcel$export(module.exports, "goalsDisabledSorting", () => $e609dcddc34139db$export$60ff70c996f5c362);

var $lO4Or = parcelRequire("lO4Or");
const $e609dcddc34139db$export$60ff70c996f5c362 = {
    [(0, $lO4Or.GOALS_CF_TYPE)]: false
};

});

parcelRegister("fgDTb", function(module, exports) {

$parcel$export(module.exports, "groupSortingHandler", () => $2965094b1aff09d1$export$a577fd60fa30451d);

var $lO4Or = parcelRequire("lO4Or");
const $2965094b1aff09d1$var$getSingleGroupSorting = (field)=>field.value?.name ?? '';
const $2965094b1aff09d1$var$getMultipleGroupSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
const $2965094b1aff09d1$export$a577fd60fa30451d = {
    [(0, $lO4Or.GROUP_CF_TYPE)]: $2965094b1aff09d1$var$getSingleGroupSorting,
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: $2965094b1aff09d1$var$getMultipleGroupSorting
};

});

parcelRegister("4kOft", function(module, exports) {

$parcel$export(module.exports, "parentSortingHandler", () => $b1645a5228930c15$export$20dbdacc158507c9);

var $lO4Or = parcelRequire("lO4Or");
const $b1645a5228930c15$var$getParentSorting = (field)=>field.value ? field.value.issueKey : '';
const $b1645a5228930c15$export$20dbdacc158507c9 = {
    [(0, $lO4Or.PARENT_TYPE)]: $b1645a5228930c15$var$getParentSorting
};

});

parcelRegister("dnGVZ", function(module, exports) {

$parcel$export(module.exports, "projectSortingHandler", () => $b535da34585ea13f$export$18c888fa7805bbf9);

var $lO4Or = parcelRequire("lO4Or");
const $b535da34585ea13f$var$getProjectSorting = (field)=>field.value?.name ?? '';
const $b535da34585ea13f$export$18c888fa7805bbf9 = {
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: $b535da34585ea13f$var$getProjectSorting
};

});

parcelRegister("5GKSf", function(module, exports) {

$parcel$export(module.exports, "radioSelectSortingHandler", () => $090676a3e9c576f9$export$d622730346571a2b);

var $lO4Or = parcelRequire("lO4Or");
const $090676a3e9c576f9$var$getRadioSelectSorting = (field)=>field.value ? field.value.value : '';
const $090676a3e9c576f9$export$d622730346571a2b = {
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: $090676a3e9c576f9$var$getRadioSelectSorting
};

});

parcelRegister("4ACib", function(module, exports) {

$parcel$export(module.exports, "resolutionSortingHandler", () => $2a63ab07413670f0$export$596a643f093db9a7);

var $lO4Or = parcelRequire("lO4Or");
const $2a63ab07413670f0$var$getResolutionSorting = (field)=>field.value?.name ?? '';
const $2a63ab07413670f0$export$596a643f093db9a7 = {
    [(0, $lO4Or.RESOLUTION_TYPE)]: $2a63ab07413670f0$var$getResolutionSorting
};

});

parcelRegister("8DMfR", function(module, exports) {

$parcel$export(module.exports, "statusCategoryDisabledSorting", () => $14c4f6b294c727dd$export$117cb43589655b27);

var $lO4Or = parcelRequire("lO4Or");
const $14c4f6b294c727dd$export$117cb43589655b27 = {
    [(0, $lO4Or.STATUS_CATEGORY_TYPE)]: false
};

});

parcelRegister("77PMd", function(module, exports) {

$parcel$export(module.exports, "teamDisabledSorting", () => $4318536e894fadd9$export$1626c947db580b0f);

var $lO4Or = parcelRequire("lO4Or");
const $4318536e894fadd9$export$1626c947db580b0f = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: false
};

});

parcelRegister("fGEjz", function(module, exports) {

$parcel$export(module.exports, "versionSortingHandler", () => $478431d0e41552b9$export$f2894a637a250eaa);

var $lO4Or = parcelRequire("lO4Or");
const $478431d0e41552b9$var$getSingleVersionSorting = (field)=>field.value?.name ?? '';
const $478431d0e41552b9$var$getMultipleVersionSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
const $478431d0e41552b9$export$f2894a637a250eaa = {
    [(0, $lO4Or.VERSION_CF_TYPE)]: $478431d0e41552b9$var$getSingleVersionSorting,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $478431d0e41552b9$var$getMultipleVersionSorting,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: $478431d0e41552b9$var$getMultipleVersionSorting,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: $478431d0e41552b9$var$getMultipleVersionSorting
};

});


parcelRegister("iJbbQ", function(module, exports) {

$parcel$export(module.exports, "isNewTransformedFieldPredicated", () => $1f6d8e2cada4a475$export$b018c2b58ea7e0de);
const $1f6d8e2cada4a475$export$b018c2b58ea7e0de = (field)=>field != null;

});

parcelRegister("3uSNh", function(module, exports) {

$parcel$export(module.exports, "getFieldValue", () => $0a411223ee962893$export$2e85048acc9aea83);
$parcel$export(module.exports, "safeGetValue", () => $0a411223ee962893$export$f17a5eaf5fe57cff);
$parcel$export(module.exports, "safeGetTransformedFieldValue", () => $0a411223ee962893$export$16456470899ab77f);
$parcel$export(module.exports, "safeGetTransformedValue", () => $0a411223ee962893$export$c1cc7bc9b4953394);

var $illlw = parcelRequire("illlw");
const $0a411223ee962893$export$2e85048acc9aea83 = (fields, fieldKey)=>{
    if (fields && fieldKey != null) return fields.find((field)=>field?.fieldKey && field.fieldKey === fieldKey || field?.fieldId && field.fieldId === fieldKey || field?.aliasFieldId && field.aliasFieldId === fieldKey);
    return undefined;
};
const $0a411223ee962893$export$f17a5eaf5fe57cff = (fields, fieldKey, attributeName, defaultValue)=>{
    const field = $0a411223ee962893$export$2e85048acc9aea83(fields, fieldKey);
    return (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(field, attributeName, defaultValue);
};
const $0a411223ee962893$export$16456470899ab77f = (fields, fieldKey, attributeName, defaultValue)=>{
    const field = $0a411223ee962893$export$2e85048acc9aea83(fields, fieldKey);
    return $0a411223ee962893$export$c1cc7bc9b4953394(field, defaultValue);
};
const $0a411223ee962893$export$c1cc7bc9b4953394 = (field, defaultValue)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(field, 'value', defaultValue);

});

parcelRegister("90Dtq", function(module, exports) {

$parcel$export(module.exports, "resolveRank", () => $668a01cc7ea88012$export$992090b26f7c7f11);
const $668a01cc7ea88012$export$992090b26f7c7f11 = (parentIssue, rank)=>{
    // for the Sub-task issue types, sorting based on rank considers the parent rank first, then sorts based on item rank
    // concatenating (parentRank + rank) would do that for us!
    const parentRank = parentIssue?.rank ?? '';
    return parentRank.concat(rank);
};

});



parcelRegister("96etS", function(module, exports) {

$parcel$export(module.exports, "useSimpleSearch", () => $70f3d6a365372dbd$export$b549f44e7ca96280);
$parcel$export(module.exports, "useSimpleSearchHighlight", () => $70f3d6a365372dbd$export$fd04dfca01137d2);
$parcel$export(module.exports, "useSearchText", () => $70f3d6a365372dbd$export$119186efd4186c93);
$parcel$export(module.exports, "useSimpleSearchJQL", () => $70f3d6a365372dbd$export$42b8d8a5ec5bc873);

var $eUqFw = parcelRequire("eUqFw");

var $6GXx9 = parcelRequire("6GXx9");

var $lB25E = parcelRequire("lB25E");

var $dG4cR = parcelRequire("dG4cR");
const $70f3d6a365372dbd$var$sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
const $70f3d6a365372dbd$var$issueKeyRegex = new RegExp(`^${(0, $6GXx9.ISSUEKEY_REGEX)}$`);
const $70f3d6a365372dbd$var$japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
const $70f3d6a365372dbd$export$b549f44e7ca96280 = ()=>{
    const [simpleSearch, persistSimpleSearch] = (0, $lB25E.useQueryParam)((0, $dG4cR.SIMPLE_SEARCH_PARAM));
    const setSimpleSearch = (0, $eUqFw.useCallback)((searchText)=>{
        searchText != null && searchText.trim() !== '' ? persistSimpleSearch(searchText) : persistSimpleSearch(undefined);
    }, [
        persistSimpleSearch
    ]);
    return [
        simpleSearch ?? '',
        setSimpleSearch
    ];
};
const $70f3d6a365372dbd$export$72839f749ccf76b2 = (text)=>{
    if (text == null) return [];
    return text.split(' ').filter((word)=>word !== '');
};
const $70f3d6a365372dbd$export$fd04dfca01137d2 = ()=>{
    const [simpleSearch] = $70f3d6a365372dbd$export$b549f44e7ca96280();
    return (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$72839f749ccf76b2(simpleSearch), [
        simpleSearch
    ]);
};
const $70f3d6a365372dbd$export$abb78553baf1cfac = (text)=>{
    if (text == null || text.trim() === '') return '';
    let search = $70f3d6a365372dbd$var$sanitize(text);
    if ($70f3d6a365372dbd$var$issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!$70f3d6a365372dbd$var$japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
};
const $70f3d6a365372dbd$export$119186efd4186c93 = (text)=>{
    const jql = (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$abb78553baf1cfac(text), [
        text
    ]);
    const highlight = (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$72839f749ccf76b2(text), [
        text
    ]);
    return {
        jql: jql,
        highlight: highlight
    };
};
const $70f3d6a365372dbd$export$42b8d8a5ec5bc873 = ()=>{
    const [simpleSearch] = $70f3d6a365372dbd$export$b549f44e7ca96280();
    const jql = (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$abb78553baf1cfac(simpleSearch), [
        simpleSearch
    ]);
    const addSimpleSearchToJQL = (0, $eUqFw.useCallback)((currentJQL)=>{
        if (jql === '') return currentJQL;
        if (currentJQL == null) return jql;
        return `${currentJQL} AND ${jql}`;
    }, [
        jql
    ]);
    return {
        jql: jql,
        isSearching: jql !== '',
        addSimpleSearchToJQL: addSimpleSearchToJQL
    };
};
var $70f3d6a365372dbd$export$2e2bcd8739ae039 = $70f3d6a365372dbd$export$b549f44e7ca96280;

});
parcelRegister("6GXx9", function(module, exports) {

$parcel$export(module.exports, "ISSUEKEY_REGEX", () => $2bd12f0fe8e9dce1$export$b52c9cee589449a8);
$parcel$export(module.exports, "default", () => $2bd12f0fe8e9dce1$export$2e2bcd8739ae039);

var $k4nIh = parcelRequire("k4nIh");
const $2bd12f0fe8e9dce1$export$b52c9cee589449a8 = '([A-Z][A-Z0-9_]+-\\d+)';
var /**
 * Returns the issue key if the URL is a valid full page Jira issue URL. It may also include a trailing
 * hash fragment. A matching URL must look like:
 * <host><baseurl>/browse/<issuekey><#hash?>
 * e.g. https://my-jira-instance.atlassian.net/browse/FOO-123#xyz
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$2bd12f0fe8e9dce1$export$2e2bcd8739ae039 = (url, host)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url, {});
    const isMatchingProtocol = parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
    const isMatchingHost = parsedUrl.host === host;
    const matches = parsedUrl.pathname.match(new RegExp(`^\\/browse\\/${$2bd12f0fe8e9dce1$export$b52c9cee589449a8}\\/?$`));
    const issueKey = matches && matches.length > 1 ? matches[1] : null;
    return isMatchingProtocol && isMatchingHost && issueKey || null;
};

});


parcelRegister("jQFcD", function(module, exports) {

$parcel$export(module.exports, "sanitiseJql", () => $fea50252d29e77ce$export$78c9a06ab18996fc);
$parcel$export(module.exports, "getJqlErrors", () => $fea50252d29e77ce$export$cc387523b0acb16d);

var $hV92L = parcelRequire("hV92L");
var $kIKLu = parcelRequire("kIKLu");
const $fea50252d29e77ce$export$78c9a06ab18996fc = (jql)=>{
    if (!jql) return jql;
    const builder = new (0, $hV92L.JastBuilder)();
    const jast = builder.build(jql);
    if (jast.query && jast.query.orderBy) jast.query.orderBy = undefined;
    return (0, $kIKLu.print)(jast, {
        operatorCase: 'upper',
        printWidth: null
    });
};
const $fea50252d29e77ce$export$cc387523b0acb16d = (jql)=>{
    if (!jql) return [];
    const builder = new (0, $hV92L.JastBuilder)();
    const jast = builder.build(jql);
    return jast.errors;
};

});



parcelRegister("5ujax", function(module, exports) {

$parcel$export(module.exports, "hasAllRequiredFields", () => $52d6130341d650ac$export$146976a1cbd99cd0);

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");
const $52d6130341d650ac$export$146976a1cbd99cd0 = ({ issueType: issueType, createInput: createInput })=>{
    if (!issueType) return false;
    return issueType.fields.every((field)=>{
        if (!field.fieldConfig?.isRequired) return true;
        if (!field.type && !field.aliasFieldId) return false;
        if (field.aliasFieldId && field.aliasFieldId === (0, $jGcn0.START_DATE_ALIAS_FIELD_ID)) return Boolean(createInput.startDate);
        if (field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)) return createInput.storyPoints != null;
        if (field.type) switch(field.type){
            case 0, $lO4Or.ISSUE_TYPE:
            case 0, $lO4Or.REPORTER_TYPE:
                return true;
            case 0, $lO4Or.SUMMARY_TYPE:
                return Boolean(createInput.summary);
            case 0, $lO4Or.PRIORITY_TYPE:
                return Boolean(createInput.priority);
            case 0, $lO4Or.ASSIGNEE_TYPE:
                return Boolean(createInput.assignee);
            case 0, $lO4Or.DUE_DATE_TYPE:
                return Boolean(createInput.dueDate);
            case 0, $lO4Or.CATEGORY_TYPE:
                return Boolean(createInput.category);
            case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
                return createInput.storyPointEstimate != null;
            case 0, $lO4Or.SPRINT_TYPE:
                return Boolean(createInput.sprint);
            default:
                break;
        }
        return false;
    });
};

});

parcelRegister("auegK", function(module, exports) {

$parcel$export(module.exports, "CancelledError", () => $3e371496a660187a$export$a8430ed4188f35a9);
$parcel$export(module.exports, "useCreateIssueDialog", () => $3e371496a660187a$export$8254d39962ec7361);

var $eUqFw = parcelRequire("eUqFw");

var $gEmpR = parcelRequire("gEmpR");

var $dNWQB = parcelRequire("dNWQB");

var $2gOs4 = parcelRequire("2gOs4");

var $1MRnf = parcelRequire("1MRnf");

var $ctR9z = parcelRequire("ctR9z");

var $fD1Hq = parcelRequire("fD1Hq");

var $l1Cux = parcelRequire("l1Cux");
class $3e371496a660187a$export$a8430ed4188f35a9 extends Error {
}
const $3e371496a660187a$export$8d1d8a0d2a7917ac = ()=>{
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    return (0, $eUqFw.useCallback)((issueType, predicate)=>{
        if (!issueType) return undefined;
        const issueTypeWithFields = typesWithFields.find((typeWithFields)=>typeWithFields.issueType.id === issueType.id);
        return issueTypeWithFields?.fields.find(predicate);
    }, [
        typesWithFields
    ]);
};
const $3e371496a660187a$export$8254d39962ec7361 = ()=>{
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const { subscribe: subscribe } = (0, $2gOs4.useGICLifeCycleEvents)();
    const getField = $3e371496a660187a$export$8d1d8a0d2a7917ac();
    // rank field is handled separately as it's not returned by the available fields API
    const { data: rankField } = (0, $fD1Hq.useRankField)();
    return (0, $eUqFw.useCallback)((createInput, extraPayload)=>new Promise((resolve, reject)=>{
            const unsubscribe = subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_KEEP_EDITING_EXISTING_ISSUE, ()=>{
                // the user cancelled editing
                onClose(null);
            });
            // resolve the promise once the GIC has been closed or reject it if cancelled
            const onClose = (data)=>{
                const result = data?.[0];
                if (result) resolve(result);
                else // adding a delay upon user cancelling because of a bug in the GIC's state management logic ICO-303
                setTimeout(()=>{
                    reject(new $3e371496a660187a$export$a8430ed4188f35a9('User cancelled'));
                }, 100);
                unsubscribe();
            };
            const { payload: payload, submitApiData: submitApiData } = (0, $l1Cux.buildGICPayload)({
                createInput: createInput,
                extraPayload: extraPayload,
                rankField: rankField,
                getField: getField
            });
            const isSubTaskCreationOpen = createInput.issueType?.hierarchyLevel === -1;
            openIssueCreateModal({
                id: 'jwm-create-issue-dialog',
                onClose: onClose,
                payload: payload,
                context: {
                    projectId: createInput.projectId,
                    submitApiData: submitApiData
                },
                isSubTaskCreationOpen: isSubTaskCreationOpen,
                triggerPointKey: (0, $1MRnf.JWM_INLINE_CREATE),
                disableProjectDropdown: true,
                disableIssueTypeDropdown: Boolean(payload.issueType?.issueTypeId),
                disableCreationSuccessFlag: true,
                displayCreateAnotherIssueToggle: false,
                minimizableModalView: 'mini'
            });
        }), [
        getField,
        openIssueCreateModal,
        rankField,
        subscribe
    ]);
};

});
parcelRegister("dNWQB", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $21eb2e23e0bf69c0$export$876003a5b887f37e);
const $21eb2e23e0bf69c0$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("2gOs4", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $c9d12900db50c35b$export$e3ff72f196296fcc);

var $jcERi = parcelRequire("jcERi");
const $c9d12900db50c35b$var$GICLifeCycleEventsService = new (0, $jcERi.PubSubHub)();
const $c9d12900db50c35b$export$e3ff72f196296fcc = ()=>({
        ...$c9d12900db50c35b$var$GICLifeCycleEventsService
    });

});
parcelRegister("jcERi", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $a1db2e8ca1046c74$export$e3607828f8f2c01e);
class $a1db2e8ca1046c74$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


parcelRegister("1MRnf", function(module, exports) {

$parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", () => $33ffe55cb7bcdadc$export$a05673a22505d5ee);
$parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", () => $33ffe55cb7bcdadc$export$c78d329777576aa0);
$parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", () => $33ffe55cb7bcdadc$export$affdc3af7a9a4677);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", () => $33ffe55cb7bcdadc$export$7e9cfd1f59e60910);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", () => $33ffe55cb7bcdadc$export$708499dcd016e5e9);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", () => $33ffe55cb7bcdadc$export$e1c8789144c4c810);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", () => $33ffe55cb7bcdadc$export$c5afabb7a17e802);
$parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$2086a63173b79b56);
$parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$fe1e5e4597147709);
$parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$9bc326812a93707);
$parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", () => $33ffe55cb7bcdadc$export$f352934e06f44599);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", () => $33ffe55cb7bcdadc$export$6ae07c77acc64360);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", () => $33ffe55cb7bcdadc$export$b41d0684e4b6ab1);
$parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", () => $33ffe55cb7bcdadc$export$be9b2b1329ff7ec9);
$parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", () => $33ffe55cb7bcdadc$export$aa348159181703a0);
$parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", () => $33ffe55cb7bcdadc$export$f90eec3841adf619);
$parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", () => $33ffe55cb7bcdadc$export$718822a309bffada);
$parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", () => $33ffe55cb7bcdadc$export$2753dafac81e805c);
$parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", () => $33ffe55cb7bcdadc$export$7c4d5cc5711d9294);
$parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", () => $33ffe55cb7bcdadc$export$998dfc72404b9e14);
$parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", () => $33ffe55cb7bcdadc$export$fc180a4b5785d2f4);
$parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", () => $33ffe55cb7bcdadc$export$946ec0b21cb84fd0);
$parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", () => $33ffe55cb7bcdadc$export$5b97e2844e620e54);
$parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", () => $33ffe55cb7bcdadc$export$b99842c2cf46f6be);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", () => $33ffe55cb7bcdadc$export$8d987f6e80b74000);
$parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$8de9fa43731c4b5b);
$parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", () => $33ffe55cb7bcdadc$export$87249ccbfd10fb78);
$parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", () => $33ffe55cb7bcdadc$export$c0eeeb31d264de76);
$parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", () => $33ffe55cb7bcdadc$export$f546e18e46478c84);
$parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", () => $33ffe55cb7bcdadc$export$1784e634ba79f1f9);
$parcel$export(module.exports, "JWM_INLINE_CREATE", () => $33ffe55cb7bcdadc$export$145eb8935a34e85e);
$parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", () => $33ffe55cb7bcdadc$export$32648b574a536c8b);
$parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", () => $33ffe55cb7bcdadc$export$c0e2ab74dfaa67cc);
const $33ffe55cb7bcdadc$export$a05673a22505d5ee = 'forge-open-issue-create';
const $33ffe55cb7bcdadc$export$c78d329777576aa0 = 'global-create-button';
const $33ffe55cb7bcdadc$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $33ffe55cb7bcdadc$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $33ffe55cb7bcdadc$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $33ffe55cb7bcdadc$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $33ffe55cb7bcdadc$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $33ffe55cb7bcdadc$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $33ffe55cb7bcdadc$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $33ffe55cb7bcdadc$export$9bc326812a93707 = 'jsw-security-create-issue';
const $33ffe55cb7bcdadc$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $33ffe55cb7bcdadc$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $33ffe55cb7bcdadc$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $33ffe55cb7bcdadc$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $33ffe55cb7bcdadc$export$235b856f54db8916 = 'jwm-board-create-issue';
const $33ffe55cb7bcdadc$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $33ffe55cb7bcdadc$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $33ffe55cb7bcdadc$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $33ffe55cb7bcdadc$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $33ffe55cb7bcdadc$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $33ffe55cb7bcdadc$export$aa348159181703a0 = 'software-create-issue-dialog';
const $33ffe55cb7bcdadc$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $33ffe55cb7bcdadc$export$718822a309bffada = 'create-linked-issue-command-palette';
const $33ffe55cb7bcdadc$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $33ffe55cb7bcdadc$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $33ffe55cb7bcdadc$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $33ffe55cb7bcdadc$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $33ffe55cb7bcdadc$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $33ffe55cb7bcdadc$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $33ffe55cb7bcdadc$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $33ffe55cb7bcdadc$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $33ffe55cb7bcdadc$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $33ffe55cb7bcdadc$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $33ffe55cb7bcdadc$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $33ffe55cb7bcdadc$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $33ffe55cb7bcdadc$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $33ffe55cb7bcdadc$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $33ffe55cb7bcdadc$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $33ffe55cb7bcdadc$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $33ffe55cb7bcdadc$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $33ffe55cb7bcdadc$export$145eb8935a34e85e = 'jwm-inline-create';
const $33ffe55cb7bcdadc$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
const $33ffe55cb7bcdadc$export$818f24c6c32e18a = 'jira-calendar-create-issue';
const $33ffe55cb7bcdadc$export$f352408886aa304b = 'connect-app-ecosystem';
const $33ffe55cb7bcdadc$export$c0e2ab74dfaa67cc = {
    FIELD_IDS: [
        'description'
    ],
    TRIGGER_POINTS: [
        'service-desk-gen-ai-pir'
    ]
};

});

parcelRegister("ctR9z", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $bd445758cecbab8c$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $bd445758cecbab8c$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $bd445758cecbab8c$export$558a195c5bfe3787);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $dfh7z = parcelRequire("dfh7z");

var $dEMIg = parcelRequire("dEMIg");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $ellXt = parcelRequire("ellXt");

var $lB25E = parcelRequire("lB25E");

var $WBLbN = parcelRequire("WBLbN");

var $1MRnf = parcelRequire("1MRnf");

var $4SS5k = parcelRequire("4SS5k");

var $dgsxZ = parcelRequire("dgsxZ");
const $bd445758cecbab8c$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $dEMIg.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $1MRnf.TRIGGER_POINT_KEY_NOT_DEFINED),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // optional component - Renders external component above form fields
    ExternalControls: undefined,
    // Analytics property for board with custom filter and icc enabled
    isCustomBoardWithIcc: false,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // Analytics property for board with swimlane enabled
    swimlaneMode: undefined,
    // prefilled custom Fields if any
    prefilledCustomFields: {}
};
const $bd445758cecbab8c$export$e324594224ef24da = {
    restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) (0, $dgsxZ.startGlobalIssueCreateMetrics)(isSubsequentLoad);
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $dgsxZ.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $bd445758cecbab8c$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...isDiscoverabilityPushEnabled && {
                        minimizableModalView: nextModalView,
                        persistentModalView: currentState.persistentModalView,
                        ...(0, $dgsxZ.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                    },
                    inProgressIssueID: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: currentState.isModalOpen,
                    ...nextState
                });
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                callbackPayload: undefined,
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $dfh7z.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            if (!(0, $1ybV0.ff)('linked-alerts-in-gic_onvr6')) return;
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $bd445758cecbab8c$var$store = (0, $WBLbN.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $bd445758cecbab8c$export$d4c72bab9d6cc13a,
    actions: $bd445758cecbab8c$export$e324594224ef24da
});
const $bd445758cecbab8c$var$useTriggerIssueCreateModalState = (0, $WBLbN.createStateHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$var$useTriggerIssueCreateModalActions = (0, $WBLbN.createActionsHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$export$71e0eb7b8a91a156 = ()=>{
    const createState = $bd445758cecbab8c$var$useTriggerIssueCreateModalState();
    const createActions = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $bd445758cecbab8c$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const [, { setSitePickerState: setSitePickerState }] = (0, $4SS5k.useSitePickerContext)();
    return (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        // overrideCloudId only used for embedded GIC
        if (nextState?.payload?.overrideCloudId && (0, $eI5EY.fg)('jira_ai_issue_create_site_user_preference')) // set cloudId inside the state if there's an override
        setSitePickerState({
            selectedCloudId: nextState?.payload?.overrideCloudId
        });
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal,
        setSitePickerState
    ]);
};
const $bd445758cecbab8c$export$4c674fe824b8f278 = (0, $WBLbN.createSubscriber)($bd445758cecbab8c$var$store);
function $bd445758cecbab8c$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $bd445758cecbab8c$export$71e0eb7b8a91a156();
        const { data: data } = (0, $lB25E.useResource)((0, $ellXt.gicOptInStatusResources));
        const currentIssueCreateVisibility = data && data?.gicOptInStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
            ...props
        });
    };
}

});
parcelRegister("dfh7z", function(module, exports) {

$parcel$export(module.exports, "CreateIssueUFOExperience", () => $5fd686e53a19cbe0$export$cd75c112ac11a83b);
$parcel$export(module.exports, "StatusFieldLoad", () => $5fd686e53a19cbe0$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $5fd686e53a19cbe0$export$70208657c8d471a7);
$parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", () => $5fd686e53a19cbe0$export$b2d8f8edec75f571);

var $4zjEa = parcelRequire("4zjEa");
var $4s7r3 = parcelRequire("4s7r3");
const $5fd686e53a19cbe0$export$cd75c112ac11a83b = new (0, $4s7r3.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $4zjEa.ExperienceTypes).Experience,
    performanceType: (0, $4zjEa.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $5fd686e53a19cbe0$export$e890e797a25e655c = new (0, $4s7r3.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $4zjEa.ExperienceTypes).Load,
    performanceType: (0, $4zjEa.ExperiencePerformanceTypes).PageSegmentLoad
});
const $5fd686e53a19cbe0$export$70208657c8d471a7 = new (0, $4s7r3.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $4zjEa.ExperienceTypes).Experience,
    performanceType: (0, $4zjEa.ExperiencePerformanceTypes).Custom,
    category: 'modern-global-issue-create.modal.issue-submit'
});
const $5fd686e53a19cbe0$export$b2d8f8edec75f571 = new (0, $4s7r3.UFOExperience)('ecosystem-api-new-gic-prefilling', {
    type: (0, $4zjEa.ExperienceTypes).Experience,
    performanceType: (0, $4zjEa.ExperiencePerformanceTypes).Custom,
    category: 'ecosystem-api-new-gic-prefilling'
});

});

parcelRegister("dEMIg", function(module, exports) {

$parcel$export(module.exports, "REQUIRED", () => $dd9f36fe091541c8$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $dd9f36fe091541c8$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $dd9f36fe091541c8$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $dd9f36fe091541c8$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $dd9f36fe091541c8$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $dd9f36fe091541c8$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $dd9f36fe091541c8$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $dd9f36fe091541c8$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $dd9f36fe091541c8$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $dd9f36fe091541c8$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $dd9f36fe091541c8$export$8170252f0ea43511);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $dd9f36fe091541c8$export$17bcab948893a9ba = 'worklog';
const $dd9f36fe091541c8$export$b1c05b34d317c074 = 'REQUIRED';
const $dd9f36fe091541c8$export$f10b32dfda12e96e = 'unknown';
const $dd9f36fe091541c8$export$e5e4b8c32e68dd0b = 'networkError';
const $dd9f36fe091541c8$export$2d06efb8146cd043 = 'graphQLError';
const $dd9f36fe091541c8$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $dd9f36fe091541c8$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $dd9f36fe091541c8$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $dd9f36fe091541c8$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $dd9f36fe091541c8$export$aac4661200ba4104 = 'worklog_startDate';
const $dd9f36fe091541c8$export$a23c32d5cf54cba0 = 'worklog_description';
const $dd9f36fe091541c8$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $dd9f36fe091541c8$export$63fd567c1d0aca19 = [
    ...$dd9f36fe091541c8$export$74ab3898ae683660,
    $dd9f36fe091541c8$export$a1a7caa1e4a73c9f,
    $dd9f36fe091541c8$export$cf70f9220e6a2f50,
    $dd9f36fe091541c8$export$aac4661200ba4104,
    $dd9f36fe091541c8$export$a23c32d5cf54cba0
];
const $dd9f36fe091541c8$export$983715bb9b0f9b2c = {
    [$dd9f36fe091541c8$export$17bcab948893a9ba]: $dd9f36fe091541c8$export$63fd567c1d0aca19
};
const $dd9f36fe091541c8$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $dd9f36fe091541c8$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $dd9f36fe091541c8$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $dd9f36fe091541c8$export$8170252f0ea43511 = 'QuickCreateIssue';

});

parcelRegister("4SS5k", function(module, exports) {

$parcel$export(module.exports, "useSitePickerContext", () => $fda55b41d7d37cf0$export$f8b5aae013e4cf77);

var $WBLbN = parcelRequire("WBLbN");
const $fda55b41d7d37cf0$export$d4c72bab9d6cc13a = {
    selectedCloudId: '',
    siteDomain: ''
};
const $fda55b41d7d37cf0$export$e324594224ef24da = {
    setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                selectedCloudId: selectedCloudId || '',
                siteDomain: siteDomain || ''
            });
        }
};
const $fda55b41d7d37cf0$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    name: 'issue.fields.site-picker',
    initialState: $fda55b41d7d37cf0$export$d4c72bab9d6cc13a,
    actions: $fda55b41d7d37cf0$export$e324594224ef24da
});
const $fda55b41d7d37cf0$export$f8b5aae013e4cf77 = (0, $WBLbN.createHook)($fda55b41d7d37cf0$export$6f57813fe9f31bf9);

});

parcelRegister("dgsxZ", function(module, exports) {

$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $b8d8e5356c7976a6$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $b8d8e5356c7976a6$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $b8d8e5356c7976a6$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $b8d8e5356c7976a6$export$720579602bb055a2);

var $dfh7z = parcelRequire("dfh7z");

var $fqKjL = parcelRequire("fqKjL");

var $hBkQt = parcelRequire("hBkQt");

var $kGAxV = parcelRequire("kGAxV");
const $b8d8e5356c7976a6$export$550b19803bc962ec = (isSubsequentLoad)=>{
    (0, $dfh7z.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $fqKjL.globalIssueCreateModalLoadSubsequent) : (0, $fqKjL.globalIssueCreateModalLoad);
    if (isSubsequentLoad) (0, $kGAxV.default)('global-issue.create-modal-subsequent');
    else (0, $kGAxV.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $hBkQt.startGlobalIssueCreateTTIWithAdjustments)();
};
const $b8d8e5356c7976a6$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $b8d8e5356c7976a6$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $b8d8e5356c7976a6$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};

});
parcelRegister("fqKjL", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $de2993c8c3fea479$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $de2993c8c3fea479$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $de2993c8c3fea479$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $de2993c8c3fea479$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $de2993c8c3fea479$export$c1592e4d8d98963e);

var $cFpT4 = parcelRequire("cFpT4");
const $de2993c8c3fea479$export$5a01a7fa84b239c8 = (0, $cFpT4.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $de2993c8c3fea479$export$c50ad3c31b6fcfc6 = (0, $cFpT4.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $de2993c8c3fea479$export$4b2382574525bb0f = (0, $cFpT4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $de2993c8c3fea479$export$7839bdaa2f6a2385 = (0, $cFpT4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $de2993c8c3fea479$export$c1592e4d8d98963e = (0, $cFpT4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("hBkQt", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $362542d6dd943f24$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $362542d6dd943f24$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $362542d6dd943f24$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $362542d6dd943f24$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $362542d6dd943f24$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $362542d6dd943f24$export$d86f4868694f2aa7);

var $cFpT4 = parcelRequire("cFpT4");

var $gGRYc = parcelRequire("gGRYc");
const $362542d6dd943f24$export$9f3d6f17e1da7874 = (0, $cFpT4.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $362542d6dd943f24$export$457c9fb71ad5b3a9 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.start();
};
const $362542d6dd943f24$export$ef664dac649a716c = ()=>$362542d6dd943f24$export$9f3d6f17e1da7874.mark('gic-tti');
const $362542d6dd943f24$export$30ca4c461fab486c = (customData)=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $362542d6dd943f24$export$27f2445288b528c = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.cancel();
};
const $362542d6dd943f24$export$7a2709fc1e33401a = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $362542d6dd943f24$export$cf3893335c93e33b = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $362542d6dd943f24$export$d86f4868694f2aa7 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});
parcelRegister("gGRYc", function(module, exports) {

$parcel$export(module.exports, "TTIFFs", () => $05ae9ccc47102fc0$export$c396ba1504d97f3f);
const $05ae9ccc47102fc0$export$c396ba1504d97f3f = [];

});




parcelRegister("l1Cux", function(module, exports) {

$parcel$export(module.exports, "buildGICPayload", () => $3b44adbb66991c12$export$eb18ffe6388f217a);
/* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable complexity */ 
var $6x1NF = parcelRequire("6x1NF");

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");
const $3b44adbb66991c12$var$assigneeFieldPredicate = (field)=>field.type === (0, $lO4Or.ASSIGNEE_TYPE);
const $3b44adbb66991c12$var$categoryFieldPredicate = (field)=>field.type === (0, $lO4Or.CATEGORY_TYPE);
const $3b44adbb66991c12$var$dueDateFieldPredicate = (field)=>field.type === (0, $lO4Or.DUE_DATE_TYPE);
const $3b44adbb66991c12$var$priorityFieldPredicate = (field)=>field.type === (0, $lO4Or.PRIORITY_TYPE);
const $3b44adbb66991c12$var$startDateFieldPredicate = (field)=>field.aliasFieldId === (0, $jGcn0.START_DATE_ALIAS_FIELD_ID);
const $3b44adbb66991c12$var$storyPointEstimateFieldPredicate = (field)=>field.type === (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE);
const $3b44adbb66991c12$var$storyPointsFieldPredicate = (field)=>field.type === (0, $lO4Or.NUMBER_CF_TYPE) && field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID);
const $3b44adbb66991c12$var$sprintFieldPredicate = (field)=>field.type === (0, $lO4Or.SPRINT_TYPE);
const $3b44adbb66991c12$export$eb18ffe6388f217a = ({ createInput: createInput, extraPayload: extraPayload, rankField: rankField, getField: getField })=>{
    const payload = {
        defaultValues: {
            singleLineTextFields: [],
            singleSelectUserPickerFields: [],
            numberFields: [],
            datePickerFields: []
        },
        project: {
            projectId: createInput.projectId
        }
    };
    const additionalFields = {};
    let transition;
    if (createInput.summary) payload.defaultValues.singleLineTextFields.push({
        fieldId: (0, $lO4Or.SUMMARY_TYPE),
        text: createInput.summary
    });
    if (createInput.issueType) payload.issueType = {
        issueTypeId: createInput.issueType.id
    };
    if (createInput.dueDate && getField(createInput.issueType, $3b44adbb66991c12$var$dueDateFieldPredicate)) {
        const formattedDueDate = (0, $6x1NF.default)(createInput.dueDate, 'UTC', 'yyyy-MM-dd');
        payload.defaultValues.datePickerFields.push({
            fieldId: (0, $lO4Or.DUE_DATE_TYPE),
            date: {
                formattedDate: formattedDueDate
            }
        });
        additionalFields.duedate = formattedDueDate;
    }
    const startDateField = getField(createInput.issueType, $3b44adbb66991c12$var$startDateFieldPredicate);
    if (createInput.startDate && startDateField) {
        const formattedStartDate = (0, $6x1NF.default)(createInput.startDate, 'UTC', 'yyyy-MM-dd');
        payload.defaultValues.datePickerFields.push({
            fieldId: startDateField.id,
            date: {
                formattedDate: formattedStartDate
            }
        });
        additionalFields[startDateField.id] = formattedStartDate;
    }
    if (createInput.assignee && getField(createInput.issueType, $3b44adbb66991c12$var$assigneeFieldPredicate)) {
        payload.defaultValues.singleSelectUserPickerFields.push({
            fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
            user: {
                accountId: createInput.assignee.accountId
            }
        });
        additionalFields[0, $lO4Or.ASSIGNEE_TYPE] = {
            id: createInput.assignee.accountId
        };
    }
    if (createInput.priority && getField(createInput.issueType, $3b44adbb66991c12$var$priorityFieldPredicate)) {
        payload.defaultValues.priority = {
            priorityId: createInput.priority.priorityId
        };
        additionalFields[0, $lO4Or.PRIORITY_TYPE] = {
            id: createInput.priority.priorityId
        };
    }
    const categoryField = getField(createInput.issueType, $3b44adbb66991c12$var$categoryFieldPredicate);
    if (createInput.category && categoryField) {
        payload.defaultValues.singleSelectFields = [
            {
                fieldId: categoryField.id,
                option: {
                    id: createInput.category.optionId,
                    optionId: createInput.category.optionId
                }
            }
        ];
        additionalFields[categoryField.id] = {
            id: createInput.category.optionId,
            value: createInput.category.value
        };
    }
    const storyPointEstimateField = getField(createInput.issueType, $3b44adbb66991c12$var$storyPointEstimateFieldPredicate);
    if (createInput.storyPointEstimate && storyPointEstimateField) {
        payload.defaultValues.numberFields.push({
            fieldId: storyPointEstimateField.id,
            value: createInput.storyPointEstimate
        });
        additionalFields[storyPointEstimateField.id] = {
            id: storyPointEstimateField.id,
            value: createInput.storyPointEstimate
        };
    }
    const storyPointsField = getField(createInput.issueType, $3b44adbb66991c12$var$storyPointsFieldPredicate);
    if (createInput.storyPoints && storyPointsField) {
        payload.defaultValues.numberFields.push({
            fieldId: storyPointsField.id,
            value: createInput.storyPoints
        });
        additionalFields[storyPointsField.id] = {
            id: storyPointsField.id,
            value: createInput.storyPoints
        };
    }
    const sprintField = getField(createInput.issueType, $3b44adbb66991c12$var$sprintFieldPredicate);
    if (createInput.sprint && sprintField) {
        payload.defaultValues.sprintsField = {
            fieldId: sprintField.id,
            sprints: [
                {
                    sprintId: createInput.sprint.id
                }
            ]
        };
        additionalFields[sprintField.id] = {
            id: sprintField.id,
            value: createInput.sprint.id
        };
    }
    if (createInput.parentIssueId) {
        payload.parentId = {
            parentId: createInput.parentIssueId
        };
        payload.defaultValues.parentField = {
            issueId: createInput.parentIssueId
        };
    }
    if (createInput.status && extraPayload?.transitionId) {
        payload.status = {
            statusId: createInput.status.statusId
        };
        transition = {
            id: extraPayload.transitionId
        };
    }
    if (rankField && (createInput.rankAfter || createInput.rankBefore)) // rank is always passed as additional field
    additionalFields[rankField.id] = {
        ...createInput.rankAfter ? {
            rankAfterIssue: createInput.rankAfter.issueId
        } : {},
        ...createInput.rankBefore ? {
            rankBeforeIssue: createInput.rankBefore.issueId
        } : {}
    };
    return {
        payload: payload,
        submitApiData: {
            additionalFields: additionalFields,
            transition: transition
        }
    };
};

});


parcelRegister("fOAem", function(module, exports) {

$parcel$export(module.exports, "useShowCreateSuccessFlag", () => $96a3689a6bc73ef9$export$dfe953d11a91d407);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $hIxFu = parcelRequire("hIxFu");

var $79xbN = parcelRequire("79xbN");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $jb0p7 = parcelRequire("jb0p7");
const $96a3689a6bc73ef9$export$dfe953d11a91d407 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const [, setSelectedIssueKey] = (0, $lB25E.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    return (0, $eUqFw.useCallback)((issueKey)=>{
        const flagId = `jwm-create-success-flag-${issueKey}`;
        showFlag({
            id: flagId,
            isAutoDismiss: true,
            type: 'success',
            title: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jb0p7.default).createSuccessFlagTitleIssueTermRefresh : (0, $jb0p7.default).createSuccessFlagTitle, {
                issueKey: issueKey
            }),
            actions: [
                {
                    content: (0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jb0p7.default).viewIssueLinkTextIssueTermRefresh : (0, $jb0p7.default).viewIssueLinkText,
                    href: `/browse/${issueKey}`,
                    onClick: (event)=>{
                        if (event && !(0, $hIxFu.isModifiedEvent)(event)) {
                            setSelectedIssueKey(issueKey);
                            event.preventDefault();
                            event.stopPropagation();
                        }
                        dismissFlag(flagId);
                    }
                }
            ]
        });
    }, [
        dismissFlag,
        formatMessage,
        setSelectedIssueKey,
        showFlag
    ]);
};

});
parcelRegister("hIxFu", function(module, exports) {

$parcel$export(module.exports, "isModifiedEvent", () => $b3eda05a90faeae0$export$642c6f14f6d4bbd5);
const $b3eda05a90faeae0$export$642c6f14f6d4bbd5 = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

});

parcelRegister("jb0p7", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d4475055050609$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $82d4475055050609$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createSuccessFlagTitle: {
        "id": "business-issue-create.controllers.show-create-success-flag.create-success-flag-title",
        "defaultMessage": "You've created issue \"{issueKey}\""
    },
    viewIssueLinkText: {
        "id": "business-issue-create.controllers.show-create-success-flag.view-issue-link-text",
        "defaultMessage": "View issue"
    },
    createSuccessFlagTitleIssueTermRefresh: {
        "id": "business-issue-create.controllers.show-create-success-flag.create-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created issue \"{issueKey}\""
    },
    viewIssueLinkTextIssueTermRefresh: {
        "id": "business-issue-create.controllers.show-create-success-flag.view-issue-link-text-issue-term-refresh",
        "defaultMessage": "View issue"
    }
});

});


parcelRegister("9Y2JR", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd43750acdd7824c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bd43750acdd7824c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorFlagTitle: {
        "id": "business-issue-create.controllers.create-issue.error-flag-title",
        "defaultMessage": "We weren't able to create an issue"
    },
    errorFlagDescription: {
        "id": "business-issue-create.controllers.create-issue.error-flag-description",
        "defaultMessage": "Refresh the page and try again."
    },
    errorFlagTitleIssueTermRefresh: {
        "id": "business-issue-create.controllers.create-issue.error-flag-title-issue-term-refresh",
        "defaultMessage": "We weren't able to create an issue"
    }
});

});


parcelRegister("frfm9", function(module, exports) {

$parcel$export(module.exports, "useCreateParamHandler", () => $6b54e991d48bd90a$export$294bf5b0ba86140);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $lB25E = parcelRequire("lB25E");

var $auegK = parcelRequire("auegK");
const $6b54e991d48bd90a$export$294bf5b0ba86140 = ()=>{
    const [inlineCreateParam, setInlineCreateParam] = (0, $lB25E.useQueryParam)((0, $jGcn0.INLINE_CREATE_PARAM));
    const showCreateIssueDialog = (0, $auegK.useCreateIssueDialog)();
    const project = (0, $kQAZu.useProject)();
    (0, $eUqFw.useEffect)(()=>{
        if (inlineCreateParam != null) {
            showCreateIssueDialog({
                projectId: String(project.id)
            }).catch(()=>{
            // we don't care about the error in this scenario
            });
            setInlineCreateParam(undefined);
        }
    }, [
        inlineCreateParam,
        project,
        setInlineCreateParam,
        showCreateIssueDialog
    ]);
};

});


parcelRegister("ib4WI", function(module, exports) {

$parcel$export(module.exports, "COLUMN_FIXED_WIDTH", () => $f265285bd2aea130$export$fb45fce6dbb30982);
$parcel$export(module.exports, "GAP_BETWEEN_COLUMNS", () => $f265285bd2aea130$export$e4e941da6bdb3c31);
$parcel$export(module.exports, "CARD_DND_TYPE", () => $f265285bd2aea130$export$b05303cbde3e8c8c);
$parcel$export(module.exports, "COLUMN_DND_TYPE", () => $f265285bd2aea130$export$57d0ef745f304b91);
$parcel$export(module.exports, "BASE_FIELDS", () => $f265285bd2aea130$export$527474bbf19f45e4);
$parcel$export(module.exports, "MAX_ISSUE_TYPES_COUNT", () => $f265285bd2aea130$export$1778b00a1b1bdb85);
$parcel$export(module.exports, "EMPTY_FILTER_VALUE", () => $f265285bd2aea130$export$9ebaf9fe814731d3);
$parcel$export(module.exports, "VIEW_EXPERIENCE", () => $f265285bd2aea130$export$4a2289be55388ee6);
$parcel$export(module.exports, "CARD_ACTION_DELETE_EXPERIENCE", () => $f265285bd2aea130$export$647c9f579a340457);
$parcel$export(module.exports, "LOAD_EXTENDED_BOARD_DATA_EXPERIENCE", () => $f265285bd2aea130$export$a105429a905474b9);
$parcel$export(module.exports, "LOAD_SUBTASKS_EXPERIENCE", () => $f265285bd2aea130$export$96ecda7ef7336f1b);
$parcel$export(module.exports, "COLUMN_ACTION_RENAME_EXPERIENCE", () => $f265285bd2aea130$export$a2dd7e77ac9433fa);
$parcel$export(module.exports, "COLUMN_ACTION_ADD_EXPERIENCE", () => $f265285bd2aea130$export$ac8265dd2cdaac92);
$parcel$export(module.exports, "COLUMN_ACTION_DELETE_EXPERIENCE", () => $f265285bd2aea130$export$4813f2d5e485cf28);
$parcel$export(module.exports, "NULL_GROUP_KEY", () => $f265285bd2aea130$export$947ad1d92ba954ec);
$parcel$export(module.exports, "OTHER", () => $f265285bd2aea130$export$d46a05f8561f868a);
$parcel$export(module.exports, "BOARD_FIELD_CATEGORY", () => $f265285bd2aea130$export$65fb8d4fddcb3db6);
$parcel$export(module.exports, "BOARD_FIELD_COMPONENTS", () => $f265285bd2aea130$export$c48edb33483d0062);
$parcel$export(module.exports, "BOARD_FIELD_CONFLUENCE_PAGES_COUNT", () => $f265285bd2aea130$export$5f51001602e4f639);
$parcel$export(module.exports, "BOARD_FIELD_DATE", () => $f265285bd2aea130$export$638505006ae9ba93);
$parcel$export(module.exports, "BOARD_FIELD_DATE_TIME", () => $f265285bd2aea130$export$465f5a7204a3dffc);
$parcel$export(module.exports, "BOARD_FIELD_FLOAT", () => $f265285bd2aea130$export$183b99b9ca85ddaa);
$parcel$export(module.exports, "BOARD_FIELD_ISSUE_LINKS_COUNT", () => $f265285bd2aea130$export$9b9930ab0e532c29);
$parcel$export(module.exports, "BOARD_FIELD_ISSUE_TYPE", () => $f265285bd2aea130$export$928ca8ef7db2c7ce);
$parcel$export(module.exports, "BOARD_FIELD_LABEL", () => $f265285bd2aea130$export$4709bd5a74152ae7);
$parcel$export(module.exports, "BOARD_FIELD_MULTI_USER", () => $f265285bd2aea130$export$2c7d7c1c0024ef92);
$parcel$export(module.exports, "BOARD_FIELD_PARENT", () => $f265285bd2aea130$export$d2edf947f6b61359);
$parcel$export(module.exports, "BOARD_FIELD_PRIORITY", () => $f265285bd2aea130$export$eb7c8ce7565d664);
$parcel$export(module.exports, "BOARD_FIELD_SELECT", () => $f265285bd2aea130$export$96d1ec764b4e2f60);
$parcel$export(module.exports, "BOARD_FIELD_STATUS", () => $f265285bd2aea130$export$ad56e5948f48da2c);
$parcel$export(module.exports, "BOARD_FIELD_STORY_POINTS", () => $f265285bd2aea130$export$d2eed83c3ed9ab1d);
$parcel$export(module.exports, "BOARD_FIELD_TEXT", () => $f265285bd2aea130$export$69cbdb5b06ddf32d);
$parcel$export(module.exports, "BOARD_FIELD_TIME_ORIGINAL_ESTIMATE", () => $f265285bd2aea130$export$66de7ee82b097a84);
$parcel$export(module.exports, "BOARD_FIELD_USER", () => $f265285bd2aea130$export$f3e4cc1059d02f6f);
$parcel$export(module.exports, "ASSIGNEE_ID", () => $f265285bd2aea130$export$9059d5c1244fee75);
$parcel$export(module.exports, "CATEGORY_ID", () => $f265285bd2aea130$export$f7c25c2b1222ecd7);
$parcel$export(module.exports, "COMPONENT_ID", () => $f265285bd2aea130$export$723ee4d7411b97b4);
$parcel$export(module.exports, "DUE_DATE_ID", () => $f265285bd2aea130$export$876c8bd8ab9d799b);
$parcel$export(module.exports, "ISSUE_KEY_ID", () => $f265285bd2aea130$export$461d491d7fb1ef7c);
$parcel$export(module.exports, "ISSUE_TYPE_ID", () => $f265285bd2aea130$export$1612a59f1be6d6f3);
$parcel$export(module.exports, "LABEL_ID", () => $f265285bd2aea130$export$4db2521ab6aa047);
$parcel$export(module.exports, "PARENT_ID", () => $f265285bd2aea130$export$3af4d9a28905196d);
$parcel$export(module.exports, "PRIORITY_ID", () => $f265285bd2aea130$export$45ce44d95b47db60);
$parcel$export(module.exports, "RANK_ID", () => $f265285bd2aea130$export$21420526762ffb8);
$parcel$export(module.exports, "STATUS_ID", () => $f265285bd2aea130$export$fac746c9db478fd8);
$parcel$export(module.exports, "SUMMARY_ID", () => $f265285bd2aea130$export$8cadcb0dac4af55);
$parcel$export(module.exports, "CARD_COVER_MEDIA_READ_TOKEN_DURATION", () => $f265285bd2aea130$export$58bbde0bd11b3269);
$parcel$export(module.exports, "CARD_COVER_MEDIA_READ_TOKEN_MAX_LENGTH", () => $f265285bd2aea130$export$c9056a07d77f30a8);
$parcel$export(module.exports, "TEMPORARY_STATUS_ID", () => $f265285bd2aea130$export$9301910120a61d41);

var $lO4Or = parcelRequire("lO4Or");
const $f265285bd2aea130$export$42310dd57a41067 = {
    collapsedStickyHeaders: 2,
    stickyHeaders: 4
};
const $f265285bd2aea130$export$5390a88bb80e075f = 200;
const $f265285bd2aea130$export$836c3f1e10326a68 = 40;
const $f265285bd2aea130$export$fb45fce6dbb30982 = 270;
const $f265285bd2aea130$export$ad065eea37c8234b = 48;
const $f265285bd2aea130$export$e4e941da6bdb3c31 = 12;
const $f265285bd2aea130$export$68cfa75d03564799 = 90;
const $f265285bd2aea130$export$b05303cbde3e8c8c = 'CARD';
const $f265285bd2aea130$export$57d0ef745f304b91 = 'COLUMN';
const $f265285bd2aea130$export$527474bbf19f45e4 = [
    'key',
    'type',
    'dueDate',
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.SUMMARY_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.DUE_DATE_TYPE),
    (0, $lO4Or.SUBTASKS_TYPE),
    (0, $lO4Or.PRIORITY_TYPE)
];
const $f265285bd2aea130$export$1778b00a1b1bdb85 = 25;
const $f265285bd2aea130$export$9ebaf9fe814731d3 = null;
const $f265285bd2aea130$export$4a2289be55388ee6 = {
    experience: 'viewBoard',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$647c9f579a340457 = {
    experience: 'cardActionDelete',
    experienceId: 'cardActionDelete',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$a105429a905474b9 = {
    experience: 'loadExtendedBoardData',
    experienceId: 'loadExtendedBoardData',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$96ecda7ef7336f1b = {
    experience: 'loadSubtasks',
    experienceId: 'loadSubtasks',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$a2dd7e77ac9433fa = {
    experience: 'columnActionRename',
    experienceId: 'columnActionRename',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$ac8265dd2cdaac92 = {
    experience: 'columnActionAdd',
    experienceId: 'columnActionAdd',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$4813f2d5e485cf28 = {
    experience: 'columnActionDelete',
    experienceId: 'columnActionDelete',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$947ad1d92ba954ec = 'null_pivot';
const $f265285bd2aea130$export$d46a05f8561f868a = 'other';
const $f265285bd2aea130$export$65fb8d4fddcb3db6 = 'BOARD_FIELD_CATEGORY';
const $f265285bd2aea130$export$c48edb33483d0062 = 'BOARD_FIELD_COMPONENTS';
const $f265285bd2aea130$export$5f51001602e4f639 = 'BOARD_FIELD_CONFLUENCE_PAGES_COUNT';
const $f265285bd2aea130$export$638505006ae9ba93 = 'BOARD_FIELD_DATE';
const $f265285bd2aea130$export$465f5a7204a3dffc = 'BOARD_FIELD_DATE_TIME';
const $f265285bd2aea130$export$183b99b9ca85ddaa = 'BOARD_FIELD_FLOAT';
const $f265285bd2aea130$export$9b9930ab0e532c29 = 'BOARD_FIELD_ISSUE_LINKS_COUNT';
const $f265285bd2aea130$export$928ca8ef7db2c7ce = 'BOARD_FIELD_ISSUE_TYPE';
const $f265285bd2aea130$export$4709bd5a74152ae7 = 'BOARD_FIELD_LABEL';
const $f265285bd2aea130$export$2c7d7c1c0024ef92 = 'BOARD_FIELD_MULTI_USER';
const $f265285bd2aea130$export$d2edf947f6b61359 = 'BOARD_FIELD_PARENT';
const $f265285bd2aea130$export$eb7c8ce7565d664 = 'BOARD_FIELD_PRIORITY';
const $f265285bd2aea130$export$96d1ec764b4e2f60 = 'BOARD_FIELD_SELECT';
const $f265285bd2aea130$export$ad56e5948f48da2c = 'BOARD_FIELD_STATUS';
const $f265285bd2aea130$export$d2eed83c3ed9ab1d = 'BOARD_FIELD_STORY_POINTS';
const $f265285bd2aea130$export$69cbdb5b06ddf32d = 'BOARD_FIELD_TEXT';
const $f265285bd2aea130$export$66de7ee82b097a84 = 'BOARD_FIELD_TIME_ORIGINAL_ESTIMATE';
const $f265285bd2aea130$export$f3e4cc1059d02f6f = 'BOARD_FIELD_USER';
const $f265285bd2aea130$export$9059d5c1244fee75 = (0, $lO4Or.ASSIGNEE_TYPE);
const $f265285bd2aea130$export$f7c25c2b1222ecd7 = 'category';
const $f265285bd2aea130$export$723ee4d7411b97b4 = (0, $lO4Or.COMPONENTS_TYPE);
const $f265285bd2aea130$export$876c8bd8ab9d799b = (0, $lO4Or.DUE_DATE_TYPE);
const $f265285bd2aea130$export$461d491d7fb1ef7c = (0, $lO4Or.ISSUE_KEY_TYPE);
const $f265285bd2aea130$export$1612a59f1be6d6f3 = (0, $lO4Or.ISSUE_TYPE);
const $f265285bd2aea130$export$4db2521ab6aa047 = (0, $lO4Or.LABELS_TYPE);
const $f265285bd2aea130$export$3af4d9a28905196d = (0, $lO4Or.PARENT_TYPE);
const $f265285bd2aea130$export$45ce44d95b47db60 = (0, $lO4Or.PRIORITY_TYPE);
const $f265285bd2aea130$export$21420526762ffb8 = 'rank';
const $f265285bd2aea130$export$fac746c9db478fd8 = (0, $lO4Or.STATUS_TYPE);
const $f265285bd2aea130$export$8cadcb0dac4af55 = (0, $lO4Or.SUMMARY_TYPE);
const $f265285bd2aea130$export$58bbde0bd11b3269 = 900;
const $f265285bd2aea130$export$c9056a07d77f30a8 = 65534;
const $f265285bd2aea130$export$9301910120a61d41 = 42;

});

parcelRegister("bFk6h", function(module, exports) {

$parcel$export(module.exports, "BoardDataProvider", () => $7c4b861c11ae769d$export$56f1728b5dbbcb33);
$parcel$export(module.exports, "useBoardData", () => $7c4b861c11ae769d$export$35c54b081e81928);

var $eUqFw = parcelRequire("eUqFw");

var $iVIEg = parcelRequire("iVIEg");

var $499dl = parcelRequire("499dl");

var $kQAZu = parcelRequire("kQAZu");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $cOkcY = parcelRequire("cOkcY");

var $ib4WI = parcelRequire("ib4WI");

var $1rVdL = parcelRequire("1rVdL");

var $dtXTv = parcelRequire("dtXTv");

var $d1mZL = parcelRequire("d1mZL");

var $aeiY7 = parcelRequire("aeiY7");

var $lgmYa = parcelRequire("lgmYa");

var $5FsEp = parcelRequire("5FsEp");

var $iq40z = parcelRequire("iq40z");

var $7x9tw = parcelRequire("7x9tw");
const $7c4b861c11ae769d$var$FETCH_FAILED_FLAG_ID = 'FETCH_BOARD_DATA_FAILED';
const $7c4b861c11ae769d$var$getActiveWorkflow = (workflows, activeWorkflowId)=>{
    const activeWorkflow = workflows.find((workflow)=>workflow.workflowId === activeWorkflowId) ?? workflows[0];
    return activeWorkflow;
};
const $7c4b861c11ae769d$var$Context = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $7c4b861c11ae769d$export$56f1728b5dbbcb33 = ({ children: children })=>{
    const { data: data, loading: isWorkflowLoading, error: error } = (0, $cOkcY.useWorkflowIssues)();
    const project = (0, $kQAZu.useProject)();
    const { workflowIssuesLastChangedTime: workflowIssuesLastChangedTime } = (0, $iq40z.useWorkflowStoreState)();
    const { setFetchResponse: setFetchResponse } = (0, $iq40z.useWorkflowStoreActions)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const [activeWorkflowId] = (0, $7c3W1.useViewPreference)((0, $ji3xf.ACTIVE_WORKFLOW_PREFERENCE));
    const { setIssues: setIssues, reset: resetIssueStore } = (0, $dtXTv.useIssueStoreActions)();
    const refetchIssuesWithThrow = (0, $5FsEp.useRefetchIssuesWithThrow)();
    const fieldIds = (0, $lgmYa.useFieldIds)();
    const [initialized, setInitialized] = (0, $eUqFw.useState)(false);
    const fetchedFields = (0, $eUqFw.useRef)([]);
    const filterIssues = (0, $1rVdL.useFilter)();
    const { isLoading: isLoadingFilters } = (0, $1rVdL.useFilterStatus)();
    const allIssues = (0, $d1mZL.useIssues)();
    const filteredIssues = (0, $eUqFw.useMemo)(()=>{
        const withoutSubtasks = Array.from(allIssues.values()).filter((issue)=>issue.fields[0, $ib4WI.ISSUE_TYPE_ID].issueType.hierarchyLevel >= 0);
        const issues = filterIssues(withoutSubtasks);
        return (0, $aeiY7.sortIssuesBy)('rank', issues);
    }, [
        allIssues,
        filterIssues
    ]);
    const reset = (0, $eUqFw.useCallback)(()=>{
        resetIssueStore();
        setInitialized(false);
        fetchedFields.current = [];
    }, [
        resetIssueStore
    ]);
    const showErrorFlag = (0, $eUqFw.useCallback)(()=>{
        showFlag({
            id: $7c4b861c11ae769d$var$FETCH_FAILED_FLAG_ID,
            type: 'error',
            title: (0, $7x9tw.default).boardInitErrorTitle,
            description: (0, $7x9tw.default).boardInitErrorMessage
        });
    }, [
        showFlag
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!initialized) {
            if (data) {
                setInitialized(true);
                const activeWorkflowData = $7c4b861c11ae769d$var$getActiveWorkflow(data.workflows, activeWorkflowId);
                if (!activeWorkflowData) return;
                const mappedIssues = (0, $aeiY7.mapWorkflowIssuesToBoardIssues)(activeWorkflowData);
                setIssues(mappedIssues);
                setFetchResponse({
                    activeWorkflow: activeWorkflowData,
                    workflows: data.workflows,
                    workflowIssuesLastChangedTime: data.lastChangedTime || undefined
                });
            } else if (error) {
                setInitialized(true);
                showErrorFlag();
            }
        }
    }, [
        activeWorkflowId,
        data,
        error,
        initialized,
        setFetchResponse,
        setIssues,
        showErrorFlag
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // if there are additional fields required to be fetched, refetch the issues
        if (initialized && !isLoadingFilters && fieldIds.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(fieldIds, fetchedFields.current).length > 0) {
            fetchedFields.current = fieldIds;
            refetchIssuesWithThrow(Array.from(allIssues.keys())).catch(showErrorFlag);
        }
    }, [
        fieldIds,
        initialized,
        isLoadingFilters,
        allIssues,
        refetchIssuesWithThrow,
        showErrorFlag
    ]);
    const refetch = (0, $eUqFw.useCallback)(async ()=>{
        try {
            const response = await (0, $499dl.fetchWorkflowIssues)(project.key, workflowIssuesLastChangedTime);
            const activeWorkflowData = $7c4b861c11ae769d$var$getActiveWorkflow(response.workflows, activeWorkflowId);
            if (!activeWorkflowData) return;
            await refetchIssuesWithThrow(activeWorkflowData.issues.map((issue)=>issue.id));
            setFetchResponse({
                activeWorkflow: activeWorkflowData,
                workflows: response.workflows,
                workflowIssuesLastChangedTime: response.lastChangedTime || undefined
            });
            dismissFlag($7c4b861c11ae769d$var$FETCH_FAILED_FLAG_ID);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (refetchError) {
            if (refetchError instanceof (0, $499dl.Unchanged)) {
                dismissFlag($7c4b861c11ae769d$var$FETCH_FAILED_FLAG_ID);
                return;
            }
            (0, $guiFP.default)({
                meta: {
                    id: 'refetchBoardData',
                    packageName: 'jiraWorkManagementBoard',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to refetch workflow issues data'
                },
                error: refetchError,
                sendToPrivacyUnsafeSplunk: true
            });
            showErrorFlag();
        }
    }, [
        project.key,
        workflowIssuesLastChangedTime,
        activeWorkflowId,
        refetchIssuesWithThrow,
        setFetchResponse,
        dismissFlag,
        showErrorFlag
    ]);
    // only mark as loading when the page initialises but not when applying filters thereafter
    const [loading, setLoading] = (0, $eUqFw.useState)(isWorkflowLoading || isLoadingFilters);
    (0, $eUqFw.useEffect)(()=>{
        if (loading && !isWorkflowLoading && !isLoadingFilters) setLoading(false);
    }, [
        loading,
        isWorkflowLoading,
        isLoadingFilters
    ]);
    const value = (0, $eUqFw.useMemo)(()=>({
            filteredIssues: filteredIssues,
            refetch: refetch,
            reset: reset,
            loading: loading,
            error: error
        }), [
        filteredIssues,
        refetch,
        reset,
        error,
        loading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c4b861c11ae769d$var$Context.Provider, {
        value: value
    }, children);
};
const $7c4b861c11ae769d$export$35c54b081e81928 = ()=>{
    const context = (0, $eUqFw.useContext)($7c4b861c11ae769d$var$Context);
    if (!context) throw new Error('useInitializeBoard must be used within a BoardDataProvider');
    return context;
};

});
parcelRegister("1rVdL", function(module, exports) {

$parcel$export(module.exports, "useFilterFieldIds", () => $4f8aeeea5d5879e1$export$db2c52178fd751e7);
$parcel$export(module.exports, "useFilterStatus", () => $4f8aeeea5d5879e1$export$66de9151ffa1198a);
$parcel$export(module.exports, "useFilter", () => $4f8aeeea5d5879e1$export$3274cf84b703fff);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $hTLlD = parcelRequire("hTLlD");

var $e4qlg = parcelRequire("e4qlg");

var $fvzkg = parcelRequire("fvzkg");

var $lEWmB = parcelRequire("lEWmB");

var $9GlEj = parcelRequire("9GlEj");

var $96etS = parcelRequire("96etS");

var $d3C6e = parcelRequire("d3C6e");

var $eI5EY = parcelRequire("eI5EY");

var $kMmsu = parcelRequire("kMmsu");

var $gd0Sp = parcelRequire("gd0Sp");

var $ib4WI = parcelRequire("ib4WI");

var $fUxR1 = parcelRequire("fUxR1");
const $4f8aeeea5d5879e1$var$filterByExtendedFields = (issue, expandedFilters)=>expandedFilters.every((filter)=>{
        // handle parent field filter separately as it searches in two fields parent and issue key
        if (filter.fieldKey === (0, $ib4WI.PARENT_ID) && (0, $eI5EY.fg)('jwm_board_implement_parent_filter')) return (0, $fUxR1.filterByParent)(filter, issue.fields);
        const issueField = issue.fields[filter.fieldKey];
        if (issueField == null) return filter.hasEmptyFilter;
        switch(issueField.type){
            case 0, $ib4WI.BOARD_FIELD_CATEGORY:
                return (0, $fUxR1.filterByCategory)(filter, issueField);
            case 0, $ib4WI.BOARD_FIELD_COMPONENTS:
                return (0, $fUxR1.filterByComponents)(filter, issueField);
            case 0, $ib4WI.BOARD_FIELD_ISSUE_TYPE:
                return (0, $fUxR1.filterByIssueType)(filter, issueField);
            case 0, $ib4WI.BOARD_FIELD_LABEL:
                return (0, $fUxR1.filterByLabels)(filter, issueField);
            case 0, $ib4WI.BOARD_FIELD_PRIORITY:
                return (0, $fUxR1.filterByPriority)(filter, issueField);
            case 0, $ib4WI.BOARD_FIELD_SELECT:
                return (0, $fUxR1.filterBySelect)(filter, issueField);
            case 0, $ib4WI.BOARD_FIELD_STATUS:
                return (0, $fUxR1.filterByStatus)(filter, issueField);
            case 0, $ib4WI.BOARD_FIELD_USER:
                return (0, $fUxR1.filterByUser)(filter, issueField);
            case 0, $ib4WI.BOARD_FIELD_MULTI_USER:
                return (0, $fUxR1.filterByMultiUser)(filter, issueField);
            default:
                return false;
        }
    });
const $4f8aeeea5d5879e1$var$filterIssues = (filters, issues, fields)=>{
    const expandedFilters = (0, $fUxR1.getExpandedFilters)(filters, fields);
    return issues.filter((issue)=>(0, $d3C6e.isOptimisticIssue)(issue.id) || $4f8aeeea5d5879e1$var$filterByExtendedFields(issue, expandedFilters));
};
const $4f8aeeea5d5879e1$var$quickFilterIssues = (quickFilters, issues, atlassianAccountId)=>{
    let results = issues;
    if (quickFilters.ASSIGNED_TO_ME && atlassianAccountId != null) results = (0, $fUxR1.isAssignedToMe)(results, atlassianAccountId);
    if (quickFilters.DUE_THIS_WEEK) results = (0, $fUxR1.isDueThisWeek)(results);
    return results;
};
const $4f8aeeea5d5879e1$var$EMPTY_FIELD_IDS = [];
const $4f8aeeea5d5879e1$export$db2c52178fd751e7 = ()=>{
    const { data: fields } = (0, $kMmsu.useFieldsResource)();
    const { data: categoryField } = (0, $e4qlg.useCategoryField)();
    const { filters: filters } = (0, $fvzkg.useDeserialisedFilters)();
    return (0, $eUqFw.useMemo)(()=>filters != null && fields != null ? Object.keys(filters).map((fieldKeyFromFilter)=>(0, $fUxR1.jqlTermToFieldId)(fieldKeyFromFilter, fields, categoryField)).filter(Boolean) : $4f8aeeea5d5879e1$var$EMPTY_FIELD_IDS, [
        categoryField,
        fields,
        filters
    ]);
};
const $4f8aeeea5d5879e1$export$66de9151ffa1198a = ()=>{
    const { loading: fieldsLoading } = (0, $kMmsu.useFieldsResource)();
    const { jql: jql } = (0, $lEWmB.useFilters)();
    const { quickFilters: quickFilters } = (0, $9GlEj.useQuickFilters)();
    const [simpleSearch] = (0, $96etS.useSimpleSearch)();
    const { isLoading: isDeserializingFilters } = (0, $fvzkg.useDeserialisedFilters)();
    const isFiltering = !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(jql) || quickFilters.ASSIGNED_TO_ME || quickFilters.DUE_THIS_WEEK || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(simpleSearch);
    return {
        isLoading: isFiltering && (Boolean(isDeserializingFilters) || fieldsLoading),
        isFiltering: isFiltering
    };
};
const $4f8aeeea5d5879e1$var$useMemoizedFiltersDependencies = (simpleSearch, filters, quickFilters)=>{
    const ref = (0, $eUqFw.useRef)({
        simpleSearch: simpleSearch,
        filters: filters,
        quickFilters: quickFilters
    });
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(ref.current, {
        simpleSearch: simpleSearch,
        filters: filters,
        quickFilters: quickFilters
    })) ref.current = {
        simpleSearch: simpleSearch,
        filters: filters,
        quickFilters: quickFilters
    };
    return ref.current;
};
const $4f8aeeea5d5879e1$export$3274cf84b703fff = ()=>{
    const { data: fields } = (0, $kMmsu.useFieldsResource)();
    const { quickFilters: quickFilters } = (0, $9GlEj.useQuickFilters)();
    const [simpleSearch] = (0, $96etS.useSimpleSearch)();
    const { filters: filters } = (0, $fvzkg.useDeserialisedFilters)();
    const { atlassianAccountId: atlassianAccountId } = (0, $gd0Sp.useTenantContext)();
    // these dependencies are memoized with deep equality comparison because they are not stable
    const filtersDependencies = $4f8aeeea5d5879e1$var$useMemoizedFiltersDependencies(simpleSearch, filters, quickFilters);
    const filter = (0, $eUqFw.useCallback)((issues)=>{
        // we always want to filter issues with text search
        const results = (0, $fUxR1.filterIssuesByText)(issues, filtersDependencies.simpleSearch);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filtersDependencies.filters)) return $4f8aeeea5d5879e1$var$filterIssues(filtersDependencies.filters, results, fields);
        return $4f8aeeea5d5879e1$var$quickFilterIssues(filtersDependencies.quickFilters, results, atlassianAccountId);
    }, [
        filtersDependencies,
        fields,
        atlassianAccountId
    ]);
    return filter;
};

});
parcelRegister("fUxR1", function(module, exports) {

$parcel$export(module.exports, "isAssignedToMe", () => $7c8f1d8205fe2b16$export$e87389f48a5305be);
$parcel$export(module.exports, "isDueThisWeek", () => $7c8f1d8205fe2b16$export$ff3ea4cb53c4a28);
$parcel$export(module.exports, "filterIssuesByText", () => $7c8f1d8205fe2b16$export$c0fbf20bc94589ef);
$parcel$export(module.exports, "jqlTermToFieldId", () => $7c8f1d8205fe2b16$export$f8fe768269c955c0);
$parcel$export(module.exports, "getExpandedFilters", () => $7c8f1d8205fe2b16$export$eb6a39f031848a63);
$parcel$export(module.exports, "filterByCategory", () => $7c8f1d8205fe2b16$export$6d1731a321e8bdf4);
$parcel$export(module.exports, "filterByComponents", () => $7c8f1d8205fe2b16$export$3f1c0440e368606f);
$parcel$export(module.exports, "filterByIssueType", () => $7c8f1d8205fe2b16$export$f836023a765b3b9f);
$parcel$export(module.exports, "filterByLabels", () => $7c8f1d8205fe2b16$export$d226d89b96788bab);
$parcel$export(module.exports, "filterByPriority", () => $7c8f1d8205fe2b16$export$710b0eb282166a50);
$parcel$export(module.exports, "filterBySelect", () => $7c8f1d8205fe2b16$export$d8a8627f7157d954);
$parcel$export(module.exports, "filterByStatus", () => $7c8f1d8205fe2b16$export$1caf81d27b0e4d0e);
$parcel$export(module.exports, "filterByUser", () => $7c8f1d8205fe2b16$export$20a671e3b06cc1b5);
$parcel$export(module.exports, "filterByMultiUser", () => $7c8f1d8205fe2b16$export$862615c6ba36b321);
$parcel$export(module.exports, "filterByParent", () => $7c8f1d8205fe2b16$export$20017115067fd3ed);

var $illlw = parcelRequire("illlw");

var $ellIm = parcelRequire("ellIm");

var $d3C6e = parcelRequire("d3C6e");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");
const $7c8f1d8205fe2b16$export$e87389f48a5305be = (issues, atlassianAccountId)=>issues.filter(({ id: id, fields: fields })=>(0, $d3C6e.isOptimisticIssue)(id) || fields[0, $ib4WI.ASSIGNEE_ID]?.user.accountId === atlassianAccountId);
const $7c8f1d8205fe2b16$export$ff3ea4cb53c4a28 = (issues)=>issues.filter((issue)=>{
        if ((0, $d3C6e.isOptimisticIssue)(issue.id)) return true;
        if (!issue.fields[0, $ib4WI.DUE_DATE_ID]) return false;
        const dueDate = new Date(issue.fields[0, $ib4WI.DUE_DATE_ID].value);
        const today = new Date();
        return (0, $ellIm.default)(dueDate, today);
    });
const $7c8f1d8205fe2b16$export$c0fbf20bc94589ef = (issues, searchText)=>{
    if (searchText != null && searchText.trim() !== '') {
        const trimmedSearchTextInLowerCase = searchText.trim().toLowerCase();
        return issues.filter(({ id: id, fields: fields })=>(0, $d3C6e.isOptimisticIssue)(id) || fields[0, $ib4WI.SUMMARY_ID].value.toLowerCase().includes(trimmedSearchTextInLowerCase) || fields[0, $ib4WI.ASSIGNEE_ID]?.user.name?.toLowerCase().includes(trimmedSearchTextInLowerCase) || fields[0, $ib4WI.ISSUE_KEY_ID].value.toLowerCase().includes(trimmedSearchTextInLowerCase));
    }
    return issues;
};
const $7c8f1d8205fe2b16$export$f8fe768269c955c0 = (jqlTerm, fields, categoryField)=>{
    const field = fields.find((f)=>f.jqlTerm === jqlTerm);
    if (field?.type === (0, $lO4Or.CATEGORY_TYPE)) return categoryField?.id ?? null;
    if (field?.type === (0, $lO4Or.COMPONENTS_TYPE)) return 0, $lO4Or.COMPONENTS_TYPE;
    if (field?.type === (0, $lO4Or.ISSUE_TYPE)) return 0, $lO4Or.ISSUE_TYPE;
    return jqlTerm;
};
const $7c8f1d8205fe2b16$var$jqlTermToIssueFieldKey = (jqlTerm, fields)=>{
    const field = fields?.find((f)=>f.jqlTerm === jqlTerm);
    if (field?.type === (0, $lO4Or.CATEGORY_TYPE)) return 0, $ib4WI.CATEGORY_ID;
    if (field?.type === (0, $lO4Or.COMPONENTS_TYPE)) return 0, $ib4WI.COMPONENT_ID;
    return field?.type ?? jqlTerm;
};
const $7c8f1d8205fe2b16$var$getFilterValues = (filterValueForExtendedField, valueProperty)=>new Set(filterValueForExtendedField.map((filterValue)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(filterValue, valueProperty, null)));
const $7c8f1d8205fe2b16$var$isSelectOption = (filterValue)=>Array.isArray(filterValue) && filterValue.length > 0 && 'value' in filterValue[0];
const $7c8f1d8205fe2b16$var$FILTER_VALUE_PROPERTY = {
    type: 'id',
    issuetype: 'id',
    priority: 'label',
    status: 'label'
};
const $7c8f1d8205fe2b16$export$eb6a39f031848a63 = (filters, fields)=>Object.entries(filters).map(([jqlTerm, filterValue])=>{
        const filterValues = $7c8f1d8205fe2b16$var$isSelectOption(filterValue) ? $7c8f1d8205fe2b16$var$getFilterValues(filterValue, $7c8f1d8205fe2b16$var$FILTER_VALUE_PROPERTY[jqlTerm] ?? 'value') : new Set();
        return {
            jqlTerm: jqlTerm,
            fieldKey: $7c8f1d8205fe2b16$var$jqlTermToIssueFieldKey(jqlTerm, fields),
            filterValues: filterValues,
            hasEmptyFilter: filterValues.has((0, $ib4WI.EMPTY_FILTER_VALUE))
        };
    });
const $7c8f1d8205fe2b16$export$6d1731a321e8bdf4 = (filter, field)=>{
    const category = field.category?.name;
    return filter.filterValues.has(category ?? '') || filter.hasEmptyFilter && !category;
};
const $7c8f1d8205fe2b16$export$3f1c0440e368606f = (filter, field)=>{
    const components = field.value;
    return Array.isArray(components) && (components.some((component)=>filter.filterValues.has(component)) || filter.hasEmptyFilter && !components.length);
};
const $7c8f1d8205fe2b16$export$f836023a765b3b9f = (filter, field)=>{
    const issueTypeId = field.issueType.id;
    return filter.filterValues.has(issueTypeId);
};
const $7c8f1d8205fe2b16$export$d226d89b96788bab = (filter, field)=>{
    const labels = field.value;
    return Array.isArray(labels) && (labels.some((label)=>filter.filterValues.has(label)) || filter.hasEmptyFilter && !labels.length);
};
const $7c8f1d8205fe2b16$export$710b0eb282166a50 = (filter, field)=>{
    const priorityName = field.priority.name;
    return filter.filterValues.has(priorityName);
};
const $7c8f1d8205fe2b16$export$d8a8627f7157d954 = (filter, field)=>{
    const selectedValues = field.value;
    return Array.isArray(selectedValues) && (selectedValues.some((selectedValue)=>filter.filterValues.has(selectedValue)) || filter.hasEmptyFilter && !selectedValues.length);
};
const $7c8f1d8205fe2b16$export$1caf81d27b0e4d0e = (filter, field)=>{
    const statusName = field.status.name;
    return filter.filterValues.has(statusName);
};
const $7c8f1d8205fe2b16$export$20a671e3b06cc1b5 = (filter, field)=>{
    const user = field.user.accountId;
    return filter.filterValues.has(user);
};
const $7c8f1d8205fe2b16$export$862615c6ba36b321 = (filter, field)=>{
    const users = field.users.map((user)=>user.accountId);
    return Array.isArray(users) && (users.some((user)=>filter.filterValues.has(user)) || filter.hasEmptyFilter && !users.length);
};
const $7c8f1d8205fe2b16$export$20017115067fd3ed = (filter, issueFields)=>{
    const issueKey = issueFields[0, $ib4WI.ISSUE_KEY_ID].value;
    const parentKey = issueFields[0, $ib4WI.PARENT_ID]?.parent?.key ?? null;
    return filter.filterValues.has(parentKey) || filter.filterValues.has(issueKey);
};

});


parcelRegister("dtXTv", function(module, exports) {

$parcel$export(module.exports, "IssueStoreContainer", () => $aa874c967cb6aed7$export$2f0bbf62c1aadb30);
$parcel$export(module.exports, "Store", () => $aa874c967cb6aed7$export$390f32400eaf98c9);
$parcel$export(module.exports, "useIssueStoreActions", () => $aa874c967cb6aed7$export$20586bb841d52702);

var $lskA1 = parcelRequire("lskA1");

var $WBLbN = parcelRequire("WBLbN");

var $ib4WI = parcelRequire("ib4WI");
const $aa874c967cb6aed7$var$initialState = {
    issues: new Map()
};
const $aa874c967cb6aed7$export$2f0bbf62c1aadb30 = (0, $WBLbN.createContainer)();
const $aa874c967cb6aed7$export$390f32400eaf98c9 = (0, $WBLbN.createStore)({
    containedBy: $aa874c967cb6aed7$export$2f0bbf62c1aadb30,
    initialState: $aa874c967cb6aed7$var$initialState,
    actions: {
        setIssues: (issues)=>({ setState: setState, getState: getState })=>{
                const issueMap = new Map(getState().issues);
                issues.forEach((issue)=>{
                    issueMap.set(issue.id, issue);
                });
                setState({
                    issues: issueMap
                });
            },
        updateIssueFields: ({ issueId: issueId, fields: fields, rank: rank })=>({ setState: setState, getState: getState })=>{
                const fieldUpdates = {
                    ...fields
                };
                const issueMap = new Map(getState().issues);
                const issue = issueMap.get(issueId);
                if (issue == null) return;
                if (rank != null) {
                    const relativeIssue = issueMap.get(rank.relativeIssueId);
                    if (relativeIssue != null) {
                        const relativeIssueRank = relativeIssue.fields[0, $ib4WI.RANK_ID].value;
                        fieldUpdates[0, $ib4WI.RANK_ID] = {
                            fieldId: (0, $ib4WI.RANK_ID),
                            type: (0, $ib4WI.BOARD_FIELD_TEXT),
                            value: rank.position === 'before' ? (0, $lskA1.getPreviousRank)(relativeIssueRank) : (0, $lskA1.getNextRank)(relativeIssueRank)
                        };
                    }
                }
                if (Object.keys(fieldUpdates).length === 0) return;
                Object.entries(fieldUpdates).forEach(([fieldId, field])=>{
                    if (field == null) {
                        delete issue.fields[fieldId];
                        return;
                    }
                    issue.fields[fieldId] = field;
                });
                issueMap.set(issueId, issue);
                setState({
                    issues: issueMap
                });
            },
        reset: ()=>({ setState: setState })=>{
                setState($aa874c967cb6aed7$var$initialState);
            },
        removeIssues: (issueIds)=>({ setState: setState, getState: getState })=>{
                const issueMap = new Map(getState().issues);
                issueIds.forEach((issueId)=>{
                    issueMap.delete(issueId);
                });
                setState({
                    issues: issueMap
                });
            }
    }
});
const $aa874c967cb6aed7$export$5c02e8fb28d6ca6c = (0, $WBLbN.createStateHook)($aa874c967cb6aed7$export$390f32400eaf98c9);
const $aa874c967cb6aed7$export$20586bb841d52702 = (0, $WBLbN.createActionsHook)($aa874c967cb6aed7$export$390f32400eaf98c9);

});

parcelRegister("d1mZL", function(module, exports) {

$parcel$export(module.exports, "useIssueAssignees", () => $8b3b45f3a2264ad5$export$d3a21f46315fa5b8);
$parcel$export(module.exports, "useSubtasksByParentId", () => $8b3b45f3a2264ad5$export$48744da495950c6b);
$parcel$export(module.exports, "useIssues", () => $8b3b45f3a2264ad5$export$fdf0b908e72b6bef);

var $WBLbN = parcelRequire("WBLbN");

var $ib4WI = parcelRequire("ib4WI");

var $dtXTv = parcelRequire("dtXTv");
const $8b3b45f3a2264ad5$var$getAssigneesInIssues = (0, $WBLbN.createSelector)((state)=>state.issues, (issues)=>{
    const userMap = new Map();
    issues.forEach((issue)=>{
        if (issue.fields.assignee) {
            const user = issue.fields.assignee.user;
            userMap.set(user.accountId, user);
        }
    });
    return userMap;
});
const $8b3b45f3a2264ad5$export$d3a21f46315fa5b8 = (0, $WBLbN.createStateHook)((0, $dtXTv.Store), {
    selector: $8b3b45f3a2264ad5$var$getAssigneesInIssues
});
const $8b3b45f3a2264ad5$var$getSubtasksByParentId = (0, $WBLbN.createSelector)((state)=>state.issues, (_, props)=>props.parentId, (issues, parentId)=>Array.from(issues.values()).filter((issue)=>issue.fields[0, $ib4WI.PARENT_ID] && String(parentId) === issue.fields[0, $ib4WI.PARENT_ID].value));
const $8b3b45f3a2264ad5$export$48744da495950c6b = (0, $WBLbN.createStateHook)((0, $dtXTv.Store), {
    selector: $8b3b45f3a2264ad5$var$getSubtasksByParentId
});
const $8b3b45f3a2264ad5$var$getIssues = (0, $WBLbN.createSelector)((state)=>state.issues, (issues)=>issues);
const $8b3b45f3a2264ad5$export$fdf0b908e72b6bef = (0, $WBLbN.createStateHook)((0, $dtXTv.Store), {
    selector: $8b3b45f3a2264ad5$var$getIssues
});

});

parcelRegister("aeiY7", function(module, exports) {

$parcel$export(module.exports, "sortIssuesBy", () => $66bbee1348362b4c$export$6c4fd61382a93216);
$parcel$export(module.exports, "mapWorkflowIssuesToBoardIssues", () => $66bbee1348362b4c$export$fd35f0368f6a9a66);

var $8Qd0L = parcelRequire("8Qd0L");

var $ib4WI = parcelRequire("ib4WI");
const $66bbee1348362b4c$export$6c4fd61382a93216 = (fieldId, issues)=>{
    switch(fieldId){
        case 0, $ib4WI.RANK_ID:
            return issues.sort((a, b)=>{
                const aRank = a.fields[0, $ib4WI.RANK_ID]?.value || '';
                const bRank = b.fields[0, $ib4WI.RANK_ID]?.value || '';
                if (aRank < bRank) return -1;
                if (aRank > bRank) return 1;
                return 0;
            });
        default:
            return issues;
    }
};
const $66bbee1348362b4c$export$fd35f0368f6a9a66 = (workflow)=>{
    const statusMap = new Map(workflow.columns.map((column)=>[
            column.statusId,
            column
        ]));
    const issueTypesMap = new Map(workflow.issueTypes.map((issueType)=>[
            issueType.id,
            issueType
        ]));
    return workflow.issues.map((issue)=>{
        const status = statusMap.get(issue.statusId);
        const issueType = issueTypesMap.get(issue.issueTypeId);
        if (!status) throw new Error(`Status with id ${issue.statusId} not found`);
        if (!issueType) throw new Error(`Issue type with id ${issue.issueTypeId} not found`);
        const fields = {
            [(0, $ib4WI.RANK_ID)]: {
                fieldId: (0, $ib4WI.RANK_ID),
                type: (0, $ib4WI.BOARD_FIELD_TEXT),
                value: issue.rank
            },
            [(0, $ib4WI.SUMMARY_ID)]: {
                fieldId: (0, $ib4WI.SUMMARY_ID),
                type: (0, $ib4WI.BOARD_FIELD_TEXT),
                value: issue.summary
            },
            [(0, $ib4WI.ISSUE_KEY_ID)]: {
                fieldId: (0, $ib4WI.ISSUE_KEY_ID),
                type: (0, $ib4WI.BOARD_FIELD_TEXT),
                value: issue.key
            },
            [(0, $ib4WI.ISSUE_TYPE_ID)]: {
                fieldId: (0, $ib4WI.ISSUE_TYPE_ID),
                type: (0, $ib4WI.BOARD_FIELD_ISSUE_TYPE),
                id: issueType.id,
                issueType: issueType
            },
            [(0, $ib4WI.STATUS_ID)]: {
                fieldId: (0, $ib4WI.STATUS_ID),
                type: (0, $ib4WI.BOARD_FIELD_STATUS),
                value: String(status.statusId),
                status: {
                    id: String(status.statusId),
                    name: status.name,
                    statusCategoryId: (0, $8Qd0L.StatusCategoryIds)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    status.statusCategory]
                }
            }
        };
        if (issue.assigneeKey && issue.assigneeName) {
            const assignee = workflow.people[issue.assigneeKey];
            fields[0, $ib4WI.ASSIGNEE_ID] = {
                fieldId: (0, $ib4WI.ASSIGNEE_ID),
                type: (0, $ib4WI.BOARD_FIELD_USER),
                value: assignee.key,
                user: {
                    accountId: assignee.key,
                    name: assignee.displayName,
                    avatarURL: assignee.avatarUrl
                }
            };
        }
        if (issue.priorityId && issue.priorityIconUrl && issue.priorityName) fields[0, $ib4WI.PRIORITY_ID] = {
            fieldId: (0, $ib4WI.PRIORITY_ID),
            type: (0, $ib4WI.BOARD_FIELD_PRIORITY),
            value: issue.priorityId,
            priority: {
                iconUrl: issue.priorityIconUrl,
                id: issue.priorityId,
                name: issue.priorityName
            }
        };
        if (issue.dueDate) fields[0, $ib4WI.DUE_DATE_ID] = {
            fieldId: (0, $ib4WI.DUE_DATE_ID),
            type: (0, $ib4WI.BOARD_FIELD_DATE),
            value: issue.dueDate
        };
        return {
            id: issue.id,
            coverMedia: null,
            fields: fields,
            subtaskMetadata: issue.subtaskMetadata
        };
    });
};

});

parcelRegister("lgmYa", function(module, exports) {

$parcel$export(module.exports, "useFieldIds", () => $d6c8b23ffeae272a$export$a8f1976671d75184);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $lO4Or = parcelRequire("lO4Or");

var $1rVdL = parcelRequire("1rVdL");

var $bZapc = parcelRequire("bZapc");
const $d6c8b23ffeae272a$var$SYSTEM_FIELDS = [
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.DUE_DATE_TYPE),
    (0, $lO4Or.ISSUE_KEY_TYPE),
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.PARENT_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $jGcn0.RANK_ALIAS_FIELD_ID),
    (0, $lO4Or.STATUS_TYPE),
    (0, $lO4Or.SUMMARY_TYPE)
];
const $d6c8b23ffeae272a$export$a8f1976671d75184 = ()=>{
    // use the raw grouping view preference instead of the group-by
    // helpers because it contains the category field id (oh god why)
    const [groupByFieldId] = (0, $7c3W1.useViewPreference)((0, $ji3xf.GROUPING_PREFERENCE));
    const selectedFields = (0, $bZapc.useSelectedFields)();
    const filteredFieldIds = (0, $1rVdL.useFilterFieldIds)();
    return (0, $eUqFw.useMemo)(()=>{
        const fieldIds = new Set($d6c8b23ffeae272a$var$SYSTEM_FIELDS);
        if (groupByFieldId) fieldIds.add(groupByFieldId);
        for (const fieldId of filteredFieldIds)fieldIds.add(fieldId);
        for (const fieldId of Object.keys(selectedFields))fieldIds.add(fieldId);
        // The formatting of the timeoriginalestimate relies on the timetrackingsettings field within timetracking: FUN 1015
        if (fieldIds.has((0, $lO4Or.TIME_ESTIMATE_TYPE))) fieldIds.add((0, $lO4Or.TIME_TRACKING_TYPE));
        return Array.from(fieldIds);
    }, [
        filteredFieldIds,
        groupByFieldId,
        selectedFields
    ]);
};

});
parcelRegister("bZapc", function(module, exports) {

$parcel$export(module.exports, "useFieldsPreference", () => $bf795410a1a30a08$export$46ce869a6df40a8b);
$parcel$export(module.exports, "useSelectedFields", () => $bf795410a1a30a08$export$eb999826034c8235);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $lO4Or = parcelRequire("lO4Or");
const $bf795410a1a30a08$export$1671dbe17e3a0329 = new Set([
    (0, $lO4Or.SUMMARY_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    'key',
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.DUE_DATE_TYPE),
    (0, $lO4Or.SUBTASKS_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $lO4Or.LABELS_TYPE),
    (0, $jGcn0.CARD_COVERS_TYPE)
]);
const $bf795410a1a30a08$export$46ce869a6df40a8b = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const [fieldPreferences, setFieldPreferences] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FIELDS_PREFERENCE));
    const fieldIds = (0, $eUqFw.useMemo)(()=>{
        const defaultValue = $bf795410a1a30a08$export$1671dbe17e3a0329;
        if (fieldPreferences == null || !Array.isArray(fieldPreferences)) return defaultValue;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return new Set(fieldPreferences);
    }, [
        fieldPreferences
    ]);
    const setFieldIds = (0, $eUqFw.useCallback)((value)=>setFieldPreferences(Array.from(value)), [
        setFieldPreferences
    ]);
    return [
        fieldIds,
        setFieldIds
    ];
};
const $bf795410a1a30a08$export$eb999826034c8235 = ()=>{
    const [fieldIds] = $bf795410a1a30a08$export$46ce869a6df40a8b();
    return (0, $eUqFw.useMemo)(()=>{
        const selectedFields = {};
        fieldIds.forEach((fieldId)=>{
            selectedFields[fieldId] = true;
        });
        return selectedFields;
    }, [
        fieldIds
    ]);
};

});


parcelRegister("5FsEp", function(module, exports) {

$parcel$export(module.exports, "useRefetchIssues", () => $eac02ab7fa0ac8a0$export$8b0ce7bde93e400a);
$parcel$export(module.exports, "useRefetchIssuesWithThrow", () => $eac02ab7fa0ac8a0$export$207597c4678856ab);

var $eUqFw = parcelRequire("eUqFw");

var $iVIEg = parcelRequire("iVIEg");

var $3MOum = parcelRequire("3MOum");

var $dtXTv = parcelRequire("dtXTv");
const $eac02ab7fa0ac8a0$export$8b0ce7bde93e400a = ()=>{
    const refetchIssuesWithThrow = $eac02ab7fa0ac8a0$export$207597c4678856ab();
    return (0, $eUqFw.useCallback)(async (issueIds)=>{
        try {
            return await refetchIssuesWithThrow(issueIds);
        } catch (error) {
            // do nothing
            return [];
        }
    }, [
        refetchIssuesWithThrow
    ]);
};
const $eac02ab7fa0ac8a0$export$207597c4678856ab = ()=>{
    const fetchIssueDetails = (0, $3MOum.useFetchIssueDetails)();
    const { setIssues: setIssues, removeIssues: removeIssues } = (0, $dtXTv.useIssueStoreActions)();
    return (0, $eUqFw.useCallback)(async (issueIds)=>{
        const issues = await fetchIssueDetails(issueIds);
        setIssues(issues);
        const fetchedIssueIds = issues.map((issue)=>issue.id);
        const removedIssueIds = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(issueIds, fetchedIssueIds);
        if (removedIssueIds.length > 0) removeIssues(removedIssueIds);
        return issues;
    }, [
        fetchIssueDetails,
        setIssues,
        removeIssues
    ]);
};

});
parcelRegister("3MOum", function(module, exports) {

$parcel$export(module.exports, "useFetchIssueDetails", () => $af3cdd1dc206d65a$export$2e8364353306e0d3);

var $eUqFw = parcelRequire("eUqFw");

var $aYAw7 = parcelRequire("aYAw7");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $ib4WI = parcelRequire("ib4WI");

var $c7RGv = parcelRequire("c7RGv");

var $1j5vW = parcelRequire("1j5vW");

var $lgmYa = parcelRequire("lgmYa");
const $af3cdd1dc206d65a$var$CHUNK_SIZE = 100;
const $af3cdd1dc206d65a$export$2e8364353306e0d3 = ()=>{
    const project = (0, $kQAZu.useProject)();
    const fieldIds = (0, $lgmYa.useFieldIds)();
    const fetchIssues = (0, $c7RGv.useFetchBoardIssues)();
    const transformToIssues = (0, $1j5vW.useTransformIssues)();
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $ib4WI.LOAD_EXTENDED_BOARD_DATA_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $ib4WI.LOAD_EXTENDED_BOARD_DATA_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $ib4WI.LOAD_EXTENDED_BOARD_DATA_EXPERIENCE));
    return (0, $eUqFw.useCallback)(async (issueIds)=>{
        if (!fieldIds.length) return [];
        startExperience();
        try {
            const chunks = (0, (/*@__PURE__*/$parcel$interopDefault($aYAw7)))(issueIds, $af3cdd1dc206d65a$var$CHUNK_SIZE);
            const results = await Promise.all(chunks.map((chunkIssueIds)=>fetchIssues({
                    jql: `project = '${project.id}' AND id in (${chunkIssueIds.join(',')})`,
                    fieldIds: fieldIds
                })));
            markExperienceSuccess();
            return results.reduce((acc, result)=>acc.concat(transformToIssues(result)), []);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            markExperienceFailed('Failed to load issue details', error);
            throw error;
        }
    }, [
        fetchIssues,
        fieldIds,
        markExperienceFailed,
        markExperienceSuccess,
        project.id,
        startExperience,
        transformToIssues
    ]);
};

});
parcelRegister("c7RGv", function(module, exports) {

$parcel$export(module.exports, "useFetchBoardIssues", () => $324309ca8ae6b1f1$export$26780ba8d679f5d);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $jlBDe = parcelRequire("jlBDe");

var $3555e = parcelRequire("3555e");

var $jGcn0 = parcelRequire("jGcn0");

var $053h2 = parcelRequire("053h2");

var $lO4Or = parcelRequire("lO4Or");

var $dWLk9 = parcelRequire("dWLk9");

var $iwwE5 = parcelRequire("iwwE5");
const $324309ca8ae6b1f1$var$ITEMS_PER_PAGE = 100;
const $324309ca8ae6b1f1$export$26780ba8d679f5d = ()=>{
    const client = (0, $iZuDo.useApolloClient)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const hasConfluence = (0, $3555e.useTenantHasConfluence)();
    return (0, $eUqFw.useCallback)(async ({ jql: jql, fieldIds: fieldIdsInput })=>{
        const fieldIds = new Set(fieldIdsInput);
        const withChildrenCount = fieldIds.has((0, $lO4Or.SUBTASKS_TYPE));
        fieldIds.delete((0, $lO4Or.SUBTASKS_TYPE));
        const withConfluenceLinks = hasConfluence && fieldIds.has((0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE));
        fieldIds.delete((0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE));
        const withIssueLinks = fieldIds.has((0, $lO4Or.ISSUE_LINKS_TYPE));
        fieldIds.delete((0, $lO4Or.ISSUE_LINKS_TYPE));
        const withCoverMedia = fieldIds.has((0, $jGcn0.CARD_COVERS_TYPE));
        fieldIds.delete((0, $jGcn0.CARD_COVERS_TYPE));
        const variables = {
            fieldIds: Array.from(fieldIds),
            first: $324309ca8ae6b1f1$var$ITEMS_PER_PAGE,
            jql: jql,
            withConfluenceLinks: withConfluenceLinks,
            withCoverMedia: withCoverMedia,
            cloudId: cloudId,
            withIssueLinks: withIssueLinks,
            withChildrenCount: withChildrenCount
        };
        const response = await client.query({
            query: (0, $iwwE5.JIS2_JWMBoardItemsQuery),
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
            variables: variables
        });
        if (!response) throw new Error('No issue response');
        if (response.errors) {
            const apolloError = new (0, $jlBDe.ApolloError)({
                graphQLErrors: response.errors
            });
            if ((0, $053h2.shouldHandleTheError)(apolloError)) throw apolloError;
        }
        const responseData = response.data.jira?.jwmViewItems;
        if (responseData?.__typename === 'JiraWorkManagementViewItemConnection' && responseData.edges != null) return responseData.edges.map((edge)=>edge?.node).filter((node)=>node != null);
        throw new Error('Invalid issue response');
    }, [
        client,
        cloudId,
        hasConfluence
    ]);
};

});
parcelRegister("iwwE5", function(module, exports) {

$parcel$export(module.exports, "JIS2_JWMBOARD_CONFLUENCE_LINKS_FRAGMENT", () => $fc4bffa3fcd81f30$export$9ed9a1cb8188c743);
$parcel$export(module.exports, "JIS2_JWMBOARD_ISSUE_LINKS_FRAGMENT", () => $fc4bffa3fcd81f30$export$cb794cef9d65b633);
$parcel$export(module.exports, "JIS2_JWMBOARD_ITEM_COVER_MEDIA_FRAGMENT", () => $fc4bffa3fcd81f30$export$832c0260442bf18d);
$parcel$export(module.exports, "JIS2_JWMBOARD_ITEM_FRAGMENT", () => $fc4bffa3fcd81f30$export$8a4c8763de723c1b);
$parcel$export(module.exports, "JIS2_JWMBoardItemsQuery", () => $fc4bffa3fcd81f30$export$aeea67f0727d06fb);

var $9ypom = parcelRequire("9ypom");
const $fc4bffa3fcd81f30$export$9ed9a1cb8188c743 = (0, $9ypom.default)`
fragment JIS2_JWMBoardConfluenceLinksFragment on JiraWorkManagementViewItem {
  legacyConfluenceLinks (getFirstOnly: true) {
    linkedConfluencePages {
      pageCount
    }
  }
}
`;
const $fc4bffa3fcd81f30$export$cb794cef9d65b633 = (0, $9ypom.default)`
fragment JIS2_JWMBoardIssueLinksFragment on JiraWorkManagementViewItem {
  issueLinks(first: 10) {
    edges {
      node {
        issue {
          issueId
        }
      }
    }
  }
}
`;
const $fc4bffa3fcd81f30$var$JIS2_JWMBOARD_ACCOUNT_FRAGMENT = (0, $9ypom.default)`
fragment JIS2_JWMBoardAccountFragment on AtlassianAccountUser {
  accountId
  name
  picture
}
`;
const $fc4bffa3fcd81f30$var$JIS2_JWMBOARD_USER_FRAGMENT = (0, $9ypom.default)`
fragment JIS2_JWMBoardUserFragment on JiraUserConnection {
  edges {
    node {
      ...JIS2_JWMBoardAccountFragment
    }
  }
}
${$fc4bffa3fcd81f30$var$JIS2_JWMBOARD_ACCOUNT_FRAGMENT}
`;
const $fc4bffa3fcd81f30$export$832c0260442bf18d = (0, $9ypom.default)`
fragment JIS2_JWMBoardItemCoverMediaFragment on JiraWorkManagementViewItem {
  coverMedia {
    ... on JiraWorkManagementColorBackground {
      entityId
      colorValue
    }
    ... on JiraWorkManagementGradientBackground {
      entityId
      gradientValue
    }
    ... on JiraWorkManagementAttachmentBackground {
        entityId
        attachment {
            attachmentId
            mediaReadToken(durationInSeconds: 900, maxTokenLength: 65534)
            fileName
            mediaApiFileId
            __typename
            # Helpful for determining the source of the attachment, such as Unsplash so that we can attribute the source
            ... on JiraPlatformAttachment {
                sourceType: attachmentProperty(key: "sourceType")
                sourceIdentifier: attachmentProperty(key: "sourceIdentifier")
            }
        }
    }
  }
}`;
const $fc4bffa3fcd81f30$export$8a4c8763de723c1b = (0, $9ypom.default)`
fragment JIS2_JWMBoardItemFragment on JiraWorkManagementViewItem {
  id
  issueId
  fieldsByIdOrAlias(idsOrAliases: $fieldIds, ignoreMissingFields: true) {
    __typename
    fieldId
    name
    ... on JiraSingleLineTextField {
      text
      type
    }
    ... on JiraLabelsField {
      selectedLabelsConnection {
        edges {
          node {
            name,
          }
        }
      }
    }
    ... on JiraSingleSelectUserPickerField {
      user {
        ... JIS2_JWMBoardAccountFragment
      }
    }
    ... on JiraDatePickerField {
      date
    }
    ... on JiraDateTimePickerField {
      dateTime
    }
    ... on JiraComponentsField {
      selectedComponentsConnection {
        edges {
          node {
            name
          }
        }
      }
    }
    ... on JiraOriginalTimeEstimateField {
      originalEstimate {
        timeInSeconds
      }
    }
    ... on JiraSingleSelectField {
      type
      fieldOption {
        optionId
        value
        color {
          colorKey
        }
      }
    }
    ... on JiraMultipleSelectField {
      selectedOptions {
        edges {
          node {
            value
          }
        }
      }
    }
    ... on JiraNumberField {
      number
    }
    ... on JiraMultipleSelectUserPickerField {
      selectedUsersConnection {
        ...JIS2_JWMBoardUserFragment
      }
    }
    ... on JiraPeopleField {
      selectedUsersConnection {
        ... JIS2_JWMBoardUserFragment
      }
    }
    ... on JiraTimeTrackingField {
      originalEstimate {
        timeInSeconds
      }
      timeTrackingSettings {
        defaultUnit
        defaultFormat
        workingHoursPerDay
        workingDaysPerWeek
      }
    }
    ... on JiraStatusField {
      status {
        name
        statusId
        statusCategory {
          statusCategoryId
        }
      }
    }
    ... on JiraIssueTypeField {
      issueType {
        issueTypeId
        name
        avatar {
          medium
        }
        hierarchy {
          level
        }
      }
    }
    ... on JiraPriorityField {
      priority {
        iconUrl
        name
        priorityId
      }
    }
    ... on JiraParentIssueField {
      parentIssue {
        issueId
        key
        summaryField {
          text
        }
      }
    }
  },
  childrenTotal: childSummary(includeDone:true) @include(if: $withChildrenCount) {
    totalCount,
  }
  childrenNotDone: childSummary(includeDone:false) @include(if: $withChildrenCount) {
    totalCount,
  }
}
${$fc4bffa3fcd81f30$var$JIS2_JWMBOARD_ACCOUNT_FRAGMENT}
${$fc4bffa3fcd81f30$var$JIS2_JWMBOARD_USER_FRAGMENT}
`;
const $fc4bffa3fcd81f30$export$aeea67f0727d06fb = (0, $9ypom.default)`
query JIS2JWMBoardItems($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int, $after: String, $withConfluenceLinks: Boolean!, $withCoverMedia: Boolean!, $withIssueLinks: Boolean!, $withChildrenCount: Boolean!) {
  jira {
    jwmViewItems(cloudId: $cloudId, jql: $jql, first: $first, after: $after) @connection (key: "boardJIS", filter:["jql"]) {
      __typename
      ... on QueryError {
          message
          extensions {
              statusCode
              errorType
          }
      }
      ... on JiraWorkManagementViewItemConnection {
        edges {
          node {
            ...JIS2_JWMBoardItemFragment
            ...JIS2_JWMBoardConfluenceLinksFragment @include(if: $withConfluenceLinks)
            ...JIS2_JWMBoardItemCoverMediaFragment @include(if: $withCoverMedia)
            ...JIS2_JWMBoardIssueLinksFragment @include(if: $withIssueLinks)
          }
        }
      }
    }
  }
}
${$fc4bffa3fcd81f30$export$8a4c8763de723c1b}
${$fc4bffa3fcd81f30$export$9ed9a1cb8188c743}
${$fc4bffa3fcd81f30$export$832c0260442bf18d}
${$fc4bffa3fcd81f30$export$cb794cef9d65b633}
`;

});


parcelRegister("1j5vW", function(module, exports) {

$parcel$export(module.exports, "transformCoverMedia", () => $93c688f39458612f$export$2c47b714cdbd1e2a);
$parcel$export(module.exports, "useTransformIssues", () => $93c688f39458612f$export$3746553fffc661a3);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $h9cCP = parcelRequire("h9cCP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $7v0hO = parcelRequire("7v0hO");

var $ib4WI = parcelRequire("ib4WI");

var $cThpl = parcelRequire("cThpl");
const $93c688f39458612f$var$transformers = {
    [(0, $lO4Or.TEXT_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.TEXT_GQL_FIELD) || field.text == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_TEXT),
            fieldId: field.fieldId,
            name: field.name,
            value: field.text
        };
    },
    [(0, $lO4Or.COMPONENTS_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.COMPONENTS_GQL_FIELD)) return null;
        const value = field.selectedComponentsConnection?.edges?.map((edge)=>edge?.node?.name ?? null).filter((name)=>name != null);
        if (value == null || value.length === 0) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_COMPONENTS),
            fieldId: field.fieldId,
            name: field.name,
            value: value
        };
    },
    [(0, $lO4Or.LABEL_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.LABEL_GQL_FIELD) || field.selectedLabelsConnection == null) return null;
        const value = field.selectedLabelsConnection.edges?.map((edge)=>edge?.node?.name ?? null).filter((name)=>name != null);
        if (value == null || value.length === 0) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_LABEL),
            fieldId: field.fieldId,
            value: value
        };
    },
    [(0, $lO4Or.ORIGINAL_ESTIMATE_GQL_FIELD)]: (field, timeTrackingConfig, intl)=>{
        if (field.__typename !== (0, $lO4Or.ORIGINAL_ESTIMATE_GQL_FIELD) || field.originalEstimate?.timeInSeconds == null) return null;
        if (!timeTrackingConfig || !intl) // if timeTrackingConfig is not available, return the original estimate in seconds
        return {
            type: (0, $ib4WI.BOARD_FIELD_TIME_ORIGINAL_ESTIMATE),
            fieldId: field.fieldId,
            name: field.name,
            value: field.originalEstimate.timeInSeconds
        };
        const { workingDaysPerWeek: workingDaysPerWeek, workingHoursPerDay: workingHoursPerDay, defaultFormat: timeFormat, defaultUnit: defaultUnit } = timeTrackingConfig;
        return {
            type: (0, $ib4WI.BOARD_FIELD_TIME_ORIGINAL_ESTIMATE),
            fieldId: field.fieldId,
            name: field.name,
            value: (0, $7v0hO.timeTrackingFormatter)(field.originalEstimate.timeInSeconds, {
                workingHoursPerDay: workingHoursPerDay,
                workingDaysPerWeek: workingDaysPerWeek,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                timeFormat: timeFormat.toLowerCase() ?? (0, $h9cCP.PRETTY),
                defaultUnit: defaultUnit
            }, intl)
        };
    },
    [(0, $lO4Or.DATE_PICKER_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.DATE_PICKER_GQL_FIELD) || field.date == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_DATE),
            fieldId: field.fieldId,
            name: field.name,
            value: field.date
        };
    },
    [(0, $lO4Or.SINGLE_SELECT_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.SINGLE_SELECT_GQL_FIELD) || field.fieldOption?.value == null) return null;
        if (field.__typename === (0, $lO4Or.SINGLE_SELECT_GQL_FIELD) && field.type === (0, $lO4Or.CATEGORY_TYPE) && field.fieldOption?.value != null) return {
            fieldId: field.fieldId,
            name: field.name,
            type: (0, $ib4WI.BOARD_FIELD_CATEGORY),
            value: field.fieldOption.optionId,
            category: {
                name: field.fieldOption.value,
                color: field.fieldOption.color?.colorKey ?? null
            }
        };
        return {
            type: (0, $ib4WI.BOARD_FIELD_SELECT),
            fieldId: field.fieldId,
            name: field.name,
            value: [
                field.fieldOption.value
            ]
        };
    },
    [(0, $lO4Or.DATE_TIME_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.DATE_TIME_GQL_FIELD) || field.dateTime == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_DATE_TIME),
            fieldId: field.fieldId,
            name: field.name,
            value: field.dateTime
        };
    },
    [(0, $lO4Or.NUMBER_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.NUMBER_GQL_FIELD) || field.number == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_FLOAT),
            fieldId: field.fieldId,
            name: field.name,
            value: field.number
        };
    },
    [(0, $lO4Or.USER_PICKER_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.USER_PICKER_GQL_FIELD) || field.user == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_USER),
            fieldId: field.fieldId,
            name: field.name,
            value: field.user.accountId,
            user: {
                accountId: field.user.accountId,
                name: field.user.name,
                avatarURL: field.user.picture
            }
        };
    },
    [(0, $lO4Or.MULTI_USER_PICKER_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.MULTI_USER_PICKER_GQL_FIELD)) return null;
        const users = field.selectedUsersConnection?.edges?.map((edge)=>edge?.node).filter((user)=>user != null).map((user)=>({
                accountId: user.accountId,
                name: user.name,
                avatarURL: user.picture
            }));
        if (users == null || users.length < 1) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_MULTI_USER),
            fieldId: field.fieldId,
            name: field.name,
            users: users
        };
    },
    [(0, $lO4Or.MULTI_SELECT_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.MULTI_SELECT_GQL_FIELD)) return null;
        const value = field.selectedOptions?.edges?.map((edge)=>edge?.node).map((node)=>node?.value).filter(// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        (optionValue)=>optionValue != null);
        if (value == null || value.length < 1) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_SELECT),
            fieldId: field.fieldId,
            name: field.name,
            value: value
        };
    },
    [(0, $lO4Or.PEOPLE_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.PEOPLE_GQL_FIELD)) return null;
        const users = field.selectedUsersConnection?.edges?.map((edge)=>edge?.node).filter((user)=>user != null).map((user)=>({
                accountId: user.accountId,
                name: user.name,
                avatarURL: user.picture
            }));
        if (users == null || users.length < 1) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_MULTI_USER),
            fieldId: field.fieldId,
            name: field.name,
            users: users
        };
    },
    [(0, $lO4Or.PARENT_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.PARENT_GQL_FIELD) || field.parentIssue == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_PARENT),
            fieldId: field.fieldId,
            name: field.name,
            value: field.parentIssue.issueId,
            parent: {
                key: field.parentIssue.key,
                summary: field.parentIssue.summaryField?.text ?? ''
            }
        };
    },
    [(0, $lO4Or.STATUS_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.STATUS_GQL_FIELD) || field.status.name == null || field.status.statusCategory?.statusCategoryId == null || field.status.statusId == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_STATUS),
            fieldId: field.fieldId,
            name: field.name,
            value: field.status.statusId,
            status: {
                id: field.status.statusId,
                name: field.status.name,
                statusCategoryId: Number(field.status.statusCategory.statusCategoryId)
            }
        };
    },
    [(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.ISSUE_TYPE_GQL_FIELD) || field.issueType?.issueTypeId == null || field.issueType.name == null || field.issueType.hierarchy?.level == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_ISSUE_TYPE),
            fieldId: field.fieldId,
            name: field.name,
            id: field.issueType.issueTypeId,
            issueType: {
                id: field.issueType.issueTypeId,
                name: field.issueType.name,
                iconUrl: field.issueType.avatar?.medium ?? '',
                hierarchyLevel: field.issueType.hierarchy.level
            }
        };
    },
    [(0, $lO4Or.PRIORITY_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.PRIORITY_GQL_FIELD) || field.priority?.iconUrl == null || field.priority?.name == null || field.priority?.priorityId == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_PRIORITY),
            fieldId: field.fieldId,
            name: field.name,
            value: field.priority.priorityId,
            priority: {
                iconUrl: field.priority.iconUrl,
                id: field.priority.priorityId,
                name: field.priority.name
            }
        };
    }
};
const $93c688f39458612f$var$transformField = (field, timeTrackingConfig, intl)=>{
    if (field == null) return null;
    if (field.__typename in $93c688f39458612f$var$transformers) return $93c688f39458612f$var$transformers[field.__typename](field, timeTrackingConfig, intl);
    return null;
};
const $93c688f39458612f$var$extractTimeTrackingConfig = (issueDetail)=>{
    const timetracking = issueDetail.fieldsByIdOrAlias?.find((field)=>field?.__typename === (0, $lO4Or.TIME_TRACKING_GQL_FIELD));
    if (timetracking && 'timeTrackingSettings' in timetracking && timetracking.timeTrackingSettings?.workingHoursPerDay != null && timetracking.timeTrackingSettings?.workingDaysPerWeek != null && timetracking.timeTrackingSettings?.defaultUnit != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return timetracking.timeTrackingSettings;
    return null;
};
const $93c688f39458612f$export$2c47b714cdbd1e2a = (coverMedia)=>{
    if (!coverMedia) return null;
    if (coverMedia.__typename === 'JiraWorkManagementColorBackground') {
        if (coverMedia.colorValue == null) return null;
        return {
            type: 'color',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            value: coverMedia.colorValue
        };
    }
    if (coverMedia.__typename === 'JiraWorkManagementGradientBackground') {
        if (coverMedia.gradientValue == null) return null;
        return {
            type: 'gradient',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            value: coverMedia.gradientValue
        };
    }
    if (coverMedia.__typename === 'JiraWorkManagementAttachmentBackground') {
        const { fileName: fileName, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken } = coverMedia.attachment ?? {};
        if (fileName == null || mediaApiFileId == null || mediaReadToken == null) return null;
        let unsplashId = null;
        const unsplashAttachment = coverMedia.attachment?.__typename === 'JiraPlatformAttachment' ? coverMedia.attachment : null;
        if (unsplashAttachment?.sourceType === 'UNSPLASH' && unsplashAttachment?.sourceIdentifier != null) unsplashId = unsplashAttachment.sourceIdentifier;
        return {
            type: 'image',
            fileName: fileName,
            mediaApiFileId: mediaApiFileId,
            mediaReadToken: mediaReadToken,
            unsplashId: unsplashId
        };
    }
    return null;
};
const $93c688f39458612f$export$3746553fffc661a3 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (0, $eUqFw.useCallback)((issueDetails)=>{
        const transformedIssues = [];
        issueDetails.forEach((issueDetail)=>{
            if (!issueDetail.fieldsByIdOrAlias) return;
            const newIssue = {
                id: issueDetail.issueId,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                fields: {},
                coverMedia: $93c688f39458612f$export$2c47b714cdbd1e2a(issueDetail.coverMedia),
                subtaskMetadata: (0, $cThpl.getSubtaskMetadata)(issueDetail.childrenTotal?.totalCount, issueDetail.childrenNotDone?.totalCount)
            };
            const timeTrackingConfig = $93c688f39458612f$var$extractTimeTrackingConfig(issueDetail);
            issueDetail.fieldsByIdOrAlias?.forEach((field)=>{
                const transformedField = $93c688f39458612f$var$transformField(field, timeTrackingConfig, {
                    formatMessage: formatMessage
                });
                if (transformedField == null) return;
                switch(transformedField.type){
                    case 0, $ib4WI.BOARD_FIELD_CATEGORY:
                        newIssue.fields[0, $ib4WI.CATEGORY_ID] = transformedField;
                        break;
                    case 0, $ib4WI.BOARD_FIELD_LABEL:
                        newIssue.fields[0, $ib4WI.LABEL_ID] = transformedField;
                        break;
                    case 0, $ib4WI.BOARD_FIELD_PARENT:
                        newIssue.fields[0, $ib4WI.PARENT_ID] = transformedField;
                        break;
                    case 0, $ib4WI.BOARD_FIELD_TEXT:
                        if (field && field.__typename === (0, $lO4Or.TEXT_GQL_FIELD) && field.type === (0, $lO4Or.RANK_CF_TYPE)) {
                            newIssue.fields[0, $ib4WI.RANK_ID] = transformedField;
                            break;
                        }
                        newIssue.fields[transformedField.fieldId] = transformedField;
                        break;
                    default:
                        newIssue.fields[transformedField.fieldId] = transformedField;
                }
            });
            if (issueDetail.legacyConfluenceLinks?.linkedConfluencePages?.pageCount != null) newIssue.fields[0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE] = {
                type: (0, $ib4WI.BOARD_FIELD_CONFLUENCE_PAGES_COUNT),
                fieldId: 'remoteIssueLinks',
                value: issueDetail.legacyConfluenceLinks.linkedConfluencePages.pageCount
            };
            if (issueDetail.issueLinks?.edges) newIssue.fields[0, $lO4Or.ISSUE_LINKS_TYPE] = {
                type: (0, $ib4WI.BOARD_FIELD_ISSUE_LINKS_COUNT),
                fieldId: (0, $lO4Or.ISSUE_LINKS_TYPE),
                value: issueDetail.issueLinks.edges.filter(Boolean).length ?? 0
            };
            transformedIssues.push(newIssue);
        });
        return transformedIssues;
    }, [
        formatMessage
    ]);
};

});
parcelRegister("h9cCP", function(module, exports) {

$parcel$export(module.exports, "MINUTE", () => $335f9886067ef898$export$f4aba04677f37907);
$parcel$export(module.exports, "HOUR", () => $335f9886067ef898$export$1bf939ebcf31ef0e);
$parcel$export(module.exports, "DAY", () => $335f9886067ef898$export$1a58b8d7f494dd72);
$parcel$export(module.exports, "WEEK", () => $335f9886067ef898$export$3241045aa1844a20);
$parcel$export(module.exports, "DAYS", () => $335f9886067ef898$export$b387b66963374517);
$parcel$export(module.exports, "HOURS", () => $335f9886067ef898$export$f25ebc73c10ad2c);
$parcel$export(module.exports, "PRETTY", () => $335f9886067ef898$export$d39e6ebabedff673);
$parcel$export(module.exports, "defaultTimeTrackingConfiguration", () => $335f9886067ef898$export$e17ebf14f4144ede);
$parcel$export(module.exports, "DEFAULT_TO_NEW_ISSUE_VIEW", () => $335f9886067ef898$export$83f9ac2d887bd06a);
const $335f9886067ef898$export$f4aba04677f37907 = 'minute';
const $335f9886067ef898$export$1bf939ebcf31ef0e = 'hour';
const $335f9886067ef898$export$1a58b8d7f494dd72 = 'day';
const $335f9886067ef898$export$3241045aa1844a20 = 'week';
const $335f9886067ef898$export$b387b66963374517 = 'days';
const $335f9886067ef898$export$f25ebc73c10ad2c = 'hours';
const $335f9886067ef898$export$d39e6ebabedff673 = 'pretty';
const $335f9886067ef898$export$e17ebf14f4144ede = {
    isTimeTrackingEnabled: false,
    daysPerWeek: 5,
    hoursPerDay: 8,
    defaultUnit: $335f9886067ef898$export$f4aba04677f37907,
    format: $335f9886067ef898$export$d39e6ebabedff673
};
const $335f9886067ef898$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
const $335f9886067ef898$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
const $335f9886067ef898$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';

});

parcelRegister("7v0hO", function(module, exports) {

$parcel$export(module.exports, "timeTrackingFormatter", () => $84936c9163886c98$export$5169d8c8f9327e33);
$parcel$export(module.exports, "timeTrackingFormatterWithDefaults", () => $84936c9163886c98$export$71be3aa954f6065b);
$parcel$export(module.exports, "timeTrackingFormatterLongForm", () => $84936c9163886c98$export$bb4e82d8c2aeeff1);
$parcel$export(module.exports, "transformAGGToJiraTimeFormat", () => $84936c9163886c98$export$9dccd3a07969375d);
$parcel$export(module.exports, "transformAGGToJiraTimeUnit", () => $84936c9163886c98$export$8516173ab945b52f);

var $4m36T = parcelRequire("4m36T");

var $eyAhE = parcelRequire("eyAhE");

var $3W1DB = parcelRequire("3W1DB");
const $84936c9163886c98$var$validate = (condition)=>(distance)=>condition ? distance : 0;
// Format time to be 2 decimal places without trailing zeros
const $84936c9163886c98$var$timeFormatter = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
const $84936c9163886c98$var$timePrettyFormatter = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0${formatMessage(units[3].suffix)}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${formatMessage(unit.suffix)}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$var$timePrettyFormatterLongForm = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0 ${formatMessage(units[3].suffix, {
        [units[3].type]: 0
    })}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const { suffix: suffix, type: type } = unit;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (currentTimeValue === 1) return {
            secondsRemaining: timeObj.secondsRemaining % unit.seconds,
            time: `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
                [type]: currentTimeValue
            })}`
        };
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
            [type]: currentTimeValue
        })}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $4m36T.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $3W1DB.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $eyAhE.default).timeUnitWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $eyAhE.default).timeUnitDay,
            transform: $84936c9163886c98$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $eyAhE.default).timeUnitHour,
            transform: $84936c9163886c98$var$validate(isTimeValid),
            seconds: (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $eyAhE.default).timeUnitMinute,
            seconds: (0, $4m36T.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $4m36T.TimeFormats).DAYS:
            return $84936c9163886c98$var$timeFormatter(units[1].time, formatMessage(units[1].suffix));
        case (0, $4m36T.TimeFormats).HOURS:
            return $84936c9163886c98$var$timeFormatter(units[2].time, formatMessage(units[2].suffix));
        case (0, $4m36T.TimeFormats).PRETTY:
        default:
            return $84936c9163886c98$var$timePrettyFormatter(timeInSeconds, units, formatMessage);
    }
};
const $84936c9163886c98$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
    const timeTrackingSettings = {
        workingHoursPerDay: workingHoursPerDay || (0, $4m36T.defaultTimeTrackingOptions).workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek || (0, $4m36T.defaultTimeTrackingOptions).workingDaysPerWeek,
        timeFormat: timeFormat || (0, $4m36T.defaultTimeTrackingOptions).timeFormat,
        defaultUnit: (0, $4m36T.defaultTimeTrackingOptions).defaultUnit
    };
    return $84936c9163886c98$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
};
const $84936c9163886c98$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $4m36T.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $3W1DB.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $eyAhE.default).timeUnitLongWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $eyAhE.default).timeUnitLongDay,
            transform: $84936c9163886c98$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $eyAhE.default).timeUnitLongHour,
            transform: $84936c9163886c98$var$validate(isTimeValid),
            seconds: (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $eyAhE.default).timeUnitLongMinute,
            seconds: (0, $4m36T.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $4m36T.TimeFormats).DAYS:
            return $84936c9163886c98$var$timeFormatter(units[1].time, ` ${formatMessage(units[1].suffix, {
                day: units[1].time
            })}`);
        case (0, $4m36T.TimeFormats).HOURS:
            return $84936c9163886c98$var$timeFormatter(units[2].time, ` ${formatMessage(units[2].suffix, {
                hour: units[2].time
            })}`);
        case (0, $4m36T.TimeFormats).PRETTY:
        default:
            return $84936c9163886c98$var$timePrettyFormatterLongForm(timeInSeconds, units, formatMessage);
    }
};
const $84936c9163886c98$export$9dccd3a07969375d = (format)=>{
    switch(String(format).toLowerCase()){
        case (0, $4m36T.TimeFormats).DAYS:
            return (0, $4m36T.TimeFormats).DAYS;
        case (0, $4m36T.TimeFormats).HOURS:
            return (0, $4m36T.TimeFormats).HOURS;
        case (0, $4m36T.TimeFormats).PRETTY:
            return (0, $4m36T.TimeFormats).PRETTY;
        default:
            return (0, $4m36T.TimeFormats).DAYS;
    }
};
const $84936c9163886c98$export$8516173ab945b52f = (defaultUnit)=>{
    switch(String(defaultUnit).toLowerCase()){
        case (0, $4m36T.TimeUnits).DAY:
            return (0, $4m36T.TimeUnits).DAY;
        case (0, $4m36T.TimeUnits).HOUR:
            return (0, $4m36T.TimeUnits).HOUR;
        case (0, $4m36T.TimeUnits).MINUTE:
            return (0, $4m36T.TimeUnits).MINUTE;
        case (0, $4m36T.TimeUnits).WEEK:
            return (0, $4m36T.TimeUnits).WEEK;
        default:
            return (0, $4m36T.TimeUnits).DAY;
    }
};

});
parcelRegister("4m36T", function(module, exports) {

$parcel$export(module.exports, "SECONDS_PER_MINUTE", () => $8d43f29047a2cbec$export$544c576050746347);
$parcel$export(module.exports, "SECONDS_PER_HOUR", () => $8d43f29047a2cbec$export$3cc7ae4b390f50a);
$parcel$export(module.exports, "TimeFormats", () => $8d43f29047a2cbec$export$5d7ed58d46354b1);
$parcel$export(module.exports, "TimeUnits", () => $8d43f29047a2cbec$export$5d7753c8ad881494);
$parcel$export(module.exports, "defaultTimeTrackingOptions", () => $8d43f29047a2cbec$export$f8d48c1fed813e90);
const $8d43f29047a2cbec$export$544c576050746347 = 60;
const $8d43f29047a2cbec$export$a4982fdb1458274 = 60;
const $8d43f29047a2cbec$export$3cc7ae4b390f50a = $8d43f29047a2cbec$export$a4982fdb1458274 * $8d43f29047a2cbec$export$544c576050746347;
const $8d43f29047a2cbec$var$TIME_FORMAT_PRETTY = 'pretty';
const $8d43f29047a2cbec$var$TIME_FORMAT_DAYS = 'days';
const $8d43f29047a2cbec$var$TIME_FORMAT_HOURS = 'hours';
const $8d43f29047a2cbec$export$5d7ed58d46354b1 = Object.freeze({
    PRETTY: $8d43f29047a2cbec$var$TIME_FORMAT_PRETTY,
    DAYS: $8d43f29047a2cbec$var$TIME_FORMAT_DAYS,
    HOURS: $8d43f29047a2cbec$var$TIME_FORMAT_HOURS
});
const $8d43f29047a2cbec$var$TIME_UNIT_WEEK = 'week';
const $8d43f29047a2cbec$var$TIME_UNIT_DAY = 'day';
const $8d43f29047a2cbec$var$TIME_UNIT_HOUR = 'hour';
const $8d43f29047a2cbec$var$TIME_UNIT_MINUTE = 'minute';
const $8d43f29047a2cbec$export$5d7753c8ad881494 = Object.freeze({
    WEEK: $8d43f29047a2cbec$var$TIME_UNIT_WEEK,
    DAY: $8d43f29047a2cbec$var$TIME_UNIT_DAY,
    HOUR: $8d43f29047a2cbec$var$TIME_UNIT_HOUR,
    MINUTE: $8d43f29047a2cbec$var$TIME_UNIT_MINUTE
});
const $8d43f29047a2cbec$export$f8d48c1fed813e90 = {
    workingHoursPerDay: 8,
    workingDaysPerWeek: 5,
    timeFormat: $8d43f29047a2cbec$export$5d7ed58d46354b1.PRETTY,
    defaultUnit: $8d43f29047a2cbec$export$5d7753c8ad881494.MINUTE
};

});

parcelRegister("eyAhE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93ae5507f3c0ae3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a93ae5507f3c0ae3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timeUnitWeek: {
        "id": "time-tracking-formatter.time-unit-week",
        "defaultMessage": "w"
    },
    timeUnitDay: {
        "id": "time-tracking-formatter.time-unit-day",
        "defaultMessage": "d"
    },
    timeUnitHour: {
        "id": "time-tracking-formatter.time-unit-hour",
        "defaultMessage": "h"
    },
    timeUnitMinute: {
        "id": "time-tracking-formatter.time-unit-minute",
        "defaultMessage": "m"
    },
    timeUnitLongWeek: {
        "id": "time-tracking-formatter.time-unit-long-week",
        "defaultMessage": "{week, plural, zero {weeks} one {week} other {weeks} }"
    },
    timeUnitLongDay: {
        "id": "time-tracking-formatter.time-unit-long-day",
        "defaultMessage": "{day, plural, zero {days} one {day} other {days} }"
    },
    timeUnitLongHour: {
        "id": "time-tracking-formatter.time-unit-long-hour",
        "defaultMessage": "{hour, plural, zero {hours} one {hour} other {hours} }"
    },
    timeUnitLongMinute: {
        "id": "time-tracking-formatter.time-unit-long-minute",
        "defaultMessage": "{minute, plural, zero {minutes} one {minute} other {minutes} }"
    }
});

});

parcelRegister("3W1DB", function(module, exports) {

$parcel$export(module.exports, "createUnit", () => $1595a85c80e57d00$export$aab44654646f3ccc);
const $1595a85c80e57d00$export$aab44654646f3ccc = (timeInSeconds)=>({ suffix: suffix, seconds: seconds, type: type, transform: transform })=>{
        const distance = timeInSeconds / seconds;
        const time = transform ? transform(distance) : distance;
        return {
            seconds: seconds,
            suffix: suffix,
            time: time,
            type: type
        };
    };

});


parcelRegister("cThpl", function(module, exports) {

$parcel$export(module.exports, "getSubtaskMetadata", () => $6fbed3cf6493d53d$export$9af279b6109e0217);
const $6fbed3cf6493d53d$export$9af279b6109e0217 = (totalCount, totalNotDoneCount)=>{
    if (totalCount == null || totalNotDoneCount == null) return {
        total: 0,
        done: 0
    };
    return {
        total: totalCount,
        done: totalCount - totalNotDoneCount
    };
};

});




parcelRegister("iq40z", function(module, exports) {

$parcel$export(module.exports, "WorkflowStoreContainer", () => $6deadcee45e6e201$export$704db246c3ac6062);
$parcel$export(module.exports, "useWorkflowStoreState", () => $6deadcee45e6e201$export$28d1a95bd5ffa117);
$parcel$export(module.exports, "useWorkflowStoreActions", () => $6deadcee45e6e201$export$d932477502b964cb);
$parcel$export(module.exports, "useInitialTransition", () => $6deadcee45e6e201$export$1c96719c98024183);

var $WBLbN = parcelRequire("WBLbN");
const $6deadcee45e6e201$var$initialState = {
    columns: [],
    issueTypes: [],
    transitions: [],
    workflows: [],
    workflowId: null,
    workflowName: null
};
const $6deadcee45e6e201$var$removeColumn = (statusId)=>({ setState: setState, getState: getState })=>{
        const { columns: columns, workflows: workflows } = getState();
        const newColumns = columns.filter((c)=>c.statusId !== statusId);
        setState({
            columns: [
                ...newColumns
            ],
            workflows: workflows.map((wf)=>{
                const newWfColumns = wf.columns.filter((c)=>c.statusId !== statusId);
                return {
                    ...wf,
                    columns: [
                        ...newWfColumns
                    ]
                };
            })
        });
    };
const $6deadcee45e6e201$var$setColumns = (columns)=>({ setState: setState, getState: getState })=>{
        const { workflowId: workflowId, workflows: workflows } = getState();
        setState({
            columns: columns,
            workflows: workflows.map((workflow)=>workflow.workflowId === workflowId ? {
                    ...workflow,
                    columns: columns
                } : workflow)
        });
    };
const $6deadcee45e6e201$var$setFetchResponse = ({ workflows: workflows, activeWorkflow: activeWorkflow, workflowIssuesLastChangedTime: workflowIssuesLastChangedTime })=>async ({ setState: setState })=>{
        setState({
            columns: activeWorkflow.columns,
            issueTypes: activeWorkflow.issueTypes,
            transitions: activeWorkflow.transitions,
            workflows: workflows,
            workflowId: activeWorkflow.workflowId,
            workflowIssuesLastChangedTime: workflowIssuesLastChangedTime,
            workflowName: activeWorkflow.workflowName
        });
    };
const $6deadcee45e6e201$var$actions = {
    removeColumn: $6deadcee45e6e201$var$removeColumn,
    setColumns: $6deadcee45e6e201$var$setColumns,
    setFetchResponse: $6deadcee45e6e201$var$setFetchResponse
};
const $6deadcee45e6e201$export$704db246c3ac6062 = (0, $WBLbN.createContainer)();
const $6deadcee45e6e201$var$WorkflowStore = (0, $WBLbN.createStore)({
    initialState: $6deadcee45e6e201$var$initialState,
    actions: $6deadcee45e6e201$var$actions,
    name: 'WorkflowStore',
    containedBy: $6deadcee45e6e201$export$704db246c3ac6062
});
const $6deadcee45e6e201$var$getInitialTransition = (0, $WBLbN.createSelector)((state)=>state.transitions, (transitions)=>transitions.find((transition)=>transition.isInitial));
const $6deadcee45e6e201$export$28d1a95bd5ffa117 = (0, $WBLbN.createStateHook)($6deadcee45e6e201$var$WorkflowStore);
const $6deadcee45e6e201$export$d932477502b964cb = (0, $WBLbN.createActionsHook)($6deadcee45e6e201$var$WorkflowStore);
const $6deadcee45e6e201$export$1c96719c98024183 = (0, $WBLbN.createStateHook)($6deadcee45e6e201$var$WorkflowStore, {
    selector: $6deadcee45e6e201$var$getInitialTransition
});

});

parcelRegister("7x9tw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebadd2525659871f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ebadd2525659871f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    boardInitErrorTitle: {
        "id": "work-management-board.controllers.board-data.board-init-error-title",
        "defaultMessage": "Failed to load the board"
    },
    boardInitErrorMessage: {
        "id": "work-management-board.controllers.board-data.board-init-error-message",
        "defaultMessage": "We couldn't load your board, try refreshing the page or try again later."
    }
});

});


parcelRegister("iLiDV", function(module, exports) {

$parcel$export(module.exports, "ConfettiColumnsProvider", () => $bdd596b34dcec0e4$export$a2ded958dc3b3a);
$parcel$export(module.exports, "useConfettiColumns", () => $bdd596b34dcec0e4$export$d2d8be1cdd91d59f);
$parcel$export(module.exports, "useAddConfettiColumn", () => $bdd596b34dcec0e4$export$5f36accfd50e20fd);
$parcel$export(module.exports, "matchConfettiColumn", () => $bdd596b34dcec0e4$export$44c2e17e7d7d4d24);

var $WBLbN = parcelRequire("WBLbN");

var $lnmSR = parcelRequire("lnmSR");
const $bdd596b34dcec0e4$var$COLUMN_CONFETTI_NAMES = [
    "\uD83C\uDF8A",
    "\uD83C\uDF89",
    "\uD83C\uDF86",
    "\uD83C\uDF87",
    "\u2728"
];
const $bdd596b34dcec0e4$var$actions = {
    addConfettiColumn: (columnId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const confettiColumns = new Set(currentState.confettiColumns);
            confettiColumns.add(columnId);
            setState({
                confettiColumns: confettiColumns
            });
        },
    removeConfettiColumn: (columnId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const confettiColumns = new Set(currentState.confettiColumns);
            confettiColumns.delete(columnId);
            setState({
                confettiColumns: confettiColumns
            });
        }
};
const $bdd596b34dcec0e4$export$a2ded958dc3b3a = (0, $WBLbN.createContainer)();
const $bdd596b34dcec0e4$var$store = (0, $WBLbN.createStore)({
    name: 'JWMConfettiColumnsStore',
    containedBy: $bdd596b34dcec0e4$export$a2ded958dc3b3a,
    initialState: {
        confettiColumns: new Set()
    },
    actions: $bdd596b34dcec0e4$var$actions
});
const $bdd596b34dcec0e4$var$useConfettiColumnsStore = (0, $WBLbN.createHook)($bdd596b34dcec0e4$var$store);
const $bdd596b34dcec0e4$var$useConfettiColumnsActions = (0, $WBLbN.createActionsHook)($bdd596b34dcec0e4$var$store);
const $bdd596b34dcec0e4$export$d2d8be1cdd91d59f = ()=>{
    const [{ confettiColumns: confettiColumns }, { removeConfettiColumn: removeConfettiColumn }] = $bdd596b34dcec0e4$var$useConfettiColumnsStore();
    return {
        confettiColumns: confettiColumns,
        removeConfettiColumn: removeConfettiColumn
    };
};
const $bdd596b34dcec0e4$export$5f36accfd50e20fd = ()=>{
    const collapsedColumnIds = (0, $lnmSR.useCollapsedColumnIds)();
    const { addConfettiColumn: addConfettiColumn } = $bdd596b34dcec0e4$var$useConfettiColumnsActions();
    const addConfettiColumnWithCheck = (columnId)=>{
        if (!collapsedColumnIds.includes(columnId)) addConfettiColumn(columnId);
    };
    return addConfettiColumnWithCheck;
};
const $bdd596b34dcec0e4$export$44c2e17e7d7d4d24 = (str)=>$bdd596b34dcec0e4$var$COLUMN_CONFETTI_NAMES.some((emoji)=>str.includes(emoji));

});
parcelRegister("lnmSR", function(module, exports) {

$parcel$export(module.exports, "useCollapsedColumnIds", () => $b1fee01dd111e5cd$export$fdfb8ac54a686d2f);
$parcel$export(module.exports, "useExpandCollapse", () => $b1fee01dd111e5cd$export$9b6687336a4cef1c);
$parcel$export(module.exports, "useExpandCollapseAllColumns", () => $b1fee01dd111e5cd$export$bc447e7b85c60666);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $iXHUp = parcelRequire("iXHUp");

var $gKXju = parcelRequire("gKXju");
const $b1fee01dd111e5cd$var$emptyColumnKeys = {
    [(0, $jGcn0.GROUP_BY_STATUS)]: [],
    [(0, $jGcn0.GROUP_BY_ASSIGNEE)]: [],
    [(0, $jGcn0.GROUP_BY_PRIORITY)]: [],
    [(0, $jGcn0.GROUP_BY_CATEGORY)]: []
};
const $b1fee01dd111e5cd$export$fdfb8ac54a686d2f = ()=>{
    const groupBy = (0, $iXHUp.useGroupByField)();
    const [collapsedColumnsByGroupBy] = (0, $7c3W1.useViewPreference)((0, $ji3xf.COLLAPSED_COLUMNS_PREFERENCE));
    const collapsedColumns = (0, $eUqFw.useMemo)(()=>{
        if (collapsedColumnsByGroupBy && typeof collapsedColumnsByGroupBy === 'object') {
            const collapsedKeys = collapsedColumnsByGroupBy[groupBy];
            if (Array.isArray(collapsedKeys)) return collapsedKeys;
        }
        return [];
    }, [
        collapsedColumnsByGroupBy,
        groupBy
    ]);
    return collapsedColumns;
};
const $b1fee01dd111e5cd$export$9b6687336a4cef1c = (groupId)=>{
    const groupBy = (0, $iXHUp.useGroupByField)();
    const [collapsedColumnsByGroupBy, updateCollapsedColumns] = (0, $7c3W1.useViewPreference)((0, $ji3xf.COLLAPSED_COLUMNS_PREFERENCE));
    const collapsedColumns = $b1fee01dd111e5cd$export$fdfb8ac54a686d2f();
    const isCollapsed = (0, $eUqFw.useMemo)(()=>collapsedColumns.includes(groupId), [
        collapsedColumns,
        groupId
    ]);
    const toggleCollapse = (0, $eUqFw.useCallback)(()=>{
        let newCollapsedKeys = [];
        if (isCollapsed) // Remove ID to expand column
        newCollapsedKeys = collapsedColumns.filter((collapsedColumnKey)=>groupId !== collapsedColumnKey);
        else // Add ID to collapse column
        newCollapsedKeys = [
            ...collapsedColumns,
            groupId
        ];
        updateCollapsedColumns({
            ...collapsedColumnsByGroupBy ?? $b1fee01dd111e5cd$var$emptyColumnKeys,
            [groupBy]: newCollapsedKeys
        });
    }, [
        collapsedColumns,
        collapsedColumnsByGroupBy,
        groupBy,
        groupId,
        isCollapsed,
        updateCollapsedColumns
    ]);
    return {
        isCollapsed: isCollapsed,
        toggleCollapse: toggleCollapse
    };
};
const $b1fee01dd111e5cd$export$bc447e7b85c60666 = ()=>{
    const groupBy = (0, $iXHUp.useGroupByField)();
    const [collapsedColumnsByGroupBy, updateCollapsedColumns] = (0, $7c3W1.useViewPreference)((0, $ji3xf.COLLAPSED_COLUMNS_PREFERENCE));
    const groupColumns = (0, $gKXju.useGroups)();
    const collapseAllColumns = (0, $eUqFw.useCallback)(()=>{
        const columnKeys = groupColumns.map((column)=>column.id ?? '');
        updateCollapsedColumns({
            ...collapsedColumnsByGroupBy ?? $b1fee01dd111e5cd$var$emptyColumnKeys,
            [groupBy]: columnKeys
        });
    }, [
        groupBy,
        groupColumns,
        collapsedColumnsByGroupBy,
        updateCollapsedColumns
    ]);
    const expandAllColumns = (0, $eUqFw.useCallback)(()=>{
        updateCollapsedColumns({
            ...collapsedColumnsByGroupBy ?? $b1fee01dd111e5cd$var$emptyColumnKeys,
            [groupBy]: []
        });
    }, [
        collapsedColumnsByGroupBy,
        groupBy,
        updateCollapsedColumns
    ]);
    return {
        collapseAllColumns: collapseAllColumns,
        expandAllColumns: expandAllColumns
    };
};

});
parcelRegister("iXHUp", function(module, exports) {

$parcel$export(module.exports, "useGroupBy", () => $31d26bc9b6a9f109$export$c4ec754551fa3ff4);
$parcel$export(module.exports, "useGroupByField", () => $31d26bc9b6a9f109$export$1897bb3806cdf8b6);
$parcel$export(module.exports, "useGroupByOptions", () => $31d26bc9b6a9f109$export$b3c181458faa8480);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $gEmpR = parcelRequire("gEmpR");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $lO4Or = parcelRequire("lO4Or");
const $31d26bc9b6a9f109$var$DEFAULT_GROUP_BY = (0, $jGcn0.GROUP_BY_STATUS);
const $31d26bc9b6a9f109$var$getGroupByValue = (groupByPreference)=>{
    if (groupByPreference === (0, $jGcn0.GROUP_BY_STATUS)) return 0, $jGcn0.GROUP_BY_STATUS;
    if (groupByPreference === (0, $jGcn0.GROUP_BY_ASSIGNEE)) return 0, $jGcn0.GROUP_BY_ASSIGNEE;
    if (groupByPreference === (0, $jGcn0.GROUP_BY_PRIORITY)) return 0, $jGcn0.GROUP_BY_PRIORITY;
    if (groupByPreference?.includes('customfield')) return 0, $jGcn0.GROUP_BY_CATEGORY;
    return $31d26bc9b6a9f109$var$DEFAULT_GROUP_BY;
};
const $31d26bc9b6a9f109$export$c4ec754551fa3ff4 = ()=>{
    const [groupByPreference, setGroupByPreference] = (0, $7c3W1.useViewPreference)((0, $ji3xf.GROUPING_PREFERENCE));
    const setGroupBy = (0, $eUqFw.useCallback)((value)=>{
        // Set the default type value to undefined so we don't show query param for the default value
        if (value === (0, $jGcn0.GROUP_BY_STATUS)) setGroupByPreference(undefined);
        else setGroupByPreference(value);
    }, [
        setGroupByPreference
    ]);
    return [
        $31d26bc9b6a9f109$var$getGroupByValue(groupByPreference),
        setGroupBy
    ];
};
const $31d26bc9b6a9f109$export$1897bb3806cdf8b6 = ()=>{
    const [groupByPreference] = (0, $7c3W1.useViewPreference)((0, $ji3xf.GROUPING_PREFERENCE));
    return $31d26bc9b6a9f109$var$getGroupByValue(groupByPreference);
};
const $31d26bc9b6a9f109$export$b3c181458faa8480 = ()=>{
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    return (0, $eUqFw.useMemo)(()=>{
        const options = new Set([
            (0, $jGcn0.GROUP_BY_STATUS)
        ]);
        // if we don't have the issue types data yet, return all options
        if (!typesWithFields.length) {
            options.add((0, $jGcn0.GROUP_BY_ASSIGNEE));
            options.add((0, $jGcn0.GROUP_BY_PRIORITY));
            options.add((0, $jGcn0.GROUP_BY_CATEGORY));
            return options;
        }
        typesWithFields.forEach((type)=>{
            // do not consider subtasks type
            if (type.issueType.hierarchyLevel < 0) return;
            type.fields.forEach((field)=>{
                if (field.type === (0, $jGcn0.GROUP_BY_ASSIGNEE) || field.type === (0, $jGcn0.GROUP_BY_PRIORITY)) options.add(field.type);
                else if (field.type === (0, $lO4Or.CATEGORY_TYPE)) options.add((0, $jGcn0.GROUP_BY_CATEGORY));
            });
        });
        return options;
    }, [
        typesWithFields
    ]);
};

});

parcelRegister("gKXju", function(module, exports) {

$parcel$export(module.exports, "GroupsProvider", () => $91ff6e8e07e8b83f$export$c4c2327ef89cf163);
$parcel$export(module.exports, "useGroups", () => $91ff6e8e07e8b83f$export$55065ab2491a4a0c);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $iXHUp = parcelRequire("iXHUp");

var $9QB5c = parcelRequire("9QB5c");
const $91ff6e8e07e8b83f$var$GroupsContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $91ff6e8e07e8b83f$var$AssigneeGroupsSetter = ({ onGroupsChange: onGroupsChange })=>{
    const groups = (0, $9QB5c.useAssigneeGroups)();
    (0, $eUqFw.useEffect)(()=>{
        onGroupsChange(groups);
    }, [
        groups,
        onGroupsChange
    ]);
    return null;
};
const $91ff6e8e07e8b83f$var$CategoryGroupsSetter = ({ onGroupsChange: onGroupsChange })=>{
    const groups = (0, $9QB5c.useCategoryGroups)();
    (0, $eUqFw.useEffect)(()=>{
        onGroupsChange(groups);
    }, [
        groups,
        onGroupsChange
    ]);
    return null;
};
const $91ff6e8e07e8b83f$var$PriorityGroupsSetter = ({ onGroupsChange: onGroupsChange })=>{
    const groups = (0, $9QB5c.usePriorityGroups)();
    (0, $eUqFw.useEffect)(()=>{
        onGroupsChange(groups);
    }, [
        groups,
        onGroupsChange
    ]);
    return null;
};
const $91ff6e8e07e8b83f$var$StatusGroupsSetter = ({ onGroupsChange: onGroupsChange })=>{
    const groups = (0, $9QB5c.useStatusGroups)();
    (0, $eUqFw.useEffect)(()=>{
        onGroupsChange(groups);
    }, [
        groups,
        onGroupsChange
    ]);
    return null;
};
const $91ff6e8e07e8b83f$export$c4c2327ef89cf163 = ({ children: children })=>{
    const groupBy = (0, $iXHUp.useGroupByField)();
    const [groups, setGroups] = (0, $eUqFw.useState)([]);
    let GroupSetter;
    switch(groupBy){
        case 0, $jGcn0.GROUP_BY_ASSIGNEE:
            GroupSetter = $91ff6e8e07e8b83f$var$AssigneeGroupsSetter;
            break;
        case 0, $jGcn0.GROUP_BY_CATEGORY:
            GroupSetter = $91ff6e8e07e8b83f$var$CategoryGroupsSetter;
            break;
        case 0, $jGcn0.GROUP_BY_PRIORITY:
            GroupSetter = $91ff6e8e07e8b83f$var$PriorityGroupsSetter;
            break;
        case 0, $jGcn0.GROUP_BY_STATUS:
            GroupSetter = $91ff6e8e07e8b83f$var$StatusGroupsSetter;
            break;
        default:
            {
                const exhaustiveCheck = groupBy;
                throw new Error(`Unexpected groupBy value: ${exhaustiveCheck}`);
            }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($91ff6e8e07e8b83f$var$GroupsContext.Provider, {
        value: groups
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(GroupSetter, {
        onGroupsChange: setGroups
    }));
};
const $91ff6e8e07e8b83f$export$55065ab2491a4a0c = ()=>{
    const context = (0, $eUqFw.useContext)($91ff6e8e07e8b83f$var$GroupsContext);
    if (!context) throw new Error('useGroups must be used within a GroupsProvider');
    return context;
};

});
parcelRegister("9QB5c", function(module, exports) {

$parcel$export(module.exports, "useAssigneeGroups", () => $9c82db01a350fd0e$export$ecac68cd9ce8682c);
$parcel$export(module.exports, "useCategoryGroups", () => $9c82db01a350fd0e$export$2b65473e959d1be7);
$parcel$export(module.exports, "usePriorityGroups", () => $9c82db01a350fd0e$export$9ad7fd5c13dc6dbb);
$parcel$export(module.exports, "useStatusGroups", () => $9c82db01a350fd0e$export$de3bb934718a3348);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $gEmpR = parcelRequire("gEmpR");

var $8Qd0L = parcelRequire("8Qd0L");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");

var $d1mZL = parcelRequire("d1mZL");

var $2XClh = parcelRequire("2XClh");

var $iq40z = parcelRequire("iq40z");
const $9c82db01a350fd0e$var$getPriorityOptions = (fields)=>{
    const priorityField = fields.find((field)=>field.type === (0, $lO4Or.PRIORITY_TYPE));
    return priorityField?.fieldConfig?.options ?? [];
};
const $9c82db01a350fd0e$var$getCategoryOptions = (fields)=>{
    const categoryField = fields.find((field)=>field.type === (0, $lO4Or.CATEGORY_TYPE));
    return categoryField?.fieldConfig?.selectOptions ?? [];
};
const $9c82db01a350fd0e$export$ecac68cd9ce8682c = ()=>{
    const users = (0, $d1mZL.useIssueAssignees)();
    const sortGroups = (0, $2XClh.useSortGroups)();
    return (0, $eUqFw.useMemo)(()=>{
        const groups = [
            {
                id: (0, $ib4WI.NULL_GROUP_KEY),
                imageUrl: null,
                name: '',
                type: (0, $jGcn0.GROUP_BY_ASSIGNEE)
            }
        ];
        users?.forEach(({ accountId: accountId, name: name, avatarURL: avatarURL })=>{
            groups.push({
                id: accountId,
                imageUrl: avatarURL,
                name: name,
                type: (0, $jGcn0.GROUP_BY_ASSIGNEE)
            });
        });
        return sortGroups(groups);
    }, [
        sortGroups,
        users
    ]);
};
const $9c82db01a350fd0e$export$2b65473e959d1be7 = ()=>{
    const { data: { fields: fields } } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const sortGroups = (0, $2XClh.useSortGroups)();
    return (0, $eUqFw.useMemo)(()=>{
        const groups = [
            {
                color: null,
                id: (0, $ib4WI.NULL_GROUP_KEY),
                name: '',
                type: (0, $jGcn0.GROUP_BY_CATEGORY)
            }
        ];
        const categoryOptions = $9c82db01a350fd0e$var$getCategoryOptions(fields);
        categoryOptions.forEach(({ label: label, color: color, optionId: optionId })=>{
            if (optionId) groups.push({
                color: color ?? null,
                id: String(optionId),
                name: label,
                type: (0, $jGcn0.GROUP_BY_CATEGORY)
            });
        });
        return sortGroups(groups);
    }, [
        fields,
        sortGroups
    ]);
};
const $9c82db01a350fd0e$export$9ad7fd5c13dc6dbb = ()=>{
    const { data: { fields: fields } } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const sortGroups = (0, $2XClh.useSortGroups)();
    return (0, $eUqFw.useMemo)(()=>{
        const priorityOptions = $9c82db01a350fd0e$var$getPriorityOptions(fields);
        const groups = priorityOptions.map(({ name: name, priorityId: priorityId, iconUrl: iconUrl })=>({
                id: priorityId,
                imageUrl: iconUrl,
                name: name,
                type: (0, $jGcn0.GROUP_BY_PRIORITY)
            }));
        return sortGroups(groups);
    }, [
        fields,
        sortGroups
    ]);
};
const $9c82db01a350fd0e$export$de3bb934718a3348 = ()=>{
    const { columns: columns } = (0, $iq40z.useWorkflowStoreState)();
    return (0, $eUqFw.useMemo)(()=>{
        const groups = columns.map(({ name: name, statusId: statusId, statusCategory: statusCategory })=>({
                id: String(statusId),
                name: name,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                statusCategoryId: (0, $8Qd0L.StatusCategoryIds)[statusCategory],
                type: (0, $jGcn0.GROUP_BY_STATUS)
            }));
        return groups;
    }, [
        columns
    ]);
};

});
parcelRegister("2XClh", function(module, exports) {

$parcel$export(module.exports, "useGroupsOrder", () => $d6c7bc83d6e84e98$export$b952fbf263ab4b98);
$parcel$export(module.exports, "useSortGroups", () => $d6c7bc83d6e84e98$export$41ac6817d8a83a93);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $ib4WI = parcelRequire("ib4WI");

var $iXHUp = parcelRequire("iXHUp");
const $d6c7bc83d6e84e98$export$b952fbf263ab4b98 = ()=>{
    const groupBy = (0, $iXHUp.useGroupByField)();
    const [orderedGroupsByGroupBy, setGroupsOrderPreference] = (0, $7c3W1.useViewPreference)((0, $ji3xf.COLUMNS_ORDER_PREFERENCE));
    const setGroupOrder = (0, $eUqFw.useCallback)((newGroupsOrderKeys)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setGroupsOrderPreference({
            ...orderedGroupsByGroupBy,
            [groupBy]: newGroupsOrderKeys
        });
    }, [
        groupBy,
        orderedGroupsByGroupBy,
        setGroupsOrderPreference
    ]);
    const orderedGroupIds = (0, $eUqFw.useMemo)(()=>orderedGroupsByGroupBy?.[groupBy] ?? null, [
        orderedGroupsByGroupBy,
        groupBy
    ]);
    return [
        orderedGroupIds,
        setGroupOrder
    ];
};
const $d6c7bc83d6e84e98$export$41ac6817d8a83a93 = ()=>{
    const [orderedGroupsKeys] = $d6c7bc83d6e84e98$export$b952fbf263ab4b98();
    const groupBy = (0, $iXHUp.useGroupByField)();
    return (0, $eUqFw.useCallback)((groups)=>{
        const indexInOrder = (groupId, order)=>{
            const index = order.indexOf(groupId);
            return index >= 0 ? index : groups.length;
        };
        if (orderedGroupsKeys == null) {
            if (groupBy === (0, $jGcn0.GROUP_BY_PRIORITY)) // Priority groups are already sorted based on the order in the field configuration
            return groups;
            return groups.sort((groupA, groupB)=>{
                if (groupA.id === (0, $ib4WI.NULL_GROUP_KEY)) return -1;
                if (groupB.id === (0, $ib4WI.NULL_GROUP_KEY)) return 1;
                // Sort fields alphabetically
                return groupA.name.localeCompare(groupB.name);
            });
        }
        return groups.sort((groupA, groupB)=>indexInOrder(groupA.id, orderedGroupsKeys) - indexInOrder(groupB.id, orderedGroupsKeys));
    }, [
        groupBy,
        orderedGroupsKeys
    ]);
};

});





parcelRegister("gWYTK", function(module, exports) {

$parcel$export(module.exports, "CardDragDropProvider", () => $c2ce2edab203bb3e$export$b1ccb12106075e69);
$parcel$export(module.exports, "useStartCardDrag", () => $c2ce2edab203bb3e$export$c489958ad236599c);
$parcel$export(module.exports, "useCancelConfirmCardDrop", () => $c2ce2edab203bb3e$export$124d43f574a408ec);
$parcel$export(module.exports, "useUpdateDropTarget", () => $c2ce2edab203bb3e$export$fd80b4a210addcaa);
$parcel$export(module.exports, "useResetDropTarget", () => $c2ce2edab203bb3e$export$886c7f1b5e5013b3);
$parcel$export(module.exports, "useHighlightedIssue", () => $c2ce2edab203bb3e$export$daf5b1f2d290b352);
$parcel$export(module.exports, "useCardDragDrop", () => $c2ce2edab203bb3e$export$51dcb5ebefb8c3d7);
$parcel$export(module.exports, "useCanDropCard", () => $c2ce2edab203bb3e$export$6075fd3ad3110a90);
$parcel$export(module.exports, "useInferredDropTargetTransition", () => $c2ce2edab203bb3e$export$79dfb0dde692631b);
$parcel$export(module.exports, "useUpdateSessionId", () => $c2ce2edab203bb3e$export$c6e81f4ae8465e96);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $gEmpR = parcelRequire("gEmpR");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");

var $ay4XV = parcelRequire("ay4XV");

var $d4s3F = parcelRequire("d4s3F");
const $c2ce2edab203bb3e$var$emptyDropTarget = {
    groupId: null,
    transition: null
};
const $c2ce2edab203bb3e$var$reducer = (state, action)=>{
    switch(action.type){
        case 'startDrag':
            return {
                ...state,
                ...action.value
            };
        case 'cancelDrop':
            return {
                ...state,
                draggedIssue: null,
                sourceGroup: null,
                dropTarget: $c2ce2edab203bb3e$var$emptyDropTarget,
                updateSessionId: null
            };
        case 'confirmDrop':
            return {
                ...state,
                draggedIssue: null,
                sourceGroup: null,
                dropTarget: $c2ce2edab203bb3e$var$emptyDropTarget,
                updateSessionId: null,
                highlightedIssueId: state.draggedIssue?.id ?? null
            };
        case 'updateDropTarget':
            return {
                ...state,
                dropTarget: {
                    ...state.dropTarget,
                    ...action.value
                }
            };
        case 'resetDropTarget':
            return {
                ...state,
                dropTarget: $c2ce2edab203bb3e$var$emptyDropTarget
            };
        case 'resetHighlightedIssue':
            return {
                ...state,
                highlightedIssueId: null
            };
        default:
            return state;
    }
};
const $c2ce2edab203bb3e$var$initialState = {
    draggedIssue: null,
    sourceGroup: null,
    dropTarget: $c2ce2edab203bb3e$var$emptyDropTarget,
    updateSessionId: null,
    highlightedIssueId: null
};
const $c2ce2edab203bb3e$var$CardDragDropContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $c2ce2edab203bb3e$export$b1ccb12106075e69 = ({ children: children })=>{
    const [state, dispatch] = (0, $eUqFw.useReducer)($c2ce2edab203bb3e$var$reducer, $c2ce2edab203bb3e$var$initialState);
    const value = (0, $eUqFw.useMemo)(()=>({
            ...state,
            dispatch: dispatch
        }), [
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c2ce2edab203bb3e$var$CardDragDropContext.Provider, {
        value: value
    }, children);
};
const $c2ce2edab203bb3e$var$useCardDragDropContext = ()=>{
    const context = (0, $eUqFw.useContext)($c2ce2edab203bb3e$var$CardDragDropContext);
    if (!context) throw new Error('useCardDragDropContext must be used within a CardDragDropProvider');
    return context;
};
const $c2ce2edab203bb3e$export$c489958ad236599c = ()=>{
    const { dispatch: dispatch } = $c2ce2edab203bb3e$var$useCardDragDropContext();
    const { fetch: fetchIssueTransitions } = (0, $ay4XV.useIssueTransitions)();
    const { fireStartCardDragAnalytics: fireStartCardDragAnalytics } = (0, $d4s3F.useCardDragDropAnalytics)();
    return (0, $eUqFw.useCallback)((issue, group)=>{
        const updateSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
        dispatch({
            type: 'startDrag',
            value: {
                draggedIssue: issue,
                sourceGroup: group,
                updateSessionId: updateSessionId
            }
        });
        fireStartCardDragAnalytics(updateSessionId);
        if (group.type === (0, $jGcn0.GROUP_BY_STATUS)) fetchIssueTransitions(issue);
    }, [
        dispatch,
        fetchIssueTransitions,
        fireStartCardDragAnalytics
    ]);
};
const $c2ce2edab203bb3e$export$124d43f574a408ec = ()=>{
    const { dispatch: dispatch } = $c2ce2edab203bb3e$var$useCardDragDropContext();
    const cancelCardDrop = (0, $eUqFw.useCallback)(()=>dispatch({
            type: 'cancelDrop'
        }), [
        dispatch
    ]);
    const confirmCardDrop = (0, $eUqFw.useCallback)(()=>dispatch({
            type: 'confirmDrop'
        }), [
        dispatch
    ]);
    return {
        cancelCardDrop: cancelCardDrop,
        confirmCardDrop: confirmCardDrop
    };
};
const $c2ce2edab203bb3e$export$fd80b4a210addcaa = ()=>{
    const { dispatch: dispatch } = $c2ce2edab203bb3e$var$useCardDragDropContext();
    return (0, $eUqFw.useCallback)((newDropTarget)=>dispatch({
            type: 'updateDropTarget',
            value: newDropTarget
        }), [
        dispatch
    ]);
};
const $c2ce2edab203bb3e$export$886c7f1b5e5013b3 = ()=>{
    const { dispatch: dispatch } = $c2ce2edab203bb3e$var$useCardDragDropContext();
    return (0, $eUqFw.useCallback)(()=>dispatch({
            type: 'resetDropTarget'
        }), [
        dispatch
    ]);
};
const $c2ce2edab203bb3e$export$daf5b1f2d290b352 = ()=>{
    const { dispatch: dispatch, highlightedIssueId: highlightedIssueId } = $c2ce2edab203bb3e$var$useCardDragDropContext();
    const resetHighlightedIssue = (0, $eUqFw.useCallback)(()=>dispatch({
            type: 'resetHighlightedIssue'
        }), [
        dispatch
    ]);
    return {
        highlightedIssueId: highlightedIssueId,
        resetHighlightedIssue: resetHighlightedIssue
    };
};
const $c2ce2edab203bb3e$export$51dcb5ebefb8c3d7 = ()=>$c2ce2edab203bb3e$var$useCardDragDropContext();
const $c2ce2edab203bb3e$var$GROUP_TYPE_TO_FIELD_TYPE = {
    [(0, $jGcn0.GROUP_BY_ASSIGNEE)]: (0, $lO4Or.ASSIGNEE_TYPE),
    [(0, $jGcn0.GROUP_BY_CATEGORY)]: (0, $lO4Or.CATEGORY_TYPE),
    [(0, $jGcn0.GROUP_BY_PRIORITY)]: (0, $lO4Or.PRIORITY_TYPE)
};
const $c2ce2edab203bb3e$export$6075fd3ad3110a90 = (group)=>{
    const project = (0, $kQAZu.useProject)();
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)();
    const { sourceGroup: sourceGroup, draggedIssue: draggedIssue, dropTarget: dropTarget } = $c2ce2edab203bb3e$var$useCardDragDropContext();
    const { transitions: transitions, loading: loading, hasError: hasError } = (0, $ay4XV.useIssueTransitions)();
    const canRank = project.permissions.scheduleIssues;
    const isSameGroup = sourceGroup?.id === group.id;
    const areTransitionsUnavailable = loading || hasError;
    if (!draggedIssue) return {
        canDropInGroup: 'unknown',
        canDropAgainstCard: 'unknown'
    };
    if (group.type !== (0, $jGcn0.GROUP_BY_STATUS)) {
        let canDropInGroup = 'unknown';
        if (!isSameGroup) {
            // check if the field is available for the dragged issue's issue type
            const fieldType = $c2ce2edab203bb3e$var$GROUP_TYPE_TO_FIELD_TYPE[group.type];
            const issueType = typesWithFields.find((type)=>type.issueType.id === draggedIssue.fields[0, $ib4WI.ISSUE_TYPE_ID].issueType.id);
            const hasField = issueType?.fields.some((field)=>field.type === fieldType);
            canDropInGroup = hasField ? 'yes' : 'no';
        }
        return {
            canDropInGroup: canDropInGroup,
            canDropAgainstCard: canRank && canDropInGroup !== 'no' ? 'yes' : 'no'
        };
    }
    if (isSameGroup && areTransitionsUnavailable) return {
        canDropInGroup: 'unknown',
        canDropAgainstCard: canRank ? 'yes' : 'no'
    };
    if (areTransitionsUnavailable) return {
        canDropInGroup: 'unknown',
        canDropAgainstCard: 'unknown'
    };
    const transitionsToGroup = transitions.filter((transition)=>String(transition.toStatusId) === group.id);
    let canDropInGroup = 'no';
    let canDropAgainstCard = canRank ? 'yes' : 'no';
    if (isSameGroup) {
        const selfTransitions = transitionsToGroup.filter((t)=>!t.isGlobal);
        canDropInGroup = selfTransitions.length > 0 ? 'choice-available' : 'unknown';
        if (dropTarget.transition != null) canDropInGroup = 'yes';
    } else if (transitionsToGroup.length === 0) canDropAgainstCard = 'no';
    else if (transitionsToGroup.length === 1) canDropInGroup = 'yes';
    else if (transitionsToGroup.length > 1) {
        canDropInGroup = dropTarget.transition == null ? 'choice-required' : 'yes';
        canDropAgainstCard = canRank && canDropInGroup === 'yes' ? 'yes' : 'no';
    }
    return {
        canDropInGroup: canDropInGroup,
        canDropAgainstCard: canDropAgainstCard
    };
};
const $c2ce2edab203bb3e$export$79dfb0dde692631b = (group)=>{
    const { sourceGroup: sourceGroup } = $c2ce2edab203bb3e$var$useCardDragDropContext();
    const { transitions: transitions } = (0, $ay4XV.useIssueTransitions)();
    const destinationGroupId = group.id;
    if (sourceGroup?.type !== (0, $jGcn0.GROUP_BY_STATUS) || sourceGroup.id === destinationGroupId || transitions.length === 0) return null;
    const transitionsToDestinationGroup = transitions.filter((transition)=>String(transition.toStatusId) === destinationGroupId);
    return transitionsToDestinationGroup.length === 1 ? transitionsToDestinationGroup[0] : null;
};
const $c2ce2edab203bb3e$export$c6e81f4ae8465e96 = ()=>{
    const { updateSessionId: updateSessionId } = $c2ce2edab203bb3e$var$useCardDragDropContext();
    return updateSessionId;
};

});
parcelRegister("ay4XV", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionsProvider", () => $9e2e3a7403c9b4ae$export$504c5361b0788bb);
$parcel$export(module.exports, "useIssueTransitions", () => $9e2e3a7403c9b4ae$export$4868b6fb356ee1e7);

var $eUqFw = parcelRequire("eUqFw");

var $NFHn0 = parcelRequire("NFHn0");

var $79xbN = parcelRequire("79xbN");

var $7byHA = parcelRequire("7byHA");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ib4WI = parcelRequire("ib4WI");

var $99zuh = parcelRequire("99zuh");

var $iq40z = parcelRequire("iq40z");

var $grmpM = parcelRequire("grmpM");
const $9e2e3a7403c9b4ae$var$IssueTransitionsContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $9e2e3a7403c9b4ae$var$initialState = {
    hasError: false,
    loading: false,
    transitions: []
};
const $9e2e3a7403c9b4ae$var$reducer = (state, action)=>{
    switch(action.type){
        case 'fetch':
            return {
                ...state,
                hasError: false,
                loading: true,
                transitions: []
            };
        case 'success':
            return {
                ...state,
                hasError: false,
                loading: false,
                transitions: action.value
            };
        case 'error':
            return {
                ...state,
                hasError: true,
                loading: false,
                transitions: []
            };
        default:
            return state;
    }
};
const $9e2e3a7403c9b4ae$export$504c5361b0788bb = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { transitions: workflowTransitions } = (0, $iq40z.useWorkflowStoreState)();
    const [{ loading: loading, hasError: hasError, transitions: transitions }, dispatch] = (0, $eUqFw.useReducer)($9e2e3a7403c9b4ae$var$reducer, $9e2e3a7403c9b4ae$var$initialState);
    const abortableFetchIssueTransitions = (0, $NFHn0.useAbortable)((0, $99zuh.fetchIssueTransitions));
    const fetch = (0, $eUqFw.useCallback)(async (issue)=>{
        // check if any of the relevant workflow transitions are conditional
        const fromStatusId = Number(issue.fields[0, $ib4WI.STATUS_ID].status.id);
        const eligibleTransitions = workflowTransitions.filter((transition)=>transition.fromStatusId === fromStatusId || transition.isGlobal);
        // if none of the eligible transitions are conditional, then we do not need to fetch
        // the transitions from the server
        if (eligibleTransitions.every((transition)=>!transition.isConditional)) {
            dispatch({
                type: 'success',
                value: eligibleTransitions
            });
            return;
        }
        try {
            dispatch({
                type: 'fetch'
            });
            const response = await abortableFetchIssueTransitions(issue.id);
            dispatch({
                type: 'success',
                value: response
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error === (0, $NFHn0.ABORTED)) return;
            dispatch({
                type: 'error'
            });
            if (error instanceof (0, $7byHA.default) && error.statusCode === 404) {
                showFlag({
                    description: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $grmpM.default).notFoundErrorMessageIssueTermRefresh : (0, $grmpM.default).notFoundErrorMessage),
                    title: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $grmpM.default).notFoundErrorTitleIssueTermRefresh : (0, $grmpM.default).notFoundErrorTitle),
                    type: 'error'
                });
                return;
            }
            showFlag({
                description: formatMessage((0, $grmpM.default).errorMessage),
                title: formatMessage((0, $grmpM.default).errorTitle),
                type: 'error'
            });
        }
    }, [
        abortableFetchIssueTransitions,
        formatMessage,
        showFlag,
        workflowTransitions
    ]);
    const value = (0, $eUqFw.useMemo)(()=>({
            fetch: fetch,
            hasError: hasError,
            loading: loading,
            transitions: transitions
        }), [
        fetch,
        hasError,
        loading,
        transitions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e2e3a7403c9b4ae$var$IssueTransitionsContext.Provider, {
        value: value
    }, children);
};
const $9e2e3a7403c9b4ae$export$4868b6fb356ee1e7 = ()=>{
    const context = (0, $eUqFw.useContext)($9e2e3a7403c9b4ae$var$IssueTransitionsContext);
    if (!context) throw new Error('useIssueTransitions must be used within a IssueTransitionsProvider');
    return context;
};

});
parcelRegister("99zuh", function(module, exports) {

$parcel$export(module.exports, "fetchIssueTransitions", () => $1d427dc2c26eea30$export$abb47d81cfdbea9e);

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");

var $lRmyA = parcelRequire("lRmyA");
const $1d427dc2c26eea30$export$abb47d81cfdbea9e = async (signal, issueId)=>{
    try {
        const response = await (0, $lRmyA.performGetRequest)(`/rest/api/3/issue/${issueId}/transitions`, {
            signal: signal
        });
        return response.transitions.map((transition)=>({
                transitionId: Number(transition.id),
                name: transition.name,
                isConditional: transition.isConditional,
                isGlobal: transition.isGlobal,
                isInitial: transition.isInitial,
                hasScreen: transition.hasScreen,
                toStatusId: Number(transition.to.id)
            }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $JRB5w.isHttpClientErrorResponse)(error) && !signal.aborted) (0, $guiFP.default)({
            meta: {
                id: 'fetchIssueTransitions',
                packageName: 'jiraWorkManagementBoard',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});

parcelRegister("grmpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4d49a2a6b3a2014$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e4d49a2a6b3a2014$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "work-management-board.controllers.issue-transitions.error-title",
        "defaultMessage": "We couldn't load transitions"
    },
    errorMessage: {
        "id": "work-management-board.controllers.issue-transitions.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    notFoundErrorTitle: {
        "id": "work-management-board.controllers.issue-transitions.not-found-error-title",
        "defaultMessage": "Issue not found"
    },
    notFoundErrorMessage: {
        "id": "work-management-board.controllers.issue-transitions.not-found-error-message",
        "defaultMessage": "Looks like this issue has been removed. Refresh the page, then try again."
    },
    notFoundErrorTitleIssueTermRefresh: {
        "id": "work-management-board.controllers.issue-transitions.not-found-error-title-issue-term-refresh",
        "defaultMessage": "Issue not found"
    },
    notFoundErrorMessageIssueTermRefresh: {
        "id": "work-management-board.controllers.issue-transitions.not-found-error-message-issue-term-refresh",
        "defaultMessage": "Looks like this issue has been removed. Refresh the page, then try again."
    }
});

});


parcelRegister("d4s3F", function(module, exports) {

$parcel$export(module.exports, "useCardDragDropAnalytics", () => $8a4ff52153cb8c04$export$bf7082aa7f5f928b);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $3bukT = parcelRequire("3bukT");

var $8Qd0L = parcelRequire("8Qd0L");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $ib4WI = parcelRequire("ib4WI");
const $8a4ff52153cb8c04$export$bf7082aa7f5f928b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const project = (0, $kQAZu.useProject)();
    const fireStartCardDragAnalytics = (0, $eUqFw.useCallback)((sessionId)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'item'
        });
        const analyticsAttributes = {
            isDragEditing: true,
            updateSessionId: sessionId
        };
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issue', analyticsAttributes);
    }, [
        createAnalyticsEvent
    ]);
    const fireCardDropAnalytics = (0, $eUqFw.useCallback)(({ issue: issue, sourceGroup: sourceGroup, destinationGroup: destinationGroup, rank: rank, transition: transition, updateSessionId: updateSessionId })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'update',
            actionSubject: 'issue'
        });
        const analyticsAttributes = $8a4ff52153cb8c04$var$getAnalyticsAttributes({
            issue: issue,
            sourceGroup: sourceGroup,
            destinationGroup: destinationGroup,
            rank: rank,
            transition: transition,
            project: project,
            updateSessionId: updateSessionId
        });
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'issue updated', 'ended', analyticsAttributes);
    }, [
        createAnalyticsEvent,
        project
    ]);
    return {
        fireStartCardDragAnalytics: fireStartCardDragAnalytics,
        fireCardDropAnalytics: fireCardDropAnalytics
    };
};
const $8a4ff52153cb8c04$var$getAnalyticsAttributes = ({ issue: issue, sourceGroup: sourceGroup, destinationGroup: destinationGroup, rank: rank, transition: transition, project: project, updateSessionId: updateSessionId })=>{
    const sourceGroupId = sourceGroup.id;
    const destinationGroupId = destinationGroup.id;
    const sourceGroupType = sourceGroup.type;
    const destinationGroupType = destinationGroup.type;
    const issueTypeName = issue.fields[0, $ib4WI.ISSUE_TYPE_ID].issueType.name;
    const attributes = {
        assigneeId: issue.fields[0, $ib4WI.ASSIGNEE_ID]?.user?.accountId ?? '',
        fieldType: destinationGroupType,
        fieldKey: destinationGroupType,
        oldValId: sourceGroupId !== (0, $ib4WI.NULL_GROUP_KEY) ? sourceGroupId : '',
        newValId: destinationGroupId !== (0, $ib4WI.NULL_GROUP_KEY) ? destinationGroupId : '',
        isClassic: !project.isSimplified,
        isDragEditing: true,
        isInlineEditing: false,
        hasRankChanged: rank != null,
        isProjectAdmin: project.permissions.administerProject,
        issueId: issue.id,
        issueType: (0, $3bukT.standardIssueTypes)[issueTypeName] ? issueTypeName : (0, $ib4WI.OTHER),
        projectId: project.id,
        updateSessionId: updateSessionId
    };
    if (sourceGroupType === (0, $jGcn0.GROUP_BY_STATUS) && destinationGroupType === (0, $jGcn0.GROUP_BY_STATUS)) {
        attributes.oldStatusCategoryId = sourceGroup.statusCategoryId;
        attributes.newStatusCategoryId = destinationGroup.statusCategoryId;
        attributes.oldStatusCategoryName = (0, $8Qd0L.statusCategoryForId)(sourceGroup.statusCategoryId);
        attributes.newStatusCategoryName = (0, $8Qd0L.statusCategoryForId)(destinationGroup.statusCategoryId);
    }
    if (transition != null) attributes.transitionId = transition.transitionId;
    return attributes;
};

});
parcelRegister("3bukT", function(module, exports) {

$parcel$export(module.exports, "CUSTOM", () => $cc2fecf6996f211b$export$952581bc40160893);
$parcel$export(module.exports, "standardIssueTypes", () => $cc2fecf6996f211b$export$c5b8a33017b6146a);
$parcel$export(module.exports, "translatedTaskNames", () => $cc2fecf6996f211b$export$ae53d86e513cd6);
const $cc2fecf6996f211b$var$EPIC = 'Epic';
const $cc2fecf6996f211b$var$STORY = 'Story';
const $cc2fecf6996f211b$var$BUG = 'Bug';
const $cc2fecf6996f211b$var$TASK = 'Task';
const $cc2fecf6996f211b$export$952581bc40160893 = 'Custom';
const $cc2fecf6996f211b$export$c5b8a33017b6146a = {
    [$cc2fecf6996f211b$var$EPIC]: true,
    [$cc2fecf6996f211b$var$STORY]: true,
    [$cc2fecf6996f211b$var$BUG]: true,
    [$cc2fecf6996f211b$var$TASK]: true
};
const $cc2fecf6996f211b$export$ae53d86e513cd6 = [
    'Task',
    'Aufgabe',
    'Tarea',
    "T\xe2che",
    "\u30BF\u30B9\u30AF",
    "\uC791\uC5C5",
    'Tarefa',
    "\u0417\u0430\u0434\u0430\u0447\u0430",
    "\xdakol",
    "\xdclesanne",
    "Teht\xe4v\xe4",
    'Feladat',
    'Verk',
    'Taak',
    'Opgave',
    'Oppgave',
    'Zadanie',
    'Activitate',
    "\u0417\u0430\u0434\u0430\u0447\u0430",
    "\xdaloha",
    'Uppgift',
    "G\xf6rev",
    "Nhi\u1EC7m v\u1EE5",
    "\u4EFB\u52A1",
    "\u4EFB\u52D9",
    "Attivit\xe0"
];

});



parcelRegister("bJNjm", function(module, exports) {

$parcel$export(module.exports, "ColumnDragDropProvider", () => $53c6eb107c910683$export$f18179b46c61fc8e);
$parcel$export(module.exports, "useColumnDragDrop", () => $53c6eb107c910683$export$c7a612ace05118e9);

var $eUqFw = parcelRequire("eUqFw");
const $53c6eb107c910683$var$ColumnDragDropContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $53c6eb107c910683$export$f18179b46c61fc8e = ({ children: children })=>{
    const [dragState, setDragState] = (0, $eUqFw.useState)({
        draggedColumnId: null,
        dragPreviewState: {
            type: 'idle'
        }
    });
    const value = (0, $eUqFw.useMemo)(()=>({
            ...dragState,
            setDragState: setDragState
        }), [
        dragState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53c6eb107c910683$var$ColumnDragDropContext.Provider, {
        value: value
    }, children);
};
const $53c6eb107c910683$var$useColumnDragDropContext = ()=>{
    const context = (0, $eUqFw.useContext)($53c6eb107c910683$var$ColumnDragDropContext);
    if (!context) throw new Error('useColumnDragDropContext must be used within a ColumnDragDropProvider');
    return context;
};
const $53c6eb107c910683$export$c7a612ace05118e9 = (columnId)=>{
    const { draggedColumnId: draggedColumnId, dragPreviewState: dragPreviewState, setDragState: setDragState } = $53c6eb107c910683$var$useColumnDragDropContext();
    const startColumnDrag = (0, $eUqFw.useCallback)(()=>setDragState((prevDragState)=>({
                ...prevDragState,
                dragPreviewState: {
                    ...prevDragState.dragPreviewState,
                    draggedColumnId: columnId
                }
            })), [
        columnId,
        setDragState
    ]);
    const resetDraggedColumn = (0, $eUqFw.useCallback)(()=>setDragState((prevDragState)=>({
                ...prevDragState,
                draggedColumnId: null
            })), [
        setDragState
    ]);
    const renderDragPreview = (0, $eUqFw.useCallback)((container)=>setDragState((prevDragState)=>({
                ...prevDragState,
                draggedColumnId: columnId,
                dragPreviewState: {
                    container: container,
                    type: 'preview'
                }
            })), [
        columnId,
        setDragState
    ]);
    const cleanupDragPreview = (0, $eUqFw.useCallback)(()=>setDragState((prevDragState)=>({
                ...prevDragState,
                dragPreviewState: {
                    type: 'idle'
                }
            })), [
        setDragState
    ]);
    const isDragging = draggedColumnId === columnId;
    return {
        cleanupDragPreview: cleanupDragPreview,
        dragPreviewState: dragPreviewState,
        isDragging: isDragging,
        renderDragPreview: renderDragPreview,
        resetDraggedColumn: resetDraggedColumn,
        startColumnDrag: startColumnDrag
    };
};

});

parcelRegister("cgK6s", function(module, exports) {

$parcel$export(module.exports, "WorkflowActionsProvider", () => $6153ddf7f13eaaea$export$52383769590f1f7d);
$parcel$export(module.exports, "useIsWorkflowOperationInProgress", () => $6153ddf7f13eaaea$export$d8535539ef06db21);
$parcel$export(module.exports, "useWorkflowOperationStatusId", () => $6153ddf7f13eaaea$export$fcd0c43b34e1ab49);
$parcel$export(module.exports, "useStopWorkflowOperationInProgress", () => $6153ddf7f13eaaea$export$7d25f9f7a4197a33);
$parcel$export(module.exports, "useStartDeleteOperation", () => $6153ddf7f13eaaea$export$f125869614239ac);
$parcel$export(module.exports, "useStartAddOperation", () => $6153ddf7f13eaaea$export$a9547f77ff1cbe18);
$parcel$export(module.exports, "useStartRenameOperation", () => $6153ddf7f13eaaea$export$1763316459ec74d5);

var $eUqFw = parcelRequire("eUqFw");
const $6153ddf7f13eaaea$export$98ff4de2f070152d = {
    DELETING: 'deleting-status',
    ADDING: 'adding-status',
    RENAMING: 'renaming-status'
};
const $6153ddf7f13eaaea$var$WorkflowActionsContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $6153ddf7f13eaaea$export$52383769590f1f7d = ({ children: children })=>{
    const [operationInProgress, setOperationInProgress] = (0, $eUqFw.useState)(null);
    const [statusId, setStatusId] = (0, $eUqFw.useState)(null);
    const value = (0, $eUqFw.useMemo)(()=>({
            statusId: statusId,
            operationInProgress: operationInProgress,
            setStatusId: setStatusId,
            setOperationInProgress: setOperationInProgress
        }), [
        statusId,
        operationInProgress
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6153ddf7f13eaaea$var$WorkflowActionsContext.Provider, {
        value: value
    }, children);
};
const $6153ddf7f13eaaea$export$1f652ba9a3f9f48e = ()=>{
    const context = (0, $eUqFw.useContext)($6153ddf7f13eaaea$var$WorkflowActionsContext);
    if (!context) throw new Error('WorkflowActionsContext must be used within a WorkflowActionsProvider');
    return context;
};
const $6153ddf7f13eaaea$export$d8535539ef06db21 = ()=>{
    const context = $6153ddf7f13eaaea$export$1f652ba9a3f9f48e();
    return context.operationInProgress != null;
};
const $6153ddf7f13eaaea$export$fcd0c43b34e1ab49 = ()=>{
    const context = $6153ddf7f13eaaea$export$1f652ba9a3f9f48e();
    return context.statusId;
};
const $6153ddf7f13eaaea$export$7d25f9f7a4197a33 = ()=>{
    const { setOperationInProgress: setOperationInProgress, setStatusId: setStatusId } = $6153ddf7f13eaaea$export$1f652ba9a3f9f48e();
    return (0, $eUqFw.useCallback)(()=>{
        setOperationInProgress(null);
        setStatusId(null);
    }, [
        setOperationInProgress,
        setStatusId
    ]);
};
const $6153ddf7f13eaaea$export$f125869614239ac = ()=>{
    const { setOperationInProgress: setOperationInProgress } = $6153ddf7f13eaaea$export$1f652ba9a3f9f48e();
    return (0, $eUqFw.useCallback)(()=>{
        setOperationInProgress($6153ddf7f13eaaea$export$98ff4de2f070152d.DELETING);
    }, [
        setOperationInProgress
    ]);
};
const $6153ddf7f13eaaea$export$a9547f77ff1cbe18 = ()=>{
    const { setOperationInProgress: setOperationInProgress, setStatusId: setStatusId } = $6153ddf7f13eaaea$export$1f652ba9a3f9f48e();
    return (0, $eUqFw.useCallback)((statusId)=>{
        setStatusId(statusId);
        setOperationInProgress($6153ddf7f13eaaea$export$98ff4de2f070152d.ADDING);
    }, [
        setOperationInProgress,
        setStatusId
    ]);
};
const $6153ddf7f13eaaea$export$1763316459ec74d5 = ()=>{
    const { setOperationInProgress: setOperationInProgress, setStatusId: setStatusId } = $6153ddf7f13eaaea$export$1f652ba9a3f9f48e();
    return (0, $eUqFw.useCallback)((statusId)=>{
        setStatusId(statusId);
        setOperationInProgress($6153ddf7f13eaaea$export$98ff4de2f070152d.RENAMING);
    }, [
        setStatusId,
        setOperationInProgress
    ]);
};

});

parcelRegister("hppqk", function(module, exports) {

$parcel$export(module.exports, "default", () => $182e7881eaae261e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $182e7881eaae261e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    boardHeading: {
        "id": "work-management-board.board-heading",
        "defaultMessage": "Board"
    }
});

});

parcelRegister("8Tm3w", function(module, exports) {

$parcel$export(module.exports, "useCreateIssue", () => $c1efd794f027b7f7$export$8af2d18142c8506c);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $i3K0B = parcelRequire("i3K0B");

var $jGcn0 = parcelRequire("jGcn0");

var $eZbpk = parcelRequire("eZbpk");

var $e4qlg = parcelRequire("e4qlg");

var $kkYfO = parcelRequire("kkYfO");

var $lGxgz = parcelRequire("lGxgz");

var $dlVOn = parcelRequire("dlVOn");

var $7byHA = parcelRequire("7byHA");

var $lO4Or = parcelRequire("lO4Or");

var $fD1Hq = parcelRequire("fD1Hq");

var $dWLk9 = parcelRequire("dWLk9");

var $3ImR7 = parcelRequire("3ImR7");

var $7vi9X = parcelRequire("7vi9X");
function $c1efd794f027b7f7$export$fd83eea6ecd2d8fa(query) {
    const client = (0, $iZuDo.useApolloClient)();
    return (0, $eUqFw.useCallback)((variables)=>client.query({
            query: query,
            variables: variables,
            errorPolicy: 'all'
        }), [
        client,
        query
    ]);
}
const $c1efd794f027b7f7$export$8af2d18142c8506c = ()=>{
    const { data: categoryField } = (0, $e4qlg.useCategoryField)();
    const isLinkingEnabled = (0, $fD1Hq.useIsLinkingEnabled)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const filtersJQL = (0, $lGxgz.useFilteredViewJQL)();
    const refetchIssue = $c1efd794f027b7f7$export$fd83eea6ecd2d8fa((0, $3ImR7.ISSUE_REFETCH_QUERY));
    const [createIssue] = (0, $iZuDo.useMutation)((0, $3ImR7.CREATE_ISSUE_MUTATION));
    const createIssueService = (0, $eUqFw.useCallback)(async (createParams, extraPayload = {})=>{
        const input = (0, $7vi9X.buildInput)(createParams.input, extraPayload, categoryField);
        const fieldIdsSet = new Set(createParams.fieldIdsToReturn);
        const withIssueLinks = fieldIdsSet.has((0, $lO4Or.ISSUE_LINKS_TYPE)) && isLinkingEnabled;
        fieldIdsSet.delete((0, $lO4Or.ISSUE_LINKS_TYPE));
        const withCoverMedia = fieldIdsSet.has((0, $jGcn0.CARD_COVERS_TYPE));
        fieldIdsSet.delete((0, $jGcn0.CARD_COVERS_TYPE));
        const fieldIds = Array.from(fieldIdsSet);
        const { data: data, errors: errors } = await createIssue({
            variables: {
                input: input,
                fieldIds: fieldIds,
                withCoverMedia: withCoverMedia,
                withChildrenCount: false,
                withIssueLinks: withIssueLinks
            },
            // @ts-expect-error - errorPolicy is not in the types but does work
            errorPolicy: 'all'
        });
        const result = data?.createJiraBusinessIssue;
        if (result?.success !== true || !result?.item) {
            const firstMutationError = result?.errors?.[0];
            if (firstMutationError) {
                const statusCode = firstMutationError.extensions?.statusCode;
                if (statusCode && statusCode >= 400 && statusCode < 500) throw new (0, $7byHA.ValidationError)(firstMutationError.message ?? 'Failed to create issue');
                throw new (0, $kkYfO.MutationError)(firstMutationError);
            }
            throw new (0, $dlVOn.GraphQLErrors)(errors);
        }
        return {
            item: result.item,
            itemIdentifiers: {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                issueId: result.itemIdentifiers.issueId,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-non-null-assertion
                issueKey: result.itemIdentifiers.issueKey[0].text
            }
        };
    }, [
        categoryField,
        createIssue,
        isLinkingEnabled
    ]);
    const refetchIssueService = (0, $eUqFw.useCallback)(async (issueId, fieldIds, withFiltersContext)=>{
        const jql = (0, $i3K0B.generateJql)({
            jqlContext: jqlContext,
            quickFiltersJql: withFiltersContext ? filtersJQL : undefined,
            issueIds: [
                issueId
            ]
        });
        const fieldIdsSet = new Set(fieldIds);
        const withIssueLinks = fieldIdsSet.has((0, $lO4Or.ISSUE_LINKS_TYPE)) && isLinkingEnabled;
        fieldIdsSet.delete((0, $lO4Or.ISSUE_LINKS_TYPE));
        const withCoverMedia = fieldIdsSet.has((0, $jGcn0.CARD_COVERS_TYPE));
        const fieldIdsToRequest = Array.from(fieldIdsSet);
        const { data: data } = await refetchIssue({
            jql: jql,
            fieldIds: fieldIdsToRequest,
            cloudId: cloudId,
            first: 1,
            withCoverMedia: withCoverMedia,
            withChildrenCount: false,
            withIssueLinks: withIssueLinks
        });
        const viewItems = data?.jira?.jwmViewItems;
        if (!viewItems || viewItems.__typename === 'QueryError') throw new Error('Issue not found');
        const issue = viewItems.edges?.[0]?.node;
        return issue ?? null;
    }, [
        cloudId,
        filtersJQL,
        jqlContext,
        refetchIssue,
        isLinkingEnabled
    ]);
    return {
        createIssue: createIssueService,
        refetchIssue: refetchIssueService
    };
};

});
parcelRegister("3ImR7", function(module, exports) {

$parcel$export(module.exports, "CREATE_ISSUE_MUTATION", () => $60c5c521b68798fd$export$f5c1cac020b22be4);
$parcel$export(module.exports, "ISSUE_REFETCH_QUERY", () => $60c5c521b68798fd$export$834c81726d4c51eb);

var $9ypom = parcelRequire("9ypom");

var $7Pw84 = parcelRequire("7Pw84");

var $iwwE5 = parcelRequire("iwwE5");
const $60c5c521b68798fd$var$CREATED_ITEM_FRAGMENT = (0, $9ypom.default)`
fragment CreatedBoardItemFragment on JiraWorkManagementViewItem {
    ...JIS2_JWMBoardItemFragment
    ...JIS2_JWMBoardConfluenceLinksFragment
}
${(0, $iwwE5.JIS2_JWMBOARD_ITEM_FRAGMENT)}
${(0, $iwwE5.JIS2_JWMBOARD_CONFLUENCE_LINKS_FRAGMENT)}
`;
const $60c5c521b68798fd$export$f5c1cac020b22be4 = (0, $9ypom.default)`
mutation JWMBoardInlineCreateIssue($input: JiraCreateIssueInput!, $fieldIds: [String]!, $withCoverMedia: Boolean!, $withIssueLinks: Boolean!, $withChildrenCount: Boolean!) {
    createJiraBusinessIssue(input: $input, fieldIdsToReturn: $fieldIds) {
        item {
            ...CreatedBoardItemFragment
            ...JIS2_JWMBoardItemCoverMediaFragment @include(if: $withCoverMedia)
            ...JIS2_JWMBoardIssueLinksFragment @include(if: $withIssueLinks)
        }
        ...CreateIssueFragment
    }
}
${$60c5c521b68798fd$var$CREATED_ITEM_FRAGMENT}
${(0, $7Pw84.CREATE_ISSUE_FRAGMENT)}
${(0, $iwwE5.JIS2_JWMBOARD_ITEM_COVER_MEDIA_FRAGMENT)}
${(0, $iwwE5.JIS2_JWMBOARD_ISSUE_LINKS_FRAGMENT)}
`;
const $60c5c521b68798fd$export$834c81726d4c51eb = (0, $9ypom.default)`
query JWMBoardInlineCreateRefetchQuery($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int, $withCoverMedia: Boolean!, $withIssueLinks: Boolean!, $withChildrenCount: Boolean!) {
    jira {
        jwmViewItems(cloudId: $cloudId, jql: $jql, first: $first) {
            ... on JiraWorkManagementViewItemConnection {
                edges {
                    node {
                        ...CreatedBoardItemFragment
                        ...JIS2_JWMBoardItemCoverMediaFragment @include(if: $withCoverMedia)
                        ...JIS2_JWMBoardIssueLinksFragment @include(if: $withIssueLinks)
                    }
                }
            }
        }
    }
}
${$60c5c521b68798fd$var$CREATED_ITEM_FRAGMENT}
${(0, $iwwE5.JIS2_JWMBOARD_ITEM_COVER_MEDIA_FRAGMENT)}
${(0, $iwwE5.JIS2_JWMBOARD_ISSUE_LINKS_FRAGMENT)}
`;

});
parcelRegister("7Pw84", function(module, exports) {

$parcel$export(module.exports, "CREATE_ISSUE_FRAGMENT", () => $33f8e9ac12479c3a$export$47232071d0e9dfb);

var $9ypom = parcelRequire("9ypom");
const $33f8e9ac12479c3a$export$47232071d0e9dfb = (0, $9ypom.default)`
fragment CreateIssueFragment on JiraBusinessCreateIssuePayload {
  itemIdentifiers: item @connection (key: "issue-create-ids") {
    issueId
    issueKey: fieldsByIdOrAlias(idsOrAliases: ["issuekey"]) {
      ... on JiraSingleLineTextField {
          text
      }
    }
  }
  success
  errors {
    message
    extensions {
      ...on MutationErrorExtension {
        statusCode
        errorType
      }
    }
  }
}`;

});


parcelRegister("7vi9X", function(module, exports) {

$parcel$export(module.exports, "buildInput", () => $10412738f80ac25d$export$f4db126e014728a3);

var $lO4Or = parcelRequire("lO4Or");
const $10412738f80ac25d$var$RANK_BEFORE_ID = 'rankBefore';
const $10412738f80ac25d$var$RANK_AFTER_ID = 'rankAfter';
const $10412738f80ac25d$export$f4db126e014728a3 = (input, extraPayload, categoryField)=>{
    const singleLineTextFields = [
        {
            fieldId: (0, $lO4Or.SUMMARY_TYPE),
            text: input.summary
        }
    ];
    const singleSelectUserPickerFields = [];
    if (input.category && categoryField?.id) singleLineTextFields.push({
        // @ts-expect-error - Type 'string' is not assignable to type '"summary"'.
        fieldId: categoryField.id,
        text: input.category.optionId
    });
    if (input.assignee) singleSelectUserPickerFields.push({
        fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
        user: {
            accountId: input.assignee.accountId
        }
    });
    const fields = {
        singleLineTextFields: singleLineTextFields,
        singleSelectUserPickerFields: singleSelectUserPickerFields,
        ...input.priority && {
            priority: {
                priorityId: input.priority.priorityId
            }
        },
        ...input.parentIssueId && {
            parentField: {
                issueId: input.parentIssueId
            }
        }
    };
    const rank = {
        ...input.rankBefore && {
            before: {
                id: $10412738f80ac25d$var$RANK_BEFORE_ID,
                issueId: input.rankBefore.issueId
            }
        },
        ...input.rankAfter && {
            after: {
                id: $10412738f80ac25d$var$RANK_AFTER_ID,
                issueId: input.rankAfter.issueId
            }
        }
    };
    const result = {
        projectId: input.projectId,
        issueType: input.issueType.id,
        fields: fields,
        rank: rank,
        ...extraPayload?.transitionId && {
            transitionId: extraPayload.transitionId
        }
    };
    return result;
};

});


parcelRegister("l3fLv", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b4275242491df62$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $6ki0E = parcelRequire("6ki0E");

var $3Udf5 = parcelRequire("3Udf5");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $4TJj0 = parcelRequire("4TJj0");

var $i0nxo = parcelRequire("i0nxo");

var $jGcn0 = parcelRequire("jGcn0");

var $3JiQx = parcelRequire("3JiQx");

var $kQAZu = parcelRequire("kQAZu");

var $gCyQH = parcelRequire("gCyQH");

var $4G5xU = parcelRequire("4G5xU");

var $96etS = parcelRequire("96etS");

var $kiBzn = parcelRequire("kiBzn");

var $7SlEV = parcelRequire("7SlEV");

var $jvtK3 = parcelRequire("jvtK3");

var $h02O8 = parcelRequire("h02O8");

var $5I9Im = parcelRequire("5I9Im");

var $kHnEs = parcelRequire("kHnEs");

var $9u6Jh = parcelRequire("9u6Jh");

var $8BjUT = parcelRequire("8BjUT");

var $bcWyL = parcelRequire("bcWyL");

var $6HWvN = parcelRequire("6HWvN");

var $eeJbA = parcelRequire("eeJbA");

var $eRpjy = parcelRequire("eRpjy");

var $90G8g = parcelRequire("90G8g");


var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $hby36 = parcelRequire("hby36");

var $3ekpH = parcelRequire("3ekpH");

var $hJ992 = parcelRequire("hJ992");

var $hzcvF = parcelRequire("hzcvF");


var $6vrw7 = parcelRequire("6vrw7");

var $jK1pm = parcelRequire("jK1pm");

var $lB25E = parcelRequire("lB25E");

var $aD5FN = parcelRequire("aD5FN");

var $lbjCz = parcelRequire("lbjCz");

var $ib4WI = parcelRequire("ib4WI");

var $bFk6h = parcelRequire("bFk6h");

var $1rVdL = parcelRequire("1rVdL");

var $3sztN = parcelRequire("3sztN");

var $2b5eO = parcelRequire("2b5eO");

var $iXHUp = parcelRequire("iXHUp");

var $cY0Xy = parcelRequire("cY0Xy");

var $c52lf = parcelRequire("c52lf");

var $sFqil = parcelRequire("sFqil");

var $93B7g = parcelRequire("93B7g");

var $1trHT = parcelRequire("1trHT");

var $2TjqC = parcelRequire("2TjqC");
const $1b4275242491df62$var$isRealTimePayloadIssueEvent = (payload)=>'issueId' in payload && payload.issueId != null;
const $1b4275242491df62$var$REALTIME_APP_ID = 'jira-business-board-view';
const $1b4275242491df62$var$BoardContent = ({ isEmpty: isEmpty })=>{
    const project = (0, $kQAZu.useProject)();
    const groups = (0, $c52lf.useIssueGroups)();
    const groupBy = (0, $iXHUp.useGroupByField)();
    const boardContentRef = (0, $eUqFw.useRef)(null);
    const [boardWrapper, setBoardWrapper] = (0, $eUqFw.useState)(null);
    const isColumnCreateEnabled = project.isSimplified && (!groupBy || groupBy === (0, $jGcn0.GROUP_BY_STATUS));
    const totalChildren = isColumnCreateEnabled ? groups.length + 1 : groups.length;
    const virtualizer = (0, $6ki0E.useVirtualizer)({
        count: totalChildren,
        horizontal: true,
        getScrollElement: ()=>boardWrapper,
        estimateSize: ()=>(0, $ib4WI.COLUMN_FIXED_WIDTH),
        gap: (0, $ib4WI.GAP_BETWEEN_COLUMNS),
        overscan: 0
    });
    (0, $eUqFw.useEffect)(()=>{
        if (!boardWrapper) return;
        return (0, $3Udf5.autoScrollForElements)({
            element: boardWrapper
        });
    }, [
        boardWrapper
    ]);
    const ColumnContent = virtualizer.getVirtualItems().map((virtualItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b4275242491df62$var$VirtualItemWrapper, {
            key: virtualItem.key,
            start: virtualItem.start,
            "data-index": virtualItem.index,
            ref: virtualizer.measureElement
        }, virtualItem.index === groups.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $93B7g.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c52lf.IssueGroupProvider), {
            key: virtualItem.key,
            group: groups[virtualItem.index]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sFqil.default), {
            columnIndex: virtualItem.index,
            columnsNumber: groups.length
        }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b4275242491df62$var$BoardWrapper, {
        ref: setBoardWrapper,
        "data-testid": "work-management-board.ui.board.board-wrapper",
        isEmpty: isEmpty
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b4275242491df62$var$BoardContentWrapper, {
        ref: boardContentRef,
        totalSize: virtualizer.getTotalSize()
    }, ColumnContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2TjqC.default), {
        boardContentElement: boardContentRef.current,
        scrollElement: boardWrapper
    }));
};
const $1b4275242491df62$var$Board = ()=>{
    const { featureView: featureView } = (0, $2b5eO.useJWMBoardFeatures)();
    const { isFiltering: isFiltering } = (0, $1rVdL.useFilterStatus)();
    const { isSearching: isSearching } = (0, $96etS.useSimpleSearchJQL)();
    const project = (0, $kQAZu.useProject)();
    const projectId = String(project.id);
    const { filteredIssues: filteredIssues, loading: loading, error: error, refetch: refetch } = (0, $bFk6h.useBoardData)();
    const { handleUpdatedIssue: handleUpdatedIssue, handleDeletedIssue: handleDeletedIssue } = (0, $cY0Xy.useHandleIssueEvents)();
    const [, { sendNodeSelected: sendNodeSelected, sendClearNodeSelection: sendClearNodeSelection }] = (0, $4TJj0.useCollabStore)();
    const [selectedIssueKey, setSelectedIssueKey] = (0, $lB25E.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const prevSelectedIssueKey = (0, $hzcvF.usePreviousWithInitial)(selectedIssueKey);
    const viewMode = (0, $hJ992.useViewMode)();
    const isViewModeSideBar = viewMode === 'SIDEBAR';
    const shouldShowInviteUserModalBasedOnSessionStorage = (0, $eI5EY.fg)('invite-users-on-project-create-killswitch') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $hby36.useShouldShowInviteUserModalBasedOnSessionStorage)(featureView === 'jwm-board-embed') : false;
    (0, $3sztN.useDropHandler)(loading);
    const boardHasNoIssues = filteredIssues.length === 0;
    const isBoardEmptyAfterFilter = boardHasNoIssues && (isFiltering || isSearching) && !loading;
    const isBoardEmpty = boardHasNoIssues && !isFiltering && !loading;
    const onIssueModalClose = (0, $eUqFw.useCallback)(()=>{
        setSelectedIssueKey(undefined);
    }, [
        setSelectedIssueKey
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // when issueKey param is removed from URL we need to clear node selection
        if (selectedIssueKey == null && prevSelectedIssueKey != null) {
            const issue = filteredIssues.find((item)=>item.fields[0, $ib4WI.ISSUE_KEY_ID].value === prevSelectedIssueKey);
            if (issue) {
                const nodeId = (0, $i0nxo.getPresenceNodeId)({
                    projectId: projectId,
                    viewId: 'board',
                    nodeId: `${issue.id}`
                });
                sendClearNodeSelection({
                    nodeId: nodeId
                });
            }
        }
    }, [
        filteredIssues,
        prevSelectedIssueKey,
        projectId,
        selectedIssueKey,
        sendClearNodeSelection,
        sendNodeSelected
    ]);
    const onPageVisibilityChange = (0, $eUqFw.useCallback)(({ isVisible: isVisible })=>{
        if (isVisible) refetch();
    }, [
        refetch
    ]);
    const onRealtimeEventOld = (0, $eUqFw.useCallback)(async (event)=>{
        if ($1b4275242491df62$var$isRealTimePayloadIssueEvent(event.payload)) {
            const { issueId: issueId } = event.payload;
            const isDeleted = event.type === (0, $1d129cd1c8b202ad$export$25fa37e5059c5a99);
            if (isDeleted) handleDeletedIssue(issueId);
            else handleUpdatedIssue(issueId);
        }
    }, [
        handleDeletedIssue,
        handleUpdatedIssue
    ]);
    const onRealtimeEvent = (0, $eUqFw.useCallback)((event)=>{
        if ((0, $h02O8.isIssueEvent)(event)) {
            const issueId = Number(event.payload.issueId);
            if (event.type === (0, $7SlEV.ISSUE_DELETED_EVENT)) handleDeletedIssue(issueId);
            else handleUpdatedIssue(issueId);
        }
    }, [
        handleDeletedIssue,
        handleUpdatedIssue
    ]);
    const onBentoChange = (0, $eUqFw.useCallback)((event)=>handleUpdatedIssue(Number(event.issueId)), [
        handleUpdatedIssue
    ]);
    const onBentoDelete = (0, $eUqFw.useCallback)(({ issueId: issueId })=>handleDeletedIssue(Number(issueId)), [
        handleDeletedIssue
    ]);
    // Memoised to prevent flicker on JIRT updates
    const issueModal = (0, $eUqFw.useMemo)(()=>selectedIssueKey != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kHnEs.default), {
            issueKey: (0, $6vrw7.toIssueKey)(selectedIssueKey),
            onClose: onIssueModalClose,
            analyticsSource: (0, $0100842672acae20$export$b2c0462ff17aa26e),
            onChange: onBentoChange,
            onDeleteSuccess: onBentoDelete
        }), [
        selectedIssueKey,
        onIssueModalClose,
        onBentoChange,
        onBentoDelete
    ]);
    if (error != null) {
        const is404 = 'statusCode' in error && error.statusCode === 404;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, is404 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceAbort), {
            experience: (0, $ib4WI.VIEW_EXPERIENCE),
            error: error
        }), !is404 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceFailed), {
            experience: (0, $ib4WI.VIEW_EXPERIENCE),
            error: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCyQH.ErrorPage), {
            error: error
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-board-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b4275242491df62$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aD5FN.default), {
        data: {
            hasSelectedIssue: !!selectedIssueKey,
            isViewModeSideBar: isViewModeSideBar,
            isFiltering: isFiltering,
            isSearching: isSearching,
            isBoardEmpty: isBoardEmpty
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbjCz.default), {
        name: "board-container-initial"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $1b4275242491df62$var$loadingWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90G8g.ThemedSpinner), null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c52lf.IssuesByGroupProvider), {
        filteredIssues: filteredIssues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b4275242491df62$var$BoardContainer, {
        "data-testid": "work-management-board.ui.board.board-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HWvN.RenderStartMark), {
        view: featureView
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b4275242491df62$var$BoardContent, {
        isEmpty: isBoardEmpty || isBoardEmptyAfterFilter
    }), isBoardEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b4275242491df62$var$EmptyStateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1trHT.EmptyBoardComponent), null)) : null, isBoardEmptyAfterFilter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b4275242491df62$var$EmptyStateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kiBzn.ThemedFilterEmptyState), null)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eRpjy.JWMSpaStatePageReady), null))), isViewModeSideBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9u6Jh.SidebarIssueView), {
        issueKey: selectedIssueKey,
        onClose: onIssueModalClose,
        onChange: onBentoChange,
        onIssueDeleteSuccess: onBentoDelete,
        analyticsSource: (0, $0100842672acae20$export$b2c0462ff17aa26e)
    }) : issueModal, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcWyL.PerformanceAnalytics), {
        view: featureView,
        loading: loading,
        itemsCount: filteredIssues.length
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eeJbA.SignupInviteModal), null), shouldShowInviteUserModalBasedOnSessionStorage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ekpH.ProjectInviteModalWithRecommendedUsers), {
        isLoading: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5I9Im.PrefetchIssueDataController), null), (0, $1ybV0.ff)('jwm.board.migrate-jirt-to-gqls') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvtK3.GqlsRealtime), {
        appId: $1b4275242491df62$var$REALTIME_APP_ID,
        entityId: projectId,
        onReceive: onRealtimeEvent
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3JiQx.BusinessRealtime), {
        appId: $1b4275242491df62$var$REALTIME_APP_ID,
        onReceive: onRealtimeEventOld
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BjUT.PageVisibility), {
        onChange: onPageVisibilityChange
    }))));
};
var $1b4275242491df62$export$2e2bcd8739ae039 = $1b4275242491df62$var$Board;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b4275242491df62$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $1b4275242491df62$var$BoardContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c1txw _2lx21bp4 _1o9zidpf _1n261q9c _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $1b4275242491df62$var$BoardWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEmpty: isEmpty, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1reo1wug _1ul9idpf _kqswh2mm _syaz1fxt _1yt41r6r _18s81mhk",
            __cmplp.isEmpty ? "_16jlidpf _1o9zkb7n _i0dlf1ug" : "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.isEmpty ? "_1tke1yk2" : "_1tkeidpf",
            __cmplp.className
        ])
    });
});
const $1b4275242491df62$var$BoardContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { totalSize: totalSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_r9fzc2": (0, $9t7rW.default)(`${__cmplp.totalSize}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1y6m _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _1n261q9c _kqswh2mm _4t3i1osq _c71l1osq _1ul91ns9 _uiztglyw _1bsb1651 _m6k4brmi",
            __cmplp.className
        ])
    });
});
const $1b4275242491df62$var$loadingWrapperStyles = (0, $8Vv3m.xcss)({
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    justifyContent: 'space-around'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b4275242491df62$var$VirtualItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_19kxfes": (0, $9t7rW.default)(`translateX(${__cmplp.start}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _kqswstnw _154iidpf _1ltvidpf _t9ec1yxo",
            __cmplp.className
        ])
    });
});
const $1b4275242491df62$var$EmptyStateContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6ki0E", function(module, exports) {
$parcel$export(module.exports, "elementScroll", () => (parcelRequire("2N9zU")).elementScroll);
$parcel$export(module.exports, "notUndefined", () => (parcelRequire("5oCQ9")).notUndefined);
$parcel$export(module.exports, "observeElementOffset", () => (parcelRequire("2N9zU")).observeElementOffset);
$parcel$export(module.exports, "observeElementRect", () => (parcelRequire("2N9zU")).observeElementRect);
$parcel$export(module.exports, "observeWindowOffset", () => (parcelRequire("2N9zU")).observeWindowOffset);
$parcel$export(module.exports, "observeWindowRect", () => (parcelRequire("2N9zU")).observeWindowRect);
$parcel$export(module.exports, "Virtualizer", () => (parcelRequire("2N9zU")).Virtualizer);
$parcel$export(module.exports, "windowScroll", () => (parcelRequire("2N9zU")).windowScroll);

$parcel$export(module.exports, "useVirtualizer", () => $49b294a7a914c493$export$dd6d526d88b5a137);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $2N9zU = parcelRequire("2N9zU");
const $49b294a7a914c493$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;
function $49b294a7a914c493$var$useVirtualizerBase(options) {
    const rerender = $eUqFw.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $lEfVV.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $eUqFw.useState(()=>new (0, $2N9zU.Virtualizer)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $eUqFw.useEffect(()=>{
        return instance._didMount();
    }, []);
    $49b294a7a914c493$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $49b294a7a914c493$export$dd6d526d88b5a137(options) {
    return $49b294a7a914c493$var$useVirtualizerBase({
        observeElementRect: $2N9zU.observeElementRect,
        observeElementOffset: $2N9zU.observeElementOffset,
        scrollToFn: (0, $2N9zU.elementScroll),
        ...options
    });
}
function $49b294a7a914c493$export$645722dcac657cb9(options) {
    return $49b294a7a914c493$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $2N9zU.observeWindowRect),
        observeElementOffset: (0, $2N9zU.observeWindowOffset),
        scrollToFn: (0, $2N9zU.windowScroll),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}

});
parcelRegister("2N9zU", function(module, exports) {

$parcel$export(module.exports, "observeElementRect", () => $20879669f8b1eab4$export$5a50ff2cde8c3802);
$parcel$export(module.exports, "observeWindowRect", () => $20879669f8b1eab4$export$e911b82c7a99311);
$parcel$export(module.exports, "observeElementOffset", () => $20879669f8b1eab4$export$fbc040aee017375a);
$parcel$export(module.exports, "observeWindowOffset", () => $20879669f8b1eab4$export$518998f8c5d09287);
$parcel$export(module.exports, "windowScroll", () => $20879669f8b1eab4$export$2162c5b3eeedd27);
$parcel$export(module.exports, "elementScroll", () => $20879669f8b1eab4$export$1cdb988e5ab69fe7);
$parcel$export(module.exports, "Virtualizer", () => $20879669f8b1eab4$export$89be5a243e59c4b2);
$parcel$export(module.exports, "notUndefined", () => (parcelRequire("5oCQ9")).notUndefined);

var $5oCQ9 = parcelRequire("5oCQ9");
const $20879669f8b1eab4$export$76974b428a49f15b = (index)=>index;
const $20879669f8b1eab4$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $20879669f8b1eab4$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (!targetWindow.ResizeObserver) return ()=>{};
    const observer = new targetWindow.ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $20879669f8b1eab4$var$addEventListenerOptions = {
    passive: true
};
const $20879669f8b1eab4$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $20879669f8b1eab4$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $20879669f8b1eab4$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $20879669f8b1eab4$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $20879669f8b1eab4$var$supportsScrollend ? ()=>void 0 : (0, $5oCQ9.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            const { horizontal: horizontal, isRtl: isRtl } = instance.options;
            offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $20879669f8b1eab4$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $20879669f8b1eab4$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $20879669f8b1eab4$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $20879669f8b1eab4$var$supportsScrollend ? ()=>void 0 : (0, $5oCQ9.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $20879669f8b1eab4$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $20879669f8b1eab4$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $20879669f8b1eab4$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $20879669f8b1eab4$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $20879669f8b1eab4$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $20879669f8b1eab4$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.targetWindow = null;
        this.isScrolling = false;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollRect = null;
        this.scrollOffset = null;
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.elementsCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        this._measureElement(entry.target, entry);
                    });
                });
            };
            return {
                disconnect: ()=>{
                    var _a;
                    (_a = get()) == null || _a.disconnect();
                    _ro = null;
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $20879669f8b1eab4$export$76974b428a49f15b,
                rangeExtractor: $20879669f8b1eab4$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $20879669f8b1eab4$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                isScrollingResetDelay: 150,
                enabled: true,
                isRtl: false,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $5oCQ9.memo)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.observer.disconnect();
            this.scrollElement = null;
            this.targetWindow = null;
        };
        this._didMount = ()=>{
            return ()=>{
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            var _a;
            const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                if (!scrollElement) {
                    this.maybeNotify();
                    return;
                }
                this.scrollElement = scrollElement;
                if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                this.elementsCache.forEach((cached)=>{
                    this.observer.observe(cached);
                });
                this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    this.isScrolling = isScrolling;
                    this.maybeNotify();
                }));
            }
        };
        this.getSize = ()=>{
            if (!this.options.enabled) {
                this.scrollRect = null;
                return 0;
            }
            this.scrollRect = this.scrollRect ?? this.options.initialRect;
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getScrollOffset = ()=>{
            if (!this.options.enabled) {
                this.scrollOffset = null;
                return 0;
            }
            this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
            return this.scrollOffset;
        };
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurementOptions = (0, $5oCQ9.memo)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey,
                this.options.enabled
            ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey,
                enabled: enabled
            };
        }, {
            key: false
        });
        this.getMeasurements = (0, $5oCQ9.memo)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
            if (!enabled) {
                this.measurementsCache = [];
                this.itemSizeCache.clear();
                return [];
            }
            if (this.measurementsCache.length === 0) {
                this.measurementsCache = this.options.initialMeasurementsCache;
                this.measurementsCache.forEach((item)=>{
                    this.itemSizeCache.set(item.key, item.size);
                });
            }
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $5oCQ9.memo)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.getScrollOffset()
            ], (measurements, outerSize, scrollOffset)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $20879669f8b1eab4$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getIndexes = (0, $5oCQ9.memo)(()=>[
                this.options.rangeExtractor,
                this.calculateRange(),
                this.options.overscan,
                this.options.count
            ], (rangeExtractor, range, overscan, count)=>{
            return range === null ? [] : rangeExtractor({
                startIndex: range.startIndex,
                endIndex: range.endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const index = this.indexFromElement(node);
            const item = this.measurementsCache[index];
            if (!item) return;
            const key = item.key;
            const prevNode = this.elementsCache.get(key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.elementsCache.set(key, node);
            }
            if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
        };
        this.resizeItem = (index, size)=>{
            const item = this.measurementsCache[index];
            if (!item) return;
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) {
                this.elementsCache.forEach((cached, key)=>{
                    if (!cached.isConnected) {
                        this.observer.unobserve(cached);
                        this.elementsCache.delete(key);
                    }
                });
                return;
            }
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $5oCQ9.memo)(()=>[
                this.getIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            if (measurements.length === 0) return void 0;
            return (0, $5oCQ9.notUndefined)(measurements[$20879669f8b1eab4$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $5oCQ9.notUndefined)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align)=>{
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (toOffset <= scrollOffset) align = "start";
                else if (toOffset >= scrollOffset + size) align = "end";
                else align = "start";
            }
            if (align === "start") toOffset;
            else if (align === "end") toOffset = toOffset - size;
            else if (align === "center") toOffset = toOffset - size / 2;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - size;
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const item = this.measurementsCache[index];
            if (!item) return void 0;
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align),
                align
            ];
        };
        this.isDynamicMode = ()=>this.elementsCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
                this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
            if (!offsetAndAlign) return;
            const [offset, align] = offsetAndAlign;
            this._scrollToOffset(offset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.elementsCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [latestOffset] = (0, $5oCQ9.notUndefined)(this.getOffsetForIndex(index, align));
                    if (!(0, $5oCQ9.approxEqual)(latestOffset, this.getScrollOffset())) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getScrollOffset() + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
            return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
    }
}
const $20879669f8b1eab4$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $20879669f8b1eab4$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
    const count = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    const startIndex = $20879669f8b1eab4$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
    let endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}

});
parcelRegister("5oCQ9", function(module, exports) {

$parcel$export(module.exports, "memo", () => $3edd5277c0f8707b$export$7c73462e0d25e514);
$parcel$export(module.exports, "notUndefined", () => $3edd5277c0f8707b$export$9a1adf421b69c6a);
$parcel$export(module.exports, "approxEqual", () => $3edd5277c0f8707b$export$8a4f1dcc58a69dbd);
$parcel$export(module.exports, "debounce", () => $3edd5277c0f8707b$export$61fc7d43ac8f84b0);
function $3edd5277c0f8707b$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    return ()=>{
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    };
}
function $3edd5277c0f8707b$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $3edd5277c0f8707b$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
const $3edd5277c0f8707b$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
    let timeoutId;
    return function(...args) {
        targetWindow.clearTimeout(timeoutId);
        timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
    };
};

});



parcelRegister("3Udf5", function(module, exports) {

$parcel$export(module.exports, "autoScrollForElements", () => $0829ccc3698f373b$export$4b66ee8317094cdb);

var $ibIV3 = parcelRequire("ibIV3");

var $5PwHq = parcelRequire("5PwHq");
const $0829ccc3698f373b$var$api = (0, $5PwHq.makeApi)({
    monitor: (0, $ibIV3.monitorForElements)
});
const $0829ccc3698f373b$export$4b66ee8317094cdb = $0829ccc3698f373b$var$api.autoScroll;
const $0829ccc3698f373b$export$c9168f41de61f525 = $0829ccc3698f373b$var$api.autoScrollWindow;

});
parcelRegister("5PwHq", function(module, exports) {

$parcel$export(module.exports, "makeApi", () => $7a6a05c47f270c80$export$b8fa21320a811083);

var $awlt9 = parcelRequire("awlt9");

var $8NVLi = parcelRequire("8NVLi");

var $2bvQc = parcelRequire("2bvQc");

var $9ypK4 = parcelRequire("9ypK4");
function $7a6a05c47f270c80$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        return (0, $awlt9.combine)((0, $2bvQc.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        return ()=>windowRegistry.delete(unique);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $9ypK4.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $8NVLi.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}

});
parcelRegister("8NVLi", function(module, exports) {

$parcel$export(module.exports, "getScheduler", () => $8c0ba77e85a7de63$export$5cff7ac265db316a);
parcelRequire("8mUBL");
var $9G8J4 = parcelRequire("9G8J4");

var $l2bDh = parcelRequire("l2bDh");
// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $8c0ba77e85a7de63$var$schedulers = new Map();
function $8c0ba77e85a7de63$export$5cff7ac265db316a(monitor) {
    const scheduler = $8c0ba77e85a7de63$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $8c0ba77e85a7de63$var$makeScheduler(monitor);
    $8c0ba77e85a7de63$var$schedulers.set(monitor, created);
    return created;
}
function $8c0ba77e85a7de63$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $9G8J4.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $l2bDh.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $l2bDh.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}

});
parcelRegister("8mUBL", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("9G8J4")).getElementFromPointWithoutHoneypot);

var $9G8J4 = parcelRequire("9G8J4");

});

parcelRegister("l2bDh", function(module, exports) {

$parcel$export(module.exports, "markAndGetEngagement", () => $e871348b265ad1a9$export$8c764c3f2fc3d2d2);
$parcel$export(module.exports, "clearUnusedEngagements", () => $e871348b265ad1a9$export$991e77dd347f3df1);
$parcel$export(module.exports, "clearEngagementHistory", () => $e871348b265ad1a9$export$13ae770ed39b71ea);
const $e871348b265ad1a9$var$ledger = new Map();
const $e871348b265ad1a9$var$requested = new Set();
function $e871348b265ad1a9$export$8c764c3f2fc3d2d2(element) {
    $e871348b265ad1a9$export$1cb7cbb266b6f6fa(element);
    const entry = $e871348b265ad1a9$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $e871348b265ad1a9$var$ledger.set(element, fresh);
    return fresh;
}
function $e871348b265ad1a9$export$1cb7cbb266b6f6fa(element) {
    $e871348b265ad1a9$var$requested.add(element);
}
function $e871348b265ad1a9$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $e871348b265ad1a9$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $e871348b265ad1a9$var$ledger.forEach((_, element)=>{
        if (!$e871348b265ad1a9$var$requested.has(element)) $e871348b265ad1a9$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $e871348b265ad1a9$var$requested.clear();
}
function $e871348b265ad1a9$export$13ae770ed39b71ea() {
    $e871348b265ad1a9$var$ledger.clear();
}

});


parcelRegister("2bvQc", function(module, exports) {

$parcel$export(module.exports, "selector", () => $4813ec763c18b533$export$aea217a45095ce11);
$parcel$export(module.exports, "addScrollableAttribute", () => $4813ec763c18b533$export$4ec12fb57dfebd53);
const $4813ec763c18b533$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $4813ec763c18b533$export$aea217a45095ce11 = `[${$4813ec763c18b533$export$4b152ab55cad4fd6}="true"]`;
function $4813ec763c18b533$export$4ec12fb57dfebd53(element) {
    element.setAttribute($4813ec763c18b533$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($4813ec763c18b533$export$4b152ab55cad4fd6);
}

});

parcelRegister("9ypK4", function(module, exports) {

$parcel$export(module.exports, "tryScroll", () => $7078593436037f16$export$233199807749476d);

var $3EFcx = parcelRequire("3EFcx");

var $l2bDh = parcelRequire("l2bDh");

var $2bvQc = parcelRequire("2bvQc");

var $iLnHQ = parcelRequire("iLnHQ");
function $7078593436037f16$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $7078593436037f16$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$7078593436037f16$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $2bvQc.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $7078593436037f16$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $l2bDh.markAndGetEngagement)(element);
    const config = (0, $3EFcx.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $iLnHQ.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $7078593436037f16$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $l2bDh.markAndGetEngagement)(element);
        const config = (0, $3EFcx.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $iLnHQ.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $7078593436037f16$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $7078593436037f16$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$7078593436037f16$var$isScrollingAvailable(remainder)) return;
    $7078593436037f16$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}

});
parcelRegister("3EFcx", function(module, exports) {

$parcel$export(module.exports, "getInternalConfig", () => $44dbd6838e470071$export$e96028ec7ff9d079);
const $44dbd6838e470071$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 300,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $44dbd6838e470071$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $44dbd6838e470071$export$e96028ec7ff9d079(provided) {
    return {
        ...$44dbd6838e470071$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $44dbd6838e470071$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}

});

parcelRegister("iLnHQ", function(module, exports) {

$parcel$export(module.exports, "getScrollBy", () => $cc504b3b0e7ede14$export$6cfa6dfe6898b98f);

var $pEuVq = parcelRequire("pEuVq");

var $lI5nv = parcelRequire("lI5nv");

var $hUVUL = parcelRequire("hUVUL");

var $hUykX = parcelRequire("hUykX");

var $1x97j = parcelRequire("1x97j");

var $cpffL = parcelRequire("cpffL");
function $cc504b3b0e7ede14$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $cc504b3b0e7ede14$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $cc504b3b0e7ede14$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $lI5nv.edges).reduce((map, edge)=>{
        const hitbox = (0, $hUVUL.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $lI5nv.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $1x97j.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $cpffL.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $pEuVq.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $hUykX.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $hUykX.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $hUykX.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $hUykX.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}

});
parcelRegister("pEuVq", function(module, exports) {

$parcel$export(module.exports, "canScrollOnEdge", () => $757a741d6e837a70$export$ccd6d9407403fcad);
const $757a741d6e837a70$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};

});

parcelRegister("lI5nv", function(module, exports) {

$parcel$export(module.exports, "edges", () => $7c6d7bef47a218dc$export$4544a00f8eb65eb2);
$parcel$export(module.exports, "edgeAxisLookup", () => $7c6d7bef47a218dc$export$7fc144124ccf8292);
const $7c6d7bef47a218dc$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $7c6d7bef47a218dc$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};

});

parcelRegister("hUVUL", function(module, exports) {

$parcel$export(module.exports, "getOverElementHitbox", () => $571d3d04086714c0$export$b9a449c20abb0e9);

var $6Fm3J = parcelRequire("6Fm3J");

var $hSmwr = parcelRequire("hSmwr");
function $571d3d04086714c0$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $6Fm3J.axisLookup)[axis];
        const side = (0, $hSmwr.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $571d3d04086714c0$export$b9a449c20abb0e9 = {
    top: $571d3d04086714c0$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $571d3d04086714c0$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $571d3d04086714c0$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $571d3d04086714c0$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};

});
parcelRegister("6Fm3J", function(module, exports) {

$parcel$export(module.exports, "axisLookup", () => $b7ab5b7bc83cfc3e$export$42e42cdab35a2b96);
const $b7ab5b7bc83cfc3e$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $b7ab5b7bc83cfc3e$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $b7ab5b7bc83cfc3e$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $b7ab5b7bc83cfc3e$var$vertical,
        crossAxis: $b7ab5b7bc83cfc3e$var$horizontal
    },
    horizontal: {
        mainAxis: $b7ab5b7bc83cfc3e$var$horizontal,
        crossAxis: $b7ab5b7bc83cfc3e$var$vertical
    }
};

});

parcelRegister("hSmwr", function(module, exports) {

$parcel$export(module.exports, "mainAxisSideLookup", () => $a7c6298ec20ef781$export$a45c0cd714a4dbaa);
const $a7c6298ec20ef781$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};

});


parcelRegister("hUykX", function(module, exports) {

$parcel$export(module.exports, "getScrollChange", () => $bc7ee78c436c946e$export$470a2ff46db8cee8);

var $6Fm3J = parcelRequire("6Fm3J");

var $i8NkD = parcelRequire("i8NkD");

var $hSmwr = parcelRequire("hSmwr");
// We want a consistent scroll speed across devices, regardless of framerate
function $bc7ee78c436c946e$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $bc7ee78c436c946e$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $6Fm3J.axisLookup)[axis];
    const side = (0, $hSmwr.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $i8NkD.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $i8NkD.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $bc7ee78c436c946e$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $bc7ee78c436c946e$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $bc7ee78c436c946e$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $i8NkD.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $hSmwr.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}

});
parcelRegister("i8NkD", function(module, exports) {

$parcel$export(module.exports, "getPercentageInRange", () => $532961d131b874e1$export$1a29de000a332d74);
function $532961d131b874e1$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}

});


parcelRegister("1x97j", function(module, exports) {

$parcel$export(module.exports, "isAxisAllowed", () => $ecf97c52079012e4$export$7120fdbd90bd1292);
function $ecf97c52079012e4$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}

});

parcelRegister("cpffL", function(module, exports) {

$parcel$export(module.exports, "isWithin", () => $717bcab8187edfb9$export$cda7a9d4399bf2e3);
function $717bcab8187edfb9$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}

});





parcelRegister("4TJj0", function(module, exports) {

$parcel$export(module.exports, "useCollabStore", () => $8f55868fdda87f4e$export$4159ae80cfa2156);

var $lyOYo = parcelRequire("lyOYo");

var $WBLbN = parcelRequire("WBLbN");

var $3BgyA = parcelRequire("3BgyA");

const $8f55868fdda87f4e$var$updateUserInParticipants = (user)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            participants: state.participants.map((participant)=>{
                if (participant.clientId === user.userId) return {
                    ...participant,
                    avatar: user.avatar,
                    name: user.name,
                    email: user.email
                };
                return participant;
            })
        });
    };
const $8f55868fdda87f4e$var$participantsJoined = (joined)=>({ getState: getState, setState: setState })=>{
        const uniqueJoined = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(joined, ({ sessionId: sessionId })=>sessionId);
        const newParticipantSessionIds = uniqueJoined.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        const { provider: provider } = state;
        const newParticipants = [
            ...state.participants.filter(({ sessionId: sessionId })=>!newParticipantSessionIds.includes(sessionId)),
            ...uniqueJoined
        ];
        // Collab team advised we should limit the number of max connections to control the load on collab service
        if (newParticipants.length >= (0, $daf44b44f86c0150$export$3debf01bbfa135e5) && provider) {
            // sort users by last active (last joined)
            const sortedUsers = newParticipants.sort((userA, userB)=>userA.lastActive > userB.lastActive ? 1 : -1);
            const currentUser = sortedUsers.find((user)=>user.sessionId === provider.sessionId);
            const lastActiveUser = sortedUsers[sortedUsers.length - 1];
            // kick the last joined user out
            setState({
                ...state,
                participants: newParticipants.filter(({ sessionId: sessionId })=>sessionId !== lastActiveUser.sessionId)
            });
            if (lastActiveUser.sessionId === currentUser?.sessionId) provider.destroy();
            return;
        }
        setState({
            ...state,
            participants: newParticipants
        });
    };
const $8f55868fdda87f4e$var$participantsLeft = (left)=>({ getState: getState, setState: setState })=>{
        const leftSessionIds = left.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        // cleanup user selection when they leave the session
        const newSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>!leftSessionIds.includes(selection.sessionId));
                if (filteredSelections.length === 0) return;
                newSelection[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            participants: state.participants.filter(({ sessionId: sessionId })=>!leftSessionIds.includes(sessionId)),
            nodeSelection: newSelection
        });
    };
const $8f55868fdda87f4e$var$setProvider = (provider)=>({ getState: getState, setState: setState })=>setState({
            ...getState(),
            provider: provider
        });
const $8f55868fdda87f4e$var$sendNodeSelected = ({ nodeId: nodeId })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                anchor: JSON.stringify({
                    nodeId: nodeId
                })
            }
        });
    };
const $8f55868fdda87f4e$var$sendClearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                head: JSON.stringify({
                    nodeId: nodeId,
                    dropParams: dropParams
                })
            }
        });
    };
const $8f55868fdda87f4e$var$setNodeSelection = ({ nodeId: nodeId, sessionId: sessionId, user: user })=>({ setState: setState, getState: getState })=>{
        const { color: color } = (0, $3BgyA.getColorFromString)(sessionId);
        const newSelection = {
            nodeId: nodeId,
            user: user,
            color: color,
            sessionId: sessionId
        };
        const state = getState();
        const dedupCurrentSelection = state.nodeSelection[nodeId] && state.nodeSelection[nodeId].filter((selection)=>selection.user.userId !== user.userId);
        const nodeSelection = dedupCurrentSelection ? [
            ...dedupCurrentSelection,
            newSelection
        ] : [
            newSelection
        ];
        // deduplicate selected nodes from this user, because each user can have only one selected node on the page
        // see JET-2794
        const dedupOtherSelections = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            // keep selections from all other users
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>selection.user.userId !== user.userId);
                if (filteredSelections.length === 0) return;
                dedupOtherSelections[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            nodeSelection: {
                ...dedupOtherSelections,
                [nodeId]: nodeSelection
            }
        });
    };
const $8f55868fdda87f4e$var$clearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams, userId: userId })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newNodeSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            if (nodeIdKey !== nodeId) newNodeSelection[nodeIdKey] = state.nodeSelection[nodeIdKey];
        });
        setState({
            ...state,
            nodeSelection: newNodeSelection,
            dragAnimation: dropParams && userId != null ? [
                ...state.dragAnimation,
                {
                    ...dropParams,
                    userId: userId
                }
            ] : state.dragAnimation
        });
    };
const $8f55868fdda87f4e$var$stopDragAnimation = ({ sourceNodeId: sourceNodeId })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            dragAnimation: state.dragAnimation.filter((animation)=>String(animation.sourceNodeId) !== String(sourceNodeId))
        });
    };
const $8f55868fdda87f4e$var$actions = {
    setProvider: $8f55868fdda87f4e$var$setProvider,
    participantsLeft: $8f55868fdda87f4e$var$participantsLeft,
    participantsJoined: $8f55868fdda87f4e$var$participantsJoined,
    updateUserInParticipants: $8f55868fdda87f4e$var$updateUserInParticipants,
    sendNodeSelected: $8f55868fdda87f4e$var$sendNodeSelected,
    sendClearNodeSelection: $8f55868fdda87f4e$var$sendClearNodeSelection,
    setNodeSelection: $8f55868fdda87f4e$var$setNodeSelection,
    clearNodeSelection: $8f55868fdda87f4e$var$clearNodeSelection,
    stopDragAnimation: $8f55868fdda87f4e$var$stopDragAnimation
};
const $8f55868fdda87f4e$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        provider: null,
        participants: [],
        nodeSelection: {},
        dragAnimation: []
    },
    actions: $8f55868fdda87f4e$var$actions,
    name: 'JWMCollabStore'
});
const $8f55868fdda87f4e$export$4159ae80cfa2156 = (0, $WBLbN.createHook)($8f55868fdda87f4e$var$Store);

});
parcelRegister("3BgyA", function(module, exports) {

$parcel$export(module.exports, "getColorFromString", () => $9bfc0522bb35e6c9$export$137ec5185b12f5a2);

const $9bfc0522bb35e6c9$var$colors = [
    (0, $1b343b038f6c23ec$exports).R300,
    (0, $1b343b038f6c23ec$exports).R400,
    (0, $1b343b038f6c23ec$exports).R500,
    (0, $1b343b038f6c23ec$exports).Y300,
    (0, $1b343b038f6c23ec$exports).Y400,
    (0, $1b343b038f6c23ec$exports).Y500,
    (0, $1b343b038f6c23ec$exports).G300,
    (0, $1b343b038f6c23ec$exports).G400,
    (0, $1b343b038f6c23ec$exports).G500,
    (0, $1b343b038f6c23ec$exports).T300,
    (0, $1b343b038f6c23ec$exports).T400,
    (0, $1b343b038f6c23ec$exports).T500,
    (0, $1b343b038f6c23ec$exports).P300,
    (0, $1b343b038f6c23ec$exports).P400,
    (0, $1b343b038f6c23ec$exports).P500,
    (0, $1b343b038f6c23ec$exports).N200,
    (0, $1b343b038f6c23ec$exports).N500,
    (0, $1b343b038f6c23ec$exports).N800
];
const $9bfc0522bb35e6c9$export$137ec5185b12f5a2 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i += 1){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash &= hash;
    /* eslint-enable no-bitwise */ }
    const index = Math.abs(hash) % $9bfc0522bb35e6c9$var$colors.length;
    const hexColor = $9bfc0522bb35e6c9$var$colors[index];
    return {
        index: index,
        color: hexColor
    };
};

});
var $1b343b038f6c23ec$exports = {};

$parcel$export($1b343b038f6c23ec$exports, "R50", () => $1b343b038f6c23ec$export$4b84fd0e2c617bd);
$parcel$export($1b343b038f6c23ec$exports, "R75", () => $1b343b038f6c23ec$export$b34b069eff244586);
$parcel$export($1b343b038f6c23ec$exports, "R100", () => $1b343b038f6c23ec$export$be802dd0d8b57f35);
$parcel$export($1b343b038f6c23ec$exports, "R200", () => $1b343b038f6c23ec$export$60847d42f9da92a6);
$parcel$export($1b343b038f6c23ec$exports, "R300", () => $1b343b038f6c23ec$export$4a7404f376229999);
$parcel$export($1b343b038f6c23ec$exports, "R400", () => $1b343b038f6c23ec$export$2010d0fb4295b346);
$parcel$export($1b343b038f6c23ec$exports, "R500", () => $1b343b038f6c23ec$export$2837b5a1a71d5c02);
$parcel$export($1b343b038f6c23ec$exports, "Y50", () => $1b343b038f6c23ec$export$8d9596b529bbb9cf);
$parcel$export($1b343b038f6c23ec$exports, "Y75", () => $1b343b038f6c23ec$export$41060a744ab0b7ae);
$parcel$export($1b343b038f6c23ec$exports, "Y100", () => $1b343b038f6c23ec$export$1cc05bbbf340e559);
$parcel$export($1b343b038f6c23ec$exports, "Y200", () => $1b343b038f6c23ec$export$5aae31392d72caaa);
$parcel$export($1b343b038f6c23ec$exports, "Y300", () => $1b343b038f6c23ec$export$c6930421db9fa514);
$parcel$export($1b343b038f6c23ec$exports, "Y400", () => $1b343b038f6c23ec$export$59619663aa6500fb);
$parcel$export($1b343b038f6c23ec$exports, "Y500", () => $1b343b038f6c23ec$export$874739ea9e379ab6);
$parcel$export($1b343b038f6c23ec$exports, "G50", () => $1b343b038f6c23ec$export$8a6341c32b6a3ee6);
$parcel$export($1b343b038f6c23ec$exports, "G75", () => $1b343b038f6c23ec$export$69a3bf21b9686c2b);
$parcel$export($1b343b038f6c23ec$exports, "G100", () => $1b343b038f6c23ec$export$afbce1382ec95f73);
$parcel$export($1b343b038f6c23ec$exports, "G200", () => $1b343b038f6c23ec$export$747d86715d4175de);
$parcel$export($1b343b038f6c23ec$exports, "G300", () => $1b343b038f6c23ec$export$940e1f69e873f202);
$parcel$export($1b343b038f6c23ec$exports, "G400", () => $1b343b038f6c23ec$export$a49394138f7b8e85);
$parcel$export($1b343b038f6c23ec$exports, "G500", () => $1b343b038f6c23ec$export$6fa04827ac68a4fb);
$parcel$export($1b343b038f6c23ec$exports, "B50", () => $1b343b038f6c23ec$export$226de0355ed012f8);
$parcel$export($1b343b038f6c23ec$exports, "B75", () => $1b343b038f6c23ec$export$8c13c2ee36917869);
$parcel$export($1b343b038f6c23ec$exports, "B100", () => $1b343b038f6c23ec$export$ecfc1dff386a3e7a);
$parcel$export($1b343b038f6c23ec$exports, "B200", () => $1b343b038f6c23ec$export$215b7063051591f1);
$parcel$export($1b343b038f6c23ec$exports, "B300", () => $1b343b038f6c23ec$export$e62e8919cca44969);
$parcel$export($1b343b038f6c23ec$exports, "B400", () => $1b343b038f6c23ec$export$b3de0ae08da2ce64);
$parcel$export($1b343b038f6c23ec$exports, "B500", () => $1b343b038f6c23ec$export$a6ee3d71bc067634);
$parcel$export($1b343b038f6c23ec$exports, "B600", () => $1b343b038f6c23ec$export$67f15409e87642a1);
$parcel$export($1b343b038f6c23ec$exports, "B700", () => $1b343b038f6c23ec$export$f0539dbc42dbb067);
$parcel$export($1b343b038f6c23ec$exports, "P50", () => $1b343b038f6c23ec$export$363e4475840015bb);
$parcel$export($1b343b038f6c23ec$exports, "P75", () => $1b343b038f6c23ec$export$4b0a4417ed59760f);
$parcel$export($1b343b038f6c23ec$exports, "P100", () => $1b343b038f6c23ec$export$6011520a64d9a187);
$parcel$export($1b343b038f6c23ec$exports, "P200", () => $1b343b038f6c23ec$export$a7175d4e9206bc80);
$parcel$export($1b343b038f6c23ec$exports, "P300", () => $1b343b038f6c23ec$export$b48405b95304b5a1);
$parcel$export($1b343b038f6c23ec$exports, "P400", () => $1b343b038f6c23ec$export$c71e4279dd54a18d);
$parcel$export($1b343b038f6c23ec$exports, "P500", () => $1b343b038f6c23ec$export$147899de772240ec);
$parcel$export($1b343b038f6c23ec$exports, "T50", () => $1b343b038f6c23ec$export$2cf711fe14c66f06);
$parcel$export($1b343b038f6c23ec$exports, "T75", () => $1b343b038f6c23ec$export$7a8f4d33f6f9772c);
$parcel$export($1b343b038f6c23ec$exports, "T100", () => $1b343b038f6c23ec$export$776c9c497ef08533);
$parcel$export($1b343b038f6c23ec$exports, "T200", () => $1b343b038f6c23ec$export$69cb3ca10c1e330e);
$parcel$export($1b343b038f6c23ec$exports, "T300", () => $1b343b038f6c23ec$export$9dc1ef0f3f48059b);
$parcel$export($1b343b038f6c23ec$exports, "T400", () => $1b343b038f6c23ec$export$7c835c78b6fcdef8);
$parcel$export($1b343b038f6c23ec$exports, "T500", () => $1b343b038f6c23ec$export$6036577f95c3877e);
$parcel$export($1b343b038f6c23ec$exports, "N0", () => $1b343b038f6c23ec$export$29a4f05edc054374);
$parcel$export($1b343b038f6c23ec$exports, "N10", () => $1b343b038f6c23ec$export$e655ef011c4aa1a2);
$parcel$export($1b343b038f6c23ec$exports, "N20", () => $1b343b038f6c23ec$export$9fdfb749e33cdf97);
$parcel$export($1b343b038f6c23ec$exports, "N30", () => $1b343b038f6c23ec$export$3e51e8f1440314ba);
$parcel$export($1b343b038f6c23ec$exports, "N40", () => $1b343b038f6c23ec$export$1ce2d1575d444ceb);
$parcel$export($1b343b038f6c23ec$exports, "N50", () => $1b343b038f6c23ec$export$8754fc7e6d8b3000);
$parcel$export($1b343b038f6c23ec$exports, "N60", () => $1b343b038f6c23ec$export$c2e91cbeada39b8b);
$parcel$export($1b343b038f6c23ec$exports, "N70", () => $1b343b038f6c23ec$export$5f71e19f3a7ad9de);
$parcel$export($1b343b038f6c23ec$exports, "N80", () => $1b343b038f6c23ec$export$eaa8c8a70ac22806);
$parcel$export($1b343b038f6c23ec$exports, "N90", () => $1b343b038f6c23ec$export$7c87d337fb91a97d);
$parcel$export($1b343b038f6c23ec$exports, "N100", () => $1b343b038f6c23ec$export$d6447c357493214f);
$parcel$export($1b343b038f6c23ec$exports, "N200", () => $1b343b038f6c23ec$export$f563ee71e9ee74cd);
$parcel$export($1b343b038f6c23ec$exports, "N300", () => $1b343b038f6c23ec$export$e2ef2124cf4024b1);
$parcel$export($1b343b038f6c23ec$exports, "N400", () => $1b343b038f6c23ec$export$eece5f492e429f08);
$parcel$export($1b343b038f6c23ec$exports, "N500", () => $1b343b038f6c23ec$export$c39c0fe0f26207ae);
$parcel$export($1b343b038f6c23ec$exports, "N600", () => $1b343b038f6c23ec$export$7090862dc3038a9f);
$parcel$export($1b343b038f6c23ec$exports, "N700", () => $1b343b038f6c23ec$export$ad0bacf983b7ddaa);
$parcel$export($1b343b038f6c23ec$exports, "N800", () => $1b343b038f6c23ec$export$7d61b15e0da132af);
$parcel$export($1b343b038f6c23ec$exports, "N900", () => $1b343b038f6c23ec$export$fbda843f0a27fe96);
$parcel$export($1b343b038f6c23ec$exports, "N10A", () => $1b343b038f6c23ec$export$791e57b27ca738ef);
$parcel$export($1b343b038f6c23ec$exports, "N20A", () => $1b343b038f6c23ec$export$8d43898f60b96a82);
$parcel$export($1b343b038f6c23ec$exports, "N30A", () => $1b343b038f6c23ec$export$920c0d5c49070351);
$parcel$export($1b343b038f6c23ec$exports, "N40A", () => $1b343b038f6c23ec$export$46987b49aab6d1a8);
$parcel$export($1b343b038f6c23ec$exports, "N50A", () => $1b343b038f6c23ec$export$7d3359664e8bb0e5);
$parcel$export($1b343b038f6c23ec$exports, "N60A", () => $1b343b038f6c23ec$export$d2d3bedfb276cac0);
$parcel$export($1b343b038f6c23ec$exports, "N70A", () => $1b343b038f6c23ec$export$6e5e7499ff054f6d);
$parcel$export($1b343b038f6c23ec$exports, "N80A", () => $1b343b038f6c23ec$export$59264b346c877fa7);
$parcel$export($1b343b038f6c23ec$exports, "N90A", () => $1b343b038f6c23ec$export$d092757d7c64925c);
$parcel$export($1b343b038f6c23ec$exports, "N100A", () => $1b343b038f6c23ec$export$486ab785e4bac3c6);
$parcel$export($1b343b038f6c23ec$exports, "N200A", () => $1b343b038f6c23ec$export$fba592bbc6419fea);
$parcel$export($1b343b038f6c23ec$exports, "N300A", () => $1b343b038f6c23ec$export$13609db0e6812ab8);
$parcel$export($1b343b038f6c23ec$exports, "N400A", () => $1b343b038f6c23ec$export$fbae4efaa892d883);
$parcel$export($1b343b038f6c23ec$exports, "N500A", () => $1b343b038f6c23ec$export$f13946d26f440ce6);
$parcel$export($1b343b038f6c23ec$exports, "N600A", () => $1b343b038f6c23ec$export$19f58225ac52a306);
$parcel$export($1b343b038f6c23ec$exports, "N700A", () => $1b343b038f6c23ec$export$6384f09da70e7b62);
$parcel$export($1b343b038f6c23ec$exports, "N800A", () => $1b343b038f6c23ec$export$d0dccc730683edc2);
$parcel$export($1b343b038f6c23ec$exports, "DN900", () => $1b343b038f6c23ec$export$2f6319cf7d736c2a);
$parcel$export($1b343b038f6c23ec$exports, "DN800", () => $1b343b038f6c23ec$export$95126bc8884d6634);
$parcel$export($1b343b038f6c23ec$exports, "DN700", () => $1b343b038f6c23ec$export$8338d8c35d44ff1);
$parcel$export($1b343b038f6c23ec$exports, "DN600", () => $1b343b038f6c23ec$export$5368d76ae4fbbda7);
$parcel$export($1b343b038f6c23ec$exports, "DN500", () => $1b343b038f6c23ec$export$9f0a771d16ec8d36);
$parcel$export($1b343b038f6c23ec$exports, "DN400", () => $1b343b038f6c23ec$export$abcf8c38338b4aa5);
$parcel$export($1b343b038f6c23ec$exports, "DN300", () => $1b343b038f6c23ec$export$97e81faa16a182c7);
$parcel$export($1b343b038f6c23ec$exports, "DN200", () => $1b343b038f6c23ec$export$bfe21c59123ecf33);
$parcel$export($1b343b038f6c23ec$exports, "DN100", () => $1b343b038f6c23ec$export$ee82aa2ea6a1558);
$parcel$export($1b343b038f6c23ec$exports, "DN90", () => $1b343b038f6c23ec$export$682927c6ed76be02);
$parcel$export($1b343b038f6c23ec$exports, "DN80", () => $1b343b038f6c23ec$export$91fd9994c5be9757);
$parcel$export($1b343b038f6c23ec$exports, "DN70", () => $1b343b038f6c23ec$export$d281fbfe3cff2df6);
$parcel$export($1b343b038f6c23ec$exports, "DN60", () => $1b343b038f6c23ec$export$3902c91d8b98a753);
$parcel$export($1b343b038f6c23ec$exports, "DN50", () => $1b343b038f6c23ec$export$8e8133c1ba5845b5);
$parcel$export($1b343b038f6c23ec$exports, "DN40", () => $1b343b038f6c23ec$export$33ff357f6620b39);
$parcel$export($1b343b038f6c23ec$exports, "DN30", () => $1b343b038f6c23ec$export$633847cf062b69e0);
$parcel$export($1b343b038f6c23ec$exports, "DN20", () => $1b343b038f6c23ec$export$9776a6e503bdbf76);
$parcel$export($1b343b038f6c23ec$exports, "DN10", () => $1b343b038f6c23ec$export$6c813d5160dff5db);
$parcel$export($1b343b038f6c23ec$exports, "DN0", () => $1b343b038f6c23ec$export$3d4f271a500072a);
$parcel$export($1b343b038f6c23ec$exports, "DN800A", () => $1b343b038f6c23ec$export$fe151285c22759ec);
$parcel$export($1b343b038f6c23ec$exports, "DN700A", () => $1b343b038f6c23ec$export$a101c6190d0da34);
$parcel$export($1b343b038f6c23ec$exports, "DN600A", () => $1b343b038f6c23ec$export$4b16f52932fda51);
$parcel$export($1b343b038f6c23ec$exports, "DN500A", () => $1b343b038f6c23ec$export$a74bcd7b9845b0d8);
$parcel$export($1b343b038f6c23ec$exports, "DN400A", () => $1b343b038f6c23ec$export$9209c179316d1751);
$parcel$export($1b343b038f6c23ec$exports, "DN300A", () => $1b343b038f6c23ec$export$88f55133f636c8dd);
$parcel$export($1b343b038f6c23ec$exports, "DN200A", () => $1b343b038f6c23ec$export$51126f85d1009512);
$parcel$export($1b343b038f6c23ec$exports, "DN100A", () => $1b343b038f6c23ec$export$a069b547bd23af78);
$parcel$export($1b343b038f6c23ec$exports, "DN90A", () => $1b343b038f6c23ec$export$40cce05af3b2600a);
$parcel$export($1b343b038f6c23ec$exports, "DN80A", () => $1b343b038f6c23ec$export$b78942185925a0d);
$parcel$export($1b343b038f6c23ec$exports, "DN70A", () => $1b343b038f6c23ec$export$e058fb44b8eaafca);
$parcel$export($1b343b038f6c23ec$exports, "DN60A", () => $1b343b038f6c23ec$export$92b0b8de26920c18);
$parcel$export($1b343b038f6c23ec$exports, "DN50A", () => $1b343b038f6c23ec$export$67564f7459d3fc9e);
$parcel$export($1b343b038f6c23ec$exports, "DN40A", () => $1b343b038f6c23ec$export$77868e1ca884ffa3);
$parcel$export($1b343b038f6c23ec$exports, "DN30A", () => $1b343b038f6c23ec$export$2afd71d7d3ea2cd5);
$parcel$export($1b343b038f6c23ec$exports, "DN20A", () => $1b343b038f6c23ec$export$f2a0acaab9972c70);
$parcel$export($1b343b038f6c23ec$exports, "DN10A", () => $1b343b038f6c23ec$export$9ab70e67d6475361);
$parcel$export($1b343b038f6c23ec$exports, "T30", () => $1b343b038f6c23ec$export$d2adc5dedf09fced);
$parcel$export($1b343b038f6c23ec$exports, "L50", () => $1b343b038f6c23ec$export$f51762073d2bb381);
$parcel$export($1b343b038f6c23ec$exports, "L75", () => $1b343b038f6c23ec$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $1b343b038f6c23ec$export$4b84fd0e2c617bd = '#FFEBE6';
const $1b343b038f6c23ec$export$b34b069eff244586 = '#FFBDAD';
const $1b343b038f6c23ec$export$be802dd0d8b57f35 = '#FF8F73';
const $1b343b038f6c23ec$export$60847d42f9da92a6 = '#FF7452';
const $1b343b038f6c23ec$export$4a7404f376229999 = '#FF5630';
const $1b343b038f6c23ec$export$2010d0fb4295b346 = '#DE350B';
const $1b343b038f6c23ec$export$2837b5a1a71d5c02 = '#BF2600';
const $1b343b038f6c23ec$export$8d9596b529bbb9cf = '#FFFAE6';
const $1b343b038f6c23ec$export$41060a744ab0b7ae = '#FFF0B3';
const $1b343b038f6c23ec$export$1cc05bbbf340e559 = '#FFE380';
const $1b343b038f6c23ec$export$5aae31392d72caaa = '#FFC400';
const $1b343b038f6c23ec$export$c6930421db9fa514 = '#FFAB00';
const $1b343b038f6c23ec$export$59619663aa6500fb = '#FF991F';
const $1b343b038f6c23ec$export$874739ea9e379ab6 = '#FF8B00';
const $1b343b038f6c23ec$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $1b343b038f6c23ec$export$69a3bf21b9686c2b = '#ABF5D1';
const $1b343b038f6c23ec$export$afbce1382ec95f73 = '#79F2C0';
const $1b343b038f6c23ec$export$747d86715d4175de = '#57D9A3';
const $1b343b038f6c23ec$export$940e1f69e873f202 = '#36B37E';
const $1b343b038f6c23ec$export$a49394138f7b8e85 = '#00875A';
const $1b343b038f6c23ec$export$6fa04827ac68a4fb = '#006644';
const $1b343b038f6c23ec$export$226de0355ed012f8 = '#DEEBFF';
const $1b343b038f6c23ec$export$8c13c2ee36917869 = '#B3D4FF';
const $1b343b038f6c23ec$export$ecfc1dff386a3e7a = '#4C9AFF';
const $1b343b038f6c23ec$export$215b7063051591f1 = '#2684FF';
const $1b343b038f6c23ec$export$e62e8919cca44969 = '#0065FF';
const $1b343b038f6c23ec$export$b3de0ae08da2ce64 = '#0052CC';
const $1b343b038f6c23ec$export$a6ee3d71bc067634 = '#0747A6';
const $1b343b038f6c23ec$export$67f15409e87642a1 = '#669DF1';
const $1b343b038f6c23ec$export$f0539dbc42dbb067 = '#8FB8F6';
const $1b343b038f6c23ec$export$363e4475840015bb = '#EAE6FF';
const $1b343b038f6c23ec$export$4b0a4417ed59760f = '#C0B6F2';
const $1b343b038f6c23ec$export$6011520a64d9a187 = '#998DD9';
const $1b343b038f6c23ec$export$a7175d4e9206bc80 = '#8777D9';
const $1b343b038f6c23ec$export$b48405b95304b5a1 = '#6554C0';
const $1b343b038f6c23ec$export$c71e4279dd54a18d = '#5243AA';
const $1b343b038f6c23ec$export$147899de772240ec = '#403294';
const $1b343b038f6c23ec$export$2cf711fe14c66f06 = '#E6FCFF';
const $1b343b038f6c23ec$export$7a8f4d33f6f9772c = '#B3F5FF';
const $1b343b038f6c23ec$export$776c9c497ef08533 = '#79E2F2';
const $1b343b038f6c23ec$export$69cb3ca10c1e330e = '#00C7E6';
const $1b343b038f6c23ec$export$9dc1ef0f3f48059b = '#00B8D9';
const $1b343b038f6c23ec$export$7c835c78b6fcdef8 = '#00A3BF';
const $1b343b038f6c23ec$export$6036577f95c3877e = '#008DA6';
const $1b343b038f6c23ec$export$29a4f05edc054374 = '#FFFFFF';
const $1b343b038f6c23ec$export$e655ef011c4aa1a2 = '#FAFBFC';
const $1b343b038f6c23ec$export$9fdfb749e33cdf97 = '#F4F5F7';
const $1b343b038f6c23ec$export$3e51e8f1440314ba = '#EBECF0';
const $1b343b038f6c23ec$export$1ce2d1575d444ceb = '#DFE1E6';
const $1b343b038f6c23ec$export$8754fc7e6d8b3000 = '#C1C7D0';
const $1b343b038f6c23ec$export$c2e91cbeada39b8b = '#B3BAC5';
const $1b343b038f6c23ec$export$5f71e19f3a7ad9de = '#A5ADBA';
const $1b343b038f6c23ec$export$eaa8c8a70ac22806 = '#97A0AF';
const $1b343b038f6c23ec$export$7c87d337fb91a97d = '#8993A4';
const $1b343b038f6c23ec$export$d6447c357493214f = '#7A869A';
const $1b343b038f6c23ec$export$f563ee71e9ee74cd = '#6B778C';
const $1b343b038f6c23ec$export$e2ef2124cf4024b1 = '#5E6C84';
const $1b343b038f6c23ec$export$eece5f492e429f08 = '#505F79';
const $1b343b038f6c23ec$export$c39c0fe0f26207ae = '#42526E';
const $1b343b038f6c23ec$export$7090862dc3038a9f = '#344563';
const $1b343b038f6c23ec$export$ad0bacf983b7ddaa = '#253858';
const $1b343b038f6c23ec$export$7d61b15e0da132af = '#172B4D';
const $1b343b038f6c23ec$export$fbda843f0a27fe96 = '#091E42';
const $1b343b038f6c23ec$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $1b343b038f6c23ec$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $1b343b038f6c23ec$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $1b343b038f6c23ec$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $1b343b038f6c23ec$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $1b343b038f6c23ec$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $1b343b038f6c23ec$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $1b343b038f6c23ec$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $1b343b038f6c23ec$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $1b343b038f6c23ec$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $1b343b038f6c23ec$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $1b343b038f6c23ec$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $1b343b038f6c23ec$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $1b343b038f6c23ec$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $1b343b038f6c23ec$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $1b343b038f6c23ec$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $1b343b038f6c23ec$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $1b343b038f6c23ec$export$2f6319cf7d736c2a = '#E6EDFA';
const $1b343b038f6c23ec$export$95126bc8884d6634 = '#DCE5F5';
const $1b343b038f6c23ec$export$8338d8c35d44ff1 = '#CED9EB';
const $1b343b038f6c23ec$export$5368d76ae4fbbda7 = '#B8C7E0';
const $1b343b038f6c23ec$export$9f0a771d16ec8d36 = '#ABBBD6';
const $1b343b038f6c23ec$export$abcf8c38338b4aa5 = '#9FB0CC';
const $1b343b038f6c23ec$export$97e81faa16a182c7 = '#8C9CB8';
const $1b343b038f6c23ec$export$bfe21c59123ecf33 = '#7988A3';
const $1b343b038f6c23ec$export$ee82aa2ea6a1558 = '#67758F';
const $1b343b038f6c23ec$export$682927c6ed76be02 = '#56637A';
const $1b343b038f6c23ec$export$91fd9994c5be9757 = '#455166';
const $1b343b038f6c23ec$export$d281fbfe3cff2df6 = '#3B475C';
const $1b343b038f6c23ec$export$3902c91d8b98a753 = '#313D52';
const $1b343b038f6c23ec$export$8e8133c1ba5845b5 = '#283447';
const $1b343b038f6c23ec$export$33ff357f6620b39 = '#202B3D';
const $1b343b038f6c23ec$export$633847cf062b69e0 = '#1B2638';
const $1b343b038f6c23ec$export$9776a6e503bdbf76 = '#121A29';
const $1b343b038f6c23ec$export$6c813d5160dff5db = '#0E1624';
const $1b343b038f6c23ec$export$3d4f271a500072a = '#0D1424';
const $1b343b038f6c23ec$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $1b343b038f6c23ec$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $1b343b038f6c23ec$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $1b343b038f6c23ec$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $1b343b038f6c23ec$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $1b343b038f6c23ec$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $1b343b038f6c23ec$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $1b343b038f6c23ec$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $1b343b038f6c23ec$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $1b343b038f6c23ec$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $1b343b038f6c23ec$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $1b343b038f6c23ec$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $1b343b038f6c23ec$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $1b343b038f6c23ec$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $1b343b038f6c23ec$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $1b343b038f6c23ec$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $1b343b038f6c23ec$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $1b343b038f6c23ec$export$d2adc5dedf09fced = '#292A2E';
const $1b343b038f6c23ec$export$f51762073d2bb381 = '#94C748';
const $1b343b038f6c23ec$export$95e26d54def96891 = '#B3DF72';


const $daf44b44f86c0150$export$3debf01bbfa135e5 = 80;


parcelRegister("i0nxo", function(module, exports) {

$parcel$export(module.exports, "getPresenceNodeId", () => $0ed5d5739c577dad$export$b31325f2ad6cf0b5);
const $0ed5d5739c577dad$export$b31325f2ad6cf0b5 = ({ projectId: projectId, viewId: viewId, nodeId: nodeId })=>`project:${projectId}:view/${viewId}/node/${nodeId}`;

});

parcelRegister("3JiQx", function(module, exports) {

$parcel$export(module.exports, "BusinessRealtime", () => $b046e6744d314566$export$3a36519ab0aab897);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $fEYK5 = parcelRequire("fEYK5");


var $giZl9 = parcelRequire("giZl9");

var $6heO3 = parcelRequire("6heO3");

var $dWLk9 = parcelRequire("dWLk9");

var $ePgRW = parcelRequire("ePgRW");
const $b046e6744d314566$var$DEFAULT_EVENTS_TO_SUBSCRIBE_TO = [
    (0, $1d129cd1c8b202ad$export$b22a14d5dac59664),
    (0, $1d129cd1c8b202ad$export$25fa37e5059c5a99),
    (0, $1d129cd1c8b202ad$export$b22142e61b3fdbee),
    (0, $1d129cd1c8b202ad$export$d9bc8850eeef9f60)
];
const $b046e6744d314566$export$3a36519ab0aab897 = ({ appId: appId, onReceive: onReceive, eventsToSubscribeTo: eventsToSubscribeTo = $b046e6744d314566$var$DEFAULT_EVENTS_TO_SUBSCRIBE_TO })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const realtimeIds = (0, $ePgRW.useRealtimeContext)();
    const realtimeChannels = (0, $eUqFw.useMemo)(()=>realtimeIds.map((pid)=>(0, $giZl9.buildChannelString)(cloudId, pid)), [
        cloudId,
        realtimeIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6heO3.default), {
        appId: appId,
        channels: realtimeChannels,
        events: eventsToSubscribeTo,
        onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onReceive: (event)=>{
            if (!(0, $fEYK5.isPageVisible)()) return;
            onReceive(event);
        },
        onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    });
};

});
const $1d129cd1c8b202ad$export$86d416e8d15777d = 'avi:jira:assigned:issue';
const $1d129cd1c8b202ad$export$b22a14d5dac59664 = 'avi:jira:created:issue';
const $1d129cd1c8b202ad$export$25fa37e5059c5a99 = 'avi:jira:deleted:issue';
const $1d129cd1c8b202ad$export$d9bc8850eeef9f60 = 'avi:jira:transitioned:issue';
const $1d129cd1c8b202ad$export$b22142e61b3fdbee = 'avi:jira:updated:issue';
const $1d129cd1c8b202ad$export$773466d9acc404c0 = 'avi:jira:commented:issue';
const $1d129cd1c8b202ad$export$6b7e46ea0442b66c = 'avi:jira:updated:issue_parent_association';
const $1d129cd1c8b202ad$export$6024bd0c20931af3 = 'avi:jira-software:update:board-scope-issues';

parcelRegister("giZl9", function(module, exports) {

$parcel$export(module.exports, "getDefaultPubSubHost", () => $5615d21da29bd94b$export$f795b2d9ba365882);
$parcel$export(module.exports, "buildChannelString", () => $5615d21da29bd94b$export$354e43de513ff5);

var $6rW04 = parcelRequire("6rW04");

const $5615d21da29bd94b$export$f795b2d9ba365882 = ()=>(0, $6rW04.default)('ajs-fabric-realtime-url') || (0, $b0799f8f855a2fe4$export$92ffb25149c24a33);
const $5615d21da29bd94b$export$354e43de513ff5 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;

});
const $b0799f8f855a2fe4$export$92ffb25149c24a33 = '/gateway/api/pubsub';
const $b0799f8f855a2fe4$export$13ac40d1a5475532 = 'JIRA';


parcelRegister("6heO3", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb89aa8c6039d680$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $fLHAD = parcelRequire("fLHAD");

var $2W6nG = parcelRequire("2W6nG");
class $eb89aa8c6039d680$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onReceive: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    render() {
        const { appId: appId, events: events, onJoin: onJoin, onLeave: onLeave, channels: channels } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2W6nG.RealtimeProvider), {
            appId: appId,
            onJoin: onJoin,
            onLeave: onLeave,
            channels: channels
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fLHAD.RealtimeClient), {
            events: events,
            onReceive: this.onEventReceive
        }));
    }
    constructor(...args){
        super(...args);
        this.onEventReceive = (eventType, payload)=>{
            const event = {
                type: eventType,
                payload: payload
            };
            this.props.onReceive(event);
        };
    }
}

});
parcelRegister("fLHAD", function(module, exports) {

$parcel$export(module.exports, "RealtimeClient", () => $42b77c4aa56216fa$export$e680ceb7b9fcc184);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $g8JvH = parcelRequire("g8JvH");

var $efKIh = parcelRequire("efKIh");

var $6yVT4 = parcelRequire("6yVT4");
// eslint-disable-next-line jira/react/no-class-components
class $42b77c4aa56216fa$var$RealtimeClientView extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            children: null
        };
    }
    componentDidMount() {
        this.subscribeToPropEvents();
    }
    componentDidUpdate(prevProps) {
        if (this.props.client !== prevProps.client || this.props.events !== prevProps.events) {
            const removedEvents = prevProps.events.filter((prevEvent)=>!this.props.events.includes(prevEvent));
            removedEvents.forEach(this.unSubscribeToEvent);
            this.subscribeToPropEvents();
        }
    }
    componentWillUnmount() {
        this.unsubscribeToPropEvents();
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.onReceiveEvent = (event, payload)=>{
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            this.props.onReceive(event, payload);
        };
        this.subscribeToEvent = (eventName)=>{
            this.props.client?.on(eventName, this.onReceiveEvent);
        };
        this.unSubscribeToEvent = (eventName)=>{
            this.props.client?.off(eventName, this.onReceiveEvent);
        };
        this.subscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.subscribeToEvent);
        };
        this.unsubscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.unSubscribeToEvent);
        };
    }
}
const $42b77c4aa56216fa$var$withAnalytics = (0, $g8JvH.AnalyticsEventToProps)('realtimeClient', {
    onReceive: 'eventReceived'
});
const $42b77c4aa56216fa$export$e680ceb7b9fcc184 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))($42b77c4aa56216fa$var$withAnalytics, (0, $6yVT4.withPubSubClient), (0, $efKIh.asClientOnly))($42b77c4aa56216fa$var$RealtimeClientView);
var $42b77c4aa56216fa$export$2e2bcd8739ae039 = $42b77c4aa56216fa$export$e680ceb7b9fcc184;

});
parcelRegister("g8JvH", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $4e66802e461455f0$export$3e9ef96ba97ea9dc);

var $f3klQ = parcelRequire("f3klQ");
const $4e66802e461455f0$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $4e66802e461455f0$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $f3klQ.default)($4e66802e461455f0$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

parcelRegister("efKIh", function(module, exports) {

$parcel$export(module.exports, "asClientOnly", () => $4874a35f2e3af873$export$95cd02374de3431);

var $eUqFw = parcelRequire("eUqFw");
function $4874a35f2e3af873$export$95cd02374de3431(WrappedComponent) {
    return (props)=>{
        if (false) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props);
    };
}
var $4874a35f2e3af873$export$2e2bcd8739ae039 = $4874a35f2e3af873$export$95cd02374de3431;

});

parcelRegister("6yVT4", function(module, exports) {

$parcel$export(module.exports, "withPubSubClient", () => $4857e418d88b13dd$export$32d968d4900ae3cd);

var $eUqFw = parcelRequire("eUqFw");

var $e97Bh = parcelRequire("e97Bh");
function $4857e418d88b13dd$export$32d968d4900ae3cd(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e97Bh.Consumer), null, ({ client: client })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                client: client
            }));
}
var $4857e418d88b13dd$export$2e2bcd8739ae039 = $4857e418d88b13dd$export$32d968d4900ae3cd;

});
parcelRegister("e97Bh", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $4f1fb1ba24fc84ec$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $4f1fb1ba24fc84ec$export$b3bffd4bb7da6b8f);

var $eUqFw = parcelRequire("eUqFw");
const $4f1fb1ba24fc84ec$var$defaultContext = {
    client: null
};
const { Provider: $4f1fb1ba24fc84ec$export$2881499e37b75b9a, Consumer: $4f1fb1ba24fc84ec$export$b3bffd4bb7da6b8f } = /*#__PURE__*/ (0, $eUqFw.createContext)($4f1fb1ba24fc84ec$var$defaultContext);

});



parcelRegister("2W6nG", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $ba1d3670c80098a4$export$64d242981d970821);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $jG2Eu = parcelRequire("jG2Eu");

var $gUUjF = parcelRequire("gUUjF");

var $g8JvH = parcelRequire("g8JvH");

var $3FyZ4 = parcelRequire("3FyZ4");


var $e97Bh = parcelRequire("e97Bh");

var $eBLah = parcelRequire("eBLah");

var $eDbRL = parcelRequire("eDbRL");

const $ba1d3670c80098a4$var$createPubSubClient = (host, analyticsClient)=>(parcelRequire("fHifU")).then((module)=>{
        const Client = module.default;
        return new Client({
            product: (0, $b0799f8f855a2fe4$export$13ac40d1a5475532),
            url: `${host}`,
            apsProtocol: {
                enabled: true
            },
            analyticsClient: analyticsClient
        });
    });
const $ba1d3670c80098a4$export$c127c26e30518ed5 = (appId, client, channels, onHandler)=>client.join(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $gUUjF.default).safeErrorWithoutCustomerData('realtime.channel.join.failure', `Failed to join channel @ ${appId}`, error);
    });
const $ba1d3670c80098a4$export$e6c41c8aa28ddeb9 = (appId, client, channels, onHandler)=>client.leave(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $gUUjF.default).safeErrorWithoutCustomerData('realtime.channel.leave.failure', `Failed to left channel @ ${appId}`, error);
    });
// eslint-disable-next-line jira/react/no-class-components
class $ba1d3670c80098a4$var$RealtimeProviderView extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            host: (0, $b0799f8f855a2fe4$export$92ffb25149c24a33),
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    componentDidMount() {
        const { appId: appId, host: host, channels: channels } = this.props;
        this.isComponentMounted = true;
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((analyticsClient)=>$ba1d3670c80098a4$var$createPubSubClient(host, analyticsClient.getInstance())).then((pubSubClient)=>$ba1d3670c80098a4$export$c127c26e30518ed5(appId, pubSubClient, channels, this.onJoinChannel).then(()=>{
                if (this.isComponentMounted) this.setState({
                    client: pubSubClient
                });
            }));
    }
    componentDidUpdate({ channels: prevChannels }) {
        const { appId: appId, channels: newChannels } = this.props;
        const { client: client } = this.state;
        if (client && newChannels !== prevChannels) {
            const removedChannels = prevChannels.filter((channel)=>!newChannels.includes(channel));
            $ba1d3670c80098a4$export$e6c41c8aa28ddeb9(appId, client, removedChannels, this.onLeaveChannel);
            $ba1d3670c80098a4$export$c127c26e30518ed5(appId, client, newChannels, this.onJoinChannel);
        }
    }
    componentWillUnmount() {
        const { appId: appId, channels: channels } = this.props;
        const { client: client } = this.state;
        this.isComponentMounted = false;
        if (client) $ba1d3670c80098a4$export$e6c41c8aa28ddeb9(appId, client, channels, this.onLeaveChannel);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e97Bh.Provider), {
            value: {
                client: this.state.client
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            client: null
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onJoinChannel = (result)=>{
            const { onJoin: onJoin } = this.props;
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onJoin(Array.from(result.currentChannels));
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onLeaveChannel = (result)=>{
            const { onLeave: onLeave } = this.props;
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onLeave(Array.from(result.currentChannels));
        };
        this.isComponentMounted = false;
    }
}
const $ba1d3670c80098a4$var$withAnalytics = (0, $g8JvH.AnalyticsEventToProps)('realtimeProvider', {
    onJoin: 'joinedChannel',
    onLeave: 'leftChannel'
});
const $ba1d3670c80098a4$export$64d242981d970821 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))($ba1d3670c80098a4$var$withAnalytics, (0, $eBLah.withHost), (0, $eDbRL.withRuntimeProvider))($ba1d3670c80098a4$var$RealtimeProviderView);
var $ba1d3670c80098a4$export$2e2bcd8739ae039 = $ba1d3670c80098a4$export$64d242981d970821;

});
parcelRegister("eBLah", function(module, exports) {

$parcel$export(module.exports, "withHost", () => $bd78fcaaefe05a83$export$b2d89aaea1461cd9);

var $eUqFw = parcelRequire("eUqFw");

var $giZl9 = parcelRequire("giZl9");
function $bd78fcaaefe05a83$export$b2d89aaea1461cd9(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            host: (0, $giZl9.getDefaultPubSubHost)()
        });
}
var $bd78fcaaefe05a83$export$2e2bcd8739ae039 = $bd78fcaaefe05a83$export$b2d89aaea1461cd9;

});

parcelRegister("eDbRL", function(module, exports) {

$parcel$export(module.exports, "withRuntimeProvider", () => $e49daff82a9a2253$export$4b38d0b01368c3f4);

var $eUqFw = parcelRequire("eUqFw");
function $e49daff82a9a2253$export$4b38d0b01368c3f4(WrappedComponent) {
    return (props)=>{
        if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props);
    };
}
var $e49daff82a9a2253$export$2e2bcd8739ae039 = $e49daff82a9a2253$export$4b38d0b01368c3f4;

});

parcelRegister("fHifU", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("5m26T")
]).then(()=>parcelRequire('buarU'));

});




parcelRegister("kiBzn", function(module, exports) {

$parcel$export(module.exports, "ThemedFilterEmptyState", () => $a505eae840e121fb$export$e911425bb76dd69e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $lGiWG = parcelRequire("lGiWG");

var $kar7l = parcelRequire("kar7l");
parcelRequire("hgbp4");
var $1lasE = parcelRequire("1lasE");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $dG4cR = parcelRequire("dG4cR");

var $9rrf5 = parcelRequire("9rrf5");
const $a505eae840e121fb$export$e911425bb76dd69e = ({ reason: reason })=>{
    // @ts-expect-error - TS2339 - Property 'updateQueryParam' does not exist on type 'BoundActions<EntireRouterState, PublicRouterActions>'.
    const { updateQueryParam: updateQueryParam } = (0, $lB25E.useRouterActions)();
    const [, setFilters] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FILTER_PREFERENCE));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleOnClear = (0, $eUqFw.useCallback)(()=>{
        // persist that the user has cleared filters in view preferences
        // but do not push the change to the URL as we're already pushing a history state
        // to clear both filters and simple search below
        setFilters(undefined, 'none');
        updateQueryParam({
            filter: undefined,
            quickFilters: undefined,
            [(0, $dG4cR.SIMPLE_SEARCH_PARAM)]: undefined
        }, 'push');
    }, [
        updateQueryParam,
        setFilters
    ]);
    const message = reason === 'INVALID_JQL' ? formatMessage((0, $9rrf5.default).invalidStateHeading) : formatMessage((0, $9rrf5.default).emptyStateHeading);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $a505eae840e121fb$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a505eae840e121fb$var$Illustration, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1lasE))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a505eae840e121fb$var$HeadingWrapper, null, message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        appearance: "primary",
        onClick: handleOnClear
    }, formatMessage((0, $9rrf5.default).clearFiltersButton)));
};
const $a505eae840e121fb$var$wrapperStyles = (0, $8Vv3m.xcss)({
    textAlign: 'center',
    margin: 'auto',
    width: '450px',
    padding: 'space.300',
    borderRadius: 'border.radius.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: (0, $kar7l.Tokens).ELEVATION_SURFACE_CONTRAST_BOLDER
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a505eae840e121fb$var$HeadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1c2q _otyr1ejb",
            __cmplp.className
        ])
    });
});
const $a505eae840e121fb$var$Illustration = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1yk2 _4t3i13i4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lGiWG", function(module, exports) {

$parcel$export(module.exports, "ThemedButton", () => $3bf493f9be098b31$export$f67fb575035cc7d0);
/* ThemedButton.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7YElh = parcelRequire("7YElh");
const $3bf493f9be098b31$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3bf493f9be098b31$var$CustomButton, {
        ...props,
        as: as,
        ref: ref
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3bf493f9be098b31$var$CustomButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7YElh.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1qt31mi8 _1g9hu0za _1umftrgn _6l8rsb7u _9se51pfj _12ra13cp _zk5ur2ew _18vg1w6j _192e1czd _fnp71tko _1xjgkwex _1u0u1y8w _17z21063 _7n831c2q _n2ulgr9p _1cf15clp _1d7c63lg _nwukkwex _fsjdky8x _z1i3tvsq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hgbp4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2d2ebe01d4784a8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1lasE")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $9TZf5 = parcelRequire("9TZf5");

var $gMIRj = parcelRequire("gMIRj");

var $1lasE = parcelRequire("1lasE");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $d2d2ebe01d4784a8$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1lasE)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($gMIRj))
});
var $d2d2ebe01d4784a8$export$2e2bcd8739ae039 = $d2d2ebe01d4784a8$var$Illustration;
// for advanced use only
const $d2d2ebe01d4784a8$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("gMIRj", function(module, exports) {
module.exports = new URL("search-no-results-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("1lasE", function(module, exports) {
module.exports = new URL("search-no-results.10b14394.svg", import.meta.url).toString();

});


parcelRegister("9rrf5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8fd0b56fda09200$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d8fd0b56fda09200$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyStateHeading: {
        "id": "business-filters.themed-filter-empty-state.empty-state-heading",
        "defaultMessage": "It looks like we can't find any results that match."
    },
    invalidStateHeading: {
        "id": "business-filters.themed-filter-empty-state.invalid-state-heading",
        "defaultMessage": "We can't handle the current filters, please clear to continue."
    },
    clearFiltersButton: {
        "id": "business-filters.themed-filter-empty-state.clear-filters-button",
        "defaultMessage": "Clear"
    }
});

});


parcelRegister("7SlEV", function(module, exports) {

$parcel$export(module.exports, "ISSUE_CREATED_EVENT", () => $dbd458bd7de773e3$export$b22a14d5dac59664);
$parcel$export(module.exports, "ISSUE_DELETED_EVENT", () => $dbd458bd7de773e3$export$25fa37e5059c5a99);
$parcel$export(module.exports, "ISSUE_UPDATED_EVENT", () => $dbd458bd7de773e3$export$b22142e61b3fdbee);
$parcel$export(module.exports, "FIELD_MUTATION_EVENT", () => $dbd458bd7de773e3$export$eddbca92a5bee91f);
$parcel$export(module.exports, "ISSUE_EVENTS", () => $dbd458bd7de773e3$export$f01b4f4e297998a0);
$parcel$export(module.exports, "DEFAULT_EVENTS_TO_SUBSCRIBE_TO", () => $dbd458bd7de773e3$export$edc58098c8ddf4cb);
$parcel$export(module.exports, "CREATE_SUBSCRIPTIONS_EXPERIENCE", () => $dbd458bd7de773e3$export$75b82bac1ec985d9);
$parcel$export(module.exports, "REALTIME_EVENT_EXPERIENCE", () => $dbd458bd7de773e3$export$245947dc0e8c134b);
const $dbd458bd7de773e3$export$b22a14d5dac59664 = 'avi:jira:created:issue';
const $dbd458bd7de773e3$export$25fa37e5059c5a99 = 'avi:jira:deleted:issue';
const $dbd458bd7de773e3$export$b22142e61b3fdbee = 'avi:jira:updated:issue';
const $dbd458bd7de773e3$export$eddbca92a5bee91f = 'avi:jira:field:updated';
const $dbd458bd7de773e3$export$f01b4f4e297998a0 = [
    $dbd458bd7de773e3$export$b22a14d5dac59664,
    $dbd458bd7de773e3$export$25fa37e5059c5a99,
    $dbd458bd7de773e3$export$b22142e61b3fdbee
];
const $dbd458bd7de773e3$export$edc58098c8ddf4cb = $dbd458bd7de773e3$export$f01b4f4e297998a0;
const $dbd458bd7de773e3$export$b8b9d90f9e5bd72b = 'jiraBusinessGqlsRealtime';
const $dbd458bd7de773e3$export$75b82bac1ec985d9 = {
    experience: 'createSubscriptions',
    packageName: $dbd458bd7de773e3$export$b8b9d90f9e5bd72b,
    teamName: 'jira-warepil'
};
const $dbd458bd7de773e3$export$245947dc0e8c134b = {
    experience: 'realtimeEvent',
    packageName: $dbd458bd7de773e3$export$b8b9d90f9e5bd72b,
    teamName: 'jira-warepil'
};

});

parcelRegister("jvtK3", function(module, exports) {

$parcel$export(module.exports, "GqlsRealtime", () => $98ac3be71dbce786$export$ad092969d774a1ab);

var $eUqFw = parcelRequire("eUqFw");

var $ePgRW = parcelRequire("ePgRW");

var $4G5xU = parcelRequire("4G5xU");

var $5GxEP = parcelRequire("5GxEP");

var $huI7r = parcelRequire("huI7r");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $gd0Sp = parcelRequire("gd0Sp");

var $7SlEV = parcelRequire("7SlEV");

var $39J28 = parcelRequire("39J28");

var $jG3N9 = parcelRequire("jG3N9");

var $55JiT = parcelRequire("55JiT");

var $bqvPy = parcelRequire("bqvPy");
const $98ac3be71dbce786$export$ad092969d774a1ab = /*#__PURE__*/ (0, $eUqFw.memo)(({ appId: appId, entityId: entityId, onReceive: onReceive, eventsToSubscribeTo: eventsToSubscribeTo = (0, $7SlEV.DEFAULT_EVENTS_TO_SUBSCRIBE_TO) })=>{
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const siteId = (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        resourceType: 'site',
        resourceId: cloudId
    });
    const realtimeIds = (0, $ePgRW.useRealtimeContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const createSubsExperienceStart = (0, $4G5xU.useExperienceStart)((0, $7SlEV.CREATE_SUBSCRIPTIONS_EXPERIENCE));
    const createSubsExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $7SlEV.CREATE_SUBSCRIPTIONS_EXPERIENCE));
    const createSubsExperienceFail = (0, $4G5xU.useExperienceFail)((0, $7SlEV.CREATE_SUBSCRIPTIONS_EXPERIENCE));
    const realtimeEventExperienceStart = (0, $4G5xU.useExperienceStart)((0, $7SlEV.REALTIME_EVENT_EXPERIENCE));
    const realtimeEventExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $7SlEV.REALTIME_EVENT_EXPERIENCE));
    const realtimeEventExperienceFail = (0, $4G5xU.useExperienceFail)((0, $7SlEV.REALTIME_EVENT_EXPERIENCE));
    createSubsExperienceStart();
    // We need to be careful not to re-trigger the subscriptions useMemo, as this
    // causes new subscribe messages to be sent over the WS, which we only want to
    // happen when something directly related to the subscription changes
    // So we are using Refs to prevent the handleReceive function from changing too much
    const extraEventDataRef = (0, $eUqFw.useRef)({
        appId: appId,
        entityId: entityId
    });
    extraEventDataRef.current.appId = appId;
    extraEventDataRef.current.entityId = entityId;
    const onReceiveRef = (0, $eUqFw.useRef)(onReceive);
    onReceiveRef.current = onReceive;
    const handleReceive = (0, $eUqFw.useCallback)((event)=>{
        realtimeEventExperienceStart();
        try {
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'subscription next', {
                ...extraEventDataRef.current,
                realtimeEvent: event.type
            });
            onReceiveRef.current(event);
            realtimeEventExperienceSuccess({
                realtimeEvent: event.type
            });
        } catch (error) {
            realtimeEventExperienceFail('jiraBusinessGqlsRealtime.gqlsRealtime', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            error, {
                realtimeEvent: event.type
            });
        }
    }, [
        createAnalyticsEvent,
        realtimeEventExperienceStart,
        realtimeEventExperienceSuccess,
        realtimeEventExperienceFail
    ]);
    const handleReactError = (0, $eUqFw.useCallback)((_location, error, event)=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraBusinessGqlsRealtime.gqlsRealtime failed', event);
        createSubsExperienceFail('jiraBusinessGqlsRealtime.gqlsRealtime', error);
    }, [
        createAnalyticsEvent,
        createSubsExperienceFail
    ]);
    const handleSubscriptionError = (0, $eUqFw.useCallback)((errorMessage, operationName)=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraBusinessGqlsRealtime.subscription failed', {
            errorMessage: errorMessage,
            operationName: operationName,
            ...extraEventDataRef.current
        });
    }, [
        createAnalyticsEvent
    ]);
    const subscriptions = (0, $eUqFw.useMemo)(()=>!realtimeIds.length ? null : realtimeIds.map((projectId)=>// eslint-disable-next-line react/jsx-key
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, eventsToSubscribeTo.includes((0, $7SlEV.ISSUE_UPDATED_EVENT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bqvPy.UpdateIssueSubscription), {
                cloudId: cloudId,
                projectId: projectId,
                onReceive: handleReceive,
                onError: handleSubscriptionError
            }), eventsToSubscribeTo.includes((0, $7SlEV.ISSUE_CREATED_EVENT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $39J28.CreateIssueSubscription), {
                cloudId: cloudId,
                projectId: projectId,
                onReceive: handleReceive,
                onError: handleSubscriptionError
            }), eventsToSubscribeTo.includes((0, $7SlEV.ISSUE_DELETED_EVENT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jG3N9.DeleteIssueSubscription), {
                cloudId: cloudId,
                projectId: projectId,
                onReceive: handleReceive,
                onError: handleSubscriptionError
            }), eventsToSubscribeTo.includes((0, $7SlEV.FIELD_MUTATION_EVENT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55JiT.FieldMutationSubscription), {
                siteId: siteId,
                onReceive: handleReceive,
                onError: handleSubscriptionError
            }))), [
        cloudId,
        siteId,
        realtimeIds,
        eventsToSubscribeTo,
        handleReceive,
        handleSubscriptionError
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const realtimeEvents = {
            issueCreated: eventsToSubscribeTo.includes((0, $7SlEV.ISSUE_CREATED_EVENT)),
            issueUpdated: eventsToSubscribeTo.includes((0, $7SlEV.ISSUE_UPDATED_EVENT)),
            issueDeleted: eventsToSubscribeTo.includes((0, $7SlEV.ISSUE_DELETED_EVENT)),
            fieldMutation: eventsToSubscribeTo.includes((0, $7SlEV.FIELD_MUTATION_EVENT))
        };
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'subscriptions created', {
            ...extraEventDataRef.current,
            ...realtimeEvents,
            subscriptions: realtimeIds.length * eventsToSubscribeTo.length
        });
        createSubsExperienceSuccess();
    }, [
        subscriptions,
        createAnalyticsEvent,
        realtimeIds,
        eventsToSubscribeTo,
        createSubsExperienceSuccess
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'subscriptions init', extraEventDataRef.current);
        const extraEventData = extraEventDataRef.current;
        return ()=>{
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'subscriptions closed', extraEventData);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "gqlsRealtime",
        packageName: "jiraBusinessGqlsRealtime",
        extraEventData: extraEventDataRef.current,
        onError: handleReactError
    }, subscriptions);
});

});
parcelRegister("39J28", function(module, exports) {

$parcel$export(module.exports, "CreateIssueSubscription", () => $4eeb3c77e3051e63$export$7876efe7a86fd4f1);

var $eUqFw = parcelRequire("eUqFw");

var $fEePJ = parcelRequire("fEePJ");

var $7SlEV = parcelRequire("7SlEV");

var $h02O8 = parcelRequire("h02O8");

const $4eeb3c77e3051e63$var$operationName = 'JwmIssueCreatedSubscription';
const $4eeb3c77e3051e63$export$7876efe7a86fd4f1 = /*#__PURE__*/ (0, $eUqFw.memo)(({ cloudId: cloudId, projectId: projectId, onReceive: onReceive, onError: onError })=>{
    (0, $fEePJ.useSubscribe)({
        query: (0, $f6f4d62eefeaafa1$export$89cddb5ca4c806e4),
        variables: {
            cloudId: cloudId,
            projectId: projectId
        },
        operationName: $4eeb3c77e3051e63$var$operationName
    }, {
        next: (value)=>{
            const error = (0, $h02O8.getResponseError)(value);
            if (error) onError(error, $4eeb3c77e3051e63$var$operationName);
            else {
                const payload = value.data?.jira?.onIssueCreatedByProject;
                if (payload) onReceive({
                    type: (0, $7SlEV.ISSUE_CREATED_EVENT),
                    payload: payload
                });
            }
        }
    });
    return null;
});

});
parcelRegister("fEePJ", function(module, exports) {

$parcel$export(module.exports, "useSubscribe", () => $a854284f214cc1d7$export$d3d523392640272);

var $eUqFw = parcelRequire("eUqFw");

var $fEYK5 = parcelRequire("fEYK5");

var $guiFP = parcelRequire("guiFP");

var $keguF = parcelRequire("keguF");


var $eliQU = parcelRequire("eliQU");

var $dIOaC = parcelRequire("dIOaC");

var $lE8MM = parcelRequire("lE8MM");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $a854284f214cc1d7$var$noop = ()=>{};
const $a854284f214cc1d7$var$subscribe = (payload, sink)=>{
    const client = (0, $dIOaC.getClient)();
    if (!client) return;
    const { query: query, variables: variables, operationName: operationName, extensions: extensions } = payload;
    const { next: next, error: error, complete: complete = $a854284f214cc1d7$var$noop } = sink;
    let requestId;
    return client.subscribe({
        query: query,
        variables: variables,
        operationName: operationName,
        extensions: {
            ...extensions ?? {}
        }
    }, {
        next: (value)=>{
            // @ts-expect-error agg prop is missing on generic "extensions" type
            const aggRequestId = value?.extensions?.agg?.request_id;
            if (aggRequestId) requestId = aggRequestId;
            // @ts-expect-error incompatible types between two libraries
            next(value);
        },
        complete: complete,
        error: (sinkError)=>{
            const errorInfo = (0, $lE8MM.getSinkError)(sinkError);
            const attributes = {
                operationName: operationName,
                requestId: requestId,
                userLocation: (0, $keguF.getUserLocation)()
            };
            error?.(errorInfo, attributes);
            (0, $guiFP.default)({
                meta: {
                    id: 'subscription',
                    packageName: 'jiraGraphqlSubscription',
                    teamName: 'uip-graphql'
                },
                error: errorInfo,
                attributes: attributes,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
};
const $a854284f214cc1d7$export$d3d523392640272 = (payload, sink)=>{
    (0, $eUqFw.useEffect)(()=>{
        let unsubscribe = $a854284f214cc1d7$var$subscribe(payload, sink);
        let timeout;
        const onVisibilityChange = ()=>{
            if ((0, $fEYK5.isPageVisible)()) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = undefined;
                } else unsubscribe = $a854284f214cc1d7$var$subscribe(payload, sink);
            } else if (!timeout) timeout = setTimeout(()=>{
                unsubscribe?.();
                unsubscribe = undefined;
                timeout = undefined;
            }, (0, $12457a63a9fa501a$export$1ad8434180c5936c));
        };
        if (!(0, $eliQU.isSSR)()) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener((0, $fEYK5.supportedVisiblityEvent), onVisibilityChange);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener((0, $fEYK5.supportedVisiblityEvent), onVisibilityChange);
            unsubscribe?.();
        };
    }, [
        payload,
        sink
    ]);
};

});
const $12457a63a9fa501a$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $12457a63a9fa501a$export$bf6cd96e19b2987f = 100;
const $12457a63a9fa501a$export$1ad8434180c5936c = 300000; // 5m


parcelRegister("h02O8", function(module, exports) {

$parcel$export(module.exports, "isIssueEvent", () => $8984b81df6dead57$export$734ba008b9d9e61c);
$parcel$export(module.exports, "getResponseError", () => $8984b81df6dead57$export$135f2bf83a3d73b1);

var $7SlEV = parcelRequire("7SlEV");
const $8984b81df6dead57$export$734ba008b9d9e61c = (event)=>(0, $7SlEV.ISSUE_EVENTS).includes(event.type);
const $8984b81df6dead57$export$135f2bf83a3d73b1 = (response)=>Array.isArray(response.errors) && response.errors.length && response.errors[0].message;

});

const $f6f4d62eefeaafa1$export$89cddb5ca4c806e4 = `
  subscription JwmIssueCreatedSubscription(
    $cloudId: ID!
    $projectId: String!
  ) {
    jira {
      onIssueCreatedByProject(cloudId: $cloudId, projectId: $projectId) @optIn(to: ["JiraIssueSubscriptions"]) {
        issueId
      }
    }
  }
`;


parcelRegister("jG3N9", function(module, exports) {

$parcel$export(module.exports, "DeleteIssueSubscription", () => $ff6bd8b7c30a306f$export$cba4fc39801f6792);

var $eUqFw = parcelRequire("eUqFw");

var $fEePJ = parcelRequire("fEePJ");

var $huI7r = parcelRequire("huI7r");

var $7SlEV = parcelRequire("7SlEV");

var $h02O8 = parcelRequire("h02O8");

const $ff6bd8b7c30a306f$var$operationName = 'JwmIssueDeletedSubscription';
const $ff6bd8b7c30a306f$export$cba4fc39801f6792 = /*#__PURE__*/ (0, $eUqFw.memo)(({ cloudId: cloudId, projectId: projectId, onReceive: onReceive, onError: onError })=>{
    (0, $fEePJ.useSubscribe)({
        query: (0, $91d960b142a4aa36$export$9c299c317f46fdc4),
        variables: {
            cloudId: cloudId,
            projectId: projectId
        },
        operationName: $ff6bd8b7c30a306f$var$operationName
    }, {
        next: (value)=>{
            const error = (0, $h02O8.getResponseError)(value);
            if (error) onError(error, $ff6bd8b7c30a306f$var$operationName);
            else {
                const payload = value.data?.jira?.onIssueDeletedByProject;
                if (payload) onReceive({
                    type: (0, $7SlEV.ISSUE_DELETED_EVENT),
                    payload: {
                        ...payload,
                        issueId: (0, $huI7r.getAriConfig)(payload.resource).resourceId
                    }
                });
            }
        }
    });
    return null;
});

});
const $91d960b142a4aa36$export$9c299c317f46fdc4 = `
  subscription JwmIssueDeletedSubscription(
    $cloudId: ID!
    $projectId: String!
  ) {
    jira {
      onIssueDeletedByProject(cloudId: $cloudId, projectId: $projectId) @optIn(to: ["JiraIssueSubscriptions"]) {
        resource
      }
    }
  }
`;


parcelRegister("55JiT", function(module, exports) {

$parcel$export(module.exports, "FieldMutationSubscription", () => $0c96b6eb3ca20eae$export$d82ea923ea48fa52);

var $eUqFw = parcelRequire("eUqFw");

var $fEePJ = parcelRequire("fEePJ");

var $7SlEV = parcelRequire("7SlEV");

var $h02O8 = parcelRequire("h02O8");

const $0c96b6eb3ca20eae$var$operationName = 'JwmFieldMutationSubscription';
const $0c96b6eb3ca20eae$export$d82ea923ea48fa52 = /*#__PURE__*/ (0, $eUqFw.memo)(({ siteId: siteId, onReceive: onReceive, onError: onError })=>{
    (0, $fEePJ.useSubscribe)({
        query: (0, $993d2190e4ed31a0$export$2e75a8174f7cddb8),
        operationName: $0c96b6eb3ca20eae$var$operationName,
        variables: {
            siteId: siteId
        }
    }, {
        next: (value)=>{
            const error = (0, $h02O8.getResponseError)(value);
            if (error) onError(error, $0c96b6eb3ca20eae$var$operationName);
            else if (value.data?.jira?.onJwmFieldMutation) onReceive({
                type: (0, $7SlEV.FIELD_MUTATION_EVENT),
                payload: {}
            });
        }
    });
    return null;
});

});
const $993d2190e4ed31a0$export$2e75a8174f7cddb8 = `
  subscription JwmFieldMutationSubscription($siteId: ID!) {
    jira {
      onJwmFieldMutation(siteId: $siteId) {
        encryptedData
      }
    }
  }
`;


parcelRegister("bqvPy", function(module, exports) {

$parcel$export(module.exports, "UpdateIssueSubscription", () => $d3e4df2394577653$export$51fac6481c0b4595);

var $eUqFw = parcelRequire("eUqFw");

var $fEePJ = parcelRequire("fEePJ");

var $7SlEV = parcelRequire("7SlEV");

var $h02O8 = parcelRequire("h02O8");

const $d3e4df2394577653$var$operationName = 'JwmIssueUpdatedSubscription';
const $d3e4df2394577653$export$51fac6481c0b4595 = /*#__PURE__*/ (0, $eUqFw.memo)(({ cloudId: cloudId, projectId: projectId, onReceive: onReceive, onError: onError })=>{
    (0, $fEePJ.useSubscribe)({
        query: (0, $4aae5f340c4dce10$export$54c41e3133084b81),
        variables: {
            cloudId: cloudId,
            projectId: projectId
        },
        operationName: $d3e4df2394577653$var$operationName
    }, {
        next: (value)=>{
            const error = (0, $h02O8.getResponseError)(value);
            if (error) onError(error, $d3e4df2394577653$var$operationName);
            else {
                const payload = value.data?.jira?.onIssueUpdatedByProject;
                if (payload) onReceive({
                    type: (0, $7SlEV.ISSUE_UPDATED_EVENT),
                    payload: payload
                });
            }
        }
    });
    return null;
});

});
const $4aae5f340c4dce10$export$54c41e3133084b81 = `
  subscription JwmIssueUpdatedSubscription(
    $cloudId: ID!
    $projectId: String!
  ) {
    jira {
      onIssueUpdatedByProject(cloudId: $cloudId, projectId: $projectId) @optIn(to: ["JiraIssueSubscriptions"]) {
        issueId
      }
    }
  }
`;



parcelRegister("5I9Im", function(module, exports) {

$parcel$export(module.exports, "PrefetchIssueDataController", () => $1fd41398a8791bc6$export$1e95fb877713bf5e);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $hzcvF = parcelRequire("hzcvF");

var $lB25E = parcelRequire("lB25E");

var $hYeSy = parcelRequire("hYeSy");

var $1SYbt = parcelRequire("1SYbt");
const $1fd41398a8791bc6$var$IssueDataLoader = /*#__PURE__*/ (0, $eUqFw.memo)(({ issues: issues })=>issues.map((issueKey)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1SYbt.AsyncIssueViewCriticalDataLoader), {
            key: issueKey,
            issueKey: issueKey
        })));
const $1fd41398a8791bc6$export$1e95fb877713bf5e = ()=>{
    const { prefetchedIssues: prefetchedIssues } = (0, $hYeSy.usePrefetchIssueViewData)();
    const { clearCache: clearCache } = (0, $hYeSy.usePrefetchIssueViewDataActions)();
    const [selectedIssueKey] = (0, $lB25E.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const prevSelectedIssueKey = (0, $hzcvF.usePreviousWithInitial)(selectedIssueKey);
    (0, $eUqFw.useEffect)(()=>{
        const isIssueAppClosed = prevSelectedIssueKey && !selectedIssueKey;
        const isIssueKeyUpdated = selectedIssueKey && prevSelectedIssueKey && selectedIssueKey !== prevSelectedIssueKey;
        // clear cache when user closes Issue modal or opens another issue without closing it (ie via breadcrumbs)
        if (isIssueAppClosed || isIssueKeyUpdated) clearCache();
    }, [
        clearCache,
        prevSelectedIssueKey,
        selectedIssueKey
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            // clear cache on unmount
            clearCache();
        }, [
        clearCache
    ]);
    const issues = (0, $eUqFw.useMemo)(()=>Object.keys(prefetchedIssues), [
        prefetchedIssues
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1fd41398a8791bc6$var$IssueDataLoader, {
        issues: issues
    });
};

});
parcelRegister("hYeSy", function(module, exports) {

$parcel$export(module.exports, "usePrefetchIssueViewData", () => $1367707b89dd09e1$export$519e056a921d9691);
$parcel$export(module.exports, "usePrefetchIssueViewDataActions", () => $1367707b89dd09e1$export$fee97ccc4dadacbb);

var $WBLbN = parcelRequire("WBLbN");
/**
 * The minimum allowed time between two consecutive issue data prefetches.
 */ const $1367707b89dd09e1$var$ALLOWED_TIME_BETWEEN_PREFETCHES = 500;
const $1367707b89dd09e1$var$MAX_DELAY = 300;
const $1367707b89dd09e1$var$MIN_DELAY = 0;
const $1367707b89dd09e1$export$a87749ac92873cf7 = ()=>100;
const $1367707b89dd09e1$var$actions = {
    // prefetches issue view data on hover
    prefetchIssue: (issueKey)=>({ getState: getState, setState: setState })=>{
            const { timestampOfTheLastPrefetch: timestampOfTheLastPrefetch, prefetchedIssues: prefetchedIssues } = getState();
            const currentTimestamp = Date.now();
            const delay = timestampOfTheLastPrefetch !== null && currentTimestamp - timestampOfTheLastPrefetch < $1367707b89dd09e1$var$ALLOWED_TIME_BETWEEN_PREFETCHES ? $1367707b89dd09e1$var$MAX_DELAY : $1367707b89dd09e1$var$MIN_DELAY;
            // clear cache if it exceeds the limit so that it doesn't grow indefinitely
            const nextPrefetchedIssues = Object.keys(prefetchedIssues).length === $1367707b89dd09e1$export$a87749ac92873cf7() ? {} : prefetchedIssues;
            setState({
                // prefetch the issue only if the time from the last prefetch is greater than ALLOWED_TIME_BETWEEN_PREFETCHES
                prefetchedIssues: delay === $1367707b89dd09e1$var$MIN_DELAY && !prefetchedIssues[issueKey] ? {
                    ...nextPrefetchedIssues,
                    [issueKey]: true
                } : prefetchedIssues,
                timestampOfTheLastPrefetch: currentTimestamp
            });
        },
    // clears cached issues (ie on view unmount)
    clearCache: ()=>({ setState: setState })=>{
            setState({
                timestampOfTheLastPrefetch: null,
                prefetchedIssues: {}
            });
        }
};
const $1367707b89dd09e1$var$PrefetchIssueViewStore = (0, $WBLbN.createStore)({
    initialState: {
        timestampOfTheLastPrefetch: null,
        prefetchedIssues: {}
    },
    actions: $1367707b89dd09e1$var$actions,
    name: 'JWMPrefetchIssueViewStore'
});
const $1367707b89dd09e1$export$519e056a921d9691 = (0, $WBLbN.createStateHook)($1367707b89dd09e1$var$PrefetchIssueViewStore);
const $1367707b89dd09e1$export$fee97ccc4dadacbb = (0, $WBLbN.createActionsHook)($1367707b89dd09e1$var$PrefetchIssueViewStore);

});

parcelRegister("1SYbt", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueViewCriticalDataLoader", () => $b758d168c0275aa2$export$15a49d6c068f7356);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $72NCz = parcelRequire("72NCz");
const $b758d168c0275aa2$var$entryPointParams = {};
const $b758d168c0275aa2$export$15a49d6c068f7356 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $72NCz.asyncIssueViewCriticalDataLoaderEntrypoint), $b758d168c0275aa2$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm-issue-view-critical-data-loader",
        packageName: "jiraBusinessIssueViewCriticalDataLoader",
        runtimeProps: props
    });
});

});
parcelRegister("72NCz", function(module, exports) {

$parcel$export(module.exports, "asyncIssueViewCriticalDataLoaderEntrypoint", () => $80aa607d47f3d3ce$export$6254258f84be452a);

var $14fpI = parcelRequire("14fpI");

var $4dIH4 = parcelRequire("4dIH4");

const $80aa607d47f3d3ce$export$6254258f84be452a = (0, $4dIH4.createEntryPoint)({
    root: (0, $14fpI.JSResourceForInteraction)(()=>(parcelRequire("jGDE5")), {
        moduleId: "1f53773a"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jGDE5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("apZDm").then(()=>parcelRequire('2rxqz'));

});




parcelRegister("kHnEs", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3cc12293a50ce22$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hSCS8 = parcelRequire("hSCS8");

var $jGcn0 = parcelRequire("jGcn0");


var $hJ992 = parcelRequire("hJ992");

var $cyVXS = parcelRequire("cyVXS");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $jK1pm = parcelRequire("jK1pm");

var $dyfd9 = parcelRequire("dyfd9");

var $lB25E = parcelRequire("lB25E");

const $f3cc12293a50ce22$export$843a6e93936e3b60 = (0, $dyfd9.lazyForPaint)(()=>(parcelRequire("2P20B")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});
const $f3cc12293a50ce22$var$ModalIssueAppWrapper = ({ issueKey: issueKey, onClose: onClose, onChange: onChange, onDeleteSuccess: onDeleteSuccess, analyticsSource: analyticsSource = (0, $0100842672acae20$export$82540942fb014b0a), viewModeSwitchDisabled: viewModeSwitchDisabled, isSoftwareProject: isSoftwareProject })=>{
    const [, setSelectedIssue] = (0, $lB25E.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const onIssueKeyChange = (0, $eUqFw.useCallback)(({ toIssueKey: toIssueKey })=>setSelectedIssue(toIssueKey), [
        setSelectedIssue
    ]);
    const [, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $hJ992.useIssueContextActions)();
    const onSwitchToModal = (0, $eUqFw.useCallback)(()=>{
        setDetailViewAsModal();
        setSidebarContent(null);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
    }, [
        createAnalyticsEvent,
        setDetailViewAsModal,
        setSidebarContent
    ]);
    const onSwitchToSidebar = (0, $eUqFw.useCallback)(()=>{
        setSidebarContent(null);
        setDetailViewAsSidebar();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
    }, [
        createAnalyticsEvent,
        setDetailViewAsSidebar,
        setSidebarContent
    ]);
    const viewModeOptions = (0, $eUqFw.useMemo)(()=>!viewModeSwitchDisabled ? {
            viewModeSwitchEnabled: true,
            onSwitchToModal: onSwitchToModal,
            onSwitchToSidebar: onSwitchToSidebar
        } : undefined, [
        onSwitchToModal,
        onSwitchToSidebar,
        viewModeSwitchDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-modal-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: isSoftwareProject ? 'jswModalIssueApp' : 'jwmModalIssueApp'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        packageName: isSoftwareProject ? 'software' : 'business',
        id: "issue-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "modal-issue-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f3cc12293a50ce22$export$843a6e93936e3b60, {
        analyticsSource: analyticsSource,
        issueKey: issueKey,
        onClose: onClose,
        onChange: onChange,
        onIssueDeleteSuccess: onDeleteSuccess,
        onIssueKeyChange: onIssueKeyChange,
        viewModeOptions: viewModeOptions
    })))));
};
var $f3cc12293a50ce22$export$2e2bcd8739ae039 = $f3cc12293a50ce22$var$ModalIssueAppWrapper;

});
const $0100842672acae20$export$53d41ff2666118e1 = 'agility-backlog';
const $0100842672acae20$export$7552fe2669628499 = 'bitbucket-issue';
const $0100842672acae20$export$41a718da0a8636f4 = 'connect-issue';
const $0100842672acae20$export$cebf0bc8b2ccaf57 = 'core-issue';
const $0100842672acae20$export$5e91e17726e54450 = 'jiraCalendar';
const $0100842672acae20$export$82540942fb014b0a = 'business-calendar';
const $0100842672acae20$export$7ca28938a07e0c33 = 'business-list';
const $0100842672acae20$export$f6cf06aaaeb58a54 = 'business-timeline';
const $0100842672acae20$export$b2c0462ff17aa26e = 'business-board';
const $0100842672acae20$export$a607850ebccd28ac = 'business-approvals';
const $0100842672acae20$export$1da6cede3561048f = 'business-files';
const $0100842672acae20$export$b19f949fb9713614 = 'full-issue';
const $0100842672acae20$export$a5132300c5214280 = 'embed-issue';
const $0100842672acae20$export$710114090a811b37 = 'global-issue-navigator-issue';
const $0100842672acae20$export$ce88447986394f2d = 'mobile-issue';
const $0100842672acae20$export$6a90d9196d330040 = 'project-issue-navigator';
const $0100842672acae20$export$2247c9059c171db1 = 'roadmap-issue';
const $0100842672acae20$export$cd16d39c55c569d0 = 'simple-software-board';
const $0100842672acae20$export$f72626bf0d75dfad = 'software-backlog-issue';
const $0100842672acae20$export$778b4609e784cb27 = 'software-deployments-issue';
const $0100842672acae20$export$5b73d694a6048002 = 'version-detail-issue';
const $0100842672acae20$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $0100842672acae20$export$21b5b7189add7861 = 'software-incidents-issue';
const $0100842672acae20$export$9c5d81b901471b27 = 'software-issue';
const $0100842672acae20$export$1735f6ad917dc411 = 'change-calendar';
const $0100842672acae20$export$7063ee6d0035a982 = 'queues-issue-view';
const $0100842672acae20$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $0100842672acae20$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $0100842672acae20$export$14a8072f422804fd = 'issue-navigator-next';

parcelRegister("cyVXS", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $f96d169c5da11246$export$c3f500e812fb1bb3);

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");

var $fee69 = parcelRequire("fee69");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");
const $f96d169c5da11246$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $eUqFw.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});

parcelRegister("2P20B", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("aTMMU")
]).then(()=>parcelRequire('kjWxV'));

});


parcelRegister("9u6Jh", function(module, exports) {

$parcel$export(module.exports, "SidebarIssueView", () => $134113658c67db96$export$ccdf533f42a8d6f8);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hSCS8 = parcelRequire("hSCS8");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $6vrw7 = parcelRequire("6vrw7");

var $bw53Y = parcelRequire("bw53Y");

var $4LhhW = parcelRequire("4LhhW");
const $134113658c67db96$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY = 'issueViewSidebar';
const $134113658c67db96$var$callWhenIdle = (callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof window.requestIdleCallback === 'function') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.requestIdleCallback(callback);
    else setTimeout(callback, 3000);
};
const $134113658c67db96$export$ccdf533f42a8d6f8 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, onClose: onClose, analyticsSource: analyticsSource, onChange: onChange, onIssueDeleteSuccess: onIssueDeleteSuccess, isSoftwareProject: isSoftwareProject })=>{
    const [{ content: content }, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const prevIssueKey = (0, $hzcvF.usePreviousWithInitial)(issueKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    (0, $4LhhW.useSetSidebarStyleVar)();
    const onCloseSidebar = (0, $eUqFw.useCallback)(()=>{
        onClose();
    }, [
        onClose
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // avoid re-rendering in case props aren't memoised
        if (issueKey === prevIssueKey && !!content) return;
        if (issueKey) {
            const newContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($134113658c67db96$var$CSSAntiCorruptionLayer, {
                key: $134113658c67db96$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bw53Y.SidebarIssueApp), {
                issueKey: (0, $6vrw7.toIssueKey)(issueKey),
                onClose: onCloseSidebar,
                analyticsSource: analyticsSource,
                onChange: onChange,
                onIssueDeleteSuccess: onIssueDeleteSuccess,
                isSoftwareProject: isSoftwareProject
            }));
            setSidebarContent(newContent);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp opened');
        } else {
            if (content?.key === $134113658c67db96$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY) setSidebarContent(null);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp closed');
        }
    }, [
        analyticsSource,
        content,
        createAnalyticsEvent,
        isSoftwareProject,
        issueKey,
        onChange,
        onCloseSidebar,
        onIssueDeleteSuccess,
        prevIssueKey,
        setSidebarContent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Preload IssueApp here, otherwise it'd be loaded when Sidebar opens up for the first time, which is a bit slow
        $134113658c67db96$var$callWhenIdle(()=>{
            (0, $bw53Y.IssueApp).preload();
        });
    }, []);
    return null;
});
// put an extra div around issue view to "adopt" styles from `SidebarContent` (`> div`)
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $134113658c67db96$var$CSSAntiCorruptionLayer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bw53Y", function(module, exports) {

$parcel$export(module.exports, "IssueApp", () => $1d0bd87d82d1f36e$export$35dd9ab573b87c3f);
$parcel$export(module.exports, "SidebarIssueApp", () => $1d0bd87d82d1f36e$export$e402f7c18d4d7f37);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $hSCS8 = parcelRequire("hSCS8");

var $hJ992 = parcelRequire("hJ992");

var $gJYxu = parcelRequire("gJYxu");

var $gGtKh = parcelRequire("gGtKh");

var $hzcvF = parcelRequire("hzcvF");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $c4qEZ = parcelRequire("c4qEZ");

var $jK1pm = parcelRequire("jK1pm");

var $dyfd9 = parcelRequire("dyfd9");

const $1d0bd87d82d1f36e$export$35dd9ab573b87c3f = (0, $dyfd9.lazy)(()=>(parcelRequire("7KNWV")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $1d0bd87d82d1f36e$export$e402f7c18d4d7f37 = ({ analyticsSource: analyticsSource, issueKey: issueKey, onClose: onClose, onIssueDeleteSuccess: onIssueDeleteSuccess, onChange: onChange, isSoftwareProject: isSoftwareProject })=>{
    const [currentIssueKey, setCurrentIssueKey] = (0, $eUqFw.useState)(issueKey);
    const prevIssueKey = (0, $hzcvF.usePreviousWithInitial)(issueKey);
    // @ts-expect-error - TS7031 - Binding element 'nextIssueKey' implicitly has an 'any' type.
    const onIssueKeyChange = (0, $eUqFw.useCallback)(({ toIssueKey: nextIssueKey })=>{
        setCurrentIssueKey(nextIssueKey);
    }, []);
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $hJ992.useIssueContextActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const [, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    (0, $eUqFw.useEffect)(()=>{
        if (prevIssueKey !== issueKey) setCurrentIssueKey(issueKey);
    }, [
        currentIssueKey,
        issueKey,
        prevIssueKey
    ]);
    const onSwitchToModal = (0, $eUqFw.useCallback)(()=>{
        setDetailViewAsModal();
        setSidebarContent(null);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
    }, [
        createAnalyticsEvent,
        setDetailViewAsModal,
        setSidebarContent
    ]);
    const onSwitchToSidebar = (0, $eUqFw.useCallback)(()=>{
        setDetailViewAsSidebar();
        setSidebarContent(null);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
    }, [
        createAnalyticsEvent,
        setDetailViewAsSidebar,
        setSidebarContent
    ]);
    const PACKAGE_NAME = (0, $eUqFw.useMemo)(()=>isSoftwareProject ? 'jswSidebarIssueApp' : 'jwmSidebarIssueApp', [
        isSoftwareProject
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-sidebar-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJYxu.IssueBoundary), {
        packageName: PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d0bd87d82d1f36e$export$35dd9ab573b87c3f, {
        viewModeOptions: {
            viewMode: 'SIDEBAR',
            viewModeSwitchEnabled: true,
            onSwitchToModal: onSwitchToModal,
            onSwitchToSidebar: onSwitchToSidebar
        },
        issueKey: currentIssueKey,
        analyticsSource: analyticsSource,
        shouldShowCloseButton: true,
        onClose: onClose,
        onIssueKeyChange: onIssueKeyChange,
        shouldSetInitialFocus: true,
        shouldShowRootProjectsBreadcrumb: true,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        onIssueDeleteFailure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        isSpaEnabled: false,
        isLoadedWithPage: false,
        onChange: onChange
    })))));
};

});
parcelRegister("gJYxu", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $47dde6f657625382$export$fbf48ede0cf52b5a);
$parcel$export(module.exports, "IssueModalBoundary", () => $47dde6f657625382$export$74d408982642a541);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $5GxEP = parcelRequire("5GxEP");

var $cyVXS = parcelRequire("cyVXS");

var $gGtKh = parcelRequire("gGtKh");

var $c4qEZ = parcelRequire("c4qEZ");
const $47dde6f657625382$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $47dde6f657625382$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});

parcelRegister("7KNWV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("kWrFZ"),
    $d1Cng("92sUi"),
    $d1Cng("i5RRW"),
    $d1Cng("eNmuD"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kMAKK")
]).then(()=>parcelRequire('9zAkH'));

});


parcelRegister("4LhhW", function(module, exports) {

$parcel$export(module.exports, "useSetSidebarStyleVar", () => $94858a1aa5f6a192$export$70b20cd72362e39d);

var $eUqFw = parcelRequire("eUqFw");

var $hSCS8 = parcelRequire("hSCS8");


var $53ucm = parcelRequire("53ucm");
const $94858a1aa5f6a192$var$MARGIN = 24;
const $94858a1aa5f6a192$export$70b20cd72362e39d = ()=>{
    const [{ content: content, sidebarWidth: sidebarWidth }] = (0, $hSCS8.useSidebar)();
    const { setWidth: setWidth } = (0, $53ucm.useDetailPanelActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (content !== null) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.documentElement?.style.setProperty((0, $29bf8722faf6f5bf$export$c83c5cba188418d8), `${sidebarWidth}px`);
            setWidth(sidebarWidth + $94858a1aa5f6a192$var$MARGIN);
        } else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.documentElement?.style.removeProperty((0, $29bf8722faf6f5bf$export$c83c5cba188418d8));
        return ()=>{
            setWidth(0);
        };
    }, [
        content,
        setWidth,
        sidebarWidth
    ]);
};

});
const $29bf8722faf6f5bf$export$c83c5cba188418d8 = '--detailPanelWidth';



parcelRegister("8BjUT", function(module, exports) {

$parcel$export(module.exports, "PageVisibility", () => $1a593bdd97c4fabd$export$ddb3b5bf3df25efc);

var $eUqFw = parcelRequire("eUqFw");

var $cNGJr = parcelRequire("cNGJr");

var $fEYK5 = parcelRequire("fEYK5");
const $1a593bdd97c4fabd$export$e39301eefbc90236 = 500;
const $1a593bdd97c4fabd$export$ddb3b5bf3df25efc = ({ onChange: onChange })=>{
    // debouncing the page visibility change to prevent when people switching tabs too fast
    // useDebouncedCallback will always call the latest parameter for every re-render
    // so even though `onChange` may change each re-render, only the last one will be called when debounce finishes
    const [onVisibilityChangeDebounced] = (0, $cNGJr.default)(()=>{
        onChange({
            isVisible: (0, $fEYK5.isPageVisible)()
        });
    }, $1a593bdd97c4fabd$export$e39301eefbc90236);
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener((0, $fEYK5.supportedVisiblityEvent), onVisibilityChangeDebounced);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener((0, $fEYK5.supportedVisiblityEvent), onVisibilityChangeDebounced);
        };
    }, [
        onVisibilityChangeDebounced
    ]);
    return null;
};

});

parcelRegister("bcWyL", function(module, exports) {

$parcel$export(module.exports, "PerformanceAnalytics", () => $44db5e6179f04fcc$export$ec3c3b39c046a620);

var $eUqFw = parcelRequire("eUqFw");


var $axxSm = parcelRequire("axxSm");

var $lbjCz = parcelRequire("lbjCz");

var $bDGTl = parcelRequire("bDGTl");

var $6HWvN = parcelRequire("6HWvN");
const $44db5e6179f04fcc$export$ec3c3b39c046a620 = /*#__PURE__*/ (0, $eUqFw.memo)(({ view: view, loading: loading, itemsCount: itemsCount, attributes: attributes })=>{
    const loadingRef = (0, $eUqFw.useRef)(loading);
    loadingRef.current = loading;
    if (loading === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbjCz.default), {
        name: "performance-analytics-loading"
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const scrollElement = false ? null : document.getElementById((0, $d02be44255a1478f$export$e5e75ff4daca6597));
    const product = view.startsWith('software') ? 'jsw' : 'jwm';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HWvN.PageLoadMetrics), {
        view: view,
        attributes: attributes,
        product: product
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDGTl.FirstInteractionMetric), {
        view: view,
        product: product
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $axxSm.default), {
        viewId: `${product}.${view}`,
        scrollElement: scrollElement,
        itemsCount: itemsCount,
        attributes: attributes
    }));
});

});
parcelRegister("axxSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed3b6e522e859da6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

const $ed3b6e522e859da6$export$df7175b69b5630dd = (frames, elapsedMs)=>Math.min(Math.floor(1000 * (frames / elapsedMs)), (0, $083bae7fff0f430d$export$9d3e6d8a99023567));
const $ed3b6e522e859da6$export$46962be62755f053 = /*#__PURE__*/ (0, $eUqFw.memo)(({ viewId: viewId, itemsCount: itemsCount, samplingRate: samplingRate = (0, $083bae7fff0f430d$export$71d024136796e395), scrollElement: scrollElement, attributes: attributes })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const samplingCount = (0, $eUqFw.useRef)(0);
    const frames = (0, $eUqFw.useRef)(0);
    const rafId = (0, $eUqFw.useRef)(null);
    const start = (0, $eUqFw.useRef)(0);
    (0, $eUqFw.useEffect)(()=>{
        const container = scrollElement ?? document;
        const hasScrollCapture = true;
        const tick = ()=>{
            if (frames.current < (0, $083bae7fff0f430d$export$299249b1dad3b14a)) {
                frames.current += 1;
                rafId.current = requestAnimationFrame(tick);
            } else {
                const stopTime = performance.now();
                const elapsedMs = stopTime - start.current;
                const fps = $ed3b6e522e859da6$export$df7175b69b5630dd(frames.current, elapsedMs);
                const avgFrameDuration = Math.floor(elapsedMs / frames.current);
                frames.current = 0;
                const attr = {
                    ...attributes || {},
                    itemsCount: itemsCount,
                    avgFrameDuration: avgFrameDuration,
                    fps: fps
                };
                (0, $jMP2a.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), `${viewId} scrolled`, attr);
            }
        };
        const handleOnScroll = ()=>{
            samplingCount.current += 1;
            if (samplingCount.current !== samplingRate) return;
            samplingCount.current = 0;
            // start counting frames
            start.current = performance.now();
            tick();
        };
        container.addEventListener('scroll', handleOnScroll, hasScrollCapture);
        return ()=>{
            container.removeEventListener('scroll', handleOnScroll, hasScrollCapture);
            if (rafId.current) cancelAnimationFrame(rafId.current);
        };
    }, [
        scrollElement,
        createAnalyticsEvent,
        itemsCount,
        samplingRate,
        viewId,
        attributes
    ]);
    return null;
});
var $ed3b6e522e859da6$export$2e2bcd8739ae039 = $ed3b6e522e859da6$export$46962be62755f053;

});
// how often do we measure, e.g. every 100th scroll
const $083bae7fff0f430d$export$71d024136796e395 = 100;
const $083bae7fff0f430d$export$299249b1dad3b14a = 20;
const $083bae7fff0f430d$export$9d3e6d8a99023567 = 60;


parcelRegister("bDGTl", function(module, exports) {

$parcel$export(module.exports, "FirstInteractionMetric", () => $f0bbcfda9127146c$export$70b569bf2edd0b7f);

var $eUqFw = parcelRequire("eUqFw");


var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");
const $f0bbcfda9127146c$export$70b569bf2edd0b7f = ({ view: view, product: product = 'jwm' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const container = document.getElementById((0, $d02be44255a1478f$export$e5e75ff4daca6597)) ?? document;
        const hasScrollCapture = true;
        const startTime = performance.now();
        const handleFirstClick = ()=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction clicked`, {
                duration: performance.now() - startTime
            });
            container.removeEventListener('click', handleFirstClick);
        };
        const handleFirstScroll = ()=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction scrolled`, {
                duration: performance.now() - startTime
            });
            container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
        };
        container.addEventListener('click', handleFirstClick);
        container.addEventListener('scroll', handleFirstScroll, hasScrollCapture);
        return ()=>{
            container.removeEventListener('click', handleFirstClick);
            container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
        };
    }, [
        createAnalyticsEvent,
        view,
        product
    ]);
    return null;
};

});

parcelRegister("6HWvN", function(module, exports) {

$parcel$export(module.exports, "RenderStartMark", () => $ebb8060987b09135$export$2128f295d6adb861);
$parcel$export(module.exports, "PageLoadMetrics", () => $ebb8060987b09135$export$66b33c055cbb625e);

var $eUqFw = parcelRequire("eUqFw");

var $7vf5z = parcelRequire("7vf5z");


var $ZvXTS = parcelRequire("ZvXTS");
const $ebb8060987b09135$export$2128f295d6adb861 = ({ view: view, loading: loading })=>{
    if (loading === true) return null;
    (0, $ZvXTS.markViewMetric)(view, (0, $78bb8734d7176028$export$b78f0bbf209e5f4));
    return null;
};
const $ebb8060987b09135$export$66b33c055cbb625e = /*#__PURE__*/ (0, $eUqFw.memo)(({ view: view, attributes: attributes, product: product = 'jwm' })=>{
    // set UI_RENDER_END mark to indicate the end of UI render
    (0, $ZvXTS.markViewMetric)(view, (0, $78bb8734d7176028$export$88ea1e280513690f));
    const metric = (0, $ZvXTS.pageLoadMetrics)[view];
    return metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        appName: `${product}.${view}`,
        metric: metric,
        extra: attributes
    });
});

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $aD5FN = parcelRequire("aD5FN");

var $2dctp = parcelRequire("2dctp");

var $5cZda = parcelRequire("5cZda");

var $i3LUJ = parcelRequire("i3LUJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $i3LUJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aD5FN.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2dctp.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $5cZda.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("2dctp", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $5eb4cd1368db1a38$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $5eb4cd1368db1a38$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $5eb4cd1368db1a38$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $abWSR = parcelRequire("abWSR");

var $5cZda = parcelRequire("5cZda");

var $F4xHF = parcelRequire("F4xHF");
function $5eb4cd1368db1a38$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $5eb4cd1368db1a38$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $abWSR.default));
    const interactionId = (0, $5cZda.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $F4xHF.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $5eb4cd1368db1a38$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $5eb4cd1368db1a38$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $5cZda.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $F4xHF.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $5eb4cd1368db1a38$export$f02972da195a43bb(marks, timingsConfig);
        (0, $F4xHF.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $iav2y = parcelRequire("iav2y");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $abWSR = parcelRequire("abWSR");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $iav2y.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $abWSR.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $abWSR = parcelRequire("abWSR");

var $i3LUJ = parcelRequire("i3LUJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $i3LUJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $i3LUJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $abWSR.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $5cZda = parcelRequire("5cZda");

var $F4xHF = parcelRequire("F4xHF");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $5cZda.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $F4xHF.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $5cZda = parcelRequire("5cZda");

var $F4xHF = parcelRequire("F4xHF");

var $i3LUJ = parcelRequire("i3LUJ");
var $cIeaO = parcelRequire("cIeaO");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $5cZda.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $i3LUJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $cIeaO.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $F4xHF.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $5cZda = parcelRequire("5cZda");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $5cZda.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});




parcelRegister("eeJbA", function(module, exports) {

$parcel$export(module.exports, "SignupInviteModal", () => $737bdeb96733c8da$export$eb44438138f66a46);

var $eUqFw = parcelRequire("eUqFw");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

var $dyfd9 = parcelRequire("dyfd9");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $737bdeb96733c8da$var$LazySignupInviteModal = (0, $dyfd9.lazy)(()=>(parcelRequire("klieu")).then(({ SignupInviteModal: SignupInviteModal })=>SignupInviteModal), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/signup-invite-modal/src/ui/main.tsx"
});
const $737bdeb96733c8da$export$eb44438138f66a46 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "jira-business.signup-invite-modal.modal",
        packageName: "jira-business.signup-invite-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "signup-invite-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($737bdeb96733c8da$var$LazySignupInviteModal, null))));

});
parcelRegister("klieu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bND13").then(()=>parcelRequire('gdLes'));

});


parcelRegister("eRpjy", function(module, exports) {

$parcel$export(module.exports, "JWMSpaStatePageReady", () => $beaa0dc8e8f2a3dd$export$d54524c142a057f);

var $eUqFw = parcelRequire("eUqFw");

var $iJHZm = parcelRequire("iJHZm");
const $beaa0dc8e8f2a3dd$export$d54524c142a057f = ()=>{
    const [isReady, setIsReady] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * Waiting for 2 animation frames is equivalent to waiting for react to paint the DOM.
		 */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        let id = window.requestAnimationFrame(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            id = window.requestAnimationFrame(()=>{
                setIsReady(true);
            });
        });
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.cancelAnimationFrame(id);
        };
    }, []);
    if (!isReady) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null);
};

});

parcelRegister("hby36", function(module, exports) {

$parcel$export(module.exports, "useShouldShowInviteUserModalBasedOnSessionStorage", () => $4f76e9cf46205f31$export$c29634004cc75294);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $bNe1g = parcelRequire("bNe1g");


var $k7Bkq = parcelRequire("k7Bkq");
const $4f76e9cf46205f31$export$c29634004cc75294 = (shouldSkip)=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const currentProjectKey = projectContext?.projectKey;
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('invite-users-on-project-create-experiment');
    const shouldShowInviteUserModal = (0, $eUqFw.useMemo)(()=>!!((0, $k7Bkq.inviteUsersSessionStorage).get((0, $a118778d850dced6$export$fde004f68299c66e)) && currentProjectKey && (0, $k7Bkq.inviteUsersSessionStorage).get((0, $a118778d850dced6$export$fde004f68299c66e)) === currentProjectKey), [
        currentProjectKey
    ]);
    return !shouldSkip && shouldShowInviteUserModal && expConfig.get('shouldShowModal', false) === true;
};

});
const $a118778d850dced6$export$fde004f68299c66e = 'nthProjectCreate';

parcelRegister("k7Bkq", function(module, exports) {

$parcel$export(module.exports, "mapUsersToAvatars", () => $f8ce04f91f87f04e$export$1251fb12c4b30642);
$parcel$export(module.exports, "inviteUsersSessionStorage", () => $f8ce04f91f87f04e$export$ec92a3cf65a1a3df);

var $89bO2 = parcelRequire("89bO2");
const $f8ce04f91f87f04e$export$1251fb12c4b30642 = (users)=>users.map((user)=>({
            key: user.accountId,
            name: user.displayName,
            src: user.avatarUrls?.['32x32']
        }));
const $f8ce04f91f87f04e$export$ec92a3cf65a1a3df = (0, $89bO2.createSessionExpirableStorageProvider)('invite-users-on-project-create');

});


parcelRegister("3ekpH", function(module, exports) {

$parcel$export(module.exports, "ProjectInviteModalWithRecommendedUsers", () => $74aa7ea8e790c4c6$export$f5fbbb53433b5eef);

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $74aa7ea8e790c4c6$var$LazyProjectInviteModalWithRecommendedUsers = (0, $dyfd9.lazy)(()=>(parcelRequire("cu0ox")).then(({ ProjectInviteModalWithRecommendedUsers: ProjectInviteModalWithRecommendedUsers })=>ProjectInviteModalWithRecommendedUsers), {
    moduleId: "./src/packages/jira-invite-users-on-project-create/src/ui/index.tsx"
});
const $74aa7ea8e790c4c6$export$f5fbbb53433b5eef = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async-project-invite-modal-with-recommended-users"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-invite-modal-with-recommended-users",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($74aa7ea8e790c4c6$var$LazyProjectInviteModalWithRecommendedUsers, props)));
};

});
parcelRegister("cu0ox", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("ahoMP")
]).then(()=>parcelRequire('lAoKF'));

});


parcelRegister("3sztN", function(module, exports) {

$parcel$export(module.exports, "useDropHandler", () => $4fe8e8e343be2ce6$export$c0f5f9f6a076ec6b);

var $eUqFw = parcelRequire("eUqFw");

var $2cKws = parcelRequire("2cKws");

var $6pUfC = parcelRequire("6pUfC");

var $ibIV3 = parcelRequire("ibIV3");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $blcyP = parcelRequire("blcyP");

var $gKXju = parcelRequire("gKXju");

var $ay4XV = parcelRequire("ay4XV");

var $aKK8W = parcelRequire("aKK8W");

var $gWYTK = parcelRequire("gWYTK");

var $gMJE7 = parcelRequire("gMJE7");
const $4fe8e8e343be2ce6$export$c0f5f9f6a076ec6b = (initialPageLoading)=>{
    const onGroupMove = (0, $blcyP.useGroupMoveHandler)();
    const moveIssue = (0, $aKK8W.useMoveIssue)();
    const groups = (0, $gKXju.useGroups)();
    const { cancelCardDrop: cancelCardDrop, confirmCardDrop: confirmCardDrop } = (0, $gWYTK.useCancelConfirmCardDrop)();
    const { transitions: transitions } = (0, $ay4XV.useIssueTransitions)();
    const { draggedIssue: draggedIssue, dropTarget: dropTarget } = (0, $gWYTK.useCardDragDrop)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>(0, $ibIV3.monitorForElements)({
            canMonitor: ()=>!initialPageLoading,
            onDrop: ({ location: location, source: source })=>{
                const sourceData = source.data;
                if (location.current.dropTargets[0]?.data == null) {
                    if ((0, $gMJE7.isCard)(sourceData)) {
                        cancelCardDrop();
                        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'card invalidDrop');
                    }
                    return;
                }
                const destinationData = location.current.dropTargets[0].data;
                // Dropping a card.
                if ((0, $gMJE7.isCard)(sourceData) && draggedIssue != null) {
                    // Dropping a card next to another card.
                    if ((0, $gMJE7.isCard)(destinationData)) {
                        const closestEdgeOfTarget = (0, $2cKws.extractClosestEdge)(destinationData);
                        const sourceIndex = sourceData.cardIndex;
                        const destinationIndex = destinationData.cardIndex;
                        const sourceColumnId = sourceData.columnId;
                        const destinationColumnId = destinationData.columnId;
                        // Return early if unable to determine the closest edge of the target.
                        if (closestEdgeOfTarget == null) {
                            cancelCardDrop();
                            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'card invalidDrop');
                            return;
                        }
                        // Return early if the card is dropped in the same place.
                        if (sourceData.issueId === destinationData.issueId) {
                            cancelCardDrop();
                            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'card invalidDrop');
                            return;
                        }
                        // Return early if the drop location would not result in a change in rank.
                        // e.g. dropping a card near the bottom of the previous card or near the top of the next card.
                        if (sourceColumnId === destinationColumnId && (0, $gMJE7.isClosestEdgeAdjacentToSource)(sourceIndex, destinationIndex, closestEdgeOfTarget)) {
                            cancelCardDrop();
                            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'card invalidDrop');
                            return;
                        }
                        moveIssue({
                            issue: draggedIssue,
                            sourceColumnId: sourceColumnId,
                            destinationColumnId: destinationColumnId,
                            rank: {
                                position: closestEdgeOfTarget === 'top' ? 'before' : 'after',
                                relativeIssueId: destinationData.issueId
                            },
                            transition: dropTarget.transition
                        });
                        confirmCardDrop();
                    } else if ((0, $gMJE7.isColumn)(destinationData) || (0, $gMJE7.isTransitionZone)(destinationData)) {
                        const transition = (0, $gMJE7.isColumn)(destinationData) ? dropTarget.transition : transitions.find((t)=>t.transitionId === destinationData.transitionId);
                        moveIssue({
                            issue: draggedIssue,
                            sourceColumnId: sourceData.columnId,
                            destinationColumnId: String(destinationData.columnId),
                            transition: transition
                        });
                        confirmCardDrop();
                    } else {
                        cancelCardDrop();
                        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'card invalidDrop');
                    }
                }
                // Dropping a column.
                if ((0, $gMJE7.isColumn)(sourceData) && (0, $gMJE7.isColumn)(destinationData)) {
                    const sourceIndex = sourceData.index;
                    const destinationIndex = destinationData.index;
                    if (sourceIndex === destinationIndex) return;
                    const closestEdgeOfTarget = (0, $2cKws.extractClosestEdge)(destinationData);
                    // Return early if the drop location would not change the order of the columns.
                    // e.g. dropping a column near the right edge of the previous column or near the left edge of the next column.
                    if ((0, $gMJE7.isClosestEdgeAdjacentToSource)(sourceIndex, destinationIndex, closestEdgeOfTarget)) return;
                    const updatedGroups = (0, $6pUfC.reorderWithEdge)({
                        list: groups,
                        startIndex: sourceIndex,
                        indexOfTarget: destinationIndex,
                        closestEdgeOfTarget: closestEdgeOfTarget,
                        axis: 'horizontal'
                    });
                    const updatedGroupIds = updatedGroups.map((group)=>group.id);
                    onGroupMove(updatedGroupIds);
                }
            }
        }), [
        cancelCardDrop,
        confirmCardDrop,
        createAnalyticsEvent,
        draggedIssue,
        dropTarget.transition,
        groups,
        initialPageLoading,
        moveIssue,
        onGroupMove,
        transitions
    ]);
};

});
parcelRegister("2cKws", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $a56fc1b31891cf12$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $a56fc1b31891cf12$export$945a571f3b658bf);
const $a56fc1b31891cf12$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $a56fc1b31891cf12$var$uniqueKey = Symbol('closestEdge');
function $a56fc1b31891cf12$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $a56fc1b31891cf12$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$a56fc1b31891cf12$var$uniqueKey]: addClosestEdge
    };
}
function $a56fc1b31891cf12$export$945a571f3b658bf(userData) {
    return userData[$a56fc1b31891cf12$var$uniqueKey] ?? null;
}

});

parcelRegister("6pUfC", function(module, exports) {

$parcel$export(module.exports, "reorderWithEdge", () => $8b3d058fc146f9db$export$d0bc664d2812b3ba);
parcelRequire("k7j7b");
var $iue3v = parcelRequire("iue3v");

var $a6RpL = parcelRequire("a6RpL");
function $8b3d058fc146f9db$export$d0bc664d2812b3ba({ list: list, startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    return (0, $iue3v.reorder)({
        list: list,
        startIndex: startIndex,
        finishIndex: (0, $a6RpL.getReorderDestinationIndex)({
            closestEdgeOfTarget: closestEdgeOfTarget,
            startIndex: startIndex,
            indexOfTarget: indexOfTarget,
            axis: axis
        })
    });
}

});
parcelRegister("k7j7b", function(module, exports) {

$parcel$export(module.exports, "reorder", () => (parcelRequire("iue3v")).reorder);

var $iue3v = parcelRequire("iue3v");

});
parcelRegister("iue3v", function(module, exports) {

$parcel$export(module.exports, "reorder", () => $f35d327f7b72cc64$export$fc77a6137e3f91c);
/**
 * Reorder a provided `list`
 * Returns a new array and does not modify the original array
 */ function $f35d327f7b72cc64$export$fc77a6137e3f91c({ list: list, startIndex: startIndex, finishIndex: finishIndex }) {
    if (startIndex === -1 || finishIndex === -1) return list;
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(finishIndex, 0, removed);
    return result;
}

});


parcelRegister("a6RpL", function(module, exports) {

$parcel$export(module.exports, "getReorderDestinationIndex", () => $99cf4b24ff9c21a7$export$846f792f51b92b6e);
function $99cf4b24ff9c21a7$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}

});


parcelRegister("blcyP", function(module, exports) {

$parcel$export(module.exports, "useGroupMoveHandler", () => $31cafa26926512c1$export$fb43401b85e3d132);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $guiFP = parcelRequire("guiFP");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $20OC3 = parcelRequire("20OC3");

var $iXHUp = parcelRequire("iXHUp");

var $2XClh = parcelRequire("2XClh");

var $iq40z = parcelRequire("iq40z");

var $gsogj = parcelRequire("gsogj");
const $31cafa26926512c1$export$3daa7ae3a08bb9e3 = (0, $eo17r.toFlagId)('move-column-error-flag');
const $31cafa26926512c1$export$fb43401b85e3d132 = ()=>{
    const { workflowName: workflowName, columns: columns } = (0, $iq40z.useWorkflowStoreState)();
    const { setColumns: setColumns } = (0, $iq40z.useWorkflowStoreActions)();
    const groupBy = (0, $iXHUp.useGroupByField)();
    const [, setGroupOrder] = (0, $2XClh.useGroupsOrder)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const project = (0, $kQAZu.useProject)();
    const projectId = String(project.id);
    return (0, $eUqFw.useCallback)(async (updatedGroupIds)=>{
        if (workflowName != null) {
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'column dragged', 'board');
            if (groupBy === (0, $jGcn0.GROUP_BY_STATUS)) {
                const updatedColumns = [];
                updatedGroupIds.forEach((groupId)=>{
                    const column = columns.find((col)=>String(col.statusId) === groupId);
                    if (column) updatedColumns.push(column);
                });
                setColumns(updatedColumns);
                try {
                    await (0, $20OC3.persistStatusGroups)(projectId, workflowName, updatedGroupIds);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    setColumns(columns);
                    (0, $guiFP.default)({
                        meta: {
                            id: 'jwmBoardControllerOnColumnMove',
                            packageName: 'jiraWorkManagementBoard',
                            teamName: 'wanjel'
                        },
                        attributes: {
                            message: 'Failed to set column order in JWM board'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    showFlag({
                        id: $31cafa26926512c1$export$3daa7ae3a08bb9e3,
                        type: 'error',
                        title: (0, $gsogj.default).columnMoveErrorTitle,
                        description: (0, $gsogj.default).columnMoveErrorMessage
                    });
                }
            } else setGroupOrder(updatedGroupIds);
        }
    }, [
        workflowName,
        createAnalyticsEvent,
        groupBy,
        setColumns,
        columns,
        projectId,
        showFlag,
        setGroupOrder
    ]);
};

});
parcelRegister("20OC3", function(module, exports) {

$parcel$export(module.exports, "persistStatusGroups", () => $8a9e513fdd8e2bc7$export$e3fa907cd4677f60);

var $lHbJt = parcelRequire("lHbJt");
const $8a9e513fdd8e2bc7$export$e3fa907cd4677f60 = async (projectId, selectedWorkflow, updatedGroupIds)=>{
    const request = {
        columnRequest: {
            workflowName: selectedWorkflow,
            columns: updatedGroupIds.map((statusId)=>({
                    statusId: statusId
                }))
        },
        projectId: projectId
    };
    await (0, $lHbJt.setBoardColumnOrder)(request);
};

});
parcelRegister("lHbJt", function(module, exports) {

$parcel$export(module.exports, "setBoardColumnOrder", () => $62dd4a32972bce00$export$8e48c3971c45541d);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $62dd4a32972bce00$export$8e48c3971c45541d = async ({ projectId: projectId, columnRequest: columnRequest })=>{
    const url = `/rest/board-api/1/project/${projectId}/columnOrder`;
    try {
        await (0, $lRmyA.performPutRequest)(url, {
            body: JSON.stringify(columnRequest)
        });
        return Promise.resolve(null);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'jwmBoardSetColumnOrder',
                packageName: 'jiraWorkManagementBoard',
                teamName: 'wanjel'
            },
            attributes: {
                message: 'Failed set board column order'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("gsogj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3200b6d7abd85587$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3200b6d7abd85587$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    columnMoveErrorTitle: {
        "id": "work-management-board.controllers.column-move-handler.column-move-error-title",
        "defaultMessage": "Failed to move column"
    },
    columnMoveErrorMessage: {
        "id": "work-management-board.controllers.column-move-handler.column-move-error-message",
        "defaultMessage": "We couldn't move this column, try refreshing the page or try again later."
    }
});

});


parcelRegister("aKK8W", function(module, exports) {

$parcel$export(module.exports, "useMoveIssue", () => $7c208b7e8aea750a$export$47e46c713d0f867d);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $e4qlg = parcelRequire("e4qlg");

var $8Qd0L = parcelRequire("8Qd0L");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");

var $iLiDV = parcelRequire("iLiDV");

var $gWYTK = parcelRequire("gWYTK");

var $d4s3F = parcelRequire("d4s3F");

var $gKXju = parcelRequire("gKXju");

var $6kWQc = parcelRequire("6kWQc");
const $7c208b7e8aea750a$var$isIssueNewlyMarkedAsDone = (sourceGroup, destinationGroup)=>{
    if (sourceGroup.type !== (0, $jGcn0.GROUP_BY_STATUS)) return false;
    return sourceGroup.statusCategoryId !== (0, $8Qd0L.StatusCategoryIds).done && destinationGroup.statusCategoryId === (0, $8Qd0L.StatusCategoryIds).done;
};
const $7c208b7e8aea750a$export$47e46c713d0f867d = ()=>{
    const groups = (0, $gKXju.useGroups)();
    const addConfettiColumn = (0, $iLiDV.useAddConfettiColumn)();
    const { data: categoryField } = (0, $e4qlg.useCategoryField)();
    const updateIssue = (0, $6kWQc.useUpdateIssue)();
    const { fireCardDropAnalytics: fireCardDropAnalytics } = (0, $d4s3F.useCardDragDropAnalytics)();
    const updateSessionId = (0, $gWYTK.useUpdateSessionId)();
    return (0, $eUqFw.useCallback)(async ({ issue: issue, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, rank: rank, transition: transition })=>{
        let showConfetti = false;
        const sourceGroup = groups.find((group)=>group.id === sourceColumnId);
        const destinationGroup = groups.find((group)=>group.id === destinationColumnId);
        if (sourceGroup == null || destinationGroup == null) throw new Error('Source or destination group not found');
        const destinationGroupType = destinationGroup.type;
        const fieldUpdates = {};
        if (sourceColumnId !== destinationColumnId) {
            switch(destinationGroupType){
                case 0, $jGcn0.GROUP_BY_ASSIGNEE:
                    fieldUpdates[0, $ib4WI.ASSIGNEE_ID] = destinationGroup.id === (0, $ib4WI.NULL_GROUP_KEY) ? undefined : {
                        fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
                        type: (0, $ib4WI.BOARD_FIELD_USER),
                        value: destinationGroup.id,
                        user: {
                            accountId: destinationGroup.id,
                            avatarURL: destinationGroup.imageUrl,
                            name: destinationGroup.name
                        }
                    };
                    break;
                case 0, $jGcn0.GROUP_BY_CATEGORY:
                    if (categoryField) fieldUpdates[0, $ib4WI.CATEGORY_ID] = destinationGroup.id === (0, $ib4WI.NULL_GROUP_KEY) ? undefined : {
                        name: categoryField.name,
                        fieldId: categoryField.id,
                        type: (0, $ib4WI.BOARD_FIELD_CATEGORY),
                        value: destinationGroup.id,
                        category: {
                            color: destinationGroup.color,
                            name: destinationGroup.name
                        }
                    };
                    break;
                case 0, $jGcn0.GROUP_BY_PRIORITY:
                    fieldUpdates[0, $ib4WI.PRIORITY_ID] = destinationGroup.id === (0, $ib4WI.NULL_GROUP_KEY) ? undefined : {
                        fieldId: (0, $lO4Or.PRIORITY_TYPE),
                        type: (0, $ib4WI.BOARD_FIELD_PRIORITY),
                        value: destinationGroup.id,
                        priority: {
                            id: destinationGroup.id,
                            iconUrl: destinationGroup.imageUrl ?? '',
                            name: destinationGroup.name
                        }
                    };
                    break;
                case 0, $jGcn0.GROUP_BY_STATUS:
                    showConfetti = $7c208b7e8aea750a$var$isIssueNewlyMarkedAsDone(sourceGroup, destinationGroup);
                    fieldUpdates[0, $ib4WI.STATUS_ID] = {
                        fieldId: (0, $lO4Or.STATUS_TYPE),
                        type: (0, $ib4WI.BOARD_FIELD_STATUS),
                        value: destinationGroup.id,
                        status: {
                            id: destinationGroup.id,
                            statusCategoryId: destinationGroup.statusCategoryId,
                            name: destinationGroup.name
                        }
                    };
                    break;
                default:
                    {
                        const exhaustiveCheck = destinationGroupType;
                        throw new Error(`Unexpected destination group type: ${exhaustiveCheck}`);
                    }
            }
            // Check if the issue is already moving to a column that should show confetti
            showConfetti = showConfetti || (0, $iLiDV.matchConfettiColumn)(destinationGroup.name);
        }
        try {
            await updateIssue({
                issue: issue,
                fields: fieldUpdates,
                transition: transition,
                rank: rank
            });
            if (showConfetti) addConfettiColumn(destinationColumnId);
            if (updateSessionId == null) throw new Error('updateSessionId is required for card drop analytics');
            fireCardDropAnalytics({
                issue: issue,
                sourceGroup: sourceGroup,
                destinationGroup: destinationGroup,
                rank: rank,
                transition: transition,
                updateSessionId: updateSessionId
            });
        } catch (error) {
        // errors handled in updateIssue controller
        }
    }, [
        addConfettiColumn,
        categoryField,
        fireCardDropAnalytics,
        groups,
        updateIssue,
        updateSessionId
    ]);
};

});
parcelRegister("6kWQc", function(module, exports) {

$parcel$export(module.exports, "useUpdateIssue", () => $60b14c9fcb9777c6$export$5ad547ae8fa63f55);

var $eUqFw = parcelRequire("eUqFw");

var $e4qlg = parcelRequire("e4qlg");

var $eI5EY = parcelRequire("eI5EY");

var $k8Qyf = parcelRequire("k8Qyf");

var $iUtze = parcelRequire("iUtze");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");

var $cZTdZ = parcelRequire("cZTdZ");

var $5bODR = parcelRequire("5bODR");

var $1j5vW = parcelRequire("1j5vW");

var $dtXTv = parcelRequire("dtXTv");

var $lgmYa = parcelRequire("lgmYa");

var $5FsEp = parcelRequire("5FsEp");

var $7vHge = parcelRequire("7vHge");

var $aW8xg = parcelRequire("aW8xg");
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $60b14c9fcb9777c6$var$noop = (_arg1, _arg2)=>{};
const $60b14c9fcb9777c6$export$5ad547ae8fa63f55 = ()=>{
    const fieldIds = (0, $lgmYa.useFieldIds)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { data: categoryField } = (0, $e4qlg.useCategoryField)();
    const { updateIssueFields: updateIssueFields, setIssues: setIssues } = (0, $dtXTv.useIssueStoreActions)();
    const transformToIssues = (0, $1j5vW.useTransformIssues)();
    const refetchIssues = (0, $5FsEp.useRefetchIssues)();
    const updateIssueFieldsService = (0, $5bODR.useUpdateIssueFields)();
    const transitionAndRankIssueService = (0, $cZTdZ.useTransitionAndRankIssueService)();
    const openTransitionScreenModal = (0, $7vHge.useTransitionScreenModal)();
    const { showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag } = (0, $eI5EY.fg)('show-modernised-issue-transition-success-flag') ? (0, $iUtze.useShowFlag)() : {
        showIssueTransitionSuccessFlag: $60b14c9fcb9777c6$var$noop
    };
    return (0, $eUqFw.useCallback)(async ({ issue: issue, fields: fields, rank: rank, transition: transition })=>{
        // optimistically update the issue fields
        updateIssueFields({
            issueId: issue.id,
            fields: fields,
            rank: rank
        });
        const issueKey = issue.fields[0, $ib4WI.ISSUE_KEY_ID].value;
        let hasTriedFieldsUpdate = false;
        let hasTriedStatusTransition = false;
        let hasTriedRanking = false;
        try {
            // perform field updates first as they are performed through REST
            // and cannot return the full issue data
            if (fields != null) {
                const fieldsForUpdate = [];
                if ((0, $ib4WI.ASSIGNEE_ID) in fields) fieldsForUpdate.push({
                    fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
                    value: fields[0, $ib4WI.ASSIGNEE_ID]
                });
                if ((0, $ib4WI.PRIORITY_ID) in fields) fieldsForUpdate.push({
                    fieldId: (0, $lO4Or.PRIORITY_TYPE),
                    value: fields[0, $ib4WI.PRIORITY_ID]
                });
                if ((0, $ib4WI.CATEGORY_ID) in fields && categoryField?.id != null) fieldsForUpdate.push({
                    fieldId: categoryField.id,
                    value: fields[0, $ib4WI.CATEGORY_ID]
                });
                if (fieldsForUpdate.length > 0) {
                    hasTriedFieldsUpdate = true;
                    await updateIssueFieldsService(issue.id, fieldsForUpdate);
                }
            }
            if (transition != null || rank != null) {
                hasTriedStatusTransition = transition != null;
                hasTriedRanking = rank != null;
                if (transition?.hasScreen) {
                    // if the transition has a screen, the transition is done through the modal
                    await openTransitionScreenModal(issue, transition.transitionId);
                    // only the ranking needs to be updated after the transition
                    if (rank == null) refetchIssues([
                        issue.id
                    ]);
                    else {
                        const response = await transitionAndRankIssueService({
                            fieldIds: fieldIds,
                            issueId: issue.id,
                            rank: rank
                        });
                        setIssues(transformToIssues([
                            response
                        ]));
                    }
                } else {
                    const response = await transitionAndRankIssueService({
                        fieldIds: fieldIds,
                        issueId: issue.id,
                        rank: rank,
                        transitionId: transition?.transitionId
                    });
                    setIssues(transformToIssues([
                        response
                    ]));
                }
                const destinationStatusName = fields?.[0, $ib4WI.STATUS_ID]?.status.name;
                if (destinationStatusName != null && (0, $eI5EY.fg)('show-modernised-issue-transition-success-flag')) showIssueTransitionSuccessFlag(issueKey, destinationStatusName);
            }
        } catch (error) {
            // if anything failed, refetch issues
            refetchIssues([
                issue.id
            ]);
            // if the user cancelled the transition modal, do not show an error flag
            if (error instanceof (0, $7vHge.TransitionModalCanceled)) throw error;
            if (error instanceof (0, $cZTdZ.TransitionValidationError)) showFlag({
                type: 'warning',
                title: (0, $aW8xg.default).transitionValidationErrorTitle,
                description: error.message
            });
            else if (hasTriedStatusTransition) showFlag({
                type: 'error',
                title: (0, $aW8xg.default).failedToTransitionErrorTitle,
                description: (0, $aW8xg.default).failedToTransitionErrorDescription
            });
            else if (hasTriedFieldsUpdate) showFlag({
                type: 'error',
                title: (0, $aW8xg.default).failedToUpdateFieldsErrorTitle,
                description: (0, $aW8xg.default).failedToUpdateFieldsErrorDescription
            });
            else if (hasTriedRanking) showFlag({
                type: 'error',
                title: (0, $aW8xg.default).failedToRankErrorTitle,
                description: (0, $aW8xg.default).failedToRankErrorDescription
            });
            throw error;
        }
    }, [
        updateIssueFields,
        categoryField?.id,
        updateIssueFieldsService,
        openTransitionScreenModal,
        refetchIssues,
        transitionAndRankIssueService,
        fieldIds,
        setIssues,
        transformToIssues,
        showIssueTransitionSuccessFlag,
        showFlag
    ]);
};

});
parcelRegister("iUtze", function(module, exports) {

$parcel$export(module.exports, "useShowFlag", () => $f828442776fe35a6$export$46b5557ad4264ef7);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jeyYc = parcelRequire("jeyYc");
const $f828442776fe35a6$export$46b5557ad4264ef7 = ()=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const showIssueTransitionSuccessFlag = (0, $eUqFw.useCallback)((issueKey, status)=>showFlag((0, $jeyYc.getTransitionSuccessFlag)(issueKey, status, formatMessage)), [
        formatMessage,
        showFlag
    ]);
    const showIssueTransitionFailureFlag = (0, $eUqFw.useCallback)((issueKey)=>showFlag((0, $jeyYc.getTransitionFailureFlag)(issueKey, formatMessage)), [
        formatMessage,
        showFlag
    ]);
    return {
        showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag,
        showIssueTransitionFailureFlag: showIssueTransitionFailureFlag
    };
};

});
parcelRegister("jeyYc", function(module, exports) {

$parcel$export(module.exports, "getTransitionSuccessFlag", () => $8041735303d9aa9a$export$8cfa71b43d733669);
$parcel$export(module.exports, "getTransitionFailureFlag", () => $8041735303d9aa9a$export$d9438db72c9548f1);

var $79xbN = parcelRequire("79xbN");

var $eo17r = parcelRequire("eo17r");

var $fNjDR = parcelRequire("fNjDR");
const $8041735303d9aa9a$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID = 'issueTransitionSuccessful';
const $8041735303d9aa9a$var$ISSUE_TRANSITION_FAILURE_FLAG_ID = 'issueTransitionFailure';
const $8041735303d9aa9a$export$8cfa71b43d733669 = (issueKey, status, formatMessage)=>{
    const showLinkToIssue = Boolean(issueKey && status);
    if (showLinkToIssue) return {
        id: (0, $eo17r.toFlagId)($8041735303d9aa9a$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
        type: 'success',
        title: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fNjDR.default).issueTransitionSuccessfulWithIssueKeyAndStatusIssueTermRefresh : (0, $fNjDR.default).issueTransitionSuccessfulWithIssueKeyAndStatus, {
            issueKey: issueKey,
            status: status
        }),
        description: (0, $fNjDR.default).issueTransitionSuccessfulFlagDescription
    };
    return {
        id: (0, $eo17r.toFlagId)($8041735303d9aa9a$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
        type: 'success',
        title: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fNjDR.default).issueTransitionSuccessfulIssueTermRefresh : (0, $fNjDR.default).issueTransitionSuccessful)
    };
};
const $8041735303d9aa9a$export$d9438db72c9548f1 = (issueKey, formatMessage)=>({
        id: (0, $eo17r.toFlagId)($8041735303d9aa9a$var$ISSUE_TRANSITION_FAILURE_FLAG_ID),
        type: 'error',
        title: issueKey ? formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fNjDR.default).issueTransitionFailureWithKeyIssueTermRefresh : (0, $fNjDR.default).issueTransitionFailureWithKey, {
            issueKey: issueKey
        }) : formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fNjDR.default).issueTransitionFailureIssueTermRefresh : (0, $fNjDR.default).issueTransitionFailure)
    });

});
parcelRegister("fNjDR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c2f93f8e85030c1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1c2f93f8e85030c1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueTransitionSuccessful: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful",
        "defaultMessage": "Issue has been updated."
    },
    issueTransitionSuccessfulWithIssueKeyAndStatus: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-with-issue-key-and-status",
        "defaultMessage": "{issueKey} moved to {status}."
    },
    issueTransitionSuccessfulFlagDescription: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-flag-description",
        "defaultMessage": "Kudos for keeping things up-to-date!"
    },
    issueTransitionFailure: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure",
        "defaultMessage": "Issue could not be updated."
    },
    issueTransitionFailureWithKey: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-with-key",
        "defaultMessage": "We couldn't update {issueKey}."
    },
    viewIssue: {
        "id": "issue-transition-use-show-flag.use-show-flag.view-issue",
        "defaultMessage": "View issue"
    },
    issueTransitionSuccessfulIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-issue-term-refresh",
        "defaultMessage": "Issue has been updated."
    },
    issueTransitionSuccessfulWithIssueKeyAndStatusIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-with-issue-key-and-status-issue-term-refresh",
        "defaultMessage": "{issueKey} moved to {status}."
    },
    issueTransitionFailureIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-issue-term-refresh",
        "defaultMessage": "Issue could not be updated."
    },
    issueTransitionFailureWithKeyIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-with-key-issue-term-refresh",
        "defaultMessage": "We couldn't update {issueKey}."
    },
    viewIssueIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.view-issue-issue-term-refresh",
        "defaultMessage": "View issue"
    }
});

});



parcelRegister("cZTdZ", function(module, exports) {

$parcel$export(module.exports, "TransitionValidationError", () => $60f6ec24021a2f56$export$eab080807dcecbbf);
$parcel$export(module.exports, "useTransitionAndRankIssueService", () => $60f6ec24021a2f56$export$13974bef1886fce4);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $jlBDe = parcelRequire("jlBDe");

var $3555e = parcelRequire("3555e");

var $jGcn0 = parcelRequire("jGcn0");

var $kkYfO = parcelRequire("kkYfO");

var $053h2 = parcelRequire("053h2");

var $4G5xU = parcelRequire("4G5xU");

var $lO4Or = parcelRequire("lO4Or");

var $fD1Hq = parcelRequire("fD1Hq");

var $a9E08 = parcelRequire("a9E08");
const $60f6ec24021a2f56$var$TRANSITION_AND_RANK_EXPERIENCE = {
    experience: 'transitionAndRankIssue',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
class $60f6ec24021a2f56$export$eab080807dcecbbf extends Error {
}
const $60f6ec24021a2f56$export$13974bef1886fce4 = ()=>{
    const hasConfluence = (0, $3555e.useTenantHasConfluence)();
    const isLinkingEnabled = (0, $fD1Hq.useIsLinkingEnabled)();
    const startTransitionAndRankIssueExperience = (0, $4G5xU.useExperienceStart)($60f6ec24021a2f56$var$TRANSITION_AND_RANK_EXPERIENCE);
    const markTransitionAndRankIssueSuccess = (0, $4G5xU.useExperienceSuccess)($60f6ec24021a2f56$var$TRANSITION_AND_RANK_EXPERIENCE);
    const markTransitionAndRankIssueFailed = (0, $4G5xU.useExperienceFail)($60f6ec24021a2f56$var$TRANSITION_AND_RANK_EXPERIENCE);
    const abortTransitionAndRankIssueExperience = (0, $4G5xU.useExperienceAbort)($60f6ec24021a2f56$var$TRANSITION_AND_RANK_EXPERIENCE);
    const [transitionAndRankMutation] = (0, $iZuDo.useMutation)((0, $a9E08.TRANSITION_AND_RANK_ISSUE_MUTATION));
    return (0, $eUqFw.useCallback)(async ({ fieldIds: fieldIdsInput, issueId: issueId, rank: rank, transitionId: transitionId })=>{
        startTransitionAndRankIssueExperience();
        try {
            const fieldIds = new Set(fieldIdsInput);
            const withChildrenCount = fieldIds.has((0, $lO4Or.SUBTASKS_TYPE));
            fieldIds.delete((0, $lO4Or.SUBTASKS_TYPE));
            const withConfluenceLinks = hasConfluence && fieldIds.has((0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE));
            fieldIds.delete((0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE));
            const withCoverMedia = fieldIds.has((0, $jGcn0.CARD_COVERS_TYPE));
            fieldIds.delete((0, $jGcn0.CARD_COVERS_TYPE));
            const withIssueLinks = fieldIds.has((0, $lO4Or.ISSUE_LINKS_TYPE)) && isLinkingEnabled;
            fieldIds.delete((0, $lO4Or.ISSUE_LINKS_TYPE));
            let rankInput;
            if (rank?.position === 'before') rankInput = {
                beforeIssueId: rank.relativeIssueId
            };
            else if (rank?.position === 'after') rankInput = {
                afterIssueId: rank.relativeIssueId
            };
            const { data: data, errors: errors } = await transitionAndRankMutation({
                variables: {
                    fieldIds: Array.from(fieldIds),
                    input: {
                        issueIds: [
                            issueId
                        ],
                        rank: rankInput,
                        transitionId: transitionId
                    },
                    withConfluenceLinks: withConfluenceLinks,
                    withCoverMedia: withCoverMedia,
                    withIssueLinks: withIssueLinks,
                    withChildrenCount: withChildrenCount
                },
                // @ts-expect-error - errorPolicy is not in the types but does work
                errorPolicy: 'all'
            });
            const mutationError = data?.transitionAndRankJwmItems?.errors?.[0];
            if (mutationError != null) {
                if (mutationError.message != null && mutationError.extensions?.statusCode === 400 && mutationError.extensions.errorType === 'TRANSITION_ERROR') throw new $60f6ec24021a2f56$export$eab080807dcecbbf(mutationError.message);
                throw new (0, $kkYfO.MutationError)(mutationError);
            }
            if (errors) {
                const apolloError = new (0, $jlBDe.ApolloError)({
                    graphQLErrors: errors
                });
                if ((0, $053h2.shouldHandleTheError)(apolloError)) throw apolloError;
            }
            if (!data) throw new Error('No transition and rank response');
            const responseData = data.transitionAndRankJwmItems;
            const issue = data.transitionAndRankJwmItems?.items?.[0]?.fieldsByIdOrAlias != null ? responseData?.items?.[0] : null;
            if (issue == null) throw new Error('Invalid transition and rank response');
            markTransitionAndRankIssueSuccess();
            return issue;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error instanceof $60f6ec24021a2f56$export$eab080807dcecbbf) abortTransitionAndRankIssueExperience('Transition validation error');
            else markTransitionAndRankIssueFailed('Failed to transition and rank issue', error);
            throw error;
        }
    }, [
        startTransitionAndRankIssueExperience,
        hasConfluence,
        isLinkingEnabled,
        transitionAndRankMutation,
        markTransitionAndRankIssueSuccess,
        abortTransitionAndRankIssueExperience,
        markTransitionAndRankIssueFailed
    ]);
};

});
parcelRegister("a9E08", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_AND_RANK_ISSUE_MUTATION", () => $db840fa3b3261479$export$f0fa92a42f51bf9b);

var $9ypom = parcelRequire("9ypom");

var $iwwE5 = parcelRequire("iwwE5");
const $db840fa3b3261479$export$f0fa92a42f51bf9b = (0, $9ypom.default)`
mutation JWMBoardTransitionAndRankIssue($input: JWMTransitionAndRankItemInput!, $fieldIds: [String]!, $withConfluenceLinks: Boolean!, $withCoverMedia: Boolean!, $withIssueLinks: Boolean!, $withChildrenCount: Boolean!) {
    transitionAndRankJwmItems(input: $input, fieldIdsToReturn: $fieldIds) {
      items {
        ...JIS2_JWMBoardItemFragment
        ...JIS2_JWMBoardConfluenceLinksFragment @include(if: $withConfluenceLinks)
        ...JIS2_JWMBoardItemCoverMediaFragment @include(if: $withCoverMedia)
        ...JIS2_JWMBoardIssueLinksFragment @include(if: $withIssueLinks)
      }
      success
      errors {
        message
        extensions {
          statusCode
          errorType
          __typename
        }
        __typename
      }
      __typename
    }
}
${(0, $iwwE5.JIS2_JWMBOARD_ITEM_FRAGMENT)}
${(0, $iwwE5.JIS2_JWMBOARD_CONFLUENCE_LINKS_FRAGMENT)}
${(0, $iwwE5.JIS2_JWMBOARD_ITEM_COVER_MEDIA_FRAGMENT)}
${(0, $iwwE5.JIS2_JWMBOARD_ISSUE_LINKS_FRAGMENT)}
`;

});


parcelRegister("5bODR", function(module, exports) {

$parcel$export(module.exports, "useUpdateIssueFields", () => $f0af32663b0b5785$export$f6fa7ea1cda1a715);

var $eUqFw = parcelRequire("eUqFw");

var $4G5xU = parcelRequire("4G5xU");

var $lRmyA = parcelRequire("lRmyA");

var $ib4WI = parcelRequire("ib4WI");
const $f0af32663b0b5785$var$UPDATE_ISSUE_FIELDS_EXPERIENCE = {
    experience: 'updateIssueFields',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f0af32663b0b5785$export$f6fa7ea1cda1a715 = ()=>{
    const startUpdateIssueFieldsExperience = (0, $4G5xU.useExperienceStart)($f0af32663b0b5785$var$UPDATE_ISSUE_FIELDS_EXPERIENCE);
    const markUpdateIssueFieldsSuccess = (0, $4G5xU.useExperienceSuccess)($f0af32663b0b5785$var$UPDATE_ISSUE_FIELDS_EXPERIENCE);
    const markUpdateIssueFieldsFailed = (0, $4G5xU.useExperienceFail)($f0af32663b0b5785$var$UPDATE_ISSUE_FIELDS_EXPERIENCE);
    return (0, $eUqFw.useCallback)(async (issueId, fields)=>{
        const fieldsPayload = {};
        fields.forEach((field)=>{
            const fieldId = field.fieldId;
            const fieldValue = field.value;
            if (fieldValue == null) {
                fieldsPayload[field.fieldId] = null;
                return;
            }
            const { type: type } = fieldValue;
            switch(type){
                case 0, $ib4WI.BOARD_FIELD_PRIORITY:
                    fieldsPayload[fieldId] = {
                        id: fieldValue.priority.id
                    };
                    break;
                case 0, $ib4WI.BOARD_FIELD_CATEGORY:
                    fieldsPayload[fieldId] = {
                        value: fieldValue.category.name
                    };
                    break;
                case 0, $ib4WI.BOARD_FIELD_USER:
                    fieldsPayload[fieldId] = {
                        accountId: fieldValue.user.accountId
                    };
                    break;
                default:
                    {
                        const exhaustiveCheck = type;
                        throw new Error(`Unexpected field type value: ${exhaustiveCheck}`);
                    }
            }
        });
        startUpdateIssueFieldsExperience();
        try {
            await (0, $lRmyA.performPutRequest)(`/rest/api/3/issue/${issueId}/`, {
                body: JSON.stringify({
                    fields: fieldsPayload
                })
            });
            markUpdateIssueFieldsSuccess();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            markUpdateIssueFieldsFailed('Failed to update issue fields', error);
            throw error;
        }
    }, [
        markUpdateIssueFieldsFailed,
        markUpdateIssueFieldsSuccess,
        startUpdateIssueFieldsExperience
    ]);
};

});

parcelRegister("7vHge", function(module, exports) {

$parcel$export(module.exports, "TransitionModalCanceled", () => $50acfe2cbc90d8f6$export$193fd3145c53120d);
$parcel$export(module.exports, "useTransitionScreenModal", () => $50acfe2cbc90d8f6$export$216691fd9138d702);

var $eUqFw = parcelRequire("eUqFw");

var $2Shq0 = parcelRequire("2Shq0");

var $1a3la = parcelRequire("1a3la");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $dWLk9 = parcelRequire("dWLk9");

var $ib4WI = parcelRequire("ib4WI");
const $50acfe2cbc90d8f6$var$TRIGGER_POINT_KEY = 'issue-transition-board-card-transition';
class $50acfe2cbc90d8f6$export$193fd3145c53120d extends Error {
}
const $50acfe2cbc90d8f6$export$216691fd9138d702 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const openIssueTransitionModal = (0, $1a3la.useOpenIssueTransitionModal)();
    return (0, $eUqFw.useCallback)((issue, transitionId)=>new Promise((resolve, reject)=>{
            const issueKey = issue.fields[0, $ib4WI.ISSUE_KEY_ID].value;
            const ariIssueId = (0, $2Shq0.JiraIssueAri).create({
                issueId: String(issue.id),
                siteId: cloudId
            }).toString();
            const onDialogSuccess = ()=>{
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTransition success', {
                    triggerPointKey: $50acfe2cbc90d8f6$var$TRIGGER_POINT_KEY,
                    isModalOpen: true
                });
                resolve(undefined);
            };
            const onDialogError = ()=>{
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTransition failed', {
                    triggerPointKey: $50acfe2cbc90d8f6$var$TRIGGER_POINT_KEY,
                    isModalOpen: true
                });
                reject(new Error('Issue transition failed'));
            };
            const onDialogCancel = ()=>{
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTransition cancel', {
                    triggerPointKey: $50acfe2cbc90d8f6$var$TRIGGER_POINT_KEY,
                    isModalOpen: true
                });
                reject(new $50acfe2cbc90d8f6$export$193fd3145c53120d('Issue transition canceled'));
            };
            openIssueTransitionModal({
                payload: {
                    issueId: ariIssueId,
                    issueKey: issueKey,
                    transitionId: String(transitionId)
                },
                triggerPointKey: $50acfe2cbc90d8f6$var$TRIGGER_POINT_KEY,
                onDialogSuccess: onDialogSuccess,
                onDialogCancel: onDialogCancel,
                onDialogError: onDialogError
            });
        }), [
        cloudId,
        createAnalyticsEvent,
        openIssueTransitionModal
    ]);
};

});
parcelRegister("2Shq0", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAri", () => $f33aa2105af1c8a3$export$1da6808e89ee03e);

var $dD8N7 = parcelRequire("dD8N7");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/issue/manifest.ts
var $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $dD8N7.JiraIssueAriResourceOwner),
    resourceType: (0, $dD8N7.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $f33aa2105af1c8a3$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("dD8N7", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $5b32aaefd8525674$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $5b32aaefd8525674$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $5b32aaefd8525674$export$665a39f1b4e29e0a = "jira", $5b32aaefd8525674$export$76beb4d0da177ad4 = "issue";

});


parcelRegister("1a3la", function(module, exports) {

$parcel$export(module.exports, "useOpenIssueTransitionModal", () => $2ec6874397d8d50c$export$736bd10472c63b49);
$parcel$export(module.exports, "useCloseIssueTransitionModal", () => $2ec6874397d8d50c$export$4629f18d511ad32e);
$parcel$export(module.exports, "useTriggerIssueTransitionModal", () => $2ec6874397d8d50c$export$95a1e9702d78f223);
$parcel$export(module.exports, "default", () => $2ec6874397d8d50c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $18to0 = parcelRequire("18to0");

var $hJ992 = parcelRequire("hJ992");

var $4ZyBG = parcelRequire("4ZyBG");

var $kIdrm = parcelRequire("kIdrm");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $h0Ytu = parcelRequire("h0Ytu");

var $6XOSh = parcelRequire("6XOSh");

var $cb3BW = parcelRequire("cb3BW");

var $b3pJg = parcelRequire("b3pJg");

var $5PGkD = parcelRequire("5PGkD");
const $2ec6874397d8d50c$export$736bd10472c63b49 = ()=>{
    const { openIssueTransitionModal: openIssueTransitionModalAction, openIssueTransitionModalNew: openIssueTransitionModalNew } = (0, $b3pJg.useTriggerIssueTransitionModalActions)();
    const { stateGet: { state: { isEnabled: isEnabled = true } = {} } = {} } = (0, $6XOSh.useIssueTransitionLabsOptIn)();
    const publish = (0, $cb3BW.usePublishOpenIssueTransitionModalPubSub)();
    const source = (0, $hJ992.useAnalyticsSource)();
    const { fireUIEvent: fireUIEvent } = (0, $kIdrm.useIssueTransitionUIAnalyticsEvent)();
    const { stateGet: { state: state } } = (0, $h0Ytu.useIssueTransitionChangeboardingPreferences)();
    const { fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened } = (0, $4ZyBG.useIssueTransitionsOperationalAnalyticsEvent)();
    const benefitsModal = typeof state !== 'number' ? state?.benefitsModal : undefined;
    const { isDisabled: isDisabled, nextDateToShowBenefitsModal: nextDateToShowBenefitsModal } = benefitsModal || {};
    return (0, $eUqFw.useCallback)((nextState)=>{
        if ((0, $eI5EY.fg)('modern_issue_transition_enable_benefits_modal')) {
            fireOperationalAnalyticsTransitionScreenOpened({
                actionSubject: 'issueTransition triggered',
                isBenefitsModalFGEneabled: (0, $eI5EY.fg)('modern_issue_transition_enable_benefits_modal'),
                preferNewIssueTransitionScreen: isEnabled,
                issueViewAnalyticsSource: source,
                isBenefitsModalDisabled: isDisabled,
                dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined
            });
            openIssueTransitionModalNew({
                nextState: nextState,
                preferNewIssueTransitionScreen: isEnabled,
                issueViewAnalyticsSource: source,
                publishTriggerToOpenTransitions: publish,
                isBenefitsModalDisabled: isDisabled,
                dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined,
                fireUIEvent: fireUIEvent
            });
            return;
        }
        if (source === 'connect-issue') {
            if ((0, $eI5EY.fg)('its_third_party_apps_instrumentation')) // fire UI event when issue transition is opened via connect API
            fireUIEvent({
                actionSubject: 'issueTransition',
                actionSubjectId: 'connectIssue',
                action: 'opened'
            });
            publish(nextState, isEnabled);
        } else openIssueTransitionModalAction(nextState, isEnabled);
    }, [
        fireOperationalAnalyticsTransitionScreenOpened,
        isEnabled,
        source,
        isDisabled,
        nextDateToShowBenefitsModal,
        openIssueTransitionModalNew,
        publish,
        fireUIEvent,
        openIssueTransitionModalAction
    ]);
};
const $2ec6874397d8d50c$export$4629f18d511ad32e = ()=>{
    const [, { resetState: resetState }] = (0, $18to0.useInlineFieldsActions)();
    const { closeIssueTransitionModal: closeIssueTransitionModalAction } = (0, $b3pJg.useTriggerIssueTransitionModalActions)();
    const { payload: { issueKey: issueKey, transitionId: transitionId }, onDialogCancel: onDialogCancel, onDialogError: onDialogError, onDialogSuccess: onDialogSuccess } = (0, $b3pJg.useTriggerIssueTransitionModalState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((shouldOpenLegacyModal = false)=>{
        closeIssueTransitionModalAction();
        (0, $1ybV0.ff)('ditto-fcf-forge-in-form-fields-in-tv_dtqg5') && resetState();
        if (shouldOpenLegacyModal) {
            const onOpenDialog = ()=>{
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'switch to legacy transition screen');
            };
            (0, $5PGkD.openLegacyIssueTransitionModal)({
                issueKey: issueKey,
                isReopenScenario: true,
                transitionId: transitionId,
                onDialogCancel: onDialogCancel,
                onDialogError: onDialogError,
                onDialogSuccess: onDialogSuccess,
                onOpenDialog: onOpenDialog
            });
        }
    }, [
        closeIssueTransitionModalAction,
        createAnalyticsEvent,
        issueKey,
        onDialogCancel,
        onDialogError,
        onDialogSuccess,
        transitionId,
        resetState
    ]);
};
const $2ec6874397d8d50c$export$95a1e9702d78f223 = ()=>{
    const state = (0, $b3pJg.useTriggerIssueTransitionModalState)();
    const actions = (0, $b3pJg.useTriggerIssueTransitionModalActions)();
    const { openIssueTransitionModalNew: openIssueTransitionModalNew, ...restActions } = actions;
    const openIssueTransitionModal = $2ec6874397d8d50c$export$736bd10472c63b49();
    return [
        state,
        {
            ...restActions,
            openIssueTransitionModal: openIssueTransitionModal
        }
    ];
};
var $2ec6874397d8d50c$export$2e2bcd8739ae039 = $2ec6874397d8d50c$export$95a1e9702d78f223;

});
parcelRegister("18to0", function(module, exports) {

$parcel$export(module.exports, "useInlineFields", () => $dac7e85413a0f58a$export$71d5b5acb7d7f5ce);
$parcel$export(module.exports, "useInlineField", () => $dac7e85413a0f58a$export$14c9655e9d9e873c);
$parcel$export(module.exports, "useInlineFieldsActions", () => $dac7e85413a0f58a$export$cdb4b503c6154b35);

var $WBLbN = parcelRequire("WBLbN");

var $7FqBr = parcelRequire("7FqBr");
// Inline fields state tracks field states in create issue view as the user interacts with them
// this is particularly needed as we want to save the field's value when the user
// unfocuses the field
const $dac7e85413a0f58a$var$store = (0, $WBLbN.createStore)({
    name: 'forge.inline-fields-state',
    initialState: {},
    actions: $7FqBr.default
});
const $dac7e85413a0f58a$export$71d5b5acb7d7f5ce = (0, $WBLbN.createHook)($dac7e85413a0f58a$var$store);
const $dac7e85413a0f58a$export$14c9655e9d9e873c = (0, $WBLbN.createHook)($dac7e85413a0f58a$var$store, {
    selector: (state, fieldId)=>state[fieldId]
});
const $dac7e85413a0f58a$export$cdb4b503c6154b35 = (0, $WBLbN.createHook)($dac7e85413a0f58a$var$store, {
    selector: null
});

});
parcelRegister("7FqBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ebb8a0129954b6a$export$2e2bcd8739ae039);

var $2h3yq = parcelRequire("2h3yq");
const $2ebb8a0129954b6a$var$actions = {
    setFieldState: $2h3yq.setFieldState,
    resetState: $2h3yq.resetState,
    dispatchRetryFunction: $2h3yq.dispatchRetryFunction,
    dispatchFormSubmits: $2h3yq.dispatchFormSubmits
};
var $2ebb8a0129954b6a$export$2e2bcd8739ae039 = $2ebb8a0129954b6a$var$actions;

});
parcelRegister("2h3yq", function(module, exports) {

$parcel$export(module.exports, "setFieldState", () => $99f6e2cbf5817dbf$export$80fd62d9217dd703);
$parcel$export(module.exports, "resetState", () => $99f6e2cbf5817dbf$export$8e84bad0b35de9e8);
$parcel$export(module.exports, "dispatchRetryFunction", () => $99f6e2cbf5817dbf$export$27c59f06a7c1fe26);
$parcel$export(module.exports, "dispatchFormSubmits", () => $99f6e2cbf5817dbf$export$42fd5e650971333b);


var $iEhdM = parcelRequire("iEhdM");
const $99f6e2cbf5817dbf$export$80fd62d9217dd703 = (data)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const stateObject = {
            status: data.status !== undefined ? data.status : currentState[data.fieldId]?.status,
            formRef: data.formRef !== undefined ? data.formRef : currentState[data.fieldId]?.formRef,
            retryFunction: data.retryFunction !== undefined ? data.retryFunction : currentState[data.fieldId]?.retryFunction
        };
        setState({
            ...getState(),
            [data.fieldId]: stateObject
        });
    };
const $99f6e2cbf5817dbf$export$8e84bad0b35de9e8 = ()=>({ getState: getState, setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stateToOverride = {};
        Object.getOwnPropertyNames(getState()).forEach((fieldId)=>{
            stateToOverride[fieldId] = {
                status: (0, $e456ec6df0e2a730$export$bbf78c43fa5268c8)
            };
        });
        setState(stateToOverride);
    };
const $99f6e2cbf5817dbf$export$27c59f06a7c1fe26 = (fieldId)=>async ({ getState: getState })=>{
        const currentState = getState();
        const fieldData = currentState[fieldId];
        const retryFunction = fieldData?.retryFunction;
        retryFunction && retryFunction();
    };
const $99f6e2cbf5817dbf$export$42fd5e650971333b = ()=>async ({ getState: getState })=>{
        const currentState = getState();
        Object.keys(currentState).forEach((fieldId)=>{
            if (currentState[fieldId]?.status === (0, $e456ec6df0e2a730$export$32bbcfb76243a487)) {
                const formRef = currentState[fieldId]?.formRef;
                (0, $iEhdM.dispatchFormSubmitAndBlurElements)(formRef);
            }
        });
    };

});
const $e456ec6df0e2a730$export$32bbcfb76243a487 = 'FOCUSED';
const $e456ec6df0e2a730$export$f81c1d6b9217380c = 'PENDING';
const $e456ec6df0e2a730$export$2ace7d3737836262 = 'RESOLVED';
const $e456ec6df0e2a730$export$9956c6a700e724c4 = 'STORED';
const $e456ec6df0e2a730$export$742c877aeb0f3dbd = 'FAILED';
const $e456ec6df0e2a730$export$bbf78c43fa5268c8 = 'IDLE';
const $e456ec6df0e2a730$export$ae7c16bdba5e2e15 = 10000;
const $e456ec6df0e2a730$export$30daef8830f2505d = 'WAIT';
const $e456ec6df0e2a730$export$f86e250f1a7b07c8 = 'PROCEED';
const $e456ec6df0e2a730$export$e784a07a62e2e0e5 = 'TIMEOUT';

parcelRegister("iEhdM", function(module, exports) {

$parcel$export(module.exports, "submitForgeFormField", () => $2e80a23b0db03f29$export$7e50fee868362aa2);
$parcel$export(module.exports, "dispatchFormSubmitAndBlurElements", () => $2e80a23b0db03f29$export$4d639a8e0790daf2);
$parcel$export(module.exports, "isBlurEventTriggeredOutsideTheField", () => $2e80a23b0db03f29$export$ee23412a8bea9333);

const $2e80a23b0db03f29$export$7e50fee868362aa2 = (formRef)=>{
    formRef?.current?.requestSubmit();
};
const $2e80a23b0db03f29$export$4d639a8e0790daf2 = (formRef)=>{
    $2e80a23b0db03f29$export$7e50fee868362aa2(formRef);
    if (formRef?.current?.elements) Array.from(formRef.current.elements).forEach((element)=>{
        if ('blur' in element && typeof element.blur === 'function') element?.blur();
    });
};
const $2e80a23b0db03f29$export$ee23412a8bea9333 = (fieldState, event, divRef)=>fieldState?.status === (0, $e456ec6df0e2a730$export$32bbcfb76243a487) && !divRef.current?.contains(event.relatedTarget);

});




parcelRegister("4ZyBG", function(module, exports) {

$parcel$export(module.exports, "useIssueTransitionsOperationalAnalyticsEvent", () => $7f280b7d76be7f5b$export$4d10663856b750d0);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");
const $7f280b7d76be7f5b$export$4d10663856b750d0 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const fireOperationalEventIssueTransitionFieldsCount = (0, $eUqFw.useCallback)(({ actionSubject: actionSubject, fieldCount: fieldCount })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
            fieldCount: fieldCount
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireOperationalAnalyticsPermissionsUnAvailable = (0, $eUqFw.useCallback)(({ actionSubject: actionSubject })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject);
    }, [
        createAnalyticsEvent
    ]);
    const fireOperationalAnalyticsTransitionScreenOpened = (0, $eUqFw.useCallback)(({ actionSubject: actionSubject, isBenefitsModalFGEneabled: isBenefitsModalFGEneabled, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen, issueViewAnalyticsSource: issueViewAnalyticsSource, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
            isBenefitsModalFGEneabled: isBenefitsModalFGEneabled,
            preferNewIssueTransitionScreen: preferNewIssueTransitionScreen,
            issueViewAnalyticsSource: issueViewAnalyticsSource,
            isBenefitsModalDisabled: isBenefitsModalDisabled,
            dateToShowBenefitsModal: dateToShowBenefitsModal
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireOperationalEventIssueTransitionFieldsCount: fireOperationalEventIssueTransitionFieldsCount,
        fireOperationalAnalyticsPermissionsUnAvailable: fireOperationalAnalyticsPermissionsUnAvailable,
        fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened
    };
};

});

parcelRegister("kIdrm", function(module, exports) {

$parcel$export(module.exports, "useIssueTransitionUIAnalyticsEvent", () => $3a8ed5a0398351ef$export$d0823e3d2e087672);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");
const $3a8ed5a0398351ef$export$d0823e3d2e087672 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const fireUIEvent = (0, $eUqFw.useCallback)(({ analyticsEvent: analyticsEvent, actionSubjectId: actionSubjectId, action: action = 'clicked', actionSubject: actionSubject, attributes: attributes = {} })=>{
        if (analyticsEvent !== undefined) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
        else {
            const createdAnalyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            });
            (0, $jMP2a.fireUIAnalytics)(createdAnalyticsEvent, actionSubjectId, attributes);
        }
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireUIEvent: fireUIEvent
    };
};

});

parcelRegister("cb3BW", function(module, exports) {

$parcel$export(module.exports, "usePublishOpenIssueTransitionModalPubSub", () => $50a5b42c9d668923$export$76b6328962c9935f);

var $eUqFw = parcelRequire("eUqFw");


var $9H6xx = parcelRequire("9H6xx");
const $50a5b42c9d668923$export$76b6328962c9935f = ()=>(0, $eUqFw.useCallback)((payload, isEnabled)=>{
        (0, $9H6xx.ITSPubSub).publish((0, $8481cb320392a1ef$export$283bfc4a4b25707a), {
            payload: payload,
            isEnabled: isEnabled
        });
    }, []);

});
const $8481cb320392a1ef$export$283bfc4a4b25707a = 'open-issue-transition-modal';

parcelRegister("9H6xx", function(module, exports) {

$parcel$export(module.exports, "ITSPubSub", () => $69f377f60a96f071$export$a3877931259d622e);

var $iGRzB = parcelRequire("iGRzB");
const $69f377f60a96f071$export$a3877931259d622e = new (0, $iGRzB.PubSubHub)();
const $69f377f60a96f071$export$58b86c4766378620 = ()=>({
        ...$69f377f60a96f071$export$a3877931259d622e
    });

});
parcelRegister("iGRzB", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $15edbdaf2cf1bbc8$export$e3607828f8f2c01e);
class $15edbdaf2cf1bbc8$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});



parcelRegister("b3pJg", function(module, exports) {

$parcel$export(module.exports, "TriggerIssueTransitionModalContainer", () => $04b7e125a8f2ae4a$export$8ad65e459a406a8a);
$parcel$export(module.exports, "useTriggerIssueTransitionModalActions", () => $04b7e125a8f2ae4a$export$68de001c738e4145);
$parcel$export(module.exports, "useTriggerIssueTransitionModalState", () => $04b7e125a8f2ae4a$export$d3aceeec551eaab5);

var $WBLbN = parcelRequire("WBLbN");

var $7iqKZ = parcelRequire("7iqKZ");

var $gtFcb = parcelRequire("gtFcb");
const $04b7e125a8f2ae4a$var$store = (0, $WBLbN.createStore)({
    name: 'issue-transition.issue-transition-form.use-trigger-issue-transition-modal',
    initialState: $7iqKZ.initialState,
    actions: $gtFcb
});
const $04b7e125a8f2ae4a$export$8ad65e459a406a8a = (0, $WBLbN.createContainer)($04b7e125a8f2ae4a$var$store);
const $04b7e125a8f2ae4a$export$68de001c738e4145 = (0, $WBLbN.createActionsHook)($04b7e125a8f2ae4a$var$store);
const $04b7e125a8f2ae4a$export$d3aceeec551eaab5 = (0, $WBLbN.createStateHook)($04b7e125a8f2ae4a$var$store);

});
parcelRegister("7iqKZ", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $ab6f76333cdb27e5$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "OPEN_MODERN_TRANSITION_MODAL", () => $ab6f76333cdb27e5$export$7320afd6d2c7276d);
$parcel$export(module.exports, "OPEN_LEGACY_TRANSITION_MODAL", () => $ab6f76333cdb27e5$export$8ed7400ca8e89de2);

var $hompL = parcelRequire("hompL");

const $ab6f76333cdb27e5$export$d4c72bab9d6cc13a = {
    inProgressTransitionID: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
    isModalOpen: false,
    isBenefitsModalOpen: false,
    isSubsequentLoad: false,
    payload: {
        issueId: '',
        issueKey: '',
        transitionId: ''
    },
    id: 'issue-transition-dialog',
    title: null,
    fetchedIssueId: '',
    triggerPointKey: (0, $fa834bef164496cf$export$8d987f6e80b74000),
    openLegacyTransitionsDialog: null,
    onDialogSuccess: null,
    onDialogCancel: null,
    onDialogError: null
};
const $ab6f76333cdb27e5$export$7320afd6d2c7276d = 'OPEN_MODERN_TRANSITION_MODAL';
const $ab6f76333cdb27e5$export$8ed7400ca8e89de2 = 'OPEN_LEGACY_TRANSITION_MODAL';

});
const $fa834bef164496cf$export$ef94a84e2990361c = 'issue-transition-issue-view';
const $fa834bef164496cf$export$de11f84a7d32933b = 'issue-transition-board-card-transition';
const $fa834bef164496cf$export$6c46e4003e7b7e9c = 'issue-transition-advanced-roadmaps-jira-transition';
const $fa834bef164496cf$export$e77cd508fbc3b5ba = 'issue-transition-backlog-inline-transition';
const $fa834bef164496cf$export$4edf4c3eee5081f6 = 'issue-transition-issue-view-shortcut-dialog';
const $fa834bef164496cf$export$27b74e685c26e665 = 'issue-transition-command-palette-status-field-transition';
const $fa834bef164496cf$export$290710ac08f770c0 = 'issue-transition-issue-results-shortcut-transition';
const $fa834bef164496cf$export$ddade13ad1b89bf0 = 'issue-transition-status-field-trigger';
const $fa834bef164496cf$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $fa834bef164496cf$export$2bf0e335b815a90b = 'comment';
const $fa834bef164496cf$export$1b8cc53b37a62399 = 'worklog';
const $fa834bef164496cf$export$d624b8367eb730df = 'issuelinks';


parcelRegister("gtFcb", function(module, exports) {

$parcel$export(module.exports, "closeIssueTransitionModal", () => (parcelRequire("bh2xU")).default);
$parcel$export(module.exports, "openIssueTransitionModal", () => (parcelRequire("kO8vo")).default);
$parcel$export(module.exports, "restoreState", () => (parcelRequire("krvVA")).default);
$parcel$export(module.exports, "setFetchedIssueId", () => (parcelRequire("cqFa9")).default);
$parcel$export(module.exports, "hideBenefitsModal", () => (parcelRequire("dRHj0")).default);
$parcel$export(module.exports, "openIssueTransitionModalNew", () => (parcelRequire("9zLXK")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $bh2xU = parcelRequire("bh2xU");

var $kO8vo = parcelRequire("kO8vo");

var $krvVA = parcelRequire("krvVA");

var $cqFa9 = parcelRequire("cqFa9");

var $dRHj0 = parcelRequire("dRHj0");

var $9zLXK = parcelRequire("9zLXK");

});
parcelRegister("bh2xU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8733dbfae9aa86f$export$2e2bcd8739ae039);

var $7iqKZ = parcelRequire("7iqKZ");
const $c8733dbfae9aa86f$var$closeIssueTransitionModal = ()=>({ setState: setState })=>{
        setState({
            ...(0, $7iqKZ.initialState),
            isModalOpen: false,
            isSubsequentLoad: true
        });
    };
var $c8733dbfae9aa86f$export$2e2bcd8739ae039 = $c8733dbfae9aa86f$var$closeIssueTransitionModal;

});

parcelRegister("kO8vo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f64237f09f9bb7e0$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $fzLv5 = parcelRequire("fzLv5");

var $hvjqG = parcelRequire("hvjqG");

var $guiFP = parcelRequire("guiFP");

var $jRlXU = parcelRequire("jRlXU");

var $7ST5U = parcelRequire("7ST5U");
const $f64237f09f9bb7e0$var$openIssueTransitionModal = (nextState, preferNewIssueTransitionScreen = true)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $7ST5U.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                transitionModalVersion = 'NEW';
                (0, $jRlXU.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $hvjqG.timeToRenderTransitionModal).start();
                new (0, $fzLv5.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $f64237f09f9bb7e0$export$2e2bcd8739ae039 = $f64237f09f9bb7e0$var$openIssueTransitionModal;

});
parcelRegister("fzLv5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f25a951ff2b0812$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $2BvS3 = parcelRequire("2BvS3");

var $5zSUY = parcelRequire("5zSUY");

var $hvjqG = parcelRequire("hvjqG");
class $0f25a951ff2b0812$export$2e2bcd8739ae039 {
    constructor({ issueId: issueId, transitionId: transitionId, issueKey: issueKey, issueKeys: issueKeys }){
        this.onDialogSuccessCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.onDialogErrorCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.onDialogCancelCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.issueId = issueId;
        this.transitionId = transitionId;
        this.issueKey = issueKey;
        this.issueKeys = issueKeys;
    }
    static{
        this.onDialogContentReady = ()=>{
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                (0, $hvjqG.timeToRenderTransitionModal).stop();
            });
        };
    }
    onDialogSuccess(onDialogSuccessCallback) {
        this.onDialogSuccessCallback = onDialogSuccessCallback;
        return this;
    }
    onDialogError(onDialogErrorCallback) {
        this.onDialogErrorCallback = onDialogErrorCallback;
        return this;
    }
    onDialogCancel(onDialogCancelCallback) {
        this.onDialogCancelCallback = onDialogCancelCallback;
        return this;
    }
    getIssueParam() {
        if (this.issueId != null) return `id=${this.issueId}`;
        if (this.issueKey != null) return `key=${this.issueKey}`;
        return '';
    }
    getUrl() {
        const { issueKeys: issueKeys } = this;
        if (issueKeys != null) // key= is needed to be sent together with keys= because of legacy API
        return `/secure/BulkTransitionIssue!default.jspa?keys=${issueKeys.join(',')}&key=${issueKeys[0]}&action=${this.transitionId}&atl_token=${(0, $5zSUY.default)() || ''}&decorator=dialog&inline=true&returnUrl=`;
        return `/secure/WorkflowUIDispatcher.jspa?${this.getIssueParam()}&action=${this.transitionId}&atl_token=${(0, $5zSUY.default)() || ''}&returnUrl=`;
    }
    async show() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogContentReady', $0f25a951ff2b0812$export$2e2bcd8739ae039.onDialogContentReady);
        // eslint-disable-next-line jira/wrm/no-load-bridge
        const FormDialog = await (0, $2BvS3.loadBridge)({
            name: 'jira/dialog/form-dialog',
            wrmKeys: 'wrc!jira.webresources:dialogs'
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const dialog = new FormDialog({
            id: 'edit-issue-dialog',
            ajaxOptions: {
                url: this.getUrl(),
                dataType: 'json'
            },
            autoClose: true,
            widthClass: 'large',
            onDialogFinished: this.onDialogSuccessCallback,
            onUnSuccessfulSubmit: this.onDialogErrorCallback,
            shouldLoadHeritageFormDialogContext: true
        });
        const cancelNativeHandler = (event)=>{
            if (!(event instanceof CustomEvent)) return;
            const dialogElement = event.detail.popup;
            const { reason: reason } = event.detail;
            if (dialogElement.is(dialog.get$popup())) {
                if (reason === 'cancel' || reason === 'esc') this.onDialogCancelCallback(event, dialogElement, reason);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.removeEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.removeEventListener('legacyJiraDialogContentReady', $0f25a951ff2b0812$export$2e2bcd8739ae039.onDialogContentReady);
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
        dialog.show();
    }
}

});
parcelRegister("hvjqG", function(module, exports) {

$parcel$export(module.exports, "timeToRenderTransitionModal", () => $5364d9ea59150bac$export$9d20a86383e90d09);

var $cFpT4 = parcelRequire("cFpT4");
const $5364d9ea59150bac$export$9d20a86383e90d09 = (0, $cFpT4.metrics).interaction({
    key: 'issue.time-to.render-issue-transition-screen',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_2500_4000_7000_10000'
    }
});

});


parcelRegister("jRlXU", function(module, exports) {

$parcel$export(module.exports, "startIssueTransitionMetrics", () => $bd86a98ef7e8a43a$export$3fc439100e136a52);

var $1ybV0 = parcelRequire("1ybV0");

var $3gb01 = parcelRequire("3gb01");

var $67xHO = parcelRequire("67xHO");

var $fy5vB = parcelRequire("fy5vB");

var $kGAxV = parcelRequire("kGAxV");
const $bd86a98ef7e8a43a$export$3fc439100e136a52 = (isSubsequentLoad)=>{
    (0, $3gb01.IssueTransitionLoadUFOExperience).start();
    (0, $3gb01.IssueTransitionUFOExperience).start();
    const issueTransitionModalLoadMetric = isSubsequentLoad ? (0, $67xHO.issueTransittionModalLoadSubsequent) : (0, $67xHO.issueTransitionModalLoad);
    if (isSubsequentLoad) (0, $kGAxV.default)('issue-transition.transition-modal-subsequent');
    else (0, $kGAxV.default)('issue-transition.transition-modal');
    issueTransitionModalLoadMetric.start();
    if ((0, $1ybV0.ff)('ui-modifications-on-issue-transition-view_7z1g0')) (0, $fy5vB.startUimTTI)();
};

});
parcelRegister("3gb01", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionLoadUFOExperience", () => $dda1b5d926efd158$export$8fb308d8abecd81a);
$parcel$export(module.exports, "IssueTransitionSubmitUFOExpereince", () => $dda1b5d926efd158$export$bd3bf8b90a131c50);
$parcel$export(module.exports, "IssueTransitionUFOExperience", () => $dda1b5d926efd158$export$2f3b26e8acf79182);

var $4zjEa = parcelRequire("4zjEa");
var $4s7r3 = parcelRequire("4s7r3");
const $dda1b5d926efd158$export$8fb308d8abecd81a = new (0, $4s7r3.UFOExperience)('issue-transition-screen.transition-load', {
    type: (0, $4zjEa.ExperienceTypes).Experience,
    performanceType: (0, $4zjEa.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-load',
    featureFlags: [
        'ui-modifications-on-issue-transition-view_7z1g0'
    ]
});
const $dda1b5d926efd158$export$bd3bf8b90a131c50 = new (0, $4s7r3.UFOExperience)('issue-transition-screen.transition-submit', {
    type: (0, $4zjEa.ExperienceTypes).Experience,
    performanceType: (0, $4zjEa.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-sumbit'
});
const $dda1b5d926efd158$export$2f3b26e8acf79182 = new (0, $4s7r3.UFOExperience)('issue-transition-screen.transition-issue', {
    type: (0, $4zjEa.ExperienceTypes).Experience,
    performanceType: (0, $4zjEa.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-issue'
});

});

parcelRegister("67xHO", function(module, exports) {

$parcel$export(module.exports, "issueTransitionModalLoad", () => $cdba3bd366b58958$export$772fb4a8bd181fd6);
$parcel$export(module.exports, "issueTransittionModalLoadSubsequent", () => $cdba3bd366b58958$export$afa89f024c56a00a);

var $cFpT4 = parcelRequire("cFpT4");
const $cdba3bd366b58958$export$772fb4a8bd181fd6 = (0, $cFpT4.metrics).interaction({
    key: 'issue-transition-modal',
    featureFlags: [
        'ui-modifications-on-issue-transition-view_7z1g0'
    ]
});
const $cdba3bd366b58958$export$afa89f024c56a00a = (0, $cFpT4.metrics).interaction({
    key: 'issue-transition-modal-subsequent',
    featureFlags: [
        'ui-modifications-on-issue-transition-view_7z1g0'
    ]
});

});

parcelRegister("fy5vB", function(module, exports) {

$parcel$export(module.exports, "startUimTTI", () => $cdecbdc0cabe0dc7$export$ae34c17d9cd2c876);
$parcel$export(module.exports, "markIssueTransitionLoaded", () => $cdecbdc0cabe0dc7$export$7cc1bb35860c7c25);
$parcel$export(module.exports, "stopTTI", () => $cdecbdc0cabe0dc7$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $cdecbdc0cabe0dc7$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $cdecbdc0cabe0dc7$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $cdecbdc0cabe0dc7$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $cdecbdc0cabe0dc7$export$d86f4868694f2aa7);

var $cFpT4 = parcelRequire("cFpT4");

var $gGRYc = parcelRequire("gGRYc");
const $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI = (0, $cFpT4.metrics).interaction({
    key: 'ui-modifications-in-issue-transition',
    timings: [
        {
            key: 'issue-transition-tti-delta',
            startMark: 'issue-transition-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $cdecbdc0cabe0dc7$export$ae34c17d9cd2c876 = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.start();
};
const $cdecbdc0cabe0dc7$export$7cc1bb35860c7c25 = ()=>$cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('issue-transition-tti');
const $cdecbdc0cabe0dc7$export$30ca4c461fab486c = (customData)=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.stop({
        customData: customData
    });
};
const $cdecbdc0cabe0dc7$export$27f2445288b528c = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.cancel();
};
const $cdecbdc0cabe0dc7$export$7a2709fc1e33401a = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('iframe-load');
};
const $cdecbdc0cabe0dc7$export$cf3893335c93e33b = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('fields-registered');
};
const $cdecbdc0cabe0dc7$export$d86f4868694f2aa7 = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('oninit-resolved');
};

});


parcelRegister("7ST5U", function(module, exports) {

$parcel$export(module.exports, "isNewTransitionScreenEnabled", () => $23d7c4603c0324df$export$1f5b72e7dbe0548d);

var $b3RcY = parcelRequire("b3RcY");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");
const $23d7c4603c0324df$export$3e9c47f2b27760a = (triggerPointKey)=>{
    const triggerPointsFlags = {
        'issue-transition-issue-view': (0, $1ybV0.ff)('issue-transition-issue-view_yq5a8'),
        'issue-transition-issue-view-shortcut-dialog': (0, $1ybV0.ff)('issue-transition-issue-view-shortcut_lv9l3'),
        'issue-transition-board-card-transition': (0, $1ybV0.ff)('issue-transition-board-card-transition_ciq82'),
        'issue-transition-advanced-roadmaps-jira-transition': (0, $1ybV0.ff)('issue-transition-advanced-roadmaps-jira-transition_b1gmi'),
        'issue-transition-command-palette-status-field-transition': (0, $1ybV0.ff)('issue-transition-command-palette-status-field-transition_ddmcl'),
        'issue-transition-issue-results-shortcut-transition': (0, $1ybV0.ff)('issue-transition-issue-results-shortcut-transition_9jznw'),
        'issue-transition-backlog-inline-transition': (0, $1ybV0.ff)('issue-transition-backlog-inline-transition_2mpzc'),
        'issue-transition-status-field-trigger': (0, $1ybV0.ff)('issue-transition-status-field-trigger_ygzr6'),
        'trigger-point-key-not-defined': (0, $1ybV0.ff)('trigger-point-key-not-defined_cixw0')
    };
    return triggerPointsFlags[triggerPointKey];
};
const $23d7c4603c0324df$export$1f5b72e7dbe0548d = (preferNewIssueTransitionScreen, triggerPointKey)=>{
    if ((0, $b3RcY.isFedRamp)()) return true;
    if (!(0, $1ybV0.ff)('render-modern-issue-transition_cxt0z')) return false;
    /* DEFAULT VALUE IS FALSE FOR ANY TRIGGER POINT NOT AVAILABLE IN THE MAP ABOVE
	 *  If trigger key is not present, then by default overall ITS will be false.
	 *  For any new trigger point, it must be necessary to list the trigger point in the map above.
	 *  When we cleanup FF for trigger points, then this should be also removed.
	 */ if (!triggerPointKey || !$23d7c4603c0324df$export$3e9c47f2b27760a(triggerPointKey)) return false;
    return preferNewIssueTransitionScreen || (0, $eI5EY.fg)('issue-transition-customisation-for-srb');
};

});


parcelRegister("krvVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e2db18eed05b7b$export$2e2bcd8739ae039);
const $a3e2db18eed05b7b$var$restoreState = (stateToRestore)=>({ setState: setState })=>{
        setState(stateToRestore);
    };
var $a3e2db18eed05b7b$export$2e2bcd8739ae039 = $a3e2db18eed05b7b$var$restoreState;

});

parcelRegister("cqFa9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e14702d6ab11f2a$export$2e2bcd8739ae039);
/**
 *
 * @deprecated since we should not be using this in the log run
 * we should not call this method any where and should clean this up as soon as GIC-JIS migration is done
 * @param issueId
 * @returns
 */ const $3e14702d6ab11f2a$var$setFetchedIssueId = (issueId)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { fetchedIssueId: fetchedIssueId } = currentState;
        if (issueId !== fetchedIssueId) setState({
            ...currentState,
            fetchedIssueId: issueId
        });
    };
var $3e14702d6ab11f2a$export$2e2bcd8739ae039 = $3e14702d6ab11f2a$var$setFetchedIssueId;

});

parcelRegister("dRHj0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd2cc3cb81c3f4e3$export$2e2bcd8739ae039);

var $7iqKZ = parcelRequire("7iqKZ");

var $jRlXU = parcelRequire("jRlXU");
const $cd2cc3cb81c3f4e3$var$hideBenefitsModal = (nextAction)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (nextAction === (0, $7iqKZ.OPEN_MODERN_TRANSITION_MODAL)) {
            (0, $jRlXU.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
            setState({
                ...currentState,
                isBenefitsModalOpen: false,
                isModalOpen: true
            });
        } else if (nextAction === (0, $7iqKZ.OPEN_LEGACY_TRANSITION_MODAL)) {
            const { openLegacyTransitionsDialog: openLegacyTransitionsDialog } = getState();
            setState({
                ...currentState,
                isBenefitsModalOpen: false,
                isModalOpen: false
            });
            openLegacyTransitionsDialog?.();
        }
    };
var $cd2cc3cb81c3f4e3$export$2e2bcd8739ae039 = $cd2cc3cb81c3f4e3$var$hideBenefitsModal;

});

parcelRegister("9zLXK", function(module, exports) {

$parcel$export(module.exports, "default", () => $531a4d6e9706b6d7$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $fzLv5 = parcelRequire("fzLv5");

var $hvjqG = parcelRequire("hvjqG");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $jRlXU = parcelRequire("jRlXU");

var $7ST5U = parcelRequire("7ST5U");
const $531a4d6e9706b6d7$var$openIssueTransitionModalNew = ({ nextState: nextState, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen = true, issueViewAnalyticsSource: issueViewAnalyticsSource, publishTriggerToOpenTransitions: publishTriggerToOpenTransitions, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal, fireUIEvent: fireUIEvent })=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $7ST5U.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                if (issueViewAnalyticsSource === 'connect-issue') {
                    publishTriggerToOpenTransitions?.(nextState, preferNewIssueTransitionScreen);
                    fireUIEvent?.({
                        actionSubject: 'issueTransition',
                        actionSubjectId: 'connectIssue',
                        action: 'opened'
                    });
                    return;
                }
                transitionModalVersion = 'NEW';
                (0, $jRlXU.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
                return;
            }
            const currentDate = new Date();
            const showBenefitsModalOnDate = dateToShowBenefitsModal && dateToShowBenefitsModal !== 'null' ? new Date(dateToShowBenefitsModal) : new Date(-1);
            const isDateToShowBenefitsModalLessThanCurrentDate = currentDate >= showBenefitsModalOnDate;
            if ((0, $1ybV0.ff)('render-modern-issue-transition_cxt0z') && !isBenefitsModalDisabled && issueViewAnalyticsSource !== 'connect-issue' && isDateToShowBenefitsModalLessThanCurrentDate) {
                // add condition to show BenefitsModal
                transitionModalVersion = 'NEW';
                const callback = ()=>{
                    (0, $hvjqG.timeToRenderTransitionModal).start();
                    new (0, $fzLv5.default)({
                        issueKey: issueKey,
                        transitionId: transitionId
                    }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).show();
                };
                setState({
                    ...currentState,
                    isBenefitsModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState,
                    openLegacyTransitionsDialog: callback
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $hvjqG.timeToRenderTransitionModal).start();
                new (0, $fzLv5.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $531a4d6e9706b6d7$export$2e2bcd8739ae039 = $531a4d6e9706b6d7$var$openIssueTransitionModalNew;

});



parcelRegister("5PGkD", function(module, exports) {

$parcel$export(module.exports, "openLegacyIssueTransitionModal", () => $4268b8c0f6eff38c$export$6bfef2005bd55204);

var $jG2Eu = parcelRequire("jG2Eu");

var $fzLv5 = parcelRequire("fzLv5");

var $hvjqG = parcelRequire("hvjqG");

var $guiFP = parcelRequire("guiFP");
const $4268b8c0f6eff38c$export$6bfef2005bd55204 = ({ issueKey: issueKey, transitionId: transitionId, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, isReopenScenario: isReopenScenario = false, onOpenDialog: onOpenDialog })=>{
    try {
        (0, $hvjqG.timeToRenderTransitionModal).start();
        new (0, $fzLv5.default)({
            issueKey: issueKey,
            transitionId: transitionId
        }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).show();
        onOpenDialog?.();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'transitionIssueTrigger',
                packageName: 'jiraIssueTransitionTrigger',
                teamName: 'gryffindor'
            },
            error: error,
            attributes: {
                transitionModalVersion: 'OLD',
                isReopenScenario: isReopenScenario
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});



parcelRegister("aW8xg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d19b0fcd13621f65$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d19b0fcd13621f65$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    transitionValidationErrorTitle: {
        "id": "work-management-board.controllers.update-issue.transition-validation-error-title",
        "defaultMessage": "Transition failed"
    },
    failedToTransitionErrorTitle: {
        "id": "work-management-board.controllers.update-issue.failed-to-transition-error-title",
        "defaultMessage": "We couldn't change the status of the item"
    },
    failedToTransitionErrorDescription: {
        "id": "work-management-board.controllers.update-issue.failed-to-transition-error-description",
        "defaultMessage": "Check your connection, then give it another try."
    },
    failedToRankErrorTitle: {
        "id": "work-management-board.controllers.update-issue.failed-to-rank-error-title",
        "defaultMessage": "We couldn't move the item"
    },
    failedToRankErrorDescription: {
        "id": "work-management-board.controllers.update-issue.failed-to-rank-error-description",
        "defaultMessage": "Check your connection, then give it another try."
    },
    failedToUpdateFieldsErrorTitle: {
        "id": "work-management-board.controllers.update-issue.failed-to-update-fields-error-title",
        "defaultMessage": "We couldn't update the item"
    },
    failedToUpdateFieldsErrorDescription: {
        "id": "work-management-board.controllers.update-issue.failed-to-update-fields-error-description",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});



parcelRegister("gMJE7", function(module, exports) {

$parcel$export(module.exports, "isCard", () => $c8cfed47b1de5a2c$export$8aa6e45444373ba8);
$parcel$export(module.exports, "isColumn", () => $c8cfed47b1de5a2c$export$891484e65a02ec71);
$parcel$export(module.exports, "isTransitionZone", () => $c8cfed47b1de5a2c$export$3efcc0a6b0c287c2);
$parcel$export(module.exports, "isClosestEdgeAdjacentToSource", () => $c8cfed47b1de5a2c$export$775b69cd23194e37);


var $ib4WI = parcelRequire("ib4WI");
function $c8cfed47b1de5a2c$export$8aa6e45444373ba8(data) {
    return data.type === (0, $ib4WI.CARD_DND_TYPE);
}
function $c8cfed47b1de5a2c$export$891484e65a02ec71(data) {
    return data.type === (0, $ib4WI.COLUMN_DND_TYPE);
}
function $c8cfed47b1de5a2c$export$3efcc0a6b0c287c2(data) {
    return data.type === (0, $df03f3fe1f111432$export$2927f4d423091b16);
}
const $c8cfed47b1de5a2c$export$775b69cd23194e37 = (sourceIndex, destinationIndex, closestEdge)=>{
    if (closestEdge == null) return false;
    const adjacentEdges = {
        top: sourceIndex + 1,
        bottom: sourceIndex - 1,
        left: sourceIndex + 1,
        right: sourceIndex - 1
    };
    return destinationIndex === adjacentEdges[closestEdge];
};

});
const $df03f3fe1f111432$export$b05303cbde3e8c8c = 'CARD';
const $df03f3fe1f111432$export$57d0ef745f304b91 = 'COLUMN';
const $df03f3fe1f111432$export$2927f4d423091b16 = 'TRANSITION_ZONE';



parcelRegister("2b5eO", function(module, exports) {

$parcel$export(module.exports, "useJWMBoardFeatures", () => $f39a893ab3cf4c9e$export$2e6493f557c370c4);
$parcel$export(module.exports, "default", () => $f39a893ab3cf4c9e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $f39a893ab3cf4c9e$var$defaultFeaturesContext = {
    isShareButtonEnabled: true,
    isPresenceEnabled: true,
    issueViewInteraction: 'default',
    isOnboardingEnabled: true,
    featureView: 'jwm-board',
    inviteButtonInteraction: 'default',
    typeSelectInteraction: 'default'
};
const $f39a893ab3cf4c9e$var$JWMBoardFeaturesContext = /*#__PURE__*/ (0, $eUqFw.createContext)($f39a893ab3cf4c9e$var$defaultFeaturesContext);
const $f39a893ab3cf4c9e$export$2e6493f557c370c4 = ()=>(0, $eUqFw.useContext)($f39a893ab3cf4c9e$var$JWMBoardFeaturesContext);
var $f39a893ab3cf4c9e$export$2e2bcd8739ae039 = $f39a893ab3cf4c9e$var$JWMBoardFeaturesContext;

});

parcelRegister("cY0Xy", function(module, exports) {

$parcel$export(module.exports, "useHandleIssueEvents", () => $c6c56e79d7475f18$export$6339e8336d465669);

var $eUqFw = parcelRequire("eUqFw");

var $d3C6e = parcelRequire("d3C6e");

var $ib4WI = parcelRequire("ib4WI");

var $dtXTv = parcelRequire("dtXTv");

var $d1mZL = parcelRequire("d1mZL");

var $5FsEp = parcelRequire("5FsEp");
const $c6c56e79d7475f18$export$6339e8336d465669 = ()=>{
    const issues = (0, $d1mZL.useIssues)();
    const getIsHighlighted = (0, $d3C6e.useIsHighlighted)();
    const refetchIssues = (0, $5FsEp.useRefetchIssues)();
    const { removeIssues: removeIssues } = (0, $dtXTv.useIssueStoreActions)();
    const handleUpdatedIssue = (0, $eUqFw.useCallback)(async (issueId)=>{
        // Return early when we receive realtime events for an issue that was
        // recently created via the issue create component in the current window.
        // This avoid race conditions.
        if (getIsHighlighted(issueId)) return;
        const [updatedIssue] = await refetchIssues([
            issueId
        ]);
        if (updatedIssue) {
            const parentIssueId = updatedIssue.fields[0, $ib4WI.PARENT_ID]?.value;
            if (parentIssueId) refetchIssues([
                Number(parentIssueId)
            ]);
        }
    }, [
        getIsHighlighted,
        refetchIssues
    ]);
    const handleDeletedIssue = (0, $eUqFw.useCallback)((issueId)=>{
        const deletedIssue = issues.get(issueId);
        if (deletedIssue == null) return;
        const parentIssue = issues.get(Number(deletedIssue.fields[0, $ib4WI.PARENT_ID]?.value));
        if (parentIssue) refetchIssues([
            parentIssue.id
        ]);
        removeIssues([
            issueId
        ]);
    }, [
        issues,
        refetchIssues,
        removeIssues
    ]);
    return {
        handleUpdatedIssue: handleUpdatedIssue,
        handleDeletedIssue: handleDeletedIssue
    };
};

});

parcelRegister("c52lf", function(module, exports) {

$parcel$export(module.exports, "IssuesByGroupProvider", () => $82f310c299227d34$export$15e029fbfaee4283);
$parcel$export(module.exports, "useIssueGroups", () => $82f310c299227d34$export$2a761b53b8f42b98);
$parcel$export(module.exports, "IssueGroupProvider", () => $82f310c299227d34$export$dc797f621868b0d5);
$parcel$export(module.exports, "useIssueGroup", () => $82f310c299227d34$export$7169da554b06d9e9);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $ib4WI = parcelRequire("ib4WI");

var $iXHUp = parcelRequire("iXHUp");

var $gKXju = parcelRequire("gKXju");

var $2XClh = parcelRequire("2XClh");
const $82f310c299227d34$var$EMPTY_ISSUES = [];
const $82f310c299227d34$var$RootContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $82f310c299227d34$export$15e029fbfaee4283 = ({ filteredIssues: filteredIssues, children: children })=>{
    const groupBy = (0, $iXHUp.useGroupByField)();
    const issuesByGroup = (0, $eUqFw.useMemo)(()=>{
        const map = new Map();
        // iterate over the filtered issues and add them to the correct group
        filteredIssues.forEach((issue)=>{
            const groupId = issue.fields[groupBy]?.value ?? (0, $ib4WI.NULL_GROUP_KEY);
            let groupIssues = map.get(groupId);
            if (!groupIssues) {
                groupIssues = [];
                map.set(groupId, groupIssues);
            }
            groupIssues.push(issue);
        });
        return map;
    }, [
        filteredIssues,
        groupBy
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82f310c299227d34$var$RootContext.Provider, {
        value: issuesByGroup
    }, children);
};
const $82f310c299227d34$var$useIssuesByGroup = ()=>{
    const issuesByGroup = (0, $eUqFw.useContext)($82f310c299227d34$var$RootContext);
    if (!issuesByGroup) throw new Error('useIssuesByGroup must be used within a IssuesByGroupProvider');
    return issuesByGroup;
};
const $82f310c299227d34$export$2a761b53b8f42b98 = ()=>{
    // merge the groups from the group context with the groups from the issues by group
    // to make sure we do not hide any groups
    const groupBy = (0, $iXHUp.useGroupByField)();
    const groups = (0, $gKXju.useGroups)();
    const issuesByGroup = $82f310c299227d34$var$useIssuesByGroup();
    const sortGroups = (0, $2XClh.useSortGroups)();
    return (0, $eUqFw.useMemo)(()=>{
        // if grouped by status or assignee, skip this
        if (groupBy === (0, $jGcn0.GROUP_BY_STATUS) || groupBy === (0, $jGcn0.GROUP_BY_ASSIGNEE)) return groups;
        // if all the groups found in issuesByGroup are already in the groups array
        // we can just return the groups array
        const missingGroups = [
            ...issuesByGroup.keys()
        ].filter((groupId)=>!groups.some((group)=>group.id === groupId));
        if (missingGroups.length === 0) return groups;
        return sortGroups([
            ...missingGroups.map((groupId)=>{
                const firstIssue = issuesByGroup.get(groupId)?.[0];
                if (!firstIssue) throw new Error('No issues found for group');
                switch(groupBy){
                    case 0, $jGcn0.GROUP_BY_PRIORITY:
                        return {
                            id: groupId,
                            imageUrl: firstIssue.fields[groupBy]?.priority?.iconUrl ?? null,
                            name: firstIssue.fields[groupBy]?.priority.name ?? '',
                            type: groupBy
                        };
                    case 0, $jGcn0.GROUP_BY_CATEGORY:
                        return {
                            id: groupId,
                            color: firstIssue.fields[groupBy]?.category?.color ?? null,
                            name: firstIssue.fields[groupBy]?.category.name ?? '',
                            type: groupBy
                        };
                    default:
                        {
                            const exhaustiveCheck = groupBy;
                            throw new Error(`Unexpected groupBy value: ${exhaustiveCheck}`);
                        }
                }
            }),
            ...groups
        ]);
    }, [
        sortGroups,
        groupBy,
        groups,
        issuesByGroup
    ]);
};
const $82f310c299227d34$var$ChildContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $82f310c299227d34$export$dc797f621868b0d5 = ({ group: group, children: children })=>{
    const issuesByGroup = $82f310c299227d34$var$useIssuesByGroup();
    const issues = issuesByGroup.get(group.id) ?? $82f310c299227d34$var$EMPTY_ISSUES;
    const value = (0, $eUqFw.useMemo)(()=>({
            issues: issues,
            group: group
        }), [
        issues,
        group
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82f310c299227d34$var$ChildContext.Provider, {
        value: value
    }, children);
};
const $82f310c299227d34$export$7169da554b06d9e9 = ()=>{
    const issueGroup = (0, $eUqFw.useContext)($82f310c299227d34$var$ChildContext);
    if (!issueGroup) throw new Error('useIssueGroup must be used within a IssueGroupProvider');
    return issueGroup;
};

});

parcelRegister("sFqil", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef8d2be9c4d9c7b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $lEfVV = parcelRequire("lEfVV");

var $6ki0E = parcelRequire("6ki0E");

var $3Udf5 = parcelRequire("3Udf5");

var $ipwBG = parcelRequire("ipwBG");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $96etS = parcelRequire("96etS");

var $ef5z4 = parcelRequire("ef5z4");

var $c7wtc = parcelRequire("c7wtc");

var $zcJ0y = parcelRequire("zcJ0y");

var $eI5EY = parcelRequire("eI5EY");

var $RZsVl = parcelRequire("RZsVl");

var $hb3Di = parcelRequire("hb3Di");

var $a4Bvw = parcelRequire("a4Bvw");

var $ib4WI = parcelRequire("ib4WI");

var $jlfkT = parcelRequire("jlfkT");

var $2sU4b = parcelRequire("2sU4b");

var $lnmSR = parcelRequire("lnmSR");

var $iXHUp = parcelRequire("iXHUp");

var $c52lf = parcelRequire("c52lf");

var $cgK6s = parcelRequire("cgK6s");

var $eMXBu = parcelRequire("eMXBu");

var $1kaEx = parcelRequire("1kaEx");

var $jduWG = parcelRequire("jduWG");

var $gQQ5C = parcelRequire("gQQ5C");

var $9sGu9 = parcelRequire("9sGu9");
const $bef8d2be9c4d9c7b$var$isSafariBrowser = (0, $zcJ0y.isSafari)();
const $bef8d2be9c4d9c7b$var$renderCardDropIndicator = (cardsCount, cardDragMeta, virtualizer)=>{
    if (!cardDragMeta) return null;
    const virtualItem = virtualizer.getVirtualItems().find((item)=>item.index === cardDragMeta.cardIndex);
    if (!virtualItem) return null;
    const isAtVeryTop = cardDragMeta.cardIndex === 0 && cardDragMeta.closestEdge === 'top';
    const isAtVeryBottom = cardDragMeta.cardIndex === cardsCount - 1 && cardDragMeta.closestEdge === 'bottom';
    let start = cardDragMeta.closestEdge === 'top' ? virtualItem.start - 3 : virtualItem.end + 1;
    if (isAtVeryTop) // makes sure the drop indicator is not clipped
    start = 3;
    else if (isAtVeryBottom) // makes sure the drop indicator doesn't cause a scrollbar
    start -= 6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bef8d2be9c4d9c7b$export$5a1a2d64cf6af79f, {
        start: start
    });
};
const $bef8d2be9c4d9c7b$var$BoardColumn = ({ columnsNumber: columnsNumber, columnIndex: columnIndex })=>{
    const project = (0, $kQAZu.useProject)();
    const { issues: issues, group: group } = (0, $c52lf.useIssueGroup)();
    const isWorkflowOperationInProgress = (0, $cgK6s.useIsWorkflowOperationInProgress)();
    const [simpleSearch] = (0, $96etS.useSimpleSearch)();
    const checkCanCreateIssueInStatus = (0, $ef5z4.useCanCreateIssueInStatus)();
    const [siblingCreateIssueId, setSiblingCreateIssueId] = (0, $eUqFw.useState)(null);
    const workflows = (0, $c7wtc.useWorkflows)();
    const [activeWorkflowId] = (0, $jlfkT.useActiveWorkflow)();
    const [cardContainer, setCardContainer] = (0, $eUqFw.useState)(null);
    const columnDropTargetRef = (0, $eUqFw.useRef)(null);
    const columnHandleRef = (0, $eUqFw.useRef)(null);
    const [cardDragMeta, setCardDragMeta] = (0, $eUqFw.useState)(null);
    const { isCollapsed: isCollapsed } = (0, $lnmSR.useExpandCollapse)(group.id);
    const groupBy = (0, $iXHUp.useGroupByField)();
    const isGroupedByStatus = groupBy === (0, $jGcn0.GROUP_BY_STATUS);
    const isEnabledForTailoredOnboardingM2 = (0, $eI5EY.fg)('jira_tailored_onboarding_jtbd_feature_gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $RZsVl.useIsTailoredOnboardingM2ForQuickstartEnabled)() : false;
    const { canDropInGroup: canDropInGroup, closestEdge: closestEdge, dragPreviewState: dragPreviewState, isCardOverColumn: isCardOverColumn, isDraggingColumn: isDraggingColumn } = (0, $2sU4b.useDraggableColumn)({
        columnDropTargetRef: columnDropTargetRef,
        columnHandleRef: columnHandleRef,
        group: group,
        index: columnIndex
    });
    const shouldShowInvalidDropTargetMessage = !isCollapsed && canDropInGroup === 'no';
    const virtualizer = (0, $6ki0E.useVirtualizer)({
        count: isCollapsed ? 0 : issues.length,
        getScrollElement: ()=>cardContainer,
        estimateSize: ()=>300,
        overscan: 2,
        gap: 4,
        getItemKey: (0, $eUqFw.useCallback)((index)=>issues[index].id, [
            issues
        ])
    });
    (0, $eUqFw.useEffect)(()=>{
        if (!cardContainer) return;
        return (0, $3Udf5.autoScrollForElements)({
            canScroll: ({ source: source })=>source.data.type === (0, $ib4WI.CARD_DND_TYPE),
            element: cardContainer,
            getAllowedAxis: ()=>'vertical'
        });
    }, [
        cardContainer
    ]);
    const scrollToLastElement = (0, $eUqFw.useCallback)(()=>{
        const issueCount = issues.length;
        if (issueCount === 0) return;
        virtualizer.scrollToIndex(issueCount, {
            align: 'start'
        });
    }, [
        issues.length,
        virtualizer
    ]);
    const textHighlight = (0, $eUqFw.useMemo)(()=>simpleSearch != null ? [
            simpleSearch
        ] : undefined, [
        simpleSearch
    ]);
    const canCreateIssues = (0, $eUqFw.useMemo)(()=>{
        if (isCollapsed) return false;
        if (!project.permissions.createIssues) return false;
        if (isGroupedByStatus && !checkCanCreateIssueInStatus(group.id, workflows?.find((workflow)=>workflow.workflowId === activeWorkflowId))) return false;
        return true;
    }, [
        activeWorkflowId,
        checkCanCreateIssueInStatus,
        group.id,
        isCollapsed,
        isGroupedByStatus,
        project.permissions.createIssues,
        workflows
    ]);
    const isDropDisabled = canDropInGroup === 'no' || isCollapsed && canDropInGroup === 'choice-required';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $bef8d2be9c4d9c7b$var$columnDropTargetStyles,
        ref: columnDropTargetRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bef8d2be9c4d9c7b$var$Column, {
        isCardOverColumn: isCardOverColumn,
        isCollapsed: isCollapsed,
        isDragging: isDraggingColumn,
        isDropDisabled: isDropDisabled,
        isShowingInvalidDropTargetMessage: shouldShowInvalidDropTargetMessage,
        "data-testid": "work-management-board.ui.board.column"
    }, isEnabledForTailoredOnboardingM2 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hb3Di.ConditionalNudgeWrapper), {
        conditionsToApplyWrapper: isGroupedByStatus && (columnsNumber > 1 ? columnIndex === 1 : columnIndex === 0),
        Wrapper: (0, $a4Bvw.TailorBoardColumnsAsync)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1kaEx.default), {
        key: group.name,
        dragHandleRef: columnHandleRef,
        group: group,
        isCardOverColumn: isCardOverColumn,
        isDragPreview: false,
        isDropDisabled: isDropDisabled,
        issueCount: issues.length
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1kaEx.default), {
        key: group.name,
        dragHandleRef: columnHandleRef,
        group: group,
        isCardOverColumn: isCardOverColumn,
        isDragPreview: false,
        isDropDisabled: isDropDisabled,
        issueCount: issues.length
    }), !isCollapsed && issues.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bef8d2be9c4d9c7b$var$ScrollContainer, {
        isDragging: isDraggingColumn,
        isScrollbarForced: (0, $zcJ0y.isFirefox)(),
        ref: setCardContainer,
        "data-testid": "work-management-board.ui.board.column.scroll-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bef8d2be9c4d9c7b$var$VirtualCardsContainer, {
        height: virtualizer.getTotalSize()
    }, virtualizer.getVirtualItems().map((virtualItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bef8d2be9c4d9c7b$var$VirtualCardWrapper, {
            key: virtualItem.key,
            "data-index": virtualItem.index,
            start: virtualItem.start,
            ref: virtualizer.measureElement
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eMXBu.default), {
            key: virtualItem.key,
            draggableIndex: virtualItem.index,
            canCreateIssues: canCreateIssues,
            group: group,
            issue: issues[virtualItem.index],
            highlight: textHighlight,
            isSiblingCreateFormOpen: siblingCreateIssueId === issues[virtualItem.index].id,
            toggleSiblingCreateForm: setSiblingCreateIssueId,
            onCardDragChange: setCardDragMeta
        }))), $bef8d2be9c4d9c7b$var$renderCardDropIndicator(issues.length, cardDragMeta, virtualizer), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $ib4WI.VIEW_EXPERIENCE)
    }))), shouldShowInvalidDropTargetMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQQ5C.default), null), !isCollapsed && [
        'choice-available',
        'choice-required'
    ].includes(canDropInGroup) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9sGu9.default), {
        group: group
    }), canCreateIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jduWG.default), {
        group: group,
        scrollToLastElement: scrollToLastElement
    }), isWorkflowOperationInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $bef8d2be9c4d9c7b$var$overlayStyles,
        testId: "work-management-board.ui.board.column.overlay"
    }), closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bef8d2be9c4d9c7b$var$ColumnDropIndicatorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ipwBG.DropIndicator), {
        edge: closestEdge,
        gap: `${(0, $ib4WI.GAP_BETWEEN_COLUMNS)}px`
    })))), dragPreviewState.type === 'preview' && isDraggingColumn ? /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bef8d2be9c4d9c7b$export$18a854943bcb82fa, {
        isCollapsed: isCollapsed,
        isTilted: !$bef8d2be9c4d9c7b$var$isSafariBrowser
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1kaEx.default), {
        key: group.name,
        group: group,
        isCardOverColumn: isCardOverColumn,
        isDragPreview: true,
        isDropDisabled: false,
        issueCount: issues.length
    })), dragPreviewState.container) : null);
};
var $bef8d2be9c4d9c7b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($bef8d2be9c4d9c7b$var$BoardColumn);
const $bef8d2be9c4d9c7b$var$columnDropTargetStyles = (0, $8Vv3m.xcss)({
    height: '100%'
});
const $bef8d2be9c4d9c7b$export$18a854943bcb82fa = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTilted: isTilted, isCollapsed: isCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkhri9 _2rkopd34 _1bsb1ogy",
            __cmplp.isTilted ? "_139ek9zm" : "_139e1i1e",
            __cmplp.isCollapsed && "_1bsb1ylp",
            __cmplp.className
        ])
    });
});
const $bef8d2be9c4d9c7b$var$ColumnDropIndicatorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_z1i3tvsq _4t3i1kxc _kqswstnw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $bef8d2be9c4d9c7b$var$Column = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isShowingInvalidDropTargetMessage: isShowingInvalidDropTargetMessage, isCardOverColumn: isCardOverColumn, isCollapsed: isCollapsed, isDropDisabled: isDropDisabled, isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkhri9 _v5641czr _2rkopd34 _1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _2lx21bp4 _c71l1osq _1bsb1ogy _kqswh2mm _12ji3acm _1cwgidpf _1qu2nqa1 _12y31bk5",
            __cmplp.isShowingInvalidDropTargetMessage && "_1tkep3fh",
            __cmplp.isCardOverColumn && "_bfhki1yw _12ji1yqz",
            __cmplp.isCollapsed && "_1bsb1ylp _c71luuw1",
            __cmplp.isDropDisabled && "_bfhk1gly _12ji1bqt",
            __cmplp.isDragging && "_tzy42wxo",
            __cmplp.className
        ])
    });
});
const $bef8d2be9c4d9c7b$var$ScrollContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isScrollbarForced: isScrollbarForced, isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tke1ylp _1reo15vq _ca0qt94y _n3tdt94y _u5f31b66 _19bvv47k _18u0mgjw _otyr1b66",
            __cmplp.isScrollbarForced ? "_18m915zi" : "_18m91wug",
            __cmplp.isDragging && "_19bv1b66 _18u0idpf _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $bef8d2be9c4d9c7b$var$overlayStyles = (0, $8Vv3m.xcss)({
    position: 'absolute',
    left: '0px',
    right: '0px',
    top: '0px',
    bottom: '0px',
    background: "var(--ds-background-disabled, rgba(235, 236, 240, 0.7))",
    zIndex: 'blanket'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bef8d2be9c4d9c7b$var$VirtualCardsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i2nrh _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $bef8d2be9c4d9c7b$var$VirtualCardWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_10d4ua4": (0, $9t7rW.default)(`translateY(${__cmplp.start}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1bsb1osq _t9ec1dpj",
            __cmplp.className
        ])
    });
});
const $bef8d2be9c4d9c7b$export$5a1a2d64cf6af79f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_10d4ua4": (0, $9t7rW.default)(`translateY(${__cmplp.start}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _kqswstnw _1pbycs5v _lcxvglyw _11q71yqz _4t3iyh40 _1ltv1y44 _1xi2idpf _t9ec1dpj _1kt9b3bt _1mp4ftgi _kfgtftgi _qnecyjp0 _1aukj39m _13y0usvi _1cs8stnw _14h8neh2 _rfx31ssb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ipwBG", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $2f48a5287a8198ff$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "default", () => $2f48a5287a8198ff$export$2e2bcd8739ae039);
/**
 * Spacing tokens don't make a lot of sense for this specific use case,
 * so disabling the linting rule.
 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $tWTrX = parcelRequire("tWTrX");
const $2f48a5287a8198ff$var$terminalSize = 8;
const $2f48a5287a8198ff$var$lineStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    position: 'absolute',
    zIndex: 1,
    // Blocking pointer events to prevent the line from triggering drag events
    // Dragging over the line should count as dragging over the element behind it
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: (0, $tWTrX.line).backgroundColor,
    // Terminal
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::before': {
        content: '""',
        width: $2f48a5287a8198ff$var$terminalSize,
        height: $2f48a5287a8198ff$var$terminalSize,
        boxSizing: 'border-box',
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        border: `${(0, $tWTrX.line).thickness}px solid ${(0, $tWTrX.line).backgroundColor}`,
        borderRadius: '50%'
    }
});
/**
 * By default, the edge of the terminal will be aligned to the edge of the line.
 *
 * Offsetting the terminal by half its size aligns the middle of the terminal
 * with the edge of the line.
 *
 * We must offset by half the line width in the opposite direction so that the
 * middle of the terminal aligns with the middle of the line.
 *
 * That is,
 *
 * offset = - (terminalSize / 2) + (line.thickness / 2)
 *
 * which simplifies to the following value.
 */ const $2f48a5287a8198ff$var$offsetToAlignTerminalWithLine = ((0, $tWTrX.line).thickness - $2f48a5287a8198ff$var$terminalSize) / 2;
/**
 * We inset the line by half the terminal size,
 * so that the terminal only half sticks out past the item.
 */ const $2f48a5287a8198ff$var$lineOffset = $2f48a5287a8198ff$var$terminalSize / 2;
const $2f48a5287a8198ff$var$orientationStyles = {
    horizontal: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $tWTrX.line).thickness,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: $2f48a5287a8198ff$var$lineOffset,
        right: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // Horizontal indicators have the terminal on the left
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            left: -$2f48a5287a8198ff$var$terminalSize
        }
    }),
    vertical: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $tWTrX.line).thickness,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: $2f48a5287a8198ff$var$lineOffset,
        bottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // Vertical indicators have the terminal at the top
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: -$2f48a5287a8198ff$var$terminalSize
        }
    })
};
const $2f48a5287a8198ff$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $2f48a5287a8198ff$var$edgeStyles = {
    top: /*#__PURE__*/ (0, $byn9U.css)({
        top: 'var(--local-line-offset)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: $2f48a5287a8198ff$var$offsetToAlignTerminalWithLine
        }
    }),
    right: /*#__PURE__*/ (0, $byn9U.css)({
        right: 'var(--local-line-offset)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            right: $2f48a5287a8198ff$var$offsetToAlignTerminalWithLine
        }
    }),
    bottom: /*#__PURE__*/ (0, $byn9U.css)({
        bottom: 'var(--local-line-offset)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            bottom: $2f48a5287a8198ff$var$offsetToAlignTerminalWithLine
        }
    }),
    left: /*#__PURE__*/ (0, $byn9U.css)({
        left: 'var(--local-line-offset)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            left: $2f48a5287a8198ff$var$offsetToAlignTerminalWithLine
        }
    })
};
function $2f48a5287a8198ff$export$62ed72bc21f6b8a6({ edge: edge, gap: gap = '0px' }) {
    /**
   * To clearly communicate the resting place of a draggable item during a drag operation,
   * the drop indicator should be positioned half way between draggable items.
   */ const lineOffset = `calc(-0.5 * (${gap} + ${(0, $tWTrX.line).thickness}px))`;
    const orientation = $2f48a5287a8198ff$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $2f48a5287a8198ff$var$lineStyles,
            $2f48a5287a8198ff$var$orientationStyles[orientation],
            $2f48a5287a8198ff$var$edgeStyles[edge]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            '--local-line-offset': lineOffset
        }
    });
}
var // This default export is intended for usage with React.lazy
$2f48a5287a8198ff$export$2e2bcd8739ae039 = $2f48a5287a8198ff$export$62ed72bc21f6b8a6;

});
parcelRegister("tWTrX", function(module, exports) {

$parcel$export(module.exports, "line", () => $3a9993f049aa74da$export$53f1d5ea8de3d7c);
/**
 * Design decisions for the drop indicator's main line
 */ const $3a9993f049aa74da$export$53f1d5ea8de3d7c = {
    borderRadius: 0,
    thickness: 2,
    backgroundColor: "var(--ds-border-selected, #0C66E4)"
};

});


parcelRegister("ef5z4", function(module, exports) {

$parcel$export(module.exports, "useCanCreateIssueInStatus", () => $24564dd80699b178$export$efe8838d1712139f);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $c7wtc = parcelRequire("c7wtc");
const $24564dd80699b178$export$efe8838d1712139f = ()=>{
    const workflows = (0, $c7wtc.useWorkflows)();
    const project = (0, $kQAZu.useProject)();
    return (0, $eUqFw.useCallback)((statusId, workflow = null)=>{
        if (!workflows) return false;
        const eligibleWorkflows = workflow != null ? [
            workflow
        ] : workflows.filter((w)=>w.issueTypes.some((it)=>it.hierarchyLevel >= 0));
        // we want to show the create button on the group if it can:
        // - be created from the initial transition,
        // - OR if it has a global transition leading to it
        //      AND the transition isn't conditional
        //      AND the user is allowed to transition issues
        return eligibleWorkflows.some((w)=>w.transitions.some((transition)=>transition.to.statusId === statusId && (transition.isInitial || transition.isGlobal && !transition.isConditional && project.permissions.transitionIssues)));
    }, [
        project,
        workflows
    ]);
};

});

parcelRegister("RZsVl", function(module, exports) {

$parcel$export(module.exports, "usePersonalisationActions", () => $c3486dd8f5cb43fa$export$5b1d43353c334c00);
$parcel$export(module.exports, "useCommonEligibilityConditionsForJtbdOnboarding", () => $c3486dd8f5cb43fa$export$c89644b13b6e777f);
$parcel$export(module.exports, "useTailoredOnboardingPersonalisationAttributes", () => $c3486dd8f5cb43fa$export$9aad8798ea46e07f);
$parcel$export(module.exports, "useTailoredOnboardingPersonalisationM2", () => $c3486dd8f5cb43fa$export$5875295cb096b1f2);
$parcel$export(module.exports, "useIsTailoredOnboardingM2ForQuickstartEnabled", () => $c3486dd8f5cb43fa$export$6bc15f8ade1cf36);
$parcel$export(module.exports, "useFireExposureForTailoredOnboardingM2ForQuickstart", () => $c3486dd8f5cb43fa$export$369994803661d31);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $1R3n5 = parcelRequire("1R3n5");

var $WBLbN = parcelRequire("WBLbN");

var $3dMdu = parcelRequire("3dMdu");

var $d4w6a = parcelRequire("d4w6a");

var $2vErl = parcelRequire("2vErl");

var $l1u3T = parcelRequire("l1u3T");
const $c3486dd8f5cb43fa$var$store = (0, $WBLbN.createStore)({
    name: 'jira-onboarding-personalisation',
    initialState: (0, $3dMdu.initialCachedEndpointState),
    actions: $d4w6a.actions
});
const $c3486dd8f5cb43fa$export$5b1d43353c334c00 = (0, $WBLbN.createActionsHook)($c3486dd8f5cb43fa$var$store);
const $c3486dd8f5cb43fa$export$31a443426d101362 = (0, $WBLbN.createHook)($c3486dd8f5cb43fa$var$store);
const $c3486dd8f5cb43fa$export$c89644b13b6e777f = ()=>{
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    return isSiteAdmin && (0, $eI5EY.fg)('jira_tailored_onboarding_jtbd_feature_gate');
};
const $c3486dd8f5cb43fa$export$6f87e1662a24f8b9 = ({ isEligible: isEligible, experienceTypes: experienceTypes, additionalParameters: additionalParameters })=>{
    const [{ fetchedOnce: fetchedOnce, isFetching: isFetching, data: data }, { fetchOnboardingPersonalisation: fetchOnboardingPersonalisation }] = $c3486dd8f5cb43fa$export$31a443426d101362();
    (0, $eUqFw.useEffect)(()=>{
        if (isEligible && !fetchedOnce && !isFetching && data === undefined) fetchOnboardingPersonalisation({
            experienceTypes: experienceTypes,
            additionalParameters: additionalParameters
        });
    }, [
        additionalParameters,
        data,
        experienceTypes,
        fetchOnboardingPersonalisation,
        fetchedOnce,
        isEligible,
        isFetching
    ]);
    if (!isEligible) // If not eligible, no fetching is done. Data is ready to be read
    return {
        data: undefined,
        isReady: true
    };
    return {
        data: data,
        isReady: fetchedOnce && !isFetching
    };
};
const $c3486dd8f5cb43fa$export$9aad8798ea46e07f = ()=>{
    const isEligibleForTailoredOnboardingM2 = $c3486dd8f5cb43fa$export$c89644b13b6e777f();
    const { data: personalisationData, isReady: personalisationDataIsReady } = $c3486dd8f5cb43fa$export$6f87e1662a24f8b9({
        isEligible: isEligibleForTailoredOnboardingM2
    });
    return {
        personalisationDataIsReady: personalisationDataIsReady,
        teamType: personalisationData?.matched.variants.find((variant)=>variant.startsWith('teamType.'))?.replace('teamType.', ''),
        jtbd: personalisationData?.matched.variants.filter((variant)=>variant.startsWith('jtbd.option_')).map((option)=>option.replace('jtbd.option_', '')).join(',')
    };
};
const $c3486dd8f5cb43fa$export$5875295cb096b1f2 = ({ isEligible: isEligible, additionalParameters: additionalParameters })=>{
    const hasSentErrorOnce = (0, $eUqFw.useRef)(false);
    const { data: data, isReady: isReady } = $c3486dd8f5cb43fa$export$6f87e1662a24f8b9({
        isEligible: isEligible,
        experienceTypes: [
            'QUICKSTART',
            'TEMPLATE',
            'LANDING_PAGE'
        ],
        additionalParameters: additionalParameters
    });
    try {
        const conditionalProjectType = `projectType.${additionalParameters?.projectType}`;
        // If projectType is not given as parameter, ignore restriction to match on projectType
        const isMatchingProjectType = Boolean(!additionalParameters?.projectType || data?.matched.variants.some((variant)=>variant === conditionalProjectType));
        const isMatchingTeamType = Boolean(data?.matched.variants.some((variant)=>variant.startsWith('teamType.') && (0, $2vErl.ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            variant.split('.')[1])));
        const isMatchingJtbd = Boolean(data?.matched.variants.some((variant)=>variant.startsWith('jtbd')));
        const matched = Boolean(data && isMatchingJtbd && isMatchingProjectType && isMatchingTeamType);
        return {
            isReady: isReady,
            data: {
                matched: matched,
                matchedVariants: {
                    projectType: isMatchingProjectType,
                    tt: isMatchingTeamType,
                    jtbd: isMatchingJtbd
                },
                QUICKSTART: matched && data ? data.experience.QUICKSTART : [],
                TEMPLATE: matched && data ? data.experience.TEMPLATE?.[0] : undefined,
                LANDING_PAGE: matched && data ? data.experience.LANDING_PAGE?.[0] : undefined
            }
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!hasSentErrorOnce.current) (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'useTailoredOnboardingPersonalisationM2',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        hasSentErrorOnce.current = true;
    }
    return {
        isReady: isReady,
        data: {
            matched: false,
            matchedVariants: {
                jtbd: false,
                tt: false,
                projectType: false
            },
            QUICKSTART: [],
            TEMPLATE: undefined,
            LANDING_PAGE: undefined
        }
    };
};
const $c3486dd8f5cb43fa$export$6bc15f8ade1cf36 = ()=>{
    const isEligibleForJtbdOnboarding = $c3486dd8f5cb43fa$export$c89644b13b6e777f();
    const isEnabled = (0, $l1u3T.isTailoredOnboardingM2ExperimentFlagEnabled)();
    const { isReady: personalisationDataIsReady, data: personalisationData } = $c3486dd8f5cb43fa$export$5875295cb096b1f2({
        isEligible: isEligibleForJtbdOnboarding,
        additionalParameters: {
            projectType: (0, $7ZZxN.CORE_PROJECT)
        }
    });
    return Boolean(personalisationDataIsReady && personalisationData.QUICKSTART && personalisationData.QUICKSTART?.length > 0 && isEnabled);
};
const $c3486dd8f5cb43fa$export$369994803661d31 = ({ projectType: projectType })=>{
    const fgAddExposure = (0, $eI5EY.fg)('tailored_onboarding_m2_content_exposure_adjust');
    const isEligibleForJtbdOnboarding = $c3486dd8f5cb43fa$export$c89644b13b6e777f();
    const { isReady: personalisationDataIsReady, data: personalisationData } = $c3486dd8f5cb43fa$export$5875295cb096b1f2({
        isEligible: isEligibleForJtbdOnboarding && fgAddExposure,
        additionalParameters: {
            projectType: (0, $7ZZxN.CORE_PROJECT)
        }
    });
    if (fgAddExposure && projectType === (0, $7ZZxN.CORE_PROJECT) && personalisationDataIsReady && personalisationData.matched && personalisationData.QUICKSTART && personalisationData.QUICKSTART?.length > 0) (0, $79xbN.expVal)('jira_tailored_onboarding_jtbd', 'isEnabled', false);
};

});
parcelRegister("3dMdu", function(module, exports) {

$parcel$export(module.exports, "initialCachedEndpointState", () => $38ffeb975058cb36$export$aaed2d023c5dc2c);
const $38ffeb975058cb36$export$aaed2d023c5dc2c = {
    isFetching: false,
    wasFetched: false,
    fetchedOnce: false,
    fetchError: null
};

});

parcelRegister("d4w6a", function(module, exports) {

$parcel$export(module.exports, "actions", () => $220ef4c26e2d16b0$export$e324594224ef24da);

var $879e1 = parcelRequire("879e1");

var $5kFcG = parcelRequire("5kFcG");
const $220ef4c26e2d16b0$var$fetchOnboardingPersonalisation = (0, $879e1.cachedEndpointCall)((args)=>(0, $5kFcG.fetchOnboardingPersonalisationWithRethrow)(args));
const $220ef4c26e2d16b0$var$trackPersonalisationAction = ({ additionalParameters: additionalParameters })=>()=>(0, $5kFcG.trackPersonalisation)({
            additionalParameters: additionalParameters
        });
const $220ef4c26e2d16b0$export$e324594224ef24da = {
    fetchOnboardingPersonalisation: $220ef4c26e2d16b0$var$fetchOnboardingPersonalisation,
    trackPersonalisation: $220ef4c26e2d16b0$var$trackPersonalisationAction
};

});
parcelRegister("879e1", function(module, exports) {

$parcel$export(module.exports, "cachedEndpointCall", () => $08a4c99d11c890ab$export$9ab04ab45a9b99da);
const $08a4c99d11c890ab$export$9ab04ab45a9b99da = (call)=>(params)=>async ({ getState: getState, setState: setState })=>{
            const { isFetching: isFetching, wasFetched: wasFetched, fetchedOnce: fetchedOnce } = getState();
            if (isFetching || wasFetched) return;
            setState({
                isFetching: true
            });
            try {
                const data = await call(params);
                if (data !== null) setState({
                    data: data,
                    wasFetched: true
                });
                else setState({
                    wasFetched: fetchedOnce
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    fetchError: error
                });
            } finally{
                setState({
                    isFetching: false,
                    fetchedOnce: true
                });
            }
        };

});

parcelRegister("5kFcG", function(module, exports) {

$parcel$export(module.exports, "fetchOnboardingPersonalisationWithRethrow", () => $3e8409fd087376e0$export$6bc39428b6510a7c);
$parcel$export(module.exports, "trackPersonalisation", () => $3e8409fd087376e0$export$9835c32b78102887);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $gs0Be = parcelRequire("gs0Be");
const $3e8409fd087376e0$var$PERSONALISATION_ENDPOINT = '/rest/personalisation/v1/experience';
const $3e8409fd087376e0$var$TRACK_PERSONALISATION_ENDPOINT = '/rest/personalisation/v1/track';
const $3e8409fd087376e0$var$responseHasAllRequestedExperienceTypes = ({ response: response, requestedExperienceTypes: requestedExperienceTypes })=>requestedExperienceTypes.every((requestedExperienceType)=>response.experience[requestedExperienceType]);
const $3e8409fd087376e0$export$6bc39428b6510a7c = async ({ experienceTypes: experienceTypes = [
    'QUICKSTART',
    'TEMPLATE',
    'LANDING_PAGE'
], additionalParameters: additionalParameters })=>{
    try {
        const localStorageOnboardingPersonalisationResponse = (0, $gs0Be.getLocalStorageOnboardingPersonalisationResponse)();
        if (localStorageOnboardingPersonalisationResponse && $3e8409fd087376e0$var$responseHasAllRequestedExperienceTypes({
            response: localStorageOnboardingPersonalisationResponse,
            requestedExperienceTypes: experienceTypes
        })) return localStorageOnboardingPersonalisationResponse;
        const response = await (0, $lRmyA.performPostRequestWithRetry)($3e8409fd087376e0$var$PERSONALISATION_ENDPOINT, {
            body: JSON.stringify({
                experienceTypes: experienceTypes,
                additionalParameters: additionalParameters
            })
        });
        if (response) {
            const mergedResponse = {
                experience: {
                    ...localStorageOnboardingPersonalisationResponse?.experience,
                    ...response.experience
                },
                matched: response.matched
            };
            (0, $gs0Be.setLocalStorageOnboardingPersonalisationResponse)(mergedResponse);
            return mergedResponse;
        }
        throw new Error('response from OnboardingPersonalisation is falsy');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'fetchOnboardingPersonalisationWithRethrow',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $3e8409fd087376e0$export$9835c32b78102887 = ({ additionalParameters: additionalParameters })=>{
    try {
        (0, $lRmyA.performPostRequestWithRetry)($3e8409fd087376e0$var$TRACK_PERSONALISATION_ENDPOINT, {
            body: JSON.stringify({
                additionalParameters: additionalParameters
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'trackOnboardingPersonalisation',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});
parcelRegister("gs0Be", function(module, exports) {

$parcel$export(module.exports, "getLocalStorageOnboardingPersonalisationResponse", () => $37ad103b17c04430$export$e9fb5b94c03fa495);
$parcel$export(module.exports, "setLocalStorageOnboardingPersonalisationResponse", () => $37ad103b17c04430$export$dda9cd59669fc243);

var $aZaPn = parcelRequire("aZaPn");

var $guiFP = parcelRequire("guiFP");
const $37ad103b17c04430$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE = 'response';
const $37ad103b17c04430$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('jira-onboarding-personalisation');
const $37ad103b17c04430$export$e9fb5b94c03fa495 = ()=>{
    try {
        return $37ad103b17c04430$var$localStorage.get($37ad103b17c04430$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPersonalisation',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return undefined;
    }
};
const $37ad103b17c04430$export$dda9cd59669fc243 = (response)=>{
    try {
        $37ad103b17c04430$var$localStorage.set($37ad103b17c04430$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE, response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPersonalisationResponse',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});



parcelRegister("2vErl", function(module, exports) {

$parcel$export(module.exports, "ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION", () => $e5c071bf4b0b6576$export$1d38dc41bb005254);

var $4MMft = parcelRequire("4MMft");
const $e5c071bf4b0b6576$export$1d38dc41bb005254 = [
    (0, $4MMft.USER_SEGMENTATION_TEAM_TYPE_MARKETING),
    (0, $4MMft.USER_SEGMENTATION_TEAM_TYPE_OPERATIONS)
];

});
parcelRegister("4MMft", function(module, exports) {

$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_MARKETING", () => $bea62c923aa19b28$export$e4824f74b9879164);
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_OPERATIONS", () => $bea62c923aa19b28$export$4f3cb0844009af52);
$parcel$export(module.exports, "userBelongsToBusinessUserSegCategory", () => $bea62c923aa19b28$export$517f94ab07724226);

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");
// Roles defined in user segmentation
const $bea62c923aa19b28$var$USER_SEGMENTATION_ROLE_DESIGNER = 'designer';
const $bea62c923aa19b28$export$572242e58bd07594 = 'customer-service';
const $bea62c923aa19b28$export$d7de553940261eba = 'it-support';
const $bea62c923aa19b28$export$4c29d0d04c15e55d = 'human-resources';
const $bea62c923aa19b28$export$3950f7f841bf94b6 = 'finance';
const $bea62c923aa19b28$export$881249b988b6030f = 'legal';
const $bea62c923aa19b28$export$e4824f74b9879164 = 'marketing';
const $bea62c923aa19b28$export$4f3cb0844009af52 = 'operations';
const $bea62c923aa19b28$export$1a65d50c4a641bb4 = 'sales';
const $bea62c923aa19b28$export$b8b1ac856ba1434b = 'software-development';
// Unique identifier used where all roles in a team type are eligible
const $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE = 'all-roles-eligible';
const $bea62c923aa19b28$export$2f3f9640393bd078 = 'unknown';
const $bea62c923aa19b28$export$4c9a72dac5ce80ae = '';
// @ts-expect-error - It seems to be missing some translations (for all-roles-eligible).
const $bea62c923aa19b28$var$USER_SEGMENTATION_CLIENT_MAPPING = {
    [$bea62c923aa19b28$var$USER_SEGMENTATION_ROLE_DESIGNER]: [
        'Designer',
        'Disainer',
        "Dise\xf1ador",
        'Formgivare',
        "Nh\xe0 thi\u1EBFt k\u1EBF",
        'Projektant',
        'Suunnittelija',
        "Tasar\u0131mc\u0131",
        "Tervez\u0151",
        "\u0414\u0438\u0437\u0430\u0439\u043D\u0435\u0440",
        "\u0E19\u0E31\u0E01\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A",
        "\u30C7\u30B6\u30A4\u30CA\u30FC",
        "\u8A2D\u8A08\u5E2B",
        "\u8BBE\u8BA1\u5E08",
        "\uB514\uC790\uC774\uB108"
    ],
    [$bea62c923aa19b28$export$572242e58bd07594]: [
        'Asiakaspalvelu',
        'Atendimento ao cliente',
        'Customer Service',
        "D\u1ECBch v\u1EE5 kh\xe1ch h\xe0ng",
        'Klantenservice',
        'Klienditeenindus',
        'Kundenservice',
        'Kundeservice',
        'Kundservice',
        "M\xfc\u015Fteri Hizmetleri",
        "Obs\u0142uga klienta",
        "Service \xe0 la client\xe8le",
        "Servicio de atenci\xf3n al cliente",
        'Servizio clienti',
        "Servi\xe7o de apoio ao cliente",
        "Z\xe1kaznick\xfd servis",
        "Z\xe1kazn\xedcky servis",
        "\xdcgyf\xe9lszolg\xe1lati",
        "\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432",
        "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
        "\u30AB\u30B9\u30BF\u30DE\u30FC \u30B5\u30FC\u30D3\u30B9",
        "\u5BA2\u6237\u670D\u52A1",
        "\u9867\u5BA2\u670D\u52D9",
        "\uACE0\uAC1D \uC11C\uBE44\uC2A4"
    ],
    [$bea62c923aa19b28$export$d7de553940261eba]: [
        'Assistenza IT',
        "BT Deste\u011Fi",
        "H\u1ED7 tr\u1EE3 CNTT",
        'IT',
        'IT Support',
        'IT podpora',
        "IT \u30B5\u30DD\u30FC\u30C8",
        "IT \u652F\u6301",
        "IT \u652F\u63F4",
        "IT \uC9C0\uC6D0",
        'IT_Support',
        "IT_st\xf8tte",
        'IT_support',
        'IT_tugi',
        'IT_tuki',
        "Informatikai t\xe1mogat\xe1si",
        'Soporte de TI',
        'Suporte de TI',
        "Support\xa0IT",
        'Wsparcie IT',
        "\u0418\u0422-\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u043E\u0457 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438",
        "\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19 IT"
    ],
    [$bea62c923aa19b28$export$3950f7f841bf94b6]: [
        'Ekonomi',
        'Finance',
        'Financeiro',
        'Financie',
        'Finans',
        'Finanse',
        'Finants',
        'Finanza',
        'Finanzas',
        'Finanzen',
        "Finan\xe7as",
        "P\xe9nz\xfcgyi",
        'Rahoitus',
        "T\xe0i ch\xednh",
        "\xd8konomi",
        "\u0424\u0438\u043D\u0430\u043D\u0441\u044B",
        "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
        "\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19",
        "\u8CA1\u52D9",
        "\u91D1\u878D",
        "\uC7AC\uBB34"
    ],
    [$bea62c923aa19b28$export$4c29d0d04c15e55d]: [
        'HR',
        "Henkil\xf6st\xf6hallinto",
        'Human Resources',
        'Human resources',
        'human-resources',
        "Lidsk\xe9 zdroje",
        'Menneskelige ressourcer',
        "Nh\xe2n s\u1EF1",
        'Personal',
        "Personalfr\xe5gor",
        'RH',
        'Recursos Humanos',
        'Recursos humanos',
        'Risorse umane',
        "Szem\xe9lyzeti",
        'Zasoby ludzkie',
        "\u0130nsan Kaynaklar\u0131",
        "\u013Dudsk\xe9 zdroje",
        "\u0412\u0456\u0434\u0434\u0456\u043B \u043A\u0430\u0434\u0440\u0456\u0432",
        "\u041A\u0430\u0434\u0440\u043E\u0432\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E32\u0E01\u0E23\u0E1A\u0E38\u0E04\u0E04\u0E25",
        "\u4EBA\u4E8B",
        "\u4EBA\u529B\u8CC7\u6E90",
        "\u4EBA\u529B\u8D44\u6E90",
        "\uC778\uC0AC"
    ],
    [$bea62c923aa19b28$export$881249b988b6030f]: [
        "Departamento jur\xeddico",
        'Hukuk',
        'Jogi',
        'Jura',
        'Juridik',
        'Juridisk',
        "Jur\xeddico",
        'Legal',
        'Legale',
        'Oikeudelliset asiat',
        "Ph\xe1p l\xfd",
        'Prawo',
        "Pr\xe1vne oddelenie",
        "Pr\xe1vn\xed odd\u011Blen\xed",
        'Rechtliches',
        'Service juridique',
        "\xd5igus",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22",
        "\u6CD5\u52D9",
        "\u6CD5\u5F8B",
        "\uBC95\uB960"
    ],
    [$bea62c923aa19b28$export$e4824f74b9879164]: [
        "Markedsf\xf8ring",
        'Marketing',
        'Markkinointi',
        "Marknadsf\xf6ring",
        'Pazarlama',
        "Ti\u1EBFp th\u1ECB",
        'Turundus',
        "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433",
        "\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14",
        "\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0",
        "\u8425\u9500",
        "\u884C\u92B7",
        "\uB9C8\uCF00\uD305"
    ],
    [$bea62c923aa19b28$export$4f3cb0844009af52]: [
        'Drift',
        'Haldus',
        'Operacional',
        'Operaciones',
        'Operacje',
        'Operasyonlar',
        'Operations',
        'Operativer Betrieb',
        'Operazioni',
        "Opera\xe7\xf5es",
        "Op\xe9rations",
        "Prev\xe1dzka",
        'Provoz',
        'Toiminnot',
        "V\u1EADn h\xe0nh",
        "\xdczemeltet\xe9si",
        "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E1D\u0E48\u0E32\u0E22\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23",
        "\u30AA\u30DA\u30EC\u30FC\u30B7\u30E7\u30F3",
        "\u71DF\u904B",
        "\u8FD0\u8425",
        "\uC6B4\uC601"
    ],
    [$bea62c923aa19b28$export$1a65d50c4a641bb4]: [
        "B\xe1n h\xe0ng",
        "F\xf6rs\xe4ljning",
        'Myynti',
        "M\xfc\xfck",
        'Predaj',
        'Prodej',
        'Sales',
        'Salg',
        "Sat\u0131\u015F",
        "Sprzeda\u017C",
        'Vendas',
        'Vendite',
        'Ventas',
        'Ventes',
        'Vertrieb',
        "\xc9rt\xe9kes\xedt\xe9si",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0438",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
        "\u0E1D\u0E48\u0E32\u0E22\u0E02\u0E32\u0E22",
        "\u30BB\u30FC\u30EB\u30B9",
        "\u92B7\u552E",
        "\u9500\u552E",
        "\uC601\uC5C5"
    ],
    [$bea62c923aa19b28$export$b8b1ac856ba1434b]: [
        'Desarrollo de software',
        'Desenvolvimento de software',
        "D\xe9veloppement logiciel",
        'Ohjelmistokehitys',
        "Ph\xe1t tri\u1EC3n ph\u1EA7n m\u1EC1m",
        'Programutveckling',
        'Programvareutvikling',
        'Software Development',
        'Softwareentwicklung',
        'Softwareontwikkeling',
        'Softwareudvikling',
        'Sviluppo software',
        "Szoftverfejleszt\u0151",
        'Tarkvaraarendus',
        'Tworzenie oprogramowania',
        "V\xfdvoj softv\xe9ru",
        "V\xfdvoj softwaru",
        "Yaz\u0131l\u0131m Geli\u015Ftirme",
        "\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u041F\u041E",
        "\u0420\u043E\u0437\u0440\u043E\u0431\u043A\u0430 \u041F\u0417",
        "\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C",
        "\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A",
        "\u8EDF\u9AD4\u958B\u767C",
        "\u8F6F\u4EF6\u5F00\u53D1",
        "\uC18C\uD504\uD2B8\uC6E8\uC5B4 \uAC1C\uBC1C"
    ]
};
const $bea62c923aa19b28$var$BUSINESS_TEAM_TYPES = [
    $bea62c923aa19b28$export$4c29d0d04c15e55d,
    $bea62c923aa19b28$export$3950f7f841bf94b6,
    $bea62c923aa19b28$export$881249b988b6030f,
    $bea62c923aa19b28$export$e4824f74b9879164,
    $bea62c923aa19b28$export$4f3cb0844009af52,
    $bea62c923aa19b28$export$1a65d50c4a641bb4,
    $bea62c923aa19b28$export$b8b1ac856ba1434b
];
const $bea62c923aa19b28$var$BUSINESS_ROLES_PER_TEAM_TYPE = {
    [$bea62c923aa19b28$export$4c29d0d04c15e55d]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$export$3950f7f841bf94b6]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$export$881249b988b6030f]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$export$e4824f74b9879164]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$export$4f3cb0844009af52]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$export$1a65d50c4a641bb4]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$export$b8b1ac856ba1434b]: [
        $bea62c923aa19b28$var$USER_SEGMENTATION_ROLE_DESIGNER
    ]
};
const $bea62c923aa19b28$var$getNormalizedEntryNew = (userSegValue)=>{
    const lowerCaseUserSegValue = userSegValue.toLowerCase();
    return Object.entries($bea62c923aa19b28$var$USER_SEGMENTATION_CLIENT_MAPPING).find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, translatedValues])=>translatedValues.map((v)=>v.toLowerCase()).includes(lowerCaseUserSegValue));
};
const $bea62c923aa19b28$var$getNormalizedEntry = (value)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries($bea62c923aa19b28$var$USER_SEGMENTATION_CLIENT_MAPPING).find(([, translatedValues])=>translatedValues.includes(value));
const $bea62c923aa19b28$export$d0bc507f0556398 = (value)=>{
    if (value === '') return $bea62c923aa19b28$export$4c9a72dac5ce80ae;
    const normalizedEntry = (0, $1ybV0.ff)('use-upaas-to-display-template-picker-if-user-seg-is-unknown') ? $bea62c923aa19b28$var$getNormalizedEntryNew(value) : $bea62c923aa19b28$var$getNormalizedEntry(value);
    return normalizedEntry !== undefined ? normalizedEntry[0] : $bea62c923aa19b28$export$2f3f9640393bd078;
};
class $bea62c923aa19b28$var$SkipSentryError extends Error {
    constructor(message){
        super(message);
        this.skipSentry = true;
    }
}
const $bea62c923aa19b28$var$fireAnalyticsError = ({ id: id, field: field, error: error, unMatchedValue: unMatchedValue })=>{
    (0, $guiFP.default)({
        meta: {
            id: id,
            packageName: 'jiraOnboardingCore'
        },
        attributes: {
            field: field,
            unMatchedValue: unMatchedValue
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $bea62c923aa19b28$export$af8a28b856b3556f = (teamType)=>{
    if (!teamType) return false;
    const normalizedTeamType = $bea62c923aa19b28$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'isInSoftwareTeam',
        field: 'teamType',
        error: new $bea62c923aa19b28$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    return normalizedTeamType === $bea62c923aa19b28$export$b8b1ac856ba1434b;
};
const $bea62c923aa19b28$export$517f94ab07724226 = (userAccountData)=>{
    const { teamType: teamType = '', role: role = '' } = userAccountData;
    const normalizedTeamType = $bea62c923aa19b28$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'userBelongsToBusinessUserSegCategory',
        field: 'teamType',
        error: new $bea62c923aa19b28$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    const normalizedRole = $bea62c923aa19b28$export$d0bc507f0556398(role);
    if (normalizedRole === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'userBelongsToBusinessUserSegCategory',
        field: 'role',
        error: new $bea62c923aa19b28$var$SkipSentryError('role mapping is not found'),
        unMatchedValue: role
    });
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'UserSegmentationTeamTypes'.
    const isTeamTypeEligible = $bea62c923aa19b28$var$BUSINESS_TEAM_TYPES.includes(normalizedTeamType);
    const isRoleEligible = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<UserSegmentationTeamTypes, UserSegmentationRoleTypes[]>>'.
    $bea62c923aa19b28$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes($bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE) || // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<UserSegmentationTeamTypes, UserSegmentationRoleTypes[]>>'.
    $bea62c923aa19b28$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes(normalizedRole);
    return isTeamTypeEligible && isRoleEligible;
};
const $bea62c923aa19b28$export$6710e0127706b297 = (userAccountData)=>{
    const { teamType: teamType = '', role: role = '' } = userAccountData;
    const normalizedTeamType = $bea62c923aa19b28$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'userBelongsToSoftwareUserSegCategory',
        field: 'teamType',
        error: new $bea62c923aa19b28$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    const normalizedRole = $bea62c923aa19b28$export$d0bc507f0556398(role);
    if (normalizedRole === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'userBelongsToSoftwareUserSegCategory',
        field: 'role',
        error: new $bea62c923aa19b28$var$SkipSentryError('role mapping is not found'),
        unMatchedValue: role
    });
    const isTeamTypeEligible = normalizedTeamType === $bea62c923aa19b28$export$b8b1ac856ba1434b;
    const isRoleEligible = normalizedRole !== $bea62c923aa19b28$var$USER_SEGMENTATION_ROLE_DESIGNER;
    return isTeamTypeEligible && isRoleEligible;
};

});


parcelRegister("l1u3T", function(module, exports) {

$parcel$export(module.exports, "isTailoredOnboardingM2ExperimentFlagEnabled", () => $e0f085336195173f$export$4f4879e3b4202c87);

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");
const $e0f085336195173f$export$4f4879e3b4202c87 = ()=>{
    const defaultValue = (0, $eI5EY.fg)('tailored_onboarding_m2_content_exposure_adjust') ? undefined : false;
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jira_tailored_onboarding_jtbd');
    return expConfig.get('isEnabled', defaultValue);
};

});


parcelRegister("hb3Di", function(module, exports) {

$parcel$export(module.exports, "ConditionalNudgeWrapper", () => $a40d8b671c4ac5be$export$56d544c4f479b7fb);

var $eUqFw = parcelRequire("eUqFw");
const $a40d8b671c4ac5be$export$56d544c4f479b7fb = ({ children: children, Wrapper: Wrapper, conditionsToApplyWrapper: conditionsToApplyWrapper, ...restProps })=>{
    if (conditionsToApplyWrapper && !false && children !== null && children !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, restProps, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};

});

parcelRegister("a4Bvw", function(module, exports) {

$parcel$export(module.exports, "TailorBoardColumnsAsync", () => $967d7731ab3d49a9$export$e4d6b2cdb1678ee0);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");


var $105cx = parcelRequire("105cx");

var $ii7Kh = parcelRequire("ii7Kh");
const $967d7731ab3d49a9$var$runtimeProps = {};
const $967d7731ab3d49a9$var$entryPointParams = {};
const $967d7731ab3d49a9$export$e4d6b2cdb1678ee0 = ({ children: children })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $ii7Kh.tailorBoardColumnsNudgeEntryPoint), $967d7731ab3d49a9$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const { ref: tailorBoardColumnsNudgeRef } = (0, $105cx.useRegisterNudgeTarget)((0, $99a775c02d636a41$export$6ffa29e74c0304c4), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: tailorBoardColumnsNudgeRef
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: (0, $99a775c02d636a41$export$573d4bf1da6d2bc6),
        packageName: "jiraBoardOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        runtimeProps: $967d7731ab3d49a9$var$runtimeProps
    }));
};

});
const $99a775c02d636a41$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $99a775c02d636a41$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $99a775c02d636a41$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $99a775c02d636a41$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $99a775c02d636a41$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $99a775c02d636a41$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $99a775c02d636a41$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $99a775c02d636a41$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $99a775c02d636a41$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $99a775c02d636a41$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $99a775c02d636a41$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $99a775c02d636a41$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $99a775c02d636a41$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $99a775c02d636a41$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $99a775c02d636a41$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $99a775c02d636a41$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $99a775c02d636a41$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $99a775c02d636a41$export$4d6567e7ee0281bf = 'asyncManageProjectsNudge';
const $99a775c02d636a41$export$f8bf435a6066832c = 'button clicked';
const $99a775c02d636a41$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $99a775c02d636a41$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $99a775c02d636a41$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $99a775c02d636a41$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $99a775c02d636a41$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $99a775c02d636a41$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $99a775c02d636a41$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $99a775c02d636a41$export$5908fa8acd2c0739 = 'filterListNudge';
const $99a775c02d636a41$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $99a775c02d636a41$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $99a775c02d636a41$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $99a775c02d636a41$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $99a775c02d636a41$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $99a775c02d636a41$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $99a775c02d636a41$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $99a775c02d636a41$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $99a775c02d636a41$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $99a775c02d636a41$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $99a775c02d636a41$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $99a775c02d636a41$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $99a775c02d636a41$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $99a775c02d636a41$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $99a775c02d636a41$export$a1be34032ee24f78 = 'shareProjectNudge';
const $99a775c02d636a41$export$29fe6611cc093756 = 'summaryTabNudge';
const $99a775c02d636a41$export$f107c06c0830f09d = 'reportsTabNudge';
const $99a775c02d636a41$export$9749a972a54ad7ba = 'boardContainerNudge';

parcelRegister("105cx", function(module, exports) {

$parcel$export(module.exports, "useRegisterNudgeTarget", () => $4897a924f3a2c5b3$export$eb8a96124d659f2d);
$parcel$export(module.exports, "PortalledNudge", () => $4897a924f3a2c5b3$export$74f8d45d75dfda4f);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $hww7R = parcelRequire("hww7R");
/**
 * This class tracks nudge target HTML DOM elements by ID.
 * It also tracks subscribers to updates of these elements.
 */ class $4897a924f3a2c5b3$var$NudgeController {
    static{
        /**
	 * Singleton instance of this class.
	 * Alternatively multiple instances would be created and passed through context.
	 */ this.instance = new $4897a924f3a2c5b3$var$NudgeController();
    }
    /**
	 * Register the HTML DOM node for an ID
	 */ registerNudgeTarget(id, ref) {
        this.nudgeTargetsMap.set(id, ref);
        this.notifySubscribers(id);
        // Return a cleanup function that will remove this ID from the map
        return ()=>{
            this.nudgeTargetsMap.delete(id);
        };
    }
    /**
	 * Subscribe to updates to a certain DOM node
	 */ subscribe(id, callback) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.push(callback);
        this.subscribers.set(id, subscribers);
        // Return a cleanup function that will remove this callback from the list of subscribers
        return ()=>{
            const subscribersOnCleanup = this.subscribers.get(id) ?? [];
            this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
        };
    }
    /**
	 * Notify subscribers that the HTML DOM node for an ID has been updated.
	 */ notifySubscribers(id) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.forEach((subscriber)=>{
            subscriber();
        });
    }
    constructor(){
        this.nudgeTargetsMap = new Map();
        this.subscribers = new Map();
    }
}
/**
 * Return the singleton controller
 */ const $4897a924f3a2c5b3$var$useNudgeController = ()=>$4897a924f3a2c5b3$var$NudgeController.instance;
const $4897a924f3a2c5b3$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (shouldRegister) {
            const unregister = controller.registerNudgeTarget(id, ref);
            return ()=>{
                unregister();
            };
        }
    }, [
        controller,
        id,
        shouldRegister
    ]);
    return {
        ref: ref
    };
};
/**
 * Creates a subscription into this component, that will return a boolean stating if
 * the HTML DOM node is associated with a given target ID.
 */ const $4897a924f3a2c5b3$var$useHasNudgeTargetNode = (id)=>{
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const [hasRefValue, setHasRefValue] = (0, $eUqFw.useState)(!!controller.nudgeTargetsMap.get(id)?.current);
    (0, $eUqFw.useLayoutEffect)(()=>{
        setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        const unsubscribe = controller.subscribe(id, ()=>{
            setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        controller,
        id
    ]);
    return hasRefValue;
};
/**
 * When the nudge is shown, get and track the rectangle of the target element.
 */ const $4897a924f3a2c5b3$var$useNudgeRectangle = (isShown, id, nudgeContainer)=>{
    const [innerRectangle, setInnerRectangle] = (0, $eUqFw.useState)(null);
    const frameId = (0, $eUqFw.useRef)(null);
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const nudgeTarget = controller.nudgeTargetsMap.get(id)?.current;
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!isShown || !nudgeTarget || !nudgeContainer.current) {
            // Reset rectangle to eliminate risk of Spotlight rendering at
            // old position when nudge is e.g. hidden then shown in a different place.
            if (innerRectangle !== null) setInnerRectangle(null);
            return undefined;
        }
        // This is one approach to tracking the elements moving. See https://hello.atlassian.net/wiki/spaces/JST/pages/1759637849/Rendering+performance+Async+component+wrappers
        // for other options.
        const loop = ()=>{
            const targetRectangle = controller.nudgeTargetsMap.get(id)?.current?.getBoundingClientRect();
            if (!targetRectangle) return undefined;
            const newRectangle = {
                top: targetRectangle.top,
                left: targetRectangle.left,
                width: targetRectangle.width,
                height: targetRectangle.height
            };
            if (innerRectangle == null || innerRectangle.top !== newRectangle.top || innerRectangle.left !== newRectangle.left || innerRectangle.width !== newRectangle.width || innerRectangle.height !== newRectangle.height) setInnerRectangle(newRectangle);
            else frameId.current = requestAnimationFrame(loop);
        };
        frameId.current = requestAnimationFrame(loop);
        return ()=>{
            if (frameId.current != null) cancelAnimationFrame(frameId.current);
        };
    }, [
        isShown,
        nudgeContainer,
        innerRectangle,
        nudgeTarget,
        controller.nudgeTargetsMap,
        id
    ]);
    return innerRectangle;
};
/**
 * Create and append a DOM node to use for the nudge. This is on a separate root to the rest of the app.
 */ const $4897a924f3a2c5b3$var$usePortalContainer = ()=>{
    const nudgeContainer = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!nudgeContainer.current) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            nudgeContainer.current = document.createElement('div');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body.appendChild(nudgeContainer.current);
        }
        return ()=>{
            if (nudgeContainer.current) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body.removeChild(nudgeContainer.current);
        };
    }, []);
    return nudgeContainer;
};
const $4897a924f3a2c5b3$export$74f8d45d75dfda4f = (props)=>{
    const nudgeContainer = $4897a924f3a2c5b3$var$usePortalContainer();
    const hasRefValue = $4897a924f3a2c5b3$var$useHasNudgeTargetNode(props.nudgeTargetId);
    const innerRectangle = $4897a924f3a2c5b3$var$useNudgeRectangle(!props.hidden, props.nudgeTargetId, nudgeContainer);
    const innerRectanglePrevious = (0, $eUqFw.useRef)(innerRectangle);
    const spotlightRef = (0, $eUqFw.useRef)(null);
    // Force update the Popper spotlight when the innerRectangle (nudge position) changes
    (0, $eUqFw.useEffect)(()=>{
        if (innerRectangle !== null && innerRectanglePrevious.current !== innerRectangle && spotlightRef.current !== null) {
            innerRectanglePrevious.current = innerRectangle;
            if (spotlightRef.current.forceUpdateCardPosition) spotlightRef.current.forceUpdateCardPosition();
        }
    }, [
        innerRectangle
    ]);
    const hasNudgeTarget = hasRefValue;
    if (!nudgeContainer.current || !hasNudgeTarget || !innerRectangle) return null;
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'fixed',
            top: innerRectangle.top,
            left: innerRectangle.left,
            height: innerRectangle.height,
            width: innerRectangle.width,
            zIndex: props.zIndex
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hww7R.NudgeSpotlight), {
        ...props,
        ref: spotlightRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            height: innerRectangle.height,
            width: innerRectangle.width
        }
    }))), nudgeContainer.current);
};

});

parcelRegister("ii7Kh", function(module, exports) {

$parcel$export(module.exports, "tailorBoardColumnsNudgeEntryPoint", () => $9c37f234eaa9d26c$export$13278346f7fe314b);

var $14fpI = parcelRequire("14fpI");

var $4dIH4 = parcelRequire("4dIH4");

const $9c37f234eaa9d26c$export$13278346f7fe314b = (0, $4dIH4.createEntryPoint)({
    root: (0, $14fpI.JSResourceForInteraction)(()=>(parcelRequire("jtzQo")), {
        moduleId: "d4273c47"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jtzQo", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("glcPs").then(()=>parcelRequire('KJQB0'));

});



parcelRegister("jlfkT", function(module, exports) {

$parcel$export(module.exports, "useActiveWorkflow", () => $b679edd3fbf5788d$export$51debb5f83907415);

var $eUqFw = parcelRequire("eUqFw");

var $lEWmB = parcelRequire("lEWmB");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $bFk6h = parcelRequire("bFk6h");
const $b679edd3fbf5788d$export$51debb5f83907415 = ()=>{
    const [activeWorkflowId, setActiveWorkflowId] = (0, $7c3W1.useViewPreference)((0, $ji3xf.ACTIVE_WORKFLOW_PREFERENCE));
    const { reset: reset } = (0, $bFk6h.useBoardData)();
    const { setFilter: setFilter } = (0, $lEWmB.useFilters)();
    const setActiveWorkflow = (0, $eUqFw.useCallback)((newWorkflowId)=>{
        setActiveWorkflowId(newWorkflowId);
        // Reset filters and board data when switching to a different workflow
        setFilter({});
        reset();
    }, [
        setActiveWorkflowId,
        setFilter,
        reset
    ]);
    return [
        activeWorkflowId,
        setActiveWorkflow
    ];
};

});

parcelRegister("2sU4b", function(module, exports) {

$parcel$export(module.exports, "useDraggableColumn", () => $07b00af135b13bd2$export$a2d73877a5476992);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $2cKws = parcelRequire("2cKws");

var $awlt9 = parcelRequire("awlt9");

var $ibIV3 = parcelRequire("ibIV3");
parcelRequire("93Ys7");
var $98AB6 = parcelRequire("98AB6");
parcelRequire("lWeOS");
var $b0ziO = parcelRequire("b0ziO");

var $ib4WI = parcelRequire("ib4WI");

var $gWYTK = parcelRequire("gWYTK");

var $bJNjm = parcelRequire("bJNjm");

var $gMJE7 = parcelRequire("gMJE7");
const $07b00af135b13bd2$export$a2d73877a5476992 = ({ columnDropTargetRef: columnDropTargetRef, columnHandleRef: columnHandleRef, group: group, index: index })=>{
    const { cleanupDragPreview: cleanupDragPreview, dragPreviewState: dragPreviewState, isDragging: isDraggingColumn, renderDragPreview: renderDragPreview, resetDraggedColumn: resetDraggedColumn, startColumnDrag: startColumnDrag } = (0, $bJNjm.useColumnDragDrop)(group.id);
    const [closestEdge, setClosestEdge] = (0, $eUqFw.useState)(null);
    const [isCardOverColumn, setIsCardOverColumn] = (0, $eUqFw.useState)(false);
    const updateDropTarget = (0, $gWYTK.useUpdateDropTarget)();
    const resetDropTarget = (0, $gWYTK.useResetDropTarget)();
    const { canDropInGroup: canDropInGroup } = (0, $gWYTK.useCanDropCard)(group);
    const inferredDropTargetTransition = (0, $gWYTK.useInferredDropTargetTransition)(group);
    (0, $eUqFw.useEffect)(()=>{
        const handleDrag = ({ source: { data: data }, self: self })=>{
            const destinationData = self.data;
            if (!(0, $gMJE7.isColumn)(destinationData)) return;
            if ((0, $gMJE7.isColumn)(data) && data.columnId !== group.id) {
                const extractedClosestEdge = (0, $2cKws.extractClosestEdge)(self.data);
                setClosestEdge((0, $gMJE7.isClosestEdgeAdjacentToSource)(data.index, destinationData.index, extractedClosestEdge) ? null : extractedClosestEdge);
                return;
            }
            if ((0, $gMJE7.isCard)(data) && ((0, $gMJE7.isColumn)(destinationData) || (0, $gMJE7.isCard)(destinationData))) {
                setIsCardOverColumn(true);
                if (inferredDropTargetTransition != null) updateDropTarget({
                    transition: inferredDropTargetTransition
                });
            }
        };
        return (0, $awlt9.combine)(columnHandleRef.current != null ? (0, $ibIV3.draggable)({
            element: columnHandleRef.current,
            getInitialData: ()=>({
                    type: (0, $ib4WI.COLUMN_DND_TYPE),
                    columnId: group.id,
                    index: index
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage, location: location, source: source })=>{
                (0, $b0ziO.setCustomNativeDragPreview)({
                    getOffset: (0, $98AB6.preserveOffsetOnSource)({
                        element: source.element,
                        input: location.current.input
                    }),
                    render ({ container: container }) {
                        renderDragPreview(container);
                        return ()=>{
                            cleanupDragPreview();
                        };
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: startColumnDrag,
            onDrop: resetDraggedColumn
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), columnDropTargetRef.current != null ? (0, $ibIV3.dropTargetForElements)({
            element: columnDropTargetRef.current,
            canDrop: ({ source: source })=>(0, $gMJE7.isColumn)(source.data) || (0, $gMJE7.isCard)(source.data) && canDropInGroup === 'yes',
            getIsSticky: ({ source: source })=>(0, $gMJE7.isColumn)(source.data),
            getData: ({ input: input, element: element })=>{
                const data = {
                    type: (0, $ib4WI.COLUMN_DND_TYPE),
                    columnId: group.id,
                    index: index
                };
                return (0, $2cKws.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'left',
                        'right'
                    ]
                });
            },
            onDragEnter: handleDrag,
            onDrag: handleDrag,
            onDragLeave: ({ source: { data: data } })=>{
                if ((0, $gMJE7.isCard)(data)) {
                    resetDropTarget();
                    setIsCardOverColumn(false);
                    return;
                }
                setClosestEdge(null);
            },
            onDrop: ({ source: { data: data } })=>{
                if ((0, $gMJE7.isCard)(data)) {
                    setIsCardOverColumn(false);
                    return;
                }
                if ((0, $gMJE7.isColumn)(data)) setClosestEdge(null);
            }
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))));
    }, [
        canDropInGroup,
        columnDropTargetRef,
        columnHandleRef,
        group,
        index,
        inferredDropTargetTransition,
        resetDropTarget,
        updateDropTarget,
        startColumnDrag,
        renderDragPreview,
        cleanupDragPreview,
        resetDraggedColumn
    ]);
    return {
        canDropInGroup: canDropInGroup,
        closestEdge: closestEdge,
        dragPreviewState: dragPreviewState,
        isCardOverColumn: isCardOverColumn,
        isDraggingColumn: isDraggingColumn
    };
};

});
parcelRegister("93Ys7", function(module, exports) {

$parcel$export(module.exports, "preserveOffsetOnSource", () => (parcelRequire("98AB6")).preserveOffsetOnSource);

var $98AB6 = parcelRequire("98AB6");

});
parcelRegister("98AB6", function(module, exports) {

$parcel$export(module.exports, "preserveOffsetOnSource", () => $5ebdd44c1b209788$export$8830e7ac6eee750e);
function $5ebdd44c1b209788$export$8830e7ac6eee750e({ element: element, input: input }) {
    return ({ container: container })=>{
        const sourceRect = element.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const offsetX = Math.min(// difference
        input.clientX - sourceRect.x, // don't let the difference be more than the width of the container,
        // otherwise the pointer will be off the preview
        containerRect.width);
        const offsetY = Math.min(// difference
        input.clientY - sourceRect.y, // don't let the difference be more than the height of the container,
        // otherwise the pointer will be off the preview
        containerRect.height);
        return {
            x: offsetX,
            y: offsetY
        };
    };
}

});


parcelRegister("lWeOS", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("b0ziO")).setCustomNativeDragPreview);

var $b0ziO = parcelRequire("b0ziO");

});
parcelRegister("b0ziO", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => $76b34968f740d014$export$52d889c66db0f96e);

var $hL3ZB = parcelRequire("hL3ZB");

var $iMM6a = parcelRequire("iMM6a");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $76b34968f740d014$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $76b34968f740d014$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $76b34968f740d014$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $f25f5b529de6bce0$export$7d0a15ee70427305),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $iMM6a.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $hL3ZB.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $f25f5b529de6bce0$export$7d0a15ee70427305 = 2147483647;




parcelRegister("eMXBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0da123ed4df02977$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lEfVV = parcelRequire("lEfVV");

var $4TJj0 = parcelRequire("4TJj0");


var $i0nxo = parcelRequire("i0nxo");

var $j8Htg = parcelRequire("j8Htg");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $d3C6e = parcelRequire("d3C6e");

var $hYeSy = parcelRequire("hYeSy");

var $zcJ0y = parcelRequire("zcJ0y");

var $eI5EY = parcelRequire("eI5EY");

var $kgzZq = parcelRequire("kgzZq");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $dWLk9 = parcelRequire("dWLk9");

var $cMvqb = parcelRequire("cMvqb");

var $ib4WI = parcelRequire("ib4WI");

var $gAOAU = parcelRequire("gAOAU");

var $gWYTK = parcelRequire("gWYTK");

var $74CPP = parcelRequire("74CPP");

var $2b5eO = parcelRequire("2b5eO");

var $bZapc = parcelRequire("bZapc");

var $f7G96 = parcelRequire("f7G96");

var $a8jG7 = parcelRequire("a8jG7");

var $cnz22 = parcelRequire("cnz22");

var $10ATT = parcelRequire("10ATT");

var $5Glvh = parcelRequire("5Glvh");

var $b5A1R = parcelRequire("b5A1R");

var $3wfag = parcelRequire("3wfag");
const $0da123ed4df02977$var$isSafariBrowser = (0, $zcJ0y.isSafari)();
const $0da123ed4df02977$var$useDropHighlight = (issueId)=>{
    const { highlightedIssueId: highlightedIssueId, resetHighlightedIssue: resetHighlightedIssue } = (0, $gWYTK.useHighlightedIssue)();
    const isDropHighlighted = highlightedIssueId === issueId;
    (0, $eUqFw.useEffect)(()=>{
        if (isDropHighlighted) {
            /*
       * We need to reset the highlighted issue after a short delay to ensure the card has enough time to move
       * to the correct position after a successful drop.
       */ const timeoutId = setTimeout(()=>{
                resetHighlightedIssue();
            }, 100);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
    }, [
        isDropHighlighted,
        resetHighlightedIssue
    ]);
    return isDropHighlighted;
};
const $0da123ed4df02977$export$60332b2344f7fe41 = /*#__PURE__*/ (0, $eUqFw.memo)(({ canCreateIssues: canCreateIssues, group: group, draggableIndex: draggableIndex, highlight: highlight, isSiblingCreateFormOpen: isSiblingCreateFormOpen, issue: issue, toggleSiblingCreateForm: toggleSiblingCreateForm, selections: selections, onCardDragChange: onCardDragChange })=>{
    const issueKey = issue.fields[0, $ib4WI.ISSUE_KEY_ID].value;
    const { issueViewInteraction: issueViewInteraction } = (0, $2b5eO.useJWMBoardFeatures)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const shouldUseEmbedIssueClick = issueViewInteraction === 'openNewTab';
    const getIsHighlighted = (0, $d3C6e.useIsHighlighted)();
    const isHighlighted = getIsHighlighted(issue.id);
    const { footerContent: footerContent, footerPlaceholder: footerPlaceholder } = (0, $b5A1R.useCardFooter)(issue);
    const isDropHighlighted = $0da123ed4df02977$var$useDropHighlight(issue.id);
    const cloudId = (0, $dWLk9.useCloudId)();
    const isCardCoversChangeboardingEnabled = (0, $eI5EY.fg)('jwm_card_covers_changeboarding');
    const { fetchTraits: fetchTraits } = (0, $cMvqb.useTraitsActions)();
    const ref = (0, $eUqFw.useRef)(null);
    const { draggedIssue: draggedIssue } = (0, $gWYTK.useCardDragDrop)();
    const { dragState: dragState } = (0, $74CPP.useDraggableCard)({
        ref: ref,
        issue: issue,
        cardIndex: draggableIndex,
        group: group,
        onCardDragChange: onCardDragChange
    });
    const isDragging = draggedIssue?.id === issue.id;
    const onEmbedIssueOpen = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issue clicked', 'boardEmbedIssue');
        (0, $j8Htg.openViewFromEmbed)({
            key: (0, $jGcn0.SELECTED_ISSUE_PARAM),
            value: issueKey
        });
    }, [
        createAnalyticsEvent,
        issueKey
    ]);
    const onIssueClick = (0, $f7G96.useViewIssue)();
    const clickHandler = (0, $eUqFw.useCallback)((e)=>{
        onIssueClick(issue, e.ctrlKey || e.metaKey);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issue clicked', 'boardIssue');
    }, [
        onIssueClick,
        issue,
        createAnalyticsEvent
    ]);
    const issueKeyClickHandler = (0, $eUqFw.useCallback)(()=>{
        onIssueClick(issue, false);
    }, [
        onIssueClick,
        issue
    ]);
    const { prefetchIssue: prefetchIssue } = (0, $hYeSy.usePrefetchIssueViewDataActions)();
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>{
        prefetchIssue(issueKey);
        if (isCardCoversChangeboardingEnabled) fetchTraits([
            'SITE_USER'
        ], {
            cloudId: cloudId
        });
    }, [
        cloudId,
        fetchTraits,
        isCardCoversChangeboardingEnabled,
        issueKey,
        prefetchIssue
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter' && event.target === event.currentTarget) shouldUseEmbedIssueClick ? onEmbedIssueOpen() : onIssueClick(issue, false);
    }, [
        onIssueClick,
        issue,
        onEmbedIssueOpen,
        shouldUseEmbedIssueClick
    ]);
    const cardContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0da123ed4df02977$var$CardSummaryWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kgzZq.CardSummary), {
        text: issue.fields[0, $ib4WI.SUMMARY_ID].value,
        shouldMenuRender: true,
        highlight: highlight
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $10ATT.CardContent), {
        highlight: highlight,
        issue: issue,
        onIssueKeyClick: shouldUseEmbedIssueClick ? onEmbedIssueOpen : issueKeyClickHandler
    }));
    const cardContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0da123ed4df02977$var$CardContentContainer, {
        onClick: shouldUseEmbedIssueClick ? onEmbedIssueOpen : clickHandler,
        onKeyDown: handleKeyDown,
        onMouseEnter: onMouseEnter,
        "data-testid": "work-management-board.ui.board.column.card.container"
    }, cardContent, footerPlaceholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, canCreateIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3wfag.default), {
        group: group,
        isTopMost: draggableIndex === 0,
        isSiblingCreateFormOpen: isSiblingCreateFormOpen,
        issue: issue,
        toggleSiblingCreateForm: toggleSiblingCreateForm
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0da123ed4df02977$var$CardContainer, {
        ref: ref,
        isDragging: isDragging,
        "data-testid": "work-management-board.ui.board.column.card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gAOAU.CardCoverEditingContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0da123ed4df02977$var$CardContentContainer, {
        onKeyDown: handleKeyDown,
        onMouseEnter: onMouseEnter,
        onClick: shouldUseEmbedIssueClick ? onEmbedIssueOpen : clickHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0da123ed4df02977$var$CardCoverWrapper, {
        coverMedia: issue.coverMedia
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0da123ed4df02977$var$RelativeMainContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0da123ed4df02977$var$HighlightContainer, {
        isDraggingAllowed: !(0, $d3C6e.isOptimisticIssue)(issue.id),
        isHighlighted: isHighlighted || isDropHighlighted
    }, selections ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cnz22.CardBadge), {
        selections: selections,
        position: draggableIndex === 0 ? (0, $18eb89570dd03c8c$export$86bcdda8e7a22b9d) : (0, $18eb89570dd03c8c$export$a3a66eb204e551b3)
    }, cardContainer) : cardContainer), footerContent, !(0, $d3C6e.isOptimisticIssue)(issue.id) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8jG7.default), {
        issue: issue
    })))), dragState.type === 'preview' ? /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0da123ed4df02977$export$6bb2a69551ff8f5b, {
        isTilted: !$0da123ed4df02977$var$isSafariBrowser
    }, cardContent), dragState.container) : null);
});
const $0da123ed4df02977$var$CardCoverWrapper = /*#__PURE__*/ (0, $eUqFw.memo)(({ coverMedia: coverMedia })=>{
    const selectedFields = (0, $bZapc.useSelectedFields)();
    const showCardCovers = selectedFields[0, $jGcn0.CARD_COVERS_TYPE];
    return showCardCovers && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Glvh.CardCover), {
        coverMedia: coverMedia
    });
});
const $0da123ed4df02977$var$CardWithSelection = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const projectData = (0, $kQAZu.useProject)();
    const projectId = String(projectData.id);
    const nodeId = (0, $i0nxo.getPresenceNodeId)({
        projectId: projectId,
        viewId: 'board',
        nodeId: `${props.issue.id}`
    });
    const [{ nodeSelection: nodeSelection }] = (0, $4TJj0.useCollabStore)();
    const selections = nodeSelection[nodeId];
    // card could have multiple selections from different users
    const cardSelections = Array.isArray(selections) && selections.length ? selections : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0da123ed4df02977$export$60332b2344f7fe41, {
        ...props,
        selections: cardSelections
    });
});
var $0da123ed4df02977$export$2e2bcd8739ae039 = $0da123ed4df02977$var$CardWithSelection;
const $0da123ed4df02977$var$MAX_CARD_WIDTH = 270;
const $0da123ed4df02977$var$ACTION_MENU_BUTTON_SIZE = 32;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0da123ed4df02977$var$CardContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1ogy _uiztglyw _vchhusvi _kqswh2mm _2rko1sit _16qs1os1 _bfhkhp5a _syaz1fxt _v5641hrg _irr3xwku _dwwu1txw _1mkw1txw",
            __cmplp.isDragging ? "_tzy42wxo" : "_tzy4kb7n",
            __cmplp.isDragging ? "_d0al5szm" : "_d0altlke",
            __cmplp.className
        ])
    });
});
const $0da123ed4df02977$var$RelativeMainContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $0da123ed4df02977$export$6bb2a69551ff8f5b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTilted: isTilted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ogy _vchhusvi _kqswh2mm _2rko1sit _bfhkhp5a",
            __cmplp.isTilted ? "_139ek9zm" : "_139e1i1e",
            __cmplp.className
        ])
    });
});
const $0da123ed4df02977$var$CardContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $0da123ed4df02977$var$CardSummaryWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4utpp _1e0c1txw _1tkezwfg",
            __cmplp.className
        ])
    });
});
const $0da123ed4df02977$var$HighlightContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDraggingAllowed: isDraggingAllowed, isHighlighted: isHighlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk18uv _v56417iv",
            __cmplp.isDraggingAllowed ? "_80om1kw7" : "_80om13gf",
            __cmplp.isHighlighted && "_bfhk1cey _v564glyw",
            __cmplp.className
        ])
    });
});

});
const $18eb89570dd03c8c$export$86bcdda8e7a22b9d = 'inner';
const $18eb89570dd03c8c$export$a3a66eb204e551b3 = 'outer';

parcelRegister("j8Htg", function(module, exports) {

$parcel$export(module.exports, "openViewFromEmbed", () => $3314031ff4af418d$export$a29603f2eb9b6da6);
const $3314031ff4af418d$export$a29603f2eb9b6da6 = (param)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const cleanUrl = window.location.href.replace('/embed', '');
    const currentUrl = new URL(cleanUrl);
    if (param != null) currentUrl.searchParams.append(param.key, param.value);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.open(currentUrl.href, '_blank');
};

});

parcelRegister("kgzZq", function(module, exports) {

$parcel$export(module.exports, "CardSummary", () => $56a5f1bee0255f5b$export$f2e6e773bb9ca12a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jl1we = parcelRequire("jl1we");

var $ggLw8 = parcelRequire("ggLw8");

var $f5DAf = parcelRequire("f5DAf");
const $56a5f1bee0255f5b$export$f2e6e773bb9ca12a = ({ text: text, highlight: highlight, shouldMenuRender: shouldMenuRender, shouldTruncate: shouldTruncate = false })=>{
    const HighlightedText = highlight && (0, $f5DAf.shouldHighlightText)(text, highlight) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f5DAf.HighlightText), {
        phrases: highlight,
        content: text
    }) : text;
    const summary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($56a5f1bee0255f5b$var$Summary, {
        shouldMenuRender: shouldMenuRender || false,
        shouldTruncate: shouldTruncate,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $ggLw8.summary
    }, HighlightedText);
    if (!shouldTruncate) return summary;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: text,
        position: "bottom"
    }, summary);
};
$56a5f1bee0255f5b$export$f2e6e773bb9ca12a.defaultProps = {
    shouldMenuRender: false,
    highlight: []
};
var $56a5f1bee0255f5b$export$2e2bcd8739ae039 = $56a5f1bee0255f5b$export$f2e6e773bb9ca12a;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $56a5f1bee0255f5b$var$Summary = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldMenuRender: shouldMenuRender, shouldTruncate: shouldTruncate, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_slp31hna _1i4q1hna _1nmz1hna",
            __cmplp.shouldMenuRender ? "_u5f3xy5q" : "_u5f3ze3t",
            __cmplp.shouldTruncate ? "_1yyj11wp" : "_1yyjn7od",
            __cmplp.shouldTruncate ? "_1e0ccj1k" : "_1e0c1nu9",
            __cmplp.shouldTruncate ? "_1reo15vq _18m915vq" : "_1reon7od _18m9n7od",
            __cmplp.shouldTruncate ? "_sudp1e54" : "_sudpn7od",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ggLw8", function(module, exports) {

$parcel$export(module.exports, "avatarContainer", () => $bd82ffe601216fab$export$4ea799498ef4a755, (v) => $bd82ffe601216fab$export$4ea799498ef4a755 = v);
$parcel$export(module.exports, "card-content-container", () => $bd82ffe601216fab$export$b097e1489ce64e3a, (v) => $bd82ffe601216fab$export$b097e1489ce64e3a = v);
$parcel$export(module.exports, "cardColorInner", () => $bd82ffe601216fab$export$e2907b219480f02f, (v) => $bd82ffe601216fab$export$e2907b219480f02f = v);
$parcel$export(module.exports, "cmpAvatar", () => $bd82ffe601216fab$export$114c94adbfe142fc, (v) => $bd82ffe601216fab$export$114c94adbfe142fc = v);
$parcel$export(module.exports, "content", () => $bd82ffe601216fab$export$a7db06668cad9adb, (v) => $bd82ffe601216fab$export$a7db06668cad9adb = v);
$parcel$export(module.exports, "customCardFieldList", () => $bd82ffe601216fab$export$8b6db2f2076ae2a6, (v) => $bd82ffe601216fab$export$8b6db2f2076ae2a6 = v);
$parcel$export(module.exports, "footer", () => $bd82ffe601216fab$export$adb608be33961c98, (v) => $bd82ffe601216fab$export$adb608be33961c98 = v);
$parcel$export(module.exports, "footerChildSection", () => $bd82ffe601216fab$export$1907b6af328e1b13, (v) => $bd82ffe601216fab$export$1907b6af328e1b13 = v);
$parcel$export(module.exports, "iconsPlaceHolder", () => $bd82ffe601216fab$export$3f4216a049dd4cce, (v) => $bd82ffe601216fab$export$3f4216a049dd4cce = v);
$parcel$export(module.exports, "primary", () => $bd82ffe601216fab$export$9ad721cf3b3debe0, (v) => $bd82ffe601216fab$export$9ad721cf3b3debe0 = v);
$parcel$export(module.exports, "secondary", () => $bd82ffe601216fab$export$745c6f71a1e0e6f7, (v) => $bd82ffe601216fab$export$745c6f71a1e0e6f7 = v);
$parcel$export(module.exports, "summary", () => $bd82ffe601216fab$export$9a2dbef7a17e2e58, (v) => $bd82ffe601216fab$export$9a2dbef7a17e2e58 = v);
$parcel$export(module.exports, "tertiary", () => $bd82ffe601216fab$export$5668677bb0c0ed27, (v) => $bd82ffe601216fab$export$5668677bb0c0ed27 = v);
var $bd82ffe601216fab$export$4ea799498ef4a755;
var $bd82ffe601216fab$export$b097e1489ce64e3a;
var $bd82ffe601216fab$export$e2907b219480f02f;
var $bd82ffe601216fab$export$114c94adbfe142fc;
var $bd82ffe601216fab$export$a7db06668cad9adb;
var $bd82ffe601216fab$export$8b6db2f2076ae2a6;
var $bd82ffe601216fab$export$adb608be33961c98;
var $bd82ffe601216fab$export$1907b6af328e1b13;
var $bd82ffe601216fab$export$3f4216a049dd4cce;
var $bd82ffe601216fab$export$9ad721cf3b3debe0;
var $bd82ffe601216fab$export$745c6f71a1e0e6f7;
var $bd82ffe601216fab$export$9a2dbef7a17e2e58;
var $bd82ffe601216fab$export$5668677bb0c0ed27;
$bd82ffe601216fab$export$4ea799498ef4a755 = `yse7za_avatarContainer`;
$bd82ffe601216fab$export$b097e1489ce64e3a = `yse7za_card-content-container`;
$bd82ffe601216fab$export$e2907b219480f02f = `yse7za_cardColorInner`;
$bd82ffe601216fab$export$114c94adbfe142fc = `yse7za_cmpAvatar`;
$bd82ffe601216fab$export$a7db06668cad9adb = `yse7za_content`;
$bd82ffe601216fab$export$8b6db2f2076ae2a6 = `yse7za_customCardFieldList`;
$bd82ffe601216fab$export$adb608be33961c98 = `yse7za_footer`;
$bd82ffe601216fab$export$1907b6af328e1b13 = `yse7za_footerChildSection`;
$bd82ffe601216fab$export$3f4216a049dd4cce = `yse7za_iconsPlaceHolder`;
$bd82ffe601216fab$export$9ad721cf3b3debe0 = `yse7za_primary`;
$bd82ffe601216fab$export$745c6f71a1e0e6f7 = `yse7za_secondary`;
$bd82ffe601216fab$export$9a2dbef7a17e2e58 = `yse7za_summary`;
$bd82ffe601216fab$export$5668677bb0c0ed27 = `yse7za_tertiary`;

});

parcelRegister("f5DAf", function(module, exports) {

$parcel$export(module.exports, "shouldHighlightText", () => $b0abd9ab06e06245$export$dceb4ab0bd0273b3);
$parcel$export(module.exports, "HighlightText", () => $b0abd9ab06e06245$export$bb02e7bc6e1a7119);

var $eUqFw = parcelRequire("eUqFw");

var $gttjd = parcelRequire("gttjd");

var $e63D2 = parcelRequire("e63D2");
const $b0abd9ab06e06245$export$dceb4ab0bd0273b3 = (text = '', keywords = [])=>text && text.length > 0 && keywords.filter((keyword)=>keyword !== '').length > 0 && keywords.some((keyword)=>(0, $gttjd.removeAccents)(text).toLowerCase().includes(keyword.toLowerCase()) || text.toLowerCase().includes(keyword.toLowerCase()));
const $b0abd9ab06e06245$export$bb02e7bc6e1a7119 = ({ content: content, phrases: phrases })=>{
    if (!phrases || !phrases.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e63D2.default), {
        highlight: phrases,
        text: content
    });
};
var $b0abd9ab06e06245$export$2e2bcd8739ae039 = $b0abd9ab06e06245$export$bb02e7bc6e1a7119;

});
parcelRegister("gttjd", function(module, exports) {

$parcel$export(module.exports, "removeAccents", () => $38a0e824f156ae86$export$f3f2882e8b11d731);
$parcel$export(module.exports, "getParts", () => $38a0e824f156ae86$export$a3aee8a24a54661f);

var $e1vfz = parcelRequire("e1vfz");

var $hTLlD = parcelRequire("hTLlD");

var $lyOYo = parcelRequire("lyOYo");

var $5iWql = parcelRequire("5iWql");
const $38a0e824f156ae86$export$f3f2882e8b11d731 = (0, $5iWql.default)((text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
const $38a0e824f156ae86$export$1633667427d99697 = (0, $5iWql.default)((highlight)=>{
    const escapedFilter = highlight.map((phrase)=>(0, (/*@__PURE__*/$parcel$interopDefault($e1vfz)))(phrase)).join('|');
    return new RegExp(escapedFilter, 'gmi');
}, (newArgs, lastArgs)=>{
    if (newArgs.length !== lastArgs.length) return false;
    const equalityFn = (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)));
    return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
});
const $38a0e824f156ae86$export$2235873b95f89ea = (content)=>({
        type: 'text',
        content: content
    });
const $38a0e824f156ae86$export$39ae7d355c29b45f = (content)=>({
        type: 'highlight',
        content: content
    });
const $38a0e824f156ae86$export$c05c39859172f90c = (str, regExp)=>{
    const ms = [];
    let m = regExp.exec(str);
    while(m){
        ms.push(m);
        m = regExp.exec(str);
    }
    return ms;
};
const $38a0e824f156ae86$export$a3aee8a24a54661f = (highlight, text)=>{
    if (highlight == null || highlight.filter((phrase)=>phrase !== '').length === 0) return [
        $38a0e824f156ae86$export$2235873b95f89ea(text)
    ];
    const parts = [];
    // Long text lengths will cause "Invalid regular expression" error
    const truncatedHighlight = highlight.map((phrase)=>phrase.substring(0, 255));
    const highlightRegExp = $38a0e824f156ae86$export$1633667427d99697(truncatedHighlight.filter((phrase)=>phrase !== ''));
    const textWithoutAccents = $38a0e824f156ae86$export$f3f2882e8b11d731(text);
    const textMatches = $38a0e824f156ae86$export$c05c39859172f90c(text, highlightRegExp);
    const textWithoutAccentsMatches = $38a0e824f156ae86$export$c05c39859172f90c(textWithoutAccents, highlightRegExp);
    const highlightMatches = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
        ...textWithoutAccentsMatches,
        ...textMatches
    ], 'index');
    let currentPosition = 0;
    highlightMatches.forEach((match)=>{
        const matchText = text.slice(match.index, match.index + match[0].length);
        const leading = text.slice(currentPosition, match.index);
        if (leading !== '') parts.push($38a0e824f156ae86$export$2235873b95f89ea(leading));
        parts.push($38a0e824f156ae86$export$39ae7d355c29b45f(matchText));
        currentPosition = match.index + matchText.length;
    });
    const trailing = text.slice(currentPosition);
    if (trailing !== '') parts.push($38a0e824f156ae86$export$2235873b95f89ea(trailing));
    return parts;
};

});

parcelRegister("e63D2", function(module, exports) {

$parcel$export(module.exports, "default", () => $29e295d31ad42542$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gttjd = parcelRequire("gttjd");

var $lbHMu = parcelRequire("lbHMu");
const $29e295d31ad42542$var$HighlightTextWithParser = /*#__PURE__*/ (0, $eUqFw.memo)(({ text: text, highlight: highlight })=>{
    const parts = (0, $gttjd.getParts)(highlight, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbHMu.default), {
        parts: parts
    });
});
var $29e295d31ad42542$export$2e2bcd8739ae039 = $29e295d31ad42542$var$HighlightTextWithParser;

});
parcelRegister("lbHMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed9071505b4a281f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gda1r = parcelRequire("gda1r");
const $ed9071505b4a281f$var$HighlightText = ({ parts: parts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, parts.map((part, i)=>{
        if (part.type === 'text') return part.content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gda1r.Mark), {
            key: i
        }, part.content);
    }));
var $ed9071505b4a281f$export$2e2bcd8739ae039 = $ed9071505b4a281f$var$HighlightText;

});
parcelRegister("gda1r", function(module, exports) {

$parcel$export(module.exports, "Mark", () => $8f973f57522751f3$export$c9d15bcfc6d42044);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $8f973f57522751f3$export$c9d15bcfc6d42044 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "mark", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkwtfv _syaz1fxt",
            __cmplp.className
        ])
    });
});

});





parcelRegister("cMvqb", function(module, exports) {

$parcel$export(module.exports, "useTraitsActions", () => $cf408626ade662ad$export$87f1d888def9d5a0);
$parcel$export(module.exports, "createTraitsSelector", () => $cf408626ade662ad$export$fb8309e220d0dd3b);
$parcel$export(module.exports, "composeTraitsSelectors", () => $cf408626ade662ad$export$e653f602b87eec56);

var $lRmyA = parcelRequire("lRmyA");

var $WBLbN = parcelRequire("WBLbN");

var $j5vbe = parcelRequire("j5vbe");

var $9Gkbd = parcelRequire("9Gkbd");
const $cf408626ade662ad$var$addTrait = (traitType, trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        const state = currentUserTraits[traitType];
        if (!state.attributes) {
            setState({
                ...currentUserTraits,
                [traitType]: {
                    attributes: [
                        trait
                    ]
                }
            });
            return;
        }
        if (state.attributes.some((existingTrait)=>existingTrait.name === trait.name)) setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: state.attributes.map((existingTrait)=>existingTrait.name === trait.name ? trait : existingTrait)
            }
        });
        else setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: [
                    ...state.attributes,
                    trait
                ]
            }
        });
    };
const $cf408626ade662ad$var$fetchTraits = (traitTypes, { cloudId: cloudId, accountId: accountId, orgId: orgId })=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        await Promise.all(traitTypes.map(async (traitType)=>{
            if (state[traitType].attributes === null || state[traitType].attributes?.length || state[traitType].loading) return;
            setState({
                ...state,
                [traitType]: {
                    ...state[traitType],
                    loading: true
                }
            });
            const traitEndpointEndingFragment = (0, $9Gkbd.buildTraitEndpointEndingFragment)({
                traitType: traitType,
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId
            });
            if (!traitEndpointEndingFragment) return;
            const url = (0, $j5vbe.TRAIT_ENDPOINT_STARTING_FRAGMENT) + traitEndpointEndingFragment;
            try {
                const fetchedTraits = await (0, $lRmyA.performGetRequest)(url);
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: fetchedTraits?.attributes?.length ? fetchedTraits.attributes : null,
                        loading: false
                    }
                });
            } catch  {
            // noop
            }
        }));
    };
const $cf408626ade662ad$var$actions = {
    fetchTraits: $cf408626ade662ad$var$fetchTraits,
    addTrait: $cf408626ade662ad$var$addTrait
};
const $cf408626ade662ad$var$initialState = {
    ATLASSIAN_ACCOUNT: {
        attributes: [],
        loading: false
    },
    SITE: {
        attributes: [],
        loading: false
    },
    SITE_USER: {
        attributes: [],
        loading: false
    },
    ORG: {
        attributes: [],
        loading: false
    },
    ORG_USER: {
        attributes: [],
        loading: false
    }
};
const $cf408626ade662ad$export$5b11e13f463f4eb = (0, $WBLbN.createStore)({
    initialState: $cf408626ade662ad$var$initialState,
    actions: $cf408626ade662ad$var$actions,
    name: 'TraitsStore'
});
const $cf408626ade662ad$export$243330301a7ccf01 = (0, $WBLbN.createHook)($cf408626ade662ad$export$5b11e13f463f4eb);
const $cf408626ade662ad$export$87f1d888def9d5a0 = (0, $WBLbN.createActionsHook)($cf408626ade662ad$export$5b11e13f463f4eb);
const $cf408626ade662ad$var$defaultSelector = (traitsType, selector)=>(0, $WBLbN.createSelector)((state)=>({
            attributes: state[traitsType]?.attributes,
            userCreatedAfter: (date)=>state[traitsType].attributes ? (0, $9Gkbd.userCreatedAfter)(state, date) : null,
            getTraitByName: (name)=>state[traitsType].attributes ? (0, $9Gkbd.getTraitByName)(state, name) : null
        }), selector);
const $cf408626ade662ad$export$fb8309e220d0dd3b = (traitsType, selector)=>(0, $WBLbN.createHook)($cf408626ade662ad$export$5b11e13f463f4eb, {
        selector: $cf408626ade662ad$var$defaultSelector(traitsType, selector)
    });
const $cf408626ade662ad$export$e653f602b87eec56 = (traitTypes, hooks)=>({
        traitTypes: traitTypes,
        hooks: hooks
    });

});
parcelRegister("j5vbe", function(module, exports) {

$parcel$export(module.exports, "ATLASSIAN_ACCOUNT", () => $8e212895925d0e66$export$eac8289d83d13c9e);
$parcel$export(module.exports, "SITE", () => $8e212895925d0e66$export$1f4740cb59ea887e);
$parcel$export(module.exports, "SITE_USER", () => $8e212895925d0e66$export$2b629adc0b711448);
$parcel$export(module.exports, "ORG", () => $8e212895925d0e66$export$c7bc89c720838974);
$parcel$export(module.exports, "ORG_USER", () => $8e212895925d0e66$export$872e93425a929c06);
$parcel$export(module.exports, "TRAIT_ENDPOINT_STARTING_FRAGMENT", () => $8e212895925d0e66$export$ff5c5bd50c21e9a4);
const $8e212895925d0e66$export$eac8289d83d13c9e = 'ATLASSIAN_ACCOUNT';
const $8e212895925d0e66$export$1f4740cb59ea887e = 'SITE';
const $8e212895925d0e66$export$2b629adc0b711448 = 'SITE_USER';
const $8e212895925d0e66$export$c7bc89c720838974 = 'ORG';
const $8e212895925d0e66$export$872e93425a929c06 = 'ORG_USER';
const $8e212895925d0e66$export$ff5c5bd50c21e9a4 = '/gateway/api/tap-delivery/api/v3/personalization/';
const $8e212895925d0e66$export$ab3e7784d2a104d4 = [
    $8e212895925d0e66$export$eac8289d83d13c9e,
    $8e212895925d0e66$export$1f4740cb59ea887e,
    $8e212895925d0e66$export$2b629adc0b711448,
    $8e212895925d0e66$export$c7bc89c720838974,
    $8e212895925d0e66$export$872e93425a929c06
];

});

parcelRegister("9Gkbd", function(module, exports) {

$parcel$export(module.exports, "buildTraitEndpointEndingFragment", () => $63a88eb8054d2806$export$118c30eb4b4c51e8);
$parcel$export(module.exports, "getTraitByName", () => $63a88eb8054d2806$export$e5b0d140cf11f46a);
$parcel$export(module.exports, "userCreatedAfter", () => $63a88eb8054d2806$export$8388eb33623a9cff);

var $j5vbe = parcelRequire("j5vbe");
const $63a88eb8054d2806$export$e320a062b20fddc3 = (traitsData)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(traitsData).reduce((acc, [, val])=>{
        if (val?.attributes) acc.push(...val.attributes.map((singleTrait)=>singleTrait));
        return acc;
    }, []);
const $63a88eb8054d2806$export$118c30eb4b4c51e8 = ({ traitType: traitType, accountId: accountId, cloudId: cloudId, orgId: orgId })=>{
    switch(traitType){
        case 0, $j5vbe.ATLASSIAN_ACCOUNT:
            return `user/${accountId}`;
        case 0, $j5vbe.SITE:
            return `site/${cloudId}`;
        case 0, $j5vbe.SITE_USER:
            return `site/${cloudId}/user/${accountId}`;
        case 0, $j5vbe.ORG:
            return `org/${orgId}`;
        case 0, $j5vbe.ORG_USER:
            return `org/${orgId}/user/${accountId}`;
        default:
            return null;
    }
};
function $63a88eb8054d2806$export$e5b0d140cf11f46a(traitsData, traitName) {
    return $63a88eb8054d2806$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName);
}
const $63a88eb8054d2806$export$d2a3b2f9735b6874 = (traitsData, traitNames)=>$63a88eb8054d2806$export$e320a062b20fddc3(traitsData)?.filter((trait)=>traitNames.includes(trait.name));
const $63a88eb8054d2806$export$8388eb33623a9cff = (traitsData, date)=>{
    const accountCreationDate = $63a88eb8054d2806$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) > date;
};

});


parcelRegister("gAOAU", function(module, exports) {

$parcel$export(module.exports, "CardCoverEditingContainer", () => $e93dee3f4ea4ce44$export$13da74796c6022b7);
$parcel$export(module.exports, "useIsCardCoverEditingOpen", () => $e93dee3f4ea4ce44$export$86192d02f3e50475);
$parcel$export(module.exports, "useCardCoverEditingActions", () => $e93dee3f4ea4ce44$export$a20e8ef4d07b82c8);

var $WBLbN = parcelRequire("WBLbN");
const $e93dee3f4ea4ce44$export$13da74796c6022b7 = (0, $WBLbN.createContainer)();
const $e93dee3f4ea4ce44$var$actions = {
    setOpen: (isOpen)=>({ setState: setState })=>{
            setState({
                isOpen: isOpen
            });
        }
};
const $e93dee3f4ea4ce44$var$store = (0, $WBLbN.createStore)({
    name: 'BusinessBoardCardCoverEditingStore',
    initialState: {
        isOpen: false
    },
    actions: $e93dee3f4ea4ce44$var$actions,
    containedBy: $e93dee3f4ea4ce44$export$13da74796c6022b7
});
const $e93dee3f4ea4ce44$export$86192d02f3e50475 = (0, $WBLbN.createStateHook)($e93dee3f4ea4ce44$var$store, {
    selector: (state)=>state.isOpen
});
const $e93dee3f4ea4ce44$export$a20e8ef4d07b82c8 = (0, $WBLbN.createActionsHook)($e93dee3f4ea4ce44$var$store);

});

parcelRegister("74CPP", function(module, exports) {

$parcel$export(module.exports, "useDraggableCard", () => $f9ac24ffce4192bf$export$ee9f6369c1b523a9);

var $eUqFw = parcelRequire("eUqFw");

var $2cKws = parcelRequire("2cKws");

var $awlt9 = parcelRequire("awlt9");

var $ibIV3 = parcelRequire("ibIV3");
parcelRequire("93Ys7");
var $98AB6 = parcelRequire("98AB6");
parcelRequire("lWeOS");
var $b0ziO = parcelRequire("b0ziO");

var $kQAZu = parcelRequire("kQAZu");

var $d3C6e = parcelRequire("d3C6e");

var $ib4WI = parcelRequire("ib4WI");

var $gWYTK = parcelRequire("gWYTK");

var $gMJE7 = parcelRequire("gMJE7");
const $f9ac24ffce4192bf$export$ee9f6369c1b523a9 = ({ ref: ref, issue: issue, cardIndex: cardIndex, group: group, onCardDragChange: onCardDragChange })=>{
    const project = (0, $kQAZu.useProject)();
    const startCardDrag = (0, $gWYTK.useStartCardDrag)();
    const { canDropAgainstCard: canDropAgainstCard } = (0, $gWYTK.useCanDropCard)(group);
    const [dragState, setDragState] = (0, $eUqFw.useState)({
        type: 'idle'
    });
    (0, $eUqFw.useEffect)(()=>{
        if (!ref.current) return;
        const handleDrag = ({ source: source, self: self })=>{
            const sourceData = source.data;
            if (!(0, $gMJE7.isCard)(sourceData)) return;
            if (sourceData.issueId === issue.id) return;
            const destinationData = self.data;
            const closestEdge = (0, $2cKws.extractClosestEdge)(destinationData);
            const isClosestEdgeAdjacentToSource = (0, $gMJE7.isCard)(destinationData) && sourceData.columnId === destinationData.columnId && closestEdge != null && (0, $gMJE7.isClosestEdgeAdjacentToSource)(sourceData.cardIndex, destinationData.cardIndex, closestEdge);
            onCardDragChange(closestEdge && !isClosestEdgeAdjacentToSource ? {
                cardIndex: cardIndex,
                closestEdge: closestEdge
            } : null);
        };
        return (0, $awlt9.combine)((0, $ibIV3.draggable)({
            element: ref.current,
            canDrag: ()=>project.permissions.editIssues && !(0, $d3C6e.isOptimisticIssue)(issue.id),
            getInitialData: ()=>({
                    type: (0, $ib4WI.CARD_DND_TYPE),
                    issueId: issue.id,
                    cardIndex: cardIndex,
                    columnId: group.id
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage, location: location, source: source })=>{
                (0, $b0ziO.setCustomNativeDragPreview)({
                    getOffset: (0, $98AB6.preserveOffsetOnSource)({
                        element: source.element,
                        input: location.current.input
                    }),
                    render ({ container: container }) {
                        setDragState({
                            type: 'preview',
                            container: container
                        });
                        return ()=>setDragState({
                                type: 'idle'
                            });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>{
                startCardDrag(issue, group);
            },
            onDrop: ()=>{
                setDragState({
                    type: 'idle'
                });
            }
        }), (0, $ibIV3.dropTargetForElements)({
            element: ref.current,
            canDrop: ({ source: source })=>(0, $gMJE7.isCard)(source.data) && canDropAgainstCard === 'yes',
            getIsSticky: ()=>true,
            getData: ({ input: input, element: element })=>{
                const data = {
                    type: (0, $ib4WI.CARD_DND_TYPE),
                    issueId: issue.id,
                    cardIndex: cardIndex,
                    columnId: group.id
                };
                return (0, $2cKws.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            onDragEnter: handleDrag,
            onDrag: handleDrag,
            onDragLeave: ()=>{
                onCardDragChange(null);
            },
            onDrop: ()=>{
                onCardDragChange(null);
            }
        }));
    }, [
        canDropAgainstCard,
        cardIndex,
        group,
        issue,
        onCardDragChange,
        project.permissions.editIssues,
        ref,
        startCardDrag
    ]);
    return {
        dragState: dragState
    };
};

});

parcelRegister("f7G96", function(module, exports) {

$parcel$export(module.exports, "useViewIssue", () => $0b9fbdb737aff2d8$export$f26a5ae87a55d4f8);

var $eUqFw = parcelRequire("eUqFw");

var $4TJj0 = parcelRequire("4TJj0");

var $i0nxo = parcelRequire("i0nxo");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $lB25E = parcelRequire("lB25E");

var $fwgIU = parcelRequire("fwgIU");

var $ib4WI = parcelRequire("ib4WI");
const $0b9fbdb737aff2d8$export$f26a5ae87a55d4f8 = ()=>{
    const ufoPressTracing = (0, $fwgIU.default)('jwm.board.issue-view-opened');
    const [, setSelectedIssueKey] = (0, $lB25E.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const [, { sendNodeSelected: sendNodeSelected }] = (0, $4TJj0.useCollabStore)();
    const project = (0, $kQAZu.useProject)();
    const projectId = String(project.id);
    return (0, $eUqFw.useCallback)((issue, withCmd)=>{
        if (issue.id && issue.fields[0, $ib4WI.ISSUE_KEY_ID].value) {
            const issueKey = issue.fields[0, $ib4WI.ISSUE_KEY_ID].value;
            if (withCmd) typeof window !== 'undefined' && window.open(`/browse/${issueKey}`, '_blank');
            else {
                ufoPressTracing();
                setSelectedIssueKey(issueKey);
                const nodeId = (0, $i0nxo.getPresenceNodeId)({
                    projectId: projectId,
                    viewId: 'board',
                    nodeId: String(issue.id)
                });
                sendNodeSelected({
                    nodeId: nodeId
                });
            }
        }
    }, [
        projectId,
        sendNodeSelected,
        setSelectedIssueKey,
        ufoPressTracing
    ]);
};

});

parcelRegister("a8jG7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d27abeee15ffba0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lUg8E = parcelRequire("lUg8E");

var $kRXDJ = parcelRequire("kRXDJ");

var $k0Oqq = parcelRequire("k0Oqq");

var $6eRT3 = parcelRequire("6eRT3");

var $eruWR = parcelRequire("eruWR");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $fyk0U = parcelRequire("fyk0U");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jvfW6 = parcelRequire("jvfW6");

var $cMvqb = parcelRequire("cMvqb");

var $8rQuz = parcelRequire("8rQuz");

var $c52lf = parcelRequire("c52lf");

var $9TPjv = parcelRequire("9TPjv");

var $6MGj1 = parcelRequire("6MGj1");
const $6d27abeee15ffba0$export$ee81106b9e254a08 = '--card-actions-display';
const $6d27abeee15ffba0$var$returnNull = ()=>null;
const $6d27abeee15ffba0$var$useIsCardCoversNew = (0, $cMvqb.createTraitsSelector)('SITE_USER', ({ userCreatedAfter: userCreatedAfter, getTraitByName: getTraitByName })=>getTraitByName('jira-core_ui_cardcovereditor_clicked_first_time') === null && !userCreatedAfter(new Date('2024-06-17')));
const $6d27abeee15ffba0$var$CardActions = ({ issue: issue })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const openMenu = (0, $eUqFw.useCallback)(()=>setIsOpen(true), []);
    const closeMenu = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const toggleMenu = (0, $eUqFw.useCallback)(()=>setIsOpen((open)=>!open), []);
    const [isCardCoversNew] = $6d27abeee15ffba0$var$useIsCardCoversNew();
    const { group: group } = (0, $c52lf.useIssueGroup)();
    const isCardCoversChangeboardingEnabled = (0, $eI5EY.fg)('jwm_card_covers_changeboarding');
    const [userTraits, { setUserTraits: setUserTraits }] = !isCardCoversChangeboardingEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fyk0U.useUserTraits)() : [
        null,
        {
            setUserTraits: ()=>undefined
        }
    ];
    const fetchUserTraits = !isCardCoversChangeboardingEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fyk0U.useFetchUserTraitsOld)() : $6d27abeee15ffba0$var$returnNull;
    const setUserTraitsIfNotAvailable = (0, $eUqFw.useCallback)(async ()=>{
        if (isCardCoversChangeboardingEnabled) return false;
        if (!userTraits?.attributes?.length && userTraits?.attributes !== null) {
            const newTraits = await fetchUserTraits();
            if (newTraits !== false) setUserTraits(newTraits);
        }
    }, [
        userTraits,
        fetchUserTraits,
        setUserTraits,
        isCardCoversChangeboardingEnabled
    ]);
    const popupContent = (0, $eUqFw.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9TPjv.default), {
            issue: issue,
            onContentResize: update,
            onClosePopup: closeMenu,
            onMenuRendered: update,
            onOpenPopup: openMenu
        }), [
        issue,
        closeMenu,
        openMenu
    ]);
    const trigger = (0, $eUqFw.useCallback)((triggerProps)=>{
        return (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
            xcss: isOpen ? [
                $6d27abeee15ffba0$var$IconButtonStyles,
                $6d27abeee15ffba0$var$IconButtonMenuOpenStyles
            ] : $6d27abeee15ffba0$var$IconButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRXDJ.default), {
            ...triggerProps,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6eRT3))),
            label: formatMessage((0, $6MGj1.default).cardActionsWithIssueName, {
                columnName: group.name,
                issueKey: issue.fields.issuekey.value
            }),
            onClick: toggleMenu,
            testId: "work-management-board.ui.board.column.card.card-actions.trigger",
            onMouseOver: setUserTraitsIfNotAvailable,
            onFocus: setUserTraitsIfNotAvailable
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6d27abeee15ffba0$var$TriggerButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6d27abeee15ffba0$var$StyledButton, {
            ...triggerProps,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k0Oqq))), {
                label: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6MGj1.default).cardActionsWithIssueNameIssueTermRefresh : (0, $6MGj1.default).cardActionsWithIssueName, {
                    columnName: group.name,
                    issueKey: issue.fields.issuekey.value
                }),
                color: "var(--ds-icon, #44546F)"
            }),
            onClick: toggleMenu,
            testId: "work-management-board.ui.board.column.card.card-actions.trigger",
            onMouseOver: setUserTraitsIfNotAvailable,
            onFocus: setUserTraitsIfNotAvailable,
            isCardCoversNew: isCardCoversNew
        }));
    }, [
        isOpen,
        formatMessage,
        group,
        issue,
        toggleMenu,
        setUserTraitsIfNotAvailable,
        isCardCoversNew
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvfW6.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eruWR.default), {
        isOpen: isOpen,
        onClose: closeMenu,
        content: popupContent,
        placement: "right-start",
        trigger: trigger
    }));
};
var $6d27abeee15ffba0$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($6d27abeee15ffba0$var$CardActions);
const $6d27abeee15ffba0$var$TriggerButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iu2gc _1xi2u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $6d27abeee15ffba0$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lUg8E.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0ch0al _1d5x1txw _1q6e1txw",
            __cmplp.isCardCoversNew ? "_16qs1wx8" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $6d27abeee15ffba0$var$IconButtonStyles = (0, $8Vv3m.xcss)({
    position: 'absolute',
    top: "var(--ds-space-100, 8px)",
    right: "var(--ds-space-100, 8px)",
    display: `var(${$6d27abeee15ffba0$export$ee81106b9e254a08}, none)`
});
const $6d27abeee15ffba0$var$IconButtonMenuOpenStyles = (0, $8Vv3m.xcss)({
    display: 'block'
});

});
parcelRegister("k0Oqq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::384f31b6891d11603b1a7b84cc388cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e91aec1f9b2e426a$var$_react = $e91aec1f9b2e426a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $e91aec1f9b2e426a$var$_showMoreHorizontal = $e91aec1f9b2e426a$var$_interopRequireDefault((parcelRequire("6eRT3")));

var $e91aec1f9b2e426a$var$_more = $e91aec1f9b2e426a$var$_interopRequireDefault((parcelRequire("fBmrg")));
function $e91aec1f9b2e426a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e91aec1f9b2e426a$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $e91aec1f9b2e426a$var$_react.default.createElement($e91aec1f9b2e426a$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $e91aec1f9b2e426a$var$_more.default
    }, props));
$e91aec1f9b2e426a$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $e91aec1f9b2e426a$var$_default = module.exports.default = $e91aec1f9b2e426a$var$ShowMoreHorizontalIcon;

});

parcelRegister("fyk0U", function(module, exports) {

$parcel$export(module.exports, "useFetchUserTraitsOld", () => $8dca86bbd49a57d4$export$d5a27009aa54a078);
$parcel$export(module.exports, "useUserTraits", () => $8dca86bbd49a57d4$export$49363c8b904e0dc7);

var $eUqFw = parcelRequire("eUqFw");

var $lRmyA = parcelRequire("lRmyA");

var $dxcfv = parcelRequire("dxcfv");

var $dWLk9 = parcelRequire("dWLk9");

var $WBLbN = parcelRequire("WBLbN");
const $8dca86bbd49a57d4$var$setUserTraits = (newTraits)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        setState({
            ...currentUserTraits,
            attributes: newTraits
        });
    };
const $8dca86bbd49a57d4$var$addUserTrait = (trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        if (currentUserTraits.attributes?.some((t)=>t.name === trait.name)) return;
        setState({
            attributes: currentUserTraits.attributes?.concat(trait) ?? [
                trait
            ]
        });
    };
const $8dca86bbd49a57d4$var$fetchUserTraits = (cloudId, accountId)=>async ({ getState: getState, setState: setState })=>{
        if (!accountId) return null;
        const state = getState();
        if (state.attributes !== null) return;
        const getUserTraits = async ()=>{
            try {
                const userTraitsData = await (0, $lRmyA.performGetRequest)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`);
                return userTraitsData?.attributes ?? [];
            } catch  {
                return null;
            }
        };
        const userTraits = await getUserTraits();
        setState({
            attributes: userTraits
        });
    };
const $8dca86bbd49a57d4$var$actions = {
    setUserTraits: $8dca86bbd49a57d4$var$setUserTraits,
    fetchUserTraits: $8dca86bbd49a57d4$var$fetchUserTraits,
    addUserTrait: $8dca86bbd49a57d4$var$addUserTrait
};
const $8dca86bbd49a57d4$var$initialState = {
    attributes: null
};
const $8dca86bbd49a57d4$export$d5a27009aa54a078 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const accountId = (0, $dxcfv.useAccountId)();
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    return (0, $eUqFw.useCallback)(async ()=>{
        if (!accountId) return null;
        const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const getUserTraits = async ()=>{
            try {
                setLoading(true);
                const userTraitsData = await (0, $lRmyA.performGetRequest)(url);
                // If a user has no attributes on their account, return null so we know
                // not to keep trying to fetch data.
                return !userTraitsData?.attributes?.length ? null : userTraitsData?.attributes;
            } catch  {
                return null;
            } finally{
                setLoading(false);
            }
        };
        if (!loading) {
            const userTraits = await getUserTraits();
            return userTraits;
        }
        return false;
    }, [
        accountId,
        cloudId,
        loading
    ]);
};
const $8dca86bbd49a57d4$export$6e688ed53ae076d5 = (0, $WBLbN.createStore)({
    initialState: $8dca86bbd49a57d4$var$initialState,
    actions: $8dca86bbd49a57d4$var$actions,
    name: 'UserTraits'
});
const $8dca86bbd49a57d4$export$49363c8b904e0dc7 = (0, $WBLbN.createHook)($8dca86bbd49a57d4$export$6e688ed53ae076d5);
const $8dca86bbd49a57d4$export$4f249a943026a90b = (0, $WBLbN.createActionsHook)($8dca86bbd49a57d4$export$6e688ed53ae076d5);

});

parcelRegister("9TPjv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4ce8ccfd7481579$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bBdMg = parcelRequire("bBdMg");

var $gGtKh = parcelRequire("gGtKh");

var $dyfd9 = parcelRequire("dyfd9");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d4ce8ccfd7481579$var$LazyCardActionsMenu = (0, $dyfd9.lazy)(()=>(parcelRequire("7rjL0")), {
    ssr: false,
    moduleId: "./src/packages/business/board/view/src/ui/board/column/card/card-actions/card-actions-menu/main.tsx"
});
const $d4ce8ccfd7481579$var$AsyncCardActionsMenu = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "card-actions-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d4ce8ccfd7481579$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bBdMg.default), {
            size: "medium"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d4ce8ccfd7481579$var$LazyCardActionsMenu, props));
var $d4ce8ccfd7481579$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d4ce8ccfd7481579$var$AsyncCardActionsMenu;
const $d4ce8ccfd7481579$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1wdt _1yt41nde",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7rjL0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("85Pd3").then(()=>parcelRequire('8q5sQ'));

});


parcelRegister("6MGj1", function(module, exports) {

$parcel$export(module.exports, "default", () => $35ab5db2d1a11b80$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $35ab5db2d1a11b80$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    cardActions: {
        "id": "work-management-board.board.column.card.card-actions.card-actions",
        "defaultMessage": "Card actions"
    },
    cardActionsWithIssueName: {
        "id": "work-management-board.board.column.card.card-actions.card-actions-with-issue-name",
        "defaultMessage": "Card actions on issue {issueKey} of column {columnName}"
    },
    cardActionsWithIssueNameIssueTermRefresh: {
        "id": "work-management-board.board.column.card.card-actions.card-actions-with-issue-name-issue-term-refresh",
        "defaultMessage": "Card actions on issue {issueKey} of column {columnName}"
    }
});

});


parcelRegister("cnz22", function(module, exports) {

$parcel$export(module.exports, "CardBadge", () => $9e1c2949054e4e70$export$bc1a48e1b7ed7af);

var $eUqFw = parcelRequire("eUqFw");

var $jl1we = parcelRequire("jl1we");

var $aZGbv = parcelRequire("aZGbv");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jNk4i = parcelRequire("jNk4i");
const $9e1c2949054e4e70$export$bc1a48e1b7ed7af = ({ selections: selections, children: children, position: position })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!selections) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    const cardSelection = selections[0];
    const tooltipContent = selections.length > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, selections.map(({ user: user }, i)=>i !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: user.name
        }, user.name))) : null;
    const otherSelectionsContent = selections.length > 1 ? formatMessage((0, $jNk4i.default).moreSelections, {
        count: selections.length - 1
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZGbv.NodeSelectionWrapper), {
        color: cardSelection.color
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: tooltipContent,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZGbv.ParticipantBadge), {
        color: cardSelection.color,
        position: position
    }, cardSelection.user.name, otherSelectionsContent), children));
};

});
parcelRegister("aZGbv", function(module, exports) {

$parcel$export(module.exports, "NodeSelectionWrapper", () => $8521b6b2ec32c74c$export$f758a58bee5c7927);
$parcel$export(module.exports, "ParticipantBadge", () => $8521b6b2ec32c74c$export$91bc13dfc76fa8fa);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

const $8521b6b2ec32c74c$var$BADGE_SIZE = 16;
// the badge text color will remain white regardless of the theme applied
const $8521b6b2ec32c74c$var$BADGE_TEXT_COLOR = 'white';
const $8521b6b2ec32c74c$export$f758a58bee5c7927 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_oor3vt": (0, $9t7rW.default)(`0 0 0 2px ${__cmplp.color} inset`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _16qs1zte _2rko1sit",
            __cmplp.className
        ])
    });
});
const $8521b6b2ec32c74c$export$91bc13dfc76fa8fa = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { position: position, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _1bah1h6o _4cvr1h6o _1xi2idpf _1bsb1wug _4t3i7vkz _1pbykb7n _1yt4otz2 _11q71cj8 _vchhusvi _11c8qk37 _syazu67f",
            __cmplp.position === (0, $18eb89570dd03c8c$export$86bcdda8e7a22b9d) ? "_154iidpf" : "_154id439",
            __cmplp.position === (0, $18eb89570dd03c8c$export$86bcdda8e7a22b9d) ? "_2rko1pph" : "_2rko2hs0",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jNk4i", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8136b50b09a1700$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e8136b50b09a1700$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moreSelections: {
        "id": "work-management-board.board.column.card.card-badge.more-selections",
        "defaultMessage": " + {count, plural, one {# other} other {# others}}"
    }
});

});


parcelRegister("10ATT", function(module, exports) {

$parcel$export(module.exports, "CardContent", () => $ace89df80f5c593a$export$64ef9b8c11710c47);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gjzML = parcelRequire("gjzML");

var $jGcn0 = parcelRequire("jGcn0");

var $d3C6e = parcelRequire("d3C6e");

var $3ySoA = parcelRequire("3ySoA");

var $8Qd0L = parcelRequire("8Qd0L");

var $daiHs = parcelRequire("daiHs");

var $4wx7G = parcelRequire("4wx7G");

var $huZle = parcelRequire("huZle");

var $byrHc = parcelRequire("byrHc");

var $2kYPS = parcelRequire("2kYPS");

var $dq5k9 = parcelRequire("dq5k9");

var $ib4WI = parcelRequire("ib4WI");

var $bZapc = parcelRequire("bZapc");

var $iXHUp = parcelRequire("iXHUp");

var $5lzG5 = parcelRequire("5lzG5");

var $ffOJV = parcelRequire("ffOJV");

var $c9bRS = parcelRequire("c9bRS");
const $ace89df80f5c593a$export$64ef9b8c11710c47 = /*#__PURE__*/ (0, $eUqFw.memo)(({ highlight: highlight, issue: issue, onIssueKeyClick: onIssueKeyClick })=>{
    const groupBy = (0, $iXHUp.useGroupByField)();
    const selectedFields = (0, $bZapc.useSelectedFields)();
    const isNewOptimisticIssue = (0, $d3C6e.isOptimisticIssue)(issue.id);
    const labels = issue.fields[0, $ib4WI.LABEL_ID]?.value ?? undefined;
    const isDone = issue.fields[0, $ib4WI.STATUS_ID].status.statusCategoryId === (0, $8Qd0L.StatusCategoryIds).done;
    const isStandardIssue = issue.fields[0, $ib4WI.ISSUE_TYPE_ID].issueType.hierarchyLevel === 0;
    const renderedLabels = (0, $eUqFw.useMemo)(()=>labels && selectedFields.labels ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ace89df80f5c593a$var$SingleFieldRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $huZle.CardLabels), {
            labels: labels,
            highlight: highlight
        })) : null, [
        selectedFields.labels,
        labels,
        highlight
    ]);
    const renderedDueDate = (0, $eUqFw.useMemo)(()=>issue.fields[0, $ib4WI.DUE_DATE_ID] != null && selectedFields.duedate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ace89df80f5c593a$var$SingleFieldRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $daiHs.CardDueDate), {
            dueDate: issue.fields[0, $ib4WI.DUE_DATE_ID].value,
            isCompleted: isDone
        })) : null, [
        issue.fields,
        isDone,
        selectedFields.duedate
    ]);
    const renderedIssueType = (0, $eUqFw.useMemo)(()=>selectedFields.issuetype ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffOJV.default), {
            issueType: issue.fields[0, $ib4WI.ISSUE_TYPE_ID]
        }) : null, [
        issue.fields,
        selectedFields.issuetype
    ]);
    const renderedPriority = (0, $eUqFw.useMemo)(()=>{
        const priority = issue.fields[0, $ib4WI.PRIORITY_ID];
        return priority && selectedFields.priority ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $byrHc.CardPriority), {
            uri: priority.priority.iconUrl,
            name: priority.priority.name
        }) : null;
    }, [
        selectedFields.priority,
        issue.fields
    ]);
    const renderedAssignee = (0, $eUqFw.useMemo)(()=>{
        const assignee = issue.fields[0, $ib4WI.ASSIGNEE_ID];
        if (assignee?.user && selectedFields.assignee) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gjzML.AvatarLite), {
            highlight: highlight,
            avatarUrl: assignee.user.avatarURL ?? undefined,
            name: assignee.user.name
        });
        return null;
    }, [
        highlight,
        issue.fields,
        selectedFields.assignee
    ]);
    const renderedKey = (0, $eUqFw.useMemo)(()=>selectedFields.key && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ace89df80f5c593a$var$IssueKeyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4wx7G.CardKey), {
            highlight: highlight,
            onClick: onIssueKeyClick,
            text: issue.fields[0, $ib4WI.ISSUE_KEY_ID].value
        })), [
        highlight,
        issue.fields,
        onIssueKeyClick,
        selectedFields.key
    ]);
    const renderedStatus = (0, $eUqFw.useMemo)(()=>{
        const { status: status } = issue.fields[0, $ib4WI.STATUS_ID];
        return groupBy !== (0, $jGcn0.GROUP_BY_STATUS) && status.statusCategoryId && status.name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ace89df80f5c593a$var$SingleFieldRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
            name: status.name,
            category: (0, $8Qd0L.statusCategoryForId)(status.statusCategoryId)
        }));
    }, [
        groupBy,
        issue.fields
    ]);
    const showMultiFieldRow = renderedIssueType || renderedKey || isDone || renderedPriority || renderedAssignee;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ace89df80f5c593a$var$ContentWrapper, null, renderedStatus, renderedLabels, renderedDueDate, showMultiFieldRow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ace89df80f5c593a$var$MultiFieldRow, null, renderedIssueType, renderedKey, isDone && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dq5k9.CardTick), null), renderedPriority, renderedAssignee), selectedFields.subtasks && isStandardIssue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c9bRS.default), {
        issue: issue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5lzG5.default), {
        issue: issue
    })), isNewOptimisticIssue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ace89df80f5c593a$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2kYPS.CardSpinner), null)));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ace89df80f5c593a$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _zulpu2gc _1yt4ia9t _fiawglyw",
            __cmplp.className
        ])
    });
});
const $ace89df80f5c593a$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154ipxbi _1xi2pxbi",
            __cmplp.className
        ])
    });
});
const $ace89df80f5c593a$var$MultiFieldRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulp1b66 _1tkegktf",
            __cmplp.className
        ])
    });
});
const $ace89df80f5c593a$var$IssueKeyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $ace89df80f5c593a$var$SingleFieldRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gjzML", function(module, exports) {

$parcel$export(module.exports, "AvatarLite", () => $1d0a2d9cba4728c5$export$8b9560cc4e12c651);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $1d0a2d9cba4728c5$var$AVATAR_SIZE = 24;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d0a2d9cba4728c5$var$Avatar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { avatarUrl: avatarUrl, isHighlighted: isHighlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fzlxay": (0, $9t7rW.default)(`url(${__cmplp.avatarUrl})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1itk1v7f _ouxl1ssb _12vemgnk _1lrw1dfr _bfhk18uv _2rko1ssb _vchh18uv _4t3i1tcg _1bsb1tcg _1ul91tcg _1tke1tcg _1e0c1o8l _kqswh2mm _12ji1r31 _1qu2glyw _12y3idpf _80om1kw7 _18s8v77o",
            __cmplp.isHighlighted ? "_16qs7aa6" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $1d0a2d9cba4728c5$var$hasKeywords = (name)=>(keyword)=>name && keyword && name.toLowerCase().includes(keyword.toLowerCase());
const $1d0a2d9cba4728c5$export$8b9560cc4e12c651 = /*#__PURE__*/ (0, $eUqFw.memo)(({ avatarUrl: avatarUrl, name: name = '', highlight: highlight, testId: testId })=>{
    const isHighlighted = highlight && highlight.some($1d0a2d9cba4728c5$var$hasKeywords(name));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d0a2d9cba4728c5$var$Avatar, {
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        avatarUrl: avatarUrl,
        title: name,
        // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
        isHighlighted: isHighlighted,
        "data-testid": testId
    });
});

});

parcelRegister("3ySoA", function(module, exports) {

$parcel$export(module.exports, "default", () => $84ca0a8de67cc8ac$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $69ay7 = parcelRequire("69ay7");

var $8Qd0L = parcelRequire("8Qd0L");
const $84ca0a8de67cc8ac$var$statusCategoryToAppearenceMap = {
    [(0, $8Qd0L.UNDEFINED)]: 'default',
    [(0, $8Qd0L.TODO)]: 'default',
    [(0, $8Qd0L.DONE)]: 'success',
    [(0, $8Qd0L.IN_PROGRESS)]: 'inprogress'
};
class $84ca0a8de67cc8ac$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isActive: false
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $69ay7.default), {
            testId: "common-components-status-lozenge.status-lozenge",
            isBold: this.props.isActive,
            appearance: $84ca0a8de67cc8ac$var$statusCategoryToAppearenceMap[this.props.category],
            maxWidth: this.props.isFullWidth ? '100%' : undefined
        }, this.props.name);
    }
}

});

parcelRegister("daiHs", function(module, exports) {

$parcel$export(module.exports, "CardDueDate", () => $486a10674c0d478f$export$9e242219cf1cc36c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $d2wNG = parcelRequire("d2wNG");
var $7n7Dc = parcelRequire("7n7Dc");
var $EN9B6 = parcelRequire("EN9B6");
var $3xcI8 = parcelRequire("3xcI8");
var $3jYzf = parcelRequire("3jYzf");

var $69ay7 = parcelRequire("69ay7");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");


var $jl1we = parcelRequire("jl1we");

var $9zysr = parcelRequire("9zysr");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8rQuz = parcelRequire("8rQuz");

var $i0Rm4 = parcelRequire("i0Rm4");


var $9CYrO = parcelRequire("9CYrO");
const $486a10674c0d478f$export$9e242219cf1cc36c = (props)=>{
    const { isCompleted: isCompleted, dueDate: dueDate, dateFormat: dateFormat } = props;
    const dueDateEndOfDay = (0, $7n7Dc.default)((0, $3xcI8.default)(dueDate));
    const currentDate = (0, $3jYzf.default)(new Date());
    const diffInDays = (0, $d2wNG.default)(dueDateEndOfDay, currentDate);
    const isDueBeforeToday = diffInDays <= 0;
    const isOverDue = isCompleted !== true && isDueBeforeToday;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const formattedDueDate = dateFormat !== undefined && dateFormat !== null ? (0, $EN9B6.default)(dueDateEndOfDay, dateFormat) : (0, $EN9B6.default)(dueDateEndOfDay, 'dd MMM');
    const formattedTooltip = formatMessage((0, $9CYrO.messages).text, {
        date: (0, $EN9B6.default)(dueDateEndOfDay, 'dd MMMM yyyy')
    });
    if ((0, $8rQuz.isVisualRefreshEnabled)()) return dueDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: [
            $486a10674c0d478f$var$baseStyles,
            isOverDue ? $486a10674c0d478f$var$overdueStyles : $486a10674c0d478f$var$normalStyles
        ],
        testId: "platform-card.common.ui.due-date.box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: formattedTooltip,
        testId: "platform-card.common.ui.due-date.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($486a10674c0d478f$var$Content, {
        "aria-label": formattedTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0Rm4.default), {
        type: (0, $db933f3263da36b1$export$d4ee7b46933c494f),
        label: formattedTooltip
    }), formattedDueDate))) : null;
    /* eslint-disable jira/react/no-style-attribute */ return dueDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $69ay7.default // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ), {
        style: $486a10674c0d478f$var$dueDateLozengeStyle(isOverDue),
        testId: "platform-card.common.ui.due-date.lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: formattedTooltip,
        testId: "platform-card.common.ui.due-date.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($486a10674c0d478f$var$Content, {
        "aria-label": formattedTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0Rm4.default), {
        type: (0, $db933f3263da36b1$export$d4ee7b46933c494f),
        label: formattedTooltip
    }), formattedDueDate))) : null;
/* eslint-enable jira/react/no-style-attribute */ };
$486a10674c0d478f$export$9e242219cf1cc36c.defaultProps = {
    isCompleted: false
};
var $486a10674c0d478f$export$2e2bcd8739ae039 = $486a10674c0d478f$export$9e242219cf1cc36c;
const $486a10674c0d478f$var$baseStyles = (0, $8Vv3m.xcss)({
    borderStyle: 'solid',
    borderRadius: 'border.radius',
    borderWidth: 'border.width',
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});
const $486a10674c0d478f$var$overdueStyles = (0, $8Vv3m.xcss)({
    color: 'color.text.danger',
    borderColor: 'color.border.danger'
});
const $486a10674c0d478f$var$normalStyles = (0, $8Vv3m.xcss)({
    color: 'color.text',
    borderColor: 'color.border'
});
const $486a10674c0d478f$var$dueDateLozengeStyle = (isOverDue)=>isOverDue ? {
        color: `var(--ds-text-accent-red, ${(0, $1b343b038f6c23ec$exports).R400})`,
        backgroundColor: `var(--ds-background-danger, ${(0, $1b343b038f6c23ec$exports).R50})`
    } : {
        color: `var(--ds-text-subtle, ${(0, $1b343b038f6c23ec$exports).N500})`,
        backgroundColor: `var(--ds-background-neutral, ${(0, $1b343b038f6c23ec$exports).N20})`
    }; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $486a10674c0d478f$var$ContentOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1n261g80",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $486a10674c0d478f$var$ContentNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1n261g80 _zulp1b66",
            __cmplp.className
        ])
    });
});
const $486a10674c0d478f$var$Content = (0, $9zysr.componentWithCondition)((0, $8rQuz.isVisualRefreshEnabled), $486a10674c0d478f$var$ContentNew, $486a10674c0d478f$var$ContentOld);

});
parcelRegister("i0Rm4", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b7d80576fbad589$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $9F3sn = parcelRequire("9F3sn");

var $80vF2 = parcelRequire("80vF2");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $8rQuz = parcelRequire("8rQuz");

var $8jchp = parcelRequire("8jchp");

const $7b7d80576fbad589$var$renderIcon = (type)=>{
    switch(type){
        case 0, $db933f3263da36b1$export$3b43f1ca008dad23:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.ChildIssuesGlyph), null);
        case 0, $db933f3263da36b1$export$aac403da0d127706:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.FlagGlyph), null);
        case 0, $db933f3263da36b1$export$540a31b23d6b9abd:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.CheckGlyph), null);
        case 0, $db933f3263da36b1$export$352da558a3a09227:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.UploadGlyph), null);
        case 0, $db933f3263da36b1$export$178cb2e5b5fc68e8:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.BitbucketBranchesGlyph), null);
        case 0, $db933f3263da36b1$export$a153e0417183b79:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.BitbucketCommitsGlyph), null);
        case 0, $db933f3263da36b1$export$555f9a88a8c5f309:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.BitbucketPullrequestsGlyph), null);
        case 0, $db933f3263da36b1$export$82a1ca282cb5e4e5:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.EmojiFrequentGlyph), null);
        case 0, $db933f3263da36b1$export$423cd243bf1888bc:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.MoreGlyph), null);
        case 0, $db933f3263da36b1$export$30a9be92cbb6f382:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.PersonGlyph), null);
        case 0, $db933f3263da36b1$export$d4ee7b46933c494f:
            return (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
                paddingInlineEnd: "space.050",
                paddingBlock: "space.025"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9F3sn))), {
                label: "",
                color: "currentColor"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.DueDateGlyph), null);
        default:
            throw Error(`Invalid Icon type - ${type}`);
    }
};
const $7b7d80576fbad589$var$CardIcon = (props)=>{
    const { label: label, primaryColor: primaryColor, type: type } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b7d80576fbad589$var$Container, {
        role: "img",
        "aria-label": label,
        primaryColor: primaryColor
    }, $7b7d80576fbad589$var$renderIcon(type));
};
var $7b7d80576fbad589$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
 = $7b7d80576fbad589$var$CardIcon;
const $7b7d80576fbad589$var$ContainerControl = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-1tuyf7k-0"
})((props)=>({
        display: 'inline-block',
        flexShrink: 0,
        lineHeight: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            verticalAlign: 'bottom',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: props.primaryColor || undefined
        }
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7b7d80576fbad589$var$ContainerExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { primaryColor: primaryColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_yk4yla": (0, $9t7rW.default)(__cmplp.primaryColor || undefined)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _1o9zidpf _vwz4kb7n _1veoyfq0 _1ksv19wz",
            __cmplp.className
        ])
    });
});
const $7b7d80576fbad589$var$Container = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $7b7d80576fbad589$var$ContainerExperiment, $7b7d80576fbad589$var$ContainerControl);

});
parcelRegister("9F3sn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db9feac5032e1f6cb5923640df1c100>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $708a9fcc46d58f4b$var$_react = $708a9fcc46d58f4b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $708a9fcc46d58f4b$var$_UNSAFE_baseNew = $708a9fcc46d58f4b$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $708a9fcc46d58f4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $708a9fcc46d58f4b$var$CalendarIcon = (props)=>/*#__PURE__*/ $708a9fcc46d58f4b$var$_react.default.createElement($708a9fcc46d58f4b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$708a9fcc46d58f4b$var$CalendarIcon.displayName = 'CalendarIcon';
var $708a9fcc46d58f4b$var$_default = module.exports.default = $708a9fcc46d58f4b$var$CalendarIcon;

});

parcelRegister("eWeL8", function(module, exports) {

$parcel$export(module.exports, "styledComponentWithCondition", () => $e0c5c7e39a960e0c$export$62d8d8fbf238d6af);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");
const $e0c5c7e39a960e0c$export$62d8d8fbf238d6af = (useCompiled, CompiledComponent, StyledComponent)=>// Couldn't destructure like {innerRef, ...rest} as
    // typescript is suspcious on destructing generics
    ({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });
const $e0c5c7e39a960e0c$export$f5b752428255ba78 = (useCompiled, CompiledComponent, StyledComponent)=>({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });

});

parcelRegister("8jchp", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesGlyph", () => $82b158e6c49496ac$export$e45c85830644abc5);
$parcel$export(module.exports, "FlagGlyph", () => $82b158e6c49496ac$export$cef8dc8280f1c02c);
$parcel$export(module.exports, "CheckGlyph", () => $82b158e6c49496ac$export$50963481dc57ac5c);
$parcel$export(module.exports, "UploadGlyph", () => $82b158e6c49496ac$export$330e95d855f0ff0);
$parcel$export(module.exports, "BitbucketBranchesGlyph", () => $82b158e6c49496ac$export$5aa1ec710367c05);
$parcel$export(module.exports, "BitbucketCommitsGlyph", () => $82b158e6c49496ac$export$4f751361dc2785a8);
$parcel$export(module.exports, "BitbucketPullrequestsGlyph", () => $82b158e6c49496ac$export$314907f846d12b79);
$parcel$export(module.exports, "EmojiFrequentGlyph", () => $82b158e6c49496ac$export$e6da30a8001300c0);
$parcel$export(module.exports, "MoreGlyph", () => $82b158e6c49496ac$export$f291c054d6e2e898);
$parcel$export(module.exports, "PersonGlyph", () => $82b158e6c49496ac$export$b59bd42a398a2b3c);
$parcel$export(module.exports, "DueDateGlyph", () => $82b158e6c49496ac$export$45e4820251213456);

var $eUqFw = parcelRequire("eUqFw");
const $82b158e6c49496ac$export$e45c85830644abc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 11h10a1 1 0 011 1v1H6v-1a1 1 0 011-1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5 18v1h4v-1H5zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2H5a2 2 0 01-2-2v-1a2 2 0 012-2zm10 2v1h4v-1h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2v-1a2 2 0 012-2zM10 5v1h4V5h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2V5a2 2 0 012-2z",
        fillRule: "nonzero"
    })));
const $82b158e6c49496ac$export$cef8dc8280f1c02c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.73 5.73 0 002.547-.567 1 1 0 00.563-.9V5.466a.998.998 0 00-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 006 5.466v6.769z",
        fill: "currentColor"
    }));
const $82b158e6c49496ac$export$50963481dc57ac5c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.735 12.322a1 1 0 00-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2335.638 2335.638 0 003.939-3.883l.04-.04a492.598 492.598 0 003.658-3.643 1 1 0 00-1.424-1.404 518.42 518.42 0 01-3.64 3.625l-.04.04a2049.114 2049.114 0 01-3.775 3.722l-3.098-3.363z",
        fill: "currentColor"
    }));
const $82b158e6c49496ac$export$330e95d855f0ff0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "24",
        width: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11.208 9.32L9.29 11.253a1 1 0 000 1.409.982.982 0 001.397 0l1.29-1.301 1.336 1.347a.982.982 0 001.397.001 1.002 1.002 0 00.001-1.408l-1.965-1.98a1.08 1.08 0 00-1.538-.001z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11 10.007l.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.938 5.481a4.8 4.8 0 00-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 014.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481z"
    })));
const $82b158e6c49496ac$export$5aa1ec710367c05 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3zM8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1zm-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $82b158e6c49496ac$export$4f751361dc2785a8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16 12c0-1.9-1.3-3.4-3-3.9V4c0-.6-.4-1-1-1s-1 .4-1 1v4.1c-1.7.4-3 2-3 3.9s1.3 3.4 3 3.9V20c0 .6.4 1 1 1s1-.4 1-1v-4.1c1.7-.5 3-2 3-3.9zm-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $82b158e6c49496ac$export$314907f846d12b79 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M18 15.2V11c0-1.7-1.3-3-3-3h-1.9l.8-.8c.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0l-2.3 2.3c-.3.4-.3.9 0 1.2l2.3 2.3c.2.2.3.2.5.2s.4-.1.6-.3c.3-.3.3-.8 0-1.1l-.7-.7H15c.6 0 1 .4 1 1v4.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8zM17 19c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM7 3C5.4 3 4 4.3 4 6c0 1.3.8 2.4 2 2.8V20c0 .6.4 1 1 1s1-.4 1-1V8.8c1.2-.4 2-1.5 2-2.8 0-1.7-1.3-3-3-3zm0 4c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $82b158e6c49496ac$export$e6da30a8001300c0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $82b158e6c49496ac$export$f291c054d6e2e898 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "5",
        cy: "12",
        r: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "19",
        cy: "12",
        r: "2"
    })));
const $82b158e6c49496ac$export$b59bd42a398a2b3c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "24",
        width: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0V14z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "12",
        cy: "7",
        r: "4"
    })));
const $82b158e6c49496ac$export$45e4820251213456 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0119.005 21H4.995A1.995 1.995 0 013 19.006V6.994C3 5.893 3.892 5 4.995 5zM5 9v9a1 1 0 001 1h12a1 1 0 001-1V9H5zm1-5a1 1 0 012 0v1H6V4zm10 0a1 1 0 012 0v1h-2V4zm-9 9v-2.001h2V13H7zm8 0v-2.001h2V13h-2zm-4 0v-2.001h2.001V13H11zm-4 4v-2h2v2H7zm4 0v-2h2.001v2H11zm4 0v-2h2v2h-2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));

});

const $db933f3263da36b1$export$3b43f1ca008dad23 = 'child-issues';
const $db933f3263da36b1$export$aac403da0d127706 = 'flag';
const $db933f3263da36b1$export$540a31b23d6b9abd = 'tick';
const $db933f3263da36b1$export$352da558a3a09227 = 'upload';
const $db933f3263da36b1$export$178cb2e5b5fc68e8 = 'bitbucket-branches';
const $db933f3263da36b1$export$a153e0417183b79 = 'bitbucket-commits';
const $db933f3263da36b1$export$555f9a88a8c5f309 = 'bitbucket-pullrequests';
const $db933f3263da36b1$export$82a1ca282cb5e4e5 = 'emoji-frequent';
const $db933f3263da36b1$export$423cd243bf1888bc = 'more';
const $db933f3263da36b1$export$30a9be92cbb6f382 = 'person';
const $db933f3263da36b1$export$d4ee7b46933c494f = 'due-date';


parcelRegister("9CYrO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $57887752e833b9f2$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $57887752e833b9f2$export$593a022a1631ee1e = 'Due Date: ';
const $57887752e833b9f2$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    text: {
        "id": "due-date.text",
        "defaultMessage": "Due Date: {date}"
    }
});

});


parcelRegister("4wx7G", function(module, exports) {

$parcel$export(module.exports, "CardKey", () => $a6fd5b79568ec04a$export$5bcc49a1014b751b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");


var $jl1we = parcelRequire("jl1we");

var $eWeL8 = parcelRequire("eWeL8");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $f5DAf = parcelRequire("f5DAf");

var $4S26w = parcelRequire("4S26w");
const $a6fd5b79568ec04a$export$5bcc49a1014b751b = /*#__PURE__*/ (0, $eUqFw.memo)(({ text: text, highlight: highlight = [], onClick: onClick, isDone: isDone = false, stopEventPropagation: stopEventPropagation = true, openInNewTab: openInNewTab = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const highlightedText = highlight && (0, $f5DAf.shouldHighlightText)(text, highlight) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f5DAf.HighlightText), {
        phrases: highlight,
        content: text
    }) : text;
    const onClickKey = (0, $eUqFw.useCallback)((event)=>{
        const isModifierClick = event.ctrlKey || event.altKey || event.metaKey || event.shiftKey;
        stopEventPropagation && event.stopPropagation();
        if (!isModifierClick && !openInNewTab) {
            event.preventDefault();
            onClick?.(event);
        }
    }, [
        onClick,
        openInNewTab,
        stopEventPropagation
    ]);
    // prevent the context menu and Bento from opening
    const onContextMenu = (0, $eUqFw.useCallback)((event)=>event.stopPropagation(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a6fd5b79568ec04a$export$42a852a2b6b56249, {
        "data-testid": "platform-card.common.ui.key.key"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a6fd5b79568ec04a$export$9048d548939551ee, {
        isLineThrough: Boolean(isDone),
        href: `/browse/${text}`,
        target: "_blank",
        onContextMenu: onContextMenu,
        onClick: onClickKey,
        ...Boolean(isDone) && {
            'aria-label': formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4S26w.default).labelIssueTermRefresh : (0, $4S26w.default).label, {
                issueKey: text
            })
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a6fd5b79568ec04a$export$cd0f44441c3b7719, null, highlightedText))));
});
var $a6fd5b79568ec04a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
 = $a6fd5b79568ec04a$export$5bcc49a1014b751b;
const $a6fd5b79568ec04a$var$StyledLinkControl = /*#__PURE__*/ (0, $kwce8.default).a.withConfig({
    componentId: "buhim-0"
})((props)=>({
        userSelect: 'initial',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-subtle, ${(0, $1b343b038f6c23ec$exports).N100})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        textDecoration: props.isLineThrough ? 'line-through' : 'none',
        '&:focus, &:hover, &:visited, &:link, &:active': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            textDecoration: props.isLineThrough ? 'line-through' : 'none'
        }
    }));
const $a6fd5b79568ec04a$var$StyledLinkExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLineThrough: isLineThrough, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_uizt1wug _syaz1o15",
            __cmplp.isLineThrough ? "_4bfu18uv _1hms1911 _ajmmnqa1" : "_4bfu18uv _1hmsglyw _ajmmnqa1",
            __cmplp.isLineThrough ? "_1nrm18uv _1a3b18uv _9oik18uv _5bd618uv _1ydc18uv _c2wa1911 _4fpr1911 _1bnx1911 _13jx1911 _1x281911 _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1" : "_1nrm18uv _1a3b18uv _9oik18uv _5bd618uv _1ydc18uv _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a6fd5b79568ec04a$export$9048d548939551ee = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $a6fd5b79568ec04a$var$StyledLinkExperiment, $a6fd5b79568ec04a$var$StyledLinkControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a6fd5b79568ec04a$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zkb7n _i0dl1wug _1eim1xrj _o5721q9c _1reo15vq _18m915vq _1e38mo4m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a6fd5b79568ec04a$export$cd0f44441c3b7719 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _1reo15vq _18m915vq _1bto1l2s _1wyb1crf _k48pni7l _syaz1o15",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4S26w", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d9870012944b968$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0d9870012944b968$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "platform-card.common.ui.key.key.styled-link.aria-label",
        "defaultMessage": "{issueKey} is resolved"
    },
    labelIssueTermRefresh: {
        "id": "platform-card.common.ui.key.key.styled-link.aria-label-issue-term-refresh",
        "defaultMessage": "{issueKey} is resolved"
    }
});

});


parcelRegister("huZle", function(module, exports) {

$parcel$export(module.exports, "CardLabels", () => $ab3523b8c4a6d48b$export$ece436c5ee6469bd);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8blac = parcelRequire("8blac");

var $jl1we = parcelRequire("jl1we");

var $fdpby = parcelRequire("fdpby");
const $ab3523b8c4a6d48b$var$CmpCardLabels = ({ labels: labels, highlight: highlight = [] })=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(labels) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab3523b8c4a6d48b$var$Overflow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: labels.join(', '),
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab3523b8c4a6d48b$var$Gradient, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab3523b8c4a6d48b$var$CmpContainer, null, labels.map((label, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fdpby.CardLabel), {
            key: index,
            text: label,
            highlight: highlight
        })))))) : null;
const $ab3523b8c4a6d48b$var$TmpCardLabels = ({ labels: labels, highlight: highlight = [] })=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(labels) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab3523b8c4a6d48b$var$Container, null, labels.map((label, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fdpby.CardLabel), {
            key: index,
            text: label,
            highlight: highlight
        }))) : null;
const $ab3523b8c4a6d48b$export$ece436c5ee6469bd = ({ labels: labels, isCMPBoard: isCMPBoard = false, highlight: highlight = [] })=>isCMPBoard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab3523b8c4a6d48b$var$CmpCardLabels, {
        labels: labels,
        highlight: highlight
    }) // now renders within custom fields
     : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab3523b8c4a6d48b$var$TmpCardLabels, {
        labels: labels,
        highlight: highlight
    });
var $ab3523b8c4a6d48b$export$2e2bcd8739ae039 = $ab3523b8c4a6d48b$export$ece436c5ee6469bd;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ab3523b8c4a6d48b$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_lcxvglyw _1e0c1txw _2lx2vrvc _1n261g80 _4cvr1h6o _18s8r5cr",
            __cmplp.className
        ])
    });
});
const $ab3523b8c4a6d48b$var$CmpContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c116y _18s8r5cr _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $ab3523b8c4a6d48b$var$Gradient = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _kqswh2mm _1reo15vq _18m915vq _aetrb3bt _15l2idpf _19doidpf _1ywu1ule _1qdg1osq _z0ai1osq _18postnw _qc5omo3v _16r23cth _e9q69hw4",
            __cmplp.className
        ])
    });
});
const $ab3523b8c4a6d48b$var$Overflow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fdpby", function(module, exports) {

$parcel$export(module.exports, "CardLabel", () => $ace01197462babc7$export$e13aaac4037b0914);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");
const $ace01197462babc7$export$e13aaac4037b0914 = (props)=>{
    const { text: text, highlight: highlight } = props;
    const isSelected = !!highlight && highlight.includes(text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ace01197462babc7$export$42a852a2b6b56249, {
        isSelected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ace01197462babc7$var$Content, null, text));
};
$ace01197462babc7$export$e13aaac4037b0914.defaultProps = {
    highlight: []
};
var $ace01197462babc7$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
 = $ace01197462babc7$export$e13aaac4037b0914;
const $ace01197462babc7$var$ContainerControl = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "xwxtfj-0"
})((props)=>({
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $c9TLT.gridSize) * 2.5}px`,
        margin: "var(--ds-space-050, 4px)",
        padding: 0,
        position: 'relative',
        cursor: 'default',
        lineHeight: 1,
        overflow: 'hidden',
        borderRadius: '3px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.isSelected ? "var(--ds-background-accent-blue-subtler, #B3D4FF)" : "var(--ds-background-neutral, #F4F5F7)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.isSelected ? "var(--ds-text-accent-blue, #0747A6)" : "var(--ds-text, #172B4D)"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ace01197462babc7$var$ContainerExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4t3igktf _18s81b66 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswh2mm _80om73ad _vwz4kb7n _1reo15vq _18m915vq _2rko1l7b",
            __cmplp.isSelected ? "_bfhkynhg" : "_bfhk1s4m",
            __cmplp.isSelected ? "_syazia9z" : "_syaz1fxt",
            __cmplp.className
        ])
    });
});
const $ace01197462babc7$export$42a852a2b6b56249 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $ace01197462babc7$var$ContainerExperiment, $ace01197462babc7$var$ContainerControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ace01197462babc7$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12fmgvx _1yt4u49m _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});


parcelRegister("byrHc", function(module, exports) {

$parcel$export(module.exports, "CardPriority", () => $46a41bceb74ea678$export$92d93d4ee23c212c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $jl1we = parcelRequire("jl1we");

var $c9TLT = parcelRequire("c9TLT");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $i5SoD = parcelRequire("i5SoD");
const $46a41bceb74ea678$export$92d93d4ee23c212c = (props)=>{
    const { name: name, uri: uri } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const priorityLevel = formatMessage((0, $i5SoD.default).priorityTooltip, {
        priorityLevel: name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46a41bceb74ea678$var$Icon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: priorityLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46a41bceb74ea678$export$3e431a229df88919, {
        alt: priorityLevel,
        src: uri
    })));
};
var $46a41bceb74ea678$export$2e2bcd8739ae039 = $46a41bceb74ea678$export$92d93d4ee23c212c;
const $46a41bceb74ea678$var$iconSize = (0, $c9TLT.gridSize) * 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $46a41bceb74ea678$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $46a41bceb74ea678$var$ImageControl = /*#__PURE__*/ (0, $kwce8.default).img.withConfig({
    componentId: "sc-18gtlq4-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$46a41bceb74ea678$var$iconSize}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${$46a41bceb74ea678$var$iconSize}px`,
    verticalAlign: 'text-bottom'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $46a41bceb74ea678$var$ImageExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _4t3i7vkz _s7n41ndm",
            __cmplp.className
        ])
    });
});
const $46a41bceb74ea678$export$3e431a229df88919 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $46a41bceb74ea678$var$ImageExperiment, $46a41bceb74ea678$var$ImageControl);

});
parcelRegister("i5SoD", function(module, exports) {

$parcel$export(module.exports, "default", () => $81b5977dca0a308e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $81b5977dca0a308e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    priorityTooltip: {
        "id": "platform-ui-card.common.priority.priority-tooltip",
        "defaultMessage": "{priorityLevel} priority"
    }
});

});


parcelRegister("2kYPS", function(module, exports) {

$parcel$export(module.exports, "CardSpinner", () => $cbc873aa655fa8e6$export$cbd2bb5b02f5fd3a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bBdMg = parcelRequire("bBdMg");

var $jl1we = parcelRequire("jl1we");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO6Wr = parcelRequire("lO6Wr");
const $cbc873aa655fa8e6$export$cbd2bb5b02f5fd3a = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const message = formatMessage((0, $lO6Wr.default).loading);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cbc873aa655fa8e6$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bBdMg.default), {
        label: message,
        size: "small"
    })));
};
var $cbc873aa655fa8e6$export$2e2bcd8739ae039 = $cbc873aa655fa8e6$export$cbd2bb5b02f5fd3a;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cbc873aa655fa8e6$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lO6Wr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d35efc65ef144f45$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d35efc65ef144f45$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    loading: {
        "id": "card.common.spinner.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("dq5k9", function(module, exports) {

$parcel$export(module.exports, "CardTick", () => $5fbf8d3f00f65718$export$711ec40e911e6898);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $jl1we = parcelRequire("jl1we");

var $5JgJ2 = parcelRequire("5JgJ2");

var $i0Rm4 = parcelRequire("i0Rm4");


var $j58hq = parcelRequire("j58hq");
const $5fbf8d3f00f65718$export$711ec40e911e6898 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const message = formatMessage((0, $j58hq.default).done);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5fbf8d3f00f65718$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0Rm4.default), {
        type: (0, $db933f3263da36b1$export$540a31b23d6b9abd),
        label: message,
        primaryColor: `var(--ds-icon-success, ${(0, $1b343b038f6c23ec$exports).G400})`
    })));
};
var $5fbf8d3f00f65718$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $5fbf8d3f00f65718$export$711ec40e911e6898;
const $5fbf8d3f00f65718$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j58hq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6db7fbf464b2de9b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6db7fbf464b2de9b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    done: {
        "id": "card.common.tick.done",
        "defaultMessage": "Done"
    }
});

});


parcelRegister("5lzG5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5178e356fbbfe64$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $k9isx = parcelRequire("k9isx");

var $40o1k = parcelRequire("40o1k");

var $iwbBD = parcelRequire("iwbBD");

var $69ay7 = parcelRequire("69ay7");

var $bwZEy = parcelRequire("bwZEy");

var $MxsGB = parcelRequire("MxsGB");

var $aa7ce = parcelRequire("aa7ce");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5TykG = parcelRequire("5TykG");

var $huZle = parcelRequire("huZle");

var $lO4Or = parcelRequire("lO4Or");

var $6BYzZ = parcelRequire("6BYzZ");

var $ib4WI = parcelRequire("ib4WI");

var $bZapc = parcelRequire("bZapc");
const $c5178e356fbbfe64$var$DATE_FORMAT_OPTIONS = {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
};
const $c5178e356fbbfe64$var$TimeStampCss = {
    whenDisplaySettingSwitchable: null
};
const $c5178e356fbbfe64$var$parentFieldRenderer = ({ field: field })=>field.type === (0, $ib4WI.BOARD_FIELD_PARENT) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId,
        noIndent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bwZEy.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aa7ce.HierarchyIcon), {
            size: 20
        }),
        text: `${field.parent?.key} ${field.parent?.summary}`
    }));
const $c5178e356fbbfe64$var$categoryFieldRenderer = ({ field: field })=>field.type === (0, $ib4WI.BOARD_FIELD_CATEGORY) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId,
        noIndent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$FieldLabel, {
        indent: true
    }, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$CategoryTagContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $MxsGB.default), {
        categoryName: field.category.name,
        categoryColor: field.category.color
    })));
const $c5178e356fbbfe64$var$componentFieldRenderer = ({ field: field })=>field.type === (0, $ib4WI.BOARD_FIELD_COMPONENTS) && field.value.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId,
        noIndent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$FieldLabel, {
        indent: true
    }, field.name), field.value.map((component)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bwZEy.default), {
            key: component,
            text: component
        })));
const $c5178e356fbbfe64$var$dateRenderer = ({ field: field, formatDate: formatDate })=>field.type === (0, $ib4WI.BOARD_FIELD_DATE) && field.value != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$FieldLabel, null, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $69ay7.default), null, formatDate((0, $6BYzZ.DateOnly).fromISODateString(field.value)))));
const $c5178e356fbbfe64$var$textAndNumberRenderer = ({ field: field, formatNumber: formatNumber })=>(field.type === (0, $ib4WI.BOARD_FIELD_TEXT) || field.type === (0, $ib4WI.BOARD_FIELD_FLOAT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$FieldLabel, null, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$SubtlestText, null, field.type === (0, $ib4WI.BOARD_FIELD_FLOAT) ? formatNumber(field.value) : field.value));
const $c5178e356fbbfe64$var$dateTimeRenderer = ({ field: field, TimeStampComponent: TimeStampComponent })=>field.type === (0, $ib4WI.BOARD_FIELD_DATE_TIME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId,
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$FieldLabel, null, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$TimeStampContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TimeStampComponent, {
        value: field.value,
        extraStyles: $c5178e356fbbfe64$var$TimeStampCss
    })));
const $c5178e356fbbfe64$var$userRenderer = ({ field: field })=>field.type === (0, $ib4WI.BOARD_FIELD_USER) && field.user && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$FieldLabel, null, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k9isx.default), {
        name: field.user.name,
        src: field.user.avatarURL ?? undefined,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$SubtlestText, null, field.user.name));
const $c5178e356fbbfe64$var$multiUserRenderer = ({ field: field })=>field.type === (0, $ib4WI.BOARD_FIELD_MULTI_USER) && field.users.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$FieldLabel, null, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $40o1k.default), {
        appearance: "stack",
        data: field.users.map((user)=>({
                name: user.name,
                src: user.avatarURL ?? undefined,
                enableTooltip: true
            })),
        maxCount: 10,
        size: "small"
    }), field.users.length === 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$SubtlestText, null, field.users[0].name));
const $c5178e356fbbfe64$var$selectFieldRenderer = ({ field: field })=>field.type === (0, $ib4WI.BOARD_FIELD_SELECT) && field.value.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$FieldLabel, null, field.name), field.value.length > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $huZle.CardLabels), {
        labels: field.value
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$SubtlestText, null, field.value[0]));
const $c5178e356fbbfe64$var$timeOriginalEstimateRenderer = ({ field: field })=>field.type === (0, $ib4WI.BOARD_FIELD_TIME_ORIGINAL_ESTIMATE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$InlineLabel, null, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$InlineContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iwbBD.default), null, field.value)));
const $c5178e356fbbfe64$var$FIELD_RENDERERS = {
    [(0, $ib4WI.BOARD_FIELD_PARENT)]: $c5178e356fbbfe64$var$parentFieldRenderer,
    [(0, $ib4WI.BOARD_FIELD_CATEGORY)]: $c5178e356fbbfe64$var$categoryFieldRenderer,
    [(0, $ib4WI.BOARD_FIELD_COMPONENTS)]: $c5178e356fbbfe64$var$componentFieldRenderer,
    [(0, $ib4WI.BOARD_FIELD_DATE)]: $c5178e356fbbfe64$var$dateRenderer,
    [(0, $ib4WI.BOARD_FIELD_TEXT)]: $c5178e356fbbfe64$var$textAndNumberRenderer,
    [(0, $ib4WI.BOARD_FIELD_USER)]: $c5178e356fbbfe64$var$userRenderer,
    [(0, $ib4WI.BOARD_FIELD_MULTI_USER)]: $c5178e356fbbfe64$var$multiUserRenderer,
    [(0, $ib4WI.BOARD_FIELD_SELECT)]: $c5178e356fbbfe64$var$selectFieldRenderer,
    [(0, $ib4WI.BOARD_FIELD_FLOAT)]: $c5178e356fbbfe64$var$textAndNumberRenderer,
    [(0, $ib4WI.BOARD_FIELD_STORY_POINTS)]: $c5178e356fbbfe64$var$textAndNumberRenderer,
    [(0, $ib4WI.BOARD_FIELD_TIME_ORIGINAL_ESTIMATE)]: $c5178e356fbbfe64$var$timeOriginalEstimateRenderer,
    [(0, $ib4WI.BOARD_FIELD_DATE_TIME)]: $c5178e356fbbfe64$var$dateTimeRenderer
};
const $c5178e356fbbfe64$var$FIELD_TYPE_ORDER = Object.keys($c5178e356fbbfe64$var$FIELD_RENDERERS);
const $c5178e356fbbfe64$var$EXCLUDED_SYSTEM_FIELDS = new Set([
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.DUE_DATE_TYPE),
    (0, $lO4Or.SUMMARY_TYPE)
]);
const $c5178e356fbbfe64$var$CardDetailFields = ({ issue: issue })=>{
    const selectedFields = (0, $bZapc.useSelectedFields)();
    const { formatDate: formatDateIntl, formatNumber: formatNumber } = (0, $5JgJ2.default)();
    const formatDate = (0, $eUqFw.useCallback)((date)=>date ? formatDateIntl(date.toLocalDate(), $c5178e356fbbfe64$var$DATE_FORMAT_OPTIONS) : '', [
        formatDateIntl
    ]);
    const fields = Object.values(issue.fields)?.filter((field)=>{
        /**
     * Filter out field based off the following criteria:
     * * If the field is not selected via customized card configuration
     * * If the field type is not in the FIELD_TYPE_ORDER (i.e. no renderer for field type available)
     * * If the field is in the EXCLUDED_SYSTEM_FIELDS
     */ if (!selectedFields[field.fieldId] || !$c5178e356fbbfe64$var$FIELD_TYPE_ORDER.includes(field.type) || $c5178e356fbbfe64$var$EXCLUDED_SYSTEM_FIELDS.has(field.fieldId)) return false;
        return true;
    }).sort((field1, field2)=>$c5178e356fbbfe64$var$FIELD_TYPE_ORDER.indexOf(field1.type) - $c5178e356fbbfe64$var$FIELD_TYPE_ORDER.indexOf(field2.type)).map((field)=>$c5178e356fbbfe64$var$FIELD_RENDERERS[field.type]?.({
            field: field,
            formatDate: formatDate,
            formatNumber: formatNumber,
            TimeStampComponent: (0, $5TykG.default)
        }) ?? null);
    return fields;
};
var $c5178e356fbbfe64$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($c5178e356fbbfe64$var$CardDetailFields);
const $c5178e356fbbfe64$var$DetailRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { noIndent: noIndent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80 _4cvr1h6o _gy1p1b66 _y08e1osq",
            __cmplp.noIndent ? "_18u0r5cr" : "_18u0ze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5178e356fbbfe64$var$FieldLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { indent: indent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1aqp _1bsb1osq _1bto1l2s _1reo15vq _18m915vq _o5721q9c _11c81vlj _k48p1wq8",
            __cmplp.indent ? "_18u01b66" : "_18u0ze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5178e356fbbfe64$var$InlineLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { indent: indent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1aqp _1bto1l2s _1reo15vq _18m915vq _o5721q9c _11c81vlj _k48p1wq8",
            __cmplp.indent ? "_18u01b66" : "_18u0ze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5178e356fbbfe64$var$InlineContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5178e356fbbfe64$var$SubtlestText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1be1 _11c8qk37",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5178e356fbbfe64$var$LozengeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5178e356fbbfe64$var$TimeStampContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _11c8qk37 _30l3jjyb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5178e356fbbfe64$var$CategoryTagContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0q1b66 _19bv1b66 _1ul9idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("40o1k", function(module, exports) {

$parcel$export(module.exports, "default", () => $1342b3c2c9207463$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $k9isx = parcelRequire("k9isx");


var $iyKES = parcelRequire("iyKES");

var $jRNJm = parcelRequire("jRNJm");

var $cUyTA = parcelRequire("cUyTA");

var $eruWR = parcelRequire("eruWR");

var $6ZA7b = parcelRequire("6ZA7b");

var $jl1we = parcelRequire("jl1we");

var $etqqr = parcelRequire("etqqr");

var $5ZUH7 = parcelRequire("5ZUH7");

var $6btx7 = parcelRequire("6btx7");

var $61KaA = parcelRequire("61KaA");

var $gTThn = parcelRequire("gTThn");

var $jHjkR = parcelRequire("jHjkR");

var $c6Av7 = parcelRequire("c6Av7");
const $1342b3c2c9207463$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $1342b3c2c9207463$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $c6Av7.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $c6Av7.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $1342b3c2c9207463$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $k9isx.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eUqFw.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $jRNJm.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $iyKES.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $iyKES.default;
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $0c63e13a9b7bc25f$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $0c63e13a9b7bc25f$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gTThn.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eruWR.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: (0, $6ZA7b.layers).modal(),
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6btx7.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $61KaA.default), {
                    onClick: (e)=>e.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $cUyTA.default), null, data.slice(max).map((avatar, index)=>$1342b3c2c9207463$var$getOverrides(overrides).AvatarGroupItem.render((0, $etqqr.default), {
                        avatar: avatar,
                        onAvatarClick: onAvatarClick,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $1342b3c2c9207463$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $jHjkR.default) : (0, $5ZUH7.default);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData, idx)=>{
        const callback = avatarData.onClick || onAvatarClick;
        const finalAvatar = $1342b3c2c9207463$var$getOverrides(overrides).Avatar.render(avatar, {
            ...avatarData,
            size: size,
            borderColor: borderColor || avatarData.borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event, analyticsEvent)=>{
                callback(event, analyticsEvent, idx);
            } : undefined,
            stackIndex: max - idx
        }, idx);
        return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $jl1we.default), {
            key: (0, $c6Av7.composeUniqueKey)(avatarData, idx),
            content: avatarData.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total));
};
var $1342b3c2c9207463$export$2e2bcd8739ae039 = $1342b3c2c9207463$var$AvatarGroup;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $0c63e13a9b7bc25f$export$390330c10ff2b9a1 = 'ArrowUp';
const $0c63e13a9b7bc25f$export$a80636c6f41931fe = 'ArrowDown';
const $0c63e13a9b7bc25f$export$4af703091671bc = 'Home';
const $0c63e13a9b7bc25f$export$e2bc30913faa5db7 = 'End';
const $0c63e13a9b7bc25f$export$10f6869ed0a7d75b = 'Tab';
const $0c63e13a9b7bc25f$export$8152f929a25a0ff4 = 'Enter';
const $0c63e13a9b7bc25f$export$e51a3576c045c8d5 = 'Space';
const $0c63e13a9b7bc25f$export$2bb790b9008907b4 = 'Escape';

parcelRegister("etqqr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d54d681b28aa779$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k9isx = parcelRequire("k9isx");

var $b5bNY = parcelRequire("b5bNY");

var $azeZS = parcelRequire("azeZS");
var $hFzXe = parcelRequire("hFzXe");
var $iCgyP = parcelRequire("iCgyP");

var $agsTr = parcelRequire("agsTr");
const $0d54d681b28aa779$var$AvatarGroupItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { avatar: avatar, onAvatarClick: onAvatarClick, testId: testId, index: index } = props;
    const { href: href, onClick: onClick, ...rest } = avatar;
    const itemRef = (0, $agsTr.default)();
    const CustomComponent = ({ children: children, ...props })=>{
        return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            type: "button",
            ...props
        }, children));
    };
    const AvatarIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k9isx.default), {
        ...rest,
        testId: testId && `${testId}--avatar`,
        borderColor: "transparent",
        size: "small",
        name: ""
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iCgyP.default), {
        ref: (0, $b5bNY.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: avatar.target,
        rel: avatar.target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, avatar.name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azeZS.default), {
        ref: (0, $b5bNY.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId
    }, avatar.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFzXe.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, avatar.name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0d54d681b28aa779$export$2e2bcd8739ae039 = $0d54d681b28aa779$var$AvatarGroupItem;

});
parcelRegister("agsTr", function(module, exports) {

$parcel$export(module.exports, "default", () => $70613ee8878191c3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6btx7 = parcelRequire("6btx7");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $70613ee8878191c3$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $6btx7.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $70613ee8878191c3$export$2e2bcd8739ae039 = $70613ee8878191c3$var$useRegisterItemWithFocusManager;

});
parcelRegister("6btx7", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $9b07b807d3bac2b1$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $9b07b807d3bac2b1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $iyKES = parcelRequire("iyKES");

var $dBpgo = parcelRequire("dBpgo");
const $9b07b807d3bac2b1$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $iyKES.default)
});
/**
 * Focus manager logic
 */ const $9b07b807d3bac2b1$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eUqFw.useEffect)(()=>{
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $dBpgo.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: (0, $dBpgo.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b07b807d3bac2b1$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $9b07b807d3bac2b1$export$2e2bcd8739ae039 = $9b07b807d3bac2b1$var$FocusManager;

});
parcelRegister("dBpgo", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ce9e76d0babc5f8$export$2e2bcd8739ae039);

const $6ce9e76d0babc5f8$var$actionMap = {
    [(0, $0c63e13a9b7bc25f$export$a80636c6f41931fe)]: 'next',
    [(0, $0c63e13a9b7bc25f$export$390330c10ff2b9a1)]: 'prev',
    [(0, $0c63e13a9b7bc25f$export$4af703091671bc)]: 'first',
    [(0, $0c63e13a9b7bc25f$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $6ce9e76d0babc5f8$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $6ce9e76d0babc5f8$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $6ce9e76d0babc5f8$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $6ce9e76d0babc5f8$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $6ce9e76d0babc5f8$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement && nextFocusableElement.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $6ce9e76d0babc5f8$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement && prevFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $6ce9e76d0babc5f8$var$getNextFocusableElement(refs, -1);
                nextFocusableElement && nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $6ce9e76d0babc5f8$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement && prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("5ZUH7", function(module, exports) {

$parcel$export(module.exports, "default", () => $085eea87ffedf080$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $085eea87ffedf080$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $085eea87ffedf080$var$gutter = "var(--ds-space-negative-050, -4px)";
const $085eea87ffedf080$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    isolation: 'isolate',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    listStyleType: 'none !important',
    marginInlineEnd: $085eea87ffedf080$var$gutter,
    marginInlineStart: $085eea87ffedf080$var$gutter
});
const $085eea87ffedf080$var$listItemStyles = {
    name: "3unxte",
    styles: "margin:var(--ds-space-0, 0px);margin-block-end:var(--ds-space-100, 8px);padding-inline-end:var(--ds-space-050, 4px);padding-inline-start:var(--ds-space-050, 4px)"
};
const $085eea87ffedf080$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $085eea87ffedf080$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $085eea87ffedf080$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$085eea87ffedf080$export$2e2bcd8739ae039 = $085eea87ffedf080$var$Grid;

});

parcelRegister("61KaA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6c9bfd9e0c76a18$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $aMFuZ = parcelRequire("aMFuZ");

var $6btx7 = parcelRequire("6btx7");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $f6c9bfd9e0c76a18$var$PopupAvatarGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, setInitialFocusRef: setInitialFocusRef, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $6btx7.FocusManagerContext));
    (0, $eUqFw.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $aMFuZ.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    }));
};
var $f6c9bfd9e0c76a18$export$2e2bcd8739ae039 = $f6c9bfd9e0c76a18$var$PopupAvatarGroup;

});

parcelRegister("gTThn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0a240941b37e1ea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8QbwU = parcelRequire("8QbwU");
var $k9isx = parcelRequire("k9isx");

var $gYrJM = parcelRequire("gYrJM");

const $c0a240941b37e1ea$var$buttonSizes = {
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xxlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $c0a240941b37e1ea$var$buttonActiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-selected, ${(0, $1b343b038f6c23ec$export$226de0355ed012f8)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 ${(0, $8QbwU.BORDER_WIDTH)}px ${`var(--ds-border-selected, ${(0, $1b343b038f6c23ec$export$e62e8919cca44969)})`}`,
        color: `var(--ds-text-selected, ${(0, $1b343b038f6c23ec$export$b3de0ae08da2ce64)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: `scale(${(0, $8QbwU.ACTIVE_SCALE_FACTOR)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $1b343b038f6c23ec$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text-selected, ${(0, $1b343b038f6c23ec$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $1b343b038f6c23ec$export$226de0355ed012f8)})`,
            color: `var(--ds-text-selected, ${(0, $1b343b038f6c23ec$export$b3de0ae08da2ce64)})`
        }
    }
});
const $c0a240941b37e1ea$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-neutral, ${(0, $1b343b038f6c23ec$export$9fdfb749e33cdf97)})`,
        color: `var(--ds-text, ${(0, $1b343b038f6c23ec$export$c39c0fe0f26207ae)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $1b343b038f6c23ec$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text, ${(0, $1b343b038f6c23ec$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $1b343b038f6c23ec$export$226de0355ed012f8)})`,
            color: `var(--ds-text, ${(0, $1b343b038f6c23ec$export$b3de0ae08da2ce64)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::after': {
            display: 'none'
        }
    }
});
const $c0a240941b37e1ea$var$MAX_DISPLAY_COUNT = 99;
const $c0a240941b37e1ea$var$MoreIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = (0, $gYrJM.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : `var(--ds-border-inverse, ${0, $1b343b038f6c23ec$export$29a4f05edc054374})`, size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $k9isx.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        ref: ref,
        onClick: onClickHander
    }, ({ testId: _, className: className, ref: ref, ...props })=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $byn9U.jsx)("button", {
            type: "submit",
            ...buttonProps,
            ...props,
            ref: ref,
            "data-testid": testId,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                font: $c0a240941b37e1ea$var$buttonSizes[size]
            },
            css: [
                $c0a240941b37e1ea$var$buttonStyles,
                isActive && $c0a240941b37e1ea$var$buttonActiveStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className
        }, "+", count > $c0a240941b37e1ea$var$MAX_DISPLAY_COUNT ? $c0a240941b37e1ea$var$MAX_DISPLAY_COUNT : count));
});
$c0a240941b37e1ea$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c0a240941b37e1ea$export$2e2bcd8739ae039 = $c0a240941b37e1ea$var$MoreIndicator;

});

parcelRegister("jHjkR", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b8ae58541ca35d1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8QbwU = parcelRequire("8QbwU");

var $6ZA7b = parcelRequire("6ZA7b");
const $3b8ae58541ca35d1$var$gutter = (0, $8QbwU.BORDER_WIDTH) * 2 + (0, $6ZA7b.gridSize)() / 2;
const $3b8ae58541ca35d1$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    isolation: 'isolate',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    listStyleType: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: $3b8ae58541ca35d1$var$gutter
});
const $3b8ae58541ca35d1$var$listItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: -$3b8ae58541ca35d1$var$gutter
});
const $3b8ae58541ca35d1$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $3b8ae58541ca35d1$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $3b8ae58541ca35d1$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3b8ae58541ca35d1$export$2e2bcd8739ae039 = $3b8ae58541ca35d1$var$Stack;

});

parcelRegister("c6Av7", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $67b1c57e57b147d0$export$b067756944994c79);
const $67b1c57e57b147d0$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});


parcelRegister("iwbBD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dacf987d4cffdb6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $gYrJM = parcelRequire("gYrJM");

var $80vF2 = parcelRequire("80vF2");
var $1JJay = parcelRequire("1JJay");
var $8Vv3m = parcelRequire("8Vv3m");

var $atHkE = parcelRequire("atHkE");
function $6dacf987d4cffdb6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6dacf987d4cffdb6$var$boxStyles = (0, $8Vv3m.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $6dacf987d4cffdb6$var$neutral300 = '#DDDEE1';
const $6dacf987d4cffdb6$var$red300 = '#FD9891';
const $6dacf987d4cffdb6$var$blue300 = '#8FB8F6';
const $6dacf987d4cffdb6$var$neutral1000 = '#292A2E';
const $6dacf987d4cffdb6$var$styles = {
    root: {
        name: "85bcg3",
        styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
    },
    added: {
        name: "4x7cmh",
        styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
    },
    default: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $6dacf987d4cffdb6$var$neutral300,
        color: $6dacf987d4cffdb6$var$neutral1000
    }),
    important: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $6dacf987d4cffdb6$var$red300,
        color: $6dacf987d4cffdb6$var$neutral1000
    }),
    primary: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $6dacf987d4cffdb6$var$blue300,
        color: $6dacf987d4cffdb6$var$neutral1000
    }),
    primaryInverted: {
        name: "1425qmy",
        styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
    },
    removed: {
        name: "10hiq01",
        styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
    }
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $6dacf987d4cffdb6$var$Badge = /*#__PURE__*/ (0, $eUqFw.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $gYrJM.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        css: [
            $6dacf987d4cffdb6$var$styles.root,
            $6dacf987d4cffdb6$var$styles[appearance]
        ],
        style: {
            background: style?.backgroundColor,
            color: style?.color
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1JJay.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === 'number' && max ? (0, $atHkE.formatValue)(children, max) : children));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $80vF2.default), {
        testId: testId,
        as: "span",
        backgroundColor: $6dacf987d4cffdb6$var$backgroundColors[appearance],
        xcss: $6dacf987d4cffdb6$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1JJay.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $6dacf987d4cffdb6$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $atHkE.formatValue)(children, max) : children));
});
$6dacf987d4cffdb6$var$Badge.displayName = 'Badge';
var $6dacf987d4cffdb6$export$2e2bcd8739ae039 = $6dacf987d4cffdb6$var$Badge;
const $6dacf987d4cffdb6$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $6dacf987d4cffdb6$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("atHkE", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $ba6c62df116a76d3$export$7c4d25c0c3217d8c);
function $ba6c62df116a76d3$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $ba6c62df116a76d3$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $ba6c62df116a76d3$var$getSafeValue(value);
    const safeMax = $ba6c62df116a76d3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("bwZEy", function(module, exports) {

$parcel$export(module.exports, "default", () => $de31638110306b7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1OaiV = parcelRequire("1OaiV");

var $a9W2D = parcelRequire("a9W2D");

var $5OYq7 = parcelRequire("5OYq7");
const $de31638110306b7b$var$SimpleTagComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $byn9U.jsx)((0, $5OYq7.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $1OaiV.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $byn9U.jsx)((0, $a9W2D.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $de31638110306b7b$var$SimpleTag = /*#__PURE__*/ (0, $eUqFw.memo)($de31638110306b7b$var$SimpleTagComponent);
var $de31638110306b7b$export$2e2bcd8739ae039 = $de31638110306b7b$var$SimpleTag;

});
parcelRegister("1OaiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $729ef976aaf71f1b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $gYrJM = parcelRequire("gYrJM");

var $1eZYk = parcelRequire("1eZYk");

var $buAmH = parcelRequire("buAmH");
function $729ef976aaf71f1b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $729ef976aaf71f1b$var$baseStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $1eZYk.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $1eZYk.defaultMargin),
    padding: "var(--ds-space-0, 0px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $1eZYk.cssVar).color.background.default})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $1eZYk.cssVar).borderRadius})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $1eZYk.cssVar).color.text.default})`,
    cursor: 'default'
});
const $729ef976aaf71f1b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $1eZYk.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $1eZYk.defaultMargin),
    position: 'relative',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
    border: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderColor: `var(${(0, $1eZYk.cssVar).color.borderColor})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    borderWidth: "var(--ds-border-width, 1px)",
    color: "var(--ds-text, #172B4D)",
    cursor: 'default',
    paddingInline: "var(--ds-space-050, 4px)"
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $729ef976aaf71f1b$var$interactiveStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $1eZYk.cssVar).color.background.hover})`
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $1eZYk.cssVar).color.background.active})`
    }
});
const $729ef976aaf71f1b$var$interactiveStyles = {
    name: "jcdcgl",
    styles: "&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #091E420F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #091E4224);}"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $729ef976aaf71f1b$var$focusRingStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 2px var(${(0, $1eZYk.cssVar).color.focusRing})`,
        outline: 'none'
    }
});
const $729ef976aaf71f1b$var$focusRingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        outline: `2px solid ${$buAmH.focusRingColors}`,
        outlineOffset: '2px '
    }
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $729ef976aaf71f1b$var$nonStandardLinkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $1eZYk.cssVar).color.text.active})`
    }
});
const $729ef976aaf71f1b$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? $buAmH.textColors['standardLink'] : $buAmH.textColors[color];
    const backgroundHoverColors = isRemovable && !isLink ? $buAmH.backgroundColors[color] : $buAmH.linkHoverBackgroundColors[color];
    const backgroundActiveColors = isRemovable && !isLink ? $buAmH.backgroundColors[color] : $buAmH.linkActiveBackgroundColors[color];
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...other,
        ref: ref,
        css: [
            (0, $gYrJM.fg)('platform-component-visual-refresh') ? $729ef976aaf71f1b$var$baseStyles : $729ef976aaf71f1b$var$baseStylesOld,
            isInteractive && ((0, $gYrJM.fg)('platform-component-visual-refresh') ? $729ef976aaf71f1b$var$focusRingStyles : $729ef976aaf71f1b$var$focusRingStylesOld),
            (0, $gYrJM.fg)('platform-component-visual-refresh') ? isLink && $729ef976aaf71f1b$var$interactiveStyles : undefined,
            !(0, $gYrJM.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && $729ef976aaf71f1b$var$nonStandardLinkStyles,
            !(0, $gYrJM.fg)('platform-component-visual-refresh') && isInteractive && $729ef976aaf71f1b$var$interactiveStylesOld
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $1eZYk.cssVar).color.borderColor]: $buAmH.borderColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $1eZYk.cssVar).color.text.default]: $buAmH.textColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $1eZYk.cssVar).color.text.hover]: $buAmH.textHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $1eZYk.cssVar).color.text.active]: $buAmH.textActiveColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $1eZYk.cssVar).color.text.link]: textLinkColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $1eZYk.cssVar).color.background.default]: $buAmH.backgroundColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $1eZYk.cssVar).color.background.hover]: backgroundHoverColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $1eZYk.cssVar).color.background.active]: backgroundActiveColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $1eZYk.cssVar).color.focusRing]: $buAmH.focusRingColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $1eZYk.cssVar).color.removeButton.default]: $buAmH.removeButtonColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $1eZYk.cssVar).color.removeButton.hover]: $buAmH.removeButtonHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $1eZYk.cssVar).borderRadius]: $buAmH.borderRadius[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$729ef976aaf71f1b$export$2e2bcd8739ae039 = $729ef976aaf71f1b$var$BaseTag;

});
parcelRegister("1eZYk", function(module, exports) {

$parcel$export(module.exports, "tagHeight", () => $49574d517908f0a3$export$5b2b1030a679f37);
$parcel$export(module.exports, "buttonWidthUnitless", () => $49574d517908f0a3$export$c6f3ea2b4cffd0ca);
$parcel$export(module.exports, "maxTextWidthUnitless", () => $49574d517908f0a3$export$2e3bcb01bf928995);
$parcel$export(module.exports, "maxTextWidth", () => $49574d517908f0a3$export$982d4a1a6de11130);
$parcel$export(module.exports, "defaultBorderRadius", () => $49574d517908f0a3$export$35d5d1e251b985cf);
$parcel$export(module.exports, "defaultRoundedBorderRadius", () => $49574d517908f0a3$export$c49771100fee18c8);
$parcel$export(module.exports, "defaultMargin", () => $49574d517908f0a3$export$6728fea658cfb92e);
$parcel$export(module.exports, "defaultTextPadding", () => $49574d517908f0a3$export$c2d03c4c68282362);
$parcel$export(module.exports, "textPaddingRight", () => $49574d517908f0a3$export$b5686dedf408caa0);
$parcel$export(module.exports, "textMarginLeft", () => $49574d517908f0a3$export$b824cac86306f7a2);
$parcel$export(module.exports, "cssVar", () => $49574d517908f0a3$export$8b4981022bd80a4e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $6ZA7b = parcelRequire("6ZA7b");
const $49574d517908f0a3$var$gridSizeValue = (0, $6ZA7b.gridSize)();
const $49574d517908f0a3$var$borderRadiusValue = (0, $6ZA7b.borderRadius)();
const $49574d517908f0a3$export$b4d89c3994664204 = 2.5 * $49574d517908f0a3$var$gridSizeValue;
const $49574d517908f0a3$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$49574d517908f0a3$export$b4d89c3994664204}px`})`;
const $49574d517908f0a3$export$c6f3ea2b4cffd0ca = $49574d517908f0a3$export$b4d89c3994664204; // button should be square
const $49574d517908f0a3$export$aba002ef70684916 = $49574d517908f0a3$export$5b2b1030a679f37; // button should be square
const $49574d517908f0a3$export$d5949a2c2ea9dcea = 25 * $49574d517908f0a3$var$gridSizeValue;
const $49574d517908f0a3$export$488fda99655ff65a = `${$49574d517908f0a3$export$d5949a2c2ea9dcea}px`;
const $49574d517908f0a3$export$2e3bcb01bf928995 = $49574d517908f0a3$export$d5949a2c2ea9dcea - $49574d517908f0a3$export$b4d89c3994664204;
const $49574d517908f0a3$export$982d4a1a6de11130 = `${$49574d517908f0a3$export$2e3bcb01bf928995}px`;
const $49574d517908f0a3$export$35d5d1e251b985cf = `${$49574d517908f0a3$var$borderRadiusValue}px`;
const $49574d517908f0a3$export$c49771100fee18c8 = `${$49574d517908f0a3$export$c6f3ea2b4cffd0ca / 2}px`;
const $49574d517908f0a3$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$49574d517908f0a3$var$gridSizeValue / 2}px`})`;
const $49574d517908f0a3$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$49574d517908f0a3$var$gridSizeValue / 2}px`})`;
const $49574d517908f0a3$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $49574d517908f0a3$var$gridSizeValue}px`})`;
const $49574d517908f0a3$export$b824cac86306f7a2 = $49574d517908f0a3$export$5b2b1030a679f37;
const $49574d517908f0a3$export$8b4981022bd80a4e = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        borderColor: '--ds-bc',
        focusRing: '--ds-cfr',
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        },
        removeButton: {
            default: '--ds-rb',
            hover: '--ds-rbh'
        }
    },
    borderRadius: '--ds-br'
};

});

parcelRegister("buAmH", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $f544195c501ef341$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $f544195c501ef341$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $f544195c501ef341$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $f544195c501ef341$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $f544195c501ef341$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $f544195c501ef341$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $f544195c501ef341$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $f544195c501ef341$export$2a31dbe82788f940);
$parcel$export(module.exports, "borderRadius", () => $f544195c501ef341$export$7a57f79000377ca2);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $f544195c501ef341$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $f544195c501ef341$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $f544195c501ef341$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $f544195c501ef341$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $f544195c501ef341$export$b03fbc2a369c563e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 

var $1eZYk = parcelRequire("1eZYk");
const $f544195c501ef341$export$daa0ace263cb20d2 = {
    standard: `var(--ds-text, ${$1b343b038f6c23ec$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-link, ${$1b343b038f6c23ec$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$1b343b038f6c23ec$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$1b343b038f6c23ec$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$1b343b038f6c23ec$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$1b343b038f6c23ec$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`
};
const $f544195c501ef341$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $f544195c501ef341$export$7c7104a5f052cab7 = {
    standard: `var(--ds-link, ${$1b343b038f6c23ec$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$1b343b038f6c23ec$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$1b343b038f6c23ec$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$1b343b038f6c23ec$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$1b343b038f6c23ec$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`
};
const $f544195c501ef341$export$382469baad253eb7 = {
    standard: `var(--ds-link-pressed, ${$1b343b038f6c23ec$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: `var(--ds-text-accent-gray, ${$1b343b038f6c23ec$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue-bolder, ${$1b343b038f6c23ec$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red-bolder, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow-bolder, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green-bolder, ${$1b343b038f6c23ec$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal-bolder, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple-bolder, ${$1b343b038f6c23ec$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: `var(--ds-text-accent-gray-bolder, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`
};
const $f544195c501ef341$export$b9d7c59a579c23c6 = {
    standard: `var(--ds-background-neutral, ${$1b343b038f6c23ec$export$9fdfb749e33cdf97})`,
    blue: `var(--ds-background-accent-blue-subtle, ${$1b343b038f6c23ec$export$ecfc1dff386a3e7a})`,
    red: `var(--ds-background-accent-red-subtle, ${$1b343b038f6c23ec$export$be802dd0d8b57f35})`,
    yellow: `var(--ds-background-accent-yellow-subtle, ${$1b343b038f6c23ec$export$5aae31392d72caaa})`,
    green: `var(--ds-background-accent-green-subtle, ${$1b343b038f6c23ec$export$747d86715d4175de})`,
    teal: `var(--ds-background-accent-teal-subtle, ${$1b343b038f6c23ec$export$69cb3ca10c1e330e})`,
    purple: `var(--ds-background-accent-purple-subtle, ${$1b343b038f6c23ec$export$6011520a64d9a187})`,
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: `var(--ds-background-accent-gray-subtle, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-background-accent-blue-subtler, ${$1b343b038f6c23ec$export$8c13c2ee36917869})`,
    redLight: `var(--ds-background-accent-red-subtler, ${$1b343b038f6c23ec$export$b34b069eff244586})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler, ${$1b343b038f6c23ec$export$1cc05bbbf340e559})`,
    greenLight: `var(--ds-background-accent-green-subtler, ${$1b343b038f6c23ec$export$afbce1382ec95f73})`,
    tealLight: `var(--ds-background-accent-teal-subtler, ${$1b343b038f6c23ec$export$776c9c497ef08533})`,
    purpleLight: `var(--ds-background-accent-purple-subtler, ${$1b343b038f6c23ec$export$4b0a4417ed59760f})`,
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: `var(--ds-background-accent-gray-subtler, ${$1b343b038f6c23ec$export$3e51e8f1440314ba})`
};
const $f544195c501ef341$export$4410079763249c74 = {
    standard: `var(--ds-background-neutral-hovered, ${$1b343b038f6c23ec$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-hovered, ${$1b343b038f6c23ec$export$8c13c2ee36917869})`,
    red: `var(--ds-background-accent-red-subtle-hovered, ${$1b343b038f6c23ec$export$b34b069eff244586})`,
    yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$1b343b038f6c23ec$export$1cc05bbbf340e559})`,
    green: `var(--ds-background-accent-green-subtle-hovered, ${$1b343b038f6c23ec$export$afbce1382ec95f73})`,
    teal: `var(--ds-background-accent-teal-subtle-hovered, ${$1b343b038f6c23ec$export$776c9c497ef08533})`,
    purple: `var(--ds-background-accent-purple-subtle-hovered, ${$1b343b038f6c23ec$export$4b0a4417ed59760f})`,
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: `var(--ds-background-accent-gray-subtle-hovered, ${$1b343b038f6c23ec$export$eece5f492e429f08})`,
    blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$1b343b038f6c23ec$export$226de0355ed012f8})`,
    redLight: `var(--ds-background-accent-red-subtler-hovered, ${$1b343b038f6c23ec$export$4b84fd0e2c617bd})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$1b343b038f6c23ec$export$41060a744ab0b7ae})`,
    greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$1b343b038f6c23ec$export$69a3bf21b9686c2b})`,
    tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$1b343b038f6c23ec$export$7a8f4d33f6f9772c})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$1b343b038f6c23ec$export$363e4475840015bb})`,
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$1b343b038f6c23ec$export$1ce2d1575d444ceb})`
};
const $f544195c501ef341$export$76be99c5e13e3566 = {
    standard: `var(--ds-background-neutral-pressed, ${$1b343b038f6c23ec$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-pressed, ${$1b343b038f6c23ec$export$226de0355ed012f8})`,
    red: `var(--ds-background-accent-red-subtle-pressed, ${$1b343b038f6c23ec$export$4b84fd0e2c617bd})`,
    yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$1b343b038f6c23ec$export$41060a744ab0b7ae})`,
    green: `var(--ds-background-accent-green-subtle-pressed, ${$1b343b038f6c23ec$export$69a3bf21b9686c2b})`,
    teal: `var(--ds-background-accent-teal-subtle-pressed, ${$1b343b038f6c23ec$export$7a8f4d33f6f9772c})`,
    purple: `var(--ds-background-accent-purple-subtle-pressed, ${$1b343b038f6c23ec$export$363e4475840015bb})`,
    grey: `var(--ds-background-accent-gray-subtle-pressed, ${$1b343b038f6c23ec$export$e2ef2124cf4024b1})`,
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$1b343b038f6c23ec$export$ecfc1dff386a3e7a})`,
    redLight: `var(--ds-background-accent-red-subtler-pressed, ${$1b343b038f6c23ec$export$be802dd0d8b57f35})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$1b343b038f6c23ec$export$5aae31392d72caaa})`,
    greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$1b343b038f6c23ec$export$747d86715d4175de})`,
    tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$1b343b038f6c23ec$export$69cb3ca10c1e330e})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$1b343b038f6c23ec$export$6011520a64d9a187})`,
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$1b343b038f6c23ec$export$8754fc7e6d8b3000})`
};
const $f544195c501ef341$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$1b343b038f6c23ec$export$ecfc1dff386a3e7a})`;
const $f544195c501ef341$export$7a57f79000377ca2 = {
    default: (0, $1eZYk.defaultBorderRadius),
    rounded: (0, $1eZYk.defaultRoundedBorderRadius)
};
const $f544195c501ef341$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$1b343b038f6c23ec$export$4b84fd0e2c617bd})`;
const $f544195c501ef341$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$1b343b038f6c23ec$export$4b84fd0e2c617bd})`;
const $f544195c501ef341$export$17d206ccea111bbb = `var(--ds-text-danger, ${$1b343b038f6c23ec$export$2837b5a1a71d5c02})`;
const $f544195c501ef341$export$f64c7641cbc22da7 = {
    standard: `var(--ds-text, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    red: `var(--ds-text-accent-red-bolder, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    green: `var(--ds-text-accent-green-bolder, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    lime: `var(--ds-text-accent-lime-bolder, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    magenta: `var(--ds-text-accent-magenta-bolder, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    orange: `var(--ds-text-accent-orange-bolder, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    grey: `var(--ds-text-accent-gray-bolder, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-text-accent-blue, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    redLight: `var(--ds-text-accent-red, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    tealLight: `var(--ds-text-accent-teal, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    limeLight: `var(--ds-text-accent-lime, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    magentaLight: `var(--ds-text-accent-magenta, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    orangeLight: `var(--ds-text-accent-orange, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    greyLight: `var(--ds-text-accent-gray, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`
};
const $f544195c501ef341$export$b03fbc2a369c563e = {
    standard: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    red: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    green: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    lime: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    magenta: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    orange: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$7d61b15e0da132af})`,
    grey: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$147899de772240ec})`,
    limeLight: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$147899de772240ec})`,
    magentaLight: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$147899de772240ec})`,
    orangeLight: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$147899de772240ec})`,
    greyLight: `var(--ds-text-danger, ${$1b343b038f6c23ec$export$c39c0fe0f26207ae})`
};

});


parcelRegister("a9W2D", function(module, exports) {

$parcel$export(module.exports, "default", () => $403c09162892b935$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $gYrJM = parcelRequire("gYrJM");

var $1eZYk = parcelRequire("1eZYk");
function $403c09162892b935$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $403c09162892b935$var$beforeElementStyles = {
    name: "cfjv6",
    styles: "display:flex;height:16px;align-items:center;justify-content:center;inset-block-start:var(--ds-space-0, 0px)"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $403c09162892b935$var$beforeElementStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $1eZYk.cssVar).borderRadius})`,
    insetBlockStart: "var(--ds-space-0, 0px)"
});
const $403c09162892b935$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $gYrJM.fg)('platform-component-visual-refresh') ? $403c09162892b935$var$beforeElementStyles : $403c09162892b935$var$beforeElementStylesOld
    }, elemBefore) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$403c09162892b935$export$2e2bcd8739ae039 = $403c09162892b935$var$Before;

});

parcelRegister("5OYq7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f009b6c85c68d78f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $gYrJM = parcelRequire("gYrJM");

var $1eZYk = parcelRequire("1eZYk");
function $f009b6c85c68d78f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $f009b6c85c68d78f$var$baseStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $1eZYk.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $1eZYk.defaultTextPadding),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineStart: (0, $1eZYk.defaultTextPadding),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $f009b6c85c68d78f$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $1eZYk.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $f009b6c85c68d78f$var$linkStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $1eZYk.cssVar).color.text.link})`,
    pointerEvents: 'auto',
    textDecoration: 'none',
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $1eZYk.cssVar).color.text.hover})`,
        textDecoration: 'underline'
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $1eZYk.cssVar).color.text.active})`,
        textDecoration: 'underline'
    },
    '&:focus': {
        outline: 'none'
    }
});
const $f009b6c85c68d78f$var$linkStyles = {
    name: "1e5oc06",
    styles: "color:var(--ds-text, #172B4D);pointer-events:auto;text-decoration:none;&:hover{color:var(--ds-text, #172B4D);text-decoration:underline;}&:active{color:var(--ds-text, #172B4D);text-decoration:underline;}&:focus{outline:none;}"
};
const $f009b6c85c68d78f$var$hasAfterStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $1eZYk.maxTextWidthUnitless) - (0, $1eZYk.buttonWidthUnitless)}px`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $1eZYk.textPaddingRight)
});
const $f009b6c85c68d78f$var$hasAfterStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $1eZYk.maxTextWidthUnitless) - (0, $1eZYk.buttonWidthUnitless)}px`
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $f009b6c85c68d78f$var$hasBeforeStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: (0, $1eZYk.textMarginLeft)
});
const $f009b6c85c68d78f$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $byn9U.jsx)(Link, {
        href: href,
        "data-color": color,
        css: [
            (0, $gYrJM.fg)('platform-component-visual-refresh') ? $f009b6c85c68d78f$var$baseStyles : $f009b6c85c68d78f$var$baseStylesOld,
            (0, $gYrJM.fg)('platform-component-visual-refresh') ? $f009b6c85c68d78f$var$linkStyles : $f009b6c85c68d78f$var$linkStylesOld,
            !(0, $gYrJM.fg)('platform-component-visual-refresh') && elemBefore && $f009b6c85c68d78f$var$hasBeforeStyles,
            isRemovable && (0, $gYrJM.fg)('platform-component-visual-refresh') ? $f009b6c85c68d78f$var$hasAfterStyles : undefined,
            isRemovable && !(0, $gYrJM.fg)('platform-component-visual-refresh') ? $f009b6c85c68d78f$var$hasAfterStylesOld : undefined
        ]
    }, text);
    else return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            (0, $gYrJM.fg)('platform-component-visual-refresh') ? $f009b6c85c68d78f$var$baseStyles : $f009b6c85c68d78f$var$baseStylesOld,
            !(0, $gYrJM.fg)('platform-component-visual-refresh') && elemBefore && $f009b6c85c68d78f$var$hasBeforeStyles,
            isRemovable && (0, $gYrJM.fg)('platform-component-visual-refresh') ? $f009b6c85c68d78f$var$hasAfterStyles : undefined,
            isRemovable && !(0, $gYrJM.fg)('platform-component-visual-refresh') ? $f009b6c85c68d78f$var$hasAfterStylesOld : undefined
        ]
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f009b6c85c68d78f$export$2e2bcd8739ae039 = $f009b6c85c68d78f$var$Content;

});


parcelRegister("MxsGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $575c3f5934e57f5b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $9zysr = parcelRequire("9zysr");

var $8rQuz = parcelRequire("8rQuz");

var $k7FjW = parcelRequire("k7FjW");
const $575c3f5934e57f5b$var$CategoryTag = ({ categoryName: categoryName, categoryColor: categoryColor, isInteractive: isInteractive = true })=>{
    const { textColor: textColor, backgroundColor: tagColor } = (0, $k7FjW.getColorMetadata)(categoryColor);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($575c3f5934e57f5b$var$CategoryTagWrapper, {
        isInteractive: isInteractive,
        textColor: (0, $8rQuz.isVisualRefreshEnabled)() ? "var(--ds-text, #172B4D)" : textColor,
        "aria-label": categoryName,
        "data-testid": "business-categories.ui.category-form.category-tag.category-tag-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($575c3f5934e57f5b$var$StyledTag, {
        color: tagColor
    }, categoryName));
};
var $575c3f5934e57f5b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($575c3f5934e57f5b$var$CategoryTag);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $575c3f5934e57f5b$var$CategoryTagWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { textColor: textColor, isInteractive: isInteractive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qrlcdp": (0, $9t7rW.default)(__cmplp.textColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _1bah1e5h _4cvr1h6o _v564188d _p12f1osq _1ul9idpf _1tkeidpf _syazijt0",
            __cmplp.isInteractive ? "_d0altlke" : "_d0al73ad",
            __cmplp.className
        ])
    });
});
const $575c3f5934e57f5b$var$StyledTagOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rkoiti9 _bfhk1cj8 _1yt41b66 _11c81oud _vwz4dlk8 _1bto1l2s _o5721q9c _1reo15vq _18m915vq _p12f1osq",
            __cmplp.className
        ])
    });
});
const $575c3f5934e57f5b$var$StyledTagNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_14v0t1n": (0, $9t7rW.default)(`1px solid ${__cmplp.color}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko5n0m _bfhk18uv _19it11we _1yt4u49m _11c81oud _vwz4dlk8 _1bto1l2s _o5721q9c _1reo15vq _18m915vq _p12f1osq",
            __cmplp.className
        ])
    });
});
const $575c3f5934e57f5b$var$StyledTag = (0, $9zysr.componentWithCondition)((0, $8rQuz.isVisualRefreshEnabled), $575c3f5934e57f5b$var$StyledTagNew, $575c3f5934e57f5b$var$StyledTagOld);

});
parcelRegister("k7FjW", function(module, exports) {

$parcel$export(module.exports, "getRandomColor", () => $0ce9d8c1415fa16c$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $0ce9d8c1415fa16c$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $0ce9d8c1415fa16c$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $0ce9d8c1415fa16c$export$49fce7fdcf55f26d);

var $fwFhq = parcelRequire("fwFhq");
const $0ce9d8c1415fa16c$export$e4369cabd7e84cd9 = ()=>{
    const randomIndex = Math.floor(Math.random() * (0, $fwFhq.CATEGORY_THEMES).length);
    return (0, $fwFhq.CATEGORY_THEMES)[randomIndex].name;
};
const $0ce9d8c1415fa16c$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $fwFhq.CATEGORY_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $0ce9d8c1415fa16c$export$9eff62e8ee2aaa2c = (colorName)=>(0, $fwFhq.CATEGORY_THEMES).find((item)=>item.name === colorName)?.backgroundColor ?? '';
const $0ce9d8c1415fa16c$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $fwFhq.GREY_LIGHTEST_META;
    return (0, $fwFhq.CATEGORY_THEMES).find((item)=>item.name === colorName) ?? (0, $fwFhq.GREY_LIGHTEST_META);
};
const $0ce9d8c1415fa16c$export$4ef6b7574883e63d = ()=>(0, $fwFhq.CATEGORY_THEMES).map((item)=>item.name);

});
parcelRegister("fwFhq", function(module, exports) {

$parcel$export(module.exports, "GREY_LIGHTEST_META", () => $592872c1ad972acf$export$cb19a604bb399a88);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $592872c1ad972acf$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $592872c1ad972acf$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "CATEGORY_THEMES", () => $592872c1ad972acf$export$845e69f3af4133a6);


var $jwyl8 = parcelRequire("jwyl8");

var $kzlGv = parcelRequire("kzlGv");
const $592872c1ad972acf$export$cb19a604bb399a88 = {
    name: 'GREY_LIGHTEST',
    backgroundColor: `var(--ds-background-neutral, ${$jwyl8.N100})`,
    textColor: `var(--ds-text-accent-gray-bolder, ${(0, $1b343b038f6c23ec$exports).N900})`,
    messageLabel: (0, $kzlGv.default).greyLightest
};
const $592872c1ad972acf$export$7c3ad8ed1eaec359 = {
    name: 'GREY_LIGHTER',
    backgroundColor: `var(--ds-background-neutral-hovered, ${$jwyl8.N200})`,
    textColor: `var(--ds-text-accent-gray-bolder, ${(0, $1b343b038f6c23ec$exports).N900})`,
    messageLabel: (0, $kzlGv.default).greyLighter
};
const $592872c1ad972acf$export$11b75436f568ab00 = {
    name: 'GREY',
    backgroundColor: `var(--ds-background-neutral-pressed, ${$jwyl8.N300})`,
    textColor: `var(--ds-text-accent-gray-bolder, ${(0, $1b343b038f6c23ec$exports).N900})`,
    messageLabel: (0, $kzlGv.default).grey
};
const $592872c1ad972acf$export$680a025ac49fcedd = {
    name: 'GREY_DARKER',
    backgroundColor: `var(--ds-background-neutral-bold, ${$jwyl8.N400})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).greyDarker
};
const $592872c1ad972acf$export$c63acd769779da32 = {
    name: 'GREY_DARKEST',
    backgroundColor: `var(--ds-background-neutral-bold-pressed, ${$jwyl8.N500})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).greyDarkest
};
const $592872c1ad972acf$export$d6bc0064d6a00b4b = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-purple-subtlest, ${$jwyl8.P100})`,
    textColor: `var(--ds-text-accent-purple-bolder, ${$jwyl8.P500})`,
    messageLabel: (0, $kzlGv.default).purpleLightest
};
const $592872c1ad972acf$export$7a53a04457b57cc7 = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: `var(--ds-background-accent-purple-subtler, ${$jwyl8.P200})`,
    textColor: `var(--ds-text-accent-purple-bolder, ${$jwyl8.P500})`,
    messageLabel: (0, $kzlGv.default).purpleLighter
};
const $592872c1ad972acf$export$d6f3928d12bf329c = {
    name: 'PURPLE',
    backgroundColor: `var(--ds-background-accent-purple-subtle, ${$jwyl8.P300})`,
    textColor: `var(--ds-text-accent-purple-bolder, ${$jwyl8.P500})`,
    messageLabel: (0, $kzlGv.default).purple
};
const $592872c1ad972acf$export$7c314e2461a7241b = {
    name: 'PURPLE_DARKER',
    backgroundColor: `var(--ds-text-accent-purple, ${$jwyl8.P400})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).purpleDarker
};
const $592872c1ad972acf$export$5e3ecd219265b1d5 = {
    name: 'PURPLE_DARKEST',
    backgroundColor: `var(--ds-text-accent-purple-bolder, ${$jwyl8.P500})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).purpleDarkest
};
const $592872c1ad972acf$export$4b98b31eae42f719 = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-blue-subtlest, ${$jwyl8.B100})`,
    textColor: `var(--ds-text-accent-blue-bolder, ${$jwyl8.B500})`,
    messageLabel: (0, $kzlGv.default).blueLightest
};
const $592872c1ad972acf$export$e92a5b8219b97745 = {
    name: 'BLUE_LIGHTER',
    backgroundColor: `var(--ds-background-accent-blue-subtler, ${$jwyl8.B200})`,
    textColor: `var(--ds-text-accent-blue-bolder, ${$jwyl8.B500})`,
    messageLabel: (0, $kzlGv.default).blueLighter
};
const $592872c1ad972acf$export$b761714c24fd7f1c = {
    name: 'BLUE',
    backgroundColor: `var(--ds-background-accent-blue-subtle, ${$jwyl8.B300})`,
    textColor: `var(--ds-text-accent-blue-bolder, ${$jwyl8.B500})`,
    messageLabel: (0, $kzlGv.default).blue
};
const $592872c1ad972acf$export$50b37b24459ab9d9 = {
    name: 'BLUE_DARKER',
    backgroundColor: `var(--ds-text-accent-blue, ${$jwyl8.B400})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).blueDarker
};
const $592872c1ad972acf$export$69c4eac71b813fba = {
    name: 'BLUE_DARKEST',
    backgroundColor: `var(--ds-text-accent-blue-bolder, ${$jwyl8.B500})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).blueDarkest
};
const $592872c1ad972acf$export$1fe5b156c0ba3acb = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-teal-subtlest, ${$jwyl8.T100})`,
    textColor: `var(--ds-text-accent-teal-bolder, ${$jwyl8.T500})`,
    messageLabel: (0, $kzlGv.default).tealLightest
};
const $592872c1ad972acf$export$fb40f4c2f659b9bb = {
    name: 'TEAL_LIGHTER',
    backgroundColor: `var(--ds-background-accent-teal-subtler, ${$jwyl8.T200})`,
    textColor: `var(--ds-text-accent-teal-bolder, ${$jwyl8.T500})`,
    messageLabel: (0, $kzlGv.default).tealLighter
};
const $592872c1ad972acf$export$d177e878b5837287 = {
    name: 'TEAL',
    backgroundColor: `var(--ds-background-accent-teal-subtle, ${$jwyl8.T300})`,
    textColor: `var(--ds-text-accent-teal-bolder, ${$jwyl8.T500})`,
    messageLabel: (0, $kzlGv.default).teal
};
const $592872c1ad972acf$export$6daaa1cc3f46f41 = {
    name: 'TEAL_DARKER',
    backgroundColor: `var(--ds-text-accent-teal, ${$jwyl8.T400})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).tealDarker
};
const $592872c1ad972acf$export$fc1c501cf599d75a = {
    name: 'TEAL_DARKEST',
    backgroundColor: `var(--ds-text-accent-teal-bolder, ${$jwyl8.T500})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).tealDarkest
};
const $592872c1ad972acf$export$d977521f30fbcdeb = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-green-subtlest, ${$jwyl8.G100})`,
    textColor: `var(--ds-text-accent-green-bolder, ${$jwyl8.G500})`,
    messageLabel: (0, $kzlGv.default).greenLightest
};
const $592872c1ad972acf$export$911ea8fce963369 = {
    name: 'GREEN_LIGHTER',
    backgroundColor: `var(--ds-background-accent-green-subtler, ${$jwyl8.G200})`,
    textColor: `var(--ds-text-accent-green-bolder, ${$jwyl8.G500})`,
    messageLabel: (0, $kzlGv.default).greenLighter
};
const $592872c1ad972acf$export$814f677491d6ea0d = {
    name: 'GREEN',
    backgroundColor: `var(--ds-background-accent-green-subtle, ${$jwyl8.G300})`,
    textColor: `var(--ds-text-accent-green-bolder, ${$jwyl8.G500})`,
    messageLabel: (0, $kzlGv.default).green
};
const $592872c1ad972acf$export$376a849da12d546d = {
    name: 'GREEN_DARKER',
    backgroundColor: `var(--ds-background-accent-green-bolder, ${$jwyl8.G400})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).greenDarker
};
const $592872c1ad972acf$export$808ba7d394e8f2c4 = {
    name: 'GREEN_DARKEST',
    backgroundColor: `var(--ds-text-accent-green-bolder, ${$jwyl8.G500})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).greenDarkest
};
const $592872c1ad972acf$export$46ad9119b0fbf094 = {
    name: 'LIME_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-lime-subtlest, ${$jwyl8.L100})`,
    textColor: `var(--ds-text-accent-lime-bolder, ${$jwyl8.L500})`,
    messageLabel: (0, $kzlGv.default).limeLightest
};
const $592872c1ad972acf$export$e5e5e485aa3ce630 = {
    name: 'LIME_LIGHTER',
    backgroundColor: `var(--ds-background-accent-lime-subtler, ${$jwyl8.L200})`,
    textColor: `var(--ds-text-accent-lime-bolder, ${$jwyl8.L500})`,
    messageLabel: (0, $kzlGv.default).limeLighter
};
const $592872c1ad972acf$export$166a57cda148857c = {
    name: 'LIME',
    backgroundColor: `var(--ds-background-accent-lime-subtle, ${$jwyl8.L300})`,
    textColor: `var(--ds-text-accent-lime-bolder, ${$jwyl8.L500})`,
    messageLabel: (0, $kzlGv.default).lime
};
const $592872c1ad972acf$export$40663533c0b649cc = {
    name: 'LIME_DARKER',
    backgroundColor: `var(--ds-text-accent-lime, ${$jwyl8.L400})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).limeDarker
};
const $592872c1ad972acf$export$78557ba4a4ffc502 = {
    name: 'LIME_DARKEST',
    backgroundColor: `var(--ds-text-accent-lime-bolder, ${$jwyl8.L500})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).limeDarkest
};
const $592872c1ad972acf$export$12021cfc394e311e = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-yellow-subtlest, ${$jwyl8.Y100})`,
    textColor: `var(--ds-text-accent-yellow-bolder, ${$jwyl8.Y500})`,
    messageLabel: (0, $kzlGv.default).yellowLightest
};
const $592872c1ad972acf$export$eab7ec7309efe3db = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: `var(--ds-background-accent-yellow-subtler, ${$jwyl8.Y200})`,
    textColor: `var(--ds-text-accent-yellow-bolder, ${$jwyl8.Y500})`,
    messageLabel: (0, $kzlGv.default).yellowLighter
};
const $592872c1ad972acf$export$8d5b340327da7fa3 = {
    name: 'YELLOW',
    backgroundColor: `var(--ds-background-accent-yellow-subtle, ${$jwyl8.Y300})`,
    textColor: `var(--ds-text-accent-yellow-bolder, ${$jwyl8.Y500})`,
    messageLabel: (0, $kzlGv.default).yellow
};
const $592872c1ad972acf$export$b0a7a0813708318e = {
    name: 'YELLOW_DARKER',
    backgroundColor: `var(--ds-text-accent-yellow, ${$jwyl8.Y400})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).yellowDarker
};
const $592872c1ad972acf$export$dde9759b2d3b0e02 = {
    name: 'YELLOW_DARKEST',
    backgroundColor: `var(--ds-text-accent-yellow-bolder, ${$jwyl8.Y500})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).yellowDarkest
};
const $592872c1ad972acf$export$4718b8cf3799954b = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-orange-subtlest, ${$jwyl8.O100})`,
    textColor: `var(--ds-text-accent-orange-bolder, ${$jwyl8.O500})`,
    messageLabel: (0, $kzlGv.default).orangeLightest
};
const $592872c1ad972acf$export$8fac1fdda0aa4e41 = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: `var(--ds-background-accent-orange-subtler, ${$jwyl8.O200})`,
    textColor: `var(--ds-text-accent-orange-bolder, ${$jwyl8.O500})`,
    messageLabel: (0, $kzlGv.default).orangeLighter
};
const $592872c1ad972acf$export$2efe350451bcec02 = {
    name: 'ORANGE',
    backgroundColor: `var(--ds-background-accent-orange-subtle, ${$jwyl8.O300})`,
    textColor: `var(--ds-text-accent-orange-bolder, ${$jwyl8.O500})`,
    messageLabel: (0, $kzlGv.default).orange
};
const $592872c1ad972acf$export$5ba9bd795da8d7d5 = {
    name: 'ORANGE_DARKER',
    backgroundColor: `var(--ds-background-accent-orange-bolder, ${$jwyl8.O400})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).orangeDarker
};
const $592872c1ad972acf$export$93a7b89503a97d81 = {
    name: 'ORANGE_DARKEST',
    backgroundColor: `var(--ds-text-accent-orange-bolder, ${$jwyl8.O500})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).orangeDarkest
};
const $592872c1ad972acf$export$56873b0b30501dbe = {
    name: 'RED_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-red-subtlest, ${$jwyl8.R100})`,
    textColor: `var(--ds-text-accent-red-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).redLightest
};
const $592872c1ad972acf$export$344aa49a80760380 = {
    name: 'RED_LIGHTER',
    backgroundColor: `var(--ds-background-accent-red-subtler, ${$jwyl8.R200})`,
    textColor: `var(--ds-text-accent-red-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).redLighter
};
const $592872c1ad972acf$export$c760bedaf9085f90 = {
    name: 'RED',
    backgroundColor: `var(--ds-background-accent-red-subtle, ${$jwyl8.R300})`,
    textColor: `var(--ds-text-accent-red-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).red
};
const $592872c1ad972acf$export$38493b731be63d77 = {
    name: 'RED_DARKER',
    backgroundColor: `var(--ds-background-accent-red-bolder, ${$jwyl8.R400})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).redDarker
};
const $592872c1ad972acf$export$dda419d8311f8d4a = {
    name: 'RED_DARKEST',
    backgroundColor: `var(--ds-text-accent-red-bolder, ${$jwyl8.R500})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).redDarkest
};
const $592872c1ad972acf$export$e0957dc0d569e65f = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-magenta-subtlest, ${$jwyl8.M100})`,
    textColor: `var(--ds-text-accent-magenta-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).magentaLightest
};
const $592872c1ad972acf$export$299af16a857bf4ca = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: `var(--ds-background-accent-magenta-subtler, ${$jwyl8.M200})`,
    textColor: `var(--ds-text-accent-magenta-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).magentaLighter
};
const $592872c1ad972acf$export$d7208e47aa15bafe = {
    name: 'MAGENTA',
    backgroundColor: `var(--ds-background-accent-magenta-subtle-hovered, ${$jwyl8.M300})`,
    textColor: `var(--ds-text-accent-magenta-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).magenta
};
const $592872c1ad972acf$export$b3aea5a31105d4e3 = {
    name: 'MAGENTA_DARKER',
    backgroundColor: `var(--ds-text-accent-magenta, ${$jwyl8.M400})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).magentaDarker
};
const $592872c1ad972acf$export$faf43e54615bce6b = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: `var(--ds-text-accent-magenta-bolder, ${$jwyl8.M500})`,
    textColor: `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`,
    messageLabel: (0, $kzlGv.default).magentaDarkest
};
const $592872c1ad972acf$export$270aee965367aeb3 = `var(--ds-text-inverse, ${(0, $1b343b038f6c23ec$exports).N0})`;
const $592872c1ad972acf$export$941ef40ef5fdd2b1 = `var(--ds-text, ${(0, $1b343b038f6c23ec$exports).N500})`;
const $592872c1ad972acf$export$845e69f3af4133a6 = [
    $592872c1ad972acf$export$cb19a604bb399a88,
    $592872c1ad972acf$export$d6bc0064d6a00b4b,
    $592872c1ad972acf$export$4b98b31eae42f719,
    $592872c1ad972acf$export$1fe5b156c0ba3acb,
    $592872c1ad972acf$export$d977521f30fbcdeb,
    $592872c1ad972acf$export$46ad9119b0fbf094,
    $592872c1ad972acf$export$12021cfc394e311e,
    $592872c1ad972acf$export$4718b8cf3799954b,
    $592872c1ad972acf$export$56873b0b30501dbe,
    $592872c1ad972acf$export$e0957dc0d569e65f,
    $592872c1ad972acf$export$7c3ad8ed1eaec359,
    $592872c1ad972acf$export$7a53a04457b57cc7,
    $592872c1ad972acf$export$e92a5b8219b97745,
    $592872c1ad972acf$export$fb40f4c2f659b9bb,
    $592872c1ad972acf$export$911ea8fce963369,
    $592872c1ad972acf$export$e5e5e485aa3ce630,
    $592872c1ad972acf$export$eab7ec7309efe3db,
    $592872c1ad972acf$export$8fac1fdda0aa4e41,
    $592872c1ad972acf$export$344aa49a80760380,
    $592872c1ad972acf$export$299af16a857bf4ca,
    $592872c1ad972acf$export$11b75436f568ab00,
    $592872c1ad972acf$export$d6f3928d12bf329c,
    $592872c1ad972acf$export$b761714c24fd7f1c,
    $592872c1ad972acf$export$d177e878b5837287,
    $592872c1ad972acf$export$814f677491d6ea0d,
    $592872c1ad972acf$export$166a57cda148857c,
    $592872c1ad972acf$export$8d5b340327da7fa3,
    $592872c1ad972acf$export$2efe350451bcec02,
    $592872c1ad972acf$export$c760bedaf9085f90,
    $592872c1ad972acf$export$d7208e47aa15bafe,
    $592872c1ad972acf$export$680a025ac49fcedd,
    $592872c1ad972acf$export$7c314e2461a7241b,
    $592872c1ad972acf$export$50b37b24459ab9d9,
    $592872c1ad972acf$export$6daaa1cc3f46f41,
    $592872c1ad972acf$export$376a849da12d546d,
    $592872c1ad972acf$export$40663533c0b649cc,
    $592872c1ad972acf$export$b0a7a0813708318e,
    $592872c1ad972acf$export$5ba9bd795da8d7d5,
    $592872c1ad972acf$export$38493b731be63d77,
    $592872c1ad972acf$export$b3aea5a31105d4e3,
    $592872c1ad972acf$export$c63acd769779da32,
    $592872c1ad972acf$export$5e3ecd219265b1d5,
    $592872c1ad972acf$export$69c4eac71b813fba,
    $592872c1ad972acf$export$fc1c501cf599d75a,
    $592872c1ad972acf$export$808ba7d394e8f2c4,
    $592872c1ad972acf$export$78557ba4a4ffc502,
    $592872c1ad972acf$export$dde9759b2d3b0e02,
    $592872c1ad972acf$export$93a7b89503a97d81,
    $592872c1ad972acf$export$dda419d8311f8d4a,
    $592872c1ad972acf$export$faf43e54615bce6b
];

});
parcelRegister("jwyl8", function(module, exports) {

$parcel$export(module.exports, "N100", () => $cccad9dbca818926$export$d6447c357493214f);
$parcel$export(module.exports, "N200", () => $cccad9dbca818926$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $cccad9dbca818926$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "N400", () => $cccad9dbca818926$export$eece5f492e429f08);
$parcel$export(module.exports, "N500", () => $cccad9dbca818926$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "P100", () => $cccad9dbca818926$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $cccad9dbca818926$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $cccad9dbca818926$export$b48405b95304b5a1);
$parcel$export(module.exports, "P400", () => $cccad9dbca818926$export$c71e4279dd54a18d);
$parcel$export(module.exports, "P500", () => $cccad9dbca818926$export$147899de772240ec);
$parcel$export(module.exports, "B100", () => $cccad9dbca818926$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B200", () => $cccad9dbca818926$export$215b7063051591f1);
$parcel$export(module.exports, "B300", () => $cccad9dbca818926$export$e62e8919cca44969);
$parcel$export(module.exports, "B400", () => $cccad9dbca818926$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $cccad9dbca818926$export$a6ee3d71bc067634);
$parcel$export(module.exports, "T100", () => $cccad9dbca818926$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $cccad9dbca818926$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $cccad9dbca818926$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T400", () => $cccad9dbca818926$export$7c835c78b6fcdef8);
$parcel$export(module.exports, "T500", () => $cccad9dbca818926$export$6036577f95c3877e);
$parcel$export(module.exports, "G100", () => $cccad9dbca818926$export$afbce1382ec95f73);
$parcel$export(module.exports, "G200", () => $cccad9dbca818926$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $cccad9dbca818926$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $cccad9dbca818926$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $cccad9dbca818926$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "L100", () => $cccad9dbca818926$export$fbb30b762ae4fcda);
$parcel$export(module.exports, "L200", () => $cccad9dbca818926$export$f72948ef771f6f15);
$parcel$export(module.exports, "L300", () => $cccad9dbca818926$export$59d89537e7d73aa4);
$parcel$export(module.exports, "L400", () => $cccad9dbca818926$export$4b0a7cabffffd4f5);
$parcel$export(module.exports, "L500", () => $cccad9dbca818926$export$58808b1c527bd1b0);
$parcel$export(module.exports, "Y100", () => $cccad9dbca818926$export$1cc05bbbf340e559);
$parcel$export(module.exports, "Y200", () => $cccad9dbca818926$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y300", () => $cccad9dbca818926$export$c6930421db9fa514);
$parcel$export(module.exports, "Y400", () => $cccad9dbca818926$export$59619663aa6500fb);
$parcel$export(module.exports, "Y500", () => $cccad9dbca818926$export$874739ea9e379ab6);
$parcel$export(module.exports, "O100", () => $cccad9dbca818926$export$4d0048026652f54a);
$parcel$export(module.exports, "O200", () => $cccad9dbca818926$export$51716a84e62e022c);
$parcel$export(module.exports, "O300", () => $cccad9dbca818926$export$59e5b1f9a23fd718);
$parcel$export(module.exports, "O400", () => $cccad9dbca818926$export$e30ed75d70748b1);
$parcel$export(module.exports, "O500", () => $cccad9dbca818926$export$d93a44e5c84e8256);
$parcel$export(module.exports, "R100", () => $cccad9dbca818926$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R200", () => $cccad9dbca818926$export$60847d42f9da92a6);
$parcel$export(module.exports, "R300", () => $cccad9dbca818926$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $cccad9dbca818926$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $cccad9dbca818926$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "M100", () => $cccad9dbca818926$export$6755153cd35f90b1);
$parcel$export(module.exports, "M200", () => $cccad9dbca818926$export$a19f0c33186f7767);
$parcel$export(module.exports, "M300", () => $cccad9dbca818926$export$a46884cf0037b203);
$parcel$export(module.exports, "M400", () => $cccad9dbca818926$export$a1d4686c17e1cdef);
$parcel$export(module.exports, "M500", () => $cccad9dbca818926$export$16814b01d9742bf7);

const $cccad9dbca818926$export$d6447c357493214f = '#F0F1F4';
const $cccad9dbca818926$export$f563ee71e9ee74cd = 'rgba(9, 30, 66, 0.14)';
const $cccad9dbca818926$export$e2ef2124cf4024b1 = (0, $1b343b038f6c23ec$exports).N60A;
const $cccad9dbca818926$export$eece5f492e429f08 = '#44546F';
const $cccad9dbca818926$export$c39c0fe0f26207ae = (0, $1b343b038f6c23ec$exports).N800;
const $cccad9dbca818926$export$6011520a64d9a187 = '#F3F0FF';
const $cccad9dbca818926$export$a7175d4e9206bc80 = '#DFD8FD';
const $cccad9dbca818926$export$b48405b95304b5a1 = '#9F8FEF';
const $cccad9dbca818926$export$c71e4279dd54a18d = '#5E4DB2';
const $cccad9dbca818926$export$147899de772240ec = '#352C63';
const $cccad9dbca818926$export$ecfc1dff386a3e7a = '#E9F2FF';
const $cccad9dbca818926$export$215b7063051591f1 = '#CCE0FF';
const $cccad9dbca818926$export$e62e8919cca44969 = '#579DFF';
const $cccad9dbca818926$export$b3de0ae08da2ce64 = '#0055CC';
const $cccad9dbca818926$export$a6ee3d71bc067634 = '#09326C';
const $cccad9dbca818926$export$776c9c497ef08533 = '#E3FAFC';
const $cccad9dbca818926$export$69cb3ca10c1e330e = '#C1F0F5';
const $cccad9dbca818926$export$9dc1ef0f3f48059b = '#60C6D2';
const $cccad9dbca818926$export$7c835c78b6fcdef8 = '#206B74';
const $cccad9dbca818926$export$6036577f95c3877e = '#1D474C';
const $cccad9dbca818926$export$afbce1382ec95f73 = '#DFFCF0';
const $cccad9dbca818926$export$747d86715d4175de = '#BAF3DB';
const $cccad9dbca818926$export$940e1f69e873f202 = '#4BCE97';
const $cccad9dbca818926$export$a49394138f7b8e85 = '#216E4E';
const $cccad9dbca818926$export$6fa04827ac68a4fb = '#164B35';
const $cccad9dbca818926$export$fbb30b762ae4fcda = '#EEFBDA';
const $cccad9dbca818926$export$f72948ef771f6f15 = '#D3F1A7';
const $cccad9dbca818926$export$59d89537e7d73aa4 = '#94C748';
const $cccad9dbca818926$export$4b0a7cabffffd4f5 = '#4C6B1F';
const $cccad9dbca818926$export$58808b1c527bd1b0 = '#37471F';
const $cccad9dbca818926$export$1cc05bbbf340e559 = '#FFF7D6';
const $cccad9dbca818926$export$5aae31392d72caaa = (0, $1b343b038f6c23ec$exports).Y75;
const $cccad9dbca818926$export$c6930421db9fa514 = '#E2B203';
const $cccad9dbca818926$export$59619663aa6500fb = '#7F5F01';
const $cccad9dbca818926$export$874739ea9e379ab6 = '#533F04';
const $cccad9dbca818926$export$4d0048026652f54a = '#FFF4E5';
const $cccad9dbca818926$export$51716a84e62e022c = '#FFE2BD';
const $cccad9dbca818926$export$59e5b1f9a23fd718 = '#FAA53D';
const $cccad9dbca818926$export$e30ed75d70748b1 = '#974F0C';
const $cccad9dbca818926$export$d93a44e5c84e8256 = '#5F3811';
const $cccad9dbca818926$export$be802dd0d8b57f35 = '#FFEDEB';
const $cccad9dbca818926$export$60847d42f9da92a6 = '#FFD2CC';
const $cccad9dbca818926$export$4a7404f376229999 = '#F87462';
const $cccad9dbca818926$export$2010d0fb4295b346 = '#AE2A19';
const $cccad9dbca818926$export$2837b5a1a71d5c02 = '#601E16';
const $cccad9dbca818926$export$6755153cd35f90b1 = '#FFECF8';
const $cccad9dbca818926$export$a19f0c33186f7767 = '#FDD0EC';
const $cccad9dbca818926$export$a46884cf0037b203 = '#F797D2';
const $cccad9dbca818926$export$a1d4686c17e1cdef = '#943D73';
const $cccad9dbca818926$export$16814b01d9742bf7 = '#50253F';

});

parcelRegister("kzlGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c77e6e90b19c039$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3c77e6e90b19c039$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    greyLightest: {
        "id": "business-categories.category-form.category-color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "business-categories.category-form.category-color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "business-categories.category-form.category-color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "business-categories.category-form.category-color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "business-categories.category-form.category-color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "business-categories.category-form.category-color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "business-categories.category-form.category-color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "business-categories.category-form.category-color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "business-categories.category-form.category-color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "business-categories.category-form.category-color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "business-categories.category-form.category-color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "business-categories.category-form.category-color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "business-categories.category-form.category-color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "business-categories.category-form.category-color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "business-categories.category-form.category-color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "business-categories.category-form.category-color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "business-categories.category-form.category-color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "business-categories.category-form.category-color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "business-categories.category-form.category-color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "business-categories.category-form.category-color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "business-categories.category-form.category-color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "business-categories.category-form.category-color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "business-categories.category-form.category-color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "business-categories.category-form.category-color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "business-categories.category-form.category-color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "business-categories.category-form.category-color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "business-categories.category-form.category-color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "business-categories.category-form.category-color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "business-categories.category-form.category-color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "business-categories.category-form.category-color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "business-categories.category-form.category-color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "business-categories.category-form.category-color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "business-categories.category-form.category-color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "business-categories.category-form.category-color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "business-categories.category-form.category-color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "business-categories.category-form.category-color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "business-categories.category-form.category-color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "business-categories.category-form.category-color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "business-categories.category-form.category-color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "business-categories.category-form.category-color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "business-categories.category-form.category-color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "business-categories.category-form.category-color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "business-categories.category-form.category-color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "business-categories.category-form.category-color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "business-categories.category-form.category-color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "business-categories.category-form.category-color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "business-categories.category-form.category-color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "business-categories.category-form.category-color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "business-categories.category-form.category-color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "business-categories.category-form.category-color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});




parcelRegister("aa7ce", function(module, exports) {

$parcel$export(module.exports, "HierarchyIcon", () => $a7933f94a217c249$export$8c3a8f220bd0db42);

var $eUqFw = parcelRequire("eUqFw");
const $a7933f94a217c249$export$8c3a8f220bd0db42 = ({ size: size = 24 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "4.33333",
        cy: "4.66732",
        r: "1.33333",
        stroke: "#9FADBC",
        "stroke-width": "1.33333"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "10.9998",
        cy: "11.3333",
        r: "1.33333",
        stroke: "#9FADBC",
        "stroke-width": "1.33333"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4.3335 6V8.66667C4.3335 10.1394 5.5274 11.3333 7.00016 11.3333H9.66683",
        stroke: "#9FADBC",
        "stroke-width": "1.33333"
    }));

});

parcelRegister("5TykG", function(module, exports) {

$parcel$export(module.exports, "default", () => $da6a9dc8604f8c0a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $ldoFd = parcelRequire("ldoFd");

var $jG2Eu = parcelRequire("jG2Eu");

var $jl1we = parcelRequire("jl1we");

var $gUUjF = parcelRequire("gUUjF");

var $1IqwQ = parcelRequire("1IqwQ");

var $4ksts = parcelRequire("4ksts");

var $kPvBW = parcelRequire("kPvBW");

var $i9pAn = parcelRequire("i9pAn");

var $6aKs0 = parcelRequire("6aKs0");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $lGLse = parcelRequire("lGLse");

var $jsScF = parcelRequire("jsScF");

var $hAlQB = parcelRequire("hAlQB");
const $da6a9dc8604f8c0a$var$TimestampView = (props)=>{
    const { value: value, extraStyles: extraStyles = {}, tooltipPosition: tooltipPosition = 'top' } = props;
    const [{ data: loggedInUser }] = (0, $lGLse.useUserSubscriber)();
    const loggedInUserTimeZone = loggedInUser ? loggedInUser.timeZone : undefined;
    const userTimeZone = loggedInUserTimeZone || (0, $6aKs0.getBrowserTimeZone)();
    const isADGTimestampDisplaySettingRelative = (0, $hAlQB.getADGTimestampDisplaySetting)(value) === (0, $jsScF.RELATIVE);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const { formatDate: formatDate } = (0, $4ksts.useIntlV2)();
    const [userDisplaySetting, { setValue: setTimestampDisplaySetting }] = (0, $i9pAn.useUserPreferencesValue)((0, $kPvBW.TIMESTAMP_DISPLAY_SETTING));
    // Use relative display setting if user hasn't set anything
    const displaySetting = (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(userDisplaySetting) || userDisplaySetting === '' ? (0, $jsScF.RELATIVE) : userDisplaySetting;
    const formattedAbsoluteTimestamp = (0, $eUqFw.useMemo)(()=>formatDate(value, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            timeZone: userTimeZone
        }), [
        formatDate,
        userTimeZone,
        value
    ]);
    const onAbsoluteClick = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'absoluteTimeButton');
        setTimestampDisplaySetting((0, $jsScF.RELATIVE)).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fields.components.timestamp', 'Failed to set timestamp display to RELATIVE', error);
        });
    }, [
        createAnalyticsEvent,
        setTimestampDisplaySetting
    ]);
    const onRelativeClick = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'relativeTimeButton');
        setTimestampDisplaySetting((0, $jsScF.ABSOLUTE)).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fields.components.timestamp', 'Failed to set timestamp display to ABSOLUTE', error);
        });
    }, [
        createAnalyticsEvent,
        setTimestampDisplaySetting
    ]);
    const renderAbsolute = (0, $eUqFw.useCallback)((canSwitchDisplaySetting)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da6a9dc8604f8c0a$var$TimestampWrapper, {
            canSwitchDisplaySetting: canSwitchDisplaySetting,
            onKeyDown: (e)=>{
                if ((e.key === 'Enter' || e.key === 'Space') && canSwitchDisplaySetting) onAbsoluteClick();
            },
            role: "presentation",
            onClick: canSwitchDisplaySetting ? onAbsoluteClick : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            extraStyles: extraStyles
        }, formattedAbsoluteTimestamp), [
        extraStyles,
        formattedAbsoluteTimestamp,
        onAbsoluteClick
    ]);
    const renderRelative = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da6a9dc8604f8c0a$var$TimestampWrapper, {
            canSwitchDisplaySetting: true,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && onRelativeClick(),
            role: "presentation",
            onClick: onRelativeClick,
            extraStyles: extraStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
            tag: "span",
            content: formattedAbsoluteTimestamp,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "data-testid": "issue-timestamp.relative-time"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1IqwQ.FormattedRelativeV2), {
            value: value
        })))), [
        extraStyles,
        formattedAbsoluteTimestamp,
        onRelativeClick,
        tooltipPosition,
        value
    ]);
    // BENTO-2569: Users have requested the ability to switch to absolute timestamps when the timestamp is to be displayed as relative.
    // When the timestamp is to be displayed as absolute then we cannot allow them to switch (to comply with ADG)
    return isADGTimestampDisplaySettingRelative && displaySetting === (0, $jsScF.RELATIVE) ? renderRelative() : renderAbsolute(isADGTimestampDisplaySettingRelative);
};
$da6a9dc8604f8c0a$var$TimestampView.displayName = 'TimestampView';
var $da6a9dc8604f8c0a$export$2e2bcd8739ae039 = $da6a9dc8604f8c0a$var$TimestampView;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da6a9dc8604f8c0a$var$TimestampWrapper = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "erd76u-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: props.canSwitchDisplaySetting ? 'pointer' : 'default'
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ extraStyles: extraStyles })=>extraStyles.always, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ canSwitchDisplaySetting: canSwitchDisplaySetting, extraStyles: { whenDisplaySettingSwitchable: extraStylesWhenSwitchable } })=>canSwitchDisplaySetting ? extraStylesWhenSwitchable : '');
$da6a9dc8604f8c0a$var$TimestampWrapper.displayName = 'TimestampWrapper';

});
parcelRegister("1IqwQ", function(module, exports) {

$parcel$export(module.exports, "getRelativeTimeAndUnit", () => $6a7dda3450af4d49$export$307c4b8ee56b97bb);
$parcel$export(module.exports, "FormattedRelativeV2", () => $6a7dda3450af4d49$export$7317ee2f88fd1276);

var $eUqFw = parcelRequire("eUqFw");

var $9KU0P = parcelRequire("9KU0P");

var $8M1qS = parcelRequire("8M1qS");
const $6a7dda3450af4d49$var$getTimeInUnits = (unitValue)=>{
    const seconds = unitValue / 1000;
    const minutes = seconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;
    const weeks = days / 7;
    const months = weeks / 4;
    const years = months / 12;
    return {
        seconds: seconds,
        minutes: minutes,
        hours: hours,
        days: days,
        weeks: weeks,
        months: months,
        years: years
    };
};
const $6a7dda3450af4d49$export$307c4b8ee56b97bb = (value, units)=>{
    const timeInMilliseconds = new Date(value);
    // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    const delta = timeInMilliseconds - Date.now();
    let valueInUnit;
    if (!units) {
        const { value: time, unit: unit } = (0, $9KU0P.selectUnit)(timeInMilliseconds, new Date());
        return {
            time: time,
            unit: unit
        };
    }
    const { seconds: seconds, minutes: minutes, hours: hours, days: days, weeks: weeks, months: months, years: years } = $6a7dda3450af4d49$var$getTimeInUnits(delta);
    switch(units){
        case 'second':
            valueInUnit = seconds;
            break;
        case 'minute':
            valueInUnit = minutes;
            break;
        case 'hour':
            valueInUnit = hours;
            break;
        case 'day':
            valueInUnit = days;
            break;
        case 'week':
            valueInUnit = weeks;
            break;
        case 'month':
            valueInUnit = months;
            break;
        case 'year':
            valueInUnit = years;
            break;
        default:
            valueInUnit = 0;
            break;
    }
    return {
        time: Math.ceil(valueInUnit),
        unit: units
    };
};
const $6a7dda3450af4d49$export$7317ee2f88fd1276 = ({ value: value, units: units, children: children, style: style, format: format, updateInterval: updateInterval })=>{
    const { time: time, unit: unit } = $6a7dda3450af4d49$export$307c4b8ee56b97bb(value, units);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8M1qS.default), {
        value: time,
        unit: unit,
        numeric: style === 'numeric' ? 'always' : 'auto',
        format: format,
        updateIntervalInSeconds: updateInterval
    }, children);
};
$6a7dda3450af4d49$export$7317ee2f88fd1276.displayName = 'FormattedRelative';

});

parcelRegister("kPvBW", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $b682c7d6e9f17978$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $b682c7d6e9f17978$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $b682c7d6e9f17978$export$b38f30d67f730bc4);
const $b682c7d6e9f17978$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $b682c7d6e9f17978$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $b682c7d6e9f17978$export$757f91ad408a28d4 = 'jira.user.issue.filter.hide-done-subtasks';
const $b682c7d6e9f17978$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("i9pAn", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesValue", () => $0735c0eb8f9298bc$export$8bd3660b16415efd);
$parcel$export(module.exports, "useUserPreferencesActions", () => $0735c0eb8f9298bc$export$eefe4b2985e8203e);

var $eUqFw = parcelRequire("eUqFw");

var $lNFDn = parcelRequire("lNFDn");

var $duUIT = parcelRequire("duUIT");
const $0735c0eb8f9298bc$export$8bd3660b16415efd = (userPreferenceKey)=>{
    const baseUrl = '';
    const [value, { setUserPreferenceValue: setUserPreferenceValue, deleteUserPreferenceValue: deleteUserPreferenceValue }] = (0, $lNFDn.useUserPreferencesStoreValue)(userPreferenceKey);
    const setValue = (0, $eUqFw.useCallback)((newValue)=>{
        setUserPreferenceValue(userPreferenceKey, newValue);
        return (0, $duUIT.saveUserPreferenceValue)(baseUrl, userPreferenceKey, newValue);
    }, [
        baseUrl,
        setUserPreferenceValue,
        userPreferenceKey
    ]);
    const deleteValue = (0, $eUqFw.useCallback)(()=>{
        deleteUserPreferenceValue(userPreferenceKey);
        return (0, $duUIT.removeUserPreferenceValue)(baseUrl, userPreferenceKey);
    }, [
        baseUrl,
        deleteUserPreferenceValue,
        userPreferenceKey
    ]);
    const setUserPreferences = (0, $eUqFw.useMemo)(()=>({
            setValue: setValue,
            deleteValue: deleteValue
        }), [
        setValue,
        deleteValue
    ]);
    return [
        value,
        setUserPreferences
    ];
};
const $0735c0eb8f9298bc$export$eefe4b2985e8203e = ()=>{
    const baseUrl = '';
    const [, actions] = (0, $lNFDn.useUserPreferencesStoreActions)();
    const userPreferenceActions = (0, $eUqFw.useMemo)(()=>{
        const setUserPreferenceValue = (userPreferenceKey, value)=>{
            actions.setUserPreferenceValue(userPreferenceKey, value);
            (0, $duUIT.saveUserPreferenceValue)(baseUrl, userPreferenceKey, value);
        };
        const deleteUserPreferenceValue = (userPreferenceKey)=>{
            actions.deleteUserPreferenceValue(userPreferenceKey);
            (0, $duUIT.removeUserPreferenceValue)(baseUrl, userPreferenceKey);
        };
        const setUserPreferences = (userPreferences)=>{
            userPreferences && Object.keys(userPreferences).length !== 0 && actions.setUserPreferences(userPreferences);
        };
        return {
            setUserPreferenceValue: setUserPreferenceValue,
            setUserPreferences: setUserPreferences,
            deleteUserPreferenceValue: deleteUserPreferenceValue,
            getUserPreferenceValue: actions.getUserPreferenceValue
        };
    }, [
        actions,
        baseUrl
    ]);
    return [
        null,
        userPreferenceActions
    ];
};

});
parcelRegister("lNFDn", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesStoreValue", () => $c14aa03e7fb8e4ad$export$46e7eeb2fc34fab8);
$parcel$export(module.exports, "useUserPreferencesStoreActions", () => $c14aa03e7fb8e4ad$export$4d156074562bac9a);

var $WBLbN = parcelRequire("WBLbN");

var $fB99X = parcelRequire("fB99X");
const $c14aa03e7fb8e4ad$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    name: 'user-preferences',
    initialState: {
        preferences: {}
    },
    actions: $fB99X.actions
});
const $c14aa03e7fb8e4ad$var$getUserPreference = (state, userPreferenceKey)=>state.preferences[userPreferenceKey];
const $c14aa03e7fb8e4ad$export$46e7eeb2fc34fab8 = (0, $WBLbN.createHook)($c14aa03e7fb8e4ad$export$6f57813fe9f31bf9, {
    selector: $c14aa03e7fb8e4ad$var$getUserPreference
});
const $c14aa03e7fb8e4ad$export$4d156074562bac9a = (0, $WBLbN.createHook)($c14aa03e7fb8e4ad$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("fB99X", function(module, exports) {

$parcel$export(module.exports, "actions", () => $15d29e400e18f42d$export$e324594224ef24da);
const $15d29e400e18f42d$var$setUserPreferenceValue = (key, value)=>({ setState: setState, getState: getState })=>{
        setState({
            preferences: {
                ...getState().preferences,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [key]: value
            }
        });
    };
const $15d29e400e18f42d$var$deleteUserPreferenceValue = (key)=>({ setState: setState, getState: getState })=>{
        const { [key]: _, ...preferences } = getState().preferences;
        setState({
            preferences: preferences
        });
    };
const $15d29e400e18f42d$var$setUserPreferences = (state)=>({ setState: setState })=>{
        setState({
            preferences: state
        });
    };
const $15d29e400e18f42d$export$df0a4f67b9888111 = (key)=>({ getState: getState })=>{
        const { preferences: preferences } = getState();
        return preferences[key];
    };
const $15d29e400e18f42d$export$e324594224ef24da = {
    setUserPreferenceValue: $15d29e400e18f42d$var$setUserPreferenceValue,
    deleteUserPreferenceValue: $15d29e400e18f42d$var$deleteUserPreferenceValue,
    setUserPreferences: $15d29e400e18f42d$var$setUserPreferences,
    getUserPreferenceValue: $15d29e400e18f42d$export$df0a4f67b9888111
};

});


parcelRegister("duUIT", function(module, exports) {

$parcel$export(module.exports, "saveUserPreferenceValue", () => $15d896639d90b0d5$export$bebe1b9e9f4cbf16);
$parcel$export(module.exports, "removeUserPreferenceValue", () => $15d896639d90b0d5$export$a60a810760d07867);

var $lRmyA = parcelRequire("lRmyA");
const $15d896639d90b0d5$export$bebe1b9e9f4cbf16 = async (baseUrl, userPreferenceKey, value)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/2/mypreferences?key=${userPreferenceKey}`, {
        body: value
    });
const $15d896639d90b0d5$export$a60a810760d07867 = async (baseUrl, userPreferenceKey)=>(0, $lRmyA.performDeleteRequest)(`${baseUrl}/rest/api/2/mypreferences?key=${userPreferenceKey}`);

});


parcelRegister("6aKs0", function(module, exports) {

$parcel$export(module.exports, "SYDNEY_TIMEZONE", () => $c7bf7e7164aeb193$export$1a022a080ce6c5bb);
$parcel$export(module.exports, "getBrowserTimeZone", () => $c7bf7e7164aeb193$export$efc596861aea1477);
const $c7bf7e7164aeb193$export$1a022a080ce6c5bb = 'Australia/Sydney';
const $c7bf7e7164aeb193$export$efc596861aea1477 = ()=>Intl.DateTimeFormat().resolvedOptions().timeZone || $c7bf7e7164aeb193$export$1a022a080ce6c5bb;

});

parcelRegister("jsScF", function(module, exports) {

$parcel$export(module.exports, "RELATIVE", () => $ad8b3ae3c84be75e$export$91389b1eb9882ae7);
$parcel$export(module.exports, "ABSOLUTE", () => $ad8b3ae3c84be75e$export$8cd2c3eb7eeb9644);
const $ad8b3ae3c84be75e$export$91389b1eb9882ae7 = 'RELATIVE';
const $ad8b3ae3c84be75e$export$8cd2c3eb7eeb9644 = 'ABSOLUTE';

});

parcelRegister("hAlQB", function(module, exports) {

$parcel$export(module.exports, "getADGTimestampDisplaySetting", () => $86e37847e2293e72$export$e89759fbd7b8f45a);

var $jsScF = parcelRequire("jsScF");
// @ts-expect-error - TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
const $86e37847e2293e72$var$getDaysElapsed = (date)=>(Date.now() - new Date(date)) / 86400000;
const $86e37847e2293e72$export$e89759fbd7b8f45a = (date)=>$86e37847e2293e72$var$getDaysElapsed(date) < 8 ? (0, $jsScF.RELATIVE) : (0, $jsScF.ABSOLUTE);

});


parcelRegister("6BYzZ", function(module, exports) {

$parcel$export(module.exports, "DateOnly", () => $5d1ef987232e205a$export$988b361b394263b6);
$parcel$export(module.exports, "toDateOnly", () => $5d1ef987232e205a$export$b0961ad8aee63b8b);
const $5d1ef987232e205a$export$9cda9b56d134780f = 'Invalid date or date format';
const $5d1ef987232e205a$var$toISOString = (year, month, day)=>`${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
const $5d1ef987232e205a$var$isLeapYear = (year)=>year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
const $5d1ef987232e205a$var$daysInMonth = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
/**
 Returns a boolean to indicate that the date specified is valid.

 Note: Dates before Year zero are treated to be invalid.
 */ const $5d1ef987232e205a$var$isDateValid = (year, month, day)=>{
    if ([
        year,
        month,
        day
    ].findIndex((n)=>typeof n !== 'number' || Number.isNaN(n)) !== -1) return false;
    if (year < 0) return false;
    if (month < 1 || month > 12) return false;
    if (day < 1) return false;
    if (day > (month === 2 && $5d1ef987232e205a$var$isLeapYear(year) ? 29 : $5d1ef987232e205a$var$daysInMonth[month - 1])) return false;
    return true;
};
const $5d1ef987232e205a$var$dateFormatRegExp = /^([0-9][0-9][0-9][0-9])-([0-1][0-9])-([0-3][0-9])$/;
class $5d1ef987232e205a$export$988b361b394263b6 {
    /**
	 * Return true if the string is a valid ISO date string in the format 'YYYY-MM-DD'.
	 * @param dateString
	 * @returns {boolean}
	 */ static isISODateString(dateString) {
        try {
            $5d1ef987232e205a$export$988b361b394263b6.fromISODateString(dateString);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e?.message === $5d1ef987232e205a$export$9cda9b56d134780f) return false;
            throw e;
        }
        return true;
    }
    /**
	 * Create a DateOnly object from a string in the format 'YYYY-MM-DD'.
	 */ // go/jfe-eslint
    static fromISODateString(dateString) {
        const matches = $5d1ef987232e205a$var$dateFormatRegExp.exec(dateString);
        if (matches === null) throw new Error($5d1ef987232e205a$export$9cda9b56d134780f);
        const [, year, month, day] = matches;
        // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
        return new $5d1ef987232e205a$export$988b361b394263b6(...[
            year,
            month,
            day
        ].map((s)=>Number.parseInt(s, 10)));
    }
    /**
	 * DISCLAIMER:
	 * Date() does NOT store timezone information.
	 *
	 * Date.prototype.toString() leverages the system's timezone to serialize it into a string according to local time.
	 * Methods getDate(), getMonth(), getFullYear() behave the same and also return values according to local time.
	 *
	 * Methods toUTCString(), getUTCDate(), getUTCMonth(), getUTCFullYear() return values according to universal time.
	 *
	 * Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
	 */ /**
	 * Create a DateOnly object that reflects the local year, month & day for the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToLocalTime(date) {
        return new $5d1ef987232e205a$export$988b361b394263b6(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }
    /**
	 * Create a DateOnly object that reflects the UTC year, month & day of the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToUTC(date) {
        return new $5d1ef987232e205a$export$988b361b394263b6(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
    }
    /**
	 * Compare 2 DateOnly objects.
	 *
	 * (Similar to the TC39 proposal Temporal.PlainDate.compare).
	 *
	 * If a comes before b, return -1.
	 * If a is equal to b, return 0.
	 * If a is greater than b, return 1.
	 */ static compare(a, b) {
        if (a.year === b.year) {
            if (a.month === b.month) {
                if (a.day === b.day) return 0;
                return a.day < b.day ? -1 : 1;
            }
            return a.month < b.month ? -1 : 1;
        }
        return a.year < b.year ? -1 : 1;
    }
    /**
	 * Create a DateOnly object which represents a day. It does not have a time component.
	 * @param year - A year, ranging between 0 and 9999 inclusive.
	 * @param month - A month, ranging between 1 and 12 inclusive.
	 * @param day - A day of the month, ranging between 1 and 31 inclusive.
	 */ constructor(year, month, day){
        if (!$5d1ef987232e205a$var$isDateValid(year, month, day)) throw new Error($5d1ef987232e205a$export$9cda9b56d134780f);
        this.year = year;
        this.month = month;
        this.day = day;
    }
    getYear() {
        return this.year;
    }
    getMonth() {
        return this.month;
    }
    getDay() {
        return this.day;
    }
    toISOString() {
        return $5d1ef987232e205a$var$toISOString(this.year, this.month, this.day);
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 which corresponds to the UTC timezone.
	 */ toUTCDate() {
        return new Date(Date.UTC(this.year, this.month - 1, this.day));
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 for the local timezone.
	 */ toLocalDate() {
        // take the current date (e.g. 1.06.2020)
        const localDate = new Date();
        // store current month in a const to compare below
        const currentMonth = localDate.getMonth();
        // set the year
        localDate.setFullYear(this.year);
        localDate.setHours(0);
        localDate.setMinutes(0);
        localDate.setSeconds(0);
        localDate.setMilliseconds(0);
        localDate.setDate(this.day);
        // if this.day doesn't exist in the current month (e.g. 31 doesn't exist in June ),
        // it will set the month to July instead. We need to make sure setDate doesn't change the month
        if (localDate.getMonth() !== currentMonth) {
            localDate.setMonth(this.month - 1);
            // reset the date after updating the month
            localDate.setDate(this.day);
        } else localDate.setMonth(this.month - 1);
        return localDate;
    }
    equals(dateOnly) {
        return $5d1ef987232e205a$export$988b361b394263b6.compare(this, dateOnly) === 0;
    }
}
const $5d1ef987232e205a$export$b0961ad8aee63b8b = (date)=>typeof date === 'string' ? $5d1ef987232e205a$export$988b361b394263b6.fromISODateString(date.replace(/T.*/, '')) : null;

});


parcelRegister("ffOJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e29972ec623d172$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $jl1we = parcelRequire("jl1we");
const $2e29972ec623d172$export$200b8444ace4b1d3 = ({ issueType: issueType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $2e29972ec623d172$var$iconStyles
    }, issueType?.issueType.iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: issueType.issueType.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2e29972ec623d172$var$Image, {
        alt: issueType.issueType.name,
        src: issueType.issueType.iconUrl
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2e29972ec623d172$var$ImagePlaceholder, null));
var $2e29972ec623d172$export$2e2bcd8739ae039 = $2e29972ec623d172$export$200b8444ace4b1d3;
const $2e29972ec623d172$var$iconStyles = (0, $8Vv3m.xcss)({
    marginRight: 'space.025'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2e29972ec623d172$var$ImagePlaceholder = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _4t3i7vkz _bfhkn82g _2rkoglpi",
            __cmplp.className
        ])
    });
});
const $2e29972ec623d172$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb7vkz _4t3i7vkz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("c9bRS", function(module, exports) {

$parcel$export(module.exports, "default", () => $25b847888d666dc4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $14luy = parcelRequire("14luy");

var $jl4eq = parcelRequire("jl4eq");

var $6naHj = parcelRequire("6naHj");

var $lIQsu = parcelRequire("lIQsu");
const $25b847888d666dc4$var$Subtasks = ({ issue: issue })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const { isExpanded: isExpanded, toggleSubtasks: toggleSubtasks } = (0, $14luy.useExpandCollapseSubtasks)(issue.id);
    const { loading: loading, fetch: fetch } = (0, $jl4eq.useIssueSubtasks)(issue);
    const hasSubtasks = Boolean(issue.subtaskMetadata?.total);
    (0, $eUqFw.useEffect)(()=>{
        if (isExpanded && hasSubtasks) fetch();
    // empty dependencies as we only want to run this effect once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleToggleClick = (0, $eUqFw.useCallback)(()=>{
        if (!isExpanded) fetch();
        toggleSubtasks();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jwmBoardCardSubtaskTrigger', {
            isExpanded: isExpanded
        });
    }, [
        createAnalyticsEvent,
        fetch,
        isExpanded,
        toggleSubtasks
    ]);
    const preventEventBubbling = (0, $eUqFw.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
    }, []);
    // Do not display any subtask UI if there are no subtasks
    if (!issue.subtaskMetadata?.total) return null;
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        onClick: preventEventBubbling
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lIQsu.default), {
        isExpanded: isExpanded,
        isLoading: loading,
        onToggle: handleToggleClick,
        subtaskMetadata: issue.subtaskMetadata
    }), isExpanded && !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6naHj.default), {
        parent: issue
    })));
};
var $25b847888d666dc4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($25b847888d666dc4$var$Subtasks);

});
parcelRegister("14luy", function(module, exports) {

$parcel$export(module.exports, "useExpandCollapseSubtasks", () => $73eb2d10ea848123$export$a152b29991d4fa38);

var $eUqFw = parcelRequire("eUqFw");

var $MdoH4 = parcelRequire("MdoH4");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");
const $73eb2d10ea848123$var$EXPANDED_ISSUES_LIMIT = 20;
const $73eb2d10ea848123$export$a152b29991d4fa38 = (issueId)=>{
    const [expandedIssues, setExpandedIssues] = (0, $7c3W1.useViewPreference)((0, $ji3xf.EXPANDED_ISSUES_PREFERENCE));
    const isExpanded = Boolean(expandedIssues?.includes(issueId));
    const collapseSubtasks = (0, $eUqFw.useCallback)(()=>{
        const newExpandedIssues = expandedIssues?.filter((id)=>issueId !== id);
        setExpandedIssues(newExpandedIssues);
    }, [
        expandedIssues,
        issueId,
        setExpandedIssues
    ]);
    const expandSubtasks = (0, $eUqFw.useCallback)(()=>{
        const newExpandedIssues = (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))([
            ...expandedIssues || [],
            issueId
        ]);
        // Trim to the last 20 items as we don't want to store too many expanded issues
        if (newExpandedIssues.length > $73eb2d10ea848123$var$EXPANDED_ISSUES_LIMIT) newExpandedIssues.splice(0, newExpandedIssues.length - $73eb2d10ea848123$var$EXPANDED_ISSUES_LIMIT);
        setExpandedIssues(newExpandedIssues);
    }, [
        expandedIssues,
        issueId,
        setExpandedIssues
    ]);
    const toggleSubtasks = (0, $eUqFw.useCallback)(()=>{
        isExpanded ? collapseSubtasks() : expandSubtasks();
    }, [
        isExpanded,
        collapseSubtasks,
        expandSubtasks
    ]);
    return {
        isExpanded: isExpanded,
        toggleSubtasks: toggleSubtasks
    };
};

});

parcelRegister("jl4eq", function(module, exports) {

$parcel$export(module.exports, "useIssueSubtasks", () => $1535a736efad0e2e$export$5b5aeea73b6178e9);

var $eUqFw = parcelRequire("eUqFw");

var $4G5xU = parcelRequire("4G5xU");

var $k8Qyf = parcelRequire("k8Qyf");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");

var $c7RGv = parcelRequire("c7RGv");

var $1j5vW = parcelRequire("1j5vW");

var $dtXTv = parcelRequire("dtXTv");

var $ecqJr = parcelRequire("ecqJr");
const $1535a736efad0e2e$export$b46cc40fdf28878c = [
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.ISSUE_KEY_TYPE),
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.PARENT_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    (0, $lO4Or.SUMMARY_TYPE)
];
const $1535a736efad0e2e$export$5b5aeea73b6178e9 = (issue)=>{
    const { setIssues: setIssues } = (0, $dtXTv.useIssueStoreActions)();
    const fetchIssues = (0, $c7RGv.useFetchBoardIssues)();
    const transformToIssues = (0, $1j5vW.useTransformIssues)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $ib4WI.LOAD_SUBTASKS_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $ib4WI.LOAD_SUBTASKS_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $ib4WI.LOAD_SUBTASKS_EXPERIENCE));
    const fetch = (0, $eUqFw.useCallback)(async ()=>{
        startExperience();
        setLoading(true);
        try {
            const results = await fetchIssues({
                fieldIds: $1535a736efad0e2e$export$b46cc40fdf28878c,
                jql: `parent = ${issue.id}`
            });
            const boardIssues = transformToIssues(results);
            setIssues(boardIssues);
            markExperienceSuccess();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            showFlag({
                description: (0, $ecqJr.default).errorMessage,
                title: (0, $ecqJr.default).errorTitle,
                type: 'error'
            });
            markExperienceFailed('Failed to load issue subtasks', error);
        } finally{
            setLoading(false);
        }
    }, [
        issue,
        fetchIssues,
        transformToIssues,
        setIssues,
        showFlag,
        startExperience,
        markExperienceSuccess,
        markExperienceFailed
    ]);
    return {
        loading: loading,
        fetch: fetch
    };
};

});
parcelRegister("ecqJr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d38812fa55c7a44$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3d38812fa55c7a44$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "work-management-board.controllers.issue-subtasks.error-title",
        "defaultMessage": "Failed to load subtasks"
    },
    errorMessage: {
        "id": "work-management-board.controllers.issue-subtasks.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("6naHj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0cd29bc92a7ef92$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $k9isx = parcelRequire("k9isx");

var $69ay7 = parcelRequire("69ay7");

var $gjzML = parcelRequire("gjzML");

var $j8Htg = parcelRequire("j8Htg");

var $jGcn0 = parcelRequire("jGcn0");

var $8Qd0L = parcelRequire("8Qd0L");

var $4wx7G = parcelRequire("4wx7G");

var $kgzZq = parcelRequire("kgzZq");

var $jkZ7i = parcelRequire("jkZ7i");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $8rQuz = parcelRequire("8rQuz");

var $ib4WI = parcelRequire("ib4WI");

var $d1mZL = parcelRequire("d1mZL");

var $2b5eO = parcelRequire("2b5eO");

var $f7G96 = parcelRequire("f7G96");

var $l4y71 = parcelRequire("l4y71");
const $a0cd29bc92a7ef92$var$appearanceMap = {
    [(0, $8Qd0L.UNDEFINED)]: 'default',
    [(0, $8Qd0L.TODO)]: 'default',
    [(0, $8Qd0L.DONE)]: 'success',
    [(0, $8Qd0L.IN_PROGRESS)]: 'inprogress'
};
const $a0cd29bc92a7ef92$var$MAX_NUMBER_OF_SUBTASKS_WITHOUT_SCROLL = 3;
const $a0cd29bc92a7ef92$var$SubtaskClickWrapper = ({ onClick: onClick, subtask: subtask, children: children })=>{
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        onClick(event, subtask);
    }, [
        onClick,
        subtask
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskWrapper, {
        "data-testid": "work-management-board.ui.board.column.card.card-content.subtasks.subtask-list",
        onClick: handleClick
    }, children);
};
const $a0cd29bc92a7ef92$var$SubtaskList = ({ parent: parent })=>{
    const subtasks = (0, $d1mZL.useSubtasksByParentId)({
        parentId: parent.id
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const { issueViewInteraction: issueViewInteraction } = (0, $2b5eO.useJWMBoardFeatures)();
    const shouldOpenInNewTab = issueViewInteraction === 'openNewTab';
    const onIssueClick = (0, $f7G96.useViewIssue)();
    const handleSubtaskClick = (0, $eUqFw.useCallback)((event, subtaskIssue)=>{
        const withCmd = event.ctrlKey || event.metaKey;
        event.stopPropagation();
        shouldOpenInNewTab ? (0, $j8Htg.openViewFromEmbed)({
            key: (0, $jGcn0.SELECTED_ISSUE_PARAM),
            value: subtaskIssue.fields[0, $ib4WI.ISSUE_KEY_ID].value
        }) : onIssueClick(subtaskIssue, withCmd);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'subtask clicked');
    }, [
        createAnalyticsEvent,
        onIssueClick,
        shouldOpenInNewTab
    ]);
    const handleIssueKeyClick = (0, $eUqFw.useCallback)((subtaskIssue)=>{
        shouldOpenInNewTab ? (0, $j8Htg.openViewFromEmbed)({
            key: (0, $jGcn0.SELECTED_ISSUE_PARAM),
            value: subtaskIssue.fields[0, $ib4WI.ISSUE_KEY_ID].value
        }) : onIssueClick(subtaskIssue, false);
    }, [
        onIssueClick,
        shouldOpenInNewTab
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l4y71.default), {
        subtasks: subtasks
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskScrollContainer, null, subtasks.map((subtaskIssue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskClickWrapper, {
            key: subtaskIssue.id,
            onClick: handleSubtaskClick,
            subtask: subtaskIssue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskSummary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kgzZq.CardSummary), {
            text: subtaskIssue.fields[0, $ib4WI.SUMMARY_ID].value
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskRowCell, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskIssueTypeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jkZ7i.CardType), {
            uri: subtaskIssue.fields[0, $ib4WI.ISSUE_TYPE_ID].issueType.iconUrl,
            text: subtaskIssue.fields[0, $ib4WI.ISSUE_TYPE_ID].issueType.name
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4wx7G.CardKey), {
            onClick: ()=>handleIssueKeyClick(subtaskIssue),
            text: subtaskIssue.fields[0, $ib4WI.ISSUE_KEY_ID].value
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskRowCell, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskLozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $69ay7.default), {
            appearance: $a0cd29bc92a7ef92$var$appearanceMap[(0, $8Qd0L.statusCategoryForId)(subtaskIssue.fields[0, $ib4WI.STATUS_ID].status.statusCategoryId)],
            isBold: (0, $8rQuz.isVisualRefreshEnabled)()
        }, subtaskIssue.fields[0, $ib4WI.STATUS_ID].status.name)), !subtaskIssue.fields[0, $ib4WI.ASSIGNEE_ID]?.user.avatarURL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k9isx.default), {
            appearance: "circle",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gjzML.AvatarLite), {
            avatarUrl: subtaskIssue.fields[0, $ib4WI.ASSIGNEE_ID].user.avatarURL,
            name: subtaskIssue.fields[0, $ib4WI.ASSIGNEE_ID].user.name
        })))))), subtasks.length > $a0cd29bc92a7ef92$var$MAX_NUMBER_OF_SUBTASKS_WITHOUT_SCROLL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtasksDivider, null));
};
var $a0cd29bc92a7ef92$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($a0cd29bc92a7ef92$var$SubtaskList);
const $a0cd29bc92a7ef92$var$maxCardWidthWithoutPadding = 236;
const $a0cd29bc92a7ef92$var$borderWidth = 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a0cd29bc92a7ef92$var$SubtaskScrollContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71leoa3 _18m9uk5w _18u0xmi2 _2hwxxmi2 _ca0qidpf _n3tdidpf _19bvutpp _u5f3utpp",
            __cmplp.className
        ])
    });
});
const $a0cd29bc92a7ef92$var$SubtaskWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0xmi2 _2hwxxmi2 _ca0q12x7 _n3td12x7 _19bvutpp _u5f3utpp _80omtlke _irr3k6hx",
            __cmplp.className
        ])
    });
});
const $a0cd29bc92a7ef92$var$SubtaskRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _1n261g80",
            __cmplp.className
        ])
    });
});
const $a0cd29bc92a7ef92$var$SubtaskRowCell = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $a0cd29bc92a7ef92$var$SubtaskIssueTypeContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $a0cd29bc92a7ef92$var$SubtaskSummary = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbl3i9 _1reo15vq _18m915vq _1bto1l2s _o5721q9c _otyr1b66",
            __cmplp.className
        ])
    });
});
const $a0cd29bc92a7ef92$var$SubtasksDivider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTop: isTop, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3iidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _x3dowsm2",
            __cmplp.isTop ? "_19pk12x7" : "_19pkze3t",
            __cmplp.className
        ])
    });
});
const $a0cd29bc92a7ef92$var$SubtaskLozengeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f31b66 _1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jkZ7i", function(module, exports) {

$parcel$export(module.exports, "CardType", () => $fc8540d3cdf1aee5$export$f1a79bffad3377cd);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $jl1we = parcelRequire("jl1we");

var $c9TLT = parcelRequire("c9TLT");

var $eWeL8 = parcelRequire("eWeL8");

var $bKxX9 = parcelRequire("bKxX9");
const $fc8540d3cdf1aee5$export$f1a79bffad3377cd = /*#__PURE__*/ (0, $eUqFw.memo)(({ text: text, uri: uri })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc8540d3cdf1aee5$var$Icon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc8540d3cdf1aee5$export$3e431a229df88919, {
        alt: text,
        src: uri
    })));
});
var $fc8540d3cdf1aee5$export$2e2bcd8739ae039 = $fc8540d3cdf1aee5$export$f1a79bffad3377cd;
const $fc8540d3cdf1aee5$var$iconSize = (0, $c9TLT.gridSize) * 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fc8540d3cdf1aee5$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $fc8540d3cdf1aee5$var$ImageControl = /*#__PURE__*/ (0, $kwce8.default).img.withConfig({
    componentId: "sc-1oveq8w-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$fc8540d3cdf1aee5$var$iconSize}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${$fc8540d3cdf1aee5$var$iconSize}px`,
    verticalAlign: 'text-bottom'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fc8540d3cdf1aee5$var$ImageExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _4t3i7vkz _s7n41ndm",
            __cmplp.className
        ])
    });
});
const $fc8540d3cdf1aee5$export$3e431a229df88919 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $bKxX9.ff)('compiled.migration.jsw.tanuki'), $fc8540d3cdf1aee5$var$ImageExperiment, $fc8540d3cdf1aee5$var$ImageControl);

});

parcelRegister("l4y71", function(module, exports) {

$parcel$export(module.exports, "default", () => $823dd0a699faa758$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $jl1we = parcelRequire("jl1we");

var $8Qd0L = parcelRequire("8Qd0L");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ib4WI = parcelRequire("ib4WI");

var $6oOl6 = parcelRequire("6oOl6");
const $823dd0a699faa758$var$SubtaskProgressBar = ({ subtasks: subtasks })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const renderBarSection = (0, $eUqFw.useCallback)((statusCategoryId, BarSectionComponent, message)=>{
        if (!subtasks) return null;
        const count = subtasks.filter((subtask)=>subtask.fields[0, $ib4WI.STATUS_ID].status.statusCategoryId === statusCategoryId).length;
        const label = formatMessage(message, {
            itemCount: count,
            totalCount: subtasks.length
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($823dd0a699faa758$var$BarSectionContainer, {
            barWidthPct: count / subtasks.length * 100,
            role: "progressbar",
            "aria-valuemax": subtasks.length,
            "aria-valuenow": count,
            "aria-label": label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
            content: label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BarSectionComponent, null)));
    }, [
        subtasks,
        formatMessage
    ]);
    if (!subtasks || subtasks.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($823dd0a699faa758$var$SubtaskProgressBarContainer, null, renderBarSection((0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).DONE], $823dd0a699faa758$var$DoneBarSection, (0, $6oOl6.default).doneItems), renderBarSection((0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).INDETERMINATE], $823dd0a699faa758$var$InProgressBarSection, (0, $6oOl6.default).inProgressItems), renderBarSection((0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).NEW], $823dd0a699faa758$var$TodoBarSection, (0, $6oOl6.default).todoItems));
};
var $823dd0a699faa758$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($823dd0a699faa758$var$SubtaskProgressBar);
const $823dd0a699faa758$var$SubtaskProgressBarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkhloo _1bsb1osq _2rko1y44 _1reo15vq _18m915vq _19pk12x7 _otyru2gc _1e0c1txw _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $823dd0a699faa758$var$BarSectionContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { barWidthPct: barWidthPct, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_mkz0ru": (0, $9t7rW.default)(`${__cmplp.barWidthPct}%`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_i0dlrmxw _11fs1y44 _1ih21y44 _k8kw1y44 _px611y44 _1jqf15vq _8dku15vq _uar715vq _1st315vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $823dd0a699faa758$var$BarSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ii2wt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $823dd0a699faa758$var$DoneBarSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $823dd0a699faa758$var$BarSection, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhku8mo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $823dd0a699faa758$var$InProgressBarSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $823dd0a699faa758$var$BarSection, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk9cbf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $823dd0a699faa758$var$TodoBarSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $823dd0a699faa758$var$BarSection, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkhloo",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6oOl6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c532475580592c48$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c532475580592c48$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    doneItems: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtask-list.subtask-progress-bar.done-items",
        "defaultMessage": "{itemCount} of {totalCount} done"
    },
    inProgressItems: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtask-list.subtask-progress-bar.in-progress-items",
        "defaultMessage": "{itemCount} of {totalCount} in progress"
    },
    todoItems: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtask-list.subtask-progress-bar.todo-items",
        "defaultMessage": "{itemCount} of {totalCount} to do"
    }
});

});



parcelRegister("lIQsu", function(module, exports) {

$parcel$export(module.exports, "default", () => $84dbf557d053c3af$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7YElh = parcelRequire("7YElh");

var $bV8f6 = parcelRequire("bV8f6");

var $lCxcH = parcelRequire("lCxcH");

var $jl1we = parcelRequire("jl1we");

var $5JgJ2 = parcelRequire("5JgJ2");

var $il7oX = parcelRequire("il7oX");
const $84dbf557d053c3af$var$SubtasksExpandCollapse = ({ isExpanded: isExpanded, isLoading: isLoading, onToggle: onToggle, subtaskMetadata: subtaskMetadata })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const tooltipContent = formatMessage(isExpanded ? (0, $il7oX.default).hideSubtasksTooltip : (0, $il7oX.default).showSubtasksTooltip);
    const ariaLabelContent = formatMessage(isExpanded ? (0, $il7oX.default).hideSubtasksAriaLabel : (0, $il7oX.default).showSubtasksAriaLabel, {
        done: subtaskMetadata.done,
        total: subtaskMetadata.total
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: tooltipContent,
        hideTooltipOnMouseDown: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7YElh.default), {
        isLoading: isLoading,
        onClick: onToggle,
        "aria-label": ariaLabelContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($84dbf557d053c3af$var$SubtaskContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lCxcH))), {
        size: "small",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, subtaskMetadata.done, "/", subtaskMetadata.total), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($84dbf557d053c3af$var$SubtaskExpandCollapse, {
        expanded: isExpanded,
        "data-testid": "work-management-board.ui.board.column.card.card-content.subtasks.subtasks-expand-collapse.subtask-expand-collapse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bV8f6))), {
        label: ""
    })))));
};
var $84dbf557d053c3af$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($84dbf557d053c3af$var$SubtasksExpandCollapse);
const $84dbf557d053c3af$var$SubtaskContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulp1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84dbf557d053c3af$var$SubtaskExpandCollapse = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { expanded: expanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _v5644a6k",
            __cmplp.expanded ? "_t9ec14w8" : "_t9ec160w",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lCxcH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbd6e728819a109c$var$_react = $fbd6e728819a109c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $fbd6e728819a109c$var$_subtasks = $fbd6e728819a109c$var$_interopRequireDefault((parcelRequire("giBik")));
function $fbd6e728819a109c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fbd6e728819a109c$var$SubtaskIcon = (props)=>/*#__PURE__*/ $fbd6e728819a109c$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M19 7c1.105.003 2 .899 2 2.006v9.988A2.005 2.005 0 0 1 18.994 21H9.006A2.005 2.005 0 0 1 7 19h11c.555 0 1-.448 1-1zM3 5.006C3 3.898 3.897 3 5.006 3h9.988C16.102 3 17 3.897 17 5.006v9.988A2.005 2.005 0 0 1 14.994 17H5.006A2.005 2.005 0 0 1 3 14.994zM5 5v10h10V5z"/><path d="M7.707 9.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L9 10.586z"/></g></svg>`
    }, props, {
        newIcon: $fbd6e728819a109c$var$_subtasks.default
    }));
$fbd6e728819a109c$var$SubtaskIcon.displayName = 'SubtaskIcon';
var $fbd6e728819a109c$var$_default = module.exports.default = $fbd6e728819a109c$var$SubtaskIcon;

});
parcelRegister("giBik", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5ba430e5f5b265db279203bc3692497>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bddb41b3182dba9f$var$_react = $bddb41b3182dba9f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $bddb41b3182dba9f$var$_UNSAFE_baseNew = $bddb41b3182dba9f$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $bddb41b3182dba9f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for subtasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bddb41b3182dba9f$var$SubtasksIcon = (props)=>/*#__PURE__*/ $bddb41b3182dba9f$var$_react.default.createElement($bddb41b3182dba9f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3 8h10c.69 0 1.25.56 1.25 1.25V13c0 .69-.56 1.25-1.25 1.25H9.25C8.56 14.25 8 13.69 8 13V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v3.75C1.75 7.44 2.31 8 3 8Z"/>`
    }, props));
$bddb41b3182dba9f$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $bddb41b3182dba9f$var$_default = module.exports.default = $bddb41b3182dba9f$var$SubtasksIcon;

});


parcelRegister("il7oX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b40260260d0c0b03$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b40260260d0c0b03$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showSubtasksTooltip: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtasks-expand-collapse.show-subtasks-tooltip",
        "defaultMessage": "Show subtasks"
    },
    hideSubtasksTooltip: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtasks-expand-collapse.hide-subtasks-tooltip",
        "defaultMessage": "Hide subtasks"
    },
    showSubtasksAriaLabel: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtasks-expand-collapse.show-subtasks-aria-label",
        "defaultMessage": "Show subtasks ({done} of {total, plural, one {# subtask} other {# subtasks}} complete)"
    },
    hideSubtasksAriaLabel: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtasks-expand-collapse.hide-subtasks-aria-label",
        "defaultMessage": "Hide subtasks ({done} of {total, plural, one {# subtask} other {# subtasks}} complete)"
    }
});

});




parcelRegister("5Glvh", function(module, exports) {

$parcel$export(module.exports, "CardCover", () => $5fd51a3656f7badc$export$1a2d6d8c98d2c941);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $fFY1m = parcelRequire("fFY1m");

var $ifH0n = parcelRequire("ifH0n");

var $bOA3Q = parcelRequire("bOA3Q");

var $aeIT6 = parcelRequire("aeIT6");

var $ib4WI = parcelRequire("ib4WI");

var $gAOAU = parcelRequire("gAOAU");
const $5fd51a3656f7badc$var$CARD_COVER_COLOR_HEIGHT = 24;
const $5fd51a3656f7badc$var$CARD_COVER_IMAGE_HEIGHT = 140;
const $5fd51a3656f7badc$export$1a2d6d8c98d2c941 = /*#__PURE__*/ (0, $eUqFw.memo)(({ coverMedia: coverMedia })=>{
    const isOpen = (0, $gAOAU.useIsCardCoverEditingOpen)();
    const { ref: ref } = (0, $fFY1m.useResizingHeight)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: isOpen ? ref : null
    }, coverMedia !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5fd51a3656f7badc$var$CardCoverInner, {
        coverMedia: coverMedia
    }));
});
const $5fd51a3656f7badc$var$CardCoverInner = /*#__PURE__*/ (0, $eUqFw.memo)(({ coverMedia: coverMedia })=>{
    if (coverMedia.type === 'color') {
        const theme = (0, $bOA3Q.themeManager).getColor(coverMedia.value)?.theme;
        if (!theme) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5fd51a3656f7badc$var$CardColorCoverContainer, {
            "data-testid": "work-management-board.ui.board.column.card.card-cover.card-cover-color",
            backgroundColor: theme.light['color.elevation.surface']
        });
    }
    if (coverMedia.type === 'gradient') {
        const theme = (0, $bOA3Q.themeManager).getGradient(coverMedia.value)?.theme;
        if (!theme) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5fd51a3656f7badc$var$CardGradientCoverContainer, {
            "data-testid": "work-management-board.ui.board.column.card.card-cover.card-cover-gradient",
            background: theme.light['elevation.surface']
        });
    }
    if (coverMedia.type === 'image') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5fd51a3656f7badc$var$CardImageCover, {
        coverMedia: coverMedia
    });
    return null;
});
const $5fd51a3656f7badc$var$CardImageCover = ({ coverMedia: coverMedia })=>{
    const media = (0, $aeIT6.useMediaConfiguration)();
    const imageRef = (0, $eUqFw.useRef)(null);
    const imgUrl = (0, $eUqFw.useMemo)(()=>{
        if (!media?.clientId || !media?.externalEndpointUrl) return null;
        return (0, $bOA3Q.generateMediaImageUrl)({
            mediaApiFileId: coverMedia.mediaApiFileId,
            mediaClientId: media.clientId,
            mediaExternalEndpointUrl: media.externalEndpointUrl,
            token: coverMedia.mediaReadToken,
            mediaEndpoint: 'image',
            // A card is really 260px wide, but we want to load the image at a higher resolution
            // and then scale it down to avoid blurry images. If you use 260px, there will be a gap
            // between the image and the card border.
            width: (0, $ib4WI.COLUMN_FIXED_WIDTH),
            'max-age': Number.MAX_SAFE_INTEGER
        });
    }, [
        coverMedia,
        media
    ]);
    /**
   * Give attribution to the unsplash api for qualified images.
   * This is needed for legal reasons to comply with their API terms of service.
   */ (0, $eUqFw.useEffect)(()=>{
        if (!imgUrl) return;
        if (coverMedia.unsplashId != null && imageRef.current) {
            const unsubscribe = (0, $ifH0n.unsplashTracker).trackWhileInViewport(imageRef.current, coverMedia.unsplashId);
            return unsubscribe;
        }
    }, [
        coverMedia.unsplashId,
        imgUrl
    ]);
    if (!imgUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5fd51a3656f7badc$var$MemoizedCardImageCover, {
        ref: imageRef,
        "data-testid": "work-management-board.ui.board.column.card.card-cover.card-cover-image",
        src: imgUrl,
        title: coverMedia.fileName
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5fd51a3656f7badc$var$CardImageCoverImg = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $9t7rW.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1itk2pcs _bfhkvdii _1lrw1dfr _12vemgnk _ouxl1ssb _4t3i11ux _1bsb1osq _13liglpi _qrwqglpi",
            __cmplp.className
        ])
    });
});
const $5fd51a3656f7badc$var$urlWithoutToken = (url)=>{
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.delete('token');
    return parsedUrl.toString();
};
/**
 * Since the board items are refetched after any board changes, we receive a new token
 * every time. As a result, the image is refetched and causes a flicker. We don't need
 * to rerender the image in that case. The cases we need to are when the image is removed
 * or added, in which case we will retrieve a token separately and rerender.
 */ const $5fd51a3656f7badc$var$MemoizedCardImageCover = /*#__PURE__*/ (0, $eUqFw.memo)($5fd51a3656f7badc$var$CardImageCoverImg, (prevProps, nextProps)=>$5fd51a3656f7badc$var$urlWithoutToken(prevProps.src) === $5fd51a3656f7badc$var$urlWithoutToken(nextProps.src));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5fd51a3656f7badc$var$CardGradientCoverContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { background: background, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_146l9hq": (0, $9t7rW.default)(__cmplp.background)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71i36 _4t3i1tcg _1bsb1osq _13liglpi _qrwqglpi",
            __cmplp.className
        ])
    });
});
const $5fd51a3656f7badc$var$CardColorCoverContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk3qkl _4t3i1tcg _1bsb1osq _13liglpi _qrwqglpi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fFY1m", function(module, exports) {

$parcel$export(module.exports, "useResizingHeight", () => $18b7474d3621cc84$export$da99457d6430d83);
$parcel$export(module.exports, "ResizingHeight", () => $18b7474d3621cc84$export$204d7b6d1491a2d3);

var $eUqFw = parcelRequire("eUqFw");

var $gE0VI = parcelRequire("gE0VI");


var $iatht = parcelRequire("iatht");

var $l0P8E = parcelRequire("l0P8E");

var $9UxuT = parcelRequire("9UxuT");

var $0460l = parcelRequire("0460l");

var $7rAKU = parcelRequire("7rAKU");
const $18b7474d3621cc84$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $iatht.mediumDurationMs), timingFunction: calcTimingFunction = ()=>(0, $230d993d2e77a932$export$c07234257a03d5e9) } = {})=>{
    const prevDimensions = (0, $eUqFw.useRef)();
    const [element, setElementRef] = (0, $9UxuT.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $l0P8E.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $l0P8E.useRequestAnimationFrame)();
    (0, $7rAKU.useSnapshotBeforeUpdate)(()=>{
        if ((0, $gE0VI.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $0460l.useLayoutEffect)(()=>{
        if ((0, $gE0VI.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $18b7474d3621cc84$export$204d7b6d1491a2d3 = ({ children: children, ...props })=>{
    const resizing = $18b7474d3621cc84$export$da99457d6430d83(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, children(resizing));
};
var /**
 * This exists only to be able to extract opts.
 */ // eslint-disable-next-line import/no-anonymous-default-export
$18b7474d3621cc84$export$2e2bcd8739ae039 = (_opts)=>{};

});
const $230d993d2e77a932$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $230d993d2e77a932$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $230d993d2e77a932$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

parcelRegister("9UxuT", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $9e43bfaf877a42f0$export$ff879f35a69d56b7);

var $eUqFw = parcelRequire("eUqFw");
const $9e43bfaf877a42f0$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $eUqFw.useRef)(null);
    const setRef = (0, $eUqFw.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("7rAKU", function(module, exports) {

$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $0c568407ee16f04f$export$9e95200239cd148b);

var $eUqFw = parcelRequire("eUqFw");

var $0460l = parcelRequire("0460l");
const $0c568407ee16f04f$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $eUqFw.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $0460l.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

});



parcelRegister("b5A1R", function(module, exports) {

$parcel$export(module.exports, "useCardFooter", () => $958a389f1314c9e6$export$59dd39d875a11145);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");

var $bZapc = parcelRequire("bZapc");

var $1CcjM = parcelRequire("1CcjM");

var $3XjFp = parcelRequire("3XjFp");
const $958a389f1314c9e6$var$CardFooterContent = /*#__PURE__*/ (0, $eUqFw.memo)(({ issue: issue, hasConfluencePages: hasConfluencePages, hasIssueLinks: hasIssueLinks })=>{
    const confluencePages = hasConfluencePages ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1CcjM.default), {
        issue: issue
    }) : null;
    const issueLinks = hasIssueLinks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XjFp.IssueLinks), {
        issueId: issue.id,
        issueKey: issue.fields[0, $ib4WI.ISSUE_KEY_ID].value,
        issueSummary: issue.fields[0, $ib4WI.SUMMARY_ID].value,
        issueLinksCount: issue.fields[0, $lO4Or.ISSUE_LINKS_TYPE]?.value ?? 0,
        issueTypeField: issue.fields[0, $ib4WI.ISSUE_TYPE_ID]
    }) : null;
    if (confluencePages || issueLinks) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($958a389f1314c9e6$var$Footer, null, confluencePages, issueLinks);
    return null;
});
const $958a389f1314c9e6$export$59dd39d875a11145 = (issue)=>{
    const selectedFields = (0, $bZapc.useSelectedFields)();
    const pageCount = issue.fields[0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE]?.value ?? 0;
    const hasConfluencePages = selectedFields[0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE] && pageCount > 0;
    const issueLinksCount = issue.fields[0, $lO4Or.ISSUE_LINKS_TYPE]?.value ?? 0;
    const hasIssueLinks = selectedFields[0, $lO4Or.ISSUE_LINKS_TYPE] && issueLinksCount > 0;
    const hasFooter = hasConfluencePages || hasIssueLinks;
    let footerContent = null;
    let footerPlaceholder = null;
    if (hasFooter) {
        footerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($958a389f1314c9e6$var$CardFooterContent, {
            issue: issue,
            hasConfluencePages: hasConfluencePages,
            hasIssueLinks: hasIssueLinks
        });
        footerPlaceholder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($958a389f1314c9e6$var$FooterPlaceholder, null);
    }
    return {
        footerContent: footerContent,
        footerPlaceholder: footerPlaceholder
    };
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $958a389f1314c9e6$var$Footer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _94n5idpf _1e0c1txw _zulp1b66 _1yt41bs6",
            __cmplp.className
        ])
    });
});
const $958a389f1314c9e6$var$FooterPlaceholder = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1jfw _x3do13y8 _18s8s8vo",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1CcjM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6e0390aa5e8d6ff$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

var $dyfd9 = parcelRequire("dyfd9");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a6e0390aa5e8d6ff$var$LazyCardDetailConfluencePages = (0, $dyfd9.lazyForPaint)(()=>(parcelRequire("1UIHm")), {
    ssr: false,
    moduleId: "./src/packages/business/board/view/src/ui/board/column/card/card-footer/confluence-pages/main.tsx"
});
const $a6e0390aa5e8d6ff$var$AsyncCardDetailConfluencePages = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.jira-business.board.card-detail-confluence-pages",
        packageName: "jira-business.board.card-detail-confluence-pages",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jwm-board-card-detail-confluence-pages",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a6e0390aa5e8d6ff$var$Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a6e0390aa5e8d6ff$var$LazyCardDetailConfluencePages, props)));
var $a6e0390aa5e8d6ff$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $a6e0390aa5e8d6ff$var$AsyncCardDetailConfluencePages;
const $a6e0390aa5e8d6ff$var$Skeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkn82g _2rkoglpi _4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1UIHm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bDEk0")
]).then(()=>parcelRequire('6DxGu'));

});


parcelRegister("3XjFp", function(module, exports) {

$parcel$export(module.exports, "IssueLinks", () => $4193899be4feee51$export$a8a190e7e67ab4f5);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $7ZZxN = parcelRequire("7ZZxN");

var $gSSYZ = parcelRequire("gSSYZ");

var $5FsEp = parcelRequire("5FsEp");
const $4193899be4feee51$var$IssueLinksNotMemo = ({ issueKey: issueKey, issueId: issueId, issueSummary: issueSummary, issueLinksCount: issueLinksCount, issueTypeField: issueTypeField })=>{
    const { permissions: { linkIssues: linkIssues } } = (0, $kQAZu.useProject)();
    const refetchIssues = (0, $5FsEp.useRefetchIssues)();
    const onIssueUnlink = (0, $eUqFw.useCallback)((issueIds)=>{
        refetchIssues(issueIds.map(Number));
    }, [
        refetchIssues
    ]);
    const onIssueLink = (0, $eUqFw.useCallback)((originalIssueId, updateIssueIds)=>{
        const issueIds = [
            originalIssueId,
            ...updateIssueIds
        ];
        refetchIssues(issueIds.map(Number));
    }, [
        refetchIssues
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gSSYZ.IssueLinksStats), {
        testId: "work-management-board.ui.board.column.card.card-footer.issue-links",
        issueLinksCount: issueLinksCount,
        issueKey: issueKey,
        issueId: String(issueId),
        issueSummary: issueSummary,
        issueType: issueTypeField?.issueType,
        feedbackCollectorPrefix: "business-board",
        isLinkingEnabled: linkIssues,
        sourceProductType: (0, $7ZZxN.CORE_PROJECT),
        onIssueUnlink: onIssueUnlink,
        onIssueLink: onIssueLink,
        maxIssueLinksStatsCount: 9
    });
};
const $4193899be4feee51$export$a8a190e7e67ab4f5 = /*#__PURE__*/ (0, $eUqFw.memo)($4193899be4feee51$var$IssueLinksNotMemo);

});
parcelRegister("gSSYZ", function(module, exports) {

$parcel$export(module.exports, "IssueLinksStats", () => $7c3797fc27cf4728$export$471e3cf08f140899);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $04VQy = parcelRequire("04VQy");
const $7c3797fc27cf4728$export$471e3cf08f140899 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "issue-links-stats-business",
        packageName: "jiraIssueLinksStatsBusiness",
        teamName: "jira-werewolves",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $04VQy.IssueLinksStats), props));

});
parcelRegister("04VQy", function(module, exports) {

$parcel$export(module.exports, "IssueLinksStats", () => $07e882c6cc812654$export$471e3cf08f140899);

var $eUqFw = parcelRequire("eUqFw");

var $6hbAE = parcelRequire("6hbAE");

var $90HtQ = parcelRequire("90HtQ");

var $eruWR = parcelRequire("eruWR");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");


var $jl1we = parcelRequire("jl1we");

var $cFpT4 = parcelRequire("cFpT4");

var $c9TLT = parcelRequire("c9TLT");

var $l3Qg0 = parcelRequire("l3Qg0");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $heNuy = parcelRequire("heNuy");

var $b03HR = parcelRequire("b03HR");

var $1i7ym = parcelRequire("1i7ym");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $eIp1n = parcelRequire("eIp1n");

var $dWLk9 = parcelRequire("dWLk9");

var $dAMh4 = parcelRequire("dAMh4");

var $bT56S = parcelRequire("bT56S");

var $gYrUv = parcelRequire("gYrUv");
const $07e882c6cc812654$export$901087bc7dae0943 = (target)=>{
    if (target instanceof HTMLElement) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (!document.querySelector('#jira-frontend')?.contains(target)) return true;
    }
    return false;
};
const $07e882c6cc812654$var$MAX_ISSUE_LINKS_COUNT = 50;
const $07e882c6cc812654$var$asyncIssueLinksDetailsLoad = (0, $cFpT4.metrics).interaction({
    key: 'issue-links-details-content-load'
});
const $07e882c6cc812654$var$asyncIssueLinkPopupLoad = (0, $cFpT4.metrics).interaction({
    key: 'issue-link-popup-load'
});
const $07e882c6cc812654$export$471e3cf08f140899 = ({ issueLinksCount: issueLinksCount, maxIssueLinksStatsCount: maxIssueLinksStatsCount, testId: testId, issueKey: issueKey, issueId: issueId, issueSummary: issueSummary, issueType: issueType, feedbackCollectorPrefix: feedbackCollectorPrefix, isLinkingEnabled: isLinkingEnabled, onIssueUnlink: onIssueUnlinkProp, onIssueLink: onIssueLinkProp, sourceProductType: sourceProductType, stopPropagationOnClick: stopPropagationOnClick = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [isLinkPopupOpen, setIsLinkPopupOpen] = (0, $eUqFw.useState)(false);
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions, stopMetric: stopMetric } = (0, $6j4bv.useEntryPoint)((0, $heNuy.issueLinksDetailsContentEntryPoint), {
        cloudId: cloudId,
        issueKey: issueKey,
        // Fetch 1 more than required so that we show view all linked issues button
        issueCount: $07e882c6cc812654$var$MAX_ISSUE_LINKS_COUNT + 1,
        withDueDate: true,
        fields: [
            'issuetype',
            'summary',
            'status',
            'duedate'
        ]
    }, $07e882c6cc812654$var$asyncIssueLinksDetailsLoad);
    const triggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions);
    const { entryPointReferenceSubject: linkIssuePopupEntryPointReferenceSubject, entryPointActions: linkIssuePopupEntryPointActions, stopMetric: linkIssuePopupStopMetric } = (0, $6j4bv.useEntryPoint)((0, $b03HR.linkIssuePopupEntryPoint), {
        cloudId: cloudId
    }, $07e882c6cc812654$var$asyncIssueLinkPopupLoad);
    const onTriggerButtonClick = (event, analyticsEvent)=>{
        if (isOpen) onPopupClose();
        else setIsOpen(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueLinksStats', {
            isToOpenPopup: !isOpen
        });
    };
    const onPopupClose = (0, $eUqFw.useCallback)((event)=>{
        if (stopPropagationOnClick && event?.target && $07e882c6cc812654$export$901087bc7dae0943(event.target)) return;
        if (isLinkPopupOpen) {
            if (event instanceof KeyboardEvent && (event.key === 'Escape' || event.key === 'Esc')) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'linkIssuePopup dismissed', {
                reason: 'escapeKey'
            });
            if (event instanceof MouseEvent) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'linkIssuePopup dismissed', {
                reason: 'clickOutsidePopup'
            });
        }
        setIsOpen(false);
        setIsLinkPopupOpen(false);
    }, [
        createAnalyticsEvent,
        isLinkPopupOpen,
        stopPropagationOnClick
    ]);
    const onIssueUnlink = (0, $eUqFw.useCallback)((issueIds)=>{
        onIssueUnlinkProp(issueIds);
        setIsOpen(false);
    }, [
        onIssueUnlinkProp
    ]);
    const onIssueLink = (0, $eUqFw.useCallback)((id, updateIssueIds)=>{
        onIssueLinkProp(id, updateIssueIds);
        onPopupClose();
    }, [
        onIssueLinkProp,
        onPopupClose
    ]);
    const onIssueLinkButtonClick = (0, $eUqFw.useCallback)(()=>{
        setIsLinkPopupOpen(true);
        linkIssuePopupEntryPointActions.load();
    }, [
        linkIssuePopupEntryPointActions
    ]);
    const onIssueLinkPopupClose = ()=>{
        setIsLinkPopupOpen(false);
    };
    const tooltipContent = issueLinksCount > maxIssueLinksStatsCount ? formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gYrUv.messages).genericMaxIssueLinksStatsTooltipLabelIssueTermRefresh : (0, $gYrUv.messages).genericMaxIssueLinksStatsTooltipLabel, {
        maxIssueLinksStatsCount: maxIssueLinksStatsCount
    }) : formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gYrUv.messages).issueLinksTooltipLabelIssueTermRefresh : (0, $gYrUv.messages).issueLinksTooltipLabel, {
        issueLinksCount: issueLinksCount
    });
    const renderTriggerButton = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
            content: tooltipContent,
            testId: "issue-links-stats-business.ui.linked-issue-stats-tooltip"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6hbAE.default), {
            ...triggerProps,
            appearance: "subtle",
            spacing: "compact",
            testId: `issue-links-stats-business.ui.issue-links-stats-button.custom-theme-button-${issueKey}`,
            ref: (element)=>{
                triggerRef(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref(element);
            },
            isSelected: isOpen,
            onClick: onTriggerButtonClick,
            "aria-label": tooltipContent,
            iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($90HtQ))), {
                    LEGACY_size: "small",
                    color: isOpen ? `var(--ds-icon-accent-blue, ${(0, $1b343b038f6c23ec$exports).B500})` : `var(--ds-icon, ${(0, $1b343b038f6c23ec$exports).N500})`,
                    label: ""
                })
        }, issueLinksCount > maxIssueLinksStatsCount ? `${maxIssueLinksStatsCount}+` : issueLinksCount));
    const popupRuntimeProps = (0, $eUqFw.useMemo)(()=>({
            issueId: issueId,
            issueKey: issueKey,
            onSuccessfulIssueLink: onIssueLink,
            onClose: onIssueLinkPopupClose,
            trackOriginSource: 'JWM',
            onReady: linkIssuePopupStopMetric
        }), [
        issueId,
        issueKey,
        linkIssuePopupStopMetric,
        onIssueLink
    ]);
    const contentRuntimeProps = (0, $eUqFw.useMemo)(()=>({
            cloudId: cloudId,
            issueKey: issueKey,
            issueSummary: issueSummary,
            issueId: issueId,
            issueType: issueType,
            canUserLinkIssue: isLinkingEnabled,
            onIssueUnlink: onIssueUnlink,
            onPopupClose: onPopupClose,
            maxIssuesToDisplay: $07e882c6cc812654$var$MAX_ISSUE_LINKS_COUNT,
            feedbackCollectorPrefix: feedbackCollectorPrefix,
            onReady: stopMetric,
            sourceProductType: sourceProductType,
            onIssueLinkButtonClick: onIssueLinkButtonClick,
            openIssueInNewTabOnExceedLimitClick: true
        }), [
        cloudId,
        feedbackCollectorPrefix,
        isLinkingEnabled,
        issueId,
        issueKey,
        issueSummary,
        issueType,
        onIssueLinkButtonClick,
        onIssueUnlink,
        onPopupClose,
        sourceProductType,
        stopMetric
    ]);
    const renderContent = ()=>{
        if (isLinkPopupOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
            id: "businessLinkIssuePopupEntryPoint",
            packageName: "@atlassian/jira-link-issue-popup",
            teamName: "jira-werewolves",
            entryPointReferenceSubject: linkIssuePopupEntryPointReferenceSubject,
            runtimeProps: popupRuntimeProps,
            errorFallback: "flag",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1i7ym.IssueLinksPopupFallback), null)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
            padding: "space.200",
            xcss: $07e882c6cc812654$var$ContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "async-issue-links-details-content",
            runtimeProps: contentRuntimeProps,
            packageName: "@atlassian/jira-issue-links-details-content",
            teamName: "jira-werewolves",
            errorFallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dAMh4.IssueLinksDetailsErrorFallback), {
                    callback: onPopupClose,
                    error: error,
                    testId: "issue-links-stats-business.ui.issue-links-details-popup-entrypoint-container"
                }),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT56S.IssueLinksDetailsPopupSkeleton), {
                noPadding: true,
                smallerWidth: true,
                testId: "issue-links-stats-business.ui.skeleton-loader"
            })
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "issueLinksStats",
        attributes: {
            application: sourceProductType && (0, $eIp1n.getApplicationForProject)(sourceProductType)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        testId: testId,
        onClick: (event)=>stopPropagationOnClick && event.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eruWR.default), {
        isOpen: isOpen,
        onClose: onPopupClose,
        placement: "bottom-start",
        testId: "issue-links-stats-business.ui.popup",
        trigger: renderTriggerButton,
        content: renderContent,
        shouldUseCaptureOnOutsideClick: stopPropagationOnClick,
        label: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gYrUv.messages).issueLinksPopupIssueTermRefresh : (0, $gYrUv.messages).issueLinksPopup)
    })));
};
const $07e882c6cc812654$var$ContainerStyles = (0, $8Vv3m.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $c9TLT.gridSize) * 64}px`
});

});
parcelRegister("90HtQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fadf8272c4914ed4349f03b15a40b7eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68f5d76c03277df6$var$_react = $68f5d76c03277df6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $68f5d76c03277df6$var$_issues = $68f5d76c03277df6$var$_interopRequireDefault((parcelRequire("2eF7l")));

var $68f5d76c03277df6$var$_issues2 = $68f5d76c03277df6$var$_interopRequireDefault((parcelRequire("e1BYB")));
function $68f5d76c03277df6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for IssuesIcon.
 * This component is IssuesIcon, with `UNSAFE_fallbackIcon` set to "IssuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multiple issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $68f5d76c03277df6$var$IssuesIcon = (props)=>/*#__PURE__*/ $68f5d76c03277df6$var$_react.default.createElement($68f5d76c03277df6$var$_issues.default, Object.assign({
        LEGACY_fallbackIcon: $68f5d76c03277df6$var$_issues2.default
    }, props));
$68f5d76c03277df6$var$IssuesIcon.Name = 'IssuesIconMigration';
var $68f5d76c03277df6$var$_default = module.exports.default = $68f5d76c03277df6$var$IssuesIcon;

});

parcelRegister("l3Qg0", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $c6e813dbc513f02a$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $c6e813dbc513f02a$export$5f13515bd3a35325);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $a9frS = parcelRequire("a9frS");
const $c6e813dbc513f02a$export$25d2524a63315ed = (actions, isActive = true, eventMap = $c6e813dbc513f02a$export$5f13515bd3a35325(actions), shouldFocusBackOnSecondMount = false)=>{
    const removePreviousListeners = (0, $eUqFw.useRef)(null);
    const isMounted = (0, $eUqFw.useRef)(true);
    const isNotFirstMount = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $eUqFw.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        if (element && isActive) {
            (0, $a9frS.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: eventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $a9frS.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: eventMap
                });
            };
            if (shouldFocusBackOnSecondMount && isNotFirstMount.current && (0, $eI5EY.fg)('jsc_create_bar_refresh')) element.focus();
        } else {
            removePreviousListeners.current = null;
            isNotFirstMount.current = true;
        }
    }, [
        eventMap,
        isActive,
        shouldFocusBackOnSecondMount
    ]);
};
const $c6e813dbc513f02a$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("a9frS", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $592b51d0c18fde03$export$15257a36a7e3f9d6);
function $592b51d0c18fde03$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("heNuy", function(module, exports) {

$parcel$export(module.exports, "issueLinksDetailsContentEntryPoint", () => $83a4c3a36fc9aef2$export$ed55e17b62c0c3b0);

var $i4Bk1 = parcelRequire("i4Bk1");

var $14fpI = parcelRequire("14fpI");

var $4dIH4 = parcelRequire("4dIH4");

const $83a4c3a36fc9aef2$export$ed55e17b62c0c3b0 = (0, $4dIH4.createEntryPoint)({
    root: (0, $14fpI.JSResourceForInteraction)(()=>(parcelRequire("4sfH4")), {
        moduleId: "56ed134e"
    }),
    getPreloadProps: ({ cloudId: cloudId, issueKey: issueKey, issueCount: issueCount, withDueDate: withDueDate, fields: fields })=>({
            queries: {
                issueLinksDetailsPopup: {
                    // policy can be updated to store-or-network once we have issue linking mutation through relay
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $i4Bk1.default,
                    variables: {
                        cloudId: cloudId,
                        issueKey: issueKey,
                        issueCount: issueCount,
                        withDueDate: withDueDate,
                        fields: fields
                    }
                }
            }
        })
});

});
parcelRegister("i4Bk1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc8186daeaa448c1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3911672bf59cd9c5cbbd5af9f5777951>>
 * @relayHash a08180161ec6ab9c7e11d8f628199d37
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fb7810939eb3c247c90b6c590a41c138ba5abb1fafe8508efd4ed201487f6b41
const $cc8186daeaa448c1$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fb7810939eb3c247c90b6c590a41c138ba5abb1fafe8508efd4ed201487f6b41",
        "metadata": {},
        "name": "srcAsyncIssueLinksDetailsContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $cc8186daeaa448c1$export$2e2bcd8739ae039 = $cc8186daeaa448c1$var$node;

});

parcelRegister("4sfH4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5xtrL").then(()=>parcelRequire('ebyPr'));

});


parcelRegister("b03HR", function(module, exports) {

$parcel$export(module.exports, "linkIssuePopupEntryPoint", () => $f8b812f447343c01$export$537a4e334f2de676);

var $6TuD4 = parcelRequire("6TuD4");

var $14fpI = parcelRequire("14fpI");

var $4dIH4 = parcelRequire("4dIH4");

const $f8b812f447343c01$export$537a4e334f2de676 = (0, $4dIH4.createEntryPoint)({
    root: (0, $14fpI.JSResourceForInteraction)(()=>(parcelRequire("csBx9")), {
        moduleId: "e0e327f9"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                issueLinksTypes: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $6TuD4.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("6TuD4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0170b90948732f90$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2f031d559b6b4aa1484052708468df2c>>
 * @relayHash ef080d6ba522722031ef94e4887d4972
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 34d278c2e16727746e37236ed6b6c53c028ecbb07c23708312783363197eb20b
const $0170b90948732f90$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "inwards"
    }, v4 = {
        "kind": "ScalarField",
        "name": "outwards"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainAsyncIssueLinksTypesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueLinkTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueLinkTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLinkTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueLinkType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.inwards"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v4 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.outwards"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainAsyncIssueLinksTypesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueLinkTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueLinkTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLinkTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueLinkType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "34d278c2e16727746e37236ed6b6c53c028ecbb07c23708312783363197eb20b",
            "metadata": {},
            "name": "mainAsyncIssueLinksTypesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0170b90948732f90$var$node.hash = "ad0bf63495377e340f30a9f1531b3f3c";
var $0170b90948732f90$export$2e2bcd8739ae039 = $0170b90948732f90$var$node;

});

parcelRegister("csBx9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dvdGb").then(()=>parcelRequire('1ZW56'));

});


parcelRegister("1i7ym", function(module, exports) {

$parcel$export(module.exports, "IssueLinksPopupFallback", () => $1d3e922d60bd0af6$export$623aae6a1e4b8f7d);

var $eUqFw = parcelRequire("eUqFw");

var $45qbL = parcelRequire("45qbL");
var $8Vv3m = parcelRequire("8Vv3m");

var $bBdMg = parcelRequire("bBdMg");
const $1d3e922d60bd0af6$export$623aae6a1e4b8f7d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $45qbL.default), {
        xcss: $1d3e922d60bd0af6$var$linkIssuePopupFallbackStyles,
        alignInline: "center",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bBdMg.default), {
        size: "medium"
    }));
const $1d3e922d60bd0af6$var$linkIssuePopupFallbackStyles = (0, $8Vv3m.xcss)({
    width: '360px',
    height: '342px'
});

});

parcelRegister("dAMh4", function(module, exports) {

$parcel$export(module.exports, "IssueLinksDetailsErrorFallback", () => $3ad3f86af2cdb875$export$5489cdf86d4767fd);

var $eUqFw = parcelRequire("eUqFw");

var $JRB5w = parcelRequire("JRB5w");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $dxw0i = parcelRequire("dxw0i");
const $3ad3f86af2cdb875$export$5489cdf86d4767fd = ({ callback: callback, testId: testId, error: error })=>{
    callback && callback();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    showFlag({
        id: 'async-issue-links-details-entrypoint-flag',
        type: 'error',
        testId: testId,
        title: formatMessage((0, $dxw0i.messages).issueLinksDetailsErrorFlagTitle),
        description: formatMessage((0, $dxw0i.messages).issueLinksDetailsErrorFlagDescription),
        isAutoDismiss: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
        task: 'viewIssueLinksDetailsPopup',
        isClientFetchError: (0, $JRB5w.isClientFetchError)(error)
    });
    // need to return an empty fragment as entrypoint fallback prop only accept ((props: { error: Error }) => ReactElement);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};

});
parcelRegister("dxw0i", function(module, exports) {

$parcel$export(module.exports, "messages", () => $707ffb590fb8f909$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $707ffb590fb8f909$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issueLinksDetailsErrorFlagTitle: {
        "id": "issue-links-stats-business.issue-links-details-error-fallback.issue-links-details-error-flag-title",
        "defaultMessage": "We couldn't load your data"
    },
    issueLinksDetailsErrorFlagDescription: {
        "id": "issue-links-stats-business.issue-links-details-error-fallback.issue-links-details-error-flag-description",
        "defaultMessage": "Refresh the page and try again, or contact your admin."
    }
});

});


parcelRegister("bT56S", function(module, exports) {

$parcel$export(module.exports, "IssueLinksDetailsPopupSkeleton", () => $3edef41f2835460f$export$c2d4e4e846447365);

var $eUqFw = parcelRequire("eUqFw");

var $7UnBG = parcelRequire("7UnBG");

var $fsrW4 = parcelRequire("fsrW4");
var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");
const $3edef41f2835460f$export$c2d4e4e846447365 = ({ testId: testId, smallerWidth: smallerWidth, noPadding: noPadding = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        testId: testId,
        xcss: smallerWidth ? $3edef41f2835460f$var$smallerWidthStyles : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fsrW4.default), {
        inline: noPadding ? 'space.200' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7UnBG.default), {
        width: "60%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7UnBG.default), {
        width: "100%",
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7UnBG.default), {
        width: "100%",
        hasIcon: true
    })));
const $3edef41f2835460f$var$smallerWidthStyles = (0, $8Vv3m.xcss)({
    width: '80%'
});

});

parcelRegister("gYrUv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $58c9180c0c47af76$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $58c9180c0c47af76$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issueLinksTooltipLabel: {
        "id": "issue-links-stats-business.issue-links-tooltip-label",
        "defaultMessage": "{issueLinksCount} linked {issueLinksCount, plural, one {issue} other {issues}}"
    },
    genericMaxIssueLinksStatsTooltipLabel: {
        "id": "issue-links-stats-business.generic-max-issue-links-stats-tooltip-label",
        "defaultMessage": "{maxIssueLinksStatsCount}+ linked issues"
    },
    issueLinksPopup: {
        "id": "issue-links-stats-business.issue-links-popup",
        "defaultMessage": "Linked issues pop up"
    },
    issueLinksTooltipLabelIssueTermRefresh: {
        "id": "issue-links-stats-business.issue-links-tooltip-label-issue-term-refresh",
        "defaultMessage": "{issueLinksCount} linked {issueLinksCount, plural, one {issue} other {issues}}"
    },
    genericMaxIssueLinksStatsTooltipLabelIssueTermRefresh: {
        "id": "issue-links-stats-business.generic-max-issue-links-stats-tooltip-label-issue-term-refresh",
        "defaultMessage": "{maxIssueLinksStatsCount}+ linked issues"
    },
    issueLinksPopupIssueTermRefresh: {
        "id": "issue-links-stats-business.issue-links-popup-issue-term-refresh",
        "defaultMessage": "Linked issues pop up"
    }
});

});





parcelRegister("3wfag", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cba0860f611197b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $hsCsM = parcelRequire("hsCsM");

var $gIx2f = parcelRequire("gIx2f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2vRZq = parcelRequire("2vRZq");

var $kySwt = parcelRequire("kySwt");
const $9cba0860f611197b$var$INLINE_CREATE_TRIGGER_OFFSET = 12;
const $9cba0860f611197b$var$InlineSiblingCreate = ({ group: group, isTopMost: isTopMost, isSiblingCreateFormOpen: isSiblingCreateFormOpen, issue: issue, toggleSiblingCreateForm: toggleSiblingCreateForm })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const inlineCreateProps = (0, $2vRZq.useInlineCreateProps)({
        group: group,
        rankBeforeIssue: issue
    });
    // prevents onBlur from being called before the click event is finished
    const handleTriggerMouseDown = (0, $eUqFw.useCallback)((e)=>{
        e.preventDefault();
    }, []);
    const openSiblingCreate = (0, $eUqFw.useCallback)(()=>toggleSiblingCreateForm(issue.id), [
        issue.id,
        toggleSiblingCreateForm
    ]);
    const closeSiblingCreate = (0, $eUqFw.useCallback)(()=>toggleSiblingCreateForm(null), [
        toggleSiblingCreateForm
    ]);
    return isSiblingCreateFormOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $9cba0860f611197b$var$inlineFormWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gIx2f.default), {
        ...inlineCreateProps,
        location: "boardSibling",
        onBlur: closeSiblingCreate
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hsCsM.default), {
        direction: "row",
        onClick: openSiblingCreate,
        onMouseDown: handleTriggerMouseDown,
        label: formatMessage((0, $kySwt.default).createSiblingIssue),
        offset: $9cba0860f611197b$var$INLINE_CREATE_TRIGGER_OFFSET,
        position: isTopMost ? 1 : -2
    });
};
var $9cba0860f611197b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($9cba0860f611197b$var$InlineSiblingCreate);
const $9cba0860f611197b$var$inlineFormWrapperStyles = (0, $8Vv3m.xcss)({
    marginBottom: 'space.050'
});

});
parcelRegister("hsCsM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b80ad28b2aa0af0b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $9xsX7 = parcelRequire("9xsX7");

var $jl1we = parcelRequire("jl1we");
const $b80ad28b2aa0af0b$var$BUTTON_SIZE = 24;
const $b80ad28b2aa0af0b$var$DIVIDER_SIZE = 2;
const $b80ad28b2aa0af0b$var$ROW = 'row';
const $b80ad28b2aa0af0b$var$COLUMN = 'column';
const $b80ad28b2aa0af0b$var$InlineCreateTrigger = ({ direction: direction, label: label, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseDown: onMouseDown, onMouseUp: onMouseUp, forceVisibility: forceVisibility = false, parentSize: parentSize = '100%', position: position = 0, offset: offset = 0 })=>{
    const [isButtonHovered, setIsButtonHovered] = (0, $eUqFw.useState)(false);
    const handleMouseEnterButton = (0, $eUqFw.useCallback)((event)=>{
        onMouseEnter && onMouseEnter(event);
        setIsButtonHovered(true);
    }, [
        onMouseEnter
    ]);
    const handleMouseLeaveButton = (0, $eUqFw.useCallback)((event)=>{
        onMouseLeave && onMouseLeave(event);
        setIsButtonHovered(false);
    }, [
        onMouseLeave
    ]);
    const Container = (0, $eUqFw.useMemo)(()=>direction === $b80ad28b2aa0af0b$var$ROW ? $b80ad28b2aa0af0b$var$RowContainer : $b80ad28b2aa0af0b$var$ColumnContainer, [
        direction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Container, {
        isButtonHovered: isButtonHovered,
        forceVisibility: forceVisibility,
        parentSize: typeof parentSize === 'number' ? `${parentSize}px` : parentSize,
        position: position,
        offset: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b80ad28b2aa0af0b$var$TriggerButton, {
        "data-testid": "business-inline-create-trigger.ui.trigger-button",
        onClick: onClick,
        onMouseDown: onMouseDown,
        onMouseEnter: handleMouseEnterButton,
        onMouseLeave: handleMouseLeaveButton,
        onMouseUp: onMouseUp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9xsX7))), {
        label: label,
        size: "medium"
    }))));
};
var $b80ad28b2aa0af0b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b80ad28b2aa0af0b$var$InlineCreateTrigger);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b80ad28b2aa0af0b$var$RowContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { forceVisibility: forceVisibility, isButtonHovered: isButtonHovered, parentSize: parentSize, position: position, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_az6wk1": (0, $9t7rW.default)(__cmplp.parentSize),
            "--_1htntus": (0, $9t7rW.default)(__cmplp.offset, "px"),
            "--_1gjsdub": (0, $9t7rW.default)(`${__cmplp.position - $b80ad28b2aa0af0b$var$BUTTON_SIZE * 0.5}px`),
            "--_s3bx6z": (0, $9t7rW.default)(`-${__cmplp.offset}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pby1kze _1e0c1txw _4cvr1h6o _4t3i1tcg _kqswstnw _154i1wab _1ltvd2z4 _v5641w7c _aetrb3bt _1hfkc6ar _1qdgyh40 _qc5o11zv _z0ai1osq _dkthkb7n _1h7hkb7n _1mygkb7n _16l4kb7n",
            __cmplp.forceVisibility ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.isButtonHovered || !__cmplp.forceVisibility ? "_1bsbzgxw" : "_1bsb1tcg",
            __cmplp.isButtonHovered ? "_1peqkb7n" : "_1peqidpf",
            __cmplp.className
        ])
    });
});
const $b80ad28b2aa0af0b$var$ColumnContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { forceVisibility: forceVisibility, isButtonHovered: isButtonHovered, parentSize: parentSize, position: position, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_az6wk1": (0, $9t7rW.default)(__cmplp.parentSize),
            "--_1htntus": (0, $9t7rW.default)(__cmplp.offset, "px"),
            "--_s3bx6z": (0, $9t7rW.default)(`-${__cmplp.offset}px`),
            "--_1gjsdub": (0, $9t7rW.default)(`${__cmplp.position - $b80ad28b2aa0af0b$var$BUTTON_SIZE * 0.5}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pby1kze _1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1tcg _kqswstnw _154id2z4 _1ltv1wab _v5641w7c _aetrb3bt _1hfkc6ar _1qdg1osq _qc5o11zv _z0aiyh40 _dkthkb7n _1h7hkb7n _1mygkb7n _16l4kb7n",
            __cmplp.forceVisibility ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.isButtonHovered || !__cmplp.forceVisibility ? "_4t3izgxw" : "_4t3i1tcg",
            __cmplp.isButtonHovered ? "_1peqkb7n" : "_1peqidpf",
            __cmplp.className
        ])
    });
});
const $b80ad28b2aa0af0b$var$TriggerButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1tcg _1bsb1tcg _kqswh2mm _16qs1ehn _19ith6cr _11q71bhr _80omtlke _2rko1sit _n7dw1ghs _1lwi1ghs _jomr12yw _irr312yw _nt751r31 _1dit1r31 _49pcglyw _ksodglyw _1hvw1o36 _4hz81o36",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gIx2f", function(module, exports) {

$parcel$export(module.exports, "CARD_APPEARANCE", () => $4f781e23a9165d0b$export$2e234a0f40160716);
$parcel$export(module.exports, "ROW_APPEARANCE", () => $4f781e23a9165d0b$export$e99c52f52501386d);
$parcel$export(module.exports, "default", () => $4f781e23a9165d0b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $lUg8E = parcelRequire("lUg8E");

var $6hbAE = parcelRequire("6hbAE");
var $kRXDJ = parcelRequire("kRXDJ");

var $3yGlo = parcelRequire("3yGlo");

var $5IJsn = parcelRequire("5IJsn");

var $iBeSy = parcelRequire("iBeSy");
var $1JJay = parcelRequire("1JJay");
var $8Vv3m = parcelRequire("8Vv3m");

var $6EqnL = parcelRequire("6EqnL");
var $5IfN7 = parcelRequire("5IfN7");

var $jl1we = parcelRequire("jl1we");

var $kQAZu = parcelRequire("kQAZu");

var $gEmpR = parcelRequire("gEmpR");

var $4G5xU = parcelRequire("4G5xU");

var $hw2eW = parcelRequire("hw2eW");

var $ji3xf = parcelRequire("ji3xf");

var $7c3W1 = parcelRequire("7c3W1");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");


var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $8rQuz = parcelRequire("8rQuz");

var $lB25E = parcelRequire("lB25E");

var $l4rzg = parcelRequire("l4rzg");

var $auegK = parcelRequire("auegK");

var $d3C6e = parcelRequire("d3C6e");

var $kTIhq = parcelRequire("kTIhq");

var $fkT5k = parcelRequire("fkT5k");
const $4f781e23a9165d0b$var$GENERIC_ICON_URL = '/icons/issuetypes/genericissue.svg';
const $4f781e23a9165d0b$export$2e234a0f40160716 = 'CARD';
const $4f781e23a9165d0b$export$e99c52f52501386d = 'ROW';
const $4f781e23a9165d0b$var$LINK = 'link';
const $4f781e23a9165d0b$var$ISSUE_TYPE = 'issueType';
const $4f781e23a9165d0b$var$useExperience = (location)=>(0, $eUqFw.useMemo)(()=>{
        let experienceId;
        switch(location){
            case 'listFooter':
            case 'listSibling':
            case 'listGroup':
            case 'listHierarchy':
                experienceId = 'list';
                break;
            case 'boardFooter':
            case 'boardSibling':
                experienceId = 'board';
                break;
            case 'calendarDate':
                experienceId = 'calendar';
                break;
            case 'timelineFooter':
            case 'timelineSibling':
            case 'timelineHierarchy':
                experienceId = 'timeline';
                break;
            default:
                throw new Error(`Unknown location ${location}`);
        }
        return {
            ...(0, $l4rzg.CREATE_ISSUE_EXPERIENCE),
            experienceId: experienceId
        };
    }, [
        location
    ]);
const $4f781e23a9165d0b$var$Option = ({ children: children, ...props })=>{
    if (props.data.optionType === $4f781e23a9165d0b$var$ISSUE_TYPE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6EqnL.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$OptionWrapper, {
        "data-testid": "business-issue-create.ui.inline-create-form.option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$OptionTypeIcon, {
        src: props.data.issueType.avatarUrl ?? $4f781e23a9165d0b$var$GENERIC_ICON_URL,
        alt: ""
    }), children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$ExtraLinksGroup, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$StyledLink, {
        href: props.data.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6EqnL.components).Option, props, children)));
};
const $4f781e23a9165d0b$export$35cad9398ceaeef0 = ()=>{
    const isReadyRef = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        setTimeout(()=>{
            isReadyRef.current = true;
        }, 100);
    }, []);
    return isReadyRef;
};
const $4f781e23a9165d0b$var$isComposing = (event)=>event.nativeEvent.isComposing;
const $4f781e23a9165d0b$var$ChevronDownIcon = ()=>{
    if ((0, $8rQuz.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5IJsn))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3yGlo))), {
        label: ""
    });
};
const $4f781e23a9165d0b$var$InlineCreateForm = ({ allowedIssueTypeIds: allowedIssueTypeIds, appearance: appearance, borderRadius: borderRadius, fieldIdsToReturn: fieldIdsToReturn = [], indent: indent, isCompact: isCompact, location: location, maxHierarchyLevel: maxHierarchyLevel = Number.POSITIVE_INFINITY, minHeight: minHeight, minHierarchyLevel: minHierarchyLevel = 0, onBlur: onBlur, onPrepareIssueContext: onPrepareIssueContext, onSubmit: onSubmit, popperStrategy: popperStrategy = 'absolute' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: { issueTypes: issueTypes } } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    const project = (0, $kQAZu.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const [filter] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FILTER_PREFERENCE));
    const [sorting] = (0, $7c3W1.useViewPreference)((0, $ji3xf.SORTING_PREFERENCE));
    const [preferredIssueTypeId, savePreferredIssueTypeId] = (0, $7c3W1.useViewPreference)((0, $ji3xf.CREATE_TYPE_ID_PREFERENCE));
    const showSuccessFlag = filter != null || sorting != null;
    const experience = $4f781e23a9165d0b$var$useExperience(location);
    const startExperience = (0, $4G5xU.useExperienceStart)(experience);
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)(experience);
    const markExperienceFail = (0, $4G5xU.useExperienceFail)(experience);
    const abortExperience = (0, $4G5xU.useExperienceAbort)(experience);
    const issueTypeOptions = (0, $eUqFw.useMemo)(()=>{
        const validIssueTypes = issueTypes.filter((issueType)=>{
            const isAllowed = allowedIssueTypeIds?.includes(issueType.id) ?? true;
            return isAllowed && issueType.hierarchyLevel >= minHierarchyLevel && issueType.hierarchyLevel <= maxHierarchyLevel;
        });
        const typeOptions = validIssueTypes.map((issueType)=>({
                label: issueType.name,
                value: issueType.id,
                issueType: issueType,
                optionType: $4f781e23a9165d0b$var$ISSUE_TYPE
            }));
        typeOptions.sort(// sort by decreasing hierarchy level
        (a, b)=>b.issueType.hierarchyLevel - a.issueType.hierarchyLevel);
        return typeOptions;
    }, [
        allowedIssueTypeIds,
        issueTypes,
        maxHierarchyLevel,
        minHierarchyLevel
    ]);
    const options = (0, $eUqFw.useMemo)(()=>{
        const canManageTypes = project.permissions.administerProject;
        const manageIssueTypesLink = (0, $hw2eW.getIssueTypesSettingsUrl)(project.key, project.isSimplified);
        let manageTypesOption = null;
        if (canManageTypes) {
            manageTypesOption = {
                label: formatMessage((0, $kTIhq.default).manageIssueTypes),
                value: manageIssueTypesLink,
                url: manageIssueTypesLink,
                optionType: $4f781e23a9165d0b$var$LINK
            };
            return [
                ...issueTypeOptions,
                manageTypesOption
            ];
        }
        return [
            ...issueTypeOptions
        ];
    }, [
        formatMessage,
        issueTypeOptions,
        project
    ]);
    const { summaryRef: summaryRef, submit: submit, blur: blur } = (0, $d3C6e.useCreateIssue)(onSubmit, onBlur);
    const [selectedType, setSelectedType] = (0, $eUqFw.useState)(()=>{
        if (preferredIssueTypeId) {
            const defaultIssueType = issueTypeOptions.find((issueType)=>issueType.value === preferredIssueTypeId);
            if (defaultIssueType) return defaultIssueType;
        } // Returns the first issue type with hierarchy level of zero if there is no last used issue type
        if (minHierarchyLevel === 0) return issueTypeOptions.find((option)=>option.issueType.hierarchyLevel === 0) ?? options[0];
        return options[0];
    });
    const [textContent, setTextContent] = (0, $eUqFw.useState)(summaryRef.current);
    summaryRef.current = textContent;
    const formRef = (0, $eUqFw.useRef)(null);
    const popperRef = (0, $eUqFw.useRef)(null);
    const isEmptyRef = (0, $eUqFw.useRef)(true);
    const textAreaRef = (0, $eUqFw.useRef)(null);
    isEmptyRef.current = textContent.trim().length === 0;
    const handleCreateIssue = ()=>{
        if (!isEmptyRef.current && selectedType.optionType === $4f781e23a9165d0b$var$ISSUE_TYPE) {
            const issueType = issueTypes.find((type)=>type.id === selectedType.value);
            startExperience();
            const result = submit({
                input: {
                    summary: textContent.trim(),
                    projectId: String(project.id),
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    issueType: issueType,
                    ...onPrepareIssueContext?.()
                },
                fieldIdsToReturn: fieldIdsToReturn,
                location: location,
                showSuccessFlag: showSuccessFlag
            });
            setTextContent('');
            result.promise.then(()=>markExperienceSuccess()).catch((error)=>{
                if (error instanceof (0, $auegK.CancelledError)) abortExperience('User cancelled');
                else markExperienceFail('Failed to create issue', error);
            });
        }
    };
    const handleCreateIssueRef = (0, $eUqFw.useRef)(handleCreateIssue);
    handleCreateIssueRef.current = handleCreateIssue; // prevent blurring from occurring when the form is first rendered
    const isReadyRef = $4f781e23a9165d0b$export$35cad9398ceaeef0();
    const handleBlur = (0, $eUqFw.useCallback)((event)=>{
        if (!isReadyRef.current) return;
         // make sure to make a local copy of the isEmptyRef value before it gets reset by the create handler
        const formEmpty = isEmptyRef.current; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const inForm = formRef.current?.contains(event.target) ?? false; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const inPopper = popperRef.current?.contains(event.target) ?? false;
        if (!inForm && !inPopper) {
            handleCreateIssueRef.current();
            blur();
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'form blurred', 'inlineCreate', {
                location: location,
                formEmpty: formEmpty,
                escapeKeyPressed: false
            });
        }
    }, [
        isReadyRef,
        blur,
        createAnalyticsEvent,
        location
    ]);
    const issueTypeButton = (0, $eUqFw.useCallback)(// PopupSelectTriggerProps is not exported from @atlaskit/select
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (triggerProps)=>(0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6hbAE.default), {
            ...triggerProps,
            appearance: "subtle",
            "aria-label": formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kTIhq.default).selectIssueTypeButtonIssueTermRefresh : (0, $kTIhq.default).selectIssueTypeButton, {
                issueType: selectedType.label
            }),
            testId: "business-issue-create.ui.inline-create-form.issue-type-trigger",
            spacing: "compact"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iBeSy.default), {
            alignItems: "center",
            justifyContent: "center",
            gap: "space.075",
            xcss: $4f781e23a9165d0b$var$issueTypeButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img" // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        , {
            src: selectedType.issueType.avatarUrl ?? undefined,
            alt: "",
            height: 16,
            width: 16
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$ChevronDownIcon, null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$StyledButton, {
            ...triggerProps,
            "aria-label": formatMessage((0, $kTIhq.default).selectIssueTypeButton, {
                issueType: selectedType.label
            }),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img" // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , {
                src: selectedType.issueType.avatarUrl ?? undefined,
                alt: "",
                height: 16,
                width: 16
            }),
            iconAfter: isCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$ChevronDownWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$ChevronDownIcon, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$ChevronDownIcon, null),
            spacing: "compact",
            testId: "business-issue-create.ui.inline-create-form.issue-type-trigger"
        }, !isCompact && selectedType.label), [
        formatMessage,
        isCompact,
        selectedType
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // on mount, we want to move the cursor to the end of the input
        textAreaRef.current?.setSelectionRange(textAreaRef.current.value.length, textAreaRef.current.value.length);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'form focused', 'inlineCreate', {
            location: location
        });
    }, [
        createAnalyticsEvent,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('click', handleBlur, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('click', handleBlur, true);
        };
    }, [
        handleBlur
    ]);
    const issueTypesSelect = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5IfN7.default), {
            onMenuOpen: ()=>{
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'select opened', 'inlineCreateIssueTypes', {
                    location: location
                });
            },
            components: {
                Option: $4f781e23a9165d0b$var$Option
            },
            searchThreshold: 10,
            options: options,
            onChange: (option)=>{
                if (option?.optionType === $4f781e23a9165d0b$var$ISSUE_TYPE) {
                    setSelectedType(option);
                    savePreferredIssueTypeId(option.value);
                }
            },
            popperProps: {
                strategy: popperStrategy,
                innerRef: popperRef
            },
            value: selectedType,
            target: ({ isOpen: isOpen, ...triggerProps })=>isCompact || appearance === $4f781e23a9165d0b$export$e99c52f52501386d && (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
                    content: selectedType.label
                }, issueTypeButton(triggerProps)) : issueTypeButton(triggerProps)
        }), [
        appearance,
        createAnalyticsEvent,
        isCompact,
        issueTypeButton,
        location,
        options,
        popperStrategy,
        savePreferredIssueTypeId,
        selectedType
    ]);
    const getRowHeader = (0, $eUqFw.useCallback)(()=>{
        if ((0, $8rQuz.isVisualRefreshEnabled)()) return issueTypesSelect;
        if (!isCompact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$IssueTypeIcon, {
            alt: "" // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ,
            src: selectedType.issueType.avatarUrl ?? $4f781e23a9165d0b$var$GENERIC_ICON_URL
        });
        return null;
    }, [
        isCompact,
        issueTypesSelect,
        selectedType
    ]); // this is not a scenario we expect to happen but we know it does happen when a project is just created
    // the issue types and fields have a retry mechanism to avoid this but we want to handle it here as well
    // to avoid runtime errors
    if (issueTypes.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$FullContent, {
        appearance: appearance,
        borderRadius: borderRadius,
        indent: indent,
        minHeight: minHeight,
        onKeyDown: (event)=>{
            event.stopPropagation();
            if (event.key === 'Escape' && !$4f781e23a9165d0b$var$isComposing(event)) {
                if ((0, $eI5EY.fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) blur(event);
                else blur();
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'form blurred', 'inlineCreate', {
                    location: location,
                    formEmpty: isEmptyRef.current,
                    escapeKeyPressed: true
                });
            }
        },
        onSubmit: (event)=>{
            event.preventDefault();
            handleCreateIssue();
        },
        ref: formRef
    }, appearance === $4f781e23a9165d0b$export$e99c52f52501386d && getRowHeader(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$StyledTextArea, {
        appearance: appearance,
        autoFocus: true,
        "data-testid": "business-issue-create.ui.inline-create-form.textarea",
        maxLength: (0, $3b526ddeb90a4d89$export$193356664cd84c83),
        onChange: (event)=>{
            const content = event.target.value.replace(/[\n\r]+/g, ' ');
            setTextContent(content);
        },
        onKeyDown: (event)=>{
            if (event.key === 'Enter' && !$4f781e23a9165d0b$var$isComposing(event)) {
                event.preventDefault();
                handleCreateIssue();
            }
        },
        placeholder: formatMessage((0, $kTIhq.default).placeholderText),
        value: textContent,
        ref: textAreaRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$Footer, {
        appearance: appearance
    }, (!(0, $8rQuz.isVisualRefreshEnabled)() || appearance !== $4f781e23a9165d0b$export$e99c52f52501386d) && issueTypesSelect, appearance !== $4f781e23a9165d0b$export$e99c52f52501386d && (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRXDJ.default), {
        label: formatMessage((0, $kTIhq.default).createButton),
        appearance: "default",
        type: "submit",
        onClick: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'inlineCreateSubmit', {
                location: location,
                hierarchyLevel: selectedType.optionType === $4f781e23a9165d0b$var$ISSUE_TYPE ? selectedType.issueType?.hierarchyLevel : undefined
            });
        },
        isDisabled: isEmptyRef.current,
        spacing: "compact",
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
                color: "inherit",
                weight: "medium"
            }, "\u23CE")
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$StyledCreateButton, {
        appearance: "primary",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fkT5k.default), null),
        isDisabled: isEmptyRef.current,
        spacing: "compact",
        type: "submit",
        onClick: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'inlineCreateSubmit', {
                location: location,
                hierarchyLevel: selectedType.optionType === $4f781e23a9165d0b$var$ISSUE_TYPE ? selectedType.issueType?.hierarchyLevel : undefined
            });
        }
    }, formatMessage((0, $kTIhq.default).createButton))));
};
const $4f781e23a9165d0b$var$InlineCreateFormWithErrorBoundary = (props)=>{
    const experience = $4f781e23a9165d0b$var$useExperience(props.location);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceErrorBoundary), {
        experience: experience,
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$InlineCreateForm, props));
};
const $4f781e23a9165d0b$var$genericMemo = (0, $eUqFw.memo);
var $4f781e23a9165d0b$export$2e2bcd8739ae039 = $4f781e23a9165d0b$var$genericMemo($4f781e23a9165d0b$var$InlineCreateFormWithErrorBoundary);
const $4f781e23a9165d0b$var$lineHeight = 20; // margin: '0px' is needed to override the default margin of the form element
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$FullContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { borderRadius: borderRadius, minHeight: minHeight, appearance: appearance, indent: indent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_a70prk": (0, $9t7rW.default)(__cmplp.borderRadius ?? "var(--ds-border-radius, 3px)"),
            "--_jfgeee": (0, $9t7rW.default)(__cmplp.minHeight ?? '40px'),
            "--_10qudx8": (0, $9t7rW.default)(__cmplp.appearance === $4f781e23a9165d0b$export$e99c52f52501386d && 'center'),
            "--_gg0ene": (0, $9t7rW.default)(__cmplp.indent)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulpu2gc _bfhkvuon _v56416gf _16qshqll _vchhusvi _12ji1r31 _1qu2glyw _12y31o36 _2rko7ebt _1tkej4pn _4cvrnb98 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc",
            __cmplp.appearance === $4f781e23a9165d0b$export$2e234a0f40160716 ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.appearance === $4f781e23a9165d0b$export$e99c52f52501386d ? "_4t3i1ylp" : "_4t3i53f4",
            __cmplp.appearance === $4f781e23a9165d0b$export$2e234a0f40160716 && "_1yt4utpp _n3tdutpp",
            __cmplp.indent && "_19bv2uct",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$StyledTextArea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "textarea", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt41b66 _14zgglyw _bfhkvuon _syaz1fxt _ect41wi2 _1wybdlk8 _vwz4gktf _1idr1wmz _1wfakb7n",
            __cmplp.appearance === $4f781e23a9165d0b$export$2e234a0f40160716 ? "_4t3i1ylp" : "_4t3igktf",
            __cmplp.appearance === $4f781e23a9165d0b$export$e99c52f52501386d && "_o572qvpr _1fjgglyw _1cicglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$Footer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulpu2gc _4cvr1h6o",
            __cmplp.appearance === $4f781e23a9165d0b$export$2e234a0f40160716 ? "_1bah1yb4" : "_1bahh9n0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lUg8E.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$StyledCreateButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lUg8E.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$OptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$OptionTypeIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ipxbi _1bsbpxbi _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$ExtraLinksGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_x3dope8f _19pk1b66 _ca0q1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$StyledLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lB25E.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$IssueTypeIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ipxbi _1bsbpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$ChevronDownWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s83jz8",
            __cmplp.className
        ])
    });
});
const $4f781e23a9165d0b$var$issueTypeButtonStyles = (0, $8Vv3m.xcss)({
    marginTop: 'space.050'
});

});
parcelRegister("6EqnL", function(module, exports) {

$parcel$export(module.exports, "components", () => $676f8cc7fc9199f1$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $676f8cc7fc9199f1$export$71abc632aa29e6fe);

var $kfs3D = parcelRequire("kfs3D");

var $5eRrO = parcelRequire("5eRrO");

var $ngqpF = parcelRequire("ngqpF");

var $8YZfj = parcelRequire("8YZfj");

var $fG8ma = parcelRequire("fG8ma");

var $6t2wI = parcelRequire("6t2wI");

var $i0VNY = parcelRequire("i0VNY");

var $35wVQ = parcelRequire("35wVQ");

var $akzU3 = parcelRequire("akzU3");

var $7VMaH = parcelRequire("7VMaH");
const $676f8cc7fc9199f1$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $8YZfj.ClearIndicator),
    Control: (0, $5eRrO.default),
    DropdownIndicator: (0, $8YZfj.DropdownIndicator),
    DownChevron: (0, $8YZfj.DownChevron),
    CrossIcon: (0, $8YZfj.CrossIcon),
    Group: (0, $ngqpF.default),
    GroupHeading: (0, $ngqpF.GroupHeading),
    IndicatorsContainer: (0, $kfs3D.IndicatorsContainer),
    IndicatorSeparator: (0, $8YZfj.IndicatorSeparator),
    Input: (0, $fG8ma.default),
    LoadingIndicator: (0, $8YZfj.LoadingIndicator),
    Menu: (0, $6t2wI.default),
    MenuList: (0, $6t2wI.MenuList),
    MenuPortal: (0, $6t2wI.MenuPortal),
    LoadingMessage: (0, $6t2wI.LoadingMessage),
    NoOptionsMessage: (0, $6t2wI.NoOptionsMessage),
    MultiValue: (0, $i0VNY.default),
    MultiValueContainer: (0, $i0VNY.MultiValueContainer),
    MultiValueLabel: (0, $i0VNY.MultiValueLabel),
    MultiValueRemove: (0, $i0VNY.MultiValueRemove),
    Option: (0, $35wVQ.default),
    Placeholder: (0, $akzU3.default),
    SelectContainer: (0, $kfs3D.SelectContainer),
    SingleValue: (0, $7VMaH.default),
    ValueContainer: (0, $kfs3D.ValueContainer)
};
const $676f8cc7fc9199f1$export$71abc632aa29e6fe = (props)=>({
        ...$676f8cc7fc9199f1$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("kfs3D", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $9bc2a331068e3f37$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $9bc2a331068e3f37$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $9bc2a331068e3f37$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $9bc2a331068e3f37$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $9bc2a331068e3f37$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $9bc2a331068e3f37$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $9bc2a331068e3f37$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    });
const $9bc2a331068e3f37$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'container', {
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }),
        ...innerProps
    }, children);
};
const $9bc2a331068e3f37$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } }, unstyled)=>({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden',
        ...unstyled ? {} : {
            padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
        }
    });
const $9bc2a331068e3f37$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
    const styles = (0, $DomJ2.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: styles.css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: styles.className || 'value-container',
        ...innerProps
    }, children);
};
const $9bc2a331068e3f37$export$9d74e3c8b5868ad7 = ()=>({
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    });
const $9bc2a331068e3f37$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'indicatorsContainer', {
            indicators: true
        }),
        ...innerProps
    }, children);
};

});
parcelRegister("DomJ2", function(module, exports) {

$parcel$export(module.exports, "noop", () => $a7fa863fc859695d$export$8793edee2d425525);
$parcel$export(module.exports, "classNames", () => $a7fa863fc859695d$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "cleanValue", () => $a7fa863fc859695d$export$33f062f47f21a01);
$parcel$export(module.exports, "cleanCommonProps", () => $a7fa863fc859695d$export$8e9fd4287627890c);
$parcel$export(module.exports, "getStyleProps", () => $a7fa863fc859695d$export$26417cabd806a658);
$parcel$export(module.exports, "handleInputChange", () => $a7fa863fc859695d$export$2096bae78ecda911);
$parcel$export(module.exports, "isDocumentElement", () => $a7fa863fc859695d$export$d8a62a489b442872);
$parcel$export(module.exports, "normalizedHeight", () => $a7fa863fc859695d$export$2e0654fad740d2e4);
$parcel$export(module.exports, "getScrollTop", () => $a7fa863fc859695d$export$c4a223a8ba9e4ea5);
$parcel$export(module.exports, "scrollTo", () => $a7fa863fc859695d$export$3f99968195accfaf);
$parcel$export(module.exports, "getScrollParent", () => $a7fa863fc859695d$export$cfa2225e87938781);
$parcel$export(module.exports, "animatedScrollTo", () => $a7fa863fc859695d$export$858c30343199f3af);
$parcel$export(module.exports, "scrollIntoView", () => $a7fa863fc859695d$export$53a0910f038337bd);
$parcel$export(module.exports, "getBoundingClientObj", () => $a7fa863fc859695d$export$7807c2a424c2f6d1);
$parcel$export(module.exports, "isTouchCapable", () => $a7fa863fc859695d$export$56963d77dbffdde7);
$parcel$export(module.exports, "isMobileDevice", () => $a7fa863fc859695d$export$44f917bf91becd01);
$parcel$export(module.exports, "supportsPassiveEvents", () => $a7fa863fc859695d$export$b0622a6911dbeaf5);
$parcel$export(module.exports, "notNullish", () => $a7fa863fc859695d$export$aedb69ff3e31596c);
$parcel$export(module.exports, "valueTernary", () => $a7fa863fc859695d$export$40fb9515c784cc3b);
$parcel$export(module.exports, "singleValueAsValue", () => $a7fa863fc859695d$export$dea4763e29237f4c);
$parcel$export(module.exports, "multiValueAsValue", () => $a7fa863fc859695d$export$d1ca752ec761b95b);
$parcel$export(module.exports, "removeProps", () => $a7fa863fc859695d$export$4213b25a1c4e877);
const $a7fa863fc859695d$export$8793edee2d425525 = ()=>{};
const $a7fa863fc859695d$export$1643ccb46f49255c = ()=>'';
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $a7fa863fc859695d$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $a7fa863fc859695d$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$a7fa863fc859695d$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $a7fa863fc859695d$export$33f062f47f21a01 = (value)=>{
    if ($a7fa863fc859695d$export$43bee75e5e14138e(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $a7fa863fc859695d$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $a7fa863fc859695d$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $a7fa863fc859695d$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $a7fa863fc859695d$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $a7fa863fc859695d$export$2e0654fad740d2e4(el) {
    if ($a7fa863fc859695d$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $a7fa863fc859695d$export$c4a223a8ba9e4ea5(el) {
    if ($a7fa863fc859695d$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $a7fa863fc859695d$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($a7fa863fc859695d$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $a7fa863fc859695d$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $a7fa863fc859695d$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $a7fa863fc859695d$export$858c30343199f3af(element, to, duration = 200, callback = $a7fa863fc859695d$export$8793edee2d425525) {
    const start = $a7fa863fc859695d$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $a7fa863fc859695d$var$easeOutCubic(currentTime, start, change, duration);
        $a7fa863fc859695d$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $a7fa863fc859695d$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $a7fa863fc859695d$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $a7fa863fc859695d$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $a7fa863fc859695d$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $a7fa863fc859695d$export$c0d0115e766e14c3(str) {
    return str.replace(/\W/g, '-');
}
function $a7fa863fc859695d$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $a7fa863fc859695d$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $a7fa863fc859695d$var$passiveOptionAccessed = false;
const $a7fa863fc859695d$var$options = {
    get passive () {
        return $a7fa863fc859695d$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $a7fa863fc859695d$var$w = typeof window !== 'undefined' ? window : {};
if ($a7fa863fc859695d$var$w.addEventListener && $a7fa863fc859695d$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $a7fa863fc859695d$var$w.addEventListener('p', $a7fa863fc859695d$export$8793edee2d425525, $a7fa863fc859695d$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $a7fa863fc859695d$var$w.removeEventListener('p', $a7fa863fc859695d$export$8793edee2d425525, false);
}
const $a7fa863fc859695d$export$b0622a6911dbeaf5 = $a7fa863fc859695d$var$passiveOptionAccessed;
function $a7fa863fc859695d$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $a7fa863fc859695d$export$43bee75e5e14138e(arg) {
    return Array.isArray(arg);
}
function $a7fa863fc859695d$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $a7fa863fc859695d$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $a7fa863fc859695d$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $a7fa863fc859695d$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};

});


parcelRegister("5eRrO", function(module, exports) {

$parcel$export(module.exports, "css", () => $6c9f9c8f28b24213$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $6c9f9c8f28b24213$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $6c9f9c8f28b24213$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } }, unstyled)=>({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms',
        ...unstyled ? {} : {
            backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
            borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
            borderRadius: borderRadius,
            borderStyle: 'solid',
            borderWidth: 1,
            boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
            '&:hover': {
                borderColor: isFocused ? colors.primary : colors.neutral30
            }
        }
    });
const $6c9f9c8f28b24213$var$Control = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        ...(0, $DomJ2.getStyleProps)(props, 'control', {
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }),
        ...innerProps,
        "aria-disabled": isDisabled || undefined
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6c9f9c8f28b24213$export$2e2bcd8739ae039 = $6c9f9c8f28b24213$var$Control;

});

parcelRegister("ngqpF", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $aad1e47212eaaeb7$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $aad1e47212eaaeb7$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $aad1e47212eaaeb7$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $aad1e47212eaaeb7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $aad1e47212eaaeb7$export$b6794329c1460634 = ({ theme: { spacing: spacing } }, unstyled)=>unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
const $aad1e47212eaaeb7$var$Group = (props)=>{
    const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'group', {
            group: true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Heading, {
        ...headingProps,
        selectProps: selectProps,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }, label), /*#__PURE__*/ (0, $byn9U.jsx)("div", null, children));
};
const $aad1e47212eaaeb7$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } }, unstyled)=>({
        label: 'group',
        cursor: 'default',
        display: 'block',
        ...unstyled ? {} : {
            color: colors.neutral40,
            fontSize: '75%',
            fontWeight: 500,
            marginBottom: '0.25em',
            paddingLeft: spacing.baseUnit * 3,
            paddingRight: spacing.baseUnit * 3,
            textTransform: 'uppercase'
        }
    });
const $aad1e47212eaaeb7$export$85c8b41a3cd87edc = (props)=>{
    const { data: data, ...innerProps } = (0, $DomJ2.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'groupHeading', {
            'group-heading': true
        }),
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$aad1e47212eaaeb7$export$2e2bcd8739ae039 = $aad1e47212eaaeb7$var$Group;

});

parcelRegister("8YZfj", function(module, exports) {

$parcel$export(module.exports, "CrossIcon", () => $17a6994453780832$export$3b621d86b1566b2);
$parcel$export(module.exports, "DownChevron", () => $17a6994453780832$export$c5cbe1656ba71e6c);
$parcel$export(module.exports, "dropdownIndicatorCSS", () => $17a6994453780832$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $17a6994453780832$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $17a6994453780832$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $17a6994453780832$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "indicatorSeparatorCSS", () => $17a6994453780832$export$ec39646155d07fdd);
$parcel$export(module.exports, "IndicatorSeparator", () => $17a6994453780832$export$bd638c2ba7915668);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $17a6994453780832$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $17a6994453780832$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
function $17a6994453780832$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
const $17a6994453780832$var$styles = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
const $17a6994453780832$var$Svg = ({ size: size, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $17a6994453780832$var$styles,
        ...props
    });
const $17a6994453780832$export$3b621d86b1566b2 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$var$Svg, {
        size: 20,
        ...props
    }, /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
const $17a6994453780832$export$c5cbe1656ba71e6c = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$var$Svg, {
        size: 20,
        ...props
    }, /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
const $17a6994453780832$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        ...unstyled ? {} : {
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2,
            ':hover': {
                color: isFocused ? colors.neutral80 : colors.neutral40
            }
        }
    });
const $17a6994453780832$export$e1687335805e1230 = $17a6994453780832$var$baseCSS;
const $17a6994453780832$export$ec98719d3db7f2e4 = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'dropdownIndicator', {
            indicator: true,
            'dropdown-indicator': true
        }),
        ...innerProps
    }, children || /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$export$c5cbe1656ba71e6c, null));
};
const $17a6994453780832$export$9c0419fd944c1def = $17a6994453780832$var$baseCSS;
const $17a6994453780832$export$ecf9cf59142dd54a = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'clearIndicator', {
            indicator: true,
            'clear-indicator': true
        }),
        ...innerProps
    }, children || /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$export$3b621d86b1566b2, null));
};
const $17a6994453780832$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1,
        ...unstyled ? {} : {
            backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
            marginBottom: baseUnit * 2,
            marginTop: baseUnit * 2
        }
    });
const $17a6994453780832$export$bd638c2ba7915668 = (props)=>{
    const { innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...innerProps,
        ...(0, $DomJ2.getStyleProps)(props, 'indicatorSeparator', {
            'indicator-separator': true
        })
    });
};
// ==============================
// Loading
// ==============================
const $17a6994453780832$var$loadingDotAnimations = (0, $byn9U.keyframes)({
    '0%, 80%, 100%': {
        opacity: 0
    },
    '40%': {
        opacity: 1
    }
});
const $17a6994453780832$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } }, unstyled)=>({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle',
        ...unstyled ? {} : {
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2
        }
    });
const $17a6994453780832$var$LoadingDot = ({ delay: delay, offset: offset })=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: (0, $byn9U.css)({
            animation: `${$17a6994453780832$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        })
    });
const $17a6994453780832$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)({
            ...restProps,
            innerProps: innerProps,
            isRtl: isRtl,
            size: size
        }, 'loadingIndicator', {
            indicator: true,
            'loading-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$var$LoadingDot, {
        delay: 160,
        offset: true
    }), /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};

});

parcelRegister("fG8ma", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $08ad391264e2f439$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $08ad391264e2f439$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $08ad391264e2f439$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : '',
        ...$08ad391264e2f439$var$containerStyle,
        ...unstyled ? {} : {
            margin: spacing.baseUnit / 2,
            paddingBottom: spacing.baseUnit / 2,
            paddingTop: spacing.baseUnit / 2,
            color: colors.neutral80
        }
    });
const $08ad391264e2f439$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
const $08ad391264e2f439$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': {
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre',
        ...$08ad391264e2f439$var$spacingStyle
    }
};
const $08ad391264e2f439$var$inputStyle = (isHidden)=>({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%',
        ...$08ad391264e2f439$var$spacingStyle
    });
const $08ad391264e2f439$var$Input = (props)=>{
    const { cx: cx, value: value } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, $DomJ2.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'input', {
            'input-container': true
        }),
        "data-value": value || ''
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $08ad391264e2f439$var$inputStyle(isHidden),
        disabled: isDisabled,
        ...innerProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$08ad391264e2f439$export$2e2bcd8739ae039 = $08ad391264e2f439$var$Input;

});

parcelRegister("6t2wI", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $b67347fe66559b87$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $b67347fe66559b87$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $b67347fe66559b87$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $b67347fe66559b87$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $b67347fe66559b87$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "noOptionsMessageCSS", () => $b67347fe66559b87$export$cf0e22534d8b0074);
$parcel$export(module.exports, "loadingMessageCSS", () => $b67347fe66559b87$export$98ec46397a8cb3cd);
$parcel$export(module.exports, "NoOptionsMessage", () => $b67347fe66559b87$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $b67347fe66559b87$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $b67347fe66559b87$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $b67347fe66559b87$export$793392f970497feb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5O3G9 = parcelRequire("5O3G9");

var $lEfVV = parcelRequire("lEfVV");

var $k286k = parcelRequire("k286k");

var $DomJ2 = parcelRequire("DomJ2");
function $b67347fe66559b87$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $DomJ2.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $DomJ2.normalizedHeight)(scrollParent);
    const scrollTop = (0, $DomJ2.getScrollTop)(scrollParent);
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTop;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $DomJ2.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $DomJ2.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $DomJ2.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $DomJ2.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $DomJ2.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
function $b67347fe66559b87$var$alignToControl(placement) {
    const placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
const $b67347fe66559b87$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $b67347fe66559b87$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'menu',
        [$b67347fe66559b87$var$alignToControl(placement)]: '100%',
        position: 'absolute',
        width: '100%',
        zIndex: 1,
        ...unstyled ? {} : {
            backgroundColor: colors.neutral0,
            borderRadius: borderRadius,
            boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
            marginBottom: spacing.menuGutter,
            marginTop: spacing.menuGutter
        }
    });
const $b67347fe66559b87$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $b67347fe66559b87$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $eUqFw.useContext)($b67347fe66559b87$var$PortalPlacementContext) || {};
    const ref = (0, $eUqFw.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $eUqFw.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $eUqFw.useState)(null);
    const { controlHeight: controlHeight } = theme.spacing;
    (0, $k286k.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $b67347fe66559b87$export$bd649b913ec78e4a({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $b67347fe66559b87$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $b67347fe66559b87$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'menu', {
            menu: true
        }),
        ref: innerRef,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b67347fe66559b87$export$2e2bcd8739ae039 = $b67347fe66559b87$var$Menu;
const $b67347fe66559b87$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } }, unstyled)=>({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch',
        ...unstyled ? {} : {
            paddingBottom: baseUnit,
            paddingTop: baseUnit
        }
    });
const $b67347fe66559b87$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'menuList', {
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }),
        //@ts-ignore
        ref: innerRef,
        ...innerProps
    }, children);
};
// ==============================
// Menu Notices
// ==============================
const $b67347fe66559b87$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        textAlign: 'center',
        ...unstyled ? {} : {
            color: colors.neutral40,
            padding: `${baseUnit * 2}px ${baseUnit * 3}px`
        }
    });
const $b67347fe66559b87$export$cf0e22534d8b0074 = $b67347fe66559b87$var$noticeCSS;
const $b67347fe66559b87$export$98ec46397a8cb3cd = $b67347fe66559b87$var$noticeCSS;
const $b67347fe66559b87$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
    return(//@ts-ignore
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'noOptionsMessage', {
            'menu-notice': true,
            'menu-notice--no-options': true
        }),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps
    }, children));
};
const $b67347fe66559b87$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'loadingMessage', {
            'menu-notice': true,
            'menu-notice--loading': true
        }),
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
    }, children);
};
const $b67347fe66559b87$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    });
const $b67347fe66559b87$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
    const menuPortalRef = (0, $eUqFw.useRef)(null);
    const cleanupRef = (0, $eUqFw.useRef)(null);
    const [placement, setPortalPlacement] = (0, $eUqFw.useState)($b67347fe66559b87$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $eUqFw.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $eUqFw.useState)(null);
    const updateComputedPosition = (0, $eUqFw.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $DomJ2.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $k286k.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $eUqFw.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $eUqFw.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: setMenuPortalElement,
        ...(0, $DomJ2.getStyleProps)({
            ...props,
            offset: computedPosition.offset,
            position: menuPosition,
            rect: computedPosition.rect
        }, 'menuPortal', {
            'menu-portal': true
        }),
        ...innerProps
    }, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)($b67347fe66559b87$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});
parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});


parcelRegister("i0VNY", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $b976d04d171aaa69$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $b976d04d171aaa69$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $b976d04d171aaa69$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $b976d04d171aaa69$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $b976d04d171aaa69$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $b976d04d171aaa69$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $b976d04d171aaa69$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");

var $8YZfj = parcelRequire("8YZfj");
const $b976d04d171aaa69$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } }, unstyled)=>({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0,
        // resolves flex/text-overflow bug
        ...unstyled ? {} : {
            backgroundColor: colors.neutral10,
            borderRadius: borderRadius / 2,
            margin: spacing.baseUnit / 2
        }
    });
const $b976d04d171aaa69$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis }, unstyled)=>({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap',
        ...unstyled ? {} : {
            borderRadius: borderRadius / 2,
            color: colors.neutral80,
            fontSize: '85%',
            padding: 3,
            paddingLeft: 6
        }
    });
const $b976d04d171aaa69$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused }, unstyled)=>({
        alignItems: 'center',
        display: 'flex',
        ...unstyled ? {} : {
            borderRadius: borderRadius / 2,
            backgroundColor: isFocused ? colors.dangerLight : undefined,
            paddingLeft: spacing.baseUnit,
            paddingRight: spacing.baseUnit,
            ':hover': {
                backgroundColor: colors.dangerLight,
                color: colors.danger
            }
        }
    });
const $b976d04d171aaa69$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", innerProps, children);
const $b976d04d171aaa69$export$cf9cf2a30a59265c = $b976d04d171aaa69$export$e1de505c1242dc1a;
const $b976d04d171aaa69$export$544aeea2a5ce08ee = $b976d04d171aaa69$export$e1de505c1242dc1a;
function $b976d04d171aaa69$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "button",
        ...innerProps
    }, children || /*#__PURE__*/ (0, $byn9U.jsx)((0, $8YZfj.CrossIcon), {
        size: 14
    }));
}
const $b976d04d171aaa69$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    return /*#__PURE__*/ (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: {
            ...(0, $DomJ2.getStyleProps)(props, 'multiValue', {
                'multi-value': true,
                'multi-value--is-disabled': isDisabled
            }),
            ...innerProps
        },
        selectProps: selectProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: {
            ...(0, $DomJ2.getStyleProps)(props, 'multiValueLabel', {
                'multi-value__label': true
            })
        },
        selectProps: selectProps
    }, children), /*#__PURE__*/ (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: {
            ...(0, $DomJ2.getStyleProps)(props, 'multiValueRemove', {
                'multi-value__remove': true
            }),
            'aria-label': `Remove ${children || 'option'}`,
            ...removeProps
        },
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b976d04d171aaa69$export$2e2bcd8739ae039 = $b976d04d171aaa69$var$MultiValue;

});

parcelRegister("35wVQ", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $b618ec36fb5deec3$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $b618ec36fb5deec3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $b618ec36fb5deec3$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        ...unstyled ? {} : {
            backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
            color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
            padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
            // provide some affordance on touch devices
            ':active': {
                backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
            }
        }
    });
const $b618ec36fb5deec3$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'option', {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }),
        //@ts-ignore
        ref: innerRef,
        "aria-disabled": isDisabled,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b618ec36fb5deec3$export$2e2bcd8739ae039 = $b618ec36fb5deec3$var$Option;

});

parcelRegister("akzU3", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $ee7392090dabd55f$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $ee7392090dabd55f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $ee7392090dabd55f$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3',
        ...unstyled ? {} : {
            color: colors.neutral50,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        }
    });
const $ee7392090dabd55f$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'placeholder', {
            placeholder: true
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ee7392090dabd55f$export$2e2bcd8739ae039 = $ee7392090dabd55f$var$Placeholder;

});

parcelRegister("7VMaH", function(module, exports) {

$parcel$export(module.exports, "css", () => $bee4e3936873fc73$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $bee4e3936873fc73$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $bee4e3936873fc73$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ...unstyled ? {} : {
            color: isDisabled ? colors.neutral40 : colors.neutral80,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        }
    });
const $bee4e3936873fc73$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'singleValue', {
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bee4e3936873fc73$export$2e2bcd8739ae039 = $bee4e3936873fc73$var$SingleValue;

});


parcelRegister("5IfN7", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf75109f1a322fd4$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $lEfVV = parcelRequire("lEfVV");

var $6Pq2D = parcelRequire("6Pq2D");

var $1TUfP = parcelRequire("1TUfP");

var $lbDTY = parcelRequire("lbDTY");

var $kQSBm = parcelRequire("kQSBm");
var $5bdEm = parcelRequire("5bdEm");
var $dmg8t = parcelRequire("dmg8t");

var $asNSH = parcelRequire("asNSH");

var $2Pede = parcelRequire("2Pede");

var $gYrJM = parcelRequire("gYrJM");

var $8r9C9 = parcelRequire("8r9C9");


var $aJuqz = parcelRequire("aJuqz");

var $a3o6L = parcelRequire("a3o6L");

var $NHgCB = parcelRequire("NHgCB");

var $2FrYX = parcelRequire("2FrYX");
/**
 * Are we rendering on the client or server?
 */ const $bf75109f1a322fd4$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $bf75109f1a322fd4$var$FocusLock = (0, $gYrJM.fg)('platform_dst_select-bump-react-focus-lock') ? (0, $1TUfP.default) : (0, $6Pq2D.default);
const $bf75109f1a322fd4$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $bf75109f1a322fd4$var$defaultPopperProps = {
    modifiers: $bf75109f1a322fd4$var$modifiers,
    placement: 'bottom-start'
};
const $bf75109f1a322fd4$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $bf75109f1a322fd4$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$bf75109f1a322fd4$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $2FrYX.defaultComponents),
            ...props.components
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$bf75109f1a322fd4$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $74BVL.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQSBm.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Pede.IdProvider), {
            postfix: "-popup-select"
        }, ({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dmg8t.Reference), null, ({ ref: ref })=>target && target({
                    isOpen: isOpen,
                    onKeyDown: this.handleTargetKeyDown,
                    ref: this.resolveTargetRef(ref),
                    'aria-haspopup': 'true',
                    'aria-expanded': isOpen,
                    'aria-controls': isOpen ? id : undefined
                })), this.renderSelect(id))));
    }
    constructor(...args){
        super(...args);
        this.menuRef = null;
        this.selectRef = null;
        this.targetRef = null;
        this.unbindWindowClick = null;
        this.unbindWindowKeydown = null;
        this.defaultStyles = (0, $8r9C9.mergeStyles)((0, $a3o6L.default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $1b343b038f6c23ec$export$eaa8c8a70ac22806})`
                })
        });
        this.isOpenControlled = this.props.isOpen !== undefined;
        this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
        this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $2FrYX.defaultComponents),
            mergedPopperProps: $bf75109f1a322fd4$var$defaultPopperProps
        };
        // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        };
        this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            if ((0, $gYrJM.fg)('tab-event-should-close-popupSelect')) {
                const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
                if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            }
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        };
        this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        };
        this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        };
        this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        };
        // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen && (0, $gYrJM.fg)('platform_design_system_team_select_node_resolver')) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        };
        /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose && (0, $gYrJM.fg)('platform_design_system_team_select_node_resolver')) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        };
        // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            };
        this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            };
        this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        };
        this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        };
        // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        };
        // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const menuHandlers = !(0, $gYrJM.fg)('platform_design_system_team_select_node_resolver') ? {
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose
            } : {};
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $bf75109f1a322fd4$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $2FrYX.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const providedAriaLabel = getLabel();
            const updateInputAriaLabel = (ariaLabelText)=>{
                // Update aria-label to get first announcement when popup opened.
                if (this.selectRef?.select?.inputRef) {
                    if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                    this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                }
            };
            const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                const { focused: focused } = onFocusProps;
                const options = props?.options || [];
                const totalLength = options?.length;
                const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                // Option LABEL focused, 1 of 8. 8 results available.
                // Use Up and Down to choose options, press Enter to select the currently focused option,
                // press Escape to exit the menu.
                return ariaLabelText;
            };
            const onReactSelectFocus = (onFocusProps)=>{
                const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                let ariaLabelText = '';
                let ariaLiveMessage = '';
                if (props.options?.length) {
                    if ((0, $NHgCB.isOptionsGrouped)(props.options)) {
                        const totalLength = (0, $NHgCB.countAllOptions)(props.options);
                        ariaLiveMessage = (0, $NHgCB.onFocus)(onFocusProps, props.options);
                        ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                    } else {
                        ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                        ariaLiveMessage = ariaLabelText;
                    }
                    updateInputAriaLabel(ariaLabelText);
                    return ariaLiveMessage;
                }
                return ariaLiveMessage;
            };
            const popper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5bdEm.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                }
            }, ({ placement: placement, ref: ref, style: style })=>// When the feature flag 'platform_design_system_team_select_node_resolver' is enabled,
                // we directly pass the ref to MenuDialog instead of wrapping it with NodeResolver.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bf75109f1a322fd4$var$ConditionalNodeResolverWrapper, {
                    hasNodeResolver: !(0, $gYrJM.fg)('platform_design_system_team_select_node_resolver'),
                    innerRef: this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2FrYX.MenuDialog), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: style,
                    "data-placement": placement,
                    minWidth: minMenuWidth,
                    maxWidth: maxMenuWidth,
                    id: id,
                    testId: testId,
                    ref: !(0, $gYrJM.fg)('platform_design_system_team_select_node_resolver') ? null : this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bf75109f1a322fd4$var$FocusLock, {
                    disabled: !focusLockEnabled,
                    returnFocus: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aJuqz.default), {
                    "aria-label": providedAriaLabel,
                    backspaceRemovesValue: false,
                    controlShouldRenderValue: false,
                    isClearable: false,
                    tabSelectsValue: false,
                    menuIsOpen: true,
                    placeholder: placeholder,
                    ref: this.getSelectRef,
                    ...props,
                    ...menuHandlers,
                    isSearchable: showSearchControl,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    styles: (0, $8r9C9.mergeStyles)(this.defaultStyles, props.styles || {}),
                    maxMenuHeight: this.getMaxHeight(),
                    components: selectComponents,
                    onChange: this.handleSelectChange,
                    ariaLiveMessages: !showSearchControl ? {
                        // Overwriting ariaLiveMessages builtin onFocus method to announce selected option when popup has been opened
                        onFocus: onReactSelectFocus,
                        ...props.ariaLiveMessages // priority to use user handlers if provided
                    } : props.ariaLiveMessages
                }), footer))));
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $lEfVV.createPortal)(popper, portalDestination);
        };
    }
}
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, otherwise just the children.
 */ const $bf75109f1a322fd4$var$ConditionalNodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    if (hasNodeResolver) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
        innerRef: innerRef
    }, children);
    return children;
};

});
parcelRegister("kQSBm", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $f2e304bb02006a02$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $f2e304bb02006a02$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $f2e304bb02006a02$export$d0d38e7dec7a1a61);

var $eUqFw = parcelRequire("eUqFw");
var $f2e304bb02006a02$export$3dbd3405086fec7b = $eUqFw.createContext();
var $f2e304bb02006a02$export$cbabb21c2529b130 = $eUqFw.createContext();
function $f2e304bb02006a02$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eUqFw.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eUqFw.useRef(false);
    $eUqFw.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eUqFw.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eUqFw.createElement($f2e304bb02006a02$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eUqFw.createElement($f2e304bb02006a02$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("5bdEm", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $3c589169ddd94ce2$export$badac9ada3a0bdf9);

var $eUqFw = parcelRequire("eUqFw");

var $kQSBm = parcelRequire("kQSBm");

var $2Leve = parcelRequire("2Leve");

var $efr5v = parcelRequire("efr5v");
var $3c589169ddd94ce2$var$NOOP = function NOOP() {
    return void 0;
};
var $3c589169ddd94ce2$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $3c589169ddd94ce2$var$EMPTY_MODIFIERS = [];
function $3c589169ddd94ce2$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $3c589169ddd94ce2$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eUqFw.useContext((0, $kQSBm.ManagerReferenceNodeContext));
    var _React$useState = $eUqFw.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eUqFw.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eUqFw.useEffect(function() {
        (0, $2Leve.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eUqFw.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $efr5v.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eUqFw.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $3c589169ddd94ce2$var$NOOP,
            update: update || $3c589169ddd94ce2$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $2Leve.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("2Leve", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $202b3879e180f9e1$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $202b3879e180f9e1$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $202b3879e180f9e1$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $202b3879e180f9e1$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $202b3879e180f9e1$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $202b3879e180f9e1$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $202b3879e180f9e1$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $202b3879e180f9e1$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $202b3879e180f9e1$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $202b3879e180f9e1$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $202b3879e180f9e1$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;

});

parcelRegister("efr5v", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $a5f77a7e238a9101$export$f4d5bf230a36dd6e);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $ap33P = parcelRequire("ap33P");

var $an8Qp = parcelRequire("an8Qp");

var $2Leve = parcelRequire("2Leve");
var $a5f77a7e238a9101$var$EMPTY_MODIFIERS = [];
var $a5f77a7e238a9101$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eUqFw.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $a5f77a7e238a9101$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eUqFw.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eUqFw.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $lEfVV.flushSync(function() {
                    setState({
                        styles: (0, $2Leve.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $2Leve.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eUqFw.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($an8Qp)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eUqFw.useRef();
    (0, $2Leve.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $2Leve.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $ap33P.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("ap33P", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $792e9cfbd261b473$export$8f7491d57c8f97a9);

var $lYrVW = parcelRequire("lYrVW");

var $anyZr = parcelRequire("anyZr");

var $3QpMQ = parcelRequire("3QpMQ");

var $bbqbM = parcelRequire("bbqbM");

var $lro9d = parcelRequire("lro9d");

var $6qkVe = parcelRequire("6qkVe");

var $8rAdb = parcelRequire("8rAdb");

var $gFjel = parcelRequire("gFjel");

var $hiKPe = parcelRequire("hiKPe");

var $izul8 = parcelRequire("izul8");


var $792e9cfbd261b473$export$d34966752335dd47 = [
    (0, $anyZr.default),
    (0, $3QpMQ.default),
    (0, $bbqbM.default),
    (0, $lro9d.default),
    (0, $6qkVe.default),
    (0, $8rAdb.default),
    (0, $gFjel.default),
    (0, $hiKPe.default),
    (0, $izul8.default)
];
var $792e9cfbd261b473$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $lYrVW.popperGenerator)({
    defaultModifiers: $792e9cfbd261b473$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("lYrVW", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $fff4de9b669adeeb$export$ed5e13716264f202);

var $ag20p = parcelRequire("ag20p");

var $QrBqo = parcelRequire("QrBqo");

var $ePkdB = parcelRequire("ePkdB");

var $dNrcD = parcelRequire("dNrcD");

var $67G0M = parcelRequire("67G0M");

var $fb5CK = parcelRequire("fb5CK");

var $dFfUS = parcelRequire("dFfUS");


var $edBYZ = parcelRequire("edBYZ");
var $fff4de9b669adeeb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $fff4de9b669adeeb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $fff4de9b669adeeb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $fff4de9b669adeeb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $fff4de9b669adeeb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $edBYZ.isElement)(reference) ? (0, $ePkdB.default)(reference) : reference.contextElement ? (0, $ePkdB.default)(reference.contextElement) : [],
                    popper: (0, $ePkdB.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $67G0M.default)((0, $dFfUS.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$fff4de9b669adeeb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $ag20p.default)(reference, (0, $dNrcD.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $QrBqo.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $fb5CK.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$fff4de9b669adeeb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $fff4de9b669adeeb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $fff4de9b669adeeb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("ag20p", function(module, exports) {

$parcel$export(module.exports, "default", () => $777cf448ef0803dd$export$2e2bcd8739ae039);

var $1a1A9 = parcelRequire("1a1A9");

var $9xSYk = parcelRequire("9xSYk");

var $k9tfz = parcelRequire("k9tfz");

var $edBYZ = parcelRequire("edBYZ");

var $5l3cx = parcelRequire("5l3cx");

var $80xbK = parcelRequire("80xbK");

var $lB8uB = parcelRequire("lB8uB");

var $lCnHF = parcelRequire("lCnHF");
function $777cf448ef0803dd$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $lCnHF.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $lCnHF.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $777cf448ef0803dd$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $edBYZ.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $edBYZ.isHTMLElement)(offsetParent) && $777cf448ef0803dd$var$isElementScaled(offsetParent);
    var documentElement = (0, $80xbK.default)(offsetParent);
    var rect = (0, $1a1A9.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $k9tfz.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $lB8uB.default)(documentElement)) scroll = (0, $9xSYk.default)(offsetParent);
        if ((0, $edBYZ.isHTMLElement)(offsetParent)) {
            offsets = (0, $1a1A9.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $5l3cx.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("1a1A9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d87f3ca928fe9a2$export$2e2bcd8739ae039);

var $edBYZ = parcelRequire("edBYZ");

var $lCnHF = parcelRequire("lCnHF");

var $3xJ5v = parcelRequire("3xJ5v");

var $920uN = parcelRequire("920uN");
function $0d87f3ca928fe9a2$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $edBYZ.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $lCnHF.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $lCnHF.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $edBYZ.isElement)(element) ? (0, $3xJ5v.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $920uN.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("edBYZ", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $a59fbe293893fdf9$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $a59fbe293893fdf9$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $a59fbe293893fdf9$export$af51f0f06c0f328a);

var $3xJ5v = parcelRequire("3xJ5v");
function $a59fbe293893fdf9$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $3xJ5v.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $a59fbe293893fdf9$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $3xJ5v.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $a59fbe293893fdf9$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $3xJ5v.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("3xJ5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $29476dadb45dea2c$export$2e2bcd8739ae039);
function $29476dadb45dea2c$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("lCnHF", function(module, exports) {

$parcel$export(module.exports, "max", () => $fbcf889019494e36$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $fbcf889019494e36$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $fbcf889019494e36$export$2077e0241d6afd3c);
var $fbcf889019494e36$export$8960430cfd85939f = Math.max;
var $fbcf889019494e36$export$96ec731ed4dcb222 = Math.min;
var $fbcf889019494e36$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("920uN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6934af65acd9e478$export$2e2bcd8739ae039);

var $72LZU = parcelRequire("72LZU");
function $6934af65acd9e478$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $72LZU.default)());
}

});
parcelRegister("72LZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $520df39ba6a9a4ac$export$2e2bcd8739ae039);
function $520df39ba6a9a4ac$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("9xSYk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f31d66ead222a8d$export$2e2bcd8739ae039);

var $ac1Wl = parcelRequire("ac1Wl");

var $3xJ5v = parcelRequire("3xJ5v");

var $edBYZ = parcelRequire("edBYZ");

var $hdS5H = parcelRequire("hdS5H");
function $6f31d66ead222a8d$export$2e2bcd8739ae039(node) {
    if (node === (0, $3xJ5v.default)(node) || !(0, $edBYZ.isHTMLElement)(node)) return (0, $ac1Wl.default)(node);
    else return (0, $hdS5H.default)(node);
}

});
parcelRegister("ac1Wl", function(module, exports) {

$parcel$export(module.exports, "default", () => $76bc879f580a47a7$export$2e2bcd8739ae039);

var $3xJ5v = parcelRequire("3xJ5v");
function $76bc879f580a47a7$export$2e2bcd8739ae039(node) {
    var win = (0, $3xJ5v.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("hdS5H", function(module, exports) {

$parcel$export(module.exports, "default", () => $c89d9be7ec372ac1$export$2e2bcd8739ae039);
function $c89d9be7ec372ac1$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("k9tfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $eabb5662a7f5257f$export$2e2bcd8739ae039);
function $eabb5662a7f5257f$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("5l3cx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e31659f48c6f7d6$export$2e2bcd8739ae039);

var $1a1A9 = parcelRequire("1a1A9");

var $80xbK = parcelRequire("80xbK");

var $ac1Wl = parcelRequire("ac1Wl");
function $3e31659f48c6f7d6$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1a1A9.default)((0, $80xbK.default)(element)).left + (0, $ac1Wl.default)(element).scrollLeft;
}

});
parcelRegister("80xbK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d481159709e436d$export$2e2bcd8739ae039);

var $edBYZ = parcelRequire("edBYZ");
function $5d481159709e436d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $edBYZ.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("lB8uB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb93a41cc2fd2e28$export$2e2bcd8739ae039);

var $aPsIR = parcelRequire("aPsIR");
function $fb93a41cc2fd2e28$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $aPsIR.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("aPsIR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e24f28110b44487$export$2e2bcd8739ae039);

var $3xJ5v = parcelRequire("3xJ5v");
function $7e24f28110b44487$export$2e2bcd8739ae039(element) {
    return (0, $3xJ5v.default)(element).getComputedStyle(element);
}

});



parcelRegister("QrBqo", function(module, exports) {

$parcel$export(module.exports, "default", () => $09da44bfd33a27e6$export$2e2bcd8739ae039);

var $1a1A9 = parcelRequire("1a1A9");
function $09da44bfd33a27e6$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1a1A9.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("ePkdB", function(module, exports) {

$parcel$export(module.exports, "default", () => $acb58313ecb6072d$export$2e2bcd8739ae039);

var $fJHhD = parcelRequire("fJHhD");

var $hoKF3 = parcelRequire("hoKF3");

var $3xJ5v = parcelRequire("3xJ5v");

var $lB8uB = parcelRequire("lB8uB");
function $acb58313ecb6072d$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $fJHhD.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $3xJ5v.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $lB8uB.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($acb58313ecb6072d$export$2e2bcd8739ae039((0, $hoKF3.default)(target)));
}

});
parcelRegister("fJHhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b74ca229b5aac469$export$2e2bcd8739ae039);

var $hoKF3 = parcelRequire("hoKF3");

var $lB8uB = parcelRequire("lB8uB");

var $k9tfz = parcelRequire("k9tfz");

var $edBYZ = parcelRequire("edBYZ");
function $b74ca229b5aac469$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $k9tfz.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $edBYZ.isHTMLElement)(node) && (0, $lB8uB.default)(node)) return node;
    return $b74ca229b5aac469$export$2e2bcd8739ae039((0, $hoKF3.default)(node));
}

});
parcelRegister("hoKF3", function(module, exports) {

$parcel$export(module.exports, "default", () => $caa8df7de2e956b1$export$2e2bcd8739ae039);

var $k9tfz = parcelRequire("k9tfz");

var $80xbK = parcelRequire("80xbK");

var $edBYZ = parcelRequire("edBYZ");
function $caa8df7de2e956b1$export$2e2bcd8739ae039(element) {
    if ((0, $k9tfz.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $edBYZ.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $80xbK.default)(element) // fallback
    );
}

});



parcelRegister("dNrcD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0b4f3d95d479f23$export$2e2bcd8739ae039);

var $3xJ5v = parcelRequire("3xJ5v");

var $k9tfz = parcelRequire("k9tfz");

var $aPsIR = parcelRequire("aPsIR");

var $edBYZ = parcelRequire("edBYZ");

var $kqjk2 = parcelRequire("kqjk2");

var $hoKF3 = parcelRequire("hoKF3");

var $72LZU = parcelRequire("72LZU");
function $a0b4f3d95d479f23$var$getTrueOffsetParent(element) {
    if (!(0, $edBYZ.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $aPsIR.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a0b4f3d95d479f23$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $72LZU.default)());
    var isIE = /Trident/i.test((0, $72LZU.default)());
    if (isIE && (0, $edBYZ.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $aPsIR.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $hoKF3.default)(element);
    if ((0, $edBYZ.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $edBYZ.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $k9tfz.default)(currentNode)) < 0){
        var css = (0, $aPsIR.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a0b4f3d95d479f23$export$2e2bcd8739ae039(element) {
    var window = (0, $3xJ5v.default)(element);
    var offsetParent = $a0b4f3d95d479f23$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $kqjk2.default)(offsetParent) && (0, $aPsIR.default)(offsetParent).position === 'static')offsetParent = $a0b4f3d95d479f23$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $k9tfz.default)(offsetParent) === 'html' || (0, $k9tfz.default)(offsetParent) === 'body' && (0, $aPsIR.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $a0b4f3d95d479f23$var$getContainingBlock(element) || window;
}

});
parcelRegister("kqjk2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ede5395aec84864a$export$2e2bcd8739ae039);

var $k9tfz = parcelRequire("k9tfz");
function $ede5395aec84864a$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $k9tfz.default)(element)) >= 0;
}

});


parcelRegister("67G0M", function(module, exports) {

$parcel$export(module.exports, "default", () => $4753fc241c56a947$export$2e2bcd8739ae039);

var $8CWSq = parcelRequire("8CWSq");
function $4753fc241c56a947$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $4753fc241c56a947$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $4753fc241c56a947$var$order(modifiers); // order based on phase
    return (0, $8CWSq.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("8CWSq", function(module, exports) {

$parcel$export(module.exports, "top", () => $647f8b13194227d9$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $647f8b13194227d9$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $647f8b13194227d9$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $647f8b13194227d9$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $647f8b13194227d9$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $647f8b13194227d9$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $647f8b13194227d9$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $647f8b13194227d9$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $647f8b13194227d9$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $647f8b13194227d9$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $647f8b13194227d9$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $647f8b13194227d9$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $647f8b13194227d9$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $647f8b13194227d9$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $647f8b13194227d9$export$d087d3878fdf71d5);
var $647f8b13194227d9$export$1e95b668f3b82d = 'top';
var $647f8b13194227d9$export$40e543e69a8b3fbb = 'bottom';
var $647f8b13194227d9$export$79ffe56a765070d2 = 'right';
var $647f8b13194227d9$export$eabcd2c8791e7bf4 = 'left';
var $647f8b13194227d9$export$dfb5619354ba860 = 'auto';
var $647f8b13194227d9$export$aec2ce47c367b8c3 = [
    $647f8b13194227d9$export$1e95b668f3b82d,
    $647f8b13194227d9$export$40e543e69a8b3fbb,
    $647f8b13194227d9$export$79ffe56a765070d2,
    $647f8b13194227d9$export$eabcd2c8791e7bf4
];
var $647f8b13194227d9$export$b3571188c770cc5a = 'start';
var $647f8b13194227d9$export$bd5df0f255a350f8 = 'end';
var $647f8b13194227d9$export$390fd549c5303b4d = 'clippingParents';
var $647f8b13194227d9$export$d7b7311ec04a3e8f = 'viewport';
var $647f8b13194227d9$export$ae5ab1c730825774 = 'popper';
var $647f8b13194227d9$export$ca50aac9f3ba507f = 'reference';
var $647f8b13194227d9$export$368f9a87e87fa4e1 = /*#__PURE__*/ $647f8b13194227d9$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $647f8b13194227d9$export$b3571188c770cc5a,
        placement + "-" + $647f8b13194227d9$export$bd5df0f255a350f8
    ]);
}, []);
var $647f8b13194227d9$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($647f8b13194227d9$export$aec2ce47c367b8c3, [
    $647f8b13194227d9$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $647f8b13194227d9$export$b3571188c770cc5a,
        placement + "-" + $647f8b13194227d9$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $647f8b13194227d9$export$421679a7c3d56e = 'beforeRead';
var $647f8b13194227d9$export$aafa59e2e03f2942 = 'read';
var $647f8b13194227d9$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $647f8b13194227d9$export$c65e99957a05207c = 'beforeMain';
var $647f8b13194227d9$export$f22da7240b7add18 = 'main';
var $647f8b13194227d9$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $647f8b13194227d9$export$8d4d2d70e7d46032 = 'beforeWrite';
var $647f8b13194227d9$export$68d8715fc104d294 = 'write';
var $647f8b13194227d9$export$70a6e5159acce2e6 = 'afterWrite';
var $647f8b13194227d9$export$d087d3878fdf71d5 = [
    $647f8b13194227d9$export$421679a7c3d56e,
    $647f8b13194227d9$export$aafa59e2e03f2942,
    $647f8b13194227d9$export$6964f6c886723980,
    $647f8b13194227d9$export$c65e99957a05207c,
    $647f8b13194227d9$export$f22da7240b7add18,
    $647f8b13194227d9$export$bab79516f2d662fe,
    $647f8b13194227d9$export$8d4d2d70e7d46032,
    $647f8b13194227d9$export$68d8715fc104d294,
    $647f8b13194227d9$export$70a6e5159acce2e6
];

});


parcelRegister("fb5CK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0cc3ee5e6caa807$export$2e2bcd8739ae039);
function $b0cc3ee5e6caa807$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("dFfUS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f2b735bd29d87f1$export$2e2bcd8739ae039);
function $9f2b735bd29d87f1$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("anyZr", function(module, exports) {

$parcel$export(module.exports, "default", () => $78e731ac5ccd6edc$export$2e2bcd8739ae039);

var $3xJ5v = parcelRequire("3xJ5v");
var $78e731ac5ccd6edc$var$passive = {
    passive: true
};
function $78e731ac5ccd6edc$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $3xJ5v.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $78e731ac5ccd6edc$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $78e731ac5ccd6edc$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $78e731ac5ccd6edc$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $78e731ac5ccd6edc$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $78e731ac5ccd6edc$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $78e731ac5ccd6edc$var$effect,
    data: {}
};

});

parcelRegister("3QpMQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cca3b2cec3a358e$export$2e2bcd8739ae039);

var $5HHLS = parcelRequire("5HHLS");
function $2cca3b2cec3a358e$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $5HHLS.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $2cca3b2cec3a358e$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $2cca3b2cec3a358e$var$popperOffsets,
    data: {}
};

});
parcelRegister("5HHLS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4272ebf28a8b18f9$export$2e2bcd8739ae039);

var $aXPSi = parcelRequire("aXPSi");

var $iR1vh = parcelRequire("iR1vh");

var $fOHu6 = parcelRequire("fOHu6");

var $8CWSq = parcelRequire("8CWSq");
function $4272ebf28a8b18f9$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $aXPSi.default)(placement) : null;
    var variation = placement ? (0, $iR1vh.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $8CWSq.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $8CWSq.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $8CWSq.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $8CWSq.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $fOHu6.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $8CWSq.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $8CWSq.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("aXPSi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fb7a75361164827$export$2e2bcd8739ae039);

function $7fb7a75361164827$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("iR1vh", function(module, exports) {

$parcel$export(module.exports, "default", () => $db9e57cb08416451$export$2e2bcd8739ae039);
function $db9e57cb08416451$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("fOHu6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b83d41a8913a6625$export$2e2bcd8739ae039);
function $b83d41a8913a6625$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("bbqbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8245095d444bc6ab$export$2e2bcd8739ae039);

var $8CWSq = parcelRequire("8CWSq");

var $dNrcD = parcelRequire("dNrcD");

var $3xJ5v = parcelRequire("3xJ5v");

var $80xbK = parcelRequire("80xbK");

var $aPsIR = parcelRequire("aPsIR");

var $aXPSi = parcelRequire("aXPSi");

var $iR1vh = parcelRequire("iR1vh");

var $lCnHF = parcelRequire("lCnHF");
var $8245095d444bc6ab$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $8245095d444bc6ab$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $lCnHF.round)(x * dpr) / dpr || 0,
        y: (0, $lCnHF.round)(y * dpr) / dpr || 0
    };
}
function $8245095d444bc6ab$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $8CWSq.left);
    var sideY = (0, $8CWSq.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $dNrcD.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $3xJ5v.default)(popper)) {
            offsetParent = (0, $80xbK.default)(popper);
            if ((0, $aPsIR.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $8CWSq.top) || (placement === (0, $8CWSq.left) || placement === (0, $8CWSq.right)) && variation === (0, $8CWSq.end)) {
            sideY = (0, $8CWSq.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $8CWSq.left) || (placement === (0, $8CWSq.top) || placement === (0, $8CWSq.bottom)) && variation === (0, $8CWSq.end)) {
            sideX = (0, $8CWSq.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $8245095d444bc6ab$var$unsetSides);
    var _ref4 = roundOffsets === true ? $8245095d444bc6ab$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $3xJ5v.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $8245095d444bc6ab$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $aXPSi.default)(state.placement),
        variation: (0, $iR1vh.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $8245095d444bc6ab$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $8245095d444bc6ab$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8245095d444bc6ab$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $8245095d444bc6ab$var$computeStyles,
    data: {}
};

});

parcelRegister("lro9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9bed9cb68105387$export$2e2bcd8739ae039);

var $k9tfz = parcelRequire("k9tfz");

var $edBYZ = parcelRequire("edBYZ");
// and applies them to the HTMLElements such as popper and arrow
function $f9bed9cb68105387$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $edBYZ.isHTMLElement)(element) || !(0, $k9tfz.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $f9bed9cb68105387$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $edBYZ.isHTMLElement)(element) || !(0, $k9tfz.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $f9bed9cb68105387$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $f9bed9cb68105387$var$applyStyles,
    effect: $f9bed9cb68105387$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("6qkVe", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ad56675e809f390$export$2e2bcd8739ae039);

var $aXPSi = parcelRequire("aXPSi");

var $8CWSq = parcelRequire("8CWSq");
function $4ad56675e809f390$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $aXPSi.default)(placement);
    var invertDistance = [
        (0, $8CWSq.left),
        (0, $8CWSq.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $8CWSq.left),
        (0, $8CWSq.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $4ad56675e809f390$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $8CWSq.placements).reduce(function(acc, placement) {
        acc[placement] = $4ad56675e809f390$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4ad56675e809f390$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $4ad56675e809f390$var$offset
};

});

parcelRegister("8rAdb", function(module, exports) {

$parcel$export(module.exports, "default", () => $625cef3e22a64921$export$2e2bcd8739ae039);

var $60Kh8 = parcelRequire("60Kh8");

var $aXPSi = parcelRequire("aXPSi");

var $ib8Lm = parcelRequire("ib8Lm");

var $ecS3L = parcelRequire("ecS3L");

var $gUvF5 = parcelRequire("gUvF5");

var $8CWSq = parcelRequire("8CWSq");

var $iR1vh = parcelRequire("iR1vh");
function $625cef3e22a64921$var$getExpandedFallbackPlacements(placement) {
    if ((0, $aXPSi.default)(placement) === (0, $8CWSq.auto)) return [];
    var oppositePlacement = (0, $60Kh8.default)(placement);
    return [
        (0, $ib8Lm.default)(placement),
        oppositePlacement,
        (0, $ib8Lm.default)(oppositePlacement)
    ];
}
function $625cef3e22a64921$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $aXPSi.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $60Kh8.default)(preferredPlacement)
    ] : $625cef3e22a64921$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $aXPSi.default)(placement) === (0, $8CWSq.auto) ? (0, $gUvF5.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $aXPSi.default)(placement);
        var isStartVariation = (0, $iR1vh.default)(placement) === (0, $8CWSq.start);
        var isVertical = [
            (0, $8CWSq.top),
            (0, $8CWSq.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $ecS3L.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $8CWSq.right) : (0, $8CWSq.left) : isStartVariation ? (0, $8CWSq.bottom) : (0, $8CWSq.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $60Kh8.default)(mainVariationSide);
        var altVariationSide = (0, $60Kh8.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $625cef3e22a64921$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $625cef3e22a64921$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("60Kh8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4606a37f7c1f292f$export$2e2bcd8739ae039);
var $4606a37f7c1f292f$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $4606a37f7c1f292f$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $4606a37f7c1f292f$var$hash[matched];
    });
}

});

parcelRegister("ib8Lm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3c00d3590b14ae0$export$2e2bcd8739ae039);
var $d3c00d3590b14ae0$var$hash = {
    start: 'end',
    end: 'start'
};
function $d3c00d3590b14ae0$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $d3c00d3590b14ae0$var$hash[matched];
    });
}

});

parcelRegister("ecS3L", function(module, exports) {

$parcel$export(module.exports, "default", () => $a57c1ec8d520bc76$export$2e2bcd8739ae039);

var $gY30K = parcelRequire("gY30K");

var $80xbK = parcelRequire("80xbK");

var $1a1A9 = parcelRequire("1a1A9");

var $5HHLS = parcelRequire("5HHLS");

var $hRFeC = parcelRequire("hRFeC");

var $8CWSq = parcelRequire("8CWSq");

var $edBYZ = parcelRequire("edBYZ");

var $5HivB = parcelRequire("5HivB");

var $gafWf = parcelRequire("gafWf");
function $a57c1ec8d520bc76$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $8CWSq.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $8CWSq.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $8CWSq.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $5HivB.default)(typeof padding !== 'number' ? padding : (0, $gafWf.default)(padding, (0, $8CWSq.basePlacements)));
    var altContext = elementContext === (0, $8CWSq.popper) ? (0, $8CWSq.reference) : (0, $8CWSq.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $gY30K.default)((0, $edBYZ.isElement)(element) ? element : element.contextElement || (0, $80xbK.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1a1A9.default)(state.elements.reference);
    var popperOffsets = (0, $5HHLS.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $hRFeC.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $8CWSq.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $8CWSq.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $8CWSq.right),
                (0, $8CWSq.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $8CWSq.top),
                (0, $8CWSq.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("gY30K", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a495e161fa24d3$export$2e2bcd8739ae039);

var $8CWSq = parcelRequire("8CWSq");

var $3GhRd = parcelRequire("3GhRd");

var $Z1xa3 = parcelRequire("Z1xa3");

var $ePkdB = parcelRequire("ePkdB");

var $dNrcD = parcelRequire("dNrcD");

var $80xbK = parcelRequire("80xbK");

var $aPsIR = parcelRequire("aPsIR");

var $edBYZ = parcelRequire("edBYZ");

var $1a1A9 = parcelRequire("1a1A9");

var $hoKF3 = parcelRequire("hoKF3");

var $4W0o9 = parcelRequire("4W0o9");

var $k9tfz = parcelRequire("k9tfz");

var $hRFeC = parcelRequire("hRFeC");

var $lCnHF = parcelRequire("lCnHF");
function $c5a495e161fa24d3$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1a1A9.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $c5a495e161fa24d3$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $8CWSq.viewport) ? (0, $hRFeC.default)((0, $3GhRd.default)(element, strategy)) : (0, $edBYZ.isElement)(clippingParent) ? $c5a495e161fa24d3$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $hRFeC.default)((0, $Z1xa3.default)((0, $80xbK.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $c5a495e161fa24d3$var$getClippingParents(element) {
    var clippingParents = (0, $ePkdB.default)((0, $hoKF3.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $aPsIR.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $edBYZ.isHTMLElement)(element) ? (0, $dNrcD.default)(element) : element;
    if (!(0, $edBYZ.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $edBYZ.isElement)(clippingParent) && (0, $4W0o9.default)(clippingParent, clipperElement) && (0, $k9tfz.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $c5a495e161fa24d3$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $c5a495e161fa24d3$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $c5a495e161fa24d3$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $lCnHF.max)(rect.top, accRect.top);
        accRect.right = (0, $lCnHF.min)(rect.right, accRect.right);
        accRect.bottom = (0, $lCnHF.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $lCnHF.max)(rect.left, accRect.left);
        return accRect;
    }, $c5a495e161fa24d3$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("3GhRd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ae3256cd0a63b6c$export$2e2bcd8739ae039);

var $3xJ5v = parcelRequire("3xJ5v");

var $80xbK = parcelRequire("80xbK");

var $5l3cx = parcelRequire("5l3cx");

var $920uN = parcelRequire("920uN");
function $2ae3256cd0a63b6c$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $3xJ5v.default)(element);
    var html = (0, $80xbK.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $920uN.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $5l3cx.default)(element),
        y: y
    };
}

});

parcelRegister("Z1xa3", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b76e33639bec5b0$export$2e2bcd8739ae039);

var $80xbK = parcelRequire("80xbK");

var $aPsIR = parcelRequire("aPsIR");

var $5l3cx = parcelRequire("5l3cx");

var $ac1Wl = parcelRequire("ac1Wl");

var $lCnHF = parcelRequire("lCnHF");
function $0b76e33639bec5b0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $80xbK.default)(element);
    var winScroll = (0, $ac1Wl.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $lCnHF.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $lCnHF.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $5l3cx.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $aPsIR.default)(body || html).direction === 'rtl') x += (0, $lCnHF.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("4W0o9", function(module, exports) {

$parcel$export(module.exports, "default", () => $397ce160bfc587fd$export$2e2bcd8739ae039);

var $edBYZ = parcelRequire("edBYZ");
function $397ce160bfc587fd$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $edBYZ.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("hRFeC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0175f4a07c21ab5$export$2e2bcd8739ae039);
function $d0175f4a07c21ab5$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("5HivB", function(module, exports) {

$parcel$export(module.exports, "default", () => $425f53560a1fdf3c$export$2e2bcd8739ae039);

var $1ZKmd = parcelRequire("1ZKmd");
function $425f53560a1fdf3c$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $1ZKmd.default)(), paddingObject);
}

});
parcelRegister("1ZKmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $173f728cc6ee2a3b$export$2e2bcd8739ae039);
function $173f728cc6ee2a3b$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("gafWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc49f189f7bd576d$export$2e2bcd8739ae039);
function $bc49f189f7bd576d$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("gUvF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4fa6fa3ea07a9a4$export$2e2bcd8739ae039);

var $iR1vh = parcelRequire("iR1vh");

var $8CWSq = parcelRequire("8CWSq");

var $ecS3L = parcelRequire("ecS3L");

var $aXPSi = parcelRequire("aXPSi");
function $c4fa6fa3ea07a9a4$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $8CWSq.placements) : _options$allowedAutoP;
    var variation = (0, $iR1vh.default)(placement);
    var placements = variation ? flipVariations ? (0, $8CWSq.variationPlacements) : (0, $8CWSq.variationPlacements).filter(function(placement) {
        return (0, $iR1vh.default)(placement) === variation;
    }) : (0, $8CWSq.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $ecS3L.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $aXPSi.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("gFjel", function(module, exports) {

$parcel$export(module.exports, "default", () => $c21f64720698273b$export$2e2bcd8739ae039);

var $8CWSq = parcelRequire("8CWSq");

var $aXPSi = parcelRequire("aXPSi");

var $fOHu6 = parcelRequire("fOHu6");

var $hAEuy = parcelRequire("hAEuy");

var $bnZ7G = parcelRequire("bnZ7G");

var $QrBqo = parcelRequire("QrBqo");

var $dNrcD = parcelRequire("dNrcD");

var $ecS3L = parcelRequire("ecS3L");

var $iR1vh = parcelRequire("iR1vh");

var $1ZKmd = parcelRequire("1ZKmd");

var $lCnHF = parcelRequire("lCnHF");
function $c21f64720698273b$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $ecS3L.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $aXPSi.default)(state.placement);
    var variation = (0, $iR1vh.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $fOHu6.default)(basePlacement);
    var altAxis = (0, $hAEuy.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $8CWSq.top) : (0, $8CWSq.left);
        var altSide = mainAxis === 'y' ? (0, $8CWSq.bottom) : (0, $8CWSq.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $8CWSq.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $8CWSq.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $QrBqo.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $1ZKmd.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $bnZ7G.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $dNrcD.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $bnZ7G.within)(tether ? (0, $lCnHF.min)(min, tetherMin) : min, offset, tether ? (0, $lCnHF.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $8CWSq.top) : (0, $8CWSq.left);
        var _altSide = mainAxis === 'x' ? (0, $8CWSq.bottom) : (0, $8CWSq.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $8CWSq.top),
            (0, $8CWSq.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $bnZ7G.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $bnZ7G.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $c21f64720698273b$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $c21f64720698273b$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("hAEuy", function(module, exports) {

$parcel$export(module.exports, "default", () => $cce5354b6e28e32b$export$2e2bcd8739ae039);
function $cce5354b6e28e32b$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("bnZ7G", function(module, exports) {

$parcel$export(module.exports, "within", () => $84a14174e88d0bc0$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $84a14174e88d0bc0$export$86c8af6d3ef0b4a);

var $lCnHF = parcelRequire("lCnHF");
function $84a14174e88d0bc0$export$f28d906d67a997f3(min, value, max) {
    return (0, $lCnHF.max)(min, (0, $lCnHF.min)(value, max));
}
function $84a14174e88d0bc0$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $84a14174e88d0bc0$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("hiKPe", function(module, exports) {

$parcel$export(module.exports, "default", () => $c988709f87b64d9b$export$2e2bcd8739ae039);

var $aXPSi = parcelRequire("aXPSi");

var $QrBqo = parcelRequire("QrBqo");

var $4W0o9 = parcelRequire("4W0o9");

var $dNrcD = parcelRequire("dNrcD");

var $fOHu6 = parcelRequire("fOHu6");

var $bnZ7G = parcelRequire("bnZ7G");

var $5HivB = parcelRequire("5HivB");

var $gafWf = parcelRequire("gafWf");

var $8CWSq = parcelRequire("8CWSq");
var $c988709f87b64d9b$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $5HivB.default)(typeof padding !== 'number' ? padding : (0, $gafWf.default)(padding, (0, $8CWSq.basePlacements)));
};
function $c988709f87b64d9b$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $aXPSi.default)(state.placement);
    var axis = (0, $fOHu6.default)(basePlacement);
    var isVertical = [
        (0, $8CWSq.left),
        (0, $8CWSq.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $c988709f87b64d9b$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $QrBqo.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $8CWSq.top) : (0, $8CWSq.left);
    var maxProp = axis === 'y' ? (0, $8CWSq.bottom) : (0, $8CWSq.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $dNrcD.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $bnZ7G.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $c988709f87b64d9b$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $4W0o9.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $c988709f87b64d9b$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $c988709f87b64d9b$var$arrow,
    effect: $c988709f87b64d9b$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("izul8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d85307bf73b62e8b$export$2e2bcd8739ae039);

var $8CWSq = parcelRequire("8CWSq");

var $ecS3L = parcelRequire("ecS3L");
function $d85307bf73b62e8b$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $d85307bf73b62e8b$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $8CWSq.top),
        (0, $8CWSq.right),
        (0, $8CWSq.bottom),
        (0, $8CWSq.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $d85307bf73b62e8b$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $ecS3L.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $ecS3L.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $d85307bf73b62e8b$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $d85307bf73b62e8b$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $d85307bf73b62e8b$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $d85307bf73b62e8b$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $d85307bf73b62e8b$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $d85307bf73b62e8b$var$hide
};

});




parcelRegister("dmg8t", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $9b99d8a8ad795e92$export$e0be378c32fb70a7);

var $eUqFw = parcelRequire("eUqFw");

var $k6muC = parcelRequire("k6muC");

var $kQSBm = parcelRequire("kQSBm");

var $2Leve = parcelRequire("2Leve");
function $9b99d8a8ad795e92$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eUqFw.useContext((0, $kQSBm.ManagerReferenceNodeSetterContext));
    var refHandler = $eUqFw.useCallback(function(node) {
        (0, $2Leve.setRef)(innerRef, node);
        (0, $2Leve.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eUqFw.useEffect(function() {
        return function() {
            return (0, $2Leve.setRef)(innerRef, null);
        };
    }, []);
    $eUqFw.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $2Leve.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("asNSH", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $c9294410708307cc$export$3e67810a3f0e9f1c);
function $c9294410708307cc$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $c9294410708307cc$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $c9294410708307cc$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $c9294410708307cc$export$967a6b9924a689f7(a, b);
    return $c9294410708307cc$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("8r9C9", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $890d25d6ddbbb5af$export$214b055320e0bf32);
$parcel$export(module.exports, "mergeStyles", () => $890d25d6ddbbb5af$export$e618dc39ac9ad607);

var $kfs3D = parcelRequire("kfs3D");

var $5eRrO = parcelRequire("5eRrO");

var $ngqpF = parcelRequire("ngqpF");

var $8YZfj = parcelRequire("8YZfj");

var $fG8ma = parcelRequire("fG8ma");

var $6t2wI = parcelRequire("6t2wI");

var $i0VNY = parcelRequire("i0VNY");

var $35wVQ = parcelRequire("35wVQ");

var $akzU3 = parcelRequire("akzU3");

var $7VMaH = parcelRequire("7VMaH");
const $890d25d6ddbbb5af$export$214b055320e0bf32 = {
    clearIndicator: (0, $8YZfj.clearIndicatorCSS),
    container: (0, $kfs3D.containerCSS),
    control: (0, $5eRrO.css),
    dropdownIndicator: (0, $8YZfj.dropdownIndicatorCSS),
    group: (0, $ngqpF.groupCSS),
    groupHeading: (0, $ngqpF.groupHeadingCSS),
    indicatorsContainer: (0, $kfs3D.indicatorsContainerCSS),
    indicatorSeparator: (0, $8YZfj.indicatorSeparatorCSS),
    input: (0, $fG8ma.inputCSS),
    loadingIndicator: (0, $8YZfj.loadingIndicatorCSS),
    loadingMessage: (0, $6t2wI.loadingMessageCSS),
    menu: (0, $6t2wI.menuCSS),
    menuList: (0, $6t2wI.menuListCSS),
    menuPortal: (0, $6t2wI.menuPortalCSS),
    multiValue: (0, $i0VNY.multiValueCSS),
    multiValueLabel: (0, $i0VNY.multiValueLabelCSS),
    multiValueRemove: (0, $i0VNY.multiValueRemoveCSS),
    noOptionsMessage: (0, $6t2wI.noOptionsMessageCSS),
    option: (0, $35wVQ.optionCSS),
    placeholder: (0, $akzU3.placeholderCSS),
    singleValue: (0, $7VMaH.css),
    valueContainer: (0, $kfs3D.valueContainerCSS)
};
function $890d25d6ddbbb5af$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});

parcelRegister("aJuqz", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $a5765027d23d0a83$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $a5765027d23d0a83$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $j8gJ1 = parcelRequire("j8gJ1");
var $8LRlt = parcelRequire("8LRlt");
var $f3klQ = parcelRequire("f3klQ");

var $8R79R = parcelRequire("8R79R");

var $1oOGD = parcelRequire("1oOGD");
const $a5765027d23d0a83$var$packageName = "platform-pkg";
const $a5765027d23d0a83$var$packageVersion = "0.0.0-use.local";
const $a5765027d23d0a83$export$d1de3b251ccaa8a3 = (0, $1oOGD.default)((0, $8R79R.default));
const $a5765027d23d0a83$var$createAndFireEventOnAtlaskit = (0, $j8gJ1.default)('atlaskit');
const $a5765027d23d0a83$var$Select = (0, $8LRlt.default)({
    componentName: 'select',
    packageName: $a5765027d23d0a83$var$packageName,
    packageVersion: $a5765027d23d0a83$var$packageVersion
})((0, $f3klQ.default)({
    onChange: $a5765027d23d0a83$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $a5765027d23d0a83$var$packageName,
            packageVersion: $a5765027d23d0a83$var$packageVersion
        }
    })
})($a5765027d23d0a83$export$d1de3b251ccaa8a3));
var $a5765027d23d0a83$export$2e2bcd8739ae039 = $a5765027d23d0a83$var$Select;

});
parcelRegister("8R79R", function(module, exports) {

$parcel$export(module.exports, "default", () => $c68207d5ffd699d7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $apnnW = parcelRequire("apnnW");

var $aXltS = parcelRequire("aXltS");
const $c68207d5ffd699d7$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const baseSelectProps = (0, $aXltS.default)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apnnW.default), {
        ref: ref,
        ...baseSelectProps
    });
});
var $c68207d5ffd699d7$export$2e2bcd8739ae039 = $c68207d5ffd699d7$var$StateManagedSelect;

});
parcelRegister("apnnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $812572970dc92908$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k1Zr4 = parcelRequire("k1Zr4");

var $a9GGG = parcelRequire("a9GGG");

var $6EqnL = parcelRequire("6EqnL");

var $l1pLY = parcelRequire("l1pLY");
var $gxsrN = parcelRequire("gxsrN");
var $4GHZi = parcelRequire("4GHZi");

var $1XbPn = parcelRequire("1XbPn");

var $6t2wI = parcelRequire("6t2wI");

var $f6Vzn = parcelRequire("f6Vzn");

var $8r9C9 = parcelRequire("8r9C9");

var $8ogLA = parcelRequire("8ogLA");

var $DomJ2 = parcelRequire("DomJ2");
const $812572970dc92908$export$9c21a3269931e1e6 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $DomJ2.isTouchCapable)(),
    captureMenuScroll: !(0, $DomJ2.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $f6Vzn.createFilter)(),
    formatGroupLabel: (0, $a9GGG.formatGroupLabel),
    getOptionLabel: (0, $a9GGG.getOptionLabel),
    getOptionValue: (0, $a9GGG.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $a9GGG.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $DomJ2.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $812572970dc92908$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $812572970dc92908$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $812572970dc92908$var$isOptionSelected(props, option, selectValue);
    const label = $812572970dc92908$var$getOptionLabel(props, option);
    const value = $812572970dc92908$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $812572970dc92908$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$812572970dc92908$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$812572970dc92908$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $812572970dc92908$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $812572970dc92908$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $DomJ2.notNullish));
}
function $812572970dc92908$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $812572970dc92908$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $812572970dc92908$var$buildFocusableOptions(props, selectValue) {
    return $812572970dc92908$var$buildFocusableOptionsFromCategorizedOptions($812572970dc92908$var$buildCategorizedOptions(props, selectValue));
}
function $812572970dc92908$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$812572970dc92908$var$shouldHideSelectedOptions(props) || !isSelected) && $812572970dc92908$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $812572970dc92908$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $812572970dc92908$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $812572970dc92908$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $812572970dc92908$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $812572970dc92908$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $812572970dc92908$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $812572970dc92908$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $812572970dc92908$var$getOptionValue(props, option);
    return selectValue.some((i)=>$812572970dc92908$var$getOptionValue(props, i) === candidate);
}
function $812572970dc92908$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $812572970dc92908$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $812572970dc92908$var$instanceId = 1;
class $812572970dc92908$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = $812572970dc92908$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props);
        this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false;
        this.isComposing = false;
        this.initialTouchX = 0;
        this.initialTouchY = 0;
        this.openAfterFocus = false;
        this.scrollToFocusedOptionOnUpdate = false;
        this.isAppleDevice = (0, $k1Zr4.isAppleDevice)();
        // Refs
        // ------------------------------
        this.controlRef = null;
        this.getControlRef = (ref)=>{
            this.controlRef = ref;
        };
        this.focusedOptionRef = null;
        this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        };
        this.menuListRef = null;
        this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        };
        this.inputRef = null;
        this.getInputRef = (ref)=>{
            this.inputRef = ref;
        };
        // aliased for consumers
        this.focus = this.focusInput;
        this.blur = this.blurInput;
        this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $DomJ2.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $DomJ2.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $DomJ2.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $DomJ2.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        };
        this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $DomJ2.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        };
        this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $DomJ2.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $DomJ2.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        this.getFocusedOptionId = (focusedOption)=>{
            return $812572970dc92908$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        };
        this.getFocusableOptionsWithIds = ()=>{
            return $812572970dc92908$var$buildFocusableOptionsWithIds($812572970dc92908$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        };
        this.getValue = ()=>this.state.selectValue;
        this.cx = (...args)=>(0, $DomJ2.classNames)(this.props.classNamePrefix, ...args);
        this.getOptionLabel = (data)=>{
            return $812572970dc92908$var$getOptionLabel(this.props, data);
        };
        this.getOptionValue = (data)=>{
            return $812572970dc92908$var$getOptionValue(this.props, data);
        };
        this.getStyles = (key, props)=>{
            const { unstyled: unstyled } = this.props;
            const base = (0, $8r9C9.defaultStyles)[key](props, unstyled);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        this.getClassNames = (key, props)=>this.props.classNames[key]?.(props);
        this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        };
        this.getComponents = ()=>{
            return (0, $6EqnL.defaultComponents)(this.props);
        };
        this.buildCategorizedOptions = ()=>$812572970dc92908$var$buildCategorizedOptions(this.props, this.state.selectValue);
        this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [];
        this.buildFocusableOptions = ()=>$812572970dc92908$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions());
        this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [];
        // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        };
        // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        };
        this.onMenuMouseMove = (event)=>{
            this.blockOptionHover = false;
        };
        this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        };
        this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        };
        this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $DomJ2.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        };
        this.onCompositionStart = ()=>{
            this.isComposing = true;
        };
        this.onCompositionEnd = ()=>{
            this.isComposing = false;
        };
        this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        };
        this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        };
        this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        };
        this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        };
        this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        };
        // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        };
        this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        };
        this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        };
        this.shouldHideSelectedOptions = ()=>{
            return $812572970dc92908$var$shouldHideSelectedOptions(this.props);
        };
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        };
        // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$812572970dc92908$var$instanceId);
        //@ts-ignore
        this.state.selectValue = (0, $DomJ2.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen && this.state.selectValue.length) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $812572970dc92908$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        //@ts-ignore
        const selectValue = (0, $DomJ2.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $812572970dc92908$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $812572970dc92908$var$buildFocusableOptionsWithIds($812572970dc92908$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $812572970dc92908$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $812572970dc92908$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $812572970dc92908$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $DomJ2.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $DomJ2.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $DomJ2.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusableOptions[openAtIndex],
            focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
        }, ()=>this.onMenuOpen());
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus]
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    // ==============================
    // Getters
    // ==============================
    getTheme() {
        // Use the default theme if there are no customisations.
        if (!this.props.theme) return 0, $8ogLA.defaultTheme;
        // If the theme prop is a function, assume the function
        // knows how to merge the passed-in default theme with
        // its own modifications.
        if (typeof this.props.theme === 'function') return this.props.theme((0, $8ogLA.defaultTheme));
        // Otherwise, if a plain theme object was passed in,
        // overlay it with the default theme.
        return {
            ...(0, $8ogLA.defaultTheme),
            ...this.props.theme
        };
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue,
            theme: this.getTheme()
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $812572970dc92908$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $812572970dc92908$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $812572970dc92908$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        const description = this.props['aria-describedby'] || descriptionId;
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            'aria-autocomplete': 'list',
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            'aria-haspopup': 'listbox',
            'aria-describedby': description,
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                'aria-describedby': description ? [
                    description,
                    this.getElementId('live-region')
                ].join(' ') : this.getElementId('live-region')
            } : {
                'aria-describedby': description ? [
                    description,
                    this.getElementId('placeholder')
                ].join(' ') : this.getElementId('placeholder')
            }
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return(//@ts-ignore
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l1pLY.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $DomJ2.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            ...ariaAttributes
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder')
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    }
                },
                data: opt
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled
        }, this.formatOptionLabel(singleValue, 'value'));
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ClearIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadingIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderIndicatorSeparator() {
        const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
        // separator doesn't make sense without the dropdown indicator
        if (!DropdownIndicator || !IndicatorSeparator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled } = this.props;
        const { isFocused: isFocused } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IndicatorSeparator, {
            ...commonProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled } = this.props;
        const { isFocused: isFocused } = this.state;
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: 'option',
                'aria-selected': this.isAppleDevice ? undefined : isSelected
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) menuUI = this.getCategorizedOptions().map((item)=>{
            if (item.type === 'group') {
                const { data: data, options: options, index: groupIndex } = item;
                const groupId = `${this.getElementId('group')}-${groupIndex}`;
                const headingId = `${groupId}-heading`;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Group, {
                    ...commonProps,
                    key: groupId,
                    data: data,
                    options: options,
                    Heading: GroupHeading,
                    headingProps: {
                        id: headingId,
                        data: item.data
                    },
                    label: this.formatGroupLabel(item.data)
                }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`)));
            } else if (item.type === 'option') return render(item, `${item.index}`);
        });
        else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadingMessage, commonProps, message);
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NoOptionsMessage, commonProps, message);
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6t2wI.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps
        }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Menu, {
                ...commonProps,
                ...menuPlacementProps,
                innerRef: ref,
                innerProps: {
                    onMouseDown: this.onMenuMouseDown,
                    onMouseMove: this.onMenuMouseMove,
                    id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                },
                isLoading: isLoading,
                placement: placement
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4GHZi.default), {
                captureEnabled: captureMenuScroll,
                onTopArrive: onMenuScrollToTop,
                onBottomArrive: onMenuScrollToBottom,
                lockEnabled: menuShouldBlockScroll
            }, (scrollTargetRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuList, {
                    ...commonProps,
                    innerRef: (instance)=>{
                        this.getMenuListRef(instance);
                        scrollTargetRef(instance);
                    },
                    innerProps: {
                        role: 'listbox',
                        'aria-multiselectable': commonProps.isMulti,
                        id: this.getElementId('listbox')
                    },
                    isLoading: isLoading,
                    maxHeight: maxHeight,
                    focusedOption: focusedOption
                }, menuUI))));
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition
        }, menuElement) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gxsrN.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
                        key: `i-${i}`,
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, input);
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1XbPn.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            focusedOption: focusedOption,
            focusedValue: focusedValue,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions,
            isAppleDevice: this.isAppleDevice
        });
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown
            },
            isDisabled: isDisabled,
            isFocused: isFocused
        }, this.renderLiveRegion(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Control, {
            ...commonProps,
            innerRef: this.getControlRef,
            innerProps: {
                onMouseDown: this.onControlMouseDown,
                onTouchEnd: this.onControlTouchEnd
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            menuIsOpen: menuIsOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ValueContainer, {
            ...commonProps,
            isDisabled: isDisabled
        }, this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IndicatorsContainer, {
            ...commonProps,
            isDisabled: isDisabled
        }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
}

});
parcelRegister("k1Zr4", function(module, exports) {

$parcel$export(module.exports, "isAppleDevice", () => $377df83acaf7b466$export$e1865c3bedcd822b);
function $377df83acaf7b466$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $377df83acaf7b466$export$186c6964ca17d99() {
    return $377df83acaf7b466$var$testPlatform(/^iPhone/i);
}
function $377df83acaf7b466$export$9ac100e40613ea10() {
    return $377df83acaf7b466$var$testPlatform(/^Mac/i);
}
function $377df83acaf7b466$export$7bef049ce92e4224() {
    return $377df83acaf7b466$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    // eslint-disable-next-line compat/compat
    $377df83acaf7b466$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $377df83acaf7b466$export$fedb369cb70207f1() {
    return $377df83acaf7b466$export$186c6964ca17d99() || $377df83acaf7b466$export$7bef049ce92e4224();
}
function $377df83acaf7b466$export$e1865c3bedcd822b() {
    return $377df83acaf7b466$export$9ac100e40613ea10() || $377df83acaf7b466$export$fedb369cb70207f1();
}

});

parcelRegister("a9GGG", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", () => $c82f797eede48f28$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $c82f797eede48f28$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $c82f797eede48f28$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $c82f797eede48f28$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $c82f797eede48f28$export$f4da216a6ca54656 = (group)=>group.label;
const $c82f797eede48f28$export$dac6ace3020563ca = (option)=>option.label;
const $c82f797eede48f28$export$40be908210c5a79c = (option)=>option.value;
const $c82f797eede48f28$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("l1pLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $edcfea7cbf7f9aab$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $edcfea7cbf7f9aab$var$dummyInputStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: 1,
    padding: 0,
    position: 'relative',
    background: 0,
    border: 0,
    caretColor: 'transparent',
    color: 'transparent',
    fontSize: 'inherit',
    gridArea: '1 / 1 / 2 / 3',
    insetInlineStart: -100,
    label: 'dummyInput',
    opacity: 0,
    outline: 0,
    transform: 'scale(.01)'
});
function $edcfea7cbf7f9aab$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $DomJ2.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ref: innerRef,
        ...filteredProps,
        css: $edcfea7cbf7f9aab$var$dummyInputStyles
    });
}

});

parcelRegister("gxsrN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcd01f5e5b5e85fd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $iyKES = parcelRequire("iyKES");
function $fcd01f5e5b5e85fd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fcd01f5e5b5e85fd$var$styles = {
    name: "1fj9brw-requiredInput",
    styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
};
const $fcd01f5e5b5e85fd$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $fcd01f5e5b5e85fd$var$styles,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $iyKES.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fcd01f5e5b5e85fd$export$2e2bcd8739ae039 = $fcd01f5e5b5e85fd$var$RequiredInput;

});

parcelRegister("4GHZi", function(module, exports) {

$parcel$export(module.exports, "default", () => $edb2811a94dc1026$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $iAaF5 = parcelRequire("iAaF5");

var $eGczi = parcelRequire("eGczi");
function $edb2811a94dc1026$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $edb2811a94dc1026$var$styles = {
    name: "qzxev8",
    styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
};
const $edb2811a94dc1026$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $edb2811a94dc1026$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $iAaF5.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $eGczi.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        onClick: $edb2811a94dc1026$var$blurSelectInput,
        css: $edb2811a94dc1026$var$styles
    }), children(targetRef));
}

});
parcelRegister("iAaF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bb9b4882346d814$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $DomJ2 = parcelRequire("DomJ2");
const $8bb9b4882346d814$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $8bb9b4882346d814$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $eUqFw.useRef)(false);
    const isTop = (0, $eUqFw.useRef)(false);
    const touchStart = (0, $eUqFw.useRef)(0);
    const scrollTarget = (0, $eUqFw.useRef)(null);
    const handleEventDelta = (0, $eUqFw.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $8bb9b4882346d814$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $eUqFw.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $eUqFw.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $eUqFw.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $eUqFw.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $DomJ2.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $eUqFw.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("eGczi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ece6486884e5b6d9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $ece6486884e5b6d9$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $ece6486884e5b6d9$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $ece6486884e5b6d9$var$preventTouchMove(e) {
    e.preventDefault();
}
function $ece6486884e5b6d9$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $ece6486884e5b6d9$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $ece6486884e5b6d9$var$isTouchDevice() {
    // eslint-disable-next-line compat/compat
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $ece6486884e5b6d9$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $ece6486884e5b6d9$var$activeScrollLocks = 0;
const $ece6486884e5b6d9$var$listenerOptions = {
    capture: false,
    passive: false
};
function $ece6486884e5b6d9$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $eUqFw.useRef)({});
    const scrollTarget = (0, $eUqFw.useRef)(null);
    const addScrollLock = (0, $eUqFw.useCallback)((touchScrollTarget)=>{
        if (!$ece6486884e5b6d9$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $ece6486884e5b6d9$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $ece6486884e5b6d9$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($ece6486884e5b6d9$var$LOCK_STYLES).forEach((key)=>{
                const val = $ece6486884e5b6d9$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $ece6486884e5b6d9$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $ece6486884e5b6d9$var$preventTouchMove, $ece6486884e5b6d9$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $ece6486884e5b6d9$var$preventInertiaScroll, $ece6486884e5b6d9$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $ece6486884e5b6d9$var$allowTouchMove, $ece6486884e5b6d9$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $ece6486884e5b6d9$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $eUqFw.useCallback)((touchScrollTarget)=>{
        if (!$ece6486884e5b6d9$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $ece6486884e5b6d9$var$activeScrollLocks = Math.max($ece6486884e5b6d9$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $ece6486884e5b6d9$var$activeScrollLocks < 1) $ece6486884e5b6d9$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $ece6486884e5b6d9$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $ece6486884e5b6d9$var$preventTouchMove, $ece6486884e5b6d9$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $ece6486884e5b6d9$var$preventInertiaScroll, $ece6486884e5b6d9$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $ece6486884e5b6d9$var$allowTouchMove, $ece6486884e5b6d9$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("1XbPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0af9987a261c33d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $625wI = parcelRequire("625wI");

var $kULp4 = parcelRequire("kULp4");
// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $c0af9987a261c33d$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
    const ariaLabel = selectProps['aria-label'] || label;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $eUqFw.useMemo)(()=>({
            ...(0, $625wI.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $eUqFw.useMemo)(()=>{
        let message = '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    const ariaFocused = (0, $eUqFw.useMemo)(()=>{
        let focusMsg = '';
        const focused = focusedOption || focusedValue;
        const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            const onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    const ariaResults = (0, $eUqFw.useMemo)(()=>{
        let resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ariaGuidance = (0, $eUqFw.useMemo)(()=>{
        let guidanceMsg = '';
        if (messages.guidance) {
            const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    const ScreenReaderText = /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: "aria-results"
    }, ariaResults), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kULp4.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, $byn9U.jsx)((0, $kULp4.default), {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c0af9987a261c33d$export$2e2bcd8739ae039 = $c0af9987a261c33d$var$LiveRegion;

});
parcelRegister("625wI", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", () => $2e07b4483663f031$export$a7265767c78f9bae);
const $2e07b4483663f031$export$a7265767c78f9bae = {
    guidance: (props)=>{
        const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
        switch(context){
            case 'menu':
                return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
            case 'input':
                return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: (props)=>{
        const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return `option ${label}, deselected.`;
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
            case 'select-option':
                return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
            default:
                return '';
        }
    },
    onFocus: (props)=>{
        const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isDisabled: isDisabled, isSelected: isSelected, isAppleDevice: isAppleDevice } = props;
        const getArrayIndex = (arr, item)=>arr && arr.length ? `${arr.indexOf(item) + 1} of ${arr.length}` : '';
        if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
        if (context === 'menu' && isAppleDevice) {
            const disabled = isDisabled ? ' disabled' : '';
            const status = `${isSelected ? ' selected' : ''}${disabled}`;
            return `${label}${status}, ${getArrayIndex(options, focused)}.`;
        }
        return '';
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
    }
};

});

parcelRegister("kULp4", function(module, exports) {

$parcel$export(module.exports, "default", () => $26f0af153c89be40$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $26f0af153c89be40$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
const $26f0af153c89be40$var$styles = {
    name: "1j8j4w4-a11yText",
    styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
};
const $26f0af153c89be40$var$A11yText = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $26f0af153c89be40$var$styles,
        ...props
    });
var $26f0af153c89be40$export$2e2bcd8739ae039 = $26f0af153c89be40$var$A11yText;

});


parcelRegister("f6Vzn", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $fdb4680dbf332fef$export$5d81789ff4aeccdf);

var $5iWql = parcelRequire("5iWql");

var $26i9q = parcelRequire("26i9q");
const $fdb4680dbf332fef$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)((0, $26i9q.stripDiacritics));
const $fdb4680dbf332fef$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $fdb4680dbf332fef$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $fdb4680dbf332fef$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $fdb4680dbf332fef$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $fdb4680dbf332fef$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $fdb4680dbf332fef$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $fdb4680dbf332fef$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $26i9q.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("26i9q", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", () => $3944c2da7f0324a1$export$b5bee4b27048330b);
const $3944c2da7f0324a1$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $3944c2da7f0324a1$var$anyDiacritic = new RegExp('[' + $3944c2da7f0324a1$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $3944c2da7f0324a1$var$diacriticToBase = {};
for(let i = 0; i < $3944c2da7f0324a1$var$diacritics.length; i++){
    let diacritic = $3944c2da7f0324a1$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$3944c2da7f0324a1$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $3944c2da7f0324a1$export$b5bee4b27048330b = (str)=>{
    return str.replace($3944c2da7f0324a1$var$anyDiacritic, (match)=>$3944c2da7f0324a1$var$diacriticToBase[match]);
};

});


parcelRegister("8ogLA", function(module, exports) {

$parcel$export(module.exports, "defaultTheme", () => $aa68feeaf48a7bc6$export$164de7ab8df77ef0);
const $aa68feeaf48a7bc6$export$8f45430ccf837300 = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
const $aa68feeaf48a7bc6$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
const $aa68feeaf48a7bc6$var$baseUnit = 4;
// The minimum height of the control
const $aa68feeaf48a7bc6$var$controlHeight = 38;
// The amount of space between the control and menu */
const $aa68feeaf48a7bc6$var$menuGutter = $aa68feeaf48a7bc6$var$baseUnit * 2;
const $aa68feeaf48a7bc6$export$5458b64234d1333c = {
    baseUnit: $aa68feeaf48a7bc6$var$baseUnit,
    controlHeight: $aa68feeaf48a7bc6$var$controlHeight,
    menuGutter: $aa68feeaf48a7bc6$var$menuGutter
};
const $aa68feeaf48a7bc6$export$164de7ab8df77ef0 = {
    borderRadius: $aa68feeaf48a7bc6$var$borderRadius,
    colors: $aa68feeaf48a7bc6$export$8f45430ccf837300,
    spacing: $aa68feeaf48a7bc6$export$5458b64234d1333c
};

});


parcelRegister("aXltS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4446f2908cc6068e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $4446f2908cc6068e$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $eUqFw.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $eUqFw.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $eUqFw.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $eUqFw.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("1oOGD", function(module, exports) {

$parcel$export(module.exports, "default", () => $38250713238549ef$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $8r9C9 = parcelRequire("8r9C9");

var $lL8xO = parcelRequire("lL8xO");
var $grOdA = parcelRequire("grOdA");

var $65zLD = parcelRequire("65zLD");

var $5Doo5 = parcelRequire("5Doo5");

var $a3o6L = parcelRequire("a3o6L");

var $NHgCB = parcelRequire("NHgCB");
function $38250713238549ef$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $lL8xO.ClearIndicator,
                DropdownIndicator: $lL8xO.DropdownIndicator,
                LoadingIndicator: $lL8xO.LoadingIndicator,
                MultiValueRemove: $grOdA.MultiValueRemove,
                IndicatorSeparator: $grOdA.IndicatorSeparator,
                Input: $65zLD.Input,
                NoOptionsMessage: $5Doo5.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $NHgCB.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $NHgCB.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $8r9C9.mergeStyles)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $a3o6L.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("lL8xO", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $b55fa3a6708e6433$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $b55fa3a6708e6433$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $b55fa3a6708e6433$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $5IJsn = parcelRequire("5IJsn");

var $3wscq = parcelRequire("3wscq");

var $45qbL = parcelRequire("45qbL");
var $1jsQJ = parcelRequire("1jsQJ");
var $8Vv3m = parcelRequire("8Vv3m");

var $6EqnL = parcelRequire("6EqnL");

var $bBdMg = parcelRequire("bBdMg");
const $b55fa3a6708e6433$var$iconContainerStyles = (0, $8Vv3m.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $b55fa3a6708e6433$var$dropdownWrapperStyles = (0, $8Vv3m.xcss)({
    padding: 'space.075'
});
const $b55fa3a6708e6433$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1jsQJ.default), {
        xcss: $b55fa3a6708e6433$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3wscq))), {
        label: "clear",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
const $b55fa3a6708e6433$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, $45qbL.default), {
        as: "span",
        xcss: $b55fa3a6708e6433$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5IJsn))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $b55fa3a6708e6433$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bBdMg.default), {
        size: "small"
    })));
};

});
parcelRegister("3wscq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e97232317682a60395e2ccf8df4ad7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $290a3c11f7e03bc6$var$_react = $290a3c11f7e03bc6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $290a3c11f7e03bc6$var$_crossCircle = $290a3c11f7e03bc6$var$_interopRequireDefault((parcelRequire("avwnz")));

var $290a3c11f7e03bc6$var$_selectClear = $290a3c11f7e03bc6$var$_interopRequireDefault((parcelRequire("93YTD")));
function $290a3c11f7e03bc6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $290a3c11f7e03bc6$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $290a3c11f7e03bc6$var$_react.default.createElement($290a3c11f7e03bc6$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $290a3c11f7e03bc6$var$_selectClear.default
    }, props));
$290a3c11f7e03bc6$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $290a3c11f7e03bc6$var$_default = module.exports.default = $290a3c11f7e03bc6$var$CrossCircleIcon;

});
parcelRegister("avwnz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc42d217064fbe3eaef70b43f6c007b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a65ea720a647725$var$_react = $7a65ea720a647725$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7a65ea720a647725$var$_UNSAFE_baseNew = $7a65ea720a647725$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $7a65ea720a647725$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7a65ea720a647725$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $7a65ea720a647725$var$_react.default.createElement($7a65ea720a647725$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$7a65ea720a647725$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $7a65ea720a647725$var$_default = module.exports.default = $7a65ea720a647725$var$CrossCircleIcon;

});

parcelRegister("93YTD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6993a19f4a8ea624$var$_react = $6993a19f4a8ea624$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $6993a19f4a8ea624$var$_crossCircle = $6993a19f4a8ea624$var$_interopRequireDefault((parcelRequire("7jum4")));
function $6993a19f4a8ea624$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6993a19f4a8ea624$var$SelectClearIcon = (props)=>/*#__PURE__*/ $6993a19f4a8ea624$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $6993a19f4a8ea624$var$_crossCircle.default
    }));
$6993a19f4a8ea624$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $6993a19f4a8ea624$var$_default = module.exports.default = $6993a19f4a8ea624$var$SelectClearIcon;

});
parcelRegister("7jum4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5531daa29081c39f$var$_react = $5531daa29081c39f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5531daa29081c39f$var$_UNSAFE_baseNew = $5531daa29081c39f$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $5531daa29081c39f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5531daa29081c39f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $5531daa29081c39f$var$_react.default.createElement($5531daa29081c39f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$5531daa29081c39f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $5531daa29081c39f$var$_default = module.exports.default = $5531daa29081c39f$var$CrossCircleIcon;

});




parcelRegister("grOdA", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $ac39515aa513e4da$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $ac39515aa513e4da$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $93YTD = parcelRequire("93YTD");

var $uSXUV = parcelRequire("uSXUV");

var $gYrJM = parcelRequire("gYrJM");

var $45qbL = parcelRequire("45qbL");
var $8Vv3m = parcelRequire("8Vv3m");

var $6EqnL = parcelRequire("6EqnL");

var $lL8xO = parcelRequire("lL8xO");
function $ac39515aa513e4da$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ac39515aa513e4da$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $ac39515aa513e4da$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $ac39515aa513e4da$var$iconWrapperStyles = (0, $8Vv3m.xcss)({
    padding: 'space.025'
});
const $ac39515aa513e4da$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $gYrJM.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($uSXUV))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $gYrJM.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $45qbL.default), {
            xcss: $ac39515aa513e4da$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($uSXUV))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($93YTD))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $ac39515aa513e4da$var$disabledStyles : $ac39515aa513e4da$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $ac39515aa513e4da$export$bd638c2ba7915668 = null;

});
parcelRegister("uSXUV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05cd7070e053e072$var$_react = $05cd7070e053e072$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $05cd7070e053e072$var$_UNSAFE_baseNew = $05cd7070e053e072$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $05cd7070e053e072$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05cd7070e053e072$var$CrossIcon = (props)=>/*#__PURE__*/ $05cd7070e053e072$var$_react.default.createElement($05cd7070e053e072$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$05cd7070e053e072$var$CrossIcon.displayName = 'CrossIcon';
var $05cd7070e053e072$var$_default = module.exports.default = $05cd7070e053e072$var$CrossIcon;

});


parcelRegister("65zLD", function(module, exports) {

$parcel$export(module.exports, "Input", () => $23b0d2dc6a551f19$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $6EqnL = parcelRequire("6EqnL");
function $23b0d2dc6a551f19$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute = props['aria-describedby'];
    const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
    if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6EqnL.components).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("5Doo5", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $5ed62d2b15567313$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $1JJay = parcelRequire("1JJay");

var $6EqnL = parcelRequire("6EqnL");
const $5ed62d2b15567313$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6EqnL.components).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
        color: "color.text.subtle"
    }, props.children || `No options`)));
};

});

parcelRegister("a3o6L", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe4a10b382601121$export$2e2bcd8739ae039);

var $gYrJM = parcelRequire("gYrJM");

function $fe4a10b382601121$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $1b343b038f6c23ec$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $1b343b038f6c23ec$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $1b343b038f6c23ec$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $1b343b038f6c23ec$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $1b343b038f6c23ec$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $1b343b038f6c23ec$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $1b343b038f6c23ec$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $1b343b038f6c23ec$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $1b343b038f6c23ec$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $1b343b038f6c23ec$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $1b343b038f6c23ec$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $1b343b038f6c23ec$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $1b343b038f6c23ec$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $1b343b038f6c23ec$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $1b343b038f6c23ec$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $1b343b038f6c23ec$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $1b343b038f6c23ec$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $1b343b038f6c23ec$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $1b343b038f6c23ec$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $1b343b038f6c23ec$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $1b343b038f6c23ec$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $1b343b038f6c23ec$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $1b343b038f6c23ec$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $1b343b038f6c23ec$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $1b343b038f6c23ec$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $1b343b038f6c23ec$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $1b343b038f6c23ec$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $1b343b038f6c23ec$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $1b343b038f6c23ec$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $1b343b038f6c23ec$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $1b343b038f6c23ec$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $1b343b038f6c23ec$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $1b343b038f6c23ec$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $gYrJM.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $1b343b038f6c23ec$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $gYrJM.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $gYrJM.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $1b343b038f6c23ec$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $1b343b038f6c23ec$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $1b343b038f6c23ec$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $gYrJM.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $1b343b038f6c23ec$export$f563ee71e9ee74cd})`,
                fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                textTransform: 'none'
            })
    };
}

});

parcelRegister("NHgCB", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $d9c0a053f0c64587$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $d9c0a053f0c64587$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $d9c0a053f0c64587$export$8ee33f304118fce4);
function $d9c0a053f0c64587$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $d9c0a053f0c64587$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $d9c0a053f0c64587$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("2FrYX", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $0361e695debecd6f$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $0361e695debecd6f$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $0361e695debecd6f$export$71abc632aa29e6fe);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ddMyj = parcelRequire("ddMyj");

var $6EqnL = parcelRequire("6EqnL");


var $6ZA7b = parcelRequire("6ZA7b");

var $hVx5a = parcelRequire("hVx5a");
function $0361e695debecd6f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0361e695debecd6f$var$menuDialogStyles = /*#__PURE__*/ (0, $byn9U.css)({
    zIndex: (0, $6ZA7b.layers).modal(),
    backgroundColor: "var(--ds-surface-overlay, white)",
    borderRadius: "var(--ds-border-radius-100, 4px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $1b343b038f6c23ec$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $1b343b038f6c23ec$export$46987b49aab6d1a8)}`})`
});
const $0361e695debecd6f$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: ref,
        css: [
            $0361e695debecd6f$var$menuDialogStyles,
            // There is not a limited amount of values for the widths, so they need
            // to remain dynamic.
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`
    }, children));
// ==============================
// Custom Components
// ==============================
const $0361e695debecd6f$var$dropdownStyles = {
    name: "7693z9",
    styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
};
const $0361e695debecd6f$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $0361e695debecd6f$var$dropdownStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ddMyj))), {
        color: "currentColor",
        spacing: "spacious",
        label: "open"
    }));
const $0361e695debecd6f$var$controlStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
});
const $0361e695debecd6f$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        css: $0361e695debecd6f$var$controlStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).Control, {
        ...props,
        innerProps: innerProps
    }));
const $0361e695debecd6f$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $hVx5a.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).Control, props));
// NOTE `props` intentionally omitted from `Fragment`
const $0361e695debecd6f$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", innerProps, children);
const $0361e695debecd6f$var$IndicatorSeparator = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).IndicatorSeparator, props);
const $0361e695debecd6f$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).ClearIndicator, props);
const $0361e695debecd6f$var$MultiValueRemove = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).MultiValueRemove, props);
const $0361e695debecd6f$export$71abc632aa29e6fe = {
    Control: $0361e695debecd6f$var$Control,
    DropdownIndicator: $0361e695debecd6f$var$DropdownIndicator,
    Menu: $0361e695debecd6f$var$Menu,
    IndicatorSeparator: $0361e695debecd6f$var$IndicatorSeparator,
    ClearIndicator: $0361e695debecd6f$var$ClearIndicator,
    MultiValueRemove: $0361e695debecd6f$var$MultiValueRemove
};

});
parcelRegister("ddMyj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::96a381bb462d74e92d39bb265721c443>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a0226c6d5821eba$var$_react = $9a0226c6d5821eba$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9a0226c6d5821eba$var$_search = $9a0226c6d5821eba$var$_interopRequireDefault((parcelRequire("eebsR")));

var $9a0226c6d5821eba$var$_search2 = $9a0226c6d5821eba$var$_interopRequireDefault((parcelRequire("hU0Tg")));
function $9a0226c6d5821eba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a0226c6d5821eba$var$SearchIcon = (props)=>/*#__PURE__*/ $9a0226c6d5821eba$var$_react.default.createElement($9a0226c6d5821eba$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $9a0226c6d5821eba$var$_search2.default
    }, props));
$9a0226c6d5821eba$var$SearchIcon.Name = 'SearchIconMigration';
var $9a0226c6d5821eba$var$_default = module.exports.default = $9a0226c6d5821eba$var$SearchIcon;

});
parcelRegister("hU0Tg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0885b6f5437ca77$var$_react = $d0885b6f5437ca77$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $d0885b6f5437ca77$var$_search = $d0885b6f5437ca77$var$_interopRequireDefault((parcelRequire("eebsR")));
function $d0885b6f5437ca77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d0885b6f5437ca77$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $d0885b6f5437ca77$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $d0885b6f5437ca77$var$_search.default
    }));
$d0885b6f5437ca77$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $d0885b6f5437ca77$var$_default = module.exports.default = $d0885b6f5437ca77$var$EditorSearchIcon;

});




parcelRegister("hw2eW", function(module, exports) {

$parcel$export(module.exports, "getIssueTypesSettingsUrl", () => $4a7674a4409ee541$export$b9500524016e18f0);
const $4a7674a4409ee541$export$b9500524016e18f0 = (projectKey, isSimplified)=>isSimplified ? `/jira/core/projects/${projectKey}/settings/issuetypes` : `/plugins/servlet/project-config/${projectKey}/issuetypes`;

});

const $3b526ddeb90a4d89$export$3789e4b2a10baa2b = 'full';
const $3b526ddeb90a4d89$export$db1cdb8627b81f84 = 'compact';
const $3b526ddeb90a4d89$export$aca095bc476d426f = 'simple';
const $3b526ddeb90a4d89$export$1aad44a7533f8ad8 = 'table_row';
const $3b526ddeb90a4d89$export$d2f7b3f0efb6e208 = 'hidden';
const $3b526ddeb90a4d89$export$dda6912361cddac9 = 'visible';
const $3b526ddeb90a4d89$export$565566e3df4dad53 = 'blur';
const $3b526ddeb90a4d89$export$806b905ec7df742f = 'enter';
const $3b526ddeb90a4d89$export$2bb790b9008907b4 = 'escape';
const $3b526ddeb90a4d89$export$ba9f60edfdf2e66 = 'create_button';
const $3b526ddeb90a4d89$export$3dd832bb5d8861ec = 'multi_dialog_single_create_button';
const $3b526ddeb90a4d89$export$b5288579893d806 = 'multi_dialog_multi_create_button';
const $3b526ddeb90a4d89$export$193356664cd84c83 = 255;
const $3b526ddeb90a4d89$export$f9e3e7ede9ba929d = 500;
const $3b526ddeb90a4d89$export$e0bc602b327f818b = 'add-issue-type-option';

parcelRegister("l4rzg", function(module, exports) {

$parcel$export(module.exports, "CREATE_ISSUE_EXPERIENCE", () => $004447294a5330e0$export$ed625f60643a6c30);
const $004447294a5330e0$export$ed625f60643a6c30 = {
    experience: 'createIssue',
    packageName: 'jiraBusinessIssueCreate',
    teamName: 'wanjel'
};

});

parcelRegister("kTIhq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef962d80dcbffe5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2ef962d80dcbffe5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholderText: {
        "id": "business-issue-create.inline-create-form.placeholder-text",
        "defaultMessage": "What needs to be done?"
    },
    createButton: {
        "id": "business-issue-create.inline-create-form.create-button",
        "defaultMessage": "Create"
    },
    selectIssueTypeButton: {
        "id": "business-issue-create.inline-create-form.select-issue-type-button",
        "defaultMessage": "Select issue type. {issueType} currently selected."
    },
    manageIssueTypes: {
        "id": "business-issue-create.inline-create-form.manage-issue-types",
        "defaultMessage": "Manage types"
    },
    selectIssueTypeButtonIssueTermRefresh: {
        "id": "business-issue-create.inline-create-form.select-issue-type-button-issue-term-refresh",
        "defaultMessage": "Select issue type. {issueType} currently selected."
    }
});

});

parcelRegister("fkT5k", function(module, exports) {

$parcel$export(module.exports, "default", () => $c337a03315092ec3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $70oKY = parcelRequire("70oKY");
const $c337a03315092ec3$var$ReturnGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 0C1.34315 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16H21C22.6569 16 24 14.6569 24 13V3C24 1.34315 22.6569 0 21 0H3Z",
        fill: "var(--ds-background-inverse-subtle, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15.5 5.75V6.75C15.5 8.26878 14.2688 9.5 12.75 9.5H8.75C8.33579 9.5 8 9.16421 8 8.75C8 8.33579 8.33579 8 8.75 8H12.75C13.4404 8 14 7.44036 14 6.75V5.75C14 5.33579 14.3358 5 14.75 5C15.1642 5 15.5 5.33579 15.5 5.75Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.28033 9.28033L11.0303 7.53033C11.3232 7.23744 11.3232 6.76256 11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967L8.21967 8.21967C7.92678 8.51256 7.92678 8.98744 8.21967 9.28033C8.51256 9.57322 8.98744 9.57322 9.28033 9.28033Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.28033 8.21967L11.0303 9.96967C11.3232 10.2626 11.3232 10.7374 11.0303 11.0303C10.7374 11.3232 10.2626 11.3232 9.96967 11.0303L8.21967 9.28033C7.92678 8.98744 7.92678 8.51256 8.21967 8.21967C8.51256 7.92678 8.98744 7.92678 9.28033 8.21967Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }));
const $c337a03315092ec3$var$ReturnIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $70oKY.default), {
        glyph: $c337a03315092ec3$var$ReturnGlyph,
        label: ""
    });
var $c337a03315092ec3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($c337a03315092ec3$var$ReturnIcon);

});


parcelRegister("2vRZq", function(module, exports) {

$parcel$export(module.exports, "useInlineCreateProps", () => $4b2c7a84b9102d07$export$ecb6499077e81078);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $e4qlg = parcelRequire("e4qlg");

var $gIx2f = parcelRequire("gIx2f");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");

var $1j5vW = parcelRequire("1j5vW");

var $dtXTv = parcelRequire("dtXTv");

var $lgmYa = parcelRequire("lgmYa");

var $iq40z = parcelRequire("iq40z");
const $4b2c7a84b9102d07$export$ecb6499077e81078 = ({ group: group, onAddOptimisticIssue: onAddOptimisticIssue, rankBeforeIssue: rankBeforeIssue })=>{
    const { data: categoryField } = (0, $e4qlg.useCategoryField)();
    const categoryFieldId = categoryField?.id;
    const { setIssues: setIssues, removeIssues: removeIssues } = (0, $dtXTv.useIssueStoreActions)();
    const fieldIdsToReturn = (0, $lgmYa.useFieldIds)();
    const transformToIssues = (0, $1j5vW.useTransformIssues)();
    const { issueTypes: issueTypes } = (0, $iq40z.useWorkflowStoreState)();
    const allowedIssueTypeIds = (0, $eUqFw.useMemo)(()=>issueTypes.map((issueType)=>issueType.id), [
        issueTypes
    ]);
    const prepareIssueContext = (0, $eUqFw.useCallback)(()=>{
        const issueContext = {};
        if (rankBeforeIssue) issueContext.rankBefore = {
            issueId: String(rankBeforeIssue.id),
            rank: rankBeforeIssue.fields[0, $ib4WI.RANK_ID].value
        };
        if (group.id === (0, $ib4WI.NULL_GROUP_KEY)) return issueContext;
        switch(group.type){
            case 0, $jGcn0.GROUP_BY_ASSIGNEE:
                issueContext.assignee = {
                    accountId: group.id,
                    avatarUrl: group.imageUrl ?? '',
                    displayName: group.name
                };
                break;
            case 0, $jGcn0.GROUP_BY_PRIORITY:
                issueContext.priority = {
                    iconUrl: group.imageUrl ?? '',
                    name: group.name,
                    priorityId: group.id
                };
                break;
            case 0, $jGcn0.GROUP_BY_CATEGORY:
                issueContext.category = {
                    color: group.color || '',
                    optionId: group.id,
                    value: group.name
                };
                break;
            case 0, $jGcn0.GROUP_BY_STATUS:
                issueContext.status = {
                    name: group.name,
                    statusCategoryId: group.statusCategoryId,
                    statusId: group.id
                };
                break;
            default:
                break;
        }
        return issueContext;
    }, [
        group,
        rankBeforeIssue
    ]);
    const handleSubmit = (0, $eUqFw.useCallback)(async ({ optimisticIssuePayload: optimisticIssuePayload, promise: promise })=>{
        const optimisticIssue = {
            id: optimisticIssuePayload.issueId,
            coverMedia: null,
            fields: {
                [(0, $ib4WI.ISSUE_TYPE_ID)]: {
                    id: optimisticIssuePayload.issueType.id,
                    fieldId: (0, $lO4Or.ISSUE_TYPE),
                    type: (0, $ib4WI.BOARD_FIELD_ISSUE_TYPE),
                    issueType: {
                        id: optimisticIssuePayload.issueType.id,
                        name: optimisticIssuePayload.issueType.name,
                        iconUrl: optimisticIssuePayload.issueType.avatarUrl ?? '',
                        hierarchyLevel: optimisticIssuePayload.issueType.hierarchyLevel
                    }
                },
                [(0, $ib4WI.ISSUE_KEY_ID)]: {
                    fieldId: (0, $lO4Or.ISSUE_KEY_TYPE),
                    type: (0, $ib4WI.BOARD_FIELD_TEXT),
                    value: ''
                },
                [(0, $ib4WI.STATUS_ID)]: {
                    fieldId: (0, $lO4Or.STATUS_TYPE),
                    status: {
                        id: optimisticIssuePayload.status?.statusId ?? '',
                        name: optimisticIssuePayload.status?.name ?? '',
                        statusCategoryId: optimisticIssuePayload.status?.statusCategoryId ?? 2
                    },
                    type: (0, $ib4WI.BOARD_FIELD_STATUS),
                    value: optimisticIssuePayload.status?.statusId ?? '0'
                },
                [(0, $ib4WI.SUMMARY_ID)]: {
                    fieldId: (0, $lO4Or.SUMMARY_TYPE),
                    type: (0, $ib4WI.BOARD_FIELD_TEXT),
                    value: optimisticIssuePayload.summary
                },
                [(0, $ib4WI.RANK_ID)]: {
                    fieldId: '',
                    type: (0, $ib4WI.BOARD_FIELD_TEXT),
                    value: optimisticIssuePayload.rank ?? 'z'
                }
            },
            subtaskMetadata: {
                done: 0,
                total: 0
            }
        };
        if (optimisticIssuePayload.assignee) optimisticIssue.fields[0, $ib4WI.ASSIGNEE_ID] = {
            fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
            type: (0, $ib4WI.BOARD_FIELD_USER),
            value: optimisticIssuePayload.assignee.accountId,
            user: {
                accountId: optimisticIssuePayload.assignee.accountId,
                avatarURL: optimisticIssuePayload.assignee.avatarUrl,
                name: optimisticIssuePayload.assignee.displayName
            }
        };
        if (optimisticIssuePayload.priority) optimisticIssue.fields[0, $ib4WI.PRIORITY_ID] = {
            fieldId: (0, $lO4Or.PRIORITY_TYPE),
            type: (0, $ib4WI.BOARD_FIELD_PRIORITY),
            value: optimisticIssuePayload.priority.priorityId,
            priority: {
                id: optimisticIssuePayload.priority.priorityId,
                iconUrl: optimisticIssuePayload.priority.iconUrl,
                name: optimisticIssuePayload.priority.name
            }
        };
        if (optimisticIssuePayload.category && categoryFieldId) optimisticIssue.fields[0, $ib4WI.CATEGORY_ID] = {
            fieldId: categoryFieldId,
            type: (0, $ib4WI.BOARD_FIELD_CATEGORY),
            value: optimisticIssuePayload.category.optionId,
            category: {
                color: optimisticIssuePayload.category.color,
                name: group.name
            }
        };
        setIssues([
            optimisticIssue
        ]);
        onAddOptimisticIssue?.();
        let createdBoardItem;
        try {
            createdBoardItem = await promise;
        } catch (e) {
        // swallow error
        }
        if (createdBoardItem) {
            const issues = transformToIssues([
                createdBoardItem
            ]);
            setIssues(issues);
        }
        removeIssues([
            optimisticIssue.id
        ]);
    }, [
        categoryFieldId,
        setIssues,
        onAddOptimisticIssue,
        removeIssues,
        group.name,
        transformToIssues
    ]);
    return {
        allowedIssueTypeIds: allowedIssueTypeIds,
        appearance: (0, $gIx2f.CARD_APPEARANCE),
        fieldIdsToReturn: fieldIdsToReturn,
        onPrepareIssueContext: prepareIssueContext,
        onSubmit: handleSubmit
    };
};

});

parcelRegister("kySwt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5050b008cfd6144a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5050b008cfd6144a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createSiblingIssue: {
        "id": "work-management-board.board.column.card.inline-sibling-create.create-sibling-issue",
        "defaultMessage": "Create"
    }
});

});



parcelRegister("1kaEx", function(module, exports) {

$parcel$export(module.exports, "default", () => $beb14cd82ffd46db$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lUg8E = parcelRequire("lUg8E");

var $fdguH = parcelRequire("fdguH");

var $6MoyP = parcelRequire("6MoyP");

var $4SVcA = parcelRequire("4SVcA");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $gEmpR = parcelRequire("gEmpR");

var $3ySoA = parcelRequire("3ySoA");

var $8Qd0L = parcelRequire("8Qd0L");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ib4WI = parcelRequire("ib4WI");

var $lUpP3 = parcelRequire("lUpP3");

var $gWYTK = parcelRequire("gWYTK");

var $lnmSR = parcelRequire("lnmSR");

var $cgK6s = parcelRequire("cgK6s");

var $iq40z = parcelRequire("iq40z");

var $9PJYX = parcelRequire("9PJYX");

var $bVeLr = parcelRequire("bVeLr");

var $1VNWp = parcelRequire("1VNWp");

var $lELme = parcelRequire("lELme");
const $beb14cd82ffd46db$var$renderTransitionInfoOverlay = (sourceGroup, targetGroup)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($beb14cd82ffd46db$var$TransitionInfoContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
        category: (0, $8Qd0L.statusCategoryForId)(sourceGroup.statusCategoryId),
        name: sourceGroup.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fdguH))), {
        size: "small",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
        category: (0, $8Qd0L.statusCategoryForId)(targetGroup.statusCategoryId),
        name: targetGroup.name
    }));
const $beb14cd82ffd46db$var$ColumnHeader = ({ dragHandleRef: dragHandleRef, group: group, isCardOverColumn: isCardOverColumn, isDragPreview: isDragPreview, isDropDisabled: isDropDisabled, issueCount: issueCount })=>{
    const isWorkflowOperationInProgress = (0, $cgK6s.useIsWorkflowOperationInProgress)();
    const workflowOperationStatusId = (0, $cgK6s.useWorkflowOperationStatusId)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { sourceGroup: sourceGroup, dropTarget: { transition: transition } } = (0, $gWYTK.useCardDragDrop)();
    const { isCollapsed: isCollapsed, toggleCollapse: toggleCollapse } = (0, $lnmSR.useExpandCollapse)(group.id);
    const [isEditMode, setEditMode] = (0, $eUqFw.useState)(false);
    const project = (0, $kQAZu.useProject)();
    const { data: { issueTypes: issueTypes } } = (0, $gEmpR.useIssueTypesAndFields)();
    const { workflows: workflows } = (0, $iq40z.useWorkflowStoreState)();
    const hasMultipleWorkflows = workflows.length > 1;
    const hasExceededMaxIssueTypes = issueTypes.length > (0, $ib4WI.MAX_ISSUE_TYPES_COUNT);
    const isTeamManaged = project.isSimplified;
    const isProjectAdmin = project.permissions.administerProject;
    const shouldShowTransitionInfoOverlay = transition != null && sourceGroup?.type === (0, $jGcn0.GROUP_BY_STATUS) && group.type === (0, $jGcn0.GROUP_BY_STATUS) && isCardOverColumn && !isCollapsed;
    const isCollapsedDropNotAllowed = isDropDisabled && isCollapsed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($beb14cd82ffd46db$var$Container, {
        "data-testid": "work-management-board.ui.board.column.column-header.container",
        isColumnCollapsed: isCollapsed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($beb14cd82ffd46db$var$HeaderTitleWrapper, {
        "data-testid": "work-management-board.ui.board.column.column-header.header-title-wrapper",
        isColumnCollapsed: isCollapsed
    }, isCollapsedDropNotAllowed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUpP3.default), null) : isProjectAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        "aria-hidden": true,
        xcss: $beb14cd82ffd46db$var$dragHandleStyles,
        ref: dragHandleRef,
        testId: "work-management-board.ui.board.column.column-header.drag-handle"
    }, "\u283F"), shouldShowTransitionInfoOverlay ? $beb14cd82ffd46db$var$renderTransitionInfoOverlay(sourceGroup, group) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bVeLr.default), {
        group: group,
        isCollapsed: isCollapsed,
        issueCount: issueCount,
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        hasMultipleWorkflows: hasMultipleWorkflows,
        hasExceededMaxIssueTypes: hasExceededMaxIssueTypes
    }), isCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($beb14cd82ffd46db$var$ExpandCollapseButtonWrapper, {
        "data-component-selector": "work-management-board.ui.board.column.column-header.expand-button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4SVcA))), {
            label: formatMessage((0, $lELme.default).expandButton),
            size: "medium"
        }),
        onClick: toggleCollapse,
        spacing: "none"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($beb14cd82ffd46db$var$MenuWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($beb14cd82ffd46db$var$ExpandCollapseButtonWrapper, {
        "data-component-selector": "work-management-board.ui.board.column.column-header.collapse-button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6MoyP))), {
            label: formatMessage((0, $lELme.default).collapseButton),
            size: "medium"
        }),
        onClick: toggleCollapse
    })), isTeamManaged && group.type === (0, $jGcn0.GROUP_BY_STATUS) && !isDragPreview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VNWp.default), {
        isLoading: workflowOperationStatusId === group.id && isWorkflowOperationInProgress,
        hasMultipleWorkflows: hasMultipleWorkflows,
        hasExceededMaxIssueTypes: hasExceededMaxIssueTypes,
        columnName: group.name,
        onRenameClick: ()=>{
            setEditMode(true);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9PJYX.default), {
        group: group
    }))));
};
const $beb14cd82ffd46db$var$HeaderTitleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isColumnCollapsed: isColumnCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _vchhusvi _syaz1tgx _1e0c1txw _zulp1b66 _1bah1yb4 _1bsb1osq",
            __cmplp.isColumnCollapsed ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.isColumnCollapsed ? "_1yt417pv" : "_1yt4zayo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $beb14cd82ffd46db$var$ExpandCollapseButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4t3i17is _tzy411de _1bsbeudw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $beb14cd82ffd46db$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isColumnCollapsed: isColumnCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswh2mm _uiztglyw _1ji3grho _59hlidpf _1xn7grho _1rop1wug _3o2n1wug _3bdqt94y _at5wt94y _tdle1wug _1d8n1wug",
            __cmplp.isColumnCollapsed ? "_4t3i1wug _1tkeidpf _1o9zkb7n _1pbycs5v" : "_4t3ickbl _1o9zidpf _1pbyegat",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $beb14cd82ffd46db$var$TransitionInfoContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c11p5 _wij21bp4 _1bah1e5h _17kn15vq _1hrp15vq _x3fa1l2s _10ca1q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $beb14cd82ffd46db$var$MenuWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
const $beb14cd82ffd46db$var$dragHandleStyles = (0, $8Vv3m.xcss)({
    color: 'color.text.subtle',
    cursor: 'grab'
});
var $beb14cd82ffd46db$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($beb14cd82ffd46db$var$ColumnHeader);

});
parcelRegister("fdguH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b134dd549af6b098$var$_react = $b134dd549af6b098$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $b134dd549af6b098$var$_arrowRight = $b134dd549af6b098$var$_interopRequireDefault((parcelRequire("5jod9")));
function $b134dd549af6b098$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b134dd549af6b098$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $b134dd549af6b098$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $b134dd549af6b098$var$_arrowRight.default
    }));
$b134dd549af6b098$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $b134dd549af6b098$var$_default = module.exports.default = $b134dd549af6b098$var$ArrowRightIcon;

});
parcelRegister("5jod9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a0af1361c1c47b464cd1f3e8c2b50c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3de181f084aefee7$var$_react = $3de181f084aefee7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3de181f084aefee7$var$_UNSAFE_baseNew = $3de181f084aefee7$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $3de181f084aefee7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3de181f084aefee7$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $3de181f084aefee7$var$_react.default.createElement($3de181f084aefee7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
    }, props));
$3de181f084aefee7$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $3de181f084aefee7$var$_default = module.exports.default = $3de181f084aefee7$var$ArrowRightIcon;

});


parcelRegister("6MoyP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4efa4700706e6558$var$_react = $4efa4700706e6558$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $4efa4700706e6558$var$_shrinkHorizontal = $4efa4700706e6558$var$_interopRequireDefault((parcelRequire("gILOf")));
function $4efa4700706e6558$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4efa4700706e6558$var$EditorCollapseIcon = (props)=>/*#__PURE__*/ $4efa4700706e6558$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.062 11 6.5 9.914A1 1 0 0 1 7.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L7.914 15.5A1 1 0 1 1 6.5 14.086L8.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1zm5.408 1.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L16.086 8.5A1 1 0 0 1 17.5 9.914L15.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68l1.562 1.086a1 1 0 0 1-1.414 1.414z"/></svg>`
    }, props, {
        newIcon: $4efa4700706e6558$var$_shrinkHorizontal.default
    }));
$4efa4700706e6558$var$EditorCollapseIcon.displayName = 'EditorCollapseIcon';
var $4efa4700706e6558$var$_default = module.exports.default = $4efa4700706e6558$var$EditorCollapseIcon;

});
parcelRegister("gILOf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::531f44052ac740918f6a90855bbca3de>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c2c5d75b919fd8db$var$_react = $c2c5d75b919fd8db$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c2c5d75b919fd8db$var$_UNSAFE_baseNew = $c2c5d75b919fd8db$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $c2c5d75b919fd8db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShrinkHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c2c5d75b919fd8db$var$ShrinkHorizontalIcon = (props)=>/*#__PURE__*/ $c2c5d75b919fd8db$var$_react.default.createElement($c2c5d75b919fd8db$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M0 8h6.25m3.5 0H16M2.75 4.5 6.25 8l-3.5 3.5m10.5-7L9.75 8l3.5 3.5"/>`
    }, props));
$c2c5d75b919fd8db$var$ShrinkHorizontalIcon.displayName = 'ShrinkHorizontalIcon';
var $c2c5d75b919fd8db$var$_default = module.exports.default = $c2c5d75b919fd8db$var$ShrinkHorizontalIcon;

});


parcelRegister("4SVcA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $38e893b13f4eb430$var$_react = $38e893b13f4eb430$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $38e893b13f4eb430$var$_growHorizontal = $38e893b13f4eb430$var$_interopRequireDefault((parcelRequire("gdKRF")));
function $38e893b13f4eb430$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $38e893b13f4eb430$var$EditorExpandIcon = (props)=>/*#__PURE__*/ $38e893b13f4eb430$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M18.062 11 16.5 9.914A1 1 0 1 1 17.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L17.914 15.5a1 1 0 0 1-1.414-1.414L18.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1zM3.47 12.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L6.086 8.5A1 1 0 0 1 7.5 9.914L5.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68L7.5 14.086A1 1 0 0 1 6.086 15.5z"/></svg>`
    }, props, {
        newIcon: $38e893b13f4eb430$var$_growHorizontal.default
    }));
$38e893b13f4eb430$var$EditorExpandIcon.displayName = 'EditorExpandIcon';
var $38e893b13f4eb430$var$_default = module.exports.default = $38e893b13f4eb430$var$EditorExpandIcon;

});
parcelRegister("gdKRF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7627d62c0580ef6f741a06b6c3044d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bcf2368dd560a1d3$var$_react = $bcf2368dd560a1d3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $bcf2368dd560a1d3$var$_UNSAFE_baseNew = $bcf2368dd560a1d3$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $bcf2368dd560a1d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "GrowHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bcf2368dd560a1d3$var$GrowHorizontalIcon = (props)=>/*#__PURE__*/ $bcf2368dd560a1d3$var$_react.default.createElement($bcf2368dd560a1d3$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m11.75 4.5 3.5 3.5-3.5 3.5M9 8h5.75M4.25 4.5.75 8l3.5 3.5M7 8H1.25"/>`
    }, props));
$bcf2368dd560a1d3$var$GrowHorizontalIcon.displayName = 'GrowHorizontalIcon';
var $bcf2368dd560a1d3$var$_default = module.exports.default = $bcf2368dd560a1d3$var$GrowHorizontalIcon;

});


parcelRegister("lUpP3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a7b767a502772fc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $4a7b767a502772fc$var$RestrictedIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4a7b767a502772fc$var$Graphic, {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.82452 2.57897C11.7787 2.57897 13.6529 3.35529 15.0348 4.73713C16.4166 6.11898 17.1929 7.99317 17.1929 9.94739C17.1929 11.9016 16.4166 13.7758 15.0348 15.1577C13.6529 16.5395 11.7787 17.3158 9.82452 17.3158C7.8703 17.3158 5.99611 16.5395 4.61426 15.1577C3.23241 13.7758 2.4561 11.9016 2.4561 9.94739C2.4561 7.99317 3.23241 6.11898 4.61426 4.73713C5.99611 3.35529 7.8703 2.57897 9.82452 2.57897ZM9.82452 0.473709C8.57209 0.460507 7.32946 0.695786 6.16855 1.16594C5.00763 1.63609 3.95146 2.33177 3.06115 3.21275C2.17084 4.09372 1.46406 5.1425 0.981702 6.29839C0.499342 7.45429 0.250977 8.69436 0.250977 9.94687C0.250977 11.1994 0.499342 12.4394 0.981702 13.5953C1.46406 14.7512 2.17084 15.8 3.06115 16.681C3.95146 17.562 5.00763 18.2576 6.16855 18.7278C7.32946 19.1979 8.57209 19.4332 9.82452 19.42C12.3371 19.42 14.7468 18.4219 16.5234 16.6452C18.3001 14.8686 19.2982 12.4589 19.2982 9.94634C19.2982 7.43376 18.3001 5.02409 16.5234 3.24743C14.7468 1.47077 12.3371 0.472656 9.82452 0.472656V0.473709Z",
        fill: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M3.68457 5.09375L15.0656 16.4695L16.9856 14.7474L5.40352 3.15796C5.43299 3.18954 3.68457 5.09375 3.68457 5.09375Z",
        fill: "var(--ds-icon-subtle, #626F86)"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $4a7b767a502772fc$var$Graphic = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
var $4a7b767a502772fc$export$2e2bcd8739ae039 = $4a7b767a502772fc$var$RestrictedIcon;

});

parcelRegister("9PJYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b1561e8a8664387$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $8Qd0L = parcelRequire("8Qd0L");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $iLiDV = parcelRequire("iLiDV");

var $116rm = parcelRequire("116rm");
const $4b1561e8a8664387$var$isStatusGroup = (group)=>group.type === (0, $jGcn0.GROUP_BY_STATUS);
const $4b1561e8a8664387$var$entryPointParams = {};
const $4b1561e8a8664387$var$ColumnConfettiAsync = ({ group: group })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $116rm.boardConfettiEntrypoint), $4b1561e8a8664387$var$entryPointParams);
    const [animating, setAnimating] = (0, $eUqFw.useState)(false);
    const { confettiColumns: confettiColumns, removeConfettiColumn: removeConfettiColumn } = (0, $iLiDV.useConfettiColumns)();
    const showConfetti = (0, $iLiDV.matchConfettiColumn)(group.name) || $4b1561e8a8664387$var$isStatusGroup(group) && group.statusCategoryId === (0, $8Qd0L.StatusCategoryIds).done;
    (0, $eUqFw.useEffect)(()=>{
        if (confettiColumns.has(group.id)) {
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'boardConfetti created', {
                columnType: (0, $iLiDV.matchConfettiColumn)(group.name) ? 'emoji' : 'done',
                columnId: group.id
            });
            setAnimating(true);
            removeConfettiColumn(group.id);
        }
    }, [
        confettiColumns,
        createAnalyticsEvent,
        group.id,
        group.name,
        removeConfettiColumn
    ]);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        if (animating) entryPointActions.load();
    }, [
        animating,
        entryPointActions
    ]);
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            onConfettiComplete: ()=>setAnimating(false)
        }), [
        setAnimating
    ]);
    if (!showConfetti || !animating) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jwm-board-confetti",
        packageName: "jiraWorkManagementBoard",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: runtimeProps
    });
};
var $4b1561e8a8664387$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($4b1561e8a8664387$var$ColumnConfettiAsync);

});
parcelRegister("116rm", function(module, exports) {

$parcel$export(module.exports, "boardConfettiEntrypoint", () => $12c7cffc509e28bb$export$1495ab1cfa22b397);

var $14fpI = parcelRequire("14fpI");

var $4dIH4 = parcelRequire("4dIH4");

const $12c7cffc509e28bb$export$1495ab1cfa22b397 = (0, $4dIH4.createEntryPoint)({
    root: (0, $14fpI.JSResourceForInteraction)(()=>(parcelRequire("7TL44")), {
        moduleId: "58031bc6"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7TL44", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("eVlda").then(()=>parcelRequire('72WXl'));

});



parcelRegister("bVeLr", function(module, exports) {

$parcel$export(module.exports, "default", () => $81f9ca4ed94e88e9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $k9isx = parcelRequire("k9isx");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $gjzML = parcelRequire("gjzML");

var $MxsGB = parcelRequire("MxsGB");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $gEmpR = parcelRequire("gEmpR");

var $3ySoA = parcelRequire("3ySoA");

var $8Qd0L = parcelRequire("8Qd0L");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $8rQuz = parcelRequire("8rQuz");

var $ib4WI = parcelRequire("ib4WI");

var $bFk6h = parcelRequire("bFk6h");

var $cgK6s = parcelRequire("cgK6s");

var $4i4ee = parcelRequire("4i4ee");

var $iq40z = parcelRequire("iq40z");

var $2gjAV = parcelRequire("2gjAV");

var $lN7up = parcelRequire("lN7up");

var $1Pyi6 = parcelRequire("1Pyi6");

var $3cUPp = parcelRequire("3cUPp");
const $81f9ca4ed94e88e9$var$HeaderContent = ({ group: group, isCollapsed: isCollapsed, issueCount: issueCount, isEditMode: isEditMode, setEditMode: setEditMode, hasMultipleWorkflows: hasMultipleWorkflows, hasExceededMaxIssueTypes: hasExceededMaxIssueTypes })=>{
    const project = (0, $kQAZu.useProject)();
    const [headerName, setHeaderName] = (0, $eUqFw.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isWorkflowOperationInProgress = (0, $cgK6s.useIsWorkflowOperationInProgress)();
    const isTeamManaged = project.isSimplified;
    const isProjectAdmin = project.permissions.administerProject;
    const { renameStatus: renameStatus, validateRenameStatus: validateRenameStatus } = (0, $4i4ee.useRenameStatus)((0, $ib4WI.COLUMN_ACTION_RENAME_EXPERIENCE));
    (0, $eUqFw.useEffect)(()=>{
        setHeaderName(group.name);
    }, [
        group.name
    ]);
    const getColumnName = (0, $eUqFw.useCallback)((message)=>group.id === (0, $ib4WI.NULL_GROUP_KEY) ? formatMessage(message) : group.name, [
        formatMessage,
        group.id,
        group.name
    ]);
    const headerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, {
        [(0, $jGcn0.GROUP_BY_STATUS)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81f9ca4ed94e88e9$var$WritingModeWrapper, {
            isVerticalWritingMode: isCollapsed
        }, group.type === (0, $jGcn0.GROUP_BY_STATUS) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
            xcss: $81f9ca4ed94e88e9$var$statusHeaderStyles
        }, headerName ?? group.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
            name: headerName ?? group.name,
            category: (0, $8Qd0L.statusCategoryForId)(group.statusCategoryId)
        }), group.statusCategoryId === (0, $8Qd0L.StatusCategoryIds).done && (0, $8rQuz.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2gjAV.default), null))),
        [(0, $jGcn0.GROUP_BY_PRIORITY)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, group.type === (0, $jGcn0.GROUP_BY_PRIORITY) && group.imageUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81f9ca4ed94e88e9$var$Image, {
            alt: "",
            draggable: false,
            src: group.imageUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81f9ca4ed94e88e9$var$ColumnName, {
            isVerticalWritingMode: isCollapsed
        }, getColumnName((0, $3cUPp.default).noPriority))),
        [(0, $jGcn0.GROUP_BY_ASSIGNEE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, group.id === (0, $ib4WI.NULL_GROUP_KEY) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k9isx.default), {
            appearance: "circle",
            src: "",
            size: "small"
        }) : group.type === (0, $jGcn0.GROUP_BY_ASSIGNEE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gjzML.AvatarLite), {
            avatarUrl: group.imageUrl ?? '',
            name: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81f9ca4ed94e88e9$var$ColumnName, {
            isVerticalWritingMode: isCollapsed
        }, getColumnName((0, $3cUPp.default).noAssignee))),
        [(0, $jGcn0.GROUP_BY_CATEGORY)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, group.type === (0, $jGcn0.GROUP_BY_CATEGORY) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81f9ca4ed94e88e9$var$WritingModeWrapper, {
            isVerticalWritingMode: isCollapsed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $MxsGB.default), {
            categoryName: getColumnName((0, $3cUPp.default).noCategory),
            categoryColor: group.color
        })))
    }[group.type], /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Pyi6.default), {
        isCollapsed: isCollapsed,
        issueCount: issueCount
    }));
    const shouldRenderReadOnly = !isTeamManaged || !isProjectAdmin || hasMultipleWorkflows || group.type !== (0, $jGcn0.GROUP_BY_STATUS) || isWorkflowOperationInProgress || hasExceededMaxIssueTypes;
    const { refetch: refetchBoardData } = (0, $bFk6h.useBoardData)();
    const { columns: columns } = (0, $iq40z.useWorkflowStoreState)();
    const { data: { issueTypes: issueTypes } } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const issueTypeIdNotSubtask = issueTypes.find((issueType)=>issueType.hierarchyLevel !== -1)?.id;
    return shouldRenderReadOnly || isCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81f9ca4ed94e88e9$var$HeaderContentWrapper, {
        isColumnCollapsed: isCollapsed
    }, headerContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81f9ca4ed94e88e9$var$EditableColumnHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lN7up.default), {
        defaultValue: group.name,
        isEditing: isEditMode,
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81f9ca4ed94e88e9$var$HeaderContentWrapper, null, headerContent),
        onCancel: ()=>setEditMode(false),
        onConfirm: async (newName)=>{
            setEditMode(false);
            setHeaderName(newName);
            try {
                await renameStatus({
                    oldName: group.name,
                    newName: newName,
                    statusId: Number(group.id),
                    issueTypeIdNotSubtask: issueTypeIdNotSubtask
                });
            } catch  {} finally{
                refetchBoardData();
            }
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'columnRenameInlineEdit confirmed', 'jwmBoardColumnRename');
        },
        onEdit: ()=>{
            setEditMode(true);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'columnHeader clicked', 'jwmBoardColumnRenameFromTitle', {
                isProjectAdmin: isProjectAdmin,
                hasMultipleWorkflows: hasMultipleWorkflows,
                hasExceededMaxIssueTypes: hasExceededMaxIssueTypes
            });
        },
        onValidate: (newName)=>validateRenameStatus({
                oldName: group.name,
                newName: newName,
                existingStatusNames: columns.map((c)=>c.name)
            })
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $81f9ca4ed94e88e9$var$WritingModeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVerticalWritingMode: isVerticalWritingMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1ul9idpf _1tkeidpf _zulp1b66",
            __cmplp.isVerticalWritingMode && "_1lfclhck",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $81f9ca4ed94e88e9$var$HeaderContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showDisabledCursor: showDisabledCursor, isColumnCollapsed: isColumnCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _16jlkb7n _zulpu2gc _1ul9idpf _1tkeidpf",
            __cmplp.showDisabledCursor ? "_80om13gf" : "_80om1kw7",
            __cmplp.isColumnCollapsed ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.isColumnCollapsed ? "_1yt41530" : "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $81f9ca4ed94e88e9$var$EditableColumnHeaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _16jlkb7n _1ul9idpf _2iu91osq _d8r5idpf _104v1r31 _1m7fglyw _o6xs1o36",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $81f9ca4ed94e88e9$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbpxbi _4t3ipxbi _s7n41ndm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $81f9ca4ed94e88e9$var$ColumnName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVerticalWritingMode: isVerticalWritingMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pni7l _1ul9idpf _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.isVerticalWritingMode && "_1lfclhck",
            __cmplp.className
        ])
    });
});
const $81f9ca4ed94e88e9$var$statusHeaderStyles = (0, $8Vv3m.xcss)({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle',
    textTransform: 'uppercase',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
var $81f9ca4ed94e88e9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($81f9ca4ed94e88e9$var$HeaderContent);

});
parcelRegister("4i4ee", function(module, exports) {

$parcel$export(module.exports, "useRenameStatus", () => $bee1df1b0c862743$export$a5702435b665f82d);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $3wNTK = parcelRequire("3wNTK");

var $aUkev = parcelRequire("aUkev");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dWLk9 = parcelRequire("dWLk9");

var $cgK6s = parcelRequire("cgK6s");

var $iONAM = parcelRequire("iONAM");

var $9dl5u = parcelRequire("9dl5u");
const $bee1df1b0c862743$var$getCleanColumnName = (name)=>name.replace(/\s{2,}/g, ' ').trim();
const $bee1df1b0c862743$export$a5702435b665f82d = (experienceDetails)=>{
    const startRenameOperation = (0, $cgK6s.useStartRenameOperation)();
    const stopWorkflowOperationInProgress = (0, $cgK6s.useStopWorkflowOperationInProgress)();
    const { fetchWorkflowsV2: fetchWorkflowsV2, validateAndUpdateWorkflowsV2: validateAndUpdateWorkflowsV2 } = (0, $3wNTK.useWorkflowsV2)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const startExperience = (0, $4G5xU.useExperienceStart)(experienceDetails);
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)(experienceDetails);
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)(experienceDetails);
    const abortExperience = (0, $4G5xU.useExperienceAbort)(experienceDetails);
    const project = (0, $kQAZu.useProject)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    /**
   * @returns undefined if it is valid, otherwise return string that will be used as error message
   * this is a pattern used by atlaskit form field validation or inline edit
   */ const validateRenameStatus = (0, $eUqFw.useCallback)(({ oldName: oldName, newName: newName, existingStatusNames: existingStatusNames })=>{
        const cleanNewName = $bee1df1b0c862743$var$getCleanColumnName(newName);
        const convertedNewName = cleanNewName.toUpperCase();
        if (convertedNewName === oldName.toUpperCase()) return undefined;
        if (!cleanNewName.length) return formatMessage((0, $9dl5u.default).emptyColumnNameError);
        if (existingStatusNames.some((statusName)=>statusName.toUpperCase() === convertedNewName)) return formatMessage((0, $9dl5u.default).statusAlreadyExists, {
            statusName: cleanNewName
        });
    }, [
        formatMessage
    ]);
    const renameStatus = (0, $eUqFw.useCallback)(async ({ oldName: oldName, statusId: statusId, newName: newName, issueTypeIdNotSubtask: issueTypeIdNotSubtask })=>{
        const cleanNewName = $bee1df1b0c862743$var$getCleanColumnName(newName);
        const convertedNewName = cleanNewName.toUpperCase();
        if (!cleanNewName.length || convertedNewName === oldName.toUpperCase()) return;
        startRenameOperation(String(statusId));
        startExperience();
        try {
            if (issueTypeIdNotSubtask == null) throw new (0, $iONAM.IssueTypeIdNotFoundError)('issueTypeIdNotSubtask is required but was not found.');
            // fetch workflow data from workflow API
            const workflowsData = await fetchWorkflowsV2({
                cloudId: cloudId,
                projectAndIssueTypes: [
                    {
                        projectId: project.id.toString(),
                        issueTypeId: issueTypeIdNotSubtask
                    }
                ]
            });
            if (workflowsData) {
                // rename the status in place
                const toRenameStatus = workflowsData.statuses.find((s)=>s.id === statusId.toString());
                if (toRenameStatus) {
                    toRenameStatus.name = cleanNewName;
                    await validateAndUpdateWorkflowsV2({
                        cloudId: cloudId,
                        payload: {
                            payload: {
                                statuses: (0, $aUkev.mapStatusesToStatusUpdateObjects)(workflowsData.statuses),
                                workflows: [
                                    (0, $aUkev.mapWorkflowToWorkflowUpdateObject)(workflowsData.workflows[0])
                                ]
                            },
                            validationOptions: {
                                levels: [
                                    'ERROR'
                                ]
                            }
                        }
                    });
                    markExperienceSuccess();
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            showFlag((0, $iONAM.getStatusActionFailedFlag)({
                messageTitle: (0, $9dl5u.default).errorFlagTitleRenameColumn,
                action: 'rename',
                error: error,
                issueTypeIdNotSubtask: issueTypeIdNotSubtask,
                projectKey: project.key,
                statusCode: error?.response?.status
            }));
            (0, $iONAM.failStatusExperience)({
                markExperienceFailed: markExperienceFailed,
                abortExperience: abortExperience,
                error: error,
                errorMessage: 'Failed to validate and update workflow'
            });
            throw error;
        } finally{
            stopWorkflowOperationInProgress();
        }
    }, [
        startRenameOperation,
        startExperience,
        fetchWorkflowsV2,
        cloudId,
        project.id,
        project.key,
        validateAndUpdateWorkflowsV2,
        markExperienceSuccess,
        showFlag,
        markExperienceFailed,
        abortExperience,
        stopWorkflowOperationInProgress
    ]);
    return {
        renameStatus: renameStatus,
        validateRenameStatus: validateRenameStatus
    };
};

});
parcelRegister("3wNTK", function(module, exports) {

$parcel$export(module.exports, "useWorkflowsV2", () => $5c98b31e4d950f5f$export$32b6f4c35d4611ee);
// The Workflow V2 API is defined here: https://developer.atlassian.com/cloud/jira-workflow/rest/api-group-workflow-v-/

var $eUqFw = parcelRequire("eUqFw");

var $dFBS3 = parcelRequire("dFBS3");

var $8Qd0L = parcelRequire("8Qd0L");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $2OdyW = parcelRequire("2OdyW");

var $7byHA = parcelRequire("7byHA");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");


var $8HJb0 = parcelRequire("8HJb0");

var $aUkev = parcelRequire("aUkev");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $5c98b31e4d950f5f$var$noop = ()=>{};
const $5c98b31e4d950f5f$export$32b6f4c35d4611ee = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const fetchWorkflowsV2 = (0, $eUqFw.useCallback)(async ({ cloudId: cloudId, projectAndIssueTypes: projectAndIssueTypes })=>{
        const url = (0, $eI5EY.fg)('jira-transition-types-update') ? `/gateway/api/jira/project-configuration/query/${cloudId}/2/workflow?useTransitionLinksFormat=true` : `/gateway/api/jira/project-configuration/query/${cloudId}/2/workflow`;
        try {
            const response = await (0, $2OdyW.default)(url, {
                method: 'POST',
                body: JSON.stringify({
                    projectAndIssueTypes: projectAndIssueTypes
                })
            });
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const jsonErrorResponse = error.originalResponse ? await error.originalResponse.json().catch($5c98b31e4d950f5f$var$noop) : undefined;
            if (jsonErrorResponse) {
                const errorMessage = `Fetch workflow fail status code: ${error.statusCode}; response: ${JSON.stringify(jsonErrorResponse)}`;
                const errorWithResponseMessage = new (0, $7byHA.default)(error.statusCode, errorMessage, error.traceId);
                (0, $guiFP.default)({
                    meta: {
                        id: 'fetchBoardWorkflowsV2',
                        packageName: 'jiraBusinessWorkflows',
                        teamName: 'wanjel'
                    },
                    error: errorWithResponseMessage,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw errorWithResponseMessage;
            }
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchBoardWorkflowsV2',
                    packageName: 'jiraBusinessWorkflows',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch board workflows'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, []);
    /**
	 * Update a single workflow only
	 * The `workflow` array in the payload can only have maximum 1 length
	 */ const updateWorkflowsV2 = (0, $eUqFw.useCallback)(async ({ payload: payload, cloudId: cloudId })=>{
        try {
            const response = await (0, $2OdyW.default)(`/gateway/api/jira/project-configuration/command/${cloudId}/2/workflow/update`, {
                method: 'POST',
                body: JSON.stringify(payload)
            });
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const jsonErrorResponse = error.originalResponse ? await error.originalResponse.json().catch($5c98b31e4d950f5f$var$noop) : undefined;
            if (jsonErrorResponse) {
                const errorMessage = `Update workflow fail status code: ${error.statusCode}; response: ${JSON.stringify(jsonErrorResponse)}`;
                const errorWithResponseMessage = new (0, $7byHA.default)(error.statusCode, errorMessage, error.traceId);
                (0, $guiFP.default)({
                    meta: {
                        id: 'updateBoardWorkflowsV2',
                        packageName: 'jiraBusinessWorkflows',
                        teamName: 'wanjel'
                    },
                    error: errorWithResponseMessage,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw errorWithResponseMessage;
            }
            (0, $guiFP.default)({
                meta: {
                    id: 'updateBoardWorkflowsV2',
                    packageName: 'jiraBusinessWorkflows',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to update board workflows'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, []);
    /**
	 * Validates the update payload and calls update workflow if there are no validation errors
	 * The `workflow` array in the payload can only have maximum 1 length
	 */ const validateAndUpdateWorkflowsV2 = (0, $eUqFw.useCallback)(async ({ payload: payload, cloudId: cloudId })=>{
        // validate payload
        let validationResponse;
        try {
            validationResponse = await (0, $2OdyW.default)(`/gateway/api/jira/project-configuration/command/${cloudId}/2/workflow/update/validation`, {
                method: 'POST',
                body: JSON.stringify(payload)
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const jsonErrorResponse = error.originalResponse ? await error.originalResponse.json().catch($5c98b31e4d950f5f$var$noop) : undefined;
            if (jsonErrorResponse) {
                const errorMessage = `Validate workflow fail status code: ${error.statusCode}; response: ${JSON.stringify(jsonErrorResponse)}`;
                const errorWithResponseMessage = new (0, $7byHA.default)(error.statusCode, errorMessage, error.traceId);
                (0, $guiFP.default)({
                    meta: {
                        id: 'validateUpdateBoardWorkflowsV2',
                        packageName: 'jiraBusinessWorkflows',
                        teamName: 'wanjel'
                    },
                    error: errorWithResponseMessage,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw errorWithResponseMessage;
            }
            (0, $guiFP.default)({
                meta: {
                    id: 'validateUpdateBoardWorkflowsV2',
                    packageName: 'jiraBusinessWorkflows',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to validate payload for update workflows'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
        if (validationResponse.errors.length > 0) {
            validationResponse.errors.forEach((e)=>{
                if (e.code === (0, $d42d7eaad5678ab9$export$fca543997a327d4c)) {
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'workflowValidation failed', {
                        message: e.message,
                        code: e.code
                    });
                    throw new (0, $8HJb0.StatusNameIsNotUniqueError)();
                }
                if (e.code === (0, $d42d7eaad5678ab9$export$cc9aaebfeb8efe99)) {
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'workflowValidation failed', {
                        message: e.message,
                        code: e.code
                    });
                    throw new (0, $8HJb0.StatusHasNoIncomingTransitionError)();
                }
                if (e.code === (0, $d42d7eaad5678ab9$export$cd6873a2b9593ebe)) throw new (0, $8HJb0.OldStatusMissingInWorkflowError)();
                if (e.code === (0, $d42d7eaad5678ab9$export$8f656a1a73ea2b22)) throw new (0, $8HJb0.NewStatusMissingInWorkflowError)();
                if (e.code === (0, $d42d7eaad5678ab9$export$a9ac4cce67a0398e)) throw new (0, $8HJb0.OnlyOneInitialTransitionAllowedError)();
                if (e.code === (0, $d42d7eaad5678ab9$export$7e934b410e3f0768)) throw new (0, $8HJb0.ApprovalRuleMisconfiguredError)();
                if (e.code === (0, $d42d7eaad5678ab9$export$3bf8ed0d6cdbf43d)) throw new (0, $8HJb0.WorkflowVersionConflictError)();
            });
            const errorMsgs = validationResponse.errors.map((e)=>e.message).join(', ');
            const errorCodes = validationResponse.errors.map((e)=>e.code).join(', ');
            const errorMessage = `Validation error(s) in update workflows payload - ${errorMsgs}`;
            const error = Error(errorMessage);
            (0, $guiFP.default)({
                meta: {
                    id: 'validateUpdateBoardWorkflowsV2',
                    packageName: 'jiraBusinessWorkflows',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: errorMessage,
                    totalErrors: validationResponse.errors.length,
                    code: errorCodes
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
        // update workflow
        return updateWorkflowsV2({
            payload: payload.payload,
            cloudId: cloudId
        });
    }, [
        updateWorkflowsV2,
        createAnalyticsEvent
    ]);
    const createWorkflowStatusV2 = (0, $eUqFw.useCallback)(async ({ statusName: statusName, statusCategory: statusCategory, cloudId: cloudId, projectId: projectId, issueTypes: issueTypes, onSuccess: onSuccess })=>{
        const workflowsData = await fetchWorkflowsV2({
            cloudId: cloudId,
            projectAndIssueTypes: issueTypes.map((it)=>({
                    projectId: projectId,
                    issueTypeId: it.id
                }))
        });
        if (workflowsData) {
            const subtaskIssueTypeId = issueTypes.find((issueType)=>issueType.hierarchyLevel === -1)?.id;
            // Remove workflows associated with one subtask issue type only
            const { statuses: statuses, workflows: boardWorkflows } = (0, $aUkev.removeWorkflowAssociatedWithSubtaskOnly)(workflowsData, subtaskIssueTypeId);
            const workflow = boardWorkflows[0];
            const transitionId = (0, $aUkev.getUniqueTransitionId)(workflow.transitions);
            // validate if the new transition name is unique
            const isTransitionNameExists = workflow.transitions.some((t)=>t.name.toUpperCase() === statusName.toUpperCase());
            const newTransitionName = isTransitionNameExists ? `${statusName} ${transitionId}` : statusName;
            const statusReference = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
            const newStatus = {
                statusReference: statusReference,
                name: statusName,
                statusCategory: statusCategory ?? (0, $8Qd0L.IN_PROGRESS),
                description: ''
            };
            const newStatusInWorkflow = {
                statusReference: statusReference,
                properties: {},
                deprecated: false
            };
            const transitionData = (0, $eI5EY.fg)('jira-transition-types-update') ? {
                links: [],
                toStatusReference: statusReference
            } : {
                from: [],
                to: {
                    statusReference: statusReference
                }
            };
            const newTransitionInWorkflow = {
                id: transitionId,
                type: 'GLOBAL',
                name: newTransitionName,
                description: '',
                actions: [],
                validators: [],
                triggers: [],
                properties: {},
                ...transitionData
            };
            // append newly created status and transition into workflow data
            workflow.statuses = [
                ...workflow.statuses,
                newStatusInWorkflow
            ];
            workflow.transitions = [
                ...workflow.transitions,
                newTransitionInWorkflow
            ];
            await validateAndUpdateWorkflowsV2({
                cloudId: cloudId,
                payload: {
                    payload: {
                        statuses: [
                            ...(0, $aUkev.mapStatusesToStatusUpdateObjects)(statuses),
                            newStatus
                        ],
                        workflows: [
                            (0, $aUkev.mapWorkflowToWorkflowUpdateObject)(workflow)
                        ]
                    },
                    validationOptions: {
                        levels: [
                            'ERROR'
                        ]
                    }
                }
            });
            onSuccess();
        }
    }, [
        fetchWorkflowsV2,
        validateAndUpdateWorkflowsV2
    ]);
    const createWorkflowStatusforSingleWorkflow = (0, $eUqFw.useCallback)(async ({ statusName: statusName, statusCategory: statusCategory, cloudId: cloudId, projectId: projectId, issueTypeId: issueTypeId, onSuccess: onSuccess })=>{
        const workflowsData = await fetchWorkflowsV2({
            cloudId: cloudId,
            projectAndIssueTypes: [
                {
                    projectId: projectId,
                    issueTypeId: issueTypeId
                }
            ]
        });
        if (workflowsData) {
            const { statuses: statuses, workflows: workflows } = workflowsData;
            const workflow = workflows[0];
            const transitionId = (0, $aUkev.getUniqueTransitionId)(workflow.transitions);
            // validate if the new transition name is unique
            const isTransitionNameExists = workflow.transitions.some((t)=>t.name.toUpperCase() === statusName.toUpperCase());
            const newTransitionName = isTransitionNameExists ? `${statusName} ${transitionId}` : statusName;
            const statusReference = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
            const newStatus = {
                statusReference: statusReference,
                name: statusName,
                statusCategory: statusCategory ?? (0, $8Qd0L.IN_PROGRESS),
                description: ''
            };
            const newStatusInWorkflow = {
                statusReference: statusReference,
                properties: {},
                deprecated: false
            };
            const transitionData = (0, $eI5EY.fg)('jira-transition-types-update') ? {
                links: [],
                toStatusReference: statusReference
            } : {
                from: [],
                to: {
                    statusReference: statusReference
                }
            };
            const newTransitionInWorkflow = {
                id: transitionId,
                type: 'GLOBAL',
                name: newTransitionName,
                description: '',
                actions: [],
                validators: [],
                triggers: [],
                properties: {},
                ...transitionData
            };
            // append newly created status and transition into workflow data
            workflow.statuses = [
                ...workflow.statuses,
                newStatusInWorkflow
            ];
            workflow.transitions = [
                ...workflow.transitions,
                newTransitionInWorkflow
            ];
            await validateAndUpdateWorkflowsV2({
                cloudId: cloudId,
                payload: {
                    payload: {
                        statuses: [
                            ...(0, $aUkev.mapStatusesToStatusUpdateObjects)(statuses),
                            newStatus
                        ],
                        workflows: [
                            (0, $aUkev.mapWorkflowToWorkflowUpdateObject)(workflow)
                        ]
                    },
                    validationOptions: {
                        levels: [
                            'ERROR'
                        ]
                    }
                }
            });
            onSuccess();
        }
    }, [
        fetchWorkflowsV2,
        validateAndUpdateWorkflowsV2
    ]);
    return {
        fetchWorkflowsV2: fetchWorkflowsV2,
        updateWorkflowsV2: updateWorkflowsV2,
        validateAndUpdateWorkflowsV2: validateAndUpdateWorkflowsV2,
        createWorkflowStatusV2: createWorkflowStatusV2,
        createWorkflowStatusforSingleWorkflow: createWorkflowStatusforSingleWorkflow
    };
};

});
const $d42d7eaad5678ab9$export$cc9aaebfeb8efe99 = 'NO_INBOUND_TRANSITIONS_TO_STATUS';
const $d42d7eaad5678ab9$export$fca543997a327d4c = 'NON_UNIQUE_STATUS_NAME';
const $d42d7eaad5678ab9$export$3bf8ed0d6cdbf43d = 'VERSION_CONFLICT';
const $d42d7eaad5678ab9$export$cd6873a2b9593ebe = 'OLD_STATUS_MISSING_IN_ORIGINAL_WORKFLOW';
const $d42d7eaad5678ab9$export$8f656a1a73ea2b22 = 'NEW_STATUS_IN_MAPPING_MISSING_IN_WORKFLOW';
const $d42d7eaad5678ab9$export$a9ac4cce67a0398e = 'ONLY_ONE_INITIAL_TRANSITION_ALLOWED';
const $d42d7eaad5678ab9$export$7e934b410e3f0768 = 'APPROVAL_RULE_MISCONFIGURED';

parcelRegister("8HJb0", function(module, exports) {

$parcel$export(module.exports, "StatusNameIsNotUniqueError", () => $bcc786fd9ecd4c00$export$364f122a770d50d5);
$parcel$export(module.exports, "StatusHasNoIncomingTransitionError", () => $bcc786fd9ecd4c00$export$f19cc85abf8e1b56);
$parcel$export(module.exports, "WorkflowVersionConflictError", () => $bcc786fd9ecd4c00$export$3bcae14a5d1b7831);
$parcel$export(module.exports, "OldStatusMissingInWorkflowError", () => $bcc786fd9ecd4c00$export$d019204849f5b18d);
$parcel$export(module.exports, "NewStatusMissingInWorkflowError", () => $bcc786fd9ecd4c00$export$a2f3292b51bfe008);
$parcel$export(module.exports, "OnlyOneInitialTransitionAllowedError", () => $bcc786fd9ecd4c00$export$2d54d539af595c13);
$parcel$export(module.exports, "ApprovalRuleMisconfiguredError", () => $bcc786fd9ecd4c00$export$abac4c6dd3226df);
/* eslint-disable max-classes-per-file */ class $bcc786fd9ecd4c00$export$364f122a770d50d5 extends Error {
    constructor(){
        super('status name is not unique');
        this.name = 'StatusNameIsNotUniqueError';
    }
}
class $bcc786fd9ecd4c00$export$f19cc85abf8e1b56 extends Error {
    constructor(){
        super('status has no incoming transition error');
        this.name = 'StatusHasNoIncomingTransitionError';
    }
}
class $bcc786fd9ecd4c00$export$3bcae14a5d1b7831 extends Error {
    constructor(){
        super('Workflow version and version token must match');
        this.name = 'WorkflowVersionConflictError';
    }
}
class $bcc786fd9ecd4c00$export$d019204849f5b18d extends Error {
    constructor(){
        super('Old status missing in workflow');
        this.name = 'OldStatusMissingInWorkflowError';
    }
}
class $bcc786fd9ecd4c00$export$a2f3292b51bfe008 extends Error {
    constructor(){
        super('New status missing in workflow');
        this.name = 'NewStatusMissingInWorkflowError';
    }
}
class $bcc786fd9ecd4c00$export$2d54d539af595c13 extends Error {
    constructor(){
        super('Workflow must have exactly one initial transition');
        this.name = 'OnlyOneInitialTransitionAllowedError';
    }
}
class $bcc786fd9ecd4c00$export$abac4c6dd3226df extends Error {
    constructor(){
        super('Approval status has invalid transitions');
        this.name = 'ApprovalRuleMisconfiguredError';
    }
}

});

parcelRegister("aUkev", function(module, exports) {

$parcel$export(module.exports, "mapStatusesToStatusUpdateObjects", () => $436d6da09aae1c2f$export$6ce728204936b996);
$parcel$export(module.exports, "mapWorkflowToWorkflowUpdateObject", () => $436d6da09aae1c2f$export$aab038e50114d198);
$parcel$export(module.exports, "removeWorkflowAssociatedWithSubtaskOnly", () => $436d6da09aae1c2f$export$404cd34180e60200);
$parcel$export(module.exports, "getUniqueTransitionId", () => $436d6da09aae1c2f$export$28172316ffe44a59);
const $436d6da09aae1c2f$export$6ce728204936b996 = (statuses)=>statuses.map((s)=>({
            id: s.id,
            name: s.name,
            description: s.description,
            statusReference: s.statusReference,
            statusCategory: s.statusCategory
        }));
const $436d6da09aae1c2f$export$aab038e50114d198 = (workflow)=>({
        id: workflow.id,
        version: workflow.version,
        description: workflow.description,
        statuses: workflow.statuses.map(({ deprecated: deprecated, ...status })=>status),
        transitions: workflow.transitions,
        startPointLayout: workflow.startPointLayout,
        statusMappings: workflow.statusMappings || []
    });
const $436d6da09aae1c2f$export$404cd34180e60200 = (workflowV2Response, subtaskIssueTypeId)=>{
    if (subtaskIssueTypeId == null) return workflowV2Response;
    const filteredWorkflows = workflowV2Response.workflows.filter((wf)=>// It checks if all workflow associations have only one issue type, and if that issue type is 'subtask'.
        // If this condition is met, it filters out the workflow.
        !wf.associatedWith.every((association)=>association.issueTypes.length === 1 && association.issueTypes[0] === subtaskIssueTypeId));
    // if no workflow specific for subtask, return original response
    if (filteredWorkflows.length === workflowV2Response.workflows.length) return workflowV2Response;
    return {
        ...workflowV2Response,
        workflows: filteredWorkflows
    };
};
const $436d6da09aae1c2f$export$28172316ffe44a59 = (transitions)=>{
    const largestId = Math.max(...transitions.map((t)=>parseInt(t.id, 10)));
    return String(largestId + 1);
};

});


parcelRegister("iONAM", function(module, exports) {

$parcel$export(module.exports, "getStatusActionFailedFlag", () => $4e9bfe43c468071f$export$eb1cd60884388450);
$parcel$export(module.exports, "failStatusExperience", () => $4e9bfe43c468071f$export$d258d7669afadfa1);
$parcel$export(module.exports, "IssueTypeIdNotFoundError", () => $4e9bfe43c468071f$export$8309ada8417b1e0b);

var $8HJb0 = parcelRequire("8HJb0");

var $7byHA = parcelRequire("7byHA");

var $JRB5w = parcelRequire("JRB5w");

var $eo17r = parcelRequire("eo17r");

var $9elEn = parcelRequire("9elEn");
const $4e9bfe43c468071f$var$GENERIC_SAVING_ERROR = 'There was an error saving the workflows';
const $4e9bfe43c468071f$var$excludedStatusCodes = new Set([
    401,
    403,
    404,
    409
]);
const $4e9bfe43c468071f$var$isFilteredNetworkError = (error)=>Boolean('statusCode' in error && error.statusCode != null && $4e9bfe43c468071f$var$excludedStatusCodes.has(error.statusCode) || error.message?.includes($4e9bfe43c468071f$var$GENERIC_SAVING_ERROR));
const $4e9bfe43c468071f$export$eb1cd60884388450 = ({ messageTitle: messageTitle, action: action, error: error, projectKey: projectKey, issueTypeIdNotSubtask: issueTypeIdNotSubtask, statusCode: statusCode })=>{
    const workflowEditorHref = issueTypeIdNotSubtask != null && issueTypeIdNotSubtask !== '' ? `/jira/core/projects/${projectKey}/settings/issuetypes/${issueTypeIdNotSubtask}/workflow` : `/jira/core/projects/${projectKey}/settings/issuetypes`;
    const openWorkflowEditorAction = {
        content: (0, $9elEn.default).openWorkflowEditorAction,
        href: workflowEditorHref,
        target: '_blank'
    };
    if (error instanceof (0, $8HJb0.StatusNameIsNotUniqueError)) return {
        type: 'error',
        title: messageTitle,
        description: (0, $9elEn.default).statusNameIsNotUniqueDescription,
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-status-name-is-not-unique.flag`)
    };
    if (error instanceof (0, $8HJb0.StatusHasNoIncomingTransitionError)) return {
        type: 'error',
        title: (0, $9elEn.default).statusHasNoIncomingTransitionTitle,
        description: (0, $9elEn.default).statusHasNoIncomingTransitionDescription,
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-status-has-no-incoming-transition.flag`)
    };
    if (error instanceof (0, $8HJb0.WorkflowVersionConflictError) || statusCode === 409) return {
        type: 'error',
        title: messageTitle,
        description: (0, $9elEn.default).workflowVersionConflictDescription,
        actions: [
            {
                content: (0, $9elEn.default).viewWorkflowEditorAction,
                href: workflowEditorHref,
                target: '_blank'
            }
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-workflow-version-conflict.flag`)
    };
    if (error instanceof (0, $8HJb0.OldStatusMissingInWorkflowError)) return {
        type: 'error',
        title: messageTitle,
        description: (0, $9elEn.default).oldStatusMissingInWorkflowDescription,
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-old-status-missing-in-workflow.flag`)
    };
    if (error instanceof (0, $8HJb0.NewStatusMissingInWorkflowError)) return {
        type: 'error',
        title: messageTitle,
        description: (0, $9elEn.default).newStatusMissingInWorkflowDescription,
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-new-status-missing-in-workflow.flag`)
    };
    if (error instanceof (0, $8HJb0.OnlyOneInitialTransitionAllowedError)) return {
        type: 'error',
        title: messageTitle,
        description: (0, $9elEn.default).oneInitialTransitionAllowedWorkflowDescription,
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-only-one-initial-transition-allowed.flag`)
    };
    if (error instanceof (0, $8HJb0.ApprovalRuleMisconfiguredError)) return {
        type: 'error',
        title: messageTitle,
        description: (0, $9elEn.default).approvalRuleMisconfiguredDescription,
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-approval-rule-misconfigured.flag`)
    };
    if (action === 'delete-polling') return {
        type: 'warning',
        title: messageTitle,
        description: (0, $9elEn.default).deletePollingTimeoutDescription,
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-timeout.flag`)
    };
    return {
        type: 'error',
        title: messageTitle,
        description: (0, $9elEn.default).errorFlagDescription,
        actions: [
            {
                content: (0, $9elEn.default).errorFlagActionsReload,
                onClick: ()=>{
                    typeof window !== 'undefined' && window.location.reload();
                },
                target: '_blank'
            },
            {
                content: (0, $9elEn.default).errorFlagActionsCheckStatus,
                href: 'https://jira-work-management.status.atlassian.com/',
                target: '_blank'
            }
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-column.flag`)
    };
};
const $4e9bfe43c468071f$export$d258d7669afadfa1 = ({ markExperienceFailed: markExperienceFailed, abortExperience: abortExperience, error: error, errorMessage: errorMessage })=>{
    if (error instanceof (0, $8HJb0.StatusNameIsNotUniqueError) || error instanceof (0, $8HJb0.StatusHasNoIncomingTransitionError) || error instanceof (0, $8HJb0.WorkflowVersionConflictError) || error instanceof (0, $8HJb0.OldStatusMissingInWorkflowError) || error instanceof (0, $8HJb0.NewStatusMissingInWorkflowError) || error instanceof (0, $8HJb0.OnlyOneInitialTransitionAllowedError) || error instanceof (0, $8HJb0.ApprovalRuleMisconfiguredError) || (0, $JRB5w.isClientFetchError)(error) || (0, $7byHA.isValidationError)(error) || $4e9bfe43c468071f$var$isFilteredNetworkError(error)) {
        abortExperience(errorMessage);
        return;
    }
    markExperienceFailed(errorMessage, error);
};
class $4e9bfe43c468071f$export$8309ada8417b1e0b extends Error {
    constructor(message){
        super(message);
        this.name = 'IssueTypeIdNotFoundError';
    }
}

});
parcelRegister("9elEn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb440c5d59115477$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fb440c5d59115477$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorFlagTitleAddColumn: {
        "id": "work-management-board.controllers.workflow-actions.error-flag-title-add-column",
        "defaultMessage": "Unable to create column"
    },
    errorFlagTitleDeleteColumn: {
        "id": "work-management-board.controllers.workflow-actions.error-flag-title-delete-column",
        "defaultMessage": "Unable to delete column"
    },
    errorFlagDescription: {
        "id": "work-management-board.controllers.workflow-actions.error-flag-description",
        "defaultMessage": "We\u2019ve run into some connection difficulties."
    },
    errorFlagActionsReload: {
        "id": "work-management-board.controllers.workflow-actions.error-flag-actions-reload",
        "defaultMessage": "Reload"
    },
    errorFlagActionsCheckStatus: {
        "id": "work-management-board.controllers.workflow-actions.error-flag-actions-check-status",
        "defaultMessage": "Check status page"
    },
    statusNameIsNotUniqueDescription: {
        "id": "work-management-board.controllers.workflow-actions.status-name-is-not-unique-description",
        "defaultMessage": "This status name has been used before. To use it again, open the workflow editor and create a status with the same name."
    },
    statusHasNoIncomingTransitionTitle: {
        "id": "work-management-board.controllers.workflow-actions.status-has-no-incoming-transition-title",
        "defaultMessage": "Action needed to delete column"
    },
    statusHasNoIncomingTransitionDescription: {
        "id": "work-management-board.controllers.workflow-actions.status-has-no-incoming-transition-description",
        "defaultMessage": "You need to remove the transitions linked to this status before you can delete it."
    },
    workflowVersionConflictDescription: {
        "id": "work-management-board.controllers.workflow-actions.workflow-version-conflict-description",
        "defaultMessage": "Other workflow updates are in progress. Check the workflow editor and make sure they are complete before making any changes."
    },
    openWorkflowEditorAction: {
        "id": "work-management-board.controllers.workflow-actions.open-workflow-editor-action",
        "defaultMessage": "Open workflow editor"
    },
    viewWorkflowEditorAction: {
        "id": "work-management-board.controllers.workflow-actions.view-workflow-editor-action",
        "defaultMessage": "View workflow editor"
    },
    deletePollingTimeoutTitle: {
        "id": "work-management-board.controllers.workflow-actions.delete-polling-timeout-title",
        "defaultMessage": "Your column is being deleted"
    },
    deletePollingTimeoutDescription: {
        "id": "work-management-board.controllers.workflow-actions.delete-polling-timeout-description",
        "defaultMessage": "Before you make other changes, check the workflow editor to make sure your column has been deleted."
    },
    oldStatusMissingInWorkflowDescription: {
        "id": "work-management-board.controllers.workflow-actions.old-status-missing-in-workflow-description",
        "defaultMessage": "The origin status is not in the current workflow. Check the workflow and try again."
    },
    newStatusMissingInWorkflowDescription: {
        "id": "work-management-board.controllers.workflow-actions.new-status-missing-in-workflow-description",
        "defaultMessage": "The target status is not in the current workflow. Check the workflow and try again."
    },
    oneInitialTransitionAllowedWorkflowDescription: {
        "id": "work-management-board.controllers.workflow-actions.one-initial-transition-allowed-workflow-description",
        "defaultMessage": "Workflow must have exactly one initial transition. Check the workflow and try again."
    },
    approvalRuleMisconfiguredDescription: {
        "id": "work-management-board.controllers.workflow-actions.approval-rule-misconfigured-description",
        "defaultMessage": "Approval status has invalid transitions. Check the workflow and try again."
    }
});

});


parcelRegister("9dl5u", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c373d0d171ab748$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0c373d0d171ab748$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    statusAlreadyExists: {
        "id": "work-management-board.controllers.workflow-actions.rename-column.status-already-exists",
        "defaultMessage": "''{statusName}'' is already a status name in this project"
    },
    emptyColumnNameError: {
        "id": "work-management-board.controllers.workflow-actions.rename-column.empty-column-name-error",
        "defaultMessage": "Status name cannot be empty"
    },
    errorFlagTitleRenameColumn: {
        "id": "work-management-board.controllers.workflow-actions.rename-column.error-flag-title-rename-column",
        "defaultMessage": "Unable to rename column"
    }
});

});


parcelRegister("2gjAV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a67dcc41910a901b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1vMd2 = parcelRequire("1vMd2");

var $iBeSy = parcelRequire("iBeSy");
var $8Vv3m = parcelRequire("8Vv3m");

var $jl1we = parcelRequire("jl1we");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $J8CSO = parcelRequire("J8CSO");
const $a67dcc41910a901b$var$DoneColumnTick = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iBeSy.default), {
        xcss: $a67dcc41910a901b$var$containerStyles,
        testId: "work-management-board.ui.board.column.column-header.header-content.done-column-tick"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $J8CSO.default).doneTickTooltipIssueTermRefresh : (0, $J8CSO.default).doneTickTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1vMd2))), {
        label: "",
        color: "var(--ds-icon-success, #22A06B)",
        LEGACY_size: "small"
    })));
};
var $a67dcc41910a901b$export$2e2bcd8739ae039 = $a67dcc41910a901b$var$DoneColumnTick;
const $a67dcc41910a901b$var$containerStyles = (0, $8Vv3m.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    lineHeight: 1
});

});
parcelRegister("1vMd2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::960f6ce03e4c8754204f0c1f72e1b16b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $119e1509285337bc$var$_react = $119e1509285337bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $119e1509285337bc$var$_checkMark = $119e1509285337bc$var$_interopRequireDefault((parcelRequire("754Ex")));

var $119e1509285337bc$var$_check = $119e1509285337bc$var$_interopRequireDefault((parcelRequire("8VBU9")));
function $119e1509285337bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $119e1509285337bc$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $119e1509285337bc$var$_react.default.createElement($119e1509285337bc$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $119e1509285337bc$var$_check.default
    }, props));
$119e1509285337bc$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $119e1509285337bc$var$_default = module.exports.default = $119e1509285337bc$var$CheckMarkIcon;

});
parcelRegister("754Ex", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $527c9bffe9af78c5$var$_react = $527c9bffe9af78c5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $527c9bffe9af78c5$var$_UNSAFE_baseNew = $527c9bffe9af78c5$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $527c9bffe9af78c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $527c9bffe9af78c5$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $527c9bffe9af78c5$var$_react.default.createElement($527c9bffe9af78c5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$527c9bffe9af78c5$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $527c9bffe9af78c5$var$_default = module.exports.default = $527c9bffe9af78c5$var$CheckMarkIcon;

});

parcelRegister("8VBU9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68010cb3d3545bb6$var$_react = $68010cb3d3545bb6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $68010cb3d3545bb6$var$_checkMark = $68010cb3d3545bb6$var$_interopRequireDefault((parcelRequire("754Ex")));
function $68010cb3d3545bb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $68010cb3d3545bb6$var$CheckIcon = (props)=>/*#__PURE__*/ $68010cb3d3545bb6$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $68010cb3d3545bb6$var$_checkMark.default
    }));
$68010cb3d3545bb6$var$CheckIcon.displayName = 'CheckIcon';
var $68010cb3d3545bb6$var$_default = module.exports.default = $68010cb3d3545bb6$var$CheckIcon;

});


parcelRegister("J8CSO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9885aa1384f8b46$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e9885aa1384f8b46$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    doneTickTooltip: {
        "id": "work-management-board.ui.board.column.column-header.header-content.done-column-tick.done-column-tick.done-tick-tooltip",
        "defaultMessage": "Issues moved to this column are marked as done"
    },
    doneTickTooltipIssueTermRefresh: {
        "id": "work-management-board.board.column.column-header.header-content.done-column-tick.done-tick-tooltip-issue-term-refresh",
        "defaultMessage": "Issues moved to this column are marked as done"
    }
});

});


parcelRegister("lN7up", function(module, exports) {

$parcel$export(module.exports, "default", () => $0db95f6962fb66d1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bEBof = parcelRequire("bEBof");

var $jIR8w = parcelRequire("jIR8w");

var $cfU5U = parcelRequire("cfU5U");

var $iSgqw = parcelRequire("iSgqw");


var $5GxEP = parcelRequire("5GxEP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $duBGk = parcelRequire("duBGk");
const $0db95f6962fb66d1$var$columnNameMaxLength = 30;
const $0db95f6962fb66d1$var$ERROR_MESSAGE_ID = 'column-name-error-dialog';
const $0db95f6962fb66d1$var$EditableColumnHeader = ({ defaultValue: defaultValue, isEditing: isEditing, onCancel: onCancel, onConfirm: onConfirm, onEdit: onEdit, onValidate: onValidate, readView: readView })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isReadyRef = (0, $eUqFw.useRef)(false);
    const renameTextFieldRef = (0, $eUqFw.useRef)(null);
    // sets component to be ready after 10 ms and
    // focus on Textfield when editing
    (0, $eUqFw.useEffect)(()=>{
        if (isEditing) setTimeout(()=>{
            isReadyRef.current = true;
            renameTextFieldRef.current?.focus();
        }, 10);
        else isReadyRef.current = false;
    }, [
        isEditing
    ]);
    const handleConfirm = (0, $eUqFw.useCallback)((value)=>{
        if (isReadyRef.current) onConfirm(value);
    }, [
        onConfirm
    ]);
    const columnNameButtonLabel = formatMessage((0, $duBGk.default).columnNameButtonLabel, {
        statusName: defaultValue
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0db95f6962fb66d1$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cfU5U.default), {
        readViewFitContainerWidth: true,
        defaultValue: defaultValue,
        isEditing: isEditing,
        readView: readView,
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jIR8w.default), {
                isOpen: fieldProps.isInvalid,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    id: $0db95f6962fb66d1$var$ERROR_MESSAGE_ID,
                    role: "alert",
                    "aria-live": "assertive"
                }, errorMessage),
                placement: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iSgqw.default), {
                ...fieldProps,
                ref: renameTextFieldRef,
                elemAfterInput: fieldProps.isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bEBof))), {
                    label: "error",
                    primaryColor: `var(--ds-icon-warning, ${(0, $1b343b038f6c23ec$exports).Y400})`
                }),
                onBlur: ()=>{
                    if (fieldProps.isInvalid) onCancel();
                },
                maxLength: $0db95f6962fb66d1$var$columnNameMaxLength,
                autoComplete: "off",
                "aria-errormessage": $0db95f6962fb66d1$var$ERROR_MESSAGE_ID,
                "aria-label": columnNameButtonLabel
            })),
        onEdit: onEdit,
        onCancel: onCancel,
        onConfirm: handleConfirm,
        validate: onValidate,
        editButtonLabel: columnNameButtonLabel
    }));
};
const $0db95f6962fb66d1$var$EditableColumnHeaderWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.jira-business.board.editable-column-header",
        packageName: "jiraWorkManagementBoard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0db95f6962fb66d1$var$EditableColumnHeader, props)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0db95f6962fb66d1$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9idpf _18u01i6y _2hwx1i6y",
            __cmplp.className
        ])
    });
});
var $0db95f6962fb66d1$export$2e2bcd8739ae039 = $0db95f6962fb66d1$var$EditableColumnHeaderWithErrorBoundary;

});
parcelRegister("cfU5U", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5dfd74fbffa6b4f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $iiktD = parcelRequire("iiktD");

var $kjf2q = parcelRequire("kjf2q");

var $kXuXp = parcelRequire("kXuXp");

var $gYrJM = parcelRequire("gYrJM");

var $1jsQJ = parcelRequire("1jsQJ");

var $hVx5a = parcelRequire("hVx5a");

var $bUp0K = parcelRequire("bUp0K");

var $bSz51 = parcelRequire("bSz51");

var $jokIk = parcelRequire("jokIk");
function $a5dfd74fbffa6b4f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a5dfd74fbffa6b4f$var$fieldStyles = {
    name: "nziz0a",
    styles: "max-width:100%;position:relative"
};
const $a5dfd74fbffa6b4f$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $a5dfd74fbffa6b4f$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $eUqFw.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $eUqFw.useState)(startWithEditViewOpen);
    const timerRef = (0, $eUqFw.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $bSz51.default)(isEditing, isEditingState);
    const onCancel = (0, $eUqFw.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $eUqFw.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $iiktD.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$a5dfd74fbffa6b4f$var$analyticsAttributes
    });
    const onCancelClick = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $eUqFw.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]);
    /**
   * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
   *  confirms the value, if the focus is not transferred to the action buttons.
   *
   *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
   *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
   *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
   *  `autoSubmitWhenBlur`.
   *
   *  There are two paths here the function can be triggered:
   *
   *  - focus on input first, and then use keyboard to `submit`
   *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
   */ const onEditViewWrapperBlur = (0, $eUqFw.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]);
    /**
   * Gets called when focus is transferred to the editView, or action buttons.
   *
   * There are three paths here the function can be called:
   *
   * - when a user click the `editView`
   * - when a user use keyboard to tab into `editView`
   * - when a user use keyboard to tab into `submit` when they were on input field.
   */ const onEditViewWrapperFocus = (0, $eUqFw.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jokIk.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kXuXp.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit)
    }, ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $byn9U.jsx)("form", {
            /**
     * It is not normally acceptable to add key handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * to add support for keyboard functionality instead of creating an inaccessible
     * custom element, we can add role="presentation" so that there is no negative
     * impacts to assistive technologies.
     */ role: "presentation",
            onKeyDown: (e)=>{
                onKeyDown(e);
                if (e.key === 'Esc' || e.key === 'Escape') {
                    if ((0, $gYrJM.fg)('platform-design-system-inline-edit-reset-on-escape')) reset();
                    onCancel();
                }
            },
            onSubmit: onSubmit,
            ref: formRef
        }, shouldBeEditing ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $kjf2q.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: defaultValue,
            validate: validate,
            isRequired: isRequired,
            key: "edit-view" // used for reset to default value
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: $a5dfd74fbffa6b4f$var$fieldStyles,
                onBlur: (e)=>{
                    if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                },
                onFocus: onEditViewWrapperFocus
            }, editView({
                ...fieldProps,
                errorMessage: error
            }, editViewRef), !hideActionButtons ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $bUp0K.default), {
                testId: testId,
                cancelButtonLabel: cancelButtonLabel,
                confirmButtonLabel: confirmButtonLabel,
                onMouseDown: ()=>{
                    /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                },
                onCancelClick: (e)=>{
                    reset();
                    onCancelClick(e);
                }
            }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $byn9U.jsx)((0, $1jsQJ.default), {
                hidden: true,
                type: "submit"
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hVx5a.default), null, "Submit")))) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $byn9U.jsx)((0, $kjf2q.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: "",
            isRequired: isRequired,
            key: "read-view" // used for reset to default value
        }, renderReadView)));
};
const $a5dfd74fbffa6b4f$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $byn9U.jsx)($a5dfd74fbffa6b4f$var$InnerInlineEdit, props);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a5dfd74fbffa6b4f$export$2e2bcd8739ae039 = $a5dfd74fbffa6b4f$var$InlineEdit;

});
parcelRegister("kjf2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $50137fc5c4153c86$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");
parcelRequire("8ynlC");

var $ac4Xm = parcelRequire("ac4Xm");

var $kXuXp = parcelRequire("kXuXp");

var $5daQk = parcelRequire("5daQk");

var $9wJ3k = parcelRequire("9wJ3k");

var $2fFJv = parcelRequire("2fFJv");
function $50137fc5c4153c86$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $50137fc5c4153c86$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $50137fc5c4153c86$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $50137fc5c4153c86$var$isFunction(x) {
    return typeof x === 'function';
}
function $50137fc5c4153c86$var$usePreviousRef(current) {
    const ref = (0, $eUqFw.useRef)(current);
    // will be updated on the next render
    (0, $eUqFw.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $50137fc5c4153c86$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $50137fc5c4153c86$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eUqFw.useContext)((0, $kXuXp.FormContext));
    const isDisabled = (0, $eUqFw.useContext)((0, $kXuXp.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $50137fc5c4153c86$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $50137fc5c4153c86$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$50137fc5c4153c86$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eUqFw.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explictly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $50137fc5c4153c86$var$usePreviousRef(state);
    (0, $eUqFw.useEffect)(()=>{
        typeof $2fFJv;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $50137fc5c4153c86$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($50137fc5c4153c86$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const fieldId = (0, $eUqFw.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    ()=>props.id ? props.id : `${props.name}-${(0, $tkrFt.uid)({
            id: props.name
        })}`, [
        props.id,
        props.name
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $50137fc5c4153c86$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $5daQk.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $9wJ3k.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $byn9U.jsx)((0, $ac4Xm.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("ac4Xm", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $a5ebb4ca1f8f209f$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $a5ebb4ca1f8f209f$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});

parcelRegister("kXuXp", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $fe0d14c455a1a3a5$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $fe0d14c455a1a3a5$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $fe0d14c455a1a3a5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DX5R = parcelRequire("3DX5R");

var $519wV = parcelRequire("519wV");

var $a0i0f = parcelRequire("a0i0f");
const $fe0d14c455a1a3a5$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $fe0d14c455a1a3a5$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $fe0d14c455a1a3a5$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eUqFw.useRef)(null);
    const onSubmitRef = (0, $eUqFw.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eUqFw.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $3DX5R.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $519wV.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eUqFw.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eUqFw.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eUqFw.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eUqFw.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fe0d14c455a1a3a5$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fe0d14c455a1a3a5$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("3DX5R", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $2a72da5b7ec16659$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $2a72da5b7ec16659$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $2a72da5b7ec16659$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $2a72da5b7ec16659$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $2a72da5b7ec16659$export$f681a8129d2e9d28);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");
//      
var $2a72da5b7ec16659$var$charCodeOfDot = ".".charCodeAt(0);
var $2a72da5b7ec16659$var$reEscapeChar = /\\(\\)?/g;
var $2a72da5b7ec16659$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2a72da5b7ec16659$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $2a72da5b7ec16659$var$charCodeOfDot) result.push("");
    string.replace($2a72da5b7ec16659$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($2a72da5b7ec16659$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $2a72da5b7ec16659$var$keysCache = {};
var $2a72da5b7ec16659$var$keysRegex = /[.[\]]+/;
var $2a72da5b7ec16659$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($2a72da5b7ec16659$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $2a72da5b7ec16659$var$keysCache[key] = key.split($2a72da5b7ec16659$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $2a72da5b7ec16659$var$keysCache[key] = $2a72da5b7ec16659$var$stringToPath(key);
    }
    return $2a72da5b7ec16659$var$keysCache[key];
};
//      
var $2a72da5b7ec16659$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $2a72da5b7ec16659$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $2a72da5b7ec16659$var$_toPropertyKey(arg) {
    var key = $2a72da5b7ec16659$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2a72da5b7ec16659$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2a72da5b7ec16659$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $6XgOP.default)(current, [
                key
            ].map($2a72da5b7ec16659$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kU09D.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $2a72da5b7ec16659$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $2a72da5b7ec16659$var$setInRecursor(state, 0, $2a72da5b7ec16659$var$toPath(key), value1, destroyArrays);
};
var $2a72da5b7ec16659$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $2a72da5b7ec16659$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $2a72da5b7ec16659$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(values, name);
    var error = $2a72da5b7ec16659$export$c52e5867d5879e24(errors, name);
    if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) error = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
    var submitError = submitErrors && $2a72da5b7ec16659$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $2a72da5b7ec16659$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $2a72da5b7ec16659$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $2a72da5b7ec16659$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $2a72da5b7ec16659$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$2a72da5b7ec16659$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $2a72da5b7ec16659$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $2a72da5b7ec16659$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$41e855cb628c1b55, $2a72da5b7ec16659$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $2a72da5b7ec16659$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $2a72da5b7ec16659$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3, $2a72da5b7ec16659$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $2a72da5b7ec16659$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$2a72da5b7ec16659$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $2a72da5b7ec16659$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $2a72da5b7ec16659$export$83d89fbfd8236492 = "4.20.10";
var $2a72da5b7ec16659$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $2a72da5b7ec16659$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $2a72da5b7ec16659$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $2a72da5b7ec16659$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $2a72da5b7ec16659$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $2a72da5b7ec16659$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $2a72da5b7ec16659$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $2a72da5b7ec16659$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kU09D.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kU09D.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kU09D.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kU09D.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kU09D.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $2a72da5b7ec16659$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $2a72da5b7ec16659$export$e6bdf135a54e021b,
                    shallowEqual: $2a72da5b7ec16659$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kU09D.default)({}, state.formState.values)); // clone to avoid writing
            if ($2a72da5b7ec16659$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $2a72da5b7ec16659$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $2a72da5b7ec16659$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kU09D.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $2a72da5b7ec16659$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) {
                    var existing = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$2a72da5b7ec16659$export$735bebc8ffabf28a] = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
                    merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$2a72da5b7ec16659$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $2a72da5b7ec16659$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $2a72da5b7ec16659$var$notify(fieldSubscriber, fieldState, lastFieldState, $2a72da5b7ec16659$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $2a72da5b7ec16659$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$2a72da5b7ec16659$var$hasAnyError(formState.errors) && !(formState.submitErrors && $2a72da5b7ec16659$var$hasAnyError(formState.submitErrors));
        var nextFormState = $2a72da5b7ec16659$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $2a72da5b7ec16659$var$notify(state.subscribers, nextFormState, lastFormState, $2a72da5b7ec16659$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kU09D.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kU09D.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kU09D.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $2a72da5b7ec16659$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $2a72da5b7ec16659$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $2a72da5b7ec16659$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $2a72da5b7ec16659$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $2a72da5b7ec16659$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $2a72da5b7ec16659$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $2a72da5b7ec16659$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("519wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a747034649a7960$export$2e2bcd8739ae039);

var $3DX5R = parcelRequire("3DX5R");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3a747034649a7960$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3a747034649a7960$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3a747034649a7960$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $3DX5R.getIn)(errors, input.name);
    });
};
//      
var $3a747034649a7960$var$noop = function noop() {};
var $3a747034649a7960$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3a747034649a7960$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3a747034649a7960$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3a747034649a7960$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3a747034649a7960$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3a747034649a7960$export$2e2bcd8739ae039 = $3a747034649a7960$var$createDecorator;

});

parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("5daQk", function(module, exports) {

$parcel$export(module.exports, "Label", () => $405fa8c1002455c3$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $405fa8c1002455c3$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $405fa8c1002455c3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $405fa8c1002455c3$var$fieldsetLabelStyles = {
    name: "zjewl9",
    styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $405fa8c1002455c3$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: $405fa8c1002455c3$var$fieldsetLabelStyles,
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $405fa8c1002455c3$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: $405fa8c1002455c3$var$fieldsetLabelStyles
    }, children);
};
var $405fa8c1002455c3$export$2e2bcd8739ae039 = $405fa8c1002455c3$export$b04be29aa201d4f5;

});

parcelRegister("9wJ3k", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ae89c844a0b0c9b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $4ae89c844a0b0c9b$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $1b343b038f6c23ec$export$2010d0fb4295b346)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $4ae89c844a0b0c9b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $4ae89c844a0b0c9b$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("bUp0K", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a38d43ab7d59695$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
                                                                                                                                      * @jsxRuntime classic
                                                                                                                                      * @jsx jsx
                                                                                                                                      */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $kRXDJ = parcelRequire("kRXDJ");

var $8VBU9 = parcelRequire("8VBU9");

var $clplI = parcelRequire("clplI");

function $5a38d43ab7d59695$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5a38d43ab7d59695$var$buttonsContainerStyles = {
    name: "ki22df",
    styles: "display:flex;position:absolute;flex-shrink:0;inset-block-start:100%;inset-inline-end:0;margin-block-start:var(--ds-space-075, 6px)"
};
const $5a38d43ab7d59695$var$buttonWrapperBaseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    width: "var(--ds-space-400, 32px)",
    zIndex: 200,
    backgroundColor: `var(--ds-surface-overlay, ${(0, $1b343b038f6c23ec$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $1b343b038f6c23ec$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $1b343b038f6c23ec$export$d2d3bedfb276cac0)}`})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:last-child': {
        marginInlineStart: "var(--ds-space-050, 4px)"
    },
    '& > button': {
        backgroundColor: `var(--ds-surface-overlay, ${(0, $1b343b038f6c23ec$export$8d43898f60b96a82)})`
    },
    '& > button:hover': {
        backgroundColor: `var(--ds-surface-overlay-hovered, ${(0, $1b343b038f6c23ec$export$920c0d5c49070351)})`
    },
    '& > button:active': {
        backgroundColor: "var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6))",
        color: `var(--ds-text, ${(0, $1b343b038f6c23ec$export$b3de0ae08da2ce64)})`
    }
});
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Buttons__
 *
 * A buttons {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $5a38d43ab7d59695$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $5a38d43ab7d59695$var$buttonsContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $5a38d43ab7d59695$var$buttonWrapperBaseStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kRXDJ.default), {
        type: "submit",
        icon: (iconProps)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8VBU9))), {
                ...iconProps,
                size: "small"
            }),
        onMouseDown: onMouseDown,
        label: confirmButtonLabel,
        testId: testId && `${testId}--confirm`
    })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $5a38d43ab7d59695$var$buttonWrapperBaseStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kRXDJ.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($clplI))), {
                ...iconProps,
                size: "small"
            }),
        label: cancelButtonLabel,
        onClick: onCancelClick,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}--cancel`
    })));
};
var $5a38d43ab7d59695$export$2e2bcd8739ae039 = $5a38d43ab7d59695$var$Buttons;

});

parcelRegister("bSz51", function(module, exports) {

$parcel$export(module.exports, "default", () => $800c5d850cf7be04$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $800c5d850cf7be04$var$usePrevious = (value)=>{
    const ref = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $800c5d850cf7be04$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $eUqFw.useRef)(null);
    const editViewRef = (0, $eUqFw.useRef)();
    const preventFocusOnEditButtonRef = (0, $eUqFw.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $800c5d850cf7be04$var$usePrevious(shouldBeEditing);
    (0, $eUqFw.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $800c5d850cf7be04$export$2e2bcd8739ae039 = $800c5d850cf7be04$var$useButtonFocusHook;

});

parcelRegister("jokIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $824ecafb10b35862$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1jsQJ = parcelRequire("1jsQJ");
var $8Vv3m = parcelRequire("8Vv3m");

function $824ecafb10b35862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $824ecafb10b35862$var$readViewContainerStyles = {
    name: "1xe63ku",
    styles: "line-height:1"
};
const $824ecafb10b35862$var$editButtonStyles = (0, $8Vv3m.xcss)({
    display: 'block',
    margin: 'space.0',
    padding: 'space.0',
    appearance: 'none',
    background: 'transparent',
    border: 0,
    lineHeight: 1,
    outline: 0,
    ':focus-visible': {
        outline: 0
    },
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ':focus + div': {
        borderColor: 'color.border.focused',
        borderWidth: 'border.width.outline',
        borderStyle: 'solid'
    }
});
const $824ecafb10b35862$var$readViewWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    border: '2px solid transparent',
    borderRadius: "var(--ds-border-radius, 3px)",
    transition: 'background 0.2s',
    '&:hover': {
        background: `var(--ds-background-neutral-subtle-hovered, ${(0, $1b343b038f6c23ec$export$3e51e8f1440314ba)})`
    }
});
const $824ecafb10b35862$var$readViewFitContainerWidthStyles = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $824ecafb10b35862$var$DRAG_THRESHOLD = 5;
const $824ecafb10b35862$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $eUqFw.useRef)(0);
    const startY = (0, $eUqFw.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $824ecafb10b35862$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $824ecafb10b35862$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /**
     * If a link is clicked in the read view, default action should be taken
     */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $824ecafb10b35862$var$readViewContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1jsQJ.default), {
        xcss: $824ecafb10b35862$var$editButtonStyles,
        onClick: onEditRequested,
        ref: editButtonRef,
        testId: testId && `${testId}--edit-button`,
        "aria-label": editButtonLabel
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $824ecafb10b35862$var$readViewWrapperStyles,
            readViewFitContainerWidth && $824ecafb10b35862$var$readViewFitContainerWidthStyles
        ],
        /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
        onClick: onReadViewClick,
        onMouseDown: (e)=>{
            startX.current = e.clientX;
            startY.current = e.clientY;
        },
        "data-read-view-fit-container-width": readViewFitContainerWidth
    }, readView()));
};
var $824ecafb10b35862$export$2e2bcd8739ae039 = $824ecafb10b35862$var$ReadView;

});


parcelRegister("iSgqw", function(module, exports) {

$parcel$export(module.exports, "default", () => $82c9623a5869bb9a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $iiktD = parcelRequire("iiktD");

var $6tn9L = parcelRequire("6tn9L");
const $82c9623a5869bb9a$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $82c9623a5869bb9a$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $iiktD.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$82c9623a5869bb9a$var$analyticsParams
    });
    const handleOnBlur = (0, $iiktD.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$82c9623a5869bb9a$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $6tn9L.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $6tn9L.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $82c9623a5869bb9a$export$2e2bcd8739ae039 = $82c9623a5869bb9a$var$Textfield;

});
parcelRegister("6tn9L", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $516a227838e26b1c$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $516a227838e26b1c$export$3eeb47dc8e6249d9);

const $516a227838e26b1c$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $1b343b038f6c23ec$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $516a227838e26b1c$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $1b343b038f6c23ec$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $1b343b038f6c23ec$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $516a227838e26b1c$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $1b343b038f6c23ec$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $1b343b038f6c23ec$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $516a227838e26b1c$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $1b343b038f6c23ec$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $516a227838e26b1c$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $1b343b038f6c23ec$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $1b343b038f6c23ec$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $516a227838e26b1c$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $1b343b038f6c23ec$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $516a227838e26b1c$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $516a227838e26b1c$var$backgroundColor[appearance],
        borderColor: $516a227838e26b1c$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $1b343b038f6c23ec$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $516a227838e26b1c$var$backgroundColorHover[appearance],
            borderColor: $516a227838e26b1c$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $516a227838e26b1c$var$backgroundColorFocus[appearance],
            borderColor: $516a227838e26b1c$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$516a227838e26b1c$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $1b343b038f6c23ec$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $1b343b038f6c23ec$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $1b343b038f6c23ec$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $1b343b038f6c23ec$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $1b343b038f6c23ec$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $1b343b038f6c23ec$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $1b343b038f6c23ec$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $516a227838e26b1c$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $516a227838e26b1c$var$getMaxWidth = (width)=>!width ? `100%` : width in $516a227838e26b1c$var$widthMap ? $516a227838e26b1c$var$widthMap[width] : +width;
const $516a227838e26b1c$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$516a227838e26b1c$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $516a227838e26b1c$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $516a227838e26b1c$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $1b343b038f6c23ec$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("duBGk", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a46d3d6a0ddafd8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7a46d3d6a0ddafd8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    columnNameButtonLabel: {
        "id": "work-management-board.board.column.column-header.header-content.editable-column-header.column-name-button-label",
        "defaultMessage": "Edit {statusName} status column"
    }
});

});


parcelRegister("1Pyi6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c18b2e6016fc872$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iwbBD = parcelRequire("iwbBD");

var $8rQuz = parcelRequire("8rQuz");
const $9c18b2e6016fc872$var$IssueCount = ({ isCollapsed: isCollapsed, issueCount: issueCount })=>(0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9c18b2e6016fc872$var$BadgeContainer, {
        isVerticalWritingMode: isCollapsed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iwbBD.default), {
        appearance: "default"
    }, issueCount)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9c18b2e6016fc872$var$Counter, {
        isVerticalWritingMode: isCollapsed
    }, issueCount);
var $9c18b2e6016fc872$export$2e2bcd8739ae039 = $9c18b2e6016fc872$var$IssueCount;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9c18b2e6016fc872$var$Counter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVerticalWritingMode: isVerticalWritingMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.isVerticalWritingMode && "_1lfclhck",
            __cmplp.className
        ])
    });
});
const $9c18b2e6016fc872$var$BadgeContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVerticalWritingMode: isVerticalWritingMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.isVerticalWritingMode && "_1lfclhck",
            __cmplp.isVerticalWritingMode && "_x1m21crf",
            __cmplp.isVerticalWritingMode && "_1lg71tcg",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3cUPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c566e2e6d8db04e3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c566e2e6d8db04e3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noAssignee: {
        "id": "work-management-board.board.column.column-header.header-content.no-assignee",
        "defaultMessage": "Unassigned"
    },
    noPriority: {
        "id": "work-management-board.board.column.column-header.header-content.no-priority",
        "defaultMessage": "Unprioritized"
    },
    noCategory: {
        "id": "work-management-board.board.column.column-header.header-content.no-category",
        "defaultMessage": "Uncategorized"
    }
});

});


parcelRegister("1VNWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f158fdcc9bc00806$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7YElh = parcelRequire("7YElh");

var $kRXDJ = parcelRequire("kRXDJ");

var $f5xzw = parcelRequire("f5xzw");
var $5E6sS = parcelRequire("5E6sS");
var $e0IEe = parcelRequire("e0IEe");

var $k0Oqq = parcelRequire("k0Oqq");

var $f9U0l = parcelRequire("f9U0l");

var $6X8a0 = parcelRequire("6X8a0");

var $k2V1M = parcelRequire("k2V1M");

var $jl1we = parcelRequire("jl1we");

var $7eqzD = parcelRequire("7eqzD");

var $kQAZu = parcelRequire("kQAZu");

var $5GxEP = parcelRequire("5GxEP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $8rQuz = parcelRequire("8rQuz");

var $4VjPN = parcelRequire("4VjPN");

var $eUIOu = parcelRequire("eUIOu");

var $4Z5qC = parcelRequire("4Z5qC");

var $gKXju = parcelRequire("gKXju");

var $cgK6s = parcelRequire("cgK6s");

var $cdPA8 = parcelRequire("cdPA8");

var $77aEt = parcelRequire("77aEt");
const $f158fdcc9bc00806$var$HeaderDropdown = ({ hasExceededMaxIssueTypes: hasExceededMaxIssueTypes, hasMultipleWorkflows: hasMultipleWorkflows, isLoading: isLoading, onRenameClick: onRenameClick, columnName: columnName })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $eUqFw.useState)(false);
    const isWorkflowOperationInProgress = (0, $cgK6s.useIsWorkflowOperationInProgress)();
    const project = (0, $kQAZu.useProject)();
    const canAdministerProject = project.permissions.administerProject;
    const actionsDisabled = !canAdministerProject || hasMultipleWorkflows === true || hasExceededMaxIssueTypes === true || isWorkflowOperationInProgress;
    const groups = (0, $gKXju.useGroups)();
    const onlyOneColumnLeft = groups.length <= 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f5xzw.default), {
        testId: "work-management-board.ui.board.column.column-header.header-dropdown.header-dropdown-menu",
        trigger: ({ triggerRef: triggerRef, ...props })=>(0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRXDJ.default), {
                ...props,
                label: "",
                isLoading: isLoading,
                appearance: "subtle",
                testId: "work-management-board.ui.board.column.column-header.header-dropdown.more-button",
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k0Oqq))), {
                        ...iconProps,
                        label: formatMessage((0, $77aEt.default).columnActionsWithColumn, {
                            columnName: columnName
                        }),
                        color: "var(--ds-icon, #44546F)"
                    }),
                ref: triggerRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f158fdcc9bc00806$var$StyledButton, {
                ...props,
                isLoading: isLoading,
                appearance: "subtle",
                testId: "work-management-board.ui.board.column.column-header.header-dropdown.more-button",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k0Oqq))), {
                    label: formatMessage((0, $77aEt.default).columnActionsWithColumn, {
                        columnName: columnName
                    }),
                    color: "var(--ds-icon, #44546F)"
                }),
                ref: triggerRef
            }),
        onOpenChange: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jwmBoardColumnMoreButton', {
                columnMoreActionsDisabled: actionsDisabled
            });
        },
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e0IEe.default), {
        title: formatMessage((0, $77aEt.default).dropdownHeaderTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        elemBefore: (0, $8rQuz.isVisualRefreshEnabled)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f9U0l))), {
            size: "small",
            label: ""
        }),
        onClick: ()=>{
            onRenameClick();
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'jwmBoardColumnRenameDropdownItem');
        },
        isDisabled: actionsDisabled
    }, formatMessage((0, $77aEt.default).rename)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eqzD.ConditionalWrapper), {
        condition: onlyOneColumnLeft,
        renderWrapper: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
                content: formatMessage((0, $77aEt.default).deleteDisabledTooltip)
            }, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        testId: "work-management-board.ui.board.column.column-header.header-dropdown.delete-dropdown",
        isDisabled: onlyOneColumnLeft || actionsDisabled,
        elemBefore: (0, $8rQuz.isVisualRefreshEnabled)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6X8a0))), {
            size: "small",
            label: ""
        }),
        onClick: ()=>{
            setIsDeleteModalOpen(true);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'jwmBoardColumnDeleteDropdownItem');
        }
    }, formatMessage((0, $77aEt.default).delete))), hasExceededMaxIssueTypes === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f158fdcc9bc00806$var$DropdownMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUIOu.OpenProjectSettingsExceededIssueTypes), null)), hasMultipleWorkflows === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f158fdcc9bc00806$var$DropdownMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Z5qC.OpenProjectSettingsMultipleWorkflows), null)), !canAdministerProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f158fdcc9bc00806$var$DropdownMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4VjPN.ContactAdminToModifyBoardMessage), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k2V1M.default), null, isDeleteModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdPA8.default), {
        onClose: ()=>setIsDeleteModalOpen(false)
    })));
};
const $f158fdcc9bc00806$var$HeaderDropdownWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "jira-business.board.header-dropdown",
        packageName: "jiraWorkManagementBoard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f158fdcc9bc00806$var$HeaderDropdown, props));
var $f158fdcc9bc00806$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f158fdcc9bc00806$var$HeaderDropdownWithErrorBoundary;
const $f158fdcc9bc00806$var$DropdownMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41bs6 _p12fuuw1 _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f158fdcc9bc00806$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7YElh.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5E6sS", function(module, exports) {

$parcel$export(module.exports, "default", () => $35ac3c3a7e824635$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5bNY = parcelRequire("b5bNY");

var $azeZS = parcelRequire("azeZS");

var $hFzXe = parcelRequire("hFzXe");

var $iCgyP = parcelRequire("iCgyP");

var $gYrJM = parcelRequire("gYrJM");

var $lKNwt = parcelRequire("lKNwt");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $35ac3c3a7e824635$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
    const itemRef = (0, $lKNwt.default)();
    const handleItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFzXe.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $b5bNY.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $gYrJM.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iCgyP.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $b5bNY.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...(0, $gYrJM.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azeZS.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $b5bNY.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $gYrJM.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
});
var $35ac3c3a7e824635$export$2e2bcd8739ae039 = $35ac3c3a7e824635$var$DropdownMenuItem;

});

parcelRegister("e0IEe", function(module, exports) {

$parcel$export(module.exports, "default", () => $3df5a6f567feefa8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2Pede = parcelRequire("2Pede");

var $cUyTA = parcelRequire("cUyTA");

var $f8stz = parcelRequire("f8stz");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $3df5a6f567feefa8$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $2Pede.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cUyTA.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8stz.default), {
        id: titleId,
        title: title
    }), children);
});
var $3df5a6f567feefa8$export$2e2bcd8739ae039 = $3df5a6f567feefa8$var$DropdownMenuItemGroup;

});

parcelRegister("f9U0l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b093239d1e44ea41$var$_react = $b093239d1e44ea41$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $b093239d1e44ea41$var$_textStyle = $b093239d1e44ea41$var$_interopRequireDefault((parcelRequire("jbBmm")));
function $b093239d1e44ea41$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b093239d1e44ea41$var$EmojiKeyboardIcon = (props)=>/*#__PURE__*/ $b093239d1e44ea41$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m5.84 6.95-3.82 9.97a.5.5 0 0 0 .47.68H3.7a.5.5 0 0 0 .47-.33l.68-1.88a.5.5 0 0 1 .47-.33h3.8a.5.5 0 0 1 .47.33l.68 1.88a.5.5 0 0 0 .47.33h1.27a.5.5 0 0 0 .47-.68L8.69 6.95a.7.7 0 0 0-.66-.45H6.49a.7.7 0 0 0-.65.45m1.57 2.46 1.25 3.41a.2.2 0 0 1-.19.27h-2.5a.2.2 0 0 1-.19-.27l1.25-3.41a.2.2 0 0 1 .38 0m10.14 6.46c1.22 0 2.14-1.01 2.14-2.6s-.9-2.53-2.14-2.53c-1.26 0-2.18.94-2.18 2.53 0 1.58.9 2.6 2.18 2.6m2.16.6c-.37.83-1.28 1.43-2.44 1.43-2.57 0-4.27-2-4.27-4.64 0-2.55 1.66-4.57 4.2-4.57 1.56 0 2.28.83 2.5 1.33v-.34c0-.25.01-.39.21-.58q.21-.18.62-.16h.76a.58.58 0 0 1 .5.17c.21.2.19.42.19.58v6.39q0 .34.02.9 0 .29-.12.43a.63.63 0 0 1-.51.24h-.93c-.19 0-.45-.08-.53-.18s-.16-.23-.18-.53a6 6 0 0 1-.01-.36z"/></svg>`
    }, props, {
        newIcon: $b093239d1e44ea41$var$_textStyle.default
    }));
$b093239d1e44ea41$var$EmojiKeyboardIcon.displayName = 'EmojiKeyboardIcon';
var $b093239d1e44ea41$var$_default = module.exports.default = $b093239d1e44ea41$var$EmojiKeyboardIcon;

});
parcelRegister("jbBmm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a635132cbd4f8834b11949e59ab0155>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df7c063c80f88bb8$var$_react = $df7c063c80f88bb8$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $df7c063c80f88bb8$var$_UNSAFE_baseNew = $df7c063c80f88bb8$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $df7c063c80f88bb8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "TextStyle".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for text styles in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $df7c063c80f88bb8$var$TextStyleIcon = (props)=>/*#__PURE__*/ $df7c063c80f88bb8$var$_react.default.createElement($df7c063c80f88bb8$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.75 11v-.375L5.032 7.25M12.25 11v-.375L10.974 7.25m0 0L8.518.75H7.5l-2.468 6.5m5.942 0H5.032"/>`
    }, props));
$df7c063c80f88bb8$var$TextStyleIcon.displayName = 'TextStyleIcon';
var $df7c063c80f88bb8$var$_default = module.exports.default = $df7c063c80f88bb8$var$TextStyleIcon;

});


parcelRegister("6X8a0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50fe95406fafb11c$var$_react = $50fe95406fafb11c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $50fe95406fafb11c$var$_delete = $50fe95406fafb11c$var$_interopRequireDefault((parcelRequire("eLURR")));
function $50fe95406fafb11c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $50fe95406fafb11c$var$TrashIcon = (props)=>/*#__PURE__*/ $50fe95406fafb11c$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5a1 1 0 0 0-1 1v1h16V6a1 1 0 0 0-1-1zm11.15 15h-8.3a1 1 0 0 1-.99-.83L5 8h14l-1.86 11.17a1 1 0 0 1-.99.83M9 4.5a.5.5 0 0 1 .49-.5h5.02a.5.5 0 0 1 .49.5V5H9z"/></svg>`
    }, props, {
        newIcon: $50fe95406fafb11c$var$_delete.default
    }));
$50fe95406fafb11c$var$TrashIcon.displayName = 'TrashIcon';
var $50fe95406fafb11c$var$_default = module.exports.default = $50fe95406fafb11c$var$TrashIcon;

});
parcelRegister("eLURR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a0de62c85427fa688b203192cfaed36b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac119137cc011824$var$_react = $ac119137cc011824$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ac119137cc011824$var$_UNSAFE_baseNew = $ac119137cc011824$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $ac119137cc011824$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ac119137cc011824$var$DeleteIcon = (props)=>/*#__PURE__*/ $ac119137cc011824$var$_react.default.createElement($ac119137cc011824$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.75 3.25V14c0 .69-.56 1.25-1.25 1.25h-7c-.69 0-1.25-.56-1.25-1.25V3.25m9.5 0h1.75m-1.75 0h-2.5m-7 0H1.5m1.75 0h2.5m0 0V.75h4.5v2.5m-4.5 0h4.5M6.5 5.5V13m3-7.5V13"/>`
    }, props));
$ac119137cc011824$var$DeleteIcon.displayName = 'DeleteIcon';
var $ac119137cc011824$var$_default = module.exports.default = $ac119137cc011824$var$DeleteIcon;

});


parcelRegister("7eqzD", function(module, exports) {

$parcel$export(module.exports, "ConditionalWrapper", () => $b3ad0a6f810bebd6$export$39aecc95f0365819);

var $eUqFw = parcelRequire("eUqFw");
const $b3ad0a6f810bebd6$export$39aecc95f0365819 = ({ condition: condition, renderWrapper: renderWrapper, children: children })=>condition ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);

});

parcelRegister("4VjPN", function(module, exports) {

$parcel$export(module.exports, "ContactAdminToModifyBoardMessage", () => $b523582b682a07b1$export$a89755471361f3c1);

var $eUqFw = parcelRequire("eUqFw");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gQp5G = parcelRequire("gQp5G");
const $b523582b682a07b1$var$ContactAdmin = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: "/secure/ContactAdministrators!default.jspa",
        target: "_blank"
    }, children);
const $b523582b682a07b1$export$a89755471361f3c1 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        componentsMapping: {
            link: $b523582b682a07b1$var$ContactAdmin
        },
        message: formatMessage((0, $gQp5G.default).noPermissionToModify, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        })
    });
};

});
parcelRegister("3x4sL", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $88ddecd12f0773cd$export$200d7bd7633253ce);

var $eUqFw = parcelRequire("eUqFw");

var $dO2kc = parcelRequire("dO2kc");

var $6nVYw = parcelRequire("6nVYw");
const $88ddecd12f0773cd$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $eUqFw.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $6nVYw.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $6nVYw.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $6nVYw.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $dO2kc.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $dO2kc.MalformedMessageError)) {
                (0, $dO2kc.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $dO2kc.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("dO2kc", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $1a42e2705665fc85$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $1a42e2705665fc85$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $1a42e2705665fc85$export$40d900e818b9630e);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

const $1a42e2705665fc85$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $1a42e2705665fc85$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $guiFP.default)({
            meta: {
                packageName: packageName,
                id: (0, $376af31d5cd90f0d$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $376af31d5cd90f0d$export$f3390a0e172fee41)}`;
        (0, $gUUjF.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $1a42e2705665fc85$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $376af31d5cd90f0d$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("6nVYw", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $ec16d76793463e9e$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $ec16d76793463e9e$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $ec16d76793463e9e$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $ec16d76793463e9e$export$d5170904651e91b1);

const $ec16d76793463e9e$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $ec16d76793463e9e$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$d5170904651e91b1 = (letter)=>letter === (0, $a86f32165c278403$export$a10c567c3288a6b4);

});
const $a86f32165c278403$export$a10c567c3288a6b4 = '}';



parcelRegister("gQp5G", function(module, exports) {

$parcel$export(module.exports, "default", () => $a680a926e4fd6ffc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a680a926e4fd6ffc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noPermissionToModify: {
        "id": "work-management-board.common.contact-admin-to-modify-board.no-permission-to-modify",
        "defaultMessage": "{linkStart}Contact your admin{linkEnd} to make changes to the board"
    }
});

});


parcelRegister("eUIOu", function(module, exports) {

$parcel$export(module.exports, "OpenProjectSettingsExceededIssueTypes", () => $0f807102606ed069$export$b7268968213268c2);

var $eUqFw = parcelRequire("eUqFw");

var $d9FyT = parcelRequire("d9FyT");

var $kQAZu = parcelRequire("kQAZu");

var $79xbN = parcelRequire("79xbN");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fAbsD = parcelRequire("fAbsD");
const $0f807102606ed069$var$OpenProjectSettings = ({ children: children })=>{
    const project = (0, $kQAZu.useProject)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: `/jira/core/projects/${project.key}/settings/issuetypes`,
        target: "_blank"
    }, children, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d9FyT))), {
        label: "",
        size: "small"
    }));
};
const $0f807102606ed069$export$b7268968213268c2 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        componentsMapping: {
            link: $0f807102606ed069$var$OpenProjectSettings
        },
        message: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fAbsD.default).exceededIssueTypesBoardActionsDisabledIssueTermRefresh : (0, $fAbsD.default).exceededIssueTypesBoardActionsDisabled, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        })
    });
};

});
parcelRegister("fAbsD", function(module, exports) {

$parcel$export(module.exports, "default", () => $81d683adbd1d9b32$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $81d683adbd1d9b32$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    exceededIssueTypesBoardActionsDisabled: {
        "id": "work-management-board.common.open-project-settings-exceeded-issue-types.exceeded-issue-types-board-actions-disabled",
        "defaultMessage": "Looks like you've got too many issue types. You can {linkStart}add, delete, or rename columns in project settings{linkEnd}."
    },
    exceededIssueTypesBoardActionsDisabledIssueTermRefresh: {
        "id": "work-management-board.common.open-project-settings-exceeded-issue-types.exceeded-issue-types-board-actions-disabled-issue-term-refresh",
        "defaultMessage": "Looks like you've got too many issue types. You can {linkStart}add, delete, or rename columns in project settings{linkEnd}."
    }
});

});


parcelRegister("4Z5qC", function(module, exports) {

$parcel$export(module.exports, "OpenProjectSettingsMultipleWorkflows", () => $24ada43abdc0be4e$export$34713a2d1d1029c);

var $eUqFw = parcelRequire("eUqFw");

var $d9FyT = parcelRequire("d9FyT");

var $kQAZu = parcelRequire("kQAZu");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gy5Ed = parcelRequire("gy5Ed");
const $24ada43abdc0be4e$var$OpenProjectSettings = ({ children: children })=>{
    const project = (0, $kQAZu.useProject)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: `/jira/core/projects/${project.key}/settings/issuetypes`,
        target: "_blank"
    }, children, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d9FyT))), {
        label: "",
        size: "small"
    }));
};
const $24ada43abdc0be4e$export$34713a2d1d1029c = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        componentsMapping: {
            link: $24ada43abdc0be4e$var$OpenProjectSettings
        },
        message: formatMessage((0, $gy5Ed.default).multipleWorkflowsBoardActionsDisabled, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        })
    });
};

});
parcelRegister("gy5Ed", function(module, exports) {

$parcel$export(module.exports, "default", () => $aac332460506c549$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $aac332460506c549$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    multipleWorkflowsBoardActionsDisabled: {
        "id": "work-management-board.common.open-project-settings-multiple-workflows.multiple-workflows-board-actions-disabled",
        "defaultMessage": "You can't add, delete, or rename columns when a board has multiple workflows. You can {linkStart}change your workflows in project settings{linkEnd}."
    }
});

});


parcelRegister("cdPA8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e23821f171c1c31$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

var $dyfd9 = parcelRequire("dyfd9");

const $1e23821f171c1c31$var$ColumnDeleteModal = (0, $dyfd9.lazyForPaint)(()=>(parcelRequire("9aBoA")), {
    moduleId: "./src/packages/business/board/view/src/ui/board/column/column-header/header-dropdown/column-delete-modal/main.tsx"
});
const $1e23821f171c1c31$var$AsyncColumnDeleteModal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.jira-business.board.column-delete-modal",
        packageName: "async.jira-business.board.column-delete-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "column-delete-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1e23821f171c1c31$var$ColumnDeleteModal, props)));
var $1e23821f171c1c31$export$2e2bcd8739ae039 = $1e23821f171c1c31$var$AsyncColumnDeleteModal;

});
parcelRegister("9aBoA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("50DLA").then(()=>parcelRequire('hiC39'));

});


parcelRegister("77aEt", function(module, exports) {

$parcel$export(module.exports, "default", () => $00276efd509970a9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $00276efd509970a9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    dropdownHeaderTitle: {
        "id": "work-management-board.board.column.column-header.header-dropdown.dropdown-header-title",
        "defaultMessage": "Actions"
    },
    rename: {
        "id": "work-management-board.board.column.column-header.header-dropdown.rename",
        "defaultMessage": "Rename"
    },
    delete: {
        "id": "work-management-board.board.column.column-header.header-dropdown.delete",
        "defaultMessage": "Delete"
    },
    deleteDisabledTooltip: {
        "id": "work-management-board.board.column.column-header.header-dropdown.delete-disabled-tooltip",
        "defaultMessage": "The board must contain at least one column"
    },
    columnActionsMenu: {
        "id": "work-management-board.board.column.column-header.header-dropdown.column-actions-menu",
        "defaultMessage": "Column actions"
    },
    columnActionsWithColumn: {
        "id": "work-management-board.board.column.column-header.header-dropdown.column-actions-with-column",
        "defaultMessage": "Column actions on column {columnName}"
    }
});

});


parcelRegister("lELme", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c4ad9f8207289bd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6c4ad9f8207289bd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    collapseButton: {
        "id": "work-management-board.board.column.column-header.collapse-button",
        "defaultMessage": "Collapse"
    },
    expandButton: {
        "id": "work-management-board.board.column.column-header.expand-button",
        "defaultMessage": "Expand"
    }
});

});


parcelRegister("jduWG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5740eb86f24e4e08$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $gCss4 = parcelRequire("gCss4");

var $2vRZq = parcelRequire("2vRZq");
const $5740eb86f24e4e08$var$inlineCreateStyles = {
    borderRadius: "var(--ds-border-radius, 3px)"
};
const $5740eb86f24e4e08$var$InlineCreate = ({ group: group, scrollToLastElement: scrollToLastElement })=>{
    const onAddOptimisticIssue = (0, $eUqFw.useCallback)(()=>{
        // Only attempt to scroll to the last element after the optimistic issue is created
        requestAnimationFrame(scrollToLastElement);
    }, [
        scrollToLastElement
    ]);
    const inlineCreateProps = (0, $2vRZq.useInlineCreateProps)({
        group: group,
        onAddOptimisticIssue: onAddOptimisticIssue
    });
    const handleToggleForm = (0, $eUqFw.useCallback)((isFormVisible)=>{
        if (isFormVisible) scrollToLastElement();
    }, [
        scrollToLastElement
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $5740eb86f24e4e08$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCss4.default), {
        ...inlineCreateProps,
        location: "boardFooter",
        inlineCreateStyles: $5740eb86f24e4e08$var$inlineCreateStyles,
        onToggleForm: handleToggleForm
    }));
};
const $5740eb86f24e4e08$var$wrapperStyles = (0, $8Vv3m.xcss)({
    paddingLeft: 'space.050',
    paddingRight: 'space.050',
    paddingBottom: 'space.050'
});
var $5740eb86f24e4e08$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5740eb86f24e4e08$var$InlineCreate);

});
parcelRegister("gCss4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d57348ffad7a3f9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gEmpR = parcelRequire("gEmpR");

var $eI5EY = parcelRequire("eI5EY");

var $gIx2f = parcelRequire("gIx2f");

var $73dL5 = parcelRequire("73dL5");
const $8d57348ffad7a3f9$var$InlineCreate = ({ allowedIssueTypeIds: allowedIssueTypeIds, appearance: appearance, fieldIdsToReturn: fieldIdsToReturn, inlineCreateStyles: inlineCreateStyles, isCompact: isCompact, location: location, maxHierarchyLevel: maxHierarchyLevel, minHierarchyLevel: minHierarchyLevel, onBlur: onBlur, onPrepareIssueContext: onPrepareIssueContext, onSubmit: onSubmit, onToggleForm: onToggleForm, isOpenByDefault: isOpenByDefault = false, popperStrategy: popperStrategy })=>{
    const [isFormVisible, setIsFormVisible] = (0, $eUqFw.useState)(isOpenByDefault);
    const { data: { issueTypes: issueTypes } } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    const showForm = (0, $eUqFw.useCallback)(()=>{
        setIsFormVisible(true);
        onToggleForm?.(true);
    }, [
        onToggleForm
    ]);
    const hideForm = (0, $eUqFw.useCallback)(()=>{
        setIsFormVisible(false);
        onToggleForm?.(false);
    }, [
        onToggleForm
    ]);
    const handleBlur = (0, $eUqFw.useCallback)(()=>{
        hideForm();
        onBlur?.();
    }, [
        hideForm,
        onBlur
    ]);
    const isInlineCreateFormVisible = (0, $eI5EY.fg)('jira_one_screen_onboarding_feature_gate') ? isFormVisible && issueTypes.length > 0 : isFormVisible;
    return isInlineCreateFormVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gIx2f.default), {
        allowedIssueTypeIds: allowedIssueTypeIds,
        appearance: appearance,
        fieldIdsToReturn: fieldIdsToReturn,
        isCompact: isCompact,
        location: location,
        maxHierarchyLevel: maxHierarchyLevel,
        minHierarchyLevel: minHierarchyLevel,
        onBlur: handleBlur,
        onPrepareIssueContext: onPrepareIssueContext,
        onSubmit: onSubmit,
        popperStrategy: popperStrategy,
        ...inlineCreateStyles
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $73dL5.default), {
        onClick: showForm,
        isDisabled: (0, $eI5EY.fg)('resolve-type-error-undefined-avatar-url') && issueTypes.length === 0,
        ...inlineCreateStyles
    });
};
const $8d57348ffad7a3f9$var$genericMemo = (0, $eUqFw.memo);
var $8d57348ffad7a3f9$export$2e2bcd8739ae039 = $8d57348ffad7a3f9$var$genericMemo($8d57348ffad7a3f9$var$InlineCreate);

});
parcelRegister("73dL5", function(module, exports) {

$parcel$export(module.exports, "default", () => $526fef1529e77253$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $h1gBX = parcelRequire("h1gBX");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9W2dp = parcelRequire("9W2dp");
const $526fef1529e77253$var$InlineCreateTrigger = ({ onClick: onClick, minHeight: minHeight, borderRadius: borderRadius, horizontalPadding: horizontalPadding, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($526fef1529e77253$var$Trigger, {
        borderRadius: borderRadius,
        "data-testid": "business-issue-create.ui.inline-create-trigger",
        horizontalPadding: horizontalPadding,
        minHeight: minHeight,
        onClick: onClick,
        disabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h1gBX))), {
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($526fef1529e77253$var$Label, null, formatMessage((0, $9W2dp.default).createLabel)));
};
var $526fef1529e77253$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($526fef1529e77253$var$InlineCreateTrigger);
const $526fef1529e77253$var$Trigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { borderRadius: borderRadius, minHeight: minHeight, horizontalPadding: horizontalPadding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ri98hz": (0, $9t7rW.default)(__cmplp.borderRadius ?? 0),
            "--_19b8a3e": (0, $9t7rW.default)(__cmplp.minHeight ?? '32px'),
            "--_1w524p6": (0, $9t7rW.default)(`0 ${__cmplp.horizontalPadding ?? "var(--ds-space-100, 8px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _syaz1thw _bfhk18uv _19itglyw _1wybdlk8 _k48pbfng _2rko16jm _1tke1um9 _1yt414jf _zulph9hh _1bsb1osq _1jhm1q09 _y2mv1q09 _1ygb1q09 _13ro1n1a _1bg41n1a _1ah31n1a _irr3166n _1di61dty",
            __cmplp.disabled ? "_80om73ad" : "_80omtlke",
            __cmplp.className
        ])
    });
});
const $526fef1529e77253$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9W2dp", function(module, exports) {

$parcel$export(module.exports, "default", () => $37a764120c338951$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $37a764120c338951$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createLabel: {
        "id": "business-issue-create.inline-create-trigger.create-label",
        "defaultMessage": "Create"
    }
});

});




parcelRegister("gQQ5C", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f7a84de394113a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jGcn0 = parcelRequire("jGcn0");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lUpP3 = parcelRequire("lUpP3");

var $c52lf = parcelRequire("c52lf");

var $j9aY9 = parcelRequire("j9aY9");
const $02f7a84de394113a$var$InvalidDropTargetMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { group: group } = (0, $c52lf.useIssueGroup)();
    let message;
    const groupType = group.type;
    switch(groupType){
        case 0, $jGcn0.GROUP_BY_ASSIGNEE:
            message = (0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $j9aY9.default).unableToUpdateAssigneeMessageIssueTermRefresh : (0, $j9aY9.default).unableToUpdateAssigneeMessage;
            break;
        case 0, $jGcn0.GROUP_BY_CATEGORY:
            message = (0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $j9aY9.default).unableToUpdateCategoryMessageIssueTermRefresh : (0, $j9aY9.default).unableToUpdateCategoryMessage;
            break;
        case 0, $jGcn0.GROUP_BY_PRIORITY:
            message = (0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $j9aY9.default).unableToUpdatePriorityMessageIssueTermRefresh : (0, $j9aY9.default).unableToUpdatePriorityMessage;
            break;
        case 0, $jGcn0.GROUP_BY_STATUS:
            message = (0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $j9aY9.default).transitionNotAvailableMessageIssueTermRefresh : (0, $j9aY9.default).transitionNotAvailableMessage;
            break;
        default:
            {
                const exhaustiveCheck = groupType;
                throw new Error(`Unexpected group type: ${exhaustiveCheck}`);
            }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02f7a84de394113a$var$Wrapper, {
        "data-testid": "work-management-board.ui.board.column.invalid-drop-target-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02f7a84de394113a$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUpP3.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02f7a84de394113a$var$Message, null, formatMessage(message))));
};
var $02f7a84de394113a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($02f7a84de394113a$var$InvalidDropTargetMessage);
const $02f7a84de394113a$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk1gly _2rko3ree _1r04idpf _kqswstnw _154ickbl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02f7a84de394113a$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _zulpu2gc _1yt4wd81 _y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02f7a84de394113a$var$Message = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j9aY9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e65e47925e32115c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e65e47925e32115c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unableToUpdateAssigneeMessage: {
        "id": "work-management-board.board.column.invalid-drop-target-message.unable-to-update-assignee-message",
        "defaultMessage": "You can't move this issue to this column because the assignee field is not associated with this issue type."
    },
    unableToUpdateCategoryMessage: {
        "id": "work-management-board.board.column.invalid-drop-target-message.unable-to-update-category-message",
        "defaultMessage": "You can't move this issue to this column because the category field is not associated with this issue type."
    },
    unableToUpdatePriorityMessage: {
        "id": "work-management-board.board.column.invalid-drop-target-message.unable-to-update-priority-message",
        "defaultMessage": "You can't move this issue to this column because the priority field is not associated with this issue type."
    },
    transitionNotAvailableMessage: {
        "id": "work-management-board.board.column.invalid-drop-target-message.transition-not-available-message",
        "defaultMessage": "You can't move this issue to this column due to workflow configurations or permissions."
    },
    unableToUpdateAssigneeMessageIssueTermRefresh: {
        "id": "work-management-board.board.column.invalid-drop-target-message.unable-to-update-assignee-message-issue-term-refresh",
        "defaultMessage": "You can't move this issue to this column because the assignee field is not associated with this issue type."
    },
    unableToUpdateCategoryMessageIssueTermRefresh: {
        "id": "work-management-board.board.column.invalid-drop-target-message.unable-to-update-category-message-issue-term-refresh",
        "defaultMessage": "You can't move this issue to this column because the category field is not associated with this issue type."
    },
    unableToUpdatePriorityMessageIssueTermRefresh: {
        "id": "work-management-board.board.column.invalid-drop-target-message.unable-to-update-priority-message-issue-term-refresh",
        "defaultMessage": "You can't move this issue to this column because the priority field is not associated with this issue type."
    },
    transitionNotAvailableMessageIssueTermRefresh: {
        "id": "work-management-board.board.column.invalid-drop-target-message.transition-not-available-message-issue-term-refresh",
        "defaultMessage": "You can't move this issue to this column due to workflow configurations or permissions."
    }
});

});


parcelRegister("9sGu9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0f91d7e9311d0a1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jGcn0 = parcelRequire("jGcn0");

var $8Qd0L = parcelRequire("8Qd0L");

var $79xbN = parcelRequire("79xbN");

var $983OU = parcelRequire("983OU");

var $gWYTK = parcelRequire("gWYTK");

var $ay4XV = parcelRequire("ay4XV");

var $aL9gA = parcelRequire("aL9gA");
const $f0f91d7e9311d0a1$var$getTransitionById = (transitions, transitionId)=>transitions.find((transition)=>transition.transitionId === transitionId);
const $f0f91d7e9311d0a1$var$TransitionZones = ({ group: group })=>{
    const { transitions: transitions } = (0, $ay4XV.useIssueTransitions)();
    const updateDropTarget = (0, $gWYTK.useUpdateDropTarget)();
    const { sourceGroup: sourceGroup, dropTarget: dropTarget } = (0, $gWYTK.useCardDragDrop)();
    const handleCardDragOver = (0, $eUqFw.useCallback)((transitionId)=>{
        updateDropTarget({
            groupId: group.id,
            transition: $f0f91d7e9311d0a1$var$getTransitionById(transitions, transitionId)
        });
    }, [
        group,
        transitions,
        updateDropTarget
    ]);
    const handleTransitionSelected = (0, $eUqFw.useCallback)((transitionId)=>{
        updateDropTarget({
            transition: $f0f91d7e9311d0a1$var$getTransitionById(transitions, transitionId)
        });
    }, [
        transitions,
        updateDropTarget
    ]);
    const sourceStatus = (0, $eUqFw.useMemo)(()=>sourceGroup ? {
            id: Number(sourceGroup.id),
            name: sourceGroup.name
        } : undefined, [
        sourceGroup
    ]);
    const statusCategoryId = group.type === (0, $jGcn0.GROUP_BY_STATUS) ? group.statusCategoryId : 0;
    const transitionZonesData = (0, $eUqFw.useMemo)(()=>transitions.filter((transition)=>String(transition.toStatusId) === group.id).map((transition)=>({
                transitionId: transition.transitionId,
                transitionName: transition.name,
                targetStatusId: transition.toStatusId,
                targetStatusName: group.name,
                targetStatusCategory: (0, $8Qd0L.statusCategoryForId)(statusCategoryId),
                isAvailable: true,
                isGlobal: transition.isGlobal
            })), [
        transitions,
        group.id,
        group.name,
        statusCategoryId
    ]);
    if (!sourceGroup) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0f91d7e9311d0a1$var$TransitionZoneWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $983OU.ColumnTransitionZonesContainer), {
        hasSwimlanes: false,
        columnId: group.id,
        sourceColumnId: sourceGroup.id,
        sourceStatus: sourceStatus,
        transitions: transitionZonesData,
        hoverIntent: false,
        columnDraggingOver: dropTarget.groupId,
        notAvailableMessage: (0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $aL9gA.default).notAvailableMessageIssueTermRefresh : (0, $aL9gA.default).notAvailableMessage,
        onCardDragOver: handleCardDragOver,
        onTransitionSelected: handleTransitionSelected
    }));
};
var $f0f91d7e9311d0a1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($f0f91d7e9311d0a1$var$TransitionZones);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f0f91d7e9311d0a1$var$TransitionZoneWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wtet4lq _vw7oglyw _1f5il1r9 _pslqidpf _1hvostnw _17hj14y2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("983OU", function(module, exports) {

$parcel$export(module.exports, "ColumnTransitionZonesContainer", () => $d8405c1b96d6c598$export$169a50ebb52c9a6);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $dxIU5 = parcelRequire("dxIU5");

var $ibIV3 = parcelRequire("ibIV3");

var $hKj4G = parcelRequire("hKj4G");

var $iIzf3 = parcelRequire("iIzf3");

var $fIrnI = parcelRequire("fIrnI");

var $cZAdR = parcelRequire("cZAdR");

var $2QY77 = parcelRequire("2QY77");


var $4iQEO = parcelRequire("4iQEO");
const $d8405c1b96d6c598$export$169a50ebb52c9a6 = ({ columnId: columnId, swimlaneId: swimlaneId, columnDraggingOver: columnDraggingOver, onCardDragOver: onCardDragOver, hoverIntent: hoverIntent, onTransitionSelected: onTransitionSelected, hasSwimlanes: hasSwimlanes, sourceStatus: sourceStatus, notAvailableMessage: notAvailableMessage, noTransitionMessage: noTransitionMessage, isLoading: isLoading, shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone, hideSourceStatusInLabel: hideSourceStatusInLabel, transitions: allTransitions, sourceColumnId: sourceColumnId, showAllTransitionZones: showAllTransitionZones })=>{
    const autobatch = (0, $hKj4G.useAutobatch)();
    const [allowSelfColumnTransitions, setAllowSelfColumnTransitions] = (0, $eUqFw.useState)(false);
    const containerRef = (0, $eUqFw.useRef)(null);
    const hoverIntentOnThisColumn = hoverIntent && columnDraggingOver === columnId;
    const debouncedOnDragOverTransition = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((transitionId, hoverIntentOnZone)=>{
            if (!hoverIntentOnThisColumn) onCardDragOver(transitionId, hoverIntentOnZone);
        }, (0, $9f45f53a8ada9764$export$c28377001f14d9d)), [
        hoverIntentOnThisColumn,
        onCardDragOver
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            debouncedOnDragOverTransition.cancel();
        }, [
        debouncedOnDragOverTransition
    ]);
    const onHoverOverTransitionToZone = (0, $eUqFw.useCallback)(()=>{
        setAllowSelfColumnTransitions(true);
    }, []);
    const renderTransitions = (transitions)=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fIrnI.LoadingContainer), null);
        if (transitions.length === 0 && noTransitionMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d8405c1b96d6c598$export$819ff6ae0287a04, {
            hasSwimlanes: hasSwimlanes,
            zoneCount: transitions.length,
            shouldRenderFullColumnTransitionZone: Boolean(shouldRenderFullColumnTransitionZone),
            "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.inner-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cZAdR.NoTransitionContainer), {
            noTransitionMessage: noTransitionMessage
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d8405c1b96d6c598$export$819ff6ae0287a04, {
            hasSwimlanes: hasSwimlanes,
            zoneCount: transitions.length,
            shouldRenderFullColumnTransitionZone: Boolean(shouldRenderFullColumnTransitionZone),
            "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.inner-container"
        }, transitions.map(({ transitionId: transitionId, transitionName: transitionName, targetStatusName: targetStatusName, targetStatusCategory: targetStatusCategory, isAvailable: isAvailable, targetStatusId: targetStatusId, isGlobal: isGlobal })=>{
            const filteredSourceStatus = sourceStatus?.id === targetStatusId ? null : sourceStatus;
            const filteredTransitionName = sourceStatus?.id === targetStatusId ? null : transitionName;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4iQEO.ColumnTransitionZone), {
                key: transitionId,
                isHidden: hoverIntent,
                transitionId: transitionId,
                transitionName: filteredTransitionName,
                targetStatusName: targetStatusName,
                onDragOver: debouncedOnDragOverTransition,
                targetStatusCategory: targetStatusCategory,
                isTransitionAvailable: isAvailable,
                isTransitionGlobal: isGlobal,
                notAvailableMessage: notAvailableMessage,
                sourceStatus: filteredSourceStatus,
                onTransitionSelection: onTransitionSelected,
                hideSourceStatusInLabel: hideSourceStatusInLabel,
                columnId: columnId,
                swimlaneId: swimlaneId
            });
        }));
    };
    (0, $eUqFw.useEffect)(()=>{
        if (!containerRef.current || isLoading || allTransitions.length === 0) return undefined;
        return (0, $ibIV3.dropTargetForElements)({
            element: containerRef.current,
            onDragLeave: ()=>{
                autobatch(()=>setAllowSelfColumnTransitions(false));
            }
        });
    }, [
        isLoading,
        allTransitions.length,
        allowSelfColumnTransitions,
        onCardDragOver,
        autobatch
    ]);
    let transitions = allTransitions;
    if (!showAllTransitionZones && columnId === sourceColumnId) {
        transitions = allTransitions.filter((t)=>!t.isGlobal || sourceStatus && t.targetStatusId !== sourceStatus.id);
        if (transitions.length === 0) return null;
    }
    if (!showAllTransitionZones && columnId === sourceColumnId && !allowSelfColumnTransitions && !hoverIntent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2QY77.default), {
        onHover: onHoverOverTransitionToZone
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d8405c1b96d6c598$export$fb3bf400d073b5dd, {
        "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.outer-transition-container",
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.outer-container",
        isHidden: !shouldRenderFullColumnTransitionZone && hoverIntent,
        hasSwimlanes: hasSwimlanes,
        shouldRenderFullColumnTransitionZone: Boolean(shouldRenderFullColumnTransitionZone),
        innerRef: containerRef
    }, renderTransitions(transitions));
};
const $d8405c1b96d6c598$export$819ff6ae0287a04 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1064em4-0"
})`--full-column-height:calc( var(--board-scroll-element-height) * 1px - ${(0, $iIzf3.columnHeaderHeight) + 8}px );position:sticky;width:100%;display:flex;flex-direction:column;top:${({ hasSwimlanes: hasSwimlanes })=>hasSwimlanes ? (0, $iIzf3.columnHeaderHeight) * 2 : (0, $iIzf3.columnHeaderHeight)}px;transition:opacity 0.2s;background-color:${({ theme: theme })=>theme.background};height:${({ shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone })=>shouldRenderFullColumnTransitionZone ? 'var(--full-column-height)' : '100%'};max-height:${({ shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone, zoneCount: zoneCount })=>shouldRenderFullColumnTransitionZone ? 'var(--full-column-height)' : `${zoneCount * (0, $iIzf3.columnHeaderHeight) * 2}px`};`;
const $d8405c1b96d6c598$export$fb3bf400d073b5dd = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1064em4-1"
})`position:absolute;top:${({ hasSwimlanes: hasSwimlanes })=>hasSwimlanes ? 0 : (0, $iIzf3.columnHeaderHeight)}px;height:100%;width:100%;z-index:${({ shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone })=>shouldRenderFullColumnTransitionZone ? (0, $iIzf3.zIndex).fullColumnHeightTransitionZones : (0, $iIzf3.zIndex).transitionZones};background-color:${({ theme: theme })=>theme.background};border-radius:${(0, $iIzf3.layout).cardListRadius}px;${({ isHidden: isHidden })=>isHidden && 'display: none;'};`;

});
parcelRegister("hKj4G", function(module, exports) {

$parcel$export(module.exports, "useAutobatch", () => $8e906032bc4f59a5$export$5b8ae94abd7adcf);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $eI5EY = parcelRequire("eI5EY");
const $8e906032bc4f59a5$var$queue = new Set();
let $8e906032bc4f59a5$var$hasQueuedFlush = false;
function $8e906032bc4f59a5$var$flush() {
    const tasks = Array.from($8e906032bc4f59a5$var$queue);
    $8e906032bc4f59a5$var$queue.clear();
    (0, $lEfVV.unstable_batchedUpdates)(()=>{
        tasks.forEach((task)=>{
            task();
        });
    });
}
function $8e906032bc4f59a5$export$46f5568dd7916109(task) {
    $8e906032bc4f59a5$var$queue.add(task);
    if (!$8e906032bc4f59a5$var$hasQueuedFlush) {
        $8e906032bc4f59a5$var$hasQueuedFlush = true;
        queueMicrotask(()=>{
            $8e906032bc4f59a5$var$hasQueuedFlush = false;
            $8e906032bc4f59a5$var$flush();
        });
    }
    return ()=>{
        $8e906032bc4f59a5$var$queue.delete(task);
    };
}
function $8e906032bc4f59a5$export$5b8ae94abd7adcf() {
    if (!(0, $eI5EY.fg)('jsw_backlog_pragmatic_dnd_automatic_batching')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $eUqFw.useCallback)((task)=>task(), []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const cancelFunctions = (0, $eUqFw.useRef)([]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const batchingFunction = (0, $eUqFw.useCallback)((task)=>{
        const cancel = $8e906032bc4f59a5$export$46f5568dd7916109(task);
        cancelFunctions.current.push(cancel);
    }, []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eUqFw.useEffect)(()=>()=>{
            cancelFunctions.current.forEach((cancel)=>{
                cancel();
            });
        }, []);
    return batchingFunction;
}

});

parcelRegister("iIzf3", function(module, exports) {

$parcel$export(module.exports, "layout", () => $773cc0e2395d35af$export$b3219800bda33a1f);
$parcel$export(module.exports, "colors", () => $773cc0e2395d35af$export$8f45430ccf837300);
$parcel$export(module.exports, "zIndex", () => $773cc0e2395d35af$export$56446adcecbeec34);
$parcel$export(module.exports, "columnHeaderHeight", () => $773cc0e2395d35af$export$b10d8d0737c2bc95);
$parcel$export(module.exports, "columnFixedWidth", () => $773cc0e2395d35af$export$fa05dc858c5009bb);
$parcel$export(module.exports, "columnMinWidth", () => $773cc0e2395d35af$export$dc572e5846332cb1);
$parcel$export(module.exports, "columnWithMarginWidth", () => $773cc0e2395d35af$export$28e72c3a8a93ac77);
$parcel$export(module.exports, "columnMinWithMarginWidth", () => $773cc0e2395d35af$export$f47ba5aa0a13b432);
$parcel$export(module.exports, "columnHeaderFontSize", () => $773cc0e2395d35af$export$bc68d684b3f68e0);
$parcel$export(module.exports, "swimlaneHeaderHeight", () => $773cc0e2395d35af$export$b12ee424ee8005de);
$parcel$export(module.exports, "minCardHeight", () => $773cc0e2395d35af$export$9c20cef8efa8ff1c);
$parcel$export(module.exports, "miniMapMapHeight", () => $773cc0e2395d35af$export$73febd7a1d3f7041);
$parcel$export(module.exports, "collapsedColumnFixedWidth", () => $773cc0e2395d35af$export$7709c197eb61e438);
$parcel$export(module.exports, "collapsedColumnWithMarginWidth", () => $773cc0e2395d35af$export$a18d33b11d25b5c7);
$parcel$export(module.exports, "scrollbarWidth", () => $773cc0e2395d35af$export$14c8a45ff6da16d);
$parcel$export(module.exports, "unscheduledColumnWidth", () => $773cc0e2395d35af$export$e635defc4ff8e744);
$parcel$export(module.exports, "unscheduledColumnHeaderHeight", () => $773cc0e2395d35af$export$1f19522691bf7df6);
// eslint-disable-next-line import/order

var $c9TLT = parcelRequire("c9TLT");
const $773cc0e2395d35af$export$b3219800bda33a1f = {
    gutter: 10,
    smallGutter: 5,
    cardRadius: 3,
    cardListRadius: 6,
    adg3smallGutter: 8,
    columnMargin: 6,
    boardBorderWidth: (0, $c9TLT.contentHorizontalSpacing)
};
const $773cc0e2395d35af$export$8f45430ccf837300 = {
    shadow: "var(--ds-border, rgba(0, 0, 0, 0.2))"
};
const $773cc0e2395d35af$export$56446adcecbeec34 = {
    // Inside board
    boardBorders: 90,
    minimap: 6,
    cardDoneRipple: 5,
    transitionZoneIndicator: 5,
    stickyHeaders: 4,
    swimlaneTickMask: 3,
    stickySwimlaneBar: 2,
    icc: 1,
    transitionZones: 1,
    fullColumnHeightTransitionZones: 3
};
const $773cc0e2395d35af$export$b10d8d0737c2bc95 = 32 + 2 * $773cc0e2395d35af$export$b3219800bda33a1f.adg3smallGutter;
const $773cc0e2395d35af$export$fa05dc858c5009bb = 270;
const $773cc0e2395d35af$export$dc572e5846332cb1 = 150;
const $773cc0e2395d35af$export$28e72c3a8a93ac77 = $773cc0e2395d35af$export$fa05dc858c5009bb + $773cc0e2395d35af$export$b3219800bda33a1f.columnMargin * 2;
const $773cc0e2395d35af$export$f47ba5aa0a13b432 = $773cc0e2395d35af$export$dc572e5846332cb1 + $773cc0e2395d35af$export$b3219800bda33a1f.columnMargin * 2;
const $773cc0e2395d35af$export$bc68d684b3f68e0 = 12;
const $773cc0e2395d35af$export$b12ee424ee8005de = 24 + 2 * $773cc0e2395d35af$export$b3219800bda33a1f.adg3smallGutter;
const $773cc0e2395d35af$export$9c20cef8efa8ff1c = (0, $c9TLT.gridSize) * 10;
const $773cc0e2395d35af$export$73febd7a1d3f7041 = 36;
const $773cc0e2395d35af$export$7709c197eb61e438 = 40;
const $773cc0e2395d35af$export$a18d33b11d25b5c7 = $773cc0e2395d35af$export$7709c197eb61e438 + $773cc0e2395d35af$export$b3219800bda33a1f.columnMargin * 2;
const $773cc0e2395d35af$export$14c8a45ff6da16d = '10px';
const $773cc0e2395d35af$export$e635defc4ff8e744 = '270px';
const $773cc0e2395d35af$var$unscheduledColumnTitleHeight = 20;
const $773cc0e2395d35af$export$1f19522691bf7df6 = $773cc0e2395d35af$export$b12ee424ee8005de + $773cc0e2395d35af$var$unscheduledColumnTitleHeight;

});

parcelRegister("fIrnI", function(module, exports) {

$parcel$export(module.exports, "LoadingContainer", () => $31048388176c5f92$export$5e3f251c730829);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bBdMg = parcelRequire("bBdMg");
function $31048388176c5f92$export$5e3f251c730829() {
    const [showSpinner, setShowSpinner] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        const timeoutId = setTimeout(()=>setShowSpinner(true), 1000);
        return ()=>clearTimeout(timeoutId);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($31048388176c5f92$var$Wrapper, null, showSpinner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bBdMg.default), {
        size: "small"
    }) : null);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $31048388176c5f92$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1e0c1txw _4t3i16xz _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cZAdR", function(module, exports) {

$parcel$export(module.exports, "NoTransitionContainer", () => $fd21cec7fc235f09$export$35d96e22ed839fc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eWeL8 = parcelRequire("eWeL8");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8PDeA = parcelRequire("8PDeA");
function $fd21cec7fc235f09$export$35d96e22ed839fc({ noTransitionMessage: noTransitionMessage }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const message = formatMessage(noTransitionMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fd21cec7fc235f09$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fd21cec7fc235f09$var$Img, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8PDeA))),
        role: "presentation",
        alt: message
    }), message);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fd21cec7fc235f09$var$WrapperOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1e0c1txw _2lx21bp4 _4t3i16xz _4cvr1h6o _1bah1h6o _y3gn1h6o _syaz131l _1wyb1skh _1yt41ejb",
            __cmplp.className
        ])
    });
});
const $fd21cec7fc235f09$var$WrapperNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1e0c1txw _2lx21bp4 _4t3i16xz _4cvr1h6o _1bah1h6o _y3gn1h6o _syaz131l _11c81vlj _1yt41ejb",
            __cmplp.className
        ])
    });
});
const $fd21cec7fc235f09$var$Wrapper = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $eI5EY.fg)('tnk-1614-visual-refresh-boardkit'), $fd21cec7fc235f09$var$WrapperNew, $fd21cec7fc235f09$var$WrapperOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fd21cec7fc235f09$var$Img = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _1bsb1tcg _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8PDeA", function(module, exports) {
module.exports = new URL("restricted.65d4317c.svg", import.meta.url).toString();

});


parcelRegister("2QY77", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d9e3819b520b47c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $dxIU5 = parcelRequire("dxIU5");

var $ibIV3 = parcelRequire("ibIV3");


var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $hKj4G = parcelRequire("hKj4G");

var $iIzf3 = parcelRequire("iIzf3");
const $9d9e3819b520b47c$var$hoverIntentDelayMs = 100;
const $9d9e3819b520b47c$var$messages = (0, $90IgZ.defineMessages)({
    transitionTo: {
        "id": "platform-board-kit.column.column-transition-zones-container.transition-to-zone.transition-to",
        "defaultMessage": "Transition To..."
    }
});
const $9d9e3819b520b47c$var$ColumnTransitionToZone = ({ onHover: onHover })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const autobatch = (0, $hKj4G.useAutobatch)();
    const [isDraggingOver, setIsDraggingOver] = (0, $eUqFw.useState)(false);
    const batchSetIsDraggingOver = (0, $eUqFw.useCallback)((draggingOver)=>{
        autobatch(()=>setIsDraggingOver(draggingOver));
    }, [
        autobatch
    ]);
    const containerRef = (0, $eUqFw.useRef)(null);
    const previousInputPosition = (0, $eUqFw.useRef)(null);
    const debouncedHoverIntent = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(onHover, $9d9e3819b520b47c$var$hoverIntentDelayMs), [
        onHover
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!containerRef.current) return undefined;
        return (0, $ibIV3.dropTargetForElements)({
            element: containerRef.current,
            onDragEnter: ()=>{
                batchSetIsDraggingOver(true);
            },
            onDrag: ({ location: { current: { input: input } } })=>{
                if (previousInputPosition.current?.x !== input.clientX || previousInputPosition.current?.y !== input.clientY) {
                    debouncedHoverIntent();
                    previousInputPosition.current = {
                        x: input.clientX,
                        y: input.clientY
                    };
                }
            },
            onDragLeave: (_args)=>{
                debouncedHoverIntent.cancel();
                batchSetIsDraggingOver(false);
            }
        });
    }, [
        batchSetIsDraggingOver,
        debouncedHoverIntent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9d9e3819b520b47c$var$TransitionToZone, {
        isDraggingOver: isDraggingOver,
        innerRef: containerRef,
        "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.transition-to-zone.transition-to-zone",
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.transition-to-zone"
    }, formatMessage($9d9e3819b520b47c$var$messages.transitionTo));
};
var $9d9e3819b520b47c$export$2e2bcd8739ae039 = $9d9e3819b520b47c$var$ColumnTransitionToZone;
const $9d9e3819b520b47c$var$ttZoneHeight = (0, $iIzf3.minCardHeight) * 0.5 - 5;
const $9d9e3819b520b47c$var$ttZoneMargin = (0, $iIzf3.layout).adg3smallGutter * 0.5;
const $9d9e3819b520b47c$var$ttZoneMarginTop = -($9d9e3819b520b47c$var$ttZoneHeight + (0, $iIzf3.layout).adg3smallGutter); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9d9e3819b520b47c$var$TransitionToZoneControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-5ashvn-0"
})`position:sticky;text-align:center;pointer-events:all !important;top:0;margin:${$9d9e3819b520b47c$var$ttZoneMarginTop}px ${$9d9e3819b520b47c$var$ttZoneMargin}px ${$9d9e3819b520b47c$var$ttZoneMargin}px;border:2px solid ${(props)=>props.isDraggingOver ? `var(--ds-border-brand, ${(0, $1b343b038f6c23ec$exports).B300})` : `var(--ds-border-brand, ${(0, $1b343b038f6c23ec$exports).B100})`};background-color:${(props)=>props.isDraggingOver ? `var(--ds-background-selected-hovered, ${(0, $1b343b038f6c23ec$exports).B75})` : `var(--ds-background-selected, ${(0, $1b343b038f6c23ec$exports).B50})`};height:${$9d9e3819b520b47c$var$ttZoneHeight}px;line-height:${$9d9e3819b520b47c$var$ttZoneHeight}px;width:calc(100% - ${(0, $iIzf3.layout).adg3smallGutter * 1.5}px);z-index:10;border-radius:${(0, $iIzf3.layout).cardListRadius}px;`;
const $9d9e3819b520b47c$var$TransitionToZoneExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDraggingOver: isDraggingOver, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _y3gn1h6o _lcxv4shg _154iidpf _19pk13i4 _2hwx1y44 _otyr1y44 _18u01y44 _4t3ildb6 _vwz4ldb6 _1bsbzd3w _1pbyzo7u _2rkoi2wt",
            __cmplp.isDraggingOver ? "_19itoh42" : "_19itoh42",
            __cmplp.isDraggingOver ? "_bfhkwtfv" : "_bfhk29zg",
            __cmplp.className
        ])
    });
});
const $9d9e3819b520b47c$var$TransitionToZone = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $9d9e3819b520b47c$var$TransitionToZoneExperiment, $9d9e3819b520b47c$var$TransitionToZoneControl);

});

const $9f45f53a8ada9764$export$c28377001f14d9d = 350;
const $9f45f53a8ada9764$export$b2112118f902d683 = 45;

parcelRegister("4iQEO", function(module, exports) {

$parcel$export(module.exports, "ColumnTransitionZone", () => $e29b7c5ae96b7ec1$export$627a5fcef77c9034);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $ibIV3 = parcelRequire("ibIV3");


var $hKj4G = parcelRequire("hKj4G");

var $dkPd7 = parcelRequire("dkPd7");


var $iIzf3 = parcelRequire("iIzf3");

var $jYyfN = parcelRequire("jYyfN");
const $e29b7c5ae96b7ec1$export$627a5fcef77c9034 = ({ onDragOver: onDragOverProp, transitionId: transitionId, isTransitionAvailable: isTransitionAvailable, isHidden: isHidden, LabelComponent: LabelComponent = (0, $jYyfN.default), targetStatusName: targetStatusName, transitionName: transitionName, targetStatusCategory: targetStatusCategory, sourceStatus: sourceStatus, isTransitionGlobal: isTransitionGlobal, notAvailableMessage: notAvailableMessage, hideSourceStatusInLabel: hideSourceStatusInLabel, onTransitionSelection: onTransitionSelection, columnId: columnId, swimlaneId: swimlaneId })=>{
    const zoneRef = (0, $eUqFw.useRef)(null);
    const previousInputPosition = (0, $eUqFw.useRef)(null);
    const autobatch = (0, $hKj4G.useAutobatch)();
    const onDragOver = (0, $dkPd7.useEvent)(onDragOverProp);
    const [isDraggingOver, setIsDraggingOver] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (!zoneRef.current) return undefined;
        return (0, $ibIV3.dropTargetForElements)({
            element: zoneRef.current,
            getData: ()=>({
                    type: (0, $df03f3fe1f111432$export$2927f4d423091b16),
                    columnId: columnId,
                    swimlaneId: swimlaneId,
                    transitionId: transitionId
                }),
            onDragEnter: ()=>{
                onDragOver(transitionId, false);
                setIsDraggingOver(true);
            },
            onDrag: ({ location: { current: { input: input } } })=>{
                if (previousInputPosition.current?.x !== input.clientX || previousInputPosition.current?.y !== input.clientY) {
                    onDragOver(transitionId, true);
                    previousInputPosition.current = {
                        x: input.clientX,
                        y: input.clientY
                    };
                }
            },
            onDragLeave: (_args)=>{
                onDragOver(null, false);
                setIsDraggingOver(false);
            },
            onDrop: ()=>{
                if (isHidden || !isTransitionAvailable) return;
                autobatch(()=>onTransitionSelection(transitionId));
            }
        });
    }, [
        autobatch,
        columnId,
        isHidden,
        isTransitionAvailable,
        onTransitionSelection,
        swimlaneId,
        transitionId,
        onDragOver
    ]);
    const labelEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LabelComponent, {
        source: hideSourceStatusInLabel ? null : transitionName,
        sourceStatus: hideSourceStatusInLabel ? null : sourceStatus,
        target: targetStatusName,
        targetStatusCategory: targetStatusCategory,
        isTransitionAvailable: isTransitionAvailable,
        isTransitionGlobal: isTransitionGlobal,
        showMessage: false,
        notAvailableMessage: notAvailableMessage
    });
    const commonProps = {
        isDraggingOver: isDraggingOver,
        isTransitionAvailable: isTransitionAvailable
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e29b7c5ae96b7ec1$export$2de257552dc02bf, {
        ref: zoneRef,
        ...commonProps,
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.transition-zone.compiled-transition-zones-container",
        "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.transition-zone.compiled-transition-zones-container"
    }, labelEl);
};
const $e29b7c5ae96b7ec1$var$borderWidth = 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $e29b7c5ae96b7ec1$var$borderRadius = `${(0, $iIzf3.layout).cardListRadius}px`;
const $e29b7c5ae96b7ec1$var$getAvailableBorderColour = (props)=>props.isDraggingOver ? `var(--ds-border-brand, ${(0, $1b343b038f6c23ec$exports).B300})` : `var(--ds-border-focused, ${(0, $1b343b038f6c23ec$exports).B200})`;
const $e29b7c5ae96b7ec1$var$getDraggingBackgroundColour = (props)=>props.isDraggingOver ? `var(--ds-background-selected-hovered, ${(0, $1b343b038f6c23ec$exports).B75})` : `var(--ds-background-selected, ${(0, $1b343b038f6c23ec$exports).B50})`;
const $e29b7c5ae96b7ec1$var$getBorder = (props)=>({
        border: `${$e29b7c5ae96b7ec1$var$borderWidth}px solid ${!props.isTransitionAvailable ? `var(--ds-background-accent-red-subtler, ${(0, $1b343b038f6c23ec$exports).R75})` : $e29b7c5ae96b7ec1$var$getAvailableBorderColour(props)}`
    });
const $e29b7c5ae96b7ec1$var$getBackgroundColor = (props)=>({
        backgroundColor: `${!props.isTransitionAvailable ? `var(--ds-background-danger, ${(0, $1b343b038f6c23ec$exports).R50})` : $e29b7c5ae96b7ec1$var$getDraggingBackgroundColour(props)}`
    });
const $e29b7c5ae96b7ec1$export$2de257552dc02bf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTransitionAvailable: isTransitionAvailable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rkfzum": (0, $9t7rW.default)(`${$e29b7c5ae96b7ec1$var$borderWidth}px solid ${!__cmplp.isTransitionAvailable ? `var(--ds-background-accent-red-subtler, ${(0, $1b343b038f6c23ec$exports).R75})` : $e29b7c5ae96b7ec1$var$getAvailableBorderColour(__cmplp)}`),
            "--_1v6vhty": (0, $9t7rW.default)($e29b7c5ae96b7ec1$var$getDraggingBackgroundColour(__cmplp)),
            "--_1lnby5": (0, $9t7rW.default)($e29b7c5ae96b7ec1$var$borderRadius)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _2lx21bp4 _1tkeidpf _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _ca0q14y2 _u5f314y2 _n3td14y2 _19bv14y2 _19it31oo _lcxv4shg _1jc111eo _e6mdhnez _kh711qt3 _am38glyw",
            !__cmplp.isTransitionAvailable ? "_bfhktaeo" : "_bfhkikgw",
            __cmplp.className
        ])
    });
});
const $e29b7c5ae96b7ec1$export$7ed12d2a5241e393 = {
    getBackgroundColor: $e29b7c5ae96b7ec1$var$getBackgroundColor,
    getBorder: $e29b7c5ae96b7ec1$var$getBorder
};

});
parcelRegister("dkPd7", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => $e657ee26e376985d$export$90fc3a17d93f704c);

var $eUqFw = parcelRequire("eUqFw");
const $e657ee26e376985d$export$90fc3a17d93f704c = (callback)=>{
    const callbackRef = (0, $eUqFw.useRef)(callback);
    (0, $eUqFw.useLayoutEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    return (0, $eUqFw.useCallback)((...args)=>callbackRef.current(...args), []);
};

});

parcelRegister("jYyfN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cb30df01bb48e09$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5jod9 = parcelRequire("5jod9");

var $2EdmT = parcelRequire("2EdmT");

var $fdguH = parcelRequire("fdguH");

var $bEBof = parcelRequire("bEBof");


var $3ySoA = parcelRequire("3ySoA");

var $giAhk = parcelRequire("giAhk");

var $hqr61 = parcelRequire("hqr61");
const $3cb30df01bb48e09$var$ColumnTransitionLabel = /*#__PURE__*/ (0, $eUqFw.memo)(({ source: source, target: target, targetStatusCategory: targetStatusCategory, isTransitionAvailable: isTransitionAvailable, isTransitionGlobal: isTransitionGlobal, notAvailableMessage: notAvailableMessage, showMessage: showMessage, sourceStatus: sourceStatus, intl: { formatMessage: formatMessage } })=>{
    const shouldRenderSource = source || sourceStatus; /**
                                                      * check null against the source and the sourceStatus.
                                                      * if they are all null. Do not display the source and arrow
                                                      * e.g.
                                                      * label with source: TO DO -> IN PROGRESS
                                                      * label without source: IN PROGRESS
                                                      */ 
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cb30df01bb48e09$var$LabelPositioningWrapper, {
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.transition-zone.label.label-positioning-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cb30df01bb48e09$var$TransitionRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cb30df01bb48e09$var$InlineWrapper, null, shouldRenderSource && isTransitionGlobal && sourceStatus?.category ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
        category: sourceStatus.category,
        name: sourceStatus.name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, source)), shouldRenderSource && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cb30df01bb48e09$var$InlineWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5jod9))), {
        label: "arrow",
        spacing: "spacious",
        color: `var(--ds-icon, ${(0, $1b343b038f6c23ec$exports).N800})`,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdguH))),
        LEGACY_size: "small",
        LEGACY_primaryColor: `var(--ds-text, ${(0, $1b343b038f6c23ec$exports).N800})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cb30df01bb48e09$var$InlineFlex, null, !isTransitionAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cb30df01bb48e09$var$Img, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hqr61))),
        role: "presentation",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2EdmT))), {
        label: formatMessage(notAvailableMessage),
        color: `var(--ds-text-danger, ${(0, $1b343b038f6c23ec$exports).R500})`,
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bEBof))),
        LEGACY_size: "small",
        LEGACY_primaryColor: `var(--ds-text-danger, ${(0, $1b343b038f6c23ec$exports).R500})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
        category: targetStatusCategory,
        name: target,
        isFullWidth: !shouldRenderSource
    }))), !isTransitionAvailable && showMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cb30df01bb48e09$var$LabelRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cb30df01bb48e09$var$LabelMessage, null, formatMessage(notAvailableMessage))));
});
var $3cb30df01bb48e09$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($3cb30df01bb48e09$var$ColumnTransitionLabel);
const $3cb30df01bb48e09$var$LabelRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _p12f1osq _1bto1l2s _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cb30df01bb48e09$var$LabelPositioningWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1h6o _p12f1osq _1bto1l2s _1n261g80",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cb30df01bb48e09$var$InlineWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _p12fn7od _o572n7od _1bto1l2s _s7n4nkob _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cb30df01bb48e09$var$TransitionRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _s7n4nkob _p12f1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cb30df01bb48e09$var$InlineFlex = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _o572n7od _1bto1l2s _s7n4nkob _p12f1osq _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cb30df01bb48e09$var$Img = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i7vkz _1bsb7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cb30df01bb48e09$var$LabelMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _y3gn1h6o _11c81vlj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hqr61", function(module, exports) {
module.exports = new URL("rule.b492f5a7.svg", import.meta.url).toString();

});




parcelRegister("aL9gA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f37f08c0e21152a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2f37f08c0e21152a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    notAvailableMessage: {
        "id": "work-management-board.board.column.transition-zones.not-available-message",
        "defaultMessage": "A workflow rule prevents you from moving the issue this way."
    },
    notAvailableMessageIssueTermRefresh: {
        "id": "work-management-board.board.column.transition-zones.not-available-message-issue-term-refresh",
        "defaultMessage": "A workflow rule prevents you from moving the issue this way."
    }
});

});



parcelRegister("93B7g", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b3b550c20ac3c2a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lUg8E = parcelRequire("lUg8E");

var $3gQB3 = parcelRequire("3gQB3");

var $9xsX7 = parcelRequire("9xsX7");

var $jIR8w = parcelRequire("jIR8w");

var $jl1we = parcelRequire("jl1we");

var $8DxFe = parcelRequire("8DxFe");

var $kQAZu = parcelRequire("kQAZu");

var $gEmpR = parcelRequire("gEmpR");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4tyew = parcelRequire("4tyew");

var $jMP2a = parcelRequire("jMP2a");

var $ib4WI = parcelRequire("ib4WI");

var $4VjPN = parcelRequire("4VjPN");

var $eUIOu = parcelRequire("eUIOu");

var $4Z5qC = parcelRequire("4Z5qC");

var $bFk6h = parcelRequire("bFk6h");

var $gKXju = parcelRequire("gKXju");

var $cgK6s = parcelRequire("cgK6s");

var $5i3bo = parcelRequire("5i3bo");

var $iq40z = parcelRequire("iq40z");

var $1aTkE = parcelRequire("1aTkE");
const $7b3b550c20ac3c2a$var$ColumnCreate = ()=>{
    const { workflows: workflows } = (0, $iq40z.useWorkflowStoreState)();
    const isWorkflowOperationInProgress = (0, $cgK6s.useIsWorkflowOperationInProgress)();
    const groups = (0, $gKXju.useGroups)();
    const existingColumnNames = (0, $eUqFw.useMemo)(()=>groups.map(({ name: name })=>name), [
        groups
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isNoPermissionMessageOpen, setIsNoPermissionMessageOpen] = (0, $eUqFw.useState)();
    const [isMultipleWorkflowsMessageOpen, setIsMultipleWorkflowsMessageOpen] = (0, $eUqFw.useState)();
    const [isExceededIssueTypesMessageOpen, setIsExceededIssueTypesMessageOpen] = (0, $eUqFw.useState)();
    const { data: { issueTypes: issueTypes } } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const issueTypeId = issueTypes.find((issueType)=>issueType.hierarchyLevel !== -1)?.id;
    const createNewStatus = (0, $5i3bo.useCreateStatus)((0, $ib4WI.COLUMN_ACTION_ADD_EXPERIENCE));
    const { removeColumn: removeColumn } = (0, $iq40z.useWorkflowStoreActions)();
    const memoizedRemoveColumn = (0, $eUqFw.useCallback)(()=>removeColumn((0, $ib4WI.TEMPORARY_STATUS_ID)), [
        removeColumn
    ]);
    const { refetch: refetchBoardData } = (0, $bFk6h.useBoardData)();
    const project = (0, $kQAZu.useProject)();
    const canAdministerProject = project.permissions.administerProject;
    const hasMultipleWorkflows = workflows.length > 1;
    const hasExceededMaxIssueTypes = issueTypes.length > (0, $ib4WI.MAX_ISSUE_TYPES_COUNT);
    const validateStatus = (0, $eUqFw.useCallback)(({ statusName: statusName })=>!existingColumnNames.some((existingColumnName)=>existingColumnName.toUpperCase() === statusName.toUpperCase()), [
        existingColumnNames
    ]);
    const createNewColumn = (0, $eUqFw.useCallback)(async ({ statusName: statusName, statusCategory: statusCategory, issueTypeIdNotSubtask: issueTypeIdNotSubtask })=>{
        try {
            await createNewStatus({
                statusName: statusName,
                statusCategory: statusCategory,
                issueTypeIdNotSubtask: issueTypeIdNotSubtask
            });
        } catch (error) {
            memoizedRemoveColumn();
            throw error;
        } finally{
            refetchBoardData();
        }
    }, [
        createNewStatus,
        memoizedRemoveColumn,
        refetchBoardData
    ]);
    const createColumnModalProps = (0, $eUqFw.useMemo)(()=>{
        return {
            createStatus: createNewColumn,
            validateStatus: validateStatus,
            issueTypeIdNotSubtask: issueTypeId
        };
    }, [
        createNewColumn,
        issueTypeId,
        validateStatus
    ]);
    if (!canAdministerProject) // show button that will trigger no permission message for user without permission
    return $7b3b550c20ac3c2a$var$renderColumnCreateButtonWithMessage({
        isOpen: Boolean(isNoPermissionMessageOpen),
        setIsOpen: setIsNoPermissionMessageOpen,
        testId: 'work-management-board.ui.board.column-create.no-permission-button',
        label: formatMessage((0, $1aTkE.default).createStatusLabel),
        analyticsId: 'jwmColumnCreateNoPermission',
        MessageComponent: (0, $4VjPN.ContactAdminToModifyBoardMessage)
    });
    if (hasExceededMaxIssueTypes) return $7b3b550c20ac3c2a$var$renderColumnCreateButtonWithMessage({
        isOpen: Boolean(isExceededIssueTypesMessageOpen),
        setIsOpen: setIsExceededIssueTypesMessageOpen,
        testId: 'work-management-board.ui.board.column-create.is-exceeded-issue-types',
        label: formatMessage((0, $1aTkE.default).createStatusLabel),
        analyticsId: 'jwmColumnCreateExceededIssueTypes',
        MessageComponent: (0, $eUIOu.OpenProjectSettingsExceededIssueTypes)
    });
    if (hasMultipleWorkflows) return $7b3b550c20ac3c2a$var$renderColumnCreateButtonWithMessage({
        isOpen: Boolean(isMultipleWorkflowsMessageOpen),
        setIsOpen: setIsMultipleWorkflowsMessageOpen,
        testId: 'work-management-board.ui.board.column-create.has-multiple-workflows-button',
        label: formatMessage((0, $1aTkE.default).createStatusLabel),
        analyticsId: 'jwmColumnCreateMultipleWorkflows',
        MessageComponent: (0, $4Z5qC.OpenProjectSettingsMultipleWorkflows)
    });
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4tyew.ModalEntryPointIconButtonTrigger), {
        entryPoint: (0, $8DxFe.createColumnEntryPoint),
        entryPointProps: createColumnModalProps,
        interactionName: "jwmColumnCreate",
        appearance: "subtle",
        testId: "work-management-board.ui.board.column-create.create-column-button",
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3gQB3))), {
                label: "",
                spacing: "spacious",
                color: "currentColor",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9xsX7)))
            }),
        isDisabled: isWorkflowOperationInProgress,
        label: formatMessage((0, $1aTkE.default).createStatusLabel)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b3b550c20ac3c2a$var$SurfaceWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: formatMessage((0, $1aTkE.default).createStatusLabel)
    }, button)));
};
var $7b3b550c20ac3c2a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($7b3b550c20ac3c2a$var$ColumnCreate);
const $7b3b550c20ac3c2a$var$renderColumnCreateButtonWithMessage = ({ isOpen: isOpen, setIsOpen: setIsOpen, testId: testId, label: label, analyticsId: analyticsId, MessageComponent: MessageComponent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jIR8w.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b3b550c20ac3c2a$var$MessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MessageComponent, null)),
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b3b550c20ac3c2a$var$SurfaceWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        appearance: "subtle",
        testId: testId,
        "aria-label": label,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3gQB3))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        }),
        onClick: (_, analyticsEvent)=>{
            setIsOpen(true);
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, analyticsId);
        }
    }))); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7b3b550c20ac3c2a$var$SurfaceWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1sit _bfhkzxtc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7b3b550c20ac3c2a$var$MessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbuuw1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8DxFe", function(module, exports) {

$parcel$export(module.exports, "createColumnEntryPoint", () => $a55a144b30a8aad0$export$e69599a4ee2697d5);

var $14fpI = parcelRequire("14fpI");

var $4dIH4 = parcelRequire("4dIH4");

const $a55a144b30a8aad0$export$e69599a4ee2697d5 = (0, $4dIH4.createEntryPoint)({
    root: (0, $14fpI.JSResourceForInteraction)(()=>(parcelRequire("iXygQ")), {
        moduleId: "69f4ff7f"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iXygQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ist8R").then(()=>parcelRequire('1vxMN'));

});


parcelRegister("4tyew", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointIconButtonTrigger", () => $28aa714b196be5f6$export$7d379857be6c65e7);

var $eUqFw = parcelRequire("eUqFw");

var $kRXDJ = parcelRequire("kRXDJ");

var $6g2XI = parcelRequire("6g2XI");
function $28aa714b196be5f6$export$7d379857be6c65e7({ entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, modalTitle: modalTitle, modalProps: modalProps, useInternalModal: useInternalModal, ...buttonProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6g2XI.ModalEntryPointPressableTrigger), {
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        errorAttributes: errorAttributes,
        Fallback: Fallback,
        modalTitle: modalTitle,
        modalProps: modalProps,
        useInternalModal: useInternalModal
    }, ({ ref: ref })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRXDJ.default), {
            ref: ref,
            ...buttonProps
        }));
}

});
parcelRegister("6g2XI", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointPressableTrigger", () => $0e824343798e0aa9$export$defad645fcc21c0a);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7UnBG = parcelRequire("7UnBG");

var $6XIVS = parcelRequire("6XIVS");
var $7aTMt = parcelRequire("7aTMt");
var $eM7u6 = parcelRequire("eM7u6");
var $9jHtf = parcelRequire("9jHtf");
var $jLDTl = parcelRequire("jLDTl");

var $2Gub2 = parcelRequire("2Gub2");

var $kGQen = parcelRequire("kGQen");

var $ioLN0 = parcelRequire("ioLN0");

var $3qf87 = parcelRequire("3qf87");

var $ln3W8 = parcelRequire("ln3W8");

var $fwgIU = parcelRequire("fwgIU");

var $2tNPJ = parcelRequire("2tNPJ");
const $0e824343798e0aa9$var$emptyObject = {};
function $0e824343798e0aa9$export$defad645fcc21c0a({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, title: title, modalProps: modalProps, useInternalModal: useInternalModal = false }) {
    const { openModal: openModal } = (0, $eUqFw.useContext)((0, $3qf87.ModalContext));
    const environmentProvider = (0, $ln3W8.useJiraRelayEnvironmentProvider)();
    // eslint-disable-next-line jira/ufo/valid-labels
    const pressTracing = (0, $fwgIU.default)(interactionName ?? '');
    const load = (0, $eUqFw.useCallback)(()=>(0, $iWLL0.loadEntryPoint)(environmentProvider, entryPoint, // @ts-expect-error TS cannot infer that emptyObject is the correct params
        // type for TEntryPoint even when performing an explicit undefined check
        entryPointParams ?? $0e824343798e0aa9$var$emptyObject), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onBeforeLoad = (0, $eUqFw.useCallback)(()=>{
        if (interactionName) pressTracing();
    }, [
        interactionName,
        pressTracing
    ]);
    const onLoad = (0, $eUqFw.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal })=>{
            const onClose = ()=>{
                entryPointProps?.onClose?.();
                closeModal();
                dispose();
            };
            const defaultFallbackInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jHtf.default), null, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jLDTl.default), null, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Gub2.default), {
                grow: "fill"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7UnBG.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7aTMt.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7UnBG.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7UnBG.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7UnBG.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eM7u6.default), null));
            const defaultFallback = useInternalModal ? defaultFallbackInner : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6XIVS.default), {
                onClose: closeModal,
                width: modalProps?.width,
                height: modalProps?.height
            }, defaultFallbackInner);
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ioLN0.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorAttributes: errorAttributes,
                errorFallback: "flag",
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                // @ts-expect-error Need to fix the types on this
                id: entryPoint.root.getModuleName?.() ?? 'unknown',
                placeholderName: "modal-entry-point-pressable-trigger-container",
                // @ts-expect-error Some type mismatch, should fix it one day
                runtimeProps: {
                    ...entryPointProps ?? $0e824343798e0aa9$var$emptyObject,
                    onClose: onClose
                }
            });
            return useInternalModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6XIVS.default), {
                ...modalProps,
                onClose: onClose
            }, container)) : container;
        });
    }, [
        entryPoint,
        entryPointProps,
        errorAttributes,
        Fallback,
        openModal,
        title,
        modalProps,
        useInternalModal
    ]);
    const triggerRef = (0, $2tNPJ.usePressablePreloadRef)({
        load: load,
        onBeforeLoad: onBeforeLoad,
        onLoad: onLoad
    });
    return children({
        ref: triggerRef
    });
}

});
parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("2tNPJ", function(module, exports) {

$parcel$export(module.exports, "usePressablePreloadRef", () => $a271f016a6ca8b83$export$1ff47f24e06a5d2d);

var $eUqFw = parcelRequire("eUqFw");
const $a271f016a6ca8b83$var$PRELOAD_MAX_AGE = 2000;
const $a271f016a6ca8b83$var$TIME_TO_INTENT = 200;
function $a271f016a6ca8b83$export$1ff47f24e06a5d2d({ load: load, onBeforeLoad: onBeforeLoad, onLoad: onLoad }) {
    const ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const clickListener = ()=>{
            clearPreloadTimeouts();
            onBeforeLoad();
            onLoad(loadReference());
        };
        const mouseDownListener = ()=>{
            clearPreloadTimeouts();
            loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $a271f016a6ca8b83$var$PRELOAD_MAX_AGE);
            }, $a271f016a6ca8b83$var$TIME_TO_INTENT);
        };
        el.addEventListener('click', clickListener);
        el.addEventListener('mousedown', mouseDownListener);
        el.addEventListener('mouseenter', preloadReference);
        el.addEventListener('mouseleave', cancelPreload);
        return ()=>{
            cancelPreload();
            el.removeEventListener('click', clickListener);
            el.removeEventListener('mousedown', mouseDownListener);
            el.removeEventListener('mouseenter', preloadReference);
            el.removeEventListener('mouseleave', cancelPreload);
        };
    }, [
        load,
        onBeforeLoad,
        onLoad
    ]);
    return ref;
}

});



parcelRegister("5i3bo", function(module, exports) {

$parcel$export(module.exports, "useCreateStatus", () => $34264d8fafbe2858$export$c2ab89f2f8598b1f);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $3wNTK = parcelRequire("3wNTK");

var $k8Qyf = parcelRequire("k8Qyf");

var $dWLk9 = parcelRequire("dWLk9");

var $ib4WI = parcelRequire("ib4WI");

var $cgK6s = parcelRequire("cgK6s");

var $iONAM = parcelRequire("iONAM");

var $2QqK4 = parcelRequire("2QqK4");
const $34264d8fafbe2858$export$c2ab89f2f8598b1f = (experienceDetails)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { createWorkflowStatusforSingleWorkflow: createWorkflowStatusforSingleWorkflow } = (0, $3wNTK.useWorkflowsV2)();
    const startAddOperation = (0, $cgK6s.useStartAddOperation)();
    const stopWorkflowOperationInProgress = (0, $cgK6s.useStopWorkflowOperationInProgress)();
    const startExperience = (0, $4G5xU.useExperienceStart)(experienceDetails);
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)(experienceDetails);
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)(experienceDetails);
    const abortExperience = (0, $4G5xU.useExperienceAbort)(experienceDetails);
    const project = (0, $kQAZu.useProject)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const createNewStatus = (0, $eUqFw.useCallback)(async ({ statusName: statusName, statusCategory: statusCategory, issueTypeIdNotSubtask: issueTypeIdNotSubtask })=>{
        startAddOperation(String((0, $ib4WI.TEMPORARY_STATUS_ID)));
        startExperience();
        try {
            if (issueTypeIdNotSubtask == null) throw new (0, $iONAM.IssueTypeIdNotFoundError)('issueTypeIdNotSubtask is required but was not found.');
            await createWorkflowStatusforSingleWorkflow({
                statusName: statusName,
                statusCategory: statusCategory,
                cloudId: cloudId,
                projectId: String(project.id),
                issueTypeId: issueTypeIdNotSubtask,
                onSuccess: markExperienceSuccess
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            showFlag((0, $iONAM.getStatusActionFailedFlag)({
                messageTitle: (0, $2QqK4.default).errorFlagTitleAddColumn,
                action: 'add',
                error: error,
                issueTypeIdNotSubtask: issueTypeIdNotSubtask,
                projectKey: project.key,
                statusCode: error?.response?.status
            }));
            (0, $iONAM.failStatusExperience)({
                markExperienceFailed: markExperienceFailed,
                abortExperience: abortExperience,
                error: error,
                errorMessage: 'Failed to validate and update workflow'
            });
            throw error;
        } finally{
            stopWorkflowOperationInProgress();
        }
    }, [
        startAddOperation,
        startExperience,
        createWorkflowStatusforSingleWorkflow,
        cloudId,
        markExperienceSuccess,
        showFlag,
        markExperienceFailed,
        abortExperience,
        stopWorkflowOperationInProgress,
        project
    ]);
    return createNewStatus;
};

});
parcelRegister("2QqK4", function(module, exports) {

$parcel$export(module.exports, "default", () => $033a9f677c1816bd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $033a9f677c1816bd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorFlagTitleAddColumn: {
        "id": "work-management-board.controllers.workflow-actions.add-column.error-flag-title-add-column",
        "defaultMessage": "Unable to create column"
    }
});

});


parcelRegister("1aTkE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e1125331f31f5b2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9e1125331f31f5b2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noPermissionToModify: {
        "id": "work-management-board.board.column-create.no-permission-to-modify",
        "defaultMessage": "Contact your admin to make changes to the board"
    },
    createStatusLabel: {
        "id": "work-management-board.board.column-create.create-status-label",
        "defaultMessage": "Create status"
    }
});

});


parcelRegister("1trHT", function(module, exports) {

$parcel$export(module.exports, "EmptyBoardComponent", () => $49d4432f08b2a361$export$7f64d91ed0b9fc41);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $jGcn0 = parcelRequire("jGcn0");

var $lGiWG = parcelRequire("lGiWG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $liMZ5 = parcelRequire("liMZ5");

var $1p0YA = parcelRequire("1p0YA");
const $49d4432f08b2a361$export$7f64d91ed0b9fc41 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const emptyBoardTitle = formatMessage((0, $1p0YA.default).emptyBoardTitle);
    const emptyBoardDescription = formatMessage((0, $1p0YA.default).emptyBoardDescription);
    const buttonTitle = formatMessage((0, $1p0YA.default).emptyBoardCreateItem);
    const [, setInlineCreateParam] = (0, $lB25E.useQueryParam)((0, $jGcn0.INLINE_CREATE_PARAM));
    const handleItemCreateClick = (0, $eUqFw.useCallback)((_e)=>{
        setInlineCreateParam('true');
    }, [
        setInlineCreateParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49d4432f08b2a361$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49d4432f08b2a361$var$EmptyBoardImageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $liMZ5.Illustration), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $49d4432f08b2a361$var$emptyBoardTextContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49d4432f08b2a361$var$Header, null, emptyBoardTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, emptyBoardDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        appearance: "primary",
        testId: "work-management-board.ui.board.empty-state.today",
        onClick: handleItemCreateClick
    }, buttonTitle));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49d4432f08b2a361$var$MessageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1kdj _vchhusvi _y3gn1h6o _1yt41ejb _11q71xtf _2rkopd34",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49d4432f08b2a361$var$EmptyBoardImageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
const $49d4432f08b2a361$var$emptyBoardTextContainerStyles = (0, $8Vv3m.xcss)({
    marginBottom: 'space.300',
    marginTop: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49d4432f08b2a361$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1c2q",
            __cmplp.className
        ])
    });
});

});
parcelRegister("liMZ5", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $c9ea171949fd4dce$export$d43c2e2ca9b2c105);

var $eUqFw = parcelRequire("eUqFw");

var $gGtKh = parcelRequire("gGtKh");

var $dyfd9 = parcelRequire("dyfd9");

const $c9ea171949fd4dce$var$LazyIllustration = (0, $dyfd9.lazyForPaint)(()=>(parcelRequire("9VSh2")), {
    moduleId: "./src/packages/business/board/view/src/ui/board/empty-state/illustration/main.tsx"
});
const $c9ea171949fd4dce$export$d43c2e2ca9b2c105 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "illustration",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9ea171949fd4dce$var$LazyIllustration, null));

});
parcelRegister("9VSh2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("eKTkT").then(()=>parcelRequire('h9qIC'));

});


parcelRegister("1p0YA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c065432f6984cb03$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c065432f6984cb03$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyBoardTitle: {
        "id": "work-management-board.board.empty-state.empty-board-title",
        "defaultMessage": "Visualize your work with a board"
    },
    emptyBoardDescription: {
        "id": "work-management-board.board.empty-state.empty-board-description",
        "defaultMessage": "Track, organize and prioritize your team\u2019s work. Get started by creating an item for your team. "
    },
    emptyBoardCreateItem: {
        "id": "work-management-board.board.empty-state.empty-board-create-item",
        "defaultMessage": "Create an item"
    }
});

});


parcelRegister("2TjqC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c54a0bc054f9270$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $9pngN = parcelRequire("9pngN");

var $kAck0 = parcelRequire("kAck0");

var $jK1pm = parcelRequire("jK1pm");

var $gKXju = parcelRequire("gKXju");
const $6c54a0bc054f9270$var$MINIMAP_MAP_HEIGHT = 36;
const $6c54a0bc054f9270$var$MIN_SCALING_FACTOR = 14;
const $6c54a0bc054f9270$var$MAX_MAP_WIDTH = 100;
const $6c54a0bc054f9270$var$SHOW_MAP_RATIO = 1.1;
const $6c54a0bc054f9270$var$getScalingFactor = (updatedScrollWidth)=>{
    const maxSizeScalingFactor = updatedScrollWidth / $6c54a0bc054f9270$var$MAX_MAP_WIDTH;
    return Math.max($6c54a0bc054f9270$var$MIN_SCALING_FACTOR, maxSizeScalingFactor);
};
const $6c54a0bc054f9270$var$Minimap = ({ boardContentElement: boardContentElement, scrollElement: scrollElement })=>{
    const [scrollLeft, setScrollLeft] = (0, $eUqFw.useState)(0);
    const [scrollWrapperWidth, setScrollWrapperWidth] = (0, $eUqFw.useState)(scrollElement?.clientWidth ?? 0);
    const [contentWrapperWidth, setContentWrapperWidth] = (0, $eUqFw.useState)(boardContentElement?.clientWidth ?? 0);
    const [isDragging, setIsDragging] = (0, $eUqFw.useState)(false);
    const [mouseStart, setMouseStart] = (0, $eUqFw.useState)(null);
    const [initialOffset, setInitialOffset] = (0, $eUqFw.useState)(0);
    const innerViewRef = (0, $eUqFw.useRef)(null);
    const groups = (0, $gKXju.useGroups)();
    const scalingFactor = $6c54a0bc054f9270$var$getScalingFactor(contentWrapperWidth);
    const outerWidth = contentWrapperWidth / scalingFactor;
    const innerWidth = scrollWrapperWidth / scalingFactor;
    const innerOffset = scrollLeft / scalingFactor;
    const onMouseDown = (0, $eUqFw.useCallback)((e)=>{
        if (e.button === 0) {
            setIsDragging(true);
            setMouseStart(e.clientX);
            setInitialOffset(innerOffset);
        }
    }, [
        innerOffset
    ]);
    const onMouseUp = (0, $eUqFw.useCallback)(()=>{
        if (isDragging) setIsDragging(false);
    }, [
        isDragging
    ]);
    const setHorizontalScroll = (0, $eUqFw.useCallback)((newOffset)=>{
        scrollElement?.scrollTo(newOffset, scrollElement?.scrollTop);
    }, [
        scrollElement
    ]);
    const onScroll = (0, $eUqFw.useCallback)((newOffset)=>{
        const newScalingFactor = $6c54a0bc054f9270$var$getScalingFactor(contentWrapperWidth);
        setHorizontalScroll(newOffset * newScalingFactor);
    }, [
        contentWrapperWidth,
        setHorizontalScroll
    ]);
    const onMouseMove = (0, $eUqFw.useCallback)((e)=>{
        if (isDragging && mouseStart !== null) {
            const mouseCurrent = e.clientX;
            onScroll(initialOffset + mouseCurrent - mouseStart);
        }
    }, [
        initialOffset,
        isDragging,
        mouseStart,
        onScroll
    ]);
    const cleanupListeners = (0, $eUqFw.useCallback)(()=>{
        if (typeof document !== 'undefined') {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        }
    }, [
        onMouseMove,
        onMouseUp
    ]);
    const updateInnerViewPosition = (0, $eUqFw.useCallback)(()=>{
        if (innerViewRef.current) innerViewRef.current.style.marginLeft = `${innerOffset}px`;
    }, [
        innerOffset
    ]);
    const handleMinimapRef = (0, $eUqFw.useCallback)((ref)=>{
        innerViewRef.current = ref;
        updateInnerViewPosition();
    }, [
        updateInnerViewPosition
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const handleScroll = ()=>{
            setScrollLeft(scrollElement?.scrollLeft ?? 0);
        };
        const scrollElementResizeObserver = new ResizeObserver((entries)=>{
            for (const entry of entries)setScrollWrapperWidth(entry.contentRect.width);
        });
        if (scrollElement) scrollElementResizeObserver.observe(scrollElement);
        const boardContentElementResizeObserver = new ResizeObserver((entries)=>{
            for (const entry of entries)setContentWrapperWidth(entry.contentRect.width);
        });
        if (boardContentElement) boardContentElementResizeObserver.observe(boardContentElement);
        scrollElement?.addEventListener('scroll', handleScroll);
        return ()=>{
            scrollElement?.removeEventListener('scroll', handleScroll);
            scrollElementResizeObserver.disconnect();
            boardContentElementResizeObserver.disconnect();
        };
    }, [
        scrollElement,
        boardContentElement
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isDragging) {
            if (typeof document !== 'undefined') {
                document.addEventListener('mousemove', onMouseMove);
                document.addEventListener('mouseup', onMouseUp);
            }
        } else cleanupListeners();
        return ()=>{
            cleanupListeners();
        };
    }, [
        cleanupListeners,
        isDragging,
        onMouseMove,
        onMouseUp
    ]);
    if (!(contentWrapperWidth / scrollWrapperWidth > $6c54a0bc054f9270$var$SHOW_MAP_RATIO)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-board-minimap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9pngN.JiraBottomRightCornerOutlet), {
        orderFromRight: 2,
        id: "business-board-minimap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c54a0bc054f9270$var$MinimapWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $6c54a0bc054f9270$var$RelativePositionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c54a0bc054f9270$var$InnerViewStyle, {
        innerWidth: innerWidth,
        isDragging: isDragging,
        onMouseDown: onMouseDown,
        onMouseMove: onMouseMove,
        onMouseUp: onMouseUp,
        ref: handleMinimapRef
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c54a0bc054f9270$var$OuterViewStyle, {
        outerWidth: outerWidth
    }, groups.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kAck0.default), {
            key: group.id
        }))))));
};
const $6c54a0bc054f9270$var$RelativePositionStyles = (0, $8Vv3m.xcss)({
    position: 'relative'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c54a0bc054f9270$var$MinimapWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71bhr _2rkogqwt _16qsacve _1e0c116y _1yt412x7",
            __cmplp.className
        ])
    });
});
const $6c54a0bc054f9270$var$OuterViewStyle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { outerWidth: outerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_qlyx8j": (0, $9t7rW.default)(`${__cmplp.outerWidth}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19it1dk9 _2rko1l7b _1e0c1txw _4t3i14no _1bsbrmio",
            __cmplp.className
        ])
    });
});
const $6c54a0bc054f9270$var$InnerViewStyle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragging: isDragging, innerWidth: innerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1u36uo4": (0, $9t7rW.default)(`${__cmplp.innerWidth}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itypf5 _2rko1l7b _80om15ng _4t3i14no _1ltv1n1a _kqswstnw _154i1n1a _1bsb1545",
            __cmplp.isDragging ? "_1h6d194a" : "_1h6d1gvp",
            __cmplp.className
        ])
    });
});
var $6c54a0bc054f9270$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($6c54a0bc054f9270$var$Minimap);

});
parcelRegister("9pngN", function(module, exports) {

$parcel$export(module.exports, "JiraBottomRightCornerOutlet", () => $c006a225e0f72214$export$ee54e6ed235df65e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lEfVV = parcelRequire("lEfVV");

var $5GxEP = parcelRequire("5GxEP");

var $71g00 = parcelRequire("71g00");
const $c006a225e0f72214$var$OutletWithPortal = ({ orderFromRight: orderFromRight, children: children, id: id })=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const portalWrapper = (0, $eUqFw.useRef)(document.createElement('div'));
    const container = (0, $71g00.useBottomRightCornerContainer)();
    if (!container) throw new Error('GlobalBottomRightContainer could not be found. Please ensure that this container was rendered on the page.');
    const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, $71g00.useBottomRightCornerActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (container) {
            const indexToRender = insertBottomRightCornerPortal({
                orderFromRight: orderFromRight,
                id: id
            });
            // @ts-expect-error - TS2538 - Type 'Promise<void>' cannot be used as an index type. | TS2538 - Type 'void' cannot be used as an index type.
            container.insertBefore(portalWrapper.current, container.children[indexToRender]);
        }
        // required as eslint complains about the ref in cleanup function
        const portalCurrent = portalWrapper.current;
        return ()=>{
            container?.removeChild(portalCurrent);
            removeBottomRightCornerPortal(id);
        };
    }, [
        container,
        id,
        orderFromRight,
        insertBottomRightCornerPortal,
        removeBottomRightCornerPortal
    ]);
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c006a225e0f72214$var$StyledOutlet, null, children), portalWrapper.current);
};
const $c006a225e0f72214$export$ee54e6ed235df65e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "bottom-right-corner-outlet",
        packageName: "jira-bottom-right-corner-controller",
        extraEventData: {
            portalId: props.id
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c006a225e0f72214$var$OutletWithPortal, props));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c006a225e0f72214$var$StyledOutlet = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1vgl1wug _1ko9pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kAck0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e202a8c3d4fe742$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");


var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e202a8c3d4fe742$var$SC1Control = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1wm91pe-0"
})({
    borderRadius: '3px',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-neutral, ${(0, $1b343b038f6c23ec$exports).N30})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + div': {
        marginLeft: "var(--ds-space-025, 2px)"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e202a8c3d4fe742$var$SC1Experiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _16jlkb7n _1o9zidpf _i0dl1wug _11q71yrq _1s87v77o",
            __cmplp.className
        ])
    });
});
const $7e202a8c3d4fe742$var$SC1 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $7e202a8c3d4fe742$var$SC1Experiment, $7e202a8c3d4fe742$var$SC1Control);
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$7e202a8c3d4fe742$export$2e2bcd8739ae039 = $7e202a8c3d4fe742$var$SC1;

});



parcelRegister("9FDwo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1587c654124b8a29$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $RZgA1 = parcelRequire("RZgA1");

var $8rPxE = parcelRequire("8rPxE");

var $d9gm1 = parcelRequire("d9gm1");

var $bSsl1 = parcelRequire("bSsl1");

var $eCCst = parcelRequire("eCCst");

var $cRKsH = parcelRequire("cRKsH");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $iSNkS = parcelRequire("iSNkS");

var $jK1pm = parcelRequire("jK1pm");

var $8rQuz = parcelRequire("8rQuz");

var $2b5eO = parcelRequire("2b5eO");

var $iq40z = parcelRequire("iq40z");

var $dZHFc = parcelRequire("dZHFc");

var $aY8Rm = parcelRequire("aY8Rm");

var $72Gha = parcelRequire("72Gha");
const $1587c654124b8a29$var$MORE_MENU_MIN_WIDTH = 260;
const $1587c654124b8a29$var$WORKFLOWS_MENU_WIDTH = 320;
const $1587c654124b8a29$var$HIDDEN_QUICKFILTERS = [
    'DONE',
    'ACTIVE_SPRINTS'
];
const $1587c654124b8a29$var$ALLOWED_FIELD_TYPES = new Set([
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $lO4Or.CATEGORY_TYPE),
    (0, $lO4Or.COMPONENTS_TYPE),
    (0, $lO4Or.LABELS_TYPE),
    (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.REPORTER_TYPE),
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.USER_CF_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    (0, $lO4Or.PARENT_TYPE)
]);
const $1587c654124b8a29$var$ALLOWED_FIELD_TYPES_OLD = new Set([
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $lO4Or.CATEGORY_TYPE),
    (0, $lO4Or.COMPONENTS_TYPE),
    (0, $lO4Or.LABELS_TYPE),
    (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.REPORTER_TYPE),
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.USER_CF_TYPE),
    (0, $lO4Or.STATUS_TYPE)
]);
const $1587c654124b8a29$var$Header = ()=>{
    const { isShareButtonEnabled: isShareButtonEnabled, inviteButtonInteraction: inviteButtonInteraction, isPresenceEnabled: isPresenceEnabled } = (0, $2b5eO.useJWMBoardFeatures)();
    const { workflows: workflows } = (0, $iq40z.useWorkflowStoreState)();
    const hasMultipleWorkflows = workflows.length > 1;
    const moreMenuContent = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'closeMenu' implicitly has an 'any' type.
    (closeMenu)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $72Gha.MoreMenuContent), {
            useCloseMenu: closeMenu ?? (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        }), []);
    const shareButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eCCst.JWMShareButton), {
        shareTitle: (0, $aY8Rm.default).shareTitle,
        integrationType: (0, $iSNkS.integrationTypes).BOARD,
        shareContentType: "board"
    });
    const searchBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9gm1.SimpleSearchField), {
        placeholder: (0, $aY8Rm.default).searchBoardLabel,
        view: "board"
    });
    const addPeopleWithPresence = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bSsl1.default), {
        view: "board",
        allowedFieldTypes: (0, $eI5EY.fg)('jwm_board_implement_parent_filter') ? $1587c654124b8a29$var$ALLOWED_FIELD_TYPES : $1587c654124b8a29$var$ALLOWED_FIELD_TYPES_OLD,
        isPresenceEnabledInContext: isPresenceEnabled,
        isOpenNewTabOnClick: inviteButtonInteraction === 'openNewTab',
        allowCustomFields: (0, $eI5EY.fg)('jira_filter-fix_filter_by_custom_fields_and_avatar')
    });
    const shareActionButton = isShareButtonEnabled && shareButton;
    const filters = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8rPxE.Filters), {
        view: "board",
        allowedFieldTypes: (0, $eI5EY.fg)('jwm_board_implement_parent_filter') ? $1587c654124b8a29$var$ALLOWED_FIELD_TYPES : $1587c654124b8a29$var$ALLOWED_FIELD_TYPES_OLD,
        hiddenQuickFilters: $1587c654124b8a29$var$HIDDEN_QUICKFILTERS,
        allowCustomFields: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-board-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RZgA1.ActionsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RZgA1.LeftActionsWrapper), null, searchBar, addPeopleWithPresence, (0, $8rQuz.isVisualRefreshEnabled)() && filters), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RZgA1.RightActionsWrapper), null, !(0, $8rQuz.isVisualRefreshEnabled)() && !(0, $eI5EY.fg)('common_project_actions_menu') && shareActionButton, !(0, $8rQuz.isVisualRefreshEnabled)() && filters, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dZHFc.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cRKsH.default), {
        renderContent: moreMenuContent,
        minWidth: hasMultipleWorkflows ? $1587c654124b8a29$var$WORKFLOWS_MENU_WIDTH : $1587c654124b8a29$var$MORE_MENU_MIN_WIDTH
    }))));
};
var $1587c654124b8a29$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($1587c654124b8a29$var$Header);

});
parcelRegister("RZgA1", function(module, exports) {

$parcel$export(module.exports, "ActionsWrapper", () => $2a4eb501d360abec$export$c8223871eecc8f3a);
$parcel$export(module.exports, "ActionsWrapperStyled", () => $2a4eb501d360abec$export$ac9cdc71f29d2899);
$parcel$export(module.exports, "LeftActionsWrapper", () => $2a4eb501d360abec$export$42cb1c7ab389bf4d);
$parcel$export(module.exports, "RightActionsWrapper", () => $2a4eb501d360abec$export$4aa2cd250ec24dcc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $8rQuz = parcelRequire("8rQuz");

var $hSCS8 = parcelRequire("hSCS8");
const $2a4eb501d360abec$export$c8223871eecc8f3a = ({ children: children, testId: testId })=>{
    const [{ content: content }] = (0, $hSCS8.useSidebar)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a4eb501d360abec$export$ac9cdc71f29d2899, {
        sidebarOpen: !!content,
        "data-testid": testId,
        isVisualRefreshEnabledFG: (0, $8rQuz.isVisualRefreshEnabled)()
    }, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a4eb501d360abec$var$CenterAlignedWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $2a4eb501d360abec$export$ac9cdc71f29d2899 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $2a4eb501d360abec$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_10qff79": (0, $9t7rW.default)(`0 ${__cmplp.sidebarOpen ? 0 : "var(--ds-space-negative-300, -24px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-negative-300, -24px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tke1ylp _18s8l1uc _1n261g80 _bfhk1ml8 _18k9kjed",
            __cmplp.isVisualRefreshEnabledFG ? "_1yt41big" : "_1yt46hdp",
            __cmplp.className
        ])
    });
});
const $2a4eb501d360abec$export$42cb1c7ab389bf4d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $2a4eb501d360abec$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $2a4eb501d360abec$export$4aa2cd250ec24dcc = $2a4eb501d360abec$var$CenterAlignedWrapper;

});

parcelRegister("8rPxE", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $4a948cec7cd2ee06$export$92a576f896a9bf72);

var $eUqFw = parcelRequire("eUqFw");

var $eruWR = parcelRequire("eruWR");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $jK1pm = parcelRequire("jK1pm");

var $jpXBE = parcelRequire("jpXBE");

var $fvzkg = parcelRequire("fvzkg");

var $jWIW7 = parcelRequire("jWIW7");

var $9GlEj = parcelRequire("9GlEj");

var $27zPy = parcelRequire("27zPy");

var $6M6Pf = parcelRequire("6M6Pf");
const $4a948cec7cd2ee06$var$hiddenQuickFiltersDefault = [
    'ACTIVE_SPRINTS'
];
const $4a948cec7cd2ee06$export$92a576f896a9bf72 = /*#__PURE__*/ (0, $eUqFw.memo)(({ view: view, allowedFieldTypes: inputAllowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, hiddenQuickFilters: hiddenQuickFilters = $4a948cec7cd2ee06$var$hiddenQuickFiltersDefault, allowCustomFields: allowCustomFields, allowSavedFilters: allowSavedFilters = true, handleHasFiltersApplied: handleHasFiltersApplied, appearance: appearance })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const allowedFieldTypes = (0, $jWIW7.useAllowedFieldTypes)(inputAllowedFieldTypes);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const close = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const toggle = (0, $eUqFw.useCallback)(()=>{
        setIsOpen((prevIsOpen)=>!prevIsOpen);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'jwmFilterButton clicked');
    }, [
        createAnalyticsEvent
    ]);
    const { quickFilters: quickFilters, persistQuickFilters: setQuickFilters } = (0, $9GlEj.useQuickFilters)();
    const { filters: filters, fieldConfig: fieldConfig, customFieldsLoader: customFieldsLoader, hasFilterError: hasFilterError, setFilters: setFilters } = (0, $fvzkg.useDeserialiseJqlFiltersWithContext)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allowCustomFields: allowCustomFields
    });
    const count = Object.values(filters).flat().length + Object.values(quickFilters).filter((value)=>value).length;
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('timeline-collapse-expand-all_61d00') && handleHasFiltersApplied) handleHasFiltersApplied(count);
    }, [
        count,
        handleHasFiltersApplied
    ]);
    if ((0, $eI5EY.fg)('native_goals_integration_on_list_view')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jpXBE.useGoalsFilterAnalyticsEvent)({
        filters: filters,
        view: view
    });
    const hasFiltersApplied = count > 0 || hasFilterError;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eruWR.default), {
        isOpen: isOpen,
        onClose: close,
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27zPy.MenuContent), {
                "data-testid": "business-filters.ui.filters.menu-content",
                count: count,
                fieldConfig: fieldConfig,
                filters: filters,
                quickFilters: quickFilters,
                setQuickFilters: setQuickFilters,
                setFilters: setFilters,
                hiddenQuickFilters: hiddenQuickFilters,
                view: view,
                allowCustomFields: allowCustomFields,
                allowSavedFilters: allowSavedFilters,
                hasFilterError: hasFilterError
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M6Pf.Trigger), {
                ...triggerProps,
                ...(0, $eI5EY.fg)('jira-calendar-business-theme') && {
                    appearance: appearance
                },
                count: count,
                hasFiltersApplied: hasFiltersApplied,
                isSelected: isOpen,
                onClick: toggle
            }),
        shouldRenderToParent: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds'),
        strategy: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds') ? 'absolute' : undefined
    }), customFieldsLoader));
});

});
parcelRegister("jpXBE", function(module, exports) {

$parcel$export(module.exports, "useGoalsFilterAnalyticsEvent", () => $bf0eb06c2610c94c$export$c9b2aef46b42c898);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $hLW3I = parcelRequire("hLW3I");
const $bf0eb06c2610c94c$export$c9b2aef46b42c898 = ({ filters: filters, view: view })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const { data: filterFields } = (0, $hLW3I.useFilterFields)();
    const goalField = (0, $eUqFw.useMemo)(()=>filterFields.find((field)=>field.type === (0, $lO4Or.GOALS_CF_TYPE)), [
        filterFields
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (goalField && filters[goalField.id]) {
            const goalsFilter = filters[goalField.id];
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'goalsFilter applied', {
                source: view,
                goalsCount: Array.isArray(goalsFilter) ? goalsFilter.length : 0
            });
        }
    }, [
        createAnalyticsEvent,
        filters,
        goalField,
        view
    ]);
};

});

parcelRegister("27zPy", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $d758afbde8c38bbf$export$479f0f2f71193efe);

var $eUqFw = parcelRequire("eUqFw");

var $gGtKh = parcelRequire("gGtKh");

var $dyfd9 = parcelRequire("dyfd9");

var $cqv89 = parcelRequire("cqv89");

var $hEiVl = parcelRequire("hEiVl");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d758afbde8c38bbf$var$LazyMenuContent = (0, $dyfd9.lazy)(()=>(parcelRequire("hdvyS")), {
    moduleId: "./src/packages/business/shared/components/filters/src/ui/filters/menu-content/main.tsx"
});
const $d758afbde8c38bbf$export$479f0f2f71193efe = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hEiVl.DropdownWrapper), {
        "data-testid": "business-filters.ui.filters.menu-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "menu-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cqv89.MenuFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d758afbde8c38bbf$var$LazyMenuContent, props)));

});
parcelRegister("cqv89", function(module, exports) {

$parcel$export(module.exports, "MenuFallback", () => $d72c10a0e4505968$export$1198e585d599d03);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bBdMg = parcelRequire("bBdMg");
const $d72c10a0e4505968$export$1198e585d599d03 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d72c10a0e4505968$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bBdMg.default), {
        size: "medium",
        testId: "business-filters.common.ui.menu-fallback.spinner"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d72c10a0e4505968$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1yt4pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hEiVl", function(module, exports) {

$parcel$export(module.exports, "DropdownWrapper", () => $5348b95debef5641$export$5f7211d21bfdae05);
$parcel$export(module.exports, "ScrollableContent", () => $5348b95debef5641$export$6c560fdadeb11d78);
$parcel$export(module.exports, "DropdownHeaderWrapper", () => $5348b95debef5641$export$e23294aded7a8a49);
$parcel$export(module.exports, "DropdownHeaderButtons", () => $5348b95debef5641$export$53ca7a3701b98335);
$parcel$export(module.exports, "FiltersListSeparator", () => $5348b95debef5641$export$1a67069896d998b9);
$parcel$export(module.exports, "FiltersListWrapper", () => $5348b95debef5641$export$a5a9080bd2c85987);
$parcel$export(module.exports, "Section", () => $5348b95debef5641$export$6e2c8f0811a474ce);
$parcel$export(module.exports, "LastSection", () => $5348b95debef5641$export$1faf3c7558df435);
$parcel$export(module.exports, "SectionMessageWrapper", () => $5348b95debef5641$export$c5e20d5e200edfe2);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $9TEHc = parcelRequire("9TEHc");
const $5348b95debef5641$var$DROPDOWN_HEADER_HEIGHT = 52;
const $5348b95debef5641$var$DROPDOWN_HEADER_VERTICAL_PADDING = "var(--ds-space-150, 12px)";
const $5348b95debef5641$export$5f7211d21bfdae05 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91gwv",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$6c560fdadeb11d78 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { offsetTop: offsetTop, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1uik9ob": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `calc(${__cmplp.offsetTop && __cmplp.offsetTop > (0, $9TEHc.POPUP_OFFSET_TOP) ? '95vh' : '85vh'} - ${// dynamically calculating offsetTop on popup mount
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (__cmplp.offsetTop ?? (0, $9TEHc.POPUP_OFFSET_TOP)) + $5348b95debef5641$var$DROPDOWN_HEADER_HEIGHT}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo1wug _18m91wug _ln19p27b _c71l1pam",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$e23294aded7a8a49 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { stickyHeader: stickyHeader, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71bhr _2rko1sit _1pbykb7n _kqswh2mm _1yt4jd10 _1e0c1txw _1bah1yb4 _4cvr1h6o _11c8qk37",
            __cmplp.stickyHeader ? "_16qsf7oa" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$53ca7a3701b98335 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$1a67069896d998b9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_x3do13y8 _18s81alc",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$a5a9080bd2c85987 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1gwv",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _zulp1f4h _n3td1f4h",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$1faf3c7558df435 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $5348b95debef5641$export$6e2c8f0811a474ce, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n3tdidpf _zulpidpf",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$c5e20d5e200edfe2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hdvyS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8LeNQ")
]).then(()=>parcelRequire('fTzDz'));

});


parcelRegister("6M6Pf", function(module, exports) {

$parcel$export(module.exports, "Trigger", () => $70b788e25198d514$export$41fb9f06171c75f4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");

var $D7hi4 = parcelRequire("D7hi4");

var $2KwA9 = parcelRequire("2KwA9");

var $lGiWG = parcelRequire("lGiWG");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8rQuz = parcelRequire("8rQuz");

var $lwKJI = parcelRequire("lwKJI");
const $70b788e25198d514$var$FILTER_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($D7hi4))), {
    label: "",
    size: "small"
});
const $70b788e25198d514$export$41fb9f06171c75f4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClick, isSelected: isSelected, count: count, hasFiltersApplied: hasFiltersApplied, withThemedButton: withThemedButton = true, isDisabled: isDisabled, appearance: appearance = 'subtle', ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const filterMessageOld = (0, $eUqFw.useMemo)(()=>{
        if (count > 0) return formatMessage((0, $lwKJI.default).filtersCount, {
            filters: count
        });
        if (hasFiltersApplied) return formatMessage((0, $lwKJI.default).buttonWithFilters);
        return formatMessage((0, $lwKJI.default).filterButton);
    }, [
        count,
        formatMessage,
        hasFiltersApplied
    ]);
    const filterMessage = (0, $eUqFw.useMemo)(()=>{
        if (hasFiltersApplied && count === 0) return formatMessage((0, $lwKJI.default).buttonWithFilters);
        return formatMessage((0, $lwKJI.default).filterButton);
    }, [
        count,
        formatMessage,
        hasFiltersApplied
    ]);
    const TriggerButton = withThemedButton ? (0, $lGiWG.ThemedButton) : (0, $lUg8E.default);
    return (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TriggerButton, {
        ...otherProps,
        "aria-label": formatMessage((0, $lwKJI.default).filtersCount, {
            filters: count
        }),
        ref: ref,
        isDisabled: isDisabled,
        isSelected: isSelected || count > 0,
        onClick: onClick,
        testId: "business-filters.ui.filters.trigger.button-wrapper",
        iconAfter: count === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2KwA9))), {
            label: "",
            color: "currentColor"
        }) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70b788e25198d514$var$ButtonContents, null, filterMessage, count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70b788e25198d514$var$BadgeContents, null, count))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TriggerButton, {
        ...otherProps,
        ref: ref,
        testId: "business-filters.ui.filters.trigger.button-wrapper",
        iconBefore: $70b788e25198d514$var$FILTER_ICON,
        isSelected: isSelected,
        onClick: onClick,
        appearance: (0, $eI5EY.fg)('jira-calendar-business-theme') ? appearance : 'subtle',
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70b788e25198d514$var$ButtonContents, null, filterMessageOld));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $70b788e25198d514$var$ButtonContents = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _zulp12x7 _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $70b788e25198d514$var$BadgeContents = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _bfhk13cp _ca0qidpf _u5f36mu8 _n3tdidpf _19bv6mu8 _4t3i1j6v _1ul91j6v _2rkogqwt _11c81oud",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lwKJI", function(module, exports) {

$parcel$export(module.exports, "default", () => $142e1a2d3eb527a7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $142e1a2d3eb527a7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filtersCount: {
        "id": "business-filters.filters.trigger.filters-count",
        "defaultMessage": "{filters, number} {filters, plural, one {filter applied} other {filters applied}}"
    },
    filterButton: {
        "id": "business-filters.filters.trigger.filter-button",
        "defaultMessage": "Filter"
    },
    buttonWithFilters: {
        "id": "business-filters.filters.trigger.button-with-filters",
        "defaultMessage": "Filters applied"
    },
    newLozenge: {
        "id": "business-filters.filters.trigger.new-lozenge",
        "defaultMessage": "New"
    },
    newLozengeTooltip: {
        "id": "business-filters.filters.trigger.new-lozenge-tooltip",
        "defaultMessage": "Now you can save your frequently used filters. Apply some filters to get started."
    }
});

});



parcelRegister("d9gm1", function(module, exports) {

$parcel$export(module.exports, "SimpleSearchTextField", () => $2ba7b21880f0a587$export$63f96dda4bd4f7dc);
$parcel$export(module.exports, "SimpleSearchField", () => $2ba7b21880f0a587$export$44e8ccf3428dc1d5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kRXDJ = parcelRequire("kRXDJ");

var $7ueIp = parcelRequire("7ueIp");

var $bQLEb = parcelRequire("bQLEb");

var $eebsR = parcelRequire("eebsR");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $iSgqw = parcelRequire("iSgqw");

var $kar7l = parcelRequire("kar7l");

var $c1K7Q = parcelRequire("c1K7Q");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2jdHI = parcelRequire("2jdHI");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $8rQuz = parcelRequire("8rQuz");

var $9JEYY = parcelRequire("9JEYY");

var $96etS = parcelRequire("96etS");

var $j33Mg = parcelRequire("j33Mg");
const $2ba7b21880f0a587$var$SEARCH_FIELD_WIDTH = 184;
const $2ba7b21880f0a587$export$63f96dda4bd4f7dc = /*#__PURE__*/ (0, $eUqFw.memo)(({ inputRef: inputRef, placeholder: placeholder, value: externalValue = '', onChange: onChange, onFocus: onFocus, view: view, testId: testId, isDisabled: isDisabled, label: label, describedbyId: describedbyId, themedField: themedField = true, isFullWidth: isFullWidth = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const [searchValue, setSearchValue] = (0, $eUqFw.useState)(externalValue);
    const handleSearchChange = (0, $eUqFw.useCallback)((newValue)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField updated', {
            view: view,
            ...(0, $9JEYY.getTextFieldAttributes)(newValue)
        });
        onChange(newValue);
    }, [
        createAnalyticsEvent,
        onChange,
        view
    ]);
    const [handleSearchChangeDebounced] = (0, $2jdHI.default)(handleSearchChange, 500);
    const handleChange = (0, $eUqFw.useCallback)((e)=>{
        setSearchValue(e.target.value);
        handleSearchChangeDebounced(e.target.value);
    }, [
        handleSearchChangeDebounced
    ]);
    const handleClear = (0, $eUqFw.useCallback)(()=>{
        setSearchValue('');
        handleSearchChangeDebounced('');
    }, [
        setSearchValue,
        handleSearchChangeDebounced
    ]);
    const themedIconPrimaryColor = isDisabled ? (0, $kar7l.Tokens).COLOR_TEXT_DISABLED : (0, $kar7l.Tokens).COLOR_TEXT_SUBTLEST;
    const Container = themedField ? $2ba7b21880f0a587$var$ThemedContainer : (0, $eUqFw.Fragment);
    (0, $eUqFw.useEffect)(()=>{
        setSearchValue(externalValue);
    }, [
        externalValue
    ]);
    const elemAfterSearchIcon = !(0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bQLEb))), {
        label: "",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_primaryColor: themedField ? themedIconPrimaryColor : undefined
    }) : null;
    let textFieldWidth;
    if ((0, $8rQuz.isVisualRefreshEnabled)()) textFieldWidth = isFullWidth ? '100%' : $2ba7b21880f0a587$var$SEARCH_FIELD_WIDTH;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iSgqw.default), {
        ref: inputRef,
        ...(0, $c1K7Q.generateDataTestId)('searchfield'),
        "aria-describedby": describedbyId,
        testId: testId,
        value: searchValue,
        isCompact: true,
        placeholder: formatMessage(placeholder),
        "aria-label": label || formatMessage(placeholder),
        onChange: handleChange,
        onFocus: onFocus,
        isDisabled: isDisabled,
        elemAfterInput: searchValue !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
            paddingInlineEnd: (0, $8rQuz.isVisualRefreshEnabled)() ? 'space.025' : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRXDJ.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ueIp))), {
                    ...iconProps,
                    label: formatMessage((0, $j33Mg.default).clear),
                    spacing: "none",
                    color: "var(--ds-text, #172B4D)",
                    LEGACY_size: "small",
                    LEGACY_primaryColor: themedField ? themedIconPrimaryColor : undefined
                }),
            appearance: "subtle",
            spacing: "compact",
            label: formatMessage((0, $j33Mg.default).clear),
            testId: "business-filters.ui.simple-search-field.clear-button",
            onClick: handleClear
        })) : elemAfterSearchIcon,
        elemBeforeInput: (0, $8rQuz.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
            xcss: $2ba7b21880f0a587$var$iconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eebsR))), {
            color: "currentColor",
            label: "",
            spacing: "none"
        })),
        width: textFieldWidth,
        className: (0, $7JEyt.default)([
            !(0, $8rQuz.isVisualRefreshEnabled)() && "_dzcou2gc"
        ])
    }));
});
const $2ba7b21880f0a587$export$44e8ccf3428dc1d5 = /*#__PURE__*/ (0, $eUqFw.memo)(({ placeholder: placeholder, view: view, describedbyId: describedbyId, onChange: onChange })=>{
    const [simpleSearch, setSimpleSearch] = (0, $96etS.useSimpleSearch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const handleFocus = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField focused', {
            view: view
        });
    }, [
        createAnalyticsEvent,
        view
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('timeline-collapse-expand-all_61d00') && onChange) onChange(simpleSearch);
    }, [
        onChange,
        simpleSearch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ba7b21880f0a587$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ba7b21880f0a587$export$63f96dda4bd4f7dc, {
        view: view,
        onFocus: handleFocus,
        describedbyId: describedbyId,
        onChange: (text)=>{
            if ((0, $1ybV0.ff)('timeline-collapse-expand-all_61d00') && onChange) onChange(text);
            return setSimpleSearch(text);
        },
        value: simpleSearch,
        placeholder: placeholder
    }));
});
const $2ba7b21880f0a587$var$textFieldStyles = null;
const $2ba7b21880f0a587$var$iconStyles = (0, $8Vv3m.xcss)({
    display: 'inline-flex',
    marginLeft: 'space.075'
}); /* eslint-disable @atlaskit/design-system/no-unsafe-design-token-usage */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2ba7b21880f0a587$var$ThemedContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_6l8r1oay _x2xk1oay _sg3v1oay _w15a1oay _n8yf1v8d _jeiekwex _7n831c2q _1o8hu22k _n2ulgr9p",
            __cmplp.className
        ])
    });
}); /* eslint-enable @atlaskit/design-system/no-unsafe-design-token-usage */ 
const $2ba7b21880f0a587$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("c1K7Q", function(module, exports) {

$parcel$export(module.exports, "generateDataTestId", () => $9d0a034fe3d4cf2e$export$7de5661ad251801);

var $1ybV0 = parcelRequire("1ybV0");
const $9d0a034fe3d4cf2e$var$DISABLED = 'disabled';
const $9d0a034fe3d4cf2e$var$DUPLICATED = 'duplicated';
const $9d0a034fe3d4cf2e$var$REPLACED = 'replaced';
const $9d0a034fe3d4cf2e$var$DEFAULT_FF = 'replace-data-test-id-with-data-testid-in-bento-m2';
const $9d0a034fe3d4cf2e$var$getDataTestIdFlagValue = (featureFlag = $9d0a034fe3d4cf2e$var$DEFAULT_FF)=>// eslint-disable-next-line jira/ff/static-feature-flags
    (0, $1ybV0.getMultivariateFeatureFlag)(featureFlag, $9d0a034fe3d4cf2e$var$DISABLED, [
        $9d0a034fe3d4cf2e$var$DISABLED,
        $9d0a034fe3d4cf2e$var$DUPLICATED,
        $9d0a034fe3d4cf2e$var$REPLACED
    ]);
const $9d0a034fe3d4cf2e$export$7de5661ad251801 = (testId, featureFlag = $9d0a034fe3d4cf2e$var$DEFAULT_FF)=>{
    const flagValue = $9d0a034fe3d4cf2e$var$getDataTestIdFlagValue(featureFlag);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let testIdProps = {};
    switch(flagValue){
        case 'duplicated':
            testIdProps = {
                'data-test-id': testId,
                'data-testid': testId
            };
            break;
        case 'replaced':
            testIdProps = {
                'data-testid': testId
            };
            break;
        case 'disabled':
        default:
            testIdProps = {
                'data-test-id': testId
            };
            break;
    }
    return testIdProps;
};

});

parcelRegister("2jdHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3243fa342b695d88$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");
function $3243fa342b695d88$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $eUqFw.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $eUqFw.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $eUqFw.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $eUqFw.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("9JEYY", function(module, exports) {

$parcel$export(module.exports, "getTextFieldAttributes", () => $98a728a18d600acd$export$dfd7972bcd113afb);
const $98a728a18d600acd$export$dfd7972bcd113afb = (value = '')=>{
    const wordCount = value.split(/s+/).filter((word)=>word !== '').length;
    return {
        queryLength: value.length,
        wordCount: wordCount
    };
};

});

parcelRegister("j33Mg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6d42843abbf146$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7a6d42843abbf146$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    clear: {
        "id": "business-filters.simple-search-field.clear",
        "defaultMessage": "Clear"
    }
});

});


parcelRegister("bSsl1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf2ff9f75b0cc835$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

var $dyfd9 = parcelRequire("dyfd9");

var $3f7Cz = parcelRequire("3f7Cz");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cf2ff9f75b0cc835$var$LazyAddPeopleWithAvatars = (0, $dyfd9.lazyAfterPaint)(()=>(parcelRequire("bttlt")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/invite-people/src/ui/add-people-with-avatars/main.tsx"
});
const $cf2ff9f75b0cc835$var$AddPeopleWithAvatar = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.jira-business.invite-people.add-people-with-avatars",
        packageName: "jiraBusinessInvitePeople",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "invite-button-with-avatars",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf2ff9f75b0cc835$var$AvatarFallback, null)
    }, props?.hasInviteButton === false ? // not including the Add People provider if the invite button is not needed
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf2ff9f75b0cc835$var$LazyAddPeopleWithAvatars, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3f7Cz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf2ff9f75b0cc835$var$LazyAddPeopleWithAvatars, props))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf2ff9f75b0cc835$var$AvatarFallback = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1ylp",
            __cmplp.className
        ])
    });
});
var $cf2ff9f75b0cc835$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($cf2ff9f75b0cc835$var$AddPeopleWithAvatar);

});
parcelRegister("3f7Cz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5829e6ed86dc42e3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5GxEP = parcelRequire("5GxEP");

var $bvGWz = parcelRequire("bvGWz");

var $3MjJX = parcelRequire("3MjJX");
const $5829e6ed86dc42e3$var$AddPeopleModal = ({ shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>{
    const { isModalOpen: isModalOpen, closeAddPeopleModal: closeAddPeopleModal } = (0, $bvGWz.useAddPeople)();
    if (isModalOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MjJX.ProjectInvitePeopleModal), {
        onModalClose: closeAddPeopleModal,
        shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
        source: source
    });
    return null;
};
const $5829e6ed86dc42e3$var$AddPeople = ({ children: children, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bvGWz.AddPeopleProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "jira-business.invite-people.ui.add-people",
        packageName: "jira-business.invite-people.ui.add-people",
        teamName: "jira-warepil"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5829e6ed86dc42e3$var$InviteWrapper, {
        "data-testid": "business-invite-people.ui.add-people-with-avatars.add-people.invite-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5829e6ed86dc42e3$var$AddPeopleModal, {
        shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
        source: source
    }))));
var $5829e6ed86dc42e3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5829e6ed86dc42e3$var$AddPeople);
// this wrapper prevents the modal component to inherit any css logic from its parent, which could cause interferences in the consumer's UI
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5829e6ed86dc42e3$var$InviteWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bvGWz", function(module, exports) {

$parcel$export(module.exports, "AddPeopleProvider", () => $f3a4a647f29aa9d7$export$6d41c2327e862d9d);
$parcel$export(module.exports, "useAddPeople", () => $f3a4a647f29aa9d7$export$93ea361ec674cff6);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");
const $f3a4a647f29aa9d7$var$AddPeopleContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    triggerBtnRef: {
        current: null
    },
    isModalOpen: false,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openAddPeopleModal: ()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    closeAddPeopleModal: ()=>{}
});
const $f3a4a647f29aa9d7$export$6d41c2327e862d9d = ({ children: children })=>{
    const projectData = (0, $kQAZu.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const [isModalOpen, setIsModalOpen] = (0, $eUqFw.useState)(false);
    const triggerBtnRef = (0, $eUqFw.useRef)(null);
    const onCloseCallbackRef = (0, $eUqFw.useRef)();
    const openAddPeopleModal = (0, $eUqFw.useCallback)((onClose, source)=>{
        setIsModalOpen(true);
        const eventName = projectData.isSimplified ? 'jwmProjectInviteComponent' : 'jwmInstanceInviteComponent';
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', eventName, {
            source: source
        });
        if (onClose) onCloseCallbackRef.current = onClose;
    }, [
        createAnalyticsEvent,
        projectData.isSimplified
    ]);
    const closeAddPeopleModal = (0, $eUqFw.useCallback)(()=>{
        setIsModalOpen(false);
        if (typeof onCloseCallbackRef.current === 'function') {
            onCloseCallbackRef.current();
            onCloseCallbackRef.current = null;
        }
    }, []);
    const context = (0, $eUqFw.useMemo)(()=>({
            triggerBtnRef: triggerBtnRef,
            isModalOpen: isModalOpen,
            openAddPeopleModal: openAddPeopleModal,
            closeAddPeopleModal: closeAddPeopleModal
        }), [
        triggerBtnRef,
        isModalOpen,
        openAddPeopleModal,
        closeAddPeopleModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f3a4a647f29aa9d7$var$AddPeopleContext.Provider, {
        value: context
    }, children);
};
const $f3a4a647f29aa9d7$export$93ea361ec674cff6 = ()=>(0, $eUqFw.useContext)($f3a4a647f29aa9d7$var$AddPeopleContext);

});

parcelRegister("3MjJX", function(module, exports) {

$parcel$export(module.exports, "ProjectInvitePeopleModal", () => $1368af08b2bd60b0$export$6dfea89767cb5ac1);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $hlZx3 = parcelRequire("hlZx3");

var $66rnh = parcelRequire("66rnh");

var $d1I0W = parcelRequire("d1I0W");
const $1368af08b2bd60b0$export$6dfea89767cb5ac1 = ({ onModalClose: onModalClose, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal = false, source: source })=>{
    const projectData = (0, $kQAZu.useProject)();
    const { handleAddSuccess: handleAddSuccess, handleError: handleError } = (0, $hlZx3.useInviteModalHandlers)();
    if (!shouldUseInvitePeopleModal && projectData.isSimplified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $66rnh.AddPeopleModal), {
        onModalClose: onModalClose,
        onInviteSuccess: handleAddSuccess,
        onInviteError: handleError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d1I0W.InvitePeopleModal), {
        onModalClose: onModalClose,
        onInviteSuccess: handleAddSuccess,
        onInviteError: handleError,
        source: source
    });
};

});
parcelRegister("hlZx3", function(module, exports) {

$parcel$export(module.exports, "useInviteModalHandlers", () => $72fe370f230f9c2c$export$f696e14fc423d0b);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $gd0Sp = parcelRequire("gd0Sp");


var $f90H0 = parcelRequire("f90H0");

var $bLjrh = parcelRequire("bLjrh");
const $72fe370f230f9c2c$export$f696e14fc423d0b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const projectData = (0, $kQAZu.useProject)();
    const handleAddSuccess = (0, $eUqFw.useCallback)(({ modalType: modalType, totalPeopleAdded: totalPeopleAdded, email: email, inviteStatus: inviteStatus })=>{
        const hasSentInvitation = inviteStatus === (0, $f90H0.InvitationStatusEnum).INVITED;
        const hasSuccessfullyAddedPeople = !inviteStatus && projectData.permissions.administerProject;
        showFlag(hasSuccessfullyAddedPeople ? (0, $bLjrh.createAddSuccessFlagConfig)({
            totalPeopleAdded: totalPeopleAdded,
            email: email,
            projectKey: projectData.key
        }) : (0, $bLjrh.createInviteSuccessFlagConfig)({
            totalPeopleAdded: totalPeopleAdded,
            email: email,
            hasSentInvitation: hasSentInvitation
        }));
        // The event tracked by the Invite People SLOs
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite success`, {
            inviteStatus: inviteStatus
        });
    }, [
        createAnalyticsEvent,
        showFlag,
        projectData
    ]);
    const handleError = (0, $eUqFw.useCallback)(({ modalType: modalType, errorMessage: errorMessage, statusCode: statusCode })=>{
        if (errorMessage.includes((0, $aa13349e4e2d4a46$export$4e427f77b64bbbed)) || errorMessage.includes((0, $aa13349e4e2d4a46$export$20ef020abfaa9ec))) {
            showFlag((0, $bLjrh.createInviteFailedUserLimitFlagConfig)(isSiteAdmin, createAnalyticsEvent));
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'userLimit reached', `jwm${modalType}Invite`);
            return;
        }
        if (errorMessage.includes((0, $aa13349e4e2d4a46$export$a1d765adf759361e))) showFlag((0, $bLjrh.inviteFailBadRequestFlagConfig));
        else if (errorMessage.includes((0, $aa13349e4e2d4a46$export$c7f012c6e67c4217))) showFlag((0, $bLjrh.inviteFailNetworkErrorFlagConfig));
        else if (errorMessage.includes((0, $aa13349e4e2d4a46$export$c8a538cf4ae41623)) || errorMessage.includes((0, $aa13349e4e2d4a46$export$9bbcbc11675c1278)) || errorMessage.includes((0, $aa13349e4e2d4a46$export$a51af3c30283d234))) showFlag((0, $bLjrh.inviteFailGenericFlagConfig));
        else showFlag((0, $bLjrh.inviteFailFlagConfig));
        const isClientError = statusCode && statusCode >= 400 && statusCode < 500;
        if (errorMessage.includes((0, $aa13349e4e2d4a46$export$14fb68f74ccc8b23)) || isClientError) return;
        (0, $guiFP.default)({
            meta: {
                id: `jwm${modalType}Invite`,
                packageName: (0, $aa13349e4e2d4a46$export$b8b9d90f9e5bd72b),
                teamName: 'jira-warepil'
            },
            attributes: {
                message: errorMessage
            },
            error: new Error(errorMessage),
            sendToPrivacyUnsafeSplunk: true
        });
        // The event tracked by the Invite People SLOs
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite failed`);
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        showFlag
    ]);
    return {
        handleAddSuccess: handleAddSuccess,
        handleError: handleError
    };
};

});
const $aa13349e4e2d4a46$export$b8b9d90f9e5bd72b = 'jira-business.invite-people';
const $aa13349e4e2d4a46$export$a1d765adf759361e = 'Check your request, then give it another try.';
const $aa13349e4e2d4a46$export$c7f012c6e67c4217 = 'Check your network connection, then give it another try.';
const $aa13349e4e2d4a46$export$c8a538cf4ae41623 = 'AUTH_FAILED';
const $aa13349e4e2d4a46$export$9bbcbc11675c1278 = 'SERVER_ERROR';
const $aa13349e4e2d4a46$export$a51af3c30283d234 = 'USER_NOT_FOUND';
const $aa13349e4e2d4a46$export$4e427f77b64bbbed = 'LICENSE_LIMIT_REACHED';
const $aa13349e4e2d4a46$export$20ef020abfaa9ec = 'Licence Exceeded';
const $aa13349e4e2d4a46$export$14fb68f74ccc8b23 = 'Recaptcha validation failed';

parcelRegister("f90H0", function(module, exports) {

$parcel$export(module.exports, "InvitationStatusEnum", () => $2279512461e31f50$export$2e0a7d2dc28c9a18);
const $2279512461e31f50$export$2e0a7d2dc28c9a18 = {
    ACCESS_REQUESTED: 'ACCESS_REQUESTED',
    INVITED: 'INVITED'
};

});

parcelRegister("bLjrh", function(module, exports) {

$parcel$export(module.exports, "inviteFailFlagConfig", () => $493a4fc4ed3495fe$export$95c6157ced8b3439);
$parcel$export(module.exports, "inviteFailGenericFlagConfig", () => $493a4fc4ed3495fe$export$1108ab4b8a5d8a7d);
$parcel$export(module.exports, "inviteFailBadRequestFlagConfig", () => $493a4fc4ed3495fe$export$7f2d6442eed4d708);
$parcel$export(module.exports, "inviteFailNetworkErrorFlagConfig", () => $493a4fc4ed3495fe$export$c3bdacfc2255a9ed);
$parcel$export(module.exports, "createInviteSuccessFlagConfig", () => $493a4fc4ed3495fe$export$d456881895c2a0b2);
$parcel$export(module.exports, "createAddSuccessFlagConfig", () => $493a4fc4ed3495fe$export$cca35dec2a083169);
$parcel$export(module.exports, "createInviteFailedUserLimitFlagConfig", () => $493a4fc4ed3495fe$export$251dc06b3962c565);

var $jMP2a = parcelRequire("jMP2a");

var $7Ya7f = parcelRequire("7Ya7f");
const $493a4fc4ed3495fe$export$8c9a09c293b933fb = ({ specificDescription: specificDescription, agnosticDescription: agnosticDescription, totalPeopleAdded: totalPeopleAdded, email: email })=>{
    if (totalPeopleAdded <= 0) return [
        agnosticDescription,
        {}
    ];
    return [
        specificDescription,
        {
            totalPeopleAddedMinusOne: totalPeopleAdded - 1,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }
    ];
};
const $493a4fc4ed3495fe$export$95c6157ced8b3439 = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedMessageDescription,
    actions: [
        {
            content: (0, $7Ya7f.default).inviteFailedMessageCta,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            onClick: ()=>window.open('/secure/ContactAdministrators!default.jspa', '_blank')
        }
    ]
};
const $493a4fc4ed3495fe$export$1108ab4b8a5d8a7d = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedGenericMessageDescription
};
const $493a4fc4ed3495fe$export$7f2d6442eed4d708 = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedBadRequestMessageDescription
};
const $493a4fc4ed3495fe$export$c3bdacfc2255a9ed = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedNetworkErrorMessageDescription
};
const $493a4fc4ed3495fe$export$d456881895c2a0b2 = ({ totalPeopleAdded: totalPeopleAdded, email: email, hasSentInvitation: hasSentInvitation })=>{
    if (!hasSentInvitation) return {
        type: 'success',
        title: (0, $7Ya7f.default).requestInviteSuccessMessageTitle,
        description: $493a4fc4ed3495fe$export$8c9a09c293b933fb({
            agnosticDescription: (0, $7Ya7f.default).requestInviteSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $7Ya7f.default).requestInviteSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        })
    };
    return {
        type: 'success',
        title: (0, $7Ya7f.default).inviteSuccessMessageTitle,
        description: $493a4fc4ed3495fe$export$8c9a09c293b933fb({
            agnosticDescription: (0, $7Ya7f.default).inviteSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $7Ya7f.default).inviteSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        })
    };
};
const $493a4fc4ed3495fe$export$cca35dec2a083169 = ({ totalPeopleAdded: totalPeopleAdded, email: email, projectKey: projectKey })=>({
        type: 'success',
        title: (0, $7Ya7f.default).peopleAddedSuccessMessageTitle,
        description: $493a4fc4ed3495fe$export$8c9a09c293b933fb({
            agnosticDescription: (0, $7Ya7f.default).peopleAddedSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $7Ya7f.default).peopleAddedSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }),
        actions: [
            {
                content: (0, $7Ya7f.default).peopleAddedManageAccess,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.assign(`/jira/core/projects/${projectKey}/settings/access`)
            }
        ]
    });
const $493a4fc4ed3495fe$export$251dc06b3962c565 = (isSiteAdmin, createAnalyticsEvent)=>({
        type: 'warning',
        title: (0, $7Ya7f.default).userLimitInviteErrorTitle,
        description: isSiteAdmin ? (0, $7Ya7f.default).userLimitInviteErrorDescriptionAdmin : (0, $7Ya7f.default).userLimitInviteErrorDescription,
        actions: isSiteAdmin ? [
            {
                content: (0, $7Ya7f.default).upgradePlan,
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'upgradePlan');
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.open('/admin/billing/applications', '_blank');
                }
            },
            {
                content: (0, $7Ya7f.default).viewUsers,
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'viewUsers');
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.open('/admin/users', '_blank');
                }
            }
        ] : [
            {
                content: (0, $7Ya7f.default).inviteFailedMessageCta,
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'contactAdmin');
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.open('/secure/ContactAdministrators!default.jspa', '_blank');
                }
            }
        ]
    });

});
parcelRegister("7Ya7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $97084d0fb7d00df5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $97084d0fb7d00df5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    inviteSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-title",
        "defaultMessage": "Invitation sent"
    },
    inviteSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description",
        "defaultMessage": "You've invited {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} to this business project."
    },
    inviteSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description-agnostic",
        "defaultMessage": "You've successfully invited people to your business project."
    },
    inviteFailedMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-title",
        "defaultMessage": "Something went wrong"
    },
    inviteFailedMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Contact your admin for help."
    },
    inviteFailedMessageCta: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-cta",
        "defaultMessage": "Contact your admin"
    },
    inviteFailedGenericMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-generic-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users, please try again."
    },
    inviteFailedBadRequestMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-bad-request-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Check your request, then give it another try."
    },
    inviteFailedNetworkErrorMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-network-error-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Check your network connection, then give it another try."
    },
    requestInviteSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-title",
        "defaultMessage": "Access request sent to your admin"
    },
    requestInviteSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description",
        "defaultMessage": "Your admin needs to approve access for {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}}."
    },
    requestInviteSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description-agnostic",
        "defaultMessage": "Your admin needs to approve access for people to your business project."
    },
    peopleAddedSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-title",
        "defaultMessage": "New people added"
    },
    peopleAddedSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description",
        "defaultMessage": "{totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} added to the project. You can also add teammates and manage their access to the project from Project settings"
    },
    peopleAddedSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description-agnostic",
        "defaultMessage": "People added to the project. You can also add teammates and manage their access to the project from Project settings"
    },
    peopleAddedManageAccess: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-manage-access",
        "defaultMessage": "Manage access"
    },
    userLimitInviteErrorTitle: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-title",
        "defaultMessage": "Can't add more people"
    },
    userLimitInviteErrorDescriptionAdmin: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description-admin",
        "defaultMessage": "You've reached your user limit. Upgrade your plan or remove other users."
    },
    userLimitInviteErrorDescription: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description",
        "defaultMessage": "You've reached your user limit. Contact your admin for help."
    },
    viewUsers: {
        "id": "business-invite-people.controllers.modal-handlers.view-users",
        "defaultMessage": "View users"
    },
    upgradePlan: {
        "id": "business-invite-people.controllers.modal-handlers.upgrade-plan",
        "defaultMessage": "Upgrade plan"
    }
});

});



parcelRegister("66rnh", function(module, exports) {

$parcel$export(module.exports, "AddPeopleModal", () => $0d2c4bae7dd02578$export$b28f48897cdf7241);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $kQAZu = parcelRequire("kQAZu");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

var $d6f6c = parcelRequire("d6f6c");

var $c7H0g = parcelRequire("c7H0g");

var $dyfd9 = parcelRequire("dyfd9");

var $bvGWz = parcelRequire("bvGWz");


const $0d2c4bae7dd02578$export$a4917c848b5c6ce8 = (0, $dyfd9.lazy)(()=>(parcelRequire("3hqQV")), {
    ssr: false,
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
const $0d2c4bae7dd02578$var$userInviteErrorCodes = {
    BAD_REQUEST_ERROR_CODE: $aa13349e4e2d4a46$export$a1d765adf759361e,
    NETWORK_ERROR_CODE: $aa13349e4e2d4a46$export$c7f012c6e67c4217,
    AUTH_FAILED_ERROR_CODE: $aa13349e4e2d4a46$export$c8a538cf4ae41623,
    SERVER_ERROR_ERROR_CODE: $aa13349e4e2d4a46$export$9bbcbc11675c1278,
    USER_NOT_FOUND_ERROR_CODE: $aa13349e4e2d4a46$export$a51af3c30283d234
};
const $0d2c4bae7dd02578$export$b28f48897cdf7241 = /*#__PURE__*/ (0, $eUqFw.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose })=>{
    const { triggerBtnRef: triggerBtnRef } = (0, $bvGWz.useAddPeople)();
    const projectData = (0, $kQAZu.useProject)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const handleInviteSuccess = (0, $eUqFw.useCallback)((addedParties, _role)=>{
        onInviteSuccess({
            totalPeopleAdded: addedParties.length,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            email: addedParties[0]?.email || addedParties[0]?.displayName,
            modalType: 'Project'
        });
    }, [
        onInviteSuccess
    ]);
    // From the given error message, we want to search for a known error code defined under the user invite endpoint
    // Otherwise, we return the whole message and use that as error code for mapping later on
    const extractErrorCode = (message)=>{
        // Typescript assumes Object.keys is of type string[] so need to type cast
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const errorCode of Object.keys($0d2c4bae7dd02578$var$userInviteErrorCodes)){
            const errorMessage = $0d2c4bae7dd02578$var$userInviteErrorCodes[errorCode];
            if (message.includes(errorMessage)) return errorCode;
        }
        return message; // Return original message if no error code found
    };
    const handleInviteFailure = (0, $eUqFw.useCallback)((errors)=>{
        const userInviteErrorsWithCode = {};
        errors.forEach((error)=>{
            // Group all errors by known user invite error codes
            const errorCode = extractErrorCode(error.message);
            if (errorCode) {
                if (!userInviteErrorsWithCode[errorCode]) userInviteErrorsWithCode[errorCode] = [];
                userInviteErrorsWithCode[errorCode].push(error);
            }
        });
        // Join messages with the same error code
        const groupedUserInviteErrors = Object.values(userInviteErrorsWithCode).map((group)=>{
            const statusCode = group[0]?.statusCode; // Assuming all errors with same error code have the same status code
            const messages = group.map((obj)=>obj.message).join('\n');
            return {
                message: messages,
                statusCode: statusCode
            };
        });
        groupedUserInviteErrors.forEach((groupedUserInviteError)=>{
            onInviteError({
                modalType: 'Project',
                errorMessage: groupedUserInviteError.message,
                statusCode: groupedUserInviteError.statusCode
            });
        });
    }, [
        onInviteError
    ]);
    const { id: id, key: key } = projectData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.jira-business.project-invite-people-modal.add-people",
        packageName: "jira-business.project-invite-people-modal.add-people",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
        eventName: "jwmProjectInviteComponent viewed"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "add-people-modal-lazy",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0d2c4bae7dd02578$export$a4917c848b5c6ce8, {
        isOpen: true,
        triggerBtnRef: triggerBtnRef,
        onClose: onModalClose,
        onAddSuccess: handleInviteSuccess,
        onError: handleInviteFailure,
        projectId: id,
        projectKey: key,
        projectType: "business",
        isAdmin: isAdmin,
        baseUrl: "",
        analyticsPrefix: "",
        allowFlags: false,
        onStopPerfMetric: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    })));
});

});
parcelRegister("3hqQV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("6HI0g")
]).then(()=>parcelRequire('4urEy'));

});


parcelRegister("d1I0W", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleModal", () => $c68f3c6d5279f8a1$export$e3ec81c4d0451f63);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $kGQen = parcelRequire("kGQen");

var $exb0h = parcelRequire("exb0h");

var $5GxEP = parcelRequire("5GxEP");

var $9GdU4 = parcelRequire("9GdU4");

var $gGtKh = parcelRequire("gGtKh");

var $10fdS = parcelRequire("10fdS");

var $d6f6c = parcelRequire("d6f6c");

var $6Ua7e = parcelRequire("6Ua7e");

var $jD3pk = parcelRequire("jD3pk");

var $eIp1n = parcelRequire("eIp1n");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");

var $dWLk9 = parcelRequire("dWLk9");

var $c7H0g = parcelRequire("c7H0g");

var $dyfd9 = parcelRequire("dyfd9");

var $f90H0 = parcelRequire("f90H0");

const $c68f3c6d5279f8a1$export$cbfde4f653ce234 = (0, $dyfd9.lazy)(()=>(parcelRequire("cuAaF")), {
    ssr: false,
    moduleId: "../platform/packages/people-and-teams/invite-people/src/index.ts"
});
const $c68f3c6d5279f8a1$export$4d2a63c83bbce998 = (res)=>{
    if (res.accessRequested?.length) return (0, $f90H0.InvitationStatusEnum).ACCESS_REQUESTED;
    return (0, $f90H0.InvitationStatusEnum).INVITED;
};
const $c68f3c6d5279f8a1$var$LIST_ROUTES = [
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST)
];
const $c68f3c6d5279f8a1$var$isFailureResponse = (res)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    res.failure !== undefined;
const $c68f3c6d5279f8a1$export$e3ec81c4d0451f63 = /*#__PURE__*/ (0, $eUqFw.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose, source: source = 'projectBoard' })=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const projectData = (0, $kQAZu.useProject)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const onInviteCompleteHandler = (0, $eUqFw.useCallback)((response)=>{
        if ($c68f3c6d5279f8a1$var$isFailureResponse(response)) {
            const { message: message, status: status } = response.failure;
            onInviteError({
                modalType: 'Instance',
                errorMessage: message,
                statusCode: status
            });
            return;
        }
        const inviteStatus = $c68f3c6d5279f8a1$export$4d2a63c83bbce998(response);
        const { invited: invited, accessRequested: accessRequested } = response;
        onInviteSuccess({
            totalPeopleAdded: invited.length || accessRequested.length,
            email: invited[0]?.email || accessRequested[0]?.email || '',
            modalType: 'Instance',
            inviteStatus: inviteStatus
        });
    }, [
        onInviteError,
        onInviteSuccess
    ]);
    const isSoftwareRoute = (0, $eUqFw.useMemo)(()=>$c68f3c6d5279f8a1$var$LIST_ROUTES.includes(route.name), [
        route
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.jira-business.project-invite-people-modal.invite-people",
        packageName: "jira-business.project-invite-people-modal.invite-people",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-invite-people-modal.invite-people",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9GdU4.JiraModal), {
        messageId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal.jira-modal",
        messageType: "transactional",
        onClose: onModalClose,
        width: "small",
        shouldScrollInViewport: true,
        testId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
        eventName: "jwmInstanceInviteComponent viewed"
    }), isSoftwareRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Ua7e.default), {
        isOpen: true,
        cloudId: cloudId,
        projectId: projectData.id,
        jiraProjectKey: projectData.key,
        isSiteAdmin: isAdmin,
        onClose: onModalClose,
        appEdition: (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_SOFTWARE), appEditions),
        jiraProjectName: projectData.name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c68f3c6d5279f8a1$export$cbfde4f653ce234, {
        onSendHandler: onModalClose,
        onInviteCompletedHandler: onInviteCompleteHandler,
        onCancelHandler: onModalClose,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        continueUrl: window.location.href,
        enableThirdParty: true,
        source: source,
        orgId: orgId
    })))));
});

});
parcelRegister("9GdU4", function(module, exports) {

$parcel$export(module.exports, "JiraModal", () => $1c76160f4beb743e$export$3782fcca1f68992e);

var $eUqFw = parcelRequire("eUqFw");

var $6XIVS = parcelRequire("6XIVS");

var $jGBLd = parcelRequire("jGBLd");

var $lwAYn = parcelRequire("lwAYn");
const $1c76160f4beb743e$export$3782fcca1f68992e = (props)=>{
    if ((0, $jGBLd.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lwAYn.ChoreographerModal), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6XIVS.default), rest);
};
$1c76160f4beb743e$export$3782fcca1f68992e.displayName = 'JiraModal';

});
parcelRegister("lwAYn", function(module, exports) {

$parcel$export(module.exports, "ChoreographerModal", () => $74b09bc27855f104$export$3f5d627caa6fc630);
// eslint-disable-next-line @typescript-eslint/no-restricted-imports

var $6XIVS = parcelRequire("6XIVS");

var $kytz8 = parcelRequire("kytz8");
const $74b09bc27855f104$export$3f5d627caa6fc630 = (0, $kytz8.withChoreographedRender)((0, $6XIVS.default));

});


parcelRegister("6Ua7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $586cc92d06f8b9df$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $586cc92d06f8b9df$var$LazyComponent = (0, $dyfd9.lazyForPaint)(()=>(parcelRequire("cTVAu")), {
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
});
const $586cc92d06f8b9df$export$6a02a79fa2b0ddab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($586cc92d06f8b9df$var$LazyComponent, props)));
var $586cc92d06f8b9df$export$2e2bcd8739ae039 = $586cc92d06f8b9df$export$6a02a79fa2b0ddab;

});
parcelRegister("cTVAu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("e1vXm")
]).then(()=>parcelRequire('bagiu'));

});


parcelRegister("cuAaF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("51mKo")
]).then(()=>parcelRequire('eZsW8'));

});




parcelRegister("bttlt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("j6IJU").then(()=>parcelRequire('dNnOv'));

});


parcelRegister("eCCst", function(module, exports) {

$parcel$export(module.exports, "JWMShareButton", () => $7c9cba86062e6e6f$export$b326da26415fdf10);

var $eUqFw = parcelRequire("eUqFw");

var $aIRhA = parcelRequire("aIRhA");

var $bDUCT = parcelRequire("bDUCT");

var $lGiWG = parcelRequire("lGiWG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fQ7Iw = parcelRequire("fQ7Iw");

var $hfslX = parcelRequire("hfslX");

var $lxV3x = parcelRequire("lxV3x");

var $bPBzW = parcelRequire("bPBzW");
const $7c9cba86062e6e6f$var$SHARE_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aIRhA))), {
    label: "",
    size: "small"
});
const $7c9cba86062e6e6f$export$b326da26415fdf10 = ({ shareTitle: shareTitle, integrationType: integrationType, shareContentType: shareContentType, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { shareIntegrations: shareIntegrations } = (0, $hfslX.useShareIntegrations)(shareContentType);
    const entityAri = (0, $bDUCT.useEntityAri)();
    const shareButtonRef = (0, $eUqFw.useRef)(null);
    const renderCustomTriggerButton = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'onClick' implicitly has an 'any' type. | TS7031 - Binding element 'isSelected' implicitly has an 'any' type. | TS7031 - Binding element 'ref' implicitly has an 'any' type.
    ({ onClick: onClick, isSelected: isSelected }, { ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
            ...triggerProps,
            ref: shareButtonRef,
            onClick: onClick,
            isSelected: isSelected,
            iconBefore: $7c9cba86062e6e6f$var$SHARE_ICON,
            appearance: "subtle"
        }, formatMessage((0, $bPBzW.default).share))), [
        formatMessage
    ]);
    const handleDialogClose = ()=>{
        onDialogClose?.();
        shareButtonRef?.current?.focus();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxV3x.AsyncShareProjectNudge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ7Iw.default), {
        isAutoOpenDialog: isAutoOpenDialog,
        integrationType: integrationType,
        triggerButtonStyle: "icon-with-text",
        productId: "jira",
        subProductId: "jira-core",
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        shareLink: false ? '' : window.location.href,
        shareTitle: formatMessage(shareTitle),
        shareContentType: shareContentType,
        // @ts-expect-error - TS2322 - Type '({ onClick, isSelected }: { onClick: any; isSelected: any; }, { ref, ...triggerProps }: { [x: string]: any; ref: any; }) => Element' is not assignable to type 'RenderCustomTriggerButton'.
        renderCustomTriggerButton: renderCustomTriggerButton,
        objectAri: entityAri,
        onDialogClose: handleDialogClose,
        copyTooltipText: formatMessage((0, $bPBzW.default).shareTooltipText),
        shareIntegrations: shareIntegrations,
        integrationMode: "tabs",
        shareFormHelperMessage: formatMessage((0, $bPBzW.default).shareJwmHelperMessage)
    }));
};

});
parcelRegister("aIRhA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ce75845568c60f5$var$_react = $7ce75845568c60f5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $7ce75845568c60f5$var$_share = $7ce75845568c60f5$var$_interopRequireDefault((parcelRequire("ffimc")));
function $7ce75845568c60f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7ce75845568c60f5$var$ShareIcon = (props)=>/*#__PURE__*/ $7ce75845568c60f5$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $7ce75845568c60f5$var$_share.default
    }));
$7ce75845568c60f5$var$ShareIcon.displayName = 'ShareIcon';
var $7ce75845568c60f5$var$_default = module.exports.default = $7ce75845568c60f5$var$ShareIcon;

});
parcelRegister("ffimc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::530cf6124b77e826fb9d0e1e695d5d78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1967f0e34536903$var$_react = $b1967f0e34536903$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b1967f0e34536903$var$_UNSAFE_baseNew = $b1967f0e34536903$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $b1967f0e34536903$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1967f0e34536903$var$ShareIcon = (props)=>/*#__PURE__*/ $b1967f0e34536903$var$_react.default.createElement($b1967f0e34536903$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
    }, props));
$b1967f0e34536903$var$ShareIcon.displayName = 'ShareIcon';
var $b1967f0e34536903$var$_default = module.exports.default = $b1967f0e34536903$var$ShareIcon;

});


parcelRegister("fQ7Iw", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $eb292e1f91805d5c$export$5619d05bf511476b);
$parcel$export(module.exports, "ShareButtonNonLazy", () => $eb292e1f91805d5c$export$2745f5fbff00ebaa);
$parcel$export(module.exports, "default", () => $eb292e1f91805d5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $lUg8E = parcelRequire("lUg8E");

var $aIRhA = parcelRequire("aIRhA");


var $5GxEP = parcelRequire("5GxEP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $dyfd9 = parcelRequire("dyfd9");

var $8nUKh = parcelRequire("8nUKh");

var $iHQJU = parcelRequire("iHQJU");
const $eb292e1f91805d5c$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aIRhA))), {
            size: "medium",
            label: formatMessage((0, $8nUKh.messages).shareTriggerButtonText),
            primaryColor: `var(--ds-icon, ${(0, $1b343b038f6c23ec$exports).N30})`
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $8nUKh.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $eb292e1f91805d5c$var$ShareButton = (0, $dyfd9.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("iHQJU"))), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
const $eb292e1f91805d5c$export$2745f5fbff00ebaa = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iHQJU.default), props));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb292e1f91805d5c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$var$ShareButton, props)));

});
parcelRegister("8nUKh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c445af617ae0da86$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c445af617ae0da86$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("iHQJU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f34cc533a63143c6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $huI7r = parcelRequire("huI7r");

var $jD3pk = parcelRequire("jD3pk");

var $gd0Sp = parcelRequire("gd0Sp");

var $ce4rN = parcelRequire("ce4rN");

var $5dKU1 = parcelRequire("5dKU1");

var $493jA = parcelRequire("493jA");

var $5KiBf = parcelRequire("5KiBf");

var $8zXW0 = parcelRequire("8zXW0");

var $8MYMy = parcelRequire("8MYMy");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f34cc533a63143c6$export$2e2bcd8739ae039 = (props)=>{
    const { integrationType: integrationType, triggerButtonStyle: triggerButtonStyle, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose, renderCustomTriggerButton: renderCustomTriggerButton, shareShortcutTriggerCount: shareShortcutTriggerCount = 0, prevShareShortcutTriggerCount: prevShareShortcutTriggerCount = 0, shareFormTitle: shareFormTitle, shareContentType: shareContentType, ...otherProps } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const { cloudId: cloudId, activationId: activationId } = (0, $gd0Sp.useTenantContext)();
    const [{ loading: loadingOutgoingMailStatus, data: outgoingMailStatus, error: outgoingMailStatusError }, fetchEmailSettings] = (0, $5dKU1.default)();
    const [{ data: hasUserPermission, error: userPermissionError }, fetchUserPermission] = (0, $493jA.default)();
    const [{ loading: loadingComplainceStatusHipaa, data: complainceStatusHIPAA, error: complainceStatusHipaaError }, fetchHipaaComplianceStatus] = (0, $ce4rN.useIsHipaaComplianceService)();
    const [isAutoOpen, setIsAutoOpen] = (0, $eUqFw.useState)(true);
    const shortcutPressed = !!(shareShortcutTriggerCount && shareShortcutTriggerCount > 0 && shareShortcutTriggerCount > prevShareShortcutTriggerCount);
    (0, $eUqFw.useEffect)(()=>{
        if (outgoingMailStatus === undefined && isAutoOpenDialog === true) fetchEmailSettings();
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        outgoingMailStatus
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (complainceStatusHIPAA === undefined && isAutoOpenDialog === true) fetchHipaaComplianceStatus();
    // complianceStatusHIPAA is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        complainceStatusHIPAA
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasUserPermission === undefined && isAutoOpenDialog === true) fetchUserPermission();
    // hasUserPermission is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        hasUserPermission
    ]);
    // This is used purely to trigger a re-render.
    // If `isAutoOpenDialog` prop is already true, when the prop is recalculated
    // in the parent if it's `true` again there will be no re-render.
    (0, $eUqFw.useEffect)(()=>{
        if (outgoingMailStatus === undefined && shortcutPressed) fetchEmailSettings();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        outgoingMailStatus,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (complainceStatusHIPAA === undefined && shortcutPressed) fetchHipaaComplianceStatus();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        complainceStatusHIPAA,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasUserPermission === undefined && shortcutPressed) fetchUserPermission();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchUserPermission is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasUserPermission,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    const getCustomFormTitle = (0, $eUqFw.useCallback)(()=>{
        switch(shareContentType){
            case 'summary':
                return formatMessage((0, $5KiBf.default).shareMainTabTextJwmSummary);
            case 'board':
                return formatMessage((0, $5KiBf.default).shareMainTabTextJwmBoard);
            case 'list':
                return formatMessage((0, $5KiBf.default).shareMainTabTextJwmList);
            case 'calendar':
                return formatMessage((0, $5KiBf.default).shareMainTabTextJwmCalendar);
            case 'timeline':
                return formatMessage((0, $5KiBf.default).shareMainTabTextJwmTimeline);
            case 'form':
                return formatMessage((0, $5KiBf.default).shareMainTabTextJwmForm);
            case 'attachments':
                return formatMessage((0, $5KiBf.default).shareMainTabTextJwmAttachments);
            default:
                return shareFormTitle;
        }
    }, [
        formatMessage,
        shareContentType,
        shareFormTitle
    ]);
    // Error handling fires analytics.
    (0, $eUqFw.useEffect)(()=>{
        if (outgoingMailStatusError) (0, $guiFP.default)({
            meta: {
                id: 'getEmailSettings',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        outgoingMailStatusError
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (complainceStatusHipaaError) (0, $guiFP.default)({
            meta: {
                id: 'getComplainceStatusHIPAA',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        complainceStatusHipaaError
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (userPermissionError) (0, $guiFP.default)({
            meta: {
                id: 'userPermissionError',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        userPermissionError
    ]);
    // Loading but no errors or data available.
    const shouldAutoOpenPreShareDialog = isAutoOpenDialog === true && (loadingOutgoingMailStatus || loadingComplainceStatusHipaa || complainceStatusHIPAA !== undefined || !!outgoingMailStatusError || !!complainceStatusHipaaError || outgoingMailStatus !== undefined);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (outgoingMailStatus === undefined || outgoingMailStatus?.isEmailEnabled === false || complainceStatusHIPAA?.isCompliant === true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8zXW0.default), {
        triggerButtonStyle: triggerButtonStyle,
        loading: loadingOutgoingMailStatus || loadingComplainceStatusHipaa,
        error: outgoingMailStatusError || complainceStatusHipaaError,
        emailSettings: outgoingMailStatus,
        hipaaStatus: complainceStatusHIPAA,
        renderCustomTriggerButton: renderCustomTriggerButton,
        getEmailSettings: fetchEmailSettings,
        getHipaaStatus: fetchHipaaComplianceStatus,
        getUserPermission: fetchUserPermission,
        isAutoOpenDialog: shortcutPressed || shouldAutoOpenPreShareDialog,
        onTriggerButtonClick: props.onTriggerButtonClick,
        shareShortcutTriggerCount: shareShortcutTriggerCount
    }), outgoingMailStatus?.isEmailEnabled === true && complainceStatusHIPAA?.isCompliant === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8MYMy.default), {
        triggerButtonAppearance: "default",
        isAutoOpenDialog: isAutoOpen,
        renderCustomTriggerButton: renderCustomTriggerButton,
        shareContentType: shareContentType,
        shareFormTitle: shareFormTitle || getCustomFormTitle(),
        triggerButtonStyle: triggerButtonStyle,
        isBrowseUsersEnabled: hasUserPermission,
        onDialogClose: ()=>{
            setIsAutoOpen(false);
            if (onDialogClose) onDialogClose();
        },
        orgId: orgId,
        workspaceAri: (0, $huI7r.createAri)({
            resourceId: activationId,
            cloudId: cloudId,
            resourceType: 'workspace',
            resourceOwner: 'jira'
        }),
        ...otherProps
    }));
};

});
parcelRegister("ce4rN", function(module, exports) {

$parcel$export(module.exports, "useIsHipaaComplianceService", () => $c4937ecf4de18f4f$export$dad138577ca71048);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $lRmyA = parcelRequire("lRmyA");
const $c4937ecf4de18f4f$var$getHipaaComplianceStatus = async ()=>(0, $lRmyA.performGetRequest)('/rest/internal/latest/compliance/status/HIPAA');
const $c4937ecf4de18f4f$export$dad138577ca71048 = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchHipaaComplianceStatus } = (0, $eEzyV.useService)($c4937ecf4de18f4f$var$getHipaaComplianceStatus);
    const transformedData = (0, $eUqFw.useMemo)(()=>data ? {
            isCompliant: data.isCompliant
        } : undefined, [
        data
    ]);
    return [
        {
            loading: loading,
            error: error,
            data: transformedData
        },
        fetchHipaaComplianceStatus
    ];
};

});

parcelRegister("5dKU1", function(module, exports) {

$parcel$export(module.exports, "default", () => $07e868744b66a325$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $lRmyA = parcelRequire("lRmyA");
const $07e868744b66a325$var$getEmailSettings = async ()=>(0, $lRmyA.performGetRequest)('/rest/jira-mail-plugin/1.0/outgoingMail/config');
const $07e868744b66a325$export$5f20fafd52370aae = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchEmailSettings } = (0, $eEzyV.useService)($07e868744b66a325$var$getEmailSettings);
    const transformedData = (0, $eUqFw.useMemo)(()=>data ? {
            isEmailEnabled: data.enabled,
            canUserEnableEmail: data.canEditConfig
        } : undefined, [
        data
    ]);
    return [
        {
            loading: loading,
            error: error,
            data: transformedData
        },
        fetchEmailSettings
    ];
};
var $07e868744b66a325$export$2e2bcd8739ae039 = $07e868744b66a325$export$5f20fafd52370aae;

});

parcelRegister("493jA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2000a1fa3dad3110$export$2e2bcd8739ae039);

var $eEzyV = parcelRequire("eEzyV");

var $lRmyA = parcelRequire("lRmyA");
const $2000a1fa3dad3110$var$getUserPermission = async ()=>(0, $lRmyA.performGetRequest)('/rest/api/3/mypermissions?permissions=USER_PICKER');
const $2000a1fa3dad3110$export$ce7974a7294500be = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchUserPermission } = (0, $eEzyV.useService)($2000a1fa3dad3110$var$getUserPermission);
    return [
        {
            loading: loading,
            error: error,
            data: data?.permissions?.USER_PICKER?.havePermission
        },
        fetchUserPermission
    ];
};
var $2000a1fa3dad3110$export$2e2bcd8739ae039 = $2000a1fa3dad3110$export$ce7974a7294500be;

});

parcelRegister("5KiBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c3f04a0c7828f4b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2c3f04a0c7828f4b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    shareMainTabTextJwmSummary: {
        "id": "share-button.share-main-tab-text-jwm-summary",
        "defaultMessage": "Share summary"
    },
    shareMainTabTextJwmBoard: {
        "id": "share-button.share-main-tab-text-jwm-board",
        "defaultMessage": "Share board"
    },
    shareMainTabTextJwmList: {
        "id": "share-button.share-main-tab-text-jwm-list",
        "defaultMessage": "Share list"
    },
    shareMainTabTextJwmCalendar: {
        "id": "share-button.share-main-tab-text-jwm-calendar",
        "defaultMessage": "Share calendar"
    },
    shareMainTabTextJwmTimeline: {
        "id": "share-button.share-main-tab-text-jwm-timeline",
        "defaultMessage": "Share timeline"
    },
    shareMainTabTextJwmForm: {
        "id": "share-button.share-main-tab-text-jwm-form",
        "defaultMessage": "Share form"
    },
    shareMainTabTextJwmAttachments: {
        "id": "share-button.share-main-tab-text-jwm-attachments",
        "defaultMessage": "Share attachments"
    }
});

});

parcelRegister("8zXW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $86834bd052f4d362$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kRXDJ = parcelRequire("kRXDJ");

var $lUg8E = parcelRequire("lUg8E");

var $ffimc = parcelRequire("ffimc");

var $aIRhA = parcelRequire("aIRhA");

var $eruWR = parcelRequire("eruWR");

var $bBdMg = parcelRequire("bBdMg");

var $jl1we = parcelRequire("jl1we");

var $kGQen = parcelRequire("kGQen");

var $c9TLT = parcelRequire("c9TLT");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $8rQuz = parcelRequire("8rQuz");

var $01uPl = parcelRequire("01uPl");

var $4C7gg = parcelRequire("4C7gg");
const $86834bd052f4d362$var$ConditionalTooltip = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: formatMessage((0, $01uPl.default).shareTriggerButtonText),
        position: "top"
    }, children);
};
const $86834bd052f4d362$var$PreShareView = ({ triggerButtonStyle: triggerButtonStyle, loading: loading, error: error, emailSettings: emailSettings, hipaaStatus: hipaaStatus, renderCustomTriggerButton: renderCustomTriggerButton, getEmailSettings: getEmailSettings, getHipaaStatus: getHipaaStatus, getUserPermission: getUserPermission, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose, onTriggerButtonClick: onTriggerButtonClick, shareShortcutTriggerCount: shareShortcutTriggerCount })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(isAutoOpenDialog);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    // Used to invoke a re-render when isAutoOpenDialog has not changed but the shortcut has been pressed again.
    (0, $eUqFw.useEffect)(()=>{
        setIsOpen(isAutoOpenDialog);
    }, [
        isAutoOpenDialog,
        shareShortcutTriggerCount
    ]);
    const onTriggerClick = (0, $eUqFw.useCallback)((trigger)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'PreShareView Button Clicked',
            actionSubject: 'Share'
        });
        setIsOpen(!isOpen);
        if (!isOpen) {
            getUserPermission();
            getEmailSettings();
            getHipaaStatus();
        }
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, trigger);
        if (onTriggerButtonClick) onTriggerButtonClick();
    }, [
        createAnalyticsEvent,
        isOpen,
        onTriggerButtonClick,
        getUserPermission,
        getEmailSettings,
        getHipaaStatus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eruWR.default), {
        onClose: ()=>{
            setIsOpen(false);
            onDialogClose && onDialogClose();
        },
        zIndex: (0, $c9TLT.layers).modal,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86834bd052f4d362$var$DialogLayout, {
                "data-testid": "share-button.ui.pre-share-view.warningModal"
            }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bBdMg.default), {
                testId: "share-button.ui.pre-share-view.loading",
                size: "medium"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4C7gg.WarningContent), {
                isEmailEnabled: emailSettings?.isEmailEnabled,
                canUserEnableEmail: !!emailSettings?.canUserEnableEmail,
                isUserHIPAA: !!hipaaStatus?.isCompliant
            }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h1", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $01uPl.default).errorMessage)))),
        isOpen: isOpen,
        placement: "left-start",
        trigger: (triggerProps)=>renderCustomTriggerButton ? renderCustomTriggerButton({
                isSelected: isOpen,
                onClick: ()=>onTriggerClick('RenderCustomTriggerPreShareView')
            }, triggerProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86834bd052f4d362$var$ConditionalTooltip, null, (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRXDJ.default), {
                testId: "share-button.ui.pre-share-view.button",
                isDisabled: loading,
                label: formatMessage((0, $01uPl.default).shareTriggerButtonText),
                ...triggerProps,
                appearance: "default",
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ffimc))), {
                        spacing: "spacious",
                        label: triggerButtonStyle === 'icon-with-text' ? '' : formatMessage((0, $01uPl.default).shareTriggerButtonText),
                        color: "var(--ds-icon, #44546F)"
                    }),
                onClick: ()=>onTriggerClick('PreShareView')
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
                testId: "share-button.ui.pre-share-view.button" // @ts-expect-error - TS2322 - Type '{ children: string | null; appearance: "subtle"; iconBefore: Element; onClick: () => void; ref: Ref<HTMLElement>; 'aria-controls'?: string | undefined; 'aria-expanded': boolean; 'aria-haspopup': boolean; testId: string; disabled: boolean; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
                ,
                disabled: loading,
                ...triggerProps,
                appearance: "subtle",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aIRhA))), {
                    size: "medium",
                    label: triggerButtonStyle === 'icon-with-text' ? '' : formatMessage((0, $01uPl.default).shareTriggerButtonText),
                    primaryColor: "var(--ds-icon, #44546F)"
                }),
                onClick: ()=>onTriggerClick('PreShareView')
            }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $01uPl.default).shareTriggerButtonText) : null))
    });
};
var $86834bd052f4d362$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $86834bd052f4d362$var$PreShareView;
const $86834bd052f4d362$var$DialogLayout = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _1yt4pxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("01uPl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f0590d2ba434fe8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2f0590d2ba434fe8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.pre-share-view.share-trigger-button-text",
        "defaultMessage": "Share"
    },
    errorMessage: {
        "id": "share-button.pre-share-view.error-message",
        "defaultMessage": "Unable to fetch sharing details"
    }
});

});

parcelRegister("4C7gg", function(module, exports) {

$parcel$export(module.exports, "WarningContent", () => $8106d7aafbb60254$export$b7eb687edfdfe752);

var $eUqFw = parcelRequire("eUqFw");

var $93tHo = parcelRequire("93tHo");

var $dnbhd = parcelRequire("dnbhd");

var $8uD7Y = parcelRequire("8uD7Y");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $avRp9 = parcelRequire("avRp9");
function $8106d7aafbb60254$export$b7eb687edfdfe752({ isEmailEnabled: isEmailEnabled, canUserEnableEmail: canUserEnableEmail, isUserHIPAA: isUserHIPAA }) {
    if (isEmailEnabled === false || isUserHIPAA) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "PreShareWarningView"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($93tHo))), {
        size: "medium",
        label: "Warning",
        testId: "share-button.ui.pre-share-view.warning-content.warning-icon"
    }), isEmailEnabled === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $avRp9.default).disabledWarningMessage), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), canUserEnableEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $avRp9.default).adminEnableOutgoingMail), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
        href: "/secure/admin/OutgoingMailServers.jspa"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $avRp9.default).outgoingMail))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $avRp9.default).nonAdminWarningMessage)), isEmailEnabled !== false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $avRp9.default).disabledWarningMessageIfHipaa), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            canUserEnableEmail: canUserEnableEmail,
            isUserHIPAA: isUserHIPAA
        }
    }));
    return null;
}

});
parcelRegister("dnbhd", function(module, exports) {

$parcel$export(module.exports, "default", () => $92444a2f8aee76e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eGI9v = parcelRequire("eGI9v");

var $lB25E = parcelRequire("lB25E");
function $92444a2f8aee76e7$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), rest, children);
}
var $92444a2f8aee76e7$export$2e2bcd8739ae039 = (0, $eGI9v.default)('link', {
    onClick: 'clicked'
})($92444a2f8aee76e7$var$Link);

});

parcelRegister("avRp9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad6983abd5e3ebe0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ad6983abd5e3ebe0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    disabledWarningMessage: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message",
        "defaultMessage": "Outgoing mail is not configured."
    },
    adminEnableOutgoingMail: {
        "id": "share-button.pre-share-view.warning-content.admin-enable-outgoing-mail",
        "defaultMessage": "You can configure it here"
    },
    outgoingMail: {
        "id": "share-button.pre-share-view.warning-content.outgoing-mail",
        "defaultMessage": "Outgoing Mail"
    },
    nonAdminWarningMessage: {
        "id": "share-button.pre-share-view.warning-content.non-admin-warning-message",
        "defaultMessage": "Please contact your Jira administrator to enable sharing."
    },
    disabledWarningMessageIfHipaa: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message-if-hipaa",
        "defaultMessage": "You cannot share issue as your organization has signed up for HIPAA compliance"
    }
});

});



parcelRegister("8MYMy", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfe41a183ab13eb9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $g0E5j = parcelRequire("g0E5j");
parcelRequire("eD9ns");
var $3aikN = parcelRequire("3aikN");

var $e91YZ = parcelRequire("e91YZ");

var $2OdyW = parcelRequire("2OdyW");

var $5oIBC = parcelRequire("5oIBC");

var $giAhk = parcelRequire("giAhk");

var $k4wXf = parcelRequire("k4wXf");

var $abtNr = parcelRequire("abtNr");
const $bfe41a183ab13eb9$var$USER_PICKER_LIMIT = 20;
class $bfe41a183ab13eb9$export$e980dfbc2840e8bc extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            shouldAutoDismissFlag: true,
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onTriggerButtonClick: ()=>{}
        };
    }
    constructor(props){
        super(props);
        this.getOriginTracingInstance = ()=>new (0, $g0E5j.default)({
                product: this.props.productId
            });
        this.loadUsers = async (searchText = '')=>{
            const searchTextEncoded = encodeURIComponent(searchText);
            const url = `/rest/api/3/groupuserpicker?maxResults=${$bfe41a183ab13eb9$var$USER_PICKER_LIMIT}&query=${searchTextEncoded}&showAvatar=true&avatarSize=medium&excludeConnectAddons=true`;
            const groupsAndUsers = await (0, $2OdyW.default)(url);
            return groupsAndUsers.users.users.filter((user)=>user.accountType === 'atlassian').map((user)=>{
                const userData = {
                    type: 'user',
                    id: user.accountId,
                    name: user.displayName,
                    avatarUrl: user.avatarUrl
                };
                return userData;
            });
        };
        this.showFlags = (flags)=>{
            const { flagService: flagService, shouldAutoDismissFlag: shouldAutoDismissFlag } = this.props;
            if (flagService.showFlag) flags.forEach((flag)=>{
                flagService.showFlag({
                    type: flag.appearance,
                    title: flag.title.defaultMessage,
                    isAutoDismiss: shouldAutoDismissFlag
                });
            });
        };
        this.cloudId = '';
        this.cloudId = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)().cloudId;
        if (props.legacyShareClientConfig !== undefined) this.legacyShareClient = new (0, $abtNr.default)(props.legacyShareClientConfig);
    }
    render() {
        const { objectAri: objectAri, renderCustomTriggerButton: renderCustomTriggerButton, shareLink: shareLink, shareTitle: shareTitle, shareContentType: shareContentType, shareFormTitle: shareFormTitle, subProductId: subProductId, triggerButtonAppearance: triggerButtonAppearance = 'subtle', triggerButtonStyle: triggerButtonStyle, onTriggerButtonClick: onTriggerButtonClick, shareIntegrations: shareIntegrations, integrationMode: integrationMode = 'off', isAutoOpenDialog: isAutoOpenDialog, onDialogClose: onDialogClose, copyTooltipText: copyTooltipText, orgId: orgId, isBrowseUsersEnabled: isBrowseUsersEnabled, shareFormHelperMessage: shareFormHelperMessage, shareFieldsFooter: shareFieldsFooter } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3aikN.ShareDialogContainer), {
            shareClient: this.legacyShareClient,
            triggerButtonAppearance: triggerButtonAppearance,
            triggerButtonStyle: triggerButtonStyle,
            cloudId: this.cloudId,
            orgId: orgId,
            loadUserOptions: this.legacyShareClient && this.loadUsers,
            // @ts-expect-error - TS2322 - Type '() => OriginTracing' is not assignable to type 'OriginTracingFactory'.
            originTracingFactory: this.getOriginTracingInstance,
            productId: subProductId,
            renderCustomTriggerButton: renderCustomTriggerButton,
            shareAri: objectAri || (0, $k4wXf.createAri)(subProductId, this.cloudId),
            shareFormHelperMessage: shareFormHelperMessage,
            shareLink: shareLink,
            shareTitle: shareTitle,
            shareContentType: shareContentType,
            shareFormTitle: shareFormTitle,
            showFlags: this.showFlags,
            enableSmartUserPicker: !this.legacyShareClient,
            product: "jira",
            onTriggerButtonClick: onTriggerButtonClick,
            shareIntegrations: shareIntegrations,
            integrationMode: integrationMode,
            isAutoOpenDialog: isAutoOpenDialog,
            onDialogClose: onDialogClose,
            copyTooltipText: copyTooltipText,
            isBrowseUsersDisabled: isBrowseUsersEnabled === false,
            shareFieldsFooter: shareFieldsFooter,
            workspaceAri: this.props.workspaceAri
        });
    }
}
var $bfe41a183ab13eb9$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $5oIBC.default)($bfe41a183ab13eb9$export$e980dfbc2840e8bc));

});
parcelRegister("eD9ns", function(module, exports) {

$parcel$export(module.exports, "ShareDialogContainer", () => (parcelRequire("3aikN")).ShareDialogContainer);

var $3aikN = parcelRequire("3aikN");

var $5ZKXn = parcelRequire("5ZKXn");

var $bVzYo = parcelRequire("bVzYo");

});
parcelRegister("3aikN", function(module, exports) {

$parcel$export(module.exports, "ShareDialogContainer", () => $11a5325340c50f00$export$78b28896b43ae5d6);

var $eUqFw = parcelRequire("eUqFw");

var $aG7FO = parcelRequire("aG7FO");

var $5iWql = parcelRequire("5iWql");

var $8uD7Y = parcelRequire("8uD7Y");

var $8ynlC = parcelRequire("8ynlC");

var $f3klQ = parcelRequire("f3klQ");

var $5SSre = parcelRequire("5SSre");

var $1INIa = parcelRequire("1INIa");

var $7WN8P = parcelRequire("7WN8P");

var $bLAWR = parcelRequire("bLAWR");

var $encBb = parcelRequire("encBb");

var $1FYo4 = parcelRequire("1FYo4");

var $a8PoO = parcelRequire("a8PoO");

var $5PhnX = parcelRequire("5PhnX");

var $4D4HV = parcelRequire("4D4HV");

var $1Vq8e = parcelRequire("1Vq8e");
const $11a5325340c50f00$var$COPY_LINK_EVENT = (0, $bLAWR.copyLinkButtonClicked)({
    start: 0
});
const $11a5325340c50f00$export$f84bd70098573c5c = {
    disableSharingToEmails: false
};
const $11a5325340c50f00$var$memoizedFormatCopyLink = (0, $5iWql.default)((origin, link)=>origin.addToUrl(link));
function $11a5325340c50f00$var$getCurrentPageUrl() {
    return window.location.href;
}
class $11a5325340c50f00$export$bc8c417f2da43f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            enableSmartUserPicker: false,
            shareeAction: 'view',
            product: 'confluence'
        };
    }
    constructor(props){
        super(props);
        this._isMounted = false;
        this._urlShorteningRequestCounter = 0;
        this._lastUrlShorteningWasTooSlow = false;
        this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $bLAWR.CHANNEL_ID));
        };
        this.fetchConfig = ()=>{
            this.setState({
                isFetchingConfig: true
            }, async ()=>{
                try {
                    (0, $1FYo4.renderShareDialogExp).start();
                    const config = await this.shareClient.getConfig(this.props.cloudId);
                    if (this._isMounted) this.setState({
                        config: config,
                        isFetchingConfig: false
                    });
                    (0, $1FYo4.renderShareDialogExp).success();
                } catch (error) {
                    if (this._isMounted) this.setState({
                        config: $11a5325340c50f00$export$f84bd70098573c5c,
                        isFetchingConfig: false
                    });
                    let { ...errObj } = error;
                    if (error instanceof Error) errObj = {
                        ...errObj,
                        className: error.constructor.name
                    };
                    (0, $encBb.isValidFailedExperience)((0, $1FYo4.renderShareDialogExp), errObj);
                }
            });
        };
        this.handleSubmitShare = ({ users: users, comment: comment })=>{
            const shareLink = this.getFormShareLink();
            const { productId: productId, shareAri: shareAri, shareContentType: shareContentType, shareTitle: shareTitle, shareeAction: shareeAction, workspaceAri: workspaceAri } = this.props;
            const content = {
                ari: shareAri,
                link: shareLink,
                title: shareTitle,
                type: shareContentType,
                workspaceAri: workspaceAri
            };
            const metaData = {
                productId: productId,
                atlOriginId: this.getFormShareOriginTracing().id,
                shareeAction: shareeAction
            };
            return this.shareClient.share(content, (0, $1Vq8e.optionDataToUsers)(users), metaData, comment).then(()=>{
                if (!this._isMounted) return;
                // renew Origin Tracing Id per share action succeeded
                this.setState((state)=>({
                        shareActionCount: state.shareActionCount + 1
                    }));
            });
        };
        this.handleDialogOpen = async ()=>{
            if (this.props.onDialogOpen) this.props.onDialogOpen();
            this.setState({
                currentPageUrl: $11a5325340c50f00$var$getCurrentPageUrl()
            }, ()=>{
                this.updateShortCopyLink();
            });
            // always refetch the config when modal is re-opened
            this.fetchConfig();
        };
        this.decorateAnalytics = (payload)=>{
            if (payload.type === $11a5325340c50f00$var$COPY_LINK_EVENT.type && payload.action === $11a5325340c50f00$var$COPY_LINK_EVENT.action && payload.actionSubjectId === $11a5325340c50f00$var$COPY_LINK_EVENT.actionSubjectId) {
                const isCopyLinkShortened = !!this.getShortenedCopyLink();
                payload = {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        shortUrl: isCopyLinkShortened
                    }
                };
                if (this.shouldShortenCopyLink() && !isCopyLinkShortened) this._lastUrlShorteningWasTooSlow = true;
            }
            return payload;
        };
        // ensure origin is re-generated if the link or the factory changes
        // separate memoization is needed since copy != form
        this.getUniqueCopyLinkOriginTracing = (0, $5iWql.default)((link, originTracingFactory)=>{
            return originTracingFactory();
        });
        // form origin must furthermore be regenerated after each form share
        this.getUniqueFormShareOriginTracing = (0, $5iWql.default)((link, originTracingFactory, shareCount)=>{
            return originTracingFactory();
        });
        this.getUpToDateShortenedCopyLink = (0, $5iWql.default)((data, originId)=>{
            this._lastUrlShorteningWasTooSlow = false;
            this._urlShorteningRequestCounter++;
            this.createAndFireEvent((0, $bLAWR.shortUrlRequested)());
            const start = Date.now();
            return this.urlShortenerClient.shorten({
                ...data,
                originId: originId
            }).then((response)=>{
                this.createAndFireEvent((0, $bLAWR.shortUrlGenerated)(start, this._lastUrlShorteningWasTooSlow));
                return response.shortUrl;
            }).catch(()=>{
                this.createAndFireEvent((0, $bLAWR.errorEncountered)('urlShortening'));
                return null;
            });
        }, (0, (/*@__PURE__*/$parcel$interopDefault($aG7FO))));
        this.getFormShareLink = ()=>{
            // original share link is used here
            return this.getRawLink();
        };
        // v0.4 -> v0.5 .client -> .shareClient
        (0, $8ynlC.default)(!props.client, 'elements/share: Breaking change, please update your props!');
        this.shareClient = props.shareClient || new (0, $1INIa.ShareServiceClient)();
        this.urlShortenerClient = props.urlShortenerClient || new (0, $5SSre.AtlassianUrlShortenerClient)();
        this.state = {
            shareActionCount: 0,
            config: $11a5325340c50f00$export$f84bd70098573c5c,
            isFetchingConfig: false,
            currentPageUrl: $11a5325340c50f00$var$getCurrentPageUrl(),
            shortenedCopyLink: null
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    componentDidUpdate(prevProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($aG7FO)))(prevProps.shortLinkData, this.props.shortLinkData)) this.updateShortCopyLink();
    }
    getRawLink() {
        const { shareLink: shareLink } = this.props;
        const { currentPageUrl: currentPageUrl } = this.state;
        return shareLink || currentPageUrl;
    }
    getCopyLinkOriginTracing() {
        const { originTracingFactory: originTracingFactory } = this.props;
        const shareLink = this.getRawLink();
        return this.getUniqueCopyLinkOriginTracing(shareLink, originTracingFactory);
    }
    getFormShareOriginTracing() {
        const { originTracingFactory: originTracingFactory } = this.props;
        const { shareActionCount: shareActionCount } = this.state;
        const shareLink = this.getRawLink();
        return this.getUniqueFormShareOriginTracing(shareLink, originTracingFactory, shareActionCount);
    }
    getFullCopyLink() {
        const { formatCopyLink: formatCopyLink } = this.props;
        const shareLink = this.getRawLink();
        const copyLinkOrigin = this.getCopyLinkOriginTracing();
        return (formatCopyLink || $11a5325340c50f00$var$memoizedFormatCopyLink)(copyLinkOrigin, shareLink);
    }
    shouldShortenCopyLink() {
        return !!this.props.shortLinkData || !!this.props.useUrlShortener;
    }
    getShortenedCopyLink() {
        return this.shouldShortenCopyLink() && this.state.shortenedCopyLink || undefined;
    }
    getCopyLink() {
        return this.getShortenedCopyLink() || this.getFullCopyLink();
    }
    updateShortCopyLink() {
        this.setState({
            shortenedCopyLink: null
        });
        const { shortLinkData: shortLinkData } = this.props;
        if (!shortLinkData) return;
        const originId = this.getCopyLinkOriginTracing().id;
        const shortLink = this.getUpToDateShortenedCopyLink(shortLinkData, originId);
        const requestCounter = this._urlShorteningRequestCounter;
        shortLink.then((shortenedCopyLink)=>{
            if (!this._isMounted) return;
            const isRequestOutdated = requestCounter !== this._urlShorteningRequestCounter;
            if (isRequestOutdated) return;
            this.setState({
                shortenedCopyLink: shortenedCopyLink
            });
        });
    }
    render() {
        const { cloudId: cloudId, orgId: orgId, isAutoOpenDialog: isAutoOpenDialog, dialogPlacement: dialogPlacement, loadUserOptions: loadUserOptions, renderCustomTriggerButton: renderCustomTriggerButton, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, shouldCloseOnEscapePress: shouldCloseOnEscapePress, showFlags: showFlags, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, triggerButtonAppearance: triggerButtonAppearance, triggerButtonIcon: triggerButtonIcon, triggerButtonStyle: triggerButtonStyle, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, bottomMessage: bottomMessage, shareeAction: shareeAction, product: product, productAttributes: productAttributes, customFooter: customFooter, onTriggerButtonClick: onTriggerButtonClick, onUserSelectionChange: onUserSelectionChange, shareFieldsFooter: shareFieldsFooter, isCopyDisabled: isCopyDisabled, isPublicLink: isPublicLink, integrationMode: integrationMode, shareIntegrations: shareIntegrations, shareAri: shareAri, tabIndex: tabIndex, copyTooltipText: copyTooltipText, onDialogClose: onDialogClose, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions } = this.props;
        const { config: config, isFetchingConfig: isFetchingConfig } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8PoO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5PhnX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4D4HV.ShareDialogWithTrigger), {
            onTriggerButtonClick: onTriggerButtonClick,
            isAutoOpenDialog: isAutoOpenDialog,
            config: config,
            isFetchingConfig: isFetchingConfig,
            copyLink: this.getCopyLink(),
            analyticsDecorator: this.decorateAnalytics,
            dialogPlacement: dialogPlacement,
            loadUserOptions: loadUserOptions,
            onDialogOpen: this.handleDialogOpen,
            onShareSubmit: this.handleSubmitShare,
            renderCustomTriggerButton: renderCustomTriggerButton,
            shareContentType: shareContentType,
            shareContentSubType: shareContentSubType,
            shareContentId: shareContentId,
            shareFormTitle: shareFormTitle,
            shareFormHelperMessage: shareFormHelperMessage,
            copyLinkOrigin: this.getCopyLinkOriginTracing(),
            formShareOrigin: this.getFormShareOriginTracing(),
            shouldCloseOnEscapePress: shouldCloseOnEscapePress,
            showFlags: showFlags,
            enableSmartUserPicker: enableSmartUserPicker,
            loggedInAccountId: loggedInAccountId,
            cloudId: cloudId,
            orgId: orgId,
            triggerButtonAppearance: triggerButtonAppearance,
            triggerButtonIcon: triggerButtonIcon,
            triggerButtonStyle: triggerButtonStyle,
            triggerButtonTooltipPosition: triggerButtonTooltipPosition,
            triggerButtonTooltipText: triggerButtonTooltipText,
            bottomMessage: bottomMessage,
            submitButtonLabel: shareeAction === 'edit' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $7WN8P.messages).inviteTriggerButtonText),
            product: product,
            productAttributes: productAttributes,
            customFooter: customFooter,
            onUserSelectionChange: onUserSelectionChange,
            shareFieldsFooter: shareFieldsFooter,
            isCopyDisabled: isCopyDisabled,
            isPublicLink: isPublicLink,
            integrationMode: integrationMode,
            shareIntegrations: shareIntegrations,
            shareAri: shareAri,
            tabIndex: tabIndex,
            copyTooltipText: copyTooltipText,
            onDialogClose: onDialogClose,
            isBrowseUsersDisabled: isBrowseUsersDisabled,
            userPickerOptions: userPickerOptions
        })));
    }
}
const $11a5325340c50f00$export$78b28896b43ae5d6 = (0, $f3klQ.default)()($11a5325340c50f00$export$bc8c417f2da43f4);

});
parcelRegister("aG7FO", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("5SSre", function(module, exports) {

$parcel$export(module.exports, "AtlassianUrlShortenerClient", () => $12750450112259e7$export$8fed7002650b52ef);
class $12750450112259e7$export$8fed7002650b52ef {
    async shorten(data) {
        try {
            const response = await fetch('/gateway/api/atl-link/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) throw new Error(`status="${response.status}"`);
            const result = await response.json();
            if (!result.shortUrl) throw new Error('Breach of contract!');
            return result;
        } catch (err) {
            if (err instanceof Error) err.message = `While shortening URL: ${err.message}!`;
            throw err;
        }
    }
}

});

parcelRegister("1INIa", function(module, exports) {

$parcel$export(module.exports, "ShareServiceClient", () => $e7761b3cf00b0eb2$export$ee05f3e1f0248b62);

var $1Ka8p = parcelRequire("1Ka8p");
const $e7761b3cf00b0eb2$export$a7d7a4246bdd7a12 = 'share';
const $e7761b3cf00b0eb2$export$1a440d9a41e6ce3e = 'share/configuration';
const $e7761b3cf00b0eb2$export$7745139d0aa6183c = '/gateway/api';
class $e7761b3cf00b0eb2$export$ee05f3e1f0248b62 {
    constructor(serviceConfig){
        this.serviceConfig = {
            url: $e7761b3cf00b0eb2$export$7745139d0aa6183c,
            ...serviceConfig || {}
        };
    }
    getConfig(cloudId) {
        const options = {
            path: $e7761b3cf00b0eb2$export$1a440d9a41e6ce3e,
            queryParams: {
                cloudId: cloudId
            },
            requestInit: {
                method: 'get'
            }
        };
        return (0, $1Ka8p.utils).requestService(this.serviceConfig, options);
    }
    /**
	 * To send a POST request to the share endpoint in Share service
	 */ share(content, recipients, metadata, comment) {
        return fetch(`${this.serviceConfig.url}/${$e7761b3cf00b0eb2$export$a7d7a4246bdd7a12}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            credentials: 'include',
            body: JSON.stringify({
                content: content,
                recipients: recipients,
                metadata: metadata,
                comment: comment
            })
        }).then((response)=>{
            if (response.status === 204) return Promise.resolve();
            else if (response.ok) return response.json();
            else return Promise.reject({
                code: response.status,
                reason: response.statusText,
                body: response.json()
            });
        });
    }
}

});

parcelRegister("7WN8P", function(module, exports) {

$parcel$export(module.exports, "messages", () => $cfb6e18c131ef2c3$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $cfb6e18c131ef2c3$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    formTitle: {
        id: 'fabric.elements.share.form.title',
        defaultMessage: 'Share',
        description: 'Title for Share form.'
    },
    formSend: {
        id: 'fabric.elements.share.form.send',
        defaultMessage: 'Send',
        description: 'Label for Share form submit button.'
    },
    formShare: {
        id: 'fabric.elements.share.form.share',
        defaultMessage: 'Share',
        description: 'Label for Share form submit button.'
    },
    formSendPublic: {
        id: 'fabric.elements.share.form.public.send',
        defaultMessage: 'Send public link',
        description: 'Label for Share form submit button when link is public.'
    },
    formSharePublic: {
        id: 'fabric.elements.share.form.public.share',
        defaultMessage: 'Share public link',
        description: 'Label for Share form submit button when link is public.'
    },
    formRetry: {
        id: 'fabric.elements.share.form.retry',
        defaultMessage: 'Retry',
        description: 'Label for Share from retry button.'
    },
    formNoPermissions: {
        id: 'fabric.elements.share.form.no-permissions',
        defaultMessage: 'You do not have the ability to share.',
        description: 'Copy to show when a user can not share.'
    },
    commentLabel: {
        id: 'fabric.elements.share.form.comment.label',
        defaultMessage: 'Message (optional)',
        description: 'Label for the comment field in the Share form.'
    },
    commentPlaceholder: {
        id: 'fabric.elements.share.form.comment.placeholder',
        defaultMessage: 'Anything they should know?',
        description: 'Placeholder for the comment field in Share form.'
    },
    // Email disabled (Jira)
    userPickerLabelEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.label.email-disabled-jira',
        defaultMessage: 'Names or teams',
        description: 'Label for the user picker field in the Share form in Jira with no email option.'
    },
    userPickerPlaceholderEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira',
        defaultMessage: 'e.g. Maria, Team Orange',
        description: 'Placeholder for the user picker field in the Share form in Jira with no email option. These examples should be localized.'
    },
    userPickerRequiredMessageEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira',
        defaultMessage: 'Select at least one person or team',
        description: 'Error message for the user picker field in the Share form in Jira with no email option, when no entries are selected.'
    },
    // Email disabled (Confluence)
    userPickerLabelEmailDisabledConfluence: {
        id: 'fabric.elements.share.form.user-picker.label.email-disabled-confluence',
        defaultMessage: 'Names, teams, or groups',
        description: 'Label for the user picker field in the Share form in Confluence with no email option.'
    },
    userPickerRequiredMessageEmailDisabledConfluence: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence',
        defaultMessage: 'Select at least one person, team, or group',
        description: 'Error message for the user picker field in the Share form in Confluence with no email option, when no entries are selected.'
    },
    // Browse users disabled
    userPickerLabelBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.label.email-only',
        defaultMessage: 'Emails',
        description: 'Label for the user picker field in the Share form when browse user permissions are disabled.'
    },
    userPickerPlaceholderBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.placeholder.email-only',
        defaultMessage: 'e.g. maria@company.com',
        description: 'Placeholder for the user picker field in the Share form when browse user permissions are disabled. These examples should be localized.'
    },
    userPickerRequiredMessageBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-only',
        defaultMessage: 'Select at least one email',
        description: 'Error message for the user picker field in the Share form in when browse user permissions are disabled, when no entries are selected.'
    },
    // Generic (Jira)
    userPickerLabelJira: {
        id: 'fabric.elements.share.form.user-picker.label.jira',
        defaultMessage: 'Names, teams, or emails',
        description: 'Label for the user picker field in the Share form in Jira.'
    },
    userPickerPlaceholderJira: {
        id: 'fabric.elements.share.form.user-picker.placeholder.jira',
        defaultMessage: 'e.g. Maria, Team Orange, maria@company.com',
        description: 'Placeholder for the user picker field in the Share form in Jira. These examples should be localized.'
    },
    userPickerRequiredMessageJira: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.jira',
        defaultMessage: 'Select at least one person, team, or email',
        description: 'Error message for the user picker field in the Share form in Jira, when no entries are selected.'
    },
    // Generic (Confluence)
    userPickerLabelConfluence: {
        id: 'fabric.elements.share.form.user-picker.label.confluence',
        defaultMessage: 'Names, teams, groups, or emails',
        description: 'Label for the user picker field in the Share form in Confluence.'
    },
    userPickerPlaceholderConfluence: {
        id: 'fabric.elements.share.form.user-picker.placeholder.confluence',
        defaultMessage: 'e.g. Maria, Team Orange, group-one',
        description: 'Placeholder for the user picker field in the Share form in Confluence. These examples should be localized.'
    },
    userPickerRequiredMessageConfluence: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.confluence',
        defaultMessage: 'Select at least one person, team, group, or email',
        description: 'Error message for the user picker field in the Share form in Confluence, when no entries are selected.'
    },
    // Common messages
    userPickerAddMoreMessage: {
        id: 'fabric.elements.share.form.user-picker.add-more',
        defaultMessage: 'Enter more',
        description: 'Message to encourage the user to add more items to user picker in Share form.'
    },
    userPickerRequiredMessage: {
        id: 'fabric.elements.share.form.user-picker.validation.required',
        defaultMessage: 'Select at least one user, group, team or email.',
        description: 'Required error message for the user picker field in Share form.'
    },
    userPickerExistingUserOnlyNoOptionsMessage: {
        id: 'fabric.elements.share.form.user-picker.no-options.existingUserOnly',
        defaultMessage: `We couldn\u{2019}t find any results for "{inputValue}".`,
        description: 'Existing user only no options message displayed when the search for users returns empty.'
    },
    userPickerGenericNoOptionsMessage: {
        id: 'fabric.elements.share.form.user-picker.no-options.generic',
        defaultMessage: `We couldn\u{2019}t find any results for "{inputValue}". Invite people by using an email address.`,
        description: 'Generic no options message displayed when the search for users returns empty.'
    },
    shareTriggerButtonIconLabel: {
        id: 'fabric.elements.share.trigger.button.icon.label',
        defaultMessage: 'Share icon',
        description: 'Default text for aria-label of the share dialog trigger button icon'
    },
    shareTriggerButtonText: {
        id: 'fabric.elements.share.trigger.button.text',
        defaultMessage: 'Share',
        description: 'Default text for the share dialog trigger button'
    },
    shareTriggerButtonTooltipText: {
        id: 'fabric.elements.share.trigger.button.tooltip.text',
        defaultMessage: 'Share',
        description: 'Default text for tooltip on the icon-only share dialog trigger button'
    },
    inviteTriggerButtonText: {
        id: 'fabric.elements.share.trigger.button.invite.text',
        defaultMessage: 'Invite',
        description: 'Button label for when the sharee action is set to "edit".'
    },
    copyLinkButtonText: {
        id: 'fabric.elements.share.copylink.button.text',
        defaultMessage: 'Copy link',
        description: 'Default text for the Copy Link button'
    },
    copyPublicLinkButtonText: {
        id: 'fabric.elements.share.copypubliclink.button.text',
        defaultMessage: 'Copy public link',
        description: 'Default text for the Copy Link button when the link is public'
    },
    copiedToClipboardMessage: {
        id: 'fabric.elements.share.copied.to.clipboard.message',
        defaultMessage: 'Link copied to clipboard',
        description: 'Default text for the copied link message'
    },
    infoMessageDefaultConfluence: {
        id: 'fabric.elements.share.form.info.message.no.invite.confluence',
        defaultMessage: 'Recipients will see the name of the page and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Confluence page title and the included message'
    },
    infoMessageDefaultJira: {
        id: 'fabric.elements.share.form.info.message.no.invite.jira',
        defaultMessage: 'Recipients will see the name of the issue and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Jira issue title and the included message'
    },
    requiredFieldSummary: {
        id: 'fabric.elements.share.form.required-field.summary',
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Summary info of required fields asterisk.'
    },
    shareFailureIconLabel: {
        id: 'fabric.elements.share.failure.icon.label',
        defaultMessage: 'Error icon',
        description: 'Default text for the aria-label of the share failure error icon in the tooltip'
    },
    shareFailureMessage: {
        id: 'fabric.elements.share.failure.message',
        defaultMessage: 'Unable to share',
        description: 'Default text for share failure message displayed in the tooltip'
    },
    shareSuccessMessage: {
        id: 'fabric.elements.share.success.message',
        defaultMessage: "{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}",
        description: 'Default text for share success message displayed in a flag'
    },
    shareToIntegrationButtonText: {
        id: 'fabric.elements.share.to.integration.button',
        defaultMessage: 'Share to {integrationName}',
        description: 'Text for the button that allows the user to share the currently viewed item through a 3rd party app like Slack'
    },
    shareInIntegrationButtonText: {
        id: 'fabric.elements.share.in.integration.button',
        defaultMessage: 'Share in {integrationName}',
        description: 'Text for the button that allows the user to share the currently viewed item through a 3rd party app like Slack'
    },
    shareMainTabTextJira: {
        id: 'fabric.elements.share.main.tab.text.jira',
        defaultMessage: 'Share issue',
        description: 'Text for the main share tab for jira'
    },
    shareMainTabTextConfluence: {
        id: 'fabric.elements.share.main.tab.text.confluence',
        defaultMessage: 'Share page',
        description: 'Text for the main share tab for confluence'
    },
    inviteToConfluence: {
        id: 'fabric.elements.share.invite.to.confluence',
        defaultMessage: 'Invite to Confluence',
        description: 'Text for the byline of the non-licensed users'
    },
    inviteToJira: {
        id: 'fabric.elements.share.invite.to.jira',
        defaultMessage: 'Invite to Jira',
        description: 'Text for the byline of the non-licensed users'
    },
    sharePopupLabel: {
        id: 'fabric.elements.share.popup.label',
        defaultMessage: 'Share',
        description: 'Label of the popup that contains share menu used by assistive technologies'
    },
    slackMenuItemText: {
        id: 'fabric.elements.share.menu.slack.label',
        defaultMessage: 'Slack',
        description: 'Text for the slack menu in share'
    },
    emailMenuItemText: {
        id: 'fabric.elements.share.menu.email.label',
        defaultMessage: 'Email',
        description: 'Text for the email menu in share'
    }
});

});

parcelRegister("bLAWR", function(module, exports) {

$parcel$export(module.exports, "CHANNEL_ID", () => $755f1378a4aaebbb$export$e5fd2b76433ec8a8);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $755f1378a4aaebbb$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "INTEGRATION_MODAL_SOURCE", () => $755f1378a4aaebbb$export$8944b0a832f27e18);
$parcel$export(module.exports, "screenEvent", () => $755f1378a4aaebbb$export$a129deea0412e0d8);
$parcel$export(module.exports, "shareSplitButtonEvent", () => $755f1378a4aaebbb$export$eab30ffadcd0ab75);
$parcel$export(module.exports, "shareIntegrationButtonEvent", () => $755f1378a4aaebbb$export$f04d85d45801fef1);
$parcel$export(module.exports, "errorEncountered", () => $755f1378a4aaebbb$export$afe83ea4a1997503);
$parcel$export(module.exports, "shareTriggerButtonClicked", () => $755f1378a4aaebbb$export$584e8ee8b04ff145);
$parcel$export(module.exports, "shareTabClicked", () => $755f1378a4aaebbb$export$544b588ba577a9a6);
$parcel$export(module.exports, "shareMenuItemClicked", () => $755f1378a4aaebbb$export$69ab8fd7ab99f6db);
$parcel$export(module.exports, "cancelShare", () => $755f1378a4aaebbb$export$b4731c87331a8174);
$parcel$export(module.exports, "shortUrlRequested", () => $755f1378a4aaebbb$export$35781a2d50f9fba9);
$parcel$export(module.exports, "shortUrlGenerated", () => $755f1378a4aaebbb$export$e78d65558f8d859a);
$parcel$export(module.exports, "copyLinkButtonClicked", () => $755f1378a4aaebbb$export$9af471d00b79f9b0);
$parcel$export(module.exports, "formShareSubmitted", () => $755f1378a4aaebbb$export$e2e6cacbe383cb80);

var $hXhjk = parcelRequire("hXhjk");
const $755f1378a4aaebbb$var$buildAttributes = (attributes = {})=>({
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        ...attributes
    });
const $755f1378a4aaebbb$var$createEvent = (eventType, source, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        source: source,
        attributes: $755f1378a4aaebbb$var$buildAttributes(attributes)
    });
const $755f1378a4aaebbb$var$createScreenEvent = (name, attributes = {})=>({
        eventType: 'screen',
        name: name,
        attributes: $755f1378a4aaebbb$var$buildAttributes(attributes)
    });
const $755f1378a4aaebbb$export$e5fd2b76433ec8a8 = 'fabric-elements';
const $755f1378a4aaebbb$export$f7109619a5e9e0d6 = 'shareModal';
const $755f1378a4aaebbb$export$8944b0a832f27e18 = 'integrationShareDialog';
const $755f1378a4aaebbb$export$a129deea0412e0d8 = ({ isPublicLink: isPublicLink = false })=>$755f1378a4aaebbb$var$createScreenEvent($755f1378a4aaebbb$export$f7109619a5e9e0d6, {
        isPublicLink: isPublicLink
    });
const $755f1378a4aaebbb$export$eab30ffadcd0ab75 = ()=>$755f1378a4aaebbb$var$createEvent('ui', $755f1378a4aaebbb$export$8944b0a832f27e18, 'clicked', 'button', 'shareSplitButton');
const $755f1378a4aaebbb$export$f04d85d45801fef1 = (type = '')=>$755f1378a4aaebbb$var$createEvent('ui', $755f1378a4aaebbb$export$8944b0a832f27e18, 'clicked', 'button', 'shareToIntegration', {
        integrationType: type.toLowerCase()
    });
const $755f1378a4aaebbb$export$afe83ea4a1997503 = (actionSubjectId, attributes = {})=>$755f1378a4aaebbb$var$createEvent('operational', $755f1378a4aaebbb$export$f7109619a5e9e0d6, 'encountered', 'error', actionSubjectId, {
        ...attributes,
        source: $755f1378a4aaebbb$export$f7109619a5e9e0d6
    });
const $755f1378a4aaebbb$export$584e8ee8b04ff145 = ()=>$755f1378a4aaebbb$var$createEvent('ui', $755f1378a4aaebbb$export$f7109619a5e9e0d6, 'clicked', 'button', 'share');
const $755f1378a4aaebbb$export$544b588ba577a9a6 = (subjectId, shareContentType)=>$755f1378a4aaebbb$var$createEvent('ui', $755f1378a4aaebbb$export$f7109619a5e9e0d6, 'clicked', 'tab', subjectId || 'shareTab', {
        shareContentType: shareContentType
    });
const $755f1378a4aaebbb$export$69ab8fd7ab99f6db = (subjectId, shareContentType)=>$755f1378a4aaebbb$var$createEvent('ui', $755f1378a4aaebbb$export$f7109619a5e9e0d6, 'clicked', 'menuItem', subjectId || 'shareMenuItem', {
        shareContentType: shareContentType
    });
const $755f1378a4aaebbb$export$b4731c87331a8174 = (start)=>$755f1378a4aaebbb$var$createEvent('ui', $755f1378a4aaebbb$export$f7109619a5e9e0d6, 'pressed', 'keyboardShortcut', 'cancelShare', {
        source: $755f1378a4aaebbb$export$f7109619a5e9e0d6,
        duration: $755f1378a4aaebbb$var$duration(start)
    });
const $755f1378a4aaebbb$export$35781a2d50f9fba9 = ()=>$755f1378a4aaebbb$var$createEvent('operational', $755f1378a4aaebbb$export$f7109619a5e9e0d6, 'requested', 'shortUrl', undefined, {
        source: $755f1378a4aaebbb$export$f7109619a5e9e0d6
    });
const $755f1378a4aaebbb$export$e78d65558f8d859a = (start, tooSlow)=>$755f1378a4aaebbb$var$createEvent('operational', $755f1378a4aaebbb$export$f7109619a5e9e0d6, 'generated', 'shortUrl', undefined, {
        source: $755f1378a4aaebbb$export$f7109619a5e9e0d6,
        duration: $755f1378a4aaebbb$var$duration(start),
        tooSlow: tooSlow
    });
const $755f1378a4aaebbb$export$9af471d00b79f9b0 = ({ start: start, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareOrigin: shareOrigin, isPublicLink: isPublicLink = false, ari: ari })=>$755f1378a4aaebbb$var$createEvent('ui', $755f1378a4aaebbb$export$f7109619a5e9e0d6, 'clicked', 'button', 'copyShareLink', {
        source: $755f1378a4aaebbb$export$f7109619a5e9e0d6,
        duration: $755f1378a4aaebbb$var$duration(start),
        shortUrl: undefined,
        // unknown at creation, will be filled later
        contentType: shareContentType,
        contentSubType: shareContentSubType,
        contentId: shareContentId,
        isPublicLink: isPublicLink,
        ari: ari,
        // this specific string is needed for marking a successful navigation session
        navdexPointType: 'navigationSessionEnd',
        ...$755f1378a4aaebbb$var$getOriginTracingAttributes(shareOrigin)
    });
const $755f1378a4aaebbb$export$e2e6cacbe383cb80 = ({ start: start, data: data, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareOrigin: shareOrigin, isPublicLink: isPublicLink = false })=>{
    const users = $755f1378a4aaebbb$var$extractIdsByType(data, (0, $hXhjk.isUser));
    const externalUsers = $755f1378a4aaebbb$var$extractIdsByType(data, (0, $hXhjk.isExternalUser));
    const teams = $755f1378a4aaebbb$var$extractIdsByType(data, (0, $hXhjk.isTeam));
    const teamUserCounts = $755f1378a4aaebbb$var$extractMemberCountsFromTeams(data, (0, $hXhjk.isTeam));
    const emails = $755f1378a4aaebbb$var$extractIdsByType(data, (0, $hXhjk.isEmail));
    return $755f1378a4aaebbb$var$createEvent('ui', $755f1378a4aaebbb$export$f7109619a5e9e0d6, 'clicked', 'button', 'submitShare', {
        ...$755f1378a4aaebbb$var$getOriginTracingAttributes(shareOrigin),
        contentType: shareContentType,
        contentSubType: shareContentSubType,
        contentId: shareContentId,
        duration: $755f1378a4aaebbb$var$duration(start),
        emailCount: emails.length,
        teamCount: teams.length,
        userCount: users.length,
        externalUserCount: externalUsers.length,
        users: users,
        teams: teams,
        teamUserCounts: teamUserCounts,
        messageLength: data.comment && data.comment.format === 'plain_text' ? data.comment.value.length : 0,
        isMessageEnabled: true,
        isPublicLink: isPublicLink
    });
};
const $755f1378a4aaebbb$var$duration = (start)=>Date.now() - start;
const $755f1378a4aaebbb$var$getOriginTracingAttributes = (origin)=>origin ? origin.toAnalyticsAttributes({
        hasGeneratedId: true
    }) : {};
const $755f1378a4aaebbb$var$extractIdsByType = (data, checker)=>data.users.filter(checker).map((option)=>option.id);
const $755f1378a4aaebbb$var$extractMemberCountsFromTeams = (data, checker)=>// teams with zero memberships cannot exist in share, so we use that
    // as the default value for undefined team member counts
    data.users.filter(checker).map((option)=>option.memberCount || 0);

});
parcelRegister("hXhjk", function(module, exports) {

$parcel$export(module.exports, "isExternalUser", () => $669a36b46b08f120$export$f6058dbcb5980cb);
$parcel$export(module.exports, "isUser", () => $669a36b46b08f120$export$2e44165f1da65304);
$parcel$export(module.exports, "isTeam", () => $669a36b46b08f120$export$f8c4277cb588611f);
$parcel$export(module.exports, "isGroup", () => $669a36b46b08f120$export$d7976824e9f55785);
$parcel$export(module.exports, "isEmail", () => $669a36b46b08f120$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isCustom", () => $669a36b46b08f120$export$d3a8f0b77e9737fc);
$parcel$export(module.exports, "isDefaultValuePopulated", () => $669a36b46b08f120$export$d6978985a41b0c8);
$parcel$export(module.exports, "extractOptionValue", () => $669a36b46b08f120$export$7ae97131df521bff);
$parcel$export(module.exports, "isIterable", () => $669a36b46b08f120$export$9652023d9040757);
$parcel$export(module.exports, "getOptions", () => $669a36b46b08f120$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "optionToSelectableOptions", () => $669a36b46b08f120$export$e6fda14a194bcbcc);
$parcel$export(module.exports, "getAvatarSize", () => $669a36b46b08f120$export$695fb564e621339a);
$parcel$export(module.exports, "isChildInput", () => $669a36b46b08f120$export$3c62cf9a01367f27);
$parcel$export(module.exports, "isSingleValue", () => $669a36b46b08f120$export$203c2bd2662d1ca2);
$parcel$export(module.exports, "hasValue", () => $669a36b46b08f120$export$96bdbc84526f3739);
$parcel$export(module.exports, "callCallback", () => $669a36b46b08f120$export$df325aa844b03c31);
$parcel$export(module.exports, "getAvatarUrl", () => $669a36b46b08f120$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "isPopupUserPickerByComponent", () => $669a36b46b08f120$export$4f60a74234178416);
$parcel$export(module.exports, "isLozengeText", () => $669a36b46b08f120$export$5419897287f5f1c7);

var $5iWql = parcelRequire("5iWql");


var $5IfN7 = parcelRequire("5IfN7");
const $669a36b46b08f120$export$f6058dbcb5980cb = (option)=>option.type === (0, $fd83a679af43746b$export$50042ec1d2e00e63) || Boolean(option.isExternal);
const $669a36b46b08f120$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $fd83a679af43746b$export$8436e53e45ffe15b);
const $669a36b46b08f120$export$f8c4277cb588611f = (option)=>option.type === (0, $fd83a679af43746b$export$26bc40b960693765);
const $669a36b46b08f120$export$d7976824e9f55785 = (option)=>option.type === (0, $fd83a679af43746b$export$d460f747b73abb10);
const $669a36b46b08f120$export$7fbbfbca30081d0 = (option)=>option.type === (0, $fd83a679af43746b$export$6662b3461398ef8c);
const $669a36b46b08f120$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $fd83a679af43746b$export$eafd0979afa5b224);
const $669a36b46b08f120$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $669a36b46b08f120$var$isOptionData = (option)=>option.name !== undefined;
const $669a36b46b08f120$export$3f993c492bd6c728 = (option)=>{
    if ($669a36b46b08f120$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $669a36b46b08f120$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $669a36b46b08f120$export$9652023d9040757 = (a)=>typeof a[Symbol.iterator] === 'function';
const $669a36b46b08f120$export$d2312e68e1f5ad00 = (0, $5iWql.default)((options)=>options.map($669a36b46b08f120$export$3f993c492bd6c728));
const $669a36b46b08f120$export$e6fda14a194bcbcc = (0, $5iWql.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($669a36b46b08f120$export$3f993c492bd6c728);
    return $669a36b46b08f120$export$3f993c492bd6c728(defaultValue);
});
const $669a36b46b08f120$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $669a36b46b08f120$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $669a36b46b08f120$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $669a36b46b08f120$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $669a36b46b08f120$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
};
const $669a36b46b08f120$export$b4f8f1f54acec99b = (optionData)=>{
    if ($669a36b46b08f120$export$2e44165f1da65304(optionData) || $669a36b46b08f120$export$f8c4277cb588611f(optionData) || $669a36b46b08f120$export$d3a8f0b77e9737fc(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $669a36b46b08f120$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $5IfN7.default);
const $669a36b46b08f120$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $669a36b46b08f120$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};

});
const $fd83a679af43746b$export$8436e53e45ffe15b = 'user';
const $fd83a679af43746b$export$50042ec1d2e00e63 = 'external_user';
const $fd83a679af43746b$export$26bc40b960693765 = 'team';
const $fd83a679af43746b$export$d460f747b73abb10 = 'group';
const $fd83a679af43746b$export$6662b3461398ef8c = 'email';
const $fd83a679af43746b$export$eafd0979afa5b224 = 'custom';



parcelRegister("encBb", function(module, exports) {

$parcel$export(module.exports, "isValidFailedExperience", () => $89788eccf1aec1d5$export$883079293b9cad76);
const $89788eccf1aec1d5$var$ignoredErrorStatusCode = [
    401,
    403,
    429
];
const $89788eccf1aec1d5$export$883079293b9cad76 = (experience, // the type for error is 'any' because consumers of the share config can pass in custom error objects
error)=>{
    const errorStatusCode = error.code || error.status || error.statusCode;
    if ($89788eccf1aec1d5$var$ignoredErrorStatusCode.includes(parseInt(errorStatusCode))) {
        experience.abort({
            metadata: {
                error: error
            }
        });
        return;
    }
    experience.failure({
        metadata: {
            error: error
        }
    });
};

});

parcelRegister("1FYo4", function(module, exports) {

$parcel$export(module.exports, "renderShareDialogExp", () => $df39e89f93526324$export$99c0383421ae57eb);
$parcel$export(module.exports, "shareSubmitExp", () => $df39e89f93526324$export$31627ee726f40567);

var $81rKJ = parcelRequire("81rKJ");
var $4VUeZ = parcelRequire("4VUeZ");
const $df39e89f93526324$export$99c0383421ae57eb = new (0, $4VUeZ.UFOExperience)('render-share-dialog', {
    type: (0, $81rKJ.ExperienceTypes).Experience,
    performanceType: (0, $81rKJ.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $df39e89f93526324$export$31627ee726f40567 = new (0, $4VUeZ.UFOExperience)('share-submit-action', {
    type: (0, $81rKJ.ExperienceTypes).Experience,
    performanceType: (0, $81rKJ.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});

});
parcelRegister("81rKJ", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $f2676a4451455673$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $f2676a4451455673$export$cc26007c03242fff);
var $f2676a4451455673$export$994164cf3ae1cc9a;
(function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
})($f2676a4451455673$export$994164cf3ae1cc9a || ($f2676a4451455673$export$994164cf3ae1cc9a = {}));
var $f2676a4451455673$export$cc26007c03242fff;
(function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
})($f2676a4451455673$export$cc26007c03242fff || ($f2676a4451455673$export$cc26007c03242fff = {}));

});

parcelRegister("4VUeZ", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $ec1bbe1b2945d366$export$c00d22927c60484a);

var $d63TT = parcelRequire("d63TT");
class $ec1bbe1b2945d366$export$c00d22927c60484a extends (0, $d63TT.UFOAbstractExperience) {
}

});
parcelRegister("d63TT", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $c2bc9aefbdfa5f87$export$d31c89db257648c);

var $hompL = parcelRequire("hompL");


var $11Jfd = parcelRequire("11Jfd");

var $6KjoJ = parcelRequire("6KjoJ");

var $hTPY9 = parcelRequire("hTPY9");

var $ES2vf = parcelRequire("ES2vf");

var $D3U2f = parcelRequire("D3U2f");

var $aQeOK = parcelRequire("aQeOK");

var $YpPYM = parcelRequire("YpPYM");

var $eHUHS = parcelRequire("eHUHS");

var $81rKJ = parcelRequire("81rKJ");
const $c2bc9aefbdfa5f87$var$getPageVisibleState = ()=>{
    return !(0, $aQeOK.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $ES2vf.PageVisibleState).VISIBLE : (0, $ES2vf.PageVisibleState).HIDDEN;
};
const $c2bc9aefbdfa5f87$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $D3U2f.roundPerfNow)();
};
class $c2bc9aefbdfa5f87$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $YpPYM.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $ES2vf.PageVisibleState).MIXED;
            (0, $hTPY9.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $c2bc9aefbdfa5f87$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $81rKJ.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $81rKJ.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $6KjoJ.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $eHUHS.canTransition)(this.state, newState)) {
            (0, $6KjoJ.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $YpPYM.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $c2bc9aefbdfa5f87$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $hompL.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $c2bc9aefbdfa5f87$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $11Jfd.getGlobalEventStream)().push((0, $11Jfd.unsubscribeEvent)((0, $ES2vf.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $6KjoJ.ufolog)('this.parent', this.parent);
                (0, $11Jfd.getGlobalEventStream)().push((0, $11Jfd.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $6KjoJ.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $6KjoJ.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $YpPYM.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $c2bc9aefbdfa5f87$var$getPageVisibleState();
            (0, $hTPY9.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $6KjoJ.ufolog)('subscribed', this.id);
                (0, $11Jfd.getGlobalEventStream)().push((0, $11Jfd.subscribeEvent)((0, $ES2vf.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $ES2vf.FMP_MARK) && name !== (0, $ES2vf.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $6KjoJ.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $c2bc9aefbdfa5f87$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $YpPYM.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $ES2vf.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $ES2vf.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $6KjoJ.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $hTPY9.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $YpPYM.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $YpPYM.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $YpPYM.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $6KjoJ.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $fdfbd9402ca234df$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $fdfbd9402ca234df$export$2295b861f318254a = '0.1.5';

parcelRegister("11Jfd", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $e80faf19d0260967$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $e80faf19d0260967$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $e80faf19d0260967$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $e80faf19d0260967$export$7c957416596ca127);

var $6KjoJ = parcelRequire("6KjoJ");

var $ES2vf = parcelRequire("ES2vf");
const $e80faf19d0260967$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $e80faf19d0260967$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $e80faf19d0260967$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $e80faf19d0260967$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $6KjoJ.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $e80faf19d0260967$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $ES2vf.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $e80faf19d0260967$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $ES2vf.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $e80faf19d0260967$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $ES2vf.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("6KjoJ", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $3b095d9d5e1b3ac8$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $3b095d9d5e1b3ac8$export$d53d07b6034c4560);
class $3b095d9d5e1b3ac8$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($3b095d9d5e1b3ac8$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($3b095d9d5e1b3ac8$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $3b095d9d5e1b3ac8$export$4ab84f6f04f6566d = new $3b095d9d5e1b3ac8$var$UFOLogger();
const $3b095d9d5e1b3ac8$export$b4958caff08a0960 = (...args)=>{
    $3b095d9d5e1b3ac8$export$4ab84f6f04f6566d.log(...args);
};
const $3b095d9d5e1b3ac8$export$d53d07b6034c4560 = (...args)=>{
    $3b095d9d5e1b3ac8$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("ES2vf", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $b235f3d851d63f60$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $b235f3d851d63f60$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $b235f3d851d63f60$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $b235f3d851d63f60$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $b235f3d851d63f60$export$837e0f79a8056912);
var $b235f3d851d63f60$export$96253c35c37cf96b;
(function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})($b235f3d851d63f60$export$96253c35c37cf96b || ($b235f3d851d63f60$export$96253c35c37cf96b = {}));
var $b235f3d851d63f60$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
})($b235f3d851d63f60$export$a12c67b37a306b13 || ($b235f3d851d63f60$export$a12c67b37a306b13 = {}));
var $b235f3d851d63f60$export$66b33c055cbb625e;
(function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
})($b235f3d851d63f60$export$66b33c055cbb625e || ($b235f3d851d63f60$export$66b33c055cbb625e = {}));
var $b235f3d851d63f60$export$3ce489cbe02dc21b;
(function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
})($b235f3d851d63f60$export$3ce489cbe02dc21b || ($b235f3d851d63f60$export$3ce489cbe02dc21b = {}));
var $b235f3d851d63f60$export$341b330828bd3906;
(function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
})($b235f3d851d63f60$export$341b330828bd3906 || ($b235f3d851d63f60$export$341b330828bd3906 = {}));
var $b235f3d851d63f60$export$b9b20160f581e4f8;
(function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
})($b235f3d851d63f60$export$b9b20160f581e4f8 || ($b235f3d851d63f60$export$b9b20160f581e4f8 = {}));
const $b235f3d851d63f60$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $b235f3d851d63f60$export$9f2bf58999404c75 = 'fmp';
const $b235f3d851d63f60$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("hTPY9", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $241bc900f7b8581b$export$13e680397ec8f3eb);

var $aQeOK = parcelRequire("aQeOK");
class $241bc900f7b8581b$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $aQeOK.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $241bc900f7b8581b$export$13e680397ec8f3eb = new $241bc900f7b8581b$var$VisibilityChangeObserver();

});
parcelRegister("aQeOK", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $31d49408802005f8$export$15e172712955e18f);
const $31d49408802005f8$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("D3U2f", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $ecea5a474f727a72$export$5f490af6b2b115cf);
const $ecea5a474f727a72$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("YpPYM", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $fbbc02172ff3c387$export$81b70111112841a0);
const $fbbc02172ff3c387$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("eHUHS", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $8eda48793af6a72d$export$178881f329fdb81f);

var $YpPYM = parcelRequire("YpPYM");
const $8eda48793af6a72d$var$UFOStateAvailableTransitions = {
    [(0, $YpPYM.UFOExperienceState).NOT_STARTED.id]: [
        (0, $YpPYM.UFOExperienceState).STARTED.id
    ],
    [(0, $YpPYM.UFOExperienceState).STARTED.id]: [
        (0, $YpPYM.UFOExperienceState).IN_PROGRESS.id,
        (0, $YpPYM.UFOExperienceState).BLOCKED.id,
        (0, $YpPYM.UFOExperienceState).SUCCEEDED.id,
        (0, $YpPYM.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $YpPYM.UFOExperienceState).FAILED.id,
        (0, $YpPYM.UFOExperienceState).ABORTED.id
    ],
    [(0, $YpPYM.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $YpPYM.UFOExperienceState).BLOCKED.id,
        (0, $YpPYM.UFOExperienceState).SUCCEEDED.id,
        (0, $YpPYM.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $YpPYM.UFOExperienceState).FAILED.id,
        (0, $YpPYM.UFOExperienceState).ABORTED.id
    ],
    [(0, $YpPYM.UFOExperienceState).BLOCKED.id]: [
        (0, $YpPYM.UFOExperienceState).RECOVERED.id,
        (0, $YpPYM.UFOExperienceState).ABORTED.id
    ],
    [(0, $YpPYM.UFOExperienceState).RECOVERED.id]: [
        (0, $YpPYM.UFOExperienceState).STARTED.id,
        (0, $YpPYM.UFOExperienceState).SUCCEEDED.id,
        (0, $YpPYM.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $YpPYM.UFOExperienceState).FAILED.id,
        (0, $YpPYM.UFOExperienceState).ABORTED.id
    ],
    [(0, $YpPYM.UFOExperienceState).SUCCEEDED.id]: [
        (0, $YpPYM.UFOExperienceState).STARTED.id
    ],
    [(0, $YpPYM.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $YpPYM.UFOExperienceState).SUCCEEDED.id,
        (0, $YpPYM.UFOExperienceState).FAILED.id,
        (0, $YpPYM.UFOExperienceState).ABORTED.id
    ],
    [(0, $YpPYM.UFOExperienceState).FAILED.id]: [
        (0, $YpPYM.UFOExperienceState).STARTED.id
    ],
    [(0, $YpPYM.UFOExperienceState).ABORTED.id]: [
        (0, $YpPYM.UFOExperienceState).STARTED.id
    ]
};
const $8eda48793af6a72d$export$178881f329fdb81f = (state1, state2)=>{
    return $8eda48793af6a72d$var$UFOStateAvailableTransitions[state1.id] && $8eda48793af6a72d$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});




parcelRegister("a8PoO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae86aa02761d9e62$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $f3klQ = parcelRequire("f3klQ");

var $bLAWR = parcelRequire("bLAWR");
// ErrorBoundary does not support in functional component
// eslint-disable-next-line @repo/internal/react/no-class-components
class $ae86aa02761d9e62$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidCatch(error) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) createAnalyticsEvent((0, $bLAWR.errorEncountered)(undefined, {
            message: error.message,
            errorClass: error.name
        })).fire((0, $bLAWR.CHANNEL_ID));
        this.setState({
            hasError: true
        });
    }
    render() {
        const { hasError: hasError } = this.state;
        if (hasError) // Silently fail.
        return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}
var $ae86aa02761d9e62$export$2e2bcd8739ae039 = (0, $f3klQ.default)()($ae86aa02761d9e62$var$ErrorBoundary);

});

parcelRegister("5PhnX", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf18e513c11645fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");
var $3dpxL = parcelRequire("3dpxL");

var $cyzWb = parcelRequire("cyzWb");
const $cf18e513c11645fd$var$MessagesIntlProvider = ({ intl: intl, children: children })=>{
    const mergedMessages = (0, $eUqFw.useMemo)(()=>{
        return {
            ...intl.messages,
            ...(0, $cyzWb.getMessagesForLocale)(intl.locale)
        };
    }, [
        intl.messages,
        intl.locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: intl.locale,
        messages: mergedMessages,
        defaultLocale: "en-US"
    }, children);
};
var $cf18e513c11645fd$export$2e2bcd8739ae039 = (0, $2qhQi.default)($cf18e513c11645fd$var$MessagesIntlProvider);

});
parcelRegister("cyzWb", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $af0143d0207f3984$export$d0a3169680473b6c);
// Cannot import from `../i18n` because there is `../i18n.tsx` file there.
/* eslint-disable @atlassian/tangerine/import/no-dangling-index */ parcelRequire("bLa9I");
var $1pVkx = parcelRequire("1pVkx");
var $hFPML = parcelRequire("hFPML");
var $9rzcX = parcelRequire("9rzcX");
var $gb9Or = parcelRequire("gb9Or");
var $ikz4n = parcelRequire("ikz4n");
var $1ZMpM = parcelRequire("1ZMpM");
var $elgI5 = parcelRequire("elgI5");
var $4uRAx = parcelRequire("4uRAx");
var $gVpdA = parcelRequire("gVpdA");
var $3p42E = parcelRequire("3p42E");
var $aXPtc = parcelRequire("aXPtc");
var $27y1w = parcelRequire("27y1w");
var $iQwQy = parcelRequire("iQwQy");
var $oAl55 = parcelRequire("oAl55");
var $fAuZu = parcelRequire("fAuZu");
var $6lffV = parcelRequire("6lffV");
var $jdnCB = parcelRequire("jdnCB");
var $7tVzL = parcelRequire("7tVzL");
var $iQT9i = parcelRequire("iQT9i");
var $dsr2c = parcelRequire("dsr2c");
var $85g4r = parcelRequire("85g4r");
var $72G9u = parcelRequire("72G9u");
var $dKOkr = parcelRequire("dKOkr");
var $aSS9W = parcelRequire("aSS9W");
const $af0143d0207f3984$var$localesMessagesMap = {
    cs: $1pVkx.default,
    da: $hFPML.default,
    de: $9rzcX.default,
    en: $gb9Or.default,
    en_GB: $ikz4n.default,
    es: $1ZMpM.default,
    et: $elgI5.default,
    fi: $4uRAx.default,
    fr: $gVpdA.default,
    hu: $3p42E.default,
    is: $aXPtc.default,
    it: $27y1w.default,
    ja: $iQwQy.default,
    ko: $oAl55.default,
    nb: $fAuZu.default,
    nl: $6lffV.default,
    pl: $jdnCB.default,
    pt_BR: $7tVzL.default,
    'pt-BR': (0, $7tVzL.default),
    pt_PT: $iQT9i.default,
    'pt-PT': (0, $iQT9i.default),
    ro: $dsr2c.default,
    ru: $85g4r.default,
    sk: $72G9u.default,
    sv: $dKOkr.default,
    zh: $aSS9W.default
};
const $af0143d0207f3984$export$d0a3169680473b6c = (locale)=>{
    let messages = $af0143d0207f3984$var$localesMessagesMap[locale];
    if (!messages) {
        const parentLocale = locale.split(/[-_]/)[0];
        messages = $af0143d0207f3984$var$localesMessagesMap[parentLocale];
    }
    if (!messages) messages = (0, $gb9Or.default);
    return messages;
};

});
parcelRegister("bLa9I", function(module, exports) {

$parcel$export(module.exports, "zh", () => (parcelRequire("aSS9W")).default);
$parcel$export(module.exports, "cs", () => (parcelRequire("1pVkx")).default);
$parcel$export(module.exports, "da", () => (parcelRequire("hFPML")).default);
$parcel$export(module.exports, "nl", () => (parcelRequire("6lffV")).default);
$parcel$export(module.exports, "et", () => (parcelRequire("elgI5")).default);
$parcel$export(module.exports, "fi", () => (parcelRequire("4uRAx")).default);
$parcel$export(module.exports, "fr", () => (parcelRequire("gVpdA")).default);
$parcel$export(module.exports, "de", () => (parcelRequire("9rzcX")).default);
$parcel$export(module.exports, "hu", () => (parcelRequire("3p42E")).default);
$parcel$export(module.exports, "it", () => (parcelRequire("27y1w")).default);
$parcel$export(module.exports, "ja", () => (parcelRequire("iQwQy")).default);
$parcel$export(module.exports, "ko", () => (parcelRequire("oAl55")).default);
$parcel$export(module.exports, "nb", () => (parcelRequire("fAuZu")).default);
$parcel$export(module.exports, "pl", () => (parcelRequire("jdnCB")).default);
$parcel$export(module.exports, "pt_BR", () => (parcelRequire("7tVzL")).default);
$parcel$export(module.exports, "pt_PT", () => (parcelRequire("iQT9i")).default);
$parcel$export(module.exports, "ru", () => (parcelRequire("85g4r")).default);
$parcel$export(module.exports, "sk", () => (parcelRequire("72G9u")).default);
$parcel$export(module.exports, "es", () => (parcelRequire("1ZMpM")).default);
$parcel$export(module.exports, "sv", () => (parcelRequire("dKOkr")).default);
$parcel$export(module.exports, "en", () => (parcelRequire("gb9Or")).default);
$parcel$export(module.exports, "en_GB", () => (parcelRequire("ikz4n")).default);
$parcel$export(module.exports, "is", () => (parcelRequire("aXPtc")).default);
$parcel$export(module.exports, "ro", () => (parcelRequire("dsr2c")).default);
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $aSS9W = parcelRequire("aSS9W");

var $fq038 = parcelRequire("fq038");

var $1pVkx = parcelRequire("1pVkx");

var $hFPML = parcelRequire("hFPML");

var $6lffV = parcelRequire("6lffV");

var $elgI5 = parcelRequire("elgI5");

var $4uRAx = parcelRequire("4uRAx");

var $gVpdA = parcelRequire("gVpdA");

var $9rzcX = parcelRequire("9rzcX");

var $3p42E = parcelRequire("3p42E");

var $27y1w = parcelRequire("27y1w");

var $iQwQy = parcelRequire("iQwQy");

var $oAl55 = parcelRequire("oAl55");

var $fAuZu = parcelRequire("fAuZu");

var $jdnCB = parcelRequire("jdnCB");

var $7tVzL = parcelRequire("7tVzL");

var $iQT9i = parcelRequire("iQT9i");

var $85g4r = parcelRequire("85g4r");

var $72G9u = parcelRequire("72G9u");

var $1ZMpM = parcelRequire("1ZMpM");

var $dKOkr = parcelRequire("dKOkr");

var $l23Gi = parcelRequire("l23Gi");

var $kZEdI = parcelRequire("kZEdI");

var $9Dz0B = parcelRequire("9Dz0B");

var $9RAG0 = parcelRequire("9RAG0");

var $f2xYB = parcelRequire("f2xYB");

var $gb9Or = parcelRequire("gb9Or");

var $ikz4n = parcelRequire("ikz4n");

var $aXPtc = parcelRequire("aXPtc");

var $dsr2c = parcelRequire("dsr2c");

});
parcelRegister("aSS9W", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ae914cf82d0247a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $3ae914cf82d0247a$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u94FE\u63A5\u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F",
    'fabric.elements.share.copylink.button.text': "\u590D\u5236\u94FE\u63A5",
    'fabric.elements.share.copypubliclink.button.text': "\u590D\u5236\u516C\u5171\u94FE\u63A5",
    'fabric.elements.share.failure.icon.label': "\u9519\u8BEF\u56FE\u6807",
    'fabric.elements.share.failure.message': "\u65E0\u6CD5\u5171\u4EAB",
    'fabric.elements.share.form.comment.label': "\u6D88\u606F\uFF08\u53EF\u9009\uFF09",
    'fabric.elements.share.form.comment.placeholder': "\u5BF9\u65B9\u662F\u5426\u5E94\u77E5\u9053\u67D0\u4E9B\u4FE1\u606F\uFF1F",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u9875\u9762\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u4E8B\u52A1\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.no-permissions': "\u60A8\u65E0\u6CD5\u5171\u4EAB\u3002",
    'fabric.elements.share.form.public.send': "\u53D1\u9001\u516C\u5171\u94FE\u63A5",
    'fabric.elements.share.form.public.share': "\u5206\u4EAB\u516C\u5F00\u94FE\u63A5",
    'fabric.elements.share.form.required-field.summary': "\u5FC5\u586B\u5B57\u6BB5\u6807\u6709\u661F\u53F7",
    'fabric.elements.share.form.retry': "\u91CD\u8BD5",
    'fabric.elements.share.form.send': "\u53D1\u9001",
    'fabric.elements.share.form.share': "\u5171\u4EAB",
    'fabric.elements.share.form.title': "\u5171\u4EAB",
    'fabric.elements.share.form.user-picker.add-more': "\u8F93\u5165\u66F4\u591A",
    'fabric.elements.share.form.user-picker.label.confluence': "\u59D3\u540D\u3001\u56E2\u961F\u3001\u7FA4\u7EC4\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u59D3\u540D\u3001\u56E2\u961F\u6216\u7FA4\u7EC4",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u59D3\u540D\u6216\u56E2\u961F",
    'fabric.elements.share.form.user-picker.label.email-only': "\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.label.jira': "\u59D3\u540D\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "\u6211\u4EEC\u627E\u4E0D\u5230\u4EFB\u4F55\u5173\u4E8E\u201C{inputValue}\u201D\u7684\u7ED3\u679C\u3002",
    'fabric.elements.share.form.user-picker.no-options.generic': "\u6211\u4EEC\u627E\u4E0D\u5230\u4EFB\u4F55\u5173\u4E8E\u201C{inputValue}\u201D\u7684\u7ED3\u679C\u3002\u8BF7\u7528\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u9080\u8BF7\u4ED6\u4EBA\u3002",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F\u3001\u7B2C\u4E00\u7EC4",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u4F8B\u5982\uFF0Cmaria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F\u3001maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u7528\u6237\u3001\u7EC4\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u3002",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u3001\u7FA4\u7EC4\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u6216\u7FA4\u7EC4",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u6216\u56E2\u961F",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.in.integration.button': "\u5728 {integrationName} \u4E2D\u5206\u4EAB",
    'fabric.elements.share.invite.to.confluence': "\u9080\u8BF7\u52A0\u5165 Confluence",
    'fabric.elements.share.invite.to.jira': "\u9080\u8BF7\u52A0\u5165 Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u5206\u4EAB\u9875\u9762",
    'fabric.elements.share.main.tab.text.jira': "\u5171\u4EAB\u4E8B\u52A1",
    'fabric.elements.share.menu.email.label': "\u7535\u5B50\u90AE\u4EF6",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u5171\u4EAB",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u535A\u5BA2\u6587\u7AE0\u5DF2\u5171\u4EAB}board {\u9762\u677F\u5DF2\u5171\u4EAB}calendar {\u65E5\u5386\u5DF2\u5171\u4EAB}draft {\u8349\u7A3F\u5DF2\u5171\u4EAB}filter {\u7B5B\u9009\u5668\u5DF2\u5171\u4EAB}issue {\u4E8B\u52A1\u5DF2\u5171\u4EAB}summary {\u6458\u8981\u5DF2\u5171\u4EAB}list {\u5217\u8868\u5DF2\u5171\u4EAB}timeline {\u65F6\u95F4\u7EBF\u5DF2\u5171\u4EAB}form {\u8868\u5355\u5DF2\u5171\u4EAB}media {\u5A92\u4F53\u5DF2\u5171\u4EAB}page {\u9875\u9762\u5DF2\u5171\u4EAB}project {\u9879\u76EE\u5DF2\u5171\u4EAB}pullrequest {\u62C9\u53D6\u8BF7\u6C42\u5DF2\u5171\u4EAB}question {\u95EE\u9898\u5DF2\u5171\u4EAB}report {\u62A5\u544A\u5DF2\u5171\u4EAB}repository {\u5B58\u50A8\u5E93\u5DF2\u5171\u4EAB}request {\u8BF7\u6C42\u5DF2\u5171\u4EAB}roadmap {\u65F6\u95F4\u7EBF\u5DF2\u5171\u4EAB}site {\u7AD9\u70B9\u5DF2\u5171\u4EAB}space {\u7A7A\u95F4\u5DF2\u5171\u4EAB}other {\u94FE\u63A5\u5DF2\u5171\u4EAB}}",
    'fabric.elements.share.to.integration.button': "\u5206\u4EAB\u5230 {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "\u5171\u4EAB\u56FE\u6807",
    'fabric.elements.share.trigger.button.invite.text': "\u9080\u8BF7",
    'fabric.elements.share.trigger.button.text': "\u5171\u4EAB",
    'fabric.elements.share.trigger.button.tooltip.text': "\u5171\u4EAB"
};

});

parcelRegister("fq038", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $cd9f86d78fb54cc8$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u5DF2\u5C07\u9023\u7D50\u8907\u88FD\u5230\u526A\u8CBC\u7C3F",
    'fabric.elements.share.copylink.button.text': "\u8907\u88FD\u9023\u7D50",
    'fabric.elements.share.copypubliclink.button.text': "\u8907\u88FD\u516C\u958B\u9023\u7D50",
    'fabric.elements.share.failure.icon.label': "\u932F\u8AA4\u5716\u793A",
    'fabric.elements.share.failure.message': "\u7121\u6CD5\u5206\u4EAB",
    'fabric.elements.share.form.comment.label': "\u8A0A\u606F (\u9078\u586B)",
    'fabric.elements.share.form.comment.placeholder': "\u4ED6\u5011\u61C9\u8A72\u77E5\u9053\u54EA\u4E9B\u4E8B\u60C5\uFF1F",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u6536\u4EF6\u8005\u5C07\u770B\u5230\u9801\u9762\u7684\u540D\u7A31\u548C\u60A8\u7684\u8A0A\u606F",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u6536\u4EF6\u8005\u5C07\u770B\u5230\u8B70\u984C\u7684\u540D\u7A31\u548C\u60A8\u7684\u8A0A\u606F",
    'fabric.elements.share.form.no-permissions': "\u60A8\u7121\u6CD5\u5206\u4EAB\u3002",
    'fabric.elements.share.form.public.send': "\u50B3\u9001\u516C\u958B\u9023\u7D50",
    'fabric.elements.share.form.public.share': "\u5171\u7528\u516C\u958B\u9023\u7D50",
    'fabric.elements.share.form.required-field.summary': "\u5FC5\u586B\u6B04\u4F4D\u6A19\u6709\u661F\u865F",
    'fabric.elements.share.form.retry': "\u91CD\u8A66",
    'fabric.elements.share.form.send': "\u50B3\u9001",
    'fabric.elements.share.form.share': "\u5206\u4EAB",
    'fabric.elements.share.form.title': "\u5206\u4EAB",
    'fabric.elements.share.form.user-picker.add-more': "\u8F38\u5165\u66F4\u591A\u9805\u76EE",
    'fabric.elements.share.form.user-picker.label.confluence': "\u540D\u7A31\u3001\u5718\u968A\u3001\u7FA4\u7D44\u6216\u96FB\u5B50\u90F5\u4EF6",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u540D\u7A31\u3001\u5718\u968A\u6216\u7FA4\u7D44",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u540D\u7A31\u6216\u5718\u968A",
    'fabric.elements.share.form.user-picker.label.email-only': "\u96FB\u5B50\u90F5\u4EF6",
    'fabric.elements.share.form.user-picker.label.jira': "\u540D\u7A31\u3001\u5718\u968A\u6216\u96FB\u5B50\u90F5\u4EF6",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "\u6211\u5011\u627E\u4E0D\u5230\u300C{inputValue}\u300D\u7684\u4EFB\u4F55\u7D50\u679C\u3002",
    'fabric.elements.share.form.user-picker.no-options.generic': "\u6211\u5011\u627E\u4E0D\u5230\u300C{inputValue}\u300D\u7684\u4EFB\u4F55\u7D50\u679C\u3002\u8ACB\u900F\u904E\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u9080\u8ACB\u4F7F\u7528\u8005\u3002",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u4F8B\u5982\uFF1A\u746A\u9E97\u4E9E, \u6A58\u968A, \u7B2C\u4E00\u7D44",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u4F8B\u5982\uFF1A\u746A\u9E97\u4E9E, \u6A58\u968A",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u4F8B\u5982\uFF1Amaria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u4F8B\u5982\uFF1A\u746A\u9E97\u4E9E, \u6A58\u968A, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u8ACB\u81F3\u5C11\u9078\u53D6\u4E00\u500B\u4F7F\u7528\u8005\u3001\u7FA4\u7D44\u3001\u5718\u968A\u6216\u96FB\u5B50\u90F5\u4EF6\u3002",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u81F3\u5C11\u9078\u53D6\u4E00\u500B\u4EBA\u54E1\u3001\u5718\u968A\u3001\u7FA4\u7D44\u6216\u96FB\u5B50\u90F5\u4EF6",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u81F3\u5C11\u9078\u53D6\u4E00\u500B\u4EBA\u54E1\u3001\u5718\u968A\u6216\u7FA4\u7D44",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u81F3\u5C11\u9078\u53D6\u4E00\u500B\u4EBA\u54E1\u6216\u5718\u968A",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u81F3\u5C11\u9078\u53D6\u4E00\u500B\u96FB\u5B50\u90F5\u4EF6",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u81F3\u5C11\u9078\u53D6\u4E00\u500B\u4EBA\u54E1\u3001\u5718\u968A\u6216\u96FB\u5B50\u90F5\u4EF6",
    'fabric.elements.share.in.integration.button': "\u5728 {integrationName} \u4E2D\u5206\u4EAB",
    'fabric.elements.share.invite.to.confluence': "\u9080\u8ACB\u52A0\u5165 Confluence",
    'fabric.elements.share.invite.to.jira': "\u9080\u8ACB\u52A0\u5165 Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u5206\u4EAB\u9801\u9762",
    'fabric.elements.share.main.tab.text.jira': "\u5171\u7528\u8B70\u984C",
    'fabric.elements.share.menu.email.label': "\u96FB\u5B50\u90F5\u4EF6",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u5206\u4EAB",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u5DF2\u5206\u4EAB\u90E8\u843D\u683C\u8CBC\u6587}board {\u5DF2\u5206\u4EAB\u770B\u677F}calendar {\u5DF2\u5206\u4EAB\u884C\u4E8B\u66C6}draft {\u5DF2\u5206\u4EAB\u8349\u7A3F}filter {\u5DF2\u5206\u4EAB\u7BE9\u9078\u689D\u4EF6}issue {\u5DF2\u5206\u4EAB\u8B70\u984C}summary {\u5DF2\u5206\u4EAB\u6458\u8981}list {\u5DF2\u5206\u4EAB\u5217\u8868}timeline {\u5DF2\u5206\u4EAB\u6642\u9593\u8868}form {\u5DF2\u5206\u4EAB\u8868\u55AE}media {\u5DF2\u5206\u4EAB\u5A92\u9AD4}page {\u5DF2\u5206\u4EAB\u9801\u9762}project {\u5DF2\u5206\u4EAB\u5C08\u6848}pullrequest {\u5DF2\u5206\u4EAB\u63D0\u53D6\u8981\u6C42}question {\u5DF2\u5206\u4EAB\u554F\u984C}report {\u5DF2\u5206\u4EAB\u5831\u544A}repository {\u5DF2\u5206\u4EAB\u5B58\u653E\u5EAB}request {\u5DF2\u5206\u4EAB\u8981\u6C42}roadmap {\u5DF2\u5206\u4EAB\u6642\u9593\u8EF8}site {\u5DF2\u5206\u4EAB\u7DB2\u7AD9}space {\u5DF2\u5206\u4EAB\u7A7A\u9593}other {\u5DF2\u5206\u4EAB\u9023\u7D50}}",
    'fabric.elements.share.to.integration.button': "\u8207 {integrationName} \u5206\u4EAB",
    'fabric.elements.share.trigger.button.icon.label': "\u5206\u4EAB\u5716\u793A",
    'fabric.elements.share.trigger.button.invite.text': "\u9080\u8ACB",
    'fabric.elements.share.trigger.button.text': "\u5206\u4EAB",
    'fabric.elements.share.trigger.button.tooltip.text': "\u5206\u4EAB"
};

});

parcelRegister("1pVkx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e96e2960dbc125a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $9e96e2960dbc125a$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Odkaz zkop\xedrov\xe1n do schr\xe1nky",
    'fabric.elements.share.copylink.button.text': "Zkop\xedrovat odkaz",
    'fabric.elements.share.copypubliclink.button.text': "Kop\xedrovat ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.failure.icon.label': 'Ikona chyby',
    'fabric.elements.share.failure.message': "Nelze sd\xedlet",
    'fabric.elements.share.form.comment.label': "Zpr\xe1va (voliteln\xe1)",
    'fabric.elements.share.form.comment.placeholder': "N\u011Bco, co by m\u011Bli v\u011Bd\u011Bt?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "P\u0159\xedjemci uvid\xed n\xe1zev str\xe1nky a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.info.message.no.invite.jira': "P\u0159\xedjemci uvid\xed n\xe1zev po\u017Eadavku a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.no-permissions': "Nem\xe1te mo\u017Enost sd\xedlet.",
    'fabric.elements.share.form.public.send': "Odeslat ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.form.public.share': "Sd\xedlet ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.form.required-field.summary': "Povinn\xe1 pole jsou ozna\u010Dena hv\u011Bzdi\u010Dkou.",
    'fabric.elements.share.form.retry': 'Zkusit znovu',
    'fabric.elements.share.form.send': 'Odeslat',
    'fabric.elements.share.form.share': "Sd\xedlet",
    'fabric.elements.share.form.title': "Sd\xedlet",
    'fabric.elements.share.form.user-picker.add-more': "Zadejte v\xedce",
    'fabric.elements.share.form.user-picker.label.confluence': "Jm\xe9na, t\xfdmy, skupiny nebo e-maily",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Jm\xe9na, t\xfdmy nebo skupiny",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Jm\xe9na nebo t\xfdmy",
    'fabric.elements.share.form.user-picker.label.email-only': 'E-maily',
    'fabric.elements.share.form.user-picker.label.jira': "Jm\xe9na, t\xfdmy nebo e-maily",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Pro \u201E{inputValue}\u201C se nepoda\u0159ilo naj\xedt \u017E\xe1dn\xe9 v\xfdsledky.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Pro \u201E{inputValue}\u201C se nepoda\u0159ilo naj\xedt \u017E\xe1dn\xe9 v\xfdsledky. Pozv\u011Bte lidi pomoc\xed jejich e-mailov\xe9 adresy.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "nap\u0159. Marie, T\xfdm pomeran\u010D, skupina-jedna",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "nap\u0159. Marie, T\xfdm pomeran\u010D",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "nap\u0159. marie@spolecnost.cz",
    'fabric.elements.share.form.user-picker.placeholder.jira': "nap\u0159. Marie, T\xfdm pomeran\u010D, marie@spolecnost.cz",
    'fabric.elements.share.form.user-picker.validation.required': "Vyberte alespo\u0148 jednoho u\u017Eivatele, skupinu, t\xfdm nebo e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Vyberte alespo\u0148 jednu osobu, t\xfdm, skupinu nebo e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Vyberte alespo\u0148 jednu osobu, t\xfdm nebo skupinu",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Vyberte alespo\u0148 jednu osobu nebo t\xfdm",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Vyberte alespo\u0148 jeden e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Vyberte alespo\u0148 jednu osobu, t\xfdm nebo e-mail",
    'fabric.elements.share.in.integration.button': "Sd\xedlet v: {integrationName}",
    'fabric.elements.share.invite.to.confluence': 'Pozvat do Confluence',
    'fabric.elements.share.invite.to.jira': 'Pozvat do Jira',
    'fabric.elements.share.main.tab.text.confluence': "Sd\xedlet str\xe1nku",
    'fabric.elements.share.main.tab.text.jira': "Sd\xedlet po\u017Eadavek",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Sd\xedlet",
    'fabric.elements.share.success.message': "{object, select,blogpost {P\u0159\xedsp\u011Bvek na blogu byl sd\xedlen}board {Board byl sd\xedlen}calendar {Kalend\xe1\u0159 byl sd\xedlen}draft {Koncept byl sd\xedlen}filter {Filtr byl sd\xedlen}issue {Po\u017Eadavek byl sd\xedlen}summary {Souhrn byl sd\xedlen}list {Seznam byl sd\xedlen}timeline {\u010Casov\xe1 osa byla sd\xedlena}form {Formul\xe1\u0159 byl sd\xedlen}media {Multim\xe9dia byla sd\xedlena}page {Str\xe1nka byla sd\xedlena}project {Projekt byl sd\xedlen}pullrequest {Pull request byl sd\xedlen}question {Ot\xe1zka byla sd\xedlena}report {Sestava byla sd\xedlena}repository {Repozit\xe1\u0159 byl sd\xedlen}request {\u017D\xe1dost byla sd\xedlena}roadmap {\u010Casov\xe1 osa byla sd\xedlena}site {Web byl sd\xedlen}space {Prostor byl sd\xedlen}other {Odkaz byl sd\xedlen}}",
    'fabric.elements.share.to.integration.button': "Sd\xedlet ve slu\u017Eb\u011B {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona sd\xedlen\xed",
    'fabric.elements.share.trigger.button.invite.text': 'Pozvat',
    'fabric.elements.share.trigger.button.text': "Sd\xedlet",
    'fabric.elements.share.trigger.button.tooltip.text': "Sd\xedlet"
};

});

parcelRegister("hFPML", function(module, exports) {

$parcel$export(module.exports, "default", () => $388256f4dca9bfdf$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $388256f4dca9bfdf$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link er kopieret til udklipsholder',
    'fabric.elements.share.copylink.button.text': 'Kopier link',
    'fabric.elements.share.copypubliclink.button.text': "Kopi\xe9r offentligt link",
    'fabric.elements.share.failure.icon.label': 'Fejlikon',
    'fabric.elements.share.failure.message': 'Kan ikke deles',
    'fabric.elements.share.form.comment.label': 'Besked (valgfrit)',
    'fabric.elements.share.form.comment.placeholder': "Er der noget, de b\xf8r vide?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Modtagere vil se navnet p\xe5 siden og din besked",
    'fabric.elements.share.form.info.message.no.invite.jira': "Modtagere vil se navnet p\xe5 sagen og din meddelelse",
    'fabric.elements.share.form.no-permissions': 'Du kan ikke dele.',
    'fabric.elements.share.form.public.send': 'Send offentligt link',
    'fabric.elements.share.form.public.share': 'Del offentligt link',
    'fabric.elements.share.form.required-field.summary': "P\xe5kr\xe6vede felter er markeret med en stjerne",
    'fabric.elements.share.form.retry': "Pr\xf8v igen",
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Del',
    'fabric.elements.share.form.title': 'Del',
    'fabric.elements.share.form.user-picker.add-more': 'Indtast mere',
    'fabric.elements.share.form.user-picker.label.confluence': 'Navne, teams, grupper eller e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Navne, teams eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Navne eller teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Navne, teams eller e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi kunne ikke finde nogen resultater for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi kunne ikke finde nogen resultater for "{inputValue}". Invit\xe9r personer via e-mailadresser.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'f.eks. Maria, Team Orange, gruppe et',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'f.eks. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'f.eks. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'f.eks. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': "V\xe6lg mindst \xe9n bruger, \xe9n gruppe, \xe9t team eller \xe9n e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe6lg mindst en person, et team, en gruppe eller en e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe6lg mindst en person, et team eller en gruppe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe6lg mindst en person eller et team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe6lg mindst en e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe6lg mindst en person, et team eller en e-mail",
    'fabric.elements.share.in.integration.button': 'Del i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Inviter til Confluence',
    'fabric.elements.share.invite.to.jira': 'Inviter til Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Del side',
    'fabric.elements.share.main.tab.text.jira': 'Del sag',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Del',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogindl\xe6g delt}board {Tavle delt}calendar {Kalender delt}draft {Udkast delt}filter {Filter delt}issue {Sag delt}summary {Oversigt delt}list {Liste delt}timeline {Tidslinje delt}form {Formular delt}media {Medier delt}page {Side delt}project {Projekt delt}pullrequest {Pullanmodning delt}question {Sp\xf8rgsm\xe5l delt}report {Rapport delt}repository {Lager delt}request {Anmodning delt}roadmap {Tidslinje delt}site {Websted delt}space {Omr\xe5de delt}other {Link delt}}",
    'fabric.elements.share.to.integration.button': 'Del med {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Del ikon',
    'fabric.elements.share.trigger.button.invite.text': "Invit\xe9r",
    'fabric.elements.share.trigger.button.text': 'Del',
    'fabric.elements.share.trigger.button.tooltip.text': 'Del'
};

});

parcelRegister("6lffV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccfc154481b62bad$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $ccfc154481b62bad$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link naar klembord gekopieerd',
    'fabric.elements.share.copylink.button.text': "Link kopi\xebren",
    'fabric.elements.share.copypubliclink.button.text': "Openbare link kopi\xebren",
    'fabric.elements.share.failure.icon.label': "Pictogram 'Fout'",
    'fabric.elements.share.failure.message': 'Kan niet delen',
    'fabric.elements.share.form.comment.label': 'Bericht (optioneel)',
    'fabric.elements.share.form.comment.placeholder': 'Is er iets ze moet weten?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Ontvangers zien de naam van de pagina en je bericht',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Ontvangers zien de naam van de issue en je bericht',
    'fabric.elements.share.form.no-permissions': 'Je kunt niet delen.',
    'fabric.elements.share.form.public.send': 'Openbare link verzenden',
    'fabric.elements.share.form.public.share': 'Openbare link delen',
    'fabric.elements.share.form.required-field.summary': 'Verplichte velden zijn aangeduid met een asterisk',
    'fabric.elements.share.form.retry': 'Opnieuw proberen',
    'fabric.elements.share.form.send': 'Verzenden',
    'fabric.elements.share.form.share': 'Delen',
    'fabric.elements.share.form.title': 'Delen',
    'fabric.elements.share.form.user-picker.add-more': 'Meer invoeren',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namen, teams, groepen of e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namen, teams of groepen',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namen of teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Namen, teams of e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Geen resultaten gevonden voor ''{inputValue}'.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Geen resultaten gevonden voor ''{inputValue}'. Nodig personen uit door hun e-mailadres in te voeren.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'bijv. Maria, team Oranje, groep-een',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'bijv. Maria, team Oranje',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'bijv. Maria, maria@bedrijf.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'bijv. Maria, team Oranje, maria@bedrijf.com',
    'fabric.elements.share.form.user-picker.validation.required': "Selecteer minimaal \xe9\xe9n gebruiker, groep, team of e-mailadres.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Selecteer minimaal \xe9\xe9n persoon, team, groep of e-mailadres",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Selecteer minimaal \xe9\xe9n persoon, team of groep",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Selecteer minimaal \xe9\xe9n persoon of team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Selecteer minimaal \xe9\xe9n e-mailadres",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Selecteer minimaal \xe9\xe9n persoon, team of e-mailadres",
    'fabric.elements.share.in.integration.button': 'Delen in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Uitnodigen voor Confluence',
    'fabric.elements.share.invite.to.jira': 'Uitnodigen voor Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Pagina delen',
    'fabric.elements.share.main.tab.text.jira': 'Issue delen',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Delen',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blogpost gedeeld}board {Bord gedeeld}calendar {Agenda gedeeld}draft {Concept gedeeld}filter {Filter gedeeld}issue {Issue gedeeld}summary {Samenvatting gedeeld}list {Lijst gedeeld}timeline {Tijdlijn gedeeld}form {Formulier gedeeld}media {Media gedeeld}page {Pagina gedeeld}project {Project gedeeld}pullrequest {Pull-request gedeeld}question {Vraag gedeeld}report {Rapport gedeeld}repository {Repository gedeeld}request {Aanvraag gedeeld}roadmap {Tijdlijn gedeeld}site {Site gedeeld}space {Space gedeeld}other {Link gedeeld}}',
    'fabric.elements.share.to.integration.button': 'Delen met {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "Pictogram 'Delen'",
    'fabric.elements.share.trigger.button.invite.text': 'Uitnodigen',
    'fabric.elements.share.trigger.button.text': 'Delen',
    'fabric.elements.share.trigger.button.tooltip.text': 'Delen'
};

});

parcelRegister("elgI5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b639e82a38440eb$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Estonian
var $5b639e82a38440eb$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Link kopeeritud l\xf5ikelauale",
    'fabric.elements.share.copylink.button.text': 'Kopeeri link',
    'fabric.elements.share.failure.icon.label': 'Vea ikoon',
    'fabric.elements.share.failure.message': 'Jagamine nurjus',
    'fabric.elements.share.form.comment.placeholder': "S\xf5numi lisamine",
    'fabric.elements.share.form.retry': 'Proovi uuesti',
    'fabric.elements.share.form.send': 'Saada',
    'fabric.elements.share.form.title': 'Jaga',
    'fabric.elements.share.form.user-picker.add-more': 'Sisesta veel',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Me ei suutnud leida \xfchtegi tulemust seoses otsitavaga \u201E{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Me ei suutnud leida \xfchtegi tulemust seoses otsitavaga \u201E{inputValue}". Kutsu inimesi e-posti aadressi alusel.',
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Sisesta nimi v\xf5i meeskond",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Sisestage nimi, r\xfchm, meeskond v\xf5i meil",
    'fabric.elements.share.form.user-picker.placeholder.jira': "Sisestage nimi, tiim v\xf5i meil",
    'fabric.elements.share.form.user-picker.validation.required': "Valige v\xe4hemalt \xfcks kasutaja, r\xfchm, meeskond v\xf5i meil.",
    'fabric.elements.share.form.user-picker.validation.required.jira': "Valige v\xe4hemalt \xfcks kasutaja, tiim v\xf5i meil.",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blogipostitus jagatud} board {T\xf6\xf6laud jagatud} calendar {Kalender jagatud} draft {Mustand jagatud} filter {Filter jagatud} issue {Probleem jagatud} media {Meediafail jagatud} page {Leht jagatud} project {Projekt jagatud} pullrequest {T\xf5mbekutse jagatud} question {K\xfcsimus jagatud} report {Raport jagatud} repository {Koodihoidla jagatud} request {Taotlus jagatud} roadmap {T\xf6\xf6plaan jagatud} site {Sait jagatud} space {Ruum jagatud} other {Link jagatud}}",
    'fabric.elements.share.trigger.button.icon.label': 'Jagamisikoon',
    'fabric.elements.share.trigger.button.invite.text': 'Kutsu',
    'fabric.elements.share.trigger.button.text': 'Jaga',
    'fabric.elements.share.trigger.button.tooltip.text': 'Jaga'
};

});

parcelRegister("4uRAx", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ec4dfd811a08b19$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $2ec4dfd811a08b19$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Linkki kopioitu leikep\xf6yd\xe4lle",
    'fabric.elements.share.copylink.button.text': 'Kopioi linkki',
    'fabric.elements.share.copypubliclink.button.text': 'Kopioi julkinen linkki',
    'fabric.elements.share.failure.icon.label': 'Virhekuvake',
    'fabric.elements.share.failure.message': 'Ei voitu jakaa',
    'fabric.elements.share.form.comment.label': 'Viesti (valinnainen)',
    'fabric.elements.share.form.comment.placeholder': "Mit\xe4 muiden tulisi tiet\xe4\xe4?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Vastaanottajat n\xe4kev\xe4t sivun nimen ja viestisi",
    'fabric.elements.share.form.info.message.no.invite.jira': "Vastaanottajat n\xe4kev\xe4t asian nimen ja viestisi",
    'fabric.elements.share.form.no-permissions': 'Sinulla ei ole jakamisoikeutta.',
    'fabric.elements.share.form.public.send': "L\xe4het\xe4 julkinen linkki",
    'fabric.elements.share.form.public.share': 'Jaa julkinen linkki',
    'fabric.elements.share.form.required-field.summary': "Pakolliset kent\xe4t on merkitty t\xe4hdell\xe4",
    'fabric.elements.share.form.retry': "Yrit\xe4 uudelleen",
    'fabric.elements.share.form.send': "L\xe4het\xe4",
    'fabric.elements.share.form.share': 'Jaa',
    'fabric.elements.share.form.title': 'Jaa',
    'fabric.elements.share.form.user-picker.add-more': "Sy\xf6t\xe4 lis\xe4\xe4",
    'fabric.elements.share.form.user-picker.label.confluence': "Nimet, tiimit, ryhm\xe4t tai s\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Nimet, tiimit tai ryhm\xe4t",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nimet tai tiimit',
    'fabric.elements.share.form.user-picker.label.email-only': "S\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.label.jira': "Nimet, tiimit tai s\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Tuloksia ei l\xf6ytynyt haulle "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Tuloksia ei l\xf6ytynyt haulle "{inputValue}". Kutsu henkil\xf6it\xe4 s\xe4hk\xf6postiosoitteen avulla.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "esim. Maria, Oranssi tiimi, ykk\xf6sryhm\xe4",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'esim. Maria, Oranssi tiimi',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'esim. maria@yritys.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'esim. Maria, Oranssi tiimi, maria@yritys.com',
    'fabric.elements.share.form.user-picker.validation.required': "Valitse v\xe4hint\xe4\xe4n yksi k\xe4ytt\xe4j\xe4, ryhm\xe4, tiimi tai s\xe4hk\xf6postiosoite.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi, ryhm\xe4 tai s\xe4hk\xf6postiosoite",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi tai ryhm\xe4",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6 tai tiimi",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Valitse v\xe4hint\xe4\xe4n yksi s\xe4hk\xf6postiosoite",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi tai s\xe4hk\xf6postiosoite",
    'fabric.elements.share.in.integration.button': 'Jaa sovelluksessa {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Kutsu Confluenceen',
    'fabric.elements.share.invite.to.jira': 'Kutsu Jiraan',
    'fabric.elements.share.main.tab.text.confluence': 'Jaa sivu',
    'fabric.elements.share.main.tab.text.jira': 'Jaa asia',
    'fabric.elements.share.menu.email.label': "S\xe4hk\xf6posti",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Jaa',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogijulkaisu jaettu}board {Taulu jaettu}calendar {Kalenteri jaettu}draft {Luonnos jaettu}filter {Suodatin jaettu}issue {Asia jaettu}summary {Yhteenveto jaettu}list {Luettelo jaettu}timeline {Aikajana jaettu}form {Lomake jaettu}media {Media jaettu}page {Sivu jaettu}project {Projekti jaettu}pullrequest {Pull-pyynt\xf6 jaettu}question {Kysymys jaettu}report {Raportti jaettu}repository {S\xe4il\xf6 jaettu}request {Pyynt\xf6 jaettu}roadmap {Aikajana jaettu}site {Sivusto jaettu}space {Ty\xf6tila jaettu}other {Linkki jaettu}}",
    'fabric.elements.share.to.integration.button': 'Jaa kohteeseen {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Jaa kuvake',
    'fabric.elements.share.trigger.button.invite.text': 'Kutsu',
    'fabric.elements.share.trigger.button.text': 'Jaa',
    'fabric.elements.share.trigger.button.tooltip.text': 'Jaa'
};

});

parcelRegister("gVpdA", function(module, exports) {

$parcel$export(module.exports, "default", () => $26417267e1cd8641$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $26417267e1cd8641$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Lien copi\xe9 dans le presse-papier",
    'fabric.elements.share.copylink.button.text': 'Copier le lien',
    'fabric.elements.share.copypubliclink.button.text': 'Copier le lien public',
    'fabric.elements.share.failure.icon.label': "Ic\xf4ne d'erreur",
    'fabric.elements.share.failure.message': 'Partage impossible',
    'fabric.elements.share.form.comment.label': 'Message (facultatif)',
    'fabric.elements.share.form.comment.placeholder': "D'autres choses \xe0 savoir\xa0?",
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Les destinataires verront le nom de la page et votre message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Les destinataires verront le nom du ticket et votre message',
    'fabric.elements.share.form.no-permissions': 'Vous ne pouvez pas partager ce contenu.',
    'fabric.elements.share.form.public.send': 'Envoyer le lien public',
    'fabric.elements.share.form.public.share': 'Partager un lien public',
    'fabric.elements.share.form.required-field.summary': "Les champs obligatoires sont marqu\xe9s d'un ast\xe9risque",
    'fabric.elements.share.form.retry': "R\xe9essayer",
    'fabric.elements.share.form.send': 'Envoyer',
    'fabric.elements.share.form.share': 'Partager',
    'fabric.elements.share.form.title': 'Partager',
    'fabric.elements.share.form.user-picker.add-more': "Saisir plus d\u2019\xe9l\xe9ments",
    'fabric.elements.share.form.user-picker.label.confluence': "Noms, \xe9quipes, groupes ou e-mails",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Noms, \xe9quipes ou groupes",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Noms ou \xe9quipes",
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': "Noms, \xe9quipes ou e-mails",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Pas de r\xe9sultats pour \xab\xa0{inputValue}\xa0\xbb.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Pas de r\xe9sultats pour \xab\xa0{inputValue}\xa0\xbb. Invitez des personnes \xe0 l'aide d'une adresse e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "Par exemple, Maria, \xe9quipe Orange, groupe-1",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "Par exemple, Maria, \xe9quipe Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'Par exemple, maria@entreprise.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': "Par exemple, Maria, \xe9quipe Orange, maria@entreprise.com",
    'fabric.elements.share.form.user-picker.validation.required': "S\xe9lectionnez au moins un utilisateur, un groupe, une \xe9quipe ou une adresse e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "S\xe9lectionnez au moins une personne, une \xe9quipe, un groupe ou un e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "S\xe9lectionnez au moins une personne, une \xe9quipe ou un groupe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "S\xe9lectionnez au moins une personne ou \xe9quipe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "S\xe9lectionnez au moins un e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "S\xe9lectionnez au moins une personne, une \xe9quipe ou un e-mail",
    'fabric.elements.share.in.integration.button': 'Partager dans {integrationName}',
    'fabric.elements.share.invite.to.confluence': "Inviter \xe0 rejoindre Confluence",
    'fabric.elements.share.invite.to.jira': "Inviter \xe0 rejoindre Jira",
    'fabric.elements.share.main.tab.text.confluence': 'Partager la page',
    'fabric.elements.share.main.tab.text.jira': 'Partager le ticket',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Partager',
    'fabric.elements.share.success.message': "{object, select,blogpost {Billet de blog partag\xe9}board {Tableau partag\xe9}calendar {Calendrier partag\xe9}draft {Brouillon partag\xe9}filter {Filtre partag\xe9}issue {Ticket partag\xe9}summary {R\xe9sum\xe9 partag\xe9}list {Liste partag\xe9e}timeline {Chronologie partag\xe9e}form {Formulaire partag\xe9}media {M\xe9dia partag\xe9}page {Page partag\xe9e}project {Projet partag\xe9}pullrequest {Pull request partag\xe9e}question {Question partag\xe9e}report {Rapport partag\xe9}repository {D\xe9p\xf4t partag\xe9}request {Demande partag\xe9e}roadmap {Chronologie partag\xe9e}site {Site partag\xe9}space {Espace partag\xe9}other {Lien partag\xe9}}",
    'fabric.elements.share.to.integration.button': 'Partager avec {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "Ic\xf4ne de partage",
    'fabric.elements.share.trigger.button.invite.text': 'Inviter',
    'fabric.elements.share.trigger.button.text': 'Partager',
    'fabric.elements.share.trigger.button.tooltip.text': 'Partager'
};

});

parcelRegister("9rzcX", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf5f67031dfc3d73$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $bf5f67031dfc3d73$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link in Zwischenablage kopiert',
    'fabric.elements.share.copylink.button.text': 'Link kopieren',
    'fabric.elements.share.copypubliclink.button.text': "\xd6ffentlichen Link kopieren",
    'fabric.elements.share.failure.icon.label': 'Fehler-Symbol',
    'fabric.elements.share.failure.message': "Teilen nicht m\xf6glich",
    'fabric.elements.share.form.comment.label': 'Nachricht (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Irgendetwas Wissenswertes?',
    'fabric.elements.share.form.info.message.no.invite.confluence': "Empf\xe4nger sehen den Namen der Seite und Ihre Nachricht",
    'fabric.elements.share.form.info.message.no.invite.jira': "Empf\xe4nger sehen den Namen des Vorgangs und Ihre Nachricht",
    'fabric.elements.share.form.no-permissions': "Sie k\xf6nnen keine Elemente teilen.",
    'fabric.elements.share.form.public.send': "\xd6ffentlichen Link senden",
    'fabric.elements.share.form.public.share': "\xd6ffentlichen Link teilen",
    'fabric.elements.share.form.required-field.summary': 'Pflichtfelder sind mit einem Sternchen markiert.',
    'fabric.elements.share.form.retry': 'Erneut versuchen',
    'fabric.elements.share.form.send': 'Senden',
    'fabric.elements.share.form.share': 'Teilen',
    'fabric.elements.share.form.title': 'Teilen',
    'fabric.elements.share.form.user-picker.add-more': 'Weitere eingeben',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namen, Teams, Gruppen oder E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namen, Teams oder Gruppen',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namen oder Teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.label.jira': 'Namen, Teams oder E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Es wurden keine Ergebnisse f\xfcr \u201E{inputValue}\u201C gefunden.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Es wurden keine Ergebnisse f\xfcr \u201E{inputValue}\u201C gefunden. Laden Sie Personen mittels E-Mail-Adresse ein.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "z.\xa0B. Maria, Team Orange, Gruppe eins",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "z.\xa0B. Maria, Team Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "z.\xa0B. maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "z.\xa0B. Maria, Team Orange, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "W\xe4hlen Sie mindestens einen Benutzer, eine Gruppe, ein Team oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "W\xe4hlen Sie mindestens eine Person, ein Team, eine Gruppe oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "W\xe4hlen Sie mindestens eine Person, ein Team oder eine Gruppe aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "W\xe4hlen Sie mindestens eine Person oder ein Team aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "W\xe4hlen Sie mindestens eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "W\xe4hlen Sie mindestens eine Person, ein Team oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.in.integration.button': 'In {integrationName} teilen',
    'fabric.elements.share.invite.to.confluence': 'Zu Confluence einladen',
    'fabric.elements.share.invite.to.jira': 'Zu Jira einladen',
    'fabric.elements.share.main.tab.text.confluence': 'Seite teilen',
    'fabric.elements.share.main.tab.text.jira': 'Vorgang teilen',
    'fabric.elements.share.menu.email.label': 'E-Mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Teilen',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blogpost geteilt}board {Board geteilt}calendar {Kalender geteilt}draft {Entwurf geteilt}filter {Filter geteilt}issue {Vorgang geteilt}summary {Zusammenfassung geteilt}list {Liste geteilt}timeline {Zeitleiste geteilt}form {Formular geteilt}media {Medien geteilt}page {Seite geteilt}project {Projekt geteilt}pullrequest {Pull-Anfrage geteilt}question {Frage geteilt}report {Bericht geteilt}repository {Repository geteilt}request {Anfrage geteilt}roadmap {Zeitleiste geteilt}site {Site geteilt}space {Bereich geteilt}other {Link geteilt}}',
    'fabric.elements.share.to.integration.button': 'Mit {integrationName} teilen',
    'fabric.elements.share.trigger.button.icon.label': 'Teilen-Symbol',
    'fabric.elements.share.trigger.button.invite.text': 'Einladen',
    'fabric.elements.share.trigger.button.text': 'Teilen',
    'fabric.elements.share.trigger.button.tooltip.text': 'Teilen'
};

});

parcelRegister("3p42E", function(module, exports) {

$parcel$export(module.exports, "default", () => $3370ea033e52bf64$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $3370ea033e52bf64$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Hivatkoz\xe1s \xe1tm\xe1solva a v\xe1g\xf3lapra",
    'fabric.elements.share.copylink.button.text': "Hivatkoz\xe1s m\xe1sol\xe1sa",
    'fabric.elements.share.copypubliclink.button.text': "Publikus link m\xe1sol\xe1sa",
    'fabric.elements.share.failure.icon.label': 'Hiba ikon',
    'fabric.elements.share.failure.message': 'Nem lehet megosztani',
    'fabric.elements.share.form.comment.label': "\xdczenet (nem k\xf6telez\u0151)",
    'fabric.elements.share.form.comment.placeholder': "Van b\xe1rmi, amit \xe9rdemes tudni?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "A c\xedmzettek l\xe1tj\xe1k az oldal nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.info.message.no.invite.jira': "A c\xedmzettek l\xe1tj\xe1k az \xfcgy nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.no-permissions': "Nincs lehet\u0151s\xe9ged a megoszt\xe1sra.",
    'fabric.elements.share.form.public.send': "Publikus link k\xfcld\xe9se",
    'fabric.elements.share.form.public.share': "Nyilv\xe1nos link megoszt\xe1sa",
    'fabric.elements.share.form.required-field.summary': "A k\xf6telez\u0151 mez\u0151k csillaggal vannak megjel\xf6lve",
    'fabric.elements.share.form.retry': "\xdajra",
    'fabric.elements.share.form.send': "K\xfcld\xe9s",
    'fabric.elements.share.form.share': "Megoszt\xe1s",
    'fabric.elements.share.form.title': "Megoszt\xe1s",
    'fabric.elements.share.form.user-picker.add-more': "Tov\xe1bbiak megad\xe1sa",
    'fabric.elements.share.form.user-picker.label.confluence': "Nevek, csapatok, csoportok vagy e-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nevek, csapatok vagy csoportok',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nevek vagy csapatok',
    'fabric.elements.share.form.user-picker.label.email-only': "E-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.label.jira': "Nevek, csapatok vagy e-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nincs tal\xe1lat a k\xf6vetkez\u0151 keres\xe9sre: \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nincs tal\xe1lat a k\xf6vetkez\u0151 keres\xe9sre: \u201E{inputValue}\u201D. H\xedvj meg embereket az e-mail-c\xedm\xfck alapj\xe1n.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "pl. M\xe1ria, Narancs csapat, egyes-csoport",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "pl. M\xe1ria, Narancs csapat",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'pl. maria@vallalat.hu',
    'fabric.elements.share.form.user-picker.placeholder.jira': "pl. M\xe1ria, Narancs csapat, maria@vallalat.hu",
    'fabric.elements.share.form.user-picker.validation.required': "V\xe1lassz ki legal\xe1bb egy felhaszn\xe1l\xf3t, csoportot, csapatot vagy e-mail-c\xedmet.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot, csoportot vagy e-mail-c\xedmet",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot vagy csoportot",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt vagy csapatot",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe1lassz ki legal\xe1bb egy e-mail-c\xedmet",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot vagy e-mail-c\xedmet",
    'fabric.elements.share.in.integration.button': "Megoszt\xe1s itt: {integrationName}",
    'fabric.elements.share.invite.to.confluence': "Megh\xedv\xe1s a Confluence-be",
    'fabric.elements.share.invite.to.jira': "Megh\xedv\xe1s a Jir\xe1ba",
    'fabric.elements.share.main.tab.text.confluence': "Oldal megoszt\xe1sa",
    'fabric.elements.share.main.tab.text.jira': "\xdcgy megoszt\xe1sa",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Megoszt\xe1s",
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogposzt megosztva}board {T\xe1bla megosztva}calendar {Napt\xe1r megosztva}draft {Piszkozat megosztva}filter {Sz\u0171r\u0151 megosztva}issue {\xdcgy megosztva}summary {\xd6sszefoglal\xf3 megosztva}list {Lista megosztva}timeline {Id\u0151vonal megosztva}form {\u0170rlap megosztva}media {M\xe9dia megosztva}page {Oldal megosztva}project {Projekt megosztva}pullrequest {Pull-k\xe9relem megosztva}question {K\xe9rd\xe9s megosztva}report {Jelent\xe9s megosztva}repository {Adatt\xe1r megosztva}request {K\xe9relem megosztva}roadmap {Id\u0151vonal megosztva}site {Webhely megosztva}space {Munkat\xe9r megosztva}other {Link megosztva}}",
    'fabric.elements.share.to.integration.button': "Megoszt\xe1s itt: {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikon megoszt\xe1sa",
    'fabric.elements.share.trigger.button.invite.text': "Megh\xedv\xe1s",
    'fabric.elements.share.trigger.button.text': "Megoszt\xe1s",
    'fabric.elements.share.trigger.button.tooltip.text': "Megoszt\xe1s"
};

});

parcelRegister("27y1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $7adc378fc3851339$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $7adc378fc3851339$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copiato negli appunti',
    'fabric.elements.share.copylink.button.text': 'Copia link',
    'fabric.elements.share.copypubliclink.button.text': 'Copia link pubblico',
    'fabric.elements.share.failure.icon.label': 'Icona Errore',
    'fabric.elements.share.failure.message': 'Impossibile effettuare la condivisione',
    'fabric.elements.share.form.comment.label': 'Messaggio (opzionale)',
    'fabric.elements.share.form.comment.placeholder': 'Vuoi comunicare loro qualcosa?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'I destinatari vedranno il nome della pagina e il tuo messaggio',
    'fabric.elements.share.form.info.message.no.invite.jira': 'I destinatari vedranno il nome del ticket e il tuo messaggio',
    'fabric.elements.share.form.no-permissions': 'Non puoi eseguire condivisioni.',
    'fabric.elements.share.form.public.send': 'Invia link pubblico',
    'fabric.elements.share.form.public.share': 'Condividi link pubblico',
    'fabric.elements.share.form.required-field.summary': 'I campi obbligatori sono contrassegnati da un asterisco',
    'fabric.elements.share.form.retry': 'Riprova',
    'fabric.elements.share.form.send': 'Invia',
    'fabric.elements.share.form.share': 'Condividi',
    'fabric.elements.share.form.title': 'Condividi',
    'fabric.elements.share.form.user-picker.add-more': 'Inerisci altri elementi',
    'fabric.elements.share.form.user-picker.label.confluence': 'Nomi, team, gruppi o indirizzi e-mail',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nomi, team o gruppi',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nomi o team',
    'fabric.elements.share.form.user-picker.label.email-only': 'Indirizzi e-mail',
    'fabric.elements.share.form.user-picker.label.jira': 'Nomi, team o indirizzi e-mail',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nessun risultato trovato per \u201C{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nessun risultato trovato per \u201C{inputValue}\u201D. Invita le persone inserendo il loro indirizzo e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'ad esempio Maria, Team Arancione, gruppo uno',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'ad esempio Maria, Team Arancione',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'ad esempio maria@azienda.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'ad esempio Maria, Team Arancione, maria@azienda.com',
    'fabric.elements.share.form.user-picker.validation.required': "Seleziona almeno un utente, un gruppo, un team o un'e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Seleziona almeno una persona, un team, un gruppo o un indirizzo e-mail.',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Seleziona almeno una persona, un team o un gruppo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Seleziona almeno una persona o un team.',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Seleziona almeno un indirizzo e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Seleziona almeno una persona, un team o un indirizzo e-mail',
    'fabric.elements.share.in.integration.button': 'Condividi in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invita in Confluence',
    'fabric.elements.share.invite.to.jira': 'Invita in Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Condividi pagina',
    'fabric.elements.share.main.tab.text.jira': 'Condividi ticket',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Condividi',
    'fabric.elements.share.success.message': '{object, select,blogpost {Post del blog condiviso}board {Board condivisa}calendar {Calendario condiviso}draft {Bozza condivisa}filter {Filtro condiviso}issue {Ticket condiviso}summary {Riepilogo condiviso}list {Elenco condiviso}timeline {Timeline condivisa}form {Modulo condiviso}media {Elemento multimediale condiviso}page {Pagina condiviso}project {Progetto condiviso}pullrequest {Pull request condivisa}question {Domanda condivisa}report {Report condiviso}repository {Repository condiviso}request {Richiesta condivisa}roadmap {Timeline condivisa}site {Sito condiviso}space {Spazio condiviso}other {Link condiviso}}',
    'fabric.elements.share.to.integration.button': 'Condividi in {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Icona Condividi',
    'fabric.elements.share.trigger.button.invite.text': 'Invita',
    'fabric.elements.share.trigger.button.text': 'Condividi',
    'fabric.elements.share.trigger.button.tooltip.text': 'Condividi'
};

});

parcelRegister("iQwQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e460a890bc44e6d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $8e460a890bc44e6d$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F",
    'fabric.elements.share.copylink.button.text': "\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
    'fabric.elements.share.copypubliclink.button.text': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
    'fabric.elements.share.failure.icon.label': "\u30A8\u30E9\u30FC \u30A2\u30A4\u30B3\u30F3",
    'fabric.elements.share.failure.message': "\u5171\u6709\u3067\u304D\u307E\u305B\u3093",
    'fabric.elements.share.form.comment.label': "\u30E1\u30C3\u30BB\u30FC\u30B8 (\u30AA\u30D7\u30B7\u30E7\u30F3)",
    'fabric.elements.share.form.comment.placeholder': "\u5171\u6709\u5148\u306E\u30E6\u30FC\u30B6\u30FC\u3078\u306E\u30B3\u30E1\u30F3\u30C8\u304C\u3042\u308B\u5834\u5408\u306F\u3053\u3053\u306B\u66F8\u304D\u8FBC\u307F\u307E\u3059\u3002",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u53D7\u4FE1\u8005\u306B\u30DA\u30FC\u30B8\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u53D7\u4FE1\u8005\u306B\u8AB2\u984C\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.no-permissions': "\u5171\u6709\u3067\u304D\u307E\u305B\u3093\u3002",
    'fabric.elements.share.form.public.send': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u9001\u4FE1",
    'fabric.elements.share.form.public.share': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u5171\u6709",
    'fabric.elements.share.form.required-field.summary': "\u5FC5\u9808\u30D5\u30A3\u30FC\u30EB\u30C9\u306B\u306F\u30A2\u30B9\u30BF\u30EA\u30B9\u30AF\u304C\u4ED8\u3044\u3066\u3044\u307E\u3059",
    'fabric.elements.share.form.retry': "\u518D\u8A66\u884C",
    'fabric.elements.share.form.send': "\u9001\u4FE1",
    'fabric.elements.share.form.share': "\u5171\u6709",
    'fabric.elements.share.form.title': "\u5171\u6709",
    'fabric.elements.share.form.user-picker.add-more': "\u3055\u3089\u306B\u8FFD\u52A0",
    'fabric.elements.share.form.user-picker.label.confluence': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30B0\u30EB\u30FC\u30D7",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u540D\u524D\u307E\u305F\u306F\u30C1\u30FC\u30E0",
    'fabric.elements.share.form.user-picker.label.email-only': "\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.label.jira': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '"{inputValue}" \u306B\u4E00\u81F4\u3059\u308B\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002',
    'fabric.elements.share.form.user-picker.no-options.generic': '"{inputValue}" \u306B\u4E00\u81F4\u3059\u308B\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u4F7F\u7528\u3057\u3066\u30E6\u30FC\u30B6\u30FC\u3092\u62DB\u5F85\u3057\u3066\u304F\u3060\u3055\u3044\u3002',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8\u3001\u30B0\u30EB\u30FC\u30D7\u30EF\u30F3",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u4F8B: sato@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8\u3001sato@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u30E6\u30FC\u30B6\u30FC\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u30C1\u30FC\u30E0\u3001\u30E1\u30FC\u30EB\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30B0\u30EB\u30FC\u30D7\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u30E6\u30FC\u30B6\u30FC\u307E\u305F\u306F\u30C1\u30FC\u30E0\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.in.integration.button': "{integrationName} \u3067\u5171\u6709",
    'fabric.elements.share.invite.to.confluence': "Confluence \u306B\u62DB\u5F85",
    'fabric.elements.share.invite.to.jira': "Jira \u306B\u62DB\u5F85",
    'fabric.elements.share.main.tab.text.confluence': "\u30DA\u30FC\u30B8\u3092\u5171\u6709",
    'fabric.elements.share.main.tab.text.jira': "\u8AB2\u984C\u3092\u5171\u6709",
    'fabric.elements.share.menu.email.label': "\u30E1\u30FC\u30EB",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u5171\u6709",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u30D6\u30ED\u30B0\u6295\u7A3F\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}board {\u30DC\u30FC\u30C9\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}calendar {\u30AB\u30EC\u30F3\u30C0\u30FC\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}draft {\u4E0B\u66F8\u304D\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}filter {\u30D5\u30A3\u30EB\u30BF\u30FC\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}issue {\u8AB2\u984C\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}summary {\u8981\u7D04\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}list {\u30EA\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}timeline {\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}form {\u30D5\u30A9\u30FC\u30E0\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}media {\u30E1\u30C7\u30A3\u30A2\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}page {\u30DA\u30FC\u30B8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}project {\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}pullrequest {\u30D7\u30EB \u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}question {\u8CEA\u554F\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}report {\u30EC\u30DD\u30FC\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}repository {\u30EA\u30DD\u30B8\u30C8\u30EA\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}request {\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}roadmap {\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}site {\u30B5\u30A4\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}space {\u30B9\u30DA\u30FC\u30B9\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}other {\u30EA\u30F3\u30AF\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}}",
    'fabric.elements.share.to.integration.button': "{integrationName} \u3068\u5171\u6709",
    'fabric.elements.share.trigger.button.icon.label': "\u5171\u6709\u30A2\u30A4\u30B3\u30F3",
    'fabric.elements.share.trigger.button.invite.text': "\u62DB\u5F85",
    'fabric.elements.share.trigger.button.text': "\u5171\u6709",
    'fabric.elements.share.trigger.button.tooltip.text': "\u5171\u6709"
};

});

parcelRegister("oAl55", function(module, exports) {

$parcel$export(module.exports, "default", () => $200bc1bcef3bcd91$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $200bc1bcef3bcd91$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\uB9C1\uD06C\uB97C \uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC\uD568",
    'fabric.elements.share.copylink.button.text': "\uB9C1\uD06C \uBCF5\uC0AC",
    'fabric.elements.share.copypubliclink.button.text': "\uACF5\uAC1C \uB9C1\uD06C \uBCF5\uC0AC",
    'fabric.elements.share.failure.icon.label': "\uC624\uB958 \uC544\uC774\uCF58",
    'fabric.elements.share.failure.message': "\uACF5\uC720\uD560 \uC218 \uC5C6\uC74C",
    'fabric.elements.share.form.comment.label': "\uBA54\uC2DC\uC9C0(\uC120\uD0DD \uC0AC\uD56D)",
    'fabric.elements.share.form.comment.placeholder': "\uC0AC\uC6A9\uC790\uAC00 \uC54C\uC544\uC57C \uD560 \uB0B4\uC6A9\uC774 \uC788\uC2B5\uB2C8\uAE4C?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\uC218\uC2E0\uC790\uAC00 \uD398\uC774\uC9C0 \uC774\uB984\uACFC \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.info.message.no.invite.jira': "\uC218\uC2E0\uC790\uAC00 \uC774\uC288 \uC774\uB984\uACFC \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.no-permissions': "\uACF5\uC720\uD560 \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'fabric.elements.share.form.public.send': "\uACF5\uAC1C \uB9C1\uD06C \uBCF4\uB0B4\uAE30",
    'fabric.elements.share.form.public.share': "\uACF5\uAC1C \uB9C1\uD06C \uACF5\uC720",
    'fabric.elements.share.form.required-field.summary': "\uD544\uC218 \uD544\uB4DC\uB294 \uBCC4\uD45C\uB85C \uD45C\uC2DC\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.retry': "\uB2E4\uC2DC \uC2DC\uB3C4",
    'fabric.elements.share.form.send': "\uBCF4\uB0B4\uAE30",
    'fabric.elements.share.form.share': "\uACF5\uC720",
    'fabric.elements.share.form.title': "\uACF5\uC720",
    'fabric.elements.share.form.user-picker.add-more': "\uB354 \uC785\uB825\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.label.confluence': "\uC774\uB984, \uD300, \uADF8\uB8F9 \uB610\uB294 \uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\uC774\uB984, \uD300 \uB610\uB294 \uADF8\uB8F9",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\uC774\uB984 \uB610\uB294 \uD300",
    'fabric.elements.share.form.user-picker.label.email-only': "\uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.label.jira': "\uC774\uB984, \uD300 \uB610\uB294 \uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '"{inputValue}"\uC5D0 \uB300\uD55C \uACB0\uACFC\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.',
    'fabric.elements.share.form.user-picker.no-options.generic': '"{inputValue}"\uC5D0 \uB300\uD55C \uACB0\uACFC\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4. \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC0AC\uC6A9\uD558\uC5EC \uC0AC\uC6A9\uC790\uB97C \uCD08\uB300\uD558\uC138\uC694.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\uC608: Maria, Team Orange, group-one",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\uC608: Maria, Team Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\uC608: maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\uC608: Maria, Team Orange, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\uC0AC\uC6A9\uC790, \uADF8\uB8F9, \uD300 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\uC0AC\uC6A9\uC790, \uD300, \uADF8\uB8F9 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\uC0AC\uC6A9\uC790, \uD300 \uB610\uB294 \uADF8\uB8F9\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\uC0AC\uC6A9\uC790 \uB610\uB294 \uD300\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\uC0AC\uC6A9\uC790, \uD300 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.in.integration.button': "{integrationName}\uC5D0\uC11C \uACF5\uC720",
    'fabric.elements.share.invite.to.confluence': "Confluence\uC5D0 \uCD08\uB300",
    'fabric.elements.share.invite.to.jira': "Jira\uC5D0 \uCD08\uB300",
    'fabric.elements.share.main.tab.text.confluence': "\uD398\uC774\uC9C0 \uACF5\uC720",
    'fabric.elements.share.main.tab.text.jira': "\uC774\uC288 \uACF5\uC720",
    'fabric.elements.share.menu.email.label': "\uC774\uBA54\uC77C",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\uACF5\uC720",
    'fabric.elements.share.success.message': "{object, select,blogpost {\uACF5\uC720\uD55C \uBE14\uB85C\uADF8 \uAC8C\uC2DC\uBB3C}board {\uACF5\uC720\uD55C \uBCF4\uB4DC}calendar {\uACF5\uC720\uD55C \uCE98\uB9B0\uB354}draft {\uACF5\uC720\uD55C \uCD08\uC548}filter {\uACF5\uC720\uD55C \uD544\uD130}issue {\uACF5\uC720\uD55C \uC774\uC288}summary {\uACF5\uC720\uD55C \uC694\uC57D}list {\uACF5\uC720\uD55C \uBAA9\uB85D}timeline {\uACF5\uC720\uD55C \uD0C0\uC784\uB77C\uC778}form {\uACF5\uC720\uD55C \uC591\uC2DD}media {\uACF5\uC720\uD55C \uBBF8\uB514\uC5B4}page {\uACF5\uC720\uD55C \uD398\uC774\uC9C0}project {\uACF5\uC720\uD55C \uD504\uB85C\uC81D\uD2B8}pullrequest {\uACF5\uC720\uD55C \uD480\uB9AC\uD018\uC2A4\uD2B8}question {\uACF5\uC720\uD55C \uC9C8\uBB38}report {\uACF5\uC720\uD55C \uBCF4\uACE0\uC11C}repository {\uACF5\uC720\uD55C \uB9AC\uD3EC\uC9C0\uD1A0\uB9AC}request {\uACF5\uC720\uD55C \uC694\uCCAD}timeline {\uACF5\uC720\uD55C \uD0C0\uC784\uB77C\uC778}site {\uACF5\uC720\uD55C \uC0AC\uC774\uD2B8}space {\uACF5\uC720\uD55C \uC2A4\uD398\uC774\uC2A4}other {\uACF5\uC720\uD55C \uB9C1\uD06C}}",
    'fabric.elements.share.to.integration.button': "{integrationName}\uC5D0 \uACF5\uC720",
    'fabric.elements.share.trigger.button.icon.label': "\uACF5\uC720 \uC544\uC774\uCF58",
    'fabric.elements.share.trigger.button.invite.text': "\uCD08\uB300",
    'fabric.elements.share.trigger.button.text': "\uACF5\uC720",
    'fabric.elements.share.trigger.button.tooltip.text': "\uACF5\uC720"
};

});

parcelRegister("fAuZu", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d54c4eb8241b5a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $00d54c4eb8241b5a$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Kobling er kopiert til utklippstavlen',
    'fabric.elements.share.copylink.button.text': 'Kopier kobling',
    'fabric.elements.share.copypubliclink.button.text': 'Kopier offentlig tilgjengelig kobling',
    'fabric.elements.share.failure.icon.label': 'Feil-ikon',
    'fabric.elements.share.failure.message': 'Kan ikke deles',
    'fabric.elements.share.form.comment.label': 'Melding (valgfritt)',
    'fabric.elements.share.form.comment.placeholder': "Er det noe mottakerne b\xf8r vite om dette?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Mottakerne vil se navnet p\xe5 siden og meldingen",
    'fabric.elements.share.form.info.message.no.invite.jira': "Mottakerne vil se navnet p\xe5 saken og meldingen",
    'fabric.elements.share.form.no-permissions': "Du har ikke muligheten til \xe5 dele.",
    'fabric.elements.share.form.public.send': 'Send offentlig tilgjengelig kobling',
    'fabric.elements.share.form.public.share': 'Del offentlig kobling',
    'fabric.elements.share.form.required-field.summary': 'Obligatoriske felt er merket med stjerne',
    'fabric.elements.share.form.retry': "Pr\xf8v igjen",
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Del',
    'fabric.elements.share.form.title': 'Del',
    'fabric.elements.share.form.user-picker.add-more': 'Legg til mer',
    'fabric.elements.share.form.user-picker.label.confluence': 'Navn, team, grupper eller e-poster',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Navn, team eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Navn eller team',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-poster',
    'fabric.elements.share.form.user-picker.label.jira': 'Navn, team eller e-poster',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi kunne ikke finne noen resultater for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi kunne ikke finne noen resultater for "{inputValue}". Inviter personer ved \xe5 bruke en e-postadresse.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "f.eks. Maria, oransje team, gruppe \xe9n",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'f.eks. Maria, oransje team',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'f.eks. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'f.eks. Maria, oransje team, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': "Velg minst \xe9n bruker, gruppe eller e-post eller minst ett team.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Velg minst \xe9n person, gruppe, e-postadresse eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Velg minst \xe9n person, gruppe eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Velg minst \xe9n person eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Velg minst \xe9n e-postadresse",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Velg minst \xe9n person, gruppe, e-postadresse eller ett team",
    'fabric.elements.share.in.integration.button': 'Del i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Inviter til Confluence',
    'fabric.elements.share.invite.to.jira': 'Inviter til Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Del side',
    'fabric.elements.share.main.tab.text.jira': 'Del sak',
    'fabric.elements.share.menu.email.label': 'E-post',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Del',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogginnlegg er delt}board {Tavle er delt}calendar {Kalender er delt}draft {Utkast er delt}filter {Filter er delt}issue {Sak er delt}summary {Sammendrag er delt}list {Liste er delt}timeline {Tidslinje er delt}form {Skjema er delt}media {Medier er delt}page {Side er delt}project {Prosjekt er delt}pullrequest {Pull-foresp\xf8rsel er delt}question {Sp\xf8rsm\xe5l er delt}report {Rapport er delt}repository {Repositorium er delt}request {Foresp\xf8rsel er delt}roadmap {Veikart er delt}site {Nettsted er delt}space {Omr\xe5de er delt}other {Kobling er delt}}",
    'fabric.elements.share.to.integration.button': 'Del til {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Dele-ikon',
    'fabric.elements.share.trigger.button.invite.text': 'Inviter',
    'fabric.elements.share.trigger.button.text': 'Del',
    'fabric.elements.share.trigger.button.tooltip.text': 'Del'
};

});

parcelRegister("jdnCB", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfcaf1289dfd960f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $dfcaf1289dfd960f$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u0141\u0105cze skopiowano do schowka",
    'fabric.elements.share.copylink.button.text': "Kopiuj \u0142\u0105cze",
    'fabric.elements.share.copypubliclink.button.text': "Kopiuj \u0142\u0105cze publiczne",
    'fabric.elements.share.failure.icon.label': "Ikona b\u0142\u0119du",
    'fabric.elements.share.failure.message': "Nie mo\u017Cna udost\u0119pni\u0107",
    'fabric.elements.share.form.comment.label': "Wiadomo\u015B\u0107 (opcjonalnie)",
    'fabric.elements.share.form.comment.placeholder': "Czy jest co\u015B, o czym powinni wiedzie\u0107?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Odbiorcy zobacz\u0105 nazw\u0119 strony i Tw\xf3j komunikat",
    'fabric.elements.share.form.info.message.no.invite.jira': "Odbiorcy zobacz\u0105 nazw\u0119 zg\u0142oszenia i Tw\xf3j komunikat",
    'fabric.elements.share.form.no-permissions': "Nie mo\u017Cesz udost\u0119pnia\u0107.",
    'fabric.elements.share.form.public.send': "Wy\u015Blij \u0142\u0105cze publiczne",
    'fabric.elements.share.form.public.share': "Udost\u0119pnij \u0142\u0105cze publiczne",
    'fabric.elements.share.form.required-field.summary': "Pola wymagane s\u0105 oznaczone gwiazdk\u0105",
    'fabric.elements.share.form.retry': "Spr\xf3buj ponownie",
    'fabric.elements.share.form.send': "Wy\u015Blij",
    'fabric.elements.share.form.share': "Udost\u0119pnij",
    'fabric.elements.share.form.title': "Udost\u0119pnij",
    'fabric.elements.share.form.user-picker.add-more': "Wprowad\u017A wi\u0119cej",
    'fabric.elements.share.form.user-picker.label.confluence': "Nazwy, zespo\u0142y, grupy lub adresy e-mail",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Nazwy, zespo\u0142y lub grupy",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Nazwy lub zespo\u0142y",
    'fabric.elements.share.form.user-picker.label.email-only': 'Adresy e-mail',
    'fabric.elements.share.form.user-picker.label.jira': "Nazwy, zespo\u0142y lub adresy e-mail",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nie znaleziono wynik\xf3w dla \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nie znaleziono wynik\xf3w dla \u201E{inputValue}\u201D. Zapro\u015B u\u017Cytkownik\xf3w, podaj\u0105c adres e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy, grupa 1",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'np. maria@firma.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy, maria@firma.com",
    'fabric.elements.share.form.user-picker.validation.required': "Wybierz co najmniej jednego u\u017Cytkownika, jedn\u0105 grup\u0119 albo jeden zesp\xf3\u0142 lub adres e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142, jedn\u0105 grup\u0119 lub jeden adres e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142 lub jedn\u0105 grup\u0119",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Wybierz co najmniej jedn\u0105 osob\u0119 lub jeden zesp\xf3\u0142",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Wybierz co najmniej jeden adres e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142 lub jeden adres e-mail",
    'fabric.elements.share.in.integration.button': "Udost\u0119pnij w {integrationName}",
    'fabric.elements.share.invite.to.confluence': "Zapro\u015B do\xa0Confluence",
    'fabric.elements.share.invite.to.jira': "Zapro\u015B do\xa0systemu Jira",
    'fabric.elements.share.main.tab.text.confluence': "Udost\u0119pnij stron\u0119",
    'fabric.elements.share.main.tab.text.jira': "Udost\u0119pnij zg\u0142oszenie",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Udost\u0119pnij",
    'fabric.elements.share.success.message': "{object, select,blogpost {Udost\u0119pniono wpis na blogu}board {Udost\u0119pniono tablic\u0119}calendar {Udost\u0119pniono kalendarz}draft {Udost\u0119pniono wersj\u0119 robocz\u0105}filter {Udost\u0119pniono filtr}issue {Udost\u0119pniono zg\u0142oszenie}summary {Udost\u0119pniono podsumowanie}list {Udost\u0119pniono list\u0119}timeline {Udost\u0119pniono o\u015B czasu}form {Udost\u0119pniono formularz}media {Udost\u0119pniono multimedia}page {Udost\u0119pniono stron\u0119}project {Udost\u0119pniono projekt}pullrequest {Udost\u0119pniono pull request}question {Udost\u0119pniono pytanie}report {Udost\u0119pniono raport}repository {Udost\u0119pniono repozytorium}request {Udost\u0119pniono wniosek}roadmap {Udost\u0119pniono o\u015B czasu}site {Udost\u0119pniono witryn\u0119}space {Udost\u0119pniono przestrze\u0144}other {Udost\u0119pniono \u0142\u0105cze}}",
    'fabric.elements.share.to.integration.button': "Udost\u0119pnij w {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona udost\u0119pniania",
    'fabric.elements.share.trigger.button.invite.text': "Zapro\u015B",
    'fabric.elements.share.trigger.button.text': "Udost\u0119pnij",
    'fabric.elements.share.trigger.button.tooltip.text': "Udost\u0119pnij"
};

});

parcelRegister("7tVzL", function(module, exports) {

$parcel$export(module.exports, "default", () => $14cfbe880c693ab1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $14cfbe880c693ab1$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Link copiado para a \xe1rea de transfer\xeancia",
    'fabric.elements.share.copylink.button.text': 'Copiar link',
    'fabric.elements.share.copypubliclink.button.text': "Copiar link p\xfablico",
    'fabric.elements.share.failure.icon.label': "\xcdcone de erro",
    'fabric.elements.share.failure.message': "N\xe3o foi poss\xedvel compartilhar",
    'fabric.elements.share.form.comment.label': 'Mensagem (opcional)',
    'fabric.elements.share.form.comment.placeholder': "H\xe1 algo que eles deveriam saber?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Os destinat\xe1rios v\xe3o ver o nome da p\xe1gina e sua mensagem",
    'fabric.elements.share.form.info.message.no.invite.jira': "Os destinat\xe1rios v\xe3o ver o nome do item e sua mensagem",
    'fabric.elements.share.form.no-permissions': "Voc\xea n\xe3o est\xe1 apto a compartilhar.",
    'fabric.elements.share.form.public.send': "Enviar link p\xfablico",
    'fabric.elements.share.form.public.share': "Compartilhar link p\xfablico",
    'fabric.elements.share.form.required-field.summary': "Os campos obrigat\xf3rios est\xe3o marcados com um asterisco",
    'fabric.elements.share.form.retry': 'Tentar novamente',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.share': 'Compartilhar',
    'fabric.elements.share.form.title': 'Compartilhar',
    'fabric.elements.share.form.user-picker.add-more': 'Insira mais itens',
    'fabric.elements.share.form.user-picker.label.confluence': 'Nomes, equipes, grupos ou e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nomes, equipes ou grupos',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nomes ou equipes',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Nomes, equipes ou e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'N\xe3o encontramos nenhum resultado para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'N\xe3o encontramos nenhum resultado para "{inputValue}". Convide pessoas usando um endere\xe7o de e-mail.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'por exemplo, Maria, equipe laranja, grupo um',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'por exemplo, Maria, equipe laranja',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'por exemplo, maria@empresa.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'por exemplo, Maria, equipe laranja, maria@empresa.com',
    'fabric.elements.share.form.user-picker.validation.required': "Selecione ao menos um usu\xe1rio, grupo, equipe ou e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Selecione pelo menos uma pessoa, equipe, grupo ou e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Selecione pelo menos uma pessoa, equipe ou grupo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Selecione pelo menos uma pessoa ou equipe',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Selecione pelo menos um e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Selecione pelo menos uma pessoa, equipe ou e-mail',
    'fabric.elements.share.in.integration.button': 'Compartilhar em {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Convidar para o Confluence',
    'fabric.elements.share.invite.to.jira': 'Convidar para o Jira',
    'fabric.elements.share.main.tab.text.confluence': "Compartilhar p\xe1gina",
    'fabric.elements.share.main.tab.text.jira': 'Compartilhar item',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Compartilhar',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blog compartilhado}board {Quadro compartilhado}calendar {Calend\xe1rio compartilhado}draft {Rascunho compartilhado}filter {Filtro compartilhado}issue {Item compartilhado}summary {Resumo compartilhado}list {Lista compartilhada}timeline {Cronograma compartilhado}form {Formul\xe1rio compartilhado}media {M\xeddia compartilhada}page {P\xe1gina compartilhada}project {Projeto compartilhado}pullrequest {Pull request compartilhada}question {Pergunta compartilhada}report {Relat\xf3rio compartilhado}repository {Reposit\xf3rio compartilhado}request {Solicita\xe7\xe3o compartilhada}roadmap {Cronograma compartilhado}site {Site compartilhado}space {Espa\xe7o compartilhado}other {Link compartilhado}}",
    'fabric.elements.share.to.integration.button': 'Compartilhar em {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "\xcdcone de compartilhamento",
    'fabric.elements.share.trigger.button.invite.text': 'Convidar',
    'fabric.elements.share.trigger.button.text': 'Compartilhar',
    'fabric.elements.share.trigger.button.tooltip.text': 'Compartilhar'
};

});

parcelRegister("iQT9i", function(module, exports) {

$parcel$export(module.exports, "default", () => $64e3782e871d3bd4$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Portugal)
var $64e3782e871d3bd4$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Liga\xe7\xe3o copiada para a \xe1rea de transfer\xeancia",
    'fabric.elements.share.copylink.button.text': "Copiar liga\xe7\xe3o",
    'fabric.elements.share.failure.icon.label': "\xcdcone de erro",
    'fabric.elements.share.failure.message': "N\xe3o \xe9 poss\xedvel partilhar",
    'fabric.elements.share.form.comment.placeholder': 'Adicionar uma mensagem',
    'fabric.elements.share.form.retry': 'Tentar novamente',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.title': 'Partilhar',
    'fabric.elements.share.form.user-picker.add-more': 'Introduza mais',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'N\xe3o foi poss\xedvel encontrar resultados para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'N\xe3o foi poss\xedvel encontrar resultados para "{inputValue}". Convite pessoas adicionando um endere\xe7o de e-mail.',
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': 'Introduza o nome ou equipa',
    'fabric.elements.share.form.user-picker.placeholder.generic': 'Introduza o nome, grupo, equipa ou e-mail',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'Introduza o nome, a equipa ou o e-mail',
    'fabric.elements.share.form.user-picker.validation.required': 'Selecione, pelo menos, um utilizador, grupo, equipa ou e-mail.',
    'fabric.elements.share.form.user-picker.validation.required.jira': 'Selecione, pelo menos, um utilizador, equipa ou e-mail.',
    'fabric.elements.share.success.message': "{object, select, blogpost {Publica\xe7\xe3o do blogue partilhada} board {Quadro partilhado} calendar {Calend\xe1rio partilhado} draft {Rascunho partilhado} filter {Filtro partilhado} issue {Problema partilhado} media {Multim\xe9dia partilhado} page {P\xe1gina partilhada} project {Projeto partilhado} pullrequest {Pedidos Pull partilhados} question {Pergunta partilhada} report {Relat\xf3rio partilhado} repository {Reposit\xf3rio partilhado} request {Pedido partilhado} roadmap {Roteiro partilhado} site {Site partilhado} space {Espa\xe7o partilhado} other {Liga\xe7\xe3o partilhada}}",
    'fabric.elements.share.trigger.button.icon.label': "Partilhar \xedcone",
    'fabric.elements.share.trigger.button.invite.text': 'Convidar',
    'fabric.elements.share.trigger.button.text': 'Partilhar',
    'fabric.elements.share.trigger.button.tooltip.text': 'Partilhar'
};

});

parcelRegister("85g4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $a67580105533c14d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $a67580105533c14d$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u0421\u0441\u044B\u043B\u043A\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430",
    'fabric.elements.share.copylink.button.text': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.copypubliclink.button.text': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.failure.icon.label': "\u0417\u043D\u0430\u0447\u043E\u043A \u043E\u0448\u0438\u0431\u043A\u0438",
    'fabric.elements.share.failure.message': "\u041D\u0435 \u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.comment.label': "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
    'fabric.elements.share.form.comment.placeholder': "\u0427\u0442\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u0437\u043D\u0430\u0442\u044C?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0437\u0430\u0434\u0430\u0447\u0438 \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.no-permissions': "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043E\u0431\u0449\u0438\u0439 \u0434\u043E\u0441\u0442\u0443\u043F.",
    'fabric.elements.share.form.public.send': "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.form.public.share': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0441\u044B\u043B\u043A\u043E\u0439 \u043E\u0431\u0449\u0435\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430",
    'fabric.elements.share.form.required-field.summary': "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F \u043E\u0442\u043C\u0435\u0447\u0435\u043D\u044B \u0437\u0432\u0435\u0437\u0434\u043E\u0447\u043A\u043E\u0439",
    'fabric.elements.share.form.retry': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C",
    'fabric.elements.share.form.send': "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
    'fabric.elements.share.form.share': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.title': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.user-picker.add-more': "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439",
    'fabric.elements.share.form.user-picker.label.confluence': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B, \u0433\u0440\u0443\u043F\u043F\u044B \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0438\u043B\u0438 \u0433\u0440\u0443\u043F\u043F\u044B",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u0418\u043C\u0435\u043D\u0430 \u0438\u043B\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u044B",
    'fabric.elements.share.form.user-picker.label.email-only': "\u0410\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.label.jira': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "\u041D\u0435\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \xab{inputValue}\xbb.",
    'fabric.elements.share.form.user-picker.no-options.generic': "\u041D\u0435\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \xab{inputValue}\xbb. \u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb, \u0433\u0440\u0443\u043F\u043F\u0430-\u043E\u0434\u0438\u043D",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B 1\xa0\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0433\u0440\u0443\u043F\u043F\u0443, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443, \u0433\u0440\u0443\u043F\u043F\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0433\u0440\u0443\u043F\u043F\u0443",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438\u043B\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u0443",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.in.integration.button': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0432 {integrationName}",
    'fabric.elements.share.invite.to.confluence': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C \u0432 Confluence",
    'fabric.elements.share.invite.to.jira': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C \u0432 Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435\u0439",
    'fabric.elements.share.main.tab.text.jira': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0437\u0430\u0434\u0430\u0447\u0435\u0439",
    'fabric.elements.share.menu.email.label': "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0438\u0441\u0438 \u0432 \u0431\u043B\u043E\u0433\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}board {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0434\u043E\u0441\u043A\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}calendar {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}draft {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0447\u0435\u0440\u043D\u043E\u0432\u0438\u043A\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}filter {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0444\u0438\u043B\u044C\u0442\u0440\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}issue {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u0434\u0430\u0447\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}summary {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0442\u0435\u043C\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}list {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u043F\u0438\u0441\u043A\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}timeline {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}form {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0444\u043E\u0440\u043C\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}media {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043C\u0435\u0434\u0438\u0430\u0444\u0430\u0439\u043B\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}page {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}project {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}pullrequest {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0440\u043E\u0441\u0443 pull \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}question {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0432\u043E\u043F\u0440\u043E\u0441\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}report {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043E\u0442\u0447\u0435\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}repository {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0440\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0440\u0438\u044E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}request {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}roadmap {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}site {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0430\u0439\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}space {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0440\u0430\u0437\u0434\u0435\u043B\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}other {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0441\u044B\u043B\u043A\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}}",
    'fabric.elements.share.to.integration.button': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0432 {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "\u0417\u043D\u0430\u0447\u043E\u043A \xab\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F\xbb",
    'fabric.elements.share.trigger.button.invite.text': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C",
    'fabric.elements.share.trigger.button.text': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.trigger.button.tooltip.text': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F"
};

});

parcelRegister("72G9u", function(module, exports) {

$parcel$export(module.exports, "default", () => $58dea193620a6956$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $58dea193620a6956$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Prepojenie sa skop\xedrovalo do schr\xe1nky",
    'fabric.elements.share.copylink.button.text': "Kop\xedrova\u0165 prepojenie",
    'fabric.elements.share.failure.icon.label': 'Ikona chyby',
    'fabric.elements.share.failure.message': "Zdie\u013Eanie nie je mo\u017En\xe9",
    'fabric.elements.share.form.comment.placeholder': "Prida\u0165 spr\xe1vu",
    'fabric.elements.share.form.retry': "Opakova\u0165",
    'fabric.elements.share.form.send': "Odosla\u0165",
    'fabric.elements.share.form.title': "Zdie\u013Eanie",
    'fabric.elements.share.form.user-picker.add-more': "Zadajte \u010Fal\u0161ie polo\u017Eky",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nepodarilo sa n\xe1js\u0165 \u017Eiadne v\xfdsledky pre \u201E{inputValue}\u201C.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nepodarilo sa n\xe1js\u0165 \u017Eiadne v\xfdsledky pre \u201E{inputValue}\u201C. Pozvite \u013Eud\xed pomocou e-mailovej adresy.",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Zadajte meno alebo t\xedm",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Zadajte meno, skupinu, t\xedm alebo e-mail",
    'fabric.elements.share.form.user-picker.placeholder.jira': "Zadajte meno, t\xedm alebo e-mail",
    'fabric.elements.share.form.user-picker.validation.required': "Vyberte aspo\u0148 jedn\xe9ho pou\u017E\xedvate\u013Ea, skupinu, t\xedm alebo e-mail.",
    'fabric.elements.share.form.user-picker.validation.required.jira': "Vyberte aspo\u0148 jedn\xe9ho pou\u017E\xedvate\u013Ea, t\xedm alebo e-mail.",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blogov\xfd pr\xedspevok sa zdie\u013Eal} board {N\xe1stenka sa zdie\u013Eala} calendar {Kalend\xe1r sa zdie\u013Eal} draft {Koncept sa zdie\u013Eal} filter {Filter sa zdie\u013Eal} issue {Probl\xe9m sa zdie\u013Eal} media {Medi\xe1lny s\xfabor sa zdie\u013Eal} page {Str\xe1nka sa zdie\u013Eala} project {Projekt sa zdie\u013Eal} pullrequest {Po\u017Eiadavka na stiahnutie a pos\xfadenie sa zdie\u013Eala} question {Ot\xe1zka sa zdie\u013Eala} report {Zostava sa zdie\u013Eala} repository {Repozit\xe1r sa zdie\u013Eal} request {\u017Diados\u0165 sa zdie\u013Eala} roadmap {Pl\xe1n sa zdie\u013Eal} site {Web sa zdie\u013Eal} space {Priestor sa zdie\u013Eal} other {Prepojenie sa zdie\u013Ealo}}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona zdie\u013Eania",
    'fabric.elements.share.trigger.button.invite.text': "Pozva\u0165",
    'fabric.elements.share.trigger.button.text': "Zdie\u013Ea\u0165",
    'fabric.elements.share.trigger.button.tooltip.text': "Zdie\u013Eanie"
};

});

parcelRegister("1ZMpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc68276e914b1179$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $cc68276e914b1179$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Enlace copiado en el portapapeles',
    'fabric.elements.share.copylink.button.text': 'Copiar enlace',
    'fabric.elements.share.copypubliclink.button.text': "Copiar enlace p\xfablico",
    'fabric.elements.share.failure.icon.label': 'Icono de error',
    'fabric.elements.share.failure.message': 'No se puede compartir',
    'fabric.elements.share.form.comment.label': 'Mensaje (opcional)',
    'fabric.elements.share.form.comment.placeholder': "\xbfHay algo que haya que saber?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Los destinatarios ver\xe1n el nombre de la p\xe1gina y tu mensaje",
    'fabric.elements.share.form.info.message.no.invite.jira': "Los destinatarios ver\xe1n el nombre de la incidencia y tu mensaje",
    'fabric.elements.share.form.no-permissions': 'No puedes compartir.',
    'fabric.elements.share.form.public.send': "Enviar enlace p\xfablico",
    'fabric.elements.share.form.public.share': "Compartir enlace p\xfablico",
    'fabric.elements.share.form.required-field.summary': "Los campos obligatorios est\xe1n marcados con un asterisco",
    'fabric.elements.share.form.retry': 'Reintentar',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.share': 'Compartir',
    'fabric.elements.share.form.title': 'Compartir',
    'fabric.elements.share.form.user-picker.add-more': "Introduce m\xe1s cosas",
    'fabric.elements.share.form.user-picker.label.confluence': "Nombres, equipos, grupos o correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nombres, equipos o grupos',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nombres o equipos',
    'fabric.elements.share.form.user-picker.label.email-only': "Correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.label.jira': "Nombres, equipos o correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'No hemos encontrado ning\xfan resultado para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'No hemos encontrado ning\xfan resultado para "{inputValue}". Invita a la gente mediante una direcci\xf3n de correo electr\xf3nico.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "p.\xa0ej. Mar\xeda, equipo naranja, grupo uno",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "p.\xa0ej. Mar\xeda, equipo naranja",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "p.\xa0ej. maria@empresa.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "p.\xa0ej. Mar\xeda, equipo naranja, maria@empresa.com",
    'fabric.elements.share.form.user-picker.validation.required': "Selecciona al menos un usuario, grupo, equipo o correo electr\xf3nico.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Selecciona al menos una persona, equipo, grupo o correo electr\xf3nico",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Selecciona al menos una persona, equipo o grupo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Selecciona al menos una persona o equipo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Selecciona al menos un correo electr\xf3nico",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Selecciona al menos una persona, equipo o correo electr\xf3nico",
    'fabric.elements.share.in.integration.button': 'Compartir en {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invitar a Confluence',
    'fabric.elements.share.invite.to.jira': 'Invitar a Jira',
    'fabric.elements.share.main.tab.text.confluence': "Compartir p\xe1gina",
    'fabric.elements.share.main.tab.text.jira': 'Compartir incidencia',
    'fabric.elements.share.menu.email.label': "Correo electr\xf3nico",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Compartir',
    'fabric.elements.share.success.message': "{object, select,blogpost {Entrada de blog compartida}board {Tablero compartido}calendar {Calendario compartido}draft {Borrador compartido}filter {Filtro compartido}issue {Incidencia compartida}summary {Resumen compartido}list {Lista compartida}timeline {Cronograma compartido}form {Formulario compartido}media {Recursos multimedia compartidos}page {P\xe1gina compartida}project {Proyecto compartido}pullrequest {Solicitud de incorporaci\xf3n de cambios compartida}question {Pregunta compartida}report {Informe compartido}repository {Repositorio compartido}request {Solicitud compartida}roadmap {Cronograma compartido}site {Sitio compartido}space {Espacio compartido}other {Enlace compartido}}",
    'fabric.elements.share.to.integration.button': 'Compartir en {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Icono de compartir',
    'fabric.elements.share.trigger.button.invite.text': 'Invitar',
    'fabric.elements.share.trigger.button.text': 'Compartir',
    'fabric.elements.share.trigger.button.tooltip.text': 'Compartir'
};

});

parcelRegister("dKOkr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6d9b34466d880a2$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $f6d9b34466d880a2$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "L\xe4nk kopierad till urklipp",
    'fabric.elements.share.copylink.button.text': "Kopiera l\xe4nk",
    'fabric.elements.share.copypubliclink.button.text': "Kopiera offentlig l\xe4nk",
    'fabric.elements.share.failure.icon.label': 'Fel-ikon',
    'fabric.elements.share.failure.message': 'Det gick inte att dela',
    'fabric.elements.share.form.comment.label': 'Meddelande (valfritt)',
    'fabric.elements.share.form.comment.placeholder': "Finns det n\xe5got de beh\xf6ver veta?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Mottagare ser namnet p\xe5 sidan och ditt meddelande",
    'fabric.elements.share.form.info.message.no.invite.jira': "Mottagare ser namnet p\xe5 \xe4rendet och ditt meddelande",
    'fabric.elements.share.form.no-permissions': "Du har inte m\xf6jlighet att dela.",
    'fabric.elements.share.form.public.send': "Skicka offentlig l\xe4nk",
    'fabric.elements.share.form.public.share': "Dela offentlig l\xe4nk",
    'fabric.elements.share.form.required-field.summary': "Obligatoriska f\xe4lt \xe4r markerade med en asterisk",
    'fabric.elements.share.form.retry': "F\xf6rs\xf6k igen",
    'fabric.elements.share.form.send': 'Skicka',
    'fabric.elements.share.form.share': 'Dela',
    'fabric.elements.share.form.title': 'Dela',
    'fabric.elements.share.form.user-picker.add-more': 'Ange fler',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namn, team, grupper eller e-postadresser',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namn, team eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namn eller team',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-postadresser',
    'fabric.elements.share.form.user-picker.label.jira': 'Namn, team eller e-postadresser',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi hittade inte n\xe5gra resultat f\xf6r "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi hittade inte n\xe5gra resultat f\xf6r "{inputValue}". Bjud in personer genom att anv\xe4nda e-postadresser.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 't.ex. Maria, Team Orange, grupp-ett',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 't.ex. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': "t.ex. maria@f\xf6retag.se",
    'fabric.elements.share.form.user-picker.placeholder.jira': "t.ex. Maria, Team Orange, maria@f\xf6retag.se",
    'fabric.elements.share.form.user-picker.validation.required': "V\xe4lj minst en anv\xe4ndare, en grupp, ett team eller en e-postadress.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe4lj minst en person, ett team, en grupp eller en e-postadress",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe4lj minst en person, ett team eller en grupp",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe4lj minst en person eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe4lj minst en e-postadress",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe4lj minst en person, ett team eller en e-postadress",
    'fabric.elements.share.in.integration.button': 'Dela i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Bjud in till Confluence',
    'fabric.elements.share.invite.to.jira': 'Bjud in till Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Dela sida',
    'fabric.elements.share.main.tab.text.jira': "Dela \xe4rende",
    'fabric.elements.share.menu.email.label': 'E-post',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Dela',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogginl\xe4gg har delats}board {Tavla har delats}calendar {Kalender har delats}draft {Utkast har delats}filter {Filter har delats}issue {\xc4rende har delats}summary {Sammanfattning har delats}list {Lista har delats}timeline {Tidslinje har delats}form {Formul\xe4r har delats}media {Media har delats}page {Sida har delats}project {Projekt har delats}pullrequest {Pull request har delats}question {Fr\xe5ga har delats}report {Rapport har delats}repository {Lagringsplats har delats}request {F\xf6rfr\xe5gan har delats}roadmap {Tidslinje har delats}site {Webbplats har delats}space {Utrymme har delats}other {L\xe4nk har delats}}",
    'fabric.elements.share.to.integration.button': 'Dela till {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Dela-ikon',
    'fabric.elements.share.trigger.button.invite.text': 'Bjud In',
    'fabric.elements.share.trigger.button.text': 'Dela',
    'fabric.elements.share.trigger.button.tooltip.text': 'Dela'
};

});

parcelRegister("l23Gi", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $3600545fbf809c3c$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E04\u0E25\u0E34\u0E1B\u0E1A\u0E2D\u0E23\u0E4C\u0E14\u0E41\u0E25\u0E49\u0E27",
    'fabric.elements.share.copylink.button.text': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C",
    'fabric.elements.share.copypubliclink.button.text': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E2A\u0E32\u0E18\u0E32\u0E23\u0E13\u0E30",
    'fabric.elements.share.failure.icon.label': "\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14",
    'fabric.elements.share.failure.message': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E0A\u0E23\u0E4C\u0E44\u0E14\u0E49",
    'fabric.elements.share.form.comment.label': "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21 (\u0E44\u0E21\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E30\u0E1A\u0E38)",
    'fabric.elements.share.form.comment.placeholder': "\u0E21\u0E35\u0E2D\u0E30\u0E44\u0E23\u0E17\u0E35\u0E48\u0E1E\u0E27\u0E01\u0E40\u0E02\u0E32\u0E04\u0E27\u0E23\u0E23\u0E39\u0E49\u0E44\u0E2B\u0E21",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u0E1C\u0E39\u0E49\u0E23\u0E31\u0E1A\u0E08\u0E30\u0E40\u0E2B\u0E47\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u0E1C\u0E39\u0E49\u0E23\u0E31\u0E1A\u0E08\u0E30\u0E40\u0E2B\u0E47\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'fabric.elements.share.form.no-permissions': "\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E41\u0E0A\u0E23\u0E4C",
    'fabric.elements.share.form.public.send': "\u0E2A\u0E48\u0E07\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E2A\u0E32\u0E18\u0E32\u0E23\u0E13\u0E30",
    'fabric.elements.share.form.public.share': "\u0E41\u0E0A\u0E23\u0E4C\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E2A\u0E32\u0E18\u0E32\u0E23\u0E13\u0E30",
    'fabric.elements.share.form.required-field.summary': "\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E30\u0E1A\u0E38\u0E08\u0E30\u0E21\u0E35\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E14\u0E2D\u0E01\u0E08\u0E31\u0E19",
    'fabric.elements.share.form.retry': "\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'fabric.elements.share.form.send': "\u0E2A\u0E48\u0E07",
    'fabric.elements.share.form.share': "\u0E41\u0E0A\u0E23\u0E4C",
    'fabric.elements.share.form.title': "\u0E41\u0E0A\u0E23\u0E4C",
    'fabric.elements.share.form.user-picker.add-more': "\u0E1B\u0E49\u0E2D\u0E19\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'fabric.elements.share.form.user-picker.label.confluence': "\u0E0A\u0E37\u0E48\u0E2D \u0E17\u0E35\u0E21 \u0E01\u0E25\u0E38\u0E48\u0E21 \u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E35\u0E40\u0E21\u0E25",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u0E0A\u0E37\u0E48\u0E2D \u0E17\u0E35\u0E21 \u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E25\u0E38\u0E48\u0E21",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u0E0A\u0E37\u0E48\u0E2D\u0E2B\u0E23\u0E37\u0E2D\u0E17\u0E35\u0E21",
    'fabric.elements.share.form.user-picker.label.email-only': "\u0E2D\u0E35\u0E40\u0E21\u0E25",
    'fabric.elements.share.form.user-picker.label.jira': "\u0E0A\u0E37\u0E48\u0E2D \u0E17\u0E35\u0E21 \u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E35\u0E40\u0E21\u0E25",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C\u0E43\u0E14 \u0E46 \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A "{inputValue}"',
    'fabric.elements.share.form.user-picker.no-options.generic': '\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C\u0E43\u0E14 \u0E46 \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A "{inputValue}" \u0E40\u0E0A\u0E34\u0E0D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u0E40\u0E0A\u0E48\u0E19 \u0E21\u0E32\u0E40\u0E23\u0E35\u0E22 \u0E17\u0E35\u0E21\u0E2A\u0E49\u0E21 \u0E01\u0E25\u0E38\u0E48\u0E21\u0E2B\u0E19\u0E36\u0E48\u0E07",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u0E40\u0E0A\u0E48\u0E19 \u0E21\u0E32\u0E40\u0E23\u0E35\u0E22 \u0E17\u0E35\u0E21\u0E2A\u0E49\u0E21",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u0E40\u0E0A\u0E48\u0E19 maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u0E40\u0E0A\u0E48\u0E19 \u0E21\u0E32\u0E40\u0E23\u0E35\u0E22 \u0E17\u0E35\u0E21\u0E2A\u0E49\u0E21 maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49 \u0E01\u0E25\u0E38\u0E48\u0E21 \u0E17\u0E35\u0E21 \u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E04\u0E19 \u0E17\u0E35\u0E21 \u0E01\u0E25\u0E38\u0E48\u0E21 \u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E04\u0E19 \u0E17\u0E35\u0E21 \u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E04\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E17\u0E35\u0E21\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E04\u0E19 \u0E17\u0E35\u0E21 \u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
    'fabric.elements.share.in.integration.button': "\u0E41\u0E0A\u0E23\u0E4C\u0E43\u0E19 {integrationName}",
    'fabric.elements.share.invite.to.confluence': "\u0E40\u0E0A\u0E34\u0E0D\u0E44\u0E1B\u0E22\u0E31\u0E07 Confluence",
    'fabric.elements.share.invite.to.jira': "\u0E40\u0E0A\u0E34\u0E0D\u0E44\u0E1B\u0E22\u0E31\u0E07 Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u0E41\u0E0A\u0E23\u0E4C\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'fabric.elements.share.main.tab.text.jira': "\u0E41\u0E0A\u0E23\u0E4C\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
    'fabric.elements.share.menu.email.label': "\u0E2D\u0E35\u0E40\u0E21\u0E25",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u0E41\u0E0A\u0E23\u0E4C",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u0E41\u0E0A\u0E23\u0E4C\u0E42\u0E1E\u0E2A\u0E15\u0E4C\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E41\u0E25\u0E49\u0E27}board {\u0E41\u0E0A\u0E23\u0E4C\u0E1A\u0E2D\u0E23\u0E4C\u0E14\u0E41\u0E25\u0E49\u0E27}calendar {\u0E41\u0E0A\u0E23\u0E4C\u0E1B\u0E0F\u0E34\u0E17\u0E34\u0E19\u0E41\u0E25\u0E49\u0E27}draft {\u0E41\u0E0A\u0E23\u0E4C\u0E41\u0E1A\u0E1A\u0E23\u0E48\u0E32\u0E07\u0E41\u0E25\u0E49\u0E27}filter {\u0E41\u0E0A\u0E23\u0E4C\u0E15\u0E31\u0E27\u0E01\u0E23\u0E2D\u0E07\u0E41\u0E25\u0E49\u0E27}issue {\u0E41\u0E0A\u0E23\u0E4C\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E41\u0E25\u0E49\u0E27}summary {\u0E41\u0E0A\u0E23\u0E4C\u0E2A\u0E23\u0E38\u0E1B\u0E41\u0E25\u0E49\u0E27}list {\u0E41\u0E0A\u0E23\u0E4C\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E41\u0E25\u0E49\u0E27}timeline {\u0E41\u0E0A\u0E23\u0E4C\u0E40\u0E2A\u0E49\u0E19\u0E40\u0E27\u0E25\u0E32 (\u0E44\u0E17\u0E21\u0E4C\u0E44\u0E25\u0E19\u0E4C) \u0E41\u0E25\u0E49\u0E27}form {\u0E41\u0E0A\u0E23\u0E4C\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E41\u0E25\u0E49\u0E27}media {\u0E41\u0E0A\u0E23\u0E4C\u0E2A\u0E37\u0E48\u0E2D\u0E41\u0E25\u0E49\u0E27}page {\u0E41\u0E0A\u0E23\u0E4C\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E25\u0E49\u0E27}project {\u0E41\u0E0A\u0E23\u0E4C\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E41\u0E25\u0E49\u0E27}pullrequest {\u0E41\u0E0A\u0E23\u0E4C Pull Request \u0E41\u0E25\u0E49\u0E27}question {\u0E41\u0E0A\u0E23\u0E4C\u0E04\u0E33\u0E16\u0E32\u0E21\u0E41\u0E25\u0E49\u0E27}report {\u0E41\u0E0A\u0E23\u0E4C\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E41\u0E25\u0E49\u0E27}repository {\u0E41\u0E0A\u0E23\u0E4C\u0E04\u0E25\u0E31\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E41\u0E25\u0E49\u0E27}request {\u0E41\u0E0A\u0E23\u0E4C\u0E04\u0E33\u0E02\u0E2D\u0E41\u0E25\u0E49\u0E27}roadmap {\u0E41\u0E0A\u0E23\u0E4C\u0E40\u0E2A\u0E49\u0E19\u0E40\u0E27\u0E25\u0E32 (\u0E44\u0E17\u0E21\u0E4C\u0E44\u0E25\u0E19\u0E4C) \u0E41\u0E25\u0E49\u0E27}site {\u0E41\u0E0A\u0E23\u0E4C\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E41\u0E25\u0E49\u0E27}space {\u0E41\u0E0A\u0E23\u0E4C\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27}other {\u0E41\u0E0A\u0E23\u0E4C\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E41\u0E25\u0E49\u0E27}}",
    'fabric.elements.share.to.integration.button': "\u0E41\u0E0A\u0E23\u0E4C\u0E44\u0E1B\u0E22\u0E31\u0E07 {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "\u0E41\u0E0A\u0E23\u0E4C\u0E44\u0E2D\u0E04\u0E2D\u0E19",
    'fabric.elements.share.trigger.button.invite.text': "\u0E40\u0E0A\u0E34\u0E0D",
    'fabric.elements.share.trigger.button.text': "\u0E41\u0E0A\u0E23\u0E4C",
    'fabric.elements.share.trigger.button.tooltip.text': "\u0E41\u0E0A\u0E23\u0E4C"
};

});

parcelRegister("kZEdI", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $79dc06767d8395f4$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Ba\u011Flant\u0131 panoya kopyaland\u0131",
    'fabric.elements.share.copylink.button.text': "Ba\u011Flant\u0131y\u0131 kopyala",
    'fabric.elements.share.copypubliclink.button.text': "Herkese a\xe7\u0131k ba\u011Flant\u0131y\u0131 kopyalay\u0131n",
    'fabric.elements.share.failure.icon.label': 'Hata simgesi',
    'fabric.elements.share.failure.message': "Payla\u015F\u0131lamad\u0131",
    'fabric.elements.share.form.comment.label': "Mesaj (iste\u011Fe ba\u011Fl\u0131)",
    'fabric.elements.share.form.comment.placeholder': "Bilmeleri gereken bir \u015Fey var m\u0131?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Al\u0131c\u0131lar sayfan\u0131n ad\u0131n\u0131 ve mesaj\u0131n\u0131z\u0131 g\xf6r\xfcr",
    'fabric.elements.share.form.info.message.no.invite.jira': "Al\u0131c\u0131lar konunun ad\u0131n\u0131 ve mesaj\u0131n\u0131z\u0131 g\xf6r\xfcr",
    'fabric.elements.share.form.no-permissions': "Payla\u015Fam\u0131yorsunuz.",
    'fabric.elements.share.form.public.send': "Herkese a\xe7\u0131k ba\u011Flant\u0131y\u0131 g\xf6nderin",
    'fabric.elements.share.form.public.share': "Herkese a\xe7\u0131k ba\u011Flant\u0131y\u0131 payla\u015F",
    'fabric.elements.share.form.required-field.summary': "Gerekli alanlar y\u0131ld\u0131z i\u015Faretiyle belirtilmi\u015Ftir",
    'fabric.elements.share.form.retry': 'Yeniden Dene',
    'fabric.elements.share.form.send': "G\xf6nder",
    'fabric.elements.share.form.share': "Payla\u015F",
    'fabric.elements.share.form.title': "Payla\u015F",
    'fabric.elements.share.form.user-picker.add-more': "Daha fazlas\u0131n\u0131 girin",
    'fabric.elements.share.form.user-picker.label.confluence': "Adlar, tak\u0131mlar, gruplar veya e-postalar",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Adlar, tak\u0131mlar veya gruplar",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Adlar veya tak\u0131mlar",
    'fabric.elements.share.form.user-picker.label.email-only': 'E-postalar',
    'fabric.elements.share.form.user-picker.label.jira': "Adlar, tak\u0131mlar veya e-postalar",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '"{inputValue}" i\xe7in herhangi bir sonu\xe7 bulunamad\u0131.',
    'fabric.elements.share.form.user-picker.no-options.generic': '"{inputValue}" i\xe7in herhangi bir sonu\xe7 bulunamad\u0131. Ki\u015Fileri e-posta adresi kullanarak davet edin.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\xf6r. Meryem, Turuncu Tak\u0131m, Birinci Grup",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\xf6r. Meryem, Turuncu Tak\u0131m",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\xf6r. meryem@sirket.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\xf6r. Meryem, Turuncu Tak\u0131m, meryem@sirket.com",
    'fabric.elements.share.form.user-picker.validation.required': "En az bir kullan\u0131c\u0131, grup, tak\u0131m veya e-posta adresi se\xe7in.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "En az bir ki\u015Fi, tak\u0131m, grup veya e-posta se\xe7in",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "En az bir ki\u015Fi, tak\u0131m veya grup se\xe7in",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "En az bir ki\u015Fi veya tak\u0131m se\xe7in",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "En az bir e-posta se\xe7in",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "En az bir ki\u015Fi, tak\u0131m veya e-posta se\xe7in",
    'fabric.elements.share.in.integration.button': "{integrationName} i\xe7inde payla\u015F",
    'fabric.elements.share.invite.to.confluence': "Confluence'a davet et",
    'fabric.elements.share.invite.to.jira': "Jira'ya davet et",
    'fabric.elements.share.main.tab.text.confluence': "Sayfay\u0131 payla\u015F\u0131n",
    'fabric.elements.share.main.tab.text.jira': "Konuyu payla\u015F\u0131n",
    'fabric.elements.share.menu.email.label': 'E-posta',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Payla\u015F",
    'fabric.elements.share.success.message': "{object, select,blogpost {Blog g\xf6nderisi payla\u015F\u0131ld\u0131}board {Pano payla\u015F\u0131ld\u0131}calendar {Takvim payla\u015F\u0131ld\u0131}draft {Taslak payla\u015F\u0131ld\u0131}filter {Filtre payla\u015F\u0131ld\u0131}issue {Konu payla\u015F\u0131ld\u0131}summary {\xd6zet payla\u015F\u0131ld\u0131}list {Liste payla\u015F\u0131ld\u0131}timeline {Zaman \xc7izelgesi payla\u015F\u0131ld\u0131}form {Form payla\u015F\u0131ld\u0131}media {Medya payla\u015F\u0131ld\u0131}page {Sayfa payla\u015F\u0131ld\u0131}project {Proje payla\u015F\u0131ld\u0131}pullrequest {\xc7ekme \u0130ste\u011Fi payla\u015F\u0131ld\u0131}question {Soru payla\u015F\u0131ld\u0131}report {Rapor payla\u015F\u0131ld\u0131}repository {Depo payla\u015F\u0131ld\u0131}request {Talep payla\u015F\u0131ld\u0131}roadmap {Zaman \xc7izelgesi payla\u015F\u0131ld\u0131}site {Site payla\u015F\u0131ld\u0131}space {Alan payla\u015F\u0131ld\u0131}other {Ba\u011Flant\u0131 payla\u015F\u0131ld\u0131}}",
    'fabric.elements.share.to.integration.button': "{integrationName} \xfczerinden payla\u015F",
    'fabric.elements.share.trigger.button.icon.label': "Payla\u015Fma simgesi",
    'fabric.elements.share.trigger.button.invite.text': 'Davet Et',
    'fabric.elements.share.trigger.button.text': "Payla\u015F",
    'fabric.elements.share.trigger.button.tooltip.text': "Payla\u015F"
};

});

parcelRegister("9Dz0B", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $0bbb38a3133f9043$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u041F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E \u0431\u0443\u0444\u0435\u0440\u0430 \u043E\u0431\u043C\u0456\u043D\u0443",
    'fabric.elements.share.copylink.button.text': "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
    'fabric.elements.share.copypubliclink.button.text': "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u0437\u0430\u0433\u0430\u043B\u044C\u043D\u043E\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
    'fabric.elements.share.failure.icon.label': "\u041F\u0456\u043A\u0442\u043E\u0433\u0440\u0430\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0438",
    'fabric.elements.share.failure.message': "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
    'fabric.elements.share.form.comment.label': "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F (\u043D\u0435\u043E\u0431\u043E\u0432\u2019\u044F\u0437\u043A\u043E\u0432\u043E)",
    'fabric.elements.share.form.comment.placeholder': "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0434\u043E\u0434\u0430\u0442\u0438 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u041E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447\u0456 \u043F\u043E\u0431\u0430\u0447\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u0442\u0430 \u0432\u0430\u0448\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u041E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447\u0456 \u043F\u043E\u0431\u0430\u0447\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0443 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438 \u0442\u0430 \u0432\u0430\u0448\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
    'fabric.elements.share.form.no-permissions': "\u0423 \u0432\u0430\u0441 \u043D\u0435\u043C\u0430\u0454 \u043C\u043E\u0436\u043B\u0438\u0432\u043E\u0441\u0442\u0456 \u043F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F.",
    'fabric.elements.share.form.public.send': "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0437\u0430\u0433\u0430\u043B\u044C\u043D\u043E\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
    'fabric.elements.share.form.public.share': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0437\u0430\u0433\u0430\u043B\u044C\u043D\u043E\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u043C \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F\u043C",
    'fabric.elements.share.form.required-field.summary': "\u041E\u0431\u043E\u0432\u2019\u044F\u0437\u043A\u043E\u0432\u0456 \u043F\u043E\u043B\u044F \u043F\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0456 \u0437\u0456\u0440\u043E\u0447\u043A\u043E\u044E",
    'fabric.elements.share.form.retry': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'fabric.elements.share.form.send': "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
    'fabric.elements.share.form.share': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F",
    'fabric.elements.share.form.title': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F",
    'fabric.elements.share.form.user-picker.add-more': "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u0431\u0456\u043B\u044C\u0448\u0435 \u0432\u0456\u0434\u043E\u043C\u043E\u0441\u0442\u0435\u0439",
    'fabric.elements.share.form.user-picker.label.confluence': "\u0406\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u0438, \u0433\u0440\u0443\u043F\u0438 \u0430\u0431\u043E \u0430\u0434\u0440\u0435\u0441\u0438 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u0406\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u0438 \u0430\u0431\u043E \u0433\u0440\u0443\u043F\u0438",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u0406\u043C\u0435\u043D\u0430 \u0430\u0431\u043E \u043A\u043E\u043C\u0430\u043D\u0434\u0438",
    'fabric.elements.share.form.user-picker.label.email-only': "\u0410\u0434\u0440\u0435\u0441\u0438 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
    'fabric.elements.share.form.user-picker.label.jira': "\u0406\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u0438 \u0430\u0431\u043E \u0430\u0434\u0440\u0435\u0441\u0438 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0436\u043E\u0434\u043D\u0438\u0445 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u0437\u0430 \u0437\u0430\u043F\u0438\u0442\u043E\u043C \xab{inputValue}\xbb.",
    'fabric.elements.share.form.user-picker.no-options.generic': "\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0436\u043E\u0434\u043D\u0438\u0445 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u0437\u0430 \u0437\u0430\u043F\u0438\u0442\u043E\u043C \xab{inputValue}\xbb. \u0417\u0430\u043F\u0440\u043E\u0441\u0456\u0442\u044C \u043B\u044E\u0434\u0435\u0439 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u0430\u0434\u0440\u0435\u0441\u0438.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u041D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434: \u041C\u0430\u0440\u0456\u044F, Team Orange, \u0433\u0440\u0443\u043F\u0430\xa01",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u041D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434: \u041C\u0430\u0440\u0456\u044F, Team Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u041D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434: maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u041D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434: \u041C\u0430\u0440\u0456\u044F, Team Orange, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u043D\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430, \u0433\u0440\u0443\u043F\u0443 \u0430\u0431\u043E \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443 \u043F\u043E\u0448\u0442\u0443.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u043D\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u0443, \u0433\u0440\u0443\u043F\u0443 \u0430\u0431\u043E \u0430\u0434\u0440\u0435\u0441\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u043D\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0430\u0431\u043E \u0433\u0440\u0443\u043F\u0443",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u043D\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u0430\u0431\u043E \u043A\u043E\u043C\u0430\u043D\u0434\u0443",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u043D\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0430\u0431\u043E \u0430\u0434\u0440\u0435\u0441\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
    'fabric.elements.share.in.integration.button': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0432 {integrationName}",
    'fabric.elements.share.invite.to.confluence': "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u0438 \u0434\u043E Confluence",
    'fabric.elements.share.invite.to.jira': "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u0438 \u0434\u043E Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u043E\u044E",
    'fabric.elements.share.main.tab.text.jira': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F\u043C",
    'fabric.elements.share.menu.email.label': "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0434\u043E\u043F\u0438\u0441\u0443 \u0432 \u0431\u043B\u043E\u0437\u0456}board {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0434\u043E\u0448\u043A\u0438}calendar {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044F}draft {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0447\u0435\u0440\u043D\u0435\u0442\u043A\u0438}filter {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0444\u0456\u043B\u044C\u0442\u0440\u0430}issue {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F}summary {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u043F\u0456\u0434\u0441\u0443\u043C\u043A\u0443}list {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0441\u043F\u0438\u0441\u043A\u0443}timeline {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0448\u043A\u0430\u043B\u0438}form {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0444\u043E\u0440\u043C\u0438}media {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u043C\u0435\u0434\u0456\u0430\u0444\u0430\u0439\u043B\u0443}page {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438}project {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0443}pullrequest {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0437\u0430\u043F\u0438\u0442\u0443 \u043D\u0430 \u0432\u043D\u0435\u0441\u0435\u043D\u043D\u044F \u0437\u043C\u0456\u043D}question {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0437\u0430\u043F\u0438\u0442\u0430\u043D\u043D\u044F}report {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0437\u0432\u0456\u0442\u0443}repository {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0440\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0440\u0456\u044E}request {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0437\u0430\u043F\u0438\u0442\u0443}roadmap {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0447\u0430\u0441\u043E\u0432\u043E\u0457 \u0448\u043A\u0430\u043B\u0438}site {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0441\u0430\u0439\u0442\u0443}space {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0440\u043E\u0437\u0434\u0456\u043B\u0443}other {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F}}",
    'fabric.elements.share.to.integration.button': "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0432 {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043F\u0456\u043A\u0442\u043E\u0433\u0440\u0430\u043C\u0443",
    'fabric.elements.share.trigger.button.invite.text': "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u0438",
    'fabric.elements.share.trigger.button.text': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F",
    'fabric.elements.share.trigger.button.tooltip.text': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F"
};

});

parcelRegister("9RAG0", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $7036ff543f412ca5$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u0110\xe3 sao ch\xe9p li\xean k\u1EBFt",
    'fabric.elements.share.copylink.button.text': "Sao ch\xe9p li\xean k\u1EBFt",
    'fabric.elements.share.copypubliclink.button.text': "Sao ch\xe9p li\xean k\u1EBFt c\xf4ng khai",
    'fabric.elements.share.failure.icon.label': "Bi\u1EC3u t\u01B0\u1EE3ng l\u1ED7i",
    'fabric.elements.share.failure.message': "Kh\xf4ng th\u1EC3 chia s\u1EBB",
    'fabric.elements.share.form.comment.label': "Tin nh\u1EAFn (kh\xf4ng b\u1EAFt bu\u1ED9c)",
    'fabric.elements.share.form.comment.placeholder': "B\u1EA1n c\xf3 n\u1ED9i dung g\xec c\u1EA7n l\u01B0u \xfd ng\u01B0\u1EDDi kh\xe1c kh\xf4ng?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Ng\u01B0\u1EDDi nh\u1EADn s\u1EBD th\u1EA5y t\xean trang v\xe0 tin nh\u1EAFn c\u1EE7a b\u1EA1n",
    'fabric.elements.share.form.info.message.no.invite.jira': "Ng\u01B0\u1EDDi nh\u1EADn s\u1EBD th\u1EA5y t\xean s\u1EF1 c\u1ED1 v\xe0 tin nh\u1EAFn c\u1EE7a b\u1EA1n",
    'fabric.elements.share.form.no-permissions': "B\u1EA1n kh\xf4ng c\xf3 kh\u1EA3 n\u0103ng chia s\u1EBB.",
    'fabric.elements.share.form.public.send': "G\u1EEDi li\xean k\u1EBFt c\xf4ng khai",
    'fabric.elements.share.form.public.share': "Chia s\u1EBB li\xean k\u1EBFt c\xf4ng khai",
    'fabric.elements.share.form.required-field.summary': "C\xe1c tr\u01B0\u1EDDng b\u1EAFt bu\u1ED9c \u0111\u01B0\u1EE3c \u0111\xe1nh d\u1EA5u b\u1EB1ng d\u1EA5u sao",
    'fabric.elements.share.form.retry': "Th\u1EED l\u1EA1i",
    'fabric.elements.share.form.send': "G\u1EEDi",
    'fabric.elements.share.form.share': "Chia s\u1EBB",
    'fabric.elements.share.form.title': "Chia s\u1EBB",
    'fabric.elements.share.form.user-picker.add-more': "Nh\u1EADp th\xeam",
    'fabric.elements.share.form.user-picker.label.confluence': "T\xean, \u0111\u1ED9i ng\u0169, nh\xf3m ho\u1EB7c email",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "T\xean, \u0111\u1ED9i ng\u0169 ho\u1EB7c nh\xf3m",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "T\xean ho\u1EB7c \u0111\u1ED9i ng\u0169",
    'fabric.elements.share.form.user-picker.label.email-only': 'Email',
    'fabric.elements.share.form.user-picker.label.jira': "T\xean, \u0111\u1ED9i ng\u0169 ho\u1EB7c email",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Ch\xfang t\xf4i kh\xf4ng th\u1EC3 t\xecm th\u1EA5y b\u1EA5t c\u1EE9 k\u1EBFt qu\u1EA3 n\xe0o cho "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Ch\xfang t\xf4i kh\xf4ng th\u1EC3 t\xecm th\u1EA5y b\u1EA5t c\u1EE9 k\u1EBFt qu\u1EA3 n\xe0o cho "{inputValue}". M\u1EDDi m\u1ECDi ng\u01B0\u1EDDi b\u1EB1ng c\xe1ch s\u1EED d\u1EE5ng \u0111\u1ECBa ch\u1EC9 email.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "v\xed d\u1EE5: Maria, \u0110\u1ED9i ng\u0169 m\xe0u cam, nh\xf3m m\u1ED9t",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "v\xed d\u1EE5: Maria, \u0110\u1ED9i ng\u0169 m\xe0u cam",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "v\xed d\u1EE5: maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "v\xed d\u1EE5: Maria, \u0110\u1ED9i ng\u0169 m\xe0u cam, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "Ch\u1ECDn \xedt nh\u1EA5t m\u1ED9t ng\u01B0\u1EDDi d\xf9ng, \u0111\u1ED9i, nh\xf3m ho\u1EB7c email.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Ch\u1ECDn \xedt nh\u1EA5t m\u1ED9t ng\u01B0\u1EDDi, \u0111\u1ED9i ng\u0169, nh\xf3m ho\u1EB7c email",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Ch\u1ECDn \xedt nh\u1EA5t m\u1ED9t ng\u01B0\u1EDDi, \u0111\u1ED9i ng\u0169 ho\u1EB7c nh\xf3m",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Ch\u1ECDn \xedt nh\u1EA5t m\u1ED9t ng\u01B0\u1EDDi ho\u1EB7c \u0111\u1ED9i ng\u0169",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Ch\u1ECDn \xedt nh\u1EA5t m\u1ED9t email",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Ch\u1ECDn \xedt nh\u1EA5t m\u1ED9t ng\u01B0\u1EDDi, \u0111\u1ED9i ng\u0169 ho\u1EB7c email",
    'fabric.elements.share.in.integration.button': "Chia s\u1EBB trong {integrationName}",
    'fabric.elements.share.invite.to.confluence': "M\u1EDDi tham gia Confluence",
    'fabric.elements.share.invite.to.jira': "M\u1EDDi tham gia Jira",
    'fabric.elements.share.main.tab.text.confluence': "Chia s\u1EBB trang",
    'fabric.elements.share.main.tab.text.jira': "Chia s\u1EBB v\u1EA5n \u0111\u1EC1",
    'fabric.elements.share.menu.email.label': 'Email',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Chia s\u1EBB",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u0110\xe3 chia s\u1EBB b\xe0i \u0111\u0103ng tr\xean blog}board {\u0110\xe3 chia s\u1EBB b\u1EA3ng th\xf4ng tin}calendar {\u0110\xe3 chia s\u1EBB l\u1ECBch}draft {\u0110\xe3 chia s\u1EBB b\u1EA3n nh\xe1p}filter {\u0110\xe3 chia s\u1EBB b\u1ED9 l\u1ECDc}issue {\u0110\xe3 chia s\u1EBB v\u1EA5n \u0111\u1EC1}summary {\u0110\xe3 chia s\u1EBB b\u1EA3n t\xf3m t\u1EAFt}list {\u0110\xe3 chia s\u1EBB danh s\xe1ch}timeline {\u0110\xe3 chia s\u1EBB l\u1ECBch tr\xecnh}form {\u0110\xe3 chia s\u1EBB bi\u1EC3u m\u1EABu}media {\u0110\xe3 chia s\u1EBB ph\u01B0\u01A1ng ti\u1EC7n}page {\u0110\xe3 chia s\u1EBB trang}project {\u0110\xe3 chia s\u1EBB d\u1EF1 \xe1n}pullrequest {\u0110\xe3 chia s\u1EBB Pull request}question {\u0110\xe3 chia s\u1EBB c\xe2u h\u1ECFi}report {\u0110\xe3 chia s\u1EBB b\xe1o c\xe1o}repository {\u0110\xe3 chia s\u1EBB kho}request {\u0110\xe3 chia s\u1EBB y\xeau c\u1EA7u}roadmap {\u0110\xe3 chia s\u1EBB l\u1ECBch tr\xecnh}site {\u0110\xe3 chia s\u1EBB trang web}space {\u0110\xe3 chia s\u1EBB kh\xf4ng gian}other {\u0110\xe3 chia s\u1EBB li\xean k\u1EBFt}}",
    'fabric.elements.share.to.integration.button': "Chia s\u1EBB v\u1EDBi {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Bi\u1EC3u t\u01B0\u1EE3ng chia s\u1EBB",
    'fabric.elements.share.trigger.button.invite.text': "M\u1EDDi",
    'fabric.elements.share.trigger.button.text': "Chia s\u1EBB",
    'fabric.elements.share.trigger.button.tooltip.text': "Chia s\u1EBB"
};

});

parcelRegister("f2xYB", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $6d815bca46daae46$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u2063\u2062Link copied to clipboard\x8f\u200D\x8f\u2061\u206B\u206A\u200D\u206E\x8f\x8d\x8f\u206C\u206A\u206C\x90\u200C\x9d\u206F\x81\x90\u206C\u206B\u2061\u206A\x8d\x8d\u206A\x90\u206C\x8d\u2060\u2061\u2063\u2064",
    'fabric.elements.share.copylink.button.text': "\u2063\u2062Copy link\x8d\u206C\x8f\u206E\u206A\u200D\u206E\x9d\x90\u061C\u2061\x8d\u206E\x90\u206D\x8d\u2061\u200C\u206F\x8d\u2061\x8d\u206A\x81\x81\u206B\u206E\u200C\x9d\u2060\u206F\x81\u2063\u2064",
    'fabric.elements.share.copypubliclink.button.text': "\u2063\u2062Copy public link\u2061\x81\u200C\u206F\u200D\u206D\x9d\u2061\x8f\u206C\u206D\x8f\u2061\x81\x81\u206A\u206A\x90\u206E\u2060\u061C\u2060\u206F\u206E\u206B\u206D\u200C\u061C\u200C\x9d\x9d\x9d\u2063\u2064",
    'fabric.elements.share.failure.icon.label': "\u2063\u2062Error icon\u200D\u061C\u206C\u206E\u206F\u2061\u206E\u206F\x8f\x90\u2060\u061C\x90\u061C\u200D\u200C\u206A\u206A\u200C\u200C\u206E\u206F\x90\u200D\u2061\u206B\u206A\u2060\x8f\u200C\x90\u206E\u2063\u2064",
    'fabric.elements.share.failure.message': "\u2063\u2062Unable to share\x8f\u206A\u206E\x90\u200D\x90\u2061\x90\u206A\x8d\u206D\x8d\x9d\u2060\x90\x9d\u206C\u2061\u206C\x9d\x8d\u206C\u206C\u206B\x9d\x8d\u206B\x9d\u200C\x81\u200D\u2060\u2063\u2064",
    'fabric.elements.share.form.comment.label': "\u2063\u2062Message (optional)\x8d\u200D\u206F\x8d\u206B\x90\u2060\u2061\u206D\u206E\u206F\u2061\u2060\x8f\u206C\u206E\u206B\x81\u200C\x90\u206D\u206C\x8d\u2060\u061C\u2060\u2060\x81\x8f\u200D\u200D\u206F\u2063\u2064",
    'fabric.elements.share.form.comment.placeholder': "\u2063\u2062Anything they should know?\u2060\u206F\x81\u061C\x8d\u2061\u2061\u200D\u206B\u206B\u206F\u206A\x81\u2061\u200C\u2060\x8d\x90\u206E\x90\u206E\x81\u206D\u200D\x8f\u206C\u206E\u206A\u206C\u2060\u206A\u206D\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u2063\u2062Recipients will see the name of the page and your message\u206F\u2060\x81\x90\u200C\u200C\x81\x90\u061C\u2060\x8d\u200C\x81\u206A\u2061\u061C\u206E\x8f\u2060\u206D\u206D\x8f\u200C\u200C\x9d\u206D\u200C\u2060\x8f\x8f\u206A\u200C\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u2063\u2062Recipients will see the name of the issue and your message\x81\u206C\u206C\x8d\u206F\u200D\u206B\u200D\u2060\u061C\u2061\x81\u206D\x8d\u206A\x8d\x90\u206B\x8d\u206A\x8f\x8d\u206D\u206E\u206D\x9d\u200D\u206C\u206E\x9d\u206F\u2060\u2063\u2064",
    'fabric.elements.share.form.no-permissions': "\u2063\u2062You do not have the ability to share.\x8f\u206B\u206F\x8f\u061C\u206B\u206D\x81\u206C\u206F\u206F\u206C\u2060\u206E\u200D\u200D\x81\x81\u200D\u206B\x8d\u206E\x9d\u206C\x8f\u206A\u2061\u2060\u2061\x90\u206D\u206E\u2063\u2064",
    'fabric.elements.share.form.public.send': "\u2063\u2062Send public link\u206E\u206B\x8d\u206D\u206E\u206C\u2060\u206F\u206B\u206F\u061C\u2060\x8d\x9d\u200D\u206F\u2060\u2061\u206E\x81\u061C\u206F\u206D\x8d\x8f\u200C\x8d\x81\u206D\u2061\u206B\u2060\u2063\u2064",
    'fabric.elements.share.form.public.share': "\u2063\u2062Share public link\u2060\u2061\x90\u200D\u206A\u206A\u200D\u206F\u200D\x8f\u206B\u200C\u2060\u206C\u061C\u200D\u206C\u200C\u206F\x9d\u206F\x8d\u200D\x81\x9d\u206D\u2061\u2061\u206D\u2061\u061C\u206E\u2063\u2064",
    'fabric.elements.share.form.required-field.summary': "\u2063\u2062Required fields are marked with an asterisk\x8d\x8d\u200D\u206C\u2060\u206F\u206A\x9d\u206F\u200D\x90\x9d\u206A\u206D\x9d\u206B\u206C\u200C\x90\x81\x81\u206C\u2061\u200C\u200C\u2060\u200D\u061C\u206B\x9d\u206B\x9d\u2063\u2064",
    'fabric.elements.share.form.retry': "\u2063\u2062Retry\u200C\u206B\u206F\u206D\u200C\x9d\u206C\u2061\u061C\u200C\u206C\u206C\u206A\u206C\u206C\x8d\x90\u206A\x9d\x8d\u206C\u206A\u200C\x81\x8f\x8f\u2061\u2061\u206F\x90\u200C\x8d\u2063\u2064",
    'fabric.elements.share.form.send': "\u2063\u2062Send\x90\u200D\u206D\u200C\x8f\u2060\u2060\u200D\u061C\u200D\x8d\u200C\u206D\u206F\u200D\u206E\u206B\u206D\u2061\u206F\x9d\u206F\u206F\u206F\u061C\u206A\u206D\u206A\x8d\x8d\u2060\u061C\u2063\u2064",
    'fabric.elements.share.form.share': "\u2063\u2062Share\u2060\x8f\u200C\u200D\x9d\x9d\u206A\u206D\u206B\u206C\x81\x90\x8d\u2060\x8f\x8f\u206C\u200C\u206A\u200C\u061C\u2060\u061C\x8f\u061C\x8f\u206D\u206E\x8f\x8f\u200C\x81\u2063\u2064",
    'fabric.elements.share.form.title': "\u2063\u2062Share\u206E\u206B\u2060\u206E\x9d\u206C\x8d\u061C\x90\x9d\u206A\u206B\u206D\u206F\u200C\u206F\u200D\x9d\u061C\u200D\u206E\u2060\u206E\x81\u206F\u061C\x8d\x81\x8f\u2061\u206B\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.add-more': "\u2063\u2062Enter more\u2060\x9d\u2060\x81\u2061\u200D\u206B\u206F\u206E\x8d\x8d\u206B\u200C\u061C\u061C\u200C\x9d\u200D\u2060\x8d\x9d\u206C\x8f\u206A\x8f\u206B\x8d\x9d\u061C\u206C\u200D\u2060\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.confluence': "\u2063\u2062Names, teams, groups, or emails\u206F\x9d\u206F\u206D\x81\u2061\x90\u200D\u206E\u2060\x90\x8f\x81\x8d\u2061\u206D\u200D\u206D\u200D\u206A\x9d\x81\u206F\u206C\u061C\x90\u200C\u200D\x81\x8d\u206E\u200D\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u2063\u2062Names, teams, or groups\u206A\x8d\x8f\u206F\x90\u206E\u200D\u206E\u2060\u061C\u206F\u206C\x8d\x8d\x9d\u200C\x90\u206F\x9d\u061C\u206C\x90\x90\u206B\u2060\u061C\u2060\u206E\x8d\u2061\x8f\u206A\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u2063\u2062Names or teams\x8d\u206B\u206C\u206D\u206E\x90\x9d\u200C\u206A\x90\x90\u206D\u200D\u206F\u200D\x8f\u061C\u061C\u206F\u206F\u061C\u206E\u206F\u206B\u2060\u061C\u2060\u200D\u2061\x9d\x8d\x90\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-only': "\u2063\u2062Emails\x81\u061C\x9d\u206C\x8f\u206A\u200C\u206A\u206F\u2060\u206B\x9d\u206F\x90\x9d\x9d\u206A\u061C\x8f\u206B\u206F\u206E\x8f\u061C\x9d\u206C\u206E\u206F\u2060\u206C\x8f\u206C\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.jira': "\u2063\u2062Names, teams, or emails\u200C\u2061\u206D\u206B\u200C\u061C\u206F\u061C\u2060\u200C\x8f\x8f\u2061\u206D\x81\u206B\x8f\u061C\u200D\x8d\x8f\u2061\u206E\u061C\u206D\x81\u2060\u061C\u2060\u206B\u206F\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '\u2063\u2062We couldn\u2019t find any results for "{inputValue}".\u206D\x8f\x8f\u2061\u206D\u200C\x81\x9d\u206D\x90\x8f\u200C\u206E\u206F\u206B\x8f\u061C\u2061\u2061\u206F\u2061\x81\x9d\u2060\x90\u2060\u206B\x9d\u200D\u206D\u200D\u206A\u2063\u2064',
    'fabric.elements.share.form.user-picker.no-options.generic': '\u2063\u2062We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.\x8d\u2061\u061C\x8f\x9d\u206E\u061C\u200D\u2060\u206A\u206A\x9d\u061C\x9d\x8f\x90\u2060\u2060\u2061\u206E\u061C\u206F\u206C\x90\u2061\u2060\u206D\u200D\u206B\x8f\x90\u200D\u2063\u2064',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u2063\u2062e.g. Maria, Team Orange, group-one\u200D\u206D\x81\u2061\u200D\u2060\u206B\u061C\x90\x8f\u206C\u206E\u206A\x8f\x8f\u061C\u206E\u200D\x90\x8d\x8d\x90\u206C\x90\u2061\u206C\x9d\u206F\x90\u206F\u206C\x9d\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u2063\u2062e.g. Maria, Team Orange\x81\u206E\u206C\x81\u061C\x9d\u2061\u206A\u206F\x9d\x90\u206C\u200C\x90\u2061\u200D\u206D\x90\u206F\x81\x81\u061C\u206C\u206C\u206C\x8d\u061C\x8d\u206F\u061C\u206A\u061C\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u2063\u2062e.g. maria@company.com\x8d\u206B\u206A\u061C\x9d\u206B\x81\u2060\u206B\x9d\u206B\u206C\u206B\u200C\u206C\u200D\u206C\u206F\u061C\u206B\x90\u206A\x8f\u2060\u200D\u061C\u206F\u206E\u200C\x8f\u061C\x8d\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u2063\u2062e.g. Maria, Team Orange, maria@company.com\x8f\x8d\u206A\u200C\u2061\u061C\u206D\x81\u2061\x8d\u206A\x8d\u200D\x8d\u206A\u206D\u2061\u2061\u061C\u200C\x9d\u200C\u206C\u200D\u206A\x8f\u206C\u2060\u206D\u206B\x9d\u2061\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required': "\u2063\u2062Select at least one user, group, team or email.\x81\u206E\u206A\x81\u206F\u2061\x8f\x9d\x9d\u206D\u2061\u061C\u206B\u206F\x9d\u200C\u200D\u206D\u206B\x81\x81\u206A\u206F\u200C\x8d\x90\x81\u206B\u2060\u061C\x9d\u206B\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u2063\u2062Select at least one person, team, group, or email\u206B\x81\u206E\x9d\u206D\x90\u200D\x9d\u200C\u206D\x9d\u2060\u206B\x8d\x8f\u206C\u206C\u2061\u206D\u206F\x8d\x90\u200C\x90\u200D\u206F\u200C\u206A\u206D\u2061\u2060\u200D\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u2063\u2062Select at least one person, team, or group\x8d\u206C\u206F\u061C\x90\u206D\x9d\u206D\u206A\u200C\u206E\x8f\u2060\u206D\x81\u206A\x8d\u206A\x9d\x9d\u2060\u200C\u206A\x8f\u200C\x9d\x9d\u206E\u2061\x8d\x81\x8f\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u2063\u2062Select at least one person or team\u206A\u206F\u200D\x8f\u206D\u206F\u206B\x90\u206C\x81\u206E\u2060\u200D\u2061\x81\u206A\x8d\u206E\u206F\x8f\x9d\x8f\x8f\u2060\x9d\x81\x81\u206A\u206C\x81\u200C\u2061\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u2063\u2062Select at least one email\x8f\u206F\u206D\x81\u200D\u206B\u206B\x8d\u206D\x8d\u200C\x8d\x9d\u200C\u206F\u200D\u200D\u2060\u2061\u206F\u061C\x8d\u206F\x90\u200D\u2061\u206A\x8d\x90\u200C\x8f\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u2063\u2062Select at least one person, team, or email\u2060\x9d\u2060\u206A\x90\u200C\u200C\u061C\u206C\u200D\x8d\u200D\u200D\u2060\u200C\u206C\u206A\u206D\u206D\u206E\u200D\u200D\x90\u061C\u200C\u2060\u206A\u206B\u2061\u206A\u2060\x8f\u2063\u2064",
    'fabric.elements.share.in.integration.button': "\u2063\u2062Share in {integrationName}\u2060\u061C\x90\u206A\u2061\u206C\u206D\u2061\u206D\x90\x8f\x8f\u200C\u206B\u206A\x9d\u206C\u2061\u061C\u200C\x90\u206E\u206A\u206F\u206C\x81\u200C\x8f\u206C\u200C\x81\u206D\u2063\u2064",
    'fabric.elements.share.invite.to.confluence': "\u2063\u2062Invite to Confluence\u206A\u206E\x8f\u2061\x8f\u206D\u206B\x9d\u206A\x9d\x8f\u206F\u061C\u200D\u206B\u206A\u200D\x9d\u2060\u206D\u200D\x8f\u2061\x8d\u2060\u2061\u206E\x81\u206C\u061C\u200D\u200D\u2063\u2064",
    'fabric.elements.share.invite.to.jira': "\u2063\u2062Invite to Jira\u061C\x8f\u2060\u2061\x8f\u206F\x8d\x81\x9d\x81\u206C\u2060\u200C\u206E\u206E\u061C\x90\u2060\u206E\u2060\u200D\x8d\x81\u206B\u206F\x8d\u200D\u206B\u2061\x9d\u206C\x8f\u2063\u2064",
    'fabric.elements.share.main.tab.text.confluence': "\u2063\u2062Share page\x81\u206A\u206F\u206D\u206C\u206C\x8f\x8f\x8f\x8d\x8f\x8f\u206A\u206C\u206F\x9d\u200C\x8f\u200D\u200C\u200D\u2060\x8d\u206B\x8f\u2061\u061C\u206E\x81\u200C\x8d\u206E\u2063\u2064",
    'fabric.elements.share.main.tab.text.jira': "\u2063\u2062Share issue\x9d\x9d\x8f\x9d\u061C\u206D\u200D\u206E\x90\x81\u200D\x9d\x81\x90\x8f\u206C\u061C\u200D\x9d\x9d\u206C\x9d\u206F\u2061\u2060\u2060\u206A\u206E\u061C\x81\u200D\x8f\u2063\u2064",
    'fabric.elements.share.menu.email.label': "\u2063\u2062Email\u206E\x90\u200D\u206B\u2061\u206C\u061C\u206A\u206A\u200C\u200C\x8f\u061C\x8f\u200C\u200C\u206C\u206D\u200C\u206A\x8f\x81\u206F\u2061\x8d\u2061\u206E\u2061\u206E\u206C\u206A\u206A\u2063\u2064",
    'fabric.elements.share.menu.slack.label': "\u2063\u2062Slack\u206B\u200C\u206B\x8f\u061C\u206D\x9d\u061C\x8f\u200D\u2060\u200D\x81\x90\u206C\u206F\u200C\x81\u2061\x9d\x8f\u206F\u200D\x8f\u206E\u200C\x8f\x81\u206C\u2060\x8d\u2060\u2063\u2064",
    'fabric.elements.share.popup.label': "\u2063\u2062Share\u206D\x9d\u206D\u206B\u206C\u200D\u200C\u206C\x8f\u206C\x90\x81\x81\x8d\x90\x8f\u206B\u206A\u2061\u200C\u206F\u206A\u200C\u206E\x9d\x8d\u206E\u200C\u200D\u200D\x81\u206C\u2063\u2064",
    'fabric.elements.share.success.message': "\u2063\u2062{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}\x8f\x8f\u206A\x81\x9d\u206F\u061C\u206F\u206A\u200C\u206C\u206F\u206F\x8d\x8d\u206C\u206C\x8d\u206C\u206D\u206C\u206A\u206E\u2060\u200D\x90\u061C\x90\x81\u206E\u206D\x9d\u2063\u2064",
    'fabric.elements.share.to.integration.button': "\u2063\u2062Share to {integrationName}\x9d\u206D\u200C\x9d\x8d\u206C\u206E\u206E\u206D\u206A\u2061\u200C\u2060\u206F\x90\u2061\x8d\u2061\u2061\u2060\x9d\u200D\x90\u200D\u206A\x9d\u061C\u200C\x9d\u206B\u2061\x8f\u2063\u2064",
    'fabric.elements.share.trigger.button.icon.label': "\u2063\u2062Share icon\x81\x90\u200C\x9d\u206C\u200D\x8f\x8f\u206E\x9d\u206F\u206B\x8f\u206F\x9d\x8d\x8d\u061C\u200D\x9d\x8f\u206C\u206F\u200D\u206D\u061C\x90\u206A\u200C\u206A\u206B\u2061\u2063\u2064",
    'fabric.elements.share.trigger.button.invite.text': "\u2063\u2062Invite\u2061\u200D\u206A\u206B\x9d\u206D\x8f\u200D\u206F\x81\u2060\u206B\u206B\x8f\x8f\u206E\u061C\u2061\x8f\u200C\u206E\x81\u2060\u061C\u061C\x9d\u206E\u061C\x9d\u206D\u206A\u061C\u2063\u2064",
    'fabric.elements.share.trigger.button.text': "\u2063\u2062Share\u206B\u206A\x81\x8d\x8d\x9d\x8f\u200C\u206D\u206D\x9d\u2061\x81\x81\u200D\u206F\u200C\u206C\u200D\x90\u206A\u206B\u206F\u061C\u061C\u206E\x9d\u2061\u200D\x90\x81\u206B\u2063\u2064",
    'fabric.elements.share.trigger.button.tooltip.text': "\u2063\u2062Share\u200C\u206F\u2061\u206A\x90\u200C\u061C\u200C\x8f\u200C\u206A\u206F\u206D\u2060\u061C\u2061\u206D\u206F\u206E\u206D\x8d\u200C\x90\u200C\u200D\u206A\u206E\x8d\u206A\u200C\u206C\u206A\u2063\u2064"
};

});

parcelRegister("gb9Or", function(module, exports) {

$parcel$export(module.exports, "default", () => $6572e39f98a14ff9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $6572e39f98a14ff9$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copied to clipboard',
    'fabric.elements.share.copylink.button.text': 'Copy link',
    'fabric.elements.share.copypubliclink.button.text': 'Copy public link',
    'fabric.elements.share.failure.icon.label': 'Error icon',
    'fabric.elements.share.failure.message': 'Unable to share',
    'fabric.elements.share.form.comment.label': 'Message (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Anything they should know?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Recipients will see the name of the page and your message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Recipients will see the name of the issue and your message',
    'fabric.elements.share.form.no-permissions': 'You do not have the ability to share.',
    'fabric.elements.share.form.public.send': 'Send public link',
    'fabric.elements.share.form.public.share': 'Share public link',
    'fabric.elements.share.form.required-field.summary': 'Required fields are marked with an asterisk',
    'fabric.elements.share.form.retry': 'Retry',
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Share',
    'fabric.elements.share.form.title': 'Share',
    'fabric.elements.share.form.user-picker.add-more': 'Enter more',
    'fabric.elements.share.form.user-picker.label.confluence': 'Names, teams, groups, or emails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Names, teams, or groups',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Names or teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'Emails',
    'fabric.elements.share.form.user-picker.label.jira': 'Names, teams, or emails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'We couldn\u2019t find any results for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'e.g. Maria, Team Orange, group-one',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'e.g. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'e.g. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'e.g. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': 'Select at least one user, group, team or email.',
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Select at least one person, team, group, or email',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Select at least one person, team, or group',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Select at least one person or team',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Select at least one email',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Select at least one person, team, or email',
    'fabric.elements.share.in.integration.button': 'Share in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invite to Confluence',
    'fabric.elements.share.invite.to.jira': 'Invite to Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Share page',
    'fabric.elements.share.main.tab.text.jira': 'Share issue',
    'fabric.elements.share.menu.email.label': 'Email',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Share',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}',
    'fabric.elements.share.to.integration.button': 'Share to {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Share icon',
    'fabric.elements.share.trigger.button.invite.text': 'Invite',
    'fabric.elements.share.trigger.button.text': 'Share',
    'fabric.elements.share.trigger.button.tooltip.text': 'Share'
};

});

parcelRegister("ikz4n", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bc923914c26892a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $3bc923914c26892a$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copied to clipboard',
    'fabric.elements.share.copylink.button.text': 'Copy link',
    'fabric.elements.share.copypubliclink.button.text': 'Copy public link',
    'fabric.elements.share.failure.icon.label': 'Error icon',
    'fabric.elements.share.failure.message': 'Unable to share',
    'fabric.elements.share.form.comment.label': 'Message (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Anything they should know?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Recipients will see the name of the page and your message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Recipients will see the name of the issue and your message',
    'fabric.elements.share.form.no-permissions': 'You do not have the ability to share.',
    'fabric.elements.share.form.public.send': 'Send public link',
    'fabric.elements.share.form.public.share': 'Share public link',
    'fabric.elements.share.form.required-field.summary': 'Required fields are marked with an asterisk',
    'fabric.elements.share.form.retry': 'Retry',
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Share',
    'fabric.elements.share.form.title': 'Share',
    'fabric.elements.share.form.user-picker.add-more': 'Enter more',
    'fabric.elements.share.form.user-picker.label.confluence': 'Names, teams, groups, or emails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Names, teams, or groups',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Names or teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'Emails',
    'fabric.elements.share.form.user-picker.label.jira': 'Names, teams, or emails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'We couldn\u2019t find any results for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'e.g. Maria, Team Orange, group-one',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'e.g. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'e.g. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'e.g. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': 'Select at least one user, group, team or email.',
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Select at least one person, team, group, or email',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Select at least one person, team, or group',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Select at least one person or team',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Select at least one email',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Select at least one person, team, or email',
    'fabric.elements.share.in.integration.button': 'Share in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invite to Confluence',
    'fabric.elements.share.invite.to.jira': 'Invite to Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Share page',
    'fabric.elements.share.main.tab.text.jira': 'Share issue',
    'fabric.elements.share.menu.email.label': 'Email',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Share',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}',
    'fabric.elements.share.to.integration.button': 'Share to {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Share icon',
    'fabric.elements.share.trigger.button.invite.text': 'Invite',
    'fabric.elements.share.trigger.button.text': 'Share',
    'fabric.elements.share.trigger.button.tooltip.text': 'Share'
};

});

parcelRegister("aXPtc", function(module, exports) {

$parcel$export(module.exports, "default", () => $704c2f71df5e4536$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ // Icelandic
var $704c2f71df5e4536$export$2e2bcd8739ae039 = {
    'fabric.elements.share.form.title': 'Deila',
    'fabric.elements.share.form.send': 'Senda ',
    'fabric.elements.share.form.retry': 'Reyna aftur',
    'fabric.elements.share.form.comment.placeholder': "B\xe6ta vi\xf0 skilabo\xf0um",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Sl\xe1\xf0u inn nafn, teymi e\xf0a t\xf6lvup\xf3stur",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Sl\xe1\xf0u inn nafn e\xf0a teymi",
    'fabric.elements.share.form.user-picker.add-more': "F\xe6ra inn fleiri ",
    'fabric.elements.share.form.user-picker.validation.required': "Veldu a\xf0 minnsta kosti einn notanda, teymi e\xf0a netfang.",
    'fabric.elements.share.form.user-picker.no-options.domainBasedUserOnly': "\xde\xfa getur a\xf0eins bo\xf0i\xf0 f\xf3lki sem eru me\xf0 {domains} netf\xf6ng. Haf\xf0u samband vi\xf0 stj\xf3rnanda s\xed\xf0unnar \xfeinnar til a\xf0 bj\xf3\xf0a \xf6\xf0ru f\xf3lki.",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Ekki fundust neinar ni\xf0urst\xf6\xf0ur fyrir \u201E{inputValue}\u201C. Bj\xf3ddu f\xf3lki me\xf0 \xfev\xed a\xf0 nota netf\xf6ng.",
    'fabric.elements.share.form.user-picker.no-options.generic': 'Engar ni\xf0urst\xf6\xf0ur fundust fyrir "{inputValue}". Bj\xf3ddu f\xf3lki me\xf0 \xfev\xed a\xf0 nota t\xf6lvup\xf3stfang.',
    'fabric.elements.share.trigger.button.icon.label': "Deilingart\xe1kn",
    'fabric.elements.share.trigger.button.text': 'Deila',
    'fabric.elements.share.trigger.button.tooltip.text': 'Deila',
    'fabric.elements.share.trigger.button.invite.text': "Bo\xf0i\xf0",
    'fabric.elements.share.copylink.button.icon.label': "\u201EAfrita tengil\u201C-t\xe1kn",
    'fabric.elements.share.copylink.button.text': 'Afrita tengil',
    'fabric.elements.share.copied.to.clipboard.icon.label': "T\xe1kn sem s\xfdnir a\xf0 tengilinn hafi veri\xf0 afrita\xf0ur me\xf0 g\xf3\xf0um \xe1rangri",
    'fabric.elements.share.copied.to.clipboard.message': "Tengill afrita\xf0ur \xe1 klippibor\xf0",
    'fabric.elements.share.form.capabilities.info.message': "Bo\xf0skorti\xf0 \xfeitt ver\xf0ur sent til stj\xf3rnanda til sam\xfeykkis",
    'fabric.elements.share.failure.icon.label': "Villut\xe1kn",
    'fabric.elements.share.failure.message': "Ekki er h\xe6gt a\xf0 deila",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blog post shared} tafla {Board shared} dagatal {Calendar shared} uppkast {Draft shared} s\xeda {Filter shared} m\xe1lefni {Issue shared} mi\xf0ill {Media shared} s\xed\xf0a {Page shared} verkefni {Project shared} togbei\xf0ni {Pull Request shared} spurning {Question shared} sk\xfdrsla {Report shared} Gagnageymsla {Repository shared} bei\xf0ni {Request shared} vegv\xedsir {Roadmap shared} s\xed\xf0a {Site shared} sv\xe6\xf0i {Space shared} anna\xf0 {Link Shared}}",
    'fabric.elements.share.admin.notified.message': "Stj\xf3rnanda hefur veri\xf0 tilkynnt"
};

});

parcelRegister("dsr2c", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6af9054e1a1047a$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ // Romanian
var $e6af9054e1a1047a$export$2e2bcd8739ae039 = {
    'fabric.elements.share.form.title': "Partaja\u021Bi",
    'fabric.elements.share.form.send': "Trimite\u021Bi",
    'fabric.elements.share.form.retry': "Re\xeencerca\u021Bi",
    'fabric.elements.share.form.comment.placeholder': "Ad\u0103uga\u021Bi un mesaj",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Introduce\u021Bi nume, echip\u0103 sau e-mail",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Introduce\u021Bi nume sau echip\u0103",
    'fabric.elements.share.form.user-picker.add-more': "Introduce\u021Bi mai multe",
    'fabric.elements.share.form.user-picker.validation.required': "Selecta\u021Bi cel pu\u021Bin un utilizator, echip\u0103 sau e-mail.",
    'fabric.elements.share.form.user-picker.no-options.domainBasedUserOnly': "Pute\u021Bi invita persoane nu mai cu adrese de e-mail {domains}. Contacta\u021Bi administratorul site-ului pentru a invita alte persoane.",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nu am g\u0103sit niciun rezultat pentru \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': 'Nu am g\u0103sit niciun rezultat pentru "{inputValue}". Invit\u0103 persoane utiliz\xe2nd o adres\u0103 de e-mail.',
    'fabric.elements.share.trigger.button.icon.label': "Pictogram\u0103 partajare",
    'fabric.elements.share.trigger.button.text': "Partaja\u021Bi",
    'fabric.elements.share.trigger.button.tooltip.text': "Partaja\u021Bi",
    'fabric.elements.share.trigger.button.invite.text': "Invita\u021Bi",
    'fabric.elements.share.copylink.button.icon.label': "Pictogram\u0103 copiere link",
    'fabric.elements.share.copylink.button.text': "Copia\u021Bi link",
    'fabric.elements.share.copied.to.clipboard.icon.label': "Pictogram\u0103 copiere linkuri cu succes",
    'fabric.elements.share.copied.to.clipboard.message': "Link copiat \xeen clipboard",
    'fabric.elements.share.form.capabilities.info.message': "Invita\u021Bia dvs. va fi transmis\u0103 unui administrator pentru aprobare",
    'fabric.elements.share.failure.icon.label': "Pictogram\u0103 eroare",
    'fabric.elements.share.failure.message': 'Nu se poate partaja',
    'fabric.elements.share.success.message': "{object, select, blogpost {Blog post shared} panou {Board shared} calendar {Calendar shared} schi\u021B\u0103{Draft shared} filtru {Filter shared} problem\u0103 {Issue shared} media {Media shared} pagin\u0103 {Page shared} proiect {Project shared} pullrequest {Pull Request shared} \xeentrebare {Question shared} raport {Report shared} depozit {Repository shared} solicitare {Request shared} planificare {Roadmap shared} site {Site shared} spa\u021Biu {Space shared} altele {Link Shared}}",
    'fabric.elements.share.admin.notified.message': 'Administratorul dvs. a fost notificat'
};

});




parcelRegister("4D4HV", function(module, exports) {

$parcel$export(module.exports, "ShareDialogWithTrigger", () => $b3159d24f4d50cc6$export$c7f8df1e37e7f581);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $f3klQ = parcelRequire("f3klQ");

var $7eL0y = parcelRequire("7eL0y");

var $gYrJM = parcelRequire("gYrJM");

var $eruWR = parcelRequire("eruWR");

var $dMihw = parcelRequire("dMihw");

var $6ZA7b = parcelRequire("6ZA7b");

var $jl1we = parcelRequire("jl1we");

var $7WN8P = parcelRequire("7WN8P");
parcelRequire("bVzYo");

var $bLAWR = parcelRequire("bLAWR");

var $encBb = parcelRequire("encBb");

var $1FYo4 = parcelRequire("1FYo4");

var $hwDUM = parcelRequire("hwDUM");

var $2lw4E = parcelRequire("2lw4E");

var $jIrpW = parcelRequire("jIrpW");

var $1Vq8e = parcelRequire("1Vq8e");
function $b3159d24f4d50cc6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b3159d24f4d50cc6$var$shareButtonWrapperStyles = {
    name: "8s6ifx",
    styles: "display:inline-flex;outline:none"
};
const $b3159d24f4d50cc6$export$4d9147e1bc6c176 = {
    users: [],
    comment: {
        format: 'plain_text',
        value: ''
    }
};
const $b3159d24f4d50cc6$export$55abe7932f6ca981 = ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7eL0y))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    });
class $b3159d24f4d50cc6$export$bc20a02e9bc30e54 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.defaultProps = {
            isDisabled: false,
            dialogPlacement: 'bottom-end',
            shouldCloseOnEscapePress: true,
            triggerButtonAppearance: 'subtle',
            triggerButtonStyle: 'icon-only',
            triggerButtonTooltipPosition: 'top',
            dialogZIndex: (0, $6ZA7b.layers).modal()
        };
    }
    componentDidMount() {
        if (this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentDidUpdate(prevProps) {
        if (this.props.isAutoOpenDialog !== prevProps.isAutoOpenDialog && this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentWillUnmount() {
        if (this.props.isAutoOpenDialog && this.props.onDialogClose) this.props.onDialogClose();
    }
    async generateShareError(err) {
        const errorBody = err.body ? await err.body : {};
        // We'll only try and deal with the first error, sorry
        const firstErrorFromBody = errorBody.messagesDetails?.[0];
        return {
            message: firstErrorFromBody?.message || err.message,
            errorCode: firstErrorFromBody?.errorCode,
            helpUrl: firstErrorFromBody?.helpUrl,
            retryable: firstErrorFromBody?.errorCode === undefined
        };
    }
    render() {
        const { isDialogOpen: isDialogOpen, isSharing: isSharing, shareError: shareError, defaultValue: defaultValue, showIntegrationForm: showIntegrationForm, selectedIntegration: selectedIntegration, isMenuItemSelected: isMenuItemSelected } = this.state;
        const { copyLink: copyLink, dialogPlacement: dialogPlacement, config: config, isFetchingConfig: isFetchingConfig, loadUserOptions: loadUserOptions, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, bottomMessage: bottomMessage, submitButtonLabel: submitButtonLabel, product: product, productAttributes: productAttributes, customFooter: customFooter, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, cloudId: cloudId, orgId: orgId, shareFieldsFooter: shareFieldsFooter, dialogZIndex: dialogZIndex, isPublicLink: isPublicLink, tabIndex: tabIndex, copyTooltipText: copyTooltipText, integrationMode: integrationMode, shareIntegrations: shareIntegrations, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions } = this.props;
        const style = typeof tabIndex !== 'undefined' && tabIndex >= 0 ? {
            outline: 'none'
        } : undefined;
        const footer = (0, $1Vq8e.resolveShareFooter)(integrationMode, this.state.tabIndex, customFooter);
        // for performance purposes, we may want to have a loadable content i.e. ShareForm
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $b3159d24f4d50cc6$var$shareButtonWrapperStyles,
            tabIndex: tabIndex,
            onKeyDown: this.handleKeyDown,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $eruWR.default), {
            content: ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
                    ref: this.containerRef
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hwDUM.default), {
                    Content: selectedIntegration && selectedIntegration.Content,
                    selectedIntegration: selectedIntegration,
                    copyLink: copyLink,
                    showIntegrationForm: showIntegrationForm,
                    bottomMessage: bottomMessage,
                    customFooter: footer,
                    loadOptions: loadUserOptions,
                    isSharing: isSharing,
                    shareFormTitle: shareFormTitle,
                    showTitle: integrationMode !== 'tabs' || !shareIntegrations || !shareIntegrations.length,
                    shareFormHelperMessage: shareFormHelperMessage,
                    shareError: shareError,
                    defaultValue: defaultValue,
                    config: config,
                    isFetchingConfig: isFetchingConfig,
                    setIsLoading: this.setIsLoading,
                    submitButtonLabel: submitButtonLabel,
                    product: product,
                    productAttributes: productAttributes,
                    enableSmartUserPicker: enableSmartUserPicker,
                    loggedInAccountId: loggedInAccountId,
                    cloudId: cloudId,
                    orgId: orgId,
                    onUserSelectionChange: this.handleOnUserSelectionChange,
                    shareFieldsFooter: shareFieldsFooter,
                    isPublicLink: isPublicLink,
                    copyTooltipText: copyTooltipText,
                    integrationMode: integrationMode,
                    shareIntegrations: shareIntegrations,
                    isMenuItemSelected: isMenuItemSelected,
                    // actions
                    onLinkCopy: this.handleCopyLink,
                    onSubmit: this.handleShareSubmit,
                    onDismiss: this.handleFormDismiss,
                    onDialogClose: this.handleCloseDialog,
                    onTabChange: this.onTabChange,
                    onMenuItemChange: this.onMenuItemChange,
                    //ref
                    selectPortalRef: this.selectPortalRef,
                    isBrowseUsersDisabled: isBrowseUsersDisabled,
                    userPickerOptions: userPickerOptions
                })),
            isOpen: isDialogOpen,
            onClose: this.handleCloseDialog,
            placement: dialogPlacement,
            trigger: this.renderShareTriggerButton,
            zIndex: dialogZIndex,
            label: this.props.intl.formatMessage((0, $7WN8P.messages).sharePopupLabel),
            role: "dialog",
            // TODO: remove after https://hello.atlassian.net/wiki/x/SoEGzQ experiment is finished
            offset: this.calculatePopupOffset({
                isMenuItemSelected: isMenuItemSelected,
                dialogPlacement: dialogPlacement
            }),
            shouldRenderToParent: (0, $gYrJM.fg)('platform.enable-appropriate-reading-order-in-share-dialog_fu49') ? true : false
        }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $dMihw.default), {
            zIndex: (0, $1Vq8e.generateSelectZIndex)(dialogZIndex)
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ref: this.selectPortalRef
        })));
    }
    constructor(...args){
        super(...args);
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        /**
   * Because the PopUp component has a higher zIndex it causes
   * the select to be rendered within it, and add scrollbars.
   * We will render the select options the PopUp outside,
   */ this.selectPortalRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.start = 0;
        this.state = {
            isDialogOpen: false,
            isSharing: false,
            ignoreIntermediateState: false,
            defaultValue: $b3159d24f4d50cc6$export$4d9147e1bc6c176,
            isUsingSplitButton: false,
            showIntegrationForm: false,
            selectedIntegration: null,
            tabIndex: 0,
            isMenuItemSelected: false,
            isLoading: false
        };
        this.closeAndResetDialog = ()=>{
            this.setState({
                defaultValue: $b3159d24f4d50cc6$export$4d9147e1bc6c176,
                ignoreIntermediateState: true,
                shareError: undefined,
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                isMenuItemSelected: false
            });
            const { onUserSelectionChange: onUserSelectionChange, onDialogClose: onDialogClose } = this.props;
            if (onUserSelectionChange) onUserSelectionChange($b3159d24f4d50cc6$export$4d9147e1bc6c176.users);
            if (onDialogClose) onDialogClose();
        };
        this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent, analyticsDecorator: analyticsDecorator } = this.props;
            if (analyticsDecorator) payload = analyticsDecorator(payload);
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $bLAWR.CHANNEL_ID));
        };
        this.onTabChange = (index)=>{
            let subjectId = 'shareTab';
            const { shareContentType: shareContentType } = this.props;
            if (index === 1) subjectId = 'shareToSlackTab';
            this.createAndFireEvent((0, $bLAWR.shareTabClicked)(subjectId, shareContentType));
            this.setState({
                tabIndex: index
            });
        };
        this.onMenuItemChange = (menuType)=>{
            let subjectId = menuType === 'Slack' ? 'shareToSlackMenuItem' : 'shareMenuItem';
            const { shareContentType: shareContentType } = this.props;
            this.createAndFireEvent((0, $bLAWR.shareMenuItemClicked)(subjectId, shareContentType));
            this.setState({
                isMenuItemSelected: true
            });
        };
        this.getFlags = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            // The reason for providing message property is that in jira,
            // the Flag system takes only Message Descriptor as payload
            // and formatMessage is called for every flag
            // if the translation data is not provided, a translated default message
            // will be displayed
            return [
                {
                    appearance: 'success',
                    title: {
                        ...(0, $7WN8P.messages).shareSuccessMessage,
                        defaultMessage: formatMessage((0, $7WN8P.messages).shareSuccessMessage, {
                            object: this.props.shareContentType.toLowerCase()
                        })
                    },
                    type: (0, $186a951487e0aa5a$export$9540ac9c843b8743)
                }
            ];
        };
        this.setIsLoading = (isLoading)=>{
            this.setState({
                isLoading: isLoading
            });
        };
        this.focus = ()=>{
            if (this.containerRef.current) this.containerRef.current.focus();
        };
        this.handleKeyDown = (event)=>{
            const { isLoading: isLoading, isDialogOpen: isDialogOpen } = this.state;
            const { shouldCloseOnEscapePress: shouldCloseOnEscapePress } = this.props;
            if (isLoading) {
                event.stopPropagation();
                this.focus();
            }
            if (isDialogOpen) switch(event.key){
                case 'Esc':
                case 'Escape':
                    // The @atlaskit/popup will capture the event and auto-close, we
                    // need to prevent that if the dialog is set to not close on `ESC`
                    if (!shouldCloseOnEscapePress) {
                        event.preventDefault();
                        event.stopPropagation();
                        // put the focus back onto the share dialog so that
                        // the user can press the escape key again to close the dialog
                        this.focus();
                        return;
                    }
                    // The dialog will auto-close in @atlaskit/popup, we just need to fire
                    // the right events.
                    if (shouldCloseOnEscapePress) {
                        // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
                        // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
                        // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
                        (0, $1FYo4.renderShareDialogExp).abort();
                        this.createAndFireEvent((0, $bLAWR.cancelShare)(this.start));
                        this.closeAndResetDialog();
                    }
            }
        };
        this.handleDialogOpen = ()=>{
            this.setState((state)=>({
                    isDialogOpen: !state.isDialogOpen,
                    ignoreIntermediateState: false,
                    showIntegrationForm: false,
                    selectedIntegration: null
                }), ()=>{
                const { onDialogOpen: onDialogOpen, isPublicLink: isPublicLink } = this.props;
                const { isDialogOpen: isDialogOpen } = this.state;
                if (isDialogOpen) {
                    this.start = Date.now();
                    this.createAndFireEvent((0, $bLAWR.screenEvent)({
                        isPublicLink: isPublicLink
                    }));
                    if (onDialogOpen) onDialogOpen();
                    this.focus();
                } else this.handleCloseDialog();
            });
        };
        this.onTriggerClick = ()=>{
            const { onTriggerButtonClick: onTriggerButtonClick } = this.props;
            this.createAndFireEvent((0, $bLAWR.shareTriggerButtonClicked)());
            this.handleDialogOpen();
            if (onTriggerButtonClick) onTriggerButtonClick();
        };
        this.handleCloseDialog = ()=>{
            if (this.props.onDialogClose) this.props.onDialogClose();
            // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
            // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
            // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
            (0, $1FYo4.renderShareDialogExp).abort();
            this.setState({
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                tabIndex: 0,
                isMenuItemSelected: false
            });
        };
        this.handleShareSubmit = (data)=>{
            const { onShareSubmit: onShareSubmit, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, formShareOrigin: formShareOrigin, showFlags: showFlags, isPublicLink: isPublicLink } = this.props;
            if (!onShareSubmit) return;
            (0, $1FYo4.shareSubmitExp).start();
            this.setState({
                isSharing: true
            });
            this.createAndFireEvent((0, $bLAWR.formShareSubmitted)({
                start: this.start,
                data: data,
                shareContentType: shareContentType,
                shareOrigin: formShareOrigin,
                isPublicLink: isPublicLink,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
            onShareSubmit(data).then(()=>{
                this.closeAndResetDialog();
                this.setState({
                    isSharing: false
                });
                showFlags(this.getFlags());
                (0, $1FYo4.shareSubmitExp).success();
            }).catch(async (err)=>{
                const shareError = await this.generateShareError(err).catch((errorGenFailed)=>({
                        message: err.message || errorGenFailed.message || 'Unknown error',
                        retryable: true
                    }));
                this.setState({
                    isSharing: false,
                    shareError: shareError
                });
                (0, $encBb.isValidFailedExperience)((0, $1FYo4.shareSubmitExp), err);
            });
        };
        this.handleFormDismiss = (data)=>{
            this.setState(({ ignoreIntermediateState: ignoreIntermediateState })=>ignoreIntermediateState ? null : {
                    defaultValue: data
                });
        };
        this.calculatePopupOffset = ({ isMenuItemSelected: isMenuItemSelected, dialogPlacement: dialogPlacement })=>{
            if (isMenuItemSelected && dialogPlacement === 'bottom-end') return [
                -0.1,
                8
            ];
            return [
                0,
                8
            ];
        };
        this.handleCopyLink = ()=>{
            const { copyLinkOrigin: copyLinkOrigin, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, isPublicLink: isPublicLink, shareAri: shareAri } = this.props;
            this.createAndFireEvent((0, $bLAWR.copyLinkButtonClicked)({
                start: this.start,
                shareContentType: shareContentType,
                shareOrigin: copyLinkOrigin,
                isPublicLink: isPublicLink,
                ari: shareAri,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
        };
        this.handleIntegrationClick = (integration)=>{
            this.setState({
                isUsingSplitButton: false,
                isDialogOpen: true,
                showIntegrationForm: true,
                selectedIntegration: integration
            });
        };
        this.renderShareTriggerButton = (triggerProps)=>{
            const { isDialogOpen: isDialogOpen, isUsingSplitButton: isUsingSplitButton } = this.state;
            const { intl: { formatMessage: formatMessage }, isDisabled: isDisabled, renderCustomTriggerButton: renderCustomTriggerButton, triggerButtonIcon: triggerButtonIcon, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, triggerButtonAppearance: triggerButtonAppearance, triggerButtonStyle: triggerButtonStyle, integrationMode: integrationMode, shareIntegrations: shareIntegrations, dialogZIndex: dialogZIndex, dialogPlacement: dialogPlacement } = this.props;
            let button;
            const ShareButtonIcon = triggerButtonIcon || $b3159d24f4d50cc6$export$55abe7932f6ca981;
            // Render a custom or standard button.
            if (renderCustomTriggerButton) {
                const { shareError: shareError } = this.state;
                button = renderCustomTriggerButton({
                    error: shareError,
                    isDisabled: isDisabled,
                    isSelected: isDialogOpen,
                    onClick: this.onTriggerClick
                }, triggerProps);
            } else button = /*#__PURE__*/ (0, $byn9U.jsx)((0, $2lw4E.default), {
                appearance: triggerButtonAppearance,
                text: triggerButtonStyle !== 'icon-only' ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $7WN8P.messages).shareTriggerButtonText) : null,
                "aria-label": formatMessage((0, $7WN8P.messages).shareTriggerButtonText),
                onClick: this.onTriggerClick,
                iconBefore: triggerButtonStyle !== 'text-only' ? /*#__PURE__*/ (0, $byn9U.jsx)(ShareButtonIcon, {
                    label: ""
                }) : undefined,
                isSelected: isDialogOpen,
                isDisabled: isDisabled,
                ref: triggerProps.ref,
                // When we autoFocus the dialog, we want to autofocus the trigger as well, that way when the dialog is closed, the trigger is focused
                autoFocus: this.props.isAutoOpenDialog
            });
            // If the button only shows the icon, wrap it in a tooltip containing the button text.
            if (triggerButtonStyle === 'icon-only') button = /*#__PURE__*/ (0, $byn9U.jsx)((0, $jl1we.default), {
                content: !isUsingSplitButton ? triggerButtonTooltipText || formatMessage((0, $7WN8P.messages).shareTriggerButtonTooltipText) : null,
                position: triggerButtonTooltipPosition,
                hideTooltipOnClick: true
            }, button);
            // If there are any integrations, wrap the share button in a split button with integrations.
            if (integrationMode === 'split' && shareIntegrations?.length) button = /*#__PURE__*/ (0, $byn9U.jsx)((0, $jIrpW.default), {
                shareButton: button,
                handleOpenSplitButton: this.handleOpenSplitButton,
                handleCloseSplitButton: this.handleCloseSplitButton,
                isUsingSplitButton: isUsingSplitButton,
                triggerButtonAppearance: triggerButtonAppearance,
                dialogZIndex: dialogZIndex,
                dialogPlacement: dialogPlacement,
                shareIntegrations: shareIntegrations,
                onIntegrationClick: this.handleIntegrationClick,
                createAndFireEvent: this.createAndFireEvent
            });
            return button;
        };
        this.handleOpenSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: true
            }, ()=>this.handleCloseDialog());
            this.createAndFireEvent((0, $bLAWR.shareSplitButtonEvent)());
        };
        this.handleCloseSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: false
            });
        };
        this.handleOnUserSelectionChange = (value)=>{
            const { onUserSelectionChange: onUserSelectionChange } = this.props;
            this.setState({
                shareError: undefined
            });
            onUserSelectionChange?.(value);
        };
    }
}
const $b3159d24f4d50cc6$export$c7f8df1e37e7f581 = (0, $f3klQ.default)()((0, $2qhQi.default)($b3159d24f4d50cc6$export$bc20a02e9bc30e54));

});
parcelRegister("7eL0y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::238da1d3f1c6691c40bb15e631a6cdbf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $544e4dfdb0fef20e$var$_react = $544e4dfdb0fef20e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $544e4dfdb0fef20e$var$_share = $544e4dfdb0fef20e$var$_interopRequireDefault((parcelRequire("ffimc")));

var $544e4dfdb0fef20e$var$_share2 = $544e4dfdb0fef20e$var$_interopRequireDefault((parcelRequire("aIRhA")));
function $544e4dfdb0fef20e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShareIcon.
 * This component is ShareIcon, with `UNSAFE_fallbackIcon` set to "ShareIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $544e4dfdb0fef20e$var$ShareIcon = (props)=>/*#__PURE__*/ $544e4dfdb0fef20e$var$_react.default.createElement($544e4dfdb0fef20e$var$_share.default, Object.assign({
        LEGACY_fallbackIcon: $544e4dfdb0fef20e$var$_share2.default
    }, props));
$544e4dfdb0fef20e$var$ShareIcon.Name = 'ShareIconMigration';
var $544e4dfdb0fef20e$var$_default = module.exports.default = $544e4dfdb0fef20e$var$ShareIcon;

});

parcelRegister("bVzYo", function(module, exports) {

$parcel$export(module.exports, "OBJECT_SHARED", () => $186a951487e0aa5a$export$9540ac9c843b8743);
$parcel$export(module.exports, "TabType", () => (parcelRequire("lHmPr")).TabType);


var $lHmPr = parcelRequire("lHmPr");

});
const $186a951487e0aa5a$export$9540ac9c843b8743 = 'object-shared';
const $186a951487e0aa5a$export$57af6ad1a12df839 = 'admin-notified';

parcelRegister("lHmPr", function(module, exports) {

$parcel$export(module.exports, "TabType", () => $4bb0cc5c8b113cc6$export$ea1f8d830f8d55e1);
var $4bb0cc5c8b113cc6$export$ea1f8d830f8d55e1;
(function(TabType) {
    TabType[TabType["default"] = 0] = "default";
    TabType[TabType["Slack"] = 1] = "Slack";
})($4bb0cc5c8b113cc6$export$ea1f8d830f8d55e1 || ($4bb0cc5c8b113cc6$export$ea1f8d830f8d55e1 = {}));

});


parcelRegister("hwDUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $de4eacd5d0a2b476$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $dyfd9 = parcelRequire("dyfd9");
var $lUjxN = parcelRequire("lUjxN");

var $bBdMg = parcelRequire("bBdMg");
parcelRequire("j3Ry8");
var $k3sKh = parcelRequire("k3sKh");
function $de4eacd5d0a2b476$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $de4eacd5d0a2b476$var$spinnerWrapperStyles = {
    name: "1frfa00",
    styles: "width:100%;height:100%;display:flex;justify-content:center;align-content:center"
};

const $de4eacd5d0a2b476$var$LazyShareFormLazy = (0, $dyfd9.lazyForPaint)(()=>(parcelRequire("bXdNE")), {
    ssr: false,
    moduleId: "../platform/packages/elements/share/src/components/LazyShareForm/LazyShareForm.tsx"
});
const $de4eacd5d0a2b476$var$LoadingDialog = ({ shareFormTitle: shareFormTitle, showTitle: showTitle, setIsLoading: setIsLoading, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        setIsLoading(true);
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $k3sKh.default), {
        shareFormTitle: shareFormTitle,
        integrationMode: integrationMode,
        isMenuItemSelected: isMenuItemSelected,
        // if `showTitle` is passed, we use it. Otherwise, we will show title for loading dialog.
        shouldShowTitle: typeof showTitle === 'boolean' ? showTitle : true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $de4eacd5d0a2b476$var$spinnerWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bBdMg.default), null)));
};
var $de4eacd5d0a2b476$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lUjxN.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $byn9U.jsx)($de4eacd5d0a2b476$var$LoadingDialog, {
            shareFormTitle: props.shareFormTitle,
            showTitle: props.showTitle,
            setIsLoading: props.setIsLoading,
            integrationMode: props.integrationMode,
            isMenuItemSelected: props.isMenuItemSelected
        })
    }, /*#__PURE__*/ (0, $byn9U.jsx)($de4eacd5d0a2b476$var$LazyShareFormLazy, props));

});
parcelRegister("j3Ry8", function(module, exports) {

$parcel$export(module.exports, "ShareFormWrapper", () => (parcelRequire("k3sKh")).default);

var $k3sKh = parcelRequire("k3sKh");

});
parcelRegister("k3sKh", function(module, exports) {

$parcel$export(module.exports, "default", () => $804d04a566bde0f4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7WN8P = parcelRequire("7WN8P");

var $7GR3H = parcelRequire("7GR3H");

var $2LGV3 = parcelRequire("2LGV3");
const $804d04a566bde0f4$var$ShareFormWrapper = ({ shareFormTitle: shareFormTitle, shouldShowTitle: shouldShowTitle, children: children = null, footer: footer = null, integrationMode: integrationMode = 'off', isMenuItemSelected: isMenuItemSelected = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2LGV3.InlineDialogContentWrapper), {
        label: formatMessage((0, $7WN8P.messages).formTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2LGV3.InlineDialogFormWrapper), {
        integrationMode: integrationMode,
        isMenuItemSelected: isMenuItemSelected
    }, shouldShowTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GR3H.ShareHeader), {
        title: shareFormTitle
    }), children), footer);
};
var $804d04a566bde0f4$export$2e2bcd8739ae039 = $804d04a566bde0f4$var$ShareFormWrapper;

});
parcelRegister("7GR3H", function(module, exports) {

$parcel$export(module.exports, "ShareHeader", () => $6d38a2247b02cf20$export$77192fbb468e5af8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
var $4WmDP = parcelRequire("4WmDP");

var $8uD7Y = parcelRequire("8uD7Y");

var $2mu6T = parcelRequire("2mu6T");

var $7WN8P = parcelRequire("7WN8P");
function $6d38a2247b02cf20$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6d38a2247b02cf20$var$headerWrapperStyles = {
    name: "1eoy87d",
    styles: "display:flex;justify-content:space-between"
};
const $6d38a2247b02cf20$export$fd8f58944443c645 = (theme)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)((0, $2mu6T.h500)(theme), "line-height:var(--ds-space-400, 32px);margin-right:var(--ds-space-400, 32px);margin-top:var(--ds-space-400, 32px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;> span{font-size:initial;}");
const $6d38a2247b02cf20$export$77192fbb468e5af8 = ({ title: title })=>{
    const theme = (0, $4WmDP.u)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $6d38a2247b02cf20$var$headerWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: $6d38a2247b02cf20$export$fd8f58944443c645(theme)
    }, title || /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $7WN8P.messages).formTitle)));
};

});

parcelRegister("2LGV3", function(module, exports) {

$parcel$export(module.exports, "InlineDialogFormWrapper", () => $665799c2519cf81a$export$54db87debcabf37b);
$parcel$export(module.exports, "InlineDialogContentWrapper", () => $665799c2519cf81a$export$a05835e82fd98f96);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $fHTQU = parcelRequire("fHTQU");
/**
 * Set fixed width considering full form width and full menu width in order
 * to prevent dialog form from bouncing when isLoading prop is set to true.
 * Since loading container has 100% width, it adjusts accordingly.
 */ const $665799c2519cf81a$var$calculateFormWrapperWidth = ({ integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected })=>{
    const formWidth = `${352}px`;
    if (!isMenuItemSelected && integrationMode === 'menu') return 0, $fHTQU.menuWrapperWidth;
    return formWidth;
};
const $665799c2519cf81a$export$54db87debcabf37b = ({ children: children, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected })=>{
    const styles = {
        width: $665799c2519cf81a$var$calculateFormWrapperWidth({
            integrationMode: integrationMode,
            isMenuItemSelected: isMenuItemSelected
        })
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: styles
    }, children);
};
const $665799c2519cf81a$var$inlineDialogContentWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`
});
const $665799c2519cf81a$export$a05835e82fd98f96 = ({ children: children, label: label })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $665799c2519cf81a$var$inlineDialogContentWrapperStyles,
        "aria-label": label
    }, children);
};

});
parcelRegister("fHTQU", function(module, exports) {

$parcel$export(module.exports, "ShareMenuItem", () => $78b9d352b764c8db$export$144cc6e5e0841ff9);
$parcel$export(module.exports, "menuWrapperWidth", () => $78b9d352b764c8db$export$1cd8104f92c0e299);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $azeZS = parcelRequire("azeZS");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");
const $78b9d352b764c8db$var$iconContainerStyles = (0, $8Vv3m.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'size.200',
    width: 'size.200',
    borderRadius: 'border.radius'
});
const $78b9d352b764c8db$export$144cc6e5e0841ff9 = ({ iconName: iconName, labelId: labelId, onClickHandler: onClickHandler })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azeZS.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($78b9d352b764c8db$export$8f314e512d92575f, {
            icon: iconName
        }),
        onClick: onClickHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), labelId));
const $78b9d352b764c8db$export$8f314e512d92575f = ({ icon: icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $78b9d352b764c8db$var$iconContainerStyles
    }, icon);
const $78b9d352b764c8db$export$1cd8104f92c0e299 = '102px';

});




parcelRegister("bXdNE", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8FgQT")
]).then(()=>parcelRequire('2mQZO'));

});


parcelRegister("2lw4E", function(module, exports) {

$parcel$export(module.exports, "default", () => $925589d666542f5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");
const $925589d666542f5c$export$e980dfbc2840e8bc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(// Discard aria-haspopup
function ShareButton({ text: text, 'aria-haspopup': _ariaHasPopup, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        ref: ref,
        "aria-haspopup": "dialog",
        ...props
    }, text);
});
$925589d666542f5c$export$e980dfbc2840e8bc.displayName = 'ShareButton';
var $925589d666542f5c$export$2e2bcd8739ae039 = $925589d666542f5c$export$e980dfbc2840e8bc;

});

parcelRegister("jIrpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $499d530102d5184c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");

var $kRXDJ = parcelRequire("kRXDJ");
var $8pjfq = parcelRequire("8pjfq");

var $f5xzw = parcelRequire("f5xzw");
var $5E6sS = parcelRequire("5E6sS");
var $e0IEe = parcelRequire("e0IEe");

var $5IJsn = parcelRequire("5IJsn");


var $7WN8P = parcelRequire("7WN8P");

var $bLAWR = parcelRequire("bLAWR");

var $aApR1 = parcelRequire("aApR1");
// span
const $499d530102d5184c$var$dropDownIntegrationButtonWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    ['button:hover']: {
        background: 'transparent'
    }
});
const $499d530102d5184c$var$integrationButtonText = (integrationName)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
        ...(0, $7WN8P.messages).shareToIntegrationButtonText,
        values: {
            integrationName: integrationName
        }
    });
const $499d530102d5184c$var$SplitButtonDropdown = (props)=>{
    const { triggerButtonAppearance: triggerButtonAppearance, isUsingSplitButton: isUsingSplitButton, handleOpenSplitButton: handleOpenSplitButton, handleCloseSplitButton: handleCloseSplitButton, shareIntegrations: shareIntegrations, onIntegrationClick: onIntegrationClick, createAndFireEvent: createAndFireEvent } = props;
    const onOpenChange = (0, $eUqFw.useCallback)(({ isOpen: isOpen })=>{
        if (isOpen) handleOpenSplitButton();
        else handleCloseSplitButton();
    }, [
        handleOpenSplitButton,
        handleCloseSplitButton
    ]);
    const onIntegrationButtonClick = (0, $eUqFw.useCallback)((integration)=>{
        onIntegrationClick(integration);
        createAndFireEvent((0, $bLAWR.shareIntegrationButtonEvent)(integration.type));
    }, [
        createAndFireEvent,
        onIntegrationClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $f5xzw.default), {
        testId: "split-button-dropdown",
        trigger: ({ triggerRef: triggerRef, ...providedProps })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $kRXDJ.default), {
                label: "",
                ...providedProps,
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($5IJsn))),
                appearance: triggerButtonAppearance
            }),
        placement: "bottom-end",
        isOpen: isUsingSplitButton,
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $e0IEe.default), null, shareIntegrations.map((integration)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5E6sS.default), {
            key: integration.type,
            testId: `split-button-dropdownitem-${integration.type}`
        }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: $499d530102d5184c$var$dropDownIntegrationButtonWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $aApR1.default), {
            textColor: `var(--ds-text, ${(0, $1b343b038f6c23ec$export$7d61b15e0da132af)})`,
            appearance: "subtle",
            onClick: ()=>onIntegrationButtonClick(integration),
            shouldFitContainer: true,
            text: $499d530102d5184c$var$integrationButtonText(integration.type),
            IntegrationIcon: integration.Icon
        }))))));
};
$499d530102d5184c$var$SplitButtonDropdown.displayName = 'SplitButtonDropdown';
function $499d530102d5184c$export$2e2bcd8739ae039({ shareButton: shareButton, handleOpenSplitButton: handleOpenSplitButton, handleCloseSplitButton: handleCloseSplitButton, isUsingSplitButton: isUsingSplitButton, shareIntegrations: shareIntegrations, onIntegrationClick: onIntegrationClick, triggerButtonAppearance: triggerButtonAppearance, createAndFireEvent: createAndFireEvent }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8pjfq.SplitButton), {
        "data-testid": "split-button",
        appearance: triggerButtonAppearance
    }, shareButton, /*#__PURE__*/ (0, $byn9U.jsx)($499d530102d5184c$var$SplitButtonDropdown, {
        shareIntegrations: shareIntegrations,
        triggerButtonAppearance: triggerButtonAppearance,
        isUsingSplitButton: isUsingSplitButton,
        handleOpenSplitButton: handleOpenSplitButton,
        handleCloseSplitButton: handleCloseSplitButton,
        onIntegrationClick: onIntegrationClick,
        createAndFireEvent: createAndFireEvent
    }));
}

});
parcelRegister("8pjfq", function(module, exports) {

$parcel$export(module.exports, "SplitButton", () => $e695a0400f3720db$export$651ad66661acd392);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $gYrJM = parcelRequire("gYrJM");

var $7WqI7 = parcelRequire("7WqI7");

var $koGkE = parcelRequire("koGkE");
function $e695a0400f3720db$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e695a0400f3720db$var$heights = {
    default: `${32 / 14}em`,
    compact: `${24 / 14}em`
};
const $e695a0400f3720db$var$baseDividerStyles = {
    name: "qgg6i6",
    styles: "width:var(--ds-border-width, 1px);position:relative;z-index:1"
};
const $e695a0400f3720db$var$defaultDividerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: $e695a0400f3720db$var$heights.default
});
const $e695a0400f3720db$var$compactDividerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: $e695a0400f3720db$var$heights.compact
});
const $e695a0400f3720db$var$dividerDisabledStyles = {
    name: "1e7ljet",
    styles: "background-color:var(--ds-text-disabled, #091E4224);cursor:not-allowed;opacity:0.51"
};
const $e695a0400f3720db$var$dividerDisabledRefreshedStyles = {
    name: "d948c5",
    styles: "background-color:var(--ds-border-disabled, #091E4224);cursor:not-allowed"
};
const $e695a0400f3720db$var$dividerAppearance = {
    default: {
        name: "w0okts",
        styles: "background-color:var(--ds-text, #172B4D);opacity:0.51"
    },
    primary: {
        name: "7nfjo9",
        styles: "background-color:var(--ds-text-inverse, #FFF);opacity:0.64"
    },
    navigation: /*#__PURE__*/ (0, $byn9U.css)({
        height: '16px',
        margin: `${"var(--ds-space-100, 8px)"} -0.5px`,
        backgroundColor: "var(--ds-text-subtle, #0052cc)",
        opacity: 0.62
    })
};
const $e695a0400f3720db$var$dividerRefreshedOffsetStyles = /*#__PURE__*/ (0, $byn9U.css)({
    marginInline: `calc(0px - ${"var(--ds-border-width, 1px)"})`
});
const $e695a0400f3720db$var$dividerHeight = {
    default: $e695a0400f3720db$var$defaultDividerStyles,
    compact: $e695a0400f3720db$var$compactDividerStyles
};
const $e695a0400f3720db$export$2e0a83ec2e27ecbb = ({ appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    return(// I find it funny to provide a div for Divider
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $e695a0400f3720db$var$baseDividerStyles,
            $e695a0400f3720db$var$dividerHeight[spacing],
            isDisabled && ((0, $gYrJM.fg)('platform-component-visual-refresh') ? $e695a0400f3720db$var$dividerDisabledRefreshedStyles : $e695a0400f3720db$var$dividerDisabledStyles),
            !isDisabled && $e695a0400f3720db$var$dividerAppearance[appearance],
            (0, $gYrJM.fg)('platform-component-visual-refresh') && $e695a0400f3720db$var$dividerRefreshedOffsetStyles
        ]
    }));
};
const $e695a0400f3720db$var$splitButtonStyles = {
    name: "jzv9d3",
    styles: "display:inline-flex;position:relative;align-items:center;white-space:nowrap"
};
const $e695a0400f3720db$var$primaryButtonStyles = {
    name: "1s736x3",
    styles: "button,a{border-end-end-radius:0;border-start-end-radius:0;}"
};
const $e695a0400f3720db$var$secondaryButtonStyles = {
    name: "1uzrn2e",
    styles: "button,a{border-end-start-radius:0;border-start-start-radius:0;}"
};
const $e695a0400f3720db$var$defaultAppearanceContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderRadius: "var(--ds-border-radius, 3px)",
    outlineColor: "var(--ds-border, #091E4224)",
    outlineOffset: `calc(0px - ${"var(--ds-border-width, 1px)"})`,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width, 1px)"
});
const $e695a0400f3720db$export$994ba1b4c598f7 = ({ appearance: appearance, children: children, isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            appearance === 'default' && !isDisabled && (0, $gYrJM.fg)('platform-component-visual-refresh') && $e695a0400f3720db$var$defaultAppearanceContainerStyles,
            $e695a0400f3720db$var$splitButtonStyles
        ]
    }, children);
};
const $e695a0400f3720db$export$651ad66661acd392 = ({ children: children, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    const { PrimaryAction: PrimaryAction, SecondaryAction: SecondaryAction } = (0, $koGkE.getActions)(children);
    return /*#__PURE__*/ (0, $byn9U.jsx)($e695a0400f3720db$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7WqI7.SplitButtonContext).Provider, {
        value: {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e695a0400f3720db$var$primaryButtonStyles
    }, PrimaryAction), /*#__PURE__*/ (0, $byn9U.jsx)($e695a0400f3720db$export$2e0a83ec2e27ecbb, {
        appearance: appearance,
        spacing: spacing,
        isDisabled: isDisabled
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e695a0400f3720db$var$secondaryButtonStyles
    }, SecondaryAction)));
};
const $e695a0400f3720db$export$e3ca81100b492e15 = ({ primaryAction: primaryAction, secondaryAction: secondaryAction, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)($e695a0400f3720db$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7WqI7.SplitButtonContext).Provider, {
        value: {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e695a0400f3720db$var$primaryButtonStyles
    }, primaryAction), /*#__PURE__*/ (0, $byn9U.jsx)($e695a0400f3720db$export$2e0a83ec2e27ecbb, {
        appearance: appearance,
        spacing: spacing,
        isDisabled: isDisabled
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e695a0400f3720db$var$secondaryButtonStyles
    }, secondaryAction)));
};

});
parcelRegister("koGkE", function(module, exports) {

$parcel$export(module.exports, "getActions", () => $f0e2c3d717efe06b$export$fe3955935f564b31);

var $eUqFw = parcelRequire("eUqFw");

var $2fFJv = parcelRequire("2fFJv");
const $f0e2c3d717efe06b$export$fe3955935f564b31 = (children)=>{
    const [PrimaryAction, SecondaryAction] = (0, $eUqFw.Children).toArray(children);
    typeof $2fFJv;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});


parcelRegister("aApR1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d06264937e67b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $dU5mb = parcelRequire("dU5mb");

function $e7d06264937e67b7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $e7d06264937e67b7$var$integrationButtonCopyWrapperStyle = {
    name: "16rgrc1",
    styles: "display:flex;justify-content:left"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $e7d06264937e67b7$var$integrationIconWrapperStyle = {
    name: "mz1ewe",
    styles: "margin:var(--ds-space-025, 2px) var(--ds-space-100, 8px) var(--ds-space-0, 0px) var(--ds-space-0, 0px)"
};
const $e7d06264937e67b7$var$IntegrationButton = (props)=>{
    const { text: text, textColor: textColor, IntegrationIcon: IntegrationIcon, ...restProps } = props;
    return(// TODO: (from codemod) CustomThemeButton will be deprecated. Please consider migrating to Pressable or Anchor Primitives with custom styles.
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $dU5mb.default), restProps, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $e7d06264937e67b7$var$integrationButtonCopyWrapperStyle,
        style: {
            color: textColor || `var(--ds-text, ${0, $1b343b038f6c23ec$export$c39c0fe0f26207ae})`
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $e7d06264937e67b7$var$integrationIconWrapperStyle
    }, /*#__PURE__*/ (0, $byn9U.jsx)(IntegrationIcon, null)), /*#__PURE__*/ (0, $byn9U.jsx)("span", null, text))));
};
$e7d06264937e67b7$var$IntegrationButton.displayName = 'IntegrationButton';
var $e7d06264937e67b7$export$2e2bcd8739ae039 = $e7d06264937e67b7$var$IntegrationButton;

});


parcelRegister("1Vq8e", function(module, exports) {

$parcel$export(module.exports, "generateSelectZIndex", () => $74bbd83fcdf1c721$export$eedd642610b90f47);
$parcel$export(module.exports, "getMenuPortalTargetCurrentHTML", () => $74bbd83fcdf1c721$export$e3e96376b61c8ea);
$parcel$export(module.exports, "optionDataToUsers", () => $74bbd83fcdf1c721$export$1c6fd61621efa6e2);
$parcel$export(module.exports, "allowEmails", () => $74bbd83fcdf1c721$export$e3c57815dfd9a32c);
$parcel$export(module.exports, "resolveShareFooter", () => $74bbd83fcdf1c721$export$6900a66855146901);

var $6ZA7b = parcelRequire("6ZA7b");
const $74bbd83fcdf1c721$export$ff1a1e5addedc4cc = 10;
const $74bbd83fcdf1c721$export$eedd642610b90f47 = (dialogZIndex)=>{
    // If user provided non-number value for zIndex, ignore and return undefined,
    // which will default to `layers.layer()` inside PopUp
    if (typeof dialogZIndex !== 'number' || !dialogZIndex) return (0, $6ZA7b.layers).modal() + $74bbd83fcdf1c721$export$ff1a1e5addedc4cc;
    return dialogZIndex + $74bbd83fcdf1c721$export$ff1a1e5addedc4cc;
};
const $74bbd83fcdf1c721$export$e3e96376b61c8ea = (ref)=>{
    if (!ref) return null;
    if (!Object.prototype.hasOwnProperty.call(ref, 'current')) return null;
    // @ts-ignore ts(2339) - ref not having property current
    return ref.current;
};
const $74bbd83fcdf1c721$export$1c6fd61621efa6e2 = (optionDataArray)=>optionDataArray.map((optionData)=>{
        switch(optionData.type){
            case 'email':
                const user = {
                    type: 'user',
                    email: optionData.id
                };
                return user;
            case 'external_user':
                // When optionData.type is 'external_user', we need to convert it to 'user'
                // because 'external_user' isn't a valid type for the '/gateway/api/share' API.
                return {
                    type: 'user',
                    id: optionData.id
                };
            default:
                return {
                    type: optionData.type || 'user',
                    id: optionData.id
                };
        }
    });
const $74bbd83fcdf1c721$export$e3c57815dfd9a32c = (config)=>!(config && config.disableSharingToEmails);
const $74bbd83fcdf1c721$export$6900a66855146901 = (integrationMode, tabIndex, customFooter)=>{
    if (customFooter) {
        if (integrationMode !== 'tabs' || tabIndex === 0) return customFooter;
    }
};

});



parcelRegister("5ZKXn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1dc9c564cbcbab0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $9cvwi = parcelRequire("9cvwi");

var $os4bU = parcelRequire("os4bU");

var $gYrJM = parcelRequire("gYrJM");

var $eruWR = parcelRequire("eruWR");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");


var $6ZA7b = parcelRequire("6ZA7b");

var $jl1we = parcelRequire("jl1we");

var $2LGV3 = parcelRequire("2LGV3");

var $fmgJv = parcelRequire("fmgJv");
const $b1dc9c564cbcbab0$var$Z_INDEX = (0, $6ZA7b.layers).modal();
const $b1dc9c564cbcbab0$var$AUTO_DISMISS_SECONDS = 8;
const $b1dc9c564cbcbab0$export$232be6fd960213fd = $b1dc9c564cbcbab0$var$AUTO_DISMISS_SECONDS * 1000;
const $b1dc9c564cbcbab0$export$2cef156ed72138a3 = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    alignItems: 'center',
    margin: `${"var(--ds-space-negative-100, -8px)"}
    ${"var(--ds-space-negative-200, -16px)"}`
});
const $b1dc9c564cbcbab0$var$boxWrapperStyle = (0, $8Vv3m.xcss)({
    marginRight: 'space.025'
});
const $b1dc9c564cbcbab0$var$messageTextStyle = (0, $8Vv3m.xcss)({
    textIndent: 'space.075'
});
const $b1dc9c564cbcbab0$var$isSafari = typeof window !== 'undefined' && window.navigator.userAgent.indexOf('Safari');
const $b1dc9c564cbcbab0$export$7196851310a3d0bf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(// we need a hidden input to reliably copy to clipboard across all browsers.
(props, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            position: 'absolute',
            left: '-9999px'
        },
        tabIndex: -1,
        "aria-hidden": true,
        ref: ref,
        value: props.text,
        "aria-label": props.label,
        readOnly: true
    }));
class $b1dc9c564cbcbab0$export$534d10f1c5b9c7b3 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentWillUnmount() {
        this.clearAutoDismiss();
    }
    render() {
        const { shouldShowCopiedMessage: shouldShowCopiedMessage } = this.state;
        const { copyTooltipText: copyTooltipText, copiedToClipboardText: copiedToClipboardText } = this.props;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $b1dc9c564cbcbab0$var$isSafari && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            className: "assistive",
            "aria-live": "assertive"
        }, shouldShowCopiedMessage && copiedToClipboardText), /*#__PURE__*/ (0, $byn9U.jsx)($b1dc9c564cbcbab0$export$7196851310a3d0bf, {
            ref: this.inputRef,
            text: this.props.link,
            label: copiedToClipboardText
        }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eruWR.default), {
            zIndex: $b1dc9c564cbcbab0$var$Z_INDEX,
            autoFocus: false,
            content: ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $2LGV3.InlineDialogContentWrapper), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                    css: $b1dc9c564cbcbab0$export$2cef156ed72138a3,
                    "data-testid": "message-container",
                    "aria-hidden": true
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($os4bU))), {
                    spacing: "spacious",
                    label: "",
                    color: `var(--ds-icon-success, ${(0, $1b343b038f6c23ec$export$940e1f69e873f202)})`
                }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $80vF2.default), {
                    xcss: $b1dc9c564cbcbab0$var$messageTextStyle
                }, copiedToClipboardText)))),
            isOpen: shouldShowCopiedMessage,
            onClose: this.handleDismissCopiedMessage,
            placement: "top-start",
            trigger: (triggerProps)=>copyTooltipText ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $jl1we.default), {
                    content: copyTooltipText,
                    position: "bottom-start"
                }, this.renderTriggerButton(triggerProps)) : this.renderTriggerButton(triggerProps),
            shouldRenderToParent: (0, $gYrJM.fg)('platform.enable-appropriate-reading-order-in-share-dialog_fu49') ? true : false
        }));
    }
    constructor(...args){
        super(...args);
        this.inputRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.state = {
            shouldShowCopiedMessage: false
        };
        this.clearAutoDismiss = ()=>{
            if (this.autoDismiss) {
                clearTimeout(this.autoDismiss);
                this.autoDismiss = undefined;
            }
        };
        this.handleClick = ()=>{
            this.inputRef.current.select();
            document.execCommand('copy');
            if (this.props.onLinkCopy) this.props.onLinkCopy(this.props.link);
            this.setState({
                shouldShowCopiedMessage: true
            }, ()=>{
                this.clearAutoDismiss();
                this.autoDismiss = setTimeout(()=>{
                    this.setState({
                        shouldShowCopiedMessage: false
                    });
                }, $b1dc9c564cbcbab0$export$232be6fd960213fd);
            });
        };
        this.handleDismissCopiedMessage = ()=>{
            this.clearAutoDismiss();
            this.setState({
                shouldShowCopiedMessage: false
            });
        };
        this.renderTriggerButton = (triggerProps)=>{
            const { isDisabled: isDisabled, copyLinkButtonText: copyLinkButtonText, children: children, iconBefore: iconBefore } = this.props;
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $fmgJv.default), {
                "aria-label": copyLinkButtonText,
                isDisabled: isDisabled,
                // TODO: (from codemod)"link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
                // https://product-fabric.atlassian.net/browse/DSP-18980
                appearance: "subtle-link",
                iconBefore: iconBefore || /*#__PURE__*/ (0, $byn9U.jsx)((0, $80vF2.default), {
                    xcss: $b1dc9c564cbcbab0$var$boxWrapperStyle
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9cvwi))), {
                    LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"} 0 0`,
                    color: "currentColor",
                    label: "",
                    LEGACY_size: "medium"
                })),
                onClick: this.handleClick,
                ref: triggerProps.ref
            }, children || copyLinkButtonText);
        };
    }
}
var $b1dc9c564cbcbab0$export$2e2bcd8739ae039 = $b1dc9c564cbcbab0$export$534d10f1c5b9c7b3;

});
parcelRegister("9cvwi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e721c2947e33cb4d29af61cae3c32db2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b2daf3edd618c28$var$_react = $6b2daf3edd618c28$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $6b2daf3edd618c28$var$_link = $6b2daf3edd618c28$var$_interopRequireDefault((parcelRequire("fL9TV")));

var $6b2daf3edd618c28$var$_linkFilled = $6b2daf3edd618c28$var$_interopRequireDefault((parcelRequire("5bscj")));
function $6b2daf3edd618c28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b2daf3edd618c28$var$LinkIcon = (props)=>/*#__PURE__*/ $6b2daf3edd618c28$var$_react.default.createElement($6b2daf3edd618c28$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $6b2daf3edd618c28$var$_linkFilled.default
    }, props));
$6b2daf3edd618c28$var$LinkIcon.Name = 'LinkIconMigration';
var $6b2daf3edd618c28$var$_default = module.exports.default = $6b2daf3edd618c28$var$LinkIcon;

});
parcelRegister("fL9TV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::af316a11070150755855d308e4656f28>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b792ececee7bc53b$var$_react = $b792ececee7bc53b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b792ececee7bc53b$var$_UNSAFE_baseNew = $b792ececee7bc53b$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $b792ececee7bc53b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b792ececee7bc53b$var$LinkIcon = (props)=>/*#__PURE__*/ $b792ececee7bc53b$var$_react.default.createElement($b792ececee7bc53b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$b792ececee7bc53b$var$LinkIcon.displayName = 'LinkIcon';
var $b792ececee7bc53b$var$_default = module.exports.default = $b792ececee7bc53b$var$LinkIcon;

});

parcelRegister("5bscj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c63da4ad3ad0dfc$var$_react = $3c63da4ad3ad0dfc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $3c63da4ad3ad0dfc$var$_link = $3c63da4ad3ad0dfc$var$_interopRequireDefault((parcelRequire("fL9TV")));
function $3c63da4ad3ad0dfc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3c63da4ad3ad0dfc$var$LinkFilledIcon = (props)=>/*#__PURE__*/ $3c63da4ad3ad0dfc$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m11.75 16.15.548-.537a.585.585 0 0 0 0-.838.61.61 0 0 0-.854 0l-.574.564c-.564.553-1.483.662-2.101.168a1.482 1.482 0 0 1-.119-2.223l1.694-1.663a1.543 1.543 0 0 1 2.156 0l.647.635.853-.839-.646-.635a2.775 2.775 0 0 0-3.863 0l-1.694 1.664a2.66 2.66 0 0 0 .208 3.979c1.104.884 2.738.715 3.746-.275"/><path fill="inherit" d="m12.25 7.85-.547.537a.585.585 0 0 0 0 .838.61.61 0 0 0 .853 0l.574-.564c.564-.553 1.483-.662 2.101-.168.71.57.75 1.603.119 2.223l-1.694 1.663a1.543 1.543 0 0 1-2.156 0l-.647-.635-.853.839.646.635a2.775 2.775 0 0 0 3.863 0l1.695-1.664a2.66 2.66 0 0 0-.209-3.979c-1.104-.884-2.738-.715-3.746.275"/></g></svg>`
    }, props, {
        newIcon: $3c63da4ad3ad0dfc$var$_link.default
    }));
$3c63da4ad3ad0dfc$var$LinkFilledIcon.displayName = 'LinkFilledIcon';
var $3c63da4ad3ad0dfc$var$_default = module.exports.default = $3c63da4ad3ad0dfc$var$LinkFilledIcon;

});


parcelRegister("os4bU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b4b1d8f8ae82590ab9e3b231233297b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04980372a0b4c9eb$var$_react = $04980372a0b4c9eb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $04980372a0b4c9eb$var$_success = $04980372a0b4c9eb$var$_interopRequireDefault((parcelRequire("dwLyV")));

var $04980372a0b4c9eb$var$_checkCircle = $04980372a0b4c9eb$var$_interopRequireDefault((parcelRequire("gghOv")));
function $04980372a0b4c9eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04980372a0b4c9eb$var$SuccessIcon = (props)=>/*#__PURE__*/ $04980372a0b4c9eb$var$_react.default.createElement($04980372a0b4c9eb$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $04980372a0b4c9eb$var$_checkCircle.default
    }, props));
$04980372a0b4c9eb$var$SuccessIcon.Name = 'SuccessIconMigration';
var $04980372a0b4c9eb$var$_default = module.exports.default = $04980372a0b4c9eb$var$SuccessIcon;

});

parcelRegister("fmgJv", function(module, exports) {

$parcel$export(module.exports, "MAX_PICKER_HEIGHT", () => $d187b87900e44e35$export$c92a3ac7d2eb7b90);
$parcel$export(module.exports, "default", () => $d187b87900e44e35$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dU5mb = parcelRequire("dU5mb");
const $d187b87900e44e35$export$c92a3ac7d2eb7b90 = 102;
const $d187b87900e44e35$var$StyledButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>// TODO: (from codemod) CustomThemeButton will be deprecated. Please consider migrating to Pressable or Anchor Primitives with custom styles.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dU5mb.default), {
        ref: ref,
        ...props
    }));
var $d187b87900e44e35$export$2e2bcd8739ae039 = $d187b87900e44e35$var$StyledButton;

});



parcelRegister("k4wXf", function(module, exports) {

$parcel$export(module.exports, "createAri", () => $d6128a3425372110$export$594d18a0ad2e0e57);
const $d6128a3425372110$var$getAriResourceOwner = (subProductId)=>{
    switch(subProductId){
        // these options aren't currently valid resource owners
        case 'jira-addon':
        case 'jira-platform':
        case 'jira-polaris':
        case 'jira-portfolio':
        case 'jira-unknown':
            return 'jira';
        // being explicit that these 3 are valid and were not forgotten
        case 'jira-core':
        case 'jira-servicedesk':
        case 'jira-software':
        default:
            return subProductId;
    }
};
const $d6128a3425372110$export$594d18a0ad2e0e57 = (subProductId, cloudId)=>`ari:cloud:${$d6128a3425372110$var$getAriResourceOwner(subProductId)}::site/${cloudId}`;

});

parcelRegister("abtNr", function(module, exports) {

$parcel$export(module.exports, "default", () => $841d9f5232b09f47$export$2e2bcd8739ae039);

var $g0E5j = parcelRequire("g0E5j");
parcelRequire("hUU24");
var $1INIa = parcelRequire("1INIa");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
class $841d9f5232b09f47$export$2e2bcd8739ae039 extends (0, $1INIa.ShareServiceClient) {
    constructor({ getShareEndpoint: getShareEndpoint, getSharePayload: getSharePayload }){
        super();
        this.categorizeRecipients = (recipients)=>{
            const accumulator = {
                userIds: [],
                emails: []
            };
            return recipients.reduce((acc, recipient)=>{
                if (recipient.type === 'user') {
                    // @ts-expect-error - TS2339 - Property 'email' does not exist on type 'User'.
                    if (recipient.email !== undefined) // @ts-expect-error - TS2339 - Property 'email' does not exist on type 'User'.
                    acc.emails.push(recipient.email);
                    else if (recipient.id !== undefined) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'User'.
                    acc.userIds.push(recipient.id);
                }
                return acc;
            }, accumulator);
        };
        this.getShareEndpoint = getShareEndpoint;
        this.getSharePayload = getSharePayload;
    }
    share(content, recipients, metadata, comment) {
        const categorizedRecipients = this.categorizeRecipients(recipients);
        const shareRequest = {
            usernames: categorizedRecipients.userIds,
            emails: categorizedRecipients.emails,
            message: comment?.value || '',
            atlOrigin: new (0, $g0E5j.default)({
                id: metadata.atlOriginId,
                product: 'jira'
            }).encode(),
            ...this.getSharePayload ? this.getSharePayload(content) : null
        };
        return (0, $lRmyA.performPostRequest)(this.getShareEndpoint(content), {
            body: JSON.stringify(shareRequest)
        }).catch((error)=>{
            (0, $guiFP.default)({
                error: error,
                sendToPrivacyUnsafeSplunk: true,
                meta: {
                    packageName: 'jiraShareButton',
                    id: 'LegacyShareClient.share'
                },
                attributes: {
                    contentType: content.type
                }
            });
            throw error;
        });
    }
}

});
parcelRegister("hUU24", function(module, exports) {

$parcel$export(module.exports, "ShareServiceClient", () => (parcelRequire("1INIa")).ShareServiceClient);

var $1INIa = parcelRequire("1INIa");

});





parcelRegister("hfslX", function(module, exports) {

$parcel$export(module.exports, "useShareIntegrations", () => $b36423e50cabd739$export$58a9f7a7ab3466f4);

var $eUqFw = parcelRequire("eUqFw");

var $b3RcY = parcelRequire("b3RcY");

var $8q0kG = parcelRequire("8q0kG");

var $k8Qyf = parcelRequire("k8Qyf");

var $dWLk9 = parcelRequire("dWLk9");

var $gWV0M = parcelRequire("gWV0M");

var $ljgr5 = parcelRequire("ljgr5");
const $b36423e50cabd739$export$58a9f7a7ab3466f4 = (shareContentType)=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const ineligibilityReasons = (0, $eUqFw.useMemo)(()=>{
        const reasons = [];
        if ((0, $8q0kG.default)()) reasons.push('notDesktop');
        // All Share to Slack must be disabled in FedRAMP environment as
        // Slack Jira Integration app is not available in FedRAMP
        if ((0, $b3RcY.isFedRamp)()) reasons.push('isFedRAMP');
        return reasons;
    }, []);
    const shareIntegrations = (0, $eUqFw.useMemo)(()=>ineligibilityReasons.length === 0 ? [
            {
                type: 'Slack',
                Icon: (0, $ljgr5.default),
                Content: ({ onClose: onClose, changeTab: changeTab })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gWV0M.ShareToSlack), {
                        showFlag: showFlag,
                        product: "jira",
                        channel: "productAnalytics",
                        onClose: onClose,
                        cloudId: cloudId,
                        changeTab: changeTab,
                        shareContentType: shareContentType
                    })
            }
        ] : [], [
        ineligibilityReasons.length,
        showFlag,
        cloudId,
        shareContentType
    ]);
    return {
        shareIntegrations: shareIntegrations
    };
};

});
parcelRegister("gWV0M", function(module, exports) {

$parcel$export(module.exports, "ShareToSlack", () => $acb191acb45641f8$export$2cc56764fd9edb21);

var $eUqFw = parcelRequire("eUqFw");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

var $335P8 = parcelRequire("335P8");

const $acb191acb45641f8$export$2cc56764fd9edb21 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async-share-to-slack",
        packageName: "integrations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-to-slack",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $335P8.StyledShareToSlackLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $335P8.StyledShareToSlack), props)));

});
parcelRegister("335P8", function(module, exports) {

$parcel$export(module.exports, "StyledShareToSlack", () => $7cc4332b79a68bdd$export$9aeb6210c91511b9);
$parcel$export(module.exports, "StyledShareToSlackLoader", () => $7cc4332b79a68bdd$export$d3f97cc63e3ee02);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bBdMg = parcelRequire("bBdMg");

var $d3qIv = parcelRequire("d3qIv");
const $7cc4332b79a68bdd$export$9aeb6210c91511b9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $d3qIv.LazyShareToSlack), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8ax2b",
            __cmplp.className
        ])
    });
});
const $7cc4332b79a68bdd$export$d3f97cc63e3ee02 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $bBdMg.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d3qIv", function(module, exports) {

$parcel$export(module.exports, "LazyShareToSlack", () => $3114157f9b395570$export$24281652e6b89b3b);

var $dyfd9 = parcelRequire("dyfd9");

const $3114157f9b395570$export$24281652e6b89b3b = (0, $dyfd9.lazyAfterPaint)(()=>(parcelRequire("4rGAP")), {
    ssr: false,
    moduleId: "../platform/packages/growth/integrations/src/share-to-slack/ui/index.tsx"
});

});
parcelRegister("4rGAP", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("4fDuj")
]).then(()=>parcelRequire('d5Qt6'));

});




parcelRegister("ljgr5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f66b2d378eff6fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1f66b2d378eff6fc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.50403 13.8563C7.50403 14.727 6.79278 15.4382 5.92212 15.4382C5.05146 15.4382 4.34021 14.727 4.34021 13.8563C4.34021 12.9857 5.05146 12.2744 5.92212 12.2744H7.50403V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.30115 13.8563C8.30115 12.9857 9.0124 12.2744 9.88307 12.2744C10.7537 12.2744 11.465 12.9857 11.465 13.8563V17.8172C11.465 18.6879 10.7537 19.3991 9.88307 19.3991C9.0124 19.3991 8.30115 18.6879 8.30115 17.8172V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.88307 7.50415C9.0124 7.50415 8.30115 6.79291 8.30115 5.92224C8.30115 5.05158 9.0124 4.34033 9.88307 4.34033C10.7537 4.34033 11.465 5.05158 11.465 5.92224V7.50415H9.88307Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.88304 8.30127C10.7537 8.30127 11.465 9.01251 11.465 9.88317C11.465 10.7538 10.7537 11.4651 9.88304 11.4651H5.92212C5.05146 11.4651 4.34021 10.7538 4.34021 9.88317C4.34021 9.01251 5.05146 8.30127 5.92212 8.30127H9.88304Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16.2354 9.88317C16.2354 9.01251 16.9466 8.30127 17.8172 8.30127C18.6879 8.30127 19.3991 9.01251 19.3991 9.88317C19.3991 10.7538 18.6879 11.4651 17.8172 11.4651H16.2354V9.88317Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15.4381 9.88316C15.4381 10.7538 14.7269 11.4651 13.8562 11.4651C12.9855 11.4651 12.2743 10.7538 12.2743 9.88316V5.92225C12.2743 5.05158 12.9855 4.34033 13.8562 4.34033C14.7269 4.34033 15.4381 5.05158 15.4381 5.92225V9.88316Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.8562 16.2354C14.7269 16.2354 15.4381 16.9466 15.4381 17.8172C15.4381 18.6879 14.7269 19.3991 13.8562 19.3991C12.9855 19.3991 12.2743 18.6879 12.2743 17.8172V16.2354H13.8562Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.8562 15.4382C12.9855 15.4382 12.2743 14.727 12.2743 13.8563C12.2743 12.9857 12.9855 12.2744 13.8562 12.2744H17.8171C18.6878 12.2744 19.399 12.9857 19.399 13.8563C19.399 14.727 18.6878 15.4382 17.8171 15.4382H13.8562Z",
        fill: "#ECB22E"
    }));

});


parcelRegister("lxV3x", function(module, exports) {

$parcel$export(module.exports, "AsyncShareProjectNudge", () => $906cb1053f659eb0$export$d95995d6ca76620b);

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");

var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $906cb1053f659eb0$var$LazyShareProjectNudge = (0, $dyfd9.lazyAfterPaint)(()=>(parcelRequire("htJn2")), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-share-project/index.tsx"
});
const $906cb1053f659eb0$export$d95995d6ca76620b = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $99a775c02d636a41$export$a1be34032ee24f78),
        fallback: children,
        attributes: {
            nudgeId: (0, $99a775c02d636a41$export$a1be34032ee24f78)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jwm-share-project-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($906cb1053f659eb0$var$LazyShareProjectNudge, null, children)));

});
parcelRegister("htJn2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("afZr6").then(()=>parcelRequire('16oN0'));

});


parcelRegister("bPBzW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6735bf02b619f7cd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6735bf02b619f7cd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    share: {
        "id": "business-invite-people.jwm-share-button.share",
        "defaultMessage": "Share"
    },
    shareTooltipText: {
        "id": "business-invite-people.jwm-share-button.share-tooltip-text",
        "defaultMessage": "Embed this Smart Link in other Atlassian products such as Confluence"
    },
    shareJwmHelperMessage: {
        "id": "business-invite-people.jwm-share-button.share-jwm-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("cRKsH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ab88bbf4e192a9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eruWR = parcelRequire("eruWR");

var $1ybV0 = parcelRequire("1ybV0");

var $jK1pm = parcelRequire("jK1pm");


var $fG0qd = parcelRequire("fG0qd");
const $b0ab88bbf4e192a9$var$MoreMenuCore = /*#__PURE__*/ (0, $eUqFw.memo)(({ renderContent: renderContent, minWidth: minWidth = (0, $f81b038ef83e0f85$export$8c68b096b2d5e9f6), forceVisibility: forceVisibility = false })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(forceVisibility);
    (0, $eUqFw.useEffect)(()=>{
        setIsOpen(forceVisibility);
    }, [
        forceVisibility
    ]);
    const closeMenu = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const toggleMenu = (0, $eUqFw.useCallback)(()=>setIsOpen((oldIsOpen)=>!oldIsOpen), []);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0ab88bbf4e192a9$export$5f7211d21bfdae05, {
            width: minWidth
        }, renderContent(closeMenu)), [
        closeMenu,
        renderContent,
        minWidth
    ]);
    const trigger = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fG0qd.default), {
            ...triggerProps,
            isSelected: isOpen,
            onClick: toggleMenu
        }), [
        isOpen,
        toggleMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-more-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eruWR.default), {
        isOpen: isOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        content: content,
        trigger: trigger,
        shouldRenderToParent: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds'),
        strategy: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds') ? 'absolute' : undefined
    }));
});
var $b0ab88bbf4e192a9$export$2e2bcd8739ae039 = $b0ab88bbf4e192a9$var$MoreMenuCore;
const $b0ab88bbf4e192a9$export$5f7211d21bfdae05 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1hdq",
            __cmplp.className
        ])
    });
});

});
const $f81b038ef83e0f85$export$8c68b096b2d5e9f6 = 320;

parcelRegister("fG0qd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4453e9a08a331d11$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6eRT3 = parcelRequire("6eRT3");

var $fBmrg = parcelRequire("fBmrg");

var $lGiWG = parcelRequire("lGiWG");

var $9zysr = parcelRequire("9zysr");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8rQuz = parcelRequire("8rQuz");

var $k1mhY = parcelRequire("k1mhY");
const $4453e9a08a331d11$var$MORE_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBmrg))), {
    label: "",
    size: "small"
});
const $4453e9a08a331d11$var$TriggerOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        ...otherProps,
        ref: ref,
        testId: "business-more-menu.ui.more-menu.more-menu-core.trigger",
        iconBefore: $4453e9a08a331d11$var$MORE_ICON,
        isSelected: isSelected,
        onClick: onClick,
        appearance: "subtle",
        "aria-label": formatMessage((0, $k1mhY.default).moreButtonLabel)
    }, formatMessage((0, $k1mhY.default).moreButton));
});
const $4453e9a08a331d11$var$Trigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        ...otherProps,
        ref: ref,
        testId: "business-more-menu.ui.more-menu.more-menu-core.trigger",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6eRT3))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }),
        isSelected: isSelected,
        onClick: onClick,
        "aria-label": formatMessage((0, $k1mhY.default).moreButtonLabel),
        title: formatMessage((0, $k1mhY.default).moreButton)
    });
});
var $4453e9a08a331d11$export$2e2bcd8739ae039 = (0, $9zysr.componentWithCondition)((0, $8rQuz.isVisualRefreshEnabled), $4453e9a08a331d11$var$Trigger, $4453e9a08a331d11$var$TriggerOld);

});
parcelRegister("k1mhY", function(module, exports) {

$parcel$export(module.exports, "default", () => $255e4847f5c60031$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $255e4847f5c60031$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moreButton: {
        "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button",
        "defaultMessage": "More"
    },
    moreButtonLabel: {
        "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button-label",
        "defaultMessage": "More actions on the view options"
    }
});

});



parcelRegister("iSNkS", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $60586429dc17d610$export$a7359bcfb0ca8e98);
const $60586429dc17d610$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments'
};

});

parcelRegister("dZHFc", function(module, exports) {

$parcel$export(module.exports, "default", () => $63836c322a52d07c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lUg8E = parcelRequire("lUg8E");

var $8VBU9 = parcelRequire("8VBU9");

var $fcbZt = parcelRequire("fcbZt");

var $azeZS = parcelRequire("azeZS");
var $hQggk = parcelRequire("hQggk");
var $aMFuZ = parcelRequire("aMFuZ");
var $cUyTA = parcelRequire("cUyTA");

var $eruWR = parcelRequire("eruWR");

var $iBeSy = parcelRequire("iBeSy");
var $8Vv3m = parcelRequire("8Vv3m");


var $2mu6T = parcelRequire("2mu6T");

var $3nkD4 = parcelRequire("3nkD4");

var $jGcn0 = parcelRequire("jGcn0");

var $e4qlg = parcelRequire("e4qlg");

var $kBh2b = parcelRequire("kBh2b");

var $lGiWG = parcelRequire("lGiWG");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $8rQuz = parcelRequire("8rQuz");

var $iXHUp = parcelRequire("iXHUp");

var $fZC2L = parcelRequire("fZC2L");
const $63836c322a52d07c$var$BoardGroupSelector = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [groupBy, setGroupBy] = (0, $iXHUp.useGroupBy)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { data: categoryField } = (0, $e4qlg.useCategoryField)();
    const categoryFieldId = categoryField?.id;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const groupByOptions = (0, $iXHUp.useGroupByOptions)();
    const fireGroupChangedTracking = (0, $eUqFw.useCallback)((newGroupBy)=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'groupBy', {
            value: newGroupBy
        }), [
        createAnalyticsEvent
    ]);
    const fireGroupMenuOpenedTracking = (0, $eUqFw.useCallback)(()=>{
        if (isOpen) return;
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jwmBoardGrouping menuOpened');
    }, [
        createAnalyticsEvent,
        isOpen
    ]);
    let groupByLabel;
    let hasDefaultGroupApplied = false;
    if (groupBy === (0, $jGcn0.GROUP_BY_PRIORITY) && groupByOptions.has((0, $jGcn0.GROUP_BY_PRIORITY))) groupByLabel = formatMessage((0, $fZC2L.default).groupByPriorityLabel);
    else if (groupBy === (0, $jGcn0.GROUP_BY_ASSIGNEE) && groupByOptions.has((0, $jGcn0.GROUP_BY_ASSIGNEE))) groupByLabel = formatMessage((0, $fZC2L.default).groupByAssigneeLabel);
    else if (groupBy === (0, $jGcn0.GROUP_BY_CATEGORY) && groupByOptions.has((0, $jGcn0.GROUP_BY_CATEGORY))) groupByLabel = formatMessage((0, $fZC2L.default).groupByCategoryLabel);
    else {
        hasDefaultGroupApplied = true;
        groupByLabel = formatMessage((0, $fZC2L.default).groupByStatusLabel);
    }
    const groupByStatus = (0, $eUqFw.useCallback)(()=>{
        fireGroupChangedTracking((0, $jGcn0.GROUP_BY_STATUS));
        setGroupBy((0, $jGcn0.GROUP_BY_STATUS));
        setIsOpen(false);
    }, [
        fireGroupChangedTracking,
        setGroupBy
    ]);
    const groupByPriority = (0, $eUqFw.useCallback)(()=>{
        fireGroupChangedTracking((0, $jGcn0.GROUP_BY_PRIORITY));
        setGroupBy((0, $jGcn0.GROUP_BY_PRIORITY));
        setIsOpen(false);
    }, [
        fireGroupChangedTracking,
        setGroupBy
    ]);
    const groupByAssignee = (0, $eUqFw.useCallback)(()=>{
        fireGroupChangedTracking((0, $jGcn0.GROUP_BY_ASSIGNEE));
        setGroupBy((0, $jGcn0.GROUP_BY_ASSIGNEE));
        setIsOpen(false);
    }, [
        fireGroupChangedTracking,
        setGroupBy
    ]);
    const groupByCategory = (0, $eUqFw.useCallback)(()=>{
        if (!categoryFieldId) return;
        fireGroupChangedTracking((0, $jGcn0.GROUP_BY_CATEGORY));
        setGroupBy(categoryFieldId);
        setIsOpen(false);
    }, [
        categoryFieldId,
        fireGroupChangedTracking,
        setGroupBy
    ]);
    return (0, $eUqFw.useMemo)(()=>{
        const checkIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8VBU9))), {
            size: "medium",
            label: formatMessage((0, $fZC2L.default).groupBySelected),
            primaryColor: `var(--ds-icon-selected, ${(0, $1b343b038f6c23ec$export$b3de0ae08da2ce64)})`
        });
        const HeadingAndClearButtonInContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iBeSy.default), {
            justifyContent: "space-between",
            alignItems: "baseline",
            xcss: $63836c322a52d07c$var$headingContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($63836c322a52d07c$var$Heading, null, formatMessage((0, $fZC2L.default).groupBySectionTitle)), !hasDefaultGroupApplied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
            testId: "work-management-board.ui.header.group-selector.clear-button",
            appearance: "subtle-link",
            spacing: "none",
            onClick: groupByStatus,
            "aria-label": formatMessage((0, $fZC2L.default).clearGroupLabel)
        }, formatMessage((0, $fZC2L.default).clearGroup)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eruWR.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-end",
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aMFuZ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cUyTA.default), null, HeadingAndClearButtonInContainer, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azeZS.default), {
                    onClick: groupByStatus,
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nkD4.StatusIcon), null),
                    iconAfter: hasDefaultGroupApplied && checkIcon,
                    testId: "work-management-board.ui.header.group-selector.status-button"
                }, formatMessage((0, $fZC2L.default).groupByStatusDefaultLabel)), groupByOptions.has((0, $jGcn0.GROUP_BY_PRIORITY)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azeZS.default), {
                    onClick: groupByPriority,
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nkD4.PriorityIcon), null),
                    iconAfter: groupBy === (0, $jGcn0.GROUP_BY_PRIORITY) && checkIcon,
                    testId: "work-management-board.ui.header.group-selector.priority-button"
                }, formatMessage((0, $fZC2L.default).groupByPriorityLabel)), groupByOptions.has((0, $jGcn0.GROUP_BY_ASSIGNEE)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azeZS.default), {
                    onClick: groupByAssignee,
                    iconBefore: (0, $kBh2b.getFieldIcons)('medium')[0, $lO4Or.ASSIGNEE_TYPE],
                    iconAfter: groupBy === (0, $jGcn0.GROUP_BY_ASSIGNEE) && checkIcon,
                    testId: "work-management-board.ui.header.group-selector.assignee-button"
                }, formatMessage((0, $fZC2L.default).groupByAssigneeLabel)), groupByOptions.has((0, $jGcn0.GROUP_BY_CATEGORY)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azeZS.default), {
                    onClick: groupByCategory,
                    iconBefore: (0, $kBh2b.getFieldIcons)('medium')[0, $lO4Or.CATEGORY_TYPE],
                    iconAfter: groupBy === (0, $jGcn0.GROUP_BY_CATEGORY) && checkIcon,
                    testId: "work-management-board.ui.header.group-selector.category-button"
                }, formatMessage((0, $fZC2L.default).groupByCategoryLabel)))),
            trigger: (triggerProps)=>(0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
                    ...triggerProps,
                    "aria-label": formatMessage((0, $fZC2L.default).groupByButtonAriaLabel, {
                        label: groupByLabel
                    }),
                    isSelected: isOpen || Boolean(groupBy),
                    onClick: ()=>{
                        setIsOpen((wasOpen)=>!wasOpen);
                        fireGroupMenuOpenedTracking();
                    },
                    testId: "work-management-board.ui.header.group-selector"
                }, formatMessage((0, $fZC2L.default).groupByButtonLabel), groupByLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
                    ...triggerProps,
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fcbZt))), {
                        label: "",
                        size: "small"
                    }),
                    isSelected: isOpen,
                    onClick: ()=>{
                        setIsOpen((wasOpen)=>!wasOpen);
                        fireGroupMenuOpenedTracking();
                    },
                    appearance: "subtle",
                    testId: "work-management-board.ui.header.group-selector"
                }, formatMessage((0, $fZC2L.default).groupByButtonLabelOld), groupByLabel),
            shouldRenderToParent: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds'),
            strategy: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds') ? 'absolute' : undefined
        });
    }, [
        fireGroupMenuOpenedTracking,
        formatMessage,
        groupBy,
        groupByAssignee,
        groupByCategory,
        groupByLabel,
        groupByOptions,
        groupByPriority,
        groupByStatus,
        hasDefaultGroupApplied,
        isOpen
    ]);
};
var $63836c322a52d07c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $63836c322a52d07c$var$BoardGroupSelector;
const $63836c322a52d07c$var$Heading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $hQggk.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $63836c322a52d07c$var$headingContainerStyles = (0, $8Vv3m.xcss)({
    paddingRight: 'space.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-body-small, ${(0, $2mu6T.fontFallback).body.small})`
});

});
parcelRegister("fcbZt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1014714f77ef539$var$_react = $b1014714f77ef539$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $b1014714f77ef539$var$_menu = $b1014714f77ef539$var$_interopRequireDefault((parcelRequire("1izGX")));
function $b1014714f77ef539$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b1014714f77ef539$var$MenuExpandIcon = (props)=>/*#__PURE__*/ $b1014714f77ef539$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 1 1 0 2H7.002A1 1 0 0 1 6 12m0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 1 1 0 2H7.002A1 1 0 0 1 6 16m0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 1 1 0 2H7.002A1 1 0 0 1 6 8"/></svg>`
    }, props, {
        newIcon: $b1014714f77ef539$var$_menu.default
    }));
$b1014714f77ef539$var$MenuExpandIcon.displayName = 'MenuExpandIcon';
var $b1014714f77ef539$var$_default = module.exports.default = $b1014714f77ef539$var$MenuExpandIcon;

});
parcelRegister("1izGX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9176a30c0755d77947ceea47f5dcd51a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f23288f2509a3f4$var$_react = $0f23288f2509a3f4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $0f23288f2509a3f4$var$_UNSAFE_baseNew = $0f23288f2509a3f4$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $0f23288f2509a3f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for accessing the menu in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f23288f2509a3f4$var$MenuIcon = (props)=>/*#__PURE__*/ $0f23288f2509a3f4$var$_react.default.createElement($0f23288f2509a3f4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 13.25h14M1 8h14M1 2.75h14"/>`
    }, props));
$0f23288f2509a3f4$var$MenuIcon.displayName = 'MenuIcon';
var $0f23288f2509a3f4$var$_default = module.exports.default = $0f23288f2509a3f4$var$MenuIcon;

});


parcelRegister("3nkD4", function(module, exports) {

$parcel$export(module.exports, "PriorityIcon", () => $2dfc1f6aacfa545f$export$3abf8cb3bcb0225);
$parcel$export(module.exports, "StatusIcon", () => $2dfc1f6aacfa545f$export$b131c49b26d3f427);
$parcel$export(module.exports, "NumberGlyph", () => $2dfc1f6aacfa545f$export$c0f9c6a1407deaef);

var $eUqFw = parcelRequire("eUqFw");
const $2dfc1f6aacfa545f$export$3abf8cb3bcb0225 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20ZM12 18.2222C15.4364 18.2222 18.2222 15.4364 18.2222 12C18.2222 8.56356 15.4364 5.77778 12 5.77778C8.56356 5.77778 5.77778 8.56356 5.77778 12C5.77778 15.4364 8.56356 18.2222 12 18.2222ZM14.1219 13.5914L14.0381 13.5174L12 11.48L9.96186 13.5174C9.64143 13.8378 9.13725 13.8625 8.78855 13.5914L8.70481 13.5174C8.38438 13.197 8.35973 12.6928 8.63086 12.3441L8.70481 12.2604L11.3715 9.5937C11.6919 9.27327 12.1961 9.24861 12.5448 9.51975L12.6285 9.5937L15.2952 12.2604C15.6423 12.6075 15.6423 13.1703 15.2952 13.5174C14.9748 13.8378 14.4706 13.8625 14.1219 13.5914Z",
        fill: "currentColor"
    }));
const $2dfc1f6aacfa545f$export$b131c49b26d3f427 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM18.2222 12C18.2222 8.56356 15.4364 5.77778 12 5.77778C8.56356 5.77778 5.77778 8.56356 5.77778 12C5.77778 15.4364 8.56356 18.2222 12 18.2222C15.4364 18.2222 18.2222 15.4364 18.2222 12ZM15.3664 11.4518L15.2952 11.3715C15.3267 11.4029 15.3553 11.4362 15.381 11.4708C15.3969 11.4923 15.4118 11.5144 15.4257 11.5372C15.4324 11.5479 15.4386 11.5588 15.4447 11.5697C15.4544 11.5873 15.4637 11.6054 15.4723 11.6239C15.4794 11.639 15.486 11.6544 15.4922 11.6699C15.4993 11.6875 15.5057 11.7051 15.5115 11.7229C15.5158 11.7361 15.5199 11.7498 15.5237 11.7636C15.5291 11.7827 15.5337 11.802 15.5377 11.8215C15.5407 11.837 15.5434 11.8525 15.5457 11.868C15.5483 11.8849 15.5504 11.9024 15.552 11.92C15.5539 11.9416 15.555 11.9626 15.5554 11.9837C15.5555 11.9886 15.5556 11.9943 15.5556 12L15.5554 12.0172C15.555 12.0382 15.5539 12.0593 15.552 12.0802L15.5556 12C15.5556 12.0439 15.5524 12.087 15.5462 12.1292C15.5436 12.1467 15.5404 12.1648 15.5366 12.1829C15.5331 12.1999 15.5293 12.2162 15.5249 12.2323C15.521 12.2463 15.5168 12.2606 15.5122 12.2748C15.5059 12.2943 15.4989 12.3135 15.4913 12.3325C15.4855 12.3467 15.4795 12.3606 15.4731 12.3744C15.4639 12.3941 15.4539 12.4138 15.4431 12.4331C15.438 12.4423 15.4326 12.4517 15.4269 12.461C15.4135 12.4829 15.3993 12.5041 15.3843 12.5246C15.3793 12.5315 15.3743 12.5382 15.3691 12.5448C15.3528 12.5655 15.3393 12.5815 15.3252 12.597L15.2952 12.6285L12.6285 15.2952C12.2814 15.6423 11.7186 15.6423 11.3715 15.2952C11.051 14.9748 11.0264 14.4706 11.2975 14.1219L11.3715 14.0381L12.52 12.8889H9.33333C8.84241 12.8889 8.44444 12.4909 8.44444 12C8.44444 11.5468 8.78355 11.1729 9.22184 11.118L9.33333 11.1111H12.5218L11.3715 9.96187C11.051 9.64144 11.0264 9.13724 11.2975 8.78853L11.3715 8.70479C11.6919 8.38436 12.1961 8.35971 12.5448 8.63085L12.6285 8.70479L15.2977 11.374C15.3221 11.3985 15.345 11.4245 15.3664 11.4518Z",
        fill: "currentColor"
    }));
const $2dfc1f6aacfa545f$export$c0f9c6a1407deaef = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2dfc1f6aacfa545f$export$ad8f8fc3bcd61b4a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.9299 7C10.9299 6.44772 11.3776 6 11.9299 6C12.4822 6 12.9299 6.44772 12.9299 7V10.268L15.76 8.63397C16.2383 8.35783 16.8499 8.5217 17.1261 9C17.4022 9.47829 17.2383 10.0899 16.76 10.366L13.9299 12L16.76 13.634C17.2383 13.9101 17.4022 14.5217 17.1261 15C16.8499 15.4783 16.2383 15.6422 15.76 15.366L12.9299 13.732V17C12.9299 17.5523 12.4822 18 11.9299 18C11.3776 18 10.9299 17.5523 10.9299 17V13.7321L8.09978 15.366C7.62148 15.6422 7.00989 15.4783 6.73375 15C6.45761 14.5217 6.62148 13.9101 7.09978 13.634L9.9299 12L7.09978 10.366C6.62148 10.0899 6.45761 9.47829 6.73375 9C7.00989 8.5217 7.62148 8.35783 8.09978 8.63397L10.9299 10.2679V7Z",
        fill: "currentColor"
    }));
const $2dfc1f6aacfa545f$export$3dc0fe769dc7dcac = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 6C9.44772 6 9 6.44772 9 7V9H7C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H9V13H7C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H9V17C9 17.5523 9.44772 18 10 18C10.5523 18 11 17.5523 11 17V15H13V17C13 17.5523 13.4477 18 14 18C14.5523 18 15 17.5523 15 17V15H17C17.5523 15 18 14.5523 18 14C18 13.4477 17.5523 13 17 13H15V11H17C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9H15V7C15 6.44772 14.5523 6 14 6C13.4477 6 13 6.44772 13 7V9H11V7C11 6.44772 10.5523 6 10 6ZM13 13V11H11V13H13Z",
        fill: "currentColor"
    }));
const $2dfc1f6aacfa545f$export$4974ca23eb8b9b46 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.5 6C17.3284 6 18 6.67157 18 7.5V16.5C18 17.3284 17.3284 18 16.5 18H7.5C6.67157 18 6 17.3284 6 16.5V7.5C6 6.67157 6.67157 6 7.5 6H16.5ZM12.375 8.25C12.2625 8.25 12.165 8.30175 12.096 8.37975L9.11175 12.1088C9.1095 12.111 9.08475 12.1425 9.08475 12.1425C9.03525 12.2092 9 12.2865 9 12.375C9 12.582 9.168 12.75 9.375 12.75C9.396 12.75 9.41325 12.7537 9.43275 12.75H11.25V15.375C11.25 15.582 11.418 15.75 11.625 15.75C11.718 15.75 11.8005 15.7125 11.8658 15.657C11.8658 15.657 11.9123 15.6068 11.9295 15.582L14.88 11.8972C14.8943 11.8837 14.9033 11.868 14.9153 11.8522L14.9355 11.8275C14.9722 11.7667 15 11.7 15 11.625C15 11.418 14.832 11.25 14.625 11.25H12.75V8.625C12.75 8.418 12.582 8.25 12.375 8.25Z",
        fill: "currentColor"
    }));

});

parcelRegister("kBh2b", function(module, exports) {

$parcel$export(module.exports, "getFieldIcons", () => $e54f455c6b41e11e$export$df250ca2240f6516);

var $jqvCZ = parcelRequire("jqvCZ");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $bsrAN = parcelRequire("bsrAN");

var $6g0DE = parcelRequire("6g0DE");

var $975Me = parcelRequire("975Me");

var $4QCVn = parcelRequire("4QCVn");

var $fCSoc = parcelRequire("fCSoc");

var $7nIOX = parcelRequire("7nIOX");

var $is7XO = parcelRequire("is7XO");

var $851U9 = parcelRequire("851U9");

var $cLwpi = parcelRequire("cLwpi");

var $6wPXB = parcelRequire("6wPXB");

var $46tzp = parcelRequire("46tzp");

var $4wZzs = parcelRequire("4wZzs");
const $e54f455c6b41e11e$export$df250ca2240f6516 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((size)=>{
    const legacyFieldIcons = (0, $4wZzs.getLegacyFieldIcons)({
        size: size
    });
    return {
        ...legacyFieldIcons,
        ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
            ...(0, $46tzp.getVersionIcons)(size),
            ...(0, $fCSoc.getParentIcon)(size),
            ...(0, $6g0DE.getDevSummaryIcons)(size),
            ...(0, $6wPXB.getTeamIcons)(size),
            ...(0, $975Me.getGoalsIcons)(size)
        } : {},
        ...(0, $1ybV0.ff)('jira.list.field-support-part1') ? {
            ...(0, $851U9.getResolutionIcons)(size),
            ...(0, $4QCVn.getGroupIcons)(size),
            ...(0, $cLwpi.getStatusCategoryIcons)(size),
            ...(0, $is7XO.getRadioSelectIcon)(size),
            ...(0, $7nIOX.getProjectIcons)(size),
            ...(0, $bsrAN.getCascadingSelectIcons)(size)
        } : {}
    };
});

});
parcelRegister("bsrAN", function(module, exports) {

$parcel$export(module.exports, "getCascadingSelectIcons", () => $4ec1409121357127$export$a1c73b689cfdba0d);

var $eUqFw = parcelRequire("eUqFw");

var $eF3fm = parcelRequire("eF3fm");

var $1WxNJ = parcelRequire("1WxNJ");

var $lO4Or = parcelRequire("lO4Or");
const $4ec1409121357127$export$a1c73b689cfdba0d = (size)=>({
        [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF3fm))), {
            label: "",
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1WxNJ))),
            LEGACY_size: size
        })
    });

});
parcelRegister("eF3fm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb8036f361a1be1ee04edce58f70ad76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aac769c0924611bb$var$_react = $aac769c0924611bb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $aac769c0924611bb$var$_UNSAFE_baseNew = $aac769c0924611bb$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $aac769c0924611bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * @deprecated Use `@atlaskit/icon/core/list-bulleted` instead.
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "BulletedList".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aac769c0924611bb$var$BulletedListIcon = (props)=>/*#__PURE__*/ $aac769c0924611bb$var$_react.default.createElement($aac769c0924611bb$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.75 2.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M5 2.75h10M5 8h10M5 13.25h10M2.75 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0-10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
    }, props));
$aac769c0924611bb$var$BulletedListIcon.displayName = 'BulletedListIcon';
var $aac769c0924611bb$var$_default = module.exports.default = $aac769c0924611bb$var$BulletedListIcon;

});

parcelRegister("1WxNJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $16a56d6ee18ee6a8$var$_react = $16a56d6ee18ee6a8$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $16a56d6ee18ee6a8$var$_listBulleted = $16a56d6ee18ee6a8$var$_interopRequireDefault((parcelRequire("ag3fn")));
function $16a56d6ee18ee6a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $16a56d6ee18ee6a8$var$EditorBulletListIcon = (props)=>/*#__PURE__*/ $16a56d6ee18ee6a8$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 8c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1m5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $16a56d6ee18ee6a8$var$_listBulleted.default
    }));
$16a56d6ee18ee6a8$var$EditorBulletListIcon.displayName = 'EditorBulletListIcon';
var $16a56d6ee18ee6a8$var$_default = module.exports.default = $16a56d6ee18ee6a8$var$EditorBulletListIcon;

});
parcelRegister("ag3fn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff718278f5b90796d34b75a3e59b4f33>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $777dead0b59f3850$var$_react = $777dead0b59f3850$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $777dead0b59f3850$var$_UNSAFE_baseNew = $777dead0b59f3850$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $777dead0b59f3850$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $777dead0b59f3850$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $777dead0b59f3850$var$_react.default.createElement($777dead0b59f3850$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.75 2.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M5 2.75h10M5 8h10M5 13.25h10M2.75 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0-10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
    }, props));
$777dead0b59f3850$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $777dead0b59f3850$var$_default = module.exports.default = $777dead0b59f3850$var$ListBulletedIcon;

});



parcelRegister("6g0DE", function(module, exports) {

$parcel$export(module.exports, "getDevSummaryIcons", () => $c249a2a5b82bb4bc$export$af7756d867a4596f);

var $eUqFw = parcelRequire("eUqFw");

var $2PSAP = parcelRequire("2PSAP");

var $dxEjV = parcelRequire("dxEjV");

var $lO4Or = parcelRequire("lO4Or");
const $c249a2a5b82bb4bc$export$af7756d867a4596f = (size)=>({
        [(0, $lO4Or.DEV_SUMMARY_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2PSAP))), {
            label: "",
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($dxEjV))),
            LEGACY_size: size
        })
    });

});
parcelRegister("2PSAP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::819aaba4ce720b386ac455b06c3dfba2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $210ab13da0a402ff$var$_react = $210ab13da0a402ff$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $210ab13da0a402ff$var$_UNSAFE_baseNew = $210ab13da0a402ff$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $210ab13da0a402ff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $210ab13da0a402ff$var$BranchIcon = (props)=>/*#__PURE__*/ $210ab13da0a402ff$var$_react.default.createElement($210ab13da0a402ff$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M4.25 4.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 0V9m1.5 3.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 0h3.5a2.5 2.5 0 0 0 2.5-2.5v-5.5m0 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>`
    }, props));
$210ab13da0a402ff$var$BranchIcon.displayName = 'BranchIcon';
var $210ab13da0a402ff$var$_default = module.exports.default = $210ab13da0a402ff$var$BranchIcon;

});

parcelRegister("dxEjV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9dbda23b158d1182$var$_react = $9dbda23b158d1182$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $9dbda23b158d1182$var$_branch = $9dbda23b158d1182$var$_interopRequireDefault((parcelRequire("2PSAP")));
function $9dbda23b158d1182$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9dbda23b158d1182$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $9dbda23b158d1182$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
    }, props, {
        newIcon: $9dbda23b158d1182$var$_branch.default
    }));
$9dbda23b158d1182$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $9dbda23b158d1182$var$_default = module.exports.default = $9dbda23b158d1182$var$BitbucketBranchesIcon;

});


parcelRegister("975Me", function(module, exports) {

$parcel$export(module.exports, "getGoalsIcons", () => $860af03e515ae7da$export$191c71adb6287036);

var $eUqFw = parcelRequire("eUqFw");

var $sLJuB = parcelRequire("sLJuB");

var $lO4Or = parcelRequire("lO4Or");
const $860af03e515ae7da$export$191c71adb6287036 = ()=>({
        [(0, $lO4Or.GOALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($sLJuB))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        })
    });

});

parcelRegister("4QCVn", function(module, exports) {

$parcel$export(module.exports, "getGroupIcons", () => $f5e22dbf818fedac$export$4b39ade85c5051f7);

var $eUqFw = parcelRequire("eUqFw");

var $dylHY = parcelRequire("dylHY");

var $3GTLN = parcelRequire("3GTLN");

var $lO4Or = parcelRequire("lO4Or");
const $f5e22dbf818fedac$export$4b39ade85c5051f7 = (size)=>({
        [(0, $lO4Or.GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dylHY))), {
            color: "currentColor",
            LEGACY_size: size,
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3GTLN)))
        }),
        [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dylHY))), {
            color: "currentColor",
            LEGACY_size: size,
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3GTLN)))
        })
    });

});

parcelRegister("fCSoc", function(module, exports) {

$parcel$export(module.exports, "getParentIcon", () => $c4211625266bf1b6$export$744c82990563f55a);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $aa7ce = parcelRequire("aa7ce");
const $c4211625266bf1b6$export$744c82990563f55a = ()=>({
        [(0, $lO4Or.PARENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aa7ce.HierarchyIcon), null)
    });

});

parcelRegister("7nIOX", function(module, exports) {

$parcel$export(module.exports, "getProjectIcons", () => $288778ae0a7a6d12$export$6db5abb9a6c7aec2);

var $eUqFw = parcelRequire("eUqFw");

var $73teA = parcelRequire("73teA");

var $be9Ag = parcelRequire("be9Ag");

var $lO4Or = parcelRequire("lO4Or");
const $288778ae0a7a6d12$export$6db5abb9a6c7aec2 = (size)=>({
        [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($73teA))), {
            color: "currentColor",
            label: "",
            LEGACY_size: size,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($be9Ag)))
        })
    });

});

parcelRegister("is7XO", function(module, exports) {

$parcel$export(module.exports, "getRadioSelectIcon", () => $17a174c113288beb$export$c36fadaa74abd39e);

var $eUqFw = parcelRequire("eUqFw");

var $6GGTE = parcelRequire("6GGTE");

var $8MIqA = parcelRequire("8MIqA");

var $lO4Or = parcelRequire("lO4Or");
const $17a174c113288beb$export$c36fadaa74abd39e = (size)=>({
        [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6GGTE))), {
            color: "currentColor",
            label: "",
            LEGACY_size: size,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8MIqA)))
        })
    });

});
parcelRegister("6GGTE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa46e6d801ee3a3fb5cceaf32be49fab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4de7f0b643268d1d$var$_react = $4de7f0b643268d1d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $4de7f0b643268d1d$var$_UNSAFE_baseNew = $4de7f0b643268d1d$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $4de7f0b643268d1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "RadioChecked".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for the selected state of radio controls.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4de7f0b643268d1d$var$RadioCheckedIcon = (props)=>/*#__PURE__*/ $4de7f0b643268d1d$var$_react.default.createElement($4de7f0b643268d1d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
    }, props));
$4de7f0b643268d1d$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
var $4de7f0b643268d1d$var$_default = module.exports.default = $4de7f0b643268d1d$var$RadioCheckedIcon;

});

parcelRegister("8MIqA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $665544e257da156c$var$_react = $665544e257da156c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $665544e257da156c$var$_radioChecked = $665544e257da156c$var$_interopRequireDefault((parcelRequire("6GGTE")));
function $665544e257da156c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $665544e257da156c$var$RadioIcon = (props)=>/*#__PURE__*/ $665544e257da156c$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $665544e257da156c$var$_radioChecked.default
    }));
$665544e257da156c$var$RadioIcon.displayName = 'RadioIcon';
var $665544e257da156c$var$_default = module.exports.default = $665544e257da156c$var$RadioIcon;

});


parcelRegister("851U9", function(module, exports) {

$parcel$export(module.exports, "getResolutionIcons", () => $b63068b3f418e7aa$export$e9550187a88e57a5);

var $eUqFw = parcelRequire("eUqFw");

var $754Ex = parcelRequire("754Ex");

var $jK61f = parcelRequire("jK61f");

var $lO4Or = parcelRequire("lO4Or");
const $b63068b3f418e7aa$export$e9550187a88e57a5 = (size)=>({
        [(0, $lO4Or.RESOLUTION_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($754Ex))), {
            color: "currentColor",
            LEGACY_size: size,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jK61f))),
            label: ""
        })
    });

});
parcelRegister("jK61f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5f6fb73c3fb2460$var$_react = $e5f6fb73c3fb2460$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $e5f6fb73c3fb2460$var$_checkMark = $e5f6fb73c3fb2460$var$_interopRequireDefault((parcelRequire("754Ex")));
function $e5f6fb73c3fb2460$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e5f6fb73c3fb2460$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $e5f6fb73c3fb2460$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $e5f6fb73c3fb2460$var$_checkMark.default
    }));
$e5f6fb73c3fb2460$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $e5f6fb73c3fb2460$var$_default = module.exports.default = $e5f6fb73c3fb2460$var$EditorDoneIcon;

});


parcelRegister("cLwpi", function(module, exports) {

$parcel$export(module.exports, "getStatusCategoryIcons", () => $77e71eb554926895$export$f263f5d2ca3dcccb);

var $eUqFw = parcelRequire("eUqFw");

var $8gFiS = parcelRequire("8gFiS");

var $lqLrE = parcelRequire("lqLrE");

var $lO4Or = parcelRequire("lO4Or");
const $77e71eb554926895$export$f263f5d2ca3dcccb = (size)=>({
        [(0, $lO4Or.STATUS_CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8gFiS))), {
            color: "currentColor",
            LEGACY_size: size,
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lqLrE)))
        })
    });

});
parcelRegister("8gFiS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bad58b909cb020b76e214ca91cc8be6d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $604fdb59c03ece2d$var$_react = $604fdb59c03ece2d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $604fdb59c03ece2d$var$_UNSAFE_baseNew = $604fdb59c03ece2d$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $604fdb59c03ece2d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Lozenge".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting status lozenges in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $604fdb59c03ece2d$var$LozengeIcon = (props)=>/*#__PURE__*/ $604fdb59c03ece2d$var$_react.default.createElement($604fdb59c03ece2d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M3 8h10M2 11.25h12c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25H2C1.31 4.75.75 5.31.75 6v4c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$604fdb59c03ece2d$var$LozengeIcon.displayName = 'LozengeIcon';
var $604fdb59c03ece2d$var$_default = module.exports.default = $604fdb59c03ece2d$var$LozengeIcon;

});

parcelRegister("lqLrE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9a0d44091c80944$var$_react = $f9a0d44091c80944$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");
function $f9a0d44091c80944$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f9a0d44091c80944$var$StatusIcon = (props)=>/*#__PURE__*/ $f9a0d44091c80944$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M4 5h16c1.105 0 2 1.045 2 2.333v9.334C22 17.955 21.105 19 20 19H4c-1.105 0-2-1.045-2-2.333V7.333C2 6.045 2.895 5 4 5m3.465 9.887h1.278L6.786 9.251H5.399l-1.957 5.636h1.183l.434-1.343h1.98zM6.02 10.423h.07l.7 2.21H5.313zm6.215 4.464c1.203 0 1.95-.625 1.95-1.613 0-.726-.544-1.289-1.29-1.344v-.07a1.22 1.22 0 0 0 1.02-1.203c0-.871-.653-1.406-1.747-1.406H9.704v5.636zm-1.352-4.734h.985c.562 0 .886.27.886.719 0 .453-.347.715-.984.715h-.887zm0 3.832v-1.601h1.024c.695 0 1.074.273 1.074.789 0 .527-.367.812-1.047.812zm6.762 1.047c1.36 0 2.352-.84 2.45-2.059h-1.15c-.112.621-.62 1.02-1.296 1.02-.89 0-1.441-.738-1.441-1.926s.55-1.922 1.437-1.922c.672 0 1.184.426 1.297 1.074h1.148c-.086-1.226-1.109-2.113-2.445-2.113-1.637 0-2.645 1.13-2.645 2.961 0 1.836 1.012 2.965 2.645 2.965"/></svg>`
    }, props));
$f9a0d44091c80944$var$StatusIcon.displayName = 'StatusIcon';
var $f9a0d44091c80944$var$_default = module.exports.default = $f9a0d44091c80944$var$StatusIcon;

});


parcelRegister("6wPXB", function(module, exports) {

$parcel$export(module.exports, "getTeamIcons", () => $38769f2763823b24$export$b7d8ffd86073bea);

var $eUqFw = parcelRequire("eUqFw");

var $83pdF = parcelRequire("83pdF");

var $3ZqJZ = parcelRequire("3ZqJZ");

var $lO4Or = parcelRequire("lO4Or");
const $38769f2763823b24$export$b7d8ffd86073bea = (size)=>({
        [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($83pdF))), {
            color: "currentColor",
            LEGACY_size: size,
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3ZqJZ)))
        })
    });

});
parcelRegister("3ZqJZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e7bcfbe8038bf28$var$_react = $2e7bcfbe8038bf28$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $2e7bcfbe8038bf28$var$_teams = $2e7bcfbe8038bf28$var$_interopRequireDefault((parcelRequire("83pdF")));
function $2e7bcfbe8038bf28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2e7bcfbe8038bf28$var$TeamsIcon = (props)=>/*#__PURE__*/ $2e7bcfbe8038bf28$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9 7.2a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m7.8 0a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m1.2 9.3a4.5 4.5 0 0 0-4.5-4.5h-1.378c-.484 0-1.275.127-1.875.41l.77 1.627c.14-.066.342-.129.566-.174s.421-.063.539-.063H17.1a2.7 2.7 0 0 1 2.7 2.7V18a.6.6 0 0 1-.6.6h-3.478a2.7 2.7 0 0 1-2.538-1.777l-.676-1.86A4.5 4.5 0 0 0 8.278 12H6.9a4.5 4.5 0 0 0-4.5 4.5V18a2.4 2.4 0 0 0 2.4 2.4h4.8v-1.8H4.8a.6.6 0 0 1-.6-.6v-1.5a2.7 2.7 0 0 1 2.7-2.7h1.378a2.7 2.7 0 0 1 2.538 1.777l.676 1.86a4.5 4.5 0 0 0 4.23 2.963H19.2a2.4 2.4 0 0 0 2.4-2.4z" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $2e7bcfbe8038bf28$var$_teams.default
    }));
$2e7bcfbe8038bf28$var$TeamsIcon.displayName = 'TeamsIcon';
var $2e7bcfbe8038bf28$var$_default = module.exports.default = $2e7bcfbe8038bf28$var$TeamsIcon;

});


parcelRegister("46tzp", function(module, exports) {

$parcel$export(module.exports, "getVersionIcons", () => $fc9004aee8bf2947$export$5c5f41529027464e);

var $eUqFw = parcelRequire("eUqFw");

var $dqOgP = parcelRequire("dqOgP");

var $atcKw = parcelRequire("atcKw");

var $lO4Or = parcelRequire("lO4Or");
const $fc9004aee8bf2947$export$5c5f41529027464e = (size)=>({
        [(0, $lO4Or.VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dqOgP))), {
            color: "currentColor",
            LEGACY_size: size,
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($atcKw)))
        }),
        [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dqOgP))), {
            color: "currentColor",
            LEGACY_size: size,
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($atcKw)))
        }),
        [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dqOgP))), {
            color: "currentColor",
            LEGACY_size: size,
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($atcKw)))
        }),
        [(0, $lO4Or.FIX_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dqOgP))), {
            color: "currentColor",
            LEGACY_size: size,
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($atcKw)))
        })
    });

});

parcelRegister("4wZzs", function(module, exports) {

$parcel$export(module.exports, "getLegacyFieldIcons", () => $96cd876843d12f51$export$eddca397cc46c15);

var $eUqFw = parcelRequire("eUqFw");

var $6P5Fq = parcelRequire("6P5Fq");

var $9F3sn = parcelRequire("9F3sn");

var $4FXt1 = parcelRequire("4FXt1");

var $lnfUw = parcelRequire("lnfUw");

var $fjxUS = parcelRequire("fjxUS");

var $6o6zs = parcelRequire("6o6zs");

var $23xSg = parcelRequire("23xSg");

var $2eF7l = parcelRequire("2eF7l");

var $fL9TV = parcelRequire("fL9TV");

var $62nZV = parcelRequire("62nZV");

var $1izGX = parcelRequire("1izGX");

var $9O3iN = parcelRequire("9O3iN");

var $dylHY = parcelRequire("dylHY");

var $bQ7Vu = parcelRequire("bQ7Vu");

var $c3JCd = parcelRequire("c3JCd");

var $giBik = parcelRequire("giBik");

var $hHOor = parcelRequire("hHOor");

var $jbBmm = parcelRequire("jbBmm");

var $3g3O0 = parcelRequire("3g3O0");

var $ltohm = parcelRequire("ltohm");

var $9d689 = parcelRequire("9d689");

var $eDBer = parcelRequire("eDBer");

var $2CGqh = parcelRequire("2CGqh");

var $6Ax6f = parcelRequire("6Ax6f");

var $8VLK2 = parcelRequire("8VLK2");

var $5nchA = parcelRequire("5nchA");

var $6FUS2 = parcelRequire("6FUS2");

var $f9U0l = parcelRequire("f9U0l");

var $e1BYB = parcelRequire("e1BYB");

var $jLPSC = parcelRequire("jLPSC");

var $dMWn6 = parcelRequire("dMWn6");

var $fcbZt = parcelRequire("fcbZt");

var $2MfFx = parcelRequire("2MfFx");

var $3Cdnl = parcelRequire("3Cdnl");

var $fNk5U = parcelRequire("fNk5U");

var $f2oqw = parcelRequire("f2oqw");

var $9HZ5N = parcelRequire("9HZ5N");

var $lCxcH = parcelRequire("lCxcH");

var $2KwA9 = parcelRequire("2KwA9");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");

var $8rQuz = parcelRequire("8rQuz");
const $96cd876843d12f51$var$PriorityIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20ZM12 18.2222C15.4364 18.2222 18.2222 15.4364 18.2222 12C18.2222 8.56356 15.4364 5.77778 12 5.77778C8.56356 5.77778 5.77778 8.56356 5.77778 12C5.77778 15.4364 8.56356 18.2222 12 18.2222ZM14.1219 13.5914L14.0381 13.5174L12 11.48L9.96186 13.5174C9.64143 13.8378 9.13725 13.8625 8.78855 13.5914L8.70481 13.5174C8.38438 13.197 8.35973 12.6928 8.63086 12.3441L8.70481 12.2604L11.3715 9.5937C11.6919 9.27327 12.1961 9.24861 12.5448 9.51975L12.6285 9.5937L15.2952 12.2604C15.6423 12.6075 15.6423 13.1703 15.2952 13.5174C14.9748 13.8378 14.4706 13.8625 14.1219 13.5914Z",
        fill: "currentColor"
    }));
const $96cd876843d12f51$var$StatusIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM18.2222 12C18.2222 8.56356 15.4364 5.77778 12 5.77778C8.56356 5.77778 5.77778 8.56356 5.77778 12C5.77778 15.4364 8.56356 18.2222 12 18.2222C15.4364 18.2222 18.2222 15.4364 18.2222 12ZM15.3664 11.4518L15.2952 11.3715C15.3267 11.4029 15.3553 11.4362 15.381 11.4708C15.3969 11.4923 15.4118 11.5144 15.4257 11.5372C15.4324 11.5479 15.4386 11.5588 15.4447 11.5697C15.4544 11.5873 15.4637 11.6054 15.4723 11.6239C15.4794 11.639 15.486 11.6544 15.4922 11.6699C15.4993 11.6875 15.5057 11.7051 15.5115 11.7229C15.5158 11.7361 15.5199 11.7498 15.5237 11.7636C15.5291 11.7827 15.5337 11.802 15.5377 11.8215C15.5407 11.837 15.5434 11.8525 15.5457 11.868C15.5483 11.8849 15.5504 11.9024 15.552 11.92C15.5539 11.9416 15.555 11.9626 15.5554 11.9837C15.5555 11.9886 15.5556 11.9943 15.5556 12L15.5554 12.0172C15.555 12.0382 15.5539 12.0593 15.552 12.0802L15.5556 12C15.5556 12.0439 15.5524 12.087 15.5462 12.1292C15.5436 12.1467 15.5404 12.1648 15.5366 12.1829C15.5331 12.1999 15.5293 12.2162 15.5249 12.2323C15.521 12.2463 15.5168 12.2606 15.5122 12.2748C15.5059 12.2943 15.4989 12.3135 15.4913 12.3325C15.4855 12.3467 15.4795 12.3606 15.4731 12.3744C15.4639 12.3941 15.4539 12.4138 15.4431 12.4331C15.438 12.4423 15.4326 12.4517 15.4269 12.461C15.4135 12.4829 15.3993 12.5041 15.3843 12.5246C15.3793 12.5315 15.3743 12.5382 15.3691 12.5448C15.3528 12.5655 15.3393 12.5815 15.3252 12.597L15.2952 12.6285L12.6285 15.2952C12.2814 15.6423 11.7186 15.6423 11.3715 15.2952C11.051 14.9748 11.0264 14.4706 11.2975 14.1219L11.3715 14.0381L12.52 12.8889H9.33333C8.84241 12.8889 8.44444 12.4909 8.44444 12C8.44444 11.5468 8.78355 11.1729 9.22184 11.118L9.33333 11.1111H12.5218L11.3715 9.96187C11.051 9.64144 11.0264 9.13724 11.2975 8.78853L11.3715 8.70479C11.6919 8.38436 12.1961 8.35971 12.5448 8.63085L12.6285 8.70479L15.2977 11.374C15.3221 11.3985 15.345 11.4245 15.3664 11.4518Z",
        fill: "currentColor"
    }));
// Custom icon not from Atlaskit
const $96cd876843d12f51$var$NumberGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $96cd876843d12f51$var$TypeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.9299 7C10.9299 6.44772 11.3776 6 11.9299 6C12.4822 6 12.9299 6.44772 12.9299 7V10.268L15.76 8.63397C16.2383 8.35783 16.8499 8.5217 17.1261 9C17.4022 9.47829 17.2383 10.0899 16.76 10.366L13.9299 12L16.76 13.634C17.2383 13.9101 17.4022 14.5217 17.1261 15C16.8499 15.4783 16.2383 15.6422 15.76 15.366L12.9299 13.732V17C12.9299 17.5523 12.4822 18 11.9299 18C11.3776 18 10.9299 17.5523 10.9299 17V13.7321L8.09978 15.366C7.62148 15.6422 7.00989 15.4783 6.73375 15C6.45761 14.5217 6.62148 13.9101 7.09978 13.634L9.9299 12L7.09978 10.366C6.62148 10.0899 6.45761 9.47829 6.73375 9C7.00989 8.5217 7.62148 8.35783 8.09978 8.63397L10.9299 10.2679V7Z",
        fill: "currentColor"
    }));
const $96cd876843d12f51$var$KeyIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 6C9.44772 6 9 6.44772 9 7V9H7C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H9V13H7C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H9V17C9 17.5523 9.44772 18 10 18C10.5523 18 11 17.5523 11 17V15H13V17C13 17.5523 13.4477 18 14 18C14.5523 18 15 17.5523 15 17V15H17C17.5523 15 18 14.5523 18 14C18 13.4477 17.5523 13 17 13H15V11H17C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9H15V7C15 6.44772 14.5523 6 14 6C13.4477 6 13 6.44772 13 7V9H11V7C11 6.44772 10.5523 6 10 6ZM13 13V11H11V13H13Z",
        fill: "currentColor"
    }));
const $96cd876843d12f51$var$EpicIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.5 6C17.3284 6 18 6.67157 18 7.5V16.5C18 17.3284 17.3284 18 16.5 18H7.5C6.67157 18 6 17.3284 6 16.5V7.5C6 6.67157 6.67157 6 7.5 6H16.5ZM12.375 8.25C12.2625 8.25 12.165 8.30175 12.096 8.37975L9.11175 12.1088C9.1095 12.111 9.08475 12.1425 9.08475 12.1425C9.03525 12.2092 9 12.2865 9 12.375C9 12.582 9.168 12.75 9.375 12.75C9.396 12.75 9.41325 12.7537 9.43275 12.75H11.25V15.375C11.25 15.582 11.418 15.75 11.625 15.75C11.718 15.75 11.8005 15.7125 11.8658 15.657C11.8658 15.657 11.9123 15.6068 11.9295 15.582L14.88 11.8972C14.8943 11.8837 14.9033 11.868 14.9153 11.8522L14.9355 11.8275C14.9722 11.7667 15 11.7 15 11.625C15 11.418 14.832 11.25 14.625 11.25H12.75V8.625C12.75 8.418 12.582 8.25 12.375 8.25Z",
        fill: "currentColor"
    }));
const $96cd876843d12f51$var$renderChevronDownIcon = ({ size: size })=>(0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $96cd876843d12f51$var$iconSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2KwA9))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2KwA9))), {
        LEGACY_size: size,
        color: "currentColor",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9d689))),
        label: ""
    });
const $96cd876843d12f51$export$eddca397cc46c15 = ({ size: size })=>({
        key: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$KeyIcon, null),
        [(0, $lO4Or.ISSUE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$TypeIcon, null),
        [(0, $lO4Or.SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6P5Fq))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ax6f))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.STATUS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$StatusIcon, null),
        [(0, $lO4Or.ASSIGNEE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($62nZV))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5nchA))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.LABELS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hHOor))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jLPSC))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.DUE_DATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9F3sn))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3g3O0))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.CREATED)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9F3sn))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3g3O0))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.UPDATED)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9F3sn))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3g3O0))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.RESOLUTION_DATE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9F3sn))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3g3O0))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.PRIORITY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$PriorityIcon, null),
        [(0, $lO4Or.REPORTER_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($62nZV))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5nchA))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.TEXT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jbBmm))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($f9U0l))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.URL_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fL9TV))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8VLK2))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bQ7Vu))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fNk5U))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6P5Fq))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ax6f))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.SELECT_CF_TYPE)]: $96cd876843d12f51$var$renderChevronDownIcon({
            size: size
        }),
        [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: $96cd876843d12f51$var$renderChevronDownIcon({
            size: size
        }),
        [(0, $lO4Or.DATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9F3sn))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3g3O0))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$NumberGlyph, null),
        [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lnfUw))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6FUS2))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.MULTI_USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dylHY))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3Cdnl))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.DATETIME_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lnfUw))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($f2oqw))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.COMPONENTS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6o6zs))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2CGqh))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.STORY_POINTS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$NumberGlyph, null),
        [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$NumberGlyph, null),
        [(0, $lO4Or.LABELS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hHOor))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jLPSC))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.PEOPLE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dylHY))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3Cdnl))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.SUBTASKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($giBik))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lCxcH))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1izGX))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fcbZt))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.EPIC_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$EpicIcon, null),
        [(0, $lO4Or.COMMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fjxUS))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($eDBer))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $jGcn0.COMMENT_SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fjxUS))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($eDBer))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4FXt1))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ltohm))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.SPRINT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c3JCd))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9HZ5N))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9O3iN))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2MfFx))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $lO4Or.ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2eF7l))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($e1BYB))),
            LEGACY_size: size,
            label: ""
        }),
        [(0, $jGcn0.CARD_COVERS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23xSg))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($dMWn6))),
            LEGACY_size: size,
            label: ""
        })
    });
const $96cd876843d12f51$var$iconSpacing = (0, $8Vv3m.xcss)({
    margin: 'space.075',
    marginTop: 'space.050'
});

});
parcelRegister("6P5Fq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b38d718ca9f4aa1019c5485273ebd51>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f7be6dd0d9445cd$var$_react = $4f7be6dd0d9445cd$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $4f7be6dd0d9445cd$var$_UNSAFE_baseNew = $4f7be6dd0d9445cd$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $4f7be6dd0d9445cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AlignLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4f7be6dd0d9445cd$var$AlignLeftIcon = (props)=>/*#__PURE__*/ $4f7be6dd0d9445cd$var$_react.default.createElement($4f7be6dd0d9445cd$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 2.75h14M1 13.25h7M1 8h14"/>`
    }, props));
$4f7be6dd0d9445cd$var$AlignLeftIcon.displayName = 'AlignLeftIcon';
var $4f7be6dd0d9445cd$var$_default = module.exports.default = $4f7be6dd0d9445cd$var$AlignLeftIcon;

});

parcelRegister("4FXt1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d440225cc59c6a59918c0efc489d2095>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36791eb4f08821a7$var$_react = $36791eb4f08821a7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $36791eb4f08821a7$var$_UNSAFE_baseNew = $36791eb4f08821a7$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $36791eb4f08821a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36791eb4f08821a7$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $36791eb4f08821a7$var$_react.default.createElement($36791eb4f08821a7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$36791eb4f08821a7$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $36791eb4f08821a7$var$_default = module.exports.default = $36791eb4f08821a7$var$CheckboxCheckedIcon;

});

parcelRegister("fjxUS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::36758847330c30e3d31c155e38099f5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b262f06fa00d6aa1$var$_react = $b262f06fa00d6aa1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b262f06fa00d6aa1$var$_UNSAFE_baseNew = $b262f06fa00d6aa1$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $b262f06fa00d6aa1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b262f06fa00d6aa1$var$CommentIcon = (props)=>/*#__PURE__*/ $b262f06fa00d6aa1$var$_react.default.createElement($b262f06fa00d6aa1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M4.25 13.25v-.75h-.2l-.172.099zm-3.5 2H0a.75.75 0 0 0 1.122.651zM2.625 2h10.75V.5H2.625zM14.5 3.125v8.25H16v-8.25zM13.375 12.5H4.25V14h9.125zm-9.497.099-3.5 2 .744 1.302 3.5-2zM1.5 15.25V3.125H0V15.25zM4 6.5h8V5H4zm0 3h5V8H4zm10.5 1.875c0 .621-.504 1.125-1.125 1.125V14A2.625 2.625 0 0 0 16 11.375zM13.375 2c.621 0 1.125.504 1.125 1.125H16A2.625 2.625 0 0 0 13.375.5zM2.625.5A2.625 2.625 0 0 0 0 3.125h1.5C1.5 2.504 2.004 2 2.625 2z"/>`
    }, props));
$b262f06fa00d6aa1$var$CommentIcon.displayName = 'CommentIcon';
var $b262f06fa00d6aa1$var$_default = module.exports.default = $b262f06fa00d6aa1$var$CommentIcon;

});

parcelRegister("6o6zs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::59539b0a20baabf49e61d8eee48596e5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a6a14d48bfd5ba7$var$_react = $4a6a14d48bfd5ba7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $4a6a14d48bfd5ba7$var$_UNSAFE_baseNew = $4a6a14d48bfd5ba7$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $4a6a14d48bfd5ba7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Component".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for components in Jira and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4a6a14d48bfd5ba7$var$ComponentIcon = (props)=>/*#__PURE__*/ $4a6a14d48bfd5ba7$var$_react.default.createElement($4a6a14d48bfd5ba7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.75 5.25H2c-.69 0-1.25.56-1.25 1.25V12c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V6.5c0-.69-.56-1.25-1.25-1.25h-.75m-10.5 0v-2.5h3.5v2.5m-3.5 0h3.5m0 0h3.5m0 0v-2.5h3.5v2.5m-3.5 0h3.5"/>`
    }, props));
$4a6a14d48bfd5ba7$var$ComponentIcon.displayName = 'ComponentIcon';
var $4a6a14d48bfd5ba7$var$_default = module.exports.default = $4a6a14d48bfd5ba7$var$ComponentIcon;

});

parcelRegister("23xSg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00d261b1bfdc09ff1b2f03c198e27896>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17f62350612690ed$var$_react = $17f62350612690ed$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $17f62350612690ed$var$_UNSAFE_baseNew = $17f62350612690ed$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $17f62350612690ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $17f62350612690ed$var$ImageIcon = (props)=>/*#__PURE__*/ $17f62350612690ed$var$_react.default.createElement($17f62350612690ed$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.75 5.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path fill="currentcolor" fill-rule="evenodd" d="M5.75 6.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 14.25h9c.69 0 1.25-.56 1.25-1.25v-2M4 14.25H3c-.69 0-1.25-.56-1.25-1.25V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v8M4 14.25 10 7l4.25 4m-7.5-5.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"/>`
    }, props));
$17f62350612690ed$var$ImageIcon.displayName = 'ImageIcon';
var $17f62350612690ed$var$_default = module.exports.default = $17f62350612690ed$var$ImageIcon;

});

parcelRegister("62nZV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::801e4e41323f7f60b70ce771f39d0636>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $46558b6d9838db25$var$_react = $46558b6d9838db25$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $46558b6d9838db25$var$_UNSAFE_baseNew = $46558b6d9838db25$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $46558b6d9838db25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Mention".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user mentions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $46558b6d9838db25$var$MentionIcon = (props)=>/*#__PURE__*/ $46558b6d9838db25$var$_react.default.createElement($46558b6d9838db25$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linecap="square" stroke-width="1.5" d="M11.625 14.28A7.25 7.25 0 1 1 15.25 8c0 1.381-.932 3.107-2.59 3.107-1.656 0-1.782-1.976-1.782-3.357l.005-.125m0 0c.022-1.019-.42-1.956-1.258-2.44-1.315-.759-3.11-.114-4.007 1.44s-.558 3.43.757 4.19c1.315.759 3.11.115 4.007-1.44a3.7 3.7 0 0 0 .5-1.75Z"/>`
    }, props));
$46558b6d9838db25$var$MentionIcon.displayName = 'MentionIcon';
var $46558b6d9838db25$var$_default = module.exports.default = $46558b6d9838db25$var$MentionIcon;

});

parcelRegister("9O3iN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c63ce0083f2e9a73a4c7c0a839641a58>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $723b5852b3658719$var$_react = $723b5852b3658719$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $723b5852b3658719$var$_UNSAFE_baseNew = $723b5852b3658719$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $723b5852b3658719$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $723b5852b3658719$var$PageIcon = (props)=>/*#__PURE__*/ $723b5852b3658719$var$_react.default.createElement($723b5852b3658719$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$723b5852b3658719$var$PageIcon.displayName = 'PageIcon';
var $723b5852b3658719$var$_default = module.exports.default = $723b5852b3658719$var$PageIcon;

});

parcelRegister("c3JCd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ac782676a50cd4df56827dce883b620>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c79261a5d22f60a$var$_react = $8c79261a5d22f60a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $8c79261a5d22f60a$var$_UNSAFE_baseNew = $8c79261a5d22f60a$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $8c79261a5d22f60a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Sprint".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8c79261a5d22f60a$var$SprintIcon = (props)=>/*#__PURE__*/ $8c79261a5d22f60a$var$_react.default.createElement($8c79261a5d22f60a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.5 6.25a5.5 5.5 0 1 0-5.5 5.5m0 0H0m8 0h6.75m-3-3.5 3.5 3.5-3.5 3.5"/>`
    }, props));
$8c79261a5d22f60a$var$SprintIcon.displayName = 'SprintIcon';
var $8c79261a5d22f60a$var$_default = module.exports.default = $8c79261a5d22f60a$var$SprintIcon;

});

parcelRegister("hHOor", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45c2d4e51182b362766f8bfa1893feb7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce3d8adccddccc90$var$_react = $ce3d8adccddccc90$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ce3d8adccddccc90$var$_UNSAFE_baseNew = $ce3d8adccddccc90$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $ce3d8adccddccc90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce3d8adccddccc90$var$TagIcon = (props)=>/*#__PURE__*/ $ce3d8adccddccc90$var$_react.default.createElement($ce3d8adccddccc90$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8.768 1.75H13c.69 0 1.25.56 1.25 1.25v4.232c0 .332-.132.65-.366.884l-5.75 5.75a1.25 1.25 0 0 1-1.768 0L2.134 9.634a1.25 1.25 0 0 1 0-1.768l5.75-5.75a1.25 1.25 0 0 1 .884-.366Z"/><rect width="2" height="2" x="10" y="4" fill="currentcolor" rx="1"/>`
    }, props));
$ce3d8adccddccc90$var$TagIcon.displayName = 'TagIcon';
var $ce3d8adccddccc90$var$_default = module.exports.default = $ce3d8adccddccc90$var$TagIcon;

});

parcelRegister("3g3O0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25f5d16cdb026daf$var$_react = $25f5d16cdb026daf$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $25f5d16cdb026daf$var$_calendar = $25f5d16cdb026daf$var$_interopRequireDefault((parcelRequire("9F3sn")));
function $25f5d16cdb026daf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25f5d16cdb026daf$var$CalendarIcon = (props)=>/*#__PURE__*/ $25f5d16cdb026daf$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $25f5d16cdb026daf$var$_calendar.default
    }));
$25f5d16cdb026daf$var$CalendarIcon.displayName = 'CalendarIcon';
var $25f5d16cdb026daf$var$_default = module.exports.default = $25f5d16cdb026daf$var$CalendarIcon;

});

parcelRegister("ltohm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa1f23b31d9ac31f$var$_react = $fa1f23b31d9ac31f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $fa1f23b31d9ac31f$var$_checkboxChecked = $fa1f23b31d9ac31f$var$_interopRequireDefault((parcelRequire("4FXt1")));
function $fa1f23b31d9ac31f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fa1f23b31d9ac31f$var$CheckboxIcon = (props)=>/*#__PURE__*/ $fa1f23b31d9ac31f$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $fa1f23b31d9ac31f$var$_checkboxChecked.default
    }));
$fa1f23b31d9ac31f$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $fa1f23b31d9ac31f$var$_default = module.exports.default = $fa1f23b31d9ac31f$var$CheckboxIcon;

});

parcelRegister("9d689", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b4a155a1f886062$var$_react = $6b4a155a1f886062$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $6b4a155a1f886062$var$_chevronDown = $6b4a155a1f886062$var$_interopRequireDefault((parcelRequire("2KwA9")));
function $6b4a155a1f886062$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6b4a155a1f886062$var$ChevronDownCircleIcon = (props)=>/*#__PURE__*/ $6b4a155a1f886062$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></g></svg>`
    }, props, {
        newIcon: $6b4a155a1f886062$var$_chevronDown.default,
        iconType: "utility"
    }));
$6b4a155a1f886062$var$ChevronDownCircleIcon.displayName = 'ChevronDownCircleIcon';
var $6b4a155a1f886062$var$_default = module.exports.default = $6b4a155a1f886062$var$ChevronDownCircleIcon;

});

parcelRegister("eDBer", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa8196b0d3d71ab1$var$_react = $aa8196b0d3d71ab1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $aa8196b0d3d71ab1$var$_comment = $aa8196b0d3d71ab1$var$_interopRequireDefault((parcelRequire("fjxUS")));
function $aa8196b0d3d71ab1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $aa8196b0d3d71ab1$var$CommentIcon = (props)=>/*#__PURE__*/ $aa8196b0d3d71ab1$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props, {
        newIcon: $aa8196b0d3d71ab1$var$_comment.default
    }));
$aa8196b0d3d71ab1$var$CommentIcon.displayName = 'CommentIcon';
var $aa8196b0d3d71ab1$var$_default = module.exports.default = $aa8196b0d3d71ab1$var$CommentIcon;

});

parcelRegister("2CGqh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e9009a7d35da266$var$_react = $1e9009a7d35da266$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $1e9009a7d35da266$var$_component = $1e9009a7d35da266$var$_interopRequireDefault((parcelRequire("6o6zs")));
function $1e9009a7d35da266$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1e9009a7d35da266$var$ComponentIcon = (props)=>/*#__PURE__*/ $1e9009a7d35da266$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991M3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 17.991z"/><path d="M7 8.34h2V6.67H7zM5 6.67C5 5.75 5.9 5 7 5h2c1.11 0 2 .75 2 1.67v1.67c0 .92-.9 1.66-2 1.66H7c-1.11 0-2-.75-2-1.66zm10 1.67h2V6.67h-2zm-2-1.67c0-.92.9-1.67 2-1.67h2c1.11 0 2 .75 2 1.67v1.67c0 .92-.9 1.67-2 1.67h-2c-1.11-.01-2-.76-2-1.67z"/></g></svg>`
    }, props, {
        newIcon: $1e9009a7d35da266$var$_component.default
    }));
$1e9009a7d35da266$var$ComponentIcon.displayName = 'ComponentIcon';
var $1e9009a7d35da266$var$_default = module.exports.default = $1e9009a7d35da266$var$ComponentIcon;

});

parcelRegister("6Ax6f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4cbfc7cd7a214c63$var$_react = $4cbfc7cd7a214c63$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $4cbfc7cd7a214c63$var$_alignLeft = $4cbfc7cd7a214c63$var$_interopRequireDefault((parcelRequire("6P5Fq")));
function $4cbfc7cd7a214c63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4cbfc7cd7a214c63$var$EditorAlignLeftIcon = (props)=>/*#__PURE__*/ $4cbfc7cd7a214c63$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m0 4h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2m0 4h5a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $4cbfc7cd7a214c63$var$_alignLeft.default
    }));
$4cbfc7cd7a214c63$var$EditorAlignLeftIcon.displayName = 'EditorAlignLeftIcon';
var $4cbfc7cd7a214c63$var$_default = module.exports.default = $4cbfc7cd7a214c63$var$EditorAlignLeftIcon;

});

parcelRegister("8VLK2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6808ae1162d8604c$var$_react = $6808ae1162d8604c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $6808ae1162d8604c$var$_link = $6808ae1162d8604c$var$_interopRequireDefault((parcelRequire("fL9TV")));
function $6808ae1162d8604c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6808ae1162d8604c$var$EditorLinkIcon = (props)=>/*#__PURE__*/ $6808ae1162d8604c$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a2 2 0 0 0-.001-2.831 2 2 0 0 0-2.83 0zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a2 2 0 0 0 .001 2.831 2 2 0 0 0 2.83 0z"/></svg>`
    }, props, {
        newIcon: $6808ae1162d8604c$var$_link.default
    }));
$6808ae1162d8604c$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
var $6808ae1162d8604c$var$_default = module.exports.default = $6808ae1162d8604c$var$EditorLinkIcon;

});

parcelRegister("5nchA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e98a0d4918a06b0$var$_react = $3e98a0d4918a06b0$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $3e98a0d4918a06b0$var$_mention = $3e98a0d4918a06b0$var$_interopRequireDefault((parcelRequire("62nZV")));
function $3e98a0d4918a06b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e98a0d4918a06b0$var$EditorMentionIcon = (props)=>/*#__PURE__*/ $3e98a0d4918a06b0$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.062 13.93c-.904 0-1.451-.734-1.451-1.945 0-1.226.538-1.952 1.467-1.952.928 0 1.422.764 1.422 1.967 0 1.195-.502 1.93-1.438 1.93M12 5c-3.925 0-7 3.075-7 7 0 4.596 3.521 7 7 7 .874 0 1.613-.09 2.258-.279a.751.751 0 0 0-.42-1.44c-.506.147-1.108.22-1.838.22-2.649 0-5.5-1.722-5.5-5.5 0-3.085 2.415-5.5 5.5-5.5 3.239 0 5.5 1.952 5.5 4.75 0 2.045-1.044 3-1.75 3-.007 0-.75-.11-.75-.75v-4a.75.75 0 1 0-1.5 0v.187c-.347-.585-1.017-.952-1.796-.952C10.103 8.736 9 10.04 9 11.938c0 1.984 1.103 3.312 2.753 3.312.865 0 1.51-.387 1.865-1.076.334 1.016 1.37 1.576 2.132 1.576 1.598 0 3.25-1.683 3.25-4.5C19 7.628 16.058 5 12 5"/></svg>`
    }, props, {
        newIcon: $3e98a0d4918a06b0$var$_mention.default
    }));
$3e98a0d4918a06b0$var$EditorMentionIcon.displayName = 'EditorMentionIcon';
var $3e98a0d4918a06b0$var$_default = module.exports.default = $3e98a0d4918a06b0$var$EditorMentionIcon;

});

parcelRegister("6FUS2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4dc2afb3dd65f211$var$_react = $4dc2afb3dd65f211$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $4dc2afb3dd65f211$var$_clock = $4dc2afb3dd65f211$var$_interopRequireDefault((parcelRequire("lnfUw")));
function $4dc2afb3dd65f211$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4dc2afb3dd65f211$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $4dc2afb3dd65f211$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
    }, props, {
        newIcon: $4dc2afb3dd65f211$var$_clock.default
    }));
$4dc2afb3dd65f211$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
var $4dc2afb3dd65f211$var$_default = module.exports.default = $4dc2afb3dd65f211$var$EmojiFrequentIcon;

});

parcelRegister("jLPSC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e64aa6602eeda9dc$var$_react = $e64aa6602eeda9dc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $e64aa6602eeda9dc$var$_tag = $e64aa6602eeda9dc$var$_interopRequireDefault((parcelRequire("hHOor")));
function $e64aa6602eeda9dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e64aa6602eeda9dc$var$LabelIcon = (props)=>/*#__PURE__*/ $e64aa6602eeda9dc$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.433 5.428-4.207.6A2 2 0 0 0 5.53 7.727l-.6 4.207a1 1 0 0 0 .281.849l6.895 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283m-.647 5.858A1.666 1.666 0 1 1 8.43 8.929a1.666 1.666 0 0 1 2.357 2.357"/></svg>`
    }, props, {
        newIcon: $e64aa6602eeda9dc$var$_tag.default
    }));
$e64aa6602eeda9dc$var$LabelIcon.displayName = 'LabelIcon';
var $e64aa6602eeda9dc$var$_default = module.exports.default = $e64aa6602eeda9dc$var$LabelIcon;

});

parcelRegister("dMWn6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a09d09720a118d07$var$_react = $a09d09720a118d07$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $a09d09720a118d07$var$_image = $a09d09720a118d07$var$_interopRequireDefault((parcelRequire("23xSg")));
function $a09d09720a118d07$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a09d09720a118d07$var$MediaServicesScaleLargeIcon = (props)=>/*#__PURE__*/ $a09d09720a118d07$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 6.007v11.986C5 18.55 5.45 19 6.007 19h11.986C18.55 19 19 18.55 19 17.993V6.007C19 5.45 18.55 5 17.993 5H6.007C5.45 5 5 5.45 5 6.007m-2 0A3.006 3.006 0 0 1 6.007 3h11.986A3.006 3.006 0 0 1 21 6.007v11.986A3.006 3.006 0 0 1 17.993 21H6.007A3.006 3.006 0 0 1 3 17.993z"/><path d="M11.005 17H16.5c.27 0 .5-.228.5-.509v-1.634a.73.73 0 0 0-.167-.44L14.5 11.85a.24.24 0 0 0-.344-.006L11 15l-.821-.821a.25.25 0 0 0-.358 0l-2.465 2.465c-.195.195-.136.356.135.356z"/><circle cx="9" cy="9" r="2"/></g></svg>`
    }, props, {
        newIcon: $a09d09720a118d07$var$_image.default
    }));
$a09d09720a118d07$var$MediaServicesScaleLargeIcon.displayName = 'MediaServicesScaleLargeIcon';
var $a09d09720a118d07$var$_default = module.exports.default = $a09d09720a118d07$var$MediaServicesScaleLargeIcon;

});

parcelRegister("2MfFx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $205c380053c34f86$var$_react = $205c380053c34f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $205c380053c34f86$var$_page = $205c380053c34f86$var$_interopRequireDefault((parcelRequire("9O3iN")));
function $205c380053c34f86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $205c380053c34f86$var$PageIcon = (props)=>/*#__PURE__*/ $205c380053c34f86$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
    }, props, {
        newIcon: $205c380053c34f86$var$_page.default
    }));
$205c380053c34f86$var$PageIcon.displayName = 'PageIcon';
var $205c380053c34f86$var$_default = module.exports.default = $205c380053c34f86$var$PageIcon;

});

parcelRegister("3Cdnl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a1f4bd309170316$var$_react = $2a1f4bd309170316$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $2a1f4bd309170316$var$_peopleGroup = $2a1f4bd309170316$var$_interopRequireDefault((parcelRequire("dylHY")));
function $2a1f4bd309170316$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2a1f4bd309170316$var$PeopleIcon = (props)=>/*#__PURE__*/ $2a1f4bd309170316$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $2a1f4bd309170316$var$_peopleGroup.default
    }));
$2a1f4bd309170316$var$PeopleIcon.displayName = 'PeopleIcon';
var $2a1f4bd309170316$var$_default = module.exports.default = $2a1f4bd309170316$var$PeopleIcon;

});

parcelRegister("9HZ5N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $711784e26ed142a7$var$_react = $711784e26ed142a7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $711784e26ed142a7$var$_sprint = $711784e26ed142a7$var$_interopRequireDefault((parcelRequire("c3JCd")));
function $711784e26ed142a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $711784e26ed142a7$var$SprintIcon = (props)=>/*#__PURE__*/ $711784e26ed142a7$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m17.717 17.137-1.436-1.438a1.003 1.003 0 0 1 1.418-1.418l3.007 3.01a1 1 0 0 1 0 1.417l-3.007 3.01a1.003 1.003 0 0 1-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 0 1 4 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a8 8 0 0 1-.789 3.451l-1.438-1.44a6.1 6.1 0 0 0 .345-2.01A6.12 6.12 0 0 0 12 4.884a6.12 6.12 0 0 0-6.118 6.125 6.12 6.12 0 0 0 5.647 6.102zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005z"/></svg>`
    }, props, {
        newIcon: $711784e26ed142a7$var$_sprint.default
    }));
$711784e26ed142a7$var$SprintIcon.displayName = 'SprintIcon';
var $711784e26ed142a7$var$_default = module.exports.default = $711784e26ed142a7$var$SprintIcon;

});



parcelRegister("fZC2L", function(module, exports) {

$parcel$export(module.exports, "default", () => $af9157298b7dc778$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $af9157298b7dc778$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    groupBySectionTitle: {
        "id": "work-management-board.header.group-selector.group-by-section-title",
        "defaultMessage": "GROUP BY"
    },
    groupByButtonAriaLabel: {
        "id": "work-management-board.header.group-selector.group-by-button-aria-label",
        "defaultMessage": "Group by {label}"
    },
    groupByButtonLabelOld: {
        "id": "work-management-board.header.group-selector.group-by-button-label-old",
        "defaultMessage": "Group by: "
    },
    groupByButtonLabel: {
        "id": "work-management-board.header.group-selector.group-by-button-label",
        "defaultMessage": "Group: "
    },
    groupByStatusLabel: {
        "id": "work-management-board.header.group-selector.group-by-status-label",
        "defaultMessage": "Status"
    },
    groupByStatusDefaultLabel: {
        "id": "work-management-board.header.group-selector.group-by-status-default-label",
        "defaultMessage": "Status (default)"
    },
    groupByPriorityLabel: {
        "id": "work-management-board.header.group-selector.group-by-priority-label",
        "defaultMessage": "Priority"
    },
    groupByAssigneeLabel: {
        "id": "work-management-board.header.group-selector.group-by-assignee-label",
        "defaultMessage": "Assignee"
    },
    groupByCategoryLabel: {
        "id": "work-management-board.header.group-selector.group-by-category-label",
        "defaultMessage": "Category"
    },
    groupBySelected: {
        "id": "work-management-board.header.group-selector.group-by-selected",
        "defaultMessage": "Selected"
    },
    clearGroup: {
        "id": "work-management-board.header.group-selector.clear-group",
        "defaultMessage": "Clear"
    },
    clearGroupLabel: {
        "id": "work-management-board.header.group-selector.clear-group-label",
        "defaultMessage": "Clear grouping"
    }
});

});


parcelRegister("aY8Rm", function(module, exports) {

$parcel$export(module.exports, "default", () => $557c5b215a8b86ea$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $557c5b215a8b86ea$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    shareTitle: {
        "id": "work-management-board.header.share-title",
        "defaultMessage": "Board"
    },
    searchBoardLabel: {
        "id": "work-management-board.header.search-board-label",
        "defaultMessage": "Search board"
    }
});

});

parcelRegister("72Gha", function(module, exports) {

$parcel$export(module.exports, "MoreMenuContent", () => $3c7a0f9a876272d0$export$293ea00cebb9b442);

var $eUqFw = parcelRequire("eUqFw");

var $l1jnn = parcelRequire("l1jnn");

var $gGtKh = parcelRequire("gGtKh");

var $dyfd9 = parcelRequire("dyfd9");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3c7a0f9a876272d0$var$LazyJWMBoardMoreMenuContent = (0, $dyfd9.lazy)(()=>(parcelRequire("cAYFz")), {
    ssr: false,
    moduleId: "./src/packages/business/board/view/src/ui/header/more-menu-content/main.tsx"
});
const $3c7a0f9a876272d0$export$293ea00cebb9b442 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jwm-board-more-menu-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l1jnn.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c7a0f9a876272d0$var$LazyJWMBoardMoreMenuContent, props));

});
parcelRegister("l1jnn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a91aceacdc3d4a91$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bBdMg = parcelRequire("bBdMg");

var $3Y9u8 = parcelRequire("3Y9u8");
const $a91aceacdc3d4a91$var$MenuFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y9u8.SpinnerWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bBdMg.default), {
        size: "medium"
    }));
var $a91aceacdc3d4a91$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($a91aceacdc3d4a91$var$MenuFallback);

});
parcelRegister("3Y9u8", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $4a1a450a9393c394$export$52b4dfd89a6b3a1b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $4a1a450a9393c394$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1yt4pxbi",
            __cmplp.className
        ])
    });
});

});


parcelRegister("cAYFz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("dTjX4")
]).then(()=>parcelRequire('al1KN'));

});



parcelRegister("lQ65S", function(module, exports) {

$parcel$export(module.exports, "transformWorkflow", () => $c8e26113839ce7f0$export$bbcfebdec0ab6a21);
const $c8e26113839ce7f0$export$bbcfebdec0ab6a21 = ({ issueTypes: issueTypes, transitions: transitions, workflowId: workflowId, workflowName: workflowName })=>({
        issueTypes: issueTypes.map(({ iconUrl: iconUrl, hierarchyLevel: hierarchyLevel, id: id, name: name })=>({
                avatarUrl: iconUrl,
                hierarchyLevel: hierarchyLevel,
                issueTypeId: id,
                name: name
            })),
        name: workflowName,
        transitions: transitions.map(({ isConditional: isConditional, isGlobal: isGlobal, isInitial: isInitial, name: name, toStatusId: toStatusId, transitionId: transitionId })=>({
                isConditional: isConditional,
                isGlobal: isGlobal,
                isInitial: isInitial,
                name: name,
                to: {
                    statusId: String(toStatusId)
                },
                transitionId: String(transitionId)
            })),
        workflowId: workflowId
    });

});



// error types
const $8b8bfa076f313cc4$export$6c8cb487d6ffc522 = 'QueryError';
const $8b8bfa076f313cc4$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $8b8bfa076f313cc4$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $8b8bfa076f313cc4$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $8b8bfa076f313cc4$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $8b8bfa076f313cc4$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $8b8bfa076f313cc4$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $8b8bfa076f313cc4$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $8b8bfa076f313cc4$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $8b8bfa076f313cc4$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $8b8bfa076f313cc4$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $8b8bfa076f313cc4$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


//# sourceMappingURL=async-business-board.a1c8117c.js.map
